/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/competitiveness-observatory/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 420);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(629);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(48);
var hide = __webpack_require__(38);
var redefine = __webpack_require__(39);
var ctx = __webpack_require__(49);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(638)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_create__);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__);

function _extends() {
  _extends = __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default.a || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_get_own_property_symbols__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js_object_keys__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__core_js_object_keys__);


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = __WEBPACK_IMPORTED_MODULE_1__core_js_object_keys___default()(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (__WEBPACK_IMPORTED_MODULE_0__core_js_object_get_own_property_symbols___default.a) {
    var sourceSymbolKeys = __WEBPACK_IMPORTED_MODULE_0__core_js_object_get_own_property_symbols___default()(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["f"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(33);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.




function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}
var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing); // expose the values on the propType function for documentation

  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */

function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}
var _curry = curry;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addLocaleData; });
/* unused harmony export intlShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* unused harmony export FormattedMessage */
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(754);

var _createChainableTypeChecker = __webpack_require__(155);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(133)('wks');
var uid = __webpack_require__(79);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(260);
var toPrimitive = __webpack_require__(56);
var dP = Object.defineProperty;

exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(58);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading__ = __webpack_require__(1036);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Loading__["a" /* default */]);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Error__ = __webpack_require__(1044);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Error__["a" /* default */]);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_config__ = __webpack_require__(46);
var getSameURLWithChangedLanguage=function getSameURLWithChangedLanguage(_ref){var url=_ref.url,language=_ref.language;var urlTail=getUrlTail(url);var newURL=__WEBPACK_IMPORTED_MODULE_0_utils_config__["a" /* default */].getConfig().site.path+('/'+language+urlTail);return newURL;};var getSameURLWithChangedRegion=function getSameURLWithChangedRegion(_ref2){var url=_ref2.url,regionCode=_ref2.regionCode;var urlHead=getUrlHead(url);var urlTail=getUrlTail(url);var newURL='';newURL+=urlHead.split('/').splice(0,3).join('/');newURL+='/'+regionCode+'/';newURL+=urlTail.split('/').splice(2).join('/');return newURL;};var getUrlHead=function getUrlHead(url){var urlParts=url.split('/');var head=urlParts.reduce(function(prevVal,actVal,index){var returningVal=prevVal;if(index<4&&index!==0){returningVal=prevVal+'/'+actVal;}return returningVal;},'');return head;};var getUrlTail=function getUrlTail(url){var urlParts=url.split('/');var tail=urlParts.reduce(function(prevVal,actVal,index){var returningVal=prevVal;if(index>2){returningVal=prevVal+'/'+actVal;}return returningVal;},'');return tail;};var getLevelDetailLink=function getLevelDetailLink(_ref3){var url=_ref3.url,level=_ref3.level;var urlHead=getUrlHead(url);switch(level){case 0:return urlHead+'/group-detail/0';case 1:return urlHead+'/group-detail/1';case 2:return urlHead+'/group-detail/2';case 3:return urlHead+'/group-detail/3';default:return'/404';}};var getPanelDimensionLink=function getPanelDimensionLink(url,dimension){var urlHead=getUrlHead(url);switch(dimension){case 0:return urlHead+'/group-detail/0';case 1:return urlHead+'/group-detail/1';case 2:return urlHead+'/group-detail/2';case 3:return urlHead+'/group-detail/3';default:return'/404';}};var getIndicatorDetailLink=function getIndicatorDetailLink(_ref4){var url=_ref4.url,indicator=_ref4.indicator;var urlHead=getUrlHead(url);return urlHead+'/indicator-detail/'+indicator;};var getIndicatorDetailLinkEx=function getIndicatorDetailLinkEx(_ref5){var url=_ref5.url,indicator=_ref5.indicator;var urlHead=getUrlHead(url);return urlHead+'/indicator-evo/'+indicator;};var getLayerFromURL=function getLayerFromURL(url){if(url.split('/').length>4){var currentPageName=getCurrentPageName(url);switch(currentPageName){case'dashboard':return 1;case'group-detail':return 2;case'indicator-detail':return 3;default:return 0;}}else if(url.split('/').length>3){return'methodology';}else{return 0;}};var getCurrentPageName=function getCurrentPageName(url){var urlParts=url.split('/');var currentPageName=urlParts[4];return currentPageName;};var getLevelFromURL=function getLevelFromURL(url){var urlParts=url.split('/');var level=urlParts[5];level=Number(level);return level;};var getIndicatorFromURL=function getIndicatorFromURL(url){var indicator=Number(getLevelFromURL(url));return indicator;};var getMethodologyLink=function getMethodologyLink(url){var urlHead=getUrlHead(url);var partialHead=urlHead.split('/').splice(0,3).join('/');return partialHead+'/panels-development-methodology';};var getHomeLink=function getHomeLink(url){var urlHead=getUrlHead(url);var homeLink=urlHead.split('/').splice(0,3).join('/');if(!__WEBPACK_IMPORTED_MODULE_0_utils_config__["a" /* default */].getProperty("enable_region_change",true)){homeLink=homeLink+"/ES21";}return homeLink;};var getReportPanelLink=function getReportPanelLink(url,region_code){var urlHead=getUrlHead(url);if(region_code===undefined){return urlHead+'/report-table';}else{var partialHead=urlHead.split('/').splice(0,3).join('/');return partialHead+'/'+region_code+'/report-table';}};var APPURL={getSameURLWithChangedLanguage:getSameURLWithChangedLanguage,getSameURLWithChangedRegion:getSameURLWithChangedRegion,getUrlHead:getUrlHead,getLevelDetailLink:getLevelDetailLink,getPanelDimensionLink:getPanelDimensionLink,getIndicatorDetailLink:getIndicatorDetailLink,getIndicatorDetailLinkEx:getIndicatorDetailLinkEx,getLayerFromURL:getLayerFromURL,getCurrentPageName:getCurrentPageName,getLevelFromURL:getLevelFromURL,getIndicatorFromURL:getIndicatorFromURL,getMethodologyLink:getMethodologyLink,getHomeLink:getHomeLink,getReportPanelLink:getReportPanelLink};/* harmony default export */ __webpack_exports__["a"] = (APPURL);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_redux__ = __webpack_require__(203);
var getDataFromRegions=function getDataFromRegions(regions){return regions.items.map(function(region){return{id:region.id,name:region.name,code:region.code,country_id:region.country_id};});};var getDataFromCountries=function getDataFromCountries(countries){return countries.items.map(function(country){return{id:country.id,name:country.name,code:country.code};});};var getRegionsDataByCountry=function getRegionsDataByCountry(regionsData){var regionsDataByCountry={};regionsData.forEach(function(region,index,regionsData){var regionCode=getRegionCodeFromId({regionsData:regionsData,id:region.id});var countryCode=getCountryCodeFromRegionCode(regionCode);var countryMeta=countryCodeToMeta(countryCode);if(countryMeta!=null){if(!(countryCode in regionsDataByCountry)){regionsDataByCountry[countryCode]={countryFullName:countryMeta.name,countryId:countryMeta.id,regions:[region]};}else{regionsDataByCountry[countryCode].regions.push(region);}}});return regionsDataByCountry;};var getDataFromReferenceRegions=function getDataFromReferenceRegions(_ref){var regions=_ref.regions,regionsData=_ref.regionsData,selectedRegionId=_ref.selectedRegionId;var referenceRegionsData=void 0;referenceRegionsData=regions.items.map(function(region){var regionCode=region.dst_code;var currentRegionData=regionsData.filter(function(regionData){return regionCode.toUpperCase()===regionData.code.toUpperCase()?true:false;})[0];return currentRegionData;});var selectedRegionData=regionsData.filter(function(regionData){return Number(regionData.id)===selectedRegionId?true:false;})[0];referenceRegionsData.push(selectedRegionData);return referenceRegionsData;};var getSameCountryRegionsData=function getSameCountryRegionsData(regions,selectedRegionId){var regionsData=getDataFromRegions(regions);var selectedRegionCode=getRegionCodeFromId({regionsData:regionsData,id:selectedRegionId});var selectedCountryCode=getCountryCodeFromRegionCode(selectedRegionCode);var sameCountryRegionsData=regionsData.filter(function(region){return getCountryCodeFromRegionCode(region.code)===selectedCountryCode;});return sameCountryRegionsData;};var getRegionIds=function getRegionIds(regions){var regionsData=getDataFromRegions(regions);return regionsData.map(function(region){return region.id;});};var getSameCountryRegionIds=function getSameCountryRegionIds(regions,selectedRegionId){var sameCountryRegionsData=getSameCountryRegionsData(regions,selectedRegionId);var sameCountryRegionIds=sameCountryRegionsData.map(function(region){return region.id;});return sameCountryRegionIds;};var getRegionNameFromId=function getRegionNameFromId(_ref2){var regionsData=_ref2.regionsData,id=_ref2.id;var name=void 0;for(var i=0;i<regionsData.length;i++){if(Number(regionsData[i].id)===Number(id)){name=regionsData[i].name;break;}}return name;};var getRegionCodeFromId=function getRegionCodeFromId(_ref3){var regionsData=_ref3.regionsData,id=_ref3.id;var selectedRegionData=regionsData.filter(function(region){return Number(region.id)===Number(id);});var selectedRegionCode=selectedRegionData[0].code;return selectedRegionCode;};var getRegionIdFromCode=function getRegionIdFromCode(_ref4){var regionsData=_ref4.regionsData,code=_ref4.code;var selectedRegionData=regionsData.filter(function(region){return region.code===code;});var selectedRegionId=selectedRegionData[0].id;return selectedRegionId;};var getCountryCodeFromRegionCode=function getCountryCodeFromRegionCode(regionCode){return regionCode.substring(0,2);};var countryCodeToMeta=function countryCodeToMeta(code){var countriesData=__WEBPACK_IMPORTED_MODULE_0_redux_redux__["a" /* default */].getState().REGIONS.countriesData;code=code.toUpperCase();var countryData=countriesData.filter(function(item){return item.code===code;})[0];return countryData;};var countryCodeToFullName=function countryCodeToFullName(code){var meta=countryCodeToMeta(code);return meta.name;};var getSortedCountryCodesByCountryName=function getSortedCountryCodesByCountryName(_ref5){var regionsDataByCountry=_ref5.regionsDataByCountry;return Object.keys(regionsDataByCountry).sort(function(countryCodeA,countryCodeB){return regionsDataByCountry[countryCodeA].countryFullName>regionsDataByCountry[countryCodeB].countryFullName?1:-1;});};var getSortedRegionsByRegionName=function getSortedRegionsByRegionName(_ref6){var regionsData=_ref6.regionsData;return regionsData.sort(function(regionA,regionB){return regionA.name>regionB.name?1:-1;});};var regionTools={getDataFromRegions:getDataFromRegions,getDataFromCountries:getDataFromCountries,getRegionsDataByCountry:getRegionsDataByCountry,getDataFromReferenceRegions:getDataFromReferenceRegions,getSameCountryRegionsData:getSameCountryRegionsData,getRegionIds:getRegionIds,getSameCountryRegionIds:getSameCountryRegionIds,getRegionNameFromId:getRegionNameFromId,getRegionCodeFromId:getRegionCodeFromId,getRegionIdFromCode:getRegionIdFromCode,getCountryCodeFromRegionCode:getCountryCodeFromRegionCode,countryCodeToFullName:countryCodeToFullName,countryCodeToMeta:countryCodeToMeta,getSortedCountryCodesByCountryName:getSortedCountryCodesByCountryName,getSortedRegionsByRegionName:getSortedRegionsByRegionName};/* harmony default export */ __webpack_exports__["a"] = (regionTools);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(57);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(630);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_redux__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_config__ = __webpack_require__(46);
var _this=this;this.formatMessage=null;var importFormatter=function importFormatter(importedFormatter){_this.formatMessage=importedFormatter;};var getDefaultLanguage=function getDefaultLanguage(){var defaultLanguage=void 0;if(getLanguageFormURL()){defaultLanguage=getLanguageFormURL();}else if(localStorage.getItem('defaultLanguage')){defaultLanguage=localStorage.getItem('defaultLanguage');}else{defaultLanguage=getActualLanguage();}return defaultLanguage;};var getLanguageFormURL=function getLanguageFormURL(){var lang=window.location.pathname.split('/')[2];return lang;};var getActualLanguage=function getActualLanguage(){return __WEBPACK_IMPORTED_MODULE_0_redux_redux__["a" /* default */].getState().LANGUAGE.selectedLanguage;};var getDimensionSubtitle=function getDimensionSubtitle(dimension){dimension=Number(dimension);switch(dimension){case 0:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_0_Subtitle);case 1:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_1_Subtitle);case 2:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_2_Subtitle);case 3:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_3_Subtitle);default:return'Not Found';}};var getComposedDataSource=function getComposedDataSource(dataSource){var composedDataSource='';if(dataSource){composedDataSource=_this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dataSource,{dataSource:dataSource});}return composedDataSource;};var getDimensionTitle=function getDimensionTitle(dimension){// const panel = Config.getConfig().panel_text;
// if ((dimension >= 0) & (dimension < panel.length)) {
//   return panel[dimension].title
// } else {
//   return "Change me!"
// }
switch(Number(dimension)){case 0:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_0_Title);case 1:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_1_Title);case 2:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_2_Title);case 3:return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */].dimension_3_Title);default:return'Dimension "'+dimension+'" not Found';}};var getSubDimensionTitle=function getSubDimensionTitle(dimension,subdimension){var panel=__WEBPACK_IMPORTED_MODULE_2_utils_config__["a" /* default */].getConfig().panel_text;if(dimension<panel.length&&subdimension<panel[dimension].indicators.length){var messageId='subdimension_'+dimension+'_'+subdimension+'_Title';if(messageId in __WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */]){return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */][messageId]);}else{var missing_subdimension_Title={id:'AppTools.missing_subdimension_Title',description:'Texto para el t\xEDtulo de subdimensi\xF3n '+dimension+'.'+subdimension,defaultMessage:'NO TEXT FOR SUBDIMENSION '+dimension+'.'+subdimension};return _this.formatMessage(missing_subdimension_Title);}// return panel[dimension].indicators[subdimension].title
}else{return"Change me!";}};// get section title, use diferent section namespaces...?
var getSectionText=function getSectionText(namespace,levels,element){// levels is an array wih section path [0,1,1] = "0.1.1"
var section_path=levels.join("_");var messageId=namespace+'_'+section_path+'_'+element;if(messageId in __WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */]){return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_1__messages__["a" /* default */][messageId]);}else{return'no Title for "'+namespace+'_'+section_path+'"';}};// 
var appTools={getDefaultLanguage:getDefaultLanguage,getActualLanguage:getActualLanguage,getDimensionSubtitle:getDimensionSubtitle,getComposedDataSource:getComposedDataSource,importFormatter:importFormatter,getDimensionTitle:getDimensionTitle,getSubDimensionTitle:getSubDimensionTitle,getSectionText:getSectionText};/* harmony default export */ __webpack_exports__["a"] = (appTools);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(674);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(675);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(676);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(678);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(205);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(680);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(682);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(683);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(726);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(749);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(752);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(753);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(331);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(222);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(756);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(757);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(332);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(767);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(768);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(221);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(769);
/* unused harmony reexport ControlLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(157);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__DropdownButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(159);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(787);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(788);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(791);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(224);
/* unused harmony reexport Glyphicon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(342);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(792);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(793);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(794);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(797);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(798);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(799);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(343);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(160);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_32__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(347);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalDialog__ = __webpack_require__(348);
/* unused harmony reexport ModalDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalFooter__ = __webpack_require__(349);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalHeader__ = __webpack_require__(350);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ModalTitle__ = __webpack_require__(351);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Nav__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_39__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Navbar__ = __webpack_require__(824);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavbarBrand__ = __webpack_require__(353);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavDropdown__ = __webpack_require__(828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_42__NavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__NavItem__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_43__NavItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Overlay__ = __webpack_require__(355);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__ = __webpack_require__(835);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageHeader__ = __webpack_require__(836);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__PageItem__ = __webpack_require__(837);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pager__ = __webpack_require__(839);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Pagination__ = __webpack_require__(840);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(842);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(323);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(848);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(849);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(850);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(851);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_56__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(52);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(853);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_59__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(231);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(232);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(856);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(361);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(857);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(858);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(362);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(859);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_68__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(861);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(862);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(304);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(307);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(308);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(206);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(150);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(309);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(310);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(207);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(151);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_config__ = __webpack_require__(46);
var getDataFromIndicators=function getDataFromIndicators(data){return data.items.map(function(indicator){var relationships={sexMale:'',sexFemale:'',sexTotal:'',exist:false};if(indicator.meta.relationships){indicator.meta.relationships.forEach(function(item){switch(item.type){case'sex-male':relationships.sexMale=item.related_id;break;case'sex-female':relationships.sexFemale=item.related_id;break;case'sex-total':relationships.sexTotal=item.related_id;break;default:break;}});}if(relationships.sexMale&&relationships.sexFemale)relationships.exist=true;return{id:indicator.id,name:indicator.name,unit:indicator.unit,lastUpdated:indicator.last_refreshed_on,dataSource:indicator.data_source,relationships:relationships,rankOrdering:indicator.rank_ordering,desc:indicator.description,note:indicator.note};});};var getDataFromSingleIndicator=function getDataFromSingleIndicator(data){var relationships={sexMale:'',sexFemale:'',sexTotal:'',exist:false};if(data.meta.relationships){relationships.exist=true;data.meta.relationships.forEach(function(item){switch(item.type){case'sex-male':relationships.sexMale=item.related_id;break;case'sex-female':relationships.sexFemale=item.related_id;break;case'sex-total':relationships.sexTotal=item.related_id;break;default:break;}});}return{id:data.id,name:data.name,unit:data.unit,lastUpdated:data.last_refreshed_on,relationships:relationships,rankOrdering:data.rank_ordering};};var getIndicatorsFromLevel=function getIndicatorsFromLevel(dimension){dimension=Number(dimension);if(dimension<__WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().panel_text.length){// convert to old format
var subdimensions=__WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().panel_text[dimension]["indicators"];return subdimensions.map(function(sd){return sd["indicators"];});}else{return[];}};var getIndicatorEvolutionData=function getIndicatorEvolutionData(data){var indicatorEvolutionData=data.map(function(item){var itemData={value:item.value,year:__WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time)};return itemData;});return indicatorEvolutionData;};var getMaxAndMinYearFromIndicator=function getMaxAndMinYearFromIndicator(indicatorEvolutionData){var min=indicatorEvolutionData[0].year;var max=indicatorEvolutionData[0].year;indicatorEvolutionData.forEach(function(item){if(item.year<min)min=item.year;if(item.year>max)max=item.year;});return{min:min,max:max};};var getLevelFromIndicator=function getLevelFromIndicator(indicator){var level=void 0;var _loop=function _loop(i){var indicators=[];if(i===3){var indicatorsByGroup=getIndicatorsFromLevel(i);indicatorsByGroup.forEach(function(item){return indicators=indicators.concat(item);});}else{indicators=getIndicatorsFromLevel(i);}if(indicators.filter(function(item){return item===indicator;}).length>0){level=i;return'break';}};for(var i=1;i<4;i++){var _ret=_loop(i);if(_ret==='break')break;}return level;};var getDimensionFromIndicator=function getDimensionFromIndicator(indicator){var panel=__WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().panel_text;for(var dimension=0;dimension<panel.length;dimension++){if(getIndicatorsFromLevel(dimension).flat(4).indexOf(indicator)>=0){return dimension;}}return null;};var getIndicatorIndexInPanel=function getIndicatorIndexInPanel(indicator){var panel=__WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().panel_text;for(var i=0;i<panel.length;i++){for(var j=0;j<panel[i].indicators.length;j++){if(panel[i].indicators[j].indicators.indexOf(indicator)>=0){return[i,j];}}}return null;};var getIndicatorNameFromId=function getIndicatorNameFromId(_ref){var indicatorsData=_ref.indicatorsData,id=_ref.id;var name=void 0;for(var i=0;i<indicatorsData.length;i++){if(Number(indicatorsData[i].id)===Number(id)){name=indicatorsData[i].name;break;}}return cleanIndicatorName(name);};var cleanIndicatorName=function cleanIndicatorName(name){var regex=/\[[^\]]*\]/gm;return name.replace(regex,'').trim();};var cleanIndicatorUnit=function cleanIndicatorUnit(unit){var regex=/\(EU27_2020\)/gm;return unit.replace(regex,'').trim();};var formatValuePartTranslate=function formatValuePartTranslate(part){if(part.type==='decimal'){return".";}else if(part.type==='group'){return'\u202F';}else{return part.value;}};var formatValue=function formatValue(n,unit){var minFractionDigits=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var fractionDigits=unit.indexOf('%')>=0?minFractionDigits+1:minFractionDigits;var formatter=new Intl.NumberFormat('en-US',{maximumFractionDigits:fractionDigits});var parts=formatter.formatToParts(n);return parts.map(formatValuePartTranslate).join("");};var indicatorTools={getDataFromIndicators:getDataFromIndicators,getDataFromSingleIndicator:getDataFromSingleIndicator,getIndicatorsFromLevel:getIndicatorsFromLevel,getIndicatorEvolutionData:getIndicatorEvolutionData,getMaxAndMinYearFromIndicator:getMaxAndMinYearFromIndicator,getLevelFromIndicator:getLevelFromIndicator,getIndicatorNameFromId:getIndicatorNameFromId,getDimensionFromIndicator:getDimensionFromIndicator,getIndicatorIndexInPanel:getIndicatorIndexInPanel,cleanIndicatorName:cleanIndicatorName,cleanIndicatorUnit:cleanIndicatorUnit,formatValue:formatValue};/* harmony default export */ __webpack_exports__["a"] = (indicatorTools);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urls__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_regions_regionTools__ = __webpack_require__(22);
var fetchJSON=function fetchJSON(url){return fetch(url).then(function(response){return response.json();});};var getRegions=function getRegions(){var lang=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getActualLanguage();if(sessionStorage.getItem('regions_'+lang)){return Promise.resolve(JSON.parse(sessionStorage.getItem('regions_'+lang)));}else{return Promise.resolve(fetchJSON(__WEBPACK_IMPORTED_MODULE_0__urls__["a" /* default */].getBenchmark()).then(function(regions){sessionStorage.setItem('regions_'+lang,JSON.stringify(regions));return regions;}));}};var getCountries=function getCountries(){var lang=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getActualLanguage();if(sessionStorage.getItem('countries_'+lang)){return Promise.resolve(JSON.parse(sessionStorage.getItem('countries_'+lang)));}else{return Promise.resolve(fetchJSON(__WEBPACK_IMPORTED_MODULE_0__urls__["a" /* default */].getBenchmarkCountries()).then(function(countries){sessionStorage.setItem('countries_'+lang,JSON.stringify(countries));return countries;}));}};var getReferenceRegions=function getReferenceRegions(regionsData,selectedRegionId){var selectedRegionCode=__WEBPACK_IMPORTED_MODULE_2_utils_regions_regionTools__["a" /* default */].getRegionCodeFromId({regionsData:regionsData,id:selectedRegionId});return getQuery(__WEBPACK_IMPORTED_MODULE_0__urls__["a" /* default */].getReferenceRegions({selectedRegionCode:selectedRegionCode}));};var getIndicators=function getIndicators(){var lang=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getActualLanguage();if(sessionStorage.getItem('indicators_'+lang)){return Promise.resolve(JSON.parse(sessionStorage.getItem('indicators_'+lang)));}else{return Promise.resolve(fetchJSON(__WEBPACK_IMPORTED_MODULE_0__urls__["a" /* default */].getAllIndicators()).then(function(indicators){sessionStorage.setItem('indicators_'+lang,JSON.stringify(indicators));return indicators;}));}};var getIndicatorsStatus=function getIndicatorsStatus(){var lang=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getActualLanguage();if(sessionStorage.getItem('indicatorsStatus_'+lang)){return Promise.resolve(JSON.parse(sessionStorage.getItem('indicatorsStatus_'+lang)));}else{return Promise.resolve(fetchJSON(__WEBPACK_IMPORTED_MODULE_0__urls__["a" /* default */].getIndicatorsStatus()).then(function(indicatorsStatus){sessionStorage.setItem('indicatorsStatus_'+lang,JSON.stringify(indicatorsStatus));return indicatorsStatus;}));}};var getQuery=function getQuery(query){//if (sessionStorage.getItem(query)) {
//  return Promise.resolve(JSON.parse(sessionStorage.getItem(query)))
//} else {
return Promise.resolve(fetchJSON(query).then(function(data){// sessionStorage.setItem(query, JSON.stringify(data))
return data;}));//}
};var api={getRegions:getRegions,getCountries:getCountries,getReferenceRegions:getReferenceRegions,getIndicators:getIndicators,getIndicatorsStatus:getIndicatorsStatus,getQuery:getQuery};/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */

function map(children, func, context) {
  var index = 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function count(children) {
  var result = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });
  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });
  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });
  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });
  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });
  return result;
}

function toArray(children) {
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(78);
module.exports = __webpack_require__(16) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(38);
var has = __webpack_require__(42);
var SRC = __webpack_require__(79)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(48).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(12);
var defined = __webpack_require__(57);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(120);
var defined = __webpack_require__(57);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(121);
var createDesc = __webpack_require__(78);
var toIObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(42);
var IE8_DOM_DEFINE = __webpack_require__(260);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(42);
var toObject = __webpack_require__(23);
var IE_PROTO = __webpack_require__(176)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Config={_config:{},fromObject:function fromObject(o){this._config=o;},getConfig:function getConfig(){return this._config;},getProperty:function getProperty(k,defval){if(this._config.hasOwnProperty(k)){return this._config[k];}else{return defval;}}};/* harmony default export */ __webpack_exports__["a"] = (Config);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var compareObjects=function compareObjects(obj1,obj2){return JSON.stringify(obj1)===JSON.stringify(obj2);};var copyObject=function copyObject(obj){return JSON.parse(JSON.stringify(obj));};var objectTools={compareObjects:compareObjects,copyObject:copyObject};/* harmony default export */ __webpack_exports__["a"] = (objectTools);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(34);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(26);








var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
        pointerEvents: 'none'
      }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getYearFromDateString=function getYearFromDateString(dateString){var date=new Date(''+dateString);return date.getFullYear();};var formatDateForContentHeader=function formatDateForContentHeader(dateString){var date=new Date(''+dateString);var day=date.getDate();var month=date.getMonth()+1;var year=date.getFullYear();var formattedDate=(day<10?'0'+day:day)+'.'+(month<10?'0'+month:month)+'.'+year;return formattedDate;};var dateTools={getYearFromDateString:getYearFromDateString,formatDateForContentHeader:formatDateForContentHeader};/* harmony default export */ __webpack_exports__["a"] = (dateTools);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.stripDiacritics = exports.scrollIntoViewIfNeeded = exports.preventInputBlur = exports.pluralize = exports.getTruncatedOptions = exports.getStringLabelKey = exports.getOptionLabel = exports.getMenuItemId = exports.getMatchBounds = exports.getInputText = exports.getHintText = exports.getDisplayName = exports.getAccessibilityStatus = exports.defaultFilterBy = exports.addCustomOption = undefined;

var _addCustomOption2 = __webpack_require__(877);

var _addCustomOption3 = _interopRequireDefault(_addCustomOption2);

var _defaultFilterBy2 = __webpack_require__(878);

var _defaultFilterBy3 = _interopRequireDefault(_defaultFilterBy2);

var _getAccessibilityStatus2 = __webpack_require__(959);

var _getAccessibilityStatus3 = _interopRequireDefault(_getAccessibilityStatus2);

var _getDisplayName2 = __webpack_require__(960);

var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);

var _getHintText2 = __webpack_require__(961);

var _getHintText3 = _interopRequireDefault(_getHintText2);

var _getInputText2 = __webpack_require__(964);

var _getInputText3 = _interopRequireDefault(_getInputText2);

var _getMatchBounds2 = __webpack_require__(383);

var _getMatchBounds3 = _interopRequireDefault(_getMatchBounds2);

var _getMenuItemId2 = __webpack_require__(965);

var _getMenuItemId3 = _interopRequireDefault(_getMenuItemId2);

var _getOptionLabel2 = __webpack_require__(245);

var _getOptionLabel3 = _interopRequireDefault(_getOptionLabel2);

var _getStringLabelKey2 = __webpack_require__(385);

var _getStringLabelKey3 = _interopRequireDefault(_getStringLabelKey2);

var _getTruncatedOptions2 = __webpack_require__(966);

var _getTruncatedOptions3 = _interopRequireDefault(_getTruncatedOptions2);

var _pluralize2 = __webpack_require__(967);

var _pluralize3 = _interopRequireDefault(_pluralize2);

var _preventInputBlur2 = __webpack_require__(968);

var _preventInputBlur3 = _interopRequireDefault(_preventInputBlur2);

var _scrollIntoViewIfNeeded2 = __webpack_require__(969);

var _scrollIntoViewIfNeeded3 = _interopRequireDefault(_scrollIntoViewIfNeeded2);

var _stripDiacritics2 = __webpack_require__(244);

var _stripDiacritics3 = _interopRequireDefault(_stripDiacritics2);

var _warn2 = __webpack_require__(77);

var _warn3 = _interopRequireDefault(_warn2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addCustomOption = _addCustomOption3.default; /* eslint-disable object-curly-spacing */

exports.defaultFilterBy = _defaultFilterBy3.default;
exports.getAccessibilityStatus = _getAccessibilityStatus3.default;
exports.getDisplayName = _getDisplayName3.default;
exports.getHintText = _getHintText3.default;
exports.getInputText = _getInputText3.default;
exports.getMatchBounds = _getMatchBounds3.default;
exports.getMenuItemId = _getMenuItemId3.default;
exports.getOptionLabel = _getOptionLabel3.default;
exports.getStringLabelKey = _getStringLabelKey3.default;
exports.getTruncatedOptions = _getTruncatedOptions3.default;
exports.pluralize = _pluralize3.default;
exports.preventInputBlur = _preventInputBlur3.default;
exports.scrollIntoViewIfNeeded = _scrollIntoViewIfNeeded3.default;
exports.stripDiacritics = _stripDiacritics3.default;
exports.warn = _warn3.default;
/* eslint-enable object-curly-spacing */

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(48);
var fails = __webpack_require__(12);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(49);
var IObject = __webpack_require__(120);
var toObject = __webpack_require__(23);
var toLength = __webpack_require__(18);
var asc = __webpack_require__(193);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(214)('wks');
var uid = __webpack_require__(153);
var Symbol = __webpack_require__(73).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(366);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(16)) {
  var LIBRARY = __webpack_require__(70);
  var global = __webpack_require__(10);
  var fails = __webpack_require__(12);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(144);
  var $buffer = __webpack_require__(199);
  var ctx = __webpack_require__(49);
  var anInstance = __webpack_require__(85);
  var propertyDesc = __webpack_require__(78);
  var hide = __webpack_require__(38);
  var redefineAll = __webpack_require__(87);
  var toInteger = __webpack_require__(58);
  var toLength = __webpack_require__(18);
  var toIndex = __webpack_require__(286);
  var toAbsoluteIndex = __webpack_require__(81);
  var toPrimitive = __webpack_require__(56);
  var has = __webpack_require__(42);
  var classof = __webpack_require__(122);
  var isObject = __webpack_require__(13);
  var toObject = __webpack_require__(23);
  var isArrayIter = __webpack_require__(190);
  var create = __webpack_require__(82);
  var getPrototypeOf = __webpack_require__(45);
  var gOPN = __webpack_require__(83).f;
  var getIterFn = __webpack_require__(192);
  var uid = __webpack_require__(79);
  var wks = __webpack_require__(15);
  var createArrayMethod = __webpack_require__(60);
  var createArrayIncludes = __webpack_require__(134);
  var speciesConstructor = __webpack_require__(141);
  var ArrayIterators = __webpack_require__(195);
  var Iterators = __webpack_require__(101);
  var $iterDetect = __webpack_require__(138);
  var setSpecies = __webpack_require__(84);
  var arrayFill = __webpack_require__(194);
  var arrayCopyWithin = __webpack_require__(276);
  var $DP = __webpack_require__(17);
  var $GOPD = __webpack_require__(44);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(281);
var $export = __webpack_require__(1);
var shared = __webpack_require__(133)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(284))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(73);
var core = __webpack_require__(36);
var ctx = __webpack_require__(208);
var hide = __webpack_require__(104);
var has = __webpack_require__(90);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setLanguage=function setLanguage(language){return{type:'SET_LANGUAGE',language:language};};var setSelectedRegionId=function setSelectedRegionId(selectedRegionId){return{type:'SET_SELECTED_REGION_ID',selectedRegionId:selectedRegionId};};var setSelectedRegionCountryMeta=function setSelectedRegionCountryMeta(selectedRegionCountryMeta){return{type:'SET_SELECTED_REGION_COUNTRY_META',selectedRegionCountryMeta:selectedRegionCountryMeta};};var setRegionsData=function setRegionsData(regionsData){return{type:'SET_REGIONS_DATA',regionsData:regionsData};};var setCountriesData=function setCountriesData(countriesData){return{type:'SET_COUNTRIES_DATA',countriesData:countriesData};};var setReferenceRegionsData=function setReferenceRegionsData(referenceRegionsData){return{type:'SET_REFERENCE_REGIONS_DATA',referenceRegionsData:referenceRegionsData};};var setSameCountryRegionsData=function setSameCountryRegionsData(sameCountryRegionsData){return{type:'SET_SAME_COUNTRY_REGIONS_DATA',sameCountryRegionsData:sameCountryRegionsData};};var setIndicatorsData=function setIndicatorsData(indicatorsData){return{type:'SET_INDICATORS_DATA',indicatorsData:indicatorsData};};var setIndicatorsLastUpdated=function setIndicatorsLastUpdated(lastUpdated){return{type:'SET_INDICATORS_LAST_UPDATED',lastUpdated:lastUpdated};};var manageAllFilter=function manageAllFilter(checked){return{type:'MANAGE_ALL_FILTER',checked:checked};};var manageReferenceFilter=function manageReferenceFilter(checked){return{type:'MANAGE_REFERENCE_FILTER',checked:checked};};var manageSameCountryFilter=function manageSameCountryFilter(checked){return{type:'MANAGE_SAME_COUNTRY_FILTER',checked:checked};};var manageTypeAheadFilter=function manageTypeAheadFilter(selected){return{type:'MANAGE_TYPE_AHEAD_FILTER',selected:selected};};var manageEvolutionFilter=function manageEvolutionFilter(selected){return{type:'MANAGE_EVOLUTION_FILTER',selected:selected};};var manageChartTypeFilter=function manageChartTypeFilter(selected){return{type:'MANAGE_CHART_TYPE_FILTER',selected:selected};};var actions={setLanguage:setLanguage,setSelectedRegionId:setSelectedRegionId,setSelectedRegionCountryMeta:setSelectedRegionCountryMeta,setRegionsData:setRegionsData,setCountriesData:setCountriesData,setReferenceRegionsData:setReferenceRegionsData,setSameCountryRegionsData:setSameCountryRegionsData,setIndicatorsData:setIndicatorsData,setIndicatorsLastUpdated:setIndicatorsLastUpdated,manageAllFilter:manageAllFilter,manageReferenceFilter:manageReferenceFilter,manageSameCountryFilter:manageSameCountryFilter,manageTypeAheadFilter:manageTypeAheadFilter,manageEvolutionFilter:manageEvolutionFilter,manageChartTypeFilter:manageChartTypeFilter};/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(79)('meta');
var isObject = __webpack_require__(13);
var has = __webpack_require__(42);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(15)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(38)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleTagManager__ = __webpack_require__(715);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__GoogleTagManager__["a" /* default */]);

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(66);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {}; /**
                  * This code is copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
                  */

function warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }
    warned[message] = true;
  }

  message = '[react-bootstrap-typeahead] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(262);
var enumBugKeys = __webpack_require__(177);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(263);
var enumBugKeys = __webpack_require__(177);
var IE_PROTO = __webpack_require__(176)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(174)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(178).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(262);
var hiddenKeys = __webpack_require__(177).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(16);
var SPECIES = __webpack_require__(15)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var call = __webpack_require__(274);
var isArrayIter = __webpack_require__(190);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(18);
var getIterFn = __webpack_require__(192);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(39);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuOffCanvas__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_0__MenuOffCanvas__["a" /* default */]));

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var IE8_DOM_DEFINE = __webpack_require__(317);
var toPrimitive = __webpack_require__(209);
var dP = Object.defineProperty;

exports.f = __webpack_require__(107) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(320);
var defined = __webpack_require__(211);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(32));

var Utils = _interopRequireWildcard(__webpack_require__(746));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var isCompositeComponent = Utils.isReactComponent(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (isCompositeComponent) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.getControlledInstance = function getControlledInstance() {
      return this.inner;
    };

    _proto.render = function render() {
      var _this4 = this;

      var props = _extends({}, this.props);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _inner;

      return (_inner = this.inner)[method].apply(_inner, arguments);
    };
  });
  UncontrolledComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return UncontrolledComponent;
}

module.exports = exports["default"];

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,regionsData:state.REGIONS.regionsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__Header__["a" /* default */])));

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131),
    getRawTag = __webpack_require__(875),
    objectToString = __webpack_require__(876);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(890),
    getValue = __webpack_require__(893);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(1046);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SurveyControllerContainer__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_0__SurveyControllerContainer__["a" /* default */]));

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HTMLTitleController__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
var mapStateToProps=function mapStateToProps(state){return{regionsData:state.REGIONS.regionsData,selectedRegionId:state.REGIONS.selectedRegionId,indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__HTMLTitleController__["a" /* default */])));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(42);
var TAG = __webpack_require__(15)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(57);
var fails = __webpack_require__(12);
var spaces = __webpack_require__(180);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(123);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(89);
var createDesc = __webpack_require__(124);
module.exports = __webpack_require__(107) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(106);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(108)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(319);
var enumBugKeys = __webpack_require__(215);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(750);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(111);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_config__ = __webpack_require__(46);
var getBenchmark=function getBenchmark(){var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('geo/tagged/eccp-2020-eu27_2020?lang='+lang);};var getBenchmarkCountries=function getBenchmarkCountries(){var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('geo/tagged/benchmark2018-country?lang='+lang);};var getAllIndicators=function getAllIndicators(){var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator?lang='+lang);};var getIndicator=function getIndicator(indicator){var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator/'+indicator+'?lang='+lang);};var getIndicatorsStatus=function getIndicatorsStatus(){var indicator_tag=__WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().indicator_tag;return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator/tagged/'+indicator_tag+'/status');};var getReferenceRegions=function getReferenceRegions(_ref){var selectedRegionCode=_ref.selectedRegionCode;var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_S3PLATFORM+('rev/2018/dist/'+selectedRegionCode+'/30/0?lang='+lang);};var getNewestDataForIndicatorAndRegions=function getNewestDataForIndicatorAndRegions(_ref2){var indicator=_ref2.indicator,query=_ref2.query;return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator/'+indicator+'/query?'+query+'&time=newest&ignore_missing=yes');};var getEvolutionForIndicatorAndRegions=function getEvolutionForIndicatorAndRegions(_ref3){var indicator=_ref3.indicator,query=_ref3.query;return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator/'+indicator+'/query?'+query);};var getDataInSpecificYearForIndicatorAndRegions=function getDataInSpecificYearForIndicatorAndRegions(_ref4){var indicator=_ref4.indicator,query=_ref4.query,year=_ref4.year;return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator/'+indicator+'/query?'+query+'&time='+year+'&ignore_weight=yes&ignore_missing=yes');};var getEvolutionForRegionAndIndicator=function getEvolutionForRegionAndIndicator(_ref5){var indicator=_ref5.indicator,selectedRegionId=_ref5.selectedRegionId;return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_REGPANEL+('geo/'+selectedRegionId+'/'+indicator);};var getRelatedDocumentsLevel=function getRelatedDocumentsLevel(_ref6){var selectedRegionCode=_ref6.selectedRegionCode,level=_ref6.level;var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();var regionCode=selectedRegionCode.toLowerCase();var levelQuery=void 0;switch(level){case 1:levelQuery='framework-result';break;case 2:levelQuery='framework-performance';break;case 3:levelQuery='framework-determinant';break;default:return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('resource/search?key='+regionCode+'&lang='+lang);}return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('resource/search?key='+regionCode+','+levelQuery+'&lang='+lang);};var getRelatedDocumentsIndicator=function getRelatedDocumentsIndicator(_ref7){var selectedRegionCode=_ref7.selectedRegionCode,indicator=_ref7.indicator;var lang=__WEBPACK_IMPORTED_MODULE_0_utils_app_appTools__["a" /* default */].getActualLanguage();var regionCode=selectedRegionCode.toLowerCase();return __WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('resource/search?key='+regionCode+',indicator-'+indicator+'&lang='+lang);};var APIURL={getBenchmark:getBenchmark,getBenchmarkCountries:getBenchmarkCountries,getAllIndicators:getAllIndicators,getIndicator:getIndicator,getIndicatorsStatus:getIndicatorsStatus,getReferenceRegions:getReferenceRegions,getNewestDataForIndicatorAndRegions:getNewestDataForIndicatorAndRegions,getEvolutionForIndicatorAndRegions:getEvolutionForIndicatorAndRegions,getDataInSpecificYearForIndicatorAndRegions:getDataInSpecificYearForIndicatorAndRegions,getEvolutionForRegionAndIndicator:getEvolutionForRegionAndIndicator,getRelatedDocumentsLevel:getRelatedDocumentsLevel,getRelatedDocumentsIndicator:getRelatedDocumentsIndicator};/* harmony default export */ __webpack_exports__["a"] = (APIURL);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable sort-keys */

/**
 * KeyCode
 *
 * Map of common (non-printable) keycodes for the `keydown` and `keyup` events.
 * Note that `keypress` handles things differently and may not return the same
 * values.
 */
module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regionLevel__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countryLevel__ = __webpack_require__(1042);
var geoJSON={regionLevel:__WEBPACK_IMPORTED_MODULE_0__regionLevel__["a" /* default */],countryLevel:__WEBPACK_IMPORTED_MODULE_1__countryLevel__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (geoJSON);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__ = __webpack_require__(25);
var addUrlParameter=function addUrlParameter(query,param){if(query!==''){query+='&';}return query+=param;};var getIndicatorDataV0Facade=function getIndicatorDataV0Facade(_ref){var indicator=_ref.indicator,geo=_ref.geo,time=_ref.time;var query='';geo.forEach(function(geo_id){query=addUrlParameter(query,'geo['+geo_id+']='+geo_id);});if(time!==undefined){time.forEach(function(time){query=addUrlParameter(query,'time='+time);});}query=addUrlParameter(query,"ignore_missing=yes");query=addUrlParameter(query,"haggr_mode=any");return __WEBPACK_IMPORTED_MODULE_0_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA+('indicator/'+indicator+'/query?'+query);};var getIndicatorData=function getIndicatorData(_ref2){var indicator=_ref2.indicator,geo=_ref2.geo,time=_ref2.time,meta=_ref2.meta;var query='';geo.forEach(function(geo_id){query=addUrlParameter(query,'geo='+geo_id);});if(time!==undefined){time.forEach(function(time){query=addUrlParameter(query,'time='+time);});}if(meta===true){query=addUrlParameter(query,'meta=true');}var lang=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getActualLanguage();query=addUrlParameter(query,'lang='+lang);return __WEBPACK_IMPORTED_MODULE_0_utils_config__["a" /* default */].getConfig().app.urls.BASE_URL_HONTZA_API_V1+('indicator/'+indicator+'/data?'+query);};var API_V1_URL={getIndicatorData:getIndicatorData,getIndicatorDataV0Facade:getIndicatorDataV0Facade};/* harmony default export */ __webpack_exports__["a"] = (API_V1_URL);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var selectedRegionColor=[222,113,6];var allRegionsColor=[39,128,204];var referenceRegionsColor=[73,203,174];var sameCountryRegionsColor=[208,126,166];var otherRegionsColors=[[15,164,196],[200,8,21],[251,54,64],[41,49,50],[234,191,203],[35,100,170],[183,240,173],[175,43,191]];var mapMaxColorDescending=[14,88,151];var mapMinColorDescending=[255,255,255];var mapMaxColorDescendingFemale=[38,5,183];var mapMinColorDescendingFemale=[255,255,255];var mapMaxColorAscending=[200,8,21];var mapMinColorAscending=[255,255,255];var mapMaxColorAscendingFemale=[247,82,22];var mapMinColorAscendingFemale=[255,255,255];var colorToRGBA=function colorToRGBA(color){var a=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return'rgba('+color[0]+','+color[1]+','+color[2]+','+a+')';};var selectOtherRegionsColor=function selectOtherRegionsColor(index){var realIndex=index;if(index>otherRegionsColors.length-1){realIndex=index-otherRegionsColors.length;}return otherRegionsColors[realIndex];};var REGION_COLORS={1:[214,136,61],// ES21
326:[111,145,198],// DE1
560:[103,159,169],// AT3º
411:[185,73,63],// ES
325:[0,95,170],// DE
2692:[188,125,214]// EU27_2020
};var getColorByRegionId=function getColorByRegionId(regionId){if(regionId in REGION_COLORS){return REGION_COLORS[regionId];}return otherRegionsColors[regionId%otherRegionsColors.length];};var colors={selectedRegionColor:selectedRegionColor,allRegionsColor:allRegionsColor,referenceRegionsColor:referenceRegionsColor,sameCountryRegionsColor:sameCountryRegionsColor,mapMaxColorDescending:mapMaxColorDescending,mapMinColorDescending:mapMinColorDescending,mapMaxColorDescendingFemale:mapMaxColorDescendingFemale,mapMinColorDescendingFemale:mapMinColorDescendingFemale,mapMaxColorAscending:mapMaxColorAscending,mapMinColorAscending:mapMinColorAscending,mapMaxColorAscendingFemale:mapMaxColorAscendingFemale,mapMinColorAscendingFemale:mapMinColorAscendingFemale,colorToRGBA:colorToRGBA,selectOtherRegionsColor:selectOtherRegionsColor,getColorByRegionId:getColorByRegionId};/* harmony default export */ __webpack_exports__["a"] = (colors);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectedRegionController__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(68);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSelectedRegionId:function setSelectedRegionId(selectedRegionId){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSelectedRegionId(selectedRegionId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__SelectedRegionController__["a" /* default */])));

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(50);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(50);
var TAG = __webpack_require__(15)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(52);











var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};
var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  _proto.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_ref, ["componentClass"]);

    var Component = componentClass || 'button';
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["active", "block", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));

    var fullClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(333);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(762);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(764);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(765);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(223);

var _isTransform = __webpack_require__(766);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(155);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(62);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(163);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(48);
var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(70) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(43);
var toLength = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(81);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(50);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(13);
var cof = __webpack_require__(50);
var MATCH = __webpack_require__(15)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(15)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(38);
var redefine = __webpack_require__(39);
var fails = __webpack_require__(12);
var defined = __webpack_require__(57);
var wks = __webpack_require__(15);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(34);
var SPECIES = __webpack_require__(15)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(39);
var redefineAll = __webpack_require__(87);
var meta = __webpack_require__(69);
var forOf = __webpack_require__(86);
var anInstance = __webpack_require__(85);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(12);
var $iterDetect = __webpack_require__(138);
var setToStringTag = __webpack_require__(99);
var inheritIfRequired = __webpack_require__(181);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(38);
var uid = __webpack_require__(79);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(70) || !__webpack_require__(12)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(10)[K];
});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(34);
var ctx = __webpack_require__(49);
var forOf = __webpack_require__(86);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(123);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(211);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(155);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__ = __webpack_require__(37);























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */].defaultProps.bsRole;
var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])),
  componentClass: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["c" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__["a" /* default */]
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Dropdown, _React$Component);

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleClose = _this.handleClose.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default()(document));
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;
    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  _proto.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu || !menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  _proto.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, {
      source: 'click'
    });
  };

  _proto.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, {
            source: 'keydown'
          });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }

        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.handleClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  _proto.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_ref, ["id", "onSelect", "rootCloseEvent"]);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, {
          source: 'select'
        });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  _proto.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  _proto.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);

    delete props.onToggle;
    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    } // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.


    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      switch (child.props.bsRole) {
        case TOGGLE_ROLE:
          return _this4.renderToggle(child, {
            id: id,
            disabled: disabled,
            open: open,
            role: role,
            bsClass: bsClass
          });

        case MENU_ROLE:
          return _this4.renderMenu(child, {
            id: id,
            open: open,
            pullRight: pullRight,
            bsClass: bsClass,
            onSelect: onSelect,
            rootCloseEvent: rootCloseEvent
          });

        default:
          return child;
      }
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', Dropdown);
var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default()(Dropdown, {
  open: 'onToggle'
});
UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;
  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__);




var _fadeStyles;





var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERING"]] = 'in', _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERED"]] = 'in', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Fade, _React$Component);

  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default.a, props, function (status, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MediaBody__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaHeading__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaLeft__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaList__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaListItem__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaRight__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(7);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Media =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Media, _React$Component);

  function Media() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Media.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;
Media.Heading = __WEBPACK_IMPORTED_MODULE_7__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_6__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_8__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_11__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_9__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_10__MediaListItem__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('media', Media));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(880),
    listCacheDelete = __webpack_require__(881),
    listCacheGet = __webpack_require__(882),
    listCacheHas = __webpack_require__(883),
    listCacheSet = __webpack_require__(884);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(166);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(902);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(41),
    isKey = __webpack_require__(243),
    stringToPath = __webpack_require__(942),
    toString = __webpack_require__(380);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1039));
	else if(typeof define === 'function' && define.amd)
		define(["react", "highcharts/highmaps"], factory);
	else if(typeof exports === 'object')
		exports["ReactHighmaps"] = factory(require("react"), require("highcharts/highmaps"));
	else
		root["ReactHighmaps"] = factory(root["React"], root["Highcharts"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_21__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var win = typeof global === 'undefined' ? window : global;

function chartsFactory(chartType, Highcharts) {
    var Chart = function (_Component) {
        _inherits(Chart, _Component);

        function Chart() {
            _classCallCheck(this, Chart);

            var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this));

            _this.chartType = chartType;
            _this.Highcharts = Highcharts;
            _this.displayName = 'Highcharts' + chartType;
            return _this;
        }

        _createClass(Chart, [{
            key: 'setChartRef',
            value: function setChartRef(chartRef) {
                this.chartRef = chartRef;
            }
        }, {
            key: 'renderChart',
            value: function renderChart(config) {
                var _this2 = this;

                if (!config) {
                    throw new Error('Config must be specified for the ' + this.displayName + ' component');
                }
                var chartConfig = config.chart;
                this.chart = new this.Highcharts[this.chartType](_extends({}, config, {
                    chart: _extends({}, chartConfig, {
                        renderTo: this.chartRef
                    })
                }), this.props.callback);

                if (!this.props.neverReflow) {
                    win && win.requestAnimationFrame && requestAnimationFrame(function () {
                        _this2.chart && _this2.chart.options && _this2.chart.reflow();
                    });
                }
            }
        }, {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                if (nextProps.neverReflow || nextProps.isPureConfig && this.props.config === nextProps.config) {
                    return true;
                }
                this.renderChart(nextProps.config);
                return false;
            }
        }, {
            key: 'getChart',
            value: function getChart() {
                if (!this.chart) {
                    throw new Error('getChart() should not be called before the component is mounted');
                }
                return this.chart;
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.renderChart(this.props.config);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.chart.destroy();
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement('div', _extends({ ref: this.setChartRef.bind(this) }, this.props.domProps));
            }
        }]);

        return Chart;
    }(_react.Component);

    if (true) {
        var PropTypes = __webpack_require__(9);

        Chart.propTypes = {
            config: PropTypes.object,
            isPureConfig: PropTypes.bool,
            neverReflow: PropTypes.bool,
            callback: PropTypes.func,
            domProps: PropTypes.object
        };
    }
    Chart.defaultProps = {
        callback: function callback() {},
        domProps: {}
    };
    var result = Chart;
    result.Highcharts = Highcharts;
    result.withHighcharts = function (Highcharts) {
        return module.exports(chartType, Highcharts);
    };

    return result;
}

exports.default = chartsFactory;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(10)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(12)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);
var assign = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(11);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(4);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chartsFactory = __webpack_require__(7);

var _chartsFactory2 = _interopRequireDefault(_chartsFactory);

var _highmaps = __webpack_require__(21);

var _highmaps2 = _interopRequireDefault(_highmaps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _chartsFactory2.default)('Map', _highmaps2.default);
module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ })
/******/ ]);
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var max=function max(values){var max_v=values[0];values.forEach(function(v){if(v>max_v)max_v=v;});return max_v;};var ascending=function ascending(a,b){return a==null||b==null?NaN:a<b?-1:a>b?1:a>=b?0:NaN;};var descending=function descending(a,b){return a==null||b==null?NaN:b<a?-1:b>a?1:b>=a?0:NaN;};// hontza related
var uniquePropertyValues=function uniquePropertyValues(data,propertyName){return[].concat(_toConsumableArray(new Set(data.map(function(d){return d[propertyName];}))));};// const intersect = (a, b) => {
//   return a.filter( v => b.includes( v ) );
// }
var intersection=function intersection(arrays){return arrays.reduce(function(a,b){return a.filter(function(v){return b.includes(v);});});};var arrayAt=function arrayAt(a,index){/* for very old browsers */// ToInteger() abstract op
index=Math.trunc(index)||0;// Allow negative indexing from the end
if(index<0)index+=a.length;// OOB access is guaranteed to return undefined
if(index<0||index>=a.length)return undefined;// Otherwise, this is just normal property access
return a[index];};var dataTools={max:max,ascending:ascending,descending:descending,uniquePropertyValues:uniquePropertyValues,intersection:intersection,arrayAt:arrayAt};/* harmony default export */ __webpack_exports__["a"] = (dataTools);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(48);
var LIBRARY = __webpack_require__(70);
var wksExt = __webpack_require__(261);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(133)('keys');
var uid = __webpack_require__(79);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(49)(Function.call, __webpack_require__(44).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var setPrototypeOf = __webpack_require__(179).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(58);
var defined = __webpack_require__(57);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var defined = __webpack_require__(57);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(70);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(39);
var hide = __webpack_require__(38);
var Iterators = __webpack_require__(101);
var $iterCreate = __webpack_require__(187);
var setToStringTag = __webpack_require__(99);
var getPrototypeOf = __webpack_require__(45);
var ITERATOR = __webpack_require__(15)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(82);
var descriptor = __webpack_require__(78);
var setToStringTag = __webpack_require__(99);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(38)(IteratorPrototype, __webpack_require__(15)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(137);
var defined = __webpack_require__(57);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(15)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(101);
var ITERATOR = __webpack_require__(15)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(78);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(122);
var ITERATOR = __webpack_require__(15)('iterator');
var Iterators = __webpack_require__(101);
module.exports = __webpack_require__(48).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(519);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(18);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(71);
var step = __webpack_require__(277);
var Iterators = __webpack_require__(101);
var toIObject = __webpack_require__(43);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(186)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var invoke = __webpack_require__(267);
var html = __webpack_require__(178);
var cel = __webpack_require__(174);
var global = __webpack_require__(10);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(50)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var macrotask = __webpack_require__(196).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(50)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(34);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(16);
var LIBRARY = __webpack_require__(70);
var $typed = __webpack_require__(144);
var hide = __webpack_require__(38);
var redefineAll = __webpack_require__(87);
var fails = __webpack_require__(12);
var anInstance = __webpack_require__(85);
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(18);
var toIndex = __webpack_require__(286);
var gOPN = __webpack_require__(83).f;
var dP = __webpack_require__(17).f;
var arrayFill = __webpack_require__(194);
var setToStringTag = __webpack_require__(99);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindActionCreators; });
/* unused harmony export applyMiddleware */
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(644);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_Reducers_mainReducer__ = __webpack_require__(660);
var initialState={};var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* createStore */])(__WEBPACK_IMPORTED_MODULE_1_redux_Reducers_mainReducer__["a" /* default */],initialState,window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__()/*Para el debug en Chrome*/);/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(150);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(151);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(728);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(106);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 210 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(214)('keys');
var uid = __webpack_require__(153);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var global = __webpack_require__(73);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(152) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 216 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(105);
var dPs = __webpack_require__(734);
var enumBugKeys = __webpack_require__(215);
var IE_PROTO = __webpack_require__(213)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(318)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(735).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(89).f;
var has = __webpack_require__(90);
var TAG = __webpack_require__(61)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(61);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(73);
var core = __webpack_require__(36);
var LIBRARY = __webpack_require__(152);
var wksExt = __webpack_require__(219);
var defineProperty = __webpack_require__(89).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  label: 'Close'
};

var CloseButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(CloseButton, _React$Component);

  function CloseButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CloseButton.prototype;

  _proto.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only"
    }, label));
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(7);









var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};
var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ButtonGroup, _React$Component);

  function ButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["block", "justified", "vertical", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["glyph", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Glyphicon.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(26);





var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];
  return value + parseInt(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERED"]] = 'collapse in', _collapseStyles);
var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Collapse, _React$Component);

  function Collapse() {
    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this, _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    }, _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    }, _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    }, _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _temp) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this);
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default.a, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(130);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(162);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(113);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(821);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(845);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uncontrollable__);





var TAB = 'tab';
var PANE = 'pane';
var idPropType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]);
var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },

  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
  })
};

var TabContainer =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(TabContainer, _React$Component);

  function TabContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;

    var getId = generateChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  _proto.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["children"]);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_uncontrollable___default()(TabContainer, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(7);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
  })
};
var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};

var TabContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(TabContent, _React$Component);

  function TabContent(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handlePaneEnter = _this.handlePaneEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handlePaneExited = _this.handlePaneExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this)); // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.

    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;
    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();
    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    } // It's possible that this child should be transitioning out.


    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  };

  _proto.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  _proto.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["componentClass", "className"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('tab', TabContent));

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__["a" /* default */])));

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(879),
    isObjectLike = __webpack_require__(76);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95),
    root = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94),
    isObject = __webpack_require__(75);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(894),
    mapCacheDelete = __webpack_require__(901),
    mapCacheGet = __webpack_require__(903),
    mapCacheHas = __webpack_require__(904),
    mapCacheSet = __webpack_require__(905);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(920),
    baseKeys = __webpack_require__(927),
    isArrayLike = __webpack_require__(241);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(922),
    isObjectLike = __webpack_require__(76);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(236),
    isLength = __webpack_require__(240);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(170),
    toKey = __webpack_require__(132);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(41),
    isSymbol = __webpack_require__(163);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripDiacritics;
/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Taken from: http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/18391901#18391901
 */

/* eslint-disable max-len */
var map = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];
/* eslint-enable max-len */

var diacriticsMap = {};
for (var ii = 0; ii < map.length; ii++) {
  var letters = map[ii].letters;
  for (var jj = 0; jj < letters.length; jj++) {
    diacriticsMap[letters[jj]] = map[ii].base;
  }
}

// "what?" version ... http://jsperf.com/diacritics/12
function stripDiacritics(str) {
  return str.replace(/[\u0300-\u036F]/g, '') // Remove combining diacritics
  /* eslint-disable-next-line no-control-regex */
  .replace(/[^\u0000-\u007E]/g, function (a) {
    return diacriticsMap[a] || a;
  });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(32);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(384);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _getStringLabelKey = __webpack_require__(385);

var _getStringLabelKey2 = _interopRequireDefault(_getStringLabelKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel(option, labelKey) {
  if (option.paginationOption || option.customOption) {
    return option[(0, _getStringLabelKey2.default)(labelKey)];
  }

  var optionLabel = void 0;

  if (typeof option === 'string') {
    optionLabel = option;
  }

  if (typeof labelKey === 'function') {
    // This overwrites string options, but we assume the consumer wants to do
    // something custom if `labelKey` is a function.
    optionLabel = labelKey(option);
  } else if (typeof labelKey === 'string' && (0, _isPlainObject2.default)(option)) {
    optionLabel = option[labelKey];
  }

  !(typeof optionLabel === 'string') ?  false ? (0, _invariant2.default)(false, 'One or more options does not have a valid label string. Check the ' + '`labelKey` prop to ensure that it matches the correct option key and ' + 'provides a string for filtering and display.') : (0, _invariant2.default)(false) : void 0;

  return optionLabel;
}

exports.default = getOptionLabel;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseMenuItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__(248);

var _noop2 = _interopRequireDefault(_noop);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _menuItemContainer = __webpack_require__(404);

var _menuItemContainer2 = _interopRequireDefault(_menuItemContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseMenuItem = function (_React$Component) {
  _inherits(BaseMenuItem, _React$Component);

  function BaseMenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BaseMenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseMenuItem.__proto__ || Object.getPrototypeOf(BaseMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;


      e.preventDefault();
      !disabled && onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BaseMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          props = _objectWithoutProperties(_props, ['active', 'children', 'className', 'disabled', 'onClick', 'onMouseDown']);

      var conditionalClassNames = {
        'active': active,
        'disabled': disabled
      };

      return (
        /* eslint-disable jsx-a11y/anchor-is-valid */
        _react2.default.createElement(
          'li',
          _extends({}, props, {
            className: (0, _classnames2.default)(conditionalClassNames, className) }),
          _react2.default.createElement(
            'a',
            {
              className: (0, _classnames2.default)('dropdown-item', conditionalClassNames),
              href: '#',
              onClick: this._handleClick,
              onMouseDown: onMouseDown },
            children
          )
        )
        /* eslint-enable jsx-a11y/anchor-is-valid */

      );
    }
  }]);

  return BaseMenuItem;
}(_react2.default.Component);

BaseMenuItem.defaultProps = {
  onClick: _noop2.default
};

exports.BaseMenuItem = BaseMenuItem;
exports.default = (0, _menuItemContainer2.default)(BaseMenuItem);

/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(405),
    baseLodash = __webpack_require__(250);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(405),
    baseLodash = __webpack_require__(250);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LayerHeader__ = __webpack_require__(1056);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LayerHeader__["a" /* default */]);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentContainer__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(68);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setRegionsData:function setRegionsData(regionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setRegionsData(regionsData));},setReferenceRegionsData:function setReferenceRegionsData(referenceRegionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setReferenceRegionsData(referenceRegionsData));},setSameCountryRegionsData:function setSameCountryRegionsData(sameCountryRegionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSameCountryRegionsData(sameCountryRegionsData));},setIndicatorsData:function setIndicatorsData(indicatorsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsData(indicatorsData));},setIndicatorsLastUpdated:function setIndicatorsLastUpdated(lastUpdated){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsLastUpdated(lastUpdated));},setCountriesData:function setCountriesData(countriesData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setCountriesData(countriesData));},setSelectedRegionCountryMeta:function setSelectedRegionCountryMeta(countryMeta){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSelectedRegionCountryMeta(countryMeta));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__ContentContainer__["a" /* default */])));

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0),__webpack_require__(413)):"function"==typeof define&&define.amd?define(["react","highcharts"],t):"object"==typeof exports?exports.ReactHighcharts=t(require("react"),require("highcharts")):e.ReactHighcharts=t(e.React,e.Highcharts)}("undefined"!=typeof self?self:this,function(e,t){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=4)}([function(t,r){t.exports=e},function(e,t,r){"use strict";(function(n){Object.defineProperty(t,"__esModule",{value:!0});var o,i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},a=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),c=r(0),u=(o=c,o&&o.__esModule?o:{default:o});var f=void 0===n?window:n;t.default=function(t,r){var n=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(n,c.Component);function n(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n);var e=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return e.chartType=t,e.Highcharts=r,e.displayName="Highcharts"+t,e}return a(n,[{key:"setChartRef",value:function(e){this.chartRef=e}},{key:"renderChart",value:function(e){var t=this;if(!e)throw new Error("Config must be specified for the "+this.displayName+" component");var r=e.chart;this.chart=new this.Highcharts[this.chartType](i({},e,{chart:i({},r,{renderTo:this.chartRef})}),this.props.callback),this.props.neverReflow||f&&f.requestAnimationFrame&&requestAnimationFrame(function(){t.chart&&t.chart.options&&t.chart.reflow()})}},{key:"shouldComponentUpdate",value:function(e){return!!(e.neverReflow||e.isPureConfig&&this.props.config===e.config)||(this.renderChart(e.config),!1)}},{key:"getChart",value:function(){if(!this.chart)throw new Error("getChart() should not be called before the component is mounted");return this.chart}},{key:"componentDidMount",value:function(){this.renderChart(this.props.config)}},{key:"componentWillUnmount",value:function(){this.chart.destroy()}},{key:"render",value:function(){return u.default.createElement("div",i({ref:this.setChartRef.bind(this)},this.props.domProps))}}]),n}();n.defaultProps={callback:function(){},domProps:{}};var o=n;return o.Highcharts=r,o.withHighcharts=function(r){return e.exports(t,r)},o},e.exports=t.default}).call(t,r(2))},function(e,t){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(r=window)}e.exports=r},,function(e,t,r){e.exports=r(5)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=i(r(1)),o=i(r(6));function i(e){return e&&e.__esModule?e:{default:e}}t.default=(0,n.default)("Chart",o.default),e.exports=t.default},function(e,r){e.exports=t}])});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatQuerySingleGEOFromId=function formatQuerySingleGEOFromId(id){return'geo[0]='+id;};var formatQueryInDifferentGEOs=function formatQueryInDifferentGEOs(regionsData){var offset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var query='';regionsData.forEach(function(regionData,index){if(index!==0){query+='&';}query+='geo['+(offset+index)+']='+regionData.id;});return query;};var formatQueryInSameGEO=function formatQueryInSameGEO(regionsData){var query='';regionsData.forEach(function(regionData,index){if(index!==0){query+='&';}query+='geo[0]='+regionData.id;});return query;};var queryTools={formatQuerySingleGEOFromId:formatQuerySingleGEOFromId,formatQueryInDifferentGEOs:formatQueryInDifferentGEOs,formatQueryInSameGEO:formatQueryInSameGEO};/* harmony default export */ __webpack_exports__["a"] = (queryTools);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentChartTitle__ = __webpack_require__(1131);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ContentChartTitle__["a" /* default */]);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentChartFooter__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_0__ContentChartFooter__["a" /* default */]));

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentDateModal__ = __webpack_require__(1135);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ContentDateModal__["a" /* default */]);

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(423);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(16) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(174)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(15);


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(42);
var toIObject = __webpack_require__(43);
var arrayIndexOf = __webpack_require__(134)(false);
var IE_PROTO = __webpack_require__(176)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(80);

module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(43);
var gOPN = __webpack_require__(83).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(135);
var pIE = __webpack_require__(121);
var toObject = __webpack_require__(23);
var IObject = __webpack_require__(120);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(34);
var isObject = __webpack_require__(13);
var invoke = __webpack_require__(267);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 267 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(10).parseInt;
var $trim = __webpack_require__(100).trim;
var ws = __webpack_require__(180);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(10).parseFloat;
var $trim = __webpack_require__(100).trim;

module.exports = 1 / $parseFloat(__webpack_require__(180) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(50);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(13);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 272 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(183);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(34);
var toObject = __webpack_require__(23);
var IObject = __webpack_require__(120);
var toLength = __webpack_require__(18);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(18);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(16) && /./g.flags != 'g') __webpack_require__(17).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(139)
});


/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(198);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(282);
var validate = __webpack_require__(102);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(143)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(17).f;
var create = __webpack_require__(82);
var redefineAll = __webpack_require__(87);
var ctx = __webpack_require__(49);
var anInstance = __webpack_require__(85);
var forOf = __webpack_require__(86);
var $iterDefine = __webpack_require__(186);
var step = __webpack_require__(277);
var setSpecies = __webpack_require__(84);
var DESCRIPTORS = __webpack_require__(16);
var fastKey = __webpack_require__(69).fastKey;
var validate = __webpack_require__(102);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(282);
var validate = __webpack_require__(102);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(143)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(60)(0);
var redefine = __webpack_require__(39);
var meta = __webpack_require__(69);
var assign = __webpack_require__(265);
var weak = __webpack_require__(285);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(12);
var validate = __webpack_require__(102);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(143)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(87);
var getWeak = __webpack_require__(69).getWeak;
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var anInstance = __webpack_require__(85);
var forOf = __webpack_require__(86);
var createArrayMethod = __webpack_require__(60);
var $has = __webpack_require__(42);
var validate = __webpack_require__(102);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(18);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(83);
var gOPS = __webpack_require__(135);
var anObject = __webpack_require__(9);
var Reflect = __webpack_require__(10).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(136);
var isObject = __webpack_require__(13);
var toLength = __webpack_require__(18);
var ctx = __webpack_require__(49);
var IS_CONCAT_SPREADABLE = __webpack_require__(15)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(18);
var repeat = __webpack_require__(182);
var defined = __webpack_require__(57);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(80);
var toIObject = __webpack_require__(43);
var isEnum = __webpack_require__(121).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(122);
var from = __webpack_require__(292);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(86);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(296);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(300);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(201);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(649);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(150);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(206);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(677)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(207);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(150);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(151);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(206);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(686)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(693);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LanguageControllerContainer__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(68);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setLanguage:function setLanguage(language){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setLanguage(language));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__LanguageControllerContainer__["a" /* default */])));

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(316);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(727);
module.exports = __webpack_require__(36).Object.assign;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(107) && !__webpack_require__(108)(function () {
  return Object.defineProperty(__webpack_require__(318)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(106);
var document = __webpack_require__(73).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(90);
var toIObject = __webpack_require__(91);
var arrayIndexOf = __webpack_require__(730)(false);
var IE_PROTO = __webpack_require__(213)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(210);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(212);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(733);
var $Object = __webpack_require__(36).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_PropTypes__ = __webpack_require__(330);











var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * An HTML role attribute
   */
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: Object(__WEBPACK_IMPORTED_MODULE_10__utils_PropTypes__["b" /* generatedId */])('PanelGroup')
};
var defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    headerRole: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    panelRole: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelGroup, _React$Component);

  function PanelGroup() {
    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this, _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    }, _temp) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this);
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        accordion = _props.accordion,
        generateChildId = _props.generateChildId,
        id = _props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _props2 = this.props,
        accordion = _props2.accordion,
        className = _props2.className,
        children = _props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('panel-group', PanelGroup), {
  activeKey: 'onSelect'
}));

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(73);
var has = __webpack_require__(90);
var DESCRIPTORS = __webpack_require__(107);
var $export = __webpack_require__(67);
var redefine = __webpack_require__(325);
var META = __webpack_require__(738).KEY;
var $fails = __webpack_require__(108);
var shared = __webpack_require__(214);
var setToStringTag = __webpack_require__(218);
var uid = __webpack_require__(153);
var wks = __webpack_require__(61);
var wksExt = __webpack_require__(219);
var wksDefine = __webpack_require__(220);
var enumKeys = __webpack_require__(739);
var isArray = __webpack_require__(740);
var anObject = __webpack_require__(105);
var isObject = __webpack_require__(106);
var toIObject = __webpack_require__(91);
var toPrimitive = __webpack_require__(209);
var createDesc = __webpack_require__(124);
var _create = __webpack_require__(217);
var gOPNExt = __webpack_require__(741);
var $GOPD = __webpack_require__(327);
var $DP = __webpack_require__(89);
var $keys = __webpack_require__(109);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(326).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(125).f = $propertyIsEnumerable;
  __webpack_require__(216).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(152)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(104)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(104);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(319);
var hiddenKeys = __webpack_require__(215).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(125);
var createDesc = __webpack_require__(124);
var toIObject = __webpack_require__(91);
var toPrimitive = __webpack_require__(209);
var has = __webpack_require__(90);
var IE8_DOM_DEFINE = __webpack_require__(317);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(107) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(747);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(109);
var toIObject = __webpack_require__(91);
var isEnum = __webpack_require__(125).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generatedId;
/* harmony export (immutable) */ __webpack_exports__["c"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(37);



var idPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);
function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}
function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}
function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(52);







var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var defaultProps = {
  active: false
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.


    var linkProps = {
      href: href,
      title: title,
      target: target
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      })
    }, active ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", props) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, linkProps)));
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__);









var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};
var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({
        direction: null
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;
    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default.a.end(__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  _proto.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  _proto.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["direction", "active", "animateIn", "animateOut", "className"]);

    delete props.onAnimateOutEnd;
    delete props.index;
    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };

    if (direction && active && animateIn) {
      classes[direction] = true;
    }

    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(761);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(2);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(771);

var _PropTypes = __webpack_require__(772);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(111);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(776)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(338)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(152);
var $export = __webpack_require__(67);
var redefine = __webpack_require__(325);
var hide = __webpack_require__(104);
var Iterators = __webpack_require__(129);
var $iterCreate = __webpack_require__(777);
var setToStringTag = __webpack_require__(218);
var getPrototypeOf = __webpack_require__(778);
var ITERATOR = __webpack_require__(61)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(112);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(340);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(113);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(227);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(228);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(7);









var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);

    delete props.bsRole;
    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */];
    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.
    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      role: "button",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open
    }), children || props.title, useCaret && ' ', useCaret && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "caret"
    }));
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Grid, _React$Component);

  function Grid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["fluid", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('container', Grid));

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(33);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  listItem: false
};

var ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ListGroupItem, _React$Component);

  function ListGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4", {
      className: headingClassName
    }, header);
  };

  _proto.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["active", "disabled", "className", "header", "listItem", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes); // TODO: Deprecate `header` prop.

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p", {
        className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text')
      }, children));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, children);
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(161);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(111);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ModalBody, _React$Component);

  function ModalBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalBody.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(33);








var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};

var ModalDialog =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ModalDialog, _React$Component);

  function ModalDialog() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalDialog.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["dialogClassName", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
      display: 'block'
    }, style);

    var dialogClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      tabIndex: "-1",
      role: "dialog",
      style: modalStyle,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(dialogClassName, dialogClasses)
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'),
      role: "document"
    }, children)));
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalDialog.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ModalFooter, _React$Component);

  function ModalFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalFooter.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CloseButton__ = __webpack_require__(221);








 // TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ModalHeader, _React$Component);

  function ModalHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["closeLabel", "closeButton", "onHide", "className", "children"]);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), closeButton && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CloseButton__["a" /* default */], {
      label: closeLabel,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
    }), children);
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ModalTitle, _React$Component);

  function ModalTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalTitle.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(37);












 // TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
// TODO: This `bsStyle` is very unlike the others. Should we rename it?
// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
  })
};

var Nav =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Nav, _React$Component);

  function Nav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Nav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;
    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    });
    var childrenArray = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);
    var childNodes = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  _proto.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
      return tabContainer;
    }

    return this.props;
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    var _this2 = this;

    var children = this.props.children;
    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    }); // This assumes the active child is not disabled.

    var activeChildIndex = validChildren.indexOf(activeChild);

    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this3 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;

    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this3.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;

      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;

      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _extends2,
        _this4 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().

    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName;
    var pullRightClassName;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || {
        bsClass: 'navbar'
      };
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;
      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: role,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var active = _this4.isActive(child, activeKey, activeHref);

      var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
        active: active,
        activeKey: activeKey,
        activeHref: activeHref,
        onSelect: childOnSelect
      }));
    }));
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('nav', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarBrand =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(NavbarBrand, _React$Component);

  function NavbarBrand() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarBrand.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), children);
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(26);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  active: false,
  disabled: false
};

var NavItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(NavItem, _React$Component);

  function NavItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = NavItem.prototype;

  _proto.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  _proto.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["active", "disabled", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.

    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fade__ = __webpack_require__(159);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Overlay, _React$Component);

  function Overlay() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overlay.prototype;

  _proto.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["animation", "children"]);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */] : animation || null;
    var child;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      transition: transition
    }), child);
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(112);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(161);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(111);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(161);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(26);









var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PagerItem, _React$Component);

  function PagerItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleSelect = _this.handleSelect.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = PagerItem.prototype;

  _proto.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  _proto.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["disabled", "previous", "next", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        disabled: disabled,
        previous: previous,
        next: next
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
    })));
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(225);






var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  })
};

var PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
      "in": expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelCollapse));

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(26);









var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */]
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    bodyId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  })
};

var PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        componentClass = _props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, props);
  };

  return PanelToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (PanelToggle);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Fade__ = __webpack_require__(159);












var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};
/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null])
};

var TabPane =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(TabPane, _React$Component);

  function TabPane(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEnter = _this.handleEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.in = false;
    return _this;
  }

  var _proto = TabPane.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  _proto.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  _proto.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  _proto.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  _proto.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;
    return this.props.eventKey === activeKey;
  };

  _proto.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  _proto.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();
    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_11__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "tabpanel",
      "aria-hidden": !active,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Transition, {
        "in": active && !exiting,
        onEnter: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, pane);
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(126);






var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired
};

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ToggleButton, _React$Component);

  function ToggleButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["children", "name", "checked", "type", "onChange", "value"]);

    var disabled = props.disabled;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      active: !!checked,
      componentClass: "label"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      value: value,
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange
    }), children);
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegionChangerController__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(27);
var mapStateToProps=function mapStateToProps(state){return{regionsData:state.REGIONS.regionsData,countriesData:state.REGIONS.countriesData,selectedRegionId:state.REGIONS.selectedRegionId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSelectedRegionId:function setSelectedRegionId(selectedRegionId){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].setSelectedRegionId(selectedRegionId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__RegionChangerController__["a" /* default */])));

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenContainer = exports.menuItemContainer = exports.asyncContainer = exports.TypeaheadMenu = exports.Typeahead = exports.Token = exports.MenuItem = exports.Menu = exports.Highlighter = exports.AsyncTypeahead = undefined;

var _AsyncTypeahead2 = __webpack_require__(871);

var _AsyncTypeahead3 = _interopRequireDefault(_AsyncTypeahead2);

var _Highlighter2 = __webpack_require__(402);

var _Highlighter3 = _interopRequireDefault(_Highlighter2);

var _Menu2 = __webpack_require__(403);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(247);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

var _Token2 = __webpack_require__(396);

var _Token3 = _interopRequireDefault(_Token2);

var _Typeahead2 = __webpack_require__(387);

var _Typeahead3 = _interopRequireDefault(_Typeahead2);

var _TypeaheadMenu2 = __webpack_require__(401);

var _TypeaheadMenu3 = _interopRequireDefault(_TypeaheadMenu2);

var _asyncContainer2 = __webpack_require__(365);

var _asyncContainer3 = _interopRequireDefault(_asyncContainer2);

var _menuItemContainer2 = __webpack_require__(404);

var _menuItemContainer3 = _interopRequireDefault(_menuItemContainer2);

var _tokenContainer2 = __webpack_require__(397);

var _tokenContainer3 = _interopRequireDefault(_tokenContainer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AsyncTypeahead = _AsyncTypeahead3.default; /* eslint-disable object-curly-spacing */

// Components

exports.Highlighter = _Highlighter3.default;
exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.Token = _Token3.default;
exports.Typeahead = _Typeahead3.default;
exports.TypeaheadMenu = _TypeaheadMenu3.default;

// HOCs

exports.asyncContainer = _asyncContainer3.default;
exports.menuItemContainer = _menuItemContainer3.default;
exports.tokenContainer = _tokenContainer3.default;

/* eslint-enable object-curly-spacing */

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = __webpack_require__(872);

var _debounce2 = _interopRequireDefault(_debounce);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_DELAY_MS = 200;

/**
 * HoC that encapsulates common behavior and functionality for doing
 * asynchronous searches, including:
 *
 *  - Debouncing user input
 *  - Query caching (optional)
 *  - Search prompt and empty results behaviors
 */
var asyncContainer = function asyncContainer(Typeahead) {
  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedTypeahead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        query: ''
      }, _this._getEmptyLabel = function () {
        var _this$props = _this.props,
            emptyLabel = _this$props.emptyLabel,
            isLoading = _this$props.isLoading,
            promptText = _this$props.promptText,
            searchText = _this$props.searchText,
            useCache = _this$props.useCache;
        var query = _this.state.query;


        if (!query.length) {
          return promptText;
        }

        if (isLoading || useCache && !_this._cache[query]) {
          return searchText;
        }

        return emptyLabel;
      }, _this._handleInputChange = function (query, e) {
        _this.props.onInputChange && _this.props.onInputChange(query, e);
        _this._handleSearchDebounced(query);
      }, _this._handleSearch = function (query) {
        var _this$props2 = _this.props,
            minLength = _this$props2.minLength,
            onSearch = _this$props2.onSearch,
            useCache = _this$props2.useCache;


        _this.setState({ query: query });

        if (!query || minLength && query.length < minLength) {
          return;
        }

        // Use cached results, if available.
        if (useCache && _this._cache[query]) {
          return;
        }

        // Perform the search.
        onSearch(query);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedTypeahead, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this._cache = {};
        this._handleSearchDebounced = (0, _debounce2.default)(this._handleSearch, this.props.delay);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var options = nextProps.options,
            useCache = nextProps.useCache;


        if (!this.props.isLoading) {
          return;
        }

        if (useCache) {
          this._cache[this.state.query] = options;
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._cache = {};
        this._handleSearchDebounced.cancel();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            options = _props.options,
            useCache = _props.useCache,
            props = _objectWithoutProperties(_props, ['options', 'useCache']);

        var cachedQuery = this._cache[this.state.query];
        var emptyLabel = this._getEmptyLabel();

        // Short-circuit the creation of custom selections while the user is in
        // the process of searching. The logic for whether or not to display the
        // custom menu option is basically the same as whether we display the
        // empty label, so use that as a proxy.
        var allowNew = props.allowNew && emptyLabel === props.emptyLabel;
        // Unless allowNew is a function,
        // in which case it is up to the function to decide
        if (typeof props.allowNew === 'function') {
          allowNew = props.allowNew;
        }

        return _react2.default.createElement(Typeahead, _extends({}, props, {
          allowNew: allowNew,
          emptyLabel: emptyLabel,
          onInputChange: this._handleInputChange,
          options: useCache && cachedQuery ? cachedQuery : options,
          ref: function ref(instance) {
            return _this2._instance = instance;
          }
        }));
      }

      /**
       * Make the component instance available.
       */

    }, {
      key: 'getInstance',
      value: function getInstance() {
        return this._instance.getInstance();
      }
    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.displayName = 'AsyncContainer(' + (0, _utils.getDisplayName)(Typeahead) + ')';

  WrappedTypeahead.propTypes = {
    /**
     * Delay, in milliseconds, before performing search.
     */
    delay: _propTypes2.default.number,
    /**
     * Whether or not a request is currently pending. Necessary for the
     * container to know when new results are available.
     */
    isLoading: _propTypes2.default.bool.isRequired,
    /**
     * Callback to perform when the search is executed.
     */
    onSearch: _propTypes2.default.func.isRequired,
    /**
     * Options to be passed to the typeahead. Will typically be the query
     * results, but can also be initial default options.
     */
    options: _propTypes2.default.array,
    /**
     * Message displayed in the menu when there is no user input.
     */
    promptText: _propTypes2.default.node,
    /**
     * Message displayed in the menu while the request is pending.
     */
    searchText: _propTypes2.default.node,
    /**
     * Whether or not the component should cache query results.
     */
    useCache: _propTypes2.default.bool
  };

  WrappedTypeahead.defaultProps = {
    delay: DEFAULT_DELAY_MS,
    minLength: 2,
    options: [],
    promptText: 'Type to search...',
    searchText: 'Searching...',
    useCache: true
  };

  return WrappedTypeahead;
};

exports.default = asyncContainer;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(234);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(164),
    stackClear = __webpack_require__(885),
    stackDelete = __webpack_require__(886),
    stackGet = __webpack_require__(887),
    stackHas = __webpack_require__(888),
    stackSet = __webpack_require__(889);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(906),
    arraySome = __webpack_require__(371),
    cacheHas = __webpack_require__(909);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(62),
    stubFalse = __webpack_require__(923);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(374)(module)))

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(924),
    baseUnary = __webpack_require__(925),
    nodeUtil = __webpack_require__(926);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95),
    root = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(75);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(945);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(947),
    hasPath = __webpack_require__(948);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMatchBounds;

var _escapeStringRegexp = __webpack_require__(962);

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

var _stripDiacritics = __webpack_require__(244);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;

function getMatchBounds(subject, search) {
  search = new RegExp((0, _escapeStringRegexp2.default)((0, _stripDiacritics2.default)(search)), CASE_INSENSITIVE);

  var matches = search.exec((0, _stripDiacritics2.default)(subject));

  if (!matches) {
    return null;
  }

  var start = matches.index;
  var matchLength = matches[0].length;

  // Account for combining marks, which changes the indices.
  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start++;
      }
    }

    // Similarly, increment the length of the match string if it contains a
    // combining mark.
    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength++;
      }
    }
  }

  return {
    end: start + matchLength,
    start: start
  };
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94),
    getPrototype = __webpack_require__(963),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStringLabelKey;

var _defaultLabelKey = __webpack_require__(386);

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : _defaultLabelKey.DEFAULT_LABELKEY;
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_LABELKEY = exports.DEFAULT_LABELKEY = 'label';

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _pick = __webpack_require__(970);

var _pick2 = _interopRequireDefault(_pick);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _ClearButton = __webpack_require__(390);

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _Loader = __webpack_require__(985);

var _Loader2 = _interopRequireDefault(_Loader);

var _Overlay = __webpack_require__(986);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _TypeaheadInputMulti = __webpack_require__(1012);

var _TypeaheadInputMulti2 = _interopRequireDefault(_TypeaheadInputMulti);

var _TypeaheadInputSingle = __webpack_require__(1014);

var _TypeaheadInputSingle2 = _interopRequireDefault(_TypeaheadInputSingle);

var _TypeaheadMenu = __webpack_require__(401);

var _TypeaheadMenu2 = _interopRequireDefault(_TypeaheadMenu);

var _typeaheadContainer = __webpack_require__(1015);

var _typeaheadContainer2 = _interopRequireDefault(_typeaheadContainer);

var _utils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Typeahead = function (_React$Component) {
  _inherits(Typeahead, _React$Component);

  function Typeahead() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _this._renderInput = function (inputProps) {
      var Input = inputProps.multiple ? _TypeaheadInputMulti2.default : _TypeaheadInputSingle2.default;

      return _react2.default.createElement(Input, inputProps);
    }, _this._renderAux = function () {
      var _this$props = _this.props,
          bsSize = _this$props.bsSize,
          clearButton = _this$props.clearButton,
          disabled = _this$props.disabled,
          isLoading = _this$props.isLoading,
          onClear = _this$props.onClear,
          selected = _this$props.selected;


      var content = void 0;

      if (isLoading) {
        content = _react2.default.createElement(_Loader2.default, { bsSize: bsSize });
      } else if (clearButton && !disabled && selected.length) {
        content = _react2.default.createElement(_ClearButton2.default, {
          bsSize: bsSize,
          onClick: onClear,
          onFocus: function onFocus(e) {
            // Prevent the main input from auto-focusing again.
            e.stopPropagation();
          },
          onMouseDown: _utils.preventInputBlur
        });
      }

      return content ? _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('rbt-aux', {
            'rbt-aux-lg': bsSize === 'large' || bsSize === 'lg'
          }) },
        content
      ) : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Typeahead, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var allowNew = nextProps.allowNew,
          onInitialItemChange = nextProps.onInitialItemChange,
          results = nextProps.results;

      // Clear the initial item when there are no results.

      if (!(allowNew || results.length)) {
        onInitialItemChange(null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          bodyContainer = _props.bodyContainer,
          children = _props.children,
          className = _props.className,
          isMenuShown = _props.isMenuShown,
          menuId = _props.menuId,
          renderMenu = _props.renderMenu,
          results = _props.results;


      var inputProps = (0, _pick2.default)(this.props, ['activeIndex', 'activeItem', 'bsSize', 'disabled', 'initialItem', 'inputProps', 'inputRef', 'isInvalid', 'isMenuShown', 'isValid', 'labelKey', 'menuId', 'multiple', 'onAdd', 'onBlur', 'onChange', 'onFocus', 'onKeyDown', 'onRemove', 'placeholder', 'renderToken', 'selected', 'selectHintOnEnter', 'text']);

      var overlayProps = (0, _pick2.default)(this.props, ['align', 'className', 'dropup', 'flip', 'onMenuHide', 'onMenuShow']);

      var menuProps = (0, _pick2.default)(this.props, ['emptyLabel', 'labelKey', 'maxHeight', 'newSelectionPrefix', 'renderMenuItemChildren', 'text']);

      var auxContent = this._renderAux();

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('rbt', 'clearfix', 'open', {
            'has-aux': !!auxContent
          }, className),
          style: { position: 'relative' },
          tabIndex: -1 },
        this._renderInput(_extends({}, inputProps, {
          // Use `findDOMNode` here since it's easier and less fragile than
          // forwarding refs down to the input's container.
          // TODO: Consider using `forwardRef` when React 16.3 usage is higher.
          ref: function ref(node) {
            return _this2._inputContainer = (0, _reactDom.findDOMNode)(node);
          }
        })),
        typeof children === 'function' ? children(this.props) : children,
        auxContent,
        _react2.default.createElement(
          _Overlay2.default,
          _extends({}, overlayProps, {
            container: bodyContainer ? document.body : this,
            referenceElement: this._inputContainer,
            show: isMenuShown }),
          renderMenu(results, _extends({}, menuProps, { id: menuId }))
        ),
        _react2.default.createElement(
          'div',
          {
            'aria-atomic': true,
            'aria-live': 'polite',
            className: 'sr-only rbt-sr-status',
            role: 'status' },
          (0, _utils.getAccessibilityStatus)(this.props)
        )
      );
    }
  }]);

  return Typeahead;
}(_react2.default.Component);

Typeahead.propTypes = {
  renderMenu: _propTypes2.default.func
};

Typeahead.defaultProps = {
  renderMenu: function renderMenu(results, menuProps) {
    return _react2.default.createElement(_TypeaheadMenu2.default, _extends({}, menuProps, { options: results }));
  }
};

exports.default = (0, _typeaheadContainer2.default)(Typeahead);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(976),
    overRest = __webpack_require__(979),
    setToString = __webpack_require__(981);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var bsSize = _ref.bsSize,
      className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['bsSize', 'className', 'label', 'onClick']);

  return _react2.default.createElement(
    'button',
    _extends({}, props, {
      'aria-label': label,
      className: (0, _classnames2.default)('close', 'rbt-close', {
        'rbt-close-lg': bsSize === 'large' || bsSize === 'lg'
      }, className),
      onClick: function onClick(e) {
        e.stopPropagation();
        _onClick(e);
      },
      type: 'button' }),
    _react2.default.createElement(
      'span',
      { 'aria-hidden': 'true' },
      '\xD7'
    ),
    _react2.default.createElement(
      'span',
      { className: 'sr-only' },
      label
    )
  );
};

ClearButton.propTypes = {
  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm']),
  label: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};

ClearButton.defaultProps = {
  label: 'Clear'
};

exports.default = ClearButton;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(988);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(394);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(989);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(995);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1000);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1004);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(394);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClearButton = __webpack_require__(390);

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _tokenContainer = __webpack_require__(397);

var _tokenContainer2 = _interopRequireDefault(_tokenContainer);

var _keyCode = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Token
 *
 * Individual token component, generally displayed within the TokenizerInput
 * component, but can also be rendered on its own.
 */
var Token = function (_React$Component) {
  _inherits(Token, _React$Component);

  function Token() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Token);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Token.__proto__ || Object.getPrototypeOf(Token)).call.apply(_ref, [this].concat(args))), _this), _this._renderRemoveableToken = function () {
      var _this$props = _this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          onRemove = _this$props.onRemove,
          props = _objectWithoutProperties(_this$props, ['active', 'children', 'className', 'onRemove']);

      return _react2.default.createElement(
        'div',
        _extends({}, props, {
          className: (0, _classnames2.default)('rbt-token', 'rbt-token-removeable', {
            'rbt-token-active': active
          }, className) }),
        children,
        _react2.default.createElement(_ClearButton2.default, {
          className: 'rbt-token-remove-button',
          label: 'Remove',
          onClick: onRemove,
          onKeyDown: _this._handleRemoveButtonKeydown,
          tabIndex: -1
        })
      );
    }, _this._renderToken = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          href = _this$props2.href;

      var classnames = (0, _classnames2.default)('rbt-token', {
        'rbt-token-disabled': disabled
      }, className);

      if (href) {
        return _react2.default.createElement(
          'a',
          { className: classnames, href: href },
          children
        );
      }

      return _react2.default.createElement(
        'div',
        { className: classnames },
        children
      );
    }, _this._handleRemoveButtonKeydown = function (e) {
      switch (e.keyCode) {
        case _keyCode.RETURN:
          _this.props.onRemove();
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Token, [{
    key: 'render',
    value: function render() {
      return this.props.onRemove && !this.props.disabled ? this._renderRemoveableToken() : this._renderToken();
    }
  }]);

  return Token;
}(_react2.default.Component);

Token.propTypes = {
  active: _propTypes2.default.bool,
  /**
   * Handler for removing/deleting the token. If not defined, the token will
   * be rendered in a read-only state.
   */
  onRemove: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};

Token.defaultProps = {
  active: false,
  tabIndex: 0
};

exports.default = (0, _tokenContainer2.default)(Token);

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactOnclickoutside = __webpack_require__(398);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _utils = __webpack_require__(55);

var _keyCode = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Higher-order component that encapsulates Token behaviors, allowing them to
 * be easily re-used.
 */
var tokenContainer = function tokenContainer(Component) {
  var WrappedComponent = function (_React$Component) {
    _inherits(WrappedComponent, _React$Component);

    function WrappedComponent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this._handleBlur = function (e) {
        _this.setState({ active: false });
      }, _this._handleKeyDown = function (e) {
        switch (e.keyCode) {
          case _keyCode.BACKSPACE:
            if (_this.state.active) {
              // Prevent backspace keypress from triggering the browser "back"
              // action.
              e.preventDefault();
              _this.props.onRemove();
            }
            break;
        }
      }, _this.handleClickOutside = function (e) {
        _this._handleBlur();
      }, _this._handleActive = function (e) {
        e.stopPropagation();
        _this.setState({ active: true });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedComponent, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            disableOnClickOutside = _props.disableOnClickOutside,
            enableOnClickOutside = _props.enableOnClickOutside,
            eventTypes = _props.eventTypes,
            outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
            preventDefault = _props.preventDefault,
            stopPropagation = _props.stopPropagation,
            tokenProps = _objectWithoutProperties(_props, ['disableOnClickOutside', 'enableOnClickOutside', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation']);

        return _react2.default.createElement(Component, _extends({}, tokenProps, this.state, {
          onBlur: this._handleBlur,
          onClick: this._handleActive,
          onFocus: this._handleActive,
          onKeyDown: this._handleKeyDown
        }));
      }

      /**
       * From `onClickOutside` HOC.
       */

    }]);

    return WrappedComponent;
  }(_react2.default.Component);

  WrappedComponent.displayName = 'TokenContainer(' + (0, _utils.getDisplayName)(Component) + ')';

  return (0, _reactOnclickoutside2.default)(WrappedComponent);
};

exports.default = tokenContainer;

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(55);

var _keyCode = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function interpolateStyle(styles, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  // Title-case the sub-attribute.
  if (subattr) {
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }

  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles[attr + dir + subattr];
  }).join(' ');
}

function copyStyles(inputNode, hintNode) {
  var inputStyle = window.getComputedStyle(inputNode);

  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
}

function hintContainer(Input) {
  var HintedInput = function (_React$Component) {
    _inherits(HintedInput, _React$Component);

    function HintedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, HintedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HintedInput.__proto__ || Object.getPrototypeOf(HintedInput)).call.apply(_ref, [this].concat(args))), _this), _this._handleKeyDown = function (e) {
        var _this$context = _this.context,
            hintText = _this$context.hintText,
            initialItem = _this$context.initialItem,
            onAdd = _this$context.onAdd,
            selectHintOnEnter = _this$context.selectHintOnEnter;
        var _this$props = _this.props,
            onKeyDown = _this$props.onKeyDown,
            value = _this$props.value;


        if (hintText && (e.keyCode === _keyCode.RETURN && selectHintOnEnter || e.keyCode === _keyCode.RIGHT && e.target.selectionStart === value.length || e.keyCode === _keyCode.TAB)) {
          e.preventDefault(); // Prevent input from blurring on TAB.
          onAdd(initialItem);
        }

        onKeyDown(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HintedInput, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        copyStyles(this._input, this._hint);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        copyStyles(this._input, this._hint);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          {
            className: 'rbt-input-hint-container',
            style: { position: 'relative' } },
          _react2.default.createElement(Input, _extends({}, this.props, {
            inputRef: function inputRef(input) {
              _this2._input = input;
              _this2.props.inputRef(input);
            },
            onKeyDown: this._handleKeyDown
          })),
          _react2.default.createElement('input', {
            'aria-hidden': true,
            className: 'rbt-input-hint',
            ref: function ref(hint) {
              return _this2._hint = hint;
            },
            style: {
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              boxShadow: 'none',
              color: 'rgba(0, 0, 0, 0.35)',
              left: 0,
              pointerEvents: 'none',
              position: 'absolute',
              top: 0
            },
            tabIndex: -1,
            value: this.context.hintText
          })
        );
      }
    }]);

    return HintedInput;
  }(_react2.default.Component);

  HintedInput.displayName = 'HintContainer(' + (0, _utils.getDisplayName)(Input) + ')';

  HintedInput.contextTypes = {
    hintText: _propTypes2.default.string.isRequired,
    initialItem: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.string.isRequired]),
    onAdd: _propTypes2.default.func.isRequired,
    selectHintOnEnter: _propTypes2.default.bool.isRequired
  };

  return HintedInput;
}

exports.default = hintContainer;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function inputContainer(Input) {
  var WrappedInput = function (_React$Component) {
    _inherits(WrappedInput, _React$Component);

    function WrappedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedInput.__proto__ || Object.getPrototypeOf(WrappedInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isFocused: false
      }, _this._handleBlur = function (e) {
        e.persist();
        _this.setState({ isFocused: false }, function () {
          return _this.props.onBlur(e);
        });
      }, _this._handleFocus = function (e) {
        e.persist();
        _this.setState({ isFocused: true }, function () {
          return _this.props.onFocus(e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedInput, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            initialItem = _props.initialItem,
            onAdd = _props.onAdd,
            selectHintOnEnter = _props.selectHintOnEnter;


        return {
          hintText: (0, _utils.getHintText)(this.props),
          initialItem: initialItem,
          onAdd: onAdd,
          selectHintOnEnter: selectHintOnEnter
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _cx;

        var _props2 = this.props,
            activeIndex = _props2.activeIndex,
            bsSize = _props2.bsSize,
            disabled = _props2.disabled,
            inputRef = _props2.inputRef,
            isInvalid = _props2.isInvalid,
            isMenuShown = _props2.isMenuShown,
            isValid = _props2.isValid,
            labelKey = _props2.labelKey,
            menuId = _props2.menuId,
            multiple = _props2.multiple,
            onChange = _props2.onChange,
            onKeyDown = _props2.onKeyDown,
            onRemove = _props2.onRemove,
            placeholder = _props2.placeholder,
            renderToken = _props2.renderToken,
            selected = _props2.selected;

        // Add a11y-related props.

        var inputProps = _extends({}, this.props.inputProps, {
          'aria-activedescendant': activeIndex >= 0 ? (0, _utils.getMenuItemId)(activeIndex) : '',
          'aria-autocomplete': multiple ? 'list' : 'both',
          'aria-expanded': isMenuShown,
          'aria-haspopup': 'listbox',
          'aria-owns': menuId,
          autoComplete: this.props.inputProps.autoComplete || 'nope',
          disabled: disabled,
          inputRef: inputRef,
          onBlur: this._handleBlur,
          onChange: onChange,
          // Re-open the menu, eg: if it's closed via ESC.
          onClick: this._handleFocus,
          onFocus: this._handleFocus,
          onKeyDown: onKeyDown,
          placeholder: selected.length ? null : placeholder,
          // Comboboxes are single-select by definition:
          // https://www.w3.org/TR/wai-aria-practices-1.1/#combobox
          role: 'combobox',
          value: (0, _utils.getInputText)(this.props)
        });

        var className = inputProps.className || '';

        if (multiple) {
          inputProps = _extends({}, inputProps, {
            inputClassName: className,
            labelKey: labelKey,
            onRemove: onRemove,
            renderToken: renderToken,
            role: '',
            selected: selected
          });
        }

        return _react2.default.createElement(Input, _extends({}, inputProps, {
          className: (0, _classnames2.default)('rbt-input', (_cx = {}, _defineProperty(_cx, className, !multiple), _defineProperty(_cx, 'focus', this.state.isFocused), _defineProperty(_cx, 'input-lg form-control-lg', bsSize === 'large' || bsSize === 'lg'), _defineProperty(_cx, 'input-sm form-control-sm', bsSize === 'small' || bsSize === 'sm'), _defineProperty(_cx, 'is-invalid', isInvalid), _defineProperty(_cx, 'is-valid', isValid), _cx))
        }));
      }
    }]);

    return WrappedInput;
  }(_react2.default.Component);

  WrappedInput.displayName = 'InputContainer(' + (0, _utils.getDisplayName)(Input) + ')';

  WrappedInput.childContextTypes = {
    hintText: _propTypes2.default.string.isRequired,
    initialItem: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.string.isRequired]),
    onAdd: _propTypes2.default.func.isRequired,
    selectHintOnEnter: _propTypes2.default.bool.isRequired
  };

  return WrappedInput;
}

exports.default = inputContainer;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Highlighter = __webpack_require__(402);

var _Highlighter2 = _interopRequireDefault(_Highlighter);

var _Menu = __webpack_require__(403);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(247);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _utils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeaheadMenu = function (_React$Component) {
  _inherits(TypeaheadMenu, _React$Component);

  function TypeaheadMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeaheadMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeaheadMenu.__proto__ || Object.getPrototypeOf(TypeaheadMenu)).call.apply(_ref, [this].concat(args))), _this), _this._renderMenuItem = function (option, idx) {
      var _this$props = _this.props,
          labelKey = _this$props.labelKey,
          newSelectionPrefix = _this$props.newSelectionPrefix,
          renderMenuItemChildren = _this$props.renderMenuItemChildren,
          text = _this$props.text;


      var label = (0, _utils.getOptionLabel)(option, labelKey);

      var menuItemProps = {
        disabled: option.disabled,
        key: idx,
        label: label,
        option: option,
        position: idx
      };

      if (option.customOption) {
        return _react2.default.createElement(
          _MenuItem2.default,
          _extends({}, menuItemProps, {
            className: 'rbt-menu-custom-option',
            label: newSelectionPrefix + label }),
          newSelectionPrefix,
          _react2.default.createElement(
            _Highlighter2.default,
            { search: text },
            label
          )
        );
      }

      if (option.paginationOption) {
        return [_react2.default.createElement(_Menu2.default.Divider, { key: 'pagination-item-divider' }), _react2.default.createElement(
          _MenuItem2.default,
          _extends({}, menuItemProps, {
            className: 'rbt-menu-pagination-option',
            key: 'pagination-item' }),
          label
        )];
      }

      return _react2.default.createElement(
        _MenuItem2.default,
        menuItemProps,
        renderMenuItemChildren(option, _this.props, idx)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeaheadMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          labelKey = _props.labelKey,
          newSelectionPrefix = _props.newSelectionPrefix,
          options = _props.options,
          renderMenuItemChildren = _props.renderMenuItemChildren,
          text = _props.text,
          menuProps = _objectWithoutProperties(_props, ['labelKey', 'newSelectionPrefix', 'options', 'renderMenuItemChildren', 'text']);

      return _react2.default.createElement(
        _Menu2.default,
        menuProps,
        options.map(this._renderMenuItem)
      );
    }
  }]);

  return TypeaheadMenu;
}(_react2.default.Component);

TypeaheadMenu.propTypes = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: _propTypes2.default.string,
  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: _propTypes2.default.func
};

TypeaheadMenu.defaultProps = {
  newSelectionPrefix: 'New selection: ',
  renderMenuItemChildren: function renderMenuItemChildren(option, props, idx) {
    return _react2.default.createElement(
      _Highlighter2.default,
      { search: props.text },
      (0, _utils.getOptionLabel)(option, props.labelKey)
    );
  }
};

exports.default = TypeaheadMenu;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = function (_React$Component) {
  _inherits(Highlighter, _React$Component);

  function Highlighter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Highlighter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Highlighter.__proto__ || Object.getPrototypeOf(Highlighter)).call.apply(_ref, [this].concat(args))), _this), _this._count = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Highlighter, [{
    key: 'render',
    value: function render() {
      var children = this.props.search ? this._renderHighlightedChildren() : this.props.children;

      return _react2.default.createElement(
        'span',
        null,
        children
      );
    }
  }, {
    key: '_renderHighlightedChildren',
    value: function _renderHighlightedChildren() {
      var children = [];
      var remaining = this.props.children;

      while (remaining) {
        var bounds = (0, _utils.getMatchBounds)(remaining, this.props.search);

        if (!bounds) {
          this._count++;
          children.push(_react2.default.createElement(
            'span',
            { key: this._count },
            remaining
          ));
          return children;
        }

        // Capture the string that leads up to a match...
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) {
          this._count++;
          children.push(_react2.default.createElement(
            'span',
            { key: this._count },
            nonMatch
          ));
        }

        // Now, capture the matching string...
        var match = remaining.slice(bounds.start, bounds.end);
        if (match) {
          this._count++;
          children.push(_react2.default.createElement(
            'mark',
            { className: 'rbt-highlight-text', key: this._count },
            match
          ));
        }

        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
      }

      return children;
    }
  }]);

  return Highlighter;
}(_react2.default.Component);

Highlighter.propTypes = {
  children: _propTypes2.default.string.isRequired,
  search: _propTypes2.default.string.isRequired
};

exports.default = Highlighter;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isRequiredForA11y = __webpack_require__(128);

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MenuItem = __webpack_require__(247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu = function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          emptyLabel = _props.emptyLabel,
          id = _props.id,
          innerRef = _props.innerRef,
          maxHeight = _props.maxHeight,
          style = _props.style;


      var contents = _react.Children.count(children) === 0 ? _react2.default.createElement(
        _MenuItem.BaseMenuItem,
        { disabled: true },
        emptyLabel
      ) : children;

      return _react2.default.createElement(
        'ul',
        {
          className: (0, _classnames2.default)('rbt-menu', 'dropdown-menu', 'show', className),
          id: id,
          ref: innerRef,
          role: 'listbox',
          style: _extends({}, style, {
            display: 'block',
            maxHeight: maxHeight,
            overflow: 'auto'
          }) },
        contents
      );
    }
  }]);

  return Menu;
}(_react2.default.Component);

Menu.propTypes = {
  /**
   * Needed for accessibility.
   */
  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: _propTypes2.default.string
};

Menu.defaultProps = {
  maxHeight: '300px'
};

Menu.Divider = function (props) {
  return _react2.default.createElement('li', { className: 'divider dropdown-divider', role: 'separator' });
};

Menu.Header = function (props) {
  return _react2.default.createElement('li', _extends({}, props, { className: 'dropdown-header' }));
};

exports.default = Menu;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _utils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var menuItemContainer = function menuItemContainer(Component) {
  var WrappedMenuItem = function (_React$Component) {
    _inherits(WrappedMenuItem, _React$Component);

    function WrappedMenuItem() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedMenuItem);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedMenuItem.__proto__ || Object.getPrototypeOf(WrappedMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
        var _this$props = _this.props,
            option = _this$props.option,
            onClick = _this$props.onClick;


        _this.context.onMenuItemClick(option, e);
        onClick && onClick(e);
      }, _this._updateInitialItem = function (props) {
        var option = props.option,
            position = props.position;

        if (position === 0) {
          _this.context.onInitialItemChange(option);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedMenuItem, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this._updateInitialItem(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var currentlyActive = this.context.activeIndex === this.props.position;
        var option = nextProps.option,
            position = nextProps.position;
        var activeIndex = nextContext.activeIndex,
            onActiveItemChange = nextContext.onActiveItemChange;


        if (position == null) {
          return;
        }

        // The item will become active.
        if (activeIndex === position) {
          // Ensures that if the menu items exceed the bounds of the menu, the
          // menu will scroll up or down as the user hits the arrow keys.
          (0, _utils.scrollIntoViewIfNeeded)((0, _reactDom.findDOMNode)(this));

          // Fire the change handler when the menu item becomes active.
          !currentlyActive && onActiveItemChange(option);
        }

        this._updateInitialItem(nextProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _context = this.context,
            activeIndex = _context.activeIndex,
            isOnlyResult = _context.isOnlyResult;

        var _props = this.props,
            label = _props.label,
            option = _props.option,
            position = _props.position,
            props = _objectWithoutProperties(_props, ['label', 'option', 'position']);

        var active = isOnlyResult || activeIndex === position;

        return _react2.default.createElement(Component, _extends({}, props, {
          active: active,
          'aria-label': label,
          'aria-selected': active,
          id: (0, _utils.getMenuItemId)(position),
          onClick: this._handleClick,
          onMouseDown: _utils.preventInputBlur,
          role: 'option'
        }));
      }
    }]);

    return WrappedMenuItem;
  }(_react2.default.Component);

  WrappedMenuItem.displayName = 'MenuItemContainer(' + (0, _utils.getDisplayName)(Component) + ')';

  WrappedMenuItem.propTypes = {
    option: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
    position: _propTypes2.default.number
  };

  WrappedMenuItem.contextTypes = {
    activeIndex: _propTypes2.default.number.isRequired,
    isOnlyResult: _propTypes2.default.bool.isRequired,
    onActiveItemChange: _propTypes2.default.func.isRequired,
    onInitialItemChange: _propTypes2.default.func.isRequired,
    onMenuItemClick: _propTypes2.default.func.isRequired
  };

  return WrappedMenuItem;
};

exports.default = menuItemContainer;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(75);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(1018),
    noop = __webpack_require__(248);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1019);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MiniMap__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selecedRegionId,selectedRegionCountryMeta:state.REGIONS.selectedRegionCountryMeta};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__MiniMap__["a" /* default */])));

/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({columnRegion:{id:'PanelSection.columnRegion',description:'Cabecera de columna',defaultMessage:'Región'},columnCountry:{id:'PanelSection.columnCountry',description:'Cabecera de columna',defaultMessage:'País'},columnEU:{id:'PanelSection.columnEU',description:'Cabecera de columna',defaultMessage:'UE27 <small>(2020)</small>'},columnRanking:{id:'PanelSection.columnRanking',description:'Cabecera de columna',defaultMessage:'Ranking'},columnEvolution:{id:'PanelSection.columnEvolution',description:'Cabecera de columna',defaultMessage:'Evolución'},rankingTooltip:{id:'PanelRowCointaner.rankingTooltip',description:'Texto para explicar el ranking',defaultMessage:'Posición de la región frente al resto de regiones de UE27 con datos disponibles'},dimensionLinkTooltip:{id:'PanelRowCointaner.dimensionLinkTooltip',description:'Tooltip para panel de dimensión',defaultMessage:'Ver dimensión <strong>{dimensionTitle}</strong> con detalle y comparaciones adicionales'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(412);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var formatMessage=null;var importFormatter=function importFormatter(importedFormatter){formatMessage=importedFormatter;};var rankData=function rankData(_ref){var data=_ref.data,rankOrdering=_ref.rankOrdering;var orderedData=data.sort(function(a,b){return b.value-a.value;});if(rankOrdering!=='descending'){orderedData=orderedData.reverse();}return orderedData;};var firstComparableSet=function firstComparableSet(data,regionIds,times,threshold,geo_key){// serach for first set of annual values with at least threshold percentage of valid values
var regionsData=data.filter(function(d){return regionIds.indexOf(d[geo_key])>=0;});var min_n_values=regionIds.length*threshold;var _loop=function _loop(time){var values=regionsData.filter(function(d){return d["time"]===time&d["value"]!=null;});if(values.length>=min_n_values){return{v:values};}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=times[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var time=_step.value;var _ret=_loop(time);if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return null;};var formatRankingSeries=function formatRankingSeries(_ref2){var data=_ref2.data,regionsData=_ref2.regionsData,selectedRegionId=_ref2.selectedRegionId,comparativeData=_ref2.comparativeData,color=_ref2.color,rankOrdering=_ref2.rankOrdering;var orderedData=orderRankingData({data:data,regionsData:regionsData,rankOrdering:rankOrdering});var series=[];var selectedRegionSerie=void 0;var comparativeSerie=void 0;var totalRegions=orderedData.length;var comparativeRegionId=void 0;if(comparativeData!==null&&!comparativeData.isCountry){comparativeRegionId=Number(comparativeData.data.query.geo[0]);}orderedData.forEach(function(item,index){var serie=void 0;if(Number(item.id)===selectedRegionId){selectedRegionSerie=formatRankingForSelectedRegion({name:item.name,index:index,totalRegions:totalRegions,value:item.value,color:color});}else if(comparativeRegionId&&Number(item.id)===comparativeRegionId){comparativeSerie=formatRankingForComparativeWithRegion({name:item.name,index:index,totalRegions:totalRegions,value:item.value,color:color});}else{serie=formatRankingForOtherRegions({name:item.name,index:index,totalRegions:totalRegions,value:item.value});series.push(serie);}});if(comparativeData!==null&&comparativeData.isCountry){comparativeSerie=formatRankingForComparativeWithCountry({name:comparativeData.countryFullName,value:comparativeData.data.data[0].value,color:color});}if(comparativeData!==null&&comparativeSerie)series.push(comparativeSerie);if(selectedRegionSerie)series.push(selectedRegionSerie);return series;};var orderRankingData=function orderRankingData(_ref3){var data=_ref3.data,regionsData=_ref3.regionsData,rankOrdering=_ref3.rankOrdering;var usefulData=data.data.map(function(item){return{name:__WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({id:data.query.geo[item.geoset],regionsData:regionsData}),id:data.query.geo[item.geoset],value:item.value};});var orderedData=usefulData.sort(function(a,b){return b.value-a.value;});if(rankOrdering!=='descending')orderedData=orderedData.reverse();return orderedData;};var formatRankingForSelectedRegion=function formatRankingForSelectedRegion(_ref4){var name=_ref4.name,index=_ref4.index,totalRegions=_ref4.totalRegions,value=_ref4.value,color=_ref4.color;return{name:''+name,marker:{radius:13,fillColor:__WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__["a" /* default */].colorToRGBA(color),lineColor:__WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__["a" /* default */].colorToRGBA(color),lineWidth:2},data:[{name:formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].rankingTooltip,{position:index+1,totalRegions:totalRegions}),x:value,y:0}]};};var formatRankingForComparativeWithCountry=function formatRankingForComparativeWithCountry(_ref5){var name=_ref5.name,value=_ref5.value,color=_ref5.color;return{name:''+name,marker:{radius:13,fillColor:'#FFFFFF',lineColor:__WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__["a" /* default */].colorToRGBA(color,1),lineWidth:2},data:[{name:'',x:value,y:0}]};};var formatRankingForComparativeWithRegion=function formatRankingForComparativeWithRegion(_ref6){var name=_ref6.name,index=_ref6.index,totalRegions=_ref6.totalRegions,value=_ref6.value,color=_ref6.color;return{name:''+name,marker:{radius:13,fillColor:'#FFFFFF',lineColor:__WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__["a" /* default */].colorToRGBA(color,1),lineWidth:2},data:[{name:formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].rankingTooltip,{position:index+1,totalRegions:totalRegions}),x:value,y:0}]};};var formatRankingForOtherRegions=function formatRankingForOtherRegions(_ref7){var name=_ref7.name,index=_ref7.index,totalRegions=_ref7.totalRegions,value=_ref7.value;return{name:''+name,data:[{name:formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].rankingTooltip,{position:index+1,totalRegions:totalRegions}),x:value,y:0}]};};var panelRowValuesAdapter={formatRankingSeries:formatRankingSeries,importFormatter:importFormatter,firstComparableSet:firstComparableSet,rankData:rankData};/* harmony default export */ __webpack_exports__["a"] = (panelRowValuesAdapter);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({rankingTooltip:{id:'RankingChart.rankingTooltip',description:'Texto para indicar la posición de la region en el ranking',defaultMessage:'Posición {position} de {totalRegions}'},noDataAvailable:{id:'RankingChart.noDataAvailable',description:'Texto para indicar que no hay datos disponibles',defaultMessage:'No hay datos disponibles'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.1.2 (2018-08-31)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(T,K){"object"===typeof module&&module.exports?module.exports=T.document?K(T):K: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return K(T)}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):T.Highcharts=K(T)})("undefined"!==typeof window?window:this,function(T){var K=function(){var a="undefined"===typeof T?window:T,C=a.document,D=a.navigator&&a.navigator.userAgent||"",E=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,m=/(edge|msie|trident)/i.test(D)&&!a.opera,h=-1!==D.indexOf("Firefox"),
f=-1!==D.indexOf("Chrome"),r=h&&4>parseInt(D.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",version:"6.1.2",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:r,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:m,isWebKit:-1!==D.indexOf("AppleWebKit"),isFirefox:h,isChrome:f,isSafari:!f&&-1!==D.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(D),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:E,win:a,marginNames:["plotTop",
"marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var C=a.charts,D=a.doc,E=a.win;a.error=function(m,h){m=a.isNumber(m)?"Highcharts error #"+m+": www.highcharts.com/errors/"+m:m;if(h)throw Error(m);E.console&&console.log(m)};a.Fx=function(a,h,f){this.options=h;this.elem=a;this.prop=f};a.Fx.prototype={dSetter:function(){var a=this.paths[0],h=this.paths[1],f=[],r=this.now,y=a.length,q;if(1===r)f=this.toD;else if(y===h.length&&1>r)for(;y--;)q=parseFloat(a[y]),
f[y]=isNaN(q)?h[y]:r*parseFloat(h[y]-q)+q;else f=h;this.elem.attr("d",f,null,!0)},update:function(){var a=this.elem,h=this.prop,f=this.now,r=this.options.step;if(this[h+"Setter"])this[h+"Setter"]();else a.attr?a.element&&a.attr(h,f,null,!0):a.style[h]=f+this.unit;r&&r.call(a,f,this)},run:function(m,h,f){var r=this,y=r.options,q=function(a){return q.stopped?!1:r.step(a)},w=E.requestAnimationFrame||function(a){setTimeout(a,13)},e=function(){for(var c=0;c<a.timers.length;c++)a.timers[c]()||a.timers.splice(c--,
1);a.timers.length&&w(e)};m!==h||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=m,this.end=h,this.unit=f,this.now=this.start,this.pos=0,q.elem=this.elem,q.prop=this.prop,q()&&1===a.timers.push(q)&&w(e)):(delete y.curAnim[this.prop],y.complete&&0===a.keys(y.curAnim).length&&y.complete.call(this.elem))},step:function(m){var h=+new Date,f,r=this.options,y=this.elem,q=r.complete,w=r.duration,e=r.curAnim;y.attr&&!y.element?m=!1:m||h>=w+this.startTime?(this.now=this.end,this.pos=
1,this.update(),f=e[this.prop]=!0,a.objectEach(e,function(a){!0!==a&&(f=!1)}),f&&q&&q.call(y),m=!1):(this.pos=r.easing((h-this.startTime)/w),this.now=this.start+(this.end-this.start)*this.pos,this.update(),m=!0);return m},initPath:function(m,h,f){function r(a){var d,k;for(b=a.length;b--;)d="M"===a[b]||"L"===a[b],k=/[a-zA-Z]/.test(a[b+3]),d&&k&&a.splice(b+1,0,a[b+1],a[b+2],a[b+1],a[b+2])}function y(a,d){for(;a.length<k;){a[0]=d[k-a.length];var c=a.slice(0,z);[].splice.apply(a,[0,0].concat(c));u&&(c=
a.slice(a.length-z),[].splice.apply(a,[a.length,0].concat(c)),b--)}a[0]="M"}function q(a,b){for(var c=(k-a.length)/z;0<c&&c--;)d=a.slice().splice(a.length/p-z,z*p),d[0]=b[k-z-c*z],l&&(d[z-6]=d[z-2],d[z-5]=d[z-1]),[].splice.apply(a,[a.length/p,0].concat(d)),u&&c--}h=h||"";var w,e=m.startX,c=m.endX,l=-1<h.indexOf("C"),z=l?7:3,k,d,b;h=h.split(" ");f=f.slice();var u=m.isArea,p=u?2:1,H;l&&(r(h),r(f));if(e&&c){for(b=0;b<e.length;b++)if(e[b]===c[0]){w=b;break}else if(e[0]===c[c.length-e.length+b]){w=b;H=
!0;break}void 0===w&&(h=[])}h.length&&a.isNumber(w)&&(k=f.length+w*p*z,H?(y(h,f),q(f,h)):(y(f,h),q(h,f)));return[h,f]},fillSetter:function(){a.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)}};a.merge=function(){var m,h=arguments,f,r={},y=function(f,m){"object"!==typeof f&&(f={});a.objectEach(m,function(e,c){!a.isObject(e,!0)||a.isClass(e)||a.isDOMElement(e)?f[c]=m[c]:f[c]=y(f[c]||{},
e)});return f};!0===h[0]&&(r=h[1],h=Array.prototype.slice.call(h,2));f=h.length;for(m=0;m<f;m++)r=y(r,h[m]);return r};a.pInt=function(a,h){return parseInt(a,h||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(m,h){return!!m&&"object"===typeof m&&(!h||!a.isArray(m))};a.isDOMElement=function(m){return a.isObject(m)&&"number"===typeof m.nodeType};a.isClass=function(m){var h=
m&&m.constructor;return!(!a.isObject(m,!0)||a.isDOMElement(m)||!h||!h.name||"Object"===h.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=function(a,h){for(var f=a.length;f--;)if(a[f]===h){a.splice(f,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(m,h,f){var r;a.isString(h)?a.defined(f)?m.setAttribute(h,f):m&&m.getAttribute&&((r=m.getAttribute(h))||"class"!==h||(r=m.getAttribute(h+"Name"))):a.defined(h)&&a.isObject(h)&&
a.objectEach(h,function(a,f){m.setAttribute(f,a)});return r};a.splat=function(m){return a.isArray(m)?m:[m]};a.syncTimeout=function(a,h,f){if(h)return setTimeout(a,h,f);a.call(0,f)};a.clearTimeout=function(m){a.defined(m)&&clearTimeout(m)};a.extend=function(a,h){var f;a||(a={});for(f in h)a[f]=h[f];return a};a.pick=function(){var a=arguments,h,f,r=a.length;for(h=0;h<r;h++)if(f=a[h],void 0!==f&&null!==f)return f};a.css=function(m,h){a.isMS&&!a.svg&&h&&void 0!==h.opacity&&(h.filter="alpha(opacity\x3d"+
100*h.opacity+")");a.extend(m.style,h)};a.createElement=function(m,h,f,r,y){m=D.createElement(m);var q=a.css;h&&a.extend(m,h);y&&q(m,{padding:0,border:"none",margin:0});f&&q(m,f);r&&r.appendChild(m);return m};a.extendClass=function(m,h){var f=function(){};f.prototype=new m;a.extend(f.prototype,h);return f};a.pad=function(a,h,f){return Array((h||2)+1-String(a).replace("-","").length).join(f||0)+a};a.relativeLength=function(a,h,f){return/%$/.test(a)?h*parseFloat(a)/100+(f||0):parseFloat(a)};a.wrap=
function(a,h,f){var m=a[h];a[h]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,w=this;w.proceed=function(){m.apply(w,arguments.length?arguments:q)};a.unshift(m);a=f.apply(this,a);w.proceed=null;return a}};a.formatSingle=function(m,h,f){var r=/\.([0-9])/,y=a.defaultOptions.lang;/f$/.test(m)?(f=(f=m.match(r))?f[1]:-1,null!==h&&(h=a.numberFormat(h,f,y.decimalPoint,-1<m.indexOf(",")?y.thousandsSep:""))):h=(f||a.time).dateFormat(m,h);return h};a.format=function(m,h,f){for(var r="{",
y=!1,q,w,e,c,l=[],z;m;){r=m.indexOf(r);if(-1===r)break;q=m.slice(0,r);if(y){q=q.split(":");w=q.shift().split(".");c=w.length;z=h;for(e=0;e<c;e++)z&&(z=z[w[e]]);q.length&&(z=a.formatSingle(q.join(":"),z,f));l.push(z)}else l.push(q);m=m.slice(r+1);r=(y=!y)?"}":"{"}l.push(m);return l.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(m,h,f,r,y){var q,w=m;f=a.pick(f,1);q=m/f;h||(h=y?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],
!1===r&&(1===f?h=a.grep(h,function(a){return 0===a%1}):.1>=f&&(h=[1/f])));for(r=0;r<h.length&&!(w=h[r],y&&w*f>=m||!y&&q<=(h[r]+(h[r+1]||h[r]))/2);r++);return w=a.correctFloat(w*f,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,h){var f=a.length,m,y;for(y=0;y<f;y++)a[y].safeI=y;a.sort(function(a,f){m=h(a,f);return 0===m?a.safeI-f.safeI:m});for(y=0;y<f;y++)delete a[y].safeI};a.arrayMin=function(a){for(var h=a.length,f=a[0];h--;)a[h]<f&&(f=a[h]);return f};a.arrayMax=function(a){for(var h=
a.length,f=a[0];h--;)a[h]>f&&(f=a[h]);return f};a.destroyObjectProperties=function(m,h){a.objectEach(m,function(a,r){a&&a!==h&&a.destroy&&a.destroy();delete m[r]})};a.discardElement=function(m){var h=a.garbageBin;h||(h=a.createElement("div"));m&&h.appendChild(m);h.innerHTML=""};a.correctFloat=function(a,h){return parseFloat(a.toPrecision(h||14))};a.setAnimation=function(m,h){h.renderer.globalAnimation=a.pick(m,h.options.chart.animation,!0)};a.animObject=function(m){return a.isObject(m)?a.merge(m):
{duration:m?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(m,h,f,r){m=+m||0;h=+h;var y=a.defaultOptions.lang,q=(m.toString().split(".")[1]||"").split("e")[0].length,w,e,c=m.toString().split("e");-1===h?h=Math.min(q,20):a.isNumber(h)?h&&c[1]&&0>c[1]&&(w=h+ +c[1],0<=w?(c[0]=(+c[0]).toExponential(w).split("e")[0],h=w):(c[0]=c[0].split(".")[0]||0,m=20>h?(c[0]*Math.pow(10,c[1])).toFixed(h):0,c[1]=0)):h=2;e=(Math.abs(c[1]?
c[0]:m)+Math.pow(10,-Math.max(h,q)-1)).toFixed(h);q=String(a.pInt(e));w=3<q.length?q.length%3:0;f=a.pick(f,y.decimalPoint);r=a.pick(r,y.thousandsSep);m=(0>m?"-":"")+(w?q.substr(0,w)+r:"");m+=q.substr(w).replace(/(\d{3})(?=\d)/g,"$1"+r);h&&(m+=f+e.slice(-h));c[1]&&0!==+m&&(m+="e"+c[1]);return m};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(m,h,f){if("width"===h)return Math.max(0,Math.min(m.offsetWidth,m.scrollWidth)-a.getStyle(m,"padding-left")-a.getStyle(m,
"padding-right"));if("height"===h)return Math.max(0,Math.min(m.offsetHeight,m.scrollHeight)-a.getStyle(m,"padding-top")-a.getStyle(m,"padding-bottom"));E.getComputedStyle||a.error(27,!0);if(m=E.getComputedStyle(m,void 0))m=m.getPropertyValue(h),a.pick(f,"opacity"!==h)&&(m=a.pInt(m));return m};a.inArray=function(m,h,f){return(a.indexOfPolyfill||Array.prototype.indexOf).call(h,m,f)};a.grep=function(m,h){return(a.filterPolyfill||Array.prototype.filter).call(m,h)};a.find=Array.prototype.find?function(a,
h){return a.find(h)}:function(a,h){var f,r=a.length;for(f=0;f<r;f++)if(h(a[f],f))return a[f]};a.some=function(m,h,f){return(a.somePolyfill||Array.prototype.some).call(m,h,f)};a.map=function(a,h){for(var f=[],r=0,y=a.length;r<y;r++)f[r]=h.call(a[r],a[r],r,a);return f};a.keys=function(m){return(a.keysPolyfill||Object.keys).call(void 0,m)};a.reduce=function(m,h,f){return(a.reducePolyfill||Array.prototype.reduce).apply(m,2<arguments.length?[h,f]:[h])};a.offset=function(a){var h=D.documentElement;a=a.parentElement||
a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(E.pageYOffset||h.scrollTop)-(h.clientTop||0),left:a.left+(E.pageXOffset||h.scrollLeft)-(h.clientLeft||0)}};a.stop=function(m,h){for(var f=a.timers.length;f--;)a.timers[f].elem!==m||h&&h!==a.timers[f].prop||(a.timers[f].stopped=!0)};a.each=function(m,h,f){return(a.forEachPolyfill||Array.prototype.forEach).call(m,h,f)};a.objectEach=function(a,h,f){for(var r in a)a.hasOwnProperty(r)&&h.call(f||a[r],a[r],r,a)};a.addEvent=function(m,
h,f,r){var y,q=m.addEventListener||a.addEventListenerPolyfill;y="function"===typeof m&&m.prototype?m.prototype.protoEvents=m.prototype.protoEvents||{}:m.hcEvents=m.hcEvents||{};a.Point&&m instanceof a.Point&&m.series&&m.series.chart&&(m.series.chart.runTrackerClick=!0);q&&q.call(m,h,f,!1);y[h]||(y[h]=[]);y[h].push(f);r&&a.isNumber(r.order)&&(f.order=r.order,y[h].sort(function(a,e){return a.order-e.order}));return function(){a.removeEvent(m,h,f)}};a.removeEvent=function(m,h,f){function r(e,c){var l=
m.removeEventListener||a.removeEventListenerPolyfill;l&&l.call(m,e,c,!1)}function y(e){var c,l;m.nodeName&&(h?(c={},c[h]=!0):c=e,a.objectEach(c,function(a,k){if(e[k])for(l=e[k].length;l--;)r(k,e[k][l])}))}var q,w;a.each(["protoEvents","hcEvents"],function(e){var c=m[e];c&&(h?(q=c[h]||[],f?(w=a.inArray(f,q),-1<w&&(q.splice(w,1),c[h]=q),r(h,f)):(y(c),c[h]=[])):(y(c),m[e]={}))})};a.fireEvent=function(m,h,f,r){var y,q,w,e,c;f=f||{};D.createEvent&&(m.dispatchEvent||m.fireEvent)?(y=D.createEvent("Events"),
y.initEvent(h,!0,!0),a.extend(y,f),m.dispatchEvent?m.dispatchEvent(y):m.fireEvent(h,y)):a.each(["protoEvents","hcEvents"],function(l){if(m[l])for(q=m[l][h]||[],w=q.length,f.target||a.extend(f,{preventDefault:function(){f.defaultPrevented=!0},target:m,type:h}),e=0;e<w;e++)(c=q[e])&&!1===c.call(m,f)&&f.preventDefault()});r&&!f.defaultPrevented&&r.call(m,f)};a.animate=function(m,h,f){var r,y="",q,w,e;a.isObject(f)||(e=arguments,f={duration:e[2],easing:e[3],complete:e[4]});a.isNumber(f.duration)||(f.duration=
400);f.easing="function"===typeof f.easing?f.easing:Math[f.easing]||Math.easeInOutSine;f.curAnim=a.merge(h);a.objectEach(h,function(c,e){a.stop(m,e);w=new a.Fx(m,f,e);q=null;"d"===e?(w.paths=w.initPath(m,m.d,h.d),w.toD=h.d,r=0,q=1):m.attr?r=m.attr(e):(r=parseFloat(a.getStyle(m,e))||0,"opacity"!==e&&(y="px"));q||(q=c);q&&q.match&&q.match("px")&&(q=q.replace(/px/g,""));w.run(r,q,y)})};a.seriesType=function(m,h,f,r,y){var q=a.getOptions(),w=a.seriesTypes;q.plotOptions[m]=a.merge(q.plotOptions[h],f);
w[m]=a.extendClass(w[h]||function(){},r);w[m].prototype.type=m;y&&(w[m].prototype.pointClass=a.extendClass(a.Point,y));return w[m]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),h=0;return function(){return"highcharts-"+a+"-"+h++}}();E.jQuery&&(E.jQuery.fn.highcharts=function(){var m=[].slice.call(arguments);if(this[0])return m[0]?(new (a[a.isString(m[0])?m.shift():"Chart"])(this[0],m[0],m[1]),this):C[a.attr(this[0],"data-highcharts-chart")]})})(K);(function(a){var C=a.each,
D=a.isNumber,E=a.map,m=a.merge,h=a.pInt;a.Color=function(f){if(!(this instanceof a.Color))return new a.Color(f);this.init(f)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[h(a[1]),h(a[2]),h(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[h(a[1]),h(a[2]),h(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(f){var h,
y,q,w;if((this.input=f=this.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=E(f.stops,function(e){return new a.Color(e[1])});else if(f&&f.charAt&&"#"===f.charAt()&&(h=f.length,f=parseInt(f.substr(1),16),7===h?y=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===h&&(y=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])),!y)for(q=this.parsers.length;q--&&!y;)w=this.parsers[q],(h=w.regex.exec(f))&&(y=w.parse(h));this.rgba=y||[]},get:function(a){var f=this.input,h=this.rgba,q;this.stops?
(q=m(f),q.stops=[].concat(q.stops),C(this.stops,function(f,e){q.stops[e]=[q.stops[e][0],f.get(a)]})):q=h&&D(h[0])?"rgb"===a||!a&&1===h[3]?"rgb("+h[0]+","+h[1]+","+h[2]+")":"a"===a?h[3]:"rgba("+h.join(",")+")":f;return q},brighten:function(a){var f,y=this.rgba;if(this.stops)C(this.stops,function(f){f.brighten(a)});else if(D(a)&&0!==a)for(f=0;3>f;f++)y[f]+=h(255*a),0>y[f]&&(y[f]=0),255<y[f]&&(y[f]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,h){var f=this.rgba,
q=a.rgba;q.length&&f&&f.length?(a=1!==q[3]||1!==f[3],h=(a?"rgba(":"rgb(")+Math.round(q[0]+(f[0]-q[0])*(1-h))+","+Math.round(q[1]+(f[1]-q[1])*(1-h))+","+Math.round(q[2]+(f[2]-q[2])*(1-h))+(a?","+(q[3]+(f[3]-q[3])*(1-h)):"")+")"):h=a.input||"none";return h}};a.color=function(f){return new a.Color(f)}})(K);(function(a){var C,D,E=a.addEvent,m=a.animate,h=a.attr,f=a.charts,r=a.color,y=a.css,q=a.createElement,w=a.defined,e=a.deg2rad,c=a.destroyObjectProperties,l=a.doc,z=a.each,k=a.extend,d=a.erase,b=a.grep,
u=a.hasTouch,p=a.inArray,H=a.isArray,t=a.isFirefox,L=a.isMS,x=a.isObject,I=a.isString,n=a.isWebKit,G=a.merge,B=a.noop,M=a.objectEach,F=a.pick,g=a.pInt,v=a.removeEvent,P=a.stop,Q=a.svg,J=a.SVG_NS,O=a.symbolSizes,N=a.win;C=a.SVGElement=function(){return this};k(C.prototype,{opacity:1,SVG_NS:J,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),init:function(a,g){this.element="span"===g?q(g):l.createElementNS(this.SVG_NS,
g);this.renderer=a},animate:function(A,g,b){g=a.animObject(F(g,this.renderer.globalAnimation,!0));0!==g.duration?(b&&(g.complete=b),m(this,A,g)):(this.attr(A,null,b),g.step&&g.step.call(this));return this},complexColor:function(A,g,b){var d=this.renderer,v,k,c,n,e,J,l,B,u,R,p,t=[],x;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){A.radialGradient?k="radialGradient":A.linearGradient&&(k="linearGradient");k&&(c=A[k],e=d.gradients,l=A.stops,R=b.radialReference,H(c)&&(A[k]=c={x1:c[0],
y1:c[1],x2:c[2],y2:c[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===k&&R&&!w(c.gradientUnits)&&(n=c,c=G(c,d.getRadialAttr(R,n),{gradientUnits:"userSpaceOnUse"})),M(c,function(a,A){"id"!==A&&t.push(A,a)}),M(l,function(a){t.push(a)}),t=t.join(","),e[t]?p=e[t].attr("id"):(c.id=p=a.uniqueKey(),e[t]=J=d.createElement(k).attr(c).add(d.defs),J.radAttr=n,J.stops=[],z(l,function(A){0===A[1].indexOf("rgba")?(v=a.color(A[1]),B=v.get("rgb"),u=v.get("a")):(B=A[1],u=1);A=d.createElement("stop").attr({offset:A[0],
"stop-color":B,"stop-opacity":u}).add(J);J.stops.push(A)})),x="url("+d.url+"#"+p+")",b.setAttribute(g,x),b.gradient=t,A.toString=function(){return x})})},applyTextOutline:function(A){var g=this.element,b,v,k,c,n;-1!==A.indexOf("contrast")&&(A=A.replace(/contrast/g,this.renderer.getContrast(g.style.fill)));A=A.split(" ");v=A[A.length-1];if((k=A[0])&&"none"!==k&&a.svg){this.fakeTS=!0;A=[].slice.call(g.getElementsByTagName("tspan"));this.ySetter=this.xSetter;k=k.replace(/(^[\d\.]+)(.*?)$/g,function(a,
A,g){return 2*A+g});for(n=A.length;n--;)b=A[n],"highcharts-text-outline"===b.getAttribute("class")&&d(A,g.removeChild(b));c=g.firstChild;z(A,function(a,A){0===A&&(a.setAttribute("x",g.getAttribute("x")),A=g.getAttribute("y"),a.setAttribute("y",A||0),null===A&&g.setAttribute("y",0));a=a.cloneNode(1);h(a,{"class":"highcharts-text-outline",fill:v,stroke:v,"stroke-width":k,"stroke-linejoin":"round"});g.insertBefore(a,c)})}},attr:function(a,g,b,d){var A,v=this.element,k,c=this,n,J;"string"===typeof a&&
void 0!==g&&(A=a,a={},a[A]=g);"string"===typeof a?c=(this[a+"Getter"]||this._defaultGetter).call(this,a,v):(M(a,function(A,g){n=!1;d||P(this,g);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(g)&&(k||(this.symbolAttr(a),k=!0),n=!0);!this.rotation||"x"!==g&&"y"!==g||(this.doTransform=!0);n||(J=this[g+"Setter"]||this._defaultSetter,J.call(this,A,g,v),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g)&&this.updateShadows(g,A,J))},this),this.afterSetters());
b&&b.call(this);return c},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,g,b){for(var A=this.shadows,d=A.length;d--;)b.call(A[d],"height"===a?Math.max(g-(A[d].cutHeight||0),0):"d"===a?this.d:g,a,A[d])},addClass:function(a,g){var A=this.attr("class")||"";-1===A.indexOf(a)&&(g||(a=(A+(A?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==p(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",
(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var A=this;z("x y r start end width height innerR anchorX anchorY".split(" "),function(g){A[g]=F(a[g],A[g])});A.attr({d:A.renderer.symbols[A.symbolName](A.x,A.y,A.width,A.height,A)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,g){var A;g=g||a.strokeWidth||0;A=Math.round(g)%2/2;a.x=Math.floor(a.x||this.x||0)+A;a.y=Math.floor(a.y||this.y||0)+A;a.width=Math.floor((a.width||
this.width||0)-2*A);a.height=Math.floor((a.height||this.height||0)-2*A);w(a.strokeWidth)&&(a.strokeWidth=g);return a},css:function(a){var A=this.styles,b={},d=this.element,v,c="",n,J=!A,e=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);A&&M(a,function(a,g){a!==A[g]&&(b[g]=a,J=!0)});J&&(A&&(a=k(A,b)),a&&(null===a.width||"auto"===a.width?delete this.textWidth:"text"===d.nodeName.toLowerCase()&&a.width&&(v=this.textWidth=g(a.width))),this.styles=a,v&&!Q&&this.renderer.forExport&&
delete a.width,d.namespaceURI===this.SVG_NS?(n=function(a,A){return"-"+A.toLowerCase()},M(a,function(a,A){-1===p(A,e)&&(c+=A.replace(/([A-Z])/g,n)+":"+a+";")}),c&&h(d,"style",c)):y(d,a),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,g){var A=this,b=A.element;u&&"click"===a?(b.ontouchstart=function(a){A.touchEventFired=Date.now();a.preventDefault();
g.call(b,a)},b.onclick=function(a){(-1===N.navigator.userAgent.indexOf("Android")||1100<Date.now()-(A.touchEventFired||0))&&g.call(b,a)}):b["on"+a]=g;return this},setRadialReference:function(a){var A=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;A&&A.radAttr&&A.animate(this.renderer.getRadialAttr(a,A.radAttr));return this},translate:function(a,g){return this.attr({translateX:a,translateY:g})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=
this.translateX||0,g=this.translateY||0,b=this.scaleX,d=this.scaleY,v=this.inverted,c=this.rotation,k=this.matrix,n=this.element;v&&(a+=this.width,g+=this.height);a=["translate("+a+","+g+")"];w(k)&&a.push("matrix("+k.join(",")+")");v?a.push("rotate(90) scale(-1,1)"):c&&a.push("rotate("+c+" "+F(this.rotationOriginX,n.getAttribute("x"),0)+" "+F(this.rotationOriginY,n.getAttribute("y")||0)+")");(w(b)||w(d))&&a.push("scale("+F(b,1)+" "+F(d,1)+")");a.length&&n.setAttribute("transform",a.join(" "))},toFront:function(){var a=
this.element;a.parentNode.appendChild(a);return this},align:function(a,g,b){var A,v,c,k,n={};v=this.renderer;c=v.alignedObjects;var J,e;if(a){if(this.alignOptions=a,this.alignByTranslate=g,!b||I(b))this.alignTo=A=b||"renderer",d(c,this),c.push(this),b=null}else a=this.alignOptions,g=this.alignByTranslate,A=this.alignTo;b=F(b,v[A],v);A=a.align;v=a.verticalAlign;c=(b.x||0)+(a.x||0);k=(b.y||0)+(a.y||0);"right"===A?J=1:"center"===A&&(J=2);J&&(c+=(b.width-(a.width||0))/J);n[g?"translateX":"x"]=Math.round(c);
"bottom"===v?e=1:"middle"===v&&(e=2);e&&(k+=(b.height-(a.height||0))/e);n[g?"translateY":"y"]=Math.round(k);this[this.placed?"animate":"attr"](n);this.placed=!0;this.alignAttr=n;return this},getBBox:function(a,g){var A,b=this.renderer,d,v=this.element,c=this.styles,n,J=this.textStr,l,B=b.cache,u=b.cacheKeys,p;g=F(g,this.rotation);d=g*e;n=c&&c.fontSize;w(J)&&(p=J.toString(),-1===p.indexOf("\x3c")&&(p=p.replace(/[0-9]/g,"0")),p+=["",g||0,n,this.textWidth,c&&c.textOverflow].join());p&&!a&&(A=B[p]);if(!A){if(v.namespaceURI===
this.SVG_NS||b.forExport){try{(l=this.fakeTS&&function(a){z(v.querySelectorAll(".highcharts-text-outline"),function(A){A.style.display=a})})&&l("none"),A=v.getBBox?k({},v.getBBox()):{width:v.offsetWidth,height:v.offsetHeight},l&&l("")}catch(W){}if(!A||0>A.width)A={width:0,height:0}}else A=this.htmlGetBBox();b.isSVG&&(a=A.width,b=A.height,c&&"11px"===c.fontSize&&17===Math.round(b)&&(A.height=b=14),g&&(A.width=Math.abs(b*Math.sin(d))+Math.abs(a*Math.cos(d)),A.height=Math.abs(b*Math.cos(d))+Math.abs(a*
Math.sin(d))));if(p&&0<A.height){for(;250<u.length;)delete B[u.shift()];B[p]||u.push(p);B[p]=A}}return A},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var A=this;A.animate({opacity:0},{duration:a||150,complete:function(){A.attr({y:-9999})}})},add:function(a){var A=this.renderer,g=this.element,b;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&A.buildText(this);this.added=
!0;if(!a||a.handleZ||this.zIndex)b=this.zIndexSetter();b||(a?a.element:A.box).appendChild(g);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var A=a.parentNode;A&&A.removeChild(a)},destroy:function(){var a=this,g=a.element||{},b=a.renderer.isSVG&&"SPAN"===g.nodeName&&a.parentGroup,v=g.ownerSVGElement,c=a.clipPath;g.onclick=g.onmouseout=g.onmouseover=g.onmousemove=g.point=null;P(a);c&&v&&(z(v.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){var g=a.getAttribute("clip-path"),
A=c.element.id;(-1<g.indexOf("(#"+A+")")||-1<g.indexOf('("#'+A+'")'))&&a.removeAttribute("clip-path")}),a.clipPath=c.destroy());if(a.stops){for(v=0;v<a.stops.length;v++)a.stops[v]=a.stops[v].destroy();a.stops=null}a.safeRemoveChild(g);for(a.destroyShadows();b&&b.div&&0===b.div.childNodes.length;)g=b.parentGroup,a.safeRemoveChild(b.div),delete b.div,b=g;a.alignTo&&d(a.renderer.alignedObjects,a);M(a,function(g,A){delete a[A]});return null},shadow:function(a,g,b){var A=[],d,v,c=this.element,k,n,J,e;
if(!a)this.destroyShadows();else if(!this.shadows){n=F(a.width,3);J=(a.opacity||.15)/n;e=this.parentInverted?"(-1,-1)":"("+F(a.offsetX,1)+", "+F(a.offsetY,1)+")";for(d=1;d<=n;d++)v=c.cloneNode(0),k=2*n+1-2*d,h(v,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":J*d,"stroke-width":k,transform:"translate"+e,fill:"none"}),b&&(h(v,"height",Math.max(h(v,"height")-k,0)),v.cutHeight=k),g?g.element.appendChild(v):c.parentNode&&c.parentNode.insertBefore(v,c),A.push(v);this.shadows=A}return this},
destroyShadows:function(){z(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=F(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,g,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[g]!==a&&(b.setAttribute(g,
a),this[g]=a)},dashstyleSetter:function(a){var b,A=this["stroke-width"];"inherit"===A&&(A=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=g(a[b])*A;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.alignValue=
a;this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,g,b){this[g]=a;b.setAttribute(g,a)},titleSetter:function(a){var g=this.element.getElementsByTagName("title")[0];g||(g=l.createElementNS(this.SVG_NS,"title"),this.element.appendChild(g));g.firstChild&&g.removeChild(g.firstChild);g.appendChild(l.createTextNode(String(F(a),"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&
(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,g,b){"string"===typeof a?b.setAttribute(g,a):a&&this.complexColor(a,g,b)},visibilitySetter:function(a,g,b){"inherit"===a?b.removeAttribute(g):this[g]!==a&&b.setAttribute(g,a);this[g]=a},zIndexSetter:function(a,b){var d=this.renderer,v=this.parentGroup,A=(v||d).element||d.box,c,k=this.element,n,J,d=A===d.box;c=this.added;var e;w(a)?(k.setAttribute("data-z-index",a),a=+a,this[b]===a&&(c=!1)):w(this[b])&&
k.removeAttribute("data-z-index");this[b]=a;if(c){(a=this.zIndex)&&v&&(v.handleZ=!0);b=A.childNodes;for(e=b.length-1;0<=e&&!n;e--)if(v=b[e],c=v.getAttribute("data-z-index"),J=!w(c),v!==k)if(0>a&&J&&!d&&!e)A.insertBefore(k,b[e]),n=!0;else if(g(c)<=a||J&&(!w(a)||0<=a))A.insertBefore(k,b[e+1]||null),n=!0;n||(A.insertBefore(k,b[d?3:0]||null),n=!0)}return n},_defaultSetter:function(a,g,b){b.setAttribute(g,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=
C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.rotationOriginXSetter=C.prototype.rotationOriginYSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=C.prototype.matrixSetter=function(a,g){this[g]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,g,b){this[g]=a;this.stroke&&this["stroke-width"]?(C.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===
g&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),this.hasStroke=!1)};D=a.SVGRenderer=function(){this.init.apply(this,arguments)};k(D.prototype,{Element:C,SVG_NS:J,init:function(a,g,b,d,v,c){var A;d=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(d));A=d.element;a.appendChild(A);h(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&h(A,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=A;this.boxWrapper=d;this.alignedObjects=[];this.url=(t||n)&&l.getElementsByTagName("base").length?
N.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(l.createTextNode("Created with Highcharts 6.1.2"));this.defs=this.createElement("defs").add();this.allowHTML=c;this.forExport=v;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(g,b,!1);var k;t&&a.getBoundingClientRect&&(g=function(){y(a,{left:0,top:0});k=a.getBoundingClientRect();y(a,{left:Math.ceil(k.left)-k.left+
"px",top:Math.ceil(k.top)-k.top+"px"})},g(),this.unSubPixelFix=E(N,"resize",g))},getStyle:function(a){return this.style=k({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();c(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());
this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var g=new this.Element;g.init(this,a);return g},draw:B,getRadialAttr:function(a,g){return{cx:a[0]-a[2]/2+g.cx*a[2],cy:a[1]-a[2]/2+g.cy*a[2],r:g.r*a[2]}},getSpanWidth:function(a){return a.getBBox(!0).width},applyEllipsis:function(a,g,b,d){var v=a.rotation,c=b,k,A=0,n=b.length,J=function(a){g.removeChild(g.firstChild);a&&g.appendChild(l.createTextNode(a))},e;a.rotation=0;c=this.getSpanWidth(a,g);if(e=
c>d){for(;A<=n;)k=Math.ceil((A+n)/2),c=b.substring(0,k)+"\u2026",J(c),c=this.getSpanWidth(a,g),A===n?A=n+1:c>d?n=k-1:A=k;0===n&&J("")}a.rotation=v;return e},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var d=a.element,v=this,c=v.forExport,k=F(a.textStr,"").toString(),A=-1!==k.indexOf("\x3c"),n=d.childNodes,e,B=h(d,"x"),u=a.styles,t=a.textWidth,G=u&&u.lineHeight,x=u&&u.textOutline,f=u&&"ellipsis"===u.textOverflow,P=u&&"nowrap"===
u.whiteSpace,O=u&&u.fontSize,w,q,H=n.length,u=t&&!a.added&&this.box,I=function(a){var b;b=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:O||v.style.fontSize||12;return G?g(G):v.fontMetrics(b,a.getAttribute("style")?a:d).h},N=function(a,g){M(v.escapes,function(b,d){g&&-1!==p(b,g)||(a=a.toString().replace(new RegExp(b,"g"),d))});return a},m=function(a,g){var b;b=a.indexOf("\x3c");a=a.substring(b,a.indexOf("\x3e")-b);b=a.indexOf(g+"\x3d");if(-1!==b&&(b=b+g.length+1,g=a.charAt(b),'"'===g||"'"===
g))return a=a.substring(b+1),a.substring(0,a.indexOf(g))};w=[k,f,P,G,x,O,t].join();if(w!==a.textCache){for(a.textCache=w;H--;)d.removeChild(n[H]);A||x||f||t||-1!==k.indexOf(" ")?(u&&u.appendChild(d),k=A?k.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[k],k=b(k,function(a){return""!==a}),z(k,function(g,b){var k,A=0;g=g.replace(/^\s+|\s+$/g,
"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");k=g.split("|||");z(k,function(g){if(""!==g||1===k.length){var n={},u=l.createElementNS(v.SVG_NS,"tspan"),p,G;(p=m(g,"class"))&&h(u,"class",p);if(p=m(g,"style"))p=p.replace(/(;| |^)color([ :])/,"$1fill$2"),h(u,"style",p);(G=m(g,"href"))&&!c&&(h(u,"onclick",'location.href\x3d"'+G+'"'),h(u,"class","highcharts-anchor"),y(u,{cursor:"pointer"}));g=N(g.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==g){u.appendChild(l.createTextNode(g));
A?n.dx=0:b&&null!==B&&(n.x=B);h(u,n);d.appendChild(u);!A&&q&&(!Q&&c&&y(u,{display:"block"}),h(u,"dy",I(u)));if(t){n=g.replace(/([^\^])-/g,"$1- ").split(" ");G=1<k.length||b||1<n.length&&!P;var x=[],z,O=I(u),w=a.rotation;for(f&&(e=v.applyEllipsis(a,u,g,t));!f&&G&&(n.length||x.length);)a.rotation=0,z=v.getSpanWidth(a,u),g=z>t,void 0===e&&(e=g),g&&1!==n.length?(u.removeChild(u.firstChild),x.unshift(n.pop())):(n=x,x=[],n.length&&!P&&(u=l.createElementNS(J,"tspan"),h(u,{dy:O,x:B}),p&&h(u,"style",p),d.appendChild(u)),
z>t&&(t=z+1)),n.length&&u.appendChild(l.createTextNode(n.join(" ").replace(/- /g,"-")));a.rotation=w}A++}}});q=q||d.childNodes.length}),f&&e&&a.attr("title",N(a.textStr,["\x26lt;","\x26gt;"])),u&&u.removeChild(d),x&&a.applyTextOutline&&a.applyTextOutline(x)):d.appendChild(l.createTextNode(N(k)))}},getContrast:function(a){a=r(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,g,b,d,v,c,n,e,J){var A=this.label(a,g,b,J,null,null,null,null,"button"),u=
0;A.attr(G({padding:8,r:2},v));var l,B,p,t;v=G({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},v);l=v.style;delete v.style;c=G(v,{fill:"#e6e6e6"},c);B=c.style;delete c.style;n=G(v,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},n);p=n.style;delete n.style;e=G(v,{style:{color:"#cccccc"}},e);t=e.style;delete e.style;E(A.element,L?"mouseover":"mouseenter",function(){3!==u&&A.setState(1)});E(A.element,L?"mouseout":"mouseleave",
function(){3!==u&&A.setState(u)});A.setState=function(a){1!==a&&(A.state=u=a);A.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);A.attr([v,c,n,e][a||0]).css([l,B,p,t][a||0])};A.attr(v).css(k({cursor:"default"},l));return A.on("click",function(a){3!==u&&d.call(A,a)})},crispLine:function(a,g){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-g%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+g%2/2);return a},path:function(a){var g=
{fill:"none"};H(a)?g.d=a:x(a)&&k(g,a);return this.createElement("path").attr(g)},circle:function(a,g,b){a=x(a)?a:{x:a,y:g,r:b};g=this.createElement("circle");g.xSetter=g.ySetter=function(a,g,b){b.setAttribute("c"+g,a)};return g.attr(a)},arc:function(a,g,b,d,v,c){x(a)?(d=a,g=d.y,b=d.r,a=d.x):d={innerR:d,start:v,end:c};a=this.symbol("arc",a,g,b,b,d);a.r=b;return a},rect:function(a,g,b,d,v,c){v=x(a)?a.r:v;var k=this.createElement("rect");a=x(a)?a:void 0===a?{}:{x:a,y:g,width:Math.max(b,0),height:Math.max(d,
0)};void 0!==c&&(a.strokeWidth=c,a=k.crisp(a));a.fill="none";v&&(a.r=v);k.rSetter=function(a,g,b){h(b,{rx:a,ry:a})};return k.attr(a)},setSize:function(a,g,b){var d=this.alignedObjects,v=d.length;this.width=a;this.height=g;for(this.boxWrapper.animate({width:a,height:g},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:F(b,!0)?void 0:0});v--;)d[v].align()},g:function(a){var g=this.createElement("g");return a?g.attr({"class":"highcharts-"+a}):g},image:function(a,
g,b,d,v,c){var n={preserveAspectRatio:"none"},e,J=function(a,g){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",g):a.setAttribute("hc-svg-href",g)},A=function(g){J(e.element,a);c.call(e,g)};1<arguments.length&&k(n,{x:g,y:b,width:d,height:v});e=this.createElement("image").attr(n);c?(J(e.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),n=new N.Image,E(n,"load",A),n.src=a,n.complete&&A({})):J(e.element,a);return e},symbol:function(a,
g,b,d,v,c){var n=this,e,J=/^url\((.*?)\)$/,A=J.test(a),u=!A&&(this.symbols[a]?a:"circle"),B=u&&this.symbols[u],p=w(g)&&B&&B.call(this.symbols,Math.round(g),Math.round(b),d,v,c),t,G;B?(e=this.path(p),e.attr("fill","none"),k(e,{symbolName:u,x:g,y:b,width:d,height:v}),c&&k(e,c)):A&&(t=a.match(J)[1],e=this.image(t),e.imgwidth=F(O[t]&&O[t].width,c&&c.width),e.imgheight=F(O[t]&&O[t].height,c&&c.height),G=function(){e.attr({width:e.width,height:e.height})},z(["width","height"],function(a){e[a+"Setter"]=
function(a,g){var b={},d=this["img"+g],v="width"===g?"translateX":"translateY";this[g]=a;w(d)&&(this.element&&this.element.setAttribute(g,d),this.alignByTranslate||(b[v]=((this[g]||0)-d)/2,this.attr(b)))}}),w(g)&&e.attr({x:g,y:b}),e.isImg=!0,w(e.imgwidth)&&w(e.imgheight)?G():(e.attr({width:0,height:0}),q("img",{onload:function(){var a=f[n.chartIndex];0===this.width&&(y(this,{position:"absolute",top:"-999em"}),l.body.appendChild(this));O[t]={width:this.width,height:this.height};e.imgwidth=this.width;
e.imgheight=this.height;e.element&&G();this.parentNode&&this.parentNode.removeChild(this);n.imgCount--;if(!n.imgCount&&a&&a.onload)a.onload()},src:t}),this.imgCount++));return e},symbols:{circle:function(a,g,b,d){return this.arc(a+b/2,g+d/2,b/2,d/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,g,b,d){return["M",a,g,"L",a+b,g,a+b,g+d,a,g+d,"Z"]},triangle:function(a,g,b,d){return["M",a+b/2,g,"L",a+b,g+d,a,g+d,"Z"]},"triangle-down":function(a,g,b,d){return["M",a,g,"L",a+b,g,a+b/2,g+d,"Z"]},diamond:function(a,
g,b,d){return["M",a+b/2,g,"L",a+b,g+d/2,a+b/2,g+d,a,g+d/2,"Z"]},arc:function(a,g,b,d,v){var c=v.start,k=v.r||b,n=v.r||d||b,e=v.end-.001;b=v.innerR;d=F(v.open,.001>Math.abs(v.end-v.start-2*Math.PI));var J=Math.cos(c),u=Math.sin(c),A=Math.cos(e),e=Math.sin(e);v=.001>v.end-c-Math.PI?0:1;k=["M",a+k*J,g+n*u,"A",k,n,0,v,1,a+k*A,g+n*e];w(b)&&k.push(d?"M":"L",a+b*A,g+b*e,"A",b,b,0,v,0,a+b*J,g+b*u);k.push(d?"":"Z");return k},callout:function(a,g,b,d,v){var c=Math.min(v&&v.r||0,b,d),k=c+6,n=v&&v.anchorX;v=
v&&v.anchorY;var e;e=["M",a+c,g,"L",a+b-c,g,"C",a+b,g,a+b,g,a+b,g+c,"L",a+b,g+d-c,"C",a+b,g+d,a+b,g+d,a+b-c,g+d,"L",a+c,g+d,"C",a,g+d,a,g+d,a,g+d-c,"L",a,g+c,"C",a,g,a,g,a+c,g];n&&n>b?v>g+k&&v<g+d-k?e.splice(13,3,"L",a+b,v-6,a+b+6,v,a+b,v+6,a+b,g+d-c):e.splice(13,3,"L",a+b,d/2,n,v,a+b,d/2,a+b,g+d-c):n&&0>n?v>g+k&&v<g+d-k?e.splice(33,3,"L",a,v+6,a-6,v,a,v-6,a,g+c):e.splice(33,3,"L",a,d/2,n,v,a,d/2,a,g+c):v&&v>d&&n>a+k&&n<a+b-k?e.splice(23,3,"L",n+6,g+d,n,g+d+6,n-6,g+d,a+c,g+d):v&&0>v&&n>a+k&&n<a+b-
k&&e.splice(3,3,"L",n-6,g,n,g-6,n+6,g,b-c,g);return e}},clipRect:function(g,b,d,v){var c=a.uniqueKey(),k=this.createElement("clipPath").attr({id:c}).add(this.defs);g=this.rect(g,b,d,v,0).add(k);g.id=c;g.clipPath=k;g.count=0;return g},text:function(a,g,b,d){var v={};if(d&&(this.allowHTML||!this.forExport))return this.html(a,g,b);v.x=Math.round(g||0);b&&(v.y=Math.round(b));if(a||0===a)v.text=a;a=this.createElement("text").attr(v);d||(a.xSetter=function(a,g,b){var d=b.getElementsByTagName("tspan"),v,
c=b.getAttribute(g),k;for(k=0;k<d.length;k++)v=d[k],v.getAttribute(g)===c&&v.setAttribute(g,a);b.setAttribute(g,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?g(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,g,b){var d=a;g&&b&&(d=Math.max(d*Math.cos(g*e),4));return{x:-a/3*Math.sin(g*e),y:d}},label:function(g,
b,d,c,n,e,J,u,l){var B=this,p=B.g("button"!==l&&"label"),t=p.text=B.text("",0,0,J).attr({zIndex:1}),A,x,Q=0,f=3,P=0,h,O,q,F,H,I={},N,y,M=/^url\((.*?)\)$/.test(c),m=M,L,r,R,U;l&&p.addClass("highcharts-"+l);m=M;L=function(){return(N||0)%2/2};r=function(){var a=t.element.style,g={};x=(void 0===h||void 0===O||H)&&w(t.textStr)&&t.getBBox();p.width=(h||x.width||0)+2*f+P;p.height=(O||x.height||0)+2*f;y=f+B.fontMetrics(a&&a.fontSize,t).b;m&&(A||(p.box=A=B.symbols[c]||M?B.symbol(c):B.rect(),A.addClass(("button"===
l?"":"highcharts-label-box")+(l?" highcharts-"+l+"-box":"")),A.add(p),a=L(),g.x=a,g.y=(u?-y:0)+a),g.width=Math.round(p.width),g.height=Math.round(p.height),A.attr(k(g,I)),I={})};R=function(){var a=P+f,g;g=u?0:y;w(h)&&x&&("center"===H||"right"===H)&&(a+={center:.5,right:1}[H]*(h-x.width));if(a!==t.x||g!==t.y)t.attr("x",a),t.hasBoxWidthChanged&&(x=t.getBBox(!0),r()),void 0!==g&&t.attr("y",g);t.x=a;t.y=g};U=function(a,g){A?A.attr(a,g):I[a]=g};p.onAdd=function(){t.add(p);p.attr({text:g||0===g?g:"",x:b,
y:d});A&&w(n)&&p.attr({anchorX:n,anchorY:e})};p.widthSetter=function(g){h=a.isNumber(g)?g:null};p.heightSetter=function(a){O=a};p["text-alignSetter"]=function(a){H=a};p.paddingSetter=function(a){w(a)&&a!==f&&(f=p.padding=a,R())};p.paddingLeftSetter=function(a){w(a)&&a!==P&&(P=a,R())};p.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==Q&&(Q=a,x&&p.attr({x:q}))};p.textSetter=function(a){void 0!==a&&t.textSetter(a);r();R()};p["stroke-widthSetter"]=function(a,g){a&&(m=!0);N=this["stroke-width"]=
a;U(g,a)};p.strokeSetter=p.fillSetter=p.rSetter=function(a,g){"r"!==g&&("fill"===g&&a&&(m=!0),p[g]=a);U(g,a)};p.anchorXSetter=function(a,g){n=p.anchorX=a;U(g,Math.round(a)-L()-q)};p.anchorYSetter=function(a,g){e=p.anchorY=a;U(g,a-F)};p.xSetter=function(a){p.x=a;Q&&(a-=Q*((h||x.width)+2*f),p["forceAnimate:x"]=!0);q=Math.round(a);p.attr("translateX",q)};p.ySetter=function(a){F=p.y=Math.round(a);p.attr("translateY",F)};var S=p.css;return k(p,{css:function(a){if(a){var g={};a=G(a);z(p.textProps,function(b){void 0!==
a[b]&&(g[b]=a[b],delete a[b])});t.css(g);"width"in g&&r()}return S.call(p,a)},getBBox:function(){return{width:x.width+2*f,height:x.height+2*f,x:x.x-f,y:x.y-f}},shadow:function(a){a&&(r(),A&&A.shadow(a));return p},destroy:function(){v(p.element,"mouseenter");v(p.element,"mouseleave");t&&(t=t.destroy());A&&(A=A.destroy());C.prototype.destroy.call(p);p=B=r=R=U=null}})}});a.Renderer=D})(K);(function(a){var C=a.attr,D=a.createElement,E=a.css,m=a.defined,h=a.each,f=a.extend,r=a.isFirefox,y=a.isMS,q=a.isWebKit,
w=a.pick,e=a.pInt,c=a.SVGRenderer,l=a.win,z=a.wrap;f(a.SVGElement.prototype,{htmlCss:function(a){var d=this.element;if((d=a&&"SPAN"===d.tagName&&a.width)||this.textWidth&&!d)delete a.width,this.textWidth=d,this.htmlUpdateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=f(this.styles,a);E(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=
this.renderer,d=this.element,b=this.translateX||0,c=this.translateY||0,p=this.x||0,l=this.y||0,t=this.textAlign||"left",f={left:0,center:.5,right:1}[t],x=this.styles,z=x&&x.whiteSpace;E(d,{marginLeft:b,marginTop:c});this.shadows&&h(this.shadows,function(a){E(a,{marginLeft:b+1,marginTop:c+1})});this.inverted&&h(d.childNodes,function(b){a.invertChild(b,d)});if("SPAN"===d.tagName){var x=this.rotation,n=this.textWidth&&e(this.textWidth),G=[x,t,d.innerHTML,this.textWidth,this.textAlign].join(),B;(B=n!==
this.oldTextWidth)&&!(B=n>this.oldTextWidth)&&((B=this.textPxLength)||(E(d,{width:"",whiteSpace:z||"nowrap"}),B=d.offsetWidth),B=B>n);B&&/[ \-]/.test(d.textContent||d.innerText)?(E(d,{width:n+"px",display:"block",whiteSpace:z||"normal"}),this.oldTextWidth=n,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;G!==this.cTT&&(z=a.fontMetrics(d.style.fontSize).b,!m(x)||x===(this.oldRotation||0)&&t===this.oldAlign||this.setSpanRotation(x,f,z),this.getSpanCorrection(!m(x)&&this.textPxLength||d.offsetWidth,
z,f,x,t));E(d,{left:p+(this.xCorr||0)+"px",top:l+(this.yCorr||0)+"px"});this.cTT=G;this.oldRotation=x;this.oldAlign=t}}else this.alignOnAdd=!0},setSpanRotation:function(a,d,b){var c={},k=this.renderer.getTransformKey();c[k]=c.transform="rotate("+a+"deg)";c[k+(r?"Origin":"-origin")]=c.transformOrigin=100*d+"% "+b+"px";E(this.element,c)},getSpanCorrection:function(a,d,b){this.xCorr=-a*b;this.yCorr=-d}});f(c.prototype,{getTransformKey:function(){return y&&!/Edge/.test(l.navigator.userAgent)?"-ms-transform":
q?"-webkit-transform":r?"MozTransform":l.opera?"-o-transform":""},html:function(a,d,b){var c=this.createElement("span"),k=c.element,e=c.renderer,l=e.isSVG,q=function(a,b){h(["opacity","visibility"],function(d){z(a,d+"Setter",function(a,d,c,k){a.call(this,d,c,k);b[c]=d})});a.addedSetters=!0};c.textSetter=function(a){a!==k.innerHTML&&delete this.bBox;this.textStr=a;k.innerHTML=w(a,"");c.doTransform=!0};l&&q(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=c.rotationSetter=function(a,b){"align"===
b&&(b="textAlign");c[b]=a;c.doTransform=!0};c.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};c.attr({text:a,x:Math.round(d),y:Math.round(b)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});k.style.whiteSpace="nowrap";c.css=c.htmlCss;l&&(c.add=function(a){var b,d=e.box.parentNode,p=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)p.push(a),a=a.parentGroup;h(p.reverse(),function(a){function k(g,b){a[b]=g;"translateX"===
b?n.left=g+"px":n.top=g+"px";a.doTransform=!0}var n,g=C(a.element,"class");g&&(g={className:g});b=a.div=a.div||D("div",g,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||d);n=b.style;f(a,{classSetter:function(a){return function(g){this.element.setAttribute("class",g);a.className=g}}(b),on:function(){p[0].div&&c.on.apply({element:p[0].div},arguments);return a},translateXSetter:k,translateYSetter:k});
a.addedSetters||q(a,n)})}}else b=d;b.appendChild(k);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})})(K);(function(a){var C=a.defined,D=a.each,E=a.extend,m=a.merge,h=a.pick,f=a.timeUnits,r=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(a){var f=h(a&&a.useUTC,!0),w=this;this.options=a=m(!0,this.options||{},a);this.Date=a.Date||r.Date;this.timezoneOffset=(this.useUTC=f)&&a.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();
(this.variableTimezone=!(f&&!a.getTimezoneOffset&&!a.timezone))||this.timezoneOffset?(this.get=function(a,c){var e=c.getTime(),f=e-w.getTimezoneOffset(c);c.setTime(f);a=c["getUTC"+a]();c.setTime(e);return a},this.set=function(a,c,l){var e;if("Milliseconds"===a||"Seconds"===a||"Minutes"===a&&0===c.getTimezoneOffset()%60)c["set"+a](l);else e=w.getTimezoneOffset(c),e=c.getTime()-e,c.setTime(e),c["setUTC"+a](l),a=w.getTimezoneOffset(c),e=c.getTime()+a,c.setTime(e)}):f?(this.get=function(a,c){return c["getUTC"+
a]()},this.set=function(a,c,l){return c["setUTC"+a](l)}):(this.get=function(a,c){return c["get"+a]()},this.set=function(a,c,l){return c["set"+a](l)})},makeTime:function(f,q,w,e,c,l){var z,k,d;this.useUTC?(z=this.Date.UTC.apply(0,arguments),k=this.getTimezoneOffset(z),z+=k,d=this.getTimezoneOffset(z),k!==d?z+=d-k:k-36E5!==this.getTimezoneOffset(z-36E5)||a.isSafari||(z-=36E5)):z=(new this.Date(f,q,h(w,1),h(e,0),h(c,0),h(l,0))).getTime();return z},timezoneOffsetFunction:function(){var f=this,h=this.options,
w=r.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(h.timezone){if(w)return function(a){return 6E4*-w.tz(a,h.timezone).utcOffset()};a.error(25)}return this.useUTC&&h.getTimezoneOffset?function(a){return 6E4*h.getTimezoneOffset(a)}:function(){return 6E4*(f.timezoneOffset||0)}},dateFormat:function(f,h,w){if(!a.defined(h)||isNaN(h))return a.defaultOptions.lang.invalidDate||"";f=a.pick(f,"%Y-%m-%d %H:%M:%S");var e=this,c=new this.Date(h),l=this.get("Hours",c),
z=this.get("Day",c),k=this.get("Date",c),d=this.get("Month",c),b=this.get("FullYear",c),u=a.defaultOptions.lang,p=u.weekdays,H=u.shortWeekdays,t=a.pad,c=a.extend({a:H?H[z]:p[z].substr(0,3),A:p[z],d:t(k),e:t(k,2," "),w:z,b:u.shortMonths[d],B:u.months[d],m:t(d+1),o:d+1,y:b.toString().substr(2,2),Y:b,H:t(l),k:l,I:t(l%12||12),l:l%12||12,M:t(e.get("Minutes",c)),p:12>l?"AM":"PM",P:12>l?"am":"pm",S:t(c.getSeconds()),L:t(Math.round(h%1E3),3)},a.dateFormats);a.objectEach(c,function(a,b){for(;-1!==f.indexOf("%"+
b);)f=f.replace("%"+b,"function"===typeof a?a.call(e,h):a)});return w?f.substr(0,1).toUpperCase()+f.substr(1):f},getTimeTicks:function(a,q,w,e){var c=this,l=[],z={},k,d=new c.Date(q),b=a.unitRange,u=a.count||1,p;if(C(q)){c.set("Milliseconds",d,b>=f.second?0:u*Math.floor(c.get("Milliseconds",d)/u));b>=f.second&&c.set("Seconds",d,b>=f.minute?0:u*Math.floor(c.get("Seconds",d)/u));b>=f.minute&&c.set("Minutes",d,b>=f.hour?0:u*Math.floor(c.get("Minutes",d)/u));b>=f.hour&&c.set("Hours",d,b>=f.day?0:u*Math.floor(c.get("Hours",
d)/u));b>=f.day&&c.set("Date",d,b>=f.month?1:u*Math.floor(c.get("Date",d)/u));b>=f.month&&(c.set("Month",d,b>=f.year?0:u*Math.floor(c.get("Month",d)/u)),k=c.get("FullYear",d));b>=f.year&&c.set("FullYear",d,k-k%u);b===f.week&&c.set("Date",d,c.get("Date",d)-c.get("Day",d)+h(e,1));k=c.get("FullYear",d);e=c.get("Month",d);var H=c.get("Date",d),t=c.get("Hours",d);q=d.getTime();c.variableTimezone&&(p=w-q>4*f.month||c.getTimezoneOffset(q)!==c.getTimezoneOffset(w));d=d.getTime();for(q=1;d<w;)l.push(d),d=
b===f.year?c.makeTime(k+q*u,0):b===f.month?c.makeTime(k,e+q*u):!p||b!==f.day&&b!==f.week?p&&b===f.hour&&1<u?c.makeTime(k,e,H,t+q*u):d+b*u:c.makeTime(k,e,H+q*u*(b===f.day?1:7)),q++;l.push(d);b<=f.hour&&1E4>l.length&&D(l,function(a){0===a%18E5&&"000000000"===c.dateFormat("%H%M%S%L",a)&&(z[a]="day")})}l.info=E(a,{higherRanks:z,totalRange:b*u});return l}}})(K);(function(a){var C=a.color,D=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),
symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,
chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",
labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",
position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:C("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(C){a.defaultOptions=D(!0,a.defaultOptions,C);
a.time.update(D(a.defaultOptions.global,a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(D(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(C,m,h){return a.time.dateFormat(C,m,h)}})(K);(function(a){var C=a.correctFloat,D=a.defined,E=a.destroyObjectProperties,m=a.fireEvent,h=a.isNumber,f=a.merge,r=a.pick,y=a.deg2rad;a.Tick=function(a,f,e,c){this.axis=a;this.pos=
f;this.type=e||"";this.isNewLabel=this.isNew=!0;e||c||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,h=a.options,e=a.chart,c=a.categories,l=a.names,z=this.pos,k=h.labels,d=a.tickPositions,b=z===d[0],u=z===d[d.length-1],l=c?r(c[z],l[z],z):z,c=this.label,d=d.info,p;a.isDatetimeAxis&&d&&(p=h.dateTimeLabelFormats[d.higherRanks[z]||d.unitName]);this.isFirst=b;this.isLast=u;h={axis:a,chart:e,isFirst:b,isLast:u,dateTimeLabelFormat:p,value:a.isLog?C(a.lin2log(l)):l,pos:z};h=a.labelFormatter.call(h,
h);if(D(c))c&&c.attr({text:h});else{if(this.label=c=D(h)&&k.enabled?e.renderer.text(h,0,0,k.useHTML).css(f(k.style)).add(a.labelGroup):null)c.textPxLength=c.getBBox().width;this.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var f=this.axis,e=f.options.labels,c=a.x,l=f.chart.chartWidth,z=f.chart.spacing,k=r(f.labelLeft,Math.min(f.pos,z[3])),z=r(f.labelRight,Math.max(f.isRadial?0:f.pos+f.len,l-z[1])),d=this.label,
b=this.rotation,u={left:0,center:.5,right:1}[f.labelAlign||d.attr("align")],p=d.getBBox().width,h=f.getSlotWidth(this),t=h,q=1,x,I={};if(b||!1===e.overflow)0>b&&c-u*p<k?x=Math.round(c/Math.cos(b*y)-k):0<b&&c+u*p>z&&(x=Math.round((l-c)/Math.cos(b*y)));else if(l=c+(1-u)*p,c-u*p<k?t=a.x+t*(1-u)-k:l>z&&(t=z-a.x+t*u,q=-1),t=Math.min(h,t),t<h&&"center"===f.labelAlign&&(a.x+=q*(h-t-u*(h-Math.min(p,t)))),p>t||f.autoRotation&&(d.styles||{}).width)x=t;x&&(I.width=x,(e.style||{}).textOverflow||(I.textOverflow=
"ellipsis"),d.css(I))},getPosition:function(f,h,e,c){var l=this.axis,z=l.chart,k=c&&z.oldChartHeight||z.chartHeight;f={x:f?a.correctFloat(l.translate(h+e,null,null,c)+l.transB):l.left+l.offset+(l.opposite?(c&&z.oldChartWidth||z.chartWidth)-l.right-l.left:0),y:f?k-l.bottom+l.offset-(l.opposite?l.height:0):a.correctFloat(k-l.translate(h+e,null,null,c)-l.transB)};m(this,"afterGetPosition",{pos:f});return f},getLabelPosition:function(a,f,e,c,l,h,k,d){var b=this.axis,u=b.transA,p=b.reversed,z=b.staggerLines,
t=b.tickRotCorr||{x:0,y:0},w=l.y,x=c||b.reserveSpaceDefault?0:-b.labelOffset*("center"===b.labelAlign?.5:1),q={};D(w)||(w=0===b.side?e.rotation?-8:-e.getBBox().height:2===b.side?t.y+8:Math.cos(e.rotation*y)*(t.y-e.getBBox(!1,0).height/2));a=a+l.x+x+t.x-(h&&c?h*u*(p?-1:1):0);f=f+w-(h&&!c?h*u*(p?1:-1):0);z&&(e=k/(d||1)%z,b.opposite&&(e=z-e-1),f+=b.labelOffset/z*e);q.x=a;q.y=Math.round(f);m(this,"afterGetLabelPosition",{pos:q});return q},getMarkPath:function(a,f,e,c,l,h){return h.crispLine(["M",a,f,
"L",a+(l?0:-e),f+(l?e:0)],c)},renderGridLine:function(a,f,e){var c=this.axis,l=c.options,h=this.gridLine,k={},d=this.pos,b=this.type,u=c.tickmarkOffset,p=c.chart.renderer,H=b?b+"Grid":"grid",t=l[H+"LineWidth"],w=l[H+"LineColor"],l=l[H+"LineDashStyle"];h||(k.stroke=w,k["stroke-width"]=t,l&&(k.dashstyle=l),b||(k.zIndex=1),a&&(k.opacity=0),this.gridLine=h=p.path().attr(k).addClass("highcharts-"+(b?b+"-":"")+"grid-line").add(c.gridGroup));if(!a&&h&&(a=c.getPlotLinePath(d+u,h.strokeWidth()*e,a,!0)))h[this.isNew?
"attr":"animate"]({d:a,opacity:f})},renderMark:function(a,f,e){var c=this.axis,l=c.options,h=c.chart.renderer,k=this.type,d=k?k+"Tick":"tick",b=c.tickSize(d),u=this.mark,p=!u,H=a.x;a=a.y;var t=r(l[d+"Width"],!k&&c.isXAxis?1:0),l=l[d+"Color"];b&&(c.opposite&&(b[0]=-b[0]),p&&(this.mark=u=h.path().addClass("highcharts-"+(k?k+"-":"")+"tick").add(c.axisGroup),u.attr({stroke:l,"stroke-width":t})),u[p?"attr":"animate"]({d:this.getMarkPath(H,a,b[0],u.strokeWidth()*e,c.horiz,h),opacity:f}))},renderLabel:function(a,
f,e,c){var l=this.axis,z=l.horiz,k=l.options,d=this.label,b=k.labels,u=b.step,l=l.tickmarkOffset,p=!0,H=a.x;a=a.y;d&&h(H)&&(d.xy=a=this.getLabelPosition(H,a,d,z,b,l,c,u),this.isFirst&&!this.isLast&&!r(k.showFirstLabel,1)||this.isLast&&!this.isFirst&&!r(k.showLastLabel,1)?p=!1:!z||b.step||b.rotation||f||0===e||this.handleOverflow(a),u&&c%u&&(p=!1),p&&h(a.y)?(a.opacity=e,d[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(d.attr("y",-9999),this.isNewLabel=!0))},render:function(f,h,e){var c=
this.axis,l=c.horiz,z=this.getPosition(l,this.pos,c.tickmarkOffset,h),k=z.x,d=z.y,c=l&&k===c.pos+c.len||!l&&d===c.pos?-1:1;e=r(e,1);this.isActive=!0;this.renderGridLine(h,e,c);this.renderMark(z,e,c);this.renderLabel(z,h,e,f);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){E(this,this.axis)}}})(K);var V=function(a){var C=a.addEvent,D=a.animObject,E=a.arrayMax,m=a.arrayMin,h=a.color,f=a.correctFloat,r=a.defaultOptions,y=a.defined,q=a.deg2rad,w=a.destroyObjectProperties,e=a.each,c=
a.extend,l=a.fireEvent,z=a.format,k=a.getMagnitude,d=a.grep,b=a.inArray,u=a.isArray,p=a.isNumber,H=a.isString,t=a.merge,L=a.normalizeTickInterval,x=a.objectEach,I=a.pick,n=a.removeEvent,G=a.splat,B=a.syncTimeout,M=a.Tick,F=function(){this.init.apply(this,arguments)};a.extend(F.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,x:0,style:{color:"#666666",
cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,
tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},
defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,d){var g=d.isX,v=this;v.chart=a;v.horiz=a.inverted&&!v.isZAxis?!g:g;v.isXAxis=g;v.coll=v.coll||(g?"xAxis":"yAxis");l(this,"init",{userOptions:d});v.opposite=d.opposite;v.side=d.side||(v.horiz?v.opposite?0:2:v.opposite?1:3);v.setOptions(d);var c=this.options,k=c.type;v.labelFormatter=c.labels.formatter||v.defaultLabelFormatter;v.userOptions=d;v.minPixelPadding=0;v.reversed=c.reversed;v.visible=!1!==c.visible;
v.zoomEnabled=!1!==c.zoomEnabled;v.hasNames="category"===k||!0===c.categories;v.categories=c.categories||v.hasNames;v.names||(v.names=[],v.names.keys={});v.plotLinesAndBandsGroups={};v.isLog="logarithmic"===k;v.isDatetimeAxis="datetime"===k;v.positiveValuesOnly=v.isLog&&!v.allowNegativeLog;v.isLinked=y(c.linkedTo);v.ticks={};v.labelEdge=[];v.minorTicks={};v.plotLinesAndBands=[];v.alternateBands={};v.len=0;v.minRange=v.userMinRange=c.minRange||c.maxZoom;v.range=c.range;v.offset=c.offset||0;v.stacks=
{};v.oldStacks={};v.stacksTouched=0;v.max=null;v.min=null;v.crosshair=I(c.crosshair,G(a.options.tooltip.crosshairs)[g?0:1],!1);d=v.options.events;-1===b(v,a.axes)&&(g?a.axes.splice(a.xAxis.length,0,v):a.axes.push(v),a[v.coll].push(v));v.series=v.series||[];a.inverted&&!v.isZAxis&&g&&void 0===v.reversed&&(v.reversed=!0);x(d,function(a,g){C(v,g,a)});v.lin2log=c.linearToLogConverter||v.lin2log;v.isLog&&(v.val2lin=v.log2lin,v.lin2val=v.lin2log);l(this,"afterInit")},setOptions:function(a){this.options=
t(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],t(r[this.coll],a));l(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var g=this.axis,b=this.value,d=g.chart.time,c=g.categories,k=this.dateTimeLabelFormat,n=r.lang,e=n.numericSymbols,n=n.numericSymbolMagnitude||1E3,p=e&&e.length,l,u=g.options.labels.format,g=g.isLog?Math.abs(b):g.tickInterval;
if(u)l=z(u,this,d);else if(c)l=b;else if(k)l=d.dateFormat(k,b);else if(p&&1E3<=g)for(;p--&&void 0===l;)d=Math.pow(n,p+1),g>=d&&0===10*b%d&&null!==e[p]&&0!==b&&(l=a.numberFormat(b/d,-1)+e[p]);void 0===l&&(l=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return l},getSeriesExtremes:function(){var a=this,b=a.chart;l(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();e(a.series,
function(g){if(g.visible||!b.options.chart.ignoreHiddenSeries){var v=g.options,c=v.threshold,k;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=c&&(c=null);if(a.isXAxis)v=g.xData,v.length&&(g=m(v),k=E(v),p(g)||g instanceof Date||(v=d(v,p),g=m(v),k=E(v)),v.length&&(a.dataMin=Math.min(I(a.dataMin,v[0],g),g),a.dataMax=Math.max(I(a.dataMax,v[0],k),k)));else if(g.getExtremes(),k=g.dataMax,g=g.dataMin,y(g)&&y(k)&&(a.dataMin=Math.min(I(a.dataMin,g),g),a.dataMax=Math.max(I(a.dataMax,k),k)),y(c)&&(a.threshold=
c),!v.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});l(this,"afterGetSeriesExtremes")},translate:function(a,b,d,c,k,n){var g=this.linkedParent||this,v=1,e=0,J=c?g.oldTransA:g.transA;c=c?g.oldMin:g.min;var l=g.minPixelPadding;k=(g.isOrdinal||g.isBroken||g.isLog&&k)&&g.lin2val;J||(J=g.transA);d&&(v*=-1,e=g.len);g.reversed&&(v*=-1,e-=v*(g.sector||g.len));b?(a=(a*v+e-l)/J+c,k&&(a=g.lin2val(a))):(k&&(a=g.val2lin(a)),a=p(c)?v*(a-c)*J+e+v*l+(p(n)?J*n:0):void 0);return a},toPixels:function(a,
b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,d,c,k){var g=this.chart,v=this.left,n=this.top,e,J,l=d&&g.oldChartHeight||g.chartHeight,u=d&&g.oldChartWidth||g.chartWidth,B;e=this.transB;var f=function(a,g,b){if(a<g||a>b)c?a=Math.min(Math.max(g,a),b):B=!0;return a};k=I(k,this.translate(a,null,null,d));k=Math.min(Math.max(-1E5,k),1E5);a=d=Math.round(k+e);e=J=Math.round(l-
k-e);p(k)?this.horiz?(e=n,J=l-this.bottom,a=d=f(a,v,v+this.width)):(a=v,d=u-this.right,e=J=f(e,n,n+this.height)):(B=!0,c=!1);return B&&!c?null:g.renderer.crispLine(["M",a,e,"L",d,J],b||1)},getLinearTickPositions:function(a,b,d){var g,v=f(Math.floor(b/a)*a);d=f(Math.ceil(d/a)*a);var c=[],k;f(v+a)===v&&(k=20);if(this.single)return[b];for(b=v;b<=d;){c.push(b);b=f(b+a,k);if(b===g)break;g=b}return c},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?I(a.minorTickInterval,"auto"):
!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,d=a.tickPositions,c=a.minorTickInterval,k=[],n=a.pointRangePadding||0,p=a.min-n,n=a.max+n,l=n-p;if(l&&l/c<a.len/3)if(a.isLog)e(this.paddedTicks,function(g,b,d){b&&k.push.apply(k,a.getLogTickPositions(c,d[b-1],d[b],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())k=k.concat(a.getTimeTicks(a.normalizeTimeTickInterval(c),p,n,b.startOfWeek));else for(b=p+(d[0]-p)%c;b<=n&&b!==k[0];b+=
c)k.push(b);0!==k.length&&a.trimTicks(k);return k},adjustForMinRange:function(){var a=this.options,b=this.min,d=this.max,c,k,n,p,l,u,B,f;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(y(a.min)||y(a.max)?this.minRange=null:(e(this.series,function(a){u=a.xData;for(p=B=a.xIncrement?1:u.length-1;0<p;p--)if(l=u[p]-u[p-1],void 0===n||l<n)n=l}),this.minRange=Math.min(5*n,this.dataMax-this.dataMin)));d-b<this.minRange&&(k=this.dataMax-this.dataMin>=this.minRange,f=this.minRange,c=(f-d+b)/2,c=[b-c,I(a.min,
b-c)],k&&(c[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=E(c),d=[b+f,I(a.max,b+f)],k&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),d=m(d),d-b<f&&(c[0]=d-f,c[1]=I(a.min,d-f),b=E(c)));this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:e(this.series,function(g){var b=g.closestPointRange,d=g.visible||!g.chart.options.chart.ignoreHiddenSeries;!g.noSharedTooltip&&y(b)&&d&&(a=y(a)?Math.min(a,b):b)});return a},nameToX:function(a){var g=u(this.categories),d=g?this.categories:
this.names,c=a.options.x,k;a.series.requireSorting=!1;y(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():g?b(a.name,d):I(d.keys[a.name],-1));-1===c?g||(k=d.length):k=c;void 0!==k&&(this.names[k]=a.name,this.names.keys[a.name]=k);return k},updateNames:function(){var b=this,d=this.names;0<d.length&&(e(a.keys(d.keys),function(a){delete d.keys[a]}),d.length=0,this.minRange=this.userMinRange,e(this.series||[],function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)a.processData(),a.generatePoints();
e(a.points,function(g,d){var c;g.options&&(c=b.nameToX(g),void 0!==c&&c!==g.x&&(g.x=c,a.xData[d]=c))})}))},setAxisTranslation:function(a){var b=this,g=b.max-b.min,d=b.axisPointRange||0,c,k=0,n=0,p=b.linkedParent,u=!!b.categories,f=b.transA,B=b.isXAxis;if(B||u||d)c=b.getClosest(),p?(k=p.minPointOffset,n=p.pointRangePadding):e(b.series,function(a){var g=u?1:B?I(a.options.pointRange,c,0):b.axisPointRange||0;a=a.options.pointPlacement;d=Math.max(d,g);b.single||(k=Math.max(k,H(a)?0:g/2),n=Math.max(n,"on"===
a?0:g))}),p=b.ordinalSlope&&c?b.ordinalSlope/c:1,b.minPointOffset=k*=p,b.pointRangePadding=n*=p,b.pointRange=Math.min(d,g),B&&(b.closestPointRange=c);a&&(b.oldTransA=f);b.translationSlope=b.transA=f=b.options.staticScale||b.len/(g+n||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=f*k;l(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(b){var g=this,d=g.chart,c=g.options,n=g.isLog,u=g.isDatetimeAxis,B=g.isXAxis,t=g.isLinked,h=c.maxPadding,
G=c.minPadding,x=c.tickInterval,z=c.tickPixelInterval,F=g.categories,H=p(g.threshold)?g.threshold:null,w=g.softThreshold,q,M,m,r;u||F||t||this.getTickAmount();m=I(g.userMin,c.min);r=I(g.userMax,c.max);t?(g.linkedParent=d[g.coll][c.linkedTo],d=g.linkedParent.getExtremes(),g.min=I(d.min,d.dataMin),g.max=I(d.max,d.dataMax),c.type!==g.linkedParent.options.type&&a.error(11,1)):(!w&&y(H)&&(g.dataMin>=H?(q=H,G=0):g.dataMax<=H&&(M=H,h=0)),g.min=I(m,q,g.dataMin),g.max=I(r,M,g.dataMax));n&&(g.positiveValuesOnly&&
!b&&0>=Math.min(g.min,I(g.dataMin,g.min))&&a.error(10,1),g.min=f(g.log2lin(g.min),15),g.max=f(g.log2lin(g.max),15));g.range&&y(g.max)&&(g.userMin=g.min=m=Math.max(g.dataMin,g.minFromRange()),g.userMax=r=g.max,g.range=null);l(g,"foundExtremes");g.beforePadding&&g.beforePadding();g.adjustForMinRange();!(F||g.axisPointRange||g.usePercentage||t)&&y(g.min)&&y(g.max)&&(d=g.max-g.min)&&(!y(m)&&G&&(g.min-=d*G),!y(r)&&h&&(g.max+=d*h));p(c.softMin)&&!p(g.userMin)&&(g.min=Math.min(g.min,c.softMin));p(c.softMax)&&
!p(g.userMax)&&(g.max=Math.max(g.max,c.softMax));p(c.floor)&&(g.min=Math.max(g.min,c.floor));p(c.ceiling)&&(g.max=Math.min(g.max,c.ceiling));w&&y(g.dataMin)&&(H=H||0,!y(m)&&g.min<H&&g.dataMin>=H?g.min=H:!y(r)&&g.max>H&&g.dataMax<=H&&(g.max=H));g.tickInterval=g.min===g.max||void 0===g.min||void 0===g.max?1:t&&!x&&z===g.linkedParent.options.tickPixelInterval?x=g.linkedParent.tickInterval:I(x,this.tickAmount?(g.max-g.min)/Math.max(this.tickAmount-1,1):void 0,F?1:(g.max-g.min)*z/Math.max(g.len,z));B&&
!b&&e(g.series,function(a){a.processData(g.min!==g.oldMin||g.max!==g.oldMax)});g.setAxisTranslation(!0);g.beforeSetTickPositions&&g.beforeSetTickPositions();g.postProcessTickInterval&&(g.tickInterval=g.postProcessTickInterval(g.tickInterval));g.pointRange&&!x&&(g.tickInterval=Math.max(g.pointRange,g.tickInterval));b=I(c.minTickInterval,g.isDatetimeAxis&&g.closestPointRange);!x&&g.tickInterval<b&&(g.tickInterval=b);u||n||x||(g.tickInterval=L(g.tickInterval,null,k(g.tickInterval),I(c.allowDecimals,
!(.5<g.tickInterval&&5>g.tickInterval&&1E3<g.max&&9999>g.max)),!!this.tickAmount));this.tickAmount||(g.tickInterval=g.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,d=a.tickPositions;b=this.getMinorTickInterval();var c=a.tickPositioner,k=a.startOnTick,n=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/5:b;this.single=this.min===this.max&&
y(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=d&&d.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()],b[0]===b[1]&&(b.length=
1)),this.tickPositions=b,c&&(c=c.apply(this,[this.min,this.max])))&&(this.tickPositions=b=c);this.paddedTicks=b.slice(0);this.trimTicks(b,k,n);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),d||c||this.adjustTickAmount());l(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var g=a[0],c=a[a.length-1],k=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==g)this.min=g;else for(;this.min-k>a[0];)a.shift();if(d)this.max=c;else for(;this.max+k<a[a.length-1];)a.pop();
0===a.length&&y(g)&&!this.options.tickPositions&&a.push((c+g)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||e(this.chart[this.coll],function(g){var d=g.options,d=[g.horiz?d.left:d.top,d.width,d.height,d.pane].join();g.series.length&&(a[d]?b=!0:a[d]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,d=a.tickPixelInterval;!y(a.tickInterval)&&this.len<d&&!this.isRadial&&
!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,d=this.tickAmount,c=this.finalTickAmt,k=b&&b.length,n=I(this.threshold,this.softThreshold?0:null);if(this.hasData()){if(k<d){for(;b.length<d;)b.length%2||this.min===n?b.push(f(b[b.length-1]+a)):b.unshift(f(b[0]-a));this.transA*=(k-1)/(d-1);this.min=b[0];this.max=b[b.length-1]}else k>
d&&(this.tickInterval*=2,this.setTickPositions());if(y(c)){for(a=d=b.length;a--;)(3===c&&1===a%2||2>=c&&0<a&&a<d-1)&&b.splice(a,1);this.finalTickAmt=void 0}}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;e(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?
(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();l(this,"afterSetScale")},setExtremes:function(a,b,d,k,n){var g=this,p=g.chart;d=I(d,!0);e(g.series,function(a){delete a.kdTree});n=c(n,{min:a,max:b});l(g,"setExtremes",n,function(){g.userMin=a;g.userMax=b;g.eventArgs=n;d&&
p.redraw(k)})},zoom:function(a,b){var g=this.dataMin,d=this.dataMax,c=this.options,k=Math.min(g,I(c.min,g)),c=Math.max(d,I(c.max,d));if(a!==this.min||b!==this.max)this.allowZoomOutside||(y(g)&&(a<k&&(a=k),a>c&&(a=c)),y(d)&&(b<k&&(b=k),b>c&&(b=c))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,d=this.options,c=d.offsets||[0,0,0,0],k=this.horiz,n=this.width=Math.round(a.relativeLength(I(d.width,b.plotWidth-c[3]+
c[1]),b.plotWidth)),e=this.height=Math.round(a.relativeLength(I(d.height,b.plotHeight-c[0]+c[2]),b.plotHeight)),p=this.top=Math.round(a.relativeLength(I(d.top,b.plotTop+c[0]),b.plotHeight,b.plotTop)),d=this.left=Math.round(a.relativeLength(I(d.left,b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-e-p;this.right=b.chartWidth-n-d;this.len=Math.max(k?n:e,0);this.pos=k?d:p},getExtremes:function(){var a=this.isLog;return{min:a?f(this.lin2log(this.min)):this.min,max:a?f(this.lin2log(this.max)):
this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,g=b?this.lin2log(this.min):this.min,b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=g:Infinity===a?a=b:g>a?a=g:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(I(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,g=b[a+"Length"],d=I(b[a+"Width"],"tick"===
a&&this.isXAxis?1:0);if(d&&g)return"inside"===b[a+"Position"]&&(g=-g),[g,d]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,d=this.tickInterval,c=d,k=this.len/(((this.categories?1:0)+this.max-this.min)/d),n,p=a.rotation,l=this.labelMetrics(),u,B=Number.MAX_VALUE,t,h=function(a){a/=
k||1;a=1<a?Math.ceil(a):1;return f(a*d)};b?(t=!a.staggerLines&&!a.step&&(y(p)?[p]:k<I(a.autoRotationLimit,80)&&a.autoRotation))&&e(t,function(a){var b;if(a===p||a&&-90<=a&&90>=a)u=h(Math.abs(l.h/Math.sin(q*a))),b=u+Math.abs(a/360),b<B&&(B=b,n=a,c=u)}):a.step||(c=h(l.h));this.autoRotation=t;this.labelRotation=I(n,p);return c},getSlotWidth:function(){var a=this.chart,b=this.horiz,d=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),k=a.margin[3];return b&&2>(d.step||0)&&
!d.rotation&&(this.staggerLines||1)*this.len/c||!b&&(d.style&&parseInt(d.style.width,10)||k&&k-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,c=this.ticks,k=this.options.labels,n=k&&k.style||{},p=this.horiz,l=this.getSlotWidth(),u=Math.max(1,Math.round(l-2*(k.padding||5))),B={},f=this.labelMetrics(),t=k.style&&k.style.textOverflow,h,G,x=0,z;H(k.rotation)||(B.rotation=k.rotation||0);e(d,function(a){(a=c[a])&&a.label&&a.label.textPxLength>
x&&(x=a.label.textPxLength)});this.maxLabelLength=x;if(this.autoRotation)x>u&&x>f.h?B.rotation=this.labelRotation:this.labelRotation=0;else if(l&&(h=u,!t))for(G="clip",u=d.length;!p&&u--;)if(z=d[u],z=c[z].label)z.styles&&"ellipsis"===z.styles.textOverflow?z.css({textOverflow:"clip"}):z.textPxLength>l&&z.css({width:l+"px"}),z.getBBox().height>this.len/d.length-(f.h-f.f)&&(z.specificTextOverflow="ellipsis");B.rotation&&(h=x>.5*a.chartHeight?.33*a.chartHeight:x,t||(G="ellipsis"));if(this.labelAlign=
k.align||this.autoLabelAlign(this.labelRotation))B.align=this.labelAlign;e(d,function(a){var b=(a=c[a])&&a.label,g=n.width,d={};b&&(b.attr(B),h&&!g&&"nowrap"!==n.whiteSpace&&(h<b.textPxLength||"SPAN"===b.element.tagName)?(d.width=h,t||(d.textOverflow=b.specificTextOverflow||G),b.css(d)):b.styles&&b.styles.width&&!d.width&&!g&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=B.rotation)});this.tickRotCorr=b.rotCorr(f.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||
y(this.min)&&y(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,g=this.horiz,d=this.opposite,c=this.options.title,k;this.axisTitle||((k=c.textAlign)||(k=(g?{low:"left",middle:"center",high:"right"}:{low:d?"right":"left",middle:"center",high:d?"left":"right"})[c.align]),this.axisTitle=b.text(c.text,0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation||0,align:k}).addClass("highcharts-axis-title").css(t(c.style)).add(this.axisGroup),this.axisTitle.isNew=
!0);c.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new M(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,c=a.options,k=a.tickPositions,n=a.ticks,p=a.horiz,u=a.side,B=b.inverted&&!a.isZAxis?[1,0,3,2][u]:u,f,t,h=0,G,z=0,H=c.title,F=c.labels,w=0,q=b.axisOffset,b=b.clipOffset,m=[-1,1,1,-1][u],M=c.className,r=a.axisParent,L=this.tickSize("tick");f=a.hasData();a.showAxis=
t=f||I(c.showEmpty,!0);a.staggerLines=a.horiz&&F.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(M||"")).add(r),a.axisGroup=d.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(M||"")).add(r),a.labelGroup=d.g("axis-labels").attr({zIndex:F.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(M||"")).add(r));f||a.isLinked?(e(k,function(b,g){a.generateTick(b,
g)}),a.renderUnsquish(),a.reserveSpaceDefault=0===u||2===u||{1:"left",3:"right"}[u]===a.labelAlign,I(F.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&e(k,function(a){w=Math.max(n[a].getLabelSize(),w)}),a.staggerLines&&(w*=a.staggerLines),a.labelOffset=w*(a.opposite?-1:1)):x(n,function(a,b){a.destroy();delete n[b]});H&&H.text&&!1!==H.enabled&&(a.addTitle(t),t&&!1!==H.reserveSpace&&(a.titleOffset=h=a.axisTitle.getBBox()[p?"height":"width"],G=H.offset,z=y(G)?0:I(H.margin,p?5:10)));
a.renderLine();a.offset=m*I(c.offset,q[u]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===u?-a.labelMetrics().h:2===u?a.tickRotCorr.y:0;z=Math.abs(w)+z;w&&(z=z-d+m*(p?I(F.y,a.tickRotCorr.y+8*m):F.x));a.axisTitleMargin=I(G,z);q[u]=Math.max(q[u],a.axisTitleMargin+h+m*a.offset,z,f&&k.length&&L?L[0]+m*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[B]=Math.max(b[B],c);l(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,g=this.opposite,d=this.offset,c=this.horiz,k=this.left+
(g?this.width:0)+d,d=b.chartHeight-this.bottom-(g?this.height:0)+d;g&&(a*=-1);return b.renderer.crispLine(["M",c?this.left:k,c?d:this.top,"L",c?b.chartWidth-this.right:k,c?d:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,
c=this.len,k=this.options.title,n=a?b:d,e=this.opposite,p=this.offset,l=k.x||0,u=k.y||0,B=this.axisTitle,f=this.chart.renderer.fontMetrics(k.style&&k.style.fontSize,B),B=Math.max(B.getBBox(null,0).height-f.h-1,0),c={low:n+(a?0:c),middle:n+c/2,high:n+(a?c:0)}[k.align],b=(a?d+this.height:b)+(a?1:-1)*(e?-1:1)*this.axisTitleMargin+[-B,B,f.f,-B][this.side];return{x:a?c+l:b+(e?this.width:0)+p+l,y:a?b+u-(e?this.height:0)+p:c+u}},renderMinorTick:function(a){var b=this.chart.hasRendered&&p(this.oldMin),d=
this.minorTicks;d[a]||(d[a]=new M(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,g=this.ticks,c=this.chart.hasRendered&&p(this.oldMin);if(!d||a>=this.min&&a<=this.max)g[a]||(g[a]=new M(this,a)),c&&g[a].isNew&&g[a].render(b,!0,.1),g[a].render(b)},render:function(){var b=this,d=b.chart,c=b.options,k=b.isLog,n=b.isLinked,u=b.tickPositions,f=b.axisTitle,t=b.ticks,h=b.minorTicks,G=b.alternateBands,z=c.stackLabels,H=c.alternateGridColor,
F=b.tickmarkOffset,w=b.axisLine,I=b.showAxis,m=D(d.renderer.globalAnimation),q,r;b.labelEdge.length=0;b.overlap=!1;e([t,h,G],function(a){x(a,function(a){a.isActive=!1})});if(b.hasData()||n)b.minorTickInterval&&!b.categories&&e(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),u.length&&(e(u,function(a,d){b.renderTick(a,d)}),F&&(0===b.min||b.single)&&(t[-1]||(t[-1]=new M(b,-1,null,!0)),t[-1].render(-1))),H&&e(u,function(c,g){r=void 0!==u[g+1]?u[g+1]+F:b.max-F;0===g%2&&c<b.max&&r<=b.max+
(d.polar?-F:F)&&(G[c]||(G[c]=new a.PlotLineOrBand(b)),q=c+F,G[c].options={from:k?b.lin2log(q):q,to:k?b.lin2log(r):r,color:H},G[c].render(),G[c].isActive=!0)}),b._addedPlotLB||(e((c.plotLines||[]).concat(c.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);e([t,h,G],function(a){var b,c=[],g=m.duration;x(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,c.push(b))});B(function(){for(b=c.length;b--;)a[c[b]]&&!a[c[b]].isActive&&(a[c[b]].destroy(),delete a[c[b]])},a!==G&&
d.hasRendered&&g?g:0)});w&&(w[w.isPlaced?"animate":"attr"]({d:this.getLinePath(w.strokeWidth())}),w.isPlaced=!0,w[I?"show":"hide"](!0));f&&I&&(c=b.getTitlePosition(),p(c.y)?(f[f.isNew?"attr":"animate"](c),f.isNew=!1):(f.attr("y",-9999),f.isNew=!0));z&&z.enabled&&b.renderStackTotals();b.isDirty=!1;l(this,"afterRender")},redraw:function(){this.visible&&(this.render(),e(this.plotLinesAndBands,function(a){a.render()}));e(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),
destroy:function(a){var d=this,c=d.stacks,g=d.plotLinesAndBands,k;l(this,"destroy",{keepEvents:a});a||n(d);x(c,function(a,b){w(a);c[b]=null});e([d.ticks,d.minorTicks,d.alternateBands],function(a){w(a)});if(g)for(a=g.length;a--;)g[a].destroy();e("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" "),function(a){d[a]&&(d[a]=d[a].destroy())});for(k in d.plotLinesAndBandsGroups)d.plotLinesAndBandsGroups[k]=d.plotLinesAndBandsGroups[k].destroy();x(d,function(a,c){-1===
b(c,d.keepProps)&&delete d[c]})},drawCrosshair:function(a,b){var d,c=this.crosshair,g=I(c.snap,!0),k,n=this.cross;l(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(y(b)||!g)){g?y(b)&&(k=I(b.crosshairPos,this.isXAxis?b.plotX:this.len-b.plotY)):k=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);y(k)&&(d=this.getPlotLinePath(b&&(this.isXAxis?b.x:I(b.stackY,b.y)),null,null,null,k)||null);if(!y(d)){this.hideCrosshair();return}g=this.categories&&
!this.isRadial;n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(g?"category ":"thin ")+c.className).attr({zIndex:I(c.zIndex,2)}).add(),n.attr({stroke:c.color||(g?h("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":I(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&n.attr({dashstyle:c.dashStyle}));n.show().attr({d:d});g&&!c.width&&n.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();l(this,"afterDrawCrosshair",
{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=F}(K);(function(a){var C=a.Axis,D=a.getMagnitude,E=a.normalizeTickInterval,m=a.timeUnits;C.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};C.prototype.normalizeTimeTickInterval=function(a,f){var h=f||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],
["month",[1,2,3,4,6]],["year",null]];f=h[h.length-1];var y=m[f[0]],q=f[1],w;for(w=0;w<h.length&&!(f=h[w],y=m[f[0]],q=f[1],h[w+1]&&a<=(y*q[q.length-1]+m[h[w+1][0]])/2);w++);y===m.year&&a<5*y&&(q=[1,2,5]);a=E(a/y,q,"year"===f[0]?Math.max(D(a/y),1):1);return{unitRange:y,count:a,unitName:f[0]}}})(K);(function(a){var C=a.Axis,D=a.getMagnitude,E=a.map,m=a.normalizeTickInterval,h=a.pick;C.prototype.getLogTickPositions=function(a,r,y,q){var f=this.options,e=this.len,c=[];q||(this._minorAutoInterval=null);
if(.5<=a)a=Math.round(a),c=this.getLinearTickPositions(a,r,y);else if(.08<=a)for(var e=Math.floor(r),l,z,k,d,b,f=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];e<y+1&&!b;e++)for(z=f.length,l=0;l<z&&!b;l++)k=this.log2lin(this.lin2log(e)*f[l]),k>r&&(!q||d<=y)&&void 0!==d&&c.push(d),d>y&&(b=!0),d=k;else r=this.lin2log(r),y=this.lin2log(y),a=q?this.getMinorTickInterval():f.tickInterval,a=h("auto"===a?null:a,this._minorAutoInterval,f.tickPixelInterval/(q?5:1)*(y-r)/((q?e/this.tickPositions.length:
e)||1)),a=m(a,null,D(a)),c=E(this.getLinearTickPositions(a,r,y),this.log2lin),q||(this._minorAutoInterval=a/5);q||(this.tickInterval=a);return c};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,a)}})(K);(function(a,C){var D=a.arrayMax,E=a.arrayMin,m=a.defined,h=a.destroyObjectProperties,f=a.each,r=a.erase,y=a.merge,q=a.pick;a.PlotLineOrBand=function(a,e){this.axis=a;e&&(this.options=e,this.id=e.id)};a.PlotLineOrBand.prototype={render:function(){var f=
this,e=f.axis,c=e.horiz,l=f.options,h=l.label,k=f.label,d=l.to,b=l.from,u=l.value,p=m(b)&&m(d),H=m(u),t=f.svgElem,r=!t,x=[],I=l.color,n=q(l.zIndex,0),G=l.events,x={"class":"highcharts-plot-"+(p?"band ":"line ")+(l.className||"")},B={},M=e.chart.renderer,F=p?"bands":"lines";e.isLog&&(b=e.log2lin(b),d=e.log2lin(d),u=e.log2lin(u));H?(x.stroke=I,x["stroke-width"]=l.width,l.dashStyle&&(x.dashstyle=l.dashStyle)):p&&(I&&(x.fill=I),l.borderWidth&&(x.stroke=l.borderColor,x["stroke-width"]=l.borderWidth));
B.zIndex=n;F+="-"+n;(I=e.plotLinesAndBandsGroups[F])||(e.plotLinesAndBandsGroups[F]=I=M.g("plot-"+F).attr(B).add());r&&(f.svgElem=t=M.path().attr(x).add(I));if(H)x=e.getPlotLinePath(u,t.strokeWidth());else if(p)x=e.getPlotBandPath(b,d,l);else return;r&&x&&x.length?(t.attr({d:x}),G&&a.objectEach(G,function(a,b){t.on(b,function(a){G[b].apply(f,[a])})})):t&&(x?(t.show(),t.animate({d:x})):(t.hide(),k&&(f.label=k=k.destroy())));h&&m(h.text)&&x&&x.length&&0<e.width&&0<e.height&&!x.isFlat?(h=y({align:c&&
p&&"center",x:c?!p&&4:10,verticalAlign:!c&&p&&"middle",y:c?p?16:10:p?6:-4,rotation:c&&!p&&90},h),this.renderLabel(h,x,p,n)):k&&k.hide();return f},renderLabel:function(a,e,c,l){var f=this.label,k=this.axis.chart.renderer;f||(f={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(c?"band":"line")+"-label "+(a.className||"")},f.zIndex=l,this.label=f=k.text(a.text,0,0,a.useHTML).attr(f).add(),f.css(a.style));l=e.xBounds||[e[1],e[4],c?e[6]:e[1]];e=e.yBounds||[e[2],e[5],c?e[7]:e[2]];
c=E(l);k=E(e);f.align(a,!1,{x:c,y:k,width:D(l)-c,height:D(e)-k});f.show()},destroy:function(){r(this.axis.plotLinesAndBands,this);delete this.axis;h(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,e){var c=this.getPlotLinePath(e,null,null,!0),l=this.getPlotLinePath(a,null,null,!0),f=[],k=this.horiz,d=1,b;a=a<this.min&&e<this.min||a>this.max&&e>this.max;if(l&&c)for(a&&(b=l.toString()===c.toString(),d=0),a=0;a<l.length;a+=6)k&&c[a+1]===l[a+1]?(c[a+1]+=d,c[a+4]+=d):k||c[a+2]!==l[a+2]||(c[a+
2]+=d,c[a+5]+=d),f.push("M",l[a+1],l[a+2],"L",l[a+4],l[a+5],c[a+4],c[a+5],c[a+1],c[a+2],"z"),f.isFlat=b;return f},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(f,e){var c=(new a.PlotLineOrBand(this,f)).render(),l=this.userOptions;c&&(e&&(l[e]=l[e]||[],l[e].push(f)),this.plotLinesAndBands.push(c));return c},removePlotBandOrLine:function(a){for(var e=this.plotLinesAndBands,c=this.options,
l=this.userOptions,h=e.length;h--;)e[h].id===a&&e[h].destroy();f([c.plotLines||[],l.plotLines||[],c.plotBands||[],l.plotBands||[]],function(c){for(h=c.length;h--;)c[h].id===a&&r(c,c[h])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(K,V);(function(a){var C=a.doc,D=a.each,E=a.extend,m=a.format,h=a.isNumber,f=a.map,r=a.merge,y=a.pick,q=a.splat,w=a.syncTimeout,e=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};
a.Tooltip.prototype={init:function(a,e){this.chart=a;this.options=e;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=e.split&&!a.inverted;this.shared=e.shared||this.split;this.outside=e.outside&&!this.split},cleanSplit:function(a){D(this.chart.series,function(c){var e=c&&c.tt;e&&(!e.isActive||a?c.tt=e.destroy():e.isActive=!1)})},getLabel:function(){var c=this.chart.renderer,e=this.options,f;this.label||(this.outside&&(this.container=f=a.doc.createElement("div"),f.className="highcharts-tooltip-container",
a.css(f,{position:"absolute",top:"1px",pointerEvents:e.style&&e.style.pointerEvents}),a.doc.body.appendChild(f),this.renderer=c=new a.Renderer(f,0,0)),this.split?this.label=c.g("tooltip"):(this.label=c.label("",0,0,e.shape||"callout",null,null,e.useHTML,null,"tooltip").attr({padding:e.padding,r:e.borderRadius}),this.label.attr({fill:e.backgroundColor,"stroke-width":e.borderWidth}).css(e.style).shadow(e.shadow)),this.outside&&(this.label.attr({x:this.distance,y:this.distance}),this.label.xSetter=function(a){f.style.left=
a+"px"},this.label.ySetter=function(a){f.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();r(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,r(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),a.discardElement(this.container));a.clearTimeout(this.hideTimer);
a.clearTimeout(this.tooltipTimeout)},move:function(c,e,f,k){var d=this,b=d.now,u=!1!==d.options.animation&&!d.isHidden&&(1<Math.abs(c-b.x)||1<Math.abs(e-b.y)),p=d.followPointer||1<d.len;E(b,{x:u?(2*b.x+c)/3:c,y:u?(b.y+e)/2:e,anchorX:p?void 0:u?(2*b.anchorX+f)/3:f,anchorY:p?void 0:u?(b.anchorY+k)/2:k});d.getLabel().attr(b);u&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){d&&d.move(c,e,f,k)},32))},hide:function(c){var e=this;a.clearTimeout(this.hideTimer);c=y(c,this.options.hideDelay,
500);this.isHidden||(this.hideTimer=w(function(){e.getLabel()[c?"fadeOut":"hide"]();e.isHidden=!0},c))},getAnchor:function(a,e){var c=this.chart,k=c.pointer,d=c.inverted,b=c.plotTop,u=c.plotLeft,p=0,l=0,t,h;a=q(a);this.followPointer&&e||k.followTouchMove&&e&&"touchmove"===e.type?(void 0===e.chartX&&(e=k.normalize(e)),a=[e.chartX-c.plotLeft,e.chartY-b]):a[0].tooltipPos?a=a[0].tooltipPos:(D(a,function(a){t=a.series.yAxis;h=a.series.xAxis;p+=a.plotX+(!d&&h?h.left-u:0);l+=(a.plotLow?(a.plotLow+a.plotHigh)/
2:a.plotY)+(!d&&t?t.top-b:0)}),p/=a.length,l/=a.length,a=[d?c.plotWidth-l:p,this.shared&&!d&&1<a.length&&e?e.chartY-b:d?c.plotHeight-p:l]);return f(a,Math.round)},getPosition:function(a,e,f){var c=this.chart,d=this.distance,b={},u=c.inverted&&f.h||0,p,l=this.outside,t=l?C.documentElement.clientWidth-2*d:c.chartWidth,h=l?Math.max(C.body.scrollHeight,C.documentElement.scrollHeight,C.body.offsetHeight,C.documentElement.offsetHeight,C.documentElement.clientHeight):c.chartHeight,x=c.pointer.chartPosition,
z=["y",h,e,(l?x.top-d:0)+f.plotY+c.plotTop,l?0:c.plotTop,l?h:c.plotTop+c.plotHeight],n=["x",t,a,(l?x.left-d:0)+f.plotX+c.plotLeft,l?0:c.plotLeft,l?t:c.plotLeft+c.plotWidth],G=!this.followPointer&&y(f.ttBelow,!c.inverted===!!f.negative),B=function(a,c,g,k,n,e){var p=g<k-d,f=k+d+g<c,B=k-d-g;k+=d;if(G&&f)b[a]=k;else if(!G&&p)b[a]=B;else if(p)b[a]=Math.min(e-g,0>B-u?B:B-u);else if(f)b[a]=Math.max(n,k+u+g>c?k:k+u);else return!1},q=function(a,c,g,k){var n;k<d||k>c-d?n=!1:b[a]=k<g/2?1:k>c-g/2?c-g-2:k-g/
2;return n},F=function(a){var b=z;z=n;n=b;p=a},g=function(){!1!==B.apply(0,z)?!1!==q.apply(0,n)||p||(F(!0),g()):p?b.x=b.y=0:(F(!0),g())};(c.inverted||1<this.len)&&F();g();return b},defaultFormatter:function(a){var c=this.points||q(this),e;e=[a.tooltipFooterHeaderFormatter(c[0])];e=e.concat(a.bodyFormatter(c));e.push(a.tooltipFooterHeaderFormatter(c[0],!0));return e},refresh:function(c,e){var f,k=this.options,d,b=c,u,p={},l=[];f=k.formatter||this.defaultFormatter;var p=this.shared,t;k.enabled&&(a.clearTimeout(this.hideTimer),
this.followPointer=q(b)[0].series.tooltipOptions.followPointer,u=this.getAnchor(b,e),e=u[0],d=u[1],!p||b.series&&b.series.noSharedTooltip?p=b.getLabelConfig():(D(b,function(a){a.setState("hover");l.push(a.getLabelConfig())}),p={x:b[0].category,y:b[0].y},p.points=l,b=b[0]),this.len=l.length,p=f.call(p,this),t=b.series,this.distance=y(t.tooltipOptions.distance,16),!1===p?this.hide():(f=this.getLabel(),this.isHidden&&f.attr({opacity:1}).show(),this.split?this.renderSplit(p,q(c)):(k.style.width||f.css({width:this.chart.spacingBox.width}),
f.attr({text:p&&p.join?p.join(""):p}),f.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+y(b.colorIndex,t.colorIndex)),f.attr({stroke:k.borderColor||b.color||t.color||"#666666"}),this.updatePosition({plotX:e,plotY:d,negative:b.negative,ttBelow:b.ttBelow,h:u[2]||0})),this.isHidden=!1))},renderSplit:function(c,e){var f=this,k=[],d=this.chart,b=d.renderer,u=!0,p=this.options,l=0,t=this.getLabel();a.isString(c)&&(c=[!1,c]);D(c.slice(0,e.length+1),function(a,c){if(!1!==a){c=e[c-1]||
{isHeader:!0,plotX:e[0].plotX};var h=c.series||f,n=h.tt,G=c.series||{},B="highcharts-color-"+y(c.colorIndex,G.colorIndex,"none");n||(h.tt=n=b.label(null,null,null,"callout",null,null,p.useHTML).addClass("highcharts-tooltip-box "+B).attr({padding:p.padding,r:p.borderRadius,fill:p.backgroundColor,stroke:p.borderColor||c.color||G.color||"#333333","stroke-width":p.borderWidth}).add(t));n.isActive=!0;n.attr({text:a});n.css(p.style).shadow(p.shadow);a=n.getBBox();G=a.width+n.strokeWidth();c.isHeader?(l=
a.height,G=Math.max(0,Math.min(c.plotX+d.plotLeft-G/2,d.chartWidth-G))):G=c.plotX+d.plotLeft-y(p.distance,16)-G;0>G&&(u=!1);a=(c.series&&c.series.yAxis&&c.series.yAxis.pos)+(c.plotY||0);a-=d.plotTop;k.push({target:c.isHeader?d.plotHeight+l:a,rank:c.isHeader?1:0,size:h.tt.getBBox().height+1,point:c,x:G,tt:n})}});this.cleanSplit();a.distribute(k,d.plotHeight+l);D(k,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:u||b.isHeader?a.x:b.plotX+d.plotLeft+y(p.distance,
16),y:a.pos+d.plotTop,anchorX:b.isHeader?b.plotX+d.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+d.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var c=this.chart,e=this.getLabel(),k=(this.options.positioner||this.getPosition).call(this,e.width,e.height,a),d=a.plotX+c.plotLeft;a=a.plotY+c.plotTop;var b;this.outside&&(b=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(e.width+b,e.height+b,!1),d+=c.pointer.chartPosition.left-k.x,a+=c.pointer.chartPosition.top-
k.y);this.move(Math.round(k.x),Math.round(k.y||0),d,a)},getDateFormat:function(a,f,h,k){var d=this.chart.time,b=d.dateFormat("%m-%d %H:%M:%S.%L",f),c,p,l={millisecond:15,second:12,minute:9,hour:6,day:3},t="millisecond";for(p in e){if(a===e.week&&+d.dateFormat("%w",f)===h&&"00:00:00.000"===b.substr(6)){p="week";break}if(e[p]>a){p=t;break}if(l[p]&&b.substr(l[p])!=="01-01 00:00:00.000".substr(l[p]))break;"week"!==p&&(t=p)}p&&(c=k[p]);return c},getXDateFormat:function(a,e,f){e=e.dateTimeLabelFormats;
var c=f&&f.closestPointRange;return(c?this.getDateFormat(c,a.x,f.options.startOfWeek,e):e.day)||e.year},tooltipFooterHeaderFormatter:function(a,e){e=e?"footer":"header";var c=a.series,k=c.tooltipOptions,d=k.xDateFormat,b=c.xAxis,f=b&&"datetime"===b.options.type&&h(a.key),p=k[e+"Format"];f&&!d&&(d=this.getXDateFormat(a,k,b));f&&d&&D(a.point&&a.point.tooltipDateKeys||["key"],function(a){p=p.replace("{point."+a+"}","{point."+a+":"+d+"}")});return m(p,{point:a,series:c},this.chart.time)},bodyFormatter:function(a){return f(a,
function(a){var c=a.series.tooltipOptions;return(c[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,c[(a.point.formatPrefix||"point")+"Format"])})}}})(K);(function(a){var C=a.addEvent,D=a.attr,E=a.charts,m=a.color,h=a.css,f=a.defined,r=a.each,y=a.extend,q=a.find,w=a.fireEvent,e=a.isNumber,c=a.isObject,l=a.offset,z=a.pick,k=a.splat,d=a.Tooltip;a.Pointer=function(a,d){this.init(a,d)};a.Pointer.prototype={init:function(a,c){this.options=c;this.chart=a;this.runChartClick=
c.chart.events&&!!c.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,c.tooltip),this.followTouchMove=z(c.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,c=d.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(c=z(d.pinchType,c));this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(a,d){var b;b=a.touches?a.touches.length?a.touches.item(0):
a.changedTouches[0]:a;d||(this.chartPosition=d=l(this.chart.container));return y(a,{chartX:Math.round(b.pageX-d.left),chartY:Math.round(b.pageY-d.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};r(this.chart.axes,function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,d,k){var b;r(a,function(a){var e=!(a.noSharedTooltip&&d)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(k,e);if((e=c(a,
!0))&&!(e=!c(b,!0)))var e=b.distX-a.distX,f=b.dist-a.dist,p=(a.series.group&&a.series.group.zIndex)-(b.series.group&&b.series.group.zIndex),e=0<(0!==e&&d?e:0!==f?f:0!==p?p:b.series.index>a.series.index?-1:1);e&&(b=a)});return b},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,d){var b=a.series,c=b.xAxis,b=b.yAxis,k=z(a.clientX,a.plotX),e=a.shapeArgs;if(c&&b)return d?{chartX:c.len+c.pos-k,chartY:b.len+b.pos-a.plotY}:
{chartX:k+c.pos,chartY:a.plotY+b.pos};if(e&&e.x&&e.y)return{chartX:e.x,chartY:e.y}},getHoverData:function(b,d,k,e,f,h,l){var p,n=[],u=l&&l.isBoosting;e=!(!e||!b);l=d&&!d.stickyTracking?[d]:a.grep(k,function(a){return a.visible&&!(!f&&a.directTouch)&&z(a.options.enableMouseTracking,!0)&&a.stickyTracking});d=(p=e?b:this.findNearestKDPoint(l,f,h))&&p.series;p&&(f&&!d.noSharedTooltip?(l=a.grep(k,function(a){return a.visible&&!(!f&&a.directTouch)&&z(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),
r(l,function(a){var b=q(a.points,function(a){return a.x===p.x&&!a.isNull});c(b)&&(u&&(b=a.getPoint(b)),n.push(b))})):n.push(p));return{hoverPoint:p,hoverSeries:d,hoverPoints:n}},runPointActions:function(b,d){var c=this.chart,k=c.tooltip&&c.tooltip.options.enabled?c.tooltip:void 0,e=k?k.shared:!1,f=d||c.hoverPoint,l=f&&f.series||c.hoverSeries,l=this.getHoverData(f,l,c.series,!!d||l&&l.directTouch&&this.isDirectTouch,e,b,{isBoosting:c.isBoosting}),u,f=l.hoverPoint;u=l.hoverPoints;l=l.hoverSeries;d=
b&&"touchmove"===b.type?!0===this.followTouchMove:l&&l.tooltipOptions.followPointer;e=e&&l&&!l.noSharedTooltip;if(f&&(f!==c.hoverPoint||k&&k.isHidden)){r(c.hoverPoints||[],function(b){-1===a.inArray(b,u)&&b.setState()});r(u||[],function(a){a.setState("hover")});if(c.hoverSeries!==l)l.onMouseOver();c.hoverPoint&&c.hoverPoint.firePointEvent("mouseOut");if(!f.series)return;f.firePointEvent("mouseOver");c.hoverPoints=u;c.hoverPoint=f;k&&k.refresh(e?u:f,b)}else d&&k&&!k.isHidden&&(f=k.getAnchor([{}],b),
k.updatePosition({plotX:f[0],plotY:f[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(c.container.ownerDocument,"mousemove",function(b){var d=E[a.hoverChartIndex];if(d)d.pointer.onDocumentMouseMove(b)}));r(c.axes,function(d){var c=z(d.crosshair.snap,!0),k=c?a.find(u,function(a){return a.series[d.coll]===d}):void 0;k||!c?d.drawCrosshair(b,k):d.hideCrosshair()})},reset:function(a,d){var b=this.chart,c=b.hoverSeries,e=b.hoverPoint,f=b.hoverPoints,l=b.tooltip,u=l&&l.shared?f:e;a&&u&&r(k(u),function(b){b.series.isCartesian&&
void 0===b.plotX&&(a=!1)});if(a)l&&u&&(l.refresh(u),l.shared&&f?r(f,function(a){a.setState(a.state,!0);a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a);a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a)}):e&&(e.setState(e.state,!0),r(b.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();f&&r(f,function(a){a.setState()});if(c)c.onMouseOut();l&&l.hide(d);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());r(b.axes,function(a){a.hideCrosshair()});
this.hoverX=b.hoverPoints=b.hoverPoint=null}},scaleGroups:function(a,d){var b=this.chart,c;r(b.series,function(k){c=a||k.getPlotBox();k.xAxis&&k.xAxis.zoomEnabled&&k.group&&(k.group.attr(c),k.markerGroup&&(k.markerGroup.attr(c),k.markerGroup.clip(d?b.clipRect:null)),k.dataLabelsGroup&&k.dataLabelsGroup.attr(c))});b.clipRect.attr(d||b.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=
this.chart,d=b.options.chart,c=a.chartX,k=a.chartY,e=this.zoomHor,f=this.zoomVert,l=b.plotLeft,n=b.plotTop,h=b.plotWidth,B=b.plotHeight,z,F=this.selectionMarker,g=this.mouseDownX,v=this.mouseDownY,q=d.panKey&&a[d.panKey+"Key"];F&&F.touch||(c<l?c=l:c>l+h&&(c=l+h),k<n?k=n:k>n+B&&(k=n+B),this.hasDragged=Math.sqrt(Math.pow(g-c,2)+Math.pow(v-k,2)),10<this.hasDragged&&(z=b.isInsidePlot(g-l,v-n),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&z&&!q&&!F&&(this.selectionMarker=F=b.renderer.rect(l,n,e?1:h,
f?1:B,0).attr({fill:d.selectionMarkerFill||m("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),F&&e&&(c-=g,F.attr({width:Math.abs(c),x:(0<c?0:c)+g})),F&&f&&(c=k-v,F.attr({height:Math.abs(c),y:(0<c?0:c)+v})),z&&!F&&d.panning&&b.pan(a,d.panning)))},drop:function(a){var b=this,d=this.chart,c=this.hasPinched;if(this.selectionMarker){var k={originalEvent:a,xAxis:[],yAxis:[]},l=this.selectionMarker,x=l.attr?l.attr("x"):l.x,z=l.attr?l.attr("y"):l.y,n=l.attr?l.attr("width"):
l.width,G=l.attr?l.attr("height"):l.height,B;if(this.hasDragged||c)r(d.axes,function(d){if(d.zoomEnabled&&f(d.min)&&(c||b[{xAxis:"zoomX",yAxis:"zoomY"}[d.coll]])){var e=d.horiz,g="touchend"===a.type?d.minPixelPadding:0,l=d.toValue((e?x:z)+g),e=d.toValue((e?x+n:z+G)-g);k[d.coll].push({axis:d,min:Math.min(l,e),max:Math.max(l,e)});B=!0}}),B&&w(d,"selection",k,function(a){d.zoom(y(a,c?{animation:!1}:null))});e(d.index)&&(this.selectionMarker=this.selectionMarker.destroy());c&&this.scaleGroups()}d&&e(d.index)&&
(h(d.container,{cursor:d._cursor}),d.cancelClick=10<this.hasDragged,d.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(b){E[a.hoverChartIndex]&&E[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,d=this.chartPosition;a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||
b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var d=E[a.hoverChartIndex];d&&(b.relatedTarget||b.toElement)&&(d.pointer.reset(),d.pointer.chartPosition=null)},onContainerMouseMove:function(b){var d=this.chart;f(a.hoverChartIndex)&&E[a.hoverChartIndex]&&E[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=d.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===d.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!d.isInsidePlot(b.chartX-
d.plotLeft,b.chartY-d.plotTop)||d.openMenu||this.runPointActions(b)},inClass:function(a,d){for(var b;a;){if(b=D(a,"class")){if(-1!==b.indexOf(d))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},
onContainerClick:function(a){var b=this.chart,d=b.hoverPoint,c=b.plotLeft,k=b.plotTop;a=this.normalize(a);b.cancelClick||(d&&this.inClass(a.target,"highcharts-tracker")?(w(d.series,"click",y(a,{point:d})),b.hoverPoint&&d.firePointEvent("click",a)):(y(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-c,a.chartY-k)&&w(b,"click",a)))},setDOMEvents:function(){var b=this,d=b.chart.container,c=d.ownerDocument;d.onmousedown=function(a){b.onContainerMouseDown(a)};d.onmousemove=function(a){b.onContainerMouseMove(a)};
d.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=C(d,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=C(c,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(d.ontouchstart=function(a){b.onContainerTouchStart(a)},d.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=C(c,"touchend",b.onDocumentTouchEnd)))},destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();
a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,d){b[d]=null})}}})(K);(function(a){var C=a.charts,D=a.each,E=a.extend,m=a.map,h=a.noop,f=a.pick;E(a.Pointer.prototype,{pinchTranslate:function(a,f,h,m,e,c){this.zoomHor&&this.pinchTranslateDirection(!0,a,f,h,m,e,c);this.zoomVert&&this.pinchTranslateDirection(!1,a,f,h,m,
e,c)},pinchTranslateDirection:function(a,f,h,m,e,c,l,z){var k=this.chart,d=a?"x":"y",b=a?"X":"Y",u="chart"+b,p=a?"width":"height",q=k["plot"+(a?"Left":"Top")],t,r,x=z||1,y=k.inverted,n=k.bounds[a?"h":"v"],G=1===f.length,B=f[0][u],M=h[0][u],F=!G&&f[1][u],g=!G&&h[1][u],v;h=function(){!G&&20<Math.abs(B-F)&&(x=z||Math.abs(M-g)/Math.abs(B-F));r=(q-M)/x+B;t=k["plot"+(a?"Width":"Height")]/x};h();f=r;f<n.min?(f=n.min,v=!0):f+t>n.max&&(f=n.max-t,v=!0);v?(M-=.8*(M-l[d][0]),G||(g-=.8*(g-l[d][1])),h()):l[d]=
[M,g];y||(c[d]=r-q,c[p]=t);c=y?1/x:x;e[p]=t;e[d]=f;m[y?a?"scaleY":"scaleX":"scale"+b]=x;m["translate"+b]=c*q+(M-c*B)},pinch:function(a){var r=this,q=r.chart,w=r.pinchDown,e=a.touches,c=e.length,l=r.lastValidTouch,z=r.hasZoom,k=r.selectionMarker,d={},b=1===c&&(r.inClass(a.target,"highcharts-tracker")&&q.runTrackerClick||r.runChartClick),u={};1<c&&(r.initiated=!0);z&&r.initiated&&!b&&a.preventDefault();m(e,function(a){return r.normalize(a)});"touchstart"===a.type?(D(e,function(a,b){w[b]={chartX:a.chartX,
chartY:a.chartY}}),l.x=[w[0].chartX,w[1]&&w[1].chartX],l.y=[w[0].chartY,w[1]&&w[1].chartY],D(q.axes,function(a){if(a.zoomEnabled){var b=q.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,c=a.toPixels(f(a.options.min,a.dataMin)),k=a.toPixels(f(a.options.max,a.dataMax)),e=Math.max(c,k);b.min=Math.min(a.pos,Math.min(c,k)-d);b.max=Math.max(a.pos+a.len,e+d)}}),r.res=!0):r.followTouchMove&&1===c?this.runPointActions(r.normalize(a)):w.length&&(k||(r.selectionMarker=k=E({destroy:h,touch:!0},q.plotBox)),r.pinchTranslate(w,
e,d,k,u,l),r.hasPinched=z,r.scaleGroups(d,u),r.res&&(r.res=!1,this.reset(!1,0)))},touch:function(h,m){var q=this.chart,r,e;if(q.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=q.index;1===h.touches.length?(h=this.normalize(h),(e=q.isInsidePlot(h.chartX-q.plotLeft,h.chartY-q.plotTop))&&!q.openMenu?(m&&this.runPointActions(h),"touchmove"===h.type&&(m=this.pinchDown,r=m[0]?4<=Math.sqrt(Math.pow(m[0].chartX-h.chartX,2)+Math.pow(m[0].chartY-h.chartY,2)):!1),f(r,
!0)&&this.pinch(h)):m&&this.reset()):2===h.touches.length&&this.pinch(h)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){C[a.hoverChartIndex]&&C[a.hoverChartIndex].pointer.drop(f)}})})(K);(function(a){var C=a.addEvent,D=a.charts,E=a.css,m=a.doc,h=a.extend,f=a.noop,r=a.Pointer,y=a.removeEvent,q=a.win,w=a.wrap;if(!a.hasTouch&&(q.PointerEvent||q.MSPointerEvent)){var e={},c=!!q.PointerEvent,l=function(){var c=
[];c.item=function(a){return this[a]};a.objectEach(e,function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},z=function(c,d,b,e){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!D[a.hoverChartIndex]||(e(c),e=D[a.hoverChartIndex].pointer,e[d]({type:b,target:c.currentTarget,preventDefault:f,touches:l()}))};h(r.prototype,{onContainerPointerDown:function(a){z(a,"onContainerTouchStart","touchstart",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},
onContainerPointerMove:function(a){z(a,"onContainerTouchMove","touchmove",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY};e[a.pointerId].target||(e[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){z(a,"onDocumentTouchEnd","touchend",function(a){delete e[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,c?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,c?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(m,c?
"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});w(r.prototype,"init",function(a,d,b){a.call(this,d,b);this.hasZoom&&E(d.container,{"-ms-touch-action":"none","touch-action":"none"})});w(r.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});w(r.prototype,"destroy",function(a){this.batchMSEvents(y);a.call(this)})}})(K);(function(a){var C=a.addEvent,D=a.css,E=a.discardElement,m=a.defined,h=a.each,f=a.fireEvent,r=a.isFirefox,y=a.marginNames,
q=a.merge,w=a.pick,e=a.setAnimation,c=a.stableSort,l=a.win,z=a.wrap;a.Legend=function(a,d){this.init(a,d)};a.Legend.prototype={init:function(a,d){this.chart=a;this.setOptions(d);d.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=C(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var d=w(a.padding,8);this.options=
a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=d;this.initialItemY=d-5;this.symbolWidth=w(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,d){var b=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;w(d,!0)&&b.redraw();f(this,"afterUpdate")},colorizeItem:function(a,d){a.legendGroup[d?"removeClass":"addClass"]("highcharts-legend-item-hidden");
var b=this.options,c=a.legendItem,k=a.legendLine,e=a.legendSymbol,l=this.itemHiddenStyle.color,b=d?b.itemStyle.color:l,h=d?a.color||l:l,x=a.options&&a.options.marker,z={fill:h};c&&c.css({fill:b,color:b});k&&k.attr({stroke:h});e&&(x&&e.isMarker&&(z=a.pointAttribs(),d||(z.stroke=z.fill=l)),e.attr(z));f(this,"afterColorizeItem",{item:a,visible:d})},positionItems:function(){h(this.allItems,this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var d=this.options,
b=d.symbolPadding,d=!d.rtl,c=a._legendItemPos,k=c[0],c=c[1],e=a.checkbox;if((a=a.legendGroup)&&a.element)a[m(a.translateY)?"animate":"attr"]({translateX:d?k:this.legendWidth-k-2*b-4,translateY:c});e&&(e.x=k,e.y=c)},destroyItem:function(a){var d=a.checkbox;h(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});d&&E(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}h(this.getAllItems(),function(c){h(["legendItem","legendGroup"],
a,c)});h("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,c,b=this.clipHeight||this.legendHeight,e=this.titleHeight;a&&(c=a.translateY,h(this.allItems,function(d){var k=d.checkbox,f;k&&(f=c+e+k.y+(this.scrollOffset||0)+3,D(k,{left:a.translateX+d.checkboxOffset+k.x-20+"px",top:f+"px",display:f>c-6&&f<c+b-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,c=this.padding,b=a.title,e=
0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,c-3,c-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),e=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:e}));this.titleHeight=e},setText:function(c){var d=this.options;c.legendItem.attr({text:d.labelFormat?a.format(d.labelFormat,c,this.chart.time):d.labelFormatter.call(c)})},renderItem:function(a){var c=this.chart,b=c.renderer,e=this.options,
k=this.symbolWidth,f=e.symbolPadding,l=this.itemStyle,h=this.itemHiddenStyle,x="horizontal"===e.layout?w(e.itemDistance,20):0,z=!e.rtl,n=a.legendItem,G=!a.series,B=!G&&a.series.drawLegendSymbol?a.series:a,m=B.options,m=this.createCheckboxForItem&&m&&m.showCheckbox,x=k+f+x+(m?20:0),F=e.useHTML,g=a.options.className;n||(a.legendGroup=b.g("legend-item").addClass("highcharts-"+B.type+"-series highcharts-color-"+a.colorIndex+(g?" "+g:"")+(G?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),
a.legendItem=n=b.text("",z?k+f:-f,this.baseline||0,F).css(q(a.visible?l:h)).attr({align:z?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(k=l.fontSize,this.fontMetrics=b.fontMetrics(k,n),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,n.attr("y",this.baseline)),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,B.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,n,F),m&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);l.width||n.css({width:(e.itemWidth||
e.width||c.spacingBox.width)-x});this.setText(a);c=n.getBBox();a.itemWidth=a.checkboxOffset=e.itemWidth||a.legendItemWidth||c.width+x;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||c.height||this.symbolHeight)},layoutItem:function(a){var c=this.options,b=this.padding,e="horizontal"===c.layout,k=a.itemHeight,f=c.itemMarginBottom||0,l=this.itemMarginTop,h=e?w(c.itemDistance,20):0,x=c.width,z=x||this.chart.spacingBox.width-
2*b-c.x,c=c.alignColumns&&this.totalItemWidth>z?this.maxItemWidth:a.itemWidth;e&&this.itemX-b+c>z&&(this.itemX=b,this.itemY+=l+this.lastLineHeight+f,this.lastLineHeight=0);this.lastItemY=l+this.itemY+f;this.lastLineHeight=Math.max(k,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=c:(this.itemY+=l+k+f,this.lastLineHeight=k);this.offsetWidth=x||Math.max((e?this.itemX-b-(a.checkbox?0:h):c)+b,this.offsetWidth)},getAllItems:function(){var a=[];h(this.chart.series,function(c){var b=
c&&c.options;c&&w(b.showInLegend,m(b.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===b.legendType?c.data:c)))});f(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,c){var b=this.chart,d=this.options,e=this.getAlignment();e&&h([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(k,
f){k.test(e)&&!m(a[f])&&(b[y[f]]=Math.max(b[y[f]],b.legend[(f+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][f]*d[f%2?"x":"y"]+w(d.margin,12)+c[f]+(0===f&&void 0!==b.options.title.margin?b.titleOffset+b.options.title.margin:0)))})},proximatePositions:function(){var c=this.chart,d=[],b="left"===this.options.align;h(this.allItems,function(e){var k,f;k=b;e.xAxis&&e.points&&(e.xAxis.options.reversed&&(k=!k),k=a.find(k?e.points:e.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),f=e.legendGroup.getBBox().height,
d.push({target:e.visible?(k?k.plotY:e.xAxis.height)-.3*f:c.plotHeight,size:f,item:e}))},this);a.distribute(d,c.plotHeight);h(d,function(a){a.item._legendItemPos[1]=c.plotTop-c.spacing[0]+a.pos})},render:function(){var a=this.chart,d=a.renderer,b=this.group,e,f,l,t=this.box,z=this.options,x=this.padding;this.itemX=x;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;b||(this.group=b=d.g("legend").attr({zIndex:7}).add(),this.contentGroup=d.g().attr({zIndex:1}).add(b),this.scrollGroup=d.g().add(this.contentGroup));
this.renderTitle();e=this.getAllItems();c(e,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});z.reversed&&e.reverse();this.allItems=e;this.display=f=!!e.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;h(e,this.renderItem,this);h(e,this.layoutItem,this);e=(z.width||this.offsetWidth)+x;l=this.lastItemY+this.lastLineHeight+this.titleHeight;l=this.handleOverflow(l);l+=x;t||(this.box=t=d.rect().addClass("highcharts-legend-box").attr({r:z.borderRadius}).add(b),
t.isNew=!0);t.attr({stroke:z.borderColor,"stroke-width":z.borderWidth||0,fill:z.backgroundColor||"none"}).shadow(z.shadow);0<e&&0<l&&(t[t.isNew?"attr":"animate"](t.crisp.call({},{x:0,y:0,width:e,height:l},t.strokeWidth())),t.isNew=!1);t[f?"show":"hide"]();this.legendWidth=e;this.legendHeight=l;f&&(d=a.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&(d=q(d,{y:d.y+a.titleOffset+a.options.title.margin})),b.align(q(z,{width:e,height:l,verticalAlign:this.proximate?"top":z.verticalAlign}),!0,d));this.proximate||
this.positionItems()},handleOverflow:function(a){var c=this,b=this.chart,e=b.renderer,k=this.options,f=k.y,l=this.padding,b=b.spacingBox.height+("top"===k.verticalAlign?-f:f)-l,f=k.maxHeight,z,x=this.clipRect,m=k.navigation,n=w(m.animation,!0),G=m.arrowSize||12,B=this.nav,q=this.pages,F,g=this.allItems,v=function(a){"number"===typeof a?x.attr({height:a}):x&&(c.clipRect=x.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")};
"horizontal"!==k.layout||"middle"===k.verticalAlign||k.floating||(b/=2);f&&(b=Math.min(b,f));q.length=0;a>b&&!1!==m.enabled?(this.clipHeight=z=Math.max(b-20-this.titleHeight-l,0),this.currentPage=w(this.currentPage,1),this.fullHeight=a,h(g,function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),e=q.length;if(!e||c-q[e-1]>z&&(F||c)!==q[e-1])q.push(F||c),e++;a.pageIx=e-1;F&&(g[b-1].pageIx=e-1);b===g.length-1&&c+d-q[e-1]>z&&(q.push(c),a.pageIx=e);c!==F&&(F=c)}),x||(x=c.clipRect=
e.clipRect(0,l,9999,0),c.contentGroup.clip(x)),v(z),B||(this.nav=B=e.g().attr({zIndex:1}).add(this.group),this.up=e.symbol("triangle",0,0,G,G).on("click",function(){c.scroll(-1,n)}).add(B),this.pager=e.text("",15,10).addClass("highcharts-legend-navigation").css(m.style).add(B),this.down=e.symbol("triangle-down",0,0,G,G).on("click",function(){c.scroll(1,n)}).add(B)),c.scroll(0),a=b):B&&(v(),this.nav=B.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var b=
this.pages,d=b.length;a=this.currentPage+a;var k=this.clipHeight,f=this.options.navigation,l=this.pager,h=this.padding;a>d&&(a=d);0<a&&(void 0!==c&&e(c,this.chart),this.nav.attr({translateX:h,translateY:k+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),l.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),
this.up.attr({fill:1===a?f.inactiveColor:f.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===d?f.inactiveColor:f.activeColor}).css({cursor:a===d?"default":"pointer"}),this.scrollOffset=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,c){var b=a.symbolHeight,d=a.options.squareSymbol;c.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-b)/2:
0,a.baseline-b+1,d?b:a.symbolWidth,b,w(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(c.legendGroup)},drawLineMarker:function(a){var c=this.options,b=c.marker,e=a.symbolWidth,k=a.symbolHeight,f=k/2,l=this.chart.renderer,h=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var z;z={"stroke-width":c.lineWidth||0};c.dashStyle&&(z.dashstyle=c.dashStyle);this.legendLine=l.path(["M",0,a,"L",e,a]).addClass("highcharts-graph").attr(z).add(h);b&&!1!==b.enabled&&e&&
(c=Math.min(w(b.radius,f),f),0===this.symbol.indexOf("url")&&(b=q(b,{width:k,height:k}),c=0),this.legendSymbol=b=l.symbol(this.symbol,e/2-c,a-c,2*c,2*c,b).addClass("highcharts-point").add(h),b.isMarker=!0)}};(/Trident\/7\.0/.test(l.navigator.userAgent)||r)&&z(a.Legend.prototype,"positionItem",function(a,c){var b=this,d=function(){c._legendItemPos&&a.call(b,c)};d();setTimeout(d)})})(K);(function(a){var C=a.addEvent,D=a.animate,E=a.animObject,m=a.attr,h=a.doc,f=a.Axis,r=a.createElement,y=a.defaultOptions,
q=a.discardElement,w=a.charts,e=a.css,c=a.defined,l=a.each,z=a.extend,k=a.find,d=a.fireEvent,b=a.grep,u=a.isNumber,p=a.isObject,H=a.isString,t=a.Legend,L=a.marginNames,x=a.merge,I=a.objectEach,n=a.Pointer,G=a.pick,B=a.pInt,M=a.removeEvent,F=a.seriesTypes,g=a.splat,v=a.syncTimeout,P=a.win,Q=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new Q(a,b,c)};z(Q.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(H(a[0])||a[0].nodeName)this.renderTo=
a.shift();this.init(a[0],a[1])},init:function(b,c){var g,e,k=b.series,f=b.plotOptions||{};d(this,"init",{args:arguments},function(){b.series=null;g=x(y,b);for(e in g.plotOptions)g.plotOptions[e].tooltip=f[e]&&x(f[e].tooltip)||void 0;g.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;g.series=b.series=k;this.userOptions=b;var n=g.chart,l=n.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=
g;this.axes=[];this.series=[];this.time=b.time&&a.keys(b.time).length?new a.Time(b.time):a.time;this.hasCartesianSeries=n.showAxes;var h=this;h.index=w.length;w.push(h);a.chartCount++;l&&I(l,function(a,b){C(h,b,a)});h.xAxis=[];h.yAxis=[];h.pointCount=h.colorCounter=h.symbolCounter=0;d(h,"afterInit");h.firstRender()})},initSeries:function(b){var c=this.options.chart;(c=F[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;
for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){d(this,"beforeRedraw");var c=this.axes,g=this.series,e=this.pointer,f=this.legend,k=this.isDirtyLegend,n,h,B=this.hasCartesianSeries,G=this.isDirtyBox,v,p=this.renderer,t=p.isHidden(),x=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);t&&this.temporaryDisplay();this.layOutTitles();
for(b=g.length;b--;)if(v=g[b],v.options.stacking&&(n=!0,v.isDirty)){h=!0;break}if(h)for(b=g.length;b--;)v=g[b],v.options.stacking&&(v.isDirty=!0);l(g,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),k=!0);a.isDirtyData&&d(a,"updatedData")});k&&f.options.enabled&&(f.render(),this.isDirtyLegend=!1);n&&this.getStacks();B&&l(c,function(a){a.updateNames();a.setScale()});this.getMargins();B&&(l(c,function(a){a.isDirty&&(G=!0)}),l(c,function(a){var b=a.min+","+a.max;
a.extKey!==b&&(a.extKey=b,x.push(function(){d(a,"afterSetExtremes",z(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(G||n)&&a.redraw()}));G&&this.drawChartBox();d(this,"predraw");l(g,function(a){(G||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});e&&e.reset(!0);p.draw();d(this,"redraw");d(this,"render");t&&this.temporaryDisplay(!0);l(x,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,g;c=k(this.axes,b)||k(this.series,
b);for(g=0;!c&&g<d.length;g++)c=k(d[g].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=g(b.xAxis||{}),b=b.yAxis=g(b.yAxis||{});d(this,"getAxes");l(c,function(a,b){a.index=b;a.isX=!0});l(b,function(a,b){a.index=b});c=c.concat(b);l(c,function(b){new f(a,b)});d(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];l(this.series,function(c){a=a.concat(b(c.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return b(this.series,function(a){return a.selected})},
setTitle:function(a,b,c){var d=this,g=d.options,e;e=g.title=x({style:{color:"#333333",fontSize:g.isStock?"16px":"18px"}},g.title,a);g=g.subtitle=x({style:{color:"#666666"}},g.subtitle,b);l([["title",a,e],["subtitle",b,g]],function(a,b){var c=a[0],g=d[c],e=a[1];a=a[2];g&&e&&(d[c]=g=g.destroy());a&&!g&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},
layOutTitles:function(a){var b=0,c,d=this.renderer,g=this.spacingBox;l(["title","subtitle"],function(a){var c=this[a],e=this.options[a];a="title"===a?-3:e.verticalAlign?0:b+2;var n;c&&(n=e.style.fontSize,n=d.fontMetrics(n,c).b,c.css({width:(e.width||g.width+e.widthAdjust)+"px"}).align(z({y:a+n},e),!1,"spacingBox"),e.floating||e.verticalAlign||(b=Math.ceil(b+c.getBBox(e.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&
G(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,d=b.width,b=b.height,g=this.renderTo;c(d)||(this.containerWidth=a.getStyle(g,"width"));c(b)||(this.containerHeight=a.getStyle(g,"height"));this.chartWidth=Math.max(0,d||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),
delete c.hcOrigStyle),c.hcOrigDetached&&(h.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){h.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,h.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;
if(c===h.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,g=c.chart,e,n;b=this.renderTo;var f=a.uniqueKey(),k;b||(this.renderTo=b=g.renderTo);H(b)&&(this.renderTo=b=h.getElementById(b));b||a.error(13,!0);e=B(m(b,"data-highcharts-chart"));u(e)&&w[e]&&w[e].hasRendered&&w[e].destroy();m(b,"data-highcharts-chart",this.index);b.innerHTML="";g.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();
e=this.chartWidth;n=this.chartHeight;k=z({position:"relative",overflow:"hidden",width:e+"px",height:n+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},g.style);this.container=b=r("div",{id:f},k,b);this._cursor=b.style.cursor;this.renderer=new (a[g.renderer]||a.Renderer)(b,e,n,null,g.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(g.className);this.renderer.setStyle(g.style);this.renderer.chartIndex=this.index;d(this,"afterGetContainer")},
getMargins:function(a){var b=this.spacing,g=this.margin,e=this.titleOffset;this.resetMargins();e&&!c(g[0])&&(this.plotTop=Math.max(this.plotTop,e+this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(g,b);d(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.margin;a.hasCartesianSeries&&l(a.axes,function(a){a.visible&&a.getOffset()});l(L,function(g,e){c(d[e])||(a[g]+=b[e])});a.setChartSize()},reflow:function(b){var d=
this,g=d.options.chart,e=d.renderTo,n=c(g.width)&&c(g.height),k=g.width||a.getStyle(e,"width"),g=g.height||a.getStyle(e,"height"),e=b?b.target:P;if(!n&&!d.isPrinting&&k&&g&&(e===P||e===h)){if(k!==d.containerWidth||g!==d.containerHeight)a.clearTimeout(d.reflowTimeout),d.reflowTimeout=v(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:0);d.containerWidth=k;d.containerHeight=g}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):
(this.unbindReflow=C(P,"resize",function(a){b.reflow(a)}),C(this,"destroy",this.unbindReflow))},setSize:function(b,c,g){var n=this,k=n.renderer;n.isResizing+=1;a.setAnimation(g,n);n.oldChartHeight=n.chartHeight;n.oldChartWidth=n.chartWidth;void 0!==b&&(n.options.chart.width=b);void 0!==c&&(n.options.chart.height=c);n.getChartSize();b=k.globalAnimation;(b?D:e)(n.container,{width:n.chartWidth+"px",height:n.chartHeight+"px"},b);n.setChartSize(!0);k.setSize(n.chartWidth,n.chartHeight,g);l(n.axes,function(a){a.isDirty=
!0;a.setScale()});n.isDirtyLegend=!0;n.isDirtyBox=!0;n.layOutTitles();n.getMargins();n.redraw(g);n.oldChartHeight=null;d(n,"resize");v(function(){n&&d(n,"endResize",null,function(){--n.isResizing})},E(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,g=this.chartWidth,e=this.chartHeight,n=this.options.chart,k=this.spacing,f=this.clipOffset,h,B,G,v;this.plotLeft=h=Math.round(this.plotLeft);this.plotTop=B=Math.round(this.plotTop);this.plotWidth=G=Math.max(0,Math.round(g-h-this.marginRight));
this.plotHeight=v=Math.max(0,Math.round(e-B-this.marginBottom));this.plotSizeX=b?v:G;this.plotSizeY=b?G:v;this.plotBorderWidth=n.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:k[3],y:k[0],width:g-k[3]-k[1],height:e-k[0]-k[2]};this.plotBox=c.plotBox={x:h,y:B,width:G,height:v};g=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(g,f[3])/2);c=Math.ceil(Math.max(g,f[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(g,f[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-
Math.max(g,f[2])/2-c))};a||l(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()});d(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){var a=this,b=a.options.chart;l(["margin","spacing"],function(c){var d=b[c],g=p(d)?d:[d,d,d,d];l(["Top","Right","Bottom","Left"],function(d,e){a[c][e]=G(b[c+d],g[e])})});l(L,function(b,c){a[b]=G(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,
g=this.chartHeight,e=this.chartBackground,n=this.plotBackground,k=this.plotBorder,f,l=this.plotBGImage,h=a.backgroundColor,B=a.plotBackgroundColor,G=a.plotBackgroundImage,v,p=this.plotLeft,t=this.plotTop,z=this.plotWidth,x=this.plotHeight,F=this.plotBox,u=this.clipRect,m=this.clipBox,q="animate";e||(this.chartBackground=e=b.rect().addClass("highcharts-background").add(),q="attr");f=a.borderWidth||0;v=f+(a.shadow?8:0);h={fill:h||"none"};if(f||e["stroke-width"])h.stroke=a.borderColor,h["stroke-width"]=
f;e.attr(h).shadow(a.shadow);e[q]({x:v/2,y:v/2,width:c-v-f%2,height:g-v-f%2,r:a.borderRadius});q="animate";n||(q="attr",this.plotBackground=n=b.rect().addClass("highcharts-plot-background").add());n[q](F);n.attr({fill:B||"none"}).shadow(a.plotShadow);G&&(l?l.animate(F):this.plotBGImage=b.image(G,p,t,z,x).add());u?u.animate({width:m.width,height:m.height}):this.clipRect=b.clipRect(m);q="animate";k||(q="attr",this.plotBorder=k=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());k.attr({stroke:a.plotBorderColor,
"stroke-width":a.plotBorderWidth||0,fill:"none"});k[q](k.crisp({x:p,y:t,width:z,height:x},-k.strokeWidth()));this.isDirtyBox=!1;d(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,g,e;l(["inverted","angular","polar"],function(n){c=F[b.type||b.defaultSeriesType];e=b[n]||c&&c.prototype[n];for(g=d&&d.length;!e&&g--;)(c=F[d[g].type])&&c.prototype[n]&&(e=!0);a[n]=e})},linkSeries:function(){var a=this,b=a.series;l(b,function(a){a.linkedSeries.length=
0});l(b,function(b){var c=b.options.linkedTo;H(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=G(b.options.visible,c.options.visible,b.visible))});d(this,"afterLinkSeries")},renderSeries:function(){l(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&l(b.items,function(c){var d=z(b.style,c.style),g=B(d.left)+a.plotLeft,e=B(d.top)+a.plotTop+12;delete d.left;delete d.top;
a.renderer.text(c.html,g,e).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,g,e;this.setTitle();this.legend=new t(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;d=this.plotHeight=Math.max(this.plotHeight-21,0);l(a,function(a){a.setScale()});this.getAxisMargins();g=1.1<c/this.plotWidth;e=1.05<d/this.plotHeight;if(g||e)l(a,function(a){(a.horiz&&g||!a.horiz&&e)&&a.setTickInterval(!0)}),this.getMargins();
this.drawChartBox();this.hasCartesianSeries&&l(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=x(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&
(P.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,g=b.series,e=b.container,n,k=e&&e.parentNode;d(b,"destroy");b.renderer.forExport?a.erase(w,b):w[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");M(b);for(n=c.length;n--;)c[n]=c[n].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();
for(n=g.length;n--;)g[n]=g[n].destroy();l("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});e&&(e.innerHTML="",M(e),k&&q(e));I(b,function(a,c){delete b[c]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();
l(b.series||[],function(b){a.initSeries(b)});a.linkSeries();d(a,"beforeRender");n&&(a.pointer=new n(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){l([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);d(this,"load");d(this,"render");c(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})})(K);(function(a){var C=a.addEvent,D=a.Chart,E=a.each;C(D,"afterSetChartSize",function(m){var h=
this.options.chart.scrollablePlotArea;(h=h&&h.minWidth)&&!this.renderer.forExport&&(this.scrollablePixels=h=Math.max(0,h-this.chartWidth))&&(this.plotWidth+=h,this.clipBox.width+=h,m.skipAxes||E(this.axes,function(f){1===f.side?f.getPlotLinePath=function(){var h=this.right,m;this.right=h-f.chart.scrollablePixels;m=a.Axis.prototype.getPlotLinePath.apply(this,arguments);this.right=h;return m}:(f.setAxisSize(),f.setAxisTranslation())}))});C(D,"render",function(){this.scrollablePixels?(this.setUpScrolling&&
this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});D.prototype.setUpScrolling=function(){this.scrollingContainer=a.createElement("div",{className:"highcharts-scrolling"},{overflowX:"auto",WebkitOverflowScrolling:"touch"},this.renderTo);this.innerContainer=a.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};D.prototype.applyFixed=function(){var m=this.container,
h,f,r=!this.fixedDiv;r&&(this.fixedDiv=a.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.fixedRenderer=h=new a.Renderer(this.fixedDiv,0,0),this.scrollableMask=h.path().attr({fill:a.color(this.options.chart.backgroundColor||"#fff").setOpacity(.85).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),a.each([this.inverted?".highcharts-xaxis":
".highcharts-yaxis",this.inverted?".highcharts-xaxis-labels":".highcharts-yaxis-labels",".highcharts-contextbutton",".highcharts-credits",".highcharts-legend",".highcharts-subtitle",".highcharts-title",".highcharts-legend-checkbox"],function(f){a.each(m.querySelectorAll(f),function(a){(a.namespaceURI===h.SVG_NS?h.box:h.box.parentNode).appendChild(a);a.style.pointerEvents="auto"})}));this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);f=this.chartWidth+this.scrollablePixels;a.stop(this.container);
this.container.style.width=f+"px";this.renderer.boxWrapper.attr({width:f,height:this.chartHeight,viewBox:[0,0,f,this.chartHeight].join(" ")});this.chartBackground.attr({width:f});r&&(f=this.options.chart.scrollablePlotArea,f.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixels*f.scrollPositionX));r=this.axisOffset;f=this.plotTop-r[0]-1;var r=this.plotTop+this.plotHeight+r[2],y=this.plotLeft+this.plotWidth-this.scrollablePixels;this.scrollableMask.attr({d:this.scrollablePixels?
["M",0,f,"L",this.plotLeft-1,f,"L",this.plotLeft-1,r,"L",0,r,"Z","M",y,f,"L",this.chartWidth,f,"L",this.chartWidth,r,"L",y,r,"Z"]:["M",0,0]})}})(K);(function(a){var C,D=a.each,E=a.extend,m=a.erase,h=a.fireEvent,f=a.format,r=a.isArray,y=a.isNumber,q=a.pick,w=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,c,f){this.series=a;this.color=a.color;this.applyOptions(c,f);a.options.colorByPoint?(c=a.options.colors||a.chart.options.colors,this.color=this.color||c[a.colorCounter],c=
c.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===c&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=q(this.colorIndex,f);a.chart.pointCount++;h(this,"afterInit");return this},applyOptions:function(a,c){var e=this.series,f=e.options.pointValKey||e.pointValKey;a=C.prototype.optionsToObject.call(this,a);E(this,a);this.options=this.options?E(this.options,a):a;a.group&&delete this.group;f&&(this.y=this[f]);this.isNull=q(this.isValid&&!this.isValid(),null===this.x||!y(this.y,!0));this.selected&&
(this.state="select");"name"in this&&void 0===c&&e.xAxis&&e.xAxis.hasNames&&(this.x=e.xAxis.nameToX(this));void 0===this.x&&e&&(this.x=void 0===c?e.autoIncrement(this):c);return this},setNestedProperty:function(e,c,f){f=f.split(".");a.reduce(f,function(e,f,d,b){e[f]=b.length-1===d?c:a.isObject(e[f],!0)?e[f]:{};return e[f]},e);return e},optionsToObject:function(e){var c={},f=this.series,h=f.options.keys,k=h||f.pointArrayMap||["y"],d=k.length,b=0,u=0;if(y(e)||null===e)c[k[0]]=e;else if(r(e))for(!h&&
e.length>d&&(f=typeof e[0],"string"===f?c.name=e[0]:"number"===f&&(c.x=e[0]),b++);u<d;)h&&void 0===e[b]||(0<k[u].indexOf(".")?a.Point.prototype.setNestedProperty(c,e[b],k[u]):c[k[u]]=e[b]),b++,u++;else"object"===typeof e&&(c=e,e.dataLabels&&(f._hasPointLabels=!0),e.marker&&(f._hasPointMarkers=!0));return c},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?
" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,c=a.zones,a=a.zoneAxis||"y",f=0,h;for(h=c[f];this[a]>=h.value;)h=c[++f];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=h&&h.color&&!this.options.color?h.color:this.nonZonedColor;return h},destroy:function(){var a=this.series.chart,c=a.hoverPoints,f;a.pointCount--;
c&&(this.setState(),m(c,this),c.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)w(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],c,f=6;f--;)c=a[f],this[c]&&(this[c]=this[c].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||
this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var c=this.series,e=c.tooltipOptions,h=q(e.valueDecimals,""),k=e.valuePrefix||"",d=e.valueSuffix||"";D(c.pointArrayMap||["y"],function(b){b="{point."+b;if(k||d)a=a.replace(RegExp(b+"}","g"),k+b+"}"+d);a=a.replace(RegExp(b+"}","g"),b+":,."+h+"f}")});return f(a,{point:this,series:this.series},c.chart.time)},firePointEvent:function(a,c,f){var e=this,k=this.series.options;
(k.point.events[a]||e.options&&e.options.events&&e.options.events[a])&&this.importEvents();"click"===a&&k.allowPointSelect&&(f=function(a){e.select&&e.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});h(this,a,c,f)},visible:!0}})(K);(function(a){var C=a.addEvent,D=a.animObject,E=a.arrayMax,m=a.arrayMin,h=a.correctFloat,f=a.defaultOptions,r=a.defaultPlotOptions,y=a.defined,q=a.each,w=a.erase,e=a.extend,c=a.fireEvent,l=a.grep,z=a.isArray,k=a.isNumber,d=a.isString,b=a.merge,u=a.objectEach,p=a.pick,H=a.removeEvent,
t=a.splat,L=a.SVGElement,x=a.syncTimeout,I=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,
-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x",
"y"],coll:"series",init:function(a,b){var d=this,n,f=a.series,g;d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();e(d,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});n=b.events;u(n,function(a,b){C(d,b,a)});if(n&&n.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();q(d.parallelArrays,function(a){d[a+"Data"]=[]});d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);f.length&&(g=
f[f.length-1]);d._i=p(g&&g._i,-1)+1;a.orderSeries(this.insert(f));c(this,"afterInit")},insert:function(a){var b=this.options.index,c;if(k(b)){for(c=a.length;c--;)if(b>=p(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return p(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;q(b.axisTypes||[],function(f){q(d[f],function(a){e=a.options;if(c[f]===e.index||void 0!==c[f]&&c[f]===e.id||void 0===c[f]&&0===e.index)b.insert(a.series),
b[f]=a,a.isDirty=!0});b[f]||b.optionalAxis===f||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,e=k(b)?function(d){var g="y"===d&&c.toYData?c.toYData(a):a[d];c[d+"Data"][b]=g}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};q(c.parallelArrays,e)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,e=this.chart.time,b=p(b,a.pointStart,0);this.pointInterval=c=p(this.pointInterval,a.pointInterval,1);
d&&(a=new e.Date(b),"day"===d?e.set("Date",a,e.get("Date",a)+c):"month"===d?e.set("Month",a,e.get("Month",a)+c):"year"===d&&e.set("FullYear",a,e.get("FullYear",a)+c),c=a.getTime()-b);this.xIncrement=b+c;return b},setOptions:function(a){var d=this.chart,e=d.options,k=e.plotOptions,n=(d.userOptions||{}).plotOptions||{},g=k[this.type];this.userOptions=a;d=b(g,k.series,a);this.tooltipOptions=b(f.tooltip,f.plotOptions.series&&f.plotOptions.series.tooltip,f.plotOptions[this.type].tooltip,e.tooltip.userOptions,
k.series&&k.series.tooltip,k[this.type].tooltip,a.tooltip);this.stickyTracking=p(a.stickyTracking,n[this.type]&&n[this.type].stickyTracking,n.series&&n.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:d.stickyTracking);null===g.marker&&delete d.marker;this.zoneAxis=d.zoneAxis;a=this.zones=(d.zones||[]).slice();!d.negativeColor&&!d.negativeFillColor||d.zones||a.push({value:d[this.zoneAxis+"Threshold"]||d.threshold||0,className:"highcharts-negative",color:d.negativeColor,fillColor:d.negativeFillColor});
a.length&&y(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});c(this,"afterSetOptions",{options:d});return d},getName:function(){return this.name||"Series "+(this.index+1)},getCyclic:function(a,b,c){var d,e=this.chart,g=this.userOptions,f=a+"Index",k=a+"Counter",n=c?c.length:p(e.options.chart[a+"Count"],e[a+"Count"]);b||(d=p(g[f],g["_"+f]),y(d)||(e.series.length||(e[k]=0),g["_"+f]=d=e[k]%n,e[k]+=1),c&&(b=c[d]));void 0!==d&&(this[f]=d);this[a]=b},getColor:function(){this.options.colorByPoint?
this.options.color=null:this.getCyclic("color",this.options.color||r[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var c=this.options,d=this.points,e=[],f,g,n,h=this.requireSorting;q(b,function(b){var g;g=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b).x;k(g)&&(g=a.inArray(g,this.xData,n),-1===g?
e.push(b):b!==c.data[g]?(d[g].update(b,!1,null,!1),d[g].touched=!0,h&&(n=g)):d[g]&&(d[g].touched=!0),f=!0)},this);if(f)for(b=d.length;b--;)g=d[b],g.touched||g.remove(!1),g.touched=!1;else if(b.length===d.length)q(b,function(a,b){d[b].update&&a!==c.data[b]&&d[b].update(a,!1,null,!1)});else return!1;q(e,function(a){this.addPoint(a,!1)},this);return!0},setData:function(b,c,e,f){var n=this,g=n.points,h=g&&g.length||0,l,B=n.options,G=n.chart,t=null,x=n.xAxis,u=B.turboThreshold,m=this.xData,r=this.yData,
w=(l=n.pointArrayMap)&&l.length,y;b=b||[];l=b.length;c=p(c,!0);!1!==f&&l&&h&&!n.cropped&&!n.hasGroupedData&&n.visible&&!n.isSeriesBoosting&&(y=this.updateData(b));if(!y){n.xIncrement=null;n.colorCounter=0;q(this.parallelArrays,function(a){n[a+"Data"].length=0});if(u&&l>u){for(e=0;null===t&&e<l;)t=b[e],e++;if(k(t))for(e=0;e<l;e++)m[e]=this.autoIncrement(),r[e]=b[e];else if(z(t))if(w)for(e=0;e<l;e++)t=b[e],m[e]=t[0],r[e]=t.slice(1,w+1);else for(e=0;e<l;e++)t=b[e],m[e]=t[0],r[e]=t[1];else a.error(12)}else for(e=
0;e<l;e++)void 0!==b[e]&&(t={series:n},n.pointClass.prototype.applyOptions.apply(t,[b[e]]),n.updateParallelArrays(t,e));r&&d(r[0])&&a.error(14,!0);n.data=[];n.options.data=n.userOptions.data=b;for(e=h;e--;)g[e]&&g[e].destroy&&g[e].destroy();x&&(x.minRange=x.userMinRange);n.isDirty=G.isDirtyBox=!0;n.isDirtyData=!!g;e=!1}"point"===B.legendType&&(this.processData(),this.generatePoints());c&&G.redraw(e)},processData:function(b){var c=this.xData,d=this.yData,e=c.length,f;f=0;var g,k,n=this.xAxis,h,l=this.options;
h=l.cropThreshold;var p=this.getExtremesFromAll||l.getExtremesFromAll,t=this.isCartesian,l=n&&n.val2lin,x=n&&n.isLog,u=this.requireSorting,m,z;if(t&&!this.isDirty&&!n.isDirty&&!this.yAxis.isDirty&&!b)return!1;n&&(b=n.getExtremes(),m=b.min,z=b.max);t&&this.sorted&&!p&&(!h||e>h||this.forceCrop)&&(c[e-1]<m||c[0]>z?(c=[],d=[]):this.yData&&(c[0]<m||c[e-1]>z)&&(f=this.cropData(this.xData,this.yData,m,z),c=f.xData,d=f.yData,f=f.start,g=!0));for(h=c.length||1;--h;)e=x?l(c[h])-l(c[h-1]):c[h]-c[h-1],0<e&&(void 0===
k||e<k)?k=e:0>e&&u&&(a.error(15),u=!1);this.cropped=g;this.cropStart=f;this.processedXData=c;this.processedYData=d;this.closestPointRange=k},cropData:function(a,b,c,d,e){var g=a.length,f=0,k=g,n;e=p(e,this.cropShoulder,1);for(n=0;n<g;n++)if(a[n]>=c){f=Math.max(0,n-e);break}for(c=n;c<g;c++)if(a[c]>d){k=c+e;break}return{xData:a.slice(f,k),yData:b.slice(f,k),start:f,end:k}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,e=this.processedXData,g=this.processedYData,f=this.pointClass,
k=e.length,h=this.cropStart||0,l,p=this.hasGroupedData,a=a.keys,x,u=[],m;c||p||(c=[],c.length=b.length,c=this.data=c);a&&p&&(this.options.keys=!1);for(m=0;m<k;m++)l=h+m,p?(x=(new f).init(this,[e[m]].concat(t(g[m]))),x.dataGroup=this.groupMap[m]):(x=c[l])||void 0===b[l]||(c[l]=x=(new f).init(this,b[l],e[m])),x&&(x.index=l,u[m]=x);this.options.keys=a;if(c&&(k!==(d=c.length)||p))for(m=0;m<d;m++)m!==h||p||(m+=k),c[m]&&(c[m].destroyElements(),c[m].plotX=void 0);this.data=c;this.points=u},getExtremes:function(a){var b=
this.yAxis,c=this.processedXData,d,e=[],g=0;d=this.xAxis.getExtremes();var f=d.min,n=d.max,h,l,p=this.requireSorting?1:0,t,x;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(x=0;x<d;x++)if(l=c[x],t=a[x],h=(k(t,!0)||z(t))&&(!b.positiveValuesOnly||t.length||0<t),l=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[x+p]||l)>=f&&(c[x-p]||l)<=n,h&&l)if(h=t.length)for(;h--;)"number"===typeof t[h]&&(e[g++]=t[h]);else e[g++]=t;this.dataMin=m(e);this.dataMax=E(e)},translate:function(){this.processedXData||
this.processData();this.generatePoints();var a=this.options,b=a.stacking,d=this.xAxis,e=d.categories,f=this.yAxis,g=this.points,l=g.length,t=!!this.modifyValue,x=a.pointPlacement,m="between"===x||k(x),u=a.threshold,z=a.startFromThreshold?u:0,q,r,w,I,H=Number.MAX_VALUE;"between"===x&&(x=.5);k(x)&&(x*=p(a.pointRange||d.pointRange));for(a=0;a<l;a++){var L=g[a],C=L.x,D=L.y;r=L.low;var E=b&&f.stacks[(this.negStacks&&D<(z?0:u)?"-":"")+this.stackKey],K;f.positiveValuesOnly&&null!==D&&0>=D&&(L.isNull=!0);
L.plotX=q=h(Math.min(Math.max(-1E5,d.translate(C,0,0,0,1,x,"flags"===this.type)),1E5));b&&this.visible&&!L.isNull&&E&&E[C]&&(I=this.getStackIndicator(I,C,this.index),K=E[C],D=K.points[I.key],r=D[0],D=D[1],r===z&&I.key===E[C].base&&(r=p(k(u)&&u,f.min)),f.positiveValuesOnly&&0>=r&&(r=null),L.total=L.stackTotal=K.total,L.percentage=K.total&&L.y/K.total*100,L.stackY=D,K.setOffset(this.pointXOffset||0,this.barW||0));L.yBottom=y(r)?Math.min(Math.max(-1E5,f.translate(r,0,1,0,1)),1E5):null;t&&(D=this.modifyValue(D,
L));L.plotY=r="number"===typeof D&&Infinity!==D?Math.min(Math.max(-1E5,f.translate(D,0,1,0,1)),1E5):void 0;L.isInside=void 0!==r&&0<=r&&r<=f.len&&0<=q&&q<=d.len;L.clientX=m?h(d.translate(C,0,0,0,1,x)):q;L.negative=L.y<(u||0);L.category=e&&void 0!==e[L.x]?e[L.x]:L.x;L.isNull||(void 0!==w&&(H=Math.min(H,Math.abs(q-w))),w=q);L.zone=this.zones.length&&L.getZone()}this.closestPointRangePx=H;c(this,"afterTranslate")},getValidPoints:function(a,b){var c=this.chart;return l(a||this.points||[],function(a){return b&&
!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,e=b.inverted,g=this.clipBox,f=g||b.clipBox,k=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),n=b[k],h=b[k+"m"];n||(a&&(f.width=0,e&&(f.x=b.plotSizeX),b[k+"m"]=h=d.clipRect(e?b.plotSizeX+99:-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight)),b[k]=n=d.clipRect(f),n.count={length:0});a&&!n.count[this.index]&&(n.count[this.index]=
!0,n.count.length+=1);!1!==c.clip&&(this.group.clip(a||g?n:b.clipRect),this.markerGroup.clip(h),this.sharedClipKey=k);a||(n.count[this.index]&&(delete n.count[this.index],--n.count.length),0===n.count.length&&k&&b[k]&&(g||(b[k]=b[k].destroy()),b[k+"m"]&&(b[k+"m"]=b[k+"m"].destroy())))},animate:function(a){var b=this.chart,c=D(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=
null)},afterAnimate:function(){this.setClip();c(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,e,g,f=this.options.marker,k,h,l,t=this[this.specialGroup]||this.markerGroup,x,m=p(f.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=f.enabledThreshold*f.radius);if(!1!==f.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],g=d.graphic,k=d.marker||{},h=!!d.marker,e=m&&void 0===k.enabled||k.enabled,l=d.isInside,e&&!d.isNull?(e=
p(k.symbol,this.symbol),x=this.markerAttribs(d,d.selected&&"select"),g?g[l?"show":"hide"](!0).animate(x):l&&(0<x.width||d.hasImage)&&(d.graphic=g=b.renderer.symbol(e,x.x,x.y,x.width,x.height,h?k:f).add(t)),g&&g.attr(this.pointAttribs(d,d.selected&&"select")),g&&g.addClass(d.getClassName(),!0)):g&&(d.graphic=g.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},e=d.symbol||c.symbol,g=p(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],g=p(b&&b.radius,c&&c.radius,
g+(c&&c.radiusPlus||0)));a.hasImage=e&&0===e.indexOf("url");a.hasImage&&(g=0);a={x:Math.floor(a.plotX)-g,y:a.plotY-g};g&&(a.width=a.height=2*g);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,e=d&&d.marker||{},g=this.color,f=d&&d.color,k=a&&a.color,d=p(e.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;g=f||a||k||g;a=e.fillColor||c.fillColor||g;g=e.lineColor||c.lineColor||g;b&&(c=c.states[b],b=e.states&&e.states[b]||{},d=p(b.lineWidth,c.lineWidth,d+p(b.lineWidthPlus,
c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,g=b.lineColor||c.lineColor||g);return{stroke:g,"stroke-width":d,fill:a}},destroy:function(){var b=this,d=b.chart,e=/AppleWebKit\/533/.test(I.navigator.userAgent),f,k,g=b.data||[],h,l;c(b,"destroy");H(b);q(b.axisTypes||[],function(a){(l=b[a])&&l.series&&(w(l.series,b),l.isDirty=l.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(k=g.length;k--;)(h=g[k])&&h.destroy&&h.destroy();b.points=null;a.clearTimeout(b.animationTimeout);u(b,function(a,
b){a instanceof L&&!a.survive&&(f=e&&"group"===b?"hide":"destroy",a[f]())});d.hoverSeries===b&&(d.hoverSeries=null);w(d.series,b);d.orderSeries();u(b,function(a,c){delete b[c]})},getGraphPath:function(a,b,c){var d=this,e=d.options,g=e.step,f,k=[],n=[],h;a=a||d.points;(f=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&f&&(g=4-g);!e.connectNulls||b||c||(a=this.getValidPoints(a));q(a,function(f,l){var p=f.plotX,t=f.plotY,x=a[l-1];(f.leftCliff||x&&x.rightCliff)&&!c&&(h=!0);f.isNull&&!y(b)&&
0<l?h=!e.connectNulls:f.isNull&&!b?h=!0:(0===l||h?l=["M",f.plotX,f.plotY]:d.getPointSpline?l=d.getPointSpline(a,f,l):g?(l=1===g?["L",x.plotX,t]:2===g?["L",(x.plotX+p)/2,x.plotY,"L",(x.plotX+p)/2,t]:["L",p,x.plotY],l.push("L",p,t)):l=["L",p,t],n.push(f.x),g&&(n.push(f.x),2===g&&n.push(f.x)),k.push.apply(k,l),h=!1)});k.xMap=n;return d.graphPath=k},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]],
d=a.getZonesGraphs(d);q(d,function(d,e){var g=d[0],f=a[g];f?(f.endX=a.preventGraphAnimation?null:c.xMap,f.animate({d:c})):c.length&&(a[g]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),f={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?f.dashstyle=d[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[g].attr(f).shadow(2>e&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},getZonesGraphs:function(a){q(this.zones,function(b,
c){a.push(["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||""),b.color||this.color,b.dashStyle||this.options.dashStyle])},this);return a},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,e,g,f=this.clips||[],k,h=this.graph,l=this.area,t=Math.max(b.chartWidth,b.chartHeight),x=this[(this.zoneAxis||"y")+"Axis"],m,u,z=b.inverted,r,w,y,I,H=!1;d.length&&(h||l)&&x&&void 0!==x.min&&(u=x.reversed,r=x.horiz,h&&!this.showLine&&h.hide(),l&&l.hide(),m=x.getExtremes(),
q(d,function(d,n){e=u?r?b.plotWidth:0:r?0:x.toPixels(m.min);e=Math.min(Math.max(p(g,e),0),t);g=Math.min(Math.max(Math.round(x.toPixels(p(d.value,m.max),!0)),0),t);H&&(e=g=x.toPixels(m.max));w=Math.abs(e-g);y=Math.min(e,g);I=Math.max(e,g);x.isXAxis?(k={x:z?I:y,y:0,width:w,height:t},r||(k.x=b.plotHeight-k.x)):(k={x:0,y:z?I:y,width:t,height:w},r&&(k.y=b.plotWidth-k.y));z&&c.isVML&&(k=x.isXAxis?{x:0,y:u?y:I,height:k.width,width:b.chartWidth}:{x:k.y-b.plotLeft-b.spacingBox.x,y:0,width:k.height,height:b.chartHeight});
f[n]?f[n].animate(k):(f[n]=c.clipRect(k),h&&a["zone-graph-"+n].clip(f[n]),l&&a["zone-area-"+n].clip(f[n]));H=d.value>m.max;a.resetZones&&0===g&&(g=void 0)}),this.clips=f)},invertGroups:function(a){function b(){q(["group","markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,e;c.xAxis&&(e=C(d,"resize",b),C(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,
b,c,d,e){var g=this[a],f=!g;f&&(this[a]=g=this.chart.renderer.g().attr({zIndex:d||.1}).add(e));g.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(y(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,
c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,d,e=a.options,f=!!a.animate&&b.renderer.isSVG&&D(e.animation).duration,g=a.visible?"inherit":"hidden",k=e.zIndex,h=a.hasRendered,l=b.seriesGroup,p=b.inverted;d=a.plotGroup("group","series",g,k,l);a.markerGroup=a.plotGroup("markerGroup","markers",g,k,l);f&&a.animate(!0);d.inverted=a.isCartesian?p:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&
a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(p);!1===e.clip||a.sharedClipKey||h||d.clip(b.clipRect);f&&a.animate();h||(a.animationTimeout=x(function(){a.afterAnimate()},f));a.isDirty=!1;a.hasRendered=!0;c(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:p(d&&
d.left,a.plotLeft),translateY:p(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,d,e){var g,f;if(f=c&&c.length)return g=b.kdAxisArray[d%e],c.sort(function(a,b){return a[g]-b[g]}),f=Math.floor(f/2),{point:c[f],
left:a(c.slice(0,f),d+1,e),right:a(c.slice(f+1),d+1,e)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;x(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,k,h){var l=b.point,n=d.kdAxisArray[k%h],p,t,x=l;t=y(a[e])&&y(l[e])?Math.pow(a[e]-l[e],2):null;p=y(a[g])&&y(l[g])?Math.pow(a[g]-l[g],2):null;p=(t||0)+(p||0);l.dist=y(p)?Math.sqrt(p):Number.MAX_VALUE;
l.distX=y(t)?Math.sqrt(t):Number.MAX_VALUE;n=a[n]-l[n];p=0>n?"left":"right";t=0>n?"right":"left";b[p]&&(p=c(a,b[p],k+1,h),x=p[f]<x[f]?p:l);b[t]&&Math.sqrt(n*n)<x[f]&&(a=c(a,b[t],k+1,h),x=a[f]<x[f]?a:x);return x}var d=this,e=this.kdAxisArray[0],g=this.kdAxisArray[1],f=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(K);(function(a){var C=a.Axis,D=a.Chart,E=a.correctFloat,m=a.defined,
h=a.destroyObjectProperties,f=a.each,r=a.format,y=a.objectEach,q=a.pick,w=a.Series;a.StackItem=function(a,c,f,h,k){var d=a.chart.inverted;this.axis=a;this.isNegative=f;this.options=c;this.x=h;this.total=null;this.points={};this.stack=k;this.rightCliff=this.leftCliff=0;this.alignOptions={align:c.align||(d?f?"left":"right":"center"),verticalAlign:c.verticalAlign||(d?"middle":f?"bottom":"top"),y:q(c.y,d?4:f?14:-6),x:q(c.x,d?f?-6:6:0)};this.textAlign=c.textAlign||(d?f?"right":"left":"center")};a.StackItem.prototype=
{destroy:function(){h(this,this.axis)},render:function(a){var c=this.axis.chart,e=this.options,f=e.format,f=f?r(f,this,c.time):e.formatter.call(this);this.label?this.label.attr({text:f,visibility:"hidden"}):this.label=c.renderer.text(f,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a);this.label.labelrank=c.plotHeight},setOffset:function(a,c){var e=this.axis,f=e.chart,k=e.translate(e.usePercentage?100:this.total,0,0,0,1),d=e.translate(0),
d=m(k)&&Math.abs(k-d);a=f.xAxis[0].translate(this.x)+a;e=m(k)&&this.getStackBox(f,this,a,k,c,d,e);(c=this.label)&&e&&(c.align(this.alignOptions,null,e),e=c.alignAttr,c[!1===this.options.crop||f.isInsidePlot(e.x,e.y)?"show":"hide"](!0))},getStackBox:function(a,c,f,h,k,d,b){var e=c.axis.reversed,l=a.inverted;a=b.height+b.pos-(l?a.plotLeft:a.plotTop);c=c.isNegative&&!e||!c.isNegative&&e;return{x:l?c?h:h-d:f,y:l?a-f-k:c?a-h-d:a-h,width:l?d:k,height:l?k:d}}};D.prototype.getStacks=function(){var a=this;
f(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});f(a.series,function(c){!c.options.stacking||!0!==c.visible&&!1!==a.options.chart.ignoreHiddenSeries||(c.stackKey=c.type+q(c.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,c=q(this.options.reversedStacks,!0),f=a.length,h;if(!this.isXAxis){this.usePercentage=!1;for(h=f;h--;)a[c?h:f-h-1].setStackedPoints();for(h=0;h<f;h++)a[h].modifyStacks()}};C.prototype.renderStackTotals=function(){var a=this.chart,
c=a.renderer,f=this.stacks,h=this.stackTotalGroup;h||(this.stackTotalGroup=h=c.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());h.translate(a.plotLeft,a.plotTop);y(f,function(a){y(a,function(a){a.render(h)})})};C.prototype.resetStacks=function(){var a=this,c=a.stacks;a.isXAxis||y(c,function(c){y(c,function(e,f){e.touched<a.stacksTouched?(e.destroy(),delete c[f]):(e.total=null,e.cumulative=null)})})};C.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=this.stacks=
this.oldStacks),y(a,function(a){y(a,function(a){a.cumulative=a.total})}))};w.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var e=this.processedXData,c=this.processedYData,f=[],h=c.length,k=this.options,d=k.threshold,b=q(k.startFromThreshold&&d,0),u=k.stack,k=k.stacking,p=this.stackKey,r="-"+p,t=this.negStacks,w=this.yAxis,x=w.stacks,y=w.oldStacks,n,G,B,M,F,g,v;w.stacksTouched+=1;for(F=0;F<h;F++)g=e[F],v=c[F],
n=this.getStackIndicator(n,g,this.index),M=n.key,B=(G=t&&v<(b?0:d))?r:p,x[B]||(x[B]={}),x[B][g]||(y[B]&&y[B][g]?(x[B][g]=y[B][g],x[B][g].total=null):x[B][g]=new a.StackItem(w,w.options.stackLabels,G,g,u)),B=x[B][g],null!==v?(B.points[M]=B.points[this.index]=[q(B.cumulative,b)],m(B.cumulative)||(B.base=M),B.touched=w.stacksTouched,0<n.index&&!1===this.singleStacks&&(B.points[M][0]=B.points[this.index+","+g+",0"][0])):B.points[M]=B.points[this.index]=null,"percent"===k?(G=G?p:r,t&&x[G]&&x[G][g]?(G=
x[G][g],B.total=G.total=Math.max(G.total,B.total)+Math.abs(v)||0):B.total=E(B.total+(Math.abs(v)||0))):B.total=E(B.total+(v||0)),B.cumulative=q(B.cumulative,b)+(v||0),null!==v&&(B.points[M].push(B.cumulative),f[F]=B.cumulative);"percent"===k&&(w.usePercentage=!0);this.stackedYData=f;w.oldStacks={}}};w.prototype.modifyStacks=function(){var a=this,c=a.stackKey,h=a.yAxis.stacks,m=a.processedXData,k,d=a.options.stacking;a[d+"Stacker"]&&f([c,"-"+c],function(b){for(var c=m.length,e,f;c--;)if(e=m[c],k=a.getStackIndicator(k,
e,a.index,b),f=(e=h[b]&&h[b][e])&&e.points[k.key])a[d+"Stacker"](f,e,c)})};w.prototype.percentStacker=function(a,c,f){c=c.total?100/c.total:0;a[0]=E(a[0]*c);a[1]=E(a[1]*c);this.stackedYData[f]=a[1]};w.prototype.getStackIndicator=function(a,c,f,h){!m(a)||a.x!==c||h&&a.key!==h?a={x:c,index:0,key:h}:a.index++;a.key=[f,c,a.index].join();return a}})(K);(function(a){var C=a.addEvent,D=a.animate,E=a.Axis,m=a.createElement,h=a.css,f=a.defined,r=a.each,y=a.erase,q=a.extend,w=a.fireEvent,e=a.inArray,c=a.isNumber,
l=a.isObject,z=a.isArray,k=a.merge,d=a.objectEach,b=a.pick,u=a.Point,p=a.Series,H=a.seriesTypes,t=a.setAnimation,L=a.splat;q(a.Chart.prototype,{addSeries:function(a,c,d){var e,f=this;a&&(c=b(c,!0),w(f,"addSeries",{options:a},function(){e=f.initSeries(a);f.isDirtyLegend=!0;f.linkSeries();w(f,"afterAddSeries");c&&f.redraw(d)}));return e},addAxis:function(a,c,d,e){var f=c?"xAxis":"yAxis",h=this.options;a=k(a,{index:this[f].length,isX:c});c=new E(this,a);h[f]=L(h[f]||{});h[f].push(a);b(d,!0)&&this.redraw(e);
return c},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=c.loading,f=function(){d&&h(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=m("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=m("span",{className:"highcharts-loading-inner"},null,d),C(b,"redraw",f));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;h(d,q(e.style,{zIndex:10}));h(b.loadingSpan,
e.labelStyle);b.loadingShown||(h(d,{opacity:0,display:""}),D(d,{opacity:e.style.opacity||.5},{duration:e.showDuration||0}));b.loadingShown=!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",D(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){h(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),update:function(a,h,l,p){var n=this,t={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},x=a.chart,g,m,u=[];w(n,"update",{options:a});if(x){k(!0,n.options.chart,x);"className"in x&&n.setClassName(x.className);"reflow"in x&&n.setReflow(x.reflow);if("inverted"in x||"polar"in x||"type"in x)n.propFromSeries(),g=!0;"alignTicks"in x&&(g=!0);d(x,function(a,b){-1!==
e("chart."+b,n.propsRequireUpdateSeries)&&(m=!0);-1!==e(b,n.propsRequireDirtyBox)&&(n.isDirtyBox=!0)});"style"in x&&n.renderer.setStyle(x.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&k(!0,this.options.plotOptions,a.plotOptions);d(a,function(a,b){if(n[b]&&"function"===typeof n[b].update)n[b].update(a,!1);else if("function"===typeof n[t[b]])n[t[b]](a);"chart"!==b&&-1!==e(b,n.propsRequireUpdateSeries)&&(m=!0)});r("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){var c;
a[b]&&("series"===b&&(c=[],r(n[b],function(a,b){a.options.isInternal||c.push(b)})),r(L(a[b]),function(a,d){(d=f(a.id)&&n.get(a.id)||n[b][c?c[d]:d])&&d.coll===b&&(d.update(a,!1),l&&(d.touched=!0));if(!d&&l)if("series"===b)n.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)n.addAxis(a,"xAxis"===b,!1).touched=!0}),l&&r(n[b],function(a){a.touched||a.options.isInternal?delete a.touched:u.push(a)}))});r(u,function(a){a.remove(!1)});g&&r(n.axes,function(a){a.update({},!1)});m&&r(n.series,function(a){a.update({},
!1)});a.loading&&k(!0,n.options.loading,a.loading);g=x&&x.width;x=x&&x.height;c(g)&&g!==n.chartWidth||c(x)&&x!==n.chartHeight?n.setSize(g,x,p):b(h,!0)&&n.redraw(p);w(n,"afterUpdate",{options:a})},setSubtitle:function(a){this.setTitle(void 0,a)}});q(u.prototype,{update:function(a,c,d,e){function f(){k.applyOptions(a);null===k.y&&g&&(k.graphic=g.destroy());l(a,!0)&&(g&&g.element&&a&&a.marker&&void 0!==a.marker.symbol&&(k.graphic=g.destroy()),a&&a.dataLabels&&k.dataLabel&&(k.dataLabel=k.dataLabel.destroy()),
k.connector&&(k.connector=k.connector.destroy()));n=k.index;h.updateParallelArrays(k,n);t.data[n]=l(t.data[n],!0)||l(a,!0)?k.options:b(a,t.data[n]);h.isDirty=h.isDirtyData=!0;!h.fixedBox&&h.hasCartesianSeries&&(p.isDirtyBox=!0);"point"===t.legendType&&(p.isDirtyLegend=!0);c&&p.redraw(d)}var k=this,h=k.series,g=k.graphic,n,p=h.chart,t=h.options;c=b(c,!0);!1===e?f():k.firePointEvent("update",{options:a},f)},remove:function(a,b){this.series.removePoint(e(this,this.series.data),a,b)}});q(p.prototype,
{addPoint:function(a,c,d,e){var f=this.options,k=this.data,h=this.chart,g=this.xAxis,g=g&&g.hasNames&&g.names,n=f.data,l,p,t=this.xData,x,m;c=b(c,!0);l={series:this};this.pointClass.prototype.applyOptions.apply(l,[a]);m=l.x;x=t.length;if(this.requireSorting&&m<t[x-1])for(p=!0;x&&t[x-1]>m;)x--;this.updateParallelArrays(l,"splice",x,0,0);this.updateParallelArrays(l,x);g&&l.name&&(g[m]=l.name);n.splice(x,0,a);p&&(this.data.splice(x,0,null),this.processData());"point"===f.legendType&&this.generatePoints();
d&&(k[0]&&k[0].remove?k[0].remove(!1):(k.shift(),this.updateParallelArrays(l,"shift"),n.shift()));this.isDirtyData=this.isDirty=!0;c&&h.redraw(e)},removePoint:function(a,c,d){var e=this,f=e.data,k=f[a],h=e.points,g=e.chart,n=function(){h&&h.length===f.length&&h.splice(a,1);f.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(k||{series:e},"splice",a,1);k&&k.destroy();e.isDirty=!0;e.isDirtyData=!0;c&&g.redraw()};t(d,g);c=b(c,!0);k?k.firePointEvent("remove",null,n):n()},remove:function(a,
c,d){function e(){f.destroy();k.isDirtyLegend=k.isDirtyBox=!0;k.linkSeries();b(a,!0)&&k.redraw(c)}var f=this,k=f.chart;!1!==d?w(f,"remove",null,e):e()},update:function(c,d){var f=this,h=f.chart,l=f.userOptions,p=f.oldType||f.type,t=c.type||l.type||h.options.chart.type,g=H[p].prototype,x,m=["group","markerGroup","dataLabelsGroup"],u=["navigatorSeries","baseSeries"],z=f.finishedAnimating&&{animation:!1},y=["data","name","turboThreshold"],I=a.keys(c),A=0<I.length;r(I,function(a){-1===e(a,y)&&(A=!1)});
if(A)c.data&&this.setData(c.data,!1),c.name&&this.setName(c.name,!1);else{u=m.concat(u);r(u,function(a){u[a]=f[a];delete f[a]});c=k(l,z,{index:f.index,pointStart:b(l.pointStart,f.xData[0])},{data:f.options.data},c);f.remove(!1,null,!1);for(x in g)f[x]=void 0;H[t||p]?q(f,H[t||p].prototype):a.error(17,!0);r(u,function(a){f[a]=u[a]});f.init(h,c);c.zIndex!==l.zIndex&&r(m,function(a){f[a]&&f[a].attr({zIndex:c.zIndex})});f.oldType=p;h.linkSeries()}w(this,"afterUpdate");b(d,!0)&&h.redraw(!1)},setName:function(a){this.name=
this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});q(E.prototype,{update:function(a,c){var e=this.chart,f=a&&a.events||{};a=k(this.userOptions,a);e.options[this.coll].indexOf&&(e.options[this.coll][e.options[this.coll].indexOf(this.userOptions)]=a);d(e.options[this.coll].events,function(a,b){"undefined"===typeof f[b]&&(f[b]=void 0)});this.destroy(!0);this.init(e,q(a,{events:f}));e.isDirtyBox=!0;b(c,!0)&&e.redraw()},remove:function(a){for(var c=this.chart,d=this.coll,e=this.series,
f=e.length;f--;)e[f]&&e[f].remove(!1);y(c.axes,this);y(c[d],this);z(c.options[d])?c.options[d].splice(this.options.index,1):delete c.options[d];r(c[d],function(a,b){a.options.index=a.userOptions.index=b});this.destroy();c.isDirtyBox=!0;b(a,!0)&&c.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(K);(function(a){var C=a.color,D=a.each,E=a.map,m=a.pick,h=a.Series,f=a.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,
getStackPoints:function(f){var h=[],q=[],r=this.xAxis,e=this.yAxis,c=e.stacks[this.stackKey],l={},z=this.index,k=e.series,d=k.length,b,u=m(e.options.reversedStacks,!0)?1:-1,p;f=f||this.points;if(this.options.stacking){for(p=0;p<f.length;p++)f[p].leftNull=f[p].rightNull=null,l[f[p].x]=f[p];a.objectEach(c,function(a,b){null!==a.total&&q.push(b)});q.sort(function(a,b){return a-b});b=E(k,function(){return this.visible});D(q,function(a,f){var k=0,t,m;if(l[a]&&!l[a].isNull)h.push(l[a]),D([-1,1],function(e){var k=
1===e?"rightNull":"leftNull",h=0,n=c[q[f+e]];if(n)for(p=z;0<=p&&p<d;)t=n.points[p],t||(p===z?l[a][k]=!0:b[p]&&(m=c[a].points[p])&&(h-=m[1]-m[0])),p+=u;l[a][1===e?"rightCliff":"leftCliff"]=h});else{for(p=z;0<=p&&p<d;){if(t=c[a].points[p]){k=t[1];break}p+=u}k=e.translate(k,0,1,0,1);h.push({isNull:!0,plotX:r.translate(a,0,0,0,1),x:a,plotY:k,yBottom:k})}})}return h},getGraphPath:function(a){var f=h.prototype.getGraphPath,q=this.options,r=q.stacking,e=this.yAxis,c,l,z=[],k=[],d=this.index,b,u=e.stacks[this.stackKey],
p=q.threshold,H=e.getThreshold(q.threshold),t,q=q.connectNulls||"percent"===r,L=function(c,f,h){var l=a[c];c=r&&u[l.x].points[d];var n=l[h+"Null"]||0;h=l[h+"Cliff"]||0;var t,m,l=!0;h||n?(t=(n?c[0]:c[1])+h,m=c[0]+h,l=!!n):!r&&a[f]&&a[f].isNull&&(t=m=p);void 0!==t&&(k.push({plotX:b,plotY:null===t?H:e.getThreshold(t),isNull:l,isCliff:!0}),z.push({plotX:b,plotY:null===m?H:e.getThreshold(m),doCurve:!1}))};a=a||this.points;r&&(a=this.getStackPoints(a));for(c=0;c<a.length;c++)if(l=a[c].isNull,b=m(a[c].rectPlotX,
a[c].plotX),t=m(a[c].yBottom,H),!l||q)q||L(c,c-1,"left"),l&&!r&&q||(k.push(a[c]),z.push({x:c,plotX:b,plotY:t})),q||L(c,c+1,"right");c=f.call(this,k,!0,!0);z.reversed=!0;l=f.call(this,z,!0,!0);l.length&&(l[0]="L");l=c.concat(l);f=f.call(this,k,!1,q);l.xMap=c.xMap;this.areaPath=l;return f},drawGraph:function(){this.areaPath=[];h.prototype.drawGraph.apply(this);var a=this,f=this.areaPath,q=this.options,w=[["area","highcharts-area",this.color,q.fillColor]];D(this.zones,function(e,c){w.push(["zone-area-"+
c,"highcharts-area highcharts-zone-area-"+c+" "+e.className,e.color||a.color,e.fillColor||q.fillColor])});D(w,function(e){var c=e[0],h=a[c];h?(h.endX=a.preventGraphAnimation?null:f.xMap,h.animate({d:f})):(h=a[c]=a.chart.renderer.path(f).addClass(e[1]).attr({fill:m(e[3],C(e[2]).setOpacity(m(q.fillOpacity,.75)).get()),zIndex:0}).add(a.group),h.isArea=!0);h.startX=f.xMap;h.shiftUnit=q.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.pick;a=a.seriesType;a("spline",
"line",{},{getPointSpline:function(a,E,m){var h=E.plotX,f=E.plotY,r=a[m-1];m=a[m+1];var y,q,w,e;if(r&&!r.isNull&&!1!==r.doCurve&&!E.isCliff&&m&&!m.isNull&&!1!==m.doCurve&&!E.isCliff){a=r.plotY;w=m.plotX;m=m.plotY;var c=0;y=(1.5*h+r.plotX)/2.5;q=(1.5*f+a)/2.5;w=(1.5*h+w)/2.5;e=(1.5*f+m)/2.5;w!==y&&(c=(e-q)*(w-h)/(w-y)+f-e);q+=c;e+=c;q>a&&q>f?(q=Math.max(a,f),e=2*f-q):q<a&&q<f&&(q=Math.min(a,f),e=2*f-q);e>m&&e>f?(e=Math.max(m,f),q=2*f-e):e<m&&e<f&&(e=Math.min(m,f),q=2*f-e);E.rightContX=w;E.rightContY=
e}E=["C",C(r.rightContX,r.plotX),C(r.rightContY,r.plotY),C(y,h),C(q,f),h,f];r.rightContX=r.rightContY=null;return E}})})(K);(function(a){var C=a.seriesTypes.area.prototype,D=a.seriesType;D("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.animObject,D=a.color,E=a.each,m=a.extend,h=a.isNumber,f=a.merge,r=a.pick,y=a.Series,q=a.seriesType,w=a.svg;
q("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){y.prototype.init.apply(this,
arguments);var a=this,c=a.chart;c.hasRendered&&E(c.series,function(c){c.type===a.type&&(c.isDirty=!0)})},getColumnMetrics:function(){var a=this,c=a.options,f=a.xAxis,h=a.yAxis,k=f.options.reversedStacks,k=f.reversed&&!k||!f.reversed&&k,d,b={},m=0;!1===c.grouping?m=1:E(a.chart.series,function(c){var e=c.options,f=c.yAxis,k;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||h.len!==f.len||h.pos!==f.pos||(e.stacking?(d=c.stackKey,void 0===b[d]&&(b[d]=m++),k=b[d]):!1!==e.grouping&&
(k=m++),c.columnIndex=k)});var p=Math.min(Math.abs(f.transA)*(f.ordinalSlope||c.pointRange||f.closestPointRange||f.tickInterval||1),f.len),q=p*c.groupPadding,t=(p-2*q)/(m||1),c=Math.min(c.maxPointWidth||f.len,r(c.pointWidth,t*(1-2*c.pointPadding)));a.columnMetrics={width:c,offset:(t-c)/2+(q+((a.columnIndex||0)+(k?1:0))*t-p/2)*(k?-1:1)};return a.columnMetrics},crispCol:function(a,c,f,h){var e=this.chart,d=this.borderWidth,b=-(d%2?.5:0),d=d%2?.5:1;e.inverted&&e.renderer.isVML&&(d+=1);this.options.crisp&&
(f=Math.round(a+f)+b,a=Math.round(a)+b,f-=a);h=Math.round(c+h)+d;b=.5>=Math.abs(c)&&.5<h;c=Math.round(c)+d;h-=c;b&&h&&(--c,h+=1);return{x:a,y:c,width:f,height:h}},translate:function(){var a=this,c=a.chart,f=a.options,h=a.dense=2>a.closestPointRange*a.xAxis.transA,h=a.borderWidth=r(f.borderWidth,h?0:1),k=a.yAxis,d=f.threshold,b=a.translatedThreshold=k.getThreshold(d),m=r(f.minPointLength,5),p=a.getColumnMetrics(),q=p.width,t=a.barW=Math.max(q,1+2*h),w=a.pointXOffset=p.offset;c.inverted&&(b-=.5);f.pointPadding&&
(t=Math.ceil(t));y.prototype.translate.apply(a);E(a.points,function(e){var f=r(e.yBottom,b),h=999+Math.abs(f),h=Math.min(Math.max(-h,e.plotY),k.len+h),l=e.plotX+w,p=t,u=Math.min(h,f),x,g=Math.max(h,f)-u;m&&Math.abs(g)<m&&(g=m,x=!k.reversed&&!e.negative||k.reversed&&e.negative,e.y===d&&a.dataMax<=d&&k.min<d&&(x=!x),u=Math.abs(u-b)>m?f-m:b-(x?m:0));e.barX=l;e.pointWidth=q;e.tooltipPos=c.inverted?[k.len+k.pos-c.plotLeft-h,a.xAxis.len-l-p/2,g]:[l+p/2,h+k.pos-c.plotTop,g];e.shapeType="rect";e.shapeArgs=
a.crispCol.apply(a,e.isNull?[l,b,p,0]:[l,u,p,g])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,c){var e=this.options,h,k=this.pointAttrToOptions||{};h=k.stroke||"borderColor";var d=k["stroke-width"]||"borderWidth",b=a&&a.color||this.color,m=a&&a[h]||e[h]||this.color||b,p=a&&a[d]||e[d]||this[d]||0,k=e.dashStyle;a&&this.zones.length&&(b=a.getZone(),b=a.options.color||
b&&b.color||this.color);c&&(a=f(e.states[c],a.options.states&&a.options.states[c]||{}),c=a.brightness,b=a.color||void 0!==c&&D(b).brighten(a.brightness).get()||b,m=a[h]||m,p=a[d]||p,k=a.dashStyle||k);h={fill:b,stroke:m,"stroke-width":p};k&&(h.dashstyle=k);return h},drawPoints:function(){var a=this,c=this.chart,l=a.options,m=c.renderer,k=l.animationLimit||250,d;E(a.points,function(b){var e=b.graphic,p=e&&c.pointCount<k?"animate":"attr";if(h(b.plotY)&&null!==b.y){d=b.shapeArgs;if(e)e[p](f(d));else b.graphic=
e=m[b.shapeType](d).add(b.group||a.group);l.borderRadius&&e.attr({r:l.borderRadius});e[p](a.pointAttribs(b,b.selected&&"select")).shadow(l.shadow,null,l.stacking&&!l.borderRadius);e.addClass(b.getClassName(),!0)}else e&&(b.graphic=e.destroy())})},animate:function(a){var c=this,f=this.yAxis,e=c.options,k=this.chart.inverted,d={},b=k?"translateX":"translateY",h;w&&(a?(d.scaleY=.001,a=Math.min(f.pos+f.len,Math.max(f.pos,f.toPixels(e.threshold))),k?d.translateX=a-f.len:d.translateY=a,c.group.attr(d)):
(h=c.group.attr(b),c.group.animate({scaleY:1},m(C(c.options.animation),{step:function(a,e){d[b]=h+e.pos*(f.pos-h);c.group.attr(d)}})),c.animate=null))},remove:function(){var a=this,c=a.chart;c.hasRendered&&E(c.series,function(c){c.type===a.type&&(c.isDirty=!0)});y.prototype.remove.apply(a,arguments)}})})(K);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(K);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(K);(function(a){var C=a.deg2rad,D=a.isNumber,E=a.pick,m=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,f=this.chart,r=2*(a.slicedOffset||0),y=f.plotWidth-2*r,
f=f.plotHeight-2*r,q=a.center,q=[E(q[0],"50%"),E(q[1],"50%"),a.size||"100%",a.innerSize||0],w=Math.min(y,f),e,c;for(e=0;4>e;++e)c=q[e],a=2>e||2===e&&/%$/.test(c),q[e]=m(c,[y,f,w,q[2]][e])+(a?r:0);q[3]>q[2]&&(q[3]=q[2]);return q},getStartAndEndRadians:function(a,f){a=D(a)?a:0;f=D(f)&&f>a&&360>f-a?f:a+360;return{start:C*(a+-90),end:C*(f+-90)}}}})(K);(function(a){var C=a.addEvent,D=a.CenteredSeriesMixin,E=a.defined,m=a.each,h=a.extend,f=D.getStartAndEndRadians,r=a.inArray,y=a.noop,q=a.pick,w=a.Point,
e=a.Series,c=a.seriesType,l=a.setAnimation;c("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,
trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var c=this,d=c.points,b=c.startAngleRad;a||(m(d,function(a){var d=a.graphic,f=a.shapeArgs;d&&(d.attr({r:a.startR||c.center[3]/2,start:b,end:b}),d.animate({r:f.r,start:f.start,end:f.end},c.options.animation))}),c.animate=null)},updateTotals:function(){var a,c=0,d=this.points,b=d.length,f,e=this.options.ignoreHiddenPoint;for(a=0;a<b;a++)f=d[a],c+=e&&!f.visible?0:f.isNull?
0:f.y;this.total=c;for(a=0;a<b;a++)f=d[a],f.percentage=0<c&&(f.visible||!e)?f.y/c*100:0,f.total=c},generatePoints:function(){e.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var c=0,d=this.options,b=d.slicedOffset,e=b+(d.borderWidth||0),h,l,t,m=f(d.startAngle,d.endAngle),x=this.startAngleRad=m.start,m=(this.endAngleRad=m.end)-x,r=this.points,n,w=d.dataLabels.distance,d=d.ignoreHiddenPoint,z,y=r.length,F;a||(this.center=a=this.getCenter());this.getX=
function(b,c,d){t=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(t)*(a[2]/2+d.labelDistance)};for(z=0;z<y;z++){F=r[z];F.labelDistance=q(F.options.dataLabels&&F.options.dataLabels.distance,w);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,F.labelDistance);h=x+c*m;if(!d||F.visible)c+=F.percentage/100;l=x+c*m;F.shapeType="arc";F.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*h)/1E3,end:Math.round(1E3*l)/1E3};t=(l+h)/2;t>1.5*Math.PI?
t-=2*Math.PI:t<-Math.PI/2&&(t+=2*Math.PI);F.slicedTranslation={translateX:Math.round(Math.cos(t)*b),translateY:Math.round(Math.sin(t)*b)};l=Math.cos(t)*a[2]/2;n=Math.sin(t)*a[2]/2;F.tooltipPos=[a[0]+.7*l,a[1]+.7*n];F.half=t<-Math.PI/2||t>Math.PI/2?1:0;F.angle=t;h=Math.min(e,F.labelDistance/5);F.labelPos=[a[0]+l+Math.cos(t)*F.labelDistance,a[1]+n+Math.sin(t)*F.labelDistance,a[0]+l+Math.cos(t)*h,a[1]+n+Math.sin(t)*h,a[0]+l,a[1]+n,0>F.labelDistance?"center":F.half?"right":"left",t]}},drawGraph:null,
drawPoints:function(){var a=this,c=a.chart.renderer,d,b,f,e,l=a.options.shadow;l&&!a.shadowGroup&&(a.shadowGroup=c.g("shadow").add(a.group));m(a.points,function(k){b=k.graphic;if(k.isNull)b&&(k.graphic=b.destroy());else{e=k.shapeArgs;d=k.getTranslate();var t=k.shadowGroup;l&&!t&&(t=k.shadowGroup=c.g("shadow").add(a.shadowGroup));t&&t.attr(d);f=a.pointAttribs(k,k.selected&&"select");b?b.setRadialReference(a.center).attr(f).animate(h(e,d)):(k.graphic=b=c[k.shapeType](e).setRadialReference(a.center).attr(d).add(a.group),
b.attr(f).attr({"stroke-linejoin":"round"}).shadow(l,t));b.attr({visibility:k.visible?"inherit":"hidden"});b.addClass(k.getClassName())}})},searchPoint:y,sortByAngle:function(a,c){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*c})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:D.getCenter,getSymbol:y},{init:function(){w.prototype.init.apply(this,arguments);var a=this,c;a.name=q(a.name,"Slice");c=function(c){a.slice("select"===c.type)};C(a,"select",c);C(a,"unselect",
c);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,c){var d=this,b=d.series,f=b.chart,e=b.options.ignoreHiddenPoint;c=q(c,e);a!==d.visible&&(d.visible=d.options.visible=a=void 0===a?!d.visible:a,b.options.data[r(d,b.data)]=d.options,m(["graphic","dataLabel","connector","shadowGroup"],function(b){if(d[b])d[b][a?"show":"hide"](!0)}),d.legendItem&&f.legend.colorizeItem(d,a),a||"hover"!==d.state||d.setState(""),e&&(b.isDirty=!0),c&&f.redraw())},slice:function(a,
c,d){var b=this.series;l(d,b.chart);q(c,!0);this.sliced=this.options.sliced=E(a)?a:!this.sliced;b.options.data[r(this,b.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:this.shapeArgs.r-
1,start:c.start,end:c.end})}})})(K);(function(a){var C=a.addEvent,D=a.arrayMax,E=a.defined,m=a.each,h=a.extend,f=a.format,r=a.map,y=a.merge,q=a.noop,w=a.pick,e=a.relativeLength,c=a.Series,l=a.seriesTypes,z=a.some,k=a.stableSort;a.distribute=function(c,b,f){function d(a,b){return a.target-b.target}var e,h=!0,l=c,x=[],q;q=0;var n=l.reducedLen||b;for(e=c.length;e--;)q+=c[e].size;if(q>n){k(c,function(a,b){return(b.rank||0)-(a.rank||0)});for(q=e=0;q<=n;)q+=c[e].size,e++;x=c.splice(e-1,c.length)}k(c,d);
for(c=r(c,function(a){return{size:a.size,targets:[a.target],align:w(a.align,.5)}});h;){for(e=c.length;e--;)h=c[e],q=(Math.min.apply(0,h.targets)+Math.max.apply(0,h.targets))/2,h.pos=Math.min(Math.max(0,q-h.size*h.align),b-h.size);e=c.length;for(h=!1;e--;)0<e&&c[e-1].pos+c[e-1].size>c[e].pos&&(c[e-1].size+=c[e].size,c[e-1].targets=c[e-1].targets.concat(c[e].targets),c[e-1].align=.5,c[e-1].pos+c[e-1].size>b&&(c[e-1].pos=b-c[e-1].size),c.splice(e,1),h=!0)}l.push.apply(l,x);e=0;z(c,function(c){var d=
0;if(z(c.targets,function(){l[e].pos=c.pos+d;if(Math.abs(l[e].pos-l[e].target)>f)return m(l.slice(0,e+1),function(a){delete a.pos}),l.reducedLen=(l.reducedLen||b)-.1*b,l.reducedLen>.1*b&&a.distribute(l,b,f),!0;d+=l[e].size;e++}))return!0});k(l,d)};c.prototype.drawDataLabels=function(){function c(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}
var b=this,e=b.chart,k=b.options,h=k.dataLabels,l=b.points,q,x,r=b.hasRendered||0,n,z,B=w(h.defer,!!k.animation),D=e.renderer;if(h.enabled||b._hasPointLabels)b.dlProcessOptions&&b.dlProcessOptions(h),z=b.plotGroup("dataLabelsGroup","data-labels",B&&!r?"hidden":"visible",h.zIndex||6),B&&(z.attr({opacity:+r}),r||C(b,"afterAnimate",function(){b.visible&&z.show(!0);z[k.animation?"animate":"attr"]({opacity:1},{duration:200})})),x=h,m(l,function(d){var g,l=d.dataLabel,t,p,m=d.connector,u=!l,r;q=d.dlOptions||
d.options&&d.options.dataLabels;(g=w(q&&q.enabled,x.enabled)&&!d.isNull)&&(g=!0===c(d,q||h));g&&(h=y(x,q),t=d.getLabelConfig(),r=h[d.formatPrefix+"Format"]||h.format,n=E(r)?f(r,t,e.time):(h[d.formatPrefix+"Formatter"]||h.formatter).call(t,h),r=h.style,t=h.rotation,r.color=w(h.color,r.color,b.color,"#000000"),"contrast"===r.color&&(d.contrastColor=D.getContrast(d.color||b.color),r.color=h.inside||0>w(d.labelDistance,h.distance)||k.stacking?d.contrastColor:"#000000"),k.cursor&&(r.cursor=k.cursor),p=
{fill:h.backgroundColor,stroke:h.borderColor,"stroke-width":h.borderWidth,r:h.borderRadius||0,rotation:t,padding:h.padding,zIndex:1},a.objectEach(p,function(a,b){void 0===a&&delete p[b]}));!l||g&&E(n)?g&&E(n)&&(l?p.text=n:(l=d.dataLabel=t?D.text(n,0,-9999,h.useHTML).addClass("highcharts-data-label"):D.label(n,0,-9999,h.shape,null,null,h.useHTML,null,"data-label"),l.addClass(" highcharts-data-label-color-"+d.colorIndex+" "+(h.className||"")+(h.useHTML?" highcharts-tracker":""))),l.attr(p),l.css(r).shadow(h.shadow),
l.added||l.add(z),b.alignDataLabel(d,l,h,null,u)):(d.dataLabel=l=l.destroy(),m&&(d.connector=m.destroy()))});a.fireEvent(this,"afterDrawDataLabels")};c.prototype.alignDataLabel=function(a,b,c,e,f){var d=this.chart,k=d.inverted,l=w(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),m=w(a.plotY,-9999),n=b.getBBox(),p,q=c.rotation,r=c.align,u=this.visible&&(a.series.forceDL||d.isInsidePlot(l,Math.round(m),k)||e&&d.isInsidePlot(l,k?e.x+1:e.y+e.height-1,k)),g="justify"===w(c.overflow,"justify");if(u&&(p=c.style.fontSize,
p=d.renderer.fontMetrics(p,b).b,e=h({x:k?this.yAxis.len-m:l,y:Math.round(k?this.xAxis.len-l:m),width:0,height:0},e),h(c,{width:n.width,height:n.height}),q?(g=!1,l=d.renderer.rotCorr(p,q),l={x:e.x+c.x+e.width/2+l.x,y:e.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*e.height},b[f?"attr":"animate"](l).attr({align:r}),m=(q+720)%360,m=180<m&&360>m,"left"===r?l.y-=m?n.height:0:"center"===r?(l.x-=n.width/2,l.y-=n.height/2):"right"===r&&(l.x-=n.width,l.y-=m?0:n.height),b.placed=!0,b.alignAttr=l):(b.align(c,
null,e),l=b.alignAttr),g&&0<=e.height?a.isLabelJustified=this.justifyDataLabel(b,c,l,n,e,f):w(c.crop,!0)&&(u=d.isInsidePlot(l.x,l.y)&&d.isInsidePlot(l.x+n.width,l.y+n.height)),c.shape&&!q))b[f?"attr":"animate"]({anchorX:k?d.plotWidth-a.plotY:a.plotX,anchorY:k?d.plotHeight-a.plotX:a.plotY});u||(b.attr({y:-9999}),b.placed=!1)};c.prototype.justifyDataLabel=function(a,b,c,e,f,k){var d=this.chart,h=b.align,l=b.verticalAlign,n,m,t=a.box?0:a.padding||0;n=c.x+t;0>n&&("right"===h?b.align="left":b.x=-n,m=!0);
n=c.x+e.width-t;n>d.plotWidth&&("left"===h?b.align="right":b.x=d.plotWidth-n,m=!0);n=c.y+t;0>n&&("bottom"===l?b.verticalAlign="top":b.y=-n,m=!0);n=c.y+e.height-t;n>d.plotHeight&&("top"===l?b.verticalAlign="bottom":b.y=d.plotHeight-n,m=!0);m&&(a.placed=!k,a.align(b,null,f));return m};l.pie&&(l.pie.prototype.drawDataLabels=function(){var d=this,b=d.data,e,f=d.chart,k=d.options.dataLabels,h=w(k.connectorPadding,10),l=w(k.connectorWidth,1),q=f.plotWidth,r=f.plotHeight,n=Math.round(f.chartWidth/3),y,z=
d.center,C=z[2]/2,F=z[1],g,v,K,Q,J=[[],[]],O,N,A,R,S=[0,0,0,0];d.visible&&(k.enabled||d._hasPointLabels)&&(m(b,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),c.prototype.drawDataLabels.apply(d),m(b,function(a){a.dataLabel&&(a.visible?(J[a.half].push(a),a.dataLabel._pos=null,!E(k.style.width)&&!E(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>
n&&(a.dataLabel.css({width:.7*n}),a.dataLabel.shortened=!0)):a.dataLabel=a.dataLabel.destroy())}),m(J,function(b,c){var l,n,t=b.length,p=[],x;if(t)for(d.sortByAngle(b,c-.5),0<d.maxLabelDistance&&(l=Math.max(0,F-C-d.maxLabelDistance),n=Math.min(F+C+d.maxLabelDistance,f.plotHeight),m(b,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,F-C-a.labelDistance),a.bottom=Math.min(F+C+a.labelDistance,f.plotHeight),x=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPos[1]-a.top+x/
2,size:x,rank:a.y},p.push(a.distributeBox))}),l=n+x-l,a.distribute(p,l,l/5)),R=0;R<t;R++)e=b[R],K=e.labelPos,g=e.dataLabel,A=!1===e.visible?"hidden":"inherit",N=l=K[1],p&&E(e.distributeBox)&&(void 0===e.distributeBox.pos?A="hidden":(Q=e.distributeBox.size,N=e.top+e.distributeBox.pos)),delete e.positionIndex,O=k.justify?z[0]+(c?-1:1)*(C+e.labelDistance):d.getX(N<e.top+2||N>e.bottom-2?l:N,c,e),g._attr={visibility:A,align:K[6]},g._pos={x:O+k.x+({left:h,right:-h}[K[6]]||0),y:N+k.y-10},K.x=O,K.y=N,w(k.crop,
!0)&&(v=g.getBBox().width,l=null,O-v<h&&1===c?(l=Math.round(v-O+h),S[3]=Math.max(l,S[3])):O+v>q-h&&0===c&&(l=Math.round(O+v-q+h),S[1]=Math.max(l,S[1])),0>N-Q/2?S[0]=Math.max(Math.round(-N+Q/2),S[0]):N+Q/2>r&&(S[2]=Math.max(Math.round(N+Q/2-r),S[2])),g.sideOverflow=l)}),0===D(S)||this.verifyDataLabelOverflow(S))&&(this.placeDataLabels(),l&&m(this.points,function(a){var b;y=a.connector;if((g=a.dataLabel)&&g._pos&&a.visible&&0<a.labelDistance){A=g._attr.visibility;if(b=!y)a.connector=y=f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+
a.colorIndex+(a.className?" "+a.className:"")).add(d.dataLabelsGroup),y.attr({"stroke-width":l,stroke:k.connectorColor||a.color||"#666666"});y[b?"attr":"animate"]({d:d.connectorPath(a.labelPos)});y.attr("visibility",A)}else y&&(a.connector=y.destroy())}))},l.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return w(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",
a[4],a[5]]},l.pie.prototype.placeDataLabels=function(){m(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},l.pie.prototype.alignDataLabel=q,l.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,
c=this.options,d=c.center,f=c.minSize||80,k,h=null!==c.size;h||(null!==d[0]?k=Math.max(b[2]-Math.max(a[1],a[3]),f):(k=Math.max(b[2]-a[1]-a[3],f),b[0]+=(a[3]-a[1])/2),null!==d[1]?k=Math.max(Math.min(k,b[2]-Math.max(a[0],a[2])),f):(k=Math.max(Math.min(k,b[2]-a[0]-a[2]),f),b[1]+=(a[0]-a[2])/2),k<b[2]?(b[2]=k,b[3]=Math.min(e(c.innerSize||0,k),k),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):h=!0);return h});l.column&&(l.column.prototype.alignDataLabel=function(a,b,e,f,k){var d=this.chart.inverted,
h=a.series,l=a.dlBox||a.shapeArgs,m=w(a.below,a.plotY>w(this.translatedThreshold,h.yAxis.len)),n=w(e.inside,!!this.options.stacking);l&&(f=y(l),0>f.y&&(f.height+=f.y,f.y=0),l=f.y+f.height-h.yAxis.len,0<l&&(f.height-=l),d&&(f={x:h.yAxis.len-f.y-f.height,y:h.xAxis.len-f.x-f.width,width:f.height,height:f.width}),n||(d?(f.x+=m?0:f.width,f.width=0):(f.y+=m?f.height:0,f.height=0)));e.align=w(e.align,!d||n?"center":m?"right":"left");e.verticalAlign=w(e.verticalAlign,d||n?"middle":m?"top":"bottom");c.prototype.alignDataLabel.call(this,
a,b,e,f,k);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(K);(function(a){var C=a.Chart,D=a.each,E=a.objectEach,m=a.pick;a=a.addEvent;a(C,"render",function(){var a=[];D(this.labelCollectors||[],function(f){a=a.concat(f())});D(this.yAxis||[],function(f){f.options.stackLabels&&!f.options.stackLabels.allowOverlap&&E(f.stacks,function(f){E(f,function(f){a.push(f.label)})})});D(this.series||[],function(f){var h=f.options.dataLabels,y=f.dataLabelCollections||["dataLabel"];
(h.enabled||f._hasPointLabels)&&!h.allowOverlap&&f.visible&&D(y,function(h){D(f.points,function(f){f[h]&&(f[h].labelrank=m(f.labelrank,f.shapeArgs&&f.shapeArgs.height),a.push(f[h]))})})});this.hideOverlappingLabels(a)});C.prototype.hideOverlappingLabels=function(a){var f=a.length,h=this.renderer,m,q,w,e,c,l,z=function(a,c,b,e,f,h,l,m){return!(f>a+b||f+l<a||h>c+e||h+m<c)};w=function(a){var c,b,e,f=2*(a.box?0:a.padding||0);e=0;if(a&&(!a.alignAttr||a.placed))return c=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},
b=a.parentGroup,a.width||(e=a.getBBox(),a.width=e.width,a.height=e.height,e=h.fontMetrics(null,a.element).h),{x:c.x+(b.translateX||0),y:c.y+(b.translateY||0)-e,width:a.width-f,height:a.height-f}};for(q=0;q<f;q++)if(m=a[q])m.oldOpacity=m.opacity,m.newOpacity=1,m.absoluteBox=w(m);a.sort(function(a,c){return(c.labelrank||0)-(a.labelrank||0)});for(q=0;q<f;q++)for(l=(w=a[q])&&w.absoluteBox,m=q+1;m<f;++m)if(c=(e=a[m])&&e.absoluteBox,l&&c&&w!==e&&0!==w.newOpacity&&0!==e.newOpacity&&(c=z(l.x,l.y,l.width,
l.height,c.x,c.y,c.width,c.height)))(w.labelrank<e.labelrank?w:e).newOpacity=0;D(a,function(a){var c,b;a&&(b=a.newOpacity,a.oldOpacity!==b&&(a.alignAttr&&a.placed?(b?a.show(!0):c=function(){a.hide()},a.alignAttr.opacity=b,a[a.isOld?"animate":"attr"](a.alignAttr,null,c)):a.attr({opacity:b})),a.isOld=!0)})}})(K);(function(a){var C=a.addEvent,D=a.Chart,E=a.createElement,m=a.css,h=a.defaultOptions,f=a.defaultPlotOptions,r=a.each,y=a.extend,q=a.fireEvent,w=a.hasTouch,e=a.inArray,c=a.isObject,l=a.Legend,
z=a.merge,k=a.pick,d=a.Point,b=a.Series,u=a.seriesTypes,p=a.svg,H;H=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};r(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(r(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",
function(a){b.onTrackerMouseOut(a)});if(w)a[d].on("touchstart",c);a.options.cursor&&a[d].css(m).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,h=f.pointer,k=f.renderer,l=f.options.tooltip.snap,g=a.tracker,m,u=function(){if(f.hoverSeries!==a)a.onMouseOver()},y="rgba(192,192,192,"+(p?.0001:.002)+")";if(e&&!c)for(m=e+1;m--;)"M"===d[m]&&d.splice(m+
1,0,d[m+1]-l,d[m+2],"L"),(m&&"M"===d[m]||m===e)&&d.splice(m,0,"L",d[m-2]+l,d[m-1]);g?g.attr({d:d}):a.graph&&(a.tracker=k.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:y,fill:c?y:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*l),zIndex:2}).add(a.group),r([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",u).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(w)a.on("touchstart",u)}));
q(this,"afterDrawTracker")}};u.column&&(u.column.prototype.drawTracker=H.drawTrackerPoint);u.pie&&(u.pie.prototype.drawTracker=H.drawTrackerPoint);u.scatter&&(u.scatter.prototype.drawTracker=H.drawTrackerPoint);y(l.prototype,{setItemEvents:function(a,b,c){var e=this,f=e.chart.renderer.boxWrapper,h="highcharts-legend-"+(a instanceof d?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(h);b.css(e.options.itemHoverStyle)}).on("mouseout",function(){b.css(z(a.visible?
e.itemStyle:e.itemHiddenStyle));f.removeClass(h);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};f.removeClass(h);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):q(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=E("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){q(a.series||
a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});h.legend.itemStyle.cursor="pointer";y(D.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=h.lang,d=b.options.chart.resetZoomButton,e=d.theme,f=e.states,k="chart"===d.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,f&&f.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,
!1,k)})},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b,d=this.pointer,e=!1,f;!a||a.resetSelection?(r(this.axes,function(a){b=a.zoom()}),d.initiated=!1):r(a.xAxis.concat(a.yAxis),function(a){var c=a.axis;d[c.isXAxis?"zoomX":"zoomY"]&&(b=c.zoom(a.min,a.max),c.displayBtn&&(e=!0))});f=this.resetZoomButton;e&&!f?this.showResetZoom():!e&&c(f)&&(this.resetZoomButton=f.destroy());b&&this.redraw(k(this.options.chart.animation,a&&a.animation,100>this.pointCount))},
pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&r(d,function(a){a.setState()});r("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",h=c[d],g=(b.pointRange||0)/2,k=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),n=b.toValue(h-f,!0)+g*k,k=b.toValue(h+b.len-f,!0)-g*k,m=k<n,h=m?k:n,n=m?n:k,k=Math.min(l.dataMin,g?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding)),g=Math.max(l.dataMax,g?l.max:b.toValue(b.toPixels(l.max)+
b.minPixelPadding)),m=k-h;0<m&&(n+=m,h=k);m=n-g;0<m&&(n=g,h-=m);b.series.length&&h!==l.min&&n!==l.max&&(b.setExtremes(h,n,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);m(c.container,{cursor:"move"})}});y(d.prototype,{select:function(a,b){var c=this,d=c.series,f=d.chart;a=k(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[e(c,d.data)]=c.options;c.setState(a&&"select");b||r(f.getSelectedPoints(),function(a){a.selected&&
a!==c&&(a.selected=a.options.selected=!1,d.options.data[e(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");r(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,
c=z(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){C(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,h=e.options.states[a||"normal"]||{},l=f[e.type].marker&&e.options.marker,m=l&&!1===l.enabled,p=l&&l.states&&l.states[a||"normal"]||{},g=!1===p.enabled,t=e.stateMarkerGraphic,r=this.marker||{},u=e.chart,w=e.halo,z,C=l&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===
h.enabled||a&&(g||m&&!1===p.enabled)||a&&r.states&&r.states[a]&&!1===r.states[a].enabled)){C&&(z=e.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(e.pointAttribs(this,a),k(u.options.chart.animation,h.animation)),z&&this.graphic.animate(z,k(u.options.chart.animation,p.animation,l.animation)),t&&t.hide();else{if(a&&p){l=r.symbol||e.symbol;t&&t.currentSymbol!==l&&(t=t.destroy());
if(t)t[b?"animate":"attr"]({x:z.x,y:z.y});else l&&(e.stateMarkerGraphic=t=u.renderer.symbol(l,z.x,z.y,z.width,z.height).add(e.markerGroup),t.currentSymbol=l);t&&t.attr(e.pointAttribs(this,a))}t&&(t[a&&u.isInsidePlot(c,d,u.inverted)?"show":"hide"](),t.element.point=this)}(c=h.halo)&&c.size?(w||(e.halo=w=u.renderer.path().add((this.graphic||t).parentGroup)),w.show()[b?"animate":"attr"]({d:this.haloPath(c.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+k(this.colorIndex,e.colorIndex)+(this.className?
" "+this.className:""),zIndex:-1}),w.point=this,w.attr(y({fill:this.color||e.color,"fill-opacity":c.opacity},c.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)},null,w.hide);this.state=a;q(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});y(b.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&q(this,"mouseOver");
this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,e=c.states,f=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(r([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+
b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!e[a]||!1!==e[a].enabled)&&(a&&(f=e[a].lineWidth||f+(e[a].lineWidthPlus||0)),d&&!d.dashstyle))for(f={"stroke-width":f},d.animate(f,k(e[a||"normal"]&&e[a||"normal"].animation,b.chart.options.chart.animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(f),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,h=d.options.chart.ignoreHiddenSeries,k=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:
a)?"show":"hide";r(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&r(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});r(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);q(c,f);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=
a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);q(this,a?"select":"unselect")},drawTracker:H.drawTrackerGraph})})(K);(function(a){var C=a.Chart,D=a.each,E=a.inArray,m=a.isArray,h=a.isObject,f=a.pick,r=a.splat;C.prototype.setResponsive=function(f){var h=this.options.responsive,m=[],e=this.currentResponsive;h&&h.rules&&D(h.rules,function(c){void 0===c._id&&(c._id=a.uniqueKey());this.matchResponsiveRule(c,m,f)},this);var c=a.merge.apply(0,a.map(m,function(c){return a.find(h.rules,
function(a){return a._id===c}).chartOptions})),m=m.toString()||void 0;m!==(e&&e.ruleIds)&&(e&&this.update(e.undoOptions,f),m?(this.currentResponsive={ruleIds:m,mergedOptions:c,undoOptions:this.currentOptions(c)},this.update(c,f)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,h){var m=a.condition;(m.callback||function(){return this.chartWidth<=f(m.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=f(m.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=f(m.minWidth,0)&&this.chartHeight>=
f(m.minHeight,0)}).call(this)&&h.push(a._id)};C.prototype.currentOptions=function(f){function q(e,c,f,w){var k;a.objectEach(e,function(a,b){if(!w&&-1<E(b,["series","xAxis","yAxis"]))for(a=r(a),f[b]=[],k=0;k<a.length;k++)c[b][k]&&(f[b][k]={},q(a[k],c[b][k],f[b][k],w+1));else h(a)?(f[b]=m(a)?[]:{},q(a,c[b]||{},f[b],w+1)):f[b]=c[b]||null})}var w={};q(f,this.options,w,0);return w}})(K);return K});


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinesChartContainer__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,regionsData:state.REGIONS.regionsData,referenceRegionsData:state.REGIONS.referenceRegionsData,sameCountryRegionsData:state.REGIONS.sameCountryRegionsData,allRegionsGroupRegionId:state.REGIONS.allRegionsGroupRegionId,allRegionsFilter:state.FILTERS.allRegionsFilter,referenceRegionsFilter:state.FILTERS.referenceRegionsFilter,sameCountryRegionsFilter:state.FILTERS.sameCountryRegionsFilter,otherRegionsFilter:state.FILTERS.otherRegionsFilter,indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__LinesChartContainer__["a" /* default */]));

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({referenceRegions:{id:'LinesChart.referenceRegions',description:'Regiones de referencia',defaultMessage:'Reg. referencia'},femaleAcronym:{id:'LinesChart.femaleAcronym',description:'Texto para mujeres',defaultMessage:'M'},maleAcronym:{id:'LinesChart.maleAcronym',description:'Texto para hombres',defaultMessage:'H'},euAcronym:{id:'LinesChart.euAcronym',description:'Texto para UE27',defaultMessage:'UE27 (2020)'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapChartContainer__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,regionsData:state.REGIONS.regionsData,referenceRegionsData:state.REGIONS.referenceRegionsData,sameCountryRegionsData:state.REGIONS.sameCountryRegionsData,allRegionsFilter:state.FILTERS.allRegionsFilter,referenceRegionsFilter:state.FILTERS.referenceRegionsFilter,sameCountryRegionsFilter:state.FILTERS.sameCountryRegionsFilter,otherRegionsFilter:state.FILTERS.otherRegionsFilter,indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__MapChartContainer__["a" /* default */]));

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorEvolutionContainer__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(68);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setRegionsData:function setRegionsData(regionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setRegionsData(regionsData));},setReferenceRegionsData:function setReferenceRegionsData(referenceRegionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setReferenceRegionsData(referenceRegionsData));},setSameCountryRegionsData:function setSameCountryRegionsData(sameCountryRegionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSameCountryRegionsData(sameCountryRegionsData));},setIndicatorsData:function setIndicatorsData(indicatorsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsData(indicatorsData));},setIndicatorsLastUpdated:function setIndicatorsLastUpdated(lastUpdated){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsLastUpdated(lastUpdated));},setCountriesData:function setCountriesData(countriesData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setCountriesData(countriesData));},setSelectedRegionCountryMeta:function setSelectedRegionCountryMeta(countryMeta){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSelectedRegionCountryMeta(countryMeta));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__IndicatorEvolutionContainer__["a" /* default */])));

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1182)
var ieee754 = __webpack_require__(1183)
var isArray = __webpack_require__(1184)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 419 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(421);
module.exports = __webpack_require__(426);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(422).enable();
  window.Promise = __webpack_require__(424);
}

// fetch() polyfill for making API calls.
__webpack_require__(425);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(173);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(259);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(259);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 425 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_redux__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setup__ = __webpack_require__(666);
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4_redux_redux__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__setup__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(428);

__webpack_require__(625);

__webpack_require__(626);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(429);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(195);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(278);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(281);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
module.exports = __webpack_require__(48);


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(42);
var DESCRIPTORS = __webpack_require__(16);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(39);
var META = __webpack_require__(69).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(133);
var setToStringTag = __webpack_require__(99);
var uid = __webpack_require__(79);
var wks = __webpack_require__(15);
var wksExt = __webpack_require__(261);
var wksDefine = __webpack_require__(175);
var enumKeys = __webpack_require__(430);
var isArray = __webpack_require__(136);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var toIObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(56);
var createDesc = __webpack_require__(78);
var _create = __webpack_require__(82);
var gOPNExt = __webpack_require__(264);
var $GOPD = __webpack_require__(44);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(80);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(83).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(121).f = $propertyIsEnumerable;
  __webpack_require__(135).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(70)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(38)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(135);
var pIE = __webpack_require__(121);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(82) });


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperties: __webpack_require__(263) });


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(43);
var $getOwnPropertyDescriptor = __webpack_require__(44).f;

__webpack_require__(59)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(23);
var $getPrototypeOf = __webpack_require__(45);

__webpack_require__(59)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(23);
var $keys = __webpack_require__(80);

__webpack_require__(59)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(59)('getOwnPropertyNames', function () {
  return __webpack_require__(264).f;
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(69).onFreeze;

__webpack_require__(59)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(69).onFreeze;

__webpack_require__(59)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(69).onFreeze;

__webpack_require__(59)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(13);

__webpack_require__(59)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(13);

__webpack_require__(59)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(13);

__webpack_require__(59)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(265) });


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(446) });


/***/ }),
/* 446 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(179).set });


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(122);
var test = {};
test[__webpack_require__(15)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(39)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(266) });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(16) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(45);
var HAS_INSTANCE = __webpack_require__(15)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(17).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(268);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(269);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var has = __webpack_require__(42);
var cof = __webpack_require__(50);
var inheritIfRequired = __webpack_require__(181);
var toPrimitive = __webpack_require__(56);
var fails = __webpack_require__(12);
var gOPN = __webpack_require__(83).f;
var gOPD = __webpack_require__(44).f;
var dP = __webpack_require__(17).f;
var $trim = __webpack_require__(100).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(82)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(16) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(39)(global, NUMBER, $Number);
}


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(58);
var aNumberValue = __webpack_require__(270);
var repeat = __webpack_require__(182);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(12)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(12);
var aNumberValue = __webpack_require__(270);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(10).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(271) });


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(271);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(269);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(268);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(272);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(183);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(184);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(273) });


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(272) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(183) });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(184);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(184);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(81);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(43);
var toLength = __webpack_require__(18);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(100)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(185)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(186)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(185)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(18);
var context = __webpack_require__(188);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(189)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(188);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(189)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(182)
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(18);
var context = __webpack_require__(188);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(189)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(40)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(40)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(40)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(40)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(40)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(40)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(40)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(40)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(40)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(40)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(40)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(40)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(40)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(56);

$export($export.P + $export.F * __webpack_require__(12)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(508);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(12);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(39)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(15)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(38)(proto, TO_PRIMITIVE, __webpack_require__(511));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(56);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(136) });


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(49);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(23);
var call = __webpack_require__(274);
var isArrayIter = __webpack_require__(190);
var toLength = __webpack_require__(18);
var createProperty = __webpack_require__(191);
var getIterFn = __webpack_require__(192);

$export($export.S + $export.F * !__webpack_require__(138)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(191);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(12)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(43);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(120) != Object || !__webpack_require__(51)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(178);
var cof = __webpack_require__(50);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(18);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(12)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(34);
var toObject = __webpack_require__(23);
var fails = __webpack_require__(12);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(51)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(60)(0);
var STRICT = __webpack_require__(51)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var isArray = __webpack_require__(136);
var SPECIES = __webpack_require__(15)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(60)(1);

$export($export.P + $export.F * !__webpack_require__(51)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(60)(2);

$export($export.P + $export.F * !__webpack_require__(51)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(60)(3);

$export($export.P + $export.F * !__webpack_require__(51)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(60)(4);

$export($export.P + $export.F * !__webpack_require__(51)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(275);

$export($export.P + $export.F * !__webpack_require__(51)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(275);

$export($export.P + $export.F * !__webpack_require__(51)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(134)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(43);
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(18);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(276) });

__webpack_require__(71)('copyWithin');


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(194) });

__webpack_require__(71)('fill');


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(60)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(71)(KEY);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(60)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(71)(KEY);


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84)('Array');


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var inheritIfRequired = __webpack_require__(181);
var dP = __webpack_require__(17).f;
var gOPN = __webpack_require__(83).f;
var isRegExp = __webpack_require__(137);
var $flags = __webpack_require__(139);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(16) && (!CORRECT_NEW || __webpack_require__(12)(function () {
  re2[__webpack_require__(15)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(39)(global, 'RegExp', $RegExp);
}

__webpack_require__(84)('RegExp');


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(278);
var anObject = __webpack_require__(9);
var $flags = __webpack_require__(139);
var DESCRIPTORS = __webpack_require__(16);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(39)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(12)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(140)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(140)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(140)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(140)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(137);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(70);
var global = __webpack_require__(10);
var ctx = __webpack_require__(49);
var classof = __webpack_require__(122);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(13);
var aFunction = __webpack_require__(34);
var anInstance = __webpack_require__(85);
var forOf = __webpack_require__(86);
var speciesConstructor = __webpack_require__(141);
var task = __webpack_require__(196).set;
var microtask = __webpack_require__(197)();
var newPromiseCapabilityModule = __webpack_require__(198);
var perform = __webpack_require__(279);
var userAgent = __webpack_require__(142);
var promiseResolve = __webpack_require__(280);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(15)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(87)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(99)($Promise, PROMISE);
__webpack_require__(84)(PROMISE);
Wrapper = __webpack_require__(48)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(138)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(285);
var validate = __webpack_require__(102);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(143)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(144);
var buffer = __webpack_require__(199);
var anObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(18);
var isObject = __webpack_require__(13);
var ArrayBuffer = __webpack_require__(10).ArrayBuffer;
var speciesConstructor = __webpack_require__(141);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(12)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(84)(ARRAY_BUFFER);


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(144).ABV, {
  DataView: __webpack_require__(199).DataView
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(34);
var anObject = __webpack_require__(9);
var rApply = (__webpack_require__(10).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(12)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(82);
var aFunction = __webpack_require__(34);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(12);
var bind = __webpack_require__(266);
var rConstruct = (__webpack_require__(10).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(17);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(56);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(12)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(44).f;
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(187)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(44);
var getPrototypeOf = __webpack_require__(45);
var has = __webpack_require__(42);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(9);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(44);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(45);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(287) });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(17);
var gOPD = __webpack_require__(44);
var getPrototypeOf = __webpack_require__(45);
var has = __webpack_require__(42);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(78);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(179);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(134)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(71)('includes');


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(288);
var toObject = __webpack_require__(23);
var toLength = __webpack_require__(18);
var aFunction = __webpack_require__(34);
var arraySpeciesCreate = __webpack_require__(193);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(71)('flatMap');


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(288);
var toObject = __webpack_require__(23);
var toLength = __webpack_require__(18);
var toInteger = __webpack_require__(58);
var arraySpeciesCreate = __webpack_require__(193);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(71)('flatten');


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(185)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(289);
var userAgent = __webpack_require__(142);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(289);
var userAgent = __webpack_require__(142);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(100)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(100)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(57);
var toLength = __webpack_require__(18);
var isRegExp = __webpack_require__(137);
var getFlags = __webpack_require__(139);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(187)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175)('asyncIterator');


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175)('observable');


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(287);
var toIObject = __webpack_require__(43);
var gOPD = __webpack_require__(44);
var createProperty = __webpack_require__(191);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(290)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(290)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(23);
var aFunction = __webpack_require__(34);
var $defineProperty = __webpack_require__(17);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(16) && $export($export.P + __webpack_require__(145), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(23);
var aFunction = __webpack_require__(34);
var $defineProperty = __webpack_require__(17);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(16) && $export($export.P + __webpack_require__(145), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(56);
var getPrototypeOf = __webpack_require__(45);
var getOwnPropertyDescriptor = __webpack_require__(44).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(16) && $export($export.P + __webpack_require__(145), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(56);
var getPrototypeOf = __webpack_require__(45);
var getOwnPropertyDescriptor = __webpack_require__(44).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(16) && $export($export.P + __webpack_require__(145), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(291)('Map') });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(291)('Set') });


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(146)('Map');


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(146)('Set');


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(146)('WeakMap');


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(146)('WeakSet');


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(147)('Map');


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(147)('Set');


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(147)('WeakMap');


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(147)('WeakSet');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(10) });


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(10) });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(50);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(293);
var fround = __webpack_require__(273);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(293) });


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(48);
var global = __webpack_require__(10);
var speciesConstructor = __webpack_require__(141);
var promiseResolve = __webpack_require__(280);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(198);
var perform = __webpack_require__(279);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(45);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(283);
var from = __webpack_require__(292);
var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(45);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(45);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(65);
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(34);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(197)();
var process = __webpack_require__(10).process;
var isNode = __webpack_require__(50)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(10);
var core = __webpack_require__(48);
var microtask = __webpack_require__(197)();
var OBSERVABLE = __webpack_require__(15)('observable');
var aFunction = __webpack_require__(34);
var anObject = __webpack_require__(9);
var anInstance = __webpack_require__(85);
var redefineAll = __webpack_require__(87);
var hide = __webpack_require__(38);
var forOf = __webpack_require__(86);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(84)('Observable');


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(10);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(142);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(196);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(195);
var getKeys = __webpack_require__(80);
var redefine = __webpack_require__(39);
var global = __webpack_require__(10);
var hide = __webpack_require__(38);
var Iterators = __webpack_require__(101);
var wks = __webpack_require__(15);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(627);
module.exports = __webpack_require__(48).RegExp.escape;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(628)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(173),n=__webpack_require__(294),p=__webpack_require__(295),q=__webpack_require__(200),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(294),ba=__webpack_require__(0),m=__webpack_require__(631),p=__webpack_require__(173),v=__webpack_require__(200),da=__webpack_require__(632),ea=__webpack_require__(633),fa=__webpack_require__(634),ha=__webpack_require__(295);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(635);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(636);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(201);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(639);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(658);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(299);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(646);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63), __webpack_require__(645)(module)))

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(655);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(652);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(650);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63)))

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(301);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(654);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(299);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(300);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(659);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(201);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languageReducer__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regionsReducer__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicatorsReducer__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtersReducer__ = __webpack_require__(664);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({LANGUAGE:__WEBPACK_IMPORTED_MODULE_1__languageReducer__["a" /* default */],REGIONS:__WEBPACK_IMPORTED_MODULE_2__regionsReducer__["a" /* default */],INDICATORS:__WEBPACK_IMPORTED_MODULE_3__indicatorsReducer__["a" /* default */],FILTERS:__WEBPACK_IMPORTED_MODULE_4__filtersReducer__["a" /* default */]}));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={selectedLanguage:'es'};var languageReducer=function languageReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_LANGUAGE':return Object.assign({},state,{selectedLanguage:action.language});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (languageReducer);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={selectedRegionId:null,allRegionsGroupRegionId:2692// EU28: 276
};var regionsReducer=function regionsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_SELECTED_REGION_ID':return Object.assign({},state,{selectedRegionId:action.selectedRegionId});case'SET_SELECTED_REGION_COUNTRY_META':return Object.assign({},state,{selectedRegionCountryMeta:action.selectedRegionCountryMeta});case'SET_REGIONS_DATA':return Object.assign({},state,{regionsData:action.regionsData});case'SET_COUNTRIES_DATA':return Object.assign({},state,{countriesData:action.countriesData});case'SET_REFERENCE_REGIONS_DATA':return Object.assign({},state,{referenceRegionsData:action.referenceRegionsData});case'SET_SAME_COUNTRY_REGIONS_DATA':return Object.assign({},state,{sameCountryRegionsData:action.sameCountryRegionsData});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (regionsReducer);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={};var indicatorsReducer=function indicatorsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_INDICATORS_DATA':return Object.assign({},state,{indicatorsData:action.indicatorsData});case'SET_INDICATORS_LAST_UPDATED':return Object.assign({},state,{lastUpdated:action.lastUpdated});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (indicatorsReducer);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={};var filtersReducer=function filtersReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'MANAGE_ALL_FILTER':return Object.assign({},state,{allRegionsFilter:action.checked});case'MANAGE_REFERENCE_FILTER':return Object.assign({},state,{referenceRegionsFilter:action.checked});case'MANAGE_SAME_COUNTRY_FILTER':return Object.assign({},state,{sameCountryRegionsFilter:action.checked});case'MANAGE_TYPE_AHEAD_FILTER':return Object.assign({},state,{otherRegionsFilter:action.selected});case'MANAGE_EVOLUTION_FILTER':return Object.assign({},state,{evolutionFilter:action.selected});case'MANAGE_CHART_TYPE_FILTER':return Object.assign({},state,{chartTypeFilter:action.selected});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (filtersReducer);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/competitiveness-observatory",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/competitiveness-observatory"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetUp__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedLanguage:state.LANGUAGE.selectedLanguage};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__SetUp__["a" /* default */]));

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_es__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_eu__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_eu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_eu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_locales__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_highcharts__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_highcharts_more__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_highcharts_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_highcharts_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_highcharts_modules_export_data__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_highcharts_modules_export_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_highcharts_modules_export_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_highcharts_modules_offline_exporting__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_highcharts_modules_offline_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_highcharts_modules_offline_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_highcharts_modules_data__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_highcharts_modules_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_highcharts_modules_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_highcharts_export_csv_export_csv__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_highcharts_export_csv_export_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_highcharts_export_csv_export_csv__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts.setOptions({lang:{numericSymbols:null},exporting:{// url: "http://localhost:7801"
}});__WEBPACK_IMPORTED_MODULE_12_highcharts_more___default()(__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting___default()(__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting___default()(__WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_15_highcharts_modules_offline_exporting___default()(__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_15_highcharts_modules_offline_exporting___default()(__WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_14_highcharts_modules_export_data___default()(__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_14_highcharts_modules_export_data___default()(__WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_16_highcharts_modules_data___default()(__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_16_highcharts_modules_data___default()(__WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_17_highcharts_export_csv_export_csv___default()(__WEBPACK_IMPORTED_MODULE_10_react_highcharts___default.a.Highcharts);__WEBPACK_IMPORTED_MODULE_17_highcharts_export_csv_export_csv___default()(__WEBPACK_IMPORTED_MODULE_11_react_highcharts_ReactHighmaps_src___default.a.Highcharts);Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_es___default.a);Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_eu___default.a);Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en___default.a);var SetUp=function(_Component){_inherits(SetUp,_Component);function SetUp(){_classCallCheck(this,SetUp);// const config = window._config;
// console.log(config);
var _this=_possibleConstructorReturn(this,(SetUp.__proto__||Object.getPrototypeOf(SetUp)).call(this));__WEBPACK_IMPORTED_MODULE_9_utils_config__["a" /* default */].fromObject(window._config);return _this;}_createClass(SetUp,[{key:'render',value:function render(){var selectedLanguage=__WEBPACK_IMPORTED_MODULE_8_utils_app_appTools__["a" /* default */].getDefaultLanguage();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* IntlProvider */],{locale:selectedLanguage,key:selectedLanguage,messages:__WEBPACK_IMPORTED_MODULE_6_i18n_locales__["a" /* default */][selectedLanguage]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],null)));}}]);return SetUp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SetUp);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(205);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(302);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(302);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(204);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(205);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(304);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(303);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(307);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(308);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(309);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(310);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(207);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(151);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(311);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 685 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(687), src$en$$ = __webpack_require__(692);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(313), src$es5$$ = __webpack_require__(688), src$compiler$$ = __webpack_require__(689), intl$messageformat$parser$$ = __webpack_require__(690);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(313);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(691)['default'];
exports['default'] = exports;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(695)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(700);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(696), src$en$$ = __webpack_require__(699);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(312), src$diff$$ = __webpack_require__(697), src$es5$$ = __webpack_require__(698);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(702)['default'];
exports['default'] = exports;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(703);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.eu=a())}(this,function(){"use strict";return[{locale:"eu",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"urtea",relative:{0:"aurten",1:"hurrengo urtea","-1":"aurreko urtea"},relativeTime:{future:{one:"{0} urte barru",other:"{0} urte barru"},past:{one:"Duela {0} urte",other:"Duela {0} urte"}}},month:{displayName:"hilabetea",relative:{0:"hilabete hau",1:"hurrengo hilabetea","-1":"aurreko hilabetea"},relativeTime:{future:{one:"{0} hilabete barru",other:"{0} hilabete barru"},past:{one:"Duela {0} hilabete",other:"Duela {0} hilabete"}}},day:{displayName:"eguna",relative:{0:"gaur",1:"bihar",2:"etzi","-2":"herenegun","-1":"atzo"},relativeTime:{future:{one:"{0} egun barru",other:"{0} egun barru"},past:{one:"Duela {0} egun",other:"Duela {0} egun"}}},hour:{displayName:"ordua",relative:{0:"ordu honetan"},relativeTime:{future:{one:"{0} ordu barru",other:"{0} ordu barru"},past:{one:"Duela {0} ordu",other:"Duela {0} ordu"}}},minute:{displayName:"minutua",relative:{0:"minutu honetan"},relativeTime:{future:{one:"{0} minutu barru",other:"{0} minutu barru"},past:{one:"Duela {0} minutu",other:"Duela {0} minutu"}}},second:{displayName:"segundoa",relative:{0:"orain"},relativeTime:{future:{one:"{0} segundo barru",other:"{0} segundo barru"},past:{one:"Duela {0} segundo",other:"Duela {0} segundo"}}}}}]});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es_json__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eu_json__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eu_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__eu_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__en_json__);
/* harmony default export */ __webpack_exports__["a"] = ({es:__WEBPACK_IMPORTED_MODULE_0__es_json___default.a,eu:__WEBPACK_IMPORTED_MODULE_1__eu_json___default.a,en:__WEBPACK_IMPORTED_MODULE_2__en_json___default.a// translation disabled
// export default {}
});

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = {"Breadcrumbs.home":"Inicio","Breadcrumbs.layer1PageName":"Panel de indicadores de competitividad","Breadcrumbs.methodology":"Metodología","HTMLTitleController.methodology":"Metodología","PanelsDevelopmentMethodology.methodology":"Metodología","Error.error":"No se han podido recuperar los datos","Footer.competitivenessBasqueInstitute":"Instituto Vasco de Competitividad","Footer.anInitiativeOf":"Una iniciativa de","Footer.spriGroup":"Esta plataforma cuenta con la financiación del <strong>Grupo SPRI</strong>,<br /> agencia vasca de desarrollo empresarial","Footer.privacy":"Privacidad","Header.basqueCountry":"País <br/> Vasco","MenuOffCanvas.basqueCountry":"País <br/> Vasco","MenuOffCanvas.youAreAt":"Estás en","RegionOverview.altVersionBtnEustat":"Cambiar a versión EUSTAT","RegionOverview.altVersionBtnEurostat":"Cambiar a versión EUROSTAT","RegionOverview.alertNewReportPanel":"Accede al <a href=\"{reportPanelLink}\">panel de diagnóstico</a> del Informe de Competitividad del País Vasco 2025 <a href=\"{reportPanelLink}\">aquí</a>","SubHeader.ReportTable_title":"Panel de diagnóstico del Informe de Competitividad del País Vasco","SubHeader.ReportTable_lastUpdated":"Actualizado a <strong>{lastUpdated}</strong>","SubHeader.ReportTable_p1":"Con el objetivo de proporcionar un <strong>diagnóstico más detallado</strong> para el <strong>País Vasco</strong>, este panel presenta una serie de indicadores de desempeño económico-empresarial, bienestar y palancas que forman parte del <a href={methodologyLink}>marco de competitividad Orkestra</a>. Este enfoque amplía la perspectiva de la comparativa regional al incorporar <strong>indicadores específicos</strong> disponibles únicamente para el País Vasco, así como para los niveles nacional y de la Unión Europea.","SubHeader.ReportTable_p2":"Puedes moverte entre las dimensiones del marco con el siguiente mini mapa y volver al inicio desde el encabezado de cada dimensión. Al hacer clic en cualquier indicador, se accederá a un gráfico de evolución comparativa que incluye, además del País Vasco y la UE-27, las líneas de tendencia de España, Alemania y las regiones comparables (Alta Austria y Baden-Wurtemberg), siempre que estén disponibles.","SubHeader.ReportTable_instructions_title":"Cómo leer el panel","SubHeader.ReportTable_instructions_paragraph":"Se presenta una visión más sintética del nivel y la evolución de los indicadores en comparación con la Unión Europea, utilizando un código de colores y símbolos de fácil interpretación. El <span class=\"positive\">color</span> verde indica un resultado positivo, el <span class=\"negative\">color rojo</span> señala un resultado negativo y el <span class=\"stable\">color gris</span> representa una diferencia nula o muy pequeña.\n<ul>\n    <li>La primera columna muestra la evolución interanual del País Vasco; un símbolo indica que la diferencia se encuentra entre el 1% y el 5%, mientras que dos símbolos indican que la diferencia supera el 5%.</li>\n    <li>La segunda columna compara el valor del País Vasco con el de la UE-27, empleando un símbolo para diferencias entre el 1% y el 5%, y dos símbolos para diferencias superiores al 5%.</li>\n    <li>La tercera columna recoge la comparativa de la evolución interanual del indicador para el País Vasco frente a la evolución de la UE-27. En este caso, un símbolo indica que el cambio en el País Vasco difiere entre 0.5 y 3 puntos porcentuales en relación con el cambio en la UE-27, mientras que dos símbolos señalan que la diferencia es superior a 3 puntos porcentuales.</li>\n    <li>En los tres casos, si la diferencia es inferior a los valores indicados, se indica con un signo de igual.</li>\n    <li>Finalmente, al pasar el cursor por encima de los símbolos o hacer click en ellos, se mostrarán los valores subyacentes asociados a cada uno de ellos.</li>\n</ul>","LinesChart.referenceRegions":"Reg. comparables","LinesChart.femaleAcronym":"M","LinesChart.maleAcronym":"H","LinesChart.euAcronym":"UE27","EvolutionChart.noPositionChange":"No ha cambiado su posición en <strong>{yearsEvolution, plural, one {# año} other {# años}}</strong>","EvolutionChart.upPositionChange":"Ha ascendido <strong>{positions, plural, one {# posición} other {# posiciones}}</strong> en <strong>{yearsEvolution, plural, one {# año} other {# años}}</strong>","EvolutionChart.downPositionChange":"Ha descendido <strong>{positions, plural, one {# posición} other {# posiciones}}</strong> en <strong>{yearsEvolution, plural, one {# año} other {# años}}</strong>","EvolutionChart.valueIn":"Valor en {year}","MapChart.yearAndUnit":"Año {year} | Unidad: {unit}","MapChart.female":"Mujeres","ContentChartFooter.female":"Mujeres","MapChart.male":"Hombres","ContentChartFooter.male":"Hombres","PanelRowCointaner.moreRecentDataAvail":"Datos de región disponibles hasta {mostRecentYear}","PanelRowCointaner.moreIndicatorDetail":"Ver indicador en detalle","RankingChart.rankingTooltip":"Posición {position} de {totalRegions}","RankingChart.noDataAvailable":"No hay datos disponibles","ReportTable.dataSource":"Fuente","ReportTable.dataNote":"Nota","ReportTableRowValues.notAvailableShort":"n.d.","ContentChartFooter.showLegendTooltip":"Leyenda","ContentChartFooter.showByGenderTooltip":"Desglose por género","ContentChartFooter.showTableTooltip":"Datos como tabla","ContentChartFooter.openModalTooltip":"Seleccionar el rango de fechas","ContentChartFooter.exportChartTooltip":"Exportar gráfico","ContentChartFooter.expandChartTooltip":"Pantalla completa","ContentChartFooter.indicatorDetail":"Detalle del indicador","ContentChartFooter.downloadPNG":"Descargar en PNG","ContentChartFooter.downloadJPEG":"Descargar en JPEG","ContentChartFooter.downloadPDF":"Descargar en PDF","ContentChartFooter.downloadSVG":"Descargar en SVG","ContentChartFooter.downloadCSV":"Descargar en CSV","ContentChartTitle":"Evolución","PanelSection.columnEvolution":"Evolución","ReportTable.columnEvo":"Evolución","ContentChartTitle.map":"Mapa","ChartTypeFilter.map":"Mapa","ContentChartWrapper.businessBehavior":"Comportamiento empresarial","ContentLevelWrapper.businessBehavior":"Comportamiento empresarial","ContentChartWrapper.specialization":"Especialización","ContentLevelWrapper.specialization":"Especialización","ContentChartWrapper.businessEnvironment":"Entorno empresarial","ContentLevelWrapper.businessEnvironment":"Entorno empresarial","ContentDateModal.modalTitle":"Cambiar el rango de fechas","ContentDateModal.modalFrom":"Desde","ContentDateModal.modalTo":"Hasta","ContentDateModal.modalYear":"Año","ReportTable.columnYear":"Año","ContentDateModal.modalClose":"Cerrar","ContentDateModal.modalApply":"Aplicar","ContentHeader.layer1Title":"Panel de indicadores de competitividad <small>actualizado a {lastUpdated}</small>","ContentHeader.layer1Subtitle":"El panel se organiza en <strong>cuatro dimensiones</strong> esenciales a la hora de identificar las claves de la competitividad al servicio del bienestar inclusivo y sostenible. Utiliza el <strong>mini mapa</strong> a la derecha para orientarte.","ContentHeader.layer2Title":"<span class=\"ork-u-default-text-color\">{levelNumber}</span> {levelName} <small>actualizado a {lastUpdated}</small>","ContentHeader.layer2Subtitle":"El panel se organiza en <strong>cuatro niveles</strong> que determinan el desempeño competitivo. Conocer más sobre la <a href={methodologyLink}>metodología de elaboración del panel</a>.","ContentHeader.layer3Title":"{indicatorName} <small>actualizado a {indicatorLastUpdated}</small>","ContentHeader.knowMoreAboutMethodology":"Conocer más sobre <a href={methodologyLink}>el marco y la metodología de elaboración del panel</a>.","ContentHeader.moreDataAvailableNote":"(*) En caso de disponer de datos más recientes para la región se indica con un <sup>*</sup> junto al año de comparación.","ContentHeader.relatedDocuments":"Análisis relacionados","ContentLevelFooter.relatedDocuments":"Análisis relacionados","RelatedDocumentsDraggable.relatedDocuments":"Análisis relacionados","ContentHeader.unit":"Unidad","ContentLevelFooter.levelDetail":"Acceder al detalle del nivel {level}","ContentLevelInfo.level1Info":"En el <strong>nivel superior</strong> (nivel 1) se sitúan los indicadores de resultado, que recogen los <strong>objetivos últimos</strong>\tque se pretende alcanzar en términos de bienestar de los ciudadanos.","ContentLevelInfo.level2Info":"En el <strong>segundo nivel</strong> aparecen los <strong>indicadores de desempeño intermedio</strong> que, aunque no son los fines últimos que se pretende alcanzar en la región, son importantes para alcanzar esos resultados finales.","ContentLevelInfo.level3Info":"El <strong>tercer nivel</strong> está compuesto por los <strong>determinantes de competitividad</strong>, es decir, los elementos que afectan a los resultados de los dos niveles superiores. Este nivel es particularmente relevante porque es aquel en el que las políticas\tpueden tener un impacto más claro. Los determinantes se agrupan en tres categorías que reflejan el comportamiento de las empresas, la\tespecialización del territorio y sus clústeres, y la calidad del entorno empresarial.","ContentLevelInfo.level4InfoParagraph1":"Finalmente, en la base del <strong><a href={methodologyLink}>marco de competitividad</a> que Orkestra utiliza a la hora de elaborar sus diagnósticos</strong>, los fundamentos hacen referencia a ciertas características del territorio que impactan en la competitividad, pero que vienen más o menos dadas, y no pueden ser modificadas fácilmente en el corto plazo (localización del territorio, recursos naturales, tamaño de la región, instituciones...).","ContentLevelInfo.level4InfoParagraph2":"Estas características estructurales de las regiones son las que utilizamos para determinar cuáles son las que más se parecen entre sí dentro del ámbito europeo de cara a identificar lo que denominamos las <strong>regiones comparables</strong>. Puedes consultar más información acerca de esta metodología y acceder a una herramienta interactiva en <a href=\"http://s3platform.jrc.ec.europa.eu/regional-benchmarking\">página del proyecto</a> desarrollado por Orkestra con el apoyo de la Comisión Europea.","ContentLevelTitle.levelEvolution":"(posición y evolución desde hace {yearsEvolution, plural, one {# año} other {# años}})","PanelSection.columnRegion":"Región","PanelSection.columnCountry":"País","PanelSection.columnEU":"UE27","PanelSection.columnRanking":"Ranking","PanelRowCointaner.rankingTooltip":"Posición de la región frente al resto de regiones de UE27 con datos disponibles","PanelRowCointaner.dimensionLinkTooltip":"Ver dimensión <strong>{dimensionTitle}</strong> con detalle y comparaciones adicionales","ReportTable.columnIndicator":"Indicador","ReportTable.columnValue":"Valor","ReportTable.columnEvoLastYear":"último año","ReportTable.columnEU27Header":"Posicionamiento relativo UE27","ReportTable.columnLevel":"Nivel","ReportTable.columnChange":"Cambio","HTMLTitleController.regional":"Observatorio de Competitividad Regional","HTMLTitleController.institute":"Orkestra Instituto Vasco de Competitividad","LanguageController.espanol":"Español","LanguageControllerResponsive.espanol":"Español","LanguageController.euskera":"Euskera","LanguageControllerResponsive.euskera":"Euskera","LanguageController.english":"English","LanguageControllerResponsive.english":"English","RegionChangerController.placeholder0":"Seleccionar región","RegionChangerController.placeholder1":"Cambiar de región","SurveyController.surveyLink":"https://www.orkestra.deusto.es/es/?option=com_rsform&view=rsform&formId=12","SurveyController/logo":"/img/logo-observatorio-competitividad-es.svg","SurveyController.hello":"Hola,","SurveyController.thanks":"Muchas gracias por utilizar el Observatorio de Competividad de Orkestra.","SurveyController.helpUs":"Ayúdanos a mejorar tu experiencia respondiendo a 4 preguntas en esta breve encuesta.","SurveyController.thanksAgain":"Gracias de nuevo. El equipo de Orkestra.","SurveyController.yes":"Sí, encantado","SurveyController.no":"No, gracias","ChartTypeFilter.absoluteValuesEvolution":"Evolución valores absolutos","EvolutionFilter.option":"{years, plural, one {# año} other {# años}}","FilterContainer.showAllRegions":"Comparar con UE27","FilterContainer.showReferenceRegions":"Regiones comparables","FilterModal.showReferenceRegions":"Regiones comparables","FilterContainer.showSameCountryRegions":"Comparar con país","FilterContainer.compareWith":"Comparar con...","FilterContainer.evolutionSince":"Evolución desde hace...","FilterContainer.chartType":"Tipo de gráfico","FilterContainer.visualizationOptions":"Opciones de visualización","FilterContainer":"Ver listado de regiones incluídas","FilterModal.showAllRegions":"Conjunto de regiones europeas (UE27_2020)","FilterModal.allRegionsModalBodyIntro":"Se compara la situación de <strong>{regionName}</strong> con la del conjunto de las <strong>{regionNumber} regiones</strong> de la UE27 (2020).","FilterModal.referenceRegionsModalBodyIntro":"<strong>{regionName}</strong> se compara con un grupo de <strong>{regionNumber} regiones</strong> de características similares. Éstas han sido elegidas por ser las que presentan una mayor similitud con <strong>{regionName}</strong> en términos de condiciones estructurales de partida (sociodemográficas, e especialización económica y tecnológica, y de estructura empresarial).","FilterModal.accept":"Aceptar","TypeAheadFilter.placeholder":"Región o país","TypeAheadFilter.placeholder2":"Añadir regiones y/o países","HomeContent.title":"La herramienta de diagnóstico regional europeo de Orkestra","HomeContent.updated":"actualizado a {lastUpdated}","HomeContent.welcome":"Bienvenido a la herramienta de <strong>diagnóstico regional</strong> de Orkestra. Aquí podrás estudiar de forma <strong>comparada</strong> la situación y evolución de los <strong>indicadores</strong> clave para la competitividad a partir de los datos más recientes a nivel <strong>regional</strong> europeo.","HomeContent.secondParagraph":"Esta herramienta persigue propiciar la mejora del estudio de la competitividad regional ofreciendo un punto de partida para diferentes análisis regionales realizados tanto dentro como fuera del Instituto.","HomeContent.videoButton":"Ver vídeo explicativo","HomeContent.benchmarking":"Benchmarking","HomeContent.benchmarkingParagraph":"Al realizar comparaciones es importante no mezclar peras con manzanas y es por ello que Orkestra ha desarrollado una <a href=\"{benchmarkingLink}\">metodología de benchmarking</a> que identifica, para cada región europea, las regiones con <b>estructuras similares</b>. Así podrá compararse con sus \"iguales\".","HomeContent.lastData":"Últimos datos","HomeContent.lastDataParagraph":"El observatorio se mantiene siempre <b>actualizado</b> con los últimos datos disponibles para el conjunto de regiones europeas. Para ello utilizamos una plataforma de datos innovadora que nos permite automatizar el proceso de recolección y procesado de datos.","HomeContent.competitivenessFrame":"Marco de competitividad","HomeContent.competitivenessFrameParagraph":"En Orkestra entendemos la competitividad como un <strong>medio para el bienestar</strong> de la sociedad y esto queda reflejado en el <a href=\"{methodologyLink}\">marco analítico</a> desarrollado por el instituto. Este marco define diferentes niveles de indicadores en función de su papel: resultado, desempeño intermedio, determinantes y fundamentos.","HomeContent.reportPanelTitle":"Panel del Informe de Competitividad del País Vasco","HomeContent.reportPanelParagraph":"Acompañando el diagnóstico incluído en el <a href=\"https://www.orkestra.deusto.es/es/investigacion/informe-de-competitividad-del-pais-vasco\">Informe de Competitividad del País Vasco</a>, este <a href=\"{reportPanelLink}\">panel</a> recoge el nivel y evolución de indicadores inscritos en el <a href=\"{methodologyLink}\">marco de competitividad de Orkestra</a>, así como su comparación con la UE-27.","PanelsDevelopmentMethodology.imgLink":"/img/ES-Marco-completo-sincabecera.png","PanelsDevelopmentMethodology.framework":"Marco de competitividad de Orkestra","PanelsDevelopmentMethodology.introductionParagraph1":"En Orkestra utilizamos un marco para analizar la competitividad territorial que propone una serie de elementos esenciales a la hora de identificar las claves de la competitividad al servicio del bienestar inclusivo y sostenible.","PanelsDevelopmentMethodology.introductionParagraph2":"Este marco, que presentamos en el <a href=\"https://www.orkestra.deusto.es/es/investigacion/informe-de-competitividad-del-pais-vasco-2021\" class=\"font-weight-bold\" target=\"_blank\">Informe de Competitividad del País Vasco 2021</a>, también nos ayuda a poner en marcha estrategias e iniciativas para el fomento de la competitividad al servicio del bienestar de las personas.","PanelsDevelopmentMethodology.level1Paragraph":"En el centro del marco <span class=\"obs-dimension-0 font-weight-bold\">(en azul)</span> encontramos las <a class=\"font-weight-bold\" href=\"{dimensionLink0}\">dimensiones de resultado económico-empresarial</a>, que típicamente forman parte del análisis de la competitividad territorial, y las <a href=\"{dimensionLink0}\" class=\"font-weight-bold\">dimensiones de bienestar</a>, a cuyas necesidades debería responder en última instancia la competitividad territorial.","PanelsDevelopmentMethodology.level2Paragraph":"En la parte izquierda <span class=\"obs-dimension-3 font-weight-bold\">(en naranja)</span> se sitúa el <a class=\"font-weight-bold\" href=\"{dimensionLink02}\">contexto estructural</a> del territorio, que incluye características que, en gran medida, vienen dadas y que no son ni buenas ni malas per se. Estos elementos cambian lentamente en el tiempo, pero es posible provocar cambios en algunos de ellos en el medio-largo plazo a través de políticas o estrategias enfocadas en las palancas dinámicas.","PanelsDevelopmentMethodology.level3Paragraph":"A la derecha <span class=\"obs-dimension-2 font-weight-bold\">(en verde)</span> están las <a class=\"font-weight-bold\" href=\"{dimensionLink3}\">palancas dinámicas</a> de la competitividad, que incluyen todos los factores que inciden de alguna manera en la competitividad y el bienestar del territorio y sobre las que las políticas y las estrategias (de los actores, los gobiernos y el territorio en sí) pueden incidir para marcar la dirección en que se debe avanzar, así como promover cambios en el medio-largo plazo en ciertos elementos del contexto estructural.","PanelsDevelopmentMethodology.level4Paragraph":"Completan el marco dos dimensiones transversales: la <strong>inclusividad</strong>, que se manifiesta de distintas maneras que pueden ser más o menos relevantes según la dimensión analizada (desigualdades de riqueza, género, raza, edad, orientación sexual, discapacidad, etc.), y la <strong>conexión internacional</strong>, que está vinculada tanto a los resultados económico-empresariales como a los análisis de las dimensiones del bienestar y de las palancas.","PanelsDevelopmentMethodology.dimensionColophonParagraph1":"Partiendo de este marco se selecciona una batería de indicadores relevantes dentro de cada dimensión, que se va contrastando y actualizando continuamente en los diferentes proyectos e informes realizados por Orkestra.","PanelsDevelopmentMethodology.geographicalScope":"Alcance geográfico","PanelsDevelopmentMethodology.geographicalScopeParagraph1":"El Observatorio de Competitividad de Orkestra abarca datos regionales a nivel europeo. La subdivisión en regiones utilizadas se basa en los niveles NUTS (<a href=\"https://ec.europa.eu/eurostat/web/nuts/background\"> Nomenclature des Unités Territoriales Statistiques</a>) definidos por la Unión Europea.","PanelsDevelopmentMethodology.geographicalScopeParagraph2":"Puesto que el ámbito geográfico de las subdivisiones NUTS varía de estado miembro a estado miembro, en nuestro análisis utilizamos una\tcombinación de niveles NUTS2 y NUTS1, eligiendo el nivel que mejor se aproxime a las divisiones administrativas de cada país.","PanelsDevelopmentMethodology.temporalScope":"Alcance temporal","PanelsDevelopmentMethodology.temporalScopeParagraph":"Este panel se basa en una plataforma de datos de Orkestra que actualiza continuamente los indicadores en función de su disponibilidad.\tCuando se utilizan datos que requieren un tratamiento mínimo su actualización es automática.En los casos de datos que han de ser tratados\testadísticamente en Orkestra la actualización puede llevar algo más de tiempo. En todo caso, si hay algo que te llama la atención, no dudes en ponerte en <a href=\"mailto:behatoki@orkerstra.deusto.es\">contacto con nosotr@s</a >.","PanelsDevelopmentMethodology.dataSources":"Fuentes de datos","PanelsDevelopmentMethodology.dataSourcesParagraph":"Las fuentes primarias de los datos utilizados para la elaboración de este panel son:","PanelsDevelopmentMethodology.dataSourcesItem1":"<a href=\"https://ec.europa.eu/eurostat\" target=\"_blank\">Eurostat</a>, la oficina estadística de la Unión Europea.","PanelsDevelopmentMethodology.dataSourcesItem2":"La base de datos <a href=\"https://www.oecd-ilibrary.org/science-and-technology/the-oecd-regpat-database_241437144144\" target=\"_blank\">REGPAT</a> de la <a href=\"https://www.oecd.org/\" target=\"_blank\">OECD</a> [explotada estadísticamente en Orkestra].","PanelsDevelopmentMethodology.dataSourcesItem3":"La Encuesta Social Europea (<a href=\"https://www.europeansocialsurvey.org/\" target=\"_blank\">European Social Survey</a>) [explotada estadísticamente en\tOrkestra].","PanelsDevelopmentMethodology.dataSourcesItem4":"<a href=\"https://www.eustat.eus\" target=\"_blank\">EUSTAT</a> para los datos de la C.A. de Euskadi cuando son metodológicamente comparables a los de Eurostat","PanelsDevelopmentMethodology.temporalSeriesCompletion":"Completado de series temporales","PanelsDevelopmentMethodology.temporalSeriesCompletionParagraph":"En la mayor parte de los casos se disponen de datos para todas las regiones europeas consideradas y con marco temporal comparable entre\tellas. En otras ocasiones nuestra plataforma de datos se encarga de estimar valores perdidos de forma que podamos ofrecer las series más\tcompletas posibles. Los métodos de estimación se adecúan a cada indicador y abarcan triangulaciones, interpolaciones lineales, resolución y herencia jerárquicas o repetición de la última observación.","PanelsDevelopmentMethodology.indicatorCalculation":"Explotación y cálculo de indicadores","PanelsDevelopmentMethodology.indicatorCalculationParagraph":"Además de utilizar datos provenientes directamente de las fuentes utilizadas, en otras ocasiones realizamos cálculos combinando diferentes indicadores para obtener uno nuevo que refleje mejor la realidad que intentamos monitorizar.","AppTools.dimension_0_Title":"Resultados de bienestar","AppTools.report_2_title":"Resultados de bienestar","AppTools.dimension_1_Title":"Resultados económico-empresariales","AppTools.report_1_title":"Resultados económico-empresariales","AppTools.dimension_2_Title":"Palancas dinámicas","AppTools.dimension_3_Title":"Contexto estructural","AppTools.report_0_title":"Contexto estructural","AppTools.dimension_0_Subtitle":"En última instancia, la competittividad de un territorio se refleja en los resultados de bienestar que es capaza de generar. Organizamos los indicadores en varias subdimensiones de bienestar.","AppTools.dimension_1_Subtitle":"Las dimensiones del desempeño económico-empresarial reflejan los resultados de las actividades empresariales y del conjunto del sistema económico de un territorio.","AppTools.dimension_2_Subtitle":"Las palancas dinámicas inciden en el nivel de competitividad para el bienestar. Son elementos sobre los que hay más margen de actuación y cuya combinación afecta a los resultados económicos empresariales del territorio y al bienestar presente y futuro de las personas.","AppTools.dimension_3_Subtitle":"El contexto estructural incluye las características del propio territorio, que son relativamente estables en el tiempo.","AppTools.subdimension_0_0_Title":"Vida material","AppTools.report_2_2_title":"Vida material","AppTools.subdimension_0_1_Title":"Empleo","AppTools.report_2_3_title":"Empleo","AppTools.subdimension_0_2_Title":"Aprendizaje","AppTools.report_2_5_title":"Aprendizaje","AppTools.subdimension_0_3_Title":"Salud","AppTools.report_2_6_title":"Salud","AppTools.subdimension_0_4_Title":"Medioambiente","AppTools.report_2_7_title":"Medioambiente","AppTools.subdimension_1_0_Title":"Resultados económicos","AppTools.subdimension_1_1_Title":"Rentabilidad empresarial","AppTools.report_1_2_title":"Rentabilidad empresarial","AppTools.subdimension_2_0_Title":"Capital natural","AppTools.report_3_1_title":"Capital natural","AppTools.subdimension_2_1_Title":"Capital físico","AppTools.report_3_2_title":"Capital físico","AppTools.subdimension_2_2_Title":"Conocimiento","AppTools.report_3_4_title":"Conocimiento","AppTools.subdimension_2_3_Title":"Capital humano","AppTools.report_3_5_title":"Capital humano","AppTools.subdimension_2_4_Title":"Capital social e institucional","AppTools.subdimension_3_0_Title":"Geodemografía","AppTools.report_0_1_title":"Geodemografía","AppTools.dataSource":"<em>Fuente:</em> {dataSource}. Elaboración Orkestra.","AppTools.report_1_1_title":"Desempeño económico","AppTools.report_1_3_title":"Innovación y empredimiento","AppTools.report_1_4_title":"Internacionalización","AppTools.report_2_1_title":"Satisfacción con la vida","AppTools.report_2_4_title":"Vida social","AppTools.report_3_title":"Palancas","AppTools.report_3_3_title":"Financiación","AppTools.report_3_6_title":"Capital social","AppTools.report_0_2_title":"Estructura económico empresarial"}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = {"Breadcrumbs.home":"Hasiera","Breadcrumbs.layer1PageName":"Lehiakortasunari lotutako adierazleen panela","Breadcrumbs.methodology":"Metodologia","HTMLTitleController.methodology":"Metodologia","PanelsDevelopmentMethodology.methodology":"Metodologia","Error.error":"Ezin izan dira datuak berreskuratu","Footer.competitivenessBasqueInstitute":"Lehiakortasunerako Euskal Institutua","Footer.anInitiativeOf":"Sustatzailea","Footer.spriGroup":"Plataforma hau <strong>SPRI-Enpresa</strong><br /> Garapenerako Euskal Agentziak finantzatu du","Footer.privacy":"Pribatutasuna","Header.basqueCountry":"Euskal <br/>Autonomia Erkidegoa","MenuOffCanvas.basqueCountry":"Euskal <br/>Autonomia Erkidegoa","MenuOffCanvas.youAreAt":"Hemen zaude","RegionOverview.altVersionBtnEustat":"EUSTAT bertsiora aldatu","RegionOverview.altVersionBtnEurostat":"EUROSTAT bertsiora aldatu","RegionOverview.alertNewReportPanel":"Sar zaitez 2025ko Euskadiko Lehiakortasun Txostenaren <a href=\"{reportPanelLink}\">diagnostiko panelean hemen</a>","SubHeader.ReportTable_title":"Euskal Autonomia Erkidegoko Lehiakortasun Txostenaren diagnostiko-panela","SubHeader.ReportTable_lastUpdated":"<strong>{lastUpdated}</strong>an eguneratua","SubHeader.ReportTable_p1":"Euskadirako <strong>diagnostiko zehatzagoa</strong> emateko helburuarekin, panel honek <a href={methodologyLink}>Orkestraren lehiakortasun-esparrua</a>ren parte diren ekonomia-enpresa-errendimenduaren, ongizatearen eta palankaren adierazle batzuk aurkezten ditu. Ikuspegi honek eskualdeen konparazioaren ikuspegia zabaltzen du, Euskadirako soilik eskuragarri dauden adierazle espezifikoak sartuz, baita estatu eta Europar Batasuneko mailarako ere.","SubHeader.ReportTable_p2":"Markoaren dimentsioen artean mugi zaitezke hurrengo mapa txikiarekin, eta hasierara itzuli dimentsio bakoitzaren burutik. Edozein adierazletan klik egitean, konparazio-bilakaerako grafiko bat eskuratuko da, eta, Euskal Herriaz eta EB-27az gain, Espainia, Alemania eta eskualde konparagarriak (Austria Handia eta Baden-Wurtemberg) barne hartuko ditu, betiere eskuragarri badaude.","SubHeader.ReportTable_instructions_title":"Panela nola irakurri","SubHeader.ReportTable_instructions_paragraph":"Adierazleen maila eta bilakaeraren ikuspegi sintetikoagoa aurkezten da Europar Batasunarekin alderatuta, kolore-kode bat eta erraz interpretatzen diren sinboloak erabiliz. <span class=\"positive\">kolore berdeak</span> emaitza positiboa adierazten du, <span class=\"negative\">kolore gorriak</span> emaitza negatiboa eta <span class=\"stable\"> kolore grisa</span>k alderik ez edo oso txikia adierazten du <ul> <li>Lehenengo zutabean Euskal Herriaren urte arteko bilakaera agertzen da; ikur batek aldea % 1 eta % 5 artekoa dela adierazten du, eta bi sinbolok, berriz, aldea % 5etik gorakoa dela adierazten dute.</li> <li>Bigarren zutabean Euskadiren balioa 27-EBkoarekin alderatzen da. % 1 eta % 5 arteko diferentziak ikur bat erabiliz, eta % 5 baino handiagoak diren diferentziak bi ikur erabiliz.</li> <li>Hirugarren zutabean, Euskal Herriaren adierazlearen urte arteko bilakaeraren konparaketa erakusten da. EB-27. Kasu honetan, ikur batek adierazten du EAEko aldaketa ehuneko 0,5 eta 3 puntu artean desberdina dela EB-27ko aldaketarekin alderatuta, eta bi ikurren artean, aldea 3 puntu baino handiagoa dela.</li > <li>Hiru kasuetan, aldea adierazitako balioak baino txikiagoa bada, berdin-zeinu batekin adierazten da.</li> <li>Azkenik, kurtsorea ikurren gainean jarriz edo horien gainean klik eginez, azpiko balioak haietako bakoitzari lotutakoak bistaratuko dira.</li></ul>","LinesChart.referenceRegions":"Erregio alderagarriak","LinesChart.femaleAcronym":"E","LinesChart.maleAcronym":"G","LinesChart.euAcronym":"EB27","EvolutionChart.noPositionChange":"Ez da tokiz aldatu <strong>{yearsEvolution, plural, one {# urtean} other {# urtean}}</strong>","EvolutionChart.upPositionChange":"<strong>{positions, plural, one {toki bat} other {# toki}}</strong> igo da <strong>{yearsEvolution, plural, one {# urtean} other {# urtean}}</strong>","EvolutionChart.downPositionChange":"<strong>{positions, plural, one {toki bat} other {# toki}}</strong> jaitsi da <strong>{yearsEvolution, plural, one {# urtean} other {# urtean}}</strong>","EvolutionChart.valueIn":"Balioa {year}an","MapChart.yearAndUnit":"{year}. urtea | Unitatea: {unit}","MapChart.female":"Emakumeak","ContentChartFooter.female":"Emakumeak","MapChart.male":"Gizonezkoak","ContentChartFooter.male":"Gizonezkoak","PanelRowCointaner.moreRecentDataAvail":"Erregioaren datuak {mostRecentYear}-raino eskuragarri","PanelRowCointaner.moreIndicatorDetail":"Ikusi adierazlea zehatz-mehatz","RankingChart.rankingTooltip":"{position}. tokia {totalRegions}tik","RankingChart.noDataAvailable":"Ez dago daturik eskuragarri","ReportTable.dataSource":"Iturria","ReportTable.dataNote":"Oharra","ReportTableRowValues.notAvailableShort":"d.e.","ContentChartFooter.showLegendTooltip":"Legenda","ContentChartFooter.showByGenderTooltip":"Banatu generoaren arabera","ContentChartFooter.showTableTooltip":"Datuak taula gisa","ContentChartFooter.openModalTooltip":"Hautatu data tartea","ContentChartFooter.exportChartTooltip":"Esportatu grafikoa","ContentChartFooter.expandChartTooltip":"Pantaila osoa","ContentChartFooter.indicatorDetail":"Adierazlearen xehetasunak","ContentChartFooter.downloadPNG":"Jaitsi PNG formatuan","ContentChartFooter.downloadJPEG":"Jaitsi JPEG formatuan","ContentChartFooter.downloadPDF":"Jaitsi PDF formatuan","ContentChartFooter.downloadSVG":"Jaitsi SVG formatuan","ContentChartFooter.downloadCSV":"Jaitsi CSV formatuan","ContentChartTitle":"Bilakaera","PanelSection.columnEvolution":"Bilakaera","ReportTable.columnEvo":"Bilakaera","ContentChartTitle.map":"Mapa","ChartTypeFilter.map":"Mapa","ContentChartWrapper.businessBehavior":"Enpresen portaera","ContentLevelWrapper.businessBehavior":"Enpresen portaera","ContentChartWrapper.specialization":"Espezializazioa","ContentLevelWrapper.specialization":"Espezializazioa","ContentChartWrapper.businessEnvironment":"Enpresa ingurunea","ContentLevelWrapper.businessEnvironment":"Enpresa ingurunea","ContentDateModal.modalTitle":"Aldatu daten tartea","ContentDateModal.modalFrom":"Noiztik","ContentDateModal.modalTo":"Noiz arte","ContentDateModal.modalYear":"Urtea","ReportTable.columnYear":"Urtea","ContentDateModal.modalClose":"Itxi","ContentDateModal.modalApply":"Aplikatu","ContentHeader.layer1Title":"Lehiakortasunari lotutako adierazleen panela <small>{lastUpdated}an eguneratua</small>","ContentHeader.layer1Subtitle":"Panela <strong>lau dimentsio</strong>tan antolatuta dago, ongizate inklusibo eta iraunkorraren zerbitzura lehiakortasunaren gakoak identifikatzeko ezinbestekoak direnean. Erabili eskuineko <strong>mapa txikia</strong> orientatzeko.","ContentHeader.layer2Title":"<span class=\"ork-u-default-text-color\">{levelNumber}</span> {levelName} <small>{lastUpdated}an eguneratua</small>","ContentHeader.layer2Subtitle":"Panela <strong>lau mailatan</strong> antolatu dugu, lehiakortasunean lortzen diren emaitzak baldintzatzen dituztenak. Gehiago jakin <a href={methodologyLink}>panela egiteko metodologiari</a> buruz.","ContentHeader.layer3Title":"{indicatorName} <small>{indicatorLastUpdated}an eguneratua</small>","ContentHeader.knowMoreAboutMethodology":"Lortu informazio gehiago <a href={methodologyLink}>panela sortzeko esparru eta metodologiari</a>-ari buruz.","ContentHeader.moreDataAvailableNote":"(*) Eskualderako datu berriagoak eskuragarri egonez gero, konparazio urtearen ondoan <sup>*</sup> batekin adieraziko da.","ContentHeader.relatedDocuments":"Lotutako analisiak","ContentLevelFooter.relatedDocuments":"Lotutako analisiak","RelatedDocumentsDraggable.relatedDocuments":"Lotutako analisiak","ContentHeader.unit":"Unitatea","ContentLevelFooter.levelDetail":"{level}. mailaren xehetasunera joan","ContentLevelInfo.level1Info":"<strong>Maila gorenean</strong> (1. maila) <strong>azken helburuak</strong> jasotzen dira, herritarren ongizateari dagokionez, lortu nahi diren emaitza adierazleak.","ContentLevelInfo.level2Info":"<strong>Bigarren mailan</strong>, <strong>bitarteko emaitzen adierazleak</strong> azaltzen dira. Ez dira eskualdeak lortu nahi dituen azken xedeak, baina garrantzitsuak dira azken emaitza horiek lortzeko.","ContentLevelInfo.level3Info":"<strong>Hirugarren mailan</strong> <strong>lehiakortasunaren baldintzatzaileak</strong> daude, hau da, goragoko bi mailetako emaitzetan eragina duten elementuak. Maila honek garrantzi berezi du, elementu horiengan izan baitezakete eraginik argiena politikek. Baldintzatzaileak hiru kategoriatan biltzen dira: enpresen portaeraren ingurukoak; lurraldearen espezializazioaren eta klusterren ingurukoak; eta enpresa ingurunearen kalitatearen ingurukoak.","ContentLevelInfo.level4InfoParagraph1":"Orkestrak diagnostikoak egiteko erabiltzen duen lehiakortasun esparruan, oinarriek lurraldearen haibat ezaugarri ematen dizkigute, lehiakortasunean eragina dutenak, baina epe laburrera aldatu ezin direnak (lurraldearen kokapena, natur baliabideak, eskualdearen tamaina, erakundeak…).","ContentLevelInfo.level4InfoParagraph2":"Eskualdeen egiturazko ezaugarri horiek erabiltzen ditugu zehazteko Europan zein eskualdek duten elkarrekiko antz handiagoa, <strong>erregio alderagarriak</strong> deitzen ditugunak identifikatzera iristeko. Metodologia honi buruzko informazio gehiago kontsultatu eta tresna interaktibo bat erabil dezakezu, Orkestrak Europako Batzordearen laguntzaz garatu duen <a href=\"http://s3platform.jrc.ec.europa.eu/regional-benchmarking\">proiektuaren webgunean</a>.","ContentLevelTitle.levelEvolution":"(tokia eta bilakaera orain dela {yearsEvolution, plural, one {urte batetik} other {# urtetik}} hona)","PanelSection.columnRegion":"Erregioa","PanelSection.columnCountry":"Herrialdea","PanelSection.columnEU":"EB27","PanelSection.columnRanking":"Rankinga","PanelRowCointaner.rankingTooltip":"Eskualdearen posizioa datuak eskuragarri dituzten EB27ko gainerako eskualdeekin alderatuta","PanelRowCointaner.dimensionLinkTooltip":"Ikusi <strong>{dimensionTitle}</strong> dimentsioa xehetasun eta konparazio gehigarriekin","ReportTable.columnIndicator":"Adierazle","ReportTable.columnValue":"Balorea","ReportTable.columnEvoLastYear":"Azken urtea","ReportTable.columnEU27Header":"EU27rekiko posizionamendu erlatiboa","ReportTable.columnLevel":"Maila","ReportTable.columnChange":"Aldaketa","HTMLTitleController.regional":"Erregio Lehiakortasunaren Behatokia","HTMLTitleController.institute":"Orkestra Lehiakortasunerako Euskal Institutua","LanguageController.espanol":"Español","LanguageControllerResponsive.espanol":"Español","LanguageController.euskera":"Euskara","LanguageControllerResponsive.euskera":"Euskara","LanguageController.english":"English","LanguageControllerResponsive.english":"English","RegionChangerController.placeholder0":"Erregioa aukeratu","RegionChangerController.placeholder1":"Erregioa aldatu","SurveyController.surveyLink":"https://www.orkestra.deusto.es/eu/?option=com_rsform&view=rsform&formId=13","SurveyController/logo":"/img/logo-observatorio-competitividad-eu.svg","SurveyController.hello":"Kaixo!","SurveyController.thanks":"Mila esker Orkestraren Lehiakortasunaren Behatokia erabiltzeagatik.","SurveyController.helpUs":"Mesedez, lagun iezaguzu zure esperientzia hobetzen, inkesta labur honetako 4 galderei erantzunez.","SurveyController.thanksAgain":"Mila esker, berriro. Orkestrako lantaldea.","SurveyController.yes":"Bai, pozik","SurveyController.no":"Ez, eskerrik asko","ChartTypeFilter.absoluteValuesEvolution":"Bilakaera balio absolutuetan","EvolutionFilter.option":"{years, plural, one {urte bat} other {# urte}}","FilterContainer.showAllRegions":"EB27-rekin alderatu","FilterContainer.showReferenceRegions":"Erregio alderagarriak","FilterModal.showReferenceRegions":"Erregio alderagarriak","FilterContainer.showSameCountryRegions":"Herriarekin alderatu","FilterContainer.compareWith":"Norekin alderatu?","FilterContainer.evolutionSince":"Bilakaera, noiztik hasita?","FilterContainer.chartType":"Grafiko mota","FilterContainer.visualizationOptions":"Bistaratzeko aukerak","FilterContainer":"Erregio zerrenda ikusi","FilterModal.showAllRegions":"Europako eskualdeen multzoa (EB27-2020)","FilterModal.allRegionsModalBodyIntro":"<strong>{regionName}ren</strong> egoera Europar Batasuneko (EB27-2020ko)<strong> {regionNumber} eskualdeen</strong> multzoarekin alderatzen da.","FilterModal.referenceRegionsModalBodyIntro":"<strong>{regionName}</strong> antzeko ezaugarriak dituzten <strong>{regionNumber} eskualdetako</strong> talde batekin alderatu dugu. Eskualdeak <strong>{regionName}rekin</strong> antzekotasun handiena dutenak dira, abiapuntuko egiturazko baldintzei begiratuta (soziodemografia, espezializazio ekonomikoa eta teknologikoa, eta enpresa egitura)","FilterModal.accept":"Onartu","TypeAheadFilter.placeholder":"Eskualdea edo herrialdea","TypeAheadFilter.placeholder2":"Gehitu eskualdeak eta/edo herrialdeak","HomeContent.title":"Orkestraren Europako eskualdeko diagnostikorako tresna","HomeContent.updated":"{lastUpdated}an eguneratua","HomeContent.welcome":"Ongi etorri Orkestraren <strong>eskualdeko diagnostikorako</strong> tresnara. Lehiakortasunerako <strong>adierazle</strong> gakoen egoera eta bilakaera <strong>alderatua</strong> aztertu ahal izango duzu hemen, Europako <strong>eskualdeetako</strong> datu berrienak erabilita.","HomeContent.secondParagraph":"Tresna honek eskualdeko lehiakortasuna aztertzen lagundu nahi du, eta, horregatik, Institutuan zein kanpoan egiten diren eskualdeko analisietarako abiapuntua eskaintzen du.","HomeContent.videoButton":"Ikusi azalpen bideoa","HomeContent.benchmarking":"Benchmarking-a","HomeContent.benchmarkingParagraph":"Alderapenak egiterakoan, garrantzitsua da udareak eta sagarrak ez nahastea. Horregatik, Orkestrak <a href=\"{benchmarkingLink}\">benchmarking-eko metodologia</a> zehatz bat garatu du eta horren bidez, Europako eskualde bakoitzerao, <b>antzeko egitura</b> duten eskualdeak identifikatu daitezke. Hala, \"berdinekin\" alderatu ahal izango zara.","HomeContent.lastData":"Azken datuak","HomeContent.lastDataParagraph":"Behatokiak Europako eskualdeen multzorako eskugarri dauden <b>azken datuak</b> erakutsiko dizkizu. Horretarako, datu plataforma berritzaile bat erabiltzen dugu, datuak biltzeko eta prozesatzeko prozesua automatizatzea ahalbidetzen diguna.","HomeContent.competitivenessFrame":"Lehiakortasun esparrua","HomeContent.competitivenessFrameParagraph":"Orkestran, lehiakortasuna gizartearen <strong>ongizatea lortzeko bitarteko bat</strong> dela uste dugu, eta horrela jasotzen da Institutuak landu duen <a href=\"{methodologyLink}\">esparru analitikoan</a>. Esparru horrek hainbat adierazle maila definitzen ditu, bakoitzaren funtzioaren arabera: emaitzak, bitarteko aldagaiak, baldintzatzaileak eta oinarriak.","HomeContent.reportPanelTitle":"Euskal Autonomia Erkidegoko Lehiakortasun Txostenaren panel","HomeContent.reportPanelParagraph":"<a href=\"https://www.orkestra.deusto.es/eu/ikerketa/euskal-autonomia-erkidegoko-lehiakortasunari-buruzko-txostena\">Euskadiko Lehiakortasun Txostena</a>n jasotako diagnostikoarekin batera, <a href=\"{reportPanelLink}\">panel</a> honek <a href=\"{methodologyLink}\">Orkestraren lehiakortasun-esparruan</a>n erregistratutako adierazleen maila eta bilakaera biltzen ditu, baita EB-27rekin alderatuz gero.","PanelsDevelopmentMethodology.imgLink":"/img/EU-Marco-completo-sincabecera.png","PanelsDevelopmentMethodology.framework":"Orkestraren lehiakortasun esparrua","PanelsDevelopmentMethodology.introductionParagraph1":"Orkestran lurralde lehiakortasuna aztertzeko esparru bat erabiltzen dugu, ezinbesteko elementu batzuk proposatzen dituena ongizate inklusibo eta iraunkorraren zerbitzura lehiakortasunaren gakoak identifikatzeko orduan.","PanelsDevelopmentMethodology.introductionParagraph2":"Esparru honek, <a href=\"https://www.orkestra.deusto.es/eu/ikerketa/euskal-autonomia-erkidegoko-lehiakortasunari-buruzko-2021eko-txostena\" class=\"font- weight-bold \" target=\"_blank\">Euskadiko Lehiakortasunaren 2021eko Txosten</a>-ean aurkeztuta, pertsonen ongizatearen zerbitzura lehiakortasuna sustatzeko estrategiak eta ekimenak abian jartzen laguntzen digu.","PanelsDevelopmentMethodology.level1Paragraph":"Esparruaren erdian <span class=\"obs-dimension-0 font-weight-bold\">(urdinez)</span> aurkitzen ditugu <a class=\"font-weight-bold\" href=\"{dimensionLink0 }\" >ekonomia-enpresa-emaitzen dimentsioak</a>, normalean lurralde-lehiakortasunaren analisiaren parte izan ohi direnak, eta <a href=\"{dimensionLink0}\" class=\"font-weight-bold\">ongizatearen dimentsioak</a>, funtsean, azken honen beharrei erantzun beharko lioke lurralde lehiakortasunak.","PanelsDevelopmentMethodology.level2Paragraph":"Ezkerrean <span class=\"obs-dimension-3 font-weight-bold\">(laranjaz)</span> lurraldearen <a class=\"font-weight-bold\" href=\"{dimensionLink02}\" >egiturazko ingurunea</a> kokatzen da, neurri handi batean ematen diren eta berez ez onak ez txarrak ez diren ezaugarriak biltzen dituena. Elementu horiek poliki-poliki aldatzen dira denborarekin, baina bada posible aldaketak eragitea palanka dinamikoetara bideratutako politiken edo estrategien bidez.","PanelsDevelopmentMethodology.level3Paragraph":"Eskuinean <span class=\"obs-dimension-2 font-weight-bold\">(berdez)</span> <a class=\"font-weight-bold\" href=\"{dimensionLink3}\">lehiakortasunerako palanka dinamikoak</a> daude, lurraldearen lehiakortasunean eta ongizatean nolabait eragiten duten eta politika eta estrategiek (eragileen, gobernuen eta lurraldearen beraren) eragin dezaketen faktore guztiak barne hartzen dituena. Aurrera egin behar den norabidea eta epe ertain-luzean egiturazko testuinguruko zenbait elementutan aldaketak sustatzeko balio dezakete.","PanelsDevelopmentMethodology.level4Paragraph":"Zeharkako bi dimentsiok osatzen dute markoa: <strong>inklusibitatea</strong>k, aztertutako dimentsioaren arabera garrantzi gehiago edo gutxiago izan dezaketen modu ezberdinetan agertzen dena (aberastasuna, generoa, arraza, adina, sexu-joera, desgaitasuna, desberdintasunak. etab.), eta <strong>nazioarteko konexioa</strong>k, zeina bai ekonomia-enpresa emaitzekin, bai ongizatearen dimentsioen eta palanken azterketarekin lotuta dagoena.","PanelsDevelopmentMethodology.dimensionColophonParagraph1":"Esparru hori abiapuntu hartuta, maila bakoitzean adierazle esanguratsu batzuk aukeratu ditugu, eta, Orkestrak aurrera eramaten dituen proiektu eta txostenei esker, etengabe alderatzen eta eguneratzen ditugu.","PanelsDevelopmentMethodology.geographicalScope":"Irismen geografikoa","PanelsDevelopmentMethodology.geographicalScopeParagraph1":"Orkestraren Lehiakortasunari buruzko Behatokiak Europako eskualdeetako datuak erabiltzen ditu. Hain zuzen ere, Europar Batasunak definitutako NUTS (<a href=\"https://ec.europa.eu/eurostat/web/nuts/background\">Nomenclature des Unités Territoriales Statistiques</a>) mailetan oinarritzen da banaketa hori.","PanelsDevelopmentMethodology.geographicalScopeParagraph2":"NUTS unitateen Geografia esparrua estatu kide batetik bestera aldatzen denez, gure analisian NUTS2 eta NUTS1 mailen konbinazio bat erabili dugu eta, hortaz, herrialdearen arabera xehetasun maila bat edo beste hartu dugu, eskualdeak elkarrekiko ahalik eta alderagarrienak izan daitezen.","PanelsDevelopmentMethodology.temporalScope":"Denbora irismena","PanelsDevelopmentMethodology.temporalScopeParagraph":"Panela Orkestrak etengabe eguneratzen duen datu plataforma batean oinarritzen da. Ia tratamendurik behar ez duten datuak erabiltzen direnean, eguneratzea automatikoa da. Datuak Orkestran tratatu behar direnean, eguneratzeak denbora gehiago eskatzen du. Nolanahi ere, zerbait deigarria gertatzen bazaizu, <a href=\"mailto:behatoki@orkerstra.deusto.es\">jar zaitez gurekin harremanetan</a >.","PanelsDevelopmentMethodology.dataSources":"Datu iturriak","PanelsDevelopmentMethodology.dataSourcesParagraph":"Hauek dira panela prestatzeko erabili ditugun lehen mailako datu iturriak:","PanelsDevelopmentMethodology.dataSourcesItem1":"<a href=\"https://ec.europa.eu/eurostat\" target=\"_blank\">Eurostat</a>, Europar Batasuneko estatistika bulegoa.","PanelsDevelopmentMethodology.dataSourcesItem2":"<a href=\"https://www.oecd.org/\" target=\"_blank\">ELGEko</a> <a href=\"https://www.oecd-ilibrary.org/science-and-technology/the-oecd-regpat-database_241437144144\" target=\"_blank\">REGPAT</a> datu basea [Orkestrak estatistikoki ustiatua].","PanelsDevelopmentMethodology.dataSourcesItem3":"Europako Gizarte Inkesta (<a href=\"https://www.europeansocialsurvey.org/\" target=\"_blank\">European Social Survey</a>) [Orkestrak estatistikoki ustiatua].","PanelsDevelopmentMethodology.dataSourcesItem4":"<a href=\"https://www.eustat.eus\" target=\"_blank\">EUSTAT</a> Euskadiko datuentzat, metodologikoki Eurostat-ekin alderagarriak direnean","PanelsDevelopmentMethodology.temporalSeriesCompletion":"Denbora segida osatuak","PanelsDevelopmentMethodology.temporalSeriesCompletionParagraph":"Kasurik gehienetan, aztertu ditugun Europako eskualde guztietarako datuak ditugu eskura, alderatzeko moduko denbora segidekin. Beste batzuetan, gure datu plataformak balio galduak zenbatetsi ditu, segida ahalik eta osoenak eskaini ahal izateko. Zenbatespen metodoak adierazle bakoitzera egokitzen dira eta triangelukatzea, interpolazio linealak, ebazpen eta herentzia hierarkikoak edo azken behaketa errepikatzea izan daitezke.","PanelsDevelopmentMethodology.indicatorCalculation":"Datuak ustiatzea eta adierazleak kalkulatzea","PanelsDevelopmentMethodology.indicatorCalculationParagraph":"Erabilitako iturrietatik zuzenean jasotako datuak erabiltzeaz gainera, beste batzuetan kalkuluak egiten ditugu, haibat adierazle konbinatuz, monitorizatu nahi dugun errealitatea hobeto islatuko duen beste adierazle bat lortzeko.","AppTools.dimension_0_Title":"Ongizatearen emaitzak","AppTools.report_2_title":"Ongizatearen emaitzak","AppTools.dimension_1_Title":"Ekonomia eta enpresen emaitzak","AppTools.report_1_title":"Ekonomia eta enpresen emaitzak","AppTools.dimension_2_Title":"Palanka dinamikoak","AppTools.dimension_3_Title":"Egiturazko ingurunea","AppTools.report_0_title":"Egiturazko ingurunea","AppTools.dimension_0_Subtitle":"Azken batean, lurralde baten lehiakortasuna sor ditzakeen ongizate emaitzetan islatzen da. Adierazleak ongizatearen hainbat azpidimentsiotan antolatzen ditugu.","AppTools.dimension_1_Subtitle":"Errendimendu ekonomiko-enpresarialaren dimentsioek enpresa-jardueren eta lurralde osoaren sistema ekonomikoaren emaitzak islatzen dituzte.","AppTools.dimension_2_Subtitle":"Palanka dinamikoek ongizaterako lehiakortasun mailan eragiten dute. Ekintzarako tarte handiagoa duten elementuak dira eta horien konbinazioak lurraldearen emaitza ekonomiko enpresarialetan eta pertsonen egungo eta etorkizuneko ongizatean eragiten du.","AppTools.dimension_3_Subtitle":"Egiturazko testuinguruak lurraldearen beraren ezaugarriak biltzen ditu, denboran zehar nahiko egonkorrak direnak.","AppTools.subdimension_0_0_Title":"Gizarte bizitza","AppTools.report_2_2_title":"Gizarte bizitza","AppTools.subdimension_0_1_Title":"Enplegua","AppTools.report_2_3_title":"Enplegua","AppTools.subdimension_0_2_Title":"Ikaskuntza","AppTools.report_2_5_title":"Ikaskuntza","AppTools.subdimension_0_3_Title":"Osasuna","AppTools.report_2_6_title":"Osasuna","AppTools.subdimension_0_4_Title":"Ingurumena","AppTools.report_2_7_title":"Ingurumena","AppTools.subdimension_1_0_Title":"Ekonomiaren emaitzak","AppTools.subdimension_1_1_Title":"Enpresa errentagarritasuna","AppTools.report_1_2_title":"Enpresa errentagarritasuna","AppTools.subdimension_2_0_Title":"Kapital naturala","AppTools.report_3_1_title":"Kapital naturala","AppTools.subdimension_2_1_Title":"Kapital fisikoa","AppTools.report_3_2_title":"Kapital fisikoa","AppTools.subdimension_2_2_Title":"Jakintza","AppTools.report_3_4_title":"Jakintza","AppTools.subdimension_2_3_Title":"Giza kapitala","AppTools.report_3_5_title":"Giza kapitala","AppTools.subdimension_2_4_Title":"Gizarte eta erakunde kapitala","AppTools.subdimension_3_0_Title":"Geodemografia","AppTools.report_0_1_title":"Geodemografia","AppTools.dataSource":"<em>Iturria:</em> {dataSource}. Orkestrak egina.","AppTools.report_1_1_title":"Jarduera ekonomikoa","AppTools.report_1_3_title":"Berrikuntza eta ekintzailetza","AppTools.report_1_4_title":"Nazioartekotzea","AppTools.report_2_1_title":"Bizitzarekiko gogobetetasuna","AppTools.report_2_4_title":"Gizarte bizitza","AppTools.report_3_title":"Palankak","AppTools.report_3_3_title":"Finantzaketa","AppTools.report_3_6_title":"Gizarte kapitala","AppTools.report_0_2_title":"Ekonomia eta enpresen egitura"}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = {"Breadcrumbs.home":"Home","Breadcrumbs.layer1PageName":"Competitiveness indicators panel","Breadcrumbs.methodology":"Methodology","HTMLTitleController.methodology":"Methodology","PanelsDevelopmentMethodology.methodology":"Methodology","Error.error":"The data could not be recovered","Footer.competitivenessBasqueInstitute":"Basque Institute of Competitiveness","Footer.anInitiativeOf":"An initiative of","Footer.spriGroup":"This platform is funded by the <strong>SPRI Group</strong>, <br/> a Basque business development agency","Footer.privacy":"Privacy","Header.basqueCountry":"Basque <br/> Country","MenuOffCanvas.basqueCountry":"Basque <br/> Country","MenuOffCanvas.youAreAt":"You are in","RegionOverview.altVersionBtnEustat":"Switch to EUSTAT version","RegionOverview.altVersionBtnEurostat":"Switch to EUROSTAT version","RegionOverview.alertNewReportPanel":"Access the <a href=\"{reportPanelLink}\">diagnostic panel</a> of the Basque Country Competitiveness Report 2025 <a href=\"{reportPanelLink}\">here</a>","SubHeader.ReportTable_title":"Diagnostic Panel of the Basque Country Competitiveness Report","SubHeader.ReportTable_lastUpdated":"Updated on {lastUpdated}","SubHeader.ReportTable_p1":"With the aim of providing <strong>more detailed analysis</strong> for the <strong>Basque Country</strong>, this panel presents a series of indicators of economic-business performance, well-being and levers that are part of the <a href={methodologyLink}>Orkestra competitiveness framework</a>. This approach broadens the perspective of regional comparison by incorporating <strong>specific indicators</strong> available only for the Basque Country, as well as for the national and European Union levels.","SubHeader.ReportTable_p2":"You can move between the framework dimensions with the following mini map and return to the start from the header of each dimension. Clicking on any indicator will take you to a comparative evolution chart that includes, in addition to the Basque Country and the EU-27, the trend lines of Spain, Germany and comparable regions (Upper Austria and Baden-Württemberg), where available.","SubHeader.ReportTable_instructions_title":"How to read the panel","SubHeader.ReportTable_instructions_paragraph":"A more synthetic overview of the level and evolution of the indicators in comparison with the European Union is presented, using a colour code and easy-to-interpret symbols. The <span class=\"positive\">green colour</span> indicates a positive result, the <span class=\"negative\">red colour</span> indicates a negative result and the <span class=\"stable\">grey colour</span> represents a null or very small difference. <ul> <li>The first column shows the year-on-year evolution of the Basque Country; one symbol indicates that the difference is between 1% and 5%, while two symbols indicate that the difference exceeds 5%. </li> <li>The second column compares the value of the Basque Country with that of the EU-27, using one symbol for differences between 1% and 5%, and two symbols for differences greater than 5%. </li> <li>The third column contains the comparison of the year-on-year evolution of the indicator for the Basque Country compared to the evolution of the EU-27. In this case, one symbol indicates that the change in the Basque Country differs by between 0.5 and 3 percentage points in relation to the change in the EU-27, while two symbols indicate that the difference is greater than 3 percentage points.</li> <li>In all three cases, if the difference is less than the indicated values, it is indicated with an equal sign.</li> <li>Finally, hovering over or clicking on the symbols will display the underlying values ​​associated with each of them.</li></ul>","LinesChart.referenceRegions":"Comparable Reg.","LinesChart.femaleAcronym":"F","LinesChart.maleAcronym":"M","LinesChart.euAcronym":"EU27","EvolutionChart.noPositionChange":"It has not changed its position in <strong>{yearsEvolution, plural, one {# year} other {# years}}</strong>","EvolutionChart.upPositionChange":"It has risen <strong>{positions, plural, one {# position} other {# positions}}</strong> in <strong>{yearsEvolution, plural, one {# year} other {# years}}</strong>","EvolutionChart.downPositionChange":"It has fallen <strong>{positions, plural, one {# position} other {# positions}}</strong> in <strong>{yearsEvolution, plural, one {# year} other {# years}}</strong>","EvolutionChart.valueIn":"Value in {year}","MapChart.yearAndUnit":"Year {year} | Unit: {unit}","MapChart.female":"Female","ContentChartFooter.female":"Female","MapChart.male":"Male","ContentChartFooter.male":"Male","PanelRowCointaner.moreRecentDataAvail":"Region data availble until {mostRecentYear}","PanelRowCointaner.moreIndicatorDetail":"View detailed indicator data","RankingChart.rankingTooltip":"Rank {position} of {totalRegions}","RankingChart.noDataAvailable":"No data available","ReportTable.dataSource":"Source","ReportTable.dataNote":"Note","ReportTableRowValues.notAvailableShort":"n.a.","ContentChartFooter.showLegendTooltip":"Key","ContentChartFooter.showByGenderTooltip":"Breakdown by gender","ContentChartFooter.showTableTooltip":"Data as a table","ContentChartFooter.openModalTooltip":"Select the date range","ContentChartFooter.exportChartTooltip":"Export graphic","ContentChartFooter.expandChartTooltip":"Full screen","ContentChartFooter.indicatorDetail":"Indicator details","ContentChartFooter.downloadPNG":"Download in PNG","ContentChartFooter.downloadJPEG":"Download in JPEG","ContentChartFooter.downloadPDF":"Download in PDF","ContentChartFooter.downloadSVG":"Download in SVG","ContentChartFooter.downloadCSV":"Download in CSV","ContentChartTitle":"Evolution","PanelSection.columnEvolution":"Evolution","ReportTable.columnEvo":"Evolution","ContentChartTitle.map":"Map","ChartTypeFilter.map":"Map","ContentChartWrapper.businessBehavior":"Business behaviour","ContentLevelWrapper.businessBehavior":"Business behaviour","ContentChartWrapper.specialization":"Specialisation","ContentLevelWrapper.specialization":"Specialisation","ContentChartWrapper.businessEnvironment":"Business environment","ContentLevelWrapper.businessEnvironment":"Business environment","ContentDateModal.modalTitle":"Change date range","ContentDateModal.modalFrom":"Since","ContentDateModal.modalTo":"Until","ContentDateModal.modalYear":"Year","ReportTable.columnYear":"Year","ContentDateModal.modalClose":"Close","ContentDateModal.modalApply":"Apply","ContentHeader.layer1Title":"Competitiveness indicators panel <small>updated to {lastUpdated}</small>","ContentHeader.layer1Subtitle":"The panel is organized in <strong>four dimensions</strong> essential when it comes to identifying the keys to competitiveness at the service of inclusive and sustainable well-being. Use the <strong>mini map</strong> on the right to orient yourself.","ContentHeader.layer2Title":"<span class=\"ork-u-default-text-color\">{levelNumber}</span> {levelName} <small>updated to {lastUpdated}</small>","ContentHeader.layer2Subtitle":"The panel is organised into <strong>four levels</strong> that determine competitive performance. Learn more about the <a href={methodologyLink}> panel's development methodology</a>.","ContentHeader.layer3Title":"{indicatorName} <small>updated to {indicatorLastUpdated}</small>","ContentHeader.knowMoreAboutMethodology":"Learn more about <a href={methodologyLink}>the framework and methodology for creating the panel</a>.","ContentHeader.moreDataAvailableNote":"(*) If more recent data is available for the region, it is indicated with a <sup>*</sup> next to the year of comparison.","ContentHeader.relatedDocuments":"Related analyses","ContentLevelFooter.relatedDocuments":"Related analyses","RelatedDocumentsDraggable.relatedDocuments":"Related analyses","ContentHeader.unit":"Unit","ContentLevelFooter.levelDetail":"Access level {level} details","ContentLevelInfo.level1Info":"The <strong>top level</strong> (level 1) contains result indicators, which show the <strong>ultimate objectives</strong> to be achieved in terms of citizens' well-being.","ContentLevelInfo.level2Info":"The <strong>second level</strong> features <strong>intermediate performance indicators</strong>, which, although they are note the ultimate goals to be achieved in the region, they are important to achieve these final results.","ContentLevelInfo.level3Info":"The <strong>third level</strong> is made of the <strong>determinants of competitiveness</strong>, that is, the elements that affect the results of the two higher levels. This level is particularly relevant because it is one in which policies can have a clearer impact. Determinants are grouped into three categories that show company behaviour, that specialization of the territory and its clusters, and the quality of the business environment.","ContentLevelInfo.level4InfoParagraph1":"Finally, last but not least, the <a href={methodologyLink}>foundations</a> of the framework refer to certain characteristics of the territory that have an impact on competitiveness, but they come more or less given, and can not be easily modified in the short term (location of the territory, natural resources, size of the region, institutions ...).","ContentLevelInfo.level4InfoParagraph2":"These structural characteristics of the regions are what we use to benchmark each region in order to find the ones most similar to each other within the European Union: this is what we call the <strong>comparable regions</strong>. You can learn more about this methodology and access an interactive tool on the <a href=\"http://s3platform.jrc.ec.europa.eu/regional-benchmarking\">site of the project</a> developed by Orkestra with the support of the European Commission.","ContentLevelTitle.levelEvolution":"(position and evolution since {yearsEvolution, plural, one {# year} other {# years}})","PanelSection.columnRegion":"Region","PanelSection.columnCountry":"Country","PanelSection.columnEU":"EU27","PanelSection.columnRanking":"Ranking","PanelRowCointaner.rankingTooltip":"Position of the region compared to the rest of the EU27 regions with available data","PanelRowCointaner.dimensionLinkTooltip":"See dimension <strong>{dimensionTitle}</strong> with additional detail and comparisons","ReportTable.columnIndicator":"Indicator","ReportTable.columnValue":"Value","ReportTable.columnEvoLastYear":"last year","ReportTable.columnEU27Header":"Relative positioning with respect to EU27","ReportTable.columnLevel":"Level","ReportTable.columnChange":"Change","HTMLTitleController.regional":"Regional Competitiveness Observatory","HTMLTitleController.institute":"Orkestra Basque Institute of Competitiveness","LanguageController.espanol":"Spanish","LanguageControllerResponsive.espanol":"Spanish","LanguageController.euskera":"Basque","LanguageControllerResponsive.euskera":"Basque","LanguageController.english":"English","LanguageControllerResponsive.english":"English","RegionChangerController.placeholder0":"Select region","RegionChangerController.placeholder1":"Change region","SurveyController.surveyLink":"https://www.orkestra.deusto.es/en/?option=com_rsform&view=rsform&formId=14","SurveyController/logo":"/img/logo-observatorio-competitividad-en.svg","SurveyController.hello":"Hello,","SurveyController.thanks":"Thank you for using Orkestra’s Competitiveness Observatory.","SurveyController.helpUs":"Please help us to improve your experience by answering 4 questions in this brief survey.","SurveyController.thanksAgain":"Thank you again, The Orkestra team.","SurveyController.yes":"Yes, I would be pleased to","SurveyController.no":"No, thank you","ChartTypeFilter.absoluteValuesEvolution":"Evolution of absolute values","EvolutionFilter.option":"{years, plural, one {# year} other {# years}}","FilterContainer.showAllRegions":"Compare with EU27","FilterContainer.showReferenceRegions":"Comparable regions","FilterModal.showReferenceRegions":"Comparable regions","FilterContainer.showSameCountryRegions":"Compare with country","FilterContainer.compareWith":"Compare with...","FilterContainer.evolutionSince":"Evolution since...","FilterContainer.chartType":"Type of graphic","FilterContainer.visualizationOptions":"Display options","FilterContainer":"Show region list","FilterModal.showAllRegions":"Set of European regions (EU27-2020)","FilterModal.allRegionsModalBodyIntro":"The situation of <strong>{regionName}</strong> is compared to that of the <strong>{regionNumber} regions</strong> of the European Union (EU27).","FilterModal.referenceRegionsModalBodyIntro":"<strong>{regionName}</strong> is compared to a group of <strong>{regionNumber} regions</strong> with similar characteristics. These have been chosen because they are the ones that are most similar to <strong>{regionName}</strong> in terms of structural starting conditions (sociodemographic conditions, economic and technological specialization and business structure).","FilterModal.accept":"Accept","TypeAheadFilter.placeholder":"Region or country","TypeAheadFilter.placeholder2":"Add regions and / or countries","HomeContent.title":"Orkestra European Regional Diagnostic Tool","HomeContent.updated":"updated to {lastUpdated}","HomeContent.welcome":"Welcome to the Orkestra <strong>regional diagnosis</strong> tool. Here you can <strong>compare</strong> the situation and evolution regarding key <strong>indicators</strong> using the most recent data available on a European <strong>regional</strong> level.","HomeContent.secondParagraph":"The aim of this tool is to foster improvement in the study of regional competitiveness by offering a starting point for different regional analyses that are conducted both within and outside the Institute.","HomeContent.videoButton":"Watch video","HomeContent.benchmarking":"Benchmarking","HomeContent.benchmarkingParagraph":"It's important not to mix things up when making comparisons, and that's why Orkestra has developed a <a href=\"{benchmarkingLink}\">benchmarking methodology</a> that identifies the regions with <b>similar structures</b> for each European region. Their \"equivalents\" may thus be compared.","HomeContent.lastData":"Most recent data","HomeContent.lastDataParagraph":"The observatory is always kept <b>up-to-date</b> with the latest available data for the European regions as a whole. To this end, we use an innovative data platform that enables us to automate the data collection and processing process.","HomeContent.competitivenessFrame":"Competitiveness framework","HomeContent.competitivenessFrameParagraph":"We at Orkestra understand competitiveness to be a <strong>means for ensuring society's wellbeing</strong>, and this is reflected in the <a href=\"{methodologyLink}\">analytical framework</a> developed by the Institute. This framework defines different levels of indicator according to their role: result, intermediate performance, determining factors and basic principles.","HomeContent.reportPanelTitle":"Diagnostic Panel of the Basque Country Competitiveness Report","HomeContent.reportPanelParagraph":"Accompanying the analysis included in the <a href=\"https://www.orkestra.deusto.es/en/publications-search/basque-country-competitiveness-report\">Basque Country Competitiveness Report</a>, this <a href=\"{reportPanelLink}\">panel</a> includes the level and evolution of indicators inscribed in the <a href=\"{methodologyLink}\">Orkestra's competitiveness framework</a>, as well as their comparison with the EU-27.","PanelsDevelopmentMethodology.imgLink":"/img/EN-Marco-completo-sincabecera.png","PanelsDevelopmentMethodology.framework":"Orkestra’s competitiveness framework","PanelsDevelopmentMethodology.introductionParagraph1":"At Orkestra we use a framework to analyze territorial competitiveness that proposes a series of essential elements when identifying the keys to competitiveness at the service of inclusive and sustainable well-being.","PanelsDevelopmentMethodology.introductionParagraph2":"This framework, which we present in the <a href=\"https://www.orkestra.deusto.es/en/research/basque-country-competitiveness-report-2021\" class=\"font-weight-bold \" target=\"_blank\">Basque Country Competitiveness Report 2021</a>, also helps us launch strategies and initiatives to promote competitiveness at the service of people's well-being.","PanelsDevelopmentMethodology.level1Paragraph":"In the center of the framework <span class=\"obs-dimension-0 font-weight-bold\">(in blue)</span> we find the <a class=\"font-weight-bold\" href=\"{dimensionLink0}\" >economic-business result dimensions</a>, which typically form part of the analysis of territorial competitiveness, and the <a href=\"{dimensionLink0}\" class=\"font-weight-bold\">well-being dimensions</a >, to whose needs territorial competitiveness should ultimately respond.","PanelsDevelopmentMethodology.level2Paragraph":"On the left <span class=\"obs-dimension-3 font-weight-bold\">(in orange)</span> is the <a class=\"font-weight-bold\" href=\"{dimensionLink02}\" >structural context</a> of the territory, which includes characteristics that, to a great extent, are given and that are neither good nor bad per se. These elements change slowly over time, but it is possible to cause changes in some of them in the medium-long term through policies or strategies focused on the dynamic levers.","PanelsDevelopmentMethodology.level3Paragraph":"To the right <span class=\"obs-dimension-2 font-weight-bold\">(in green)</span> are the <a class=\"font-weight-bold\" href=\"{dimensionLink3}\">dynamic levers</a> of competitiveness, which include all the factors that affect in some way the competitiveness and well-being of the territory and on which the policies and strategies (of the actors, governments and the territory itself) can influence to mark the direction in which progress must be made, as well as promote changes in the medium-long term in certain elements of the structural context.","PanelsDevelopmentMethodology.level4Paragraph":"Two transversal dimensions complete the framework: <strong>inclusivity</strong>, which manifests itself in different ways that may be more or less relevant depending on the dimension analyzed (inequalities in wealth, gender, race, age, sexual orientation, disability, etc.), and the <strong>international connection</strong>, which is linked both to the economic-business results and to the analysis of the dimensions of well-being and the levers.","PanelsDevelopmentMethodology.dimensionColophonParagraph1":"Based on this framework, a battery of relevant indicators is selected within each dimension, which is continually compared and updated in the different projects and reports carried out by Orkestra.","PanelsDevelopmentMethodology.geographicalScope":"Geographical scope","PanelsDevelopmentMethodology.geographicalScopeParagraph1":"Orkestra’s Competitiveness Observatory covers regional data at European level. The regional subdivision used is based on the NUTS levels (<a href=\"https://ec.europa.eu/eurostat/web/nuts/background\">Nomenclature des Units Territoriales Statistiques</a>) defined by the European Union.","PanelsDevelopmentMethodology.geographicalScopeParagraph2":"Since the geographical scope of the NUTS subdivisions varies from member state to member state, in our analysis we use a combination of NUTS2 and NUTS1 levels, using a different degree of detail depending on the country so that the regions are the most comparable among them.","PanelsDevelopmentMethodology.temporalScope":"Temporal scope","PanelsDevelopmentMethodology.temporalScopeParagraph":"This panel is based on Orkestra’s own data platform that maintains the indicators up to date based on their availability. When the treatment required by the data can  be automatised there’s no need for manual intervention and update is automatic. In other cases, data must be treated statistically at Orkestra, and update may take a little more time. In any case, if there is something that catches your attention, do not hesitate to <a href=\"mailto:behatoki@orkerstra.deusto.es\">contact us</a >.","PanelsDevelopmentMethodology.dataSources":"Datasources","PanelsDevelopmentMethodology.dataSourcesParagraph":"The primary data sources utilised in this panel are:","PanelsDevelopmentMethodology.dataSourcesItem1":"<a href=\"https://ec.europa.eu/eurostat\" target=\"_blank\">Eurostat</a>the statistical office of the European Union.","PanelsDevelopmentMethodology.dataSourcesItem2":"<a href=\"https://www.oecd.org/\" target=\"_blank\">OECD</a>’s <a href=\"https://www.oecd-ilibrary.org/science-and-technology/the-oecd-regpat-database_241437144144\" target=\"_blank\">REGPAT</a> database [statistically exploited at Orkestra].","PanelsDevelopmentMethodology.dataSourcesItem3":"The <a href=\"https://www.europeansocialsurvey.org/\" target=\"_blank\">European Social Survey</a> [statistically exploited at Orkestra].","PanelsDevelopmentMethodology.dataSourcesItem4":"<a href=\"https://www.eustat.eus\" target=\"_blank\">EUSTAT</a> for the Basque Country data when methodology is compatible with Eurostat","PanelsDevelopmentMethodology.temporalSeriesCompletion":"Temporal series completion","PanelsDevelopmentMethodology.temporalSeriesCompletionParagraph":"In most of the cases there’s complete data for the european regions and temporal span analysed. Sometimes our data platform is used to estimate missing data so we can work with and offer the most complete series. Different estimation methods are employed for each indicator according to their nature and level of incompletion; these methods include triangulation, linear interpolations, hierarchical resolution and inheritance o last observation carried forward.","PanelsDevelopmentMethodology.indicatorCalculation":"Indicator calculation and exploitation","PanelsDevelopmentMethodology.indicatorCalculationParagraph":"In addition to using direct data directly from the sources, in some occasions we perform calculations combining different indicators to obtain a new one that better reflects the reality we are trying to monitor.","AppTools.dimension_0_Title":"Wellbeing results","AppTools.report_2_title":"Wellbeing results","AppTools.dimension_1_Title":"Economic-business results","AppTools.report_1_title":"Economic-business results","AppTools.dimension_2_Title":"Dynamic levers","AppTools.dimension_3_Title":"Structural Context","AppTools.report_0_title":"Structural Context","AppTools.dimension_0_Subtitle":"Ultimately, the competitiveness of a territory is reflected in the welfare results that it is capable of generating. We organize the indicators into various well-being subdimensions.","AppTools.dimension_1_Subtitle":"The dimensions of economic-business performance reflect the results of business activities and of the economic system of a territory as a whole.","AppTools.dimension_2_Subtitle":"The dynamic levers affect the level of competitiveness for well-being. They are elements on which there is more room for action and whose combination affects the business economic results of the territory and the present and future well-being of people.","AppTools.dimension_3_Subtitle":"The structural context includes the characteristics of the territory itself, which are relatively stable over time.","AppTools.subdimension_0_0_Title":"Material life","AppTools.report_2_2_title":"Material life","AppTools.subdimension_0_1_Title":"Employment","AppTools.report_2_3_title":"Employment","AppTools.subdimension_0_2_Title":"Learning","AppTools.report_2_5_title":"Learning","AppTools.subdimension_0_3_Title":"Health","AppTools.report_2_6_title":"Health","AppTools.subdimension_0_4_Title":"Environment","AppTools.report_2_7_title":"Environment","AppTools.subdimension_1_0_Title":"Economic performance","AppTools.subdimension_1_1_Title":"Business profitability","AppTools.report_1_2_title":"Business profitability","AppTools.subdimension_2_0_Title":"Natural capital","AppTools.report_3_1_title":"Natural capital","AppTools.subdimension_2_1_Title":"Physical capital","AppTools.report_3_2_title":"Physical capital","AppTools.subdimension_2_2_Title":"Knowledge","AppTools.report_3_4_title":"Knowledge","AppTools.subdimension_2_3_Title":"Human capital","AppTools.report_3_5_title":"Human capital","AppTools.subdimension_2_4_Title":"Social and institutional capital","AppTools.subdimension_3_0_Title":"Geodemograpfy","AppTools.report_0_1_title":"Geodemograpfy","AppTools.dataSource":"<em>Source:</em> {dataSource}. Prepared by Orkestra.","AppTools.report_1_1_title":"Economic performance","AppTools.report_1_3_title":"Innovation and entrepreneurship","AppTools.report_1_4_title":"Internationalisation","AppTools.report_2_1_title":"Life satisfaction","AppTools.report_2_4_title":"Social life","AppTools.report_3_title":"Levers","AppTools.report_3_3_title":"Financing","AppTools.report_3_6_title":"Social capital","AppTools.report_0_2_title":"Economic-business estructure"}

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_Home__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_CompetitivenessGeneralDashboard__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_IndicatorsPerformance__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_IndicatorDetail__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_IndicatorEvolutionPage__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_IndicatorEvolutionEmbedPage__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_PanelsDevelopmentMethodology__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_ReportTablePage__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_config__ = __webpack_require__(46);
var App=function App(){var defaultLanguage=__WEBPACK_IMPORTED_MODULE_2_utils_app_appTools__["a" /* default */].getDefaultLanguage();var BASE_PATH=__WEBPACK_IMPORTED_MODULE_11_utils_config__["a" /* default */].getConfig().site.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{from:BASE_PATH,exact:true,to:BASE_PATH+'/'+defaultLanguage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/panels-development-methodology',exact:true,component:__WEBPACK_IMPORTED_MODULE_9_pages_PanelsDevelopmentMethodology__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{from:BASE_PATH+'/:lang/:regionCode',exact:true,to:BASE_PATH+'/:lang/:regionCode/dashboard'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/',exact:true,component:__WEBPACK_IMPORTED_MODULE_3_pages_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/:regionCode/dashboard',exact:true,component:__WEBPACK_IMPORTED_MODULE_4_pages_CompetitivenessGeneralDashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/:regionCode/report-table',exact:true,component:__WEBPACK_IMPORTED_MODULE_10_pages_ReportTablePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/:regionCode/group-detail/:level',exact:true,component:__WEBPACK_IMPORTED_MODULE_5_pages_IndicatorsPerformance__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/:regionCode/indicator-detail/:indicatorId',exact:true,component:__WEBPACK_IMPORTED_MODULE_6_pages_IndicatorDetail__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/:regionCode/indicator-evo/:indicatorId',exact:true,component:__WEBPACK_IMPORTED_MODULE_7_pages_IndicatorEvolutionPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:BASE_PATH+'/:lang/:regionCode/indicator-evo/:indicatorId/embed',exact:true,component:__WEBPACK_IMPORTED_MODULE_8_pages_IndicatorEvolutionEmbedPage__["a" /* default */]}));};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({dimension_0_Title:{id:'AppTools.dimension_0_Title',description:'Texto para el título del nivel',defaultMessage:'Resultados de bienestar'},dimension_1_Title:{id:'AppTools.dimension_1_Title',description:'Texto para el título del nivel',defaultMessage:'Resultados económico-empresariales'},dimension_2_Title:{id:'AppTools.dimension_2_Title',description:'Texto para el título del nivel',defaultMessage:'Palancas dinámicas'},dimension_3_Title:{id:'AppTools.dimension_3_Title',description:'Texto para el título del nivel',defaultMessage:'Contexto estructural'},dimension_0_Subtitle:{id:'AppTools.dimension_0_Subtitle',description:'Texto para el subtitulo del nivel',defaultMessage:'En última instancia, la competittividad de un territorio se refleja en los resultados de bienestar que es capaza de generar. Organizamos los indicadores en varias subdimensiones de bienestar.'},dimension_1_Subtitle:{id:'AppTools.dimension_1_Subtitle',description:'Texto para el subtitulo del nivel',defaultMessage:'Las dimensiones del desempeño económico-empresarial reflejan los resultados de las actividades empresariales y del conjunto del sistema económico de un territorio.'},dimension_2_Subtitle:{id:'AppTools.dimension_2_Subtitle',description:'Texto para el subtitulo del nivel',defaultMessage:'Las palancas dinámicas inciden en el nivel de competitividad para el bienestar. Son elementos sobre los que hay más margen de actuación y cuya combinación afecta a los resultados económicos empresariales del territorio y al bienestar presente y futuro de las personas.'},dimension_3_Subtitle:{id:'AppTools.dimension_3_Subtitle',description:'Texto para el subtitulo del nivel',defaultMessage:'El contexto estructural incluye las características del propio territorio, que son relativamente estables en el tiempo.'},subdimension_0_0_Title:{id:'AppTools.subdimension_0_0_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Vida material'},subdimension_0_1_Title:{id:'AppTools.subdimension_0_1_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Empleo'},subdimension_0_2_Title:{id:'AppTools.subdimension_0_2_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Aprendizaje'},subdimension_0_3_Title:{id:'AppTools.subdimension_0_3_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Salud'},subdimension_0_4_Title:{id:'AppTools.subdimension_0_4_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Medioambiente'},subdimension_1_0_Title:{id:'AppTools.subdimension_1_0_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Resultados económicos'},subdimension_1_1_Title:{id:'AppTools.subdimension_1_1_Title',description:'Texto para el título del subdimensión 0.0',defaultMessage:'Rentabilidad empresarial'},subdimension_2_0_Title:{id:'AppTools.subdimension_2_0_Title',description:'Texto para el título del subdimensión 2.0',defaultMessage:'Capital natural'},subdimension_2_1_Title:{id:'AppTools.subdimension_2_1_Title',description:'Texto para el título del subdimensión 2.0',defaultMessage:'Capital físico'},subdimension_2_2_Title:{id:'AppTools.subdimension_2_2_Title',description:'Texto para el título del subdimensión 2.0',defaultMessage:'Conocimiento'},subdimension_2_3_Title:{id:'AppTools.subdimension_2_3_Title',description:'Texto para el título del subdimensión 2.0',defaultMessage:'Capital humano'},subdimension_2_4_Title:{id:'AppTools.subdimension_2_4_Title',description:'Texto para el título del subdimensión 2.0',defaultMessage:'Capital social e institucional'},subdimension_3_0_Title:{id:'AppTools.subdimension_3_0_Title',description:'Texto para el título del subdimensión 3.0',defaultMessage:'Geodemografía'},dataSource:{id:'AppTools.dataSource',description:'Texto para la fuente de los datos',defaultMessage:'<em>Fuente:</em> {dataSource}. Elaboración Orkestra.'},report_1_title:{id:'AppTools.report_1_title',description:'n/a',defaultMessage:'Resultados económico-empresariales'},report_1_1_title:{id:'AppTools.report_1_1_title',description:'n/a',defaultMessage:'Desempeño económico'},report_1_2_title:{id:'AppTools.report_1_2_title',description:'n/a',defaultMessage:'Rentabilidad empresarial'},report_1_3_title:{id:'AppTools.report_1_3_title',description:'n/a',defaultMessage:'Innovación y empredimiento'},report_1_4_title:{id:'AppTools.report_1_4_title',description:'n/a',defaultMessage:'Internacionalización'},report_2_title:{id:'AppTools.report_2_title',description:'n/a',defaultMessage:'Resultados de bienestar'},report_2_1_title:{id:'AppTools.report_2_1_title',description:'n/a',defaultMessage:'Satisfacción con la vida'},report_2_2_title:{id:'AppTools.report_2_2_title',description:'n/a',defaultMessage:'Vida material'},report_2_3_title:{id:'AppTools.report_2_3_title',description:'n/a',defaultMessage:'Empleo'},report_2_4_title:{id:'AppTools.report_2_4_title',description:'n/a',defaultMessage:'Vida social'},report_2_5_title:{id:'AppTools.report_2_5_title',description:'n/a',defaultMessage:'Aprendizaje'},report_2_6_title:{id:'AppTools.report_2_6_title',description:'n/a',defaultMessage:'Salud'},report_2_7_title:{id:'AppTools.report_2_7_title',description:'n/a',defaultMessage:'Medioambiente'},report_3_title:{id:'AppTools.report_3_title',description:'n/a',defaultMessage:'Palancas'},report_3_1_title:{id:'AppTools.report_3_1_title',description:'n/a',defaultMessage:'Capital natural'},report_3_2_title:{id:'AppTools.report_3_2_title',description:'n/a',defaultMessage:'Capital físico'},report_3_3_title:{id:'AppTools.report_3_3_title',description:'n/a',defaultMessage:'Financiación'},report_3_4_title:{id:'AppTools.report_3_4_title',description:'n/a',defaultMessage:'Conocimiento'},report_3_5_title:{id:'AppTools.report_3_5_title',description:'n/a',defaultMessage:'Capital humano'},report_3_6_title:{id:'AppTools.report_3_6_title',description:'n/a',defaultMessage:'Capital social'},report_0_title:{id:'AppTools.report_0_title',description:'n/a',defaultMessage:'Contexto estructural'},report_0_1_title:{id:'AppTools.report_0_1_title',description:'n/a',defaultMessage:'Geodemografía'},report_0_2_title:{id:'AppTools.report_0_2_title',description:'n/a',defaultMessage:'Estructura económico empresarial'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home__ = __webpack_require__(714);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Home__["a" /* default */]);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_HomeContent__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_HomeContent__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_tag_manager__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_tag_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_tag_manager__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleTagManager=function(_Component){_inherits(GoogleTagManager,_Component);function GoogleTagManager(){_classCallCheck(this,GoogleTagManager);return _possibleConstructorReturn(this,(GoogleTagManager.__proto__||Object.getPrototypeOf(GoogleTagManager)).apply(this,arguments));}_createClass(GoogleTagManager,[{key:'componentDidMount',value:function componentDidMount(){var dataLayerName=this.props.dataLayerName||'dataLayer';var scriptId=this.props.scriptId||'react-google-tag-manager-gtm';if(!window[dataLayerName]){var script=document.createElement('script');var gtmScriptNode=document.getElementById(scriptId);var scriptText=document.createTextNode(gtmScriptNode.textContent);script.appendChild(scriptText);document.head.appendChild(script);}}},{key:'render',value:function render(){var gtm=__WEBPACK_IMPORTED_MODULE_1_react_google_tag_manager___default()({id:this.props.gtmId,dataLayerName:this.props.dataLayerName||'dataLayer',additionalEvents:this.props.additionalEvents||{},previewVariables:this.props.previewVariables||false});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,gtm.noScriptAsReact()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:this.props.scriptId||'react-google-tag-manager-gtm'},gtm.scriptAsReact()));}}]);return GoogleTagManager;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GoogleTagManager);

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _build_parts = __webpack_require__(717);

var _build_parts2 = _interopRequireDefault(_build_parts);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GTMParts(args) {
    var parts = (0, _build_parts2.default)(args);

    function noScriptAsReact() {
        return _react2.default.createElement('noscript', { dangerouslySetInnerHTML: { __html: parts.iframe } });
    }

    function noScriptAsHTML() {
        return '<noscript>' + parts.iframe + '</noscript>';
    }

    function scriptAsReact() {
        return _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: parts.script } });
    }

    function scriptAsHTML() {
        return '<script>' + parts.script + '</script>';
    }

    return {
        noScriptAsReact: noScriptAsReact,
        noScriptAsHTML: noScriptAsHTML,
        scriptAsReact: scriptAsReact,
        scriptAsHTML: scriptAsHTML
    };
}

exports.default = GTMParts;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function convertToKeyValueString(obj) {
    return JSON.stringify(obj).slice(1, -1);
}

function buildParts(_ref) {
    var id = _ref.id,
        _ref$dataLayerName = _ref.dataLayerName,
        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
        _ref$additionalEvents = _ref.additionalEvents,
        additionalEvents = _ref$additionalEvents === undefined ? {} : _ref$additionalEvents,
        _ref$scheme = _ref.scheme,
        scheme = _ref$scheme === undefined ? '' : _ref$scheme,
        previewVariables = _ref.previewVariables;

    if (id === undefined) {
        throw new Error('No GTM id provided');
    }

    var iframe = '\n        <iframe src="' + scheme + '//www.googletagmanager.com/ns.html?id=' + id + '"\n            height="0" width="0" style="display:none;visibility:hidden"></iframe>';

    var script = '\n        (function(w,d,s,l,i){w[l]=w[l]||[];\n            w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + convertToKeyValueString(additionalEvents) + '});\n            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n            j.async=true;j.src=\'' + scheme + '//www.googletagmanager.com/gtm.js?id=\'+i+dl\n            ' + (previewVariables ? '+"' + previewVariables + '"' : '') + ';\n            f.parentNode.insertBefore(j,f);\n        })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';

    return {
        iframe: iframe,
        script: script
    };
}

exports.default = buildParts;

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Controllers_Language_LanguageControllerContainer__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Breadcrumbs__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_urls__ = __webpack_require__(21);
var _this=this;var closeMenuOffCanvas=function closeMenuOffCanvas(event){document.getElementsByTagName('html')[0].classList.remove('ork-menu-off-canvas-open');// event.preventDefault()
};var MenuOffCanvas=function MenuOffCanvas(props){var formatMessage=props.intl.formatMessage;var url=props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getLayerFromURL(url);var language=props.match.params.lang;_this.formatMessage=formatMessage;var BASE_URL= true?"/competitiveness-observatory":'';var classHome=void 0;var imgSrc=void 0;if(layer===0){classHome='ork-menu-off-canvas__header--home';imgSrc=BASE_URL+'/img/logo-observatorio-competitividad-dos-lineas-'+language+'.svg';}else{classHome='';imgSrc=BASE_URL+'/img/logo-observatorio-competitividad-'+language+'.svg';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-menu-off-canvas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-menu-off-canvas__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-menu-off-canvas__header '+classHome},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-menu-off-canvas__header__logo-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imgSrc,alt:'Observatorio de competitividad',className:'ork-menu-off-canvas__header__logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-menu-off-canvas__header__region-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-menu-off-canvas__header__region',dangerouslySetInnerHTML:{__html:_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].basqueCountry)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'js-hide-menu ork-menu-off-canvas__header__close',onClick:closeMenuOffCanvas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-times fa-2x'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' ork-menu-off-canvas__block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-uppercase'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].youAreAt),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Breadcrumbs__["a" /* default */],{responsive:true,closeMenuOffCanvas:closeMenuOffCanvas})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Controllers_Language_LanguageControllerContainer__["a" /* default */],{responsive:true,closeMenuOffCanvas:closeMenuOffCanvas}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ork-menu-off-canvas__social-media ork-menu-off-canvas__block clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-facebook.svg',alt:'Facebook'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-twitter.svg',alt:'Twitter'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-linkedin.svg',alt:'LinkedIn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-youtube.svg',alt:'Youtube'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-slideshare.svg',alt:'SlideShare'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-menu-off-canvas__logo-orkestra ork-menu-off-canvas__block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/logo-orkestra.svg',alt:'Orkestra: Instituto Vasco de Competitividad (Fundaci\xF3n Deusto)'}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(MenuOffCanvas));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({basqueCountry:{id:'MenuOffCanvas.basqueCountry',description:'[Mantener HTML] Texto para la cabecera de País Vasco',defaultMessage:'País <br/> Vasco'},youAreAt:{id:'MenuOffCanvas.youAreAt',description:'Texto para el MenuOffCanvas para indicar donde se encuentra el usuario',defaultMessage:'Estás en'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Controllers_Language_LanguageControllerResponsive__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Controllers_Language_LanguageController__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_app_urls__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LanguageControllerContainer=function(_Component){_inherits(LanguageControllerContainer,_Component);function LanguageControllerContainer(props){_classCallCheck(this,LanguageControllerContainer);var _this=_possibleConstructorReturn(this,(LanguageControllerContainer.__proto__||Object.getPrototypeOf(LanguageControllerContainer)).call(this,props));_this.setLanguage=function(lang){_this.props.setLanguage(lang);localStorage.setItem('defaultLanguage',lang);var oldURL=_this.props.history.location.pathname;var newURL=__WEBPACK_IMPORTED_MODULE_3_utils_app_urls__["a" /* default */].getSameURLWithChangedLanguage({url:oldURL,language:lang});if(oldURL!==newURL){_this.props.history.push(newURL);}};_this.state={};return _this;}_createClass(LanguageControllerContainer,[{key:'componentDidMount',value:function componentDidMount(){this.setLanguage(this.props.match.params.lang);}},{key:'renderDecider',value:function renderDecider(){if(this.props.responsive){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Controllers_Language_LanguageControllerResponsive__["a" /* default */],{fn:this.setLanguage,selectedLanguage:this.props.match.params.lang,closeMenuOffCanvas:this.props.closeMenuOffCanvas});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Controllers_Language_LanguageController__["a" /* default */],{fn:this.setLanguage,selectedLanguage:this.props.match.params.lang});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderDecider());}}]);return LanguageControllerContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LanguageControllerContainer);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LanguageControllerResponsive__ = __webpack_require__(722);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LanguageControllerResponsive__["a" /* default */]);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(723);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LanguageControllerResponsive=function(_Component){_inherits(LanguageControllerResponsive,_Component);function LanguageControllerResponsive(props){_classCallCheck(this,LanguageControllerResponsive);var _this=_possibleConstructorReturn(this,(LanguageControllerResponsive.__proto__||Object.getPrototypeOf(LanguageControllerResponsive)).call(this,props));_this.setLanguage=function(event){_this.props.fn(event.target.getAttribute('value'));_this.closeMenuOffCanvas();};_this.getLanguageFullName=function(lang){switch(lang){case'es':return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].espanol);case'eu':return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].euskera);case'en':return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].english);default:}};_this.showLanguages=function(){var buffer=[];var availableLanguages=['es','eu','en'];var selectedLanguage=_this.props.selectedLanguage;availableLanguages.forEach(function(lang){if(lang!==selectedLanguage){buffer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{value:lang,onClick:_this.setLanguage},_this.getLanguageFullName(lang))));}});return buffer;};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.closeMenuOffCanvas=props.closeMenuOffCanvas;_this.select=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(LanguageControllerResponsive,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ork-menu-off-canvas__languages ork-menu-off-canvas__block'},this.showLanguages());}}]);return LanguageControllerResponsive;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LanguageControllerResponsive));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({espanol:{id:'LanguageControllerResponsive.espanol',description:'Español',defaultMessage:'Español'},euskera:{id:'LanguageControllerResponsive.euskera',description:'Euskera',defaultMessage:'Euskera'},english:{id:'LanguageControllerResponsive.english',description:'English',defaultMessage:'English'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LanguageController__ = __webpack_require__(725);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LanguageController__["a" /* default */]);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(863);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LanguageController=function(_Component){_inherits(LanguageController,_Component);function LanguageController(props){_classCallCheck(this,LanguageController);var _this=_possibleConstructorReturn(this,(LanguageController.__proto__||Object.getPrototypeOf(LanguageController)).call(this,props));_this.setLanguage=function(eventKey){_this.props.fn(eventKey);};_this.getLanguageFullName=function(lang){switch(lang){case'es':return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].espanol);case'eu':return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].euskera);case'en':return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].english);default:}};_this.showLanguages=function(){var buffer=[];var availableLanguages=['es','eu','en'];var selectedLanguage=_this.props.selectedLanguage;availableLanguages.forEach(function(lang){if(lang!==selectedLanguage){buffer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* MenuItem */],{key:lang,eventKey:lang,onSelect:_this.setLanguage},_this.getLanguageFullName(lang)));}});return buffer;};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.select=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(LanguageController,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* DropdownButton */],{bsStyle:'primary',title:this.getLanguageFullName(this.props.selectedLanguage),id:'languages','data-toggle':'dropdown',noCaret:true,ref:this.dropdown,value:this.props.selectedLanguage},this.showLanguages());}}]);return LanguageController;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(LanguageController));

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelGroup__ = __webpack_require__(323);





var Accordion =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PanelGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, this.props, {
      accordion: true
    }), this.props.children);
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(67);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(729) });


/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(109);
var gOPS = __webpack_require__(216);
var pIE = __webpack_require__(125);
var toObject = __webpack_require__(154);
var IObject = __webpack_require__(320);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(108)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(91);
var toLength = __webpack_require__(321);
var toAbsoluteIndex = __webpack_require__(731);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(212);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(322);

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(67);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(217) });


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(89);
var anObject = __webpack_require__(105);
var getKeys = __webpack_require__(109);

module.exports = __webpack_require__(107) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(73).document;
module.exports = document && document.documentElement;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(737);

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324);
module.exports = __webpack_require__(36).Object.getOwnPropertySymbols;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(153)('meta');
var isObject = __webpack_require__(106);
var has = __webpack_require__(90);
var setDesc = __webpack_require__(89).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(108)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(109);
var gOPS = __webpack_require__(216);
var pIE = __webpack_require__(125);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(210);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(91);
var gOPN = __webpack_require__(326).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(743);

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(744);
module.exports = __webpack_require__(36).Object.keys;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(154);
var $keys = __webpack_require__(109);

__webpack_require__(745)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(67);
var core = __webpack_require__(36);
var fails = __webpack_require__(108);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.isReactComponent = isReactComponent;

var _invariant = _interopRequireDefault(__webpack_require__(32));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(748);
module.exports = __webpack_require__(36).Object.entries;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(67);
var $entries = __webpack_require__(329)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CloseButton__ = __webpack_require__(221);










var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Alert, _React$Component);

  function Alert() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["onDismiss", "closeLabel", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "alert",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), dismissable && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CloseButton__["a" /* default */], {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('alert', Alert)));

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(751);
module.exports = __webpack_require__(36).Object.values;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(67);
var $values = __webpack_require__(329)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);






 // TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  pullRight: false
};

var Badge =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Badge, _React$Component);

  function Badge() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Badge.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["pullRight", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('badge', Badge));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);








var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Breadcrumb, _React$Component);

  function Breadcrumb() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ol", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "navigation",
      "aria-label": "breadcrumbs",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(755);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var ButtonToolbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonToolbar.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "toolbar",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselItem__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Glyphicon__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(37);












 // TODO: `slide` should be `animate`.
// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-left"
  }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-right"
  }),
  nextLabel: 'Next'
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleMouseOver = _this.handleMouseOver.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handlePrev = _this.handlePrev.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleNext = _this.handleNext.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    var defaultActiveIndex = props.defaultActiveIndex;
    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);
      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  _proto.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  _proto.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  _proto.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  _proto.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }

      index = 0;
    }

    this.select(index, e, 'next');
  };

  _proto.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }

      index = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  }; // This might be a public API.


  _proto.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  }; // This might be a public API.


  _proto.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  _proto.select = function select(index, e, direction) {
    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.

    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);
    var onSelect = this.props.onSelect;

    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = {
            direction: direction
          };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  _proto.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;

    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  _proto.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(children);
    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "prev",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'left'),
      onClick: this.handlePrev
    }, prevIcon, prevLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "next",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'right'),
      onClick: this.handleNext
    }, nextIcon, nextLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];
    __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ol", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators')
    }, indicators);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut
    }), indicators && this.renderIndicators(children, activeIndex, bsProps), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
      var active = index === activeIndex;
      var previousActive = slide && index === previousActiveIndex;
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        active: active,
        index: index,
        animateOut: previousActive,
        animateIn: active && previousActiveIndex != null && slide,
        direction: direction,
        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
      });
    })), controls && this.renderControls({
      wrap: wrap,
      children: children,
      activeIndex: activeIndex,
      prevIcon: prevIcon,
      prevLabel: prevLabel,
      nextIcon: nextIcon,
      nextLabel: nextLabel,
      bsProps: bsProps
    }));
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
Carousel.Caption = __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_8__CarouselItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(CarouselCaption, _React$Component);

  function CarouselCaption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CarouselCaption.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properties = exports.end = undefined;

var _end = __webpack_require__(760);

var _end2 = _interopRequireDefault(_end);

var _properties = __webpack_require__(223);

var _properties2 = _interopRequireDefault(_properties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.end = _end2.default;
exports.properties = _properties2.default;
exports.default = { end: _end2.default, properties: _properties2.default };

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _properties = __webpack_require__(223);

var _properties2 = _interopRequireDefault(_properties);

var _style = __webpack_require__(127);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;

  if (!_properties2.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties2.default.end) {
    node.addEventListener(_properties2.default.end, done, false);

    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties2.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;

exports.default = onEnd;


function parseDuration(node) {
  var str = (0, _style2.default)(node, _properties2.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;

  return parseFloat(str) * mult;
}
module.exports = exports['default'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(763);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(333);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "checkbox",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(33);










var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div'
};

var Clearfix =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Clearfix, _React$Component);

  function Clearfix() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Clearfix.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = "visible" + Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size) + "Block";

      if (elementProps[propName]) {
        classes["visible-" + size + "-block"] = true;
      }

      delete elementProps[propName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  srOnly: false
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var ControlLabel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ControlLabel, _React$Component);

  function ControlLabel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ControlLabel.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === void 0 ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["htmlFor", "srOnly", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(33);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};
var defaultProps = {
  componentClass: 'div'
};

var Col =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Col, _React$Component);

  function Col() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Col.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = "" + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, "" + size + modifier + "-" + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      var hiddenPropName = size + "Hidden";

      if (elementProps[hiddenPropName]) {
        classes.push("hidden-" + size);
      }

      delete elementProps[hiddenPropName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('col', Col));

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_core_js_array_from__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(37);














var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['click', 'mousedown'])
};
var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleRootClose = _this.handleRootClose.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this);

    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);
    return {
      items: items,
      activeIndex: activeIndex
    };
  };

  _proto.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  _proto.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  };

  _proto.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default.a, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "menu",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      "aria-labelledby": labelledBy
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(child, {
        onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    })));
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(775);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(337);
__webpack_require__(779);
module.exports = __webpack_require__(36).Array.from;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(212);
var defined = __webpack_require__(211);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(217);
var descriptor = __webpack_require__(124);
var setToStringTag = __webpack_require__(218);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(104)(IteratorPrototype, __webpack_require__(61)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(90);
var toObject = __webpack_require__(154);
var IE_PROTO = __webpack_require__(213)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(208);
var $export = __webpack_require__(67);
var toObject = __webpack_require__(154);
var call = __webpack_require__(780);
var isArrayIter = __webpack_require__(781);
var toLength = __webpack_require__(321);
var createProperty = __webpack_require__(782);
var getIterFn = __webpack_require__(783);

$export($export.S + $export.F * !__webpack_require__(785)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(105);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(129);
var ITERATOR = __webpack_require__(61)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(89);
var createDesc = __webpack_require__(124);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(784);
var ITERATOR = __webpack_require__(61)('iterator');
var Iterators = __webpack_require__(129);
module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(210);
var TAG = __webpack_require__(61)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(61)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dropdown__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__ = __webpack_require__(158);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(DropdownButton, _React$Component);

  function DropdownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownButton.prototype;

  _proto.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["bsSize", "bsStyle", "title", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Menu, null, children));
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownButton);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Form, _React$Component);

  function Form() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["horizontal", "inline", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }

    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form', Form));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(33);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  componentClass: 'input'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === void 0 ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])({
        bsClass: 'input'
      }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;
FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('form-control', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Glyphicon__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var defaultProps = {
  bsRole: 'feedback'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Glyphicon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(37);









var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};
var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var FormGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(FormGroup, _React$Component);

  function FormGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;
    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  _proto.hasFeedback = function hasFeedback(children) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
    });
  };

  _proto.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["validationState", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-group', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var HelpBlock =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(HelpBlock, _React$Component);

  function HelpBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HelpBlock.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["responsive", "rounded", "circle", "thumbnail", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('img', Image));

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(33);










var InputGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var InputGroupAddon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupAddon.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var InputGroupButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(InputGroupButton, _React$Component);

  function InputGroupButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupButton.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(33);









var Label =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Label, _React$Component);

  function Label() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), children);
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('label', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(37);









var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === void 0 ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["children", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), useListItem ? __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        listItem: true
      });
    }) : children);
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ListGroup.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Media__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(7);









var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var MediaBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MediaBody, _React$Component);

  function MediaBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaBody.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        align = _props.align,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MediaHeading, _React$Component);

  function MediaHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaHeading.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MediaLeft, _React$Component);

  function MediaLeft() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaLeft.prototype;

  _proto.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaLeft.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var MediaList =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var MediaListItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MediaListItem, _React$Component);

  function MediaListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaListItem.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MediaRight, _React$Component);

  function MediaRight() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaRight.prototype;

  _proto.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaRight.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(26);











var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(MenuItem, _React$Component);

  function MenuItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  _proto.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
        role: "separator",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
        role: "heading",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "menuitem",
      tabIndex: "-1",
      onClick: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Fade__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalBody__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalDialog__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalFooter__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalHeader__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalTitle__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__ = __webpack_require__(33);


























var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */].propTypes, {
  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
  })
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
    timeout: Modal.TRANSITION_DURATION
  }));
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
    timeout: Modal.BACKDROP_TRANSITION_DURATION
  }));
}
/* eslint-enable no-use-before-define */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEntering = _this.handleEntering.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleDialogClick = _this.handleDialogClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.setModalRef = _this.setModalRef.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.state = {
      style: {}
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  _proto.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  _proto.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  _proto.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  _proto.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  _proto.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();

    var dialogHeight = dialogNode.scrollHeight;
    var document = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, baseModalProps, {
      ref: this.setModalRef,
      show: show,
      containerClassName: Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
      transition: animation ? DialogTransition : undefined,
      backdrop: backdrop,
      backdropTransition: animation ? BackdropTransition : undefined,
      backdropClassName: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
      onEntering: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
      onExited: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited)
    }), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Dialog, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, dialogProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, this.state.style, style),
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, inClassName),
      onClick: backdrop === true ? this.handleDialogClick : null
    }), children));
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;
Modal.Body = __WEBPACK_IMPORTED_MODULE_16__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_19__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_20__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_18__ModalFooter__["a" /* default */];
Modal.Dialog = __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */];
Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = __webpack_require__(227);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(228);

var _off2 = _interopRequireDefault(_off);

var _filter = __webpack_require__(809);

var _filter2 = _interopRequireDefault(_filter);

var _listen = __webpack_require__(811);

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterEvents;

var _contains = __webpack_require__(112);

var _contains2 = _interopRequireDefault(_contains);

var _querySelectorAll = __webpack_require__(810);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll2.default)(top, selector);

    if (matches.some(function (match) {
      return (0, _contains2.default)(match, target);
    })) handler.call(this, e);
  };
}
module.exports = exports['default'];

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));

    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}
module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _on = __webpack_require__(227);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(228);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listen = function listen() {};

if (_inDOM2.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on2.default)(node, eventName, handler, capture);
    return function () {
      (0, _off2.default)(node, eventName, handler, capture);
    };
  };
}

exports.default = listen;
module.exports = exports['default'];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(336);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(112);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(74);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(130);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(813);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(14);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(815);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(816);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(229);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(822);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(340);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(823);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(162);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(113);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(814);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(817);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(127);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(344);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(346);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(820);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(818);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(819);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(345);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(345);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(130);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(162);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(113);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__ = __webpack_require__(26);




// TODO: Remove this pragma once we upgrade eslint-config-airbnb.

/* eslint-disable react/no-multi-comp */













var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};
var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Navbar, _React$Component);

  function Navbar(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleCollapse = _this.handleCollapse.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;
    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  _proto.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;

    if (expanded) {
      onToggle(false);
    }
  };

  _proto.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;
    onToggle(!expanded);
  };

  _proto.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["a" /* default */], {
      fluid: fluid
    }, children));
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;
Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* bsClass */])('navbar', Navbar);
var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Navbar, {
  expanded: 'onToggle'
});

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);

    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === void 0 ? {
      bsClass: 'navbar'
    } : _ref2$$bs_navbar;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;
  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  };
  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };
  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
    })
  };
  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__["a" /* default */];
UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["c" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var NavbarCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarCollapse.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
      "in": navbarProps.expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: bsClassName
    }, children));
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(NavbarHeader, _React$Component);

  function NavbarHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarHeader.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(26);








var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(NavbarToggle, _React$Component);

  function NavbarToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarToggle.prototype;

  _proto.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["onClick", "className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };

    var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, children);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, "Toggle navigation"), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }));
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(37);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  activeHref: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
});

var NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
    var _this = this;

    var props = _ref.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["title", "activeKey", "activeHref", "className", "style", "children"]);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().

    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, dropdownProps, {
      componentClass: "li",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      }),
      style: style
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, toggleProps, {
      useAnchor: true
    }), title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        active: _this2.isActive(child, activeKey, activeHref)
      });
    })));
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavDropdown.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavDropdown);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(14);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(229);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(830);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(339);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(130);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(831);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(162);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(113);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(356);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(832);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(357);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(113);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = position;

var _offset = __webpack_require__(356);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(833);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(357);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(834);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(127);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(111);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(127);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(161);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_contains__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Overlay__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(26);











/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */

function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_9__Overlay__["a" /* default */].propTypes, {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleDelayedShow = _this.handleDelayedShow.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleDelayedHide = _this.handleDelayedHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));
    _this.handleHide = _this.handleHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this));

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  var _proto = OverlayTrigger.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;
    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  _proto.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;

      _this2.hide();
    }, delay);
  };

  _proto.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;

      _this3.show();
    }, delay);
  };

  _proto.handleHide = function handleHide() {
    this.hide();
  }; // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  _proto.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  _proto.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Overlay__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      show: this.state.show,
      onHide: this.handleHide,
      target: this
    }), overlay);
  };

  _proto.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  _proto.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;
    var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    } // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.


    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);
    return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);







var PageHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PageHeader, _React$Component);

  function PageHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageHeader.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h1", null, children));
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(838);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);


var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message;

  if (typeof oldname === 'object') {
    message = oldname.message;
  } else {
    message = oldname + " is deprecated. Use " + newname + " instead.";

    if (link) {
      message += "\nYou can read more about it at " + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(DeprecatedComponent, _Component);

      function DeprecatedComponent() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = DeprecatedComponent.prototype;

      _proto.componentWillMount = function componentWillMount() {
        deprecationWarning.apply(void 0, args);

        if (_Component.prototype.componentWillMount) {
          var _Component$prototype$;

          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            methodArgs[_key2] = arguments[_key2];
          }

          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
        }
      };

      return DeprecatedComponent;
    }(Component)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);
function _resetWarned() {
  warned = {};
}

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PagerItem__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(37);










var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Pager =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Pager, _React$Component);

  function Pager() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pager.prototype;

  _proto.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["onSelect", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    }));
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Pager.propTypes = propTypes;
Pager.Item = __WEBPACK_IMPORTED_MODULE_6__PagerItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('pager', Pager));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaginationItem__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);








var Pagination =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('pagination', Pagination);
Pagination.First = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["b" /* First */];
Pagination.Prev = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["e" /* Prev */];
Pagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["a" /* Ellipsis */];
Pagination.Item = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["f" /* default */];
Pagination.Next = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["d" /* Next */];
Pagination.Last = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["c" /* Last */];
/* unused harmony default export */ var _unused_webpack_default_export = (Pagination);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PaginationItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(52);




/* eslint-disable react/no-multi-comp */




var propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  activeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};
var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
      active: active,
      disabled: disabled
    })
  }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({
    disabled: disabled
  }, props), children, active && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}
PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _props = this.props,
          disabled = _props.disabled,
          children = _props.children,
          className = _props.className,
          props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["disabled", "children", "className"]);

      var Component = disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({
        "aria-label": label,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
          disabled: disabled
        })
      }, props), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, null, children || defaultValue));
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.displayName = name, _class.propTypes = {
    disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  }, _temp;
}

var First = createButton('First', "\xAB");
var Prev = createButton('Prev', "\u2039");
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
var Next = createButton('Next', "\u203A");
var Last = createButton('Last', "\xBB");

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_assign__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PanelBody__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelHeading__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PanelTitle__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelFooter__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelToggle__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PanelCollapse__ = __webpack_require__(359);


















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var contextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};
var childContextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Panel, _React$Component);

  function Panel() {
    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this, _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    }, _temp) || Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_assertThisInitialized__["a" /* default */])(_this);
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _props = this.props,
        eventKey = _props.eventKey,
        id = _props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        children = _props2.children;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps))
    }), children);
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;
var UncontrolledPanel = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('panel', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)), {
  expanded: 'onToggle'
});

__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_assign___default()(UncontrolledPanel, {
  Heading: __WEBPACK_IMPORTED_MODULE_13__PanelHeading__["a" /* default */],
  Title: __WEBPACK_IMPORTED_MODULE_14__PanelTitle__["a" /* default */],
  Body: __WEBPACK_IMPORTED_MODULE_12__PanelBody__["a" /* default */],
  Footer: __WEBPACK_IMPORTED_MODULE_15__PanelFooter__["a" /* default */],
  Toggle: __WEBPACK_IMPORTED_MODULE_16__PanelToggle__["a" /* default */],
  Collapse: __WEBPACK_IMPORTED_MODULE_17__PanelCollapse__["a" /* default */]
});

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledPanel);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelCollapse__ = __webpack_require__(359);







var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
var defaultProps = {
  collapsible: false
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        collapsible = _props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    var body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PanelCollapse__["a" /* default */], null, body);
    }

    return body;
  };

  return PanelBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelBody));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })
};

var PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        Component = _props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelHeading));

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PanelToggle__ = __webpack_require__(360);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};
var defaultProps = {
  componentClass: 'div'
};

var PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        toggle = _props.toggle,
        Component = _props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PanelToggle__["a" /* default */], null, children);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelTitle));

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);






var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelFooter.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelFooter));

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var defaultProps = {
  placement: 'right'
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Popover, _React$Component);

  function Popover() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popover.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h3", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title')
    }, title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content')
    }, children));
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('popover', Popover));

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(37);










var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProgressBar, null);
    if (child.type === element.type) return;
    var childIdentifier = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "progressbar",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, wrapperProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress')
    }), children ? __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      active: active,
      bsClass: bsClass,
      bsStyle: bsStyle
    }));
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "radio",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('radio', Radio));

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);







 // TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element.isRequired,

  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["a16by9", "a4by3", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes)
    }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
    })));
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('row', Row));

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitToggle__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(158);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,

  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var SplitButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_extends__["a" /* default */])({}, buttonProps, {
      disabled: props.disabled,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */], {
      "aria-label": toggleLabel || title,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, children));
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SplitButton.propTypes = propTypes;
SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__ = __webpack_require__(341);





var SplitToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(SplitToggle, _React$Component);

  function SplitToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitToggle.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */].defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabContainer__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabContent__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabPane__ = __webpack_require__(361);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */].propTypes, {
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
});

var Tab =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_extends__["a" /* default */])({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.


    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Tab.propTypes = propTypes;
Tab.Container = __WEBPACK_IMPORTED_MODULE_4__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_5__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(7);







var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("table", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')
      }, table);
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('table', Table));

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nav__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavItem__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabContainer__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContent__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(37);














var TabContainer = __WEBPACK_IMPORTED_MODULE_10__TabContainer__["a" /* default */].ControlledComponent;
var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['tabs', 'pills']),

  /**
   * Sets a default animation strategy. Use `false` to disable, `true`
   * to enable the default `<Fade>` animation, or a react-transition-group
   * v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], {
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === void 0 ? getDefaultActiveKey(children) : _props$activeKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      className: className,
      style: style
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Nav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      role: "tablist"
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TabContent__["a" /* default */], {
      bsClass: bsClass,
      animation: animation,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, children)));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('tab', Tabs);
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Tabs, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);




/* eslint-disable jsx-a11y/alt-text */





var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Thumbnail =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Thumbnail, _React$Component);

  function Thumbnail() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Thumbnail.prototype;

  _proto.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["src", "alt", "onError", "onLoad", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
      src: src,
      alt: alt,
      onError: onError,
      onLoad: onLoad
    }), children && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "caption"
    }, children));
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Thumbnail.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGroup__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ToggleButton__ = __webpack_require__(362);











var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};
var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }

      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange(values.concat([value]));
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props2, ["children", "type", "name"]);

    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_5_invariant___default()(false) : void 0;
    delete props.onChange;
    delete props.value; // the data attribute is required b/c twbs css uses it in the selector

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, props, {
      "data-toggle": "buttons"
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler() {
        return _this.handleToggle(value);
      };

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;
var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_10__ToggleButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(7);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string])
};
var defaultProps = {
  placement: 'right'
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'),
      style: arrowStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, children));
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__ = __webpack_require__(33);








var Well =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_es6_inheritsLoose__["a" /* default */])(Well, _React$Component);

  function Well() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Well.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_es6_objectWithoutProperties__["a" /* default */])(_props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_es6_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('well', Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(7);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(26);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(37);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({espanol:{id:'LanguageController.espanol',description:'Español',defaultMessage:'Español'},euskera:{id:'LanguageController.euskera',description:'Euskera',defaultMessage:'Euskera'},english:{id:'LanguageController.english',description:'English',defaultMessage:'English'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__ = __webpack_require__(31);
var _this=this;var Breadcrumbs=function Breadcrumbs(props){var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].importFormatter(formatMessage);var path=props.history.location.pathname;var currentLayer=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getLayerFromURL(path);var closeMenuOffCanvas=props.closeMenuOffCanvas;var renderIfAllOK=function renderIfAllOK(){var renderingComponent=null;if(props.responsive){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'breadcrumb ork-menu-off-canvas__breadcrumb'},renderBreadcrumbs());}else{renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'breadcrumb hidden-xs hidden-sm'},renderBreadcrumbs());}return renderingComponent;};var renderBreadcrumbs=function renderBreadcrumbs(){switch(currentLayer){case 1:return loadLayer1();case 2:return loadLayer2();case 3:return loadLayer3();case'methodology':return loadMethodology();default:return'';}};var loadLayer1=function loadLayer1(){var homeLink=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getHomeLink(path);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:homeLink,onClick:closeMenuOffCanvas},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].home))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'active'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer1PageName)));};var loadLayer2=function loadLayer2(){var homeLink=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getHomeLink(path);var urlHead=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getUrlHead(path);var level=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getLevelFromURL(path);var dimensionTitle=__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].getDimensionTitle(level);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:homeLink,onClick:closeMenuOffCanvas},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].home))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:urlHead,onClick:closeMenuOffCanvas},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer1PageName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'active'},dimensionTitle));};var loadLayer3=function loadLayer3(){var homeLink=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getHomeLink(path);var urlHead=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getUrlHead(path);var indicator=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getIndicatorFromURL(path);// const dimension = IndicatorTools.getDimensionFromIndicator( indicator );
var panel_index=__WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__["a" /* default */].getIndicatorIndexInPanel(indicator);var dimensionTitle=__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].getDimensionTitle(panel_index[0]);var subDimensionTitle=__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].getSubDimensionTitle(panel_index[0],panel_index[1]);var newURL=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getLevelDetailLink({url:urlHead,level:panel_index[0]});if(props.indicatorsData===undefined){return;}else{var indicatorData=props.indicatorsData.filter(function(item){return Number(item.id)===Number(indicator);})[0];var indicatorName=indicatorData.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:homeLink,onClick:closeMenuOffCanvas},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].home))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:urlHead,onClick:closeMenuOffCanvas},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer1PageName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:newURL,onClick:closeMenuOffCanvas},dimensionTitle,' - ',subDimensionTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'active'},indicatorName));}};var loadMethodology=function loadMethodology(){var homeLink=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getHomeLink(path);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:homeLink,onClick:closeMenuOffCanvas},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].home))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'active'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].methodology)));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,renderIfAllOK());};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(Breadcrumbs));

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({home:{id:'Breadcrumbs.home',description:'Texto para la página de home',defaultMessage:'Inicio'},layer1PageName:{id:'Breadcrumbs.layer1PageName',description:'Texto para las migas de pan del nombre de la capa 1',defaultMessage:'Panel de indicadores de competitividad'},methodology:{id:'Breadcrumbs.methodology',description:'Texto para las migas de pan de metodología',defaultMessage:'Metodología'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Controllers_Language_LanguageControllerContainer__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_config__ = __webpack_require__(46);
var _this=this;var openMenuOffCanvas=function openMenuOffCanvas(event){document.getElementsByTagName('html')[0].classList.add('ork-menu-off-canvas-open');event.preventDefault();};var Header=function Header(props){var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;var path=props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getLayerFromURL(path);var language=props.match.params.lang;var homeLink=__WEBPACK_IMPORTED_MODULE_6_utils_config__["a" /* default */].getConfig().site.path+'/'+language;var facebookLink='https://www.facebook.com/OrkestraIVC';var twitterLink='https://twitter.com/orkestra';var linkedinLink='https://www.linkedin.com/company/orkestra-basque-institute-of-competitiveness/';var youtubeLink='https://www.youtube.com/channel/UCwmbDDFEzX1Dg37jSz-Bi3g';var slideshareLink='https://es.slideshare.net/OrkestraIVC';var orkestraLink='https://www.orkestra.deusto.es/';var BASE_URL= true?"/competitiveness-observatory":'';var selectedRegionName='';if(props.regionsData){selectedRegionName=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:props.regionsData,id:props.selectedRegionId});}var classHome=void 0;var imgSrc=void 0;if(layer===0){classHome='ork-header--home';imgSrc=BASE_URL+'/img/logo-observatorio-competitividad-dos-lineas-'+language+'.svg';}else if(!__WEBPACK_IMPORTED_MODULE_6_utils_config__["a" /* default */].getProperty("enable_region_change",true)){classHome='ork-header--home';imgSrc=BASE_URL+'/img/logo-observatorio-competitividad-eustat-2-'+language+'.svg';homeLink=homeLink+"/ES21";}else{classHome='';imgSrc=BASE_URL+'/img/logo-observatorio-competitividad-'+language+'.svg';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'container-fluid ork-header '+classHome},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-lg-7 ork-header__left-block-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-header__left-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-header__logo-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:homeLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imgSrc,alt:'Observatorio de competitividad',className:'ork-header__logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-header__region-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-header__region',dangerouslySetInnerHTML:{__html:selectedRegionName}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'js-show-menu ork-burger-menu visible-xs-inline visible-sm-inline',onClick:openMenuOffCanvas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-bars'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hidden-xs hidden-sm col-md-6 col-lg-5 clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-header__right-block clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ork-header__social-media clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:facebookLink,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-facebook.svg',alt:'Facebook'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:twitterLink,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-twitter.svg',alt:'Twitter'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:linkedinLink,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-linkedin.svg',alt:'LinkedIn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:youtubeLink,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-youtube.svg',alt:'Youtube'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:slideshareLink,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/icono-slideshare.svg',alt:'SlideShare'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-header__languages'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Controllers_Language_LanguageControllerContainer__["a" /* default */],{responsive:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-header__logo-orkestra'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:orkestraLink,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/logo-orkestra.svg',alt:'Orkestra: Instituto Vasco de Competitividad (Fundaci\xF3n Deusto)'})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(Header));

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomeContent__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(68);
var mapStateToProps=function mapStateToProps(state){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setRegionsData:function setRegionsData(regionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setRegionsData(regionsData));},setCountriesData:function setCountriesData(countriesData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setCountriesData(countriesData));},setSelectedRegionId:function setSelectedRegionId(selectedRegionId){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSelectedRegionId(selectedRegionId));},setIndicatorsLastUpdated:function setIndicatorsLastUpdated(lastUpdated){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsLastUpdated(lastUpdated));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__HomeContent__["a" /* default */])));

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_RegionChanger_RegionChangerController__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Charts_Map_HomeMap__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeContent=function(_Component){_inherits(HomeContent,_Component);function HomeContent(props){_classCallCheck(this,HomeContent);var _this=_possibleConstructorReturn(this,(HomeContent.__proto__||Object.getPrototypeOf(HomeContent)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={loading:true,error:false};return _this;}_createClass(HomeContent,[{key:'componentDidMount',value:function componentDidMount(){this.props.setSelectedRegionId(null);this.loadData();}},{key:'loadData',value:function loadData(){var _this2=this;var p1=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getRegions().then(function(regions){return __WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getDataFromRegions(regions);});var p2=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getCountries().then(function(countries){return __WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getDataFromCountries(countries);});var p3=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getIndicatorsStatus().then(function(indicatorsStatus){return indicatorsStatus.last_checked_on;});Promise.all([p1,p2,p3]).then(function(values){_this2.props.setRegionsData(values[0]);_this2.props.setCountriesData(values[1]);_this2.props.setIndicatorsLastUpdated(values[2]);return values[2];}).then(function(lastUpdated){_this2.setState({loading:false,lastUpdated:lastUpdated});}).catch(function(reason){_this2.setState({error:true,loading:false});});}},{key:'renderIfAllOK',value:function renderIfAllOK(){if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Error__["a" /* default */],null);}else if(this.state.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null);}else{var path=this.props.history.location.pathname;var methodologyLink=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getMethodologyLink(path);var reportPanelLink=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getReportPanelLink(path,"ES21");// const benchmarkingLink = 'http://s3platform.jrc.ec.europa.eu/regional-benchmarking'
var lastUpdated=__WEBPACK_IMPORTED_MODULE_6_utils_dates_dateTools__["a" /* default */].formatDateForContentHeader(this.state.lastUpdated);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'ork-u-mb'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].title),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].updated,{lastUpdated:lastUpdated})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid ork-gray-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8 col-md-push-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-home-map-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ork-home-map-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_RegionChanger_RegionChangerController__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Charts_Map_HomeMap__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-md-pull-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-home-map-aside'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ork-u-mb-2',dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].welcome)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ork-u-mb-2',dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].secondParagraph)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',role:'button',className:'btn btn-primary hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-video fa-lg'}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-u-ml-half'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].videoButton))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ork-home-panels'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body alert-new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'h3 ork-u-mt-0'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].reportPanelTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-u-mt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].reportPanelParagraph,{reportPanelLink:reportPanelLink,methodologyLink:methodologyLink})}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ork-home-panels'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'h3 ork-u-mt-0 ork-u-text-green'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].lastData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-u-mt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].lastDataParagraph)}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'h3 ork-u-mt-0 ork-u-text-pink'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].competitivenessFrame)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-u-mt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].competitivenessFrameParagraph,{methodologyLink:methodologyLink})}}))))))));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return HomeContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(HomeContent));

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({title:{id:'HomeContent.title',description:'Texto para el titulo de la página',defaultMessage:'La herramienta de diagnóstico regional europeo de Orkestra'},updated:{id:'HomeContent.updated',description:'Texto para el small al lado del titulo',defaultMessage:'actualizado a {lastUpdated}'},welcome:{id:'HomeContent.welcome',description:'Parrafo de bienvenida a la pagina',defaultMessage:'Bienvenido a la herramienta de <strong>diagnóstico regional</strong> de Orkestra. Aquí podrás estudiar de forma <strong>comparada</strong> la situación y evolución de los <strong>indicadores</strong> clave para la competitividad a partir de los datos más recientes a nivel <strong>regional</strong> europeo.'},secondParagraph:{id:'HomeContent.secondParagraph',description:'Segundo párrafo introductorio',defaultMessage:'Esta herramienta persigue propiciar la mejora del estudio de la competitividad regional ofreciendo un punto de partida para diferentes análisis regionales realizados tanto dentro como fuera del Instituto.'},videoButton:{id:'HomeContent.videoButton',description:'Texto para el boton del video',defaultMessage:'Ver vídeo explicativo'},benchmarking:{id:'HomeContent.benchmarking',description:'Benchmarking',defaultMessage:'Benchmarking'},benchmarkingParagraph:{id:'HomeContent.benchmarkingParagraph',description:'Parrafo sobre el benchmarking',defaultMessage:'Al realizar comparaciones es importante no mezclar peras con manzanas y es por ello que Orkestra ha desarrollado una <a href="{benchmarkingLink}">metodología de benchmarking</a> que identifica, para cada región europea, las regiones con <b>estructuras similares</b>. Así podrá compararse con sus "iguales".'},lastData:{id:'HomeContent.lastData',description:'Ultimos datos',defaultMessage:'Últimos datos'},lastDataParagraph:{id:'HomeContent.lastDataParagraph',description:'Parrafo sobre los ultimos datos',defaultMessage:'El observatorio se mantiene siempre <b>actualizado</b> con los últimos datos disponibles para el conjunto de regiones europeas. Para ello utilizamos una plataforma de datos innovadora que nos permite automatizar el proceso de recolección y procesado de datos.'},competitivenessFrame:{id:'HomeContent.competitivenessFrame',description:'Marco de competitividad',defaultMessage:'Marco de competitividad'},competitivenessFrameParagraph:{id:'HomeContent.competitivenessFrameParagraph',description:'Parrafo sobre el marco de competitividad',defaultMessage:'En Orkestra entendemos la competitividad como un <strong>medio para el bienestar</strong> de la sociedad y esto queda reflejado en el <a href="{methodologyLink}">marco analítico</a> desarrollado por el instituto. Este marco define diferentes niveles de indicadores en función de su papel: resultado, desempeño intermedio, determinantes y fundamentos.'},reportPanelTitle:{id:'HomeContent.reportPanelTitle',description:'Panel de diagnóstico',defaultMessage:'NUEVO Panel del Informe de Competitividad del País Vasco'},reportPanelParagraph:{id:'HomeContent.reportPanelParagraph',description:'Parrafo sobre panel de diagnóstico',defaultMessage:'Acompañando el diagnóstico incluído en el <a href="https://www.orkestra.deusto.es/es/investigacion/informe-de-competitividad-del-pais-vasco">Informe de Competitividad del País Vasco</a>, este <a href="{reportPanelLink}">nuevo panel</a> recoge el nivel y evolución de nuevos indicadores inscritos en el <a href="{methodologyLink}">marco de competitividad de Orkestra</a>, así como su comparación con la UE-27.'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Loading__ = __webpack_require__(19);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegionChangerController=function(_Component){_inherits(RegionChangerController,_Component);function RegionChangerController(props){_classCallCheck(this,RegionChangerController);var _this=_possibleConstructorReturn(this,(RegionChangerController.__proto__||Object.getPrototypeOf(RegionChangerController)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={selected:[],loading:true,regionsDataByCountry:null};return _this;}_createClass(RegionChangerController,[{key:'componentDidMount',value:function componentDidMount(){if(this.state.loading){if(this.props.regionsData&&this.props.countriesData){var regionsDataByCountry=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getRegionsDataByCountry(this.props.regionsData);this.setState({loading:false,regionsDataByCountry:regionsDataByCountry});}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(!this.state.regionsDataByCountry){if(this.state.loading){if(this.props.regionsData&&this.props.countriesData){var regionsDataByCountry=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getRegionsDataByCountry(this.props.regionsData);this.setState({loading:false,regionsDataByCountry:regionsDataByCountry});}}}else if(!__WEBPACK_IMPORTED_MODULE_6_utils_objects_objectTools__["a" /* default */].compareObjects(this.state.selected,prevState.selected)){setTimeout(function(){_this2.props.setSelectedRegionId(_this2.state.selected[0].id);_this2.setState({loading:false});},1000);}}},{key:'handleChange',value:function handleChange(selected){selected=this.handleMultiple(selected);if(selected.length>0){var selectedCode=selected[0].code;var oldURL=this.props.history.location.pathname;var newURL=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getSameURLWithChangedRegion({url:oldURL,regionCode:selectedCode});if(oldURL!==newURL){this.props.history.push(newURL);}this.setState({selected:selected,loading:true});}}},{key:'handleMultiple',value:function handleMultiple(selected){if(!this.props.multiple){if(selected.length>1){selected.shift();}}return selected;}},{key:'renderMenu',value:function renderMenu(results,menuProps){var items=results.map(function(result,index){if(result.isCountry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Menu"].Header,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,result.name));}else if(result.paginationOption){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["MenuItem"],{option:result,position:index,key:index},''+result.label);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["MenuItem"],{option:result,position:index,key:index},result.name+' ('+result.code+')');}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Menu"],menuProps,items);}},{key:'loadOptions',value:function loadOptions(){var _this3=this;if(this.state.regionsDataByCountry){var _ret=function(){var regionsDataByCountry=_this3.state.regionsDataByCountry;var sortedCountryCodes=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getSortedCountryCodesByCountryName({regionsDataByCountry:regionsDataByCountry});var processedData=[];var _loop=function _loop(i){var actualCountryData=regionsDataByCountry[sortedCountryCodes[i]];actualCountryData.regions=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getSortedRegionsByRegionName({regionsData:actualCountryData.regions});var processedCountry={countryCode:sortedCountryCodes[i],countryFullName:actualCountryData.countryFullName,code:sortedCountryCodes[i],name:actualCountryData.countryFullName,isCountry:true};processedData.push(processedCountry);actualCountryData.regions.forEach(function(region){var processedRegion=region;processedRegion.countryCode=sortedCountryCodes[i];processedRegion.countryFullName=actualCountryData.countryFullName;processedRegion.isCountry=false;processedData.push(processedRegion);});};for(var i=0;i<sortedCountryCodes.length;i++){_loop(i);}return{v:processedData};}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}return[];}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this4=this;if(this.state.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Loading__["a" /* default */],null);}else{var actualURL=this.props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getLayerFromURL(actualURL);var placeholder=null;if(layer===0){placeholder=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].placeholder0);}else{placeholder=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].placeholder1);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"],{selected:[],multiple:true,onChange:function onChange(selected){return _this4.handleChange(selected);},options:this.loadOptions(),labelKey:function labelKey(option){return option.name+' ('+option.code+')';},filterBy:['countryFullName','code'],renderMenu:this.renderMenu,selectHintOnEnter:true,placeholder:placeholder});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return RegionChangerController;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(RegionChangerController));

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncContainer = __webpack_require__(365);

var _asyncContainer2 = _interopRequireDefault(_asyncContainer);

var _Typeahead = __webpack_require__(387);

var _Typeahead2 = _interopRequireDefault(_Typeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _asyncContainer2.default)(_Typeahead2.default);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(75),
    now = __webpack_require__(873),
    toNumber = __webpack_require__(874);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(62);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(75),
    isSymbol = __webpack_require__(163);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 876 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(55);

function addCustomOption(results, props) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey,
      text = props.text;


  if (!allowNew || !text.trim()) {
    return false;
  }

  // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.
  if (typeof allowNew === 'function') {
    return allowNew(results, props);
  }

  // By default, don't add the custom option if there is an exact text match
  // with an existing option.
  return !results.some(function (o) {
    return (0, _index.getOptionLabel)(o, labelKey) === text;
  });
}

exports.default = addCustomOption;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFilterBy;

var _isEqual = __webpack_require__(367);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isFunction = __webpack_require__(236);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isString = __webpack_require__(934);

var _isString2 = _interopRequireDefault(_isString);

var _some = __webpack_require__(935);

var _some2 = _interopRequireDefault(_some);

var _stripDiacritics = __webpack_require__(244);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMatch(input, string, props) {
  if (!props.caseSensitive) {
    input = input.toLowerCase();
    string = string.toLowerCase();
  }

  if (props.ignoreDiacritics) {
    input = (0, _stripDiacritics2.default)(input);
    string = (0, _stripDiacritics2.default)(string);
  }

  return string.indexOf(input) !== -1;
}

/**
 * Default algorithm for filtering results.
 */
function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text;

  // Don't show selected options in the menu for the multi-select case.

  if (multiple && selected.some(function (o) {
    return (0, _isEqual2.default)(o, option);
  })) {
    return false;
  }

  var fields = filterBy.slice();

  if ((0, _isFunction2.default)(labelKey) && isMatch(text, labelKey(option), props)) {
    return true;
  }

  if ((0, _isString2.default)(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }

  if ((0, _isString2.default)(option)) {
    (0, _warn2.default)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');

    return isMatch(text, option, props);
  }

  return (0, _some2.default)(fields, function (field) {
    var value = option[field];

    if (!(0, _isString2.default)(value)) {
      (0, _warn2.default)(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');

      // Coerce to string since `toString` isn't null-safe.
      value = value + '';
    }

    return isMatch(text, value, props);
  });
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(368),
    equalArrays = __webpack_require__(370),
    equalByTag = __webpack_require__(910),
    equalObjects = __webpack_require__(914),
    getTag = __webpack_require__(930),
    isArray = __webpack_require__(41),
    isBuffer = __webpack_require__(373),
    isTypedArray = __webpack_require__(375);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 880 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(165);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(165);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(165);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(165);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(164);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 887 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(164),
    Map = __webpack_require__(235),
    MapCache = __webpack_require__(237);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(236),
    isMasked = __webpack_require__(891),
    isObject = __webpack_require__(75),
    toSource = __webpack_require__(369);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(892);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(62);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 893 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(895),
    ListCache = __webpack_require__(164),
    Map = __webpack_require__(235);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(896),
    hashDelete = __webpack_require__(897),
    hashGet = __webpack_require__(898),
    hashHas = __webpack_require__(899),
    hashSet = __webpack_require__(900);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(167);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 897 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(167);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(167);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(168);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 902 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(168);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(168);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(168);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(237),
    setCacheAdd = __webpack_require__(907),
    setCacheHas = __webpack_require__(908);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 907 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 908 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131),
    Uint8Array = __webpack_require__(911),
    eq = __webpack_require__(166),
    equalArrays = __webpack_require__(370),
    mapToArray = __webpack_require__(912),
    setToArray = __webpack_require__(913);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(62);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 913 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(915);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(916),
    getSymbols = __webpack_require__(917),
    keys = __webpack_require__(238);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(372),
    isArray = __webpack_require__(41);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(918),
    stubArray = __webpack_require__(919);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 919 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(921),
    isArguments = __webpack_require__(239),
    isArray = __webpack_require__(41),
    isBuffer = __webpack_require__(373),
    isIndex = __webpack_require__(169),
    isTypedArray = __webpack_require__(375);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 921 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 923 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94),
    isLength = __webpack_require__(240),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 925 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(366);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(374)(module)))

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(928),
    nativeKeys = __webpack_require__(929);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(376);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(931),
    Map = __webpack_require__(235),
    Promise = __webpack_require__(932),
    Set = __webpack_require__(933),
    WeakMap = __webpack_require__(377),
    baseGetTag = __webpack_require__(94),
    toSource = __webpack_require__(369);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95),
    root = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95),
    root = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(95),
    root = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94),
    isArray = __webpack_require__(41),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(371),
    baseIteratee = __webpack_require__(936),
    baseSome = __webpack_require__(952),
    isArray = __webpack_require__(41),
    isIterateeCall = __webpack_require__(958);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(937),
    baseMatchesProperty = __webpack_require__(940),
    identity = __webpack_require__(382),
    isArray = __webpack_require__(41),
    property = __webpack_require__(949);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(938),
    getMatchData = __webpack_require__(939),
    matchesStrictComparable = __webpack_require__(379);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(368),
    baseIsEqual = __webpack_require__(234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(378),
    keys = __webpack_require__(238);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(234),
    get = __webpack_require__(941),
    hasIn = __webpack_require__(381),
    isKey = __webpack_require__(243),
    isStrictComparable = __webpack_require__(378),
    matchesStrictComparable = __webpack_require__(379),
    toKey = __webpack_require__(132);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(242);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(943);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(944);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(237);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131),
    arrayMap = __webpack_require__(946),
    isArray = __webpack_require__(41),
    isSymbol = __webpack_require__(163);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 946 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 947 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(170),
    isArguments = __webpack_require__(239),
    isArray = __webpack_require__(41),
    isIndex = __webpack_require__(169),
    isLength = __webpack_require__(240),
    toKey = __webpack_require__(132);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(950),
    basePropertyDeep = __webpack_require__(951),
    isKey = __webpack_require__(243),
    toKey = __webpack_require__(132);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(242);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(953);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(954),
    createBaseEach = __webpack_require__(957);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(955),
    keys = __webpack_require__(238);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(956);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(241);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(166),
    isArrayLike = __webpack_require__(241),
    isIndex = __webpack_require__(169),
    isObject = __webpack_require__(75);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAccessibilityStatus(props) {
  var a11yNumResults = props.a11yNumResults,
      a11yNumSelected = props.a11yNumSelected,
      emptyLabel = props.emptyLabel,
      isMenuShown = props.isMenuShown,
      results = props.results,
      selected = props.selected;

  // If the menu is hidden, display info about the number of selections.

  if (!isMenuShown) {
    return a11yNumSelected(selected);
  }

  // Display info about the number of matches.
  if (results.length === 0) {
    return emptyLabel;
  }

  return a11yNumResults(results);
}

exports.default = getAccessibilityStatus;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMatchBounds = __webpack_require__(383);

var _getMatchBounds2 = _interopRequireDefault(_getMatchBounds);

var _getOptionLabel = __webpack_require__(245);

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHintText(_ref) {
  var activeItem = _ref.activeItem,
      initialItem = _ref.initialItem,
      isMenuShown = _ref.isMenuShown,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  // Don't display a hint under the following conditions:
  if (
  // No text entered.
  !text ||
  // The menu is hidden.
  !isMenuShown ||
  // No item in the menu.
  !initialItem ||
  // The initial item is a custom option.
  initialItem.customOption ||
  // One of the menu items is active.
  activeItem ||
  // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }

  var initialItemStr = (0, _getOptionLabel2.default)(initialItem, labelKey);
  var bounds = (0, _getMatchBounds2.default)(initialItemStr.toLowerCase(), text.toLowerCase());

  if (!(bounds && bounds.start === 0)) {
    return '';
  }

  // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.
  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

exports.default = getHintText;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(376);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(246);

var _head2 = _interopRequireDefault(_head);

var _getOptionLabel = __webpack_require__(245);

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getInputText(_ref) {
  var activeItem = _ref.activeItem,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  if (activeItem) {
    // Display the input value if the pagination item is active.
    return activeItem.paginationOption ? text : (0, _getOptionLabel2.default)(activeItem, labelKey);
  }

  var selectedItem = !multiple && !!selected.length && (0, _head2.default)(selected);
  if (selectedItem) {
    return (0, _getOptionLabel2.default)(selectedItem, labelKey);
  }

  return text;
}

exports.default = getInputText;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMenuItemId;
function getMenuItemId(position) {
  return "rbt-menu-item-" + position;
}

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

exports.default = getTruncatedOptions;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pluralize;
/**
 * Basic util for pluralizing words. By default, simply adds an 's' to the word.
 * Also allows for a custom plural version.
 */
function pluralize(text, count, plural) {
  plural = plural || text + "s";
  return count === 1 ? "1 " + text : count + " " + plural;
}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = preventInputBlur;
/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Partial polyfill for webkit `scrollIntoViewIfNeeded()` method. Addresses
 * vertical scrolling only.
 *
 * Inspired by https://gist.github.com/hsablonniere/2581101, but uses
 * `getBoundingClientRect`.
 */
function scrollIntoViewIfNeeded(node) {
  // Webkit browsers
  if (Element.prototype.scrollIntoViewIfNeeded) {
    node.scrollIntoViewIfNeeded();
    return;
  }

  // FF, IE, etc.
  var rect = node.getBoundingClientRect();
  var parent = node.parentNode;
  var parentRect = parent.getBoundingClientRect();

  var parentComputedStyle = window.getComputedStyle(parent, null);
  var parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width'));

  if (rect.top < parentRect.top || rect.bottom > parentRect.bottom) {
    parent.scrollTop = node.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + node.clientHeight / 2;
  }
}

exports.default = scrollIntoViewIfNeeded;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(971),
    flatRest = __webpack_require__(389);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(972),
    hasIn = __webpack_require__(381);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(242),
    baseSet = __webpack_require__(973),
    castPath = __webpack_require__(170);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(974),
    castPath = __webpack_require__(170),
    isIndex = __webpack_require__(169),
    isObject = __webpack_require__(75),
    toKey = __webpack_require__(132);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(975),
    eq = __webpack_require__(166);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(388);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(977);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(372),
    isFlattenable = __webpack_require__(978);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131),
    isArguments = __webpack_require__(239),
    isArray = __webpack_require__(41);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(980);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(982),
    shortOut = __webpack_require__(984);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(983),
    defineProperty = __webpack_require__(388),
    identity = __webpack_require__(382);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 983 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 984 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader(_ref) {
  var bsSize = _ref.bsSize;
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('rbt-loader', {
      'rbt-loader-lg': bsSize === 'large' || bsSize === 'lg',
      'rbt-loader-sm': bsSize === 'small' || bsSize === 'sm'
    })
  });
};

Loader.propTypes = {
  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm'])
};

exports.default = Loader;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(130);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _Portal = __webpack_require__(229);

var _Portal2 = _interopRequireDefault(_Portal);

var _Popper = __webpack_require__(987);

var _Popper2 = _interopRequireDefault(_Popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BODY_CLASS = 'rbt-body-container';

// When appending the overlay to `document.body`, clicking on it will register
// as an "outside" click and immediately close the overlay. This classname tells
// `react-onclickoutside` to ignore the click.
var IGNORE_CLICK_OUTSIDE = 'ignore-react-onclickoutside';

function getModifiers(_ref) {
  var align = _ref.align,
      flip = _ref.flip;

  return {
    computeStyles: {
      enabled: true,
      fn: function fn(data) {
        // Use the following condition instead of `align === 'justify'` since
        // it allows the component to fall back to justifying the menu width
        // even when `align` is undefined.
        if (align !== 'right' && align !== 'left') {
          // Set the popper width to match the target width.
          data.styles.width = data.offsets.reference.width;
        }
        return data;
      }
    },
    flip: {
      enabled: flip
    },
    preventOverflow: {
      escapeWithReference: true
    }
  };
}

function isBody(container) {
  return container === document.body;
}

/**
 * Custom `Overlay` component, since the version in `react-overlays` doesn't
 * work for our needs. Specifically, the `Position` component doesn't provide
 * the customized placement we need.
 */

var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref2, [this].concat(args))), _this), _this._update = function () {
      var _container$classList;

      var _this$props = _this.props,
          className = _this$props.className,
          container = _this$props.container,
          show = _this$props.show;

      // Positioning is only used when body is the container.

      if (!(show && isBody(container))) {
        return;
      }

      // Set a classname on the body for scoping purposes.
      container.classList.add(BODY_CLASS);
      !!className && (_container$classList = container.classList).add.apply(_container$classList, _toConsumableArray(className.split(' ')));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Overlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._update();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var onMenuHide = nextProps.onMenuHide,
          onMenuShow = nextProps.onMenuShow,
          show = nextProps.show;


      if (this.props.show && !show) {
        onMenuHide();
      }

      if (!this.props.show && show) {
        onMenuShow();
      }

      // Remove scoping classes if menu isn't being appended to document body.
      var _props = this.props,
          className = _props.className,
          container = _props.container;

      if (isBody(container) && !isBody(nextProps.container)) {
        var _container$classList2;

        container.classList.remove(BODY_CLASS);
        !!className && (_container$classList2 = container.classList).remove.apply(_container$classList2, _toConsumableArray(className.split(' ')));
      }

      this._update();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          align = _props2.align,
          children = _props2.children,
          container = _props2.container,
          dropup = _props2.dropup,
          referenceElement = _props2.referenceElement,
          show = _props2.show;


      if (!(show && _react.Children.count(children) && referenceElement)) {
        return null;
      }

      var child = _react.Children.only(children);

      var xPlacement = align === 'right' ? 'end' : 'start';
      var yPlacement = dropup ? 'top' : 'bottom';

      return _react2.default.createElement(
        _Portal2.default,
        { container: container },
        _react2.default.createElement(
          _Popper2.default,
          {
            modifiers: getModifiers(this.props),
            placement: yPlacement + '-' + xPlacement,
            referenceElement: referenceElement },
          function (_ref3) {
            var ref = _ref3.ref,
                props = _objectWithoutProperties(_ref3, ['ref']);

            return (0, _react.cloneElement)(child, _extends({}, child.props, props, {
              className: (0, _classnames2.default)(child.props.className, _defineProperty({}, IGNORE_CLICK_OUTSIDE, isBody(container))),
              innerRef: ref
            }));
          }
        )
      );
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = {
  children: _propTypes2.default.element,
  container: _componentOrElement2.default.isRequired,
  onMenuHide: _propTypes2.default.func.isRequired,
  onMenuShow: _propTypes2.default.func.isRequired,
  referenceElement: _componentOrElement2.default,
  show: _propTypes2.default.bool
};

Overlay.defaultProps = {
  show: false
};

exports.default = Overlay;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placements = exports.InnerPopper = undefined;

var _extends2 = __webpack_require__(391);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(392);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(393);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(395);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = Popper;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _popper = __webpack_require__(1005);

var _popper2 = _interopRequireDefault(_popper);

var _Manager = __webpack_require__(1006);

var _utils = __webpack_require__(1011);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};

var initialArrowStyle = {};

var InnerPopper = exports.InnerPopper = function (_React$Component) {
  (0, _inherits3.default)(InnerPopper, _React$Component);

  function InnerPopper() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InnerPopper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      data: undefined,
      placement: undefined
    }, _this.popperNode = null, _this.arrowNode = null, _this.setPopperNode = function (popperNode) {
      if (_this.popperNode === popperNode) return;

      (0, _utils.safeInvoke)(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      if (!_this.popperInstance) _this.updatePopperInstance();
    }, _this.setArrowNode = function (arrowNode) {
      if (_this.arrowNode === arrowNode) return;
      _this.arrowNode = arrowNode;

      if (!_this.popperInstance) _this.updatePopperInstance();
    }, _this.updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({ data: data, placement: placement }, placement !== _this.state.placement ? _this.scheduleUpdate : undefined);
        return data;
      }
    }, _this.getOptions = function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: (0, _extends3.default)({}, _this.props.modifiers, {
          arrow: {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          },
          applyStyle: { enabled: false },
          updateStateModifier: _this.updateStateModifier
        })
      };
    }, _this.getPopperStyle = function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends3.default)({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    }, _this.getPopperPlacement = function () {
      return !_this.state.data ? undefined : _this.state.placement;
    }, _this.getArrowStyle = function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    }, _this.getOutOfBoundariesState = function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    }, _this.destroyPopperInstance = function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();
      _this.popperInstance = null;
    }, _this.updatePopperInstance = function () {
      _this.destroyPopperInstance();

      var _this2 = _this,
          popperNode = _this2.popperNode;
      var referenceElement = _this.props.referenceElement;


      if (!referenceElement || !popperNode) return;

      _this.popperInstance = new _popper2.default(referenceElement, popperNode, _this.getOptions());
    }, _this.scheduleUpdate = function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  InnerPopper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.eventsEnabled !== prevProps.eventsEnabled || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
      return;
    }

    // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  InnerPopper.prototype.componentWillUnmount = function componentWillUnmount() {
    this.destroyPopperInstance();
  };

  InnerPopper.prototype.render = function render() {
    return (0, _utils.unwrapArray)(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(React.Component);

InnerPopper.defaultProps = {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
};


var placements = _popper2.default.placements;
exports.placements = placements;
function Popper(props) {
  return React.createElement(
    _Manager.ManagerContext.Consumer,
    null,
    function (_ref) {
      var referenceNode = _ref.referenceNode;
      return React.createElement(InnerPopper, (0, _extends3.default)({ referenceElement: referenceNode }, props));
    }
  );
}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(316), __esModule: true };

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(990), __esModule: true };

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(337);
__webpack_require__(991);
module.exports = __webpack_require__(219).f('iterator');


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(992);
var global = __webpack_require__(73);
var hide = __webpack_require__(104);
var Iterators = __webpack_require__(129);
var TO_STRING_TAG = __webpack_require__(61)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(993);
var step = __webpack_require__(994);
var Iterators = __webpack_require__(129);
var toIObject = __webpack_require__(91);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(338)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(996), __esModule: true };

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324);
__webpack_require__(997);
__webpack_require__(998);
__webpack_require__(999);
module.exports = __webpack_require__(36).Symbol;


/***/ }),
/* 997 */
/***/ (function(module, exports) {



/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(220)('asyncIterator');


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(220)('observable');


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1001), __esModule: true };

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1002);
module.exports = __webpack_require__(36).Object.setPrototypeOf;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(67);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1003).set });


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(106);
var anObject = __webpack_require__(105);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(208)(Function.call, __webpack_require__(327).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(322), __esModule: true };

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63)))

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagerContext = undefined;

var _extends2 = __webpack_require__(391);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(392);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(393);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(395);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _createReactContext = __webpack_require__(1007);

var _createReactContext2 = _interopRequireDefault(_createReactContext);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManagerContext = exports.ManagerContext = (0, _createReactContext2.default)({ getReferenceRef: undefined, referenceNode: undefined });

var Manager = function (_React$Component) {
  (0, _inherits3.default)(Manager, _React$Component);

  function Manager() {
    (0, _classCallCheck3.default)(this, Manager);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

    _this.getReferenceRef = function (referenceNode) {
      return _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: (0, _extends3.default)({}, context, { referenceNode: referenceNode })
        };
      });
    };

    _this.state = {
      context: {
        getReferenceRef: _this.getReferenceRef,
        referenceNode: undefined
      }
    };
    return _this;
  }

  Manager.prototype.render = function render() {
    return React.createElement(
      ManagerContext.Provider,
      { value: this.state.context },
      this.props.children
    );
  };

  return Manager;
}(React.Component);

exports.default = Manager;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1008);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1009);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1010);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(200);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = exports.unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};

/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */
var safeInvoke = exports.safeInvoke = function safeInvoke(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof fn === "function") {
    return fn.apply(undefined, args);
  }
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AutosizeInput = __webpack_require__(1013);

var _AutosizeInput2 = _interopRequireDefault(_AutosizeInput);

var _Token = __webpack_require__(396);

var _Token2 = _interopRequireDefault(_Token);

var _utils = __webpack_require__(55);

var _hintContainer = __webpack_require__(399);

var _hintContainer2 = _interopRequireDefault(_hintContainer);

var _inputContainer = __webpack_require__(400);

var _inputContainer2 = _interopRequireDefault(_inputContainer);

var _keyCode = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HintedAutosizeInput = (0, _hintContainer2.default)(_AutosizeInput2.default);

var TypeaheadInputMulti = function (_React$Component) {
  _inherits(TypeaheadInputMulti, _React$Component);

  function TypeaheadInputMulti() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeaheadInputMulti);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeaheadInputMulti.__proto__ || Object.getPrototypeOf(TypeaheadInputMulti)).call.apply(_ref, [this].concat(args))), _this), _this._renderToken = function (option, idx) {
      var _this$props = _this.props,
          _onRemove = _this$props.onRemove,
          renderToken = _this$props.renderToken;

      var props = _extends({}, _this.props, {
        onRemove: function onRemove() {
          return _onRemove(option);
        }
      });

      return renderToken(option, props, idx);
    }, _this._handleContainerClickOrFocus = function (e) {
      // Don't focus the input if it's disabled.
      if (_this.props.disabled) {
        e.target.blur();
        return;
      }

      // Move cursor to the end if the user clicks outside the actual input.
      var inputNode = _this._input;
      if (e.target !== inputNode) {
        inputNode.selectionStart = inputNode.value.length;
      }

      inputNode.focus();
    }, _this._handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onKeyDown = _this$props2.onKeyDown,
          selected = _this$props2.selected,
          value = _this$props2.value;


      switch (e.keyCode) {
        case _keyCode.BACKSPACE:
          if (e.target === _this._input && selected.length && !value) {
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var children = _this._wrapper.children;
            var lastToken = children[children.length - 2];
            lastToken && lastToken.focus();
          }
          break;
      }

      onKeyDown(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeaheadInputMulti, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          inputClassName = _props.inputClassName,
          labelKey = _props.labelKey,
          onRemove = _props.onRemove,
          renderToken = _props.renderToken,
          selected = _props.selected,
          props = _objectWithoutProperties(_props, ['className', 'inputClassName', 'labelKey', 'onRemove', 'renderToken', 'selected']);

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('form-control', 'rbt-input-multi', className),
            disabled: props.disabled,
            onClick: this._handleContainerClickOrFocus,
            onFocus: this._handleContainerClickOrFocus,
            tabIndex: -1 },
          _react2.default.createElement(
            'div',
            { className: 'rbt-input-wrapper', ref: function ref(el) {
                return _this2._wrapper = el;
              } },
            selected.map(this._renderToken),
            _react2.default.createElement(HintedAutosizeInput, _extends({}, props, {
              inputClassName: (0, _classnames2.default)('rbt-input-main', inputClassName),
              inputRef: function inputRef(input) {
                _this2._input = input;
                _this2.props.inputRef(input);
              },
              inputStyle: {
                backgroundColor: 'transparent',
                border: 0,
                boxShadow: 'none',
                cursor: 'inherit',
                outline: 'none',
                padding: 0
              },
              onKeyDown: this._handleKeyDown,
              style: {
                position: 'relative',
                zIndex: 1
              }
            }))
          )
        )
        /* eslint-enable jsx-a11y/no-static-element-interactions */
        /* eslint-enable jsx-a11y/click-events-have-key-events */

      );
    }

    /**
     * Forward click or focus events on the container element to the input.
     */

  }]);

  return TypeaheadInputMulti;
}(_react2.default.Component);

TypeaheadInputMulti.propTypes = {
  /**
   * Provides a hook for customized rendering of tokens when multiple
   * selections are enabled.
   */
  renderToken: _propTypes2.default.func
};

TypeaheadInputMulti.defaultProps = {
  renderToken: function renderToken(option, props, idx) {
    return _react2.default.createElement(
      _Token2.default,
      {
        disabled: props.disabled,
        key: idx,
        onRemove: props.onRemove,
        tabIndex: props.tabIndex },
      (0, _utils.getOptionLabel)(option, props.labelKey)
    );
  }
};

exports.default = (0, _inputContainer2.default)(TypeaheadInputMulti);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIZER_STYLE = {
  height: 0,
  left: 0,
  overflow: 'scroll',
  position: 'absolute',
  top: 0,
  visibility: 'hidden',
  whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['inputClassName', 'inputRef', 'inputStyle'];

var MIN_WIDTH = 1;

var cleanInputProps = function cleanInputProps(inputProps) {
  INPUT_PROPS_BLACKLIST.forEach(function (field) {
    return delete inputProps[field];
  });
  return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
  node.style.fontSize = styles.fontSize;
  node.style.fontFamily = styles.fontFamily;
  node.style.fontWeight = styles.fontWeight;
  node.style.fontStyle = styles.fontStyle;
  node.style.letterSpacing = styles.letterSpacing;
  node.style.textTransform = styles.textTransform;
};

var AutosizeInput = function (_React$Component) {
  _inherits(AutosizeInput, _React$Component);

  function AutosizeInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutosizeInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputWidth: MIN_WIDTH
    }, _this._copyInputStyles = function () {
      var inputStyles = _this._input && window.getComputedStyle && window.getComputedStyle(_this._input);

      if (!inputStyles) {
        return;
      }

      copyStyles(inputStyles, _this._sizer);

      if (_this._placeHolderSizer) {
        copyStyles(inputStyles, _this._placeHolderSizer);
      }
    }, _this._updateInputWidth = function () {
      if (!_this._sizer || _this._sizer.scrollWidth === undefined) {
        return;
      }

      _this._copyInputStyles();

      var placeholderWidth = _this._placeHolderSizer && _this._placeHolderSizer.scrollWidth || MIN_WIDTH;

      var inputWidth = Math.max(_this._sizer.scrollWidth, placeholderWidth) + 2;

      if (inputWidth !== _this.state.inputWidth) {
        _this.setState({ inputWidth: inputWidth });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutosizeInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updateInputWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._updateInputWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          value = _props.value;


      var wrapperStyle = _extends({}, this.props.style);
      if (!wrapperStyle.display) {
        wrapperStyle.display = 'inline-block';
      }

      var inputProps = cleanInputProps(_extends({}, this.props, {
        className: this.props.inputClassName,
        style: _extends({}, this.props.inputStyle, {
          boxSizing: 'content-box',
          width: this.state.inputWidth + 'px'
        })
      }));

      return _react2.default.createElement(
        'div',
        { className: className, style: wrapperStyle },
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(el) {
            _this2._input = el;
            if (typeof _this2.props.inputRef === 'function') {
              _this2.props.inputRef(el);
            }
          }
        })),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(el) {
              return _this2._sizer = el;
            },
            style: SIZER_STYLE },
          defaultValue || value || ''
        ),
        placeholder ? _react2.default.createElement(
          'div',
          {
            ref: function ref(el) {
              return _this2._placeHolderSizer = el;
            },
            style: SIZER_STYLE },
          placeholder
        ) : null
      );
    }
  }]);

  return AutosizeInput;
}(_react2.default.Component);

AutosizeInput.propTypes = {
  /**
   * ClassName for the input element.
   */
  inputClassName: _propTypes2.default.string,
  /**
   * Ref callback for the input element.
   */
  inputRef: _propTypes2.default.func,
  /**
   * CSS styles for the input element.
   */
  inputStyle: _propTypes2.default.object
};

exports.default = AutosizeInput;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hintContainer = __webpack_require__(399);

var _hintContainer2 = _interopRequireDefault(_hintContainer);

var _inputContainer = __webpack_require__(400);

var _inputContainer2 = _interopRequireDefault(_inputContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeaheadInputSingle = function (_React$Component) {
  _inherits(TypeaheadInputSingle, _React$Component);

  function TypeaheadInputSingle() {
    _classCallCheck(this, TypeaheadInputSingle);

    return _possibleConstructorReturn(this, (TypeaheadInputSingle.__proto__ || Object.getPrototypeOf(TypeaheadInputSingle)).apply(this, arguments));
  }

  _createClass(TypeaheadInputSingle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['className', 'inputRef']);

      return _react2.default.createElement('input', _extends({}, props, {
        className: (0, _classnames2.default)('rbt-input-main', 'form-control', className),
        ref: inputRef,
        type: 'text'
      }));
    }
  }]);

  return TypeaheadInputSingle;
}(_react2.default.Component);

exports.default = (0, _inputContainer2.default)((0, _hintContainer2.default)(TypeaheadInputSingle));

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _flowRight = __webpack_require__(1016);

var _flowRight2 = _interopRequireDefault(_flowRight);

var _head = __webpack_require__(246);

var _head2 = _interopRequireDefault(_head);

var _isEqual = __webpack_require__(367);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _noop = __webpack_require__(248);

var _noop2 = _interopRequireDefault(_noop);

var _uniqueId = __webpack_require__(1024);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOnclickoutside = __webpack_require__(398);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _highlightOnlyResultContainer = __webpack_require__(1025);

var _highlightOnlyResultContainer2 = _interopRequireDefault(_highlightOnlyResultContainer);

var _propTypes3 = __webpack_require__(1026);

var _utils = __webpack_require__(55);

var _defaultLabelKey = __webpack_require__(386);

var _keyCode = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function genId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return prefix + Math.random().toString(36).substr(2, 12);
}

function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      maxResults = props.maxResults,
      multiple = props.multiple;


  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();

  var text = defaultInputValue;

  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = (0, _utils.getOptionLabel)((0, _head2.default)(selected), props.labelKey);

    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }

  return {
    activeIndex: -1,
    activeItem: null,
    initialItem: null,
    selected: selected,
    showMenu: false,
    shownResults: maxResults,
    text: text
  };
}

function typeaheadContainer(Typeahead) {
  // Nested HOCs to encapsulate behaviors. In order from outer to inner.
  Typeahead = (0, _flowRight2.default)(_highlightOnlyResultContainer2.default)(Typeahead);

  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead(props) {
      _classCallCheck(this, WrappedTypeahead);

      var _this = _possibleConstructorReturn(this, (WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call(this, props));

      _this.blur = function () {
        _this.getInput().blur();
        _this._hideMenu();
      };

      _this.clear = function () {
        _this.setState(_extends({}, getInitialState(_this.props), {
          selected: [],
          text: ''
        }));
      };

      _this.focus = function () {
        _this.getInput().focus();
      };

      _this.getInput = function () {
        return _this._input;
      };

      _this._handleActiveIndexChange = function (activeIndex) {
        var newState = { activeIndex: activeIndex };

        if (activeIndex === -1) {
          // Reset the active item if there is no active index.
          newState.activeItem = null;
        }

        _this.setState(newState);
      };

      _this._handleActiveItemChange = function (activeItem) {
        _this.setState({ activeItem: activeItem });
      };

      _this._handleClear = function () {
        _this.clear();
        _this._updateSelected([]);
      };

      _this._handleFocus = function (e) {
        _this.setState({ showMenu: true }, function () {
          return _this.props.onFocus(e);
        });
      };

      _this._handleInitialItemChange = function (initialItem) {
        var labelKey = _this.props.labelKey;

        var currentItem = _this.state.initialItem;

        // Don't update the initial item if it hasn't changed. For custom items,
        // compare the `labelKey` values since a unique id is generated each time,
        // causing the comparison to always return false otherwise.
        if ((0, _isEqual2.default)(initialItem, currentItem) || currentItem && initialItem && initialItem.customOption && initialItem[labelKey] === currentItem[labelKey]) {
          return;
        }

        _this.setState({ initialItem: initialItem });
      };

      _this._handleInputChange = function (e) {
        e.persist();
        var text = e.target.value;

        var _getInitialState = getInitialState(_this.props),
            activeIndex = _getInitialState.activeIndex,
            activeItem = _getInitialState.activeItem;

        var _this$props = _this.props,
            multiple = _this$props.multiple,
            onInputChange = _this$props.onInputChange;


        _this.setState({
          activeIndex: activeIndex,
          activeItem: activeItem,
          showMenu: true,
          text: text
        }, function () {
          return onInputChange(text, e);
        });

        // Clear any selections if text is entered in single-select mode.
        if (_this.state.selected.length && !multiple) {
          _this._updateSelected([]);
        }
      };

      _this._handleKeyDown = function (e, results, isMenuShown) {
        var activeItem = _this.state.activeItem;


        switch (e.keyCode) {
          case _keyCode.UP:
          case _keyCode.DOWN:
            if (!isMenuShown) {
              _this._showMenu();
              break;
            }

            var activeIndex = _this.state.activeIndex;

            // Prevents input cursor from going to the beginning when pressing up.

            e.preventDefault();

            // Increment or decrement index based on user keystroke.
            activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;

            // Skip over any disabled options.
            while (results[activeIndex] && results[activeIndex].disabled) {
              activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;
            }

            // If we've reached the end, go back to the beginning or vice-versa.
            if (activeIndex === results.length) {
              activeIndex = -1;
            } else if (activeIndex === -2) {
              activeIndex = results.length - 1;
            }

            _this._handleActiveIndexChange(activeIndex);
            break;
          case _keyCode.ESC:
            isMenuShown && _this._hideMenu();
            break;
          case _keyCode.RETURN:
            if (!isMenuShown) {
              break;
            }

            // Prevent form submission while menu is open.
            e.preventDefault();
            activeItem && _this._handleMenuItemSelect(activeItem, e);
            break;
          case _keyCode.RIGHT:
          case _keyCode.TAB:
            if (!isMenuShown) {
              break;
            }

            if (activeItem && !activeItem.paginationOption) {
              // Prevent blurring when selecting the active item.
              e.keyCode === _keyCode.TAB && e.preventDefault();
              _this._handleSelectionAdd(activeItem);
              break;
            }

            if (e.keyCode === _keyCode.TAB) {
              _this._hideMenu();
            }
            break;
        }

        _this.props.onKeyDown(e);
      };

      _this._handleMenuItemSelect = function (option, e) {
        if (option.paginationOption) {
          _this._handlePaginate(e);
        } else {
          _this._handleSelectionAdd(option);
        }
      };

      _this._handlePaginate = function (e) {
        e.persist();
        var _this$props2 = _this.props,
            maxResults = _this$props2.maxResults,
            onPaginate = _this$props2.onPaginate;


        _this.setState({
          shownResults: _this.state.shownResults + maxResults
        }, function () {
          return onPaginate(e);
        });
      };

      _this._handleSelectionAdd = function (selection) {
        var _this$props3 = _this.props,
            multiple = _this$props3.multiple,
            labelKey = _this$props3.labelKey;


        var selected = void 0;
        var text = void 0;

        if (multiple) {
          // If multiple selections are allowed, add the new selection to the
          // existing selections.
          selected = _this.state.selected.concat(selection);
          text = '';
        } else {
          // If only a single selection is allowed, replace the existing selection
          // with the new one.
          selected = [selection];
          text = (0, _utils.getOptionLabel)(selection, labelKey);
        }

        _this._hideMenu();
        _this.setState({
          initialItem: selection,
          text: text
        });

        // Text must be updated before the selection to fix #211.
        // TODO: Find a more robust way of solving the issue.
        _this._updateSelected(selected);
      };

      _this._handleSelectionRemove = function (selection) {
        var selected = _this.state.selected.filter(function (option) {
          return !(0, _isEqual2.default)(option, selection);
        });

        // Make sure the input stays focused after the item is removed.
        _this.focus();
        _this._hideMenu();
        _this._updateSelected(selected);
      };

      _this.handleClickOutside = function (e) {
        _this.state.showMenu && _this._hideMenu();
      };

      _this._hideMenu = function () {
        var _getInitialState2 = getInitialState(_this.props),
            activeIndex = _getInitialState2.activeIndex,
            activeItem = _getInitialState2.activeItem,
            showMenu = _getInitialState2.showMenu,
            shownResults = _getInitialState2.shownResults;

        _this.setState({
          activeIndex: activeIndex,
          activeItem: activeItem,
          showMenu: showMenu,
          shownResults: shownResults
        });
      };

      _this._showMenu = function () {
        _this.setState({ showMenu: true });
      };

      _this._updateSelected = function (selected) {
        _this.setState({ selected: selected }, function () {
          return _this.props.onChange(selected);
        });
      };

      _this.state = getInitialState(props);
      return _this;
    }

    _createClass(WrappedTypeahead, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          activeIndex: this.state.activeIndex,
          onActiveItemChange: this._handleActiveItemChange,
          onInitialItemChange: this._handleInitialItemChange,
          onMenuItemClick: this._handleMenuItemSelect
        };
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        // Generate random id here since doing it in defaultProps will generate
        // the same id for every instance.
        this._menuId = genId('rbt-menu-');
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.autoFocus && this.focus();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var labelKey = nextProps.labelKey,
            multiple = nextProps.multiple,
            selected = nextProps.selected;

        // If new selections are passed via props, treat as a controlled input.

        if (selected && !(0, _isEqual2.default)(selected, this.state.selected)) {
          this.setState({ selected: selected });

          if (multiple) {
            return;
          }

          this.setState({
            text: selected.length ? (0, _utils.getOptionLabel)((0, _head2.default)(selected), labelKey) : ''
          });
        }

        // Truncate selections when in single-select mode.
        var newSelected = selected || this.state.selected;
        if (!multiple && newSelected.length > 1) {
          newSelected = newSelected.slice(0, 1);
          this.setState({
            selected: newSelected,
            text: (0, _utils.getOptionLabel)((0, _head2.default)(newSelected), labelKey)
          });
          return;
        }

        if (multiple !== this.props.multiple) {
          this.setState({ text: '' });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            emptyLabel = _props.emptyLabel,
            filterBy = _props.filterBy,
            labelKey = _props.labelKey,
            minLength = _props.minLength,
            options = _props.options,
            paginate = _props.paginate,
            paginationText = _props.paginationText;
        var _state = this.state,
            shownResults = _state.shownResults,
            showMenu = _state.showMenu,
            text = _state.text;

        var mergedPropsAndState = _extends({}, this.props, this.state);

        var results = [];
        if (text.length >= minLength) {
          var cb = Array.isArray(filterBy) ? _utils.defaultFilterBy : filterBy;
          results = options.filter(function (option) {
            return cb(option, mergedPropsAndState);
          });
        }

        // This must come before results are truncated.
        var shouldPaginate = paginate && results.length > shownResults;

        // Truncate results if necessary.
        results = (0, _utils.getTruncatedOptions)(results, shownResults);

        // Add the custom option if necessary.
        if ((0, _utils.addCustomOption)(results, mergedPropsAndState)) {
          results.push(_defineProperty({
            customOption: true,
            id: (0, _uniqueId2.default)('new-id-')
          }, (0, _utils.getStringLabelKey)(labelKey), text));
        }

        // Add the pagination item if necessary.
        if (shouldPaginate) {
          var _results$push2;

          results.push((_results$push2 = {}, _defineProperty(_results$push2, (0, _utils.getStringLabelKey)(labelKey), paginationText), _defineProperty(_results$push2, 'paginationOption', true), _results$push2));
        }

        // This must come after the custom option is added, if applicable.
        var isMenuShown = !!(text.length >= minLength && showMenu && (results.length || emptyLabel));

        return _react2.default.createElement(Typeahead, _extends({}, this.props, this.state, {
          inputRef: function inputRef(input) {
            return _this2._input = input;
          },
          isMenuShown: isMenuShown,
          menuId: this.props.menuId || this._menuId,
          onAdd: this._handleSelectionAdd,
          onChange: this._handleInputChange,
          onClear: this._handleClear,
          onFocus: this._handleFocus,
          onInitialItemChange: this._handleInitialItemChange,
          onKeyDown: function onKeyDown(e) {
            return _this2._handleKeyDown(e, results, isMenuShown);
          },
          onRemove: this._handleSelectionRemove,
          results: results
        }));
      }

      /**
       * From `onClickOutside` HOC.
       */

    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.displayName = 'TypeaheadContainer(' + (0, _utils.getDisplayName)(Typeahead) + ')';

  WrappedTypeahead.propTypes = {
    /**
     * For localized accessibility: Should return a string indicating the number
     * of results for screen readers. Receives the current results.
     */
    a11yNumResults: _propTypes2.default.func,
    /**
     * For localized accessibility: Should return a string indicating the number
     * of selections for screen readers. Receives the current selections.
     */
    a11yNumSelected: _propTypes2.default.func,
    /**
     * Specify menu alignment. The default value is `justify`, which makes the
     * menu as wide as the input and truncates long values. Specifying `left`
     * or `right` will align the menu to that side and the width will be
     * determined by the length of menu item values.
     */
    align: _propTypes2.default.oneOf(['justify', 'left', 'right']),
    /**
     * Allows the creation of new selections on the fly. Note that any new items
     * will be added to the list of selections, but not the list of original
     * options unless handled as such by `Typeahead`'s parent.
     *
     * If a function is specified, it will be used to determine whether a custom
     * option should be included. The return value should be true or false.
     */
    allowNew: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    /**
     * Autofocus the input when the component initially mounts.
     */
    autoFocus: _propTypes2.default.bool,
    /**
     * Whether to render the menu inline or attach to `document.body`.
     */
    bodyContainer: _propTypes2.default.bool,
    /**
     * Whether or not filtering should be case-sensitive.
     */
    caseSensitive: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.caseSensitiveType),
    /**
     * Displays a button to clear the input when there are selections.
     */
    clearButton: _propTypes2.default.bool,
    /**
     * The initial value displayed in the text input.
     */
    defaultInputValue: (0, _propTypes3.checkPropType)(_propTypes2.default.string, _propTypes3.defaultInputValueType),
    /**
     * Specify any pre-selected options. Use only if you want the component to
     * be uncontrolled.
     */
    defaultSelected: _propTypes3.optionType,
    /**
     * Whether to disable the component.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Specify whether the menu should appear above the input.
     */
    dropup: _propTypes2.default.bool,
    /**
     * Message to display in the menu if there are no valid results.
     */
    emptyLabel: _propTypes2.default.node,
    /**
     * Either an array of fields in `option` to search, or a custom filtering
     * callback.
     */
    filterBy: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string.isRequired), _propTypes2.default.func]),
    /**
     * Whether or not to automatically adjust the position of the menu when it
     * reaches the viewport boundaries.
     */
    flip: _propTypes2.default.bool,
    /**
     * Highlights the menu item if there is only one result and allows selecting
     * that item by hitting enter. Does not work with `allowNew`.
     */
    highlightOnlyResult: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.highlightOnlyResultType),
    /**
     * Whether the filter should ignore accents and other diacritical marks.
     */
    ignoreDiacritics: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.ignoreDiacriticsType),
    /**
     * Props to be applied directly to the input. `onBlur`, `onChange`,
     * `onFocus`, and `onKeyDown` are ignored.
     */
    inputProps: (0, _propTypes3.checkPropType)(_propTypes2.default.object, _propTypes3.inputPropsType),
    /**
     * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
     */
    isInvalid: _propTypes2.default.bool,
    /**
     * Indicate whether an asynchronous data fetch is happening.
     */
    isLoading: _propTypes2.default.bool,
    /**
     * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
     */
    isValid: _propTypes2.default.bool,
    /**
     * Specify the option key to use for display or a function returning the
     * display string. By default, the selector will use the `label` key.
     */
    labelKey: (0, _propTypes3.checkPropType)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]), _propTypes3.labelKeyType),
    /**
     * Maximum number of results to display by default. Mostly done for
     * performance reasons so as not to render too many DOM nodes in the case of
     * large data sets.
     */
    maxResults: _propTypes2.default.number,
    /**
     * Id applied to the top-level menu element. Required for accessibility.
     */
    menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    /**
     * Number of input characters that must be entered before showing results.
     */
    minLength: _propTypes2.default.number,
    /**
     * Whether or not multiple selections are allowed.
     */
    multiple: _propTypes2.default.bool,
    /**
     * Invoked when the input is blurred. Receives an event.
     */
    onBlur: _propTypes2.default.func,
    /**
     * Invoked whenever items are added or removed. Receives an array of the
     * selected options.
     */
    onChange: _propTypes2.default.func,
    /**
     * Invoked when the input is focused. Receives an event.
     */
    onFocus: _propTypes2.default.func,
    /**
     * Invoked when the input value changes. Receives the string value of the
     * input.
     */
    onInputChange: _propTypes2.default.func,
    /**
     * Invoked when a key is pressed. Receives an event.
     */
    onKeyDown: _propTypes2.default.func,
    /**
     * Invoked when the menu is hidden.
     */
    onMenuHide: _propTypes2.default.func,
    /**
     * Invoked when the menu is shown.
     */
    onMenuShow: _propTypes2.default.func,
    /**
     * Invoked when the pagination menu item is clicked. Receives an event.
     */
    onPaginate: _propTypes2.default.func,
    /**
     * Full set of options, including pre-selected options. Must either be an
     * array of objects (recommended) or strings.
     */
    options: _propTypes3.optionType.isRequired,
    /**
     * Give user the ability to display additional results if the number of
     * results exceeds `maxResults`.
     */
    paginate: _propTypes2.default.bool,
    /**
     * Prompt displayed when large data sets are paginated.
     */
    paginationText: _propTypes2.default.string,
    /**
     * Placeholder text for the input.
     */
    placeholder: _propTypes2.default.string,
    /**
     * Callback for custom menu rendering.
     */
    renderMenu: _propTypes2.default.func,
    /**
     * The selected option(s) displayed in the input. Use this prop if you want
     * to control the component via its parent.
     */
    selected: _propTypes3.optionType,
    /**
     * Allows selecting the hinted result by pressing enter.
     */
    selectHintOnEnter: _propTypes2.default.bool
  };

  WrappedTypeahead.defaultProps = {
    a11yNumResults: function a11yNumResults(results) {
      var resultString = (0, _utils.pluralize)('result', results.length);
      return resultString + '. Use up and down arrow keys to navigate.';
    },
    a11yNumSelected: function a11yNumSelected(selected) {
      return (0, _utils.pluralize)('selection', selected.length);
    },
    align: 'justify',
    allowNew: false,
    autoFocus: false,
    bodyContainer: false,
    caseSensitive: false,
    clearButton: false,
    defaultInputValue: '',
    defaultSelected: [],
    disabled: false,
    dropup: false,
    emptyLabel: 'No matches found.',
    filterBy: [],
    flip: false,
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    inputProps: {},
    isInvalid: false,
    isLoading: false,
    isValid: false,
    labelKey: _defaultLabelKey.DEFAULT_LABELKEY,
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: _noop2.default,
    onChange: _noop2.default,
    onFocus: _noop2.default,
    onInputChange: _noop2.default,
    onKeyDown: _noop2.default,
    onMenuHide: _noop2.default,
    onMenuShow: _noop2.default,
    onPaginate: _noop2.default,
    paginate: true,
    paginationText: 'Display additional results...',
    placeholder: '',
    selectHintOnEnter: false
  };

  WrappedTypeahead.childContextTypes = {
    activeIndex: _propTypes2.default.number.isRequired,
    onActiveItemChange: _propTypes2.default.func.isRequired,
    onInitialItemChange: _propTypes2.default.func.isRequired,
    onMenuItemClick: _propTypes2.default.func.isRequired
  };

  return (0, _reactOnclickoutside2.default)(WrappedTypeahead);
}

exports.default = typeaheadContainer;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(1017);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(249),
    flatRest = __webpack_require__(389),
    getData = __webpack_require__(406),
    getFuncName = __webpack_require__(407),
    isArray = __webpack_require__(41),
    isLaziable = __webpack_require__(1020);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(377);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(251),
    getData = __webpack_require__(406),
    getFuncName = __webpack_require__(407),
    lodash = __webpack_require__(1021);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(251),
    LodashWrapper = __webpack_require__(249),
    baseLodash = __webpack_require__(250),
    isArray = __webpack_require__(41),
    isObjectLike = __webpack_require__(76),
    wrapperClone = __webpack_require__(1022);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(251),
    LodashWrapper = __webpack_require__(249),
    copyArray = __webpack_require__(1023);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(380);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _head = __webpack_require__(246);

var _head2 = _interopRequireDefault(_head);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _keyCode = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function highlightOnlyResultContainer(Typeahead) {
  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedTypeahead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isOnlyResult: false
      }, _this._handleKeyDown = function (e) {
        var _this$props = _this.props,
            initialItem = _this$props.initialItem,
            onKeyDown = _this$props.onKeyDown,
            onAdd = _this$props.onAdd;


        switch (e.keyCode) {
          case _keyCode.RETURN:
            if (_this.state.isOnlyResult) {
              onAdd(initialItem);
            }
            break;
        }

        onKeyDown(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedTypeahead, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowNew = nextProps.allowNew,
            highlightOnlyResult = nextProps.highlightOnlyResult,
            results = nextProps.results;


        if (!highlightOnlyResult || allowNew) {
          return;
        }

        if (results.length !== this.props.results.length) {
          this.setState({
            isOnlyResult: results.length === 1 && !(0, _head2.default)(results).disabled
          });
        }
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          isOnlyResult: this.state.isOnlyResult
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Typeahead, _extends({}, this.props, {
          onKeyDown: this._handleKeyDown
        }));
      }
    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.childContextTypes = {
    isOnlyResult: _propTypes2.default.bool.isRequired
  };

  return WrappedTypeahead;
}

exports.default = highlightOnlyResultContainer;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionType = exports.labelKeyType = exports.inputPropsType = exports.ignoreDiacriticsType = exports.highlightOnlyResultType = exports.defaultInputValueType = exports.checkPropType = exports.caseSensitiveType = undefined;

var _caseSensitiveType2 = __webpack_require__(1027);

var _caseSensitiveType3 = _interopRequireDefault(_caseSensitiveType2);

var _checkPropType2 = __webpack_require__(1028);

var _checkPropType3 = _interopRequireDefault(_checkPropType2);

var _defaultInputValueType2 = __webpack_require__(1029);

var _defaultInputValueType3 = _interopRequireDefault(_defaultInputValueType2);

var _highlightOnlyResultType2 = __webpack_require__(1030);

var _highlightOnlyResultType3 = _interopRequireDefault(_highlightOnlyResultType2);

var _ignoreDiacriticsType2 = __webpack_require__(1031);

var _ignoreDiacriticsType3 = _interopRequireDefault(_ignoreDiacriticsType2);

var _inputPropsType2 = __webpack_require__(1032);

var _inputPropsType3 = _interopRequireDefault(_inputPropsType2);

var _labelKeyType2 = __webpack_require__(1033);

var _labelKeyType3 = _interopRequireDefault(_labelKeyType2);

var _optionType2 = __webpack_require__(1034);

var _optionType3 = _interopRequireDefault(_optionType2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.caseSensitiveType = _caseSensitiveType3.default; /* eslint-disable object-curly-spacing */

exports.checkPropType = _checkPropType3.default;
exports.defaultInputValueType = _defaultInputValueType3.default;
exports.highlightOnlyResultType = _highlightOnlyResultType3.default;
exports.ignoreDiacriticsType = _ignoreDiacriticsType3.default;
exports.inputPropsType = _inputPropsType3.default;
exports.labelKeyType = _labelKeyType3.default;
exports.optionType = _optionType3.default;
/* eslint-enable object-curly-spacing */

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = caseSensitiveType;

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function caseSensitiveType(props, propName, componentName) {
  var caseSensitive = props.caseSensitive,
      filterBy = props.filterBy;

  (0, _warn2.default)(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkPropType;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Allows additional warnings or messaging related to prop validation.
 */
function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    _propTypes2.default.checkPropTypes(_defineProperty({}, propName, validator), props, 'prop', componentName);

    typeof callback === 'function' && callback(props, propName, componentName);
  };
}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultInputValueType;

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultInputValueType(props, propName, componentName) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      multiple = props.multiple,
      selected = props.selected;

  var name = defaultSelected.length ? 'defaultSelected' : 'selected';

  (0, _warn2.default)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), '`defaultInputValue` will be overridden by the value from `' + name + '`.');
}

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = highlightOnlyResultType;

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function highlightOnlyResultType(props, propName, componentName) {
  var allowNew = props.allowNew,
      highlightOnlyResult = props.highlightOnlyResult;

  (0, _warn2.default)(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ignoreDiacriticsType;

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ignoreDiacriticsType(props, propName, componentName) {
  var filterBy = props.filterBy,
      ignoreDiacritics = props.ignoreDiacritics;

  (0, _warn2.default)(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inputPropsType;

var _isPlainObject = __webpack_require__(384);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLACKLIST = [{ alt: 'onBlur', prop: 'onBlur' }, { alt: 'onInputChange', prop: 'onChange' }, { alt: 'onFocus', prop: 'onFocus' }, { alt: 'onKeyDown', prop: 'onKeyDown' }];

function inputPropsType(props, propName, componentName) {
  var inputProps = props.inputProps;

  if (!(inputProps && (0, _isPlainObject2.default)(inputProps))) {
    return;
  }

  // Blacklisted properties.
  BLACKLIST.forEach(function (_ref) {
    var alt = _ref.alt,
        prop = _ref.prop;

    var msg = alt ? ' Use the top-level `' + alt + '` prop instead.' : null;
    (0, _warn2.default)(!inputProps.hasOwnProperty(prop), 'The `' + prop + '` property of `inputProps` will be ignored.' + msg);
  });
}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labelKeyType;

var _warn = __webpack_require__(77);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function labelKeyType(props, propName, componentName) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey;

  (0, _warn2.default)(!(typeof labelKey === 'function' && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.object.isRequired), _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired)]);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({placeholder0:{id:'RegionChangerController.placeholder0',description:'Texto para el placeholder del componente para el cambio de region para la capa 0',defaultMessage:'Seleccionar región'},placeholder1:{id:'RegionChangerController.placeholder1',description:'Texto para el placeholder del componente para el cambio de region para la capa 1',defaultMessage:'Cambiar de región'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Loading=function Loading(){var BASE_URL= true?"/competitiveness-observatory":'';return(// <span style={{ textAlign: 'center' }}>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+'/img/loading.svg',alt:'Loading...',style:{marginTop:'10px',maxHeight:'24px'}})// </span>
);};/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomeMap__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(27);
var mapStateToProps=function mapStateToProps(state){return{regionsData:state.REGIONS.regionsData,countriesData:state.REGIONS.countriesData};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSelectedRegionId:function setSelectedRegionId(selectedRegionId){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].setSelectedRegionId(selectedRegionId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__HomeMap__["a" /* default */])));

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeMapAdapter__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomeMapConfig__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeMap=function(_Component){_inherits(HomeMap,_Component);function HomeMap(props){_classCallCheck(this,HomeMap);var _this=_possibleConstructorReturn(this,(HomeMap.__proto__||Object.getPrototypeOf(HomeMap)).call(this,props));_this.changeRegion=function(region){var selectedCode=region.code;var oldURL=_this.props.history.location.pathname;var newURL=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getSameURLWithChangedRegion({url:oldURL,regionCode:selectedCode});if(oldURL!==newURL){_this.props.history.push(newURL);}_this.props.setSelectedRegionId(region.id);};_this.state={loading:true,error:false};return _this;}_createClass(HomeMap,[{key:'componentDidMount',value:function componentDidMount(){var chartConfig=__WEBPACK_IMPORTED_MODULE_3__HomeMapConfig__["a" /* default */].generalConfig;var series=__WEBPACK_IMPORTED_MODULE_2__HomeMapAdapter__["a" /* default */].formatMapSeries({regionsData:this.props.regionsData,fn:this.changeRegion});chartConfig.series=series;this.setState({chartConfig:chartConfig,loading:false,error:false});}},{key:'renderIfAllOK',value:function renderIfAllOK(){if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Error__["a" /* default */],null);}else if(this.state.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Loading__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src___default.a,{ref:this.mapChart,config:this.state.chartConfig});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return HomeMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeMap);

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highmaps JS v6.1.2 (2018-08-31)

 (c) 2011-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(T,J){"object"===typeof module&&module.exports?module.exports=T.document?J(T):J: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return J(T)}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):T.Highcharts=J(T)})("undefined"!==typeof window?window:this,function(T){var J=function(){var a="undefined"===typeof T?window:T,B=a.document,y=a.navigator&&a.navigator.userAgent||"",D=B&&B.createElementNS&&!!B.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,p=/(edge|msie|trident)/i.test(y)&&!a.opera,d=-1!==y.indexOf("Firefox"),
m=-1!==y.indexOf("Chrome"),v=d&&4>parseInt(y.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highmaps",version:"6.1.2",deg2rad:2*Math.PI/360,doc:B,hasBidiBug:v,hasTouch:B&&void 0!==B.documentElement.ontouchstart,isMS:p,isWebKit:-1!==y.indexOf("AppleWebKit"),isFirefox:d,isChrome:m,isSafari:!m&&-1!==y.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(y),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:D,win:a,marginNames:["plotTop",
"marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var B=a.charts,y=a.doc,D=a.win;a.error=function(p,d){p=a.isNumber(p)?"Highcharts error #"+p+": www.highcharts.com/errors/"+p:p;if(d)throw Error(p);D.console&&console.log(p)};a.Fx=function(a,d,m){this.options=d;this.elem=a;this.prop=m};a.Fx.prototype={dSetter:function(){var a=this.paths[0],d=this.paths[1],m=[],v=this.now,t=a.length,q;if(1===v)m=this.toD;else if(t===d.length&&1>v)for(;t--;)q=parseFloat(a[t]),
m[t]=isNaN(q)?d[t]:v*parseFloat(d[t]-q)+q;else m=d;this.elem.attr("d",m,null,!0)},update:function(){var a=this.elem,d=this.prop,m=this.now,v=this.options.step;if(this[d+"Setter"])this[d+"Setter"]();else a.attr?a.element&&a.attr(d,m,null,!0):a.style[d]=m+this.unit;v&&v.call(a,m,this)},run:function(p,d,m){var v=this,t=v.options,q=function(a){return q.stopped?!1:v.step(a)},l=D.requestAnimationFrame||function(a){setTimeout(a,13)},g=function(){for(var f=0;f<a.timers.length;f++)a.timers[f]()||a.timers.splice(f--,
1);a.timers.length&&l(g)};p!==d||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=p,this.end=d,this.unit=m,this.now=this.start,this.pos=0,q.elem=this.elem,q.prop=this.prop,q()&&1===a.timers.push(q)&&l(g)):(delete t.curAnim[this.prop],t.complete&&0===a.keys(t.curAnim).length&&t.complete.call(this.elem))},step:function(p){var d=+new Date,m,v=this.options,t=this.elem,q=v.complete,l=v.duration,g=v.curAnim;t.attr&&!t.element?p=!1:p||d>=l+this.startTime?(this.now=this.end,this.pos=
1,this.update(),m=g[this.prop]=!0,a.objectEach(g,function(a){!0!==a&&(m=!1)}),m&&q&&q.call(t),p=!1):(this.pos=v.easing((d-this.startTime)/l),this.now=this.start+(this.end-this.start)*this.pos,this.update(),p=!0);return p},initPath:function(p,d,m){function v(a){var b,c;for(e=a.length;e--;)b="M"===a[e]||"L"===a[e],c=/[a-zA-Z]/.test(a[e+3]),b&&c&&a.splice(e+1,0,a[e+1],a[e+2],a[e+1],a[e+2])}function t(a,b){for(;a.length<c;){a[0]=b[c-a.length];var f=a.slice(0,w);[].splice.apply(a,[0,0].concat(f));n&&(f=
a.slice(a.length-w),[].splice.apply(a,[a.length,0].concat(f)),e--)}a[0]="M"}function q(a,e){for(var f=(c-a.length)/w;0<f&&f--;)b=a.slice().splice(a.length/A-w,w*A),b[0]=e[c-w-f*w],h&&(b[w-6]=b[w-2],b[w-5]=b[w-1]),[].splice.apply(a,[a.length/A,0].concat(b)),n&&f--}d=d||"";var l,g=p.startX,f=p.endX,h=-1<d.indexOf("C"),w=h?7:3,c,b,e;d=d.split(" ");m=m.slice();var n=p.isArea,A=n?2:1,G;h&&(v(d),v(m));if(g&&f){for(e=0;e<g.length;e++)if(g[e]===f[0]){l=e;break}else if(g[0]===f[f.length-g.length+e]){l=e;G=
!0;break}void 0===l&&(d=[])}d.length&&a.isNumber(l)&&(c=m.length+l*A*w,G?(t(d,m),q(m,d)):(t(m,d),q(d,m)));return[d,m]},fillSetter:function(){a.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)}};a.merge=function(){var p,d=arguments,m,v={},t=function(q,l){"object"!==typeof q&&(q={});a.objectEach(l,function(g,f){!a.isObject(g,!0)||a.isClass(g)||a.isDOMElement(g)?q[f]=l[f]:q[f]=t(q[f]||{},
g)});return q};!0===d[0]&&(v=d[1],d=Array.prototype.slice.call(d,2));m=d.length;for(p=0;p<m;p++)v=t(v,d[p]);return v};a.pInt=function(a,d){return parseInt(a,d||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(p,d){return!!p&&"object"===typeof p&&(!d||!a.isArray(p))};a.isDOMElement=function(p){return a.isObject(p)&&"number"===typeof p.nodeType};a.isClass=function(p){var d=
p&&p.constructor;return!(!a.isObject(p,!0)||a.isDOMElement(p)||!d||!d.name||"Object"===d.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=function(a,d){for(var m=a.length;m--;)if(a[m]===d){a.splice(m,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(p,d,m){var v;a.isString(d)?a.defined(m)?p.setAttribute(d,m):p&&p.getAttribute&&((v=p.getAttribute(d))||"class"!==d||(v=p.getAttribute(d+"Name"))):a.defined(d)&&a.isObject(d)&&
a.objectEach(d,function(a,q){p.setAttribute(q,a)});return v};a.splat=function(p){return a.isArray(p)?p:[p]};a.syncTimeout=function(a,d,m){if(d)return setTimeout(a,d,m);a.call(0,m)};a.clearTimeout=function(p){a.defined(p)&&clearTimeout(p)};a.extend=function(a,d){var m;a||(a={});for(m in d)a[m]=d[m];return a};a.pick=function(){var a=arguments,d,m,v=a.length;for(d=0;d<v;d++)if(m=a[d],void 0!==m&&null!==m)return m};a.css=function(p,d){a.isMS&&!a.svg&&d&&void 0!==d.opacity&&(d.filter="alpha(opacity\x3d"+
100*d.opacity+")");a.extend(p.style,d)};a.createElement=function(p,d,m,v,t){p=y.createElement(p);var q=a.css;d&&a.extend(p,d);t&&q(p,{padding:0,border:"none",margin:0});m&&q(p,m);v&&v.appendChild(p);return p};a.extendClass=function(p,d){var m=function(){};m.prototype=new p;a.extend(m.prototype,d);return m};a.pad=function(a,d,m){return Array((d||2)+1-String(a).replace("-","").length).join(m||0)+a};a.relativeLength=function(a,d,m){return/%$/.test(a)?d*parseFloat(a)/100+(m||0):parseFloat(a)};a.wrap=
function(a,d,m){var p=a[d];a[d]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,l=this;l.proceed=function(){p.apply(l,arguments.length?arguments:q)};a.unshift(p);a=m.apply(this,a);l.proceed=null;return a}};a.formatSingle=function(p,d,m){var v=/\.([0-9])/,t=a.defaultOptions.lang;/f$/.test(p)?(m=(m=p.match(v))?m[1]:-1,null!==d&&(d=a.numberFormat(d,m,t.decimalPoint,-1<p.indexOf(",")?t.thousandsSep:""))):d=(m||a.time).dateFormat(p,d);return d};a.format=function(p,d,m){for(var v="{",
t=!1,q,l,g,f,h=[],w;p;){v=p.indexOf(v);if(-1===v)break;q=p.slice(0,v);if(t){q=q.split(":");l=q.shift().split(".");f=l.length;w=d;for(g=0;g<f;g++)w&&(w=w[l[g]]);q.length&&(w=a.formatSingle(q.join(":"),w,m));h.push(w)}else h.push(q);p=p.slice(v+1);v=(t=!t)?"}":"{"}h.push(p);return h.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(p,d,m,v,t){var q,l=p;m=a.pick(m,1);q=p/m;d||(d=t?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],
!1===v&&(1===m?d=a.grep(d,function(a){return 0===a%1}):.1>=m&&(d=[1/m])));for(v=0;v<d.length&&!(l=d[v],t&&l*m>=p||!t&&q<=(d[v]+(d[v+1]||d[v]))/2);v++);return l=a.correctFloat(l*m,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,d){var m=a.length,p,t;for(t=0;t<m;t++)a[t].safeI=t;a.sort(function(a,l){p=d(a,l);return 0===p?a.safeI-l.safeI:p});for(t=0;t<m;t++)delete a[t].safeI};a.arrayMin=function(a){for(var d=a.length,m=a[0];d--;)a[d]<m&&(m=a[d]);return m};a.arrayMax=function(a){for(var d=
a.length,m=a[0];d--;)a[d]>m&&(m=a[d]);return m};a.destroyObjectProperties=function(p,d){a.objectEach(p,function(a,v){a&&a!==d&&a.destroy&&a.destroy();delete p[v]})};a.discardElement=function(p){var d=a.garbageBin;d||(d=a.createElement("div"));p&&d.appendChild(p);d.innerHTML=""};a.correctFloat=function(a,d){return parseFloat(a.toPrecision(d||14))};a.setAnimation=function(p,d){d.renderer.globalAnimation=a.pick(p,d.options.chart.animation,!0)};a.animObject=function(p){return a.isObject(p)?a.merge(p):
{duration:p?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(p,d,m,v){p=+p||0;d=+d;var t=a.defaultOptions.lang,q=(p.toString().split(".")[1]||"").split("e")[0].length,l,g,f=p.toString().split("e");-1===d?d=Math.min(q,20):a.isNumber(d)?d&&f[1]&&0>f[1]&&(l=d+ +f[1],0<=l?(f[0]=(+f[0]).toExponential(l).split("e")[0],d=l):(f[0]=f[0].split(".")[0]||0,p=20>d?(f[0]*Math.pow(10,f[1])).toFixed(d):0,f[1]=0)):d=2;g=(Math.abs(f[1]?
f[0]:p)+Math.pow(10,-Math.max(d,q)-1)).toFixed(d);q=String(a.pInt(g));l=3<q.length?q.length%3:0;m=a.pick(m,t.decimalPoint);v=a.pick(v,t.thousandsSep);p=(0>p?"-":"")+(l?q.substr(0,l)+v:"");p+=q.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+v);d&&(p+=m+g.slice(-d));f[1]&&0!==+p&&(p+="e"+f[1]);return p};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(p,d,m){if("width"===d)return Math.max(0,Math.min(p.offsetWidth,p.scrollWidth)-a.getStyle(p,"padding-left")-a.getStyle(p,
"padding-right"));if("height"===d)return Math.max(0,Math.min(p.offsetHeight,p.scrollHeight)-a.getStyle(p,"padding-top")-a.getStyle(p,"padding-bottom"));D.getComputedStyle||a.error(27,!0);if(p=D.getComputedStyle(p,void 0))p=p.getPropertyValue(d),a.pick(m,"opacity"!==d)&&(p=a.pInt(p));return p};a.inArray=function(p,d,m){return(a.indexOfPolyfill||Array.prototype.indexOf).call(d,p,m)};a.grep=function(p,d){return(a.filterPolyfill||Array.prototype.filter).call(p,d)};a.find=Array.prototype.find?function(a,
d){return a.find(d)}:function(a,d){var m,p=a.length;for(m=0;m<p;m++)if(d(a[m],m))return a[m]};a.some=function(p,d,m){return(a.somePolyfill||Array.prototype.some).call(p,d,m)};a.map=function(a,d){for(var m=[],p=0,t=a.length;p<t;p++)m[p]=d.call(a[p],a[p],p,a);return m};a.keys=function(p){return(a.keysPolyfill||Object.keys).call(void 0,p)};a.reduce=function(p,d,m){return(a.reducePolyfill||Array.prototype.reduce).apply(p,2<arguments.length?[d,m]:[d])};a.offset=function(a){var d=y.documentElement;a=a.parentElement||
a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(D.pageYOffset||d.scrollTop)-(d.clientTop||0),left:a.left+(D.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}};a.stop=function(p,d){for(var m=a.timers.length;m--;)a.timers[m].elem!==p||d&&d!==a.timers[m].prop||(a.timers[m].stopped=!0)};a.each=function(p,d,m){return(a.forEachPolyfill||Array.prototype.forEach).call(p,d,m)};a.objectEach=function(a,d,m){for(var p in a)a.hasOwnProperty(p)&&d.call(m||a[p],a[p],p,a)};a.addEvent=function(p,
d,m,v){var t,q=p.addEventListener||a.addEventListenerPolyfill;t="function"===typeof p&&p.prototype?p.prototype.protoEvents=p.prototype.protoEvents||{}:p.hcEvents=p.hcEvents||{};a.Point&&p instanceof a.Point&&p.series&&p.series.chart&&(p.series.chart.runTrackerClick=!0);q&&q.call(p,d,m,!1);t[d]||(t[d]=[]);t[d].push(m);v&&a.isNumber(v.order)&&(m.order=v.order,t[d].sort(function(a,g){return a.order-g.order}));return function(){a.removeEvent(p,d,m)}};a.removeEvent=function(p,d,m){function v(g,f){var l=
p.removeEventListener||a.removeEventListenerPolyfill;l&&l.call(p,g,f,!1)}function t(g){var f,l;p.nodeName&&(d?(f={},f[d]=!0):f=g,a.objectEach(f,function(a,c){if(g[c])for(l=g[c].length;l--;)v(c,g[c][l])}))}var q,l;a.each(["protoEvents","hcEvents"],function(g){var f=p[g];f&&(d?(q=f[d]||[],m?(l=a.inArray(m,q),-1<l&&(q.splice(l,1),f[d]=q),v(d,m)):(t(f),f[d]=[])):(t(f),p[g]={}))})};a.fireEvent=function(p,d,m,v){var t,q,l,g,f;m=m||{};y.createEvent&&(p.dispatchEvent||p.fireEvent)?(t=y.createEvent("Events"),
t.initEvent(d,!0,!0),a.extend(t,m),p.dispatchEvent?p.dispatchEvent(t):p.fireEvent(d,t)):a.each(["protoEvents","hcEvents"],function(h){if(p[h])for(q=p[h][d]||[],l=q.length,m.target||a.extend(m,{preventDefault:function(){m.defaultPrevented=!0},target:p,type:d}),g=0;g<l;g++)(f=q[g])&&!1===f.call(p,m)&&m.preventDefault()});v&&!m.defaultPrevented&&v.call(p,m)};a.animate=function(p,d,m){var v,t="",q,l,g;a.isObject(m)||(g=arguments,m={duration:g[2],easing:g[3],complete:g[4]});a.isNumber(m.duration)||(m.duration=
400);m.easing="function"===typeof m.easing?m.easing:Math[m.easing]||Math.easeInOutSine;m.curAnim=a.merge(d);a.objectEach(d,function(f,g){a.stop(p,g);l=new a.Fx(p,m,g);q=null;"d"===g?(l.paths=l.initPath(p,p.d,d.d),l.toD=d.d,v=0,q=1):p.attr?v=p.attr(g):(v=parseFloat(a.getStyle(p,g))||0,"opacity"!==g&&(t="px"));q||(q=f);q&&q.match&&q.match("px")&&(q=q.replace(/px/g,""));l.run(v,q,t)})};a.seriesType=function(p,d,m,v,t){var q=a.getOptions(),l=a.seriesTypes;q.plotOptions[p]=a.merge(q.plotOptions[d],m);
l[p]=a.extendClass(l[d]||function(){},v);l[p].prototype.type=p;t&&(l[p].prototype.pointClass=a.extendClass(a.Point,t));return l[p]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),d=0;return function(){return"highcharts-"+a+"-"+d++}}();D.jQuery&&(D.jQuery.fn.highcharts=function(){var p=[].slice.call(arguments);if(this[0])return p[0]?(new (a[a.isString(p[0])?p.shift():"Chart"])(this[0],p[0],p[1]),this):B[a.attr(this[0],"data-highcharts-chart")]})})(J);(function(a){var B=a.each,
y=a.isNumber,D=a.map,p=a.merge,d=a.pInt;a.Color=function(d){if(!(this instanceof a.Color))return new a.Color(d);this.init(d)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[d(a[1]),d(a[2]),d(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[d(a[1]),d(a[2]),d(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(d){var m,
p,q,l;if((this.input=d=this.names[d&&d.toLowerCase?d.toLowerCase():""]||d)&&d.stops)this.stops=D(d.stops,function(g){return new a.Color(g[1])});else if(d&&d.charAt&&"#"===d.charAt()&&(m=d.length,d=parseInt(d.substr(1),16),7===m?p=[(d&16711680)>>16,(d&65280)>>8,d&255,1]:4===m&&(p=[(d&3840)>>4|(d&3840)>>8,(d&240)>>4|d&240,(d&15)<<4|d&15,1])),!p)for(q=this.parsers.length;q--&&!p;)l=this.parsers[q],(m=l.regex.exec(d))&&(p=l.parse(m));this.rgba=p||[]},get:function(a){var d=this.input,m=this.rgba,q;this.stops?
(q=p(d),q.stops=[].concat(q.stops),B(this.stops,function(l,g){q.stops[g]=[q.stops[g][0],l.get(a)]})):q=m&&y(m[0])?"rgb"===a||!a&&1===m[3]?"rgb("+m[0]+","+m[1]+","+m[2]+")":"a"===a?m[3]:"rgba("+m.join(",")+")":d;return q},brighten:function(a){var m,p=this.rgba;if(this.stops)B(this.stops,function(d){d.brighten(a)});else if(y(a)&&0!==a)for(m=0;3>m;m++)p[m]+=d(255*a),0>p[m]&&(p[m]=0),255<p[m]&&(p[m]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,d){var m=this.rgba,
q=a.rgba;q.length&&m&&m.length?(a=1!==q[3]||1!==m[3],d=(a?"rgba(":"rgb(")+Math.round(q[0]+(m[0]-q[0])*(1-d))+","+Math.round(q[1]+(m[1]-q[1])*(1-d))+","+Math.round(q[2]+(m[2]-q[2])*(1-d))+(a?","+(q[3]+(m[3]-q[3])*(1-d)):"")+")"):d=a.input||"none";return d}};a.color=function(d){return new a.Color(d)}})(J);(function(a){var B=a.defined,y=a.each,D=a.extend,p=a.merge,d=a.pick,m=a.timeUnits,v=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(a){var q=d(a&&a.useUTC,
!0),l=this;this.options=a=p(!0,this.options||{},a);this.Date=a.Date||v.Date;this.timezoneOffset=(this.useUTC=q)&&a.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(q&&!a.getTimezoneOffset&&!a.timezone))||this.timezoneOffset?(this.get=function(a,f){var g=f.getTime(),w=g-l.getTimezoneOffset(f);f.setTime(w);a=f["getUTC"+a]();f.setTime(g);return a},this.set=function(a,f,h){var g;if("Milliseconds"===a||"Seconds"===a||"Minutes"===a&&0===f.getTimezoneOffset()%
60)f["set"+a](h);else g=l.getTimezoneOffset(f),g=f.getTime()-g,f.setTime(g),f["setUTC"+a](h),a=l.getTimezoneOffset(f),g=f.getTime()+a,f.setTime(g)}):q?(this.get=function(a,f){return f["getUTC"+a]()},this.set=function(a,f,l){return f["setUTC"+a](l)}):(this.get=function(a,f){return f["get"+a]()},this.set=function(a,f,l){return f["set"+a](l)})},makeTime:function(m,q,l,g,f,h){var w,c,b;this.useUTC?(w=this.Date.UTC.apply(0,arguments),c=this.getTimezoneOffset(w),w+=c,b=this.getTimezoneOffset(w),c!==b?w+=
b-c:c-36E5!==this.getTimezoneOffset(w-36E5)||a.isSafari||(w-=36E5)):w=(new this.Date(m,q,d(l,1),d(g,0),d(f,0),d(h,0))).getTime();return w},timezoneOffsetFunction:function(){var d=this,q=this.options,l=v.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(q.timezone){if(l)return function(a){return 6E4*-l.tz(a,q.timezone).utcOffset()};a.error(25)}return this.useUTC&&q.getTimezoneOffset?function(a){return 6E4*q.getTimezoneOffset(a)}:function(){return 6E4*(d.timezoneOffset||
0)}},dateFormat:function(d,q,l){if(!a.defined(q)||isNaN(q))return a.defaultOptions.lang.invalidDate||"";d=a.pick(d,"%Y-%m-%d %H:%M:%S");var g=this,f=new this.Date(q),h=this.get("Hours",f),w=this.get("Day",f),c=this.get("Date",f),b=this.get("Month",f),e=this.get("FullYear",f),n=a.defaultOptions.lang,A=n.weekdays,G=n.shortWeekdays,C=a.pad,f=a.extend({a:G?G[w]:A[w].substr(0,3),A:A[w],d:C(c),e:C(c,2," "),w:w,b:n.shortMonths[b],B:n.months[b],m:C(b+1),o:b+1,y:e.toString().substr(2,2),Y:e,H:C(h),k:h,I:C(h%
12||12),l:h%12||12,M:C(g.get("Minutes",f)),p:12>h?"AM":"PM",P:12>h?"am":"pm",S:C(f.getSeconds()),L:C(Math.round(q%1E3),3)},a.dateFormats);a.objectEach(f,function(a,b){for(;-1!==d.indexOf("%"+b);)d=d.replace("%"+b,"function"===typeof a?a.call(g,q):a)});return l?d.substr(0,1).toUpperCase()+d.substr(1):d},getTimeTicks:function(a,q,l,g){var f=this,h=[],w={},c,b=new f.Date(q),e=a.unitRange,n=a.count||1,A;if(B(q)){f.set("Milliseconds",b,e>=m.second?0:n*Math.floor(f.get("Milliseconds",b)/n));e>=m.second&&
f.set("Seconds",b,e>=m.minute?0:n*Math.floor(f.get("Seconds",b)/n));e>=m.minute&&f.set("Minutes",b,e>=m.hour?0:n*Math.floor(f.get("Minutes",b)/n));e>=m.hour&&f.set("Hours",b,e>=m.day?0:n*Math.floor(f.get("Hours",b)/n));e>=m.day&&f.set("Date",b,e>=m.month?1:n*Math.floor(f.get("Date",b)/n));e>=m.month&&(f.set("Month",b,e>=m.year?0:n*Math.floor(f.get("Month",b)/n)),c=f.get("FullYear",b));e>=m.year&&f.set("FullYear",b,c-c%n);e===m.week&&f.set("Date",b,f.get("Date",b)-f.get("Day",b)+d(g,1));c=f.get("FullYear",
b);g=f.get("Month",b);var G=f.get("Date",b),C=f.get("Hours",b);q=b.getTime();f.variableTimezone&&(A=l-q>4*m.month||f.getTimezoneOffset(q)!==f.getTimezoneOffset(l));b=b.getTime();for(q=1;b<l;)h.push(b),b=e===m.year?f.makeTime(c+q*n,0):e===m.month?f.makeTime(c,g+q*n):!A||e!==m.day&&e!==m.week?A&&e===m.hour&&1<n?f.makeTime(c,g,G,C+q*n):b+e*n:f.makeTime(c,g,G+q*n*(e===m.day?1:7)),q++;h.push(b);e<=m.hour&&1E4>h.length&&y(h,function(a){0===a%18E5&&"000000000"===f.dateFormat("%H%M%S%L",a)&&(w[a]="day")})}h.info=
D(a,{higherRanks:w,totalRange:e*n});return h}}})(J);(function(a){var B=a.color,y=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},
subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",
width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",
month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:B("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com",
position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(D){a.defaultOptions=y(!0,a.defaultOptions,D);a.time.update(y(a.defaultOptions.global,a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(y(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(y,p,d){return a.time.dateFormat(y,
p,d)}})(J);(function(a){var B,y,D=a.addEvent,p=a.animate,d=a.attr,m=a.charts,v=a.color,t=a.css,q=a.createElement,l=a.defined,g=a.deg2rad,f=a.destroyObjectProperties,h=a.doc,w=a.each,c=a.extend,b=a.erase,e=a.grep,n=a.hasTouch,A=a.inArray,G=a.isArray,C=a.isFirefox,M=a.isMS,u=a.isObject,F=a.isString,k=a.isWebKit,E=a.merge,x=a.noop,L=a.objectEach,H=a.pick,r=a.pInt,z=a.removeEvent,N=a.stop,S=a.svg,K=a.SVG_NS,P=a.symbolSizes,O=a.win;B=a.SVGElement=function(){return this};c(B.prototype,{opacity:1,SVG_NS:K,
textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),init:function(a,b){this.element="span"===b?q(b):h.createElementNS(this.SVG_NS,b);this.renderer=a},animate:function(b,c,e){c=a.animObject(H(c,this.renderer.globalAnimation,!0));0!==c.duration?(e&&(c.complete=e),p(this,b,c)):(this.attr(b,null,e),c.step&&c.step.call(this));return this},complexColor:function(b,c,e){var I=this.renderer,r,z,k,n,f,K,g,
h,A,Q,d,x=[],u;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){b.radialGradient?z="radialGradient":b.linearGradient&&(z="linearGradient");z&&(k=b[z],f=I.gradients,g=b.stops,Q=e.radialReference,G(k)&&(b[z]=k={x1:k[0],y1:k[1],x2:k[2],y2:k[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===z&&Q&&!l(k.gradientUnits)&&(n=k,k=E(k,I.getRadialAttr(Q,n),{gradientUnits:"userSpaceOnUse"})),L(k,function(a,b){"id"!==b&&x.push(b,a)}),L(g,function(a){x.push(a)}),x=x.join(","),f[x]?d=f[x].attr("id"):
(k.id=d=a.uniqueKey(),f[x]=K=I.createElement(z).attr(k).add(I.defs),K.radAttr=n,K.stops=[],w(g,function(b){0===b[1].indexOf("rgba")?(r=a.color(b[1]),h=r.get("rgb"),A=r.get("a")):(h=b[1],A=1);b=I.createElement("stop").attr({offset:b[0],"stop-color":h,"stop-opacity":A}).add(K);K.stops.push(b)})),u="url("+I.url+"#"+d+")",e.setAttribute(c,u),e.gradient=x,b.toString=function(){return u})})},applyTextOutline:function(c){var e=this.element,I,r,z,k,n;-1!==c.indexOf("contrast")&&(c=c.replace(/contrast/g,this.renderer.getContrast(e.style.fill)));
c=c.split(" ");r=c[c.length-1];if((z=c[0])&&"none"!==z&&a.svg){this.fakeTS=!0;c=[].slice.call(e.getElementsByTagName("tspan"));this.ySetter=this.xSetter;z=z.replace(/(^[\d\.]+)(.*?)$/g,function(a,b,c){return 2*b+c});for(n=c.length;n--;)I=c[n],"highcharts-text-outline"===I.getAttribute("class")&&b(c,e.removeChild(I));k=e.firstChild;w(c,function(a,b){0===b&&(a.setAttribute("x",e.getAttribute("x")),b=e.getAttribute("y"),a.setAttribute("y",b||0),null===b&&e.setAttribute("y",0));a=a.cloneNode(1);d(a,{"class":"highcharts-text-outline",
fill:r,stroke:r,"stroke-width":z,"stroke-linejoin":"round"});e.insertBefore(a,k)})}},attr:function(a,b,c,e){var I,r=this.element,z,k=this,n,f;"string"===typeof a&&void 0!==b&&(I=a,a={},a[I]=b);"string"===typeof a?k=(this[a+"Getter"]||this._defaultGetter).call(this,a,r):(L(a,function(b,c){n=!1;e||N(this,c);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(c)&&(z||(this.symbolAttr(a),z=!0),n=!0);!this.rotation||"x"!==c&&"y"!==c||(this.doTransform=!0);n||(f=this[c+"Setter"]||
this._defaultSetter,f.call(this,b,c,r),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(c)&&this.updateShadows(c,b,f))},this),this.afterSetters());c&&c.call(this);return k},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,b,c){for(var e=this.shadows,I=e.length;I--;)c.call(e[I],"height"===a?Math.max(b-(e[I].cutHeight||0),0):"d"===a?this.d:b,a,e[I])},addClass:function(a,b){var c=this.attr("class")||"";-1===c.indexOf(a)&&
(b||(a=(c+(c?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==A(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var b=this;w("x y r start end width height innerR anchorX anchorY".split(" "),function(c){b[c]=H(a[c],b[c])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",a?"url("+
this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,b){var c;b=b||a.strokeWidth||0;c=Math.round(b)%2/2;a.x=Math.floor(a.x||this.x||0)+c;a.y=Math.floor(a.y||this.y||0)+c;a.width=Math.floor((a.width||this.width||0)-2*c);a.height=Math.floor((a.height||this.height||0)-2*c);l(a.strokeWidth)&&(a.strokeWidth=b);return a},css:function(a){var b=this.styles,e={},I=this.element,z,k="",n,f=!b,K=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);b&&L(a,function(a,c){a!==b[c]&&(e[c]=a,f=!0)});
f&&(b&&(a=c(b,e)),a&&(null===a.width||"auto"===a.width?delete this.textWidth:"text"===I.nodeName.toLowerCase()&&a.width&&(z=this.textWidth=r(a.width))),this.styles=a,z&&!S&&this.renderer.forExport&&delete a.width,I.namespaceURI===this.SVG_NS?(n=function(a,b){return"-"+b.toLowerCase()},L(a,function(a,b){-1===A(b,K)&&(k+=b.replace(/([A-Z])/g,n)+":"+a+";")}),k&&d(I,"style",k)):t(I,a),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));
return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,b){var c=this,e=c.element;n&&"click"===a?(e.ontouchstart=function(a){c.touchEventFired=Date.now();a.preventDefault();b.call(e,a)},e.onclick=function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(c.touchEventFired||0))&&b.call(e,a)}):e["on"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,
b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,c=this.scaleX,e=this.scaleY,r=this.inverted,z=this.rotation,k=this.matrix,n=this.element;r&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];l(k)&&a.push("matrix("+k.join(",")+")");r?a.push("rotate(90) scale(-1,1)"):z&&a.push("rotate("+z+" "+H(this.rotationOriginX,
n.getAttribute("x"),0)+" "+H(this.rotationOriginY,n.getAttribute("y")||0)+")");(l(c)||l(e))&&a.push("scale("+H(c,1)+" "+H(e,1)+")");a.length&&n.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,c,e){var r,z,I,k,n={};z=this.renderer;I=z.alignedObjects;var f,K;if(a){if(this.alignOptions=a,this.alignByTranslate=c,!e||F(e))this.alignTo=r=e||"renderer",b(I,this),I.push(this),e=null}else a=this.alignOptions,c=this.alignByTranslate,
r=this.alignTo;e=H(e,z[r],z);r=a.align;z=a.verticalAlign;I=(e.x||0)+(a.x||0);k=(e.y||0)+(a.y||0);"right"===r?f=1:"center"===r&&(f=2);f&&(I+=(e.width-(a.width||0))/f);n[c?"translateX":"x"]=Math.round(I);"bottom"===z?K=1:"middle"===z&&(K=2);K&&(k+=(e.height-(a.height||0))/K);n[c?"translateY":"y"]=Math.round(k);this[this.placed?"animate":"attr"](n);this.placed=!0;this.alignAttr=n;return this},getBBox:function(a,b){var e,r=this.renderer,z,I=this.element,k=this.styles,n,f=this.textStr,K,h=r.cache,A=r.cacheKeys,
x;b=H(b,this.rotation);z=b*g;n=k&&k.fontSize;l(f)&&(x=f.toString(),-1===x.indexOf("\x3c")&&(x=x.replace(/[0-9]/g,"0")),x+=["",b||0,n,this.textWidth,k&&k.textOverflow].join());x&&!a&&(e=h[x]);if(!e){if(I.namespaceURI===this.SVG_NS||r.forExport){try{(K=this.fakeTS&&function(a){w(I.querySelectorAll(".highcharts-text-outline"),function(b){b.style.display=a})})&&K("none"),e=I.getBBox?c({},I.getBBox()):{width:I.offsetWidth,height:I.offsetHeight},K&&K("")}catch(X){}if(!e||0>e.width)e={width:0,height:0}}else e=
this.htmlGetBBox();r.isSVG&&(a=e.width,r=e.height,k&&"11px"===k.fontSize&&17===Math.round(r)&&(e.height=r=14),b&&(e.width=Math.abs(r*Math.sin(z))+Math.abs(a*Math.cos(z)),e.height=Math.abs(r*Math.cos(z))+Math.abs(a*Math.sin(z))));if(x&&0<e.height){for(;250<A.length;)delete h[A.shift()];h[x]||A.push(x);h[x]=e}}return e},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var b=this;b.animate({opacity:0},
{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,c=this.element,e;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)e=this.zIndexSetter();e||(a?a.element:b.box).appendChild(c);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,c=a.element||{},e=a.renderer.isSVG&&"SPAN"===c.nodeName&&
a.parentGroup,r=c.ownerSVGElement,z=a.clipPath;c.onclick=c.onmouseout=c.onmouseover=c.onmousemove=c.point=null;N(a);z&&r&&(w(r.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){var b=a.getAttribute("clip-path"),c=z.element.id;(-1<b.indexOf("(#"+c+")")||-1<b.indexOf('("#'+c+'")'))&&a.removeAttribute("clip-path")}),a.clipPath=z.destroy());if(a.stops){for(r=0;r<a.stops.length;r++)a.stops[r]=a.stops[r].destroy();a.stops=null}a.safeRemoveChild(c);for(a.destroyShadows();e&&e.div&&0===e.div.childNodes.length;)c=
e.parentGroup,a.safeRemoveChild(e.div),delete e.div,e=c;a.alignTo&&b(a.renderer.alignedObjects,a);L(a,function(b,c){delete a[c]});return null},shadow:function(a,b,c){var e=[],r,z,I=this.element,k,n,f,K;if(!a)this.destroyShadows();else if(!this.shadows){n=H(a.width,3);f=(a.opacity||.15)/n;K=this.parentInverted?"(-1,-1)":"("+H(a.offsetX,1)+", "+H(a.offsetY,1)+")";for(r=1;r<=n;r++)z=I.cloneNode(0),k=2*n+1-2*r,d(z,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":f*r,"stroke-width":k,transform:"translate"+
K,fill:"none"}),c&&(d(z,"height",Math.max(d(z,"height")-k,0)),z.cutHeight=k),b?b.element.appendChild(z):I.parentNode&&I.parentNode.insertBefore(z,I),e.push(z);this.shadows=e}return this},destroyShadows:function(){w(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=H(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):
null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,b,c){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[b]!==a&&(c.setAttribute(b,a),this[b]=a)},dashstyleSetter:function(a){var b,c=this["stroke-width"];"inherit"===c&&(c=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,
"").split(",");for(b=a.length;b--;)a[b]=r(a[b])*c;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.alignValue=a;this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,b,c){this[b]=a;c.setAttribute(b,a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=h.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);
b.appendChild(h.createTextNode(String(H(a),"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,b,c){"string"===typeof a?c.setAttribute(b,a):a&&this.complexColor(a,b,c)},visibilitySetter:function(a,b,c){"inherit"===a?c.removeAttribute(b):this[b]!==a&&c.setAttribute(b,a);this[b]=a},zIndexSetter:function(a,b){var c=this.renderer,e=this.parentGroup,
z=(e||c).element||c.box,k,n=this.element,f,K,c=z===c.box;k=this.added;var I;l(a)?(n.setAttribute("data-z-index",a),a=+a,this[b]===a&&(k=!1)):l(this[b])&&n.removeAttribute("data-z-index");this[b]=a;if(k){(a=this.zIndex)&&e&&(e.handleZ=!0);b=z.childNodes;for(I=b.length-1;0<=I&&!f;I--)if(e=b[I],k=e.getAttribute("data-z-index"),K=!l(k),e!==n)if(0>a&&K&&!c&&!I)z.insertBefore(n,b[I]),f=!0;else if(r(k)<=a||K&&(!l(a)||0<=a))z.insertBefore(n,b[I+1]||null),f=!0;f||(z.insertBefore(n,b[c?3:0]||null),f=!0)}return f},
_defaultSetter:function(a,b,c){c.setAttribute(b,a)}});B.prototype.yGetter=B.prototype.xGetter;B.prototype.translateXSetter=B.prototype.translateYSetter=B.prototype.rotationSetter=B.prototype.verticalAlignSetter=B.prototype.rotationOriginXSetter=B.prototype.rotationOriginYSetter=B.prototype.scaleXSetter=B.prototype.scaleYSetter=B.prototype.matrixSetter=function(a,b){this[b]=a;this.doTransform=!0};B.prototype["stroke-widthSetter"]=B.prototype.strokeSetter=function(a,b,c){this[b]=a;this.stroke&&this["stroke-width"]?
(B.prototype.fillSetter.call(this,this.stroke,"stroke",c),c.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===b&&0===a&&this.hasStroke&&(c.removeAttribute("stroke"),this.hasStroke=!1)};y=a.SVGRenderer=function(){this.init.apply(this,arguments)};c(y.prototype,{Element:B,SVG_NS:K,init:function(a,b,c,e,r,z){var n;e=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(e));n=e.element;a.appendChild(n);d(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&
d(n,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=n;this.boxWrapper=e;this.alignedObjects=[];this.url=(C||k)&&h.getElementsByTagName("base").length?O.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(h.createTextNode("Created with Highmaps 6.1.2"));this.defs=this.createElement("defs").add();this.allowHTML=z;this.forExport=r;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,
c,!1);var f;C&&a.getBoundingClientRect&&(b=function(){t(a,{left:0,top:0});f=a.getBoundingClientRect();t(a,{left:Math.ceil(f.left)-f.left+"px",top:Math.ceil(f.top)-f.top+"px"})},b(),this.unSubPixelFix=D(O,"resize",b))},getStyle:function(a){return this.style=c({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();f(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:x,getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},getSpanWidth:function(a){return a.getBBox(!0).width},applyEllipsis:function(a,b,c,e){var r=a.rotation,z=c,k,n=0,f=
c.length,K=function(a){b.removeChild(b.firstChild);a&&b.appendChild(h.createTextNode(a))},g;a.rotation=0;z=this.getSpanWidth(a,b);if(g=z>e){for(;n<=f;)k=Math.ceil((n+f)/2),z=c.substring(0,k)+"\u2026",K(z),z=this.getSpanWidth(a,b),n===f?n=f+1:z>e?f=k-1:n=k;0===f&&K("")}a.rotation=r;return g},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var b=a.element,c=this,z=c.forExport,k=H(a.textStr,"").toString(),n=-1!==k.indexOf("\x3c"),f=b.childNodes,
g,l=d(b,"x"),x=a.styles,I=a.textWidth,u=x&&x.lineHeight,E=x&&x.textOutline,C=x&&"ellipsis"===x.textOverflow,N=x&&"nowrap"===x.whiteSpace,q=x&&x.fontSize,G,m,P=f.length,x=I&&!a.added&&this.box,F=function(a){var e;e=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:q||c.style.fontSize||12;return u?r(u):c.fontMetrics(e,a.getAttribute("style")?a:b).h},p=function(a,b){L(c.escapes,function(c,e){b&&-1!==A(c,b)||(a=a.toString().replace(new RegExp(c,"g"),e))});return a},O=function(a,b){var c;c=a.indexOf("\x3c");
a=a.substring(c,a.indexOf("\x3e")-c);c=a.indexOf(b+"\x3d");if(-1!==c&&(c=c+b.length+1,b=a.charAt(c),'"'===b||"'"===b))return a=a.substring(c+1),a.substring(0,a.indexOf(b))};G=[k,C,N,u,E,q,I].join();if(G!==a.textCache){for(a.textCache=G;P--;)b.removeChild(f[P]);n||E||C||I||-1!==k.indexOf(" ")?(x&&x.appendChild(b),k=n?k.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,
"\x3c/span\x3e").split(/<br.*?>/g):[k],k=e(k,function(a){return""!==a}),w(k,function(e,r){var k,n=0;e=e.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");k=e.split("|||");w(k,function(e){if(""!==e||1===k.length){var f={},x=h.createElementNS(c.SVG_NS,"tspan"),A,u;(A=O(e,"class"))&&d(x,"class",A);if(A=O(e,"style"))A=A.replace(/(;| |^)color([ :])/,"$1fill$2"),d(x,"style",A);(u=O(e,"href"))&&!z&&(d(x,"onclick",'location.href\x3d"'+u+'"'),d(x,"class","highcharts-anchor"),
t(x,{cursor:"pointer"}));e=p(e.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==e){x.appendChild(h.createTextNode(e));n?f.dx=0:r&&null!==l&&(f.x=l);d(x,f);b.appendChild(x);!n&&m&&(!S&&z&&t(x,{display:"block"}),d(x,"dy",F(x)));if(I){f=e.replace(/([^\^])-/g,"$1- ").split(" ");u=1<k.length||r||1<f.length&&!N;var w=[],E,q=F(x),G=a.rotation;for(C&&(g=c.applyEllipsis(a,x,e,I));!C&&u&&(f.length||w.length);)a.rotation=0,E=c.getSpanWidth(a,x),e=E>I,void 0===g&&(g=e),e&&1!==f.length?(x.removeChild(x.firstChild),
w.unshift(f.pop())):(f=w,w=[],f.length&&!N&&(x=h.createElementNS(K,"tspan"),d(x,{dy:q,x:l}),A&&d(x,"style",A),b.appendChild(x)),E>I&&(I=E+1)),f.length&&x.appendChild(h.createTextNode(f.join(" ").replace(/- /g,"-")));a.rotation=G}n++}}});m=m||b.childNodes.length}),C&&g&&a.attr("title",p(a.textStr,["\x26lt;","\x26gt;"])),x&&x.removeChild(b),E&&a.applyTextOutline&&a.applyTextOutline(E)):b.appendChild(h.createTextNode(p(k)))}},getContrast:function(a){a=v(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<
a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,b,e,r,z,k,n,f,K){var x=this.label(a,b,e,K,null,null,null,null,"button"),g=0;x.attr(E({padding:8,r:2},z));var l,A,h,I;z=E({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},z);l=z.style;delete z.style;k=E(z,{fill:"#e6e6e6"},k);A=k.style;delete k.style;n=E(z,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},n);h=n.style;delete n.style;f=E(z,{style:{color:"#cccccc"}},f);I=f.style;
delete f.style;D(x.element,M?"mouseover":"mouseenter",function(){3!==g&&x.setState(1)});D(x.element,M?"mouseout":"mouseleave",function(){3!==g&&x.setState(g)});x.setState=function(a){1!==a&&(x.state=g=a);x.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);x.attr([z,k,n,f][a||0]).css([l,A,h,I][a||0])};x.attr(z).css(c({cursor:"default"},l));return x.on("click",function(a){3!==g&&r.call(x,a)})},crispLine:function(a,
b){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+b%2/2);return a},path:function(a){var b={fill:"none"};G(a)?b.d=a:u(a)&&c(b,a);return this.createElement("path").attr(b)},circle:function(a,b,c){a=u(a)?a:{x:a,y:b,r:c};b=this.createElement("circle");b.xSetter=b.ySetter=function(a,b,c){c.setAttribute("c"+b,a)};return b.attr(a)},arc:function(a,b,c,e,r,z){u(a)?(e=a,b=e.y,c=e.r,a=e.x):e={innerR:e,start:r,end:z};a=this.symbol("arc",a,b,c,c,e);a.r=c;return a},rect:function(a,
b,c,e,r,z){r=u(a)?a.r:r;var k=this.createElement("rect");a=u(a)?a:void 0===a?{}:{x:a,y:b,width:Math.max(c,0),height:Math.max(e,0)};void 0!==z&&(a.strokeWidth=z,a=k.crisp(a));a.fill="none";r&&(a.r=r);k.rSetter=function(a,b,c){d(c,{rx:a,ry:a})};return k.attr(a)},setSize:function(a,b,c){var e=this.alignedObjects,r=e.length;this.width=a;this.height=b;for(this.boxWrapper.animate({width:a,height:b},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:H(c,!0)?
void 0:0});r--;)e[r].align()},g:function(a){var b=this.createElement("g");return a?b.attr({"class":"highcharts-"+a}):b},image:function(a,b,e,r,z,k){var n={preserveAspectRatio:"none"},f,K=function(a,b){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",b):a.setAttribute("hc-svg-href",b)},x=function(b){K(f.element,a);k.call(f,b)};1<arguments.length&&c(n,{x:b,y:e,width:r,height:z});f=this.createElement("image").attr(n);k?(K(f.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),
n=new O.Image,D(n,"load",x),n.src=a,n.complete&&x({})):K(f.element,a);return f},symbol:function(a,b,e,r,z,k){var n=this,f,K=/^url\((.*?)\)$/,x=K.test(a),g=!x&&(this.symbols[a]?a:"circle"),A=g&&this.symbols[g],d=l(b)&&A&&A.call(this.symbols,Math.round(b),Math.round(e),r,z,k),u,E;A?(f=this.path(d),f.attr("fill","none"),c(f,{symbolName:g,x:b,y:e,width:r,height:z}),k&&c(f,k)):x&&(u=a.match(K)[1],f=this.image(u),f.imgwidth=H(P[u]&&P[u].width,k&&k.width),f.imgheight=H(P[u]&&P[u].height,k&&k.height),E=function(){f.attr({width:f.width,
height:f.height})},w(["width","height"],function(a){f[a+"Setter"]=function(a,b){var c={},e=this["img"+b],r="width"===b?"translateX":"translateY";this[b]=a;l(e)&&(this.element&&this.element.setAttribute(b,e),this.alignByTranslate||(c[r]=((this[b]||0)-e)/2,this.attr(c)))}}),l(b)&&f.attr({x:b,y:e}),f.isImg=!0,l(f.imgwidth)&&l(f.imgheight)?E():(f.attr({width:0,height:0}),q("img",{onload:function(){var a=m[n.chartIndex];0===this.width&&(t(this,{position:"absolute",top:"-999em"}),h.body.appendChild(this));
P[u]={width:this.width,height:this.height};f.imgwidth=this.width;f.imgheight=this.height;f.element&&E();this.parentNode&&this.parentNode.removeChild(this);n.imgCount--;if(!n.imgCount&&a&&a.onload)a.onload()},src:u}),this.imgCount++));return f},symbols:{circle:function(a,b,c,e){return this.arc(a+c/2,b+e/2,c/2,e/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,b,c,e){return["M",a,b,"L",a+c,b,a+c,b+e,a,b+e,"Z"]},triangle:function(a,b,c,e){return["M",a+c/2,b,"L",a+c,b+e,a,b+e,"Z"]},"triangle-down":function(a,
b,c,e){return["M",a,b,"L",a+c,b,a+c/2,b+e,"Z"]},diamond:function(a,b,c,e){return["M",a+c/2,b,"L",a+c,b+e/2,a+c/2,b+e,a,b+e/2,"Z"]},arc:function(a,b,c,e,r){var z=r.start,k=r.r||c,f=r.r||e||c,n=r.end-.001;c=r.innerR;e=H(r.open,.001>Math.abs(r.end-r.start-2*Math.PI));var K=Math.cos(z),x=Math.sin(z),g=Math.cos(n),n=Math.sin(n);r=.001>r.end-z-Math.PI?0:1;k=["M",a+k*K,b+f*x,"A",k,f,0,r,1,a+k*g,b+f*n];l(c)&&k.push(e?"M":"L",a+c*g,b+c*n,"A",c,c,0,r,0,a+c*K,b+c*x);k.push(e?"":"Z");return k},callout:function(a,
b,c,e,r){var z=Math.min(r&&r.r||0,c,e),k=z+6,f=r&&r.anchorX;r=r&&r.anchorY;var n;n=["M",a+z,b,"L",a+c-z,b,"C",a+c,b,a+c,b,a+c,b+z,"L",a+c,b+e-z,"C",a+c,b+e,a+c,b+e,a+c-z,b+e,"L",a+z,b+e,"C",a,b+e,a,b+e,a,b+e-z,"L",a,b+z,"C",a,b,a,b,a+z,b];f&&f>c?r>b+k&&r<b+e-k?n.splice(13,3,"L",a+c,r-6,a+c+6,r,a+c,r+6,a+c,b+e-z):n.splice(13,3,"L",a+c,e/2,f,r,a+c,e/2,a+c,b+e-z):f&&0>f?r>b+k&&r<b+e-k?n.splice(33,3,"L",a,r+6,a-6,r,a,r-6,a,b+z):n.splice(33,3,"L",a,e/2,f,r,a,e/2,a,b+z):r&&r>e&&f>a+k&&f<a+c-k?n.splice(23,
3,"L",f+6,b+e,f,b+e+6,f-6,b+e,a+z,b+e):r&&0>r&&f>a+k&&f<a+c-k&&n.splice(3,3,"L",f-6,b,f,b-6,f+6,b,c-z,b);return n}},clipRect:function(b,c,e,r){var z=a.uniqueKey(),k=this.createElement("clipPath").attr({id:z}).add(this.defs);b=this.rect(b,c,e,r,0).add(k);b.id=z;b.clipPath=k;b.count=0;return b},text:function(a,b,c,e){var r={};if(e&&(this.allowHTML||!this.forExport))return this.html(a,b,c);r.x=Math.round(b||0);c&&(r.y=Math.round(c));if(a||0===a)r.text=a;a=this.createElement("text").attr(r);e||(a.xSetter=
function(a,b,c){var e=c.getElementsByTagName("tspan"),r,z=c.getAttribute(b),k;for(k=0;k<e.length;k++)r=e[k],r.getAttribute(b)===z&&r.setAttribute(b,a);c.setAttribute(b,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?r(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,b,c){var e=a;b&&c&&(e=Math.max(e*Math.cos(b*g),
4));return{x:-a/3*Math.sin(b*g),y:e}},label:function(b,e,r,k,f,n,K,x,g){var A=this,h=A.g("button"!==g&&"label"),u=h.text=A.text("",0,0,K).attr({zIndex:1}),d,C,S=0,N=3,q=0,G,H,m,P,F,p={},O,L,I=/^url\((.*?)\)$/.test(k),M=I,t,v,Q,U;g&&h.addClass("highcharts-"+g);M=I;t=function(){return(O||0)%2/2};v=function(){var a=u.element.style,b={};C=(void 0===G||void 0===H||F)&&l(u.textStr)&&u.getBBox();h.width=(G||C.width||0)+2*N+q;h.height=(H||C.height||0)+2*N;L=N+A.fontMetrics(a&&a.fontSize,u).b;M&&(d||(h.box=
d=A.symbols[k]||I?A.symbol(k):A.rect(),d.addClass(("button"===g?"":"highcharts-label-box")+(g?" highcharts-"+g+"-box":"")),d.add(h),a=t(),b.x=a,b.y=(x?-L:0)+a),b.width=Math.round(h.width),b.height=Math.round(h.height),d.attr(c(b,p)),p={})};Q=function(){var a=q+N,b;b=x?0:L;l(G)&&C&&("center"===F||"right"===F)&&(a+={center:.5,right:1}[F]*(G-C.width));if(a!==u.x||b!==u.y)u.attr("x",a),u.hasBoxWidthChanged&&(C=u.getBBox(!0),v()),void 0!==b&&u.attr("y",b);u.x=a;u.y=b};U=function(a,b){d?d.attr(a,b):p[a]=
b};h.onAdd=function(){u.add(h);h.attr({text:b||0===b?b:"",x:e,y:r});d&&l(f)&&h.attr({anchorX:f,anchorY:n})};h.widthSetter=function(b){G=a.isNumber(b)?b:null};h.heightSetter=function(a){H=a};h["text-alignSetter"]=function(a){F=a};h.paddingSetter=function(a){l(a)&&a!==N&&(N=h.padding=a,Q())};h.paddingLeftSetter=function(a){l(a)&&a!==q&&(q=a,Q())};h.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==S&&(S=a,C&&h.attr({x:m}))};h.textSetter=function(a){void 0!==a&&u.textSetter(a);v();Q()};h["stroke-widthSetter"]=
function(a,b){a&&(M=!0);O=this["stroke-width"]=a;U(b,a)};h.strokeSetter=h.fillSetter=h.rSetter=function(a,b){"r"!==b&&("fill"===b&&a&&(M=!0),h[b]=a);U(b,a)};h.anchorXSetter=function(a,b){f=h.anchorX=a;U(b,Math.round(a)-t()-m)};h.anchorYSetter=function(a,b){n=h.anchorY=a;U(b,a-P)};h.xSetter=function(a){h.x=a;S&&(a-=S*((G||C.width)+2*N),h["forceAnimate:x"]=!0);m=Math.round(a);h.attr("translateX",m)};h.ySetter=function(a){P=h.y=Math.round(a);h.attr("translateY",P)};var R=h.css;return c(h,{css:function(a){if(a){var b=
{};a=E(a);w(h.textProps,function(c){void 0!==a[c]&&(b[c]=a[c],delete a[c])});u.css(b);"width"in b&&v()}return R.call(h,a)},getBBox:function(){return{width:C.width+2*N,height:C.height+2*N,x:C.x-N,y:C.y-N}},shadow:function(a){a&&(v(),d&&d.shadow(a));return h},destroy:function(){z(h.element,"mouseenter");z(h.element,"mouseleave");u&&(u=u.destroy());d&&(d=d.destroy());B.prototype.destroy.call(h);h=A=v=Q=U=null}})}});a.Renderer=y})(J);(function(a){var B=a.attr,y=a.createElement,D=a.css,p=a.defined,d=a.each,
m=a.extend,v=a.isFirefox,t=a.isMS,q=a.isWebKit,l=a.pick,g=a.pInt,f=a.SVGRenderer,h=a.win,w=a.wrap;m(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if((b=a&&"SPAN"===b.tagName&&a.width)||this.textWidth&&!b)delete a.width,this.textWidth=b,this.htmlUpdateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=m(this.styles,a);D(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,
height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,e=this.translateX||0,f=this.translateY||0,h=this.x||0,l=this.y||0,C=this.textAlign||"left",w={left:0,center:.5,right:1}[C],u=this.styles,q=u&&u.whiteSpace;D(b,{marginLeft:e,marginTop:f});this.shadows&&d(this.shadows,function(a){D(a,{marginLeft:e+1,marginTop:f+1})});this.inverted&&d(b.childNodes,function(c){a.invertChild(c,b)});if("SPAN"===b.tagName){var u=this.rotation,k=this.textWidth&&g(this.textWidth),
E=[u,C,b.innerHTML,this.textWidth,this.textAlign].join(),x;(x=k!==this.oldTextWidth)&&!(x=k>this.oldTextWidth)&&((x=this.textPxLength)||(D(b,{width:"",whiteSpace:q||"nowrap"}),x=b.offsetWidth),x=x>k);x&&/[ \-]/.test(b.textContent||b.innerText)?(D(b,{width:k+"px",display:"block",whiteSpace:q||"normal"}),this.oldTextWidth=k,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;E!==this.cTT&&(q=a.fontMetrics(b.style.fontSize).b,!p(u)||u===(this.oldRotation||0)&&C===this.oldAlign||this.setSpanRotation(u,
w,q),this.getSpanCorrection(!p(u)&&this.textPxLength||b.offsetWidth,q,w,u,C));D(b,{left:h+(this.xCorr||0)+"px",top:l+(this.yCorr||0)+"px"});this.cTT=E;this.oldRotation=u;this.oldAlign=C}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,e){var c={},f=this.renderer.getTransformKey();c[f]=c.transform="rotate("+a+"deg)";c[f+(v?"Origin":"-origin")]=c.transformOrigin=100*b+"% "+e+"px";D(this.element,c)},getSpanCorrection:function(a,b,e){this.xCorr=-a*e;this.yCorr=-b}});m(f.prototype,{getTransformKey:function(){return t&&
!/Edge/.test(h.navigator.userAgent)?"-ms-transform":q?"-webkit-transform":v?"MozTransform":h.opera?"-o-transform":""},html:function(a,b,e){var c=this.createElement("span"),f=c.element,g=c.renderer,h=g.isSVG,q=function(a,b){d(["opacity","visibility"],function(c){w(a,c+"Setter",function(a,c,e,k){a.call(this,c,e,k);b[e]=c})});a.addedSetters=!0};c.textSetter=function(a){a!==f.innerHTML&&delete this.bBox;this.textStr=a;f.innerHTML=l(a,"");c.doTransform=!0};h&&q(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=
c.rotationSetter=function(a,b){"align"===b&&(b="textAlign");c[b]=a;c.doTransform=!0};c.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};c.attr({text:a,x:Math.round(b),y:Math.round(e)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});f.style.whiteSpace="nowrap";c.css=c.htmlCss;h&&(c.add=function(a){var b,e=g.box.parentNode,n=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)n.push(a),a=a.parentGroup;d(n.reverse(),function(a){function k(b,
c){a[c]=b;"translateX"===c?f.left=b+"px":f.top=b+"px";a.doTransform=!0}var f,r=B(a.element,"class");r&&(r={className:r});b=a.div=a.div||y("div",r,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||e);f=b.style;m(a,{classSetter:function(a){return function(b){this.element.setAttribute("class",b);a.className=b}}(b),on:function(){n[0].div&&c.on.apply({element:n[0].div},arguments);return a},
translateXSetter:k,translateYSetter:k});a.addedSetters||q(a,f)})}}else b=e;b.appendChild(f);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})})(J);(function(a){var B=a.correctFloat,y=a.defined,D=a.destroyObjectProperties,p=a.fireEvent,d=a.isNumber,m=a.merge,v=a.pick,t=a.deg2rad;a.Tick=function(a,l,g,f){this.axis=a;this.pos=l;this.type=g||"";this.isNewLabel=this.isNew=!0;g||f||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,l=a.options,g=a.chart,f=a.categories,
h=a.names,d=this.pos,c=l.labels,b=a.tickPositions,e=d===b[0],n=d===b[b.length-1],h=f?v(f[d],h[d],d):d,f=this.label,b=b.info,A;a.isDatetimeAxis&&b&&(A=l.dateTimeLabelFormats[b.higherRanks[d]||b.unitName]);this.isFirst=e;this.isLast=n;l={axis:a,chart:g,isFirst:e,isLast:n,dateTimeLabelFormat:A,value:a.isLog?B(a.lin2log(h)):h,pos:d};l=a.labelFormatter.call(l,l);if(y(f))f&&f.attr({text:l});else{if(this.label=f=y(l)&&c.enabled?g.renderer.text(l,0,0,c.useHTML).css(m(c.style)).add(a.labelGroup):null)f.textPxLength=
f.getBBox().width;this.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var l=this.axis,g=l.options.labels,f=a.x,h=l.chart.chartWidth,d=l.chart.spacing,c=v(l.labelLeft,Math.min(l.pos,d[3])),d=v(l.labelRight,Math.max(l.isRadial?0:l.pos+l.len,h-d[1])),b=this.label,e=this.rotation,n={left:0,center:.5,right:1}[l.labelAlign||b.attr("align")],A=b.getBBox().width,G=l.getSlotWidth(this),C=G,q=1,u,m={};if(e||!1===g.overflow)0>
e&&f-n*A<c?u=Math.round(f/Math.cos(e*t)-c):0<e&&f+n*A>d&&(u=Math.round((h-f)/Math.cos(e*t)));else if(h=f+(1-n)*A,f-n*A<c?C=a.x+C*(1-n)-c:h>d&&(C=d-a.x+C*n,q=-1),C=Math.min(G,C),C<G&&"center"===l.labelAlign&&(a.x+=q*(G-C-n*(G-Math.min(A,C)))),A>C||l.autoRotation&&(b.styles||{}).width)u=C;u&&(m.width=u,(g.style||{}).textOverflow||(m.textOverflow="ellipsis"),b.css(m))},getPosition:function(d,l,g,f){var h=this.axis,w=h.chart,c=f&&w.oldChartHeight||w.chartHeight;d={x:d?a.correctFloat(h.translate(l+g,null,
null,f)+h.transB):h.left+h.offset+(h.opposite?(f&&w.oldChartWidth||w.chartWidth)-h.right-h.left:0),y:d?c-h.bottom+h.offset-(h.opposite?h.height:0):a.correctFloat(c-h.translate(l+g,null,null,f)-h.transB)};p(this,"afterGetPosition",{pos:d});return d},getLabelPosition:function(a,l,g,f,h,d,c,b){var e=this.axis,n=e.transA,A=e.reversed,w=e.staggerLines,C=e.tickRotCorr||{x:0,y:0},q=h.y,u=f||e.reserveSpaceDefault?0:-e.labelOffset*("center"===e.labelAlign?.5:1),m={};y(q)||(q=0===e.side?g.rotation?-8:-g.getBBox().height:
2===e.side?C.y+8:Math.cos(g.rotation*t)*(C.y-g.getBBox(!1,0).height/2));a=a+h.x+u+C.x-(d&&f?d*n*(A?-1:1):0);l=l+q-(d&&!f?d*n*(A?1:-1):0);w&&(g=c/(b||1)%w,e.opposite&&(g=w-g-1),l+=e.labelOffset/w*g);m.x=a;m.y=Math.round(l);p(this,"afterGetLabelPosition",{pos:m});return m},getMarkPath:function(a,l,g,f,h,d){return d.crispLine(["M",a,l,"L",a+(h?0:-g),l+(h?g:0)],f)},renderGridLine:function(a,l,g){var f=this.axis,h=f.options,d=this.gridLine,c={},b=this.pos,e=this.type,n=f.tickmarkOffset,A=f.chart.renderer,
m=e?e+"Grid":"grid",C=h[m+"LineWidth"],q=h[m+"LineColor"],h=h[m+"LineDashStyle"];d||(c.stroke=q,c["stroke-width"]=C,h&&(c.dashstyle=h),e||(c.zIndex=1),a&&(c.opacity=0),this.gridLine=d=A.path().attr(c).addClass("highcharts-"+(e?e+"-":"")+"grid-line").add(f.gridGroup));if(!a&&d&&(a=f.getPlotLinePath(b+n,d.strokeWidth()*g,a,!0)))d[this.isNew?"attr":"animate"]({d:a,opacity:l})},renderMark:function(a,d,g){var f=this.axis,h=f.options,l=f.chart.renderer,c=this.type,b=c?c+"Tick":"tick",e=f.tickSize(b),n=
this.mark,A=!n,m=a.x;a=a.y;var C=v(h[b+"Width"],!c&&f.isXAxis?1:0),h=h[b+"Color"];e&&(f.opposite&&(e[0]=-e[0]),A&&(this.mark=n=l.path().addClass("highcharts-"+(c?c+"-":"")+"tick").add(f.axisGroup),n.attr({stroke:h,"stroke-width":C})),n[A?"attr":"animate"]({d:this.getMarkPath(m,a,e[0],n.strokeWidth()*g,f.horiz,l),opacity:d}))},renderLabel:function(a,l,g,f){var h=this.axis,w=h.horiz,c=h.options,b=this.label,e=c.labels,n=e.step,h=h.tickmarkOffset,A=!0,m=a.x;a=a.y;b&&d(m)&&(b.xy=a=this.getLabelPosition(m,
a,b,w,e,h,f,n),this.isFirst&&!this.isLast&&!v(c.showFirstLabel,1)||this.isLast&&!this.isFirst&&!v(c.showLastLabel,1)?A=!1:!w||e.step||e.rotation||l||0===g||this.handleOverflow(a),n&&f%n&&(A=!1),A&&d(a.y)?(a.opacity=g,b[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(b.attr("y",-9999),this.isNewLabel=!0))},render:function(d,l,g){var f=this.axis,h=f.horiz,w=this.getPosition(h,this.pos,f.tickmarkOffset,l),c=w.x,b=w.y,f=h&&c===f.pos+f.len||!h&&b===f.pos?-1:1;g=v(g,1);this.isActive=!0;this.renderGridLine(l,
g,f);this.renderMark(w,g,f);this.renderLabel(w,l,g,d);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){D(this,this.axis)}}})(J);var W=function(a){var B=a.addEvent,y=a.animObject,D=a.arrayMax,p=a.arrayMin,d=a.color,m=a.correctFloat,v=a.defaultOptions,t=a.defined,q=a.deg2rad,l=a.destroyObjectProperties,g=a.each,f=a.extend,h=a.fireEvent,w=a.format,c=a.getMagnitude,b=a.grep,e=a.inArray,n=a.isArray,A=a.isNumber,G=a.isString,C=a.merge,M=a.normalizeTickInterval,u=a.objectEach,F=a.pick,k=
a.removeEvent,E=a.splat,x=a.syncTimeout,L=a.Tick,H=function(){this.init.apply(this,arguments)};a.extend(H.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,
tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,
-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,b){var c=b.isX,r=this;r.chart=a;r.horiz=a.inverted&&!r.isZAxis?!c:c;r.isXAxis=c;r.coll=r.coll||
(c?"xAxis":"yAxis");h(this,"init",{userOptions:b});r.opposite=b.opposite;r.side=b.side||(r.horiz?r.opposite?0:2:r.opposite?1:3);r.setOptions(b);var z=this.options,k=z.type;r.labelFormatter=z.labels.formatter||r.defaultLabelFormatter;r.userOptions=b;r.minPixelPadding=0;r.reversed=z.reversed;r.visible=!1!==z.visible;r.zoomEnabled=!1!==z.zoomEnabled;r.hasNames="category"===k||!0===z.categories;r.categories=z.categories||r.hasNames;r.names||(r.names=[],r.names.keys={});r.plotLinesAndBandsGroups={};r.isLog=
"logarithmic"===k;r.isDatetimeAxis="datetime"===k;r.positiveValuesOnly=r.isLog&&!r.allowNegativeLog;r.isLinked=t(z.linkedTo);r.ticks={};r.labelEdge=[];r.minorTicks={};r.plotLinesAndBands=[];r.alternateBands={};r.len=0;r.minRange=r.userMinRange=z.minRange||z.maxZoom;r.range=z.range;r.offset=z.offset||0;r.stacks={};r.oldStacks={};r.stacksTouched=0;r.max=null;r.min=null;r.crosshair=F(z.crosshair,E(a.options.tooltip.crosshairs)[c?0:1],!1);b=r.options.events;-1===e(r,a.axes)&&(c?a.axes.splice(a.xAxis.length,
0,r):a.axes.push(r),a[r.coll].push(r));r.series=r.series||[];a.inverted&&!r.isZAxis&&c&&void 0===r.reversed&&(r.reversed=!0);u(b,function(a,b){B(r,b,a)});r.lin2log=z.linearToLogConverter||r.lin2log;r.isLog&&(r.val2lin=r.log2lin,r.lin2val=r.lin2log);h(this,"afterInit")},setOptions:function(a){this.options=C(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],
C(v[this.coll],a));h(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var b=this.axis,c=this.value,e=b.chart.time,k=b.categories,f=this.dateTimeLabelFormat,n=v.lang,g=n.numericSymbols,n=n.numericSymbolMagnitude||1E3,h=g&&g.length,x,d=b.options.labels.format,b=b.isLog?Math.abs(c):b.tickInterval;if(d)x=w(d,this,e);else if(k)x=c;else if(f)x=e.dateFormat(f,c);else if(h&&1E3<=b)for(;h--&&void 0===x;)e=Math.pow(n,h+1),b>=e&&0===10*c%e&&null!==g[h]&&0!==c&&(x=a.numberFormat(c/e,
-1)+g[h]);void 0===x&&(x=1E4<=Math.abs(c)?a.numberFormat(c,-1):a.numberFormat(c,-1,void 0,""));return x},getSeriesExtremes:function(){var a=this,c=a.chart;h(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();g(a.series,function(e){if(e.visible||!c.options.chart.ignoreHiddenSeries){var r=e.options,z=r.threshold,k;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=z&&(z=null);if(a.isXAxis)r=e.xData,
r.length&&(e=p(r),k=D(r),A(e)||e instanceof Date||(r=b(r,A),e=p(r),k=D(r)),r.length&&(a.dataMin=Math.min(F(a.dataMin,r[0],e),e),a.dataMax=Math.max(F(a.dataMax,r[0],k),k)));else if(e.getExtremes(),k=e.dataMax,e=e.dataMin,t(e)&&t(k)&&(a.dataMin=Math.min(F(a.dataMin,e),e),a.dataMax=Math.max(F(a.dataMax,k),k)),t(z)&&(a.threshold=z),!r.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});h(this,"afterGetSeriesExtremes")},translate:function(a,b,c,e,k,f){var r=this.linkedParent||this,z=1,n=0,g=e?
r.oldTransA:r.transA;e=e?r.oldMin:r.min;var h=r.minPixelPadding;k=(r.isOrdinal||r.isBroken||r.isLog&&k)&&r.lin2val;g||(g=r.transA);c&&(z*=-1,n=r.len);r.reversed&&(z*=-1,n-=z*(r.sector||r.len));b?(a=(a*z+n-h)/g+e,k&&(a=r.lin2val(a))):(k&&(a=r.val2lin(a)),a=A(e)?z*(a-e)*g+n+z*h+(A(f)?g*f:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,
b,c,e,k){var r=this.chart,z=this.left,f=this.top,n,g,h=c&&r.oldChartHeight||r.chartHeight,x=c&&r.oldChartWidth||r.chartWidth,d;n=this.transB;var K=function(a,b,c){if(a<b||a>c)e?a=Math.min(Math.max(b,a),c):d=!0;return a};k=F(k,this.translate(a,null,null,c));k=Math.min(Math.max(-1E5,k),1E5);a=c=Math.round(k+n);n=g=Math.round(h-k-n);A(k)?this.horiz?(n=f,g=h-this.bottom,a=c=K(a,z,z+this.width)):(a=z,c=x-this.right,n=g=K(n,f,f+this.height)):(d=!0,e=!1);return d&&!e?null:r.renderer.crispLine(["M",a,n,"L",
c,g],b||1)},getLinearTickPositions:function(a,b,c){var e,r=m(Math.floor(b/a)*a);c=m(Math.ceil(c/a)*a);var z=[],k;m(r+a)===r&&(k=20);if(this.single)return[b];for(b=r;b<=c;){z.push(b);b=m(b+a,k);if(b===e)break;e=b}return z},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?F(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,c=a.tickPositions,e=a.minorTickInterval,k=[],f=a.pointRangePadding||0,n=a.min-
f,f=a.max+f,h=f-n;if(h&&h/e<a.len/3)if(a.isLog)g(this.paddedTicks,function(b,c,r){c&&k.push.apply(k,a.getLogTickPositions(e,r[c-1],r[c],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())k=k.concat(a.getTimeTicks(a.normalizeTimeTickInterval(e),n,f,b.startOfWeek));else for(b=n+(c[0]-n)%e;b<=f&&b!==k[0];b+=e)k.push(b);0!==k.length&&a.trimTicks(k);return k},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,e,k,f,n,h,x,d,l;this.isXAxis&&void 0===this.minRange&&!this.isLog&&
(t(a.min)||t(a.max)?this.minRange=null:(g(this.series,function(a){x=a.xData;for(n=d=a.xIncrement?1:x.length-1;0<n;n--)if(h=x[n]-x[n-1],void 0===f||h<f)f=h}),this.minRange=Math.min(5*f,this.dataMax-this.dataMin)));c-b<this.minRange&&(k=this.dataMax-this.dataMin>=this.minRange,l=this.minRange,e=(l-c+b)/2,e=[b-e,F(a.min,b-e)],k&&(e[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=D(e),c=[b+l,F(a.max,b+l)],k&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),c=p(c),c-b<l&&(e[0]=c-l,e[1]=
F(a.min,c-l),b=D(e)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:g(this.series,function(b){var c=b.closestPointRange,e=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&t(c)&&e&&(a=t(a)?Math.min(a,c):c)});return a},nameToX:function(a){var b=n(this.categories),c=b?this.categories:this.names,r=a.options.x,k;a.series.requireSorting=!1;t(r)||(r=!1===this.options.uniqueNames?a.series.autoIncrement():b?e(a.name,c):F(c.keys[a.name],-1));-1===r?b||(k=c.length):
k=r;void 0!==k&&(this.names[k]=a.name,this.names.keys[a.name]=k);return k},updateNames:function(){var b=this,c=this.names;0<c.length&&(g(a.keys(c.keys),function(a){delete c.keys[a]}),c.length=0,this.minRange=this.userMinRange,g(this.series||[],function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)a.processData(),a.generatePoints();g(a.points,function(c,e){var r;c.options&&(r=b.nameToX(c),void 0!==r&&r!==c.x&&(c.x=r,a.xData[e]=r))})}))},setAxisTranslation:function(a){var b=this,c=b.max-b.min,e=
b.axisPointRange||0,r,k=0,f=0,n=b.linkedParent,x=!!b.categories,d=b.transA,l=b.isXAxis;if(l||x||e)r=b.getClosest(),n?(k=n.minPointOffset,f=n.pointRangePadding):g(b.series,function(a){var c=x?1:l?F(a.options.pointRange,r,0):b.axisPointRange||0;a=a.options.pointPlacement;e=Math.max(e,c);b.single||(k=Math.max(k,G(a)?0:c/2),f=Math.max(f,"on"===a?0:c))}),n=b.ordinalSlope&&r?b.ordinalSlope/r:1,b.minPointOffset=k*=n,b.pointRangePadding=f*=n,b.pointRange=Math.min(e,c),l&&(b.closestPointRange=r);a&&(b.oldTransA=
d);b.translationSlope=b.transA=d=b.options.staticScale||b.len/(c+f||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=d*k;h(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(b){var e=this,r=e.chart,k=e.options,f=e.isLog,n=e.isDatetimeAxis,x=e.isXAxis,d=e.isLinked,l=k.maxPadding,u=k.minPadding,C=k.tickInterval,E=k.tickPixelInterval,w=e.categories,G=A(e.threshold)?e.threshold:null,H=e.softThreshold,q,p,L,v;n||w||d||this.getTickAmount();
L=F(e.userMin,k.min);v=F(e.userMax,k.max);d?(e.linkedParent=r[e.coll][k.linkedTo],r=e.linkedParent.getExtremes(),e.min=F(r.min,r.dataMin),e.max=F(r.max,r.dataMax),k.type!==e.linkedParent.options.type&&a.error(11,1)):(!H&&t(G)&&(e.dataMin>=G?(q=G,u=0):e.dataMax<=G&&(p=G,l=0)),e.min=F(L,q,e.dataMin),e.max=F(v,p,e.dataMax));f&&(e.positiveValuesOnly&&!b&&0>=Math.min(e.min,F(e.dataMin,e.min))&&a.error(10,1),e.min=m(e.log2lin(e.min),15),e.max=m(e.log2lin(e.max),15));e.range&&t(e.max)&&(e.userMin=e.min=
L=Math.max(e.dataMin,e.minFromRange()),e.userMax=v=e.max,e.range=null);h(e,"foundExtremes");e.beforePadding&&e.beforePadding();e.adjustForMinRange();!(w||e.axisPointRange||e.usePercentage||d)&&t(e.min)&&t(e.max)&&(r=e.max-e.min)&&(!t(L)&&u&&(e.min-=r*u),!t(v)&&l&&(e.max+=r*l));A(k.softMin)&&!A(e.userMin)&&(e.min=Math.min(e.min,k.softMin));A(k.softMax)&&!A(e.userMax)&&(e.max=Math.max(e.max,k.softMax));A(k.floor)&&(e.min=Math.max(e.min,k.floor));A(k.ceiling)&&(e.max=Math.min(e.max,k.ceiling));H&&t(e.dataMin)&&
(G=G||0,!t(L)&&e.min<G&&e.dataMin>=G?e.min=G:!t(v)&&e.max>G&&e.dataMax<=G&&(e.max=G));e.tickInterval=e.min===e.max||void 0===e.min||void 0===e.max?1:d&&!C&&E===e.linkedParent.options.tickPixelInterval?C=e.linkedParent.tickInterval:F(C,this.tickAmount?(e.max-e.min)/Math.max(this.tickAmount-1,1):void 0,w?1:(e.max-e.min)*E/Math.max(e.len,E));x&&!b&&g(e.series,function(a){a.processData(e.min!==e.oldMin||e.max!==e.oldMax)});e.setAxisTranslation(!0);e.beforeSetTickPositions&&e.beforeSetTickPositions();
e.postProcessTickInterval&&(e.tickInterval=e.postProcessTickInterval(e.tickInterval));e.pointRange&&!C&&(e.tickInterval=Math.max(e.pointRange,e.tickInterval));b=F(k.minTickInterval,e.isDatetimeAxis&&e.closestPointRange);!C&&e.tickInterval<b&&(e.tickInterval=b);n||f||C||(e.tickInterval=M(e.tickInterval,null,c(e.tickInterval),F(k.allowDecimals,!(.5<e.tickInterval&&5>e.tickInterval&&1E3<e.max&&9999>e.max)),!!this.tickAmount));this.tickAmount||(e.tickInterval=e.unsquish());this.setTickPositions()},setTickPositions:function(){var a=
this.options,b,e=a.tickPositions;b=this.getMinorTickInterval();var c=a.tickPositioner,k=a.startOnTick,f=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/5:b;this.single=this.min===this.max&&t(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=e&&e.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,
a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()],b[0]===b[1]&&(b.length=1)),this.tickPositions=b,c&&(c=c.apply(this,[this.min,this.max])))&&(this.tickPositions=b=c);this.paddedTicks=b.slice(0);this.trimTicks(b,k,f);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),e||
c||this.adjustTickAmount());h(this,"afterSetTickPositions")},trimTicks:function(a,b,e){var c=a[0],k=a[a.length-1],r=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==c)this.min=c;else for(;this.min-r>a[0];)a.shift();if(e)this.max=k;else for(;this.max+r<a[a.length-1];)a.pop();0===a.length&&t(c)&&!this.options.tickPositions&&a.push((k+c)/2)}},alignToOthers:function(){var a={},b,e=this.options;!1===this.chart.options.chart.alignTicks||!1===e.alignTicks||!1===e.startOnTick||!1===e.endOnTick||
this.isLog||g(this.chart[this.coll],function(e){var c=e.options,c=[e.horiz?c.left:c.top,c.width,c.height,c.pane].join();e.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,e=a.tickPixelInterval;!t(a.tickInterval)&&this.len<e&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/e)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=
this.tickPositions,e=this.tickAmount,c=this.finalTickAmt,k=b&&b.length,f=F(this.threshold,this.softThreshold?0:null);if(this.hasData()){if(k<e){for(;b.length<e;)b.length%2||this.min===f?b.push(m(b[b.length-1]+a)):b.unshift(m(b[0]-a));this.transA*=(k-1)/(e-1);this.min=b[0];this.max=b[b.length-1]}else k>e&&(this.tickInterval*=2,this.setTickPositions());if(t(c)){for(a=e=b.length;a--;)(3===c&&1===a%2||2>=c&&0<a&&a<e-1)&&b.splice(a,1);this.finalTickAmt=void 0}}},setScale:function(){var a,b;this.oldMin=
this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;g(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=
b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();h(this,"afterSetScale")},setExtremes:function(a,b,e,c,k){var r=this,n=r.chart;e=F(e,!0);g(r.series,function(a){delete a.kdTree});k=f(k,{min:a,max:b});h(r,"setExtremes",k,function(){r.userMin=a;r.userMax=b;r.eventArgs=k;e&&n.redraw(c)})},zoom:function(a,b){var e=this.dataMin,c=this.dataMax,k=this.options,r=Math.min(e,F(k.min,e)),k=Math.max(c,F(k.max,c));if(a!==this.min||b!==this.max)this.allowZoomOutside||(t(e)&&
(a<r&&(a=r),a>k&&(a=k)),t(c)&&(b<r&&(b=r),b>k&&(b=k))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,e=this.options,c=e.offsets||[0,0,0,0],k=this.horiz,f=this.width=Math.round(a.relativeLength(F(e.width,b.plotWidth-c[3]+c[1]),b.plotWidth)),n=this.height=Math.round(a.relativeLength(F(e.height,b.plotHeight-c[0]+c[2]),b.plotHeight)),g=this.top=Math.round(a.relativeLength(F(e.top,b.plotTop+c[0]),b.plotHeight,b.plotTop)),
e=this.left=Math.round(a.relativeLength(F(e.left,b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-n-g;this.right=b.chartWidth-f-e;this.len=Math.max(k?f:n,0);this.pos=k?e:g},getExtremes:function(){var a=this.isLog;return{min:a?m(this.lin2log(this.min)):this.min,max:a?m(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,e=b?this.lin2log(this.min):this.min,b=b?this.lin2log(this.max):
this.max;null===a||-Infinity===a?a=e:Infinity===a?a=b:e>a?a=e:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(F(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,e=b[a+"Length"],c=F(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&e)return"inside"===b[a+"Position"]&&(e=-e),[e,c]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&
this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,e=this.tickInterval,c=e,k=this.len/(((this.categories?1:0)+this.max-this.min)/e),f,n=a.rotation,h=this.labelMetrics(),x,d=Number.MAX_VALUE,l,A=function(a){a/=k||1;a=1<a?Math.ceil(a):1;return m(a*e)};b?(l=!a.staggerLines&&!a.step&&(t(n)?[n]:k<F(a.autoRotationLimit,80)&&a.autoRotation))&&g(l,function(a){var b;if(a===n||a&&-90<=a&&90>=a)x=A(Math.abs(h.h/Math.sin(q*a))),b=
x+Math.abs(a/360),b<d&&(d=b,f=a,c=x)}):a.step||(c=A(h.h));this.autoRotation=l;this.labelRotation=F(f,n);return c},getSlotWidth:function(){var a=this.chart,b=this.horiz,e=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),k=a.margin[3];return b&&2>(e.step||0)&&!e.rotation&&(this.staggerLines||1)*this.len/c||!b&&(e.style&&parseInt(e.style.width,10)||k&&k-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,e=this.tickPositions,c=this.ticks,
k=this.options.labels,f=k&&k.style||{},n=this.horiz,h=this.getSlotWidth(),x=Math.max(1,Math.round(h-2*(k.padding||5))),d={},l=this.labelMetrics(),A=k.style&&k.style.textOverflow,u,C,E=0,w;G(k.rotation)||(d.rotation=k.rotation||0);g(e,function(a){(a=c[a])&&a.label&&a.label.textPxLength>E&&(E=a.label.textPxLength)});this.maxLabelLength=E;if(this.autoRotation)E>x&&E>l.h?d.rotation=this.labelRotation:this.labelRotation=0;else if(h&&(u=x,!A))for(C="clip",x=e.length;!n&&x--;)if(w=e[x],w=c[w].label)w.styles&&
"ellipsis"===w.styles.textOverflow?w.css({textOverflow:"clip"}):w.textPxLength>h&&w.css({width:h+"px"}),w.getBBox().height>this.len/e.length-(l.h-l.f)&&(w.specificTextOverflow="ellipsis");d.rotation&&(u=E>.5*a.chartHeight?.33*a.chartHeight:E,A||(C="ellipsis"));if(this.labelAlign=k.align||this.autoLabelAlign(this.labelRotation))d.align=this.labelAlign;g(e,function(a){var b=(a=c[a])&&a.label,e=f.width,k={};b&&(b.attr(d),u&&!e&&"nowrap"!==f.whiteSpace&&(u<b.textPxLength||"SPAN"===b.element.tagName)?
(k.width=u,A||(k.textOverflow=b.specificTextOverflow||C),b.css(k)):b.styles&&b.styles.width&&!k.width&&!e&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=d.rotation)});this.tickRotCorr=b.rotCorr(l.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||t(this.min)&&t(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,e=this.horiz,c=this.opposite,k=this.options.title,f;this.axisTitle||((f=k.textAlign)||
(f=(e?{low:"left",middle:"center",high:"right"}:{low:c?"right":"left",middle:"center",high:c?"left":"right"})[k.align]),this.axisTitle=b.text(k.text,0,0,k.useHTML).attr({zIndex:7,rotation:k.rotation||0,align:f}).addClass("highcharts-axis-title").css(C(k.style)).add(this.axisGroup),this.axisTitle.isNew=!0);k.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new L(this,a)},getOffset:function(){var a=
this,b=a.chart,e=b.renderer,c=a.options,k=a.tickPositions,f=a.ticks,n=a.horiz,x=a.side,d=b.inverted&&!a.isZAxis?[1,0,3,2][x]:x,l,A,C=0,E,w=0,m=c.title,G=c.labels,H=0,q=b.axisOffset,b=b.clipOffset,p=[-1,1,1,-1][x],L=c.className,M=a.axisParent,v=this.tickSize("tick");l=a.hasData();a.showAxis=A=l||F(c.showEmpty,!0);a.staggerLines=a.horiz&&G.staggerLines;a.axisGroup||(a.gridGroup=e.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(L||"")).add(M),a.axisGroup=
e.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(L||"")).add(M),a.labelGroup=e.g("axis-labels").attr({zIndex:G.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(L||"")).add(M));l||a.isLinked?(g(k,function(b,e){a.generateTick(b,e)}),a.renderUnsquish(),a.reserveSpaceDefault=0===x||2===x||{1:"left",3:"right"}[x]===a.labelAlign,F(G.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&g(k,function(a){H=Math.max(f[a].getLabelSize(),
H)}),a.staggerLines&&(H*=a.staggerLines),a.labelOffset=H*(a.opposite?-1:1)):u(f,function(a,b){a.destroy();delete f[b]});m&&m.text&&!1!==m.enabled&&(a.addTitle(A),A&&!1!==m.reserveSpace&&(a.titleOffset=C=a.axisTitle.getBBox()[n?"height":"width"],E=m.offset,w=t(E)?0:F(m.margin,n?5:10)));a.renderLine();a.offset=p*F(c.offset,q[x]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};e=0===x?-a.labelMetrics().h:2===x?a.tickRotCorr.y:0;w=Math.abs(H)+w;H&&(w=w-e+p*(n?F(G.y,a.tickRotCorr.y+8*p):G.x));a.axisTitleMargin=
F(E,w);q[x]=Math.max(q[x],a.axisTitleMargin+C+p*a.offset,w,l&&k.length&&v?v[0]+p*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[d]=Math.max(b[d],c);h(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,e=this.opposite,c=this.offset,k=this.horiz,f=this.left+(e?this.width:0)+c,c=b.chartHeight-this.bottom-(e?this.height:0)+c;e&&(a*=-1);return b.renderer.crispLine(["M",k?this.left:f,k?c:this.top,"L",k?b.chartWidth-this.right:f,k?c:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||
(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,e=this.top,c=this.len,k=this.options.title,f=a?b:e,n=this.opposite,x=this.offset,h=k.x||0,g=k.y||0,d=this.axisTitle,l=this.chart.renderer.fontMetrics(k.style&&k.style.fontSize,d),d=Math.max(d.getBBox(null,0).height-l.h-1,0),c={low:f+(a?0:c),middle:f+
c/2,high:f+(a?c:0)}[k.align],b=(a?e+this.height:b)+(a?1:-1)*(n?-1:1)*this.axisTitleMargin+[-d,d,l.f,-d][this.side];return{x:a?c+h:b+(n?this.width:0)+x+h,y:a?b+g-(n?this.height:0)+x:c+g}},renderMinorTick:function(a){var b=this.chart.hasRendered&&A(this.oldMin),e=this.minorTicks;e[a]||(e[a]=new L(this,a,"minor"));b&&e[a].isNew&&e[a].render(null,!0);e[a].render(null,!1,1)},renderTick:function(a,b){var e=this.isLinked,c=this.ticks,k=this.chart.hasRendered&&A(this.oldMin);if(!e||a>=this.min&&a<=this.max)c[a]||
(c[a]=new L(this,a)),k&&c[a].isNew&&c[a].render(b,!0,.1),c[a].render(b)},render:function(){var b=this,e=b.chart,c=b.options,k=b.isLog,f=b.isLinked,n=b.tickPositions,d=b.axisTitle,l=b.ticks,C=b.minorTicks,E=b.alternateBands,w=c.stackLabels,m=c.alternateGridColor,G=b.tickmarkOffset,H=b.axisLine,q=b.showAxis,p=y(e.renderer.globalAnimation),F,M;b.labelEdge.length=0;b.overlap=!1;g([l,C,E],function(a){u(a,function(a){a.isActive=!1})});if(b.hasData()||f)b.minorTickInterval&&!b.categories&&g(b.getMinorTickPositions(),
function(a){b.renderMinorTick(a)}),n.length&&(g(n,function(a,e){b.renderTick(a,e)}),G&&(0===b.min||b.single)&&(l[-1]||(l[-1]=new L(b,-1,null,!0)),l[-1].render(-1))),m&&g(n,function(c,f){M=void 0!==n[f+1]?n[f+1]+G:b.max-G;0===f%2&&c<b.max&&M<=b.max+(e.polar?-G:G)&&(E[c]||(E[c]=new a.PlotLineOrBand(b)),F=c+G,E[c].options={from:k?b.lin2log(F):F,to:k?b.lin2log(M):M,color:m},E[c].render(),E[c].isActive=!0)}),b._addedPlotLB||(g((c.plotLines||[]).concat(c.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),
b._addedPlotLB=!0);g([l,C,E],function(a){var b,c=[],k=p.duration;u(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,c.push(b))});x(function(){for(b=c.length;b--;)a[c[b]]&&!a[c[b]].isActive&&(a[c[b]].destroy(),delete a[c[b]])},a!==E&&e.hasRendered&&k?k:0)});H&&(H[H.isPlaced?"animate":"attr"]({d:this.getLinePath(H.strokeWidth())}),H.isPlaced=!0,H[q?"show":"hide"](!0));d&&q&&(c=b.getTitlePosition(),A(c.y)?(d[d.isNew?"attr":"animate"](c),d.isNew=!1):(d.attr("y",-9999),d.isNew=!0));w&&w.enabled&&
b.renderStackTotals();b.isDirty=!1;h(this,"afterRender")},redraw:function(){this.visible&&(this.render(),g(this.plotLinesAndBands,function(a){a.render()}));g(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,c=b.stacks,f=b.plotLinesAndBands,n;h(this,"destroy",{keepEvents:a});a||k(b);u(c,function(a,b){l(a);c[b]=null});g([b.ticks,b.minorTicks,b.alternateBands],function(a){l(a)});if(f)for(a=f.length;a--;)f[a].destroy();
g("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(n in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[n]=b.plotLinesAndBandsGroups[n].destroy();u(b,function(a,c){-1===e(c,b.keepProps)&&delete b[c]})},drawCrosshair:function(a,b){var e,c=this.crosshair,k=F(c.snap,!0),f,n=this.cross;h(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(t(b)||!k)){k?t(b)&&(f=F(b.crosshairPos,
this.isXAxis?b.plotX:this.len-b.plotY)):f=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);t(f)&&(e=this.getPlotLinePath(b&&(this.isXAxis?b.x:F(b.stackY,b.y)),null,null,null,f)||null);if(!t(e)){this.hideCrosshair();return}k=this.categories&&!this.isRadial;n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(k?"category ":"thin ")+c.className).attr({zIndex:F(c.zIndex,2)}).add(),n.attr({stroke:c.color||(k?d("#ccd6eb").setOpacity(.25).get():"#cccccc"),
"stroke-width":F(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&n.attr({dashstyle:c.dashStyle}));n.show().attr({d:e});k&&!c.width&&n.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();h(this,"afterDrawCrosshair",{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=H}(J);(function(a){var B=a.Axis,y=a.getMagnitude,D=a.map,p=a.normalizeTickInterval,d=a.pick;B.prototype.getLogTickPositions=function(a,v,t,q){var l=this.options,g=this.len,
f=[];q||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),f=this.getLinearTickPositions(a,v,t);else if(.08<=a)for(var g=Math.floor(v),h,w,c,b,e,l=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];g<t+1&&!e;g++)for(w=l.length,h=0;h<w&&!e;h++)c=this.log2lin(this.lin2log(g)*l[h]),c>v&&(!q||b<=t)&&void 0!==b&&f.push(b),b>t&&(e=!0),b=c;else v=this.lin2log(v),t=this.lin2log(t),a=q?this.getMinorTickInterval():l.tickInterval,a=d("auto"===a?null:a,this._minorAutoInterval,l.tickPixelInterval/(q?5:1)*
(t-v)/((q?g/this.tickPositions.length:g)||1)),a=p(a,null,y(a)),f=D(this.getLinearTickPositions(a,v,t),this.log2lin),q||(this._minorAutoInterval=a/5);q||(this.tickInterval=a);return f};B.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};B.prototype.lin2log=function(a){return Math.pow(10,a)}})(J);(function(a,B){var y=a.arrayMax,D=a.arrayMin,p=a.defined,d=a.destroyObjectProperties,m=a.each,v=a.erase,t=a.merge,q=a.pick;a.PlotLineOrBand=function(a,d){this.axis=a;d&&(this.options=d,this.id=d.id)};
a.PlotLineOrBand.prototype={render:function(){var d=this,g=d.axis,f=g.horiz,h=d.options,w=h.label,c=d.label,b=h.to,e=h.from,n=h.value,A=p(e)&&p(b),G=p(n),C=d.svgElem,m=!C,u=[],F=h.color,k=q(h.zIndex,0),E=h.events,u={"class":"highcharts-plot-"+(A?"band ":"line ")+(h.className||"")},x={},L=g.chart.renderer,H=A?"bands":"lines";g.isLog&&(e=g.log2lin(e),b=g.log2lin(b),n=g.log2lin(n));G?(u.stroke=F,u["stroke-width"]=h.width,h.dashStyle&&(u.dashstyle=h.dashStyle)):A&&(F&&(u.fill=F),h.borderWidth&&(u.stroke=
h.borderColor,u["stroke-width"]=h.borderWidth));x.zIndex=k;H+="-"+k;(F=g.plotLinesAndBandsGroups[H])||(g.plotLinesAndBandsGroups[H]=F=L.g("plot-"+H).attr(x).add());m&&(d.svgElem=C=L.path().attr(u).add(F));if(G)u=g.getPlotLinePath(n,C.strokeWidth());else if(A)u=g.getPlotBandPath(e,b,h);else return;m&&u&&u.length?(C.attr({d:u}),E&&a.objectEach(E,function(a,b){C.on(b,function(a){E[b].apply(d,[a])})})):C&&(u?(C.show(),C.animate({d:u})):(C.hide(),c&&(d.label=c=c.destroy())));w&&p(w.text)&&u&&u.length&&
0<g.width&&0<g.height&&!u.isFlat?(w=t({align:f&&A&&"center",x:f?!A&&4:10,verticalAlign:!f&&A&&"middle",y:f?A?16:10:A?6:-4,rotation:f&&!A&&90},w),this.renderLabel(w,u,A,k)):c&&c.hide();return d},renderLabel:function(a,d,f,h){var g=this.label,c=this.axis.chart.renderer;g||(g={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(f?"band":"line")+"-label "+(a.className||"")},g.zIndex=h,this.label=g=c.text(a.text,0,0,a.useHTML).attr(g).add(),g.css(a.style));h=d.xBounds||[d[1],d[4],
f?d[6]:d[1]];d=d.yBounds||[d[2],d[5],f?d[7]:d[2]];f=D(h);c=D(d);g.align(a,!1,{x:f,y:c,width:y(h)-f,height:y(d)-c});g.show()},destroy:function(){v(this.axis.plotLinesAndBands,this);delete this.axis;d(this)}};a.extend(B.prototype,{getPlotBandPath:function(a,d){var f=this.getPlotLinePath(d,null,null,!0),h=this.getPlotLinePath(a,null,null,!0),g=[],c=this.horiz,b=1,e;a=a<this.min&&d<this.min||a>this.max&&d>this.max;if(h&&f)for(a&&(e=h.toString()===f.toString(),b=0),a=0;a<h.length;a+=6)c&&f[a+1]===h[a+
1]?(f[a+1]+=b,f[a+4]+=b):c||f[a+2]!==h[a+2]||(f[a+2]+=b,f[a+5]+=b),g.push("M",h[a+1],h[a+2],"L",h[a+4],h[a+5],f[a+4],f[a+5],f[a+1],f[a+2],"z"),g.isFlat=e;return g},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(d,g){var f=(new a.PlotLineOrBand(this,d)).render(),h=this.userOptions;f&&(g&&(h[g]=h[g]||[],h[g].push(d)),this.plotLinesAndBands.push(f));return f},removePlotBandOrLine:function(a){for(var d=
this.plotLinesAndBands,f=this.options,h=this.userOptions,l=d.length;l--;)d[l].id===a&&d[l].destroy();m([f.plotLines||[],h.plotLines||[],f.plotBands||[],h.plotBands||[]],function(c){for(l=c.length;l--;)c[l].id===a&&v(c,c[l])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(J,W);(function(a){var B=a.doc,y=a.each,D=a.extend,p=a.format,d=a.isNumber,m=a.map,v=a.merge,t=a.pick,q=a.splat,l=a.syncTimeout,g=a.timeUnits;a.Tooltip=function(){this.init.apply(this,
arguments)};a.Tooltip.prototype={init:function(a,d){this.chart=a;this.options=d;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=d.split&&!a.inverted;this.shared=d.shared||this.split;this.outside=d.outside&&!this.split},cleanSplit:function(a){y(this.chart.series,function(f){var d=f&&f.tt;d&&(!d.isActive||a?f.tt=d.destroy():d.isActive=!1)})},getLabel:function(){var f=this.chart.renderer,d=this.options,g;this.label||(this.outside&&(this.container=g=a.doc.createElement("div"),g.className=
"highcharts-tooltip-container",a.css(g,{position:"absolute",top:"1px",pointerEvents:d.style&&d.style.pointerEvents}),a.doc.body.appendChild(g),this.renderer=f=new a.Renderer(g,0,0)),this.split?this.label=f.g("tooltip"):(this.label=f.label("",0,0,d.shape||"callout",null,null,d.useHTML,null,"tooltip").attr({padding:d.padding,r:d.borderRadius}),this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow)),this.outside&&(this.label.attr({x:this.distance,y:this.distance}),
this.label.xSetter=function(a){g.style.left=a+"px"},this.label.ySetter=function(a){g.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();v(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,v(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),a.discardElement(this.container));
a.clearTimeout(this.hideTimer);a.clearTimeout(this.tooltipTimeout)},move:function(f,d,g,c){var b=this,e=b.now,n=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(f-e.x)||1<Math.abs(d-e.y)),h=b.followPointer||1<b.len;D(e,{x:n?(2*e.x+f)/3:f,y:n?(e.y+d)/2:d,anchorX:h?void 0:n?(2*e.anchorX+g)/3:g,anchorY:h?void 0:n?(e.anchorY+c)/2:c});b.getLabel().attr(e);n&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&b.move(f,d,g,c)},32))},hide:function(f){var d=this;a.clearTimeout(this.hideTimer);
f=t(f,this.options.hideDelay,500);this.isHidden||(this.hideTimer=l(function(){d.getLabel()[f?"fadeOut":"hide"]();d.isHidden=!0},f))},getAnchor:function(a,d){var f=this.chart,c=f.pointer,b=f.inverted,e=f.plotTop,n=f.plotLeft,g=0,h=0,l,p;a=q(a);this.followPointer&&d||c.followTouchMove&&d&&"touchmove"===d.type?(void 0===d.chartX&&(d=c.normalize(d)),a=[d.chartX-f.plotLeft,d.chartY-e]):a[0].tooltipPos?a=a[0].tooltipPos:(y(a,function(a){l=a.series.yAxis;p=a.series.xAxis;g+=a.plotX+(!b&&p?p.left-n:0);h+=
(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!b&&l?l.top-e:0)}),g/=a.length,h/=a.length,a=[b?f.plotWidth-h:g,this.shared&&!b&&1<a.length&&d?d.chartY-e:b?f.plotHeight-g:h]);return m(a,Math.round)},getPosition:function(a,d,g){var c=this.chart,b=this.distance,e={},f=c.inverted&&g.h||0,h,l=this.outside,C=l?B.documentElement.clientWidth-2*b:c.chartWidth,w=l?Math.max(B.body.scrollHeight,B.documentElement.scrollHeight,B.body.offsetHeight,B.documentElement.offsetHeight,B.documentElement.clientHeight):c.chartHeight,
u=c.pointer.chartPosition,m=["y",w,d,(l?u.top-b:0)+g.plotY+c.plotTop,l?0:c.plotTop,l?w:c.plotTop+c.plotHeight],k=["x",C,a,(l?u.left-b:0)+g.plotX+c.plotLeft,l?0:c.plotLeft,l?C:c.plotLeft+c.plotWidth],E=!this.followPointer&&t(g.ttBelow,!c.inverted===!!g.negative),x=function(a,c,k,n,d,g){var x=k<n-b,r=n+b+k<c,h=n-b-k;n+=b;if(E&&r)e[a]=n;else if(!E&&x)e[a]=h;else if(x)e[a]=Math.min(g-k,0>h-f?h:h-f);else if(r)e[a]=Math.max(d,n+f+k>c?n:n+f);else return!1},q=function(a,c,k,f){var n;f<b||f>c-b?n=!1:e[a]=
f<k/2?1:f>c-k/2?c-k-2:f-k/2;return n},H=function(a){var b=m;m=k;k=b;h=a},r=function(){!1!==x.apply(0,m)?!1!==q.apply(0,k)||h||(H(!0),r()):h?e.x=e.y=0:(H(!0),r())};(c.inverted||1<this.len)&&H();r();return e},defaultFormatter:function(a){var f=this.points||q(this),d;d=[a.tooltipFooterHeaderFormatter(f[0])];d=d.concat(a.bodyFormatter(f));d.push(a.tooltipFooterHeaderFormatter(f[0],!0));return d},refresh:function(f,d){var g,c=this.options,b,e=f,n,h={},l=[];g=c.formatter||this.defaultFormatter;var h=this.shared,
C;c.enabled&&(a.clearTimeout(this.hideTimer),this.followPointer=q(e)[0].series.tooltipOptions.followPointer,n=this.getAnchor(e,d),d=n[0],b=n[1],!h||e.series&&e.series.noSharedTooltip?h=e.getLabelConfig():(y(e,function(a){a.setState("hover");l.push(a.getLabelConfig())}),h={x:e[0].category,y:e[0].y},h.points=l,e=e[0]),this.len=l.length,h=g.call(h,this),C=e.series,this.distance=t(C.tooltipOptions.distance,16),!1===h?this.hide():(g=this.getLabel(),this.isHidden&&g.attr({opacity:1}).show(),this.split?
this.renderSplit(h,q(f)):(c.style.width||g.css({width:this.chart.spacingBox.width}),g.attr({text:h&&h.join?h.join(""):h}),g.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+t(e.colorIndex,C.colorIndex)),g.attr({stroke:c.borderColor||e.color||C.color||"#666666"}),this.updatePosition({plotX:d,plotY:b,negative:e.negative,ttBelow:e.ttBelow,h:n[2]||0})),this.isHidden=!1))},renderSplit:function(f,d){var g=this,c=[],b=this.chart,e=b.renderer,n=!0,h=this.options,l=0,C=this.getLabel();a.isString(f)&&
(f=[!1,f]);y(f.slice(0,d.length+1),function(a,f){if(!1!==a){f=d[f-1]||{isHeader:!0,plotX:d[0].plotX};var A=f.series||g,k=A.tt,E=f.series||{},x="highcharts-color-"+t(f.colorIndex,E.colorIndex,"none");k||(A.tt=k=e.label(null,null,null,"callout",null,null,h.useHTML).addClass("highcharts-tooltip-box "+x).attr({padding:h.padding,r:h.borderRadius,fill:h.backgroundColor,stroke:h.borderColor||f.color||E.color||"#333333","stroke-width":h.borderWidth}).add(C));k.isActive=!0;k.attr({text:a});k.css(h.style).shadow(h.shadow);
a=k.getBBox();E=a.width+k.strokeWidth();f.isHeader?(l=a.height,E=Math.max(0,Math.min(f.plotX+b.plotLeft-E/2,b.chartWidth-E))):E=f.plotX+b.plotLeft-t(h.distance,16)-E;0>E&&(n=!1);a=(f.series&&f.series.yAxis&&f.series.yAxis.pos)+(f.plotY||0);a-=b.plotTop;c.push({target:f.isHeader?b.plotHeight+l:a,rank:f.isHeader?1:0,size:A.tt.getBBox().height+1,point:f,x:E,tt:k})}});this.cleanSplit();a.distribute(c,b.plotHeight+l);y(c,function(a){var e=a.point,c=e.series;a.tt.attr({visibility:void 0===a.pos?"hidden":
"inherit",x:n||e.isHeader?a.x:e.plotX+b.plotLeft+t(h.distance,16),y:a.pos+b.plotTop,anchorX:e.isHeader?e.plotX+b.plotLeft:e.plotX+c.xAxis.pos,anchorY:e.isHeader?a.pos+b.plotTop-15:e.plotY+c.yAxis.pos})})},updatePosition:function(a){var f=this.chart,d=this.getLabel(),c=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a),b=a.plotX+f.plotLeft;a=a.plotY+f.plotTop;var e;this.outside&&(e=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(d.width+e,d.height+e,!1),b+=
f.pointer.chartPosition.left-c.x,a+=f.pointer.chartPosition.top-c.y);this.move(Math.round(c.x),Math.round(c.y||0),b,a)},getDateFormat:function(a,d,l,c){var b=this.chart.time,e=b.dateFormat("%m-%d %H:%M:%S.%L",d),f,h,m={millisecond:15,second:12,minute:9,hour:6,day:3},C="millisecond";for(h in g){if(a===g.week&&+b.dateFormat("%w",d)===l&&"00:00:00.000"===e.substr(6)){h="week";break}if(g[h]>a){h=C;break}if(m[h]&&e.substr(m[h])!=="01-01 00:00:00.000".substr(m[h]))break;"week"!==h&&(C=h)}h&&(f=c[h]);return f},
getXDateFormat:function(a,d,g){d=d.dateTimeLabelFormats;var c=g&&g.closestPointRange;return(c?this.getDateFormat(c,a.x,g.options.startOfWeek,d):d.day)||d.year},tooltipFooterHeaderFormatter:function(a,g){g=g?"footer":"header";var f=a.series,c=f.tooltipOptions,b=c.xDateFormat,e=f.xAxis,n=e&&"datetime"===e.options.type&&d(a.key),h=c[g+"Format"];n&&!b&&(b=this.getXDateFormat(a,c,e));n&&b&&y(a.point&&a.point.tooltipDateKeys||["key"],function(a){h=h.replace("{point."+a+"}","{point."+a+":"+b+"}")});return p(h,
{point:a,series:f},this.chart.time)},bodyFormatter:function(a){return m(a,function(a){var f=a.series.tooltipOptions;return(f[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,f[(a.point.formatPrefix||"point")+"Format"])})}}})(J);(function(a){var B=a.addEvent,y=a.attr,D=a.charts,p=a.color,d=a.css,m=a.defined,v=a.each,t=a.extend,q=a.find,l=a.fireEvent,g=a.isNumber,f=a.isObject,h=a.offset,w=a.pick,c=a.splat,b=a.Tooltip;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype=
{init:function(a,c){this.options=c;this.chart=a;this.runChartClick=c.chart.events&&!!c.chart.events.click;this.pinchDown=[];this.lastValidTouch={};b&&(a.tooltip=new b(a,c.tooltip),this.followTouchMove=w(c.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,e=b.options.chart,c=e.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(c=w(e.pinchType,c));this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||
c},normalize:function(a,b){var e;e=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=h(this.chart.container));return t(a,{chartX:Math.round(e.pageX-b.left),chartY:Math.round(e.pageY-b.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};v(this.chart.axes,function(e){b[e.isXAxis?"xAxis":"yAxis"].push({axis:e,value:e.toValue(a[e.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,c){var e;v(a,function(a){var d=!(a.noSharedTooltip&&
b)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(c,d);if((d=f(a,!0))&&!(d=!f(e,!0)))var d=e.distX-a.distX,n=e.dist-a.dist,g=(a.series.group&&a.series.group.zIndex)-(e.series.group&&e.series.group.zIndex),d=0<(0!==d&&b?d:0!==n?n:0!==g?g:e.series.index>a.series.index?-1:1);d&&(e=a)});return e},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var e=a.series,c=e.xAxis,e=e.yAxis,f=w(a.clientX,a.plotX),
d=a.shapeArgs;if(c&&e)return b?{chartX:c.len+c.pos-f,chartY:e.len+e.pos-a.plotY}:{chartX:f+c.pos,chartY:a.plotY+e.pos};if(d&&d.x&&d.y)return{chartX:d.x,chartY:d.y}},getHoverData:function(b,c,d,g,h,l,u){var e,k=[],n=u&&u.isBoosting;g=!(!g||!b);u=c&&!c.stickyTracking?[c]:a.grep(d,function(a){return a.visible&&!(!h&&a.directTouch)&&w(a.options.enableMouseTracking,!0)&&a.stickyTracking});c=(e=g?b:this.findNearestKDPoint(u,h,l))&&e.series;e&&(h&&!c.noSharedTooltip?(u=a.grep(d,function(a){return a.visible&&
!(!h&&a.directTouch)&&w(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),v(u,function(a){var b=q(a.points,function(a){return a.x===e.x&&!a.isNull});f(b)&&(n&&(b=a.getPoint(b)),k.push(b))})):k.push(e));return{hoverPoint:e,hoverSeries:c,hoverPoints:k}},runPointActions:function(b,c){var e=this.chart,f=e.tooltip&&e.tooltip.options.enabled?e.tooltip:void 0,d=f?f.shared:!1,n=c||e.hoverPoint,g=n&&n.series||e.hoverSeries,g=this.getHoverData(n,g,e.series,!!c||g&&g.directTouch&&this.isDirectTouch,d,
b,{isBoosting:e.isBoosting}),h,n=g.hoverPoint;h=g.hoverPoints;g=g.hoverSeries;c=b&&"touchmove"===b.type?!0===this.followTouchMove:g&&g.tooltipOptions.followPointer;d=d&&g&&!g.noSharedTooltip;if(n&&(n!==e.hoverPoint||f&&f.isHidden)){v(e.hoverPoints||[],function(b){-1===a.inArray(b,h)&&b.setState()});v(h||[],function(a){a.setState("hover")});if(e.hoverSeries!==g)g.onMouseOver();e.hoverPoint&&e.hoverPoint.firePointEvent("mouseOut");if(!n.series)return;n.firePointEvent("mouseOver");e.hoverPoints=h;e.hoverPoint=
n;f&&f.refresh(d?h:n,b)}else c&&f&&!f.isHidden&&(n=f.getAnchor([{}],b),f.updatePosition({plotX:n[0],plotY:n[1]}));this.unDocMouseMove||(this.unDocMouseMove=B(e.container.ownerDocument,"mousemove",function(b){var e=D[a.hoverChartIndex];if(e)e.pointer.onDocumentMouseMove(b)}));v(e.axes,function(e){var c=w(e.crosshair.snap,!0),k=c?a.find(h,function(a){return a.series[e.coll]===e}):void 0;k||!c?e.drawCrosshair(b,k):e.hideCrosshair()})},reset:function(a,b){var e=this.chart,f=e.hoverSeries,d=e.hoverPoint,
n=e.hoverPoints,g=e.tooltip,h=g&&g.shared?n:d;a&&h&&v(c(h),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)g&&h&&(g.refresh(h),g.shared&&n?v(n,function(a){a.setState(a.state,!0);a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a);a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a)}):d&&(d.setState(d.state,!0),v(e.axes,function(a){a.crosshair&&a.drawCrosshair(null,d)})));else{if(d)d.onMouseOut();n&&v(n,function(a){a.setState()});if(f)f.onMouseOut();g&&g.hide(b);
this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());v(e.axes,function(a){a.hideCrosshair()});this.hoverX=e.hoverPoints=e.hoverPoint=null}},scaleGroups:function(a,b){var e=this.chart,c;v(e.series,function(f){c=a||f.getPlotBox();f.xAxis&&f.xAxis.zoomEnabled&&f.group&&(f.group.attr(c),f.markerGroup&&(f.markerGroup.attr(c),f.markerGroup.clip(b?e.clipRect:null)),f.dataLabelsGroup&&f.dataLabelsGroup.attr(c))});e.clipRect.attr(b||e.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=
a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,e=b.options.chart,c=a.chartX,f=a.chartY,d=this.zoomHor,g=this.zoomVert,h=b.plotLeft,k=b.plotTop,l=b.plotWidth,x=b.plotHeight,m,H=this.selectionMarker,r=this.mouseDownX,q=this.mouseDownY,w=e.panKey&&a[e.panKey+"Key"];H&&H.touch||(c<h?c=h:c>h+l&&(c=h+l),f<k?f=k:f>k+x&&(f=k+x),this.hasDragged=Math.sqrt(Math.pow(r-c,2)+Math.pow(q-f,2)),10<this.hasDragged&&(m=b.isInsidePlot(r-
h,q-k),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&m&&!w&&!H&&(this.selectionMarker=H=b.renderer.rect(h,k,d?1:l,g?1:x,0).attr({fill:e.selectionMarkerFill||p("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),H&&d&&(c-=r,H.attr({width:Math.abs(c),x:(0<c?0:c)+r})),H&&g&&(c=f-q,H.attr({height:Math.abs(c),y:(0<c?0:c)+q})),m&&!H&&e.panning&&b.pan(a,e.panning)))},drop:function(a){var b=this,c=this.chart,e=this.hasPinched;if(this.selectionMarker){var f={originalEvent:a,
xAxis:[],yAxis:[]},h=this.selectionMarker,u=h.attr?h.attr("x"):h.x,q=h.attr?h.attr("y"):h.y,k=h.attr?h.attr("width"):h.width,E=h.attr?h.attr("height"):h.height,x;if(this.hasDragged||e)v(c.axes,function(c){if(c.zoomEnabled&&m(c.min)&&(e||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var d=c.horiz,n="touchend"===a.type?c.minPixelPadding:0,g=c.toValue((d?u:q)+n),d=c.toValue((d?u+k:q+E)-n);f[c.coll].push({axis:c,min:Math.min(g,d),max:Math.max(g,d)});x=!0}}),x&&l(c,"selection",f,function(a){c.zoom(t(a,e?
{animation:!1}:null))});g(c.index)&&(this.selectionMarker=this.selectionMarker.destroy());e&&this.scaleGroups()}c&&g(c.index)&&(d(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(b){D[a.hoverChartIndex]&&D[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=
this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=D[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;m(a.hoverChartIndex)&&D[a.hoverChartIndex]&&D[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=
!1;"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var c;a;){if(c=y(a,"class")){if(-1!==c.indexOf(b))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||
this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,e=b.plotLeft,f=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(l(c.series,"click",t(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(t(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-e,a.chartY-f)&&l(b,"click",a)))},setDOMEvents:function(){var b=this,c=b.chart.container,f=c.ownerDocument;
c.onmousedown=function(a){b.onContainerMouseDown(a)};c.onmousemove=function(a){b.onContainerMouseMove(a)};c.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=B(c,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=B(f,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(c.ontouchstart=function(a){b.onContainerTouchStart(a)},c.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=B(f,"touchend",b.onDocumentTouchEnd)))},
destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,c){b[c]=null})}}})(J);(function(a){var B=a.charts,y=a.each,D=a.extend,p=a.map,d=a.noop,m=a.pick;D(a.Pointer.prototype,{pinchTranslate:function(a,d,m,l,g,f){this.zoomHor&&
this.pinchTranslateDirection(!0,a,d,m,l,g,f);this.zoomVert&&this.pinchTranslateDirection(!1,a,d,m,l,g,f)},pinchTranslateDirection:function(a,d,m,l,g,f,h,w){var c=this.chart,b=a?"x":"y",e=a?"X":"Y",n="chart"+e,q=a?"width":"height",p=c["plot"+(a?"Left":"Top")],C,t,u=w||1,F=c.inverted,k=c.bounds[a?"h":"v"],E=1===d.length,x=d[0][n],L=m[0][n],H=!E&&d[1][n],r=!E&&m[1][n],z;m=function(){!E&&20<Math.abs(x-H)&&(u=w||Math.abs(L-r)/Math.abs(x-H));t=(p-L)/u+x;C=c["plot"+(a?"Width":"Height")]/u};m();d=t;d<k.min?
(d=k.min,z=!0):d+C>k.max&&(d=k.max-C,z=!0);z?(L-=.8*(L-h[b][0]),E||(r-=.8*(r-h[b][1])),m()):h[b]=[L,r];F||(f[b]=t-p,f[q]=C);f=F?1/u:u;g[q]=C;g[b]=d;l[F?a?"scaleY":"scaleX":"scale"+e]=u;l["translate"+e]=f*p+(L-f*x)},pinch:function(a){var t=this,q=t.chart,l=t.pinchDown,g=a.touches,f=g.length,h=t.lastValidTouch,w=t.hasZoom,c=t.selectionMarker,b={},e=1===f&&(t.inClass(a.target,"highcharts-tracker")&&q.runTrackerClick||t.runChartClick),n={};1<f&&(t.initiated=!0);w&&t.initiated&&!e&&a.preventDefault();
p(g,function(a){return t.normalize(a)});"touchstart"===a.type?(y(g,function(a,b){l[b]={chartX:a.chartX,chartY:a.chartY}}),h.x=[l[0].chartX,l[1]&&l[1].chartX],h.y=[l[0].chartY,l[1]&&l[1].chartY],y(q.axes,function(a){if(a.zoomEnabled){var b=q.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,e=a.toPixels(m(a.options.min,a.dataMin)),f=a.toPixels(m(a.options.max,a.dataMax)),d=Math.max(e,f);b.min=Math.min(a.pos,Math.min(e,f)-c);b.max=Math.max(a.pos+a.len,d+c)}}),t.res=!0):t.followTouchMove&&1===f?this.runPointActions(t.normalize(a)):
l.length&&(c||(t.selectionMarker=c=D({destroy:d,touch:!0},q.plotBox)),t.pinchTranslate(l,g,b,c,n,h),t.hasPinched=w,t.scaleGroups(b,n),t.res&&(t.res=!1,this.reset(!1,0)))},touch:function(d,p){var q=this.chart,l,g;if(q.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=q.index;1===d.touches.length?(d=this.normalize(d),(g=q.isInsidePlot(d.chartX-q.plotLeft,d.chartY-q.plotTop))&&!q.openMenu?(p&&this.runPointActions(d),"touchmove"===d.type&&(p=this.pinchDown,l=p[0]?
4<=Math.sqrt(Math.pow(p[0].chartX-d.chartX,2)+Math.pow(p[0].chartY-d.chartY,2)):!1),m(l,!0)&&this.pinch(d)):p&&this.reset()):2===d.touches.length&&this.pinch(d)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(d){B[a.hoverChartIndex]&&B[a.hoverChartIndex].pointer.drop(d)}})})(J);(function(a){var B=a.addEvent,y=a.charts,D=a.css,p=a.doc,d=a.extend,m=a.noop,v=a.Pointer,t=a.removeEvent,q=a.win,l=a.wrap;
if(!a.hasTouch&&(q.PointerEvent||q.MSPointerEvent)){var g={},f=!!q.PointerEvent,h=function(){var c=[];c.item=function(a){return this[a]};a.objectEach(g,function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},w=function(c,b,e,f){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!y[a.hoverChartIndex]||(f(c),f=y[a.hoverChartIndex].pointer,f[b]({type:e,target:c.currentTarget,preventDefault:m,touches:h()}))};d(v.prototype,{onContainerPointerDown:function(a){w(a,"onContainerTouchStart",
"touchstart",function(a){g[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){w(a,"onContainerTouchMove","touchmove",function(a){g[a.pointerId]={pageX:a.pageX,pageY:a.pageY};g[a.pointerId].target||(g[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){w(a,"onDocumentTouchEnd","touchend",function(a){delete g[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,f?"pointerdown":"MSPointerDown",this.onContainerPointerDown);
a(this.chart.container,f?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(p,f?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});l(v.prototype,"init",function(a,b,e){a.call(this,b,e);this.hasZoom&&D(b.container,{"-ms-touch-action":"none","touch-action":"none"})});l(v.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(B)});l(v.prototype,"destroy",function(a){this.batchMSEvents(t);a.call(this)})}})(J);(function(a){var B=a.addEvent,
y=a.css,D=a.discardElement,p=a.defined,d=a.each,m=a.fireEvent,v=a.isFirefox,t=a.marginNames,q=a.merge,l=a.pick,g=a.setAnimation,f=a.stableSort,h=a.win,w=a.wrap;a.Legend=function(a,b){this.init(a,b)};a.Legend.prototype={init:function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),B(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=B(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&
this.unchartrender())},setOptions:function(a){var b=l(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.symbolWidth=l(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,b){var c=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();c.isDirtyLegend=c.isDirtyBox=!0;l(b,!0)&&c.redraw();m(this,
"afterUpdate")},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");var c=this.options,f=a.legendItem,d=a.legendLine,g=a.legendSymbol,h=this.itemHiddenStyle.color,c=b?c.itemStyle.color:h,l=b?a.color||h:h,u=a.options&&a.options.marker,q={fill:l};f&&f.css({fill:c,color:c});d&&d.attr({stroke:l});g&&(u&&g.isMarker&&(q=a.pointAttribs(),b||(q.stroke=q.fill=h)),g.attr(q));m(this,"afterColorizeItem",{item:a,visible:b})},positionItems:function(){d(this.allItems,
this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var b=this.options,c=b.symbolPadding,b=!b.rtl,f=a._legendItemPos,d=f[0],f=f[1],g=a.checkbox;if((a=a.legendGroup)&&a.element)a[p(a.translateY)?"animate":"attr"]({translateX:b?d:this.legendWidth-d-2*c-4,translateY:f});g&&(g.x=d,g.y=f)},destroyItem:function(a){var b=a.checkbox;d(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&D(a.checkbox)},destroy:function(){function a(a){this[a]&&
(this[a]=this[a].destroy())}d(this.getAllItems(),function(b){d(["legendItem","legendGroup"],a,b)});d("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,b,e=this.clipHeight||this.legendHeight,f=this.titleHeight;a&&(b=a.translateY,d(this.allItems,function(c){var d=c.checkbox,g;d&&(g=b+f+d.y+(this.scrollOffset||0)+3,y(d,{left:a.translateX+c.checkboxOffset+d.x-20+"px",top:g+"px",display:g>b-6&&g<b+e-6?
"":"none"}))},this))},renderTitle:function(){var a=this.options,b=this.padding,e=a.title,f=0;e.text&&(this.title||(this.title=this.chart.renderer.label(e.text,b-3,b-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(e.style).add(this.group)),a=this.title.getBBox(),f=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:f}));this.titleHeight=f},setText:function(c){var b=this.options;c.legendItem.attr({text:b.labelFormat?a.format(b.labelFormat,c,this.chart.time):b.labelFormatter.call(c)})},
renderItem:function(a){var b=this.chart,c=b.renderer,f=this.options,d=this.symbolWidth,g=f.symbolPadding,h=this.itemStyle,m=this.itemHiddenStyle,u="horizontal"===f.layout?l(f.itemDistance,20):0,p=!f.rtl,k=a.legendItem,E=!a.series,x=!E&&a.series.drawLegendSymbol?a.series:a,w=x.options,w=this.createCheckboxForItem&&w&&w.showCheckbox,u=d+g+u+(w?20:0),H=f.useHTML,r=a.options.className;k||(a.legendGroup=c.g("legend-item").addClass("highcharts-"+x.type+"-series highcharts-color-"+a.colorIndex+(r?" "+r:
"")+(E?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=k=c.text("",p?d+g:-g,this.baseline||0,H).css(q(a.visible?h:m)).attr({align:p?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(d=h.fontSize,this.fontMetrics=c.fontMetrics(d,k),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,k.attr("y",this.baseline)),this.symbolHeight=f.symbolHeight||this.fontMetrics.f,x.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,k,H),w&&this.createCheckboxForItem(a));
this.colorizeItem(a,a.visible);h.width||k.css({width:(f.itemWidth||f.width||b.spacingBox.width)-u});this.setText(a);b=k.getBBox();a.itemWidth=a.checkboxOffset=f.itemWidth||a.legendItemWidth||b.width+u;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||b.height||this.symbolHeight)},layoutItem:function(a){var b=this.options,c=this.padding,f="horizontal"===b.layout,d=a.itemHeight,g=b.itemMarginBottom||
0,h=this.itemMarginTop,m=f?l(b.itemDistance,20):0,u=b.width,q=u||this.chart.spacingBox.width-2*c-b.x,b=b.alignColumns&&this.totalItemWidth>q?this.maxItemWidth:a.itemWidth;f&&this.itemX-c+b>q&&(this.itemX=c,this.itemY+=h+this.lastLineHeight+g,this.lastLineHeight=0);this.lastItemY=h+this.itemY+g;this.lastLineHeight=Math.max(d,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];f?this.itemX+=b:(this.itemY+=h+d+g,this.lastLineHeight=d);this.offsetWidth=u||Math.max((f?this.itemX-c-(a.checkbox?
0:m):b)+c,this.offsetWidth)},getAllItems:function(){var a=[];d(this.chart.series,function(b){var c=b&&b.options;b&&l(c.showInLegend,p(c.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===c.legendType?b.data:b)))});m(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,b){var c=this.chart,f=this.options,
g=this.getAlignment();g&&d([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(e,d){e.test(g)&&!p(a[d])&&(c[t[d]]=Math.max(c[t[d]],c.legend[(d+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][d]*f[d%2?"x":"y"]+l(f.margin,12)+b[d]+(0===d&&void 0!==c.options.title.margin?c.titleOffset+c.options.title.margin:0)))})},proximatePositions:function(){var c=this.chart,b=[],e="left"===this.options.align;d(this.allItems,function(f){var d,g;d=e;f.xAxis&&f.points&&(f.xAxis.options.reversed&&(d=
!d),d=a.find(d?f.points:f.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),g=f.legendGroup.getBBox().height,b.push({target:f.visible?(d?d.plotY:f.xAxis.height)-.3*g:c.plotHeight,size:g,item:f}))},this);a.distribute(b,c.plotHeight);d(b,function(a){a.item._legendItemPos[1]=c.plotTop-c.spacing[0]+a.pos})},render:function(){var a=this.chart,b=a.renderer,e=this.group,g,h,l,m=this.box,p=this.options,u=this.padding;this.itemX=u;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=
0;e||(this.group=e=b.g("legend").attr({zIndex:7}).add(),this.contentGroup=b.g().attr({zIndex:1}).add(e),this.scrollGroup=b.g().add(this.contentGroup));this.renderTitle();g=this.getAllItems();f(g,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});p.reversed&&g.reverse();this.allItems=g;this.display=h=!!g.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;d(g,this.renderItem,this);d(g,this.layoutItem,this);g=(p.width||this.offsetWidth)+
u;l=this.lastItemY+this.lastLineHeight+this.titleHeight;l=this.handleOverflow(l);l+=u;m||(this.box=m=b.rect().addClass("highcharts-legend-box").attr({r:p.borderRadius}).add(e),m.isNew=!0);m.attr({stroke:p.borderColor,"stroke-width":p.borderWidth||0,fill:p.backgroundColor||"none"}).shadow(p.shadow);0<g&&0<l&&(m[m.isNew?"attr":"animate"](m.crisp.call({},{x:0,y:0,width:g,height:l},m.strokeWidth())),m.isNew=!1);m[h?"show":"hide"]();this.legendWidth=g;this.legendHeight=l;h&&(b=a.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&
(b=q(b,{y:b.y+a.titleOffset+a.options.title.margin})),e.align(q(p,{width:g,height:l,verticalAlign:this.proximate?"top":p.verticalAlign}),!0,b));this.proximate||this.positionItems()},handleOverflow:function(a){var b=this,c=this.chart,f=c.renderer,g=this.options,h=g.y,m=this.padding,c=c.spacingBox.height+("top"===g.verticalAlign?-h:h)-m,h=g.maxHeight,q,u=this.clipRect,p=g.navigation,k=l(p.animation,!0),E=p.arrowSize||12,x=this.nav,w=this.pages,H,r=this.allItems,z=function(a){"number"===typeof a?u.attr({height:a}):
u&&(b.clipRect=u.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+m+"px,9999px,"+(m+a)+"px,0)":"auto")};"horizontal"!==g.layout||"middle"===g.verticalAlign||g.floating||(c/=2);h&&(c=Math.min(c,h));w.length=0;a>c&&!1!==p.enabled?(this.clipHeight=q=Math.max(c-20-this.titleHeight-m,0),this.currentPage=l(this.currentPage,1),this.fullHeight=a,d(r,function(a,b){var c=a._legendItemPos[1],e=Math.round(a.legendItem.getBBox().height),f=w.length;if(!f||c-w[f-1]>q&&
(H||c)!==w[f-1])w.push(H||c),f++;a.pageIx=f-1;H&&(r[b-1].pageIx=f-1);b===r.length-1&&c+e-w[f-1]>q&&(w.push(c),a.pageIx=f);c!==H&&(H=c)}),u||(u=b.clipRect=f.clipRect(0,m,9999,0),b.contentGroup.clip(u)),z(q),x||(this.nav=x=f.g().attr({zIndex:1}).add(this.group),this.up=f.symbol("triangle",0,0,E,E).on("click",function(){b.scroll(-1,k)}).add(x),this.pager=f.text("",15,10).addClass("highcharts-legend-navigation").css(p.style).add(x),this.down=f.symbol("triangle-down",0,0,E,E).on("click",function(){b.scroll(1,
k)}).add(x)),b.scroll(0),a=c):x&&(z(),this.nav=x.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,b){var c=this.pages,f=c.length;a=this.currentPage+a;var d=this.clipHeight,h=this.options.navigation,l=this.pager,m=this.padding;a>f&&(a=f);0<a&&(void 0!==b&&g(b,this.chart),this.nav.attr({translateX:m,translateY:d+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),
l.attr({text:a+"/"+f}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===f?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?h.inactiveColor:h.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===f?h.inactiveColor:h.activeColor}).css({cursor:a===f?"default":"pointer"}),this.scrollOffset=-c[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin=
{drawRectangle:function(a,b){var c=a.symbolHeight,f=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(f?(a.symbolWidth-c)/2:0,a.baseline-c+1,f?c:a.symbolWidth,c,l(a.options.symbolRadius,c/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,c=b.marker,f=a.symbolWidth,d=a.symbolHeight,g=d/2,h=this.chart.renderer,m=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var u;u={"stroke-width":b.lineWidth||0};b.dashStyle&&
(u.dashstyle=b.dashStyle);this.legendLine=h.path(["M",0,a,"L",f,a]).addClass("highcharts-graph").attr(u).add(m);c&&!1!==c.enabled&&f&&(b=Math.min(l(c.radius,g),g),0===this.symbol.indexOf("url")&&(c=q(c,{width:d,height:d}),b=0),this.legendSymbol=c=h.symbol(this.symbol,f/2-b,a-b,2*b,2*b,c).addClass("highcharts-point").add(m),c.isMarker=!0)}};(/Trident\/7\.0/.test(h.navigator.userAgent)||v)&&w(a.Legend.prototype,"positionItem",function(a,b){var c=this,f=function(){b._legendItemPos&&a.call(c,b)};f();
setTimeout(f)})})(J);(function(a){var B=a.addEvent,y=a.animate,D=a.animObject,p=a.attr,d=a.doc,m=a.Axis,v=a.createElement,t=a.defaultOptions,q=a.discardElement,l=a.charts,g=a.css,f=a.defined,h=a.each,w=a.extend,c=a.find,b=a.fireEvent,e=a.grep,n=a.isNumber,A=a.isObject,G=a.isString,C=a.Legend,M=a.marginNames,u=a.merge,F=a.objectEach,k=a.Pointer,E=a.pick,x=a.pInt,L=a.removeEvent,H=a.seriesTypes,r=a.splat,z=a.syncTimeout,N=a.win,S=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,
b,c){return new S(a,b,c)};w(S.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(G(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(c,e){var f,k,d=c.series,g=c.plotOptions||{};b(this,"init",{args:arguments},function(){c.series=null;f=u(t,c);for(k in f.plotOptions)f.plotOptions[k].tooltip=g[k]&&u(g[k].tooltip)||void 0;f.tooltip.userOptions=c.chart&&c.chart.forExport&&c.tooltip.userOptions||c.tooltip;f.series=c.series=d;this.userOptions=c;var h=
f.chart,x=h.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=e;this.isResizing=0;this.options=f;this.axes=[];this.series=[];this.time=c.time&&a.keys(c.time).length?new a.Time(c.time):a.time;this.hasCartesianSeries=h.showAxes;var r=this;r.index=l.length;l.push(r);a.chartCount++;x&&F(x,function(a,b){B(r,b,a)});r.xAxis=[];r.yAxis=[];r.pointCount=r.colorCounter=r.symbolCounter=0;b(r,"afterInit");r.firstRender()})},initSeries:function(b){var c=this.options.chart;
(c=H[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,c){var e=c?b:a;a=c?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(c){b(this,"beforeRedraw");var e=this.axes,f=this.series,k=this.pointer,d=this.legend,g=this.isDirtyLegend,x,r,l=this.hasCartesianSeries,n=this.isDirtyBox,E,m=this.renderer,
u=m.isHidden(),q=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(c,this);u&&this.temporaryDisplay();this.layOutTitles();for(c=f.length;c--;)if(E=f[c],E.options.stacking&&(x=!0,E.isDirty)){r=!0;break}if(r)for(c=f.length;c--;)E=f[c],E.options.stacking&&(E.isDirty=!0);h(f,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),g=!0);a.isDirtyData&&b(a,"updatedData")});g&&d.options.enabled&&(d.render(),this.isDirtyLegend=!1);x&&this.getStacks();l&&h(e,function(a){a.updateNames();
a.setScale()});this.getMargins();l&&(h(e,function(a){a.isDirty&&(n=!0)}),h(e,function(a){var c=a.min+","+a.max;a.extKey!==c&&(a.extKey=c,q.push(function(){b(a,"afterSetExtremes",w(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(n||x)&&a.redraw()}));n&&this.drawChartBox();b(this,"predraw");h(f,function(a){(n||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});k&&k.reset(!0);m.draw();b(this,"redraw");b(this,"render");u&&this.temporaryDisplay(!0);h(q,function(a){a.call()})},get:function(a){function b(b){return b.id===
a||b.options&&b.options.id===a}var e,f=this.series,k;e=c(this.axes,b)||c(this.series,b);for(k=0;!e&&k<f.length;k++)e=c(f[k].points||[],b);return e},getAxes:function(){var a=this,c=this.options,e=c.xAxis=r(c.xAxis||{}),c=c.yAxis=r(c.yAxis||{});b(this,"getAxes");h(e,function(a,b){a.index=b;a.isX=!0});h(c,function(a,b){a.index=b});e=e.concat(c);h(e,function(b){new m(a,b)});b(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];h(this.series,function(b){a=a.concat(e(b.data||[],function(a){return a.selected}))});
return a},getSelectedSeries:function(){return e(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var e=this,f=e.options,k;k=f.title=u({style:{color:"#333333",fontSize:f.isStock?"16px":"18px"}},f.title,a);f=f.subtitle=u({style:{color:"#666666"}},f.subtitle,b);h([["title",a,k],["subtitle",b,f]],function(a,b){var c=a[0],f=e[c],k=a[1];a=a[2];f&&k&&(e[c]=f=f.destroy());a&&!f&&(e[c]=e.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),
e[c].update=function(a){e.setTitle(!b&&a,b&&a)},e[c].css(a.style))});e.layOutTitles(c)},layOutTitles:function(a){var b=0,c,e=this.renderer,f=this.spacingBox;h(["title","subtitle"],function(a){var c=this[a],k=this.options[a];a="title"===a?-3:k.verticalAlign?0:b+2;var d;c&&(d=k.style.fontSize,d=e.fontMetrics(d,c).b,c.css({width:(k.width||f.width+k.widthAdjust)+"px"}).align(w({y:a+d},k),!1,"spacingBox"),k.floating||k.verticalAlign||(b=Math.ceil(b+c.getBBox(k.useHTML).height)))},this);c=this.titleOffset!==
b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&E(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,c=b.width,b=b.height,e=this.renderTo;f(c)||(this.containerWidth=a.getStyle(e,"width"));f(b)||(this.containerHeight=a.getStyle(e,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},
temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(d.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){d.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,d.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&
(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===d.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var c,e=this.options,f=e.chart,k,g;c=this.renderTo;var h=a.uniqueKey(),r;c||(this.renderTo=c=f.renderTo);G(c)&&(this.renderTo=c=d.getElementById(c));c||a.error(13,!0);k=x(p(c,"data-highcharts-chart"));n(k)&&l[k]&&l[k].hasRendered&&l[k].destroy();p(c,"data-highcharts-chart",
this.index);c.innerHTML="";f.skipClone||c.offsetWidth||this.temporaryDisplay();this.getChartSize();k=this.chartWidth;g=this.chartHeight;r=w({position:"relative",overflow:"hidden",width:k+"px",height:g+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},f.style);this.container=c=v("div",{id:h},r,c);this._cursor=c.style.cursor;this.renderer=new (a[f.renderer]||a.Renderer)(c,k,g,null,f.forExport,e.exporting&&e.exporting.allowHTML);this.setClassName(f.className);
this.renderer.setStyle(f.style);this.renderer.chartIndex=this.index;b(this,"afterGetContainer")},getMargins:function(a){var c=this.spacing,e=this.margin,k=this.titleOffset;this.resetMargins();k&&!f(e[0])&&(this.plotTop=Math.max(this.plotTop,k+this.options.title.margin+c[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(e,c);b(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&h(a.axes,function(a){a.visible&&
a.getOffset()});h(M,function(e,k){f(c[k])||(a[e]+=b[k])});a.setChartSize()},reflow:function(b){var c=this,e=c.options.chart,k=c.renderTo,g=f(e.width)&&f(e.height),h=e.width||a.getStyle(k,"width"),e=e.height||a.getStyle(k,"height"),k=b?b.target:N;if(!g&&!c.isPrinting&&h&&e&&(k===N||k===d)){if(h!==c.containerWidth||e!==c.containerHeight)a.clearTimeout(c.reflowTimeout),c.reflowTimeout=z(function(){c.container&&c.setSize(void 0,void 0,!1)},b?100:0);c.containerWidth=h;c.containerHeight=e}},setReflow:function(a){var b=
this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=B(N,"resize",function(a){b.reflow(a)}),B(this,"destroy",this.unbindReflow))},setSize:function(c,e,f){var k=this,d=k.renderer;k.isResizing+=1;a.setAnimation(f,k);k.oldChartHeight=k.chartHeight;k.oldChartWidth=k.chartWidth;void 0!==c&&(k.options.chart.width=c);void 0!==e&&(k.options.chart.height=e);k.getChartSize();c=d.globalAnimation;(c?y:g)(k.container,{width:k.chartWidth+"px",height:k.chartHeight+
"px"},c);k.setChartSize(!0);d.setSize(k.chartWidth,k.chartHeight,f);h(k.axes,function(a){a.isDirty=!0;a.setScale()});k.isDirtyLegend=!0;k.isDirtyBox=!0;k.layOutTitles();k.getMargins();k.redraw(f);k.oldChartHeight=null;b(k,"resize");z(function(){k&&b(k,"endResize",null,function(){--k.isResizing})},D(c).duration)},setChartSize:function(a){var c=this.inverted,e=this.renderer,f=this.chartWidth,k=this.chartHeight,d=this.options.chart,g=this.spacing,x=this.clipOffset,r,l,n,E;this.plotLeft=r=Math.round(this.plotLeft);
this.plotTop=l=Math.round(this.plotTop);this.plotWidth=n=Math.max(0,Math.round(f-r-this.marginRight));this.plotHeight=E=Math.max(0,Math.round(k-l-this.marginBottom));this.plotSizeX=c?E:n;this.plotSizeY=c?n:E;this.plotBorderWidth=d.plotBorderWidth||0;this.spacingBox=e.spacingBox={x:g[3],y:g[0],width:f-g[3]-g[1],height:k-g[0]-g[2]};this.plotBox=e.plotBox={x:r,y:l,width:n,height:E};f=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(Math.max(f,x[3])/2);e=Math.ceil(Math.max(f,x[0])/2);this.clipBox={x:c,
y:e,width:Math.floor(this.plotSizeX-Math.max(f,x[1])/2-c),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(f,x[2])/2-e))};a||h(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()});b(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){var a=this,b=a.options.chart;h(["margin","spacing"],function(c){var e=b[c],f=A(e)?e:[e,e,e,e];h(["Top","Right","Bottom","Left"],function(e,k){a[c][k]=E(b[c+e],f[k])})});h(M,function(b,c){a[b]=E(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,
0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,c=this.renderer,e=this.chartWidth,f=this.chartHeight,k=this.chartBackground,d=this.plotBackground,g=this.plotBorder,h,x=this.plotBGImage,r=a.backgroundColor,l=a.plotBackgroundColor,n=a.plotBackgroundImage,E,m=this.plotLeft,u=this.plotTop,q=this.plotWidth,p=this.plotHeight,H=this.plotBox,w=this.clipRect,z=this.clipBox,C="animate";k||(this.chartBackground=k=c.rect().addClass("highcharts-background").add(),C="attr");h=a.borderWidth||
0;E=h+(a.shadow?8:0);r={fill:r||"none"};if(h||k["stroke-width"])r.stroke=a.borderColor,r["stroke-width"]=h;k.attr(r).shadow(a.shadow);k[C]({x:E/2,y:E/2,width:e-E-h%2,height:f-E-h%2,r:a.borderRadius});C="animate";d||(C="attr",this.plotBackground=d=c.rect().addClass("highcharts-plot-background").add());d[C](H);d.attr({fill:l||"none"}).shadow(a.plotShadow);n&&(x?x.animate(H):this.plotBGImage=c.image(n,m,u,q,p).add());w?w.animate({width:z.width,height:z.height}):this.clipRect=c.clipRect(z);C="animate";
g||(C="attr",this.plotBorder=g=c.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());g.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});g[C](g.crisp({x:m,y:u,width:q,height:p},-g.strokeWidth()));this.isDirtyBox=!1;b(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,c,e=a.options.series,f,k;h(["inverted","angular","polar"],function(d){c=H[b.type||b.defaultSeriesType];k=b[d]||c&&c.prototype[d];for(f=e&&e.length;!k&&f--;)(c=
H[e[f].type])&&c.prototype[d]&&(k=!0);a[d]=k})},linkSeries:function(){var a=this,c=a.series;h(c,function(a){a.linkedSeries.length=0});h(c,function(b){var c=b.options.linkedTo;G(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=E(b.options.visible,c.options.visible,b.visible))});b(this,"afterLinkSeries")},renderSeries:function(){h(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;
b.items&&h(b.items,function(c){var e=w(b.style,c.style),f=x(e.left)+a.plotLeft,k=x(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(c.html,f,k).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,e,f,k;this.setTitle();this.legend=new C(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;e=this.plotHeight=Math.max(this.plotHeight-21,0);h(a,function(a){a.setScale()});this.getAxisMargins();
f=1.1<c/this.plotWidth;k=1.05<e/this.plotHeight;if(f||k)h(a,function(a){(a.horiz&&f||!a.horiz&&k)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&h(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=u(!0,this.options.credits,a);a.enabled&&
!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var c=this,e=c.axes,f=c.series,k=c.container,d,g=k&&k.parentNode;b(c,"destroy");c.renderer.forExport?a.erase(l,c):l[c.index]=void 0;a.chartCount--;c.renderTo.removeAttribute("data-highcharts-chart");
L(c);for(d=e.length;d--;)e[d]=e[d].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(d=f.length;d--;)f[d]=f[d].destroy();h("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var b=c[a];b&&b.destroy&&(c[a]=b.destroy())});k&&(k.innerHTML="",L(k),g&&q(k));F(c,function(a,b){delete c[b]})},firstRender:function(){var a=this,c=a.options;if(!a.isReadyToRender||
a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();h(c.series||[],function(b){a.initSeries(b)});a.linkSeries();b(a,"beforeRender");k&&(a.pointer=new k(a,c));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){h([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);b(this,"load");b(this,"render");f(this.index)&&this.setReflow(this.options.chart.reflow);
this.onload=null}})})(J);(function(a){var B,y=a.each,D=a.extend,p=a.erase,d=a.fireEvent,m=a.format,v=a.isArray,t=a.isNumber,q=a.pick,l=a.removeEvent;a.Point=B=function(){};a.Point.prototype={init:function(a,f,h){this.series=a;this.color=a.color;this.applyOptions(f,h);a.options.colorByPoint?(f=a.options.colors||a.chart.options.colors,this.color=this.color||f[a.colorCounter],f=f.length,h=a.colorCounter,a.colorCounter++,a.colorCounter===f&&(a.colorCounter=0)):h=a.colorIndex;this.colorIndex=q(this.colorIndex,
h);a.chart.pointCount++;d(this,"afterInit");return this},applyOptions:function(a,f){var d=this.series,g=d.options.pointValKey||d.pointValKey;a=B.prototype.optionsToObject.call(this,a);D(this,a);this.options=this.options?D(this.options,a):a;a.group&&delete this.group;g&&(this.y=this[g]);this.isNull=q(this.isValid&&!this.isValid(),null===this.x||!t(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===f&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));void 0===this.x&&d&&
(this.x=void 0===f?d.autoIncrement(this):f);return this},setNestedProperty:function(d,f,h){h=h.split(".");a.reduce(h,function(d,c,b,e){d[c]=e.length-1===b?f:a.isObject(d[c],!0)?d[c]:{};return d[c]},d);return d},optionsToObject:function(d){var f={},g=this.series,l=g.options.keys,c=l||g.pointArrayMap||["y"],b=c.length,e=0,n=0;if(t(d)||null===d)f[c[0]]=d;else if(v(d))for(!l&&d.length>b&&(g=typeof d[0],"string"===g?f.name=d[0]:"number"===g&&(f.x=d[0]),e++);n<b;)l&&void 0===d[e]||(0<c[n].indexOf(".")?
a.Point.prototype.setNestedProperty(f,d[e],c[n]):f[c[n]]=d[e]),e++,n++;else"object"===typeof d&&(f=d,d.dataLabels&&(g._hasPointLabels=!0),d.marker&&(g._hasPointMarkers=!0));return f},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?
" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,f=a.zones,a=a.zoneAxis||"y",d=0,l;for(l=f[d];this[a]>=l.value;)l=f[++d];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=l&&l.color&&!this.options.color?l.color:this.nonZonedColor;return l},destroy:function(){var a=this.series.chart,f=a.hoverPoints,d;a.pointCount--;f&&(this.setState(),p(f,this),f.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)l(this),
this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(d in this)this[d]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],f,d=6;d--;)f=a[d],this[f]&&(this[f]=this[f].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var f=
this.series,d=f.tooltipOptions,g=q(d.valueDecimals,""),c=d.valuePrefix||"",b=d.valueSuffix||"";y(f.pointArrayMap||["y"],function(e){e="{point."+e;if(c||b)a=a.replace(RegExp(e+"}","g"),c+e+"}"+b);a=a.replace(RegExp(e+"}","g"),e+":,."+g+"f}")});return m(a,{point:this,series:this.series},f.chart.time)},firePointEvent:function(a,f,h){var g=this,c=this.series.options;(c.point.events[a]||g.options&&g.options.events&&g.options.events[a])&&this.importEvents();"click"===a&&c.allowPointSelect&&(h=function(a){g.select&&
g.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});d(this,a,f,h)},visible:!0}})(J);(function(a){var B=a.addEvent,y=a.animObject,D=a.arrayMax,p=a.arrayMin,d=a.correctFloat,m=a.defaultOptions,v=a.defaultPlotOptions,t=a.defined,q=a.each,l=a.erase,g=a.extend,f=a.fireEvent,h=a.grep,w=a.isArray,c=a.isNumber,b=a.isString,e=a.merge,n=a.objectEach,A=a.pick,G=a.removeEvent,C=a.splat,M=a.SVGElement,u=a.syncTimeout,F=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},
events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,
pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,e,k=a.series,d;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();g(c,{name:b.name,
state:"",visible:!1!==b.visible,selected:!0===b.selected});e=b.events;n(e,function(a,b){B(c,b,a)});if(e&&e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();q(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);k.length&&(d=k[k.length-1]);c._i=A(d&&d._i,-1)+1;a.orderSeries(this.insert(k));f(this,"afterInit")},insert:function(a){var b=this.options.index,e;if(c(b)){for(e=a.length;e--;)if(b>=
A(a[e].options.index,a[e]._i)){a.splice(e+1,0,this);break}-1===e&&a.unshift(this);e+=1}else a.push(this);return A(e,a.length-1)},bindAxes:function(){var b=this,c=b.options,e=b.chart,f;q(b.axisTypes||[],function(k){q(e[k],function(a){f=a.options;if(c[k]===f.index||void 0!==c[k]&&c[k]===f.id||void 0===c[k]&&0===f.index)b.insert(a.series),b[k]=a,a.isDirty=!0});b[k]||b.optionalAxis===k||a.error(18,!0)})},updateParallelArrays:function(a,b){var e=a.series,f=arguments,k=c(b)?function(c){var f="y"===c&&e.toYData?
e.toYData(a):a[c];e[c+"Data"][b]=f}:function(a){Array.prototype[b].apply(e[a+"Data"],Array.prototype.slice.call(f,2))};q(e.parallelArrays,k)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,e=a.pointIntervalUnit,f=this.chart.time,b=A(b,a.pointStart,0);this.pointInterval=c=A(this.pointInterval,a.pointInterval,1);e&&(a=new f.Date(b),"day"===e?f.set("Date",a,f.get("Date",a)+c):"month"===e?f.set("Month",a,f.get("Month",a)+c):"year"===e&&f.set("FullYear",a,f.get("FullYear",a)+c),c=a.getTime()-
b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options,k=c.plotOptions,d=(b.userOptions||{}).plotOptions||{},g=k[this.type];this.userOptions=a;b=e(g,k.series,a);this.tooltipOptions=e(m.tooltip,m.plotOptions.series&&m.plotOptions.series.tooltip,m.plotOptions[this.type].tooltip,c.tooltip.userOptions,k.series&&k.series.tooltip,k[this.type].tooltip,a.tooltip);this.stickyTracking=A(a.stickyTracking,d[this.type]&&d[this.type].stickyTracking,d.series&&d.series.stickyTracking,
this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===g.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&t(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});f(this,"afterSetOptions",{options:b});return b},getName:function(){return this.name||
"Series "+(this.index+1)},getCyclic:function(a,b,c){var e,f=this.chart,k=this.userOptions,d=a+"Index",g=a+"Counter",h=c?c.length:A(f.options.chart[a+"Count"],f[a+"Count"]);b||(e=A(k[d],k["_"+d]),t(e)||(f.series.length||(f[g]=0),k["_"+d]=e=f[g]%h,f[g]+=1),c&&(b=c[e]));void 0!==e&&(this[d]=e);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||v[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",
this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var e=this.options,f=this.points,d=[],k,g,h,l=this.requireSorting;q(b,function(b){var g;g=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b).x;c(g)&&(g=a.inArray(g,this.xData,h),-1===g?d.push(b):b!==e.data[g]?(f[g].update(b,!1,null,!1),f[g].touched=!0,l&&(h=g)):f[g]&&(f[g].touched=!0),k=!0)},this);if(k)for(b=f.length;b--;)g=f[b],g.touched||g.remove(!1),
g.touched=!1;else if(b.length===f.length)q(b,function(a,b){f[b].update&&a!==e.data[b]&&f[b].update(a,!1,null,!1)});else return!1;q(d,function(a){this.addPoint(a,!1)},this);return!0},setData:function(e,f,d,g){var k=this,h=k.points,l=h&&h.length||0,n,x=k.options,m=k.chart,u=null,E=k.xAxis,p=x.turboThreshold,C=this.xData,F=this.yData,t=(n=k.pointArrayMap)&&n.length,G;e=e||[];n=e.length;f=A(f,!0);!1!==g&&n&&l&&!k.cropped&&!k.hasGroupedData&&k.visible&&!k.isSeriesBoosting&&(G=this.updateData(e));if(!G){k.xIncrement=
null;k.colorCounter=0;q(this.parallelArrays,function(a){k[a+"Data"].length=0});if(p&&n>p){for(d=0;null===u&&d<n;)u=e[d],d++;if(c(u))for(d=0;d<n;d++)C[d]=this.autoIncrement(),F[d]=e[d];else if(w(u))if(t)for(d=0;d<n;d++)u=e[d],C[d]=u[0],F[d]=u.slice(1,t+1);else for(d=0;d<n;d++)u=e[d],C[d]=u[0],F[d]=u[1];else a.error(12)}else for(d=0;d<n;d++)void 0!==e[d]&&(u={series:k},k.pointClass.prototype.applyOptions.apply(u,[e[d]]),k.updateParallelArrays(u,d));F&&b(F[0])&&a.error(14,!0);k.data=[];k.options.data=
k.userOptions.data=e;for(d=l;d--;)h[d]&&h[d].destroy&&h[d].destroy();E&&(E.minRange=E.userMinRange);k.isDirty=m.isDirtyBox=!0;k.isDirtyData=!!h;d=!1}"point"===x.legendType&&(this.processData(),this.generatePoints());f&&m.redraw(d)},processData:function(b){var c=this.xData,e=this.yData,f=c.length,d;d=0;var k,g,h=this.xAxis,l,n=this.options;l=n.cropThreshold;var m=this.getExtremesFromAll||n.getExtremesFromAll,u=this.isCartesian,n=h&&h.val2lin,q=h&&h.isLog,p=this.requireSorting,C,w;if(u&&!this.isDirty&&
!h.isDirty&&!this.yAxis.isDirty&&!b)return!1;h&&(b=h.getExtremes(),C=b.min,w=b.max);u&&this.sorted&&!m&&(!l||f>l||this.forceCrop)&&(c[f-1]<C||c[0]>w?(c=[],e=[]):this.yData&&(c[0]<C||c[f-1]>w)&&(d=this.cropData(this.xData,this.yData,C,w),c=d.xData,e=d.yData,d=d.start,k=!0));for(l=c.length||1;--l;)f=q?n(c[l])-n(c[l-1]):c[l]-c[l-1],0<f&&(void 0===g||f<g)?g=f:0>f&&p&&(a.error(15),p=!1);this.cropped=k;this.cropStart=d;this.processedXData=c;this.processedYData=e;this.closestPointRange=g},cropData:function(a,
b,c,e,f){var d=a.length,k=0,g=d,h;f=A(f,this.cropShoulder,1);for(h=0;h<d;h++)if(a[h]>=c){k=Math.max(0,h-f);break}for(c=h;c<d;c++)if(a[c]>e){g=c+f;break}return{xData:a.slice(k,g),yData:b.slice(k,g),start:k,end:g}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,e,f=this.processedXData,d=this.processedYData,g=this.pointClass,h=f.length,l=this.cropStart||0,n,m=this.hasGroupedData,a=a.keys,u,q=[],p;c||m||(c=[],c.length=b.length,c=this.data=c);a&&m&&(this.options.keys=!1);for(p=0;p<h;p++)n=
l+p,m?(u=(new g).init(this,[f[p]].concat(C(d[p]))),u.dataGroup=this.groupMap[p]):(u=c[n])||void 0===b[n]||(c[n]=u=(new g).init(this,b[n],f[p])),u&&(u.index=n,q[p]=u);this.options.keys=a;if(c&&(h!==(e=c.length)||m))for(p=0;p<e;p++)p!==l||m||(p+=h),c[p]&&(c[p].destroyElements(),c[p].plotX=void 0);this.data=c;this.points=q},getExtremes:function(a){var b=this.yAxis,e=this.processedXData,f,d=[],k=0;f=this.xAxis.getExtremes();var g=f.min,h=f.max,l,n,m=this.requireSorting?1:0,u,q;a=a||this.stackedYData||
this.processedYData||[];f=a.length;for(q=0;q<f;q++)if(n=e[q],u=a[q],l=(c(u,!0)||w(u))&&(!b.positiveValuesOnly||u.length||0<u),n=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(e[q+m]||n)>=g&&(e[q-m]||n)<=h,l&&n)if(l=u.length)for(;l--;)"number"===typeof u[l]&&(d[k++]=u[l]);else d[k++]=u;this.dataMin=p(d);this.dataMax=D(d)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,e=this.xAxis,g=e.categories,h=this.yAxis,
l=this.points,n=l.length,m=!!this.modifyValue,u=a.pointPlacement,p="between"===u||c(u),q=a.threshold,C=a.startFromThreshold?q:0,w,F,G,v,M=Number.MAX_VALUE;"between"===u&&(u=.5);c(u)&&(u*=A(a.pointRange||e.pointRange));for(a=0;a<n;a++){var y=l[a],D=y.x,B=y.y;F=y.low;var J=b&&h.stacks[(this.negStacks&&B<(C?0:q)?"-":"")+this.stackKey],V;h.positiveValuesOnly&&null!==B&&0>=B&&(y.isNull=!0);y.plotX=w=d(Math.min(Math.max(-1E5,e.translate(D,0,0,0,1,u,"flags"===this.type)),1E5));b&&this.visible&&!y.isNull&&
J&&J[D]&&(v=this.getStackIndicator(v,D,this.index),V=J[D],B=V.points[v.key],F=B[0],B=B[1],F===C&&v.key===J[D].base&&(F=A(c(q)&&q,h.min)),h.positiveValuesOnly&&0>=F&&(F=null),y.total=y.stackTotal=V.total,y.percentage=V.total&&y.y/V.total*100,y.stackY=B,V.setOffset(this.pointXOffset||0,this.barW||0));y.yBottom=t(F)?Math.min(Math.max(-1E5,h.translate(F,0,1,0,1)),1E5):null;m&&(B=this.modifyValue(B,y));y.plotY=F="number"===typeof B&&Infinity!==B?Math.min(Math.max(-1E5,h.translate(B,0,1,0,1)),1E5):void 0;
y.isInside=void 0!==F&&0<=F&&F<=h.len&&0<=w&&w<=e.len;y.clientX=p?d(e.translate(D,0,0,0,1,u)):w;y.negative=y.y<(q||0);y.category=g&&void 0!==g[y.x]?g[y.x]:y.x;y.isNull||(void 0!==G&&(M=Math.min(M,Math.abs(w-G))),G=w);y.zone=this.zones.length&&y.getZone()}this.closestPointRangePx=M;f(this,"afterTranslate")},getValidPoints:function(a,b){var c=this.chart;return h(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,
c=this.options,e=b.renderer,f=b.inverted,d=this.clipBox,k=d||b.clipBox,g=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,k.height,c.xAxis,c.yAxis].join(),h=b[g],l=b[g+"m"];h||(a&&(k.width=0,f&&(k.x=b.plotSizeX),b[g+"m"]=l=e.clipRect(f?b.plotSizeX+99:-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),b[g]=h=e.clipRect(k),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=1);!1!==c.clip&&(this.group.clip(a||d?h:b.clipRect),this.markerGroup.clip(l),
this.sharedClipKey=g);a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),0===h.count.length&&g&&b[g]&&(d||(b[g]=b[g].destroy()),b[g+"m"]&&(b[g+"m"]=b[g+"m"].destroy())))},animate:function(a){var b=this.chart,c=y(this.options.animation),e;a?this.setClip(c):(e=this.sharedClipKey,(a=b[e])&&a.animate({width:b.plotSizeX,x:0},c),b[e+"m"]&&b[e+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=null)},afterAnimate:function(){this.setClip();f(this,"afterAnimate");this.finishedAnimating=
!0},drawPoints:function(){var a=this.points,b=this.chart,c,e,f,d,g=this.options.marker,h,l,n,m=this[this.specialGroup]||this.markerGroup,u,p=A(g.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=g.enabledThreshold*g.radius);if(!1!==g.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)e=a[c],d=e.graphic,h=e.marker||{},l=!!e.marker,f=p&&void 0===h.enabled||h.enabled,n=e.isInside,f&&!e.isNull?(f=A(h.symbol,this.symbol),u=this.markerAttribs(e,e.selected&&"select"),d?d[n?"show":"hide"](!0).animate(u):
n&&(0<u.width||e.hasImage)&&(e.graphic=d=b.renderer.symbol(f,u.x,u.y,u.width,u.height,l?h:g).add(m)),d&&d.attr(this.pointAttribs(e,e.selected&&"select")),d&&d.addClass(e.getClassName(),!0)):d&&(e.graphic=d.destroy())},markerAttribs:function(a,b){var c=this.options.marker,e=a.marker||{},f=e.symbol||c.symbol,d=A(e.radius,c.radius);b&&(c=c.states[b],b=e.states&&e.states[b],d=A(b&&b.radius,c&&c.radius,d+(c&&c.radiusPlus||0)));a.hasImage=f&&0===f.indexOf("url");a.hasImage&&(d=0);a={x:Math.floor(a.plotX)-
d,y:a.plotY-d};d&&(a.width=a.height=2*d);return a},pointAttribs:function(a,b){var c=this.options.marker,e=a&&a.options,f=e&&e.marker||{},d=this.color,k=e&&e.color,g=a&&a.color,e=A(f.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;d=k||a||g||d;a=f.fillColor||c.fillColor||d;d=f.lineColor||c.lineColor||d;b&&(c=c.states[b],b=f.states&&f.states[b]||{},e=A(b.lineWidth,c.lineWidth,e+A(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,d=b.lineColor||c.lineColor||d);return{stroke:d,"stroke-width":e,
fill:a}},destroy:function(){var b=this,c=b.chart,e=/AppleWebKit\/533/.test(F.navigator.userAgent),d,g,h=b.data||[],u,m;f(b,"destroy");G(b);q(b.axisTypes||[],function(a){(m=b[a])&&m.series&&(l(m.series,b),m.isDirty=m.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(g=h.length;g--;)(u=h[g])&&u.destroy&&u.destroy();b.points=null;a.clearTimeout(b.animationTimeout);n(b,function(a,b){a instanceof M&&!a.survive&&(d=e&&"group"===b?"hide":"destroy",a[d]())});c.hoverSeries===b&&(c.hoverSeries=
null);l(c.series,b);c.orderSeries();n(b,function(a,c){delete b[c]})},getGraphPath:function(a,b,c){var e=this,f=e.options,d=f.step,k,g=[],h=[],l;a=a||e.points;(k=a.reversed)&&a.reverse();(d={right:1,center:2}[d]||d&&3)&&k&&(d=4-d);!f.connectNulls||b||c||(a=this.getValidPoints(a));q(a,function(k,n){var u=k.plotX,m=k.plotY,r=a[n-1];(k.leftCliff||r&&r.rightCliff)&&!c&&(l=!0);k.isNull&&!t(b)&&0<n?l=!f.connectNulls:k.isNull&&!b?l=!0:(0===n||l?n=["M",k.plotX,k.plotY]:e.getPointSpline?n=e.getPointSpline(a,
k,n):d?(n=1===d?["L",r.plotX,m]:2===d?["L",(r.plotX+u)/2,r.plotY,"L",(r.plotX+u)/2,m]:["L",u,r.plotY],n.push("L",u,m)):n=["L",u,m],h.push(k.x),d&&(h.push(k.x),2===d&&h.push(k.x)),g.push.apply(g,n),l=!1)});g.xMap=h;return e.graphPath=g},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),e=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]],e=a.getZonesGraphs(e);q(e,function(e,f){var d=e[0],k=a[d];k?(k.endX=a.preventGraphAnimation?null:c.xMap,
k.animate({d:c})):c.length&&(a[d]=a.chart.renderer.path(c).addClass(e[1]).attr({zIndex:1}).add(a.group),k={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?k.dashstyle=e[3]:"square"!==b.linecap&&(k["stroke-linecap"]=k["stroke-linejoin"]="round"),k=a[d].attr(k).shadow(2>f&&b.shadow));k&&(k.startX=c.xMap,k.isArea=c.isArea)})},getZonesGraphs:function(a){q(this.zones,function(b,c){a.push(["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||""),b.color||
this.color,b.dashStyle||this.options.dashStyle])},this);return a},applyZones:function(){var a=this,b=this.chart,c=b.renderer,e=this.zones,f,d,g=this.clips||[],h,l=this.graph,n=this.area,u=Math.max(b.chartWidth,b.chartHeight),m=this[(this.zoneAxis||"y")+"Axis"],p,C,w=b.inverted,F,t,G,v,M=!1;e.length&&(l||n)&&m&&void 0!==m.min&&(C=m.reversed,F=m.horiz,l&&!this.showLine&&l.hide(),n&&n.hide(),p=m.getExtremes(),q(e,function(e,k){f=C?F?b.plotWidth:0:F?0:m.toPixels(p.min);f=Math.min(Math.max(A(d,f),0),u);
d=Math.min(Math.max(Math.round(m.toPixels(A(e.value,p.max),!0)),0),u);M&&(f=d=m.toPixels(p.max));t=Math.abs(f-d);G=Math.min(f,d);v=Math.max(f,d);m.isXAxis?(h={x:w?v:G,y:0,width:t,height:u},F||(h.x=b.plotHeight-h.x)):(h={x:0,y:w?v:G,width:u,height:t},F&&(h.y=b.plotWidth-h.y));w&&c.isVML&&(h=m.isXAxis?{x:0,y:C?G:v,height:h.width,width:b.chartWidth}:{x:h.y-b.plotLeft-b.spacingBox.x,y:0,width:h.height,height:b.chartHeight});g[k]?g[k].animate(h):(g[k]=c.clipRect(h),l&&a["zone-graph-"+k].clip(g[k]),n&&
a["zone-area-"+k].clip(g[k]));M=e.value>p.max;a.resetZones&&0===d&&(d=void 0)}),this.clips=g)},invertGroups:function(a){function b(){q(["group","markerGroup"],function(b){c[b]&&(e.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,e=c.chart,f;c.xAxis&&(f=B(e,"resize",b),B(c,"destroy",f),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,e,f){var d=this[a],k=!d;k&&(this[a]=d=this.chart.renderer.g().attr({zIndex:e||
.1}).add(f));d.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(t(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(d.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);d.attr({visibility:c})[k?"attr":"animate"](this.getPlotBox());return d},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,
scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,e=a.options,d=!!a.animate&&b.renderer.isSVG&&y(e.animation).duration,g=a.visible?"inherit":"hidden",h=e.zIndex,l=a.hasRendered,n=b.seriesGroup,m=b.inverted;c=a.plotGroup("group","series",g,h,n);a.markerGroup=a.plotGroup("markerGroup","markers",g,h,n);d&&a.animate(!0);c.inverted=a.isCartesian?m:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&
a.drawTracker();a.invertGroups(m);!1===e.clip||a.sharedClipKey||l||c.clip(b.clipRect);d&&a.animate();l||(a.animationTimeout=u(function(){a.afterAnimate()},d));a.isDirty=!1;a.hasRendered=!0;f(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,e=this.xAxis,f=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:A(e&&e.left,a.plotLeft),translateY:A(f&&f.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},
kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,e=this.yAxis,f=this.chart.inverted;return this.searchKDTree({clientX:f?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:f?e.len-a.chartX+e.pos:a.chartY-e.pos},b)},buildKDTree:function(){function a(c,e,f){var d,k;if(k=c&&c.length)return d=b.kdAxisArray[e%f],c.sort(function(a,b){return a[d]-b[d]}),k=Math.floor(k/2),{point:c[k],left:a(c.slice(0,k),e+1,f),right:a(c.slice(k+1),e+1,f)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?
2:1;delete b.kdTree;u(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,g,h){var l=b.point,n=e.kdAxisArray[g%h],m,u,r=l;u=t(a[f])&&t(l[f])?Math.pow(a[f]-l[f],2):null;m=t(a[d])&&t(l[d])?Math.pow(a[d]-l[d],2):null;m=(u||0)+(m||0);l.dist=t(m)?Math.sqrt(m):Number.MAX_VALUE;l.distX=t(u)?Math.sqrt(u):Number.MAX_VALUE;n=a[n]-l[n];m=0>n?"left":"right";u=0>n?"right":"left";b[m]&&(m=c(a,b[m],g+1,h),r=m[k]<r[k]?
m:l);b[u]&&Math.sqrt(n*n)<r[k]&&(a=c(a,b[u],g+1,h),r=a[k]<r[k]?a:r);return r}var e=this,f=this.kdAxisArray[0],d=this.kdAxisArray[1],k=b?"distX":"dist";b=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(J);(function(a){var B=a.addEvent,y=a.animate,D=a.Axis,p=a.createElement,d=a.css,m=a.defined,v=a.each,t=a.erase,q=a.extend,l=a.fireEvent,g=a.inArray,f=a.isNumber,h=a.isObject,w=a.isArray,c=a.merge,b=
a.objectEach,e=a.pick,n=a.Point,A=a.Series,G=a.seriesTypes,C=a.setAnimation,M=a.splat;q(a.Chart.prototype,{addSeries:function(a,b,c){var f,d=this;a&&(b=e(b,!0),l(d,"addSeries",{options:a},function(){f=d.initSeries(a);d.isDirtyLegend=!0;d.linkSeries();l(d,"afterAddSeries");b&&d.redraw(c)}));return f},addAxis:function(a,b,f,d){var k=b?"xAxis":"yAxis",g=this.options;a=c(a,{index:this[k].length,isX:b});b=new D(this,a);g[k]=M(g[k]||{});g[k].push(a);e(f,!0)&&this.redraw(d);return b},showLoading:function(a){var b=
this,c=b.options,e=b.loadingDiv,f=c.loading,g=function(){e&&d(e,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};e||(b.loadingDiv=e=p("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=p("span",{className:"highcharts-loading-inner"},null,e),B(b,"redraw",g));e.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;d(e,q(f.style,{zIndex:10}));d(b.loadingSpan,f.labelStyle);b.loadingShown||(d(e,
{opacity:0,display:""}),y(e,{opacity:f.style.opacity||.5},{duration:f.showDuration||0}));b.loadingShown=!0;g()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",y(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){d(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),update:function(a,d,k,h){var n=this,u={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},p=a.chart,r,q,C=[];l(n,"update",{options:a});if(p){c(!0,n.options.chart,p);"className"in p&&n.setClassName(p.className);"reflow"in p&&n.setReflow(p.reflow);if("inverted"in p||"polar"in p||"type"in p)n.propFromSeries(),r=!0;"alignTicks"in p&&(r=!0);b(p,function(a,b){-1!==
g("chart."+b,n.propsRequireUpdateSeries)&&(q=!0);-1!==g(b,n.propsRequireDirtyBox)&&(n.isDirtyBox=!0)});"style"in p&&n.renderer.setStyle(p.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&c(!0,this.options.plotOptions,a.plotOptions);b(a,function(a,b){if(n[b]&&"function"===typeof n[b].update)n[b].update(a,!1);else if("function"===typeof n[u[b]])n[u[b]](a);"chart"!==b&&-1!==g(b,n.propsRequireUpdateSeries)&&(q=!0)});v("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){var c;
a[b]&&("series"===b&&(c=[],v(n[b],function(a,b){a.options.isInternal||c.push(b)})),v(M(a[b]),function(a,e){(e=m(a.id)&&n.get(a.id)||n[b][c?c[e]:e])&&e.coll===b&&(e.update(a,!1),k&&(e.touched=!0));if(!e&&k)if("series"===b)n.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)n.addAxis(a,"xAxis"===b,!1).touched=!0}),k&&v(n[b],function(a){a.touched||a.options.isInternal?delete a.touched:C.push(a)}))});v(C,function(a){a.remove(!1)});r&&v(n.axes,function(a){a.update({},!1)});q&&v(n.series,function(a){a.update({},
!1)});a.loading&&c(!0,n.options.loading,a.loading);r=p&&p.width;p=p&&p.height;f(r)&&r!==n.chartWidth||f(p)&&p!==n.chartHeight?n.setSize(r,p,h):e(d,!0)&&n.redraw(h);l(n,"afterUpdate",{options:a})},setSubtitle:function(a){this.setTitle(void 0,a)}});q(n.prototype,{update:function(a,b,c,f){function d(){k.applyOptions(a);null===k.y&&n&&(k.graphic=n.destroy());h(a,!0)&&(n&&n.element&&a&&a.marker&&void 0!==a.marker.symbol&&(k.graphic=n.destroy()),a&&a.dataLabels&&k.dataLabel&&(k.dataLabel=k.dataLabel.destroy()),
k.connector&&(k.connector=k.connector.destroy()));l=k.index;g.updateParallelArrays(k,l);u.data[l]=h(u.data[l],!0)||h(a,!0)?k.options:e(a,u.data[l]);g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(m.isDirtyBox=!0);"point"===u.legendType&&(m.isDirtyLegend=!0);b&&m.redraw(c)}var k=this,g=k.series,n=k.graphic,l,m=g.chart,u=g.options;b=e(b,!0);!1===f?d():k.firePointEvent("update",{options:a},d)},remove:function(a,b){this.series.removePoint(g(this,this.series.data),a,b)}});q(A.prototype,
{addPoint:function(a,b,c,f){var d=this.options,k=this.data,g=this.chart,h=this.xAxis,h=h&&h.hasNames&&h.names,n=d.data,l,m,u=this.xData,p,q;b=e(b,!0);l={series:this};this.pointClass.prototype.applyOptions.apply(l,[a]);q=l.x;p=u.length;if(this.requireSorting&&q<u[p-1])for(m=!0;p&&u[p-1]>q;)p--;this.updateParallelArrays(l,"splice",p,0,0);this.updateParallelArrays(l,p);h&&l.name&&(h[q]=l.name);n.splice(p,0,a);m&&(this.data.splice(p,0,null),this.processData());"point"===d.legendType&&this.generatePoints();
c&&(k[0]&&k[0].remove?k[0].remove(!1):(k.shift(),this.updateParallelArrays(l,"shift"),n.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(f)},removePoint:function(a,b,c){var f=this,d=f.data,k=d[a],g=f.points,h=f.chart,l=function(){g&&g.length===d.length&&g.splice(a,1);d.splice(a,1);f.options.data.splice(a,1);f.updateParallelArrays(k||{series:f},"splice",a,1);k&&k.destroy();f.isDirty=!0;f.isDirtyData=!0;b&&h.redraw()};C(c,h);b=e(b,!0);k?k.firePointEvent("remove",null,l):l()},remove:function(a,
b,c){function f(){d.destroy();k.isDirtyLegend=k.isDirtyBox=!0;k.linkSeries();e(a,!0)&&k.redraw(b)}var d=this,k=d.chart;!1!==c?l(d,"remove",null,f):f()},update:function(b,f){var d=this,h=d.chart,n=d.userOptions,m=d.oldType||d.type,p=b.type||n.type||h.options.chart.type,u=G[m].prototype,C,w=["group","markerGroup","dataLabelsGroup"],A=["navigatorSeries","baseSeries"],t=d.finishedAnimating&&{animation:!1},F=["data","name","turboThreshold"],M=a.keys(b),y=0<M.length;v(M,function(a){-1===g(a,F)&&(y=!1)});
if(y)b.data&&this.setData(b.data,!1),b.name&&this.setName(b.name,!1);else{A=w.concat(A);v(A,function(a){A[a]=d[a];delete d[a]});b=c(n,t,{index:d.index,pointStart:e(n.pointStart,d.xData[0])},{data:d.options.data},b);d.remove(!1,null,!1);for(C in u)d[C]=void 0;G[p||m]?q(d,G[p||m].prototype):a.error(17,!0);v(A,function(a){d[a]=A[a]});d.init(h,b);b.zIndex!==n.zIndex&&v(w,function(a){d[a]&&d[a].attr({zIndex:b.zIndex})});d.oldType=m;h.linkSeries()}l(this,"afterUpdate");e(f,!0)&&h.redraw(!1)},setName:function(a){this.name=
this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});q(D.prototype,{update:function(a,f){var d=this.chart,g=a&&a.events||{};a=c(this.userOptions,a);d.options[this.coll].indexOf&&(d.options[this.coll][d.options[this.coll].indexOf(this.userOptions)]=a);b(d.options[this.coll].events,function(a,b){"undefined"===typeof g[b]&&(g[b]=void 0)});this.destroy(!0);this.init(d,q(a,{events:g}));d.isDirtyBox=!0;e(f,!0)&&d.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,f=this.series,
d=f.length;d--;)f[d]&&f[d].remove(!1);t(b.axes,this);t(b[c],this);w(b.options[c])?b.options[c].splice(this.options.index,1):delete b.options[c];v(b[c],function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;e(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(J);(function(a){var B=a.animObject,y=a.color,D=a.each,p=a.extend,d=a.isNumber,m=a.merge,v=a.pick,t=a.Series,q=a.seriesType,l=a.svg;q("column",
"line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){t.prototype.init.apply(this,
arguments);var a=this,f=a.chart;f.hasRendered&&D(f.series,function(f){f.type===a.type&&(f.isDirty=!0)})},getColumnMetrics:function(){var a=this,f=a.options,d=a.xAxis,l=a.yAxis,c=d.options.reversedStacks,c=d.reversed&&!c||!d.reversed&&c,b,e={},n=0;!1===f.grouping?n=1:D(a.chart.series,function(c){var f=c.options,d=c.yAxis,k;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||l.len!==d.len||l.pos!==d.pos||(f.stacking?(b=c.stackKey,void 0===e[b]&&(e[b]=n++),k=e[b]):!1!==f.grouping&&
(k=n++),c.columnIndex=k)});var m=Math.min(Math.abs(d.transA)*(d.ordinalSlope||f.pointRange||d.closestPointRange||d.tickInterval||1),d.len),p=m*f.groupPadding,q=(m-2*p)/(n||1),f=Math.min(f.maxPointWidth||d.len,v(f.pointWidth,q*(1-2*f.pointPadding)));a.columnMetrics={width:f,offset:(q-f)/2+(p+((a.columnIndex||0)+(c?1:0))*q-m/2)*(c?-1:1)};return a.columnMetrics},crispCol:function(a,f,d,l){var c=this.chart,b=this.borderWidth,e=-(b%2?.5:0),b=b%2?.5:1;c.inverted&&c.renderer.isVML&&(b+=1);this.options.crisp&&
(d=Math.round(a+d)+e,a=Math.round(a)+e,d-=a);l=Math.round(f+l)+b;e=.5>=Math.abs(f)&&.5<l;f=Math.round(f)+b;l-=f;e&&l&&(--f,l+=1);return{x:a,y:f,width:d,height:l}},translate:function(){var a=this,f=a.chart,d=a.options,l=a.dense=2>a.closestPointRange*a.xAxis.transA,l=a.borderWidth=v(d.borderWidth,l?0:1),c=a.yAxis,b=d.threshold,e=a.translatedThreshold=c.getThreshold(b),n=v(d.minPointLength,5),m=a.getColumnMetrics(),p=m.width,q=a.barW=Math.max(p,1+2*l),M=a.pointXOffset=m.offset;f.inverted&&(e-=.5);d.pointPadding&&
(q=Math.ceil(q));t.prototype.translate.apply(a);D(a.points,function(d){var g=v(d.yBottom,e),k=999+Math.abs(g),k=Math.min(Math.max(-k,d.plotY),c.len+k),h=d.plotX+M,l=q,m=Math.min(k,g),u,r=Math.max(k,g)-m;n&&Math.abs(r)<n&&(r=n,u=!c.reversed&&!d.negative||c.reversed&&d.negative,d.y===b&&a.dataMax<=b&&c.min<b&&(u=!u),m=Math.abs(m-e)>n?g-n:e-(u?n:0));d.barX=h;d.pointWidth=p;d.tooltipPos=f.inverted?[c.len+c.pos-f.plotLeft-k,a.xAxis.len-h-l/2,r]:[h+l/2,k+c.pos-f.plotTop,r];d.shapeType="rect";d.shapeArgs=
a.crispCol.apply(a,d.isNull?[h,e,l,0]:[h,m,l,r])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,d){var f=this.options,g,c=this.pointAttrToOptions||{};g=c.stroke||"borderColor";var b=c["stroke-width"]||"borderWidth",e=a&&a.color||this.color,l=a&&a[g]||f[g]||this.color||e,p=a&&a[b]||f[b]||this[b]||0,c=f.dashStyle;a&&this.zones.length&&(e=a.getZone(),e=a.options.color||
e&&e.color||this.color);d&&(a=m(f.states[d],a.options.states&&a.options.states[d]||{}),d=a.brightness,e=a.color||void 0!==d&&y(e).brighten(a.brightness).get()||e,l=a[g]||l,p=a[b]||p,c=a.dashStyle||c);g={fill:e,stroke:l,"stroke-width":p};c&&(g.dashstyle=c);return g},drawPoints:function(){var a=this,f=this.chart,h=a.options,l=f.renderer,c=h.animationLimit||250,b;D(a.points,function(e){var g=e.graphic,p=g&&f.pointCount<c?"animate":"attr";if(d(e.plotY)&&null!==e.y){b=e.shapeArgs;if(g)g[p](m(b));else e.graphic=
g=l[e.shapeType](b).add(e.group||a.group);h.borderRadius&&g.attr({r:h.borderRadius});g[p](a.pointAttribs(e,e.selected&&"select")).shadow(h.shadow,null,h.stacking&&!h.borderRadius);g.addClass(e.getClassName(),!0)}else g&&(e.graphic=g.destroy())})},animate:function(a){var d=this,g=this.yAxis,m=d.options,c=this.chart.inverted,b={},e=c?"translateX":"translateY",n;l&&(a?(b.scaleY=.001,a=Math.min(g.pos+g.len,Math.max(g.pos,g.toPixels(m.threshold))),c?b.translateX=a-g.len:b.translateY=a,d.group.attr(b)):
(n=d.group.attr(e),d.group.animate({scaleY:1},p(B(d.options.animation),{step:function(a,c){b[e]=n+c.pos*(g.pos-n);d.group.attr(b)}})),d.animate=null))},remove:function(){var a=this,d=a.chart;d.hasRendered&&D(d.series,function(d){d.type===a.type&&(d.isDirty=!0)});t.prototype.remove.apply(a,arguments)}})})(J);(function(a){var B=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&B.prototype.drawGraph.call(this)}})})(J);(function(a){var B=a.addEvent,y=a.arrayMax,D=a.defined,p=a.each,d=a.extend,m=a.format,v=a.map,t=a.merge,q=a.noop,l=a.pick,g=a.relativeLength,f=a.Series,h=a.seriesTypes,w=a.some,c=a.stableSort;
a.distribute=function(b,e,d){function f(a,b){return a.target-b.target}var g,h=!0,n=b,m=[],q;q=0;var k=n.reducedLen||e;for(g=b.length;g--;)q+=b[g].size;if(q>k){c(b,function(a,b){return(b.rank||0)-(a.rank||0)});for(q=g=0;q<=k;)q+=b[g].size,g++;m=b.splice(g-1,b.length)}c(b,f);for(b=v(b,function(a){return{size:a.size,targets:[a.target],align:l(a.align,.5)}});h;){for(g=b.length;g--;)h=b[g],q=(Math.min.apply(0,h.targets)+Math.max.apply(0,h.targets))/2,h.pos=Math.min(Math.max(0,q-h.size*h.align),e-h.size);
g=b.length;for(h=!1;g--;)0<g&&b[g-1].pos+b[g-1].size>b[g].pos&&(b[g-1].size+=b[g].size,b[g-1].targets=b[g-1].targets.concat(b[g].targets),b[g-1].align=.5,b[g-1].pos+b[g-1].size>e&&(b[g-1].pos=e-b[g-1].size),b.splice(g,1),h=!0)}n.push.apply(n,m);g=0;w(b,function(b){var c=0;if(w(b.targets,function(){n[g].pos=b.pos+c;if(Math.abs(n[g].pos-n[g].target)>d)return p(n.slice(0,g+1),function(a){delete a.pos}),n.reducedLen=(n.reducedLen||e)-.1*e,n.reducedLen>.1*e&&a.distribute(n,e,d),!0;c+=n[g].size;g++}))return!0});
c(n,f)};f.prototype.drawDataLabels=function(){function b(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}var c=this,d=c.chart,f=c.options,g=f.dataLabels,h=c.points,q,u,w=c.hasRendered||0,k,v,x=l(g.defer,!!f.animation),y=d.renderer;if(g.enabled||c._hasPointLabels)c.dlProcessOptions&&c.dlProcessOptions(g),v=c.plotGroup("dataLabelsGroup","data-labels",
x&&!w?"hidden":"visible",g.zIndex||6),x&&(v.attr({opacity:+w}),w||B(c,"afterAnimate",function(){c.visible&&v.show(!0);v[f.animation?"animate":"attr"]({opacity:1},{duration:200})})),u=g,p(h,function(e){var h,n=e.dataLabel,p,C,w=e.connector,A=!n,x;q=e.dlOptions||e.options&&e.options.dataLabels;(h=l(q&&q.enabled,u.enabled)&&!e.isNull)&&(h=!0===b(e,q||g));h&&(g=t(u,q),p=e.getLabelConfig(),x=g[e.formatPrefix+"Format"]||g.format,k=D(x)?m(x,p,d.time):(g[e.formatPrefix+"Formatter"]||g.formatter).call(p,g),
x=g.style,p=g.rotation,x.color=l(g.color,x.color,c.color,"#000000"),"contrast"===x.color&&(e.contrastColor=y.getContrast(e.color||c.color),x.color=g.inside||0>l(e.labelDistance,g.distance)||f.stacking?e.contrastColor:"#000000"),f.cursor&&(x.cursor=f.cursor),C={fill:g.backgroundColor,stroke:g.borderColor,"stroke-width":g.borderWidth,r:g.borderRadius||0,rotation:p,padding:g.padding,zIndex:1},a.objectEach(C,function(a,b){void 0===a&&delete C[b]}));!n||h&&D(k)?h&&D(k)&&(n?C.text=k:(n=e.dataLabel=p?y.text(k,
0,-9999,g.useHTML).addClass("highcharts-data-label"):y.label(k,0,-9999,g.shape,null,null,g.useHTML,null,"data-label"),n.addClass(" highcharts-data-label-color-"+e.colorIndex+" "+(g.className||"")+(g.useHTML?" highcharts-tracker":""))),n.attr(C),n.css(x).shadow(g.shadow),n.added||n.add(v),c.alignDataLabel(e,n,g,null,A)):(e.dataLabel=n=n.destroy(),w&&(e.connector=w.destroy()))});a.fireEvent(this,"afterDrawDataLabels")};f.prototype.alignDataLabel=function(a,c,f,g,h){var b=this.chart,e=b.inverted,n=l(a.dlBox&&
a.dlBox.centerX,a.plotX,-9999),m=l(a.plotY,-9999),k=c.getBBox(),p,q=f.rotation,w=f.align,t=this.visible&&(a.series.forceDL||b.isInsidePlot(n,Math.round(m),e)||g&&b.isInsidePlot(n,e?g.x+1:g.y+g.height-1,e)),r="justify"===l(f.overflow,"justify");if(t&&(p=f.style.fontSize,p=b.renderer.fontMetrics(p,c).b,g=d({x:e?this.yAxis.len-m:n,y:Math.round(e?this.xAxis.len-n:m),width:0,height:0},g),d(f,{width:k.width,height:k.height}),q?(r=!1,n=b.renderer.rotCorr(p,q),n={x:g.x+f.x+g.width/2+n.x,y:g.y+f.y+{top:0,
middle:.5,bottom:1}[f.verticalAlign]*g.height},c[h?"attr":"animate"](n).attr({align:w}),m=(q+720)%360,m=180<m&&360>m,"left"===w?n.y-=m?k.height:0:"center"===w?(n.x-=k.width/2,n.y-=k.height/2):"right"===w&&(n.x-=k.width,n.y-=m?0:k.height),c.placed=!0,c.alignAttr=n):(c.align(f,null,g),n=c.alignAttr),r&&0<=g.height?a.isLabelJustified=this.justifyDataLabel(c,f,n,k,g,h):l(f.crop,!0)&&(t=b.isInsidePlot(n.x,n.y)&&b.isInsidePlot(n.x+k.width,n.y+k.height)),f.shape&&!q))c[h?"attr":"animate"]({anchorX:e?b.plotWidth-
a.plotY:a.plotX,anchorY:e?b.plotHeight-a.plotX:a.plotY});t||(c.attr({y:-9999}),c.placed=!1)};f.prototype.justifyDataLabel=function(a,c,d,f,g,h){var b=this.chart,e=c.align,l=c.verticalAlign,k,n,m=a.box?0:a.padding||0;k=d.x+m;0>k&&("right"===e?c.align="left":c.x=-k,n=!0);k=d.x+f.width-m;k>b.plotWidth&&("left"===e?c.align="right":c.x=b.plotWidth-k,n=!0);k=d.y+m;0>k&&("bottom"===l?c.verticalAlign="top":c.y=-k,n=!0);k=d.y+f.height-m;k>b.plotHeight&&("top"===l?c.verticalAlign="bottom":c.y=b.plotHeight-
k,n=!0);n&&(a.placed=!h,a.align(c,null,g));return n};h.pie&&(h.pie.prototype.drawDataLabels=function(){var b=this,c=b.data,d,g=b.chart,h=b.options.dataLabels,m=l(h.connectorPadding,10),q=l(h.connectorWidth,1),u=g.plotWidth,w=g.plotHeight,k=Math.round(g.chartWidth/3),t,x=b.center,v=x[2]/2,H=x[1],r,z,B,J,K=[[],[]],P,O,I,Q,R=[0,0,0,0];b.visible&&(h.enabled||b._hasPointLabels)&&(p(c,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),
a.dataLabel.shortened=!1)}),f.prototype.drawDataLabels.apply(b),p(c,function(a){a.dataLabel&&(a.visible?(K[a.half].push(a),a.dataLabel._pos=null,!D(h.style.width)&&!D(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>k&&(a.dataLabel.css({width:.7*k}),a.dataLabel.shortened=!0)):a.dataLabel=a.dataLabel.destroy())}),p(K,function(c,e){var f,k,n=c.length,q=[],C;if(n)for(b.sortByAngle(c,e-.5),0<b.maxLabelDistance&&(f=Math.max(0,H-v-b.maxLabelDistance),
k=Math.min(H+v+b.maxLabelDistance,g.plotHeight),p(c,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,H-v-a.labelDistance),a.bottom=Math.min(H+v+a.labelDistance,g.plotHeight),C=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPos[1]-a.top+C/2,size:C,rank:a.y},q.push(a.distributeBox))}),f=k+C-f,a.distribute(q,f,f/5)),Q=0;Q<n;Q++)d=c[Q],B=d.labelPos,r=d.dataLabel,I=!1===d.visible?"hidden":"inherit",O=f=B[1],q&&D(d.distributeBox)&&(void 0===d.distributeBox.pos?I="hidden":(J=
d.distributeBox.size,O=d.top+d.distributeBox.pos)),delete d.positionIndex,P=h.justify?x[0]+(e?-1:1)*(v+d.labelDistance):b.getX(O<d.top+2||O>d.bottom-2?f:O,e,d),r._attr={visibility:I,align:B[6]},r._pos={x:P+h.x+({left:m,right:-m}[B[6]]||0),y:O+h.y-10},B.x=P,B.y=O,l(h.crop,!0)&&(z=r.getBBox().width,f=null,P-z<m&&1===e?(f=Math.round(z-P+m),R[3]=Math.max(f,R[3])):P+z>u-m&&0===e&&(f=Math.round(P+z-u+m),R[1]=Math.max(f,R[1])),0>O-J/2?R[0]=Math.max(Math.round(-O+J/2),R[0]):O+J/2>w&&(R[2]=Math.max(Math.round(O+
J/2-w),R[2])),r.sideOverflow=f)}),0===y(R)||this.verifyDataLabelOverflow(R))&&(this.placeDataLabels(),q&&p(this.points,function(a){var c;t=a.connector;if((r=a.dataLabel)&&r._pos&&a.visible&&0<a.labelDistance){I=r._attr.visibility;if(c=!t)a.connector=t=g.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(b.dataLabelsGroup),t.attr({"stroke-width":q,stroke:h.connectorColor||a.color||"#666666"});t[c?"attr":"animate"]({d:b.connectorPath(a.labelPos)});
t.attr("visibility",I)}else t&&(a.connector=t.destroy())}))},h.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return l(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},h.pie.prototype.placeDataLabels=function(){p(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+
"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},h.pie.prototype.alignDataLabel=q,h.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,f=c.minSize||80,h,l=null!==c.size;l||(null!==d[0]?h=Math.max(b[2]-Math.max(a[1],a[3]),f):(h=Math.max(b[2]-a[1]-a[3],f),b[0]+=(a[3]-a[1])/2),null!==d[1]?h=Math.max(Math.min(h,b[2]-Math.max(a[0],
a[2])),f):(h=Math.max(Math.min(h,b[2]-a[0]-a[2]),f),b[1]+=(a[0]-a[2])/2),h<b[2]?(b[2]=h,b[3]=Math.min(g(c.innerSize||0,h),h),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):l=!0);return l});h.column&&(h.column.prototype.alignDataLabel=function(a,c,d,g,h){var b=this.chart.inverted,e=a.series,n=a.dlBox||a.shapeArgs,m=l(a.below,a.plotY>l(this.translatedThreshold,e.yAxis.len)),k=l(d.inside,!!this.options.stacking);n&&(g=t(n),0>g.y&&(g.height+=g.y,g.y=0),n=g.y+g.height-e.yAxis.len,0<n&&(g.height-=
n),b&&(g={x:e.yAxis.len-g.y-g.height,y:e.xAxis.len-g.x-g.width,width:g.height,height:g.width}),k||(b?(g.x+=m?0:g.width,g.width=0):(g.y+=m?g.height:0,g.height=0)));d.align=l(d.align,!b||k?"center":m?"right":"left");d.verticalAlign=l(d.verticalAlign,b||k?"middle":m?"top":"bottom");f.prototype.alignDataLabel.call(this,a,c,d,g,h);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(J);(function(a){var B=a.Chart,y=a.each,D=a.objectEach,p=a.pick;a=a.addEvent;a(B,"render",function(){var a=
[];y(this.labelCollectors||[],function(d){a=a.concat(d())});y(this.yAxis||[],function(d){d.options.stackLabels&&!d.options.stackLabels.allowOverlap&&D(d.stacks,function(d){D(d,function(d){a.push(d.label)})})});y(this.series||[],function(d){var m=d.options.dataLabels,t=d.dataLabelCollections||["dataLabel"];(m.enabled||d._hasPointLabels)&&!m.allowOverlap&&d.visible&&y(t,function(m){y(d.points,function(d){d[m]&&(d[m].labelrank=p(d.labelrank,d.shapeArgs&&d.shapeArgs.height),a.push(d[m]))})})});this.hideOverlappingLabels(a)});
B.prototype.hideOverlappingLabels=function(a){var d=a.length,p=this.renderer,t,q,l,g,f,h,w=function(a,b,e,d,f,g,h,l){return!(f>a+e||f+h<a||g>b+d||g+l<b)};l=function(a){var b,c,d,f=2*(a.box?0:a.padding||0);d=0;if(a&&(!a.alignAttr||a.placed))return b=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},c=a.parentGroup,a.width||(d=a.getBBox(),a.width=d.width,a.height=d.height,d=p.fontMetrics(null,a.element).h),{x:b.x+(c.translateX||0),y:b.y+(c.translateY||0)-d,width:a.width-f,height:a.height-f}};for(q=0;q<d;q++)if(t=
a[q])t.oldOpacity=t.opacity,t.newOpacity=1,t.absoluteBox=l(t);a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(q=0;q<d;q++)for(h=(l=a[q])&&l.absoluteBox,t=q+1;t<d;++t)if(f=(g=a[t])&&g.absoluteBox,h&&f&&l!==g&&0!==l.newOpacity&&0!==g.newOpacity&&(f=w(h.x,h.y,h.width,h.height,f.x,f.y,f.width,f.height)))(l.labelrank<g.labelrank?l:g).newOpacity=0;y(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&(a.alignAttr&&a.placed?(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=
c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)):a.attr({opacity:c})),a.isOld=!0)})}})(J);(function(a){var B=a.addEvent,y=a.Chart,D=a.createElement,p=a.css,d=a.defaultOptions,m=a.defaultPlotOptions,v=a.each,t=a.extend,q=a.fireEvent,l=a.hasTouch,g=a.inArray,f=a.isObject,h=a.Legend,w=a.merge,c=a.pick,b=a.Point,e=a.Series,n=a.seriesTypes,A=a.svg,G;G=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};
v(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(v(a.trackerGroups,function(e){if(a[e]){a[e].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(l)a[e].on("touchstart",c);a.options.cursor&&a[e].css(p).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=
b.trackByArea,e=[].concat(c?a.areaPath:a.graphPath),d=e.length,f=a.chart,g=f.pointer,h=f.renderer,n=f.options.tooltip.snap,m=a.tracker,p,w=function(){if(f.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+(A?.0001:.002)+")";if(d&&!c)for(p=d+1;p--;)"M"===e[p]&&e.splice(p+1,0,e[p+1]-n,e[p+2],"L"),(p&&"M"===e[p]||p===d)&&e.splice(p,0,"L",e[p-2]+n,e[p-1]);m?m.attr({d:e}):a.graph&&(a.tracker=h.path(e).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:t,fill:c?t:"none",
"stroke-width":a.graph.strokeWidth()+(c?0:2*n),zIndex:2}).add(a.group),v([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",w).on("mouseout",function(a){g.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(l)a.on("touchstart",w)}));q(this,"afterDrawTracker")}};n.column&&(n.column.prototype.drawTracker=G.drawTrackerPoint);n.pie&&(n.pie.prototype.drawTracker=G.drawTrackerPoint);n.scatter&&(n.scatter.prototype.drawTracker=G.drawTrackerPoint);t(h.prototype,
{setItemEvents:function(a,c,e){var d=this,f=d.chart.renderer.boxWrapper,g="highcharts-legend-"+(a instanceof b?"point":"series")+"-active";(e?c:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(g);c.css(d.options.itemHoverStyle)}).on("mouseout",function(){c.css(w(a.visible?d.itemStyle:d.itemHiddenStyle));f.removeClass(g);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};f.removeClass(g);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",
b,c):q(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=D("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);B(a.checkbox,"click",function(b){q(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});d.legend.itemStyle.cursor="pointer";t(y.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=d.lang,e=b.options.chart.resetZoomButton,
f=e.theme,g=f.states,h="chart"===e.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,f,g&&g.hover).attr({align:e.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(e.position,!1,h)})},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b,e=this.pointer,d=!1,g;!a||a.resetSelection?(v(this.axes,function(a){b=a.zoom()}),e.initiated=!1):v(a.xAxis.concat(a.yAxis),
function(a){var c=a.axis;e[c.isXAxis?"zoomX":"zoomY"]&&(b=c.zoom(a.min,a.max),c.displayBtn&&(d=!0))});g=this.resetZoomButton;d&&!g?this.showResetZoom():!d&&f(g)&&(this.resetZoomButton=g.destroy());b&&this.redraw(c(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,e=c.hoverPoints,d;e&&v(e,function(a){a.setState()});v("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var e=b.horiz,f=a[e?"chartX":"chartY"],e=e?"mouseDownX":"mouseDownY",g=c[e],k=(b.pointRange||
0)/2,h=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),n=b.toValue(g-f,!0)+k*h,h=b.toValue(g+b.len-f,!0)-k*h,m=h<n,g=m?h:n,n=m?n:h,h=Math.min(l.dataMin,k?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding)),k=Math.max(l.dataMax,k?l.max:b.toValue(b.toPixels(l.max)+b.minPixelPadding)),m=h-g;0<m&&(n+=m,g=h);m=n-k;0<m&&(n=k,g-=m);b.series.length&&g!==l.min&&n!==l.max&&(b.setExtremes(g,n,!1,!1,{trigger:"pan"}),d=!0);c[e]=f});d&&c.redraw(!1);p(c.container,{cursor:"move"})}});t(b.prototype,
{select:function(a,b){var e=this,d=e.series,f=d.chart;a=c(a,!e.selected);e.firePointEvent(a?"select":"unselect",{accumulate:b},function(){e.selected=e.options.selected=a;d.options.data[g(e,d.data)]=e.options;e.setState(a&&"select");b||v(f.getSelectedPoints(),function(a){a.selected&&a!==e&&(a.selected=a.options.selected=!1,d.options.data[g(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,
b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");v(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=w(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){B(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var e=Math.floor(this.plotX),d=this.plotY,f=this.series,g=f.options.states[a||"normal"]||{},h=
m[f.type].marker&&f.options.marker,l=h&&!1===h.enabled,n=h&&h.states&&h.states[a||"normal"]||{},p=!1===n.enabled,w=f.stateMarkerGraphic,v=this.marker||{},C=f.chart,A=f.halo,y,G=h&&f.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===g.enabled||a&&(p||l&&!1===n.enabled)||a&&v.states&&v.states[a]&&!1===v.states[a].enabled)){G&&(y=f.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+
a),this.graphic.animate(f.pointAttribs(this,a),c(C.options.chart.animation,g.animation)),y&&this.graphic.animate(y,c(C.options.chart.animation,n.animation,h.animation)),w&&w.hide();else{if(a&&n){h=v.symbol||f.symbol;w&&w.currentSymbol!==h&&(w=w.destroy());if(w)w[b?"animate":"attr"]({x:y.x,y:y.y});else h&&(f.stateMarkerGraphic=w=C.renderer.symbol(h,y.x,y.y,y.width,y.height).add(f.markerGroup),w.currentSymbol=h);w&&w.attr(f.pointAttribs(this,a))}w&&(w[a&&C.isInsidePlot(e,d,C.inverted)?"show":"hide"](),
w.element.point=this)}(e=g.halo)&&e.size?(A||(f.halo=A=C.renderer.path().add((this.graphic||w).parentGroup)),A.show()[b?"animate":"attr"]({d:this.haloPath(e.size)}),A.attr({"class":"highcharts-halo highcharts-color-"+c(this.colorIndex,f.colorIndex)+(this.className?" "+this.className:""),zIndex:-1}),A.point=this,A.attr(t({fill:this.color||f.color,"fill-opacity":e.opacity},e.attributes))):A&&A.point&&A.point.haloPath&&A.animate({d:A.point.haloPath(0)},null,A.hide);this.state=a;q(this,"afterSetState")}},
haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});t(e.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&q(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,e=b.hoverPoint;b.hoverSeries=null;if(e)e.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||
c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,e=b.options,d=b.graph,f=e.states,g=e.lineWidth,e=0;a=a||"";if(b.state!==a&&(v([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!f[a]||!1!==f[a].enabled)&&(a&&(g=f[a].lineWidth||g+(f[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":g},d.animate(g,c(f[a||"normal"]&&f[a||"normal"].animation,
b.chart.options.chart.animation));b["zone-graph-"+e];)b["zone-graph-"+e].attr(g),e+=1},setVisible:function(a,b){var c=this,e=c.chart,d=c.legendItem,f,g=e.options.chart.ignoreHiddenSeries,h=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!h:a)?"show":"hide";v(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(e.hoverSeries===c||(e.hoverPoint&&e.hoverPoint.series)===c)c.onMouseOut();d&&e.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&
v(e.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});v(c.linkedSeries,function(b){b.setVisible(a,!1)});g&&(e.isDirtyBox=!0);q(c,f);!1!==b&&e.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);q(this,a?"select":"unselect")},drawTracker:G.drawTrackerGraph})})(J);(function(a){var B=a.Chart,y=a.each,D=a.inArray,p=a.isArray,d=a.isObject,m=a.pick,v=a.splat;
B.prototype.setResponsive=function(d){var m=this.options.responsive,l=[],g=this.currentResponsive;m&&m.rules&&y(m.rules,function(f){void 0===f._id&&(f._id=a.uniqueKey());this.matchResponsiveRule(f,l,d)},this);var f=a.merge.apply(0,a.map(l,function(d){return a.find(m.rules,function(a){return a._id===d}).chartOptions})),l=l.toString()||void 0;l!==(g&&g.ruleIds)&&(g&&this.update(g.undoOptions,d),l?(this.currentResponsive={ruleIds:l,mergedOptions:f,undoOptions:this.currentOptions(f)},this.update(f,d)):
this.currentResponsive=void 0)};B.prototype.matchResponsiveRule=function(a,d){var l=a.condition;(l.callback||function(){return this.chartWidth<=m(l.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=m(l.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=m(l.minWidth,0)&&this.chartHeight>=m(l.minHeight,0)}).call(this)&&d.push(a._id)};B.prototype.currentOptions=function(m){function q(g,f,h,l){var c;a.objectEach(g,function(a,e){if(!l&&-1<D(e,["series","xAxis","yAxis"]))for(a=v(a),h[e]=[],c=0;c<a.length;c++)f[e][c]&&
(h[e][c]={},q(a[c],f[e][c],h[e][c],l+1));else d(a)?(h[e]=p(a)?[]:{},q(a,f[e]||{},h[e],l+1)):h[e]=f[e]||null})}var l={};q(m,this.options,l,0);return l}})(J);(function(a){var B=a.addEvent,y=a.Axis,D=a.each,p=a.pick;B(y,"getSeriesExtremes",function(){var a=[];this.isXAxis&&(D(this.series,function(d,p){d.useMapGeometry&&(a[p]=d.xData,d.xData=[])}),this.seriesXData=a)});B(y,"afterGetSeriesExtremes",function(){var a=this.seriesXData,m,v,t;this.isXAxis&&(m=p(this.dataMin,Number.MAX_VALUE),v=p(this.dataMax,
-Number.MAX_VALUE),D(this.series,function(d,l){d.useMapGeometry&&(m=Math.min(m,p(d.minX,m)),v=Math.max(v,p(d.maxX,v)),d.xData=a[l],t=!0)}),t&&(this.dataMin=m,this.dataMax=v),delete this.seriesXData)});B(y,"afterSetAxisTranslation",function(){var a=this.chart,m;m=a.plotWidth/a.plotHeight;var a=a.xAxis[0],p;"yAxis"===this.coll&&void 0!==a.transA&&D(this.series,function(a){a.preserveAspectRatio&&(p=!0)});if(p&&(this.transA=a.transA=Math.min(this.transA,a.transA),m/=(a.max-a.min)/(this.max-this.min),
m=1>m?this:a,a=(m.max-m.min)*m.transA,m.pixelPadding=m.len-a,m.minPixelPadding=m.pixelPadding/2,a=m.fixTo)){a=a[1]-m.toValue(a[0],!0);a*=m.transA;if(Math.abs(a)>m.minPixelPadding||m.min===m.dataMin&&m.max===m.dataMax)a=0;m.minPixelPadding-=a}});B(y,"render",function(){this.fixTo=null})})(J);(function(a){var B=a.addEvent,y=a.Axis,D=a.Chart,p=a.color,d,m=a.each,v=a.extend,t=a.isNumber,q=a.Legend,l=a.LegendSymbolMixin,g=a.noop,f=a.merge,h=a.pick;a.ColorAxis||(d=a.ColorAxis=function(){this.init.apply(this,
arguments)},v(d.prototype,y.prototype),v(d.prototype,{defaultColorAxisOptions:{lineWidth:0,minPadding:0,maxPadding:0,gridLineWidth:1,tickPixelInterval:72,startOnTick:!0,endOnTick:!0,offset:0,marker:{animation:{duration:50},width:.01,color:"#999999"},labels:{overflow:"justify",rotation:0},minColor:"#e6ebf5",maxColor:"#003399",tickLength:5,showInLegend:!0},keepProps:["legendGroup","legendItemHeight","legendItemWidth","legendItem","legendSymbol"].concat(y.prototype.keepProps),init:function(a,c){var b=
"vertical"!==a.options.legend.layout,e;this.coll="colorAxis";e=f(this.defaultColorAxisOptions,{side:b?2:1,reversed:!b},c,{opposite:!b,showEmpty:!1,title:null,visible:a.options.legend.enabled});y.prototype.init.call(this,a,e);c.dataClasses&&this.initDataClasses(c);this.initStops();this.horiz=b;this.zoomEnabled=!1;this.defaultLegendLength=200},initDataClasses:function(a){var c=this.chart,b,e=0,d=c.options.chart.colorCount,g=this.options,h=a.dataClasses.length;this.dataClasses=b=[];this.legendItems=
[];m(a.dataClasses,function(a,l){a=f(a);b.push(a);a.color||("category"===g.dataClassColor?(l=c.options.colors,d=l.length,a.color=l[e],a.colorIndex=e,e++,e===d&&(e=0)):a.color=p(g.minColor).tweenTo(p(g.maxColor),2>h?.5:l/(h-1)))})},setTickPositions:function(){if(!this.dataClasses)return y.prototype.setTickPositions.call(this)},initStops:function(){this.stops=this.options.stops||[[0,this.options.minColor],[1,this.options.maxColor]];m(this.stops,function(a){a.color=p(a[1])})},setOptions:function(a){y.prototype.setOptions.call(this,
a);this.options.crosshair=this.options.marker},setAxisSize:function(){var a=this.legendSymbol,c=this.chart,b=c.options.legend||{},e,d;a?(this.left=b=a.attr("x"),this.top=e=a.attr("y"),this.width=d=a.attr("width"),this.height=a=a.attr("height"),this.right=c.chartWidth-b-d,this.bottom=c.chartHeight-e-a,this.len=this.horiz?d:a,this.pos=this.horiz?b:e):this.len=(this.horiz?b.symbolWidth:b.symbolHeight)||this.defaultLegendLength},normalizedValue:function(a){this.isLog&&(a=this.val2lin(a));return 1-(this.max-
a)/(this.max-this.min||1)},toColor:function(a,c){var b=this.stops,e,d,f=this.dataClasses,g,h;if(f)for(h=f.length;h--;){if(g=f[h],e=g.from,b=g.to,(void 0===e||a>=e)&&(void 0===b||a<=b)){d=g.color;c&&(c.dataClass=h,c.colorIndex=g.colorIndex);break}}else{a=this.normalizedValue(a);for(h=b.length;h--&&!(a>b[h][0]););e=b[h]||b[h+1];b=b[h+1]||e;a=1-(b[0]-a)/(b[0]-e[0]||1);d=e.color.tweenTo(b.color,a)}return d},getOffset:function(){var a=this.legendGroup,c=this.chart.axisOffset[this.side];a&&(this.axisParent=
a,y.prototype.getOffset.call(this),this.added||(this.added=!0,this.labelLeft=0,this.labelRight=this.width),this.chart.axisOffset[this.side]=c)},setLegendColor:function(){var a,c=this.reversed;a=c?1:0;c=c?0:1;a=this.horiz?[a,0,c,0]:[0,c,0,a];this.legendColor={linearGradient:{x1:a[0],y1:a[1],x2:a[2],y2:a[3]},stops:this.stops}},drawLegendSymbol:function(a,c){var b=a.padding,e=a.options,d=this.horiz,f=h(e.symbolWidth,d?this.defaultLegendLength:12),g=h(e.symbolHeight,d?12:this.defaultLegendLength),l=h(e.labelPadding,
d?16:30),e=h(e.itemDistance,10);this.setLegendColor();c.legendSymbol=this.chart.renderer.rect(0,a.baseline-11,f,g).attr({zIndex:1}).add(c.legendGroup);this.legendItemWidth=f+b+(d?e:l);this.legendItemHeight=g+b+(d?l:0)},setState:function(a){m(this.series,function(c){c.setState(a)})},visible:!0,setVisible:g,getSeriesExtremes:function(){var a=this.series,c=a.length;this.dataMin=Infinity;for(this.dataMax=-Infinity;c--;)a[c].getExtremes(),void 0!==a[c].valueMin&&(this.dataMin=Math.min(this.dataMin,a[c].valueMin),
this.dataMax=Math.max(this.dataMax,a[c].valueMax))},drawCrosshair:function(a,c){var b=c&&c.plotX,e=c&&c.plotY,d,f=this.pos,g=this.len;c&&(d=this.toPixels(c[c.series.colorKey]),d<f?d=f-2:d>f+g&&(d=f+g+2),c.plotX=d,c.plotY=this.len-d,y.prototype.drawCrosshair.call(this,a,c),c.plotX=b,c.plotY=e,this.cross&&!this.cross.addedToColorAxis&&this.legendGroup&&(this.cross.addClass("highcharts-coloraxis-marker").add(this.legendGroup),this.cross.addedToColorAxis=!0,this.cross.attr({fill:this.crosshair.color})))},
getPlotLinePath:function(a,c,b,e,d){return t(d)?this.horiz?["M",d-4,this.top-6,"L",d+4,this.top-6,d,this.top,"Z"]:["M",this.left,d,"L",this.left-6,d+6,this.left-6,d-6,"Z"]:y.prototype.getPlotLinePath.call(this,a,c,b,e)},update:function(a,c){var b=this.chart,e=b.legend;m(this.series,function(a){a.isDirtyData=!0});a.dataClasses&&e.allItems&&(m(e.allItems,function(a){a.isDataClass&&a.legendGroup&&a.legendGroup.destroy()}),b.isDirtyLegend=!0);b.options[this.coll]=f(this.userOptions,a);y.prototype.update.call(this,
a,c);this.legendItem&&(this.setLegendColor(),e.colorizeItem(this,!0))},remove:function(){this.legendItem&&this.chart.legend.destroyItem(this);y.prototype.remove.call(this)},getDataClassLegendSymbols:function(){var d=this,c=this.chart,b=this.legendItems,e=c.options.legend,f=e.valueDecimals,h=e.valueSuffix||"",p;b.length||m(this.dataClasses,function(e,n){var q=!0,w=e.from,k=e.to;p="";void 0===w?p="\x3c ":void 0===k&&(p="\x3e ");void 0!==w&&(p+=a.numberFormat(w,f)+h);void 0!==w&&void 0!==k&&(p+=" - ");
void 0!==k&&(p+=a.numberFormat(k,f)+h);b.push(v({chart:c,name:p,options:{},drawLegendSymbol:l.drawRectangle,visible:!0,setState:g,isDataClass:!0,setVisible:function(){q=this.visible=!q;m(d.series,function(a){m(a.points,function(a){a.dataClass===n&&a.setVisible(q)})});c.legend.colorizeItem(this,q)}},e))});return b},name:""}),m(["fill","stroke"],function(d){a.Fx.prototype[d+"Setter"]=function(){this.elem.attr(d,p(this.start).tweenTo(p(this.end),this.pos),null,!0)}}),B(D,"afterGetAxes",function(){var a=
this.options.colorAxis;this.colorAxis=[];a&&new d(this,a)}),B(q,"afterGetAllItems",function(d){var c=[],b=this.chart.colorAxis[0];b&&b.options&&b.options.showInLegend&&(b.options.dataClasses?c=b.getDataClassLegendSymbols():c.push(b),m(b.series,function(b){a.erase(d.allItems,b)}));for(b=c.length;b--;)d.allItems.unshift(c[b])}),B(q,"afterColorizeItem",function(a){a.visible&&a.item.legendColor&&a.item.legendSymbol.attr({fill:a.item.legendColor})}),B(q,"afterUpdate",function(a,c,b){this.chart.colorAxis[0]&&
this.chart.colorAxis[0].update({},b)}))})(J);(function(a){var B=a.defined,y=a.each,D=a.noop,p=a.seriesTypes;a.colorPointMixin={isValid:function(){return null!==this.value&&Infinity!==this.value&&-Infinity!==this.value},setVisible:function(a){var d=this,p=a?"show":"hide";y(["graphic","dataLabel"],function(a){if(d[a])d[a][p]()})},setState:function(d){a.Point.prototype.setState.call(this,d);this.graphic&&this.graphic.attr({zIndex:"hover"===d?1:0})}};a.colorSeriesMixin={pointArrayMap:["value"],axisTypes:["xAxis",
"yAxis","colorAxis"],optionalAxis:"colorAxis",trackerGroups:["group","markerGroup","dataLabelsGroup"],getSymbol:D,parallelArrays:["x","y","value"],colorKey:"value",pointAttribs:p.column.prototype.pointAttribs,translateColors:function(){var a=this,m=this.options.nullColor,p=this.colorAxis,t=this.colorKey;y(this.data,function(d){var l=d[t];if(l=d.options.color||(d.isNull?m:p&&void 0!==l?p.toColor(l,d):d.color||a.color))d.color=l})},colorAttribs:function(a){var d={};B(a.color)&&(d[this.colorProp||"fill"]=
a.color);return d}}})(J);(function(a){function B(a){a&&(a.preventDefault&&a.preventDefault(),a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)}function y(a){this.init(a)}var D=a.addEvent,p=a.Chart,d=a.doc,m=a.each,v=a.extend,t=a.merge,q=a.pick;y.prototype.init=function(a){this.chart=a;a.mapNavButtons=[]};y.prototype.update=function(d){var g=this.chart,f=g.options.mapNavigation,h,l,c,b,e,n=function(a){this.handler.call(g,a);B(a)},m=g.mapNavButtons;d&&(f=g.options.mapNavigation=t(g.options.mapNavigation,
d));for(;m.length;)m.pop().destroy();q(f.enableButtons,f.enabled)&&!g.renderer.forExport&&a.objectEach(f.buttons,function(a,d){h=t(f.buttonOptions,a);l=h.theme;l.style=t(h.theme.style,h.style);b=(c=l.states)&&c.hover;e=c&&c.select;a=g.renderer.button(h.text,0,0,n,l,b,e,0,"zoomIn"===d?"topbutton":"bottombutton").addClass("highcharts-map-navigation").attr({width:h.width,height:h.height,title:g.options.lang[d],padding:h.padding,zIndex:5}).add();a.handler=h.onclick;a.align(v(h,{width:a.width,height:2*
a.height}),null,h.alignTo);D(a.element,"dblclick",B);m.push(a)});this.updateEvents(f)};y.prototype.updateEvents=function(a){var g=this.chart;q(a.enableDoubleClickZoom,a.enabled)||a.enableDoubleClickZoomTo?this.unbindDblClick=this.unbindDblClick||D(g.container,"dblclick",function(a){g.pointer.onContainerDblClick(a)}):this.unbindDblClick&&(this.unbindDblClick=this.unbindDblClick());q(a.enableMouseWheelZoom,a.enabled)?this.unbindMouseWheel=this.unbindMouseWheel||D(g.container,void 0===d.onmousewheel?
"DOMMouseScroll":"mousewheel",function(a){g.pointer.onContainerMouseWheel(a);B(a);return!1}):this.unbindMouseWheel&&(this.unbindMouseWheel=this.unbindMouseWheel())};v(p.prototype,{fitToBox:function(a,d){m([["x","width"],["y","height"]],function(f){var g=f[0];f=f[1];a[g]+a[f]>d[g]+d[f]&&(a[f]>d[f]?(a[f]=d[f],a[g]=d[g]):a[g]=d[g]+d[f]-a[f]);a[f]>d[f]&&(a[f]=d[f]);a[g]<d[g]&&(a[g]=d[g])});return a},mapZoom:function(a,d,f,h,m){var c=this.xAxis[0],b=c.max-c.min,e=q(d,c.min+b/2),g=b*a,b=this.yAxis[0],l=
b.max-b.min,p=q(f,b.min+l/2),l=l*a,e=this.fitToBox({x:e-g*(h?(h-c.pos)/c.len:.5),y:p-l*(m?(m-b.pos)/b.len:.5),width:g,height:l},{x:c.dataMin,y:b.dataMin,width:c.dataMax-c.dataMin,height:b.dataMax-b.dataMin}),g=e.x<=c.dataMin&&e.width>=c.dataMax-c.dataMin&&e.y<=b.dataMin&&e.height>=b.dataMax-b.dataMin;h&&(c.fixTo=[h-c.pos,d]);m&&(b.fixTo=[m-b.pos,f]);void 0===a||g?(c.setExtremes(void 0,void 0,!1),b.setExtremes(void 0,void 0,!1)):(c.setExtremes(e.x,e.x+e.width,!1),b.setExtremes(e.y,e.y+e.height,!1));
this.redraw()}});D(p,"beforeRender",function(){this.mapNavigation=new y(this);this.mapNavigation.update()})})(J);(function(a){var B=a.extend,y=a.pick,D=a.Pointer;a=a.wrap;B(D.prototype,{onContainerDblClick:function(a){var d=this.chart;a=this.normalize(a);d.options.mapNavigation.enableDoubleClickZoomTo?d.pointer.inClass(a.target,"highcharts-tracker")&&d.hoverPoint&&d.hoverPoint.zoomTo():d.isInsidePlot(a.chartX-d.plotLeft,a.chartY-d.plotTop)&&d.mapZoom(.5,d.xAxis[0].toValue(a.chartX),d.yAxis[0].toValue(a.chartY),
a.chartX,a.chartY)},onContainerMouseWheel:function(a){var d=this.chart,m;a=this.normalize(a);m=a.detail||-(a.wheelDelta/120);d.isInsidePlot(a.chartX-d.plotLeft,a.chartY-d.plotTop)&&d.mapZoom(Math.pow(d.options.mapNavigation.mouseWheelSensitivity,m),d.xAxis[0].toValue(a.chartX),d.yAxis[0].toValue(a.chartY),a.chartX,a.chartY)}});a(D.prototype,"zoomOption",function(a){var d=this.chart.options.mapNavigation;y(d.enableTouchZoom,d.enabled)&&(this.chart.options.chart.pinchType="xy");a.apply(this,[].slice.call(arguments,
1))});a(D.prototype,"pinchTranslate",function(a,d,m,v,t,q,l){a.call(this,d,m,v,t,q,l);"map"===this.chart.options.chart.type&&this.hasZoom&&(a=v.scaleX>v.scaleY,this.pinchTranslateDirection(!a,d,m,v,t,q,l,a?v.scaleX:v.scaleY))})})(J);(function(a){var B=a.colorPointMixin,y=a.each,D=a.extend,p=a.isNumber,d=a.map,m=a.merge,v=a.noop,t=a.pick,q=a.isArray,l=a.Point,g=a.Series,f=a.seriesType,h=a.seriesTypes,w=a.splat;f("map","scatter",{allAreas:!0,animation:!1,nullColor:"#f7f7f7",borderColor:"#cccccc",borderWidth:1,
marker:null,stickyTracking:!1,joinBy:"hc-key",dataLabels:{formatter:function(){return this.point.value},inside:!0,verticalAlign:"middle",crop:!1,overflow:!1,padding:0},turboThreshold:0,tooltip:{followPointer:!0,pointFormat:"{point.name}: {point.value}\x3cbr/\x3e"},states:{normal:{animation:!0},hover:{halo:null,brightness:.2},select:{color:"#cccccc"}}},m(a.colorSeriesMixin,{type:"map",getExtremesFromAll:!0,useMapGeometry:!0,forceDL:!0,searchPoint:v,directTouch:!0,preserveAspectRatio:!0,pointArrayMap:["value"],
getBox:function(c){var b=Number.MAX_VALUE,e=-b,d=b,f=-b,g=b,h=b,l=this.xAxis,m=this.yAxis,q;y(c||[],function(c){if(c.path){"string"===typeof c.path&&(c.path=a.splitPath(c.path));var k=c.path||[],l=k.length,n=!1,m=-b,r=b,u=-b,w=b,v=c.properties;if(!c._foundBox){for(;l--;)p(k[l])&&(n?(m=Math.max(m,k[l]),r=Math.min(r,k[l])):(u=Math.max(u,k[l]),w=Math.min(w,k[l])),n=!n);c._midX=r+(m-r)*t(c.middleX,v&&v["hc-middle-x"],.5);c._midY=w+(u-w)*t(c.middleY,v&&v["hc-middle-y"],.5);c._maxX=m;c._minX=r;c._maxY=
u;c._minY=w;c.labelrank=t(c.labelrank,(m-r)*(u-w));c._foundBox=!0}e=Math.max(e,c._maxX);d=Math.min(d,c._minX);f=Math.max(f,c._maxY);g=Math.min(g,c._minY);h=Math.min(c._maxX-c._minX,c._maxY-c._minY,h);q=!0}});q&&(this.minY=Math.min(g,t(this.minY,b)),this.maxY=Math.max(f,t(this.maxY,-b)),this.minX=Math.min(d,t(this.minX,b)),this.maxX=Math.max(e,t(this.maxX,-b)),l&&void 0===l.options.minRange&&(l.minRange=Math.min(5*h,(this.maxX-this.minX)/5,l.minRange||b)),m&&void 0===m.options.minRange&&(m.minRange=
Math.min(5*h,(this.maxY-this.minY)/5,m.minRange||b)))},getExtremes:function(){g.prototype.getExtremes.call(this,this.valueData);this.chart.hasRendered&&this.isDirtyData&&this.getBox(this.options.data);this.valueMin=this.dataMin;this.valueMax=this.dataMax;this.dataMin=this.minY;this.dataMax=this.maxY},translatePath:function(a){var b=!1,c=this.xAxis,d=this.yAxis,f=c.min,g=c.transA,c=c.minPixelPadding,h=d.min,l=d.transA,d=d.minPixelPadding,m,q=[];if(a)for(m=a.length;m--;)p(a[m])?(q[m]=b?(a[m]-f)*g+c:
(a[m]-h)*l+d,b=!b):q[m]=a[m];return q},setData:function(c,b,e,f){var h=this.options,l=this.chart.options.chart,n=l&&l.map,t=h.mapData,u=h.joinBy,v=null===u,k=h.keys||this.pointArrayMap,B=[],x={},D=this.chart.mapTransforms;!t&&n&&(t="string"===typeof n?a.maps[n]:n);v&&(u="_i");u=this.joinBy=w(u);u[1]||(u[1]=u[0]);c&&y(c,function(b,e){var d=0;if(p(b))c[e]={value:b};else if(q(b)){c[e]={};!h.keys&&b.length>k.length&&"string"===typeof b[0]&&(c[e]["hc-key"]=b[0],++d);for(var f=0;f<k.length;++f,++d)k[f]&&
void 0!==b[d]&&(0<k[f].indexOf(".")?a.Point.prototype.setNestedProperty(c[e],b[d],k[f]):c[e][k[f]]=b[d])}v&&(c[e]._i=e)});this.getBox(c);(this.chart.mapTransforms=D=l&&l.mapTransforms||t&&t["hc-transform"]||D)&&a.objectEach(D,function(a){a.rotation&&(a.cosAngle=Math.cos(a.rotation),a.sinAngle=Math.sin(a.rotation))});if(t){"FeatureCollection"===t.type&&(this.mapTitle=t.title,t=a.geojson(t,this.type,this));this.mapData=t;this.mapMap={};for(D=0;D<t.length;D++)l=t[D],n=l.properties,l._i=D,u[0]&&n&&n[u[0]]&&
(l[u[0]]=n[u[0]]),x[l[u[0]]]=l;this.mapMap=x;c&&u[1]&&y(c,function(a){x[a[u[1]]]&&B.push(x[a[u[1]]])});h.allAreas?(this.getBox(t),c=c||[],u[1]&&y(c,function(a){B.push(a[u[1]])}),B="|"+d(B,function(a){return a&&a[u[0]]}).join("|")+"|",y(t,function(a){u[0]&&-1!==B.indexOf("|"+a[u[0]]+"|")||(c.push(m(a,{value:null})),f=!1)})):this.getBox(B)}g.prototype.setData.call(this,c,b,e,f)},drawGraph:v,drawDataLabels:v,doFullTranslate:function(){return this.isDirtyData||this.chart.isResizing||this.chart.renderer.isVML||
!this.baseTrans},translate:function(){var a=this,b=a.xAxis,e=a.yAxis,d=a.doFullTranslate();a.generatePoints();y(a.data,function(c){c.plotX=b.toPixels(c._midX,!0);c.plotY=e.toPixels(c._midY,!0);d&&(c.shapeType="path",c.shapeArgs={d:a.translatePath(c.path)})});a.translateColors()},pointAttribs:function(a,b){b=h.column.prototype.pointAttribs.call(this,a,b);b["stroke-width"]=t(a.options[this.pointAttrToOptions&&this.pointAttrToOptions["stroke-width"]||"borderWidth"],"inherit");return b},drawPoints:function(){var a=
this,b=a.xAxis,e=a.yAxis,d=a.group,f=a.chart,g=f.renderer,l,m,p,q,k=this.baseTrans,w,t,v,B,r;a.transformGroup||(a.transformGroup=g.g().attr({scaleX:1,scaleY:1}).add(d),a.transformGroup.survive=!0);a.doFullTranslate()?(f.hasRendered&&y(a.points,function(b){b.shapeArgs&&(b.shapeArgs.fill=a.pointAttribs(b,b.state).fill)}),a.group=a.transformGroup,h.column.prototype.drawPoints.apply(a),a.group=d,y(a.points,function(a){a.graphic&&(a.name&&a.graphic.addClass("highcharts-name-"+a.name.replace(/ /g,"-").toLowerCase()),
a.properties&&a.properties["hc-key"]&&a.graphic.addClass("highcharts-key-"+a.properties["hc-key"].toLowerCase()))}),this.baseTrans={originX:b.min-b.minPixelPadding/b.transA,originY:e.min-e.minPixelPadding/e.transA+(e.reversed?0:e.len/e.transA),transAX:b.transA,transAY:e.transA},this.transformGroup.animate({translateX:0,translateY:0,scaleX:1,scaleY:1})):(l=b.transA/k.transAX,m=e.transA/k.transAY,p=b.toPixels(k.originX,!0),q=e.toPixels(k.originY,!0),.99<l&&1.01>l&&.99<m&&1.01>m&&(m=l=1,p=Math.round(p),
q=Math.round(q)),w=this.transformGroup,f.renderer.globalAnimation?(t=w.attr("translateX"),v=w.attr("translateY"),B=w.attr("scaleX"),r=w.attr("scaleY"),w.attr({animator:0}).animate({animator:1},{step:function(a,b){w.attr({translateX:t+(p-t)*b.pos,translateY:v+(q-v)*b.pos,scaleX:B+(l-B)*b.pos,scaleY:r+(m-r)*b.pos})}})):w.attr({translateX:p,translateY:q,scaleX:l,scaleY:m}));d.element.setAttribute("stroke-width",(a.options[a.pointAttrToOptions&&a.pointAttrToOptions["stroke-width"]||"borderWidth"]||1)/
(l||1));this.drawMapDataLabels()},drawMapDataLabels:function(){g.prototype.drawDataLabels.call(this);this.dataLabelsGroup&&this.dataLabelsGroup.clip(this.chart.clipRect)},render:function(){var a=this,b=g.prototype.render;a.chart.renderer.isVML&&3E3<a.data.length?setTimeout(function(){b.call(a)}):b.call(a)},animate:function(a){var b=this.options.animation,c=this.group,d=this.xAxis,f=this.yAxis,g=d.pos,h=f.pos;this.chart.renderer.isSVG&&(!0===b&&(b={duration:1E3}),a?c.attr({translateX:g+d.len/2,translateY:h+
f.len/2,scaleX:.001,scaleY:.001}):(c.animate({translateX:g,translateY:h,scaleX:1,scaleY:1},b),this.animate=null))},animateDrilldown:function(a){var b=this.chart.plotBox,c=this.chart.drilldownLevels[this.chart.drilldownLevels.length-1],d=c.bBox,f=this.chart.options.drilldown.animation;a||(a=Math.min(d.width/b.width,d.height/b.height),c.shapeArgs={scaleX:a,scaleY:a,translateX:d.x,translateY:d.y},y(this.points,function(a){a.graphic&&a.graphic.attr(c.shapeArgs).animate({scaleX:1,scaleY:1,translateX:0,
translateY:0},f)}),this.animate=null)},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,animateDrillupFrom:function(a){h.column.prototype.animateDrillupFrom.call(this,a)},animateDrillupTo:function(a){h.column.prototype.animateDrillupTo.call(this,a)}}),D({applyOptions:function(a,b){a=l.prototype.applyOptions.call(this,a,b);b=this.series;var c=b.joinBy;b.mapData&&((c=void 0!==a[c[1]]&&b.mapMap[a[c[1]]])?(b.xyFromShape&&(a.x=c._midX,a.y=c._midY),D(a,c)):a.value=a.value||null);return a},onMouseOver:function(c){a.clearTimeout(this.colorInterval);
if(null!==this.value||this.series.options.nullInteraction)l.prototype.onMouseOver.call(this,c);else this.series.onMouseOut(c)},zoomTo:function(){var a=this.series;a.xAxis.setExtremes(this._minX,this._maxX,!1);a.yAxis.setExtremes(this._minY,this._maxY,!1);a.chart.redraw()}},B))})(J);(function(a){var B=a.seriesType,y=a.seriesTypes;B("mapline","map",{lineWidth:1,fillColor:"none"},{type:"mapline",colorProp:"stroke",pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},pointAttribs:function(a,
p){a=y.map.prototype.pointAttribs.call(this,a,p);a.fill=this.options.fillColor;return a},drawLegendSymbol:y.line.prototype.drawLegendSymbol})})(J);(function(a){var B=a.merge,y=a.Point;a=a.seriesType;a("mappoint","scatter",{dataLabels:{enabled:!0,formatter:function(){return this.point.name},crop:!1,defer:!1,overflow:!1,style:{color:"#000000"}}},{type:"mappoint",forceDL:!0},{applyOptions:function(a,p){a=void 0!==a.lat&&void 0!==a.lon?B(a,this.series.chart.fromLatLonToPoint(a)):a;return y.prototype.applyOptions.call(this,
a,p)}})})(J);(function(a){var B=a.arrayMax,y=a.arrayMin,D=a.Axis,p=a.color,d=a.each,m=a.isNumber,v=a.noop,t=a.pick,q=a.pInt,l=a.Point,g=a.Series,f=a.seriesType,h=a.seriesTypes;f("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},animationLimit:250,marker:{lineColor:null,lineWidth:1,fillOpacity:.5,radius:null,states:{hover:{radiusPlus:0}},symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},
turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,pointAttribs:function(a,c){var b=this.options.marker.fillOpacity;a=g.prototype.pointAttribs.call(this,a,c);1!==b&&(a.fill=p(a.fill).setOpacity(b).get("rgba"));return a},getRadii:function(a,c,b,e){var d,f,g,h=this.zData,l=[],p=this.options,q="width"!==p.sizeBy,k=p.zThreshold,w=c-a;f=0;for(d=h.length;f<
d;f++)g=h[f],p.sizeByAbsoluteValue&&null!==g&&(g=Math.abs(g-k),c=w=Math.max(c-k,Math.abs(a-k)),a=0),m(g)?g<a?g=b/2-1:(g=0<w?(g-a)/w:.5,q&&0<=g&&(g=Math.sqrt(g)),g=Math.ceil(b+g*(e-b))/2):g=null,l.push(g);this.radii=l},animate:function(a){!a&&this.points.length<this.options.animationLimit&&(d(this.points,function(a){var b=a.graphic,c;b&&b.width&&(c={x:b.x,y:b.y,width:b.width,height:b.height},b.attr({x:a.plotX,y:a.plotY,width:1,height:1}),b.animate(c,this.options.animation))},this),this.animate=null)},
translate:function(){var d,c=this.data,b,e,f=this.radii;h.scatter.prototype.translate.call(this);for(d=c.length;d--;)b=c[d],e=f?f[d]:0,m(e)&&e>=this.minPxSize/2?(b.marker=a.extend(b.marker,{radius:e,width:2*e,height:2*e}),b.dlBox={x:b.plotX-e,y:b.plotY-e,width:2*e,height:2*e}):b.shapeArgs=b.plotY=b.dlBox=void 0},alignDataLabel:h.column.prototype.alignDataLabel,buildKDTree:v,applyZones:v},{haloPath:function(a){return l.prototype.haloPath.call(this,0===a?0:(this.marker?this.marker.radius||0:0)+a)},
ttBelow:!1});D.prototype.beforePadding=function(){var f=this,c=this.len,b=this.chart,e=0,g=c,h=this.isXAxis,l=h?"xData":"yData",p=this.min,v={},u=Math.min(b.plotWidth,b.plotHeight),D=Number.MAX_VALUE,k=-Number.MAX_VALUE,E=this.max-p,x=c/E,J=[];d(this.series,function(c){var e=c.options;!c.bubblePadding||!c.visible&&b.options.chart.ignoreHiddenSeries||(f.allowZoomOutside=!0,J.push(c),h&&(d(["minSize","maxSize"],function(a){var b=e[a],c=/%$/.test(b),b=q(b);v[a]=c?u*b/100:b}),c.minPxSize=v.minSize,c.maxPxSize=
Math.max(v.maxSize,v.minSize),c=a.grep(c.zData,a.isNumber),c.length&&(D=t(e.zMin,Math.min(D,Math.max(y(c),!1===e.displayNegative?e.zThreshold:-Number.MAX_VALUE))),k=t(e.zMax,Math.max(k,B(c))))))});d(J,function(a){var b=a[l],c=b.length,d;h&&a.getRadii(D,k,a.minPxSize,a.maxPxSize);if(0<E)for(;c--;)m(b[c])&&f.dataMin<=b[c]&&b[c]<=f.dataMax&&(d=a.radii[c],e=Math.min((b[c]-p)*x-d,e),g=Math.max((b[c]-p)*x+d,g))});J.length&&0<E&&!this.isLog&&(g-=c,x*=(c+e-g)/c,d([["min","userMin",e],["max","userMax",g]],
function(a){void 0===t(f.options[a[0]],f[a[1]])&&(f[a[0]]+=a[2]/x)}))}})(J);(function(a){var B=a.merge,y=a.Point,D=a.seriesType,p=a.seriesTypes;p.bubble&&D("mapbubble","bubble",{animationLimit:500,tooltip:{pointFormat:"{point.name}: {point.z}"}},{xyFromShape:!0,type:"mapbubble",pointArrayMap:["z"],getMapData:p.map.prototype.getMapData,getBox:p.map.prototype.getBox,setData:p.map.prototype.setData},{applyOptions:function(a,m){return a&&void 0!==a.lat&&void 0!==a.lon?y.prototype.applyOptions.call(this,
B(a,this.series.chart.fromLatLonToPoint(a)),m):p.map.prototype.pointClass.prototype.applyOptions.call(this,a,m)},isValid:function(){return"number"===typeof this.z},ttBelow:!1})})(J);(function(a){var B=a.colorPointMixin,y=a.each,D=a.merge,p=a.noop,d=a.pick,m=a.Series,v=a.seriesType,t=a.seriesTypes;v("heatmap","scatter",{animation:!1,borderWidth:0,nullColor:"#f7f7f7",dataLabels:{formatter:function(){return this.point.value},inside:!0,verticalAlign:"middle",crop:!1,overflow:!1,padding:0},marker:null,
pointRange:null,tooltip:{pointFormat:"{point.x}, {point.y}: {point.value}\x3cbr/\x3e"},states:{hover:{halo:!1,brightness:.2}}},D(a.colorSeriesMixin,{pointArrayMap:["y","value"],hasPointSpecificOptions:!0,getExtremesFromAll:!0,directTouch:!0,init:function(){var a;t.scatter.prototype.init.apply(this,arguments);a=this.options;a.pointRange=d(a.pointRange,a.colsize||1);this.yAxis.axisPointRange=a.rowsize||1},translate:function(){var a=this.options,l=this.xAxis,g=this.yAxis,f=a.pointPadding||0,h=function(a,
c,b){return Math.min(Math.max(c,a),b)};this.generatePoints();y(this.points,function(m){var c=(a.colsize||1)/2,b=(a.rowsize||1)/2,e=h(Math.round(l.len-l.translate(m.x-c,0,1,0,1)),-l.len,2*l.len),c=h(Math.round(l.len-l.translate(m.x+c,0,1,0,1)),-l.len,2*l.len),n=h(Math.round(g.translate(m.y-b,0,1,0,1)),-g.len,2*g.len),b=h(Math.round(g.translate(m.y+b,0,1,0,1)),-g.len,2*g.len),p=d(m.pointPadding,f);m.plotX=m.clientX=(e+c)/2;m.plotY=(n+b)/2;m.shapeType="rect";m.shapeArgs={x:Math.min(e,c)+p,y:Math.min(n,
b)+p,width:Math.abs(c-e)-2*p,height:Math.abs(b-n)-2*p}});this.translateColors()},drawPoints:function(){t.column.prototype.drawPoints.call(this);y(this.points,function(a){a.graphic.attr(this.colorAttribs(a))},this)},animate:p,getBox:p,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,alignDataLabel:t.column.prototype.alignDataLabel,getExtremes:function(){m.prototype.getExtremes.call(this,this.valueData);this.valueMin=this.dataMin;this.valueMax=this.dataMax;m.prototype.getExtremes.call(this)}}),a.extend({haloPath:function(a){if(!a)return[];
var d=this.shapeArgs;return["M",d.x-a,d.y-a,"L",d.x-a,d.y+d.height+a,d.x+d.width+a,d.y+d.height+a,d.x+d.width+a,d.y-a,"Z"]}},B))})(J);(function(a){function B(a,d){var g,f,h,l=!1,c=a.x,b=a.y;a=0;for(g=d.length-1;a<d.length;g=a++)f=d[a][1]>b,h=d[g][1]>b,f!==h&&c<(d[g][0]-d[a][0])*(b-d[a][1])/(d[g][1]-d[a][1])+d[a][0]&&(l=!l);return l}var y=a.Chart,D=a.each,p=a.extend,d=a.format,m=a.merge,v=a.win,t=a.wrap;y.prototype.transformFromLatLon=function(d,l){if(void 0===v.proj4)return a.error(21),{x:0,y:null};
d=v.proj4(l.crs,[d.lon,d.lat]);var g=l.cosAngle||l.rotation&&Math.cos(l.rotation),f=l.sinAngle||l.rotation&&Math.sin(l.rotation);d=l.rotation?[d[0]*g+d[1]*f,-d[0]*f+d[1]*g]:d;return{x:((d[0]-(l.xoffset||0))*(l.scale||1)+(l.xpan||0))*(l.jsonres||1)+(l.jsonmarginX||0),y:(((l.yoffset||0)-d[1])*(l.scale||1)+(l.ypan||0))*(l.jsonres||1)-(l.jsonmarginY||0)}};y.prototype.transformToLatLon=function(d,l){if(void 0===v.proj4)a.error(21);else{d={x:((d.x-(l.jsonmarginX||0))/(l.jsonres||1)-(l.xpan||0))/(l.scale||
1)+(l.xoffset||0),y:((-d.y-(l.jsonmarginY||0))/(l.jsonres||1)+(l.ypan||0))/(l.scale||1)+(l.yoffset||0)};var g=l.cosAngle||l.rotation&&Math.cos(l.rotation),f=l.sinAngle||l.rotation&&Math.sin(l.rotation);l=v.proj4(l.crs,"WGS84",l.rotation?{x:d.x*g+d.y*-f,y:d.x*f+d.y*g}:d);return{lat:l.y,lon:l.x}}};y.prototype.fromPointToLatLon=function(d){var l=this.mapTransforms,g;if(l){for(g in l)if(l.hasOwnProperty(g)&&l[g].hitZone&&B({x:d.x,y:-d.y},l[g].hitZone.coordinates[0]))return this.transformToLatLon(d,l[g]);
return this.transformToLatLon(d,l["default"])}a.error(22)};y.prototype.fromLatLonToPoint=function(d){var l=this.mapTransforms,g,f;if(!l)return a.error(22),{x:0,y:null};for(g in l)if(l.hasOwnProperty(g)&&l[g].hitZone&&(f=this.transformFromLatLon(d,l[g]),B({x:f.x,y:-f.y},l[g].hitZone.coordinates[0])))return f;return this.transformFromLatLon(d,l["default"])};a.geojson=function(a,l,g){var f=[],h=[],m=function(a){var b,c=a.length;h.push("M");for(b=0;b<c;b++)1===b&&h.push("L"),h.push(a[b][0],-a[b][1])};
l=l||"map";D(a.features,function(a){var b=a.geometry,c=b.type,b=b.coordinates;a=a.properties;var d;h=[];"map"===l||"mapbubble"===l?("Polygon"===c?(D(b,m),h.push("Z")):"MultiPolygon"===c&&(D(b,function(a){D(a,m)}),h.push("Z")),h.length&&(d={path:h})):"mapline"===l?("LineString"===c?m(b):"MultiLineString"===c&&D(b,m),h.length&&(d={path:h})):"mappoint"===l&&"Point"===c&&(d={x:b[0],y:-b[1]});d&&f.push(p(d,{name:a.name||a.NAME,properties:a}))});g&&a.copyrightShort&&(g.chart.mapCredits=d(g.chart.options.credits.mapText,
{geojson:a}),g.chart.mapCreditsFull=d(g.chart.options.credits.mapTextFull,{geojson:a}));return f};t(y.prototype,"addCredits",function(a,d){d=m(!0,this.options.credits,d);this.mapCredits&&(d.href=null);a.call(this,d);this.credits&&this.mapCreditsFull&&this.credits.attr({title:this.mapCreditsFull})})})(J);(function(a){function B(a,d,h,l,c,b,e,m){return["M",a+c,d,"L",a+h-b,d,"C",a+h-b/2,d,a+h,d+b/2,a+h,d+b,"L",a+h,d+l-e,"C",a+h,d+l-e/2,a+h-e/2,d+l,a+h-e,d+l,"L",a+m,d+l,"C",a+m/2,d+l,a,d+l-m/2,a,d+l-
m,"L",a,d+c,"C",a,d+c/2,a+c/2,d,a+c,d,"Z"]}var y=a.Chart,D=a.defaultOptions,p=a.each,d=a.extend,m=a.merge,v=a.pick,t=a.Renderer,q=a.SVGRenderer,l=a.VMLRenderer;d(D.lang,{zoomIn:"Zoom in",zoomOut:"Zoom out"});D.mapNavigation={buttonOptions:{alignTo:"plotBox",align:"left",verticalAlign:"top",x:0,width:18,height:18,padding:5,style:{fontSize:"15px",fontWeight:"bold"},theme:{"stroke-width":1,"text-align":"center"}},buttons:{zoomIn:{onclick:function(){this.mapZoom(.5)},text:"+",y:0},zoomOut:{onclick:function(){this.mapZoom(2)},
text:"-",y:28}},mouseWheelSensitivity:1.1};a.splitPath=function(a){var d;a=a.replace(/([A-Za-z])/g," $1 ");a=a.replace(/^\s*/,"").replace(/\s*$/,"");a=a.split(/[ ,]+/);for(d=0;d<a.length;d++)/[a-zA-Z]/.test(a[d])||(a[d]=parseFloat(a[d]));return a};a.maps={};q.prototype.symbols.topbutton=function(a,d,h,l,c){return B(a-1,d-1,h,l,c.r,c.r,0,0)};q.prototype.symbols.bottombutton=function(a,d,h,l,c){return B(a-1,d-1,h,l,0,0,c.r,c.r)};t===l&&p(["topbutton","bottombutton"],function(a){l.prototype.symbols[a]=
q.prototype.symbols[a]});a.Map=a.mapChart=function(d,f,h){var g="string"===typeof d||d.nodeName,c=arguments[g?1:0],b={endOnTick:!1,visible:!1,minPadding:0,maxPadding:0,startOnTick:!1},e,l=a.getOptions().credits;e=c.series;c.series=null;c=m({chart:{panning:"xy",type:"map"},credits:{mapText:v(l.mapText,' \u00a9 \x3ca href\x3d"{geojson.copyrightUrl}"\x3e{geojson.copyrightShort}\x3c/a\x3e'),mapTextFull:v(l.mapTextFull,"{geojson.copyright}")},tooltip:{followTouchMove:!1},xAxis:b,yAxis:m(b,{reversed:!0})},
c,{chart:{inverted:!1,alignTicks:!1}});c.series=e;return g?new y(d,c,h):new y(c,f)}})(J);return J});


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_geoJSON_geoJSON__ = __webpack_require__(116);
var formatMapSeries=function formatMapSeries(_ref){var regionsData=_ref.regionsData,fn=_ref.fn;var chartData=regionsData.map(function(region){var name=region.name;var code=region.code;var eventClick=function eventClick(){return fn(region);};var countryCode=__WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__["a" /* default */].getCountryCodeFromRegionCode(code);var countryName=__WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__["a" /* default */].countryCodeToFullName(countryCode);return{name:name,code:code,countryName:countryName,events:{click:eventClick}};});var series=[{type:'map',index:1,mapData:__WEBPACK_IMPORTED_MODULE_1_utils_geoJSON_geoJSON__["a" /* default */].regionLevel,data:chartData,joinBy:['NUTS_ID','code'],color:'#E9F2F4',cursor:'pointer',states:{hover:{color:'#0fa4c4'}}},{type:'mapline',index:2,mapData:__WEBPACK_IMPORTED_MODULE_1_utils_geoJSON_geoJSON__["a" /* default */].countryLevel,nullColor:'#333',showInLegend:false,includeInCSVExport:false,name:'borders',lineWidth:0.75,color:'#CCCCCC',dataLabels:{enabled:false},states:{hover:{enabled:false}}}];return series;};var mapChartAdapter={formatMapSeries:formatMapSeries};/* harmony default export */ __webpack_exports__["a"] = (mapChartAdapter);

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var regionLevel={"type":"FeatureCollection","name":"regions","crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:EPSG::3035"}},"features":[{"type":"Feature","properties":{"id":"AT11","CNTR_CODE":"AT","NUTS_NAME":"Burgenland","LEVL_CODE":2,"FID":"AT11","NUTS_ID":"AT11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4786948.0,2658725.0],[4778299.0,2654263.0],[4786359.0,2720266.0],[4794232.0,2724667.0],[4799461.0,2746013.0],[4800642.0,2776515.0],[4816326.0,2779513.0],[4846490.0,2803511.0],[4854633.0,2791782.0],[4844981.0,2758836.0],[4802913.0,2748898.0],[4821839.0,2726166.0],[4806751.0,2714375.0],[4811577.0,2680342.0],[4786948.0,2658725.0]]]}},{"type":"Feature","properties":{"id":"AT12","CNTR_CODE":"AT","NUTS_NAME":"Niederösterreich","LEVL_CODE":2,"FID":"AT12","NUTS_ID":"AT12","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4827292.0,2837438.0],[4839233.0,2808803.0],[4846490.0,2803511.0],[4816326.0,2779513.0],[4800642.0,2776515.0],[4799461.0,2746013.0],[4794232.0,2724667.0],[4786359.0,2720266.0],[4760797.0,2734594.0],[4711805.0,2756072.0],[4702487.0,2749484.0],[4676276.0,2748476.0],[4654777.0,2787028.0],[4656733.0,2801818.0],[4668364.0,2794302.0],[4688302.0,2819349.0],[4666961.0,2841108.0],[4689833.0,2885246.0],[4726984.0,2881333.0],[4742889.0,2876363.0],[4832035.0,2857837.0],[4833566.0,2848881.0],[4827292.0,2837438.0]],[[4780682.0,2803584.0],[4788814.0,2798999.0],[4810026.0,2802881.0],[4797247.0,2818046.0],[4780682.0,2803584.0]]]}},{"type":"Feature","properties":{"id":"AT13","CNTR_CODE":"AT","NUTS_NAME":"Wien","LEVL_CODE":2,"FID":"AT13","NUTS_ID":"AT13","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4810026.0,2802881.0],[4788814.0,2798999.0],[4780682.0,2803584.0],[4797247.0,2818046.0],[4810026.0,2802881.0]]]}},{"type":"Feature","properties":{"id":"AT21","CNTR_CODE":"AT","NUTS_NAME":"Kärnten","LEVL_CODE":2,"FID":"AT21","NUTS_ID":"AT21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4609292.0,2655196.0],[4621593.0,2655568.0],[4688943.0,2671473.0],[4708765.0,2628649.0],[4680270.0,2604354.0],[4672387.0,2595157.0],[4661893.0,2602364.0],[4606152.0,2608175.0],[4589829.0,2612229.0],[4530306.0,2617286.0],[4527096.0,2619690.0],[4536664.0,2638260.0],[4522751.0,2668743.0],[4575783.0,2670627.0],[4609292.0,2655196.0]]]}},{"type":"Feature","properties":{"id":"AT22","CNTR_CODE":"AT","NUTS_NAME":"Steiermark","LEVL_CODE":2,"FID":"AT22","NUTS_ID":"AT22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4711805.0,2756072.0],[4760797.0,2734594.0],[4786359.0,2720266.0],[4778299.0,2654263.0],[4763403.0,2638818.0],[4753009.0,2637824.0],[4734492.0,2630626.0],[4708765.0,2628649.0],[4688943.0,2671473.0],[4621593.0,2655568.0],[4609292.0,2655196.0],[4613599.0,2689645.0],[4593952.0,2692169.0],[4591351.0,2713257.0],[4622044.0,2740040.0],[4642340.0,2731638.0],[4676276.0,2748476.0],[4702487.0,2749484.0],[4711805.0,2756072.0]]]}},{"type":"Feature","properties":{"id":"AT31","CNTR_CODE":"AT","NUTS_NAME":"Oberösterreich","LEVL_CODE":2,"FID":"AT31","NUTS_ID":"AT31","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4666961.0,2841108.0],[4688302.0,2819349.0],[4668364.0,2794302.0],[4656733.0,2801818.0],[4654777.0,2787028.0],[4676276.0,2748476.0],[4642340.0,2731638.0],[4622044.0,2740040.0],[4591351.0,2713257.0],[4586019.0,2715536.0],[4582323.0,2741015.0],[4567548.0,2771539.0],[4534509.0,2768916.0],[4525936.0,2781512.0],[4539907.0,2792493.0],[4556759.0,2802949.0],[4576130.0,2833244.0],[4576657.0,2832784.0],[4577521.0,2832997.0],[4577590.0,2833819.0],[4578257.0,2833744.0],[4578695.0,2834034.0],[4578832.0,2834530.0],[4579578.0,2834989.0],[4579715.0,2835385.0],[4579445.0,2836171.0],[4579671.0,2836836.0],[4579900.0,2836890.0],[4596342.0,2829134.0],[4600313.0,2851667.0],[4603174.0,2858273.0],[4666961.0,2841108.0]]]}},{"type":"Feature","properties":{"id":"AT32","CNTR_CODE":"AT","NUTS_NAME":"Salzburg","LEVL_CODE":2,"FID":"AT32","NUTS_ID":"AT32","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4586019.0,2715536.0],[4591351.0,2713257.0],[4593952.0,2692169.0],[4613599.0,2689645.0],[4609292.0,2655196.0],[4575783.0,2670627.0],[4522751.0,2668743.0],[4491314.0,2664310.0],[4483321.0,2665352.0],[4483745.0,2684365.0],[4518573.0,2708707.0],[4514604.0,2727669.0],[4523483.0,2733535.0],[4550493.0,2716599.0],[4542425.0,2755743.0],[4535816.0,2765182.0],[4534509.0,2768916.0],[4567548.0,2771539.0],[4582323.0,2741015.0],[4586019.0,2715536.0]]]}},{"type":"Feature","properties":{"id":"AT33","CNTR_CODE":"AT","NUTS_NAME":"Tirol","LEVL_CODE":2,"FID":"AT33","NUTS_ID":"AT33","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4483321.0,2665352.0],[4462343.0,2656248.0],[4444822.0,2656889.0],[4409680.0,2650942.0],[4395997.0,2633155.0],[4356849.0,2638051.0],[4332067.0,2637516.0],[4337149.0,2671547.0],[4334507.0,2684075.0],[4352657.0,2697260.0],[4355225.0,2715903.0],[4387766.0,2714092.0],[4395879.0,2698560.0],[4397790.0,2698612.0],[4428275.0,2704501.0],[4427326.0,2710092.0],[4443880.0,2721226.0],[4460729.0,2722685.0],[4475985.0,2724950.0],[4496572.0,2734271.0],[4514604.0,2727669.0],[4518573.0,2708707.0],[4483745.0,2684365.0],[4483321.0,2665352.0]]],[[[4527096.0,2619690.0],[4510729.0,2621661.0],[4489657.0,2645101.0],[4491314.0,2664310.0],[4522751.0,2668743.0],[4536664.0,2638260.0],[4527096.0,2619690.0]]]]}},{"type":"Feature","properties":{"id":"AT34","CNTR_CODE":"AT","NUTS_NAME":"Vorarlberg","LEVL_CODE":2,"FID":"AT34","NUTS_ID":"AT34","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4337149.0,2671547.0],[4332067.0,2637516.0],[4291125.0,2660883.0],[4292202.0,2670972.0],[4285464.0,2684223.0],[4287757.0,2714352.0],[4318575.0,2714737.0],[4320964.0,2707712.0],[4334507.0,2684075.0],[4337149.0,2671547.0]]]}},{"type":"Feature","properties":{"id":"ITH4","CNTR_CODE":"IT","NUTS_NAME":"Friuli-Venezia Giulia","LEVL_CODE":2,"FID":"ITH4","NUTS_ID":"ITH4","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4591854.0,2555074.0],[4600801.0,2529735.0],[4600791.0,2528447.0],[4615787.0,2521948.0],[4625607.0,2510559.0],[4620628.0,2504938.0],[4611707.0,2505313.0],[4599618.0,2526058.0],[4589954.0,2516386.0],[4582187.0,2519521.0],[4562838.0,2508582.0],[4552694.0,2529223.0],[4528181.0,2523672.0],[4507006.0,2550672.0],[4513282.0,2592009.0],[4530306.0,2617286.0],[4589829.0,2612229.0],[4606152.0,2608175.0],[4604291.0,2598605.0],[4591449.0,2588075.0],[4591854.0,2555074.0]]]}},{"type":"Feature","properties":{"id":"ITH5","CNTR_CODE":"IT","NUTS_NAME":"Emilia-Romagna","LEVL_CODE":2,"FID":"ITH5","NUTS_ID":"ITH5","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4360890.0,2423561.0],[4391236.0,2422939.0],[4419512.0,2427466.0],[4433784.0,2427572.0],[4467738.0,2430950.0],[4511152.0,2412080.0],[4501438.0,2393730.0],[4511885.0,2349087.0],[4517387.0,2342327.0],[4542187.0,2321830.0],[4521700.0,2314146.0],[4519615.0,2321416.0],[4518296.0,2312960.0],[4505311.0,2297879.0],[4491117.0,2296227.0],[4470759.0,2302504.0],[4458761.0,2309117.0],[4458634.0,2336295.0],[4443245.0,2339855.0],[4417490.0,2333074.0],[4405229.0,2331726.0],[4386367.0,2334368.0],[4371064.0,2334684.0],[4358646.0,2346312.0],[4341313.0,2350944.0],[4332349.0,2360377.0],[4314178.0,2371447.0],[4295977.0,2361757.0],[4279421.0,2366653.0],[4280667.0,2382905.0],[4257616.0,2389496.0],[4257466.0,2397553.0],[4285438.0,2446857.0],[4312419.0,2446562.0],[4327590.0,2436913.0],[4357692.0,2425177.0],[4360890.0,2423561.0]]]}},{"type":"Feature","properties":{"id":"ITI1","CNTR_CODE":"IT","NUTS_NAME":"Toscana","LEVL_CODE":2,"FID":"ITI1","NUTS_ID":"ITI1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4386367.0,2334368.0],[4405229.0,2331726.0],[4417490.0,2333074.0],[4443245.0,2339855.0],[4458634.0,2336295.0],[4458761.0,2309117.0],[4470759.0,2302504.0],[4491117.0,2296227.0],[4505311.0,2297879.0],[4500143.0,2280639.0],[4480917.0,2230893.0],[4479434.0,2197881.0],[4476384.0,2193961.0],[4464291.0,2188250.0],[4440807.0,2142554.0],[4378765.0,2204150.0],[4345279.0,2274843.0],[4341817.0,2300678.0],[4332539.0,2318420.0],[4322508.0,2326071.0],[4295977.0,2361757.0],[4314178.0,2371447.0],[4332349.0,2360377.0],[4341313.0,2350944.0],[4358646.0,2346312.0],[4371064.0,2334684.0],[4386367.0,2334368.0]]]}},{"type":"Feature","properties":{"id":"ITI2","CNTR_CODE":"IT","NUTS_NAME":"Umbria","LEVL_CODE":2,"FID":"ITI2","NUTS_ID":"ITI2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4522908.0,2147016.0],[4476384.0,2193961.0],[4479434.0,2197881.0],[4480917.0,2230893.0],[4500143.0,2280639.0],[4545500.0,2265401.0],[4554181.0,2238160.0],[4562209.0,2212746.0],[4586077.0,2201360.0],[4582894.0,2186358.0],[4559325.0,2172420.0],[4535792.0,2149113.0],[4522908.0,2147016.0]]]}},{"type":"Feature","properties":{"id":"BG31","CNTR_CODE":"BG","NUTS_NAME":"Северозападен","LEVL_CODE":2,"FID":"BG31","NUTS_ID":"BG31","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5355670.0,2421937.0],[5363359.0,2390534.0],[5375820.0,2393237.0],[5413836.0,2397732.0],[5453726.0,2394931.0],[5470511.0,2397911.0],[5496186.0,2405891.0],[5548283.0,2408759.0],[5544106.0,2363806.0],[5540881.0,2353047.0],[5531725.0,2349584.0],[5530123.0,2329112.0],[5544811.0,2305139.0],[5545453.0,2301620.0],[5494265.0,2295306.0],[5454917.0,2323066.0],[5408315.0,2325540.0],[5388590.0,2316452.0],[5375158.0,2323275.0],[5351004.0,2340907.0],[5344289.0,2341573.0],[5317493.0,2376327.0],[5322636.0,2410289.0],[5330612.0,2430822.0],[5355670.0,2421937.0]]]}},{"type":"Feature","properties":{"id":"BG32","CNTR_CODE":"BG","NUTS_NAME":"Северен централен","LEVL_CODE":2,"FID":"BG32","NUTS_ID":"BG32","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5728800.0,2487226.0],[5699432.0,2443299.0],[5681595.0,2442812.0],[5666929.0,2406717.0],[5654635.0,2396567.0],[5621755.0,2408808.0],[5611593.0,2383980.0],[5632656.0,2346890.0],[5610151.0,2322114.0],[5592132.0,2319358.0],[5544811.0,2305139.0],[5530123.0,2329112.0],[5531725.0,2349584.0],[5540881.0,2353047.0],[5544106.0,2363806.0],[5548283.0,2408759.0],[5568141.0,2411495.0],[5577229.0,2418572.0],[5623303.0,2468347.0],[5625118.0,2468918.0],[5692417.0,2494414.0],[5728800.0,2487226.0]]]}},{"type":"Feature","properties":{"id":"BG33","CNTR_CODE":"BG","NUTS_NAME":"Североизточен","LEVL_CODE":2,"FID":"BG33","NUTS_ID":"BG33","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5803878.0,2477397.0],[5805366.0,2442801.0],[5773956.0,2421445.0],[5771739.0,2366169.0],[5706379.0,2363775.0],[5667040.0,2350901.0],[5664570.0,2357814.0],[5632656.0,2346890.0],[5611593.0,2383980.0],[5621755.0,2408808.0],[5654635.0,2396567.0],[5666929.0,2406717.0],[5681595.0,2442812.0],[5699432.0,2443299.0],[5728800.0,2487226.0],[5803878.0,2477397.0]]]}},{"type":"Feature","properties":{"id":"BG34","CNTR_CODE":"BG","NUTS_NAME":"Югоизточен","LEVL_CODE":2,"FID":"BG34","NUTS_ID":"BG34","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5664570.0,2357814.0],[5667040.0,2350901.0],[5706379.0,2363775.0],[5771739.0,2366169.0],[5769660.0,2314718.0],[5794317.0,2287897.0],[5804913.0,2276443.0],[5723795.0,2269103.0],[5716920.0,2257473.0],[5687247.0,2242311.0],[5651157.0,2266351.0],[5634702.0,2248213.0],[5584627.0,2240553.0],[5566140.0,2269261.0],[5545453.0,2301620.0],[5544811.0,2305139.0],[5592132.0,2319358.0],[5610151.0,2322114.0],[5632656.0,2346890.0],[5664570.0,2357814.0]]]}},{"type":"Feature","properties":{"id":"BG41","CNTR_CODE":"BG","NUTS_NAME":"Югозападен","LEVL_CODE":2,"FID":"BG41","NUTS_ID":"BG41","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5375158.0,2323275.0],[5388590.0,2316452.0],[5408315.0,2325540.0],[5454917.0,2323066.0],[5494265.0,2295306.0],[5500978.0,2274348.0],[5479155.0,2268944.0],[5468092.0,2249950.0],[5455584.0,2223713.0],[5467047.0,2191028.0],[5489883.0,2172765.0],[5491534.0,2156084.0],[5458423.0,2133421.0],[5444429.0,2133892.0],[5401576.0,2119112.0],[5401768.0,2139537.0],[5394496.0,2162270.0],[5384665.0,2193093.0],[5364848.0,2199118.0],[5353217.0,2202689.0],[5338320.0,2217739.0],[5340815.0,2256089.0],[5336281.0,2275236.0],[5341408.0,2280945.0],[5359818.0,2286469.0],[5375158.0,2323275.0]]]}},{"type":"Feature","properties":{"id":"BG42","CNTR_CODE":"BG","NUTS_NAME":"Южен централен","LEVL_CODE":2,"FID":"BG42","NUTS_ID":"BG42","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5584627.0,2240553.0],[5634702.0,2248213.0],[5651157.0,2266351.0],[5687247.0,2242311.0],[5675519.0,2215229.0],[5650630.0,2165420.0],[5647445.0,2163287.0],[5592371.0,2146860.0],[5587713.0,2151062.0],[5554204.0,2149957.0],[5526579.0,2165243.0],[5491534.0,2156084.0],[5489883.0,2172765.0],[5467047.0,2191028.0],[5455584.0,2223713.0],[5468092.0,2249950.0],[5479155.0,2268944.0],[5500978.0,2274348.0],[5494265.0,2295306.0],[5545453.0,2301620.0],[5566140.0,2269261.0],[5584627.0,2240553.0]]]}},{"type":"Feature","properties":{"id":"CZ01","CNTR_CODE":"CZ","NUTS_NAME":"Praha","LEVL_CODE":2,"FID":"CZ01","NUTS_ID":"CZ01","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4625398.0,3001301.0],[4638591.0,3020331.0],[4653916.0,3013086.0],[4652498.0,2999442.0],[4633809.0,2986063.0],[4625398.0,3001301.0]]]}},{"type":"Feature","properties":{"id":"CZ02","CNTR_CODE":"CZ","NUTS_NAME":"Střední Čechy","LEVL_CODE":2,"FID":"CZ02","NUTS_ID":"CZ02","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4709592.0,3014139.0],[4715870.0,2986863.0],[4677658.0,2949338.0],[4658943.0,2945821.0],[4593603.0,2940446.0],[4591561.0,2983813.0],[4564741.0,3003138.0],[4639069.0,3053425.0],[4652255.0,3052062.0],[4685658.0,3058492.0],[4709592.0,3014139.0]],[[4625398.0,3001301.0],[4633809.0,2986063.0],[4652498.0,2999442.0],[4653916.0,3013086.0],[4638591.0,3020331.0],[4625398.0,3001301.0]]]}},{"type":"Feature","properties":{"id":"CZ03","CNTR_CODE":"CZ","NUTS_NAME":"Jihozápad","LEVL_CODE":2,"FID":"CZ03","NUTS_ID":"CZ03","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4593603.0,2940446.0],[4658943.0,2945821.0],[4677658.0,2949338.0],[4688972.0,2919507.0],[4729896.0,2885955.0],[4726984.0,2881333.0],[4689833.0,2885246.0],[4666961.0,2841108.0],[4603174.0,2858273.0],[4581003.0,2879001.0],[4571072.0,2879895.0],[4552189.0,2900592.0],[4511864.0,2932679.0],[4508712.0,2939911.0],[4494031.0,2963467.0],[4504236.0,2980139.0],[4557137.0,3003907.0],[4564741.0,3003138.0],[4591561.0,2983813.0],[4593603.0,2940446.0]]]}},{"type":"Feature","properties":{"id":"CZ04","CNTR_CODE":"CZ","NUTS_NAME":"Severozápad","LEVL_CODE":2,"FID":"CZ04","NUTS_ID":"CZ04","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4639069.0,3053425.0],[4564741.0,3003138.0],[4557137.0,3003907.0],[4504236.0,2980139.0],[4482882.0,2996473.0],[4475192.0,3014234.0],[4470617.0,3025026.0],[4504645.0,3036025.0],[4530540.0,3036694.0],[4568655.0,3063911.0],[4578744.0,3075178.0],[4613161.0,3090520.0],[4623550.0,3113763.0],[4635755.0,3113255.0],[4645979.0,3093185.0],[4629530.0,3066449.0],[4639069.0,3053425.0]]]}},{"type":"Feature","properties":{"id":"CZ05","CNTR_CODE":"CZ","NUTS_NAME":"Severovýchod","LEVL_CODE":2,"FID":"CZ05","NUTS_ID":"CZ05","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4790699.0,3024479.0],[4810262.0,3032463.0],[4812157.0,2965656.0],[4782782.0,2960975.0],[4715870.0,2986863.0],[4709592.0,3014139.0],[4685658.0,3058492.0],[4652255.0,3052062.0],[4639069.0,3053425.0],[4629530.0,3066449.0],[4645979.0,3093185.0],[4660256.0,3095529.0],[4684723.0,3106895.0],[4710987.0,3088956.0],[4752268.0,3079151.0],[4768791.0,3072784.0],[4790699.0,3024479.0]]]}},{"type":"Feature","properties":{"id":"CZ06","CNTR_CODE":"CZ","NUTS_NAME":"Jihovýchod","LEVL_CODE":2,"FID":"CZ06","NUTS_ID":"CZ06","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4715870.0,2986863.0],[4782782.0,2960975.0],[4812157.0,2965656.0],[4841158.0,2932184.0],[4851728.0,2908993.0],[4881191.0,2889220.0],[4863381.0,2882817.0],[4832035.0,2857837.0],[4742889.0,2876363.0],[4726984.0,2881333.0],[4729896.0,2885955.0],[4688972.0,2919507.0],[4677658.0,2949338.0],[4715870.0,2986863.0]]]}},{"type":"Feature","properties":{"id":"CZ07","CNTR_CODE":"CZ","NUTS_NAME":"Střední Morava","LEVL_CODE":2,"FID":"CZ07","NUTS_ID":"CZ07","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4892859.0,2966952.0],[4929608.0,2955256.0],[4924769.0,2945551.0],[4881191.0,2889220.0],[4851728.0,2908993.0],[4841158.0,2932184.0],[4812157.0,2965656.0],[4810262.0,3032463.0],[4810829.0,3060614.0],[4849854.0,3042645.0],[4835136.0,3007507.0],[4840672.0,2996545.0],[4856278.0,3000460.0],[4892859.0,2966952.0]]]}},{"type":"Feature","properties":{"id":"CZ08","CNTR_CODE":"CZ","NUTS_NAME":"Moravskoslezsko","LEVL_CODE":2,"FID":"CZ08","NUTS_ID":"CZ08","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4895030.0,3026304.0],[4935450.0,3013500.0],[4960290.0,2972378.0],[4929608.0,2955256.0],[4892859.0,2966952.0],[4856278.0,3000460.0],[4840672.0,2996545.0],[4835136.0,3007507.0],[4849854.0,3042645.0],[4895030.0,3026304.0]]]}},{"type":"Feature","properties":{"id":"PL21","CNTR_CODE":"PL","NUTS_NAME":"Małopolskie","LEVL_CODE":2,"FID":"PL21","NUTS_ID":"PL21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5080508.0,3065873.0],[5115170.0,3087891.0],[5116883.0,3052783.0],[5130016.0,3032463.0],[5127204.0,3024501.0],[5144084.0,2988537.0],[5088278.0,2978299.0],[5056055.0,2957983.0],[5038951.0,2947340.0],[5003134.0,2988592.0],[4997115.0,3005944.0],[4971688.0,3023075.0],[4980654.0,3044128.0],[5018055.0,3082735.0],[5024413.0,3091536.0],[5038661.0,3084937.0],[5080508.0,3065873.0]]]}},{"type":"Feature","properties":{"id":"PL22","CNTR_CODE":"PL","NUTS_NAME":"Śląskie","LEVL_CODE":2,"FID":"PL22","NUTS_ID":"PL22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5003134.0,2988592.0],[4981147.0,2964054.0],[4960290.0,2972378.0],[4935450.0,3013500.0],[4895030.0,3026304.0],[4895475.0,3038547.0],[4920501.0,3049703.0],[4929465.0,3084498.0],[4922058.0,3092264.0],[4926117.0,3118143.0],[4927441.0,3141102.0],[4967353.0,3143774.0],[5004869.0,3129486.0],[5004494.0,3114060.0],[5012799.0,3112171.0],[5019716.0,3104639.0],[5024413.0,3091536.0],[5018055.0,3082735.0],[4980654.0,3044128.0],[4971688.0,3023075.0],[4997115.0,3005944.0],[5003134.0,2988592.0]]]}},{"type":"Feature","properties":{"id":"PL41","CNTR_CODE":"PL","NUTS_NAME":"Wielkopolskie","LEVL_CODE":2,"FID":"PL41","NUTS_ID":"PL41","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4903249.0,3227301.0],[4890580.0,3149792.0],[4875773.0,3141021.0],[4864736.0,3149378.0],[4836542.0,3194872.0],[4822426.0,3195225.0],[4793618.0,3184530.0],[4763100.0,3205526.0],[4733641.0,3225823.0],[4721763.0,3258512.0],[4722012.0,3310414.0],[4720427.0,3342288.0],[4763556.0,3369922.0],[4757741.0,3392578.0],[4775949.0,3415917.0],[4810612.0,3400891.0],[4816363.0,3376465.0],[4823852.0,3318029.0],[4887969.0,3302501.0],[4935891.0,3285312.0],[4924698.0,3253777.0],[4917573.0,3230021.0],[4903249.0,3227301.0]]]}},{"type":"Feature","properties":{"id":"PL42","CNTR_CODE":"PL","NUTS_NAME":"Zachodniopomorskie","LEVL_CODE":2,"FID":"PL42","NUTS_ID":"PL42","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4720427.0,3342288.0],[4629911.0,3289188.0],[4620842.0,3294804.0],[4600578.0,3317655.0],[4599282.0,3324914.0],[4614776.0,3366892.0],[4602721.0,3407226.0],[4672679.0,3463344.0],[4753691.0,3515985.0],[4765920.0,3451845.0],[4779151.0,3444087.0],[4777367.0,3428307.0],[4775949.0,3415917.0],[4757741.0,3392578.0],[4763556.0,3369922.0],[4720427.0,3342288.0]]]}},{"type":"Feature","properties":{"id":"PL43","CNTR_CODE":"PL","NUTS_NAME":"Lubuskie","LEVL_CODE":2,"FID":"PL43","NUTS_ID":"PL43","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4717167.0,3171818.0],[4667129.0,3151023.0],[4648591.0,3174086.0],[4644665.0,3220610.0],[4646803.0,3228427.0],[4634822.0,3250189.0],[4629436.0,3263564.0],[4629911.0,3289188.0],[4720427.0,3342288.0],[4722012.0,3310414.0],[4721763.0,3258512.0],[4733641.0,3225823.0],[4763100.0,3205526.0],[4732678.0,3198659.0],[4717167.0,3171818.0]]]}},{"type":"Feature","properties":{"id":"PL51","CNTR_CODE":"PL","NUTS_NAME":"Dolnośląskie","LEVL_CODE":2,"FID":"PL51","NUTS_ID":"PL51","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4763100.0,3205526.0],[4793618.0,3184530.0],[4822426.0,3195225.0],[4836542.0,3194872.0],[4864736.0,3149378.0],[4827218.0,3080536.0],[4810829.0,3060614.0],[4810262.0,3032463.0],[4790699.0,3024479.0],[4768791.0,3072784.0],[4752268.0,3079151.0],[4710987.0,3088956.0],[4684723.0,3106895.0],[4660256.0,3095529.0],[4667129.0,3151023.0],[4717167.0,3171818.0],[4732678.0,3198659.0],[4763100.0,3205526.0]]]}},{"type":"Feature","properties":{"id":"PL52","CNTR_CODE":"PL","NUTS_NAME":"Opolskie","LEVL_CODE":2,"FID":"PL52","NUTS_ID":"PL52","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4864736.0,3149378.0],[4875773.0,3141021.0],[4890580.0,3149792.0],[4927441.0,3141102.0],[4926117.0,3118143.0],[4922058.0,3092264.0],[4929465.0,3084498.0],[4920501.0,3049703.0],[4895475.0,3038547.0],[4895030.0,3026304.0],[4849854.0,3042645.0],[4810829.0,3060614.0],[4827218.0,3080536.0],[4864736.0,3149378.0]]]}},{"type":"Feature","properties":{"id":"PL61","CNTR_CODE":"PL","NUTS_NAME":"Kujawsko-pomorskie","LEVL_CODE":2,"FID":"PL61","NUTS_ID":"PL61","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4951388.0,3294006.0],[4935891.0,3285312.0],[4887969.0,3302501.0],[4823852.0,3318029.0],[4816363.0,3376465.0],[4810612.0,3400891.0],[4851908.0,3437818.0],[4899411.0,3423607.0],[4923775.0,3424768.0],[4965341.0,3392752.0],[4971833.0,3382022.0],[4969569.0,3360491.0],[4953943.0,3355720.0],[4951388.0,3294006.0]]]}},{"type":"Feature","properties":{"id":"PL62","CNTR_CODE":"PL","NUTS_NAME":"Warmińsko-mazurskie","LEVL_CODE":2,"FID":"PL62","NUTS_ID":"PL62","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4988318.0,3525041.0],[5069608.0,3528478.0],[5147704.0,3546424.0],[5139652.0,3524619.0],[5152804.0,3484976.0],[5147235.0,3478588.0],[5121212.0,3449087.0],[5088238.0,3436418.0],[5084279.0,3435473.0],[5030366.0,3403591.0],[5013803.0,3394924.0],[4996079.0,3389423.0],[4971833.0,3382022.0],[4965341.0,3392752.0],[4923775.0,3424768.0],[4932427.0,3445777.0],[4939031.0,3461990.0],[4922008.0,3483837.0],[4922207.0,3502101.0],[4954962.0,3524884.0],[4976731.0,3524959.0],[4988318.0,3525041.0]]]}},{"type":"Feature","properties":{"id":"PL63","CNTR_CODE":"PL","NUTS_NAME":"Pomorskie","LEVL_CODE":2,"FID":"PL63","NUTS_ID":"PL63","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4871927.0,3530225.0],[4901277.0,3508415.0],[4944136.0,3525194.0],[4944638.0,3524518.0],[4925941.0,3510877.0],[4922207.0,3502101.0],[4922008.0,3483837.0],[4939031.0,3461990.0],[4932427.0,3445777.0],[4923775.0,3424768.0],[4899411.0,3423607.0],[4851908.0,3437818.0],[4810612.0,3400891.0],[4775949.0,3415917.0],[4777367.0,3428307.0],[4779151.0,3444087.0],[4765920.0,3451845.0],[4753691.0,3515985.0],[4813353.0,3545895.0],[4852860.0,3552931.0],[4871927.0,3530225.0]]]}},{"type":"Feature","properties":{"id":"PL71","CNTR_CODE":"PL","NUTS_NAME":"Łódzkie","LEVL_CODE":2,"FID":"PL71","NUTS_ID":"PL71","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5023357.0,3145975.0],[5004869.0,3129486.0],[4967353.0,3143774.0],[4927441.0,3141102.0],[4890580.0,3149792.0],[4903249.0,3227301.0],[4917573.0,3230021.0],[4924698.0,3253777.0],[4935891.0,3285312.0],[4951388.0,3294006.0],[4996398.0,3289545.0],[5012255.0,3274781.0],[5043406.0,3246137.0],[5037099.0,3221211.0],[5040303.0,3218295.0],[5045154.0,3188348.0],[5026059.0,3167410.0],[5023357.0,3145975.0]]]}},{"type":"Feature","properties":{"id":"PL72","CNTR_CODE":"PL","NUTS_NAME":"Świętokrzyskie","LEVL_CODE":2,"FID":"PL72","NUTS_ID":"PL72","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5045154.0,3188348.0],[5132345.0,3170532.0],[5144127.0,3173424.0],[5153177.0,3144481.0],[5145312.0,3123363.0],[5115170.0,3087891.0],[5080508.0,3065873.0],[5038661.0,3084937.0],[5024413.0,3091536.0],[5019716.0,3104639.0],[5012799.0,3112171.0],[5004494.0,3114060.0],[5004869.0,3129486.0],[5023357.0,3145975.0],[5026059.0,3167410.0],[5045154.0,3188348.0]]]}},{"type":"Feature","properties":{"id":"PL81","CNTR_CODE":"PL","NUTS_NAME":"Lubelskie","LEVL_CODE":2,"FID":"PL81","NUTS_ID":"PL81","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5280979.0,3104580.0],[5251080.0,3113193.0],[5216331.0,3098696.0],[5202774.0,3128036.0],[5182921.0,3129590.0],[5170647.0,3145624.0],[5153177.0,3144481.0],[5144127.0,3173424.0],[5134381.0,3220875.0],[5121589.0,3231369.0],[5140030.0,3276625.0],[5182547.0,3286989.0],[5211234.0,3322626.0],[5214671.0,3322723.0],[5250672.0,3303594.0],[5251593.0,3262451.0],[5260076.0,3243410.0],[5271129.0,3219181.0],[5311677.0,3151425.0],[5280979.0,3104580.0]]]}},{"type":"Feature","properties":{"id":"PL82","CNTR_CODE":"PL","NUTS_NAME":"Podkarpackie","LEVL_CODE":2,"FID":"PL82","NUTS_ID":"PL82","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5202774.0,3128036.0],[5216331.0,3098696.0],[5251080.0,3113193.0],[5280979.0,3104580.0],[5233493.0,3019106.0],[5242088.0,2978646.0],[5234033.0,2964367.0],[5144084.0,2988537.0],[5127204.0,3024501.0],[5130016.0,3032463.0],[5116883.0,3052783.0],[5115170.0,3087891.0],[5145312.0,3123363.0],[5153177.0,3144481.0],[5170647.0,3145624.0],[5182921.0,3129590.0],[5202774.0,3128036.0]]]}},{"type":"Feature","properties":{"id":"PL84","CNTR_CODE":"PL","NUTS_NAME":"Podlaskie","LEVL_CODE":2,"FID":"PL84","NUTS_ID":"PL84","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5214671.0,3322723.0],[5211234.0,3322626.0],[5156875.0,3349414.0],[5150187.0,3371506.0],[5093940.0,3411834.0],[5088238.0,3436418.0],[5121212.0,3449087.0],[5147235.0,3478588.0],[5152804.0,3484976.0],[5139652.0,3524619.0],[5147704.0,3546424.0],[5183760.0,3540552.0],[5202339.0,3510354.0],[5212597.0,3482700.0],[5236430.0,3437175.0],[5250768.0,3400148.0],[5251371.0,3377815.0],[5214671.0,3322723.0]]]}},{"type":"Feature","properties":{"id":"PL91","CNTR_CODE":"PL","NUTS_NAME":"Warszawski stołeczny","LEVL_CODE":2,"FID":"PL91","NUTS_ID":"PL91","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5093947.0,3256241.0],[5091029.0,3258588.0],[5045085.0,3262926.0],[5026665.0,3303333.0],[5059087.0,3327806.0],[5071982.0,3329178.0],[5103754.0,3334155.0],[5133026.0,3286597.0],[5093947.0,3256241.0]]]}},{"type":"Feature","properties":{"id":"PL92","CNTR_CODE":"PL","NUTS_NAME":"Mazowiecki regionalny","LEVL_CODE":2,"FID":"PL92","NUTS_ID":"PL92","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5156875.0,3349414.0],[5211234.0,3322626.0],[5182547.0,3286989.0],[5140030.0,3276625.0],[5121589.0,3231369.0],[5134381.0,3220875.0],[5144127.0,3173424.0],[5132345.0,3170532.0],[5045154.0,3188348.0],[5040303.0,3218295.0],[5037099.0,3221211.0],[5043406.0,3246137.0],[5012255.0,3274781.0],[4996398.0,3289545.0],[4951388.0,3294006.0],[4953943.0,3355720.0],[4969569.0,3360491.0],[4971833.0,3382022.0],[4996079.0,3389423.0],[5013803.0,3394924.0],[5030366.0,3403591.0],[5084279.0,3435473.0],[5088238.0,3436418.0],[5093940.0,3411834.0],[5150187.0,3371506.0],[5156875.0,3349414.0]],[[5091029.0,3258588.0],[5093947.0,3256241.0],[5133026.0,3286597.0],[5103754.0,3334155.0],[5071982.0,3329178.0],[5059087.0,3327806.0],[5026665.0,3303333.0],[5045085.0,3262926.0],[5091029.0,3258588.0]]]}},{"type":"Feature","properties":{"id":"PT11","CNTR_CODE":"PT","NUTS_NAME":"Norte","LEVL_CODE":2,"FID":"PT11","NUTS_ID":"PT11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2828169.0,2298249.0],[2822605.0,2261163.0],[2831796.0,2259162.0],[2901985.0,2249097.0],[2921463.0,2255029.0],[2947977.0,2240662.0],[2968509.0,2201289.0],[2947305.0,2172125.0],[2928115.0,2166295.0],[2904458.0,2151678.0],[2872386.0,2155168.0],[2856393.0,2138163.0],[2823459.0,2169709.0],[2808485.0,2169663.0],[2787937.0,2149091.0],[2761837.0,2178697.0],[2764565.0,2236104.0],[2765263.0,2251929.0],[2767741.0,2281168.0],[2828169.0,2298249.0]]]}},{"type":"Feature","properties":{"id":"PT15","CNTR_CODE":"PT","NUTS_NAME":"Algarve","LEVL_CODE":2,"FID":"PT15","NUTS_ID":"PT15","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2777974.0,1743032.0],[2716790.0,1743704.0],[2650903.0,1770069.0],[2663467.0,1801242.0],[2699182.0,1790554.0],[2723038.0,1772994.0],[2776212.0,1783298.0],[2777974.0,1743032.0]]]}},{"type":"Feature","properties":{"id":"PT16","CNTR_CODE":"PT","NUTS_NAME":"Centro (PT)","LEVL_CODE":2,"FID":"PT16","NUTS_ID":"PT16","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2904458.0,2151678.0],[2903687.0,2094914.0],[2892687.0,2068077.0],[2885230.0,2068271.0],[2868562.0,2012859.0],[2822317.0,2015260.0],[2795765.0,2007305.0],[2784157.0,2008590.0],[2769105.0,1985892.0],[2759414.0,1981476.0],[2716102.0,2019950.0],[2703825.0,2021964.0],[2690472.0,1974159.0],[2650546.0,1988702.0],[2699298.0,2054639.0],[2718975.0,2084387.0],[2740606.0,2132542.0],[2761837.0,2178697.0],[2787937.0,2149091.0],[2808485.0,2169663.0],[2823459.0,2169709.0],[2856393.0,2138163.0],[2872386.0,2155168.0],[2904458.0,2151678.0]]]}},{"type":"Feature","properties":{"id":"PT17","CNTR_CODE":"PT","NUTS_NAME":"Área Metropolitana de Lisboa","LEVL_CODE":2,"FID":"PT17","NUTS_ID":"PT17","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2690472.0,1974159.0],[2690120.0,1949086.0],[2716593.0,1938482.0],[2703603.0,1917326.0],[2694644.0,1915722.0],[2656160.0,1919938.0],[2640741.0,1957902.0],[2650546.0,1988702.0],[2690472.0,1974159.0]]]}},{"type":"Feature","properties":{"id":"PT18","CNTR_CODE":"PT","NUTS_NAME":"Alentejo","LEVL_CODE":2,"FID":"PT18","NUTS_ID":"PT18","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2839691.0,1967475.0],[2851525.0,1934572.0],[2830219.0,1909755.0],[2817368.0,1878991.0],[2825811.0,1846891.0],[2841368.0,1845643.0],[2785764.0,1800102.0],[2776212.0,1783298.0],[2723038.0,1772994.0],[2699182.0,1790554.0],[2663467.0,1801242.0],[2669850.0,1828254.0],[2694644.0,1915722.0],[2703603.0,1917326.0],[2716593.0,1938482.0],[2690120.0,1949086.0],[2690472.0,1974159.0],[2703825.0,2021964.0],[2716102.0,2019950.0],[2759414.0,1981476.0],[2769105.0,1985892.0],[2784157.0,2008590.0],[2795765.0,2007305.0],[2822317.0,2015260.0],[2839691.0,1967475.0]]]}},{"type":"Feature","properties":{"id":"PT20","CNTR_CODE":"PT","NUTS_NAME":"Região Autónoma dos Açores","LEVL_CODE":2,"FID":"PT20","NUTS_ID":"PT20","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[6085783.287917856127024,3213816.054976544342935],[6075877.287917856127024,3208555.054976544342935],[6047282.287917856127024,3230903.054976544342935],[6042167.287917856127024,3254334.054976544342935],[6065057.287917856127024,3252676.054976544342935],[6085783.287917856127024,3213816.054976544342935]]],[[[5935078.287917856127024,3433010.054976544342935],[5916000.287917856127024,3417978.054976544342935],[5903893.287917856127024,3425871.054976544342935],[5909980.287917856127024,3445500.054976544342935],[5923944.287917856127024,3457969.054976544342935],[5935078.287917856127024,3433010.054976544342935]]],[[[6198085.287917856127024,3193689.054976544342935],[6189506.287917856127024,3167372.054976544342935],[6164393.287917856127024,3183145.054976544342935],[6162808.287917856127024,3200672.054976544342935],[6198085.287917856127024,3193689.054976544342935]]],[[[6293503.287917856127024,3004046.054976544342935],[6258335.287917856127024,3016646.054976544342935],[6256383.287917856127024,3027872.054976544342935],[6268353.287917856127024,3033386.054976544342935],[6301650.287917856127024,3016813.054976544342935],[6293503.287917856127024,3004046.054976544342935]]],[[[6260083.287917856127024,3031898.054976544342935],[6243879.287917856127024,3026366.054976544342935],[6236034.287917856127024,3052327.054976544342935],[6252194.287917856127024,3057064.054976544342935],[6260083.287917856127024,3031898.054976544342935]]]]}},{"type":"Feature","properties":{"id":"PT30","CNTR_CODE":"PT","NUTS_NAME":"Região Autónoma da Madeira","LEVL_CODE":2,"FID":"PT30","NUTS_ID":"PT30","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[6888906.26022701151669,3091381.653459304943681],[6876669.26022701151669,3085312.653459304943681],[6852502.26022701151669,3100072.653459304943681],[6855220.26022701151669,3113433.653459304943681],[6873179.26022701151669,3122944.653459304943681],[6888906.26022701151669,3091381.653459304943681]]],[[[6896462.26022701151669,3407619.653459304943681],[6863897.26022701151669,3403062.653459304943681],[6851066.26022701151669,3427958.653459304943681],[6883066.26022701151669,3427730.653459304943681],[6896462.26022701151669,3407619.653459304943681]]]]}},{"type":"Feature","properties":{"id":"EL65","CNTR_CODE":"EL","NUTS_NAME":"Πελοπόννησος","LEVL_CODE":2,"FID":"EL65","NUTS_ID":"EL65","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5481335.0,1752736.0],[5479887.0,1727657.0],[5488662.0,1713642.0],[5510477.0,1702306.0],[5458096.0,1692110.0],[5479066.0,1651168.0],[5483653.0,1616536.0],[5432891.0,1606388.0],[5401915.0,1625019.0],[5379500.0,1607847.0],[5359181.0,1668490.0],[5382689.0,1683985.0],[5370170.0,1724724.0],[5385931.0,1717810.0],[5403331.0,1727026.0],[5407983.0,1761674.0],[5474074.0,1763692.0],[5481335.0,1752736.0]]]}},{"type":"Feature","properties":{"id":"ES11","CNTR_CODE":"ES","NUTS_NAME":"Galicia","LEVL_CODE":2,"FID":"ES11","NUTS_ID":"ES11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2956203.0,2354584.0],[2926589.0,2315020.0],[2938602.0,2292401.0],[2944190.0,2281962.0],[2921463.0,2255029.0],[2901985.0,2249097.0],[2831796.0,2259162.0],[2822605.0,2261163.0],[2828169.0,2298249.0],[2767741.0,2281168.0],[2785737.0,2329544.0],[2799517.0,2366661.0],[2779357.0,2365202.0],[2768932.0,2408013.0],[2777570.0,2417447.0],[2793854.0,2435305.0],[2823821.0,2434649.0],[2849079.0,2434214.0],[2906665.0,2459936.0],[2912845.0,2451347.0],[2954462.0,2426795.0],[2947304.0,2404511.0],[2956203.0,2354584.0]]]}},{"type":"Feature","properties":{"id":"ES12","CNTR_CODE":"ES","NUTS_NAME":"Principado de Asturias","LEVL_CODE":2,"FID":"ES12","NUTS_ID":"ES12","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3150432.0,2367562.0],[3142053.0,2362589.0],[3133221.0,2357367.0],[3119952.0,2349560.0],[3058388.0,2350926.0],[2956203.0,2354584.0],[2947304.0,2404511.0],[2954462.0,2426795.0],[3048811.0,2413342.0],[3150432.0,2367562.0]]]}},{"type":"Feature","properties":{"id":"ES13","CNTR_CODE":"ES","NUTS_NAME":"Cantabria","LEVL_CODE":2,"FID":"ES13","NUTS_ID":"ES13","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3257970.0,2342918.0],[3255851.0,2341204.0],[3232789.0,2322639.0],[3214125.0,2321923.0],[3179180.0,2291421.0],[3125001.0,2330449.0],[3119952.0,2349560.0],[3133221.0,2357367.0],[3142053.0,2362589.0],[3150432.0,2367562.0],[3241372.0,2352093.0],[3257970.0,2342918.0]]]}},{"type":"Feature","properties":{"id":"ES21","CNTR_CODE":"ES","NUTS_NAME":"País Vasco","LEVL_CODE":2,"FID":"ES21","NUTS_ID":"ES21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3313142.0,2331293.0],[3340071.0,2326831.0],[3358654.0,2325035.0],[3367336.0,2324216.0],[3368408.0,2322271.0],[3371029.0,2317520.0],[3355770.0,2305777.0],[3322411.0,2280362.0],[3311949.0,2258879.0],[3301776.0,2238083.0],[3274282.0,2256746.0],[3288193.0,2270296.0],[3252006.0,2283257.0],[3255443.0,2321748.0],[3232789.0,2322639.0],[3255851.0,2341204.0],[3257970.0,2342918.0],[3288670.0,2346256.0],[3313142.0,2331293.0]]]}},{"type":"Feature","properties":{"id":"ES22","CNTR_CODE":"ES","NUTS_NAME":"Comunidad Foral de Navarra","LEVL_CODE":2,"FID":"ES22","NUTS_ID":"ES22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3446155.0,2264004.0],[3437767.0,2258312.0],[3429203.0,2246576.0],[3369176.0,2184040.0],[3340603.0,2177689.0],[3338861.0,2192078.0],[3336381.0,2212853.0],[3320895.0,2224094.0],[3301776.0,2238083.0],[3311949.0,2258879.0],[3322411.0,2280362.0],[3355770.0,2305777.0],[3371029.0,2317520.0],[3393706.0,2309700.0],[3446155.0,2264004.0]]]}},{"type":"Feature","properties":{"id":"ES23","CNTR_CODE":"ES","NUTS_NAME":"La Rioja","LEVL_CODE":2,"FID":"ES23","NUTS_ID":"ES23","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3301776.0,2238083.0],[3320895.0,2224094.0],[3336381.0,2212853.0],[3338861.0,2192078.0],[3340603.0,2177689.0],[3339165.0,2173248.0],[3253551.0,2193820.0],[3249597.0,2224206.0],[3255332.0,2235172.0],[3274282.0,2256746.0],[3301776.0,2238083.0]]]}},{"type":"Feature","properties":{"id":"ES24","CNTR_CODE":"ES","NUTS_NAME":"Aragón","LEVL_CODE":2,"FID":"ES24","NUTS_ID":"ES24","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3498097.0,2050131.0],[3489478.0,2013464.0],[3461634.0,2018208.0],[3447271.0,1996333.0],[3395897.0,1931187.0],[3344585.0,1968320.0],[3318344.0,2000697.0],[3342725.0,2058006.0],[3329918.0,2068837.0],[3321774.0,2075757.0],[3309793.0,2085985.0],[3333658.0,2156811.0],[3339165.0,2173248.0],[3340603.0,2177689.0],[3369176.0,2184040.0],[3429203.0,2246576.0],[3437767.0,2258312.0],[3446155.0,2264004.0],[3478445.0,2251519.0],[3540710.0,2226544.0],[3555450.0,2223671.0],[3548575.0,2191241.0],[3512139.0,2085823.0],[3514609.0,2071151.0],[3498097.0,2050131.0]]]}},{"type":"Feature","properties":{"id":"ES30","CNTR_CODE":"ES","NUTS_NAME":"Comunidad de Madrid","LEVL_CODE":2,"FID":"ES30","NUTS_ID":"ES30","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3208186.0,1992004.0],[3198669.0,1983223.0],[3180206.0,1982996.0],[3160927.0,1982816.0],[3112604.0,2022663.0],[3082331.0,2021947.0],[3109907.0,2051757.0],[3112313.0,2064695.0],[3186712.0,2109111.0],[3194428.0,2070149.0],[3201576.0,2034854.0],[3208186.0,1992004.0]]]}},{"type":"Feature","properties":{"id":"ES41","CNTR_CODE":"ES","NUTS_NAME":"Castilla y León","LEVL_CODE":2,"FID":"ES41","NUTS_ID":"ES41","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3125001.0,2330449.0],[3179180.0,2291421.0],[3214125.0,2321923.0],[3232789.0,2322639.0],[3255443.0,2321748.0],[3252006.0,2283257.0],[3288193.0,2270296.0],[3274282.0,2256746.0],[3255332.0,2235172.0],[3249597.0,2224206.0],[3253551.0,2193820.0],[3339165.0,2173248.0],[3333658.0,2156811.0],[3309793.0,2085985.0],[3250527.0,2107068.0],[3216695.0,2119410.0],[3201674.0,2114229.0],[3186712.0,2109111.0],[3112313.0,2064695.0],[3109907.0,2051757.0],[3082331.0,2021947.0],[3016925.0,2023620.0],[2987054.0,2050029.0],[2949946.0,2074610.0],[2892687.0,2068077.0],[2903687.0,2094914.0],[2904458.0,2151678.0],[2928115.0,2166295.0],[2947305.0,2172125.0],[2968509.0,2201289.0],[2947977.0,2240662.0],[2921463.0,2255029.0],[2944190.0,2281962.0],[2938602.0,2292401.0],[2926589.0,2315020.0],[2956203.0,2354584.0],[3058388.0,2350926.0],[3119952.0,2349560.0],[3125001.0,2330449.0]]]}},{"type":"Feature","properties":{"id":"ES42","CNTR_CODE":"ES","NUTS_NAME":"Castilla-La Mancha","LEVL_CODE":2,"FID":"ES42","NUTS_ID":"ES42","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3344585.0,1968320.0],[3357944.0,1934335.0],[3328751.0,1889372.0],[3350207.0,1873027.0],[3349044.0,1842869.0],[3368963.0,1812558.0],[3358647.0,1799735.0],[3332128.0,1806749.0],[3309866.0,1777571.0],[3287243.0,1768697.0],[3277148.0,1764769.0],[3234891.0,1748534.0],[3217567.0,1757886.0],[3224326.0,1788861.0],[3206655.0,1809949.0],[3152522.0,1810887.0],[3073284.0,1813058.0],[3013686.0,1867697.0],[3046686.0,1920719.0],[3035808.0,1938392.0],[3034808.0,1938577.0],[3011296.0,1996849.0],[3016925.0,2023620.0],[3082331.0,2021947.0],[3112604.0,2022663.0],[3160927.0,1982816.0],[3180206.0,1982996.0],[3198669.0,1983223.0],[3208186.0,1992004.0],[3201576.0,2034854.0],[3194428.0,2070149.0],[3186712.0,2109111.0],[3201674.0,2114229.0],[3216695.0,2119410.0],[3250527.0,2107068.0],[3309793.0,2085985.0],[3321774.0,2075757.0],[3329918.0,2068837.0],[3342725.0,2058006.0],[3318344.0,2000697.0],[3344585.0,1968320.0]]]}},{"type":"Feature","properties":{"id":"ES43","CNTR_CODE":"ES","NUTS_NAME":"Extremadura","LEVL_CODE":2,"FID":"ES43","NUTS_ID":"ES43","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3034808.0,1938577.0],[3035808.0,1938392.0],[3046686.0,1920719.0],[3013686.0,1867697.0],[2969174.0,1845376.0],[2955595.0,1812174.0],[2900309.0,1802349.0],[2841368.0,1845643.0],[2825811.0,1846891.0],[2817368.0,1878991.0],[2830219.0,1909755.0],[2851525.0,1934572.0],[2839691.0,1967475.0],[2822317.0,2015260.0],[2868562.0,2012859.0],[2885230.0,2068271.0],[2892687.0,2068077.0],[2949946.0,2074610.0],[2987054.0,2050029.0],[3016925.0,2023620.0],[3011296.0,1996849.0],[3034808.0,1938577.0]]]}},{"type":"Feature","properties":{"id":"ES51","CNTR_CODE":"ES","NUTS_NAME":"Cataluña","LEVL_CODE":2,"FID":"ES51","NUTS_ID":"ES51","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3618229.0,2206418.0],[3621046.0,2191586.0],[3640254.0,2192873.0],[3640545.0,2191503.0],[3758413.0,2173293.0],[3745684.0,2120436.0],[3718113.0,2089576.0],[3618795.0,2049424.0],[3556316.0,2032334.0],[3538321.0,2011973.0],[3515777.0,1986675.0],[3489478.0,2013464.0],[3498097.0,2050131.0],[3514609.0,2071151.0],[3512139.0,2085823.0],[3548575.0,2191241.0],[3555450.0,2223671.0],[3563129.0,2229191.0],[3573289.0,2236522.0],[3610160.0,2218085.0],[3618229.0,2206418.0]]]}},{"type":"Feature","properties":{"id":"ES52","CNTR_CODE":"ES","NUTS_NAME":"Comunidad Valenciana","LEVL_CODE":2,"FID":"ES52","NUTS_ID":"ES52","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3515777.0,1986675.0],[3445578.0,1906511.0],[3431718.0,1869960.0],[3447421.0,1813123.0],[3460823.0,1791282.0],[3406426.0,1762028.0],[3370291.0,1707909.0],[3351015.0,1750286.0],[3358647.0,1799735.0],[3368963.0,1812558.0],[3349044.0,1842869.0],[3350207.0,1873027.0],[3328751.0,1889372.0],[3357944.0,1934335.0],[3344585.0,1968320.0],[3395897.0,1931187.0],[3447271.0,1996333.0],[3461634.0,2018208.0],[3489478.0,2013464.0],[3515777.0,1986675.0]]]}},{"type":"Feature","properties":{"id":"ES53","CNTR_CODE":"ES","NUTS_NAME":"Illes Balears","LEVL_CODE":2,"FID":"ES53","NUTS_ID":"ES53","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[3666500.0,1865968.0],[3700964.0,1891478.0],[3722706.0,1898039.0],[3731041.0,1879795.0],[3748221.0,1879825.0],[3756255.0,1864875.0],[3734531.0,1834378.0],[3718504.0,1825569.0],[3697085.0,1838182.0],[3685691.0,1861506.0],[3675220.0,1850664.0],[3666500.0,1865968.0]]],[[[3588739.0,1813044.0],[3569607.0,1788721.0],[3548589.0,1799186.0],[3560772.0,1820485.0],[3588739.0,1813044.0]]],[[[3838965.0,1880982.0],[3821292.0,1875260.0],[3798550.0,1899270.0],[3820936.0,1909529.0],[3838965.0,1880982.0]]]]}},{"type":"Feature","properties":{"id":"ES61","CNTR_CODE":"ES","NUTS_NAME":"Andalucía","LEVL_CODE":2,"FID":"ES61","NUTS_ID":"ES61","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3013686.0,1867697.0],[3073284.0,1813058.0],[3152522.0,1810887.0],[3206655.0,1809949.0],[3224326.0,1788861.0],[3217567.0,1757886.0],[3234891.0,1748534.0],[3244842.0,1734684.0],[3259751.0,1725348.0],[3258515.0,1707629.0],[3267375.0,1695188.0],[3275446.0,1683910.0],[3287209.0,1667565.0],[3270542.0,1648420.0],[3259019.0,1635252.0],[3236982.0,1610218.0],[3175488.0,1617311.0],[3144923.0,1621046.0],[3123118.0,1624308.0],[3087264.0,1629828.0],[3033302.0,1635461.0],[2948814.0,1608502.0],[2938042.0,1592777.0],[2936960.0,1593057.0],[2935430.0,1593683.0],[2930861.0,1595972.0],[2927031.0,1585948.0],[2912634.0,1582547.0],[2896409.0,1593440.0],[2888153.0,1605791.0],[2877072.0,1609937.0],[2853957.0,1668881.0],[2853476.0,1676544.0],[2862161.0,1681572.0],[2817387.0,1732249.0],[2777974.0,1743032.0],[2776212.0,1783298.0],[2785764.0,1800102.0],[2841368.0,1845643.0],[2900309.0,1802349.0],[2955595.0,1812174.0],[2969174.0,1845376.0],[3013686.0,1867697.0]]]}},{"type":"Feature","properties":{"id":"ES62","CNTR_CODE":"ES","NUTS_NAME":"Región de Murcia","LEVL_CODE":2,"FID":"ES62","NUTS_ID":"ES62","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3358647.0,1799735.0],[3351015.0,1750286.0],[3370291.0,1707909.0],[3287209.0,1667565.0],[3275446.0,1683910.0],[3267375.0,1695188.0],[3258515.0,1707629.0],[3259751.0,1725348.0],[3244842.0,1734684.0],[3234891.0,1748534.0],[3277148.0,1764769.0],[3287243.0,1768697.0],[3309866.0,1777571.0],[3332128.0,1806749.0],[3358647.0,1799735.0]]]}},{"type":"Feature","properties":{"id":"ES63","CNTR_CODE":"ES","NUTS_NAME":"Ciudad Autónoma de Ceuta","LEVL_CODE":2,"FID":"ES63","NUTS_ID":"ES63","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[2932473.0,1566454.0],[2933353.0,1564854.0],[2934437.0,1565168.0],[2935189.0,1563889.0],[2936390.0,1564075.0],[2936894.0,1564789.0],[2937875.0,1565146.0],[2938533.0,1564338.0],[2938366.0,1563875.0],[2937579.0,1563526.0],[2935840.0,1563196.0],[2934673.0,1563596.0],[2933782.0,1562987.0],[2932890.0,1563032.0],[2932255.0,1562346.0],[2929630.0,1567616.0],[2930066.0,1567858.0],[2931211.0,1567705.0],[2932473.0,1566454.0]]]}},{"type":"Feature","properties":{"id":"ES64","CNTR_CODE":"ES","NUTS_NAME":"Ciudad Autónoma de Melilla","LEVL_CODE":2,"FID":"ES64","NUTS_ID":"ES64","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3138029.0,1458218.0],[3138377.0,1457597.0],[3135235.0,1459882.0],[3137231.0,1462499.0],[3137739.0,1461779.0],[3137650.0,1461082.0],[3138660.0,1459316.0],[3138269.0,1459154.0],[3138029.0,1458218.0]]]}},{"type":"Feature","properties":{"id":"ES70","CNTR_CODE":"ES","NUTS_NAME":"Canarias","LEVL_CODE":2,"FID":"ES70","NUTS_ID":"ES70","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[6062289.218346489593387,5305987.722377296537161],[6031469.218346489593387,5300447.722377296537161],[6021229.218346489593387,5343950.722377296537161],[6061056.218346489593387,5337418.722377296537161],[6085023.218346489593387,5347644.722377296537161],[6092559.218346489593387,5339310.722377296537161],[6062289.218346489593387,5305987.722377296537161]]],[[[6153268.218346489593387,5240190.722377296537161],[6127916.218346489593387,5233753.722377296537161],[6111461.218346489593387,5268283.722377296537161],[6130726.218346489593387,5283704.722377296537161],[6157702.218346489593387,5273904.722377296537161],[6153268.218346489593387,5240190.722377296537161]]],[[[6303343.218346489593387,5234959.722377296537161],[6270398.218346489593387,5241940.722377296537161],[6300824.218346489593387,5279591.722377296537161],[6321367.218346489593387,5293970.722377296537161],[6323329.218346489593387,5271927.722377296537161],[6303343.218346489593387,5234959.722377296537161]]],[[[5951483.218346489593387,5391893.722377296537161],[5936531.218346489593387,5391352.722377296537161],[5930942.218346489593387,5428529.722377296537161],[5959515.218346489593387,5426940.722377296537161],[5951483.218346489593387,5391893.722377296537161]]],[[[6368142.218346489593387,5302755.722377296537161],[6330048.218346489593387,5298214.722377296537161],[6324898.218346489593387,5309098.722377296537161],[6329524.218346489593387,5318656.722377296537161],[6369966.218346489593387,5319824.722377296537161],[6368142.218346489593387,5302755.722377296537161]]],[[[5924000.218346489593387,5321882.722377296537161],[5898590.218346489593387,5297708.722377296537161],[5876345.218346489593387,5322806.722377296537161],[5919809.218346489593387,5330609.722377296537161],[5924000.218346489593387,5321882.722377296537161]]],[[[6005794.218346489593387,5317959.722377296537161],[5978300.218346489593387,5313033.722377296537161],[5965785.218346489593387,5333490.722377296537161],[5986107.218346489593387,5349554.722377296537161],[6005794.218346489593387,5317959.722377296537161]]]]}},{"type":"Feature","properties":{"id":"FI19","CNTR_CODE":"FI","NUTS_NAME":"Länsi-Suomi","LEVL_CODE":2,"FID":"FI19","NUTS_ID":"FI19","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5004387.0,4542255.0],[5043288.0,4520199.0],[5068067.0,4564391.0],[5078297.0,4580580.0],[5121735.0,4576536.0],[5141587.0,4513923.0],[5177668.0,4474784.0],[5166126.0,4434496.0],[5185762.0,4390663.0],[5180918.0,4378693.0],[5153014.0,4387345.0],[5115305.0,4345785.0],[5115480.0,4331473.0],[5088317.0,4316350.0],[5057887.0,4283492.0],[5032377.0,4277845.0],[5019405.0,4280171.0],[4974942.0,4258158.0],[4957658.0,4268141.0],[4936924.0,4266002.0],[4936631.0,4321582.0],[4914878.0,4364837.0],[4889604.0,4446257.0],[4885968.0,4486648.0],[4960842.0,4587133.0],[4987872.0,4573447.0],[5004387.0,4542255.0]]]}},{"type":"Feature","properties":{"id":"FI1B","CNTR_CODE":"FI","NUTS_NAME":"Helsinki-Uusimaa","LEVL_CODE":2,"FID":"FI1B","NUTS_ID":"FI1B","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5198275.0,4285301.0],[5220201.0,4271737.0],[5218624.0,4259109.0],[5072006.0,4157719.0],[5046108.0,4154066.0],[5041165.0,4175348.0],[5069946.0,4203520.0],[5077919.0,4246813.0],[5119994.0,4251727.0],[5138476.0,4278695.0],[5189170.0,4278276.0],[5198275.0,4285301.0]]]}},{"type":"Feature","properties":{"id":"FI1C","CNTR_CODE":"FI","NUTS_NAME":"Etelä-Suomi","LEVL_CODE":2,"FID":"FI1C","NUTS_ID":"FI1C","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5368678.0,4456901.0],[5295069.0,4299086.0],[5288693.0,4283534.0],[5273757.0,4265294.0],[5235584.0,4253988.0],[5218624.0,4259109.0],[5220201.0,4271737.0],[5198275.0,4285301.0],[5189170.0,4278276.0],[5138476.0,4278695.0],[5119994.0,4251727.0],[5077919.0,4246813.0],[5069946.0,4203520.0],[5041165.0,4175348.0],[5018495.0,4156323.0],[4995851.0,4183129.0],[4951957.0,4163053.0],[4928832.0,4235379.0],[4936924.0,4266002.0],[4957658.0,4268141.0],[4974942.0,4258158.0],[5019405.0,4280171.0],[5032377.0,4277845.0],[5057887.0,4283492.0],[5088317.0,4316350.0],[5115480.0,4331473.0],[5115305.0,4345785.0],[5153014.0,4387345.0],[5180918.0,4378693.0],[5200330.0,4344999.0],[5239527.0,4341748.0],[5343446.0,4434375.0],[5368678.0,4456901.0]]],[[[5001266.0,4135606.0],[4991594.0,4121921.0],[4983243.0,4137835.0],[4976175.0,4151379.0],[4992664.0,4157357.0],[5001266.0,4135606.0]]]]}},{"type":"Feature","properties":{"id":"FI1D","CNTR_CODE":"FI","NUTS_NAME":"Pohjois- ja Itä-Suomi","LEVL_CODE":2,"FID":"FI1D","NUTS_ID":"FI1D","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5072809.0,5205674.0],[5073953.0,5144644.0],[5089249.0,5117361.0],[5102409.0,5111128.0],[5162417.0,5069948.0],[5150353.0,4990509.0],[5179393.0,4947692.0],[5187963.0,4936694.0],[5232502.0,4872870.0],[5227537.0,4839633.0],[5244975.0,4776305.0],[5266351.0,4762868.0],[5273601.0,4742689.0],[5277738.0,4731172.0],[5306798.0,4707264.0],[5307643.0,4671756.0],[5296286.0,4657446.0],[5368495.0,4621134.0],[5400404.0,4588602.0],[5398604.0,4540275.0],[5368678.0,4456901.0],[5343446.0,4434375.0],[5239527.0,4341748.0],[5200330.0,4344999.0],[5180918.0,4378693.0],[5185762.0,4390663.0],[5166126.0,4434496.0],[5177668.0,4474784.0],[5141587.0,4513923.0],[5121735.0,4576536.0],[5078297.0,4580580.0],[5068067.0,4564391.0],[5043288.0,4520199.0],[5004387.0,4542255.0],[4987872.0,4573447.0],[4960842.0,4587133.0],[4985007.0,4614223.0],[5005514.0,4674930.0],[5012198.0,4702483.0],[5003689.0,4735026.0],[5015893.0,4739799.0],[5026116.0,4715435.0],[5040403.0,4727559.0],[5015510.0,4795586.0],[4994333.0,4799920.0],[4967896.0,4811191.0],[4939458.0,4857279.0],[4929426.0,4919019.0],[4882631.0,5043780.0],[4744758.0,5136005.0],[4760596.0,5158083.0],[4770073.0,5167675.0],[4781584.0,5166482.0],[4786542.0,5162421.0],[4801470.0,5146847.0],[4853856.0,5111818.0],[4889483.0,5130750.0],[4932227.0,5124379.0],[4948346.0,5164462.0],[4943808.0,5250195.0],[4996323.0,5301736.0],[5064259.0,5266231.0],[5072809.0,5205674.0]]]}},{"type":"Feature","properties":{"id":"FI20","CNTR_CODE":"FI","NUTS_NAME":"Åland","LEVL_CODE":2,"FID":"FI20","NUTS_ID":"FI20","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4906992.0,4154329.0],[4885223.0,4144300.0],[4849742.0,4160483.0],[4852847.0,4171726.0],[4880172.0,4177511.0],[4895042.0,4177026.0],[4906992.0,4154329.0]]],[[[4930820.0,4199583.0],[4931862.0,4177671.0],[4912181.0,4177879.0],[4916773.0,4208000.0],[4930820.0,4199583.0]]]]}},{"type":"Feature","properties":{"id":"FRY1","CNTR_CODE":"FR","NUTS_NAME":"Guadeloupe","LEVL_CODE":2,"FID":"FRY1","NUTS_ID":"FRY1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[6853942.912470887415111,4761180.598077617585659],[6831363.912470887415111,4758843.598077617585659],[6844398.912470887415111,4798418.598077617585659],[6870712.912470887415111,4780620.598077617585659],[6886740.912470887415111,4786849.598077617585659],[6880946.912470887415111,4748377.598077617585659],[6853942.912470887415111,4761180.598077617585659]]],[[[6872705.912470887415111,4697571.598077617585659],[6845499.912470887415111,4700358.598077617585659],[6847902.912470887415111,4732984.598077617585659],[6870556.912470887415111,4733967.598077617585659],[6872705.912470887415111,4697571.598077617585659]]]]}},{"type":"Feature","properties":{"id":"FRY2","CNTR_CODE":"FR","NUTS_NAME":"Martinique ","LEVL_CODE":2,"FID":"FRY2","NUTS_ID":"FRY2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[6799752.912470887415111,4540848.598077617585659],[6785149.912470887415111,4548352.598077617585659],[6790041.912470887415111,4602511.598077617585659],[6813248.912470887415111,4574228.598077617585659],[6799752.912470887415111,4540848.598077617585659]]]}},{"type":"Feature","properties":{"id":"FRY3","CNTR_CODE":"FR","NUTS_NAME":"Guyane","LEVL_CODE":2,"FID":"FRY3","NUTS_ID":"FRY3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[6285194.226165406405926,4514955.832234361208975],[6147392.226165406405926,4443576.832234361208975],[6093573.226165406405926,4443804.832234361208975],[6029283.226165406405926,4519413.832234361208975],[5984402.226165406405926,4542492.832234361208975],[5956926.226165406405926,4596880.832234361208975],[5990691.226165406405926,4600139.832234361208975],[6058829.226165406405926,4669215.832234361208975],[6059475.226165406405926,4787802.832234361208975],[6109372.226165406405926,4859398.832234361208975],[6150659.226165406405926,4869719.832234361208975],[6167829.226165406405926,4865341.832234361208975],[6224423.226165406405926,4775519.832234361208975],[6243269.226165406405926,4722459.832234361208975],[6292079.226165406405926,4586709.832234361208975],[6285194.226165406405926,4514955.832234361208975]]]}},{"type":"Feature","properties":{"id":"FRY4","CNTR_CODE":"FR","NUTS_NAME":"La Réunion ","LEVL_CODE":2,"FID":"FRY4","NUTS_ID":"FRY4","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[6887294.024561231024563,3984088.254666533321142],[6880117.024561231024563,3961520.254666533321142],[6827531.024561231024563,3943982.254666533321142],[6812421.024561231024563,3961624.254666533321142],[6840463.024561231024563,3993115.254666533321142],[6864251.024561231024563,4000471.254666533321142],[6887294.024561231024563,3984088.254666533321142]]]}},{"type":"Feature","properties":{"id":"FRY5","CNTR_CODE":"FR","NUTS_NAME":"Mayotte","LEVL_CODE":2,"FID":"FRY5","NUTS_ID":"FRY5","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[6115422.950583933852613,3978801.982913423329592],[6106257.950583933852613,3941066.982913423329592],[6079301.950583933852613,3943656.982913423329592],[6087687.950583933852613,3971278.982913423329592],[6115422.950583933852613,3978801.982913423329592]]]}},{"type":"Feature","properties":{"id":"HR03","CNTR_CODE":"HR","NUTS_NAME":"Jadranska Hrvatska","LEVL_CODE":2,"FID":"HR03","NUTS_ID":"HR03","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4677334.0,2517639.0],[4730255.0,2493771.0],[4716019.0,2458963.0],[4774121.0,2442304.0],[4809435.0,2391562.0],[4814758.0,2364694.0],[4837474.0,2348050.0],[4846574.0,2341238.0],[4927372.0,2260005.0],[4989826.0,2212175.0],[5014574.0,2200025.0],[5023279.0,2185928.0],[4972073.0,2210100.0],[4946488.0,2229853.0],[4940446.0,2234753.0],[4920628.0,2249011.0],[4884346.0,2273303.0],[4808250.0,2285466.0],[4766933.0,2321857.0],[4749010.0,2330506.0],[4749261.0,2326769.0],[4749292.0,2326310.0],[4749538.0,2322638.0],[4749570.0,2322171.0],[4749610.0,2321563.0],[4749742.0,2319603.0],[4749967.0,2316250.0],[4750169.0,2313239.0],[4741378.0,2321524.0],[4724763.0,2349761.0],[4742243.0,2376583.0],[4715103.0,2395120.0],[4710045.0,2410425.0],[4706013.0,2448079.0],[4678710.0,2434725.0],[4653694.0,2458517.0],[4625173.0,2427476.0],[4599009.0,2476415.0],[4606911.0,2489415.0],[4642725.0,2494425.0],[4643272.0,2494334.0],[4664447.0,2498010.0],[4677334.0,2517639.0]]],[[[4802010.0,2225570.0],[4783944.0,2217553.0],[4766843.0,2225618.0],[4774200.0,2232729.0],[4799661.0,2245652.0],[4812173.0,2241081.0],[4802010.0,2225570.0]]],[[[4868898.0,2156199.0],[4844343.0,2151647.0],[4826234.0,2163734.0],[4836438.0,2175422.0],[4857612.0,2174401.0],[4868898.0,2156199.0]]],[[[4919648.0,2235888.0],[4916831.0,2223446.0],[4892341.0,2221846.0],[4886811.0,2231552.0],[4894495.0,2246522.0],[4909040.0,2248928.0],[4919648.0,2235888.0]]]]}},{"type":"Feature","properties":{"id":"HR04","CNTR_CODE":"HR","NUTS_NAME":"Kontinentalna Hrvatska","LEVL_CODE":2,"FID":"HR04","NUTS_ID":"HR04","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4914925.0,2556676.0],[4935711.0,2552487.0],[5004437.0,2574074.0],[5009623.0,2575456.0],[5026320.0,2528867.0],[5024761.0,2522836.0],[5031555.0,2513131.0],[5060947.0,2497458.0],[5039110.0,2489241.0],[5033462.0,2459084.0],[5018480.0,2458934.0],[5009326.0,2474682.0],[4991980.0,2480138.0],[4951515.0,2480303.0],[4937776.0,2471262.0],[4906109.0,2478964.0],[4882408.0,2477038.0],[4813687.0,2460179.0],[4779875.0,2474907.0],[4774121.0,2442304.0],[4716019.0,2458963.0],[4730255.0,2493771.0],[4735901.0,2531543.0],[4741351.0,2535262.0],[4763300.0,2557231.0],[4756288.0,2569025.0],[4767522.0,2589203.0],[4773662.0,2591914.0],[4805669.0,2605574.0],[4800110.0,2617567.0],[4827386.0,2618351.0],[4848359.0,2606260.0],[4850286.0,2603109.0],[4885838.0,2569453.0],[4897746.0,2566288.0],[4914925.0,2556676.0]]]}},{"type":"Feature","properties":{"id":"HU11","CNTR_CODE":"HU","NUTS_NAME":"Budapest","LEVL_CODE":2,"FID":"HU11","NUTS_ID":"HU11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4990240.0,2753056.0],[5003357.0,2766082.0],[5020256.0,2748495.0],[5010807.0,2733643.0],[4995385.0,2734680.0],[4990240.0,2753056.0]]]}},{"type":"Feature","properties":{"id":"HU12","CNTR_CODE":"HU","NUTS_NAME":"Pest","LEVL_CODE":2,"FID":"HU12","NUTS_ID":"HU12","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5037029.0,2782125.0],[5046179.0,2766903.0],[5086597.0,2707114.0],[5001218.0,2698474.0],[4973370.0,2756523.0],[4982213.0,2784592.0],[4974418.0,2794447.0],[4985039.0,2811671.0],[4996035.0,2795443.0],[5037029.0,2782125.0]],[[4990240.0,2753056.0],[4995385.0,2734680.0],[5010807.0,2733643.0],[5020256.0,2748495.0],[5003357.0,2766082.0],[4990240.0,2753056.0]]]}},{"type":"Feature","properties":{"id":"HU21","CNTR_CODE":"HU","NUTS_NAME":"Közép-Dunántúl","LEVL_CODE":2,"FID":"HU21","NUTS_ID":"HU21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4973370.0,2756523.0],[5001218.0,2698474.0],[5000354.0,2679127.0],[4947193.0,2664109.0],[4944472.0,2685446.0],[4887343.0,2654700.0],[4858089.0,2685117.0],[4861500.0,2728306.0],[4881641.0,2732337.0],[4915386.0,2729016.0],[4912120.0,2767794.0],[4982213.0,2784592.0],[4973370.0,2756523.0]]]}},{"type":"Feature","properties":{"id":"HU22","CNTR_CODE":"HU","NUTS_NAME":"Nyugat-Dunántúl","LEVL_CODE":2,"FID":"HU22","NUTS_ID":"HU22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4912120.0,2767794.0],[4915386.0,2729016.0],[4881641.0,2732337.0],[4861500.0,2728306.0],[4858089.0,2685117.0],[4887343.0,2654700.0],[4850286.0,2603109.0],[4848359.0,2606260.0],[4827386.0,2618351.0],[4807826.0,2644114.0],[4786948.0,2658725.0],[4811577.0,2680342.0],[4806751.0,2714375.0],[4821839.0,2726166.0],[4802913.0,2748898.0],[4844981.0,2758836.0],[4854633.0,2791782.0],[4861009.0,2793005.0],[4897845.0,2768465.0],[4912120.0,2767794.0]]]}},{"type":"Feature","properties":{"id":"HU23","CNTR_CODE":"HU","NUTS_NAME":"Dél-Dunántúl","LEVL_CODE":2,"FID":"HU23","NUTS_ID":"HU23","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4944472.0,2685446.0],[4947193.0,2664109.0],[5000354.0,2679127.0],[5000525.0,2595361.0],[5004437.0,2574074.0],[4935711.0,2552487.0],[4914925.0,2556676.0],[4897746.0,2566288.0],[4885838.0,2569453.0],[4850286.0,2603109.0],[4887343.0,2654700.0],[4944472.0,2685446.0]]]}},{"type":"Feature","properties":{"id":"HU31","CNTR_CODE":"HU","NUTS_NAME":"Észak-Magyarország","LEVL_CODE":2,"FID":"HU31","NUTS_ID":"HU31","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5127433.0,2785630.0],[5105397.0,2762259.0],[5080954.0,2773484.0],[5072443.0,2776180.0],[5046179.0,2766903.0],[5037029.0,2782125.0],[4996035.0,2795443.0],[4985039.0,2811671.0],[4991118.0,2814757.0],[5066406.0,2834644.0],[5092186.0,2871556.0],[5159904.0,2891350.0],[5214660.0,2880854.0],[5148465.0,2823363.0],[5131540.0,2786747.0],[5127433.0,2785630.0]]]}},{"type":"Feature","properties":{"id":"HU32","CNTR_CODE":"HU","NUTS_NAME":"Észak-Alföld","LEVL_CODE":2,"FID":"HU32","NUTS_ID":"HU32","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5229004.0,2795172.0],[5203938.0,2726155.0],[5182771.0,2718922.0],[5150533.0,2741566.0],[5114475.0,2688102.0],[5086992.0,2684603.0],[5086597.0,2707114.0],[5046179.0,2766903.0],[5072443.0,2776180.0],[5080954.0,2773484.0],[5105397.0,2762259.0],[5127433.0,2785630.0],[5131540.0,2786747.0],[5148465.0,2823363.0],[5214660.0,2880854.0],[5216710.0,2884027.0],[5279162.0,2843993.0],[5232859.0,2796039.0],[5229004.0,2795172.0]]]}},{"type":"Feature","properties":{"id":"HU33","CNTR_CODE":"HU","NUTS_NAME":"Dél-Alföld","LEVL_CODE":2,"FID":"HU33","NUTS_ID":"HU33","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5150533.0,2741566.0],[5182771.0,2718922.0],[5203938.0,2726155.0],[5193728.0,2682801.0],[5176556.0,2644649.0],[5149175.0,2633827.0],[5145578.0,2620384.0],[5112370.0,2611778.0],[5102474.0,2611270.0],[5081487.0,2610251.0],[5068154.0,2612699.0],[5040492.0,2587133.0],[5009623.0,2575456.0],[5004437.0,2574074.0],[5000525.0,2595361.0],[5000354.0,2679127.0],[5001218.0,2698474.0],[5086597.0,2707114.0],[5086992.0,2684603.0],[5114475.0,2688102.0],[5150533.0,2741566.0]]]}},{"type":"Feature","properties":{"id":"IE04","CNTR_CODE":"IE","NUTS_NAME":"Northern and Western","LEVL_CODE":2,"FID":"IE04","NUTS_ID":"IE04","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3214939.0,3602581.0],[3235161.0,3596830.0],[3245166.0,3577208.0],[3244776.0,3561763.0],[3190681.0,3546537.0],[3177886.0,3564956.0],[3154715.0,3558121.0],[3126143.0,3489877.0],[3100173.0,3478220.0],[3065671.0,3502790.0],[3016106.0,3538828.0],[3005533.0,3570045.0],[3019430.0,3589715.0],[3018438.0,3617603.0],[3042559.0,3639690.0],[3087910.0,3615180.0],[3142931.0,3637197.0],[3133727.0,3663080.0],[3170811.0,3705283.0],[3233385.0,3710083.0],[3230330.0,3682748.0],[3197575.0,3657011.0],[3199285.0,3641565.0],[3173848.0,3612489.0],[3195615.0,3589513.0],[3214939.0,3602581.0]]]}},{"type":"Feature","properties":{"id":"IE05","CNTR_CODE":"IE","NUTS_NAME":"Southern","LEVL_CODE":2,"FID":"IE05","NUTS_ID":"IE05","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3126143.0,3489877.0],[3141981.0,3441400.0],[3192492.0,3440411.0],[3240880.0,3412798.0],[3205615.0,3361773.0],[3108541.0,3354477.0],[2978351.0,3337522.0],[2945860.0,3376723.0],[2965101.0,3427072.0],[3025762.0,3449549.0],[3035186.0,3491157.0],[3065671.0,3502790.0],[3100173.0,3478220.0],[3126143.0,3489877.0]]]}},{"type":"Feature","properties":{"id":"IE06","CNTR_CODE":"IE","NUTS_NAME":"Eastern and Midland","LEVL_CODE":2,"FID":"IE06","NUTS_ID":"IE06","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3267014.0,3563206.0],[3258609.0,3511383.0],[3263290.0,3493217.0],[3255317.0,3463709.0],[3240880.0,3412798.0],[3192492.0,3440411.0],[3141981.0,3441400.0],[3126143.0,3489877.0],[3154715.0,3558121.0],[3177886.0,3564956.0],[3190681.0,3546537.0],[3244776.0,3561763.0],[3267014.0,3563206.0]]]}},{"type":"Feature","properties":{"id":"ITC1","CNTR_CODE":"IT","NUTS_NAME":"Piemonte","LEVL_CODE":2,"FID":"ITC1","NUTS_ID":"ITC1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4257616.0,2389496.0],[4207564.0,2378673.0],[4182530.0,2380336.0],[4181854.0,2381385.0],[4161805.0,2335512.0],[4137477.0,2330752.0],[4072438.0,2366359.0],[4078566.0,2398683.0],[4088123.0,2404819.0],[4055456.0,2450216.0],[4095551.0,2465999.0],[4094309.0,2488413.0],[4156591.0,2499824.0],[4160176.0,2514638.0],[4155108.0,2536148.0],[4156153.0,2537251.0],[4196777.0,2594561.0],[4221437.0,2554668.0],[4211597.0,2524974.0],[4219896.0,2494861.0],[4230260.0,2476435.0],[4204264.0,2467955.0],[4206654.0,2451801.0],[4257466.0,2397553.0],[4257616.0,2389496.0]]]}},{"type":"Feature","properties":{"id":"ITC2","CNTR_CODE":"IT","NUTS_NAME":"Valle d'Aosta/Vallée d'Aoste","LEVL_CODE":2,"FID":"ITC2","NUTS_ID":"ITC2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4155108.0,2536148.0],[4160176.0,2514638.0],[4156591.0,2499824.0],[4094309.0,2488413.0],[4072064.0,2523773.0],[4091540.0,2538951.0],[4155108.0,2536148.0]]]}},{"type":"Feature","properties":{"id":"ITC3","CNTR_CODE":"IT","NUTS_NAME":"Liguria","LEVL_CODE":2,"FID":"ITC3","NUTS_ID":"ITC3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4280667.0,2382905.0],[4279421.0,2366653.0],[4295977.0,2361757.0],[4322508.0,2326071.0],[4281866.0,2345283.0],[4211842.0,2364241.0],[4170960.0,2316231.0],[4121720.0,2300473.0],[4137477.0,2330752.0],[4161805.0,2335512.0],[4181854.0,2381385.0],[4182530.0,2380336.0],[4207564.0,2378673.0],[4257616.0,2389496.0],[4280667.0,2382905.0]]]}},{"type":"Feature","properties":{"id":"ITC4","CNTR_CODE":"IT","NUTS_NAME":"Lombardia","LEVL_CODE":2,"FID":"ITC4","NUTS_ID":"ITC4","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4360748.0,2581253.0],[4360977.0,2529889.0],[4386364.0,2524813.0],[4372320.0,2478396.0],[4379543.0,2467234.0],[4387053.0,2462036.0],[4416023.0,2444947.0],[4433784.0,2427572.0],[4419512.0,2427466.0],[4391236.0,2422939.0],[4360890.0,2423561.0],[4357692.0,2425177.0],[4327590.0,2436913.0],[4312419.0,2446562.0],[4285438.0,2446857.0],[4257466.0,2397553.0],[4206654.0,2451801.0],[4204264.0,2467955.0],[4230260.0,2476435.0],[4219896.0,2494861.0],[4211597.0,2524974.0],[4221437.0,2554668.0],[4236365.0,2524806.0],[4256007.0,2562205.0],[4262968.0,2569255.0],[4270832.0,2595632.0],[4324907.0,2580200.0],[4334344.0,2607398.0],[4355774.0,2602037.0],[4368853.0,2592961.0],[4360748.0,2581253.0]]]}},{"type":"Feature","properties":{"id":"ITF1","CNTR_CODE":"IT","NUTS_NAME":"Abruzzo","LEVL_CODE":2,"FID":"ITF1","NUTS_ID":"ITF1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4717677.0,2119916.0],[4695183.0,2084110.0],[4673210.0,2095860.0],[4650207.0,2073654.0],[4640645.0,2078169.0],[4595224.0,2099896.0],[4572443.0,2117415.0],[4589589.0,2129406.0],[4586274.0,2148744.0],[4587013.0,2162844.0],[4600364.0,2171343.0],[4597069.0,2182063.0],[4641630.0,2206987.0],[4650922.0,2184703.0],[4662614.0,2167739.0],[4671923.0,2158742.0],[4717677.0,2119916.0]]]}},{"type":"Feature","properties":{"id":"ITF2","CNTR_CODE":"IT","NUTS_NAME":"Molise","LEVL_CODE":2,"FID":"ITF2","NUTS_ID":"ITF2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4748384.0,2106071.0],[4744955.0,2084329.0],[4740542.0,2056664.0],[4699131.0,2042537.0],[4688495.0,2048645.0],[4654502.0,2048895.0],[4650207.0,2073654.0],[4673210.0,2095860.0],[4695183.0,2084110.0],[4717677.0,2119916.0],[4748384.0,2106071.0]]]}},{"type":"Feature","properties":{"id":"ITF3","CNTR_CODE":"IT","NUTS_NAME":"Campania","LEVL_CODE":2,"FID":"ITF3","NUTS_ID":"ITF3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4740542.0,2056664.0],[4753815.0,2034720.0],[4788524.0,2012270.0],[4772608.0,1986622.0],[4809657.0,1916155.0],[4804764.0,1901170.0],[4756715.0,1912832.0],[4727078.0,1954207.0],[4701598.0,1960714.0],[4662108.0,1986871.0],[4637532.0,2021521.0],[4646425.0,2034721.0],[4654502.0,2048895.0],[4688495.0,2048645.0],[4699131.0,2042537.0],[4740542.0,2056664.0]]]}},{"type":"Feature","properties":{"id":"ITF4","CNTR_CODE":"IT","NUTS_NAME":"Puglia","LEVL_CODE":2,"FID":"ITF4","NUTS_ID":"ITF4","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4871067.0,2038145.0],[4945372.0,2007501.0],[4990655.0,1988740.0],[5009077.0,1972177.0],[5041303.0,1938835.0],[5035626.0,1904444.0],[5015703.0,1908574.0],[4983094.0,1945003.0],[4905973.0,1948907.0],[4891047.0,1982644.0],[4849351.0,1992851.0],[4845180.0,2001330.0],[4815412.0,2023629.0],[4788524.0,2012270.0],[4753815.0,2034720.0],[4740542.0,2056664.0],[4744955.0,2084329.0],[4748384.0,2106071.0],[4824161.0,2109317.0],[4824850.0,2090224.0],[4826062.0,2056175.0],[4871067.0,2038145.0]]]}},{"type":"Feature","properties":{"id":"ITF5","CNTR_CODE":"IT","NUTS_NAME":"Basilicata","LEVL_CODE":2,"FID":"ITF5","NUTS_ID":"ITF5","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4869105.0,1907680.0],[4815169.0,1888735.0],[4804764.0,1901170.0],[4809657.0,1916155.0],[4772608.0,1986622.0],[4788524.0,2012270.0],[4815412.0,2023629.0],[4845180.0,2001330.0],[4849351.0,1992851.0],[4891047.0,1982644.0],[4905973.0,1948907.0],[4889506.0,1916502.0],[4869105.0,1907680.0]]]}},{"type":"Feature","properties":{"id":"ITF6","CNTR_CODE":"IT","NUTS_NAME":"Calabria","LEVL_CODE":2,"FID":"ITF6","NUTS_ID":"ITF6","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4898486.0,1734482.0],[4836967.0,1669864.0],[4819544.0,1691929.0],[4840159.0,1733790.0],[4863490.0,1769259.0],[4851084.0,1794642.0],[4815169.0,1888735.0],[4869105.0,1907680.0],[4889506.0,1916502.0],[4884048.0,1871924.0],[4927897.0,1849465.0],[4939271.0,1802361.0],[4921369.0,1787170.0],[4909333.0,1781128.0],[4895576.0,1760870.0],[4898486.0,1734482.0]]]}},{"type":"Feature","properties":{"id":"ITG1","CNTR_CODE":"IT","NUTS_NAME":"Sicilia","LEVL_CODE":2,"FID":"ITG1","NUTS_ID":"ITG1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4690793.0,1670055.0],[4792130.0,1692431.0],[4787072.0,1652570.0],[4775275.0,1602135.0],[4791106.0,1571966.0],[4771338.0,1529624.0],[4732533.0,1534570.0],[4710072.0,1558883.0],[4682531.0,1568852.0],[4578760.0,1616091.0],[4556152.0,1622072.0],[4546804.0,1653886.0],[4584163.0,1667360.0],[4605539.0,1685111.0],[4690793.0,1670055.0]]],[[[4518352.0,1531189.0],[4500971.0,1507150.0],[4479218.0,1536458.0],[4487649.0,1545686.0],[4518352.0,1531189.0]]]]}},{"type":"Feature","properties":{"id":"ITG2","CNTR_CODE":"IT","NUTS_NAME":"Sardegna","LEVL_CODE":2,"FID":"ITG2","NUTS_ID":"ITG2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4199980.0,1764520.0],[4178712.0,1777248.0],[4181882.0,1818822.0],[4191866.0,1848045.0],[4189784.0,1901713.0],[4184513.0,1924933.0],[4171083.0,1968065.0],[4219713.0,1982155.0],[4268807.0,2010861.0],[4299705.0,1951217.0],[4289165.0,1900466.0],[4290842.0,1828772.0],[4279336.0,1788231.0],[4199980.0,1764520.0]]]}},{"type":"Feature","properties":{"id":"ITH1","CNTR_CODE":"IT","NUTS_NAME":"Provincia Autonoma di Bolzano/Bozen","LEVL_CODE":2,"FID":"ITH1","NUTS_ID":"ITH1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4491314.0,2664310.0],[4489657.0,2645101.0],[4510729.0,2621661.0],[4463644.0,2602365.0],[4421075.0,2576090.0],[4402897.0,2597970.0],[4368853.0,2592961.0],[4355774.0,2602037.0],[4356849.0,2638051.0],[4395997.0,2633155.0],[4409680.0,2650942.0],[4444822.0,2656889.0],[4462343.0,2656248.0],[4483321.0,2665352.0],[4491314.0,2664310.0]]]}},{"type":"Feature","properties":{"id":"ITH2","CNTR_CODE":"IT","NUTS_NAME":"Provincia Autonoma di Trento","LEVL_CODE":2,"FID":"ITH2","NUTS_ID":"ITH2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4451663.0,2542720.0],[4409779.0,2510064.0],[4386364.0,2524813.0],[4360977.0,2529889.0],[4360748.0,2581253.0],[4368853.0,2592961.0],[4402897.0,2597970.0],[4421075.0,2576090.0],[4463644.0,2602365.0],[4467313.0,2565146.0],[4451663.0,2542720.0]]]}},{"type":"Feature","properties":{"id":"ITH3","CNTR_CODE":"IT","NUTS_NAME":"Veneto","LEVL_CODE":2,"FID":"ITH3","NUTS_ID":"ITH3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4507006.0,2550672.0],[4528181.0,2523672.0],[4552694.0,2529223.0],[4562838.0,2508582.0],[4495895.0,2470763.0],[4504513.0,2452710.0],[4511152.0,2412080.0],[4467738.0,2430950.0],[4433784.0,2427572.0],[4416023.0,2444947.0],[4387053.0,2462036.0],[4379543.0,2467234.0],[4372320.0,2478396.0],[4386364.0,2524813.0],[4409779.0,2510064.0],[4451663.0,2542720.0],[4467313.0,2565146.0],[4463644.0,2602365.0],[4510729.0,2621661.0],[4527096.0,2619690.0],[4530306.0,2617286.0],[4513282.0,2592009.0],[4507006.0,2550672.0]]]}},{"type":"Feature","properties":{"id":"RO11","CNTR_CODE":"RO","NUTS_NAME":"Nord-Vest","LEVL_CODE":2,"FID":"RO11","NUTS_ID":"RO11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5455652.0,2785165.0],[5415223.0,2738131.0],[5396830.0,2735657.0],[5389800.0,2691920.0],[5325767.0,2688422.0],[5298664.0,2690837.0],[5291415.0,2671163.0],[5193728.0,2682801.0],[5203938.0,2726155.0],[5229004.0,2795172.0],[5232859.0,2796039.0],[5279162.0,2843993.0],[5295136.0,2864797.0],[5322717.0,2853436.0],[5401520.0,2864804.0],[5434197.0,2848155.0],[5438078.0,2833905.0],[5455652.0,2785165.0]]]}},{"type":"Feature","properties":{"id":"RO12","CNTR_CODE":"RO","NUTS_NAME":"Centru","LEVL_CODE":2,"FID":"RO12","NUTS_ID":"RO12","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5500967.0,2789636.0],[5533241.0,2751699.0],[5565220.0,2707331.0],[5583340.0,2687720.0],[5585248.0,2661149.0],[5569157.0,2624924.0],[5567827.0,2623431.0],[5521937.0,2606182.0],[5513232.0,2597496.0],[5459801.0,2611871.0],[5447924.0,2606829.0],[5386811.0,2585566.0],[5379095.0,2581495.0],[5334634.0,2636779.0],[5297874.0,2666115.0],[5291415.0,2671163.0],[5298664.0,2690837.0],[5325767.0,2688422.0],[5389800.0,2691920.0],[5396830.0,2735657.0],[5415223.0,2738131.0],[5455652.0,2785165.0],[5470087.0,2783780.0],[5500967.0,2789636.0]]]}},{"type":"Feature","properties":{"id":"RO21","CNTR_CODE":"RO","NUTS_NAME":"Nord-Est","LEVL_CODE":2,"FID":"RO21","NUTS_ID":"RO21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5707440.0,2725187.0],[5660770.0,2717354.0],[5659515.0,2719297.0],[5583340.0,2687720.0],[5565220.0,2707331.0],[5533241.0,2751699.0],[5500967.0,2789636.0],[5470087.0,2783780.0],[5455652.0,2785165.0],[5438078.0,2833905.0],[5434197.0,2848155.0],[5512617.0,2893427.0],[5544404.0,2932763.0],[5593798.0,2903636.0],[5616142.0,2872864.0],[5688360.0,2804383.0],[5707262.0,2763101.0],[5707440.0,2725187.0]]]}},{"type":"Feature","properties":{"id":"RO22","CNTR_CODE":"RO","NUTS_NAME":"Sud-Est","LEVL_CODE":2,"FID":"RO22","NUTS_ID":"RO22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5731143.0,2657535.0],[5770137.0,2642597.0],[5814677.0,2672729.0],[5845264.0,2669526.0],[5848989.0,2658979.0],[5849006.0,2619963.0],[5811317.0,2587520.0],[5797649.0,2549193.0],[5803878.0,2477397.0],[5728800.0,2487226.0],[5692417.0,2494414.0],[5744995.0,2531629.0],[5723873.0,2574903.0],[5671239.0,2564968.0],[5623586.0,2561911.0],[5584445.0,2605006.0],[5567827.0,2623431.0],[5569157.0,2624924.0],[5585248.0,2661149.0],[5583340.0,2687720.0],[5659515.0,2719297.0],[5660770.0,2717354.0],[5707440.0,2725187.0],[5731143.0,2657535.0]]]}},{"type":"Feature","properties":{"id":"RO31","CNTR_CODE":"RO","NUTS_NAME":"Sud - Muntenia","LEVL_CODE":2,"FID":"RO31","NUTS_ID":"RO31","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5459801.0,2611871.0],[5513232.0,2597496.0],[5521937.0,2606182.0],[5567827.0,2623431.0],[5584445.0,2605006.0],[5623586.0,2561911.0],[5671239.0,2564968.0],[5723873.0,2574903.0],[5744995.0,2531629.0],[5692417.0,2494414.0],[5625118.0,2468918.0],[5623303.0,2468347.0],[5577229.0,2418572.0],[5568141.0,2411495.0],[5548283.0,2408759.0],[5496186.0,2405891.0],[5500625.0,2481499.0],[5457800.0,2527102.0],[5450914.0,2576950.0],[5447924.0,2606829.0],[5459801.0,2611871.0]],[[5609779.0,2494714.0],[5616721.0,2522105.0],[5602218.0,2547044.0],[5577969.0,2535030.0],[5575558.0,2515212.0],[5578386.0,2496628.0],[5599813.0,2487774.0],[5609779.0,2494714.0]]]}},{"type":"Feature","properties":{"id":"RO32","CNTR_CODE":"RO","NUTS_NAME":"Bucureşti - Ilfov","LEVL_CODE":2,"FID":"RO32","NUTS_ID":"RO32","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5609779.0,2494714.0],[5599813.0,2487774.0],[5578386.0,2496628.0],[5575558.0,2515212.0],[5577969.0,2535030.0],[5602218.0,2547044.0],[5616721.0,2522105.0],[5609779.0,2494714.0]]]}},{"type":"Feature","properties":{"id":"RO41","CNTR_CODE":"RO","NUTS_NAME":"Sud-Vest Oltenia","LEVL_CODE":2,"FID":"RO41","NUTS_ID":"RO41","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5457800.0,2527102.0],[5500625.0,2481499.0],[5496186.0,2405891.0],[5470511.0,2397911.0],[5453726.0,2394931.0],[5413836.0,2397732.0],[5375820.0,2393237.0],[5363359.0,2390534.0],[5355670.0,2421937.0],[5330612.0,2430822.0],[5309847.0,2471925.0],[5272190.0,2464261.0],[5313280.0,2528481.0],[5312890.0,2545312.0],[5380904.0,2568211.0],[5379095.0,2581495.0],[5386811.0,2585566.0],[5447924.0,2606829.0],[5450914.0,2576950.0],[5457800.0,2527102.0]]]}},{"type":"Feature","properties":{"id":"RO42","CNTR_CODE":"RO","NUTS_NAME":"Vest","LEVL_CODE":2,"FID":"RO42","NUTS_ID":"RO42","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5313280.0,2528481.0],[5272190.0,2464261.0],[5271841.0,2464555.0],[5217048.0,2480558.0],[5220467.0,2522847.0],[5182475.0,2531852.0],[5147918.0,2579517.0],[5112370.0,2611778.0],[5145578.0,2620384.0],[5149175.0,2633827.0],[5176556.0,2644649.0],[5193728.0,2682801.0],[5291415.0,2671163.0],[5297874.0,2666115.0],[5334634.0,2636779.0],[5379095.0,2581495.0],[5380904.0,2568211.0],[5312890.0,2545312.0],[5313280.0,2528481.0]]]}},{"type":"Feature","properties":{"id":"SE11","CNTR_CODE":"SE","NUTS_NAME":"Stockholm","LEVL_CODE":2,"FID":"SE11","NUTS_ID":"SE11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4756741.0,4006532.0],[4748057.0,4016598.0],[4740044.0,4025941.0],[4742524.0,4053508.0],[4802428.0,4155191.0],[4828639.0,4099628.0],[4813628.0,4024026.0],[4778124.0,3992595.0],[4756741.0,4006532.0]]]}},{"type":"Feature","properties":{"id":"SE12","CNTR_CODE":"SE","NUTS_NAME":"Östra Mellansverige","LEVL_CODE":2,"FID":"SE12","NUTS_ID":"SE12","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4802428.0,4155191.0],[4742524.0,4053508.0],[4740044.0,4025941.0],[4748057.0,4016598.0],[4756741.0,4006532.0],[4749147.0,3979009.0],[4713516.0,3965892.0],[4730318.0,3916416.0],[4715178.0,3895576.0],[4690731.0,3903987.0],[4644269.0,3857038.0],[4628069.0,3858855.0],[4621058.0,3872038.0],[4616484.0,3896839.0],[4607432.0,3897001.0],[4581023.0,3906467.0],[4592482.0,3940633.0],[4598743.0,3958748.0],[4568142.0,3997671.0],[4568854.0,4110600.0],[4596618.0,4114964.0],[4625291.0,4095427.0],[4647937.0,4131605.0],[4693220.0,4139304.0],[4717504.0,4157228.0],[4724601.0,4193676.0],[4802428.0,4155191.0]]]}},{"type":"Feature","properties":{"id":"SE21","CNTR_CODE":"SE","NUTS_NAME":"Småland med öarna","LEVL_CODE":2,"FID":"SE21","NUTS_ID":"SE21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4644269.0,3857038.0],[4690731.0,3903987.0],[4715178.0,3895576.0],[4723660.0,3846239.0],[4714642.0,3797036.0],[4734262.0,3762691.0],[4722887.0,3713585.0],[4707053.0,3735828.0],[4695105.0,3706695.0],[4682817.0,3706799.0],[4661870.0,3724258.0],[4651386.0,3721132.0],[4620891.0,3705766.0],[4599348.0,3715052.0],[4534730.0,3707908.0],[4526137.0,3749093.0],[4544999.0,3769020.0],[4508843.0,3786621.0],[4536814.0,3831793.0],[4549153.0,3882065.0],[4581023.0,3906467.0],[4607432.0,3897001.0],[4616484.0,3896839.0],[4621058.0,3872038.0],[4628069.0,3858855.0],[4644269.0,3857038.0]]],[[[4848367.0,3829771.0],[4819113.0,3791718.0],[4817976.0,3810697.0],[4808951.0,3823346.0],[4812959.0,3837543.0],[4806241.0,3853279.0],[4823232.0,3886956.0],[4837869.0,3900907.0],[4859011.0,3904881.0],[4856710.0,3882759.0],[4845993.0,3871328.0],[4848367.0,3829771.0]]]]}},{"type":"Feature","properties":{"id":"SE22","CNTR_CODE":"SE","NUTS_NAME":"Sydsverige","LEVL_CODE":2,"FID":"SE22","NUTS_ID":"SE22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4695105.0,3706695.0],[4680619.0,3681309.0],[4604193.0,3670894.0],[4583909.0,3601419.0],[4522236.0,3592092.0],[4487079.0,3662743.0],[4499887.0,3708682.0],[4534730.0,3707908.0],[4599348.0,3715052.0],[4620891.0,3705766.0],[4651386.0,3721132.0],[4661870.0,3724258.0],[4682817.0,3706799.0],[4695105.0,3706695.0]]]}},{"type":"Feature","properties":{"id":"SE23","CNTR_CODE":"SE","NUTS_NAME":"Västsverige","LEVL_CODE":2,"FID":"SE23","NUTS_ID":"SE23","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4568142.0,3997671.0],[4598743.0,3958748.0],[4592482.0,3940633.0],[4581023.0,3906467.0],[4549153.0,3882065.0],[4536814.0,3831793.0],[4508843.0,3786621.0],[4544999.0,3769020.0],[4526137.0,3749093.0],[4534730.0,3707908.0],[4499887.0,3708682.0],[4436223.0,3830455.0],[4409724.0,3876750.0],[4390495.0,3950683.0],[4390977.0,3986335.0],[4404885.0,3988539.0],[4414591.0,3982029.0],[4419717.0,3995431.0],[4425446.0,4016571.0],[4443881.0,4018636.0],[4475706.0,4005315.0],[4481232.0,3997378.0],[4503177.0,3966219.0],[4531212.0,3998690.0],[4568142.0,3997671.0]]]}},{"type":"Feature","properties":{"id":"SE31","CNTR_CODE":"SE","NUTS_NAME":"Norra Mellansverige","LEVL_CODE":2,"FID":"SE31","NUTS_ID":"SE31","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4724601.0,4193676.0],[4717504.0,4157228.0],[4693220.0,4139304.0],[4647937.0,4131605.0],[4625291.0,4095427.0],[4596618.0,4114964.0],[4568854.0,4110600.0],[4568142.0,3997671.0],[4531212.0,3998690.0],[4503177.0,3966219.0],[4481232.0,3997378.0],[4475706.0,4005315.0],[4443881.0,4018636.0],[4425446.0,4016571.0],[4429455.0,4078126.0],[4424394.0,4083583.0],[4441629.0,4089344.0],[4457049.0,4110971.0],[4462806.0,4150810.0],[4445605.0,4211601.0],[4465658.0,4219983.0],[4465246.0,4261088.0],[4436644.0,4298009.0],[4440905.0,4353715.0],[4494309.0,4326445.0],[4514173.0,4290444.0],[4557821.0,4284568.0],[4594831.0,4323937.0],[4598508.0,4362773.0],[4650257.0,4362952.0],[4712401.0,4358106.0],[4708560.0,4324518.0],[4717891.0,4307526.0],[4707582.0,4249823.0],[4724601.0,4193676.0]]]}},{"type":"Feature","properties":{"id":"SE32","CNTR_CODE":"SE","NUTS_NAME":"Mellersta Norrland","LEVL_CODE":2,"FID":"SE32","NUTS_ID":"SE32","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4650735.0,4562849.0],[4661349.0,4555023.0],[4699836.0,4551739.0],[4727534.0,4564094.0],[4739429.0,4552772.0],[4761705.0,4547080.0],[4769488.0,4538348.0],[4784816.0,4515904.0],[4748513.0,4460125.0],[4748690.0,4441849.0],[4708275.0,4382150.0],[4712401.0,4358106.0],[4650257.0,4362952.0],[4598508.0,4362773.0],[4594831.0,4323937.0],[4557821.0,4284568.0],[4514173.0,4290444.0],[4494309.0,4326445.0],[4440905.0,4353715.0],[4438332.0,4360687.0],[4424849.0,4454897.0],[4428899.0,4481072.0],[4430967.0,4503389.0],[4445733.0,4529631.0],[4475502.0,4555686.0],[4517889.0,4557693.0],[4520390.0,4592219.0],[4506169.0,4609614.0],[4500553.0,4616549.0],[4525408.0,4674222.0],[4555630.0,4647389.0],[4590782.0,4615337.0],[4650735.0,4562849.0]]]}},{"type":"Feature","properties":{"id":"SE33","CNTR_CODE":"SE","NUTS_NAME":"Övre Norrland","LEVL_CODE":2,"FID":"SE33","NUTS_ID":"SE33","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4744758.0,5136005.0],[4882631.0,5043780.0],[4929426.0,4919019.0],[4939458.0,4857279.0],[4967896.0,4811191.0],[4971227.0,4797935.0],[4915519.0,4784777.0],[4897827.0,4749344.0],[4882949.0,4752631.0],[4865014.0,4706862.0],[4852405.0,4671787.0],[4863192.0,4648472.0],[4866056.0,4612842.0],[4824122.0,4539690.0],[4784816.0,4515904.0],[4769488.0,4538348.0],[4761705.0,4547080.0],[4739429.0,4552772.0],[4727534.0,4564094.0],[4699836.0,4551739.0],[4661349.0,4555023.0],[4650735.0,4562849.0],[4590782.0,4615337.0],[4555630.0,4647389.0],[4525408.0,4674222.0],[4532038.0,4779505.0],[4566979.0,4813266.0],[4563730.0,4830690.0],[4598950.0,4895825.0],[4587372.0,4935277.0],[4605711.0,4987905.0],[4626113.0,5012633.0],[4644415.0,5008080.0],[4659061.0,5021416.0],[4655620.0,5065449.0],[4731700.0,5058529.0],[4736997.0,5130193.0],[4744758.0,5136005.0]]]}},{"type":"Feature","properties":{"id":"SI03","CNTR_CODE":"SI","NUTS_NAME":"Vzhodna Slovenija","LEVL_CODE":2,"FID":"SI03","NUTS_ID":"SI03","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4807826.0,2644114.0],[4827386.0,2618351.0],[4800110.0,2617567.0],[4805669.0,2605574.0],[4773662.0,2591914.0],[4767522.0,2589203.0],[4756288.0,2569025.0],[4763300.0,2557231.0],[4741351.0,2535262.0],[4735901.0,2531543.0],[4730255.0,2493771.0],[4677334.0,2517639.0],[4664447.0,2498010.0],[4643272.0,2494334.0],[4635732.0,2525063.0],[4641876.0,2537424.0],[4676157.0,2530750.0],[4704644.0,2553396.0],[4699953.0,2578566.0],[4672421.0,2594630.0],[4672387.0,2595157.0],[4680270.0,2604354.0],[4708765.0,2628649.0],[4734492.0,2630626.0],[4753009.0,2637824.0],[4763403.0,2638818.0],[4778299.0,2654263.0],[4786948.0,2658725.0],[4807826.0,2644114.0]]]}},{"type":"Feature","properties":{"id":"SI04","CNTR_CODE":"SI","NUTS_NAME":"Zahodna Slovenija","LEVL_CODE":2,"FID":"SI04","NUTS_ID":"SI04","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4704644.0,2553396.0],[4676157.0,2530750.0],[4641876.0,2537424.0],[4635732.0,2525063.0],[4643272.0,2494334.0],[4642725.0,2494425.0],[4606911.0,2489415.0],[4611707.0,2505313.0],[4620628.0,2504938.0],[4625607.0,2510559.0],[4615787.0,2521948.0],[4600791.0,2528447.0],[4600801.0,2529735.0],[4591854.0,2555074.0],[4591449.0,2588075.0],[4604291.0,2598605.0],[4606152.0,2608175.0],[4661893.0,2602364.0],[4672387.0,2595157.0],[4672421.0,2594630.0],[4699953.0,2578566.0],[4704644.0,2553396.0]]]}},{"type":"Feature","properties":{"id":"SK01","CNTR_CODE":"SK","NUTS_NAME":"Bratislavský kraj","LEVL_CODE":2,"FID":"SK01","NUTS_ID":"SK01","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4861009.0,2793005.0],[4854633.0,2791782.0],[4846490.0,2803511.0],[4839233.0,2808803.0],[4827292.0,2837438.0],[4833566.0,2848881.0],[4853815.0,2849144.0],[4872520.0,2831561.0],[4873400.0,2810541.0],[4861009.0,2793005.0]]]}},{"type":"Feature","properties":{"id":"SK02","CNTR_CODE":"SK","NUTS_NAME":"Západné Slovensko","LEVL_CODE":2,"FID":"SK02","NUTS_ID":"SK02","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4982213.0,2784592.0],[4912120.0,2767794.0],[4897845.0,2768465.0],[4861009.0,2793005.0],[4873400.0,2810541.0],[4872520.0,2831561.0],[4853815.0,2849144.0],[4833566.0,2848881.0],[4832035.0,2857837.0],[4863381.0,2882817.0],[4881191.0,2889220.0],[4924769.0,2945551.0],[4968583.0,2886704.0],[4945647.0,2862095.0],[4991118.0,2814757.0],[4985039.0,2811671.0],[4974418.0,2794447.0],[4982213.0,2784592.0]]]}},{"type":"Feature","properties":{"id":"SK03","CNTR_CODE":"SK","NUTS_NAME":"Stredné Slovensko","LEVL_CODE":2,"FID":"SK03","NUTS_ID":"SK03","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5003134.0,2988592.0],[5038951.0,2947340.0],[5051147.0,2915667.0],[5061872.0,2915176.0],[5071615.0,2914749.0],[5092186.0,2871556.0],[5066406.0,2834644.0],[4991118.0,2814757.0],[4945647.0,2862095.0],[4968583.0,2886704.0],[4924769.0,2945551.0],[4929608.0,2955256.0],[4960290.0,2972378.0],[4981147.0,2964054.0],[5003134.0,2988592.0]]]}},{"type":"Feature","properties":{"id":"SK04","CNTR_CODE":"SK","NUTS_NAME":"Východné Slovensko","LEVL_CODE":2,"FID":"SK04","NUTS_ID":"SK04","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5216710.0,2884027.0],[5214660.0,2880854.0],[5159904.0,2891350.0],[5092186.0,2871556.0],[5071615.0,2914749.0],[5061872.0,2915176.0],[5051147.0,2915667.0],[5038951.0,2947340.0],[5056055.0,2957983.0],[5088278.0,2978299.0],[5144084.0,2988537.0],[5234033.0,2964367.0],[5224941.0,2937247.0],[5224307.0,2918986.0],[5215149.0,2903071.0],[5216710.0,2884027.0]]]}},{"type":"Feature","properties":{"id":"DK01","CNTR_CODE":"DK","NUTS_NAME":"Hovedstaden","LEVL_CODE":2,"FID":"DK01","NUTS_ID":"DK01","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4483004.0,3636653.0],[4483443.0,3627096.0],[4494202.0,3619376.0],[4486272.0,3610440.0],[4478645.0,3616398.0],[4470059.0,3612362.0],[4462528.0,3624902.0],[4456015.0,3630030.0],[4438852.0,3627457.0],[4442809.0,3636989.0],[4454857.0,3667686.0],[4477925.0,3664114.0],[4478970.0,3648033.0],[4483004.0,3636653.0]]],[[[4650437.0,3566065.0],[4646834.0,3554928.0],[4637472.0,3554821.0],[4620474.0,3568133.0],[4624297.0,3584536.0],[4635780.0,3578897.0],[4650437.0,3566065.0]]]]}},{"type":"Feature","properties":{"id":"DK02","CNTR_CODE":"DK","NUTS_NAME":"Sjælland","LEVL_CODE":2,"FID":"DK02","NUTS_ID":"DK02","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4442809.0,3636989.0],[4438852.0,3627457.0],[4456015.0,3630030.0],[4462528.0,3624902.0],[4470059.0,3612362.0],[4461580.0,3593304.0],[4466904.0,3569193.0],[4447265.0,3510328.0],[4409463.0,3523908.0],[4415599.0,3550646.0],[4398888.0,3579315.0],[4398650.0,3616063.0],[4416604.0,3640366.0],[4442809.0,3636989.0]]]}},{"type":"Feature","properties":{"id":"DK03","CNTR_CODE":"DK","NUTS_NAME":"Syddanmark","LEVL_CODE":2,"FID":"DK03","NUTS_ID":"DK03","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4283857.0,3525296.0],[4274284.0,3523119.0],[4264046.0,3530123.0],[4249690.0,3532312.0],[4233489.0,3534838.0],[4206730.0,3607914.0],[4207098.0,3636783.0],[4251431.0,3642545.0],[4282654.0,3646836.0],[4289962.0,3635452.0],[4300375.0,3623120.0],[4310655.0,3543740.0],[4296791.0,3530751.0],[4283857.0,3525296.0]]],[[[4377518.0,3548324.0],[4372611.0,3530144.0],[4348493.0,3530953.0],[4340720.0,3530914.0],[4306133.0,3584923.0],[4323871.0,3607135.0],[4364880.0,3604561.0],[4377518.0,3548324.0]]]]}},{"type":"Feature","properties":{"id":"DK04","CNTR_CODE":"DK","NUTS_NAME":"Midtjylland","LEVL_CODE":2,"FID":"DK04","NUTS_ID":"DK04","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4278367.0,3732416.0],[4308435.0,3717615.0],[4333207.0,3731189.0],[4371445.0,3709873.0],[4373684.0,3691339.0],[4317589.0,3625126.0],[4300375.0,3623120.0],[4289962.0,3635452.0],[4282654.0,3646836.0],[4251431.0,3642545.0],[4207098.0,3636783.0],[4209646.0,3718057.0],[4239258.0,3714501.0],[4252908.0,3735150.0],[4278367.0,3732416.0]]]}},{"type":"Feature","properties":{"id":"DK05","CNTR_CODE":"DK","NUTS_NAME":"Nordjylland","LEVL_CODE":2,"FID":"DK05","NUTS_ID":"DK05","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4333207.0,3731189.0],[4308435.0,3717615.0],[4278367.0,3732416.0],[4264071.0,3758783.0],[4253282.0,3758474.0],[4242406.0,3736611.0],[4218669.0,3749597.0],[4237985.0,3778485.0],[4253632.0,3780310.0],[4337943.0,3832935.0],[4350873.0,3805523.0],[4333207.0,3731189.0]]]}},{"type":"Feature","properties":{"id":"EL30","CNTR_CODE":"EL","NUTS_NAME":"Aττική","LEVL_CODE":2,"FID":"EL30","NUTS_ID":"EL30","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5532122.0,1750830.0],[5524357.0,1759295.0],[5516523.0,1766109.0],[5504508.0,1764940.0],[5481335.0,1752736.0],[5474074.0,1763692.0],[5472996.0,1775581.0],[5516325.0,1788085.0],[5518880.0,1803024.0],[5546712.0,1796330.0],[5548723.0,1780525.0],[5560887.0,1739450.0],[5532122.0,1750830.0]]],[[[5504351.0,1579442.0],[5502336.0,1541086.0],[5482693.0,1550479.0],[5477582.0,1574866.0],[5504351.0,1579442.0]]],[[[5510477.0,1702306.0],[5488662.0,1713642.0],[5499344.0,1717588.0],[5496203.0,1734035.0],[5506721.0,1735910.0],[5510477.0,1702306.0]]]]}},{"type":"Feature","properties":{"id":"EL41","CNTR_CODE":"EL","NUTS_NAME":"Βόρειο Αιγαίο","LEVL_CODE":2,"FID":"EL41","NUTS_ID":"EL41","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5752924.0,1769872.0],[5787230.0,1775005.0],[5780021.0,1792273.0],[5802592.0,1805812.0],[5817737.0,1795306.0],[5796629.0,1758861.0],[5759899.0,1755539.0],[5752924.0,1769872.0]]],[[[5729877.0,1958322.0],[5741416.0,1940614.0],[5740734.0,1920089.0],[5717914.0,1918179.0],[5714085.0,1937831.0],[5703903.0,1925096.0],[5687318.0,1933626.0],[5690806.0,1942674.0],[5729877.0,1958322.0]]],[[[5731824.0,1842012.0],[5722775.0,1822222.0],[5712642.0,1830971.0],[5716012.0,1847459.0],[5699493.0,1861229.0],[5712726.0,1870825.0],[5727390.0,1868252.0],[5731824.0,1842012.0]]],[[[5620095.0,2016374.0],[5628488.0,1983296.0],[5601725.0,1984453.0],[5597467.0,2004466.0],[5620095.0,2016374.0]]]]}},{"type":"Feature","properties":{"id":"EL42","CNTR_CODE":"EL","NUTS_NAME":"Νότιο Αιγαίο","LEVL_CODE":2,"FID":"EL42","NUTS_ID":"EL42","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5946892.0,1642818.0],[5932149.0,1617118.0],[5919815.0,1614900.0],[5913572.0,1634881.0],[5910781.0,1650777.0],[5942015.0,1672627.0],[5946892.0,1642818.0]]],[[[5708788.0,1703806.0],[5716324.0,1677820.0],[5699206.0,1671426.0],[5689133.0,1687844.0],[5674014.0,1672224.0],[5660024.0,1679253.0],[5666955.0,1699892.0],[5708788.0,1703806.0]]],[[[5722954.0,1624872.0],[5716151.0,1602802.0],[5685436.0,1622599.0],[5704893.0,1640638.0],[5722954.0,1624872.0]]],[[[5646438.0,1779321.0],[5643831.0,1751145.0],[5612028.0,1767654.0],[5626905.0,1786614.0],[5646438.0,1779321.0]]]]}},{"type":"Feature","properties":{"id":"EL43","CNTR_CODE":"EL","NUTS_NAME":"Κρήτη","LEVL_CODE":2,"FID":"EL43","NUTS_ID":"EL43","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5627380.0,1488246.0],[5681342.0,1504585.0],[5733951.0,1502942.0],[5800945.0,1502612.0],[5795153.0,1485787.0],[5745263.0,1470712.0],[5684918.0,1454671.0],[5668626.0,1466863.0],[5627846.0,1468434.0],[5568031.0,1465584.0],[5558465.0,1476241.0],[5564777.0,1492092.0],[5603985.0,1506606.0],[5627380.0,1488246.0]]]}},{"type":"Feature","properties":{"id":"EL51","CNTR_CODE":"EL","NUTS_NAME":"Aνατολική Μακεδονία, Θράκη","LEVL_CODE":2,"FID":"EL51","NUTS_ID":"EL51","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5670221.0,2102712.0],[5634310.0,2110076.0],[5590945.0,2115570.0],[5566631.0,2095682.0],[5560640.0,2071344.0],[5540871.0,2095945.0],[5489626.0,2071908.0],[5506159.0,2100667.0],[5458423.0,2133421.0],[5491534.0,2156084.0],[5526579.0,2165243.0],[5554204.0,2149957.0],[5587713.0,2151062.0],[5592371.0,2146860.0],[5647445.0,2163287.0],[5650630.0,2165420.0],[5675519.0,2215229.0],[5701097.0,2187851.0],[5670221.0,2102712.0]]],[[[5653962.0,2058109.0],[5635578.0,2045419.0],[5624704.0,2060110.0],[5629116.0,2079460.0],[5648199.0,2078565.0],[5653962.0,2058109.0]]]]}},{"type":"Feature","properties":{"id":"EL52","CNTR_CODE":"EL","NUTS_NAME":"Κεντρική Μακεδονία","LEVL_CODE":2,"FID":"EL52","NUTS_ID":"EL52","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5458423.0,2133421.0],[5506159.0,2100667.0],[5489626.0,2071908.0],[5481467.0,2068050.0],[5483053.0,2054452.0],[5480097.0,2017692.0],[5452305.0,2001760.0],[5425133.0,2012116.0],[5395086.0,2027025.0],[5394172.0,2022670.0],[5390662.0,1986516.0],[5402932.0,1966144.0],[5353881.0,1980466.0],[5356964.0,1995266.0],[5327527.0,2033117.0],[5320242.0,2033600.0],[5313655.0,2058838.0],[5322793.0,2079259.0],[5345488.0,2090788.0],[5355938.0,2086870.0],[5397537.0,2118651.0],[5401576.0,2119112.0],[5444429.0,2133892.0],[5458423.0,2133421.0]]],[[[5514374.0,2008579.0],[5521544.0,1982032.0],[5497392.0,1981817.0],[5485349.0,2006014.0],[5514374.0,2008579.0]]]]}},{"type":"Feature","properties":{"id":"EL53","CNTR_CODE":"EL","NUTS_NAME":"Δυτική Μακεδονία","LEVL_CODE":2,"FID":"EL53","NUTS_ID":"EL53","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5353881.0,1980466.0],[5341675.0,1942364.0],[5288773.0,1934807.0],[5271267.0,1939801.0],[5259658.0,1963657.0],[5237775.0,1982254.0],[5257241.0,2015038.0],[5247353.0,2040321.0],[5313655.0,2058838.0],[5320242.0,2033600.0],[5327527.0,2033117.0],[5356964.0,1995266.0],[5353881.0,1980466.0]]]}},{"type":"Feature","properties":{"id":"EL54","CNTR_CODE":"EL","NUTS_NAME":"Ήπειρος","LEVL_CODE":2,"FID":"EL54","NUTS_ID":"EL54","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5288773.0,1934807.0],[5284352.0,1894310.0],[5305580.0,1861000.0],[5284757.0,1843548.0],[5249808.0,1838938.0],[5227287.0,1860860.0],[5181590.0,1901159.0],[5204902.0,1917791.0],[5212815.0,1916170.0],[5209461.0,1937387.0],[5227594.0,1950737.0],[5237775.0,1982254.0],[5259658.0,1963657.0],[5271267.0,1939801.0],[5288773.0,1934807.0]]]}},{"type":"Feature","properties":{"id":"EL61","CNTR_CODE":"EL","NUTS_NAME":"Θεσσαλία","LEVL_CODE":2,"FID":"EL61","NUTS_ID":"EL61","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5402932.0,1966144.0],[5430523.0,1929121.0],[5449490.0,1907782.0],[5445167.0,1861252.0],[5403354.0,1871555.0],[5379932.0,1883573.0],[5355819.0,1856517.0],[5332402.0,1869913.0],[5307743.0,1860223.0],[5305580.0,1861000.0],[5284352.0,1894310.0],[5288773.0,1934807.0],[5341675.0,1942364.0],[5353881.0,1980466.0],[5402932.0,1966144.0]]],[[[5541785.0,1880286.0],[5525805.0,1866517.0],[5513241.0,1887784.0],[5538367.0,1912122.0],[5541785.0,1880286.0]]]]}},{"type":"Feature","properties":{"id":"EL62","CNTR_CODE":"EL","NUTS_NAME":"Ιόνια Νησιά","LEVL_CODE":2,"FID":"EL62","NUTS_ID":"EL62","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5233555.0,1743039.0],[5242977.0,1768759.0],[5258661.0,1773480.0],[5264108.0,1730539.0],[5233555.0,1743039.0]]],[[[5289612.0,1699542.0],[5283990.0,1683128.0],[5253064.0,1703315.0],[5262293.0,1724217.0],[5289612.0,1699542.0]]],[[[5267790.0,1797657.0],[5238463.0,1778736.0],[5241114.0,1811624.0],[5253416.0,1823474.0],[5267790.0,1797657.0]]],[[[5172421.0,1885690.0],[5159431.0,1883576.0],[5140741.0,1905524.0],[5160423.0,1916811.0],[5173007.0,1910016.0],[5172421.0,1885690.0]]],[[[5323298.0,1642764.0],[5297380.0,1628417.0],[5280023.0,1641772.0],[5311962.0,1661822.0],[5323298.0,1642764.0]]]]}},{"type":"Feature","properties":{"id":"EL63","CNTR_CODE":"EL","NUTS_NAME":"Δυτική Ελλάδα","LEVL_CODE":2,"FID":"EL63","NUTS_ID":"EL63","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5407983.0,1761674.0],[5403331.0,1727026.0],[5385931.0,1717810.0],[5370170.0,1724724.0],[5382689.0,1683985.0],[5359181.0,1668490.0],[5339112.0,1689276.0],[5310700.0,1715306.0],[5319575.0,1743336.0],[5361530.0,1770217.0],[5407983.0,1761674.0]]],[[[5360855.0,1825872.0],[5365704.0,1824919.0],[5359044.0,1779807.0],[5303207.0,1769046.0],[5258027.0,1819145.0],[5284757.0,1843548.0],[5305580.0,1861000.0],[5307743.0,1860223.0],[5332825.0,1830234.0],[5340404.0,1814958.0],[5360855.0,1825872.0]]]]}},{"type":"Feature","properties":{"id":"EL64","CNTR_CODE":"EL","NUTS_NAME":"Στερεά Ελλάδα","LEVL_CODE":2,"FID":"EL64","NUTS_ID":"EL64","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5403354.0,1871555.0],[5445167.0,1861252.0],[5433921.0,1841243.0],[5488623.0,1818402.0],[5496224.0,1816735.0],[5494944.0,1845212.0],[5547412.0,1825536.0],[5543952.0,1811812.0],[5515660.0,1803759.0],[5518880.0,1803024.0],[5516325.0,1788085.0],[5472996.0,1775581.0],[5452024.0,1777729.0],[5424908.0,1788694.0],[5376410.0,1784530.0],[5359044.0,1779807.0],[5365704.0,1824919.0],[5360855.0,1825872.0],[5340404.0,1814958.0],[5332825.0,1830234.0],[5307743.0,1860223.0],[5332402.0,1869913.0],[5355819.0,1856517.0],[5379932.0,1883573.0],[5403354.0,1871555.0]]],[[[5601404.0,1793566.0],[5588763.0,1767929.0],[5558149.0,1782727.0],[5567323.0,1795253.0],[5601404.0,1793566.0]]]]}},{"type":"Feature","properties":{"id":"ITI3","CNTR_CODE":"IT","NUTS_NAME":"Marche","LEVL_CODE":2,"FID":"ITI3","NUTS_ID":"ITI3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4542187.0,2321830.0],[4577064.0,2298876.0],[4616324.0,2270014.0],[4625431.0,2250490.0],[4625722.0,2249913.0],[4626261.0,2248711.0],[4626751.0,2247578.0],[4627358.0,2246296.0],[4627654.0,2245721.0],[4628255.0,2244616.0],[4628558.0,2244105.0],[4629808.0,2240147.0],[4631030.0,2237181.0],[4631634.0,2236266.0],[4632308.0,2234299.0],[4633317.0,2232322.0],[4634480.0,2229759.0],[4634828.0,2228808.0],[4634998.0,2227229.0],[4635294.0,2225750.0],[4641630.0,2206987.0],[4597069.0,2182063.0],[4582894.0,2186358.0],[4586077.0,2201360.0],[4562209.0,2212746.0],[4554181.0,2238160.0],[4545500.0,2265401.0],[4500143.0,2280639.0],[4505311.0,2297879.0],[4518296.0,2312960.0],[4518519.0,2312665.0],[4519277.0,2312612.0],[4519783.0,2312942.0],[4521281.0,2312977.0],[4521700.0,2314146.0],[4542187.0,2321830.0]]]}},{"type":"Feature","properties":{"id":"ITI4","CNTR_CODE":"IT","NUTS_NAME":"Lazio","LEVL_CODE":2,"FID":"ITI4","NUTS_ID":"ITI4","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4476384.0,2193961.0],[4522908.0,2147016.0],[4535792.0,2149113.0],[4559325.0,2172420.0],[4582894.0,2186358.0],[4597069.0,2182063.0],[4600364.0,2171343.0],[4587013.0,2162844.0],[4586274.0,2148744.0],[4589589.0,2129406.0],[4572443.0,2117415.0],[4595224.0,2099896.0],[4640645.0,2078169.0],[4650207.0,2073654.0],[4654502.0,2048895.0],[4646425.0,2034721.0],[4637532.0,2021521.0],[4553746.0,2039279.0],[4513774.0,2073012.0],[4464783.0,2118744.0],[4440807.0,2142554.0],[4464291.0,2188250.0],[4476384.0,2193961.0]],[[4517770.0,2089869.0],[4520216.0,2088254.0],[4530802.0,2089645.0],[4528137.0,2098003.0],[4523439.0,2096238.0],[4517770.0,2089869.0]]]}},{"type":"Feature","properties":{"id":"LT01","CNTR_CODE":"LT","NUTS_NAME":"Sostinės regionas","LEVL_CODE":2,"FID":"LT01","NUTS_ID":"LT01","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5374609.0,3696417.0],[5371401.0,3683816.0],[5351502.0,3675907.0],[5347478.0,3660179.0],[5334162.0,3651099.0],[5326370.0,3631446.0],[5331054.0,3607862.0],[5334688.0,3564717.0],[5282724.0,3548285.0],[5275983.0,3572044.0],[5247190.0,3584760.0],[5251858.0,3628240.0],[5228767.0,3678703.0],[5239782.0,3695432.0],[5292752.0,3653342.0],[5325868.0,3687173.0],[5374609.0,3696417.0]]]}},{"type":"Feature","properties":{"id":"LT02","CNTR_CODE":"LT","NUTS_NAME":"Vidurio ir vakarų Lietuvos regionas ","LEVL_CODE":2,"FID":"LT02","NUTS_ID":"LT02","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5114449.0,3771207.0],[5130157.0,3766126.0],[5192242.0,3769546.0],[5231737.0,3790696.0],[5298223.0,3769133.0],[5314580.0,3760462.0],[5356924.0,3740091.0],[5374609.0,3696417.0],[5325868.0,3687173.0],[5292752.0,3653342.0],[5239782.0,3695432.0],[5228767.0,3678703.0],[5251858.0,3628240.0],[5247190.0,3584760.0],[5275983.0,3572044.0],[5282724.0,3548285.0],[5264628.0,3519689.0],[5202339.0,3510354.0],[5183760.0,3540552.0],[5147704.0,3546424.0],[5140298.0,3597576.0],[5120797.0,3621729.0],[5059830.0,3623763.0],[5041851.0,3630961.0],[5034954.0,3627178.0],[5009299.0,3698293.0],[5007411.0,3715790.0],[5057504.0,3759611.0],[5097787.0,3764687.0],[5114449.0,3771207.0]]]}},{"type":"Feature","properties":{"id":"NL11","CNTR_CODE":"NL","NUTS_NAME":"Groningen","LEVL_CODE":2,"FID":"NL11","NUTS_ID":"NL11","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4134708.0,3351905.0],[4133736.0,3337488.0],[4125135.0,3307187.0],[4115299.0,3324875.0],[4107505.0,3333865.0],[4084820.0,3349316.0],[4074259.0,3338002.0],[4065387.0,3345750.0],[4069681.0,3356177.0],[4067838.0,3373652.0],[4085029.0,3374111.0],[4113226.0,3371155.0],[4127371.0,3353524.0],[4134708.0,3351905.0]]]}},{"type":"Feature","properties":{"id":"NL12","CNTR_CODE":"NL","NUTS_NAME":"Friesland (NL)","LEVL_CODE":2,"FID":"NL12","NUTS_ID":"NL12","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4037609.0,3307942.0],[4009190.0,3305020.0],[3996616.0,3332178.0],[4014218.0,3347858.0],[4022187.0,3358880.0],[4046789.0,3371595.0],[4067838.0,3373652.0],[4069681.0,3356177.0],[4065387.0,3345750.0],[4074259.0,3338002.0],[4076895.0,3318692.0],[4059751.0,3312033.0],[4039340.0,3309048.0],[4037609.0,3307942.0]]]}},{"type":"Feature","properties":{"id":"NL13","CNTR_CODE":"NL","NUTS_NAME":"Drenthe","LEVL_CODE":2,"FID":"NL13","NUTS_ID":"NL13","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4125135.0,3307187.0],[4118394.0,3285247.0],[4098288.0,3284898.0],[4093074.0,3289798.0],[4081674.0,3285200.0],[4067227.0,3293191.0],[4059751.0,3312033.0],[4076895.0,3318692.0],[4074259.0,3338002.0],[4084820.0,3349316.0],[4107505.0,3333865.0],[4115299.0,3324875.0],[4125135.0,3307187.0]]]}},{"type":"Feature","properties":{"id":"NL21","CNTR_CODE":"NL","NUTS_NAME":"Overijssel","LEVL_CODE":2,"FID":"NL21","NUTS_ID":"NL21","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4093074.0,3289798.0],[4098288.0,3284898.0],[4096766.0,3269198.0],[4117147.0,3258660.0],[4120624.0,3240895.0],[4099187.0,3228125.0],[4074003.0,3243519.0],[4059213.0,3242600.0],[4056601.0,3266092.0],[4040429.0,3275634.0],[4037609.0,3307942.0],[4039340.0,3309048.0],[4059751.0,3312033.0],[4067227.0,3293191.0],[4081674.0,3285200.0],[4093074.0,3289798.0]]]}},{"type":"Feature","properties":{"id":"NL22","CNTR_CODE":"NL","NUTS_NAME":"Gelderland","LEVL_CODE":2,"FID":"NL22","NUTS_ID":"NL22","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4056601.0,3266092.0],[4059213.0,3242600.0],[4074003.0,3243519.0],[4099187.0,3228125.0],[4092852.0,3207674.0],[4073466.0,3196970.0],[4057369.0,3205893.0],[4041681.0,3189694.0],[4035672.0,3191097.0],[4017728.0,3200028.0],[3984742.0,3192039.0],[3976591.0,3201887.0],[3987665.0,3213690.0],[4019060.0,3212788.0],[4007396.0,3247675.0],[4040429.0,3275634.0],[4056601.0,3266092.0]]]}},{"type":"Feature","properties":{"id":"NL23","CNTR_CODE":"NL","NUTS_NAME":"Flevoland","LEVL_CODE":2,"FID":"NL23","NUTS_ID":"NL23","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4040429.0,3275634.0],[4007396.0,3247675.0],[4002974.0,3252483.0],[3986272.0,3264566.0],[3986443.0,3285784.0],[4009190.0,3305020.0],[4037609.0,3307942.0],[4040429.0,3275634.0]]]}},{"type":"Feature","properties":{"id":"NL31","CNTR_CODE":"NL","NUTS_NAME":"Utrecht","LEVL_CODE":2,"FID":"NL31","NUTS_ID":"NL31","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4002974.0,3252483.0],[4007396.0,3247675.0],[4019060.0,3212788.0],[3987665.0,3213690.0],[3969073.0,3215453.0],[3965655.0,3247934.0],[3981701.0,3255265.0],[3985896.0,3244430.0],[4002974.0,3252483.0]]]}},{"type":"Feature","properties":{"id":"NL32","CNTR_CODE":"NL","NUTS_NAME":"Noord-Holland","LEVL_CODE":2,"FID":"NL32","NUTS_ID":"NL32","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3986272.0,3264566.0],[4002974.0,3252483.0],[3985896.0,3244430.0],[3981701.0,3255265.0],[3965655.0,3247934.0],[3961039.0,3246380.0],[3953917.0,3258485.0],[3946031.0,3260714.0],[3951477.0,3272491.0],[3955930.0,3287338.0],[3960097.0,3307432.0],[3971474.0,3356964.0],[3996616.0,3332178.0],[4009190.0,3305020.0],[3986443.0,3285784.0],[3986272.0,3264566.0]]]}},{"type":"Feature","properties":{"id":"NL33","CNTR_CODE":"NL","NUTS_NAME":"Zuid-Holland","LEVL_CODE":2,"FID":"NL33","NUTS_ID":"NL33","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3953917.0,3258485.0],[3961039.0,3246380.0],[3965655.0,3247934.0],[3969073.0,3215453.0],[3987665.0,3213690.0],[3976591.0,3201887.0],[3953520.0,3192809.0],[3949582.0,3191894.0],[3922965.0,3186450.0],[3896191.0,3201061.0],[3918217.0,3226298.0],[3923498.0,3231860.0],[3936687.0,3245669.0],[3946031.0,3260714.0],[3953917.0,3258485.0]]]}},{"type":"Feature","properties":{"id":"NL34","CNTR_CODE":"NL","NUTS_NAME":"Zeeland","LEVL_CODE":2,"FID":"NL34","NUTS_ID":"NL34","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[3923162.0,3156164.0],[3920660.0,3156218.0],[3883443.0,3175162.0],[3896191.0,3201061.0],[3922965.0,3186450.0],[3923162.0,3156164.0]]],[[[3900841.0,3141114.0],[3892268.0,3140258.0],[3859809.0,3150169.0],[3859737.0,3160855.0],[3919814.0,3153328.0],[3900841.0,3141114.0]]]]}},{"type":"Feature","properties":{"id":"NL41","CNTR_CODE":"NL","NUTS_NAME":"Noord-Brabant","LEVL_CODE":2,"FID":"NL41","NUTS_ID":"NL41","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4035672.0,3191097.0],[4032595.0,3169988.0],[4031358.0,3145587.0],[4011460.0,3132703.0],[3988851.0,3138674.0],[3980659.0,3157888.0],[3957507.0,3167694.0],[3950634.0,3159703.0],[3923162.0,3156164.0],[3922965.0,3186450.0],[3949582.0,3191894.0],[3953520.0,3192809.0],[3976591.0,3201887.0],[3984742.0,3192039.0],[4017728.0,3200028.0],[4035672.0,3191097.0]]]}},{"type":"Feature","properties":{"id":"NL42","CNTR_CODE":"NL","NUTS_NAME":"Limburg (NL)","LEVL_CODE":2,"FID":"NL42","NUTS_ID":"NL42","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4040360.0,3079039.0],[4025884.0,3075419.0],[4017252.0,3086773.0],[4024033.0,3108311.0],[4026611.0,3113862.0],[4011460.0,3132703.0],[4031358.0,3145587.0],[4032595.0,3169988.0],[4035672.0,3191097.0],[4041681.0,3189694.0],[4058181.0,3146141.0],[4046900.0,3133098.0],[4053685.0,3126266.0],[4031952.0,3110464.0],[4045945.0,3096437.0],[4040360.0,3079039.0]]]}},{"type":"Feature","properties":{"id":"CY0","CNTR_CODE":"CY","NUTS_NAME":"ΚΥΠΡΟΣ","LEVL_CODE":1,"FID":"CY0","NUTS_ID":"CY0","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[6467380.0,1643362.0],[6413299.0,1602176.0],[6378263.0,1596715.0],[6357016.0,1609133.0],[6357268.0,1635313.0],[6400291.0,1678043.0],[6483594.0,1715913.0],[6487898.0,1674176.0],[6467380.0,1643362.0]]],[[[6543487.0,1781986.0],[6522804.0,1733815.0],[6513551.0,1741191.0],[6523476.0,1783397.0],[6543487.0,1781986.0]]]]}},{"type":"Feature","properties":{"id":"DE1","CNTR_CODE":"DE","NUTS_NAME":"BADEN-WÜRTTEMBERG","LEVL_CODE":1,"FID":"DE1","NUTS_ID":"DE1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4295704.0,2964381.0],[4316898.0,2934409.0],[4327060.0,2936754.0],[4329578.0,2928930.0],[4329131.0,2919116.0],[4339771.0,2882960.0],[4351012.0,2873888.0],[4352171.0,2847997.0],[4356882.0,2842709.0],[4341565.0,2822558.0],[4338058.0,2821924.0],[4330908.0,2815722.0],[4323419.0,2815972.0],[4320822.0,2804070.0],[4328097.0,2783390.0],[4331167.0,2777220.0],[4329587.0,2762526.0],[4328785.0,2762313.0],[4329233.0,2758179.0],[4330885.0,2745173.0],[4326812.0,2725076.0],[4297839.0,2721916.0],[4287757.0,2714352.0],[4283009.0,2715445.0],[4259528.0,2727259.0],[4221123.0,2731036.0],[4220592.0,2731160.0],[4217105.0,2744026.0],[4209278.0,2741412.0],[4209312.0,2724853.0],[4202526.0,2718363.0],[4162515.0,2721450.0],[4148793.0,2716636.0],[4142867.0,2719236.0],[4139577.0,2722540.0],[4136890.0,2739717.0],[4140149.0,2758618.0],[4140556.0,2780970.0],[4140623.0,2781606.0],[4148737.0,2796455.0],[4170833.0,2847105.0],[4191568.0,2874149.0],[4193703.0,2875694.0],[4194902.0,2876669.0],[4199707.0,2886591.0],[4205447.0,2905334.0],[4209447.0,2908937.0],[4210939.0,2909690.0],[4209211.0,2912147.0],[4211940.0,2923163.0],[4210213.0,2926776.0],[4206859.0,2937782.0],[4206908.0,2941381.0],[4206911.0,2942404.0],[4218269.0,2935098.0],[4243571.0,2929204.0],[4254631.0,2935221.0],[4256118.0,2940916.0],[4278465.0,2950260.0],[4282931.0,2963150.0],[4295704.0,2964381.0]]]}},{"type":"Feature","properties":{"id":"DE2","CNTR_CODE":"DE","NUTS_NAME":"BAYERN","LEVL_CODE":1,"FID":"DE2","NUTS_ID":"DE2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4353033.0,3032305.0],[4364539.0,3013049.0],[4373034.0,3013351.0],[4388261.0,3030928.0],[4405836.0,3018360.0],[4410857.0,3041610.0],[4426267.0,3036581.0],[4434993.0,3033109.0],[4457382.0,3036536.0],[4470617.0,3025026.0],[4475192.0,3014234.0],[4482882.0,2996473.0],[4504236.0,2980139.0],[4494031.0,2963467.0],[4508712.0,2939911.0],[4511864.0,2932679.0],[4552189.0,2900592.0],[4571072.0,2879895.0],[4581003.0,2879001.0],[4603174.0,2858273.0],[4600313.0,2851667.0],[4596342.0,2829134.0],[4579900.0,2836890.0],[4579671.0,2836836.0],[4579445.0,2836171.0],[4579715.0,2835385.0],[4579578.0,2834989.0],[4578832.0,2834530.0],[4578695.0,2834034.0],[4578257.0,2833744.0],[4577590.0,2833819.0],[4577521.0,2832997.0],[4576657.0,2832784.0],[4576130.0,2833244.0],[4556759.0,2802949.0],[4539907.0,2792493.0],[4525936.0,2781512.0],[4534509.0,2768916.0],[4535816.0,2765182.0],[4542425.0,2755743.0],[4550493.0,2716599.0],[4523483.0,2733535.0],[4514604.0,2727669.0],[4496572.0,2734271.0],[4475985.0,2724950.0],[4460729.0,2722685.0],[4443880.0,2721226.0],[4427326.0,2710092.0],[4428275.0,2704501.0],[4397790.0,2698612.0],[4395879.0,2698560.0],[4387766.0,2714092.0],[4355225.0,2715903.0],[4352657.0,2697260.0],[4334507.0,2684075.0],[4320964.0,2707712.0],[4318575.0,2714737.0],[4287757.0,2714352.0],[4297839.0,2721916.0],[4326812.0,2725076.0],[4330885.0,2745173.0],[4329233.0,2758179.0],[4328785.0,2762313.0],[4329587.0,2762526.0],[4331167.0,2777220.0],[4328097.0,2783390.0],[4320822.0,2804070.0],[4323419.0,2815972.0],[4330908.0,2815722.0],[4338058.0,2821924.0],[4341565.0,2822558.0],[4356882.0,2842709.0],[4352171.0,2847997.0],[4351012.0,2873888.0],[4339771.0,2882960.0],[4329131.0,2919116.0],[4329578.0,2928930.0],[4327060.0,2936754.0],[4316898.0,2934409.0],[4295704.0,2964381.0],[4282931.0,2963150.0],[4278465.0,2950260.0],[4256118.0,2940916.0],[4251664.0,2970895.0],[4252699.0,2973085.0],[4250439.0,2987020.0],[4248723.0,2995473.0],[4268152.0,3003455.0],[4278414.0,2997441.0],[4294108.0,3013054.0],[4301992.0,3027157.0],[4316427.0,3034183.0],[4323932.0,3044956.0],[4353033.0,3032305.0]]]}},{"type":"Feature","properties":{"id":"DE3","CNTR_CODE":"DE","NUTS_NAME":"BERLIN","LEVL_CODE":1,"FID":"DE3","NUTS_ID":"DE3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4565855.0,3276636.0],[4570054.0,3269038.0],[4572823.0,3258448.0],[4553875.0,3257338.0],[4546341.0,3259545.0],[4536437.0,3258557.0],[4535086.0,3270478.0],[4535330.0,3281303.0],[4550928.0,3287499.0],[4565855.0,3276636.0]]]}},{"type":"Feature","properties":{"id":"DE4","CNTR_CODE":"DE","NUTS_NAME":"BRANDENBURG","LEVL_CODE":1,"FID":"DE4","NUTS_ID":"DE4","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4614776.0,3366892.0],[4599282.0,3324914.0],[4600578.0,3317655.0],[4620842.0,3294804.0],[4629911.0,3289188.0],[4629436.0,3263564.0],[4634822.0,3250189.0],[4646803.0,3228427.0],[4644665.0,3220610.0],[4648591.0,3174086.0],[4629350.0,3168446.0],[4609663.0,3167169.0],[4587903.0,3147670.0],[4577903.0,3146845.0],[4544296.0,3148678.0],[4532108.0,3175213.0],[4537996.0,3199068.0],[4511258.0,3211309.0],[4483990.0,3217678.0],[4476969.0,3224011.0],[4478496.0,3263035.0],[4468427.0,3268541.0],[4472708.0,3300460.0],[4464133.0,3311150.0],[4445938.0,3312755.0],[4428178.0,3326451.0],[4405739.0,3335587.0],[4475923.0,3359511.0],[4476378.0,3359160.0],[4520568.0,3343737.0],[4537383.0,3351969.0],[4567221.0,3380885.0],[4614776.0,3366892.0]],[[4535086.0,3270478.0],[4536437.0,3258557.0],[4546341.0,3259545.0],[4553875.0,3257338.0],[4572823.0,3258448.0],[4570054.0,3269038.0],[4565855.0,3276636.0],[4550928.0,3287499.0],[4535330.0,3281303.0],[4535086.0,3270478.0]]]}},{"type":"Feature","properties":{"id":"DE5","CNTR_CODE":"DE","NUTS_NAME":"BREMEN","LEVL_CODE":1,"FID":"DE5","NUTS_ID":"DE5","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4252998.0,3335779.0],[4248229.0,3323044.0],[4234578.0,3327007.0],[4230921.0,3334223.0],[4219844.0,3347604.0],[4252998.0,3335779.0]]],[[[4220906.0,3374886.0],[4225157.0,3380667.0],[4223057.0,3389734.0],[4229260.0,3382600.0],[4220906.0,3374886.0]]]]}},{"type":"Feature","properties":{"id":"DE6","CNTR_CODE":"DE","NUTS_NAME":"HAMBURG","LEVL_CODE":1,"FID":"DE6","NUTS_ID":"DE6","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4341470.0,3369525.0],[4314598.0,3369360.0],[4305662.0,3377527.0],[4303112.0,3383356.0],[4317388.0,3393935.0],[4326001.0,3400558.0],[4336709.0,3376535.0],[4341470.0,3369525.0]]],[[[4236123.0,3426692.0],[4220741.0,3412520.0],[4210703.0,3415765.0],[4221198.0,3439473.0],[4236123.0,3426692.0]]]]}},{"type":"Feature","properties":{"id":"DE7","CNTR_CODE":"DE","NUTS_NAME":"HESSEN","LEVL_CODE":1,"FID":"DE7","NUTS_ID":"DE7","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4299189.0,3163541.0],[4298462.0,3133631.0],[4316010.0,3140497.0],[4335467.0,3119972.0],[4335697.0,3114793.0],[4322514.0,3097958.0],[4315792.0,3072869.0],[4326487.0,3058434.0],[4323932.0,3044956.0],[4316427.0,3034183.0],[4301992.0,3027157.0],[4294108.0,3013054.0],[4278414.0,2997441.0],[4268152.0,3003455.0],[4248723.0,2995473.0],[4250439.0,2987020.0],[4252699.0,2973085.0],[4251664.0,2970895.0],[4256118.0,2940916.0],[4254631.0,2935221.0],[4243571.0,2929204.0],[4218269.0,2935098.0],[4206911.0,2942404.0],[4206384.0,2943713.0],[4208936.0,2958700.0],[4209059.0,2958914.0],[4209168.0,2959145.0],[4205818.0,2966931.0],[4202053.0,2982236.0],[4198261.0,2988401.0],[4191329.0,2993035.0],[4190259.0,2992946.0],[4171106.0,2987851.0],[4161637.0,2997328.0],[4187131.0,3020058.0],[4176810.0,3034687.0],[4190142.0,3055828.0],[4188559.0,3065487.0],[4205226.0,3084692.0],[4214087.0,3096412.0],[4219379.0,3111083.0],[4249535.0,3155626.0],[4262279.0,3148330.0],[4282274.0,3171250.0],[4299189.0,3163541.0]]]}},{"type":"Feature","properties":{"id":"DE8","CNTR_CODE":"DE","NUTS_NAME":"MECKLENBURG-VORPOMMERN","LEVL_CODE":1,"FID":"DE8","NUTS_ID":"DE8","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4602721.0,3407226.0],[4614776.0,3366892.0],[4567221.0,3380885.0],[4537383.0,3351969.0],[4520568.0,3343737.0],[4476378.0,3359160.0],[4475923.0,3359511.0],[4405739.0,3335587.0],[4399392.0,3339338.0],[4390919.0,3350157.0],[4360616.0,3361935.0],[4383955.0,3393756.0],[4371265.0,3411806.0],[4380329.0,3428122.0],[4423357.0,3436787.0],[4451512.0,3453831.0],[4464497.0,3461971.0],[4469893.0,3465507.0],[4531388.0,3500547.0],[4551178.0,3486755.0],[4537622.0,3459062.0],[4598483.0,3432718.0],[4598024.0,3425759.0],[4591127.0,3414093.0],[4602721.0,3407226.0]]]}},{"type":"Feature","properties":{"id":"DE9","CNTR_CODE":"DE","NUTS_NAME":"NIEDERSACHSEN","LEVL_CODE":1,"FID":"DE9","NUTS_ID":"DE9","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4256375.0,3414615.0],[4273210.0,3418043.0],[4287047.0,3400145.0],[4303112.0,3383356.0],[4305662.0,3377527.0],[4314598.0,3369360.0],[4341470.0,3369525.0],[4352221.0,3364313.0],[4360616.0,3361935.0],[4390919.0,3350157.0],[4399392.0,3339338.0],[4405739.0,3335587.0],[4428178.0,3326451.0],[4422178.0,3315760.0],[4377693.0,3305156.0],[4372219.0,3298822.0],[4389510.0,3265749.0],[4384505.0,3262905.0],[4387148.0,3216740.0],[4375985.0,3215643.0],[4359540.0,3210601.0],[4369551.0,3170422.0],[4367887.0,3169982.0],[4354869.0,3162802.0],[4316010.0,3140497.0],[4298462.0,3133631.0],[4299189.0,3163541.0],[4282274.0,3171250.0],[4280669.0,3170915.0],[4274380.0,3194089.0],[4273455.0,3201627.0],[4263136.0,3221221.0],[4251654.0,3232135.0],[4261478.0,3256200.0],[4232926.0,3266469.0],[4205260.0,3262149.0],[4216298.0,3240880.0],[4212132.0,3223996.0],[4190451.0,3218063.0],[4176050.0,3221372.0],[4175415.0,3246353.0],[4158497.0,3265415.0],[4137969.0,3244557.0],[4122915.0,3240990.0],[4120624.0,3240895.0],[4117147.0,3258660.0],[4096766.0,3269198.0],[4098288.0,3284898.0],[4118394.0,3285247.0],[4125135.0,3307187.0],[4133736.0,3337488.0],[4134708.0,3351905.0],[4138750.0,3360935.0],[4127540.0,3366605.0],[4155275.0,3399818.0],[4176383.0,3402210.0],[4194752.0,3393947.0],[4197879.0,3384616.0],[4192373.0,3379298.0],[4201005.0,3368300.0],[4225157.0,3380667.0],[4220906.0,3374886.0],[4229260.0,3382600.0],[4223057.0,3389734.0],[4229550.0,3407325.0],[4234678.0,3421310.0],[4247890.0,3417220.0],[4256375.0,3414615.0]],[[4234578.0,3327007.0],[4248229.0,3323044.0],[4252998.0,3335779.0],[4219844.0,3347604.0],[4230921.0,3334223.0],[4234578.0,3327007.0]]]}},{"type":"Feature","properties":{"id":"DEA","CNTR_CODE":"DE","NUTS_NAME":"NORDRHEIN-WESTFALEN","LEVL_CODE":1,"FID":"DEA","NUTS_ID":"DEA","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4263136.0,3221221.0],[4273455.0,3201627.0],[4274380.0,3194089.0],[4280669.0,3170915.0],[4282274.0,3171250.0],[4262279.0,3148330.0],[4249535.0,3155626.0],[4219379.0,3111083.0],[4214087.0,3096412.0],[4205226.0,3084692.0],[4188559.0,3065487.0],[4182511.0,3066932.0],[4169961.0,3092710.0],[4165398.0,3094413.0],[4156202.0,3081393.0],[4140272.0,3069801.0],[4123783.0,3060604.0],[4103368.0,3054208.0],[4093418.0,3032716.0],[4066527.0,3029642.0],[4065087.0,3029746.0],[4059686.0,3049366.0],[4040360.0,3079039.0],[4045945.0,3096437.0],[4031952.0,3110464.0],[4053685.0,3126266.0],[4046900.0,3133098.0],[4058181.0,3146141.0],[4041681.0,3189694.0],[4057369.0,3205893.0],[4073466.0,3196970.0],[4092852.0,3207674.0],[4099187.0,3228125.0],[4120624.0,3240895.0],[4122915.0,3240990.0],[4137969.0,3244557.0],[4158497.0,3265415.0],[4175415.0,3246353.0],[4176050.0,3221372.0],[4190451.0,3218063.0],[4212132.0,3223996.0],[4216298.0,3240880.0],[4205260.0,3262149.0],[4232926.0,3266469.0],[4261478.0,3256200.0],[4251654.0,3232135.0],[4263136.0,3221221.0]]]}},{"type":"Feature","properties":{"id":"DEB","CNTR_CODE":"DE","NUTS_NAME":"RHEINLAND-PFALZ","LEVL_CODE":1,"FID":"DEB","NUTS_ID":"DEB","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4176810.0,3034687.0],[4187131.0,3020058.0],[4161637.0,2997328.0],[4171106.0,2987851.0],[4190259.0,2992946.0],[4191329.0,2993035.0],[4198261.0,2988401.0],[4202053.0,2982236.0],[4205818.0,2966931.0],[4209168.0,2959145.0],[4209059.0,2958914.0],[4208936.0,2958700.0],[4206384.0,2943713.0],[4206911.0,2942404.0],[4206908.0,2941381.0],[4206859.0,2937782.0],[4210213.0,2926776.0],[4211940.0,2923163.0],[4209211.0,2912147.0],[4210939.0,2909690.0],[4209447.0,2908937.0],[4205447.0,2905334.0],[4199707.0,2886591.0],[4194902.0,2876669.0],[4193703.0,2875694.0],[4191568.0,2874149.0],[4179638.0,2878091.0],[4168238.0,2883501.0],[4148170.0,2885086.0],[4129089.0,2897694.0],[4125671.0,2900938.0],[4125618.0,2907240.0],[4131564.0,2914841.0],[4132313.0,2920530.0],[4131882.0,2921027.0],[4124529.0,2925318.0],[4121722.0,2928009.0],[4123939.0,2940965.0],[4106361.0,2951754.0],[4096387.0,2949271.0],[4059131.0,2944039.0],[4067411.0,2973722.0],[4044954.0,3009233.0],[4065087.0,3029746.0],[4066527.0,3029642.0],[4093418.0,3032716.0],[4103368.0,3054208.0],[4123783.0,3060604.0],[4140272.0,3069801.0],[4156202.0,3081393.0],[4165398.0,3094413.0],[4169961.0,3092710.0],[4182511.0,3066932.0],[4188559.0,3065487.0],[4190142.0,3055828.0],[4176810.0,3034687.0]]]}},{"type":"Feature","properties":{"id":"DEC","CNTR_CODE":"DE","NUTS_NAME":"SAARLAND","LEVL_CODE":1,"FID":"DEC","NUTS_ID":"DEC","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4129089.0,2897694.0],[4121360.0,2894899.0],[4109552.0,2897821.0],[4082335.0,2905957.0],[4071243.0,2928771.0],[4057754.0,2935021.0],[4059131.0,2944039.0],[4096387.0,2949271.0],[4106361.0,2951754.0],[4123939.0,2940965.0],[4121722.0,2928009.0],[4124529.0,2925318.0],[4131882.0,2921027.0],[4132313.0,2920530.0],[4131564.0,2914841.0],[4125618.0,2907240.0],[4125671.0,2900938.0],[4129089.0,2897694.0]]]}},{"type":"Feature","properties":{"id":"DED","CNTR_CODE":"DE","NUTS_NAME":"SACHSEN","LEVL_CODE":1,"FID":"DED","NUTS_ID":"DED","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4544296.0,3148678.0],[4577903.0,3146845.0],[4587903.0,3147670.0],[4609663.0,3167169.0],[4629350.0,3168446.0],[4648591.0,3174086.0],[4667129.0,3151023.0],[4660256.0,3095529.0],[4645979.0,3093185.0],[4635755.0,3113255.0],[4623550.0,3113763.0],[4613161.0,3090520.0],[4578744.0,3075178.0],[4568655.0,3063911.0],[4530540.0,3036694.0],[4504645.0,3036025.0],[4470617.0,3025026.0],[4457382.0,3036536.0],[4454607.0,3058977.0],[4468707.0,3053984.0],[4484887.0,3065355.0],[4479595.0,3080970.0],[4507488.0,3093634.0],[4504767.0,3099894.0],[4480955.0,3111467.0],[4472463.0,3131643.0],[4473853.0,3138030.0],[4473564.0,3160151.0],[4499637.0,3171553.0],[4532108.0,3175213.0],[4544296.0,3148678.0]]]}},{"type":"Feature","properties":{"id":"DEE","CNTR_CODE":"DE","NUTS_NAME":"SACHSEN-ANHALT","LEVL_CODE":1,"FID":"DEE","NUTS_ID":"DEE","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4480955.0,3111467.0],[4477299.0,3094770.0],[4472988.0,3096385.0],[4462947.0,3097269.0],[4451204.0,3106378.0],[4439886.0,3109855.0],[4424973.0,3111528.0],[4417729.0,3127014.0],[4423804.0,3132605.0],[4420562.0,3137520.0],[4389027.0,3146690.0],[4384447.0,3167714.0],[4369551.0,3170422.0],[4359540.0,3210601.0],[4375985.0,3215643.0],[4387148.0,3216740.0],[4384505.0,3262905.0],[4389510.0,3265749.0],[4372219.0,3298822.0],[4377693.0,3305156.0],[4422178.0,3315760.0],[4428178.0,3326451.0],[4445938.0,3312755.0],[4464133.0,3311150.0],[4472708.0,3300460.0],[4468427.0,3268541.0],[4478496.0,3263035.0],[4476969.0,3224011.0],[4483990.0,3217678.0],[4511258.0,3211309.0],[4537996.0,3199068.0],[4532108.0,3175213.0],[4499637.0,3171553.0],[4473564.0,3160151.0],[4473853.0,3138030.0],[4472463.0,3131643.0],[4480955.0,3111467.0]]]}},{"type":"Feature","properties":{"id":"DEF","CNTR_CODE":"DE","NUTS_NAME":"SCHLESWIG-HOLSTEIN","LEVL_CODE":1,"FID":"DEF","NUTS_ID":"DEF","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4264046.0,3530123.0],[4274284.0,3523119.0],[4283857.0,3525296.0],[4286823.0,3523626.0],[4288333.0,3524217.0],[4306700.0,3513564.0],[4307694.0,3495169.0],[4331939.0,3480738.0],[4332329.0,3471046.0],[4367472.0,3466736.0],[4386497.0,3468979.0],[4376190.0,3431980.0],[4380329.0,3428122.0],[4371265.0,3411806.0],[4383955.0,3393756.0],[4360616.0,3361935.0],[4352221.0,3364313.0],[4341470.0,3369525.0],[4336709.0,3376535.0],[4326001.0,3400558.0],[4317388.0,3393935.0],[4303112.0,3383356.0],[4287047.0,3400145.0],[4273210.0,3418043.0],[4268365.0,3419505.0],[4244479.0,3435837.0],[4245717.0,3462796.0],[4233489.0,3534838.0],[4249690.0,3532312.0],[4264046.0,3530123.0]]],[[[4194193.0,3462176.0],[4188683.0,3433561.0],[4166955.0,3464870.0],[4184292.0,3472667.0],[4194193.0,3462176.0]]]]}},{"type":"Feature","properties":{"id":"DEG","CNTR_CODE":"DE","NUTS_NAME":"THÜRINGEN","LEVL_CODE":1,"FID":"DEG","NUTS_ID":"DEG","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4472988.0,3096385.0],[4477299.0,3094770.0],[4480955.0,3111467.0],[4504767.0,3099894.0],[4507488.0,3093634.0],[4479595.0,3080970.0],[4484887.0,3065355.0],[4468707.0,3053984.0],[4454607.0,3058977.0],[4457382.0,3036536.0],[4434993.0,3033109.0],[4426267.0,3036581.0],[4410857.0,3041610.0],[4405836.0,3018360.0],[4388261.0,3030928.0],[4373034.0,3013351.0],[4364539.0,3013049.0],[4353033.0,3032305.0],[4323932.0,3044956.0],[4326487.0,3058434.0],[4315792.0,3072869.0],[4322514.0,3097958.0],[4335697.0,3114793.0],[4335467.0,3119972.0],[4316010.0,3140497.0],[4354869.0,3162802.0],[4367887.0,3169982.0],[4369551.0,3170422.0],[4384447.0,3167714.0],[4389027.0,3146690.0],[4420562.0,3137520.0],[4423804.0,3132605.0],[4417729.0,3127014.0],[4424973.0,3111528.0],[4439886.0,3109855.0],[4451204.0,3106378.0],[4462947.0,3097269.0],[4472988.0,3096385.0]]]}},{"type":"Feature","properties":{"id":"EE0","CNTR_CODE":"EE","NUTS_NAME":"EESTI","LEVL_CODE":1,"FID":"EE0","NUTS_ID":"EE0","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[5314985.0,4087161.0],[5354050.0,4004104.0],[5350178.0,3949791.0],[5297162.0,3941153.0],[5203368.0,3975554.0],[5192748.0,3965598.0],[5167150.0,3949299.0],[5166522.0,3996787.0],[5135024.0,3990002.0],[5103396.0,4016848.0],[5090939.0,4077903.0],[5100684.0,4090792.0],[5209290.0,4151086.0],[5218020.0,4159433.0],[5262087.0,4156078.0],[5333199.0,4170603.0],[5340949.0,4159054.0],[5314985.0,4087161.0]]],[[[5068119.0,4043693.0],[5066259.0,4016325.0],[5083635.0,4020511.0],[5085144.0,4000835.0],[5053057.0,3958959.0],[5030958.0,3957907.0],[5013912.0,3983249.0],[5041780.0,4011076.0],[5041690.0,4058791.0],[5068119.0,4043693.0]]]]}},{"type":"Feature","properties":{"id":"FR1","CNTR_CODE":"FR","NUTS_NAME":"ILE-DE-FRANCE","LEVL_CODE":1,"FID":"FR1","NUTS_ID":"FR1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3718146.0,2936166.0],[3780605.0,2912396.0],[3815977.0,2913173.0],[3843451.0,2880981.0],[3846397.0,2854858.0],[3833828.0,2830289.0],[3796199.0,2808440.0],[3758459.0,2829789.0],[3727939.0,2829213.0],[3724662.0,2848710.0],[3699819.0,2905655.0],[3709319.0,2919889.0],[3718146.0,2936166.0]]]}},{"type":"Feature","properties":{"id":"FRB","CNTR_CODE":"FR","NUTS_NAME":"CENTRE - VAL DE LOIRE","LEVL_CODE":1,"FID":"FRB","NUTS_ID":"FRB","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3724662.0,2848710.0],[3727939.0,2829213.0],[3758459.0,2829789.0],[3796199.0,2808440.0],[3802099.0,2780079.0],[3793083.0,2742389.0],[3784943.0,2737698.0],[3789420.0,2656258.0],[3728189.0,2620517.0],[3719568.0,2621833.0],[3661111.0,2619733.0],[3643386.0,2625933.0],[3624512.0,2669022.0],[3616083.0,2677064.0],[3568838.0,2722831.0],[3588378.0,2770116.0],[3618197.0,2775854.0],[3631123.0,2800671.0],[3640546.0,2818877.0],[3638560.0,2829374.0],[3651966.0,2858535.0],[3646244.0,2881761.0],[3656436.0,2885442.0],[3699819.0,2905655.0],[3724662.0,2848710.0]]]}},{"type":"Feature","properties":{"id":"FRC","CNTR_CODE":"FR","NUTS_NAME":"BOURGOGNE-FRANCHE-COMTÉ","LEVL_CODE":1,"FID":"FRC","NUTS_ID":"FRC","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3894782.0,2773361.0],[3926135.0,2781564.0],[3973192.0,2732089.0],[4013469.0,2765502.0],[4083044.0,2749494.0],[4084784.0,2750520.0],[4104717.0,2714129.0],[4090009.0,2707008.0],[4082698.0,2677681.0],[4082828.0,2677478.0],[4051112.0,2643953.0],[4024714.0,2612632.0],[4018233.0,2597242.0],[3988223.0,2582701.0],[3960564.0,2603992.0],[3933135.0,2607555.0],[3917849.0,2576779.0],[3903680.0,2591132.0],[3887972.0,2583761.0],[3850860.0,2592945.0],[3854393.0,2613133.0],[3834440.0,2647126.0],[3817664.0,2650484.0],[3789420.0,2656258.0],[3784943.0,2737698.0],[3793083.0,2742389.0],[3802099.0,2780079.0],[3796199.0,2808440.0],[3833828.0,2830289.0],[3843586.0,2815472.0],[3867291.0,2779914.0],[3894782.0,2773361.0]]]}},{"type":"Feature","properties":{"id":"FRD","CNTR_CODE":"FR","NUTS_NAME":"NORMANDIE","LEVL_CODE":1,"FID":"FRD","NUTS_ID":"FRD","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3721015.0,2955669.0],[3718146.0,2936166.0],[3709319.0,2919889.0],[3699819.0,2905655.0],[3656436.0,2885442.0],[3646244.0,2881761.0],[3651966.0,2858535.0],[3638560.0,2829374.0],[3635016.0,2832421.0],[3601123.0,2861857.0],[3578558.0,2858311.0],[3564205.0,2876982.0],[3521434.0,2879915.0],[3506235.0,2882990.0],[3471714.0,2901644.0],[3473346.0,3001726.0],[3500006.0,3008007.0],[3515982.0,2973171.0],[3619367.0,2970507.0],[3644489.0,2968707.0],[3648739.0,2975372.0],[3652783.0,2976094.0],[3652818.0,2976375.0],[3652853.0,2976656.0],[3608006.0,2984296.0],[3621889.0,3003960.0],[3657642.0,3015041.0],[3705361.0,3030982.0],[3730320.0,2993721.0],[3721015.0,2955669.0]]]}},{"type":"Feature","properties":{"id":"FRE","CNTR_CODE":"FR","NUTS_NAME":"NORD-PAS DE CALAIS-PICARDIE","LEVL_CODE":1,"FID":"FRE","NUTS_ID":"FRE","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3817785.0,3090854.0],[3818209.0,3090204.0],[3819381.0,3090403.0],[3820232.0,3088929.0],[3820865.0,3089001.0],[3821127.0,3089941.0],[3821873.0,3089835.0],[3822512.0,3090764.0],[3822702.0,3092377.0],[3823206.0,3092752.0],[3823720.0,3092926.0],[3823373.0,3093872.0],[3823576.0,3094429.0],[3824817.0,3095158.0],[3825314.0,3094776.0],[3825882.0,3094750.0],[3826732.0,3095446.0],[3828414.0,3096281.0],[3828830.0,3096702.0],[3829125.0,3097051.0],[3829392.0,3097021.0],[3835047.0,3097096.0],[3844678.0,3088814.0],[3853162.0,3069289.0],[3868536.0,3061788.0],[3871120.0,3058361.0],[3876166.0,3046343.0],[3896519.0,3044671.0],[3901204.0,3001917.0],[3907619.0,2999071.0],[3889480.0,2938891.0],[3861334.0,2926771.0],[3850797.0,2899715.0],[3843451.0,2880981.0],[3815977.0,2913173.0],[3780605.0,2912396.0],[3718146.0,2936166.0],[3721015.0,2955669.0],[3730320.0,2993721.0],[3705361.0,3030982.0],[3727769.0,3060350.0],[3726112.0,3087332.0],[3734384.0,3117050.0],[3765498.0,3129649.0],[3799789.0,3135289.0],[3802065.0,3115283.0],[3817785.0,3090854.0]]]}},{"type":"Feature","properties":{"id":"FRF","CNTR_CODE":"FR","NUTS_NAME":"ALSACE-CHAMPAGNE-ARDENNE-LORRAINE","LEVL_CODE":1,"FID":"FRF","NUTS_ID":"FRF","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3949129.0,3017067.0],[3959124.0,2977872.0],[3971752.0,2967666.0],[3988313.0,2955361.0],[3993084.0,2941705.0],[4012457.0,2945943.0],[4018497.0,2945664.0],[4023634.0,2939875.0],[4057754.0,2935021.0],[4071243.0,2928771.0],[4082335.0,2905957.0],[4109552.0,2897821.0],[4121360.0,2894899.0],[4129089.0,2897694.0],[4148170.0,2885086.0],[4168238.0,2883501.0],[4179638.0,2878091.0],[4191568.0,2874149.0],[4170833.0,2847105.0],[4148737.0,2796455.0],[4140623.0,2781606.0],[4140556.0,2780970.0],[4140149.0,2758618.0],[4136890.0,2739717.0],[4139577.0,2722540.0],[4136939.0,2719812.0],[4133384.0,2713040.0],[4123319.0,2705528.0],[4104717.0,2714129.0],[4084784.0,2750520.0],[4083044.0,2749494.0],[4013469.0,2765502.0],[3973192.0,2732089.0],[3926135.0,2781564.0],[3894782.0,2773361.0],[3867291.0,2779914.0],[3843586.0,2815472.0],[3833828.0,2830289.0],[3846397.0,2854858.0],[3843451.0,2880981.0],[3850797.0,2899715.0],[3861334.0,2926771.0],[3889480.0,2938891.0],[3907619.0,2999071.0],[3921742.0,2996169.0],[3949129.0,3017067.0]]]}},{"type":"Feature","properties":{"id":"FRG","CNTR_CODE":"FR","NUTS_NAME":"PAYS DE LA LOIRE","LEVL_CODE":1,"FID":"FRG","NUTS_ID":"FRG","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3578558.0,2858311.0],[3601123.0,2861857.0],[3635016.0,2832421.0],[3638560.0,2829374.0],[3640546.0,2818877.0],[3631123.0,2800671.0],[3618197.0,2775854.0],[3588378.0,2770116.0],[3568838.0,2722831.0],[3555682.0,2713519.0],[3494921.0,2712203.0],[3508014.0,2669755.0],[3495177.0,2636669.0],[3464112.0,2643534.0],[3420152.0,2673330.0],[3414051.0,2687679.0],[3407139.0,2704063.0],[3414069.0,2730768.0],[3385828.0,2782799.0],[3403794.0,2785581.0],[3415899.0,2798444.0],[3431726.0,2800628.0],[3440060.0,2801798.0],[3482486.0,2807955.0],[3506235.0,2882990.0],[3521434.0,2879915.0],[3564205.0,2876982.0],[3578558.0,2858311.0]]]}},{"type":"Feature","properties":{"id":"FRH","CNTR_CODE":"FR","NUTS_NAME":"BRETAGNE","LEVL_CODE":1,"FID":"FRH","NUTS_ID":"FRH","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3442784.0,2896432.0],[3471714.0,2901644.0],[3506235.0,2882990.0],[3482486.0,2807955.0],[3440060.0,2801798.0],[3431726.0,2800628.0],[3415899.0,2798444.0],[3403794.0,2785581.0],[3385828.0,2782799.0],[3363647.0,2799697.0],[3338782.0,2790545.0],[3323014.0,2823440.0],[3314790.0,2840825.0],[3256615.0,2855615.0],[3259546.0,2886464.0],[3243120.0,2916493.0],[3264232.0,2938073.0],[3320985.0,2931509.0],[3343001.0,2935486.0],[3362406.0,2939072.0],[3382724.0,2911833.0],[3442784.0,2896432.0]]]}},{"type":"Feature","properties":{"id":"FRI","CNTR_CODE":"FR","NUTS_NAME":"AQUITAINE-LIMOUSIN-POITOU-CHARENTES","LEVL_CODE":1,"FID":"FRI","NUTS_ID":"FRI","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3643386.0,2625933.0],[3661111.0,2619733.0],[3719568.0,2621833.0],[3728189.0,2620517.0],[3746982.0,2587613.0],[3737000.0,2543360.0],[3735498.0,2514581.0],[3712790.0,2493311.0],[3695181.0,2462729.0],[3647468.0,2472809.0],[3612679.0,2427491.0],[3609311.0,2405667.0],[3580053.0,2374584.0],[3579738.0,2374251.0],[3525634.0,2372046.0],[3502379.0,2361443.0],[3494580.0,2331667.0],[3506245.0,2329784.0],[3500017.0,2302893.0],[3478445.0,2251519.0],[3446155.0,2264004.0],[3393706.0,2309700.0],[3371029.0,2317520.0],[3368408.0,2322271.0],[3367336.0,2324216.0],[3391141.0,2340602.0],[3427515.0,2440388.0],[3451405.0,2543018.0],[3482990.0,2528821.0],[3457114.0,2585136.0],[3464112.0,2643534.0],[3495177.0,2636669.0],[3508014.0,2669755.0],[3494921.0,2712203.0],[3555682.0,2713519.0],[3568838.0,2722831.0],[3616083.0,2677064.0],[3624512.0,2669022.0],[3643386.0,2625933.0]]]}},{"type":"Feature","properties":{"id":"FRJ","CNTR_CODE":"FR","NUTS_NAME":"LANGUEDOC-ROUSSILLON-MIDI-PYRÉNÉES","LEVL_CODE":1,"FID":"FRJ","NUTS_ID":"FRJ","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3695181.0,2462729.0],[3702567.0,2421653.0],[3746518.0,2446170.0],[3764080.0,2418784.0],[3797174.0,2452165.0],[3834643.0,2423604.0],[3842966.0,2391303.0],[3893292.0,2366400.0],[3897911.0,2327570.0],[3853358.0,2279282.0],[3843685.0,2290547.0],[3798360.0,2270510.0],[3785158.0,2264760.0],[3771048.0,2258658.0],[3751465.0,2218748.0],[3750769.0,2202241.0],[3758413.0,2173293.0],[3640545.0,2191503.0],[3640254.0,2192873.0],[3645973.0,2199965.0],[3618229.0,2206418.0],[3610160.0,2218085.0],[3573289.0,2236522.0],[3563129.0,2229191.0],[3555450.0,2223671.0],[3540710.0,2226544.0],[3478445.0,2251519.0],[3500017.0,2302893.0],[3506245.0,2329784.0],[3494580.0,2331667.0],[3502379.0,2361443.0],[3525634.0,2372046.0],[3579738.0,2374251.0],[3580053.0,2374584.0],[3609311.0,2405667.0],[3612679.0,2427491.0],[3647468.0,2472809.0],[3695181.0,2462729.0]]]}},{"type":"Feature","properties":{"id":"FRK","CNTR_CODE":"FR","NUTS_NAME":"AUVERGNE-RHÔNE-ALPES","LEVL_CODE":1,"FID":"FRK","NUTS_ID":"FRK","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3850860.0,2592945.0],[3887972.0,2583761.0],[3903680.0,2591132.0],[3917849.0,2576779.0],[3933135.0,2607555.0],[3960564.0,2603992.0],[3988223.0,2582701.0],[4018233.0,2597242.0],[4022416.0,2586012.0],[4008291.0,2566177.0],[4025673.0,2570762.0],[4031470.0,2588477.0],[4048975.0,2597449.0],[4076473.0,2595666.0],[4091540.0,2538951.0],[4072064.0,2523773.0],[4094309.0,2488413.0],[4095551.0,2465999.0],[4055456.0,2450216.0],[4042020.0,2444597.0],[4026458.0,2453485.0],[4024388.0,2428069.0],[3987846.0,2408865.0],[3964109.0,2382613.0],[3974775.0,2352355.0],[3960124.0,2344808.0],[3921091.0,2375508.0],[3893849.0,2372971.0],[3893292.0,2366400.0],[3842966.0,2391303.0],[3834643.0,2423604.0],[3797174.0,2452165.0],[3764080.0,2418784.0],[3746518.0,2446170.0],[3702567.0,2421653.0],[3695181.0,2462729.0],[3712790.0,2493311.0],[3735498.0,2514581.0],[3737000.0,2543360.0],[3746982.0,2587613.0],[3728189.0,2620517.0],[3789420.0,2656258.0],[3817664.0,2650484.0],[3834440.0,2647126.0],[3854393.0,2613133.0],[3850860.0,2592945.0]]]}},{"type":"Feature","properties":{"id":"FRL","CNTR_CODE":"FR","NUTS_NAME":"PROVENCE-ALPES-CÔTE D’AZUR","LEVL_CODE":1,"FID":"FRL","NUTS_ID":"FRL","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4026458.0,2453485.0],[4042020.0,2444597.0],[4055456.0,2450216.0],[4088123.0,2404819.0],[4078566.0,2398683.0],[4072438.0,2366359.0],[4137477.0,2330752.0],[4121720.0,2300473.0],[4114290.0,2296841.0],[4114147.0,2297136.0],[4112108.0,2295115.0],[4111882.0,2294742.0],[4112225.0,2294422.0],[4072166.0,2268613.0],[4032632.0,2234462.0],[3968344.0,2240335.0],[3853358.0,2279282.0],[3897911.0,2327570.0],[3893292.0,2366400.0],[3893849.0,2372971.0],[3921091.0,2375508.0],[3960124.0,2344808.0],[3974775.0,2352355.0],[3964109.0,2382613.0],[3987846.0,2408865.0],[4024388.0,2428069.0],[4026458.0,2453485.0]]]}},{"type":"Feature","properties":{"id":"FRM","CNTR_CODE":"FR","NUTS_NAME":"CORSE","LEVL_CODE":1,"FID":"FRM","NUTS_ID":"FRM","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4206959.0,2141948.0],[4272738.0,2188027.0],[4271177.0,2084154.0],[4266689.0,2070300.0],[4257348.0,2041660.0],[4236116.0,2046353.0],[4228587.0,2070743.0],[4215930.0,2112204.0],[4206959.0,2141948.0]]]}},{"type":"Feature","properties":{"id":"LU0","CNTR_CODE":"LU","NUTS_NAME":"LUXEMBOURG","LEVL_CODE":1,"FID":"LU0","NUTS_ID":"LU0","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4044954.0,3009233.0],[4067411.0,2973722.0],[4059131.0,2944039.0],[4057754.0,2935021.0],[4023634.0,2939875.0],[4018497.0,2945664.0],[4015260.0,2980087.0],[4037218.0,3015532.0],[4044954.0,3009233.0]]]}},{"type":"Feature","properties":{"id":"LV0","CNTR_CODE":"LV","NUTS_NAME":"LATVIJA","LEVL_CODE":1,"FID":"LV0","NUTS_ID":"LV0","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[5374000.0,3938766.0],[5435586.0,3815983.0],[5412480.0,3775880.0],[5356924.0,3740091.0],[5314580.0,3760462.0],[5298223.0,3769133.0],[5231737.0,3790696.0],[5192242.0,3769546.0],[5130157.0,3766126.0],[5114449.0,3771207.0],[5097787.0,3764687.0],[5057504.0,3759611.0],[5007411.0,3715790.0],[4995327.0,3794589.0],[5019721.0,3883841.0],[5062315.0,3909757.0],[5108900.0,3874214.0],[5134269.0,3848235.0],[5162340.0,3849279.0],[5171516.0,3860202.0],[5181786.0,3888519.0],[5167150.0,3949299.0],[5192748.0,3965598.0],[5203368.0,3975554.0],[5297162.0,3941153.0],[5350178.0,3949791.0],[5374000.0,3938766.0]]]}},{"type":"Feature","properties":{"id":"MT0","CNTR_CODE":"MT","NUTS_NAME":"MALTA","LEVL_CODE":1,"FID":"MT0","NUTS_ID":"MT0","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4743978.0,1443103.0],[4725858.0,1418219.0],[4706799.0,1435254.0],[4721965.0,1456527.0],[4743978.0,1443103.0]]],[[[4716375.0,1452229.0],[4708696.0,1449147.0],[4700231.0,1455547.0],[4705401.0,1457903.0],[4716375.0,1452229.0]]]]}},{"type":"Feature","properties":{"id":"BE1","CNTR_CODE":"BE","NUTS_NAME":"RÉGION DE BRUXELLES-CAPITALE/BRUSSELS HOOFDSTEDELIJK GEWEST","LEVL_CODE":1,"FID":"BE1","NUTS_ID":"BE1","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[3915050.0,3094470.0],[3919591.0,3102656.0],[3930443.0,3102658.0],[3925465.0,3086683.0],[3915050.0,3094470.0]]]}},{"type":"Feature","properties":{"id":"BE2","CNTR_CODE":"BE","NUTS_NAME":"VLAAMS GEWEST","LEVL_CODE":1,"FID":"BE2","NUTS_ID":"BE2","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"Polygon","coordinates":[[[4011460.0,3132703.0],[4026611.0,3113862.0],[4024033.0,3108311.0],[4017252.0,3086773.0],[3998616.0,3077636.0],[3984947.0,3079341.0],[3975414.0,3077941.0],[3969815.0,3082970.0],[3940202.0,3086500.0],[3904759.0,3082816.0],[3890599.0,3086994.0],[3885116.0,3089442.0],[3882298.0,3089365.0],[3865687.0,3089223.0],[3860314.0,3093300.0],[3844678.0,3088814.0],[3835047.0,3097096.0],[3829392.0,3097021.0],[3829125.0,3097051.0],[3823510.0,3098721.0],[3817785.0,3090854.0],[3802065.0,3115283.0],[3799789.0,3135289.0],[3814726.0,3141880.0],[3841459.0,3156116.0],[3859737.0,3160855.0],[3859809.0,3150169.0],[3892268.0,3140258.0],[3900841.0,3141114.0],[3919814.0,3153328.0],[3920366.0,3153923.0],[3920660.0,3156218.0],[3923162.0,3156164.0],[3950634.0,3159703.0],[3957507.0,3167694.0],[3980659.0,3157888.0],[3988851.0,3138674.0],[4011460.0,3132703.0]],[[3915050.0,3094470.0],[3925465.0,3086683.0],[3930443.0,3102658.0],[3919591.0,3102656.0],[3915050.0,3094470.0]]]}},{"type":"Feature","properties":{"id":"BE3","CNTR_CODE":"BE","NUTS_NAME":"RÉGION WALLONNE","LEVL_CODE":1,"FID":"BE3","NUTS_ID":"BE3","EFTA_FLAG":null,"EU_FLAG":null,"COAS_FLAG":null,"NUTS_BN_ID":null,"CC_FLAG":null,"OTHR_CNTR_FLAG":null},"geometry":{"type":"MultiPolygon","coordinates":[[[[4017252.0,3086773.0],[4025884.0,3075419.0],[4040360.0,3079039.0],[4059686.0,3049366.0],[4065087.0,3029746.0],[4044954.0,3009233.0],[4037218.0,3015532.0],[4015260.0,2980087.0],[4018497.0,2945664.0],[4012457.0,2945943.0],[3993084.0,2941705.0],[3988313.0,2955361.0],[3971752.0,2967666.0],[3959124.0,2977872.0],[3949129.0,3017067.0],[3921742.0,2996169.0],[3907619.0,2999071.0],[3901204.0,3001917.0],[3896519.0,3044671.0],[3876166.0,3046343.0],[3871120.0,3058361.0],[3868536.0,3061788.0],[3853162.0,3069289.0],[3844678.0,3088814.0],[3860314.0,3093300.0],[3865687.0,3089223.0],[3882298.0,3089365.0],[3885116.0,3089442.0],[3890599.0,3086994.0],[3904759.0,3082816.0],[3940202.0,3086500.0],[3969815.0,3082970.0],[3975414.0,3077941.0],[3984947.0,3079341.0],[3998616.0,3077636.0],[4017252.0,3086773.0]]],[[[3817785.0,3090854.0],[3823510.0,3098721.0],[3829125.0,3097051.0],[3828830.0,3096702.0],[3828414.0,3096281.0],[3826732.0,3095446.0],[3825882.0,3094750.0],[3825314.0,3094776.0],[3824817.0,3095158.0],[3823576.0,3094429.0],[3823373.0,3093872.0],[3823720.0,3092926.0],[3823206.0,3092752.0],[3822702.0,3092377.0],[3822512.0,3090764.0],[3821873.0,3089835.0],[3821127.0,3089941.0],[3820865.0,3089001.0],[3820232.0,3088929.0],[3819381.0,3090403.0],[3818209.0,3090204.0],[3817785.0,3090854.0]]]]}}]};/* harmony default export */ __webpack_exports__["a"] = (regionLevel);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countryLevel={"type":"FeatureCollection","name":"NUTS_BN_60M_2013_3035_LEVL_COUNTRY_LINES","crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:EPSG::3035"}},"features":[{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":85,"LEVL_CODE":0,"NUTS_BN_ID":85,"OTHR_CNTR_":"T","Shape_Leng":85274.635032031802},"geometry":{"type":"MultiLineString","coordinates":[[[6667079.0,1943517.0],[6710604.0,1939198.0],[6747420.0,1958428.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":86,"LEVL_CODE":0,"NUTS_BN_ID":86,"OTHR_CNTR_":"T","Shape_Leng":173290.47479590939},"geometry":{"type":"MultiLineString","coordinates":[[[6632576.0,1824645.0],[6657497.0,1820752.0],[6669246.0,1845941.0],[6663598.0,1869241.0],[6687498.0,1880736.0],[6667783.0,1903094.0],[6665486.0,1942998.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":87,"LEVL_CODE":0,"NUTS_BN_ID":87,"OTHR_CNTR_":"F","Shape_Leng":1675.7925722465},"geometry":{"type":"MultiLineString","coordinates":[[[6665486.0,1942998.0],[6667079.0,1943517.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":89,"LEVL_CODE":0,"NUTS_BN_ID":89,"OTHR_CNTR_":"F","Shape_Leng":44885.581599701502},"geometry":{"type":"MultiLineString","coordinates":[[[6747420.0,1958428.0],[6780983.0,1988231.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":96,"LEVL_CODE":0,"NUTS_BN_ID":96,"OTHR_CNTR_":"T","Shape_Leng":203598.03134698499},"geometry":{"type":"MultiLineString","coordinates":[[[6780983.0,1988231.0],[6807253.0,2004831.0],[6884960.0,2008226.0],[6958938.0,2067415.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":120,"LEVL_CODE":0,"NUTS_BN_ID":120,"OTHR_CNTR_":"T","Shape_Leng":134461.31546006241},"geometry":{"type":"MultiLineString","coordinates":[[[6958938.0,2067415.0],[6995135.0,2109147.0],[7068257.0,2139622.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":134,"LEVL_CODE":0,"NUTS_BN_ID":134,"OTHR_CNTR_":"T","Shape_Leng":183659.7919653948},"geometry":{"type":"MultiLineString","coordinates":[[[7068257.0,2139622.0],[7102476.0,2178045.0],[7124014.0,2165624.0],[7147293.0,2210236.0],[7202816.0,2223242.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":137,"LEVL_CODE":0,"NUTS_BN_ID":137,"OTHR_CNTR_":"T","Shape_Leng":227171.9288676836},"geometry":{"type":"MultiLineString","coordinates":[[[7202816.0,2223242.0],[7256358.0,2254244.0],[7286687.0,2234820.0],[7315863.0,2266543.0],[7310147.0,2281773.0],[7288018.0,2285777.0],[7278230.0,2315091.0],[7262037.0,2318390.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":146,"LEVL_CODE":0,"NUTS_BN_ID":146,"OTHR_CNTR_":"F","Shape_Leng":563620.76410760114},"geometry":{"type":"MultiLineString","coordinates":[[[6046337.0,1688778.0],[6030486.0,1694089.0],[6023797.0,1724692.0],[6006529.0,1729923.0],[6001979.0,1718208.0],[5946917.0,1726196.0],[5928364.0,1687762.0],[5936194.0,1716940.0],[5872443.0,1689538.0],[5927699.0,1714184.0],[5947940.0,1747011.0],[5882668.0,1724987.0],[5869110.0,1728448.0],[5856688.0,1717460.0],[5857517.0,1739671.0],[5872118.0,1734254.0],[5880342.0,1756223.0],[5859943.0,1763994.0],[5860829.0,1768612.0],[5860236.0,1769030.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":229,"LEVL_CODE":0,"NUTS_BN_ID":229,"OTHR_CNTR_":"F","Shape_Leng":106235.2450381871},"geometry":{"type":"MultiLineString","coordinates":[[[5860236.0,1769030.0],[5842809.0,1758078.0],[5838745.0,1784376.0],[5818770.0,1787593.0],[5837329.0,1799136.0],[5836588.0,1816074.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":425,"LEVL_CODE":0,"NUTS_BN_ID":425,"OTHR_CNTR_":"F","Shape_Leng":375545.87749735429},"geometry":{"type":"MultiLineString","coordinates":[[[5836588.0,1816074.0],[5785438.0,1843704.0],[5773675.0,1827635.0],[5743575.0,1839548.0],[5744373.0,1864465.0],[5744421.0,1866013.0],[5744998.0,1885220.0],[5767467.0,1874313.0],[5776283.0,1851909.0],[5815705.0,1875403.0],[5773985.0,1890089.0],[5797338.0,1920762.0],[5765134.0,1947265.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":493,"LEVL_CODE":0,"NUTS_BN_ID":493,"OTHR_CNTR_":"F","Shape_Leng":82315.672850045201},"geometry":{"type":"MultiLineString","coordinates":[[[5765134.0,1947265.0],[5755010.0,1956806.0],[5772345.0,1992572.0],[5744714.0,1984965.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":607,"LEVL_CODE":0,"NUTS_BN_ID":607,"OTHR_CNTR_":"F","Shape_Leng":243502.65285969441},"geometry":{"type":"MultiLineString","coordinates":[[[5744714.0,1984965.0],[5699343.0,1967261.0],[5698244.0,2025021.0],[5737346.0,2080489.0],[5783328.0,2094433.0],[5801743.0,2084105.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":609,"LEVL_CODE":0,"NUTS_BN_ID":609,"OTHR_CNTR_":"F","Shape_Leng":90482.284479320093},"geometry":{"type":"MultiLineString","coordinates":[[[5801743.0,2084105.0],[5830993.0,2098885.0],[5816938.0,2113228.0],[5840592.0,2109716.0],[5854054.0,2107096.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":610,"LEVL_CODE":0,"NUTS_BN_ID":610,"OTHR_CNTR_":"F","Shape_Leng":98730.303374698706},"geometry":{"type":"MultiLineString","coordinates":[[[5854054.0,2107096.0],[5934848.0,2130951.0],[5920391.0,2131892.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":648,"LEVL_CODE":0,"NUTS_BN_ID":648,"OTHR_CNTR_":"F","Shape_Leng":190484.96015490571},"geometry":{"type":"MultiLineString","coordinates":[[[5751529.0,2100720.0],[5695816.0,2031422.0],[5694481.0,2061392.0],[5740009.0,2101782.0],[5730189.0,2106048.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":665,"LEVL_CODE":0,"NUTS_BN_ID":665,"OTHR_CNTR_":"F","Shape_Leng":87045.742732358805},"geometry":{"type":"MultiLineString","coordinates":[[[5920391.0,2131892.0],[5901285.0,2134999.0],[5960059.0,2168574.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":672,"LEVL_CODE":0,"NUTS_BN_ID":672,"OTHR_CNTR_":"F","Shape_Leng":68363.317513083501},"geometry":{"type":"MultiLineString","coordinates":[[[5730189.0,2106048.0],[5683055.0,2089510.0],[5670221.0,2102712.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":688,"LEVL_CODE":0,"NUTS_BN_ID":688,"OTHR_CNTR_":"F","Shape_Leng":84992.506119236597},"geometry":{"type":"MultiLineString","coordinates":[[[5960059.0,2168574.0],[5990865.0,2183192.0],[5940444.0,2176265.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":733,"LEVL_CODE":0,"NUTS_BN_ID":733,"OTHR_CNTR_":"F","Shape_Leng":106893.1826289227},"geometry":{"type":"MultiLineString","coordinates":[[[5824749.0,2171035.0],[5786626.0,2156884.0],[5751529.0,2100720.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":749,"LEVL_CODE":0,"NUTS_BN_ID":749,"OTHR_CNTR_":"F","Shape_Leng":90984.501958882902},"geometry":{"type":"MultiLineString","coordinates":[[[6636246.0,2422567.0],[6714845.0,2468397.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":751,"LEVL_CODE":0,"NUTS_BN_ID":751,"OTHR_CNTR_":"F","Shape_Leng":96291.644672666996},"geometry":{"type":"MultiLineString","coordinates":[[[6714845.0,2468397.0],[6806798.0,2496974.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":757,"LEVL_CODE":0,"NUTS_BN_ID":757,"OTHR_CNTR_":"F","Shape_Leng":26896.363314976701},"geometry":{"type":"MultiLineString","coordinates":[[[6066416.0,2241475.0],[6090471.0,2253508.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":761,"LEVL_CODE":0,"NUTS_BN_ID":761,"OTHR_CNTR_":"F","Shape_Leng":199782.80487879581},"geometry":{"type":"MultiLineString","coordinates":[[[5826981.0,2233956.0],[5911143.0,2216932.0],[5906651.0,2207382.0],[5910305.0,2204740.0],[5894390.0,2181113.0],[5824749.0,2171035.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":768,"LEVL_CODE":0,"NUTS_BN_ID":768,"OTHR_CNTR_":"F","Shape_Leng":82252.024277231307},"geometry":{"type":"MultiLineString","coordinates":[[[6554504.0,2413418.0],[6636246.0,2422567.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":777,"LEVL_CODE":0,"NUTS_BN_ID":777,"OTHR_CNTR_":"F","Shape_Leng":41392.941301009902},"geometry":{"type":"MultiLineString","coordinates":[[[5974176.0,2223871.0],[6012650.0,2239141.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":779,"LEVL_CODE":0,"NUTS_BN_ID":779,"OTHR_CNTR_":"F","Shape_Leng":53816.748185074401},"geometry":{"type":"MultiLineString","coordinates":[[[6012650.0,2239141.0],[6066416.0,2241475.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":788,"LEVL_CODE":0,"NUTS_BN_ID":788,"OTHR_CNTR_":"F","Shape_Leng":122565.92518414609},"geometry":{"type":"MultiLineString","coordinates":[[[5940444.0,2176265.0],[5910975.0,2186857.0],[5910113.0,2210883.0],[5923220.0,2220279.0],[5974176.0,2223871.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":809,"LEVL_CODE":0,"NUTS_BN_ID":809,"OTHR_CNTR_":"F","Shape_Leng":87449.572703499594},"geometry":{"type":"MultiLineString","coordinates":[[[6806798.0,2496974.0],[6863319.0,2563703.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":842,"LEVL_CODE":0,"NUTS_BN_ID":842,"OTHR_CNTR_":"F","Shape_Leng":33141.037178659499},"geometry":{"type":"MultiLineString","coordinates":[[[6863319.0,2563703.0],[6877693.0,2593565.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":856,"LEVL_CODE":0,"NUTS_BN_ID":856,"OTHR_CNTR_":"F","Shape_Leng":2883.0422622349001},"geometry":{"type":"MultiLineString","coordinates":[[[5824292.0,2234996.0],[5826981.0,2233956.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":857,"LEVL_CODE":0,"NUTS_BN_ID":857,"OTHR_CNTR_":"F","Shape_Leng":87266.086439388993},"geometry":{"type":"MultiLineString","coordinates":[[[6090471.0,2253508.0],[6093361.0,2277641.0],[6138407.0,2321628.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":877,"LEVL_CODE":0,"NUTS_BN_ID":877,"OTHR_CNTR_":"F","Shape_Leng":177414.2459285784},"geometry":{"type":"MultiLineString","coordinates":[[[6409167.0,2417609.0],[6440669.0,2440662.0],[6490630.0,2402225.0],[6506949.0,2423417.0],[6554504.0,2413418.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":887,"LEVL_CODE":0,"NUTS_BN_ID":887,"OTHR_CNTR_":"F","Shape_Leng":64108.2864548988},"geometry":{"type":"MultiLineString","coordinates":[[[6138407.0,2321628.0],[6183748.0,2366949.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":911,"LEVL_CODE":0,"NUTS_BN_ID":911,"OTHR_CNTR_":"F","Shape_Leng":45753.5492152019},"geometry":{"type":"MultiLineString","coordinates":[[[5804913.0,2276443.0],[5824292.0,2234996.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":917,"LEVL_CODE":0,"NUTS_BN_ID":917,"OTHR_CNTR_":"F","Shape_Leng":127481.8911909037},"geometry":{"type":"MultiLineString","coordinates":[[[6183748.0,2366949.0],[6224558.0,2399485.0],[6297883.0,2416571.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":928,"LEVL_CODE":0,"NUTS_BN_ID":928,"OTHR_CNTR_":"F","Shape_Leng":135962.2986360894},"geometry":{"type":"MultiLineString","coordinates":[[[6297883.0,2416571.0],[6342395.0,2431750.0],[6348996.0,2450839.0],[6409167.0,2417609.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":976,"LEVL_CODE":0,"NUTS_BN_ID":976,"OTHR_CNTR_":"F","Shape_Leng":102532.8436162381},"geometry":{"type":"MultiLineString","coordinates":[[[5099940.0,2131468.0],[5036225.0,2192311.0],[5023279.0,2185928.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"F","FID":1925,"LEVL_CODE":0,"NUTS_BN_ID":1925,"OTHR_CNTR_":"F","Shape_Leng":10013.063674932901},"geometry":{"type":"MultiLineString","coordinates":[[[4281156.0,2659948.0],[4291125.0,2660883.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"F","FID":1977,"LEVL_CODE":0,"NUTS_BN_ID":1977,"OTHR_CNTR_":"F","Shape_Leng":24654.7470284189},"geometry":{"type":"MultiLineString","coordinates":[[[4285464.0,2684223.0],[4281156.0,2659948.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"F","FID":5583,"LEVL_CODE":0,"NUTS_BN_ID":5583,"OTHR_CNTR_":"T","Shape_Leng":136572.26562706989},"geometry":{"type":"MultiLineString","coordinates":[[[5120442.0,5305023.0],[5129984.0,5291327.0],[5096703.0,5283963.0],[5103746.0,5275696.0],[5073773.0,5207018.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":4933,"LEVL_CODE":0,"NUTS_BN_ID":4933,"OTHR_CNTR_":"F","Shape_Leng":152779.62366727009},"geometry":{"type":"MultiLineString","coordinates":[[[4213958.0,3894853.0],[4145762.0,3883613.0],[4117645.0,3895605.0],[4138347.0,3912086.0],[4111890.0,3915157.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":4949,"LEVL_CODE":0,"NUTS_BN_ID":4949,"OTHR_CNTR_":"F","Shape_Leng":120152.21621107961},"geometry":{"type":"MultiLineString","coordinates":[[[4284249.0,3963532.0],[4267767.0,3961194.0],[4266305.0,3958601.0],[4277152.0,3958484.0],[4213958.0,3894853.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":4981,"LEVL_CODE":0,"NUTS_BN_ID":4981,"OTHR_CNTR_":"F","Shape_Leng":58202.940882386698},"geometry":{"type":"MultiLineString","coordinates":[[[4311751.0,3993711.0],[4279894.0,3971109.0],[4290197.0,3969987.0],[4284249.0,3963532.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5033,"LEVL_CODE":0,"NUTS_BN_ID":5033,"OTHR_CNTR_":"F","Shape_Leng":373791.10071551322},"geometry":{"type":"MultiLineString","coordinates":[[[4111890.0,3915157.0],[4059764.0,3969796.0],[4066533.0,4000077.0],[4090305.0,3991822.0],[4104933.0,4024140.0],[4089849.0,4035553.0],[4070978.0,4033258.0],[4066950.0,4026935.0],[4053131.0,4038885.0],[4051588.0,4013856.0],[4044790.0,4017991.0],[4054429.0,4051090.0],[4069417.0,4078078.0],[4066303.0,4055248.0],[4083474.0,4068181.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5035,"LEVL_CODE":0,"NUTS_BN_ID":5035,"OTHR_CNTR_":"F","Shape_Leng":79077.179574955706},"geometry":{"type":"MultiLineString","coordinates":[[[4405150.0,3988392.0],[4387224.0,3996949.0],[4386163.0,3997459.0],[4368307.0,4006107.0],[4359962.0,4043380.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5058,"LEVL_CODE":0,"NUTS_BN_ID":5058,"OTHR_CNTR_":"F","Shape_Leng":99868.7241593207},"geometry":{"type":"MultiLineString","coordinates":[[[4339059.0,4065677.0],[4342157.0,4064094.0],[4343088.0,4019422.0],[4336726.0,3993459.0],[4311751.0,3993711.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5070,"LEVL_CODE":0,"NUTS_BN_ID":5070,"OTHR_CNTR_":"F","Shape_Leng":76003.285686357805},"geometry":{"type":"MultiLineString","coordinates":[[[4348996.0,4076514.0],[4351576.0,4067621.0],[4352387.0,4064836.0],[4356000.0,4052477.0],[4344900.0,4047228.0],[4345813.0,4062880.0],[4332963.0,4070760.0],[4339059.0,4065677.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5074,"LEVL_CODE":0,"NUTS_BN_ID":5074,"OTHR_CNTR_":"F","Shape_Leng":43389.744691762797},"geometry":{"type":"MultiLineString","coordinates":[[[4359962.0,4043380.0],[4353783.0,4073041.0],[4364000.0,4081227.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5078,"LEVL_CODE":0,"NUTS_BN_ID":5078,"OTHR_CNTR_":"F","Shape_Leng":80581.784847248899},"geometry":{"type":"MultiLineString","coordinates":[[[4050574.0,4095533.0],[4061465.0,4076321.0],[4048410.0,4061908.0],[4043674.0,4093376.0],[4050574.0,4095533.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5083,"LEVL_CODE":0,"NUTS_BN_ID":5083,"OTHR_CNTR_":"F","Shape_Leng":27345.1410585173},"geometry":{"type":"MultiLineString","coordinates":[[[4364000.0,4081227.0],[4359281.0,4087323.0],[4357009.0,4090267.0],[4348996.0,4076514.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5226,"LEVL_CODE":0,"NUTS_BN_ID":5226,"OTHR_CNTR_":"F","Shape_Leng":664105.51266445476},"geometry":{"type":"MultiLineString","coordinates":[[[4083474.0,4068181.0],[4117890.0,4091193.0],[4078140.0,4090520.0],[4096744.0,4101221.0],[4103229.0,4127230.0],[4119324.0,4146297.0],[4146149.0,4156235.0],[4140237.0,4161930.0],[4099979.0,4136062.0],[4087042.0,4104984.0],[4074761.0,4124723.0],[4086560.0,4151364.0],[4067652.0,4125460.0],[4055066.0,4141196.0],[4061808.0,4151658.0],[4060169.0,4164869.0],[4085997.0,4158034.0],[4087295.0,4181821.0],[4084423.0,4159454.0],[4064688.0,4168551.0],[4086381.0,4191426.0],[4061405.0,4168677.0],[4058075.0,4177938.0],[4062174.0,4178850.0],[4045301.0,4199716.0],[4072688.0,4181135.0],[4056147.0,4202393.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5289,"LEVL_CODE":0,"NUTS_BN_ID":5289,"OTHR_CNTR_":"F","Shape_Leng":452515.71369031363},"geometry":{"type":"MultiLineString","coordinates":[[[4056147.0,4202393.0],[4055795.0,4216391.0],[4051350.0,4221639.0],[4073271.0,4223840.0],[4071745.0,4226928.0],[4049169.0,4249509.0],[4063872.0,4256910.0],[4052121.0,4266947.0],[4098686.0,4268570.0],[4067553.0,4284429.0],[4054512.0,4286137.0],[4054276.0,4300626.0],[4154469.0,4311397.0],[4081809.0,4323046.0],[4064292.0,4349591.0],[4084116.0,4331291.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5348,"LEVL_CODE":0,"NUTS_BN_ID":5348,"OTHR_CNTR_":"F","Shape_Leng":505426.83051482443},"geometry":{"type":"MultiLineString","coordinates":[[[4084116.0,4331291.0],[4091441.0,4336644.0],[4080456.0,4344062.0],[4128145.0,4333826.0],[4108578.0,4352391.0],[4130285.0,4368720.0],[4146132.0,4347733.0],[4143949.0,4386551.0],[4127511.0,4386009.0],[4132048.0,4395059.0],[4225662.0,4399706.0],[4162668.0,4426526.0],[4183684.0,4436808.0],[4190821.0,4424835.0],[4224909.0,4425648.0],[4224972.0,4446019.0],[4258462.0,4454047.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5350,"LEVL_CODE":0,"NUTS_BN_ID":5350,"OTHR_CNTR_":"F","Shape_Leng":259534.14765059669},"geometry":{"type":"MultiLineString","coordinates":[[[4258462.0,4454047.0],[4261942.0,4455926.0],[4244868.0,4464630.0],[4258872.0,4471525.0],[4253205.0,4478145.0],[4258515.0,4480649.0],[4275258.0,4465177.0],[4295968.0,4477161.0],[4283237.0,4474029.0],[4278287.0,4487428.0],[4308715.0,4504622.0],[4306784.0,4501320.0],[4319881.0,4482010.0],[4312090.0,4467674.0],[4363824.0,4481991.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5420,"LEVL_CODE":0,"NUTS_BN_ID":5420,"OTHR_CNTR_":"F","Shape_Leng":165864.08839671849},"geometry":{"type":"MultiLineString","coordinates":[[[4329520.0,4491392.0],[4311319.0,4502565.0],[4327456.0,4516663.0],[4297595.0,4512112.0],[4321505.0,4548975.0],[4351822.0,4587387.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5425,"LEVL_CODE":0,"NUTS_BN_ID":5425,"OTHR_CNTR_":"F","Shape_Leng":268332.74231449701},"geometry":{"type":"MultiLineString","coordinates":[[[4363824.0,4481991.0],[4368037.0,4495928.0],[4352388.0,4493807.0],[4393287.0,4522757.0],[4374036.0,4528691.0],[4394862.0,4545286.0],[4380994.0,4552665.0],[4350292.0,4522352.0],[4373965.0,4526800.0],[4368413.0,4516039.0],[4329520.0,4491392.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5438,"LEVL_CODE":0,"NUTS_BN_ID":5438,"OTHR_CNTR_":"F","Shape_Leng":220576.71875820571},"geometry":{"type":"MultiLineString","coordinates":[[[4351822.0,4587387.0],[4347561.0,4592931.0],[4385972.0,4592958.0],[4380649.0,4579005.0],[4404196.0,4609747.0],[4377665.0,4626493.0],[4393232.0,4642043.0],[4382028.0,4639479.0],[4413856.0,4664560.0],[4414872.0,4663887.0],[4417938.0,4663048.0],[4420232.0,4660610.0],[4424862.0,4656351.0],[4424695.0,4654270.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":456,"LEVL_CODE":0,"NUTS_BN_ID":456,"OTHR_CNTR_":"T","Shape_Leng":204744.03252638821},"geometry":{"type":"MultiLineString","coordinates":[[[7262037.0,2318390.0],[7239350.0,2318251.0],[7240176.0,2373668.0],[7223756.0,2372850.0],[7203873.0,2417992.0],[7161575.0,2461760.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":505,"LEVL_CODE":0,"NUTS_BN_ID":505,"OTHR_CNTR_":"T","Shape_Leng":145297.96636822241},"geometry":{"type":"MultiLineString","coordinates":[[[7180384.0,2515331.0],[7207824.0,2518559.0],[7200777.0,2525289.0],[7155233.0,2540833.0],[7097392.0,2525650.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":506,"LEVL_CODE":0,"NUTS_BN_ID":506,"OTHR_CNTR_":"T","Shape_Leng":66124.044797044393},"geometry":{"type":"MultiLineString","coordinates":[[[7161575.0,2461760.0],[7186133.0,2480686.0],[7180384.0,2515331.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":709,"LEVL_CODE":0,"NUTS_BN_ID":709,"OTHR_CNTR_":"F","Shape_Leng":14360.0728649175},"geometry":{"type":"MultiLineString","coordinates":[[[5234386.0,2046492.0],[5247353.0,2040321.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":743,"LEVL_CODE":0,"NUTS_BN_ID":743,"OTHR_CNTR_":"T","Shape_Leng":113636.8669069726},"geometry":{"type":"MultiLineString","coordinates":[[[7097392.0,2525650.0],[7077851.0,2555965.0],[7077451.0,2592343.0],[7042457.0,2614068.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":760,"LEVL_CODE":0,"NUTS_BN_ID":760,"OTHR_CNTR_":"T","Shape_Leng":111551.0066400846},"geometry":{"type":"MultiLineString","coordinates":[[[7042457.0,2614068.0],[7039844.0,2620996.0],[6971766.0,2645367.0],[6954096.0,2618884.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":843,"LEVL_CODE":0,"NUTS_BN_ID":843,"OTHR_CNTR_":"T","Shape_Leng":80488.827235175704},"geometry":{"type":"MultiLineString","coordinates":[[[6954096.0,2618884.0],[6877693.0,2593565.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":859,"LEVL_CODE":0,"NUTS_BN_ID":859,"OTHR_CNTR_":"F","Shape_Leng":88085.501759167702},"geometry":{"type":"MultiLineString","coordinates":[[[5201644.0,2114996.0],[5193635.0,2110758.0],[5203137.0,2075960.0],[5234386.0,2046492.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":893,"LEVL_CODE":0,"NUTS_BN_ID":893,"OTHR_CNTR_":"F","Shape_Leng":102901.23715817821},"geometry":{"type":"MultiLineString","coordinates":[[[5247775.0,2180925.0],[5237823.0,2190137.0],[5200420.0,2147880.0],[5201644.0,2114996.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":948,"LEVL_CODE":0,"NUTS_BN_ID":948,"OTHR_CNTR_":"F","Shape_Leng":23729.919389910701},"geometry":{"type":"MultiLineString","coordinates":[[[5247775.0,2180925.0],[5264814.0,2197440.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":953,"LEVL_CODE":0,"NUTS_BN_ID":953,"OTHR_CNTR_":"F","Shape_Leng":76397.827559952493},"geometry":{"type":"MultiLineString","coordinates":[[[5264814.0,2197440.0],[5276031.0,2202301.0],[5338320.0,2217739.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"F","FID":1184,"LEVL_CODE":0,"NUTS_BN_ID":1184,"OTHR_CNTR_":"F","Shape_Leng":438827.34019295301},"geometry":{"type":"MultiLineString","coordinates":[[[5099940.0,2131468.0],[5088368.0,2166835.0],[5110860.0,2215446.0],[5148385.0,2216599.0],[5141292.0,2239060.0],[5166993.0,2250206.0],[5141137.0,2266081.0],[5066457.0,2314658.0],[5026386.0,2278342.0],[5013975.0,2247728.0],[5024012.0,2211771.0],[5014574.0,2200025.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":79,"LEVL_CODE":0,"NUTS_BN_ID":79,"OTHR_CNTR_":"F","Shape_Leng":238482.25256236721},"geometry":{"type":"MultiLineString","coordinates":[[[6520093.0,1880306.0],[6490442.0,1873763.0],[6434813.0,1781580.0],[6340388.0,1747312.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":93,"LEVL_CODE":0,"NUTS_BN_ID":93,"OTHR_CNTR_":"F","Shape_Leng":365935.29785307782},"geometry":{"type":"MultiLineString","coordinates":[[[6340388.0,1747312.0],[6280643.0,1780634.0],[6156544.0,1784669.0],[6139685.0,1712697.0],[6082563.0,1685889.0],[6046337.0,1688778.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":97,"LEVL_CODE":0,"NUTS_BN_ID":97,"OTHR_CNTR_":"F","Shape_Leng":117856.0761420444},"geometry":{"type":"MultiLineString","coordinates":[[[6604630.0,1929138.0],[6582102.0,1881443.0],[6563747.0,1871955.0],[6520093.0,1880306.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"F","FID":98,"LEVL_CODE":0,"NUTS_BN_ID":98,"OTHR_CNTR_":"F","Shape_Leng":143658.94741399781},"geometry":{"type":"MultiLineString","coordinates":[[[6632576.0,1824645.0],[6634820.0,1836095.0],[6608183.0,1861745.0],[6633922.0,1911030.0],[6621807.0,1929664.0],[6604630.0,1929138.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1206,"LEVL_CODE":0,"NUTS_BN_ID":1206,"OTHR_CNTR_":"F","Shape_Leng":20258.606278563901},"geometry":{"type":"MultiLineString","coordinates":[[[5548099.0,2408593.0],[5568146.0,2411511.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1210,"LEVL_CODE":0,"NUTS_BN_ID":1210,"OTHR_CNTR_":"F","Shape_Leng":11643.2575319548},"geometry":{"type":"MultiLineString","coordinates":[[[5568146.0,2411511.0],[5577132.0,2418915.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1214,"LEVL_CODE":0,"NUTS_BN_ID":1214,"OTHR_CNTR_":"F","Shape_Leng":17043.231233234699},"geometry":{"type":"MultiLineString","coordinates":[[[5453787.0,2394900.0],[5470522.0,2398126.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1219,"LEVL_CODE":0,"NUTS_BN_ID":1219,"OTHR_CNTR_":"F","Shape_Leng":25903.550154428802},"geometry":{"type":"MultiLineString","coordinates":[[[5470522.0,2398126.0],[5494945.0,2406758.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1220,"LEVL_CODE":0,"NUTS_BN_ID":1220,"OTHR_CNTR_":"F","Shape_Leng":53185.115601285303},"geometry":{"type":"MultiLineString","coordinates":[[[5494945.0,2406758.0],[5548099.0,2408593.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1228,"LEVL_CODE":0,"NUTS_BN_ID":1228,"OTHR_CNTR_":"F","Shape_Leng":114592.9576385391},"geometry":{"type":"MultiLineString","coordinates":[[[4927372.0,2260005.0],[4870047.0,2318986.0],[4846574.0,2341238.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1236,"LEVL_CODE":0,"NUTS_BN_ID":1236,"OTHR_CNTR_":"F","Shape_Leng":3370.1076224632998},"geometry":{"type":"MultiLineString","coordinates":[[[4114107.0,2299149.0],[4112209.0,2296365.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1243,"LEVL_CODE":0,"NUTS_BN_ID":1243,"OTHR_CNTR_":"F","Shape_Leng":40081.063575502099},"geometry":{"type":"MultiLineString","coordinates":[[[5413807.0,2397750.0],[5453787.0,2394900.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1246,"LEVL_CODE":0,"NUTS_BN_ID":1246,"OTHR_CNTR_":"F","Shape_Leng":50962.893379902896},"geometry":{"type":"MultiLineString","coordinates":[[[5363362.0,2390508.0],[5413807.0,2397750.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1265,"LEVL_CODE":0,"NUTS_BN_ID":1265,"OTHR_CNTR_":"F","Shape_Leng":6410.0469588039996},"geometry":{"type":"MultiLineString","coordinates":[[[4515661.0,2313079.0],[4521741.0,2315111.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1281,"LEVL_CODE":0,"NUTS_BN_ID":1281,"OTHR_CNTR_":"F","Shape_Leng":75718.622569776402},"geometry":{"type":"MultiLineString","coordinates":[[[5728800.0,2487226.0],[5803878.0,2477397.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1282,"LEVL_CODE":0,"NUTS_BN_ID":1282,"OTHR_CNTR_":"F","Shape_Leng":24515.686088615599},"geometry":{"type":"MultiLineString","coordinates":[[[4521741.0,2315111.0],[4523042.0,2323554.0],[4514417.0,2319323.0],[4515661.0,2313079.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1285,"LEVL_CODE":0,"NUTS_BN_ID":1285,"OTHR_CNTR_":"F","Shape_Leng":67733.665448683896},"geometry":{"type":"MultiLineString","coordinates":[[[5577132.0,2418915.0],[5623289.0,2468487.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1287,"LEVL_CODE":0,"NUTS_BN_ID":1287,"OTHR_CNTR_":"F","Shape_Leng":1808.8960851872},"geometry":{"type":"MultiLineString","coordinates":[[[5623289.0,2468487.0],[5624874.0,2469358.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1290,"LEVL_CODE":0,"NUTS_BN_ID":1290,"OTHR_CNTR_":"F","Shape_Leng":34134.276312556103},"geometry":{"type":"MultiLineString","coordinates":[[[4137477.0,2330752.0],[4121720.0,2300473.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1296,"LEVL_CODE":0,"NUTS_BN_ID":1296,"OTHR_CNTR_":"F","Shape_Leng":48936.051058666497},"geometry":{"type":"MultiLineString","coordinates":[[[5355669.0,2421964.0],[5362572.0,2419257.0],[5349544.0,2396012.0],[5363362.0,2390508.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1308,"LEVL_CODE":0,"NUTS_BN_ID":1308,"OTHR_CNTR_":"F","Shape_Leng":72040.941555591693},"geometry":{"type":"MultiLineString","coordinates":[[[5624874.0,2469358.0],[5692417.0,2494415.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1309,"LEVL_CODE":0,"NUTS_BN_ID":1309,"OTHR_CNTR_":"F","Shape_Leng":37086.416125969103},"geometry":{"type":"MultiLineString","coordinates":[[[5692417.0,2494415.0],[5728800.0,2487226.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1326,"LEVL_CODE":0,"NUTS_BN_ID":1326,"OTHR_CNTR_":"F","Shape_Leng":26576.598300830701},"geometry":{"type":"MultiLineString","coordinates":[[[5330612.0,2430822.0],[5355669.0,2421964.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1329,"LEVL_CODE":0,"NUTS_BN_ID":1329,"OTHR_CNTR_":"F","Shape_Leng":37992.505991566803},"geometry":{"type":"MultiLineString","coordinates":[[[4846574.0,2341238.0],[4817552.0,2365757.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1333,"LEVL_CODE":0,"NUTS_BN_ID":1333,"OTHR_CNTR_":"F","Shape_Leng":76767.834138853505},"geometry":{"type":"MultiLineString","coordinates":[[[4072438.0,2366359.0],[4081518.0,2352161.0],[4137477.0,2330752.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1376,"LEVL_CODE":0,"NUTS_BN_ID":1376,"OTHR_CNTR_":"F","Shape_Leng":27072.500008764},"geometry":{"type":"MultiLineString","coordinates":[[[4817552.0,2365757.0],[4809414.0,2391577.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1414,"LEVL_CODE":0,"NUTS_BN_ID":1414,"OTHR_CNTR_":"F","Shape_Leng":32898.989181455501},"geometry":{"type":"MultiLineString","coordinates":[[[4078566.0,2398683.0],[4072438.0,2366359.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1422,"LEVL_CODE":0,"NUTS_BN_ID":1422,"OTHR_CNTR_":"F","Shape_Leng":11357.549390989199},"geometry":{"type":"MultiLineString","coordinates":[[[4088123.0,2404819.0],[4078566.0,2398683.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1459,"LEVL_CODE":0,"NUTS_BN_ID":1459,"OTHR_CNTR_":"F","Shape_Leng":61796.812421691298},"geometry":{"type":"MultiLineString","coordinates":[[[4809414.0,2391577.0],[4774121.0,2442304.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5534,"LEVL_CODE":0,"NUTS_BN_ID":5534,"OTHR_CNTR_":"F","Shape_Leng":1302247.476627423},"geometry":{"type":"MultiLineString","coordinates":[[[4424695.0,4654270.0],[4460081.0,4693338.0],[4417157.0,4680059.0],[4427528.0,4721619.0],[4450855.0,4708517.0],[4429936.0,4726003.0],[4442941.0,4747195.0],[4443364.0,4758981.0],[4430324.0,4755562.0],[4508250.0,4807560.0],[4457675.0,4789532.0],[4482033.0,4803246.0],[4455965.0,4806899.0],[4487767.0,4837279.0],[4463682.0,4848000.0],[4498366.0,4858775.0],[4474921.0,4874263.0],[4497767.0,4876913.0],[4498736.0,4899070.0],[4517745.0,4905362.0],[4542582.0,4910288.0],[4558834.0,4896937.0],[4560147.0,4905858.0],[4544974.0,4920802.0],[4508480.0,4910988.0],[4564006.0,4945412.0],[4542127.0,4954168.0],[4571011.0,4965035.0],[4523425.0,4971842.0],[4574182.0,4997067.0],[4553540.0,5002989.0],[4548330.0,4999396.0],[4550325.0,4998270.0],[4549510.0,4994988.0],[4543154.0,5000556.0],[4573968.0,5025852.0],[4606683.0,5017741.0],[4581538.0,5039530.0],[4648060.0,5051358.0],[4572820.0,5043284.0],[4592146.0,5059185.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5549,"LEVL_CODE":0,"NUTS_BN_ID":5549,"OTHR_CNTR_":"F","Shape_Leng":106773.6095943542},"geometry":{"type":"MultiLineString","coordinates":[[[4534906.0,5043352.0],[4497276.0,5011077.0],[4504340.0,5035801.0],[4534906.0,5043352.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5560,"LEVL_CODE":0,"NUTS_BN_ID":5560,"OTHR_CNTR_":"F","Shape_Leng":125164.11295173501},"geometry":{"type":"MultiLineString","coordinates":[[[4566279.0,5080563.0],[4556984.0,5055531.0],[4569253.0,5080038.0],[4578832.0,5077215.0],[4570106.0,5090723.0],[4581550.0,5093287.0],[4586926.0,5060463.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5564,"LEVL_CODE":0,"NUTS_BN_ID":5564,"OTHR_CNTR_":"F","Shape_Leng":116324.0480895864},"geometry":{"type":"MultiLineString","coordinates":[[[4542879.0,5072804.0],[4500101.0,5067705.0],[4536736.0,5096035.0],[4535650.0,5078092.0],[4542879.0,5072804.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5566,"LEVL_CODE":0,"NUTS_BN_ID":5566,"OTHR_CNTR_":"F","Shape_Leng":189255.22865159411},"geometry":{"type":"MultiLineString","coordinates":[[[4586926.0,5060463.0],[4528775.0,5024222.0],[4555127.0,5072751.0],[4544264.0,5078490.0],[4548588.0,5100907.0],[4562967.0,5095068.0],[4563275.0,5093715.0],[4565032.0,5086013.0],[4566279.0,5080563.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5577,"LEVL_CODE":0,"NUTS_BN_ID":5577,"OTHR_CNTR_":"F","Shape_Leng":142327.7748550121},"geometry":{"type":"MultiLineString","coordinates":[[[4623494.0,5167474.0],[4640936.0,5162731.0],[4594227.0,5116657.0],[4623494.0,5167474.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5609,"LEVL_CODE":0,"NUTS_BN_ID":5609,"OTHR_CNTR_":"F","Shape_Leng":674968.82375811052},"geometry":{"type":"MultiLineString","coordinates":[[[4592146.0,5059185.0],[4635690.0,5078452.0],[4616921.0,5085918.0],[4639537.0,5087322.0],[4622886.0,5103017.0],[4648374.0,5132852.0],[4639402.0,5140505.0],[4646356.0,5169575.0],[4702232.0,5147038.0],[4671775.0,5185823.0],[4682054.0,5207159.0],[4723234.0,5225514.0],[4716474.0,5154852.0],[4728110.0,5211927.0],[4758465.0,5233257.0],[4753269.0,5243553.0],[4793154.0,5220868.0],[4770833.0,5251348.0],[4747080.0,5266295.0],[4755858.0,5267938.0],[4758338.0,5265842.0],[4758926.0,5265819.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5626,"LEVL_CODE":0,"NUTS_BN_ID":5626,"OTHR_CNTR_":"F","Shape_Leng":130852.4820098514},"geometry":{"type":"MultiLineString","coordinates":[[[4819016.0,5340470.0],[4800756.0,5308631.0],[4765804.0,5316715.0],[4819016.0,5340470.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5635,"LEVL_CODE":0,"NUTS_BN_ID":5635,"OTHR_CNTR_":"F","Shape_Leng":1264578.8774033671},"geometry":{"type":"MultiLineString","coordinates":[[[4758926.0,5265819.0],[4759017.0,5279737.0],[4772323.0,5264707.0],[4768544.0,5274134.0],[4774580.0,5283125.0],[4814532.0,5274766.0],[4822168.0,5245634.0],[4836425.0,5253737.0],[4839774.0,5260183.0],[4823198.0,5264757.0],[4821878.0,5279215.0],[4823630.0,5283156.0],[4847720.0,5321126.0],[4851633.0,5338293.0],[4845567.0,5353924.0],[4853355.0,5371391.0],[4904866.0,5371780.0],[4884969.0,5326180.0],[4889743.0,5279804.0],[4899608.0,5278475.0],[4926203.0,5385938.0],[4935847.0,5373580.0],[4940443.0,5321101.0],[4956940.0,5339972.0],[4952068.0,5345923.0],[4971284.0,5379977.0],[4945706.0,5388365.0],[4959460.0,5414230.0],[4995907.0,5405845.0],[4988568.0,5342111.0],[5011730.0,5350500.0],[5004552.0,5359342.0],[5013446.0,5401339.0],[5109490.0,5361254.0],[5029763.0,5321886.0],[5024984.0,5316288.0],[5079068.0,5297836.0],[5073647.0,5276014.0],[5120442.0,5305023.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5428,"LEVL_CODE":0,"NUTS_BN_ID":5428,"OTHR_CNTR_":"F","Shape_Leng":53354.768686603398},"geometry":{"type":"MultiLineString","coordinates":[[[2807713.0,4905170.0],[2858074.0,4922790.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"T","EFTA_FLAG":"T","EU_FLAG":"F","FID":5513,"LEVL_CODE":0,"NUTS_BN_ID":5513,"OTHR_CNTR_":"F","Shape_Leng":2319693.9867474269},"geometry":{"type":"MultiLineString","coordinates":[[[2858074.0,4922790.0],[2825721.0,4929230.0],[2836830.0,4988052.0],[2772994.0,5030467.0],[2873664.0,4996331.0],[2884812.0,5007584.0],[2850207.0,5026491.0],[2901522.0,5036021.0],[2789081.0,5102185.0],[2823604.0,5122086.0],[2858775.0,5099169.0],[2837372.0,5125010.0],[2861864.0,5105557.0],[2847713.0,5138451.0],[2870147.0,5146809.0],[2899502.0,5097006.0],[2891388.0,5138982.0],[2918199.0,5131039.0],[2889917.0,5156099.0],[2906877.0,5162335.0],[2945303.0,5084013.0],[2930388.0,5057287.0],[2914091.0,5069187.0],[2925425.0,5023664.0],[2973964.0,5034938.0],[2985949.0,5073939.0],[3007090.0,5020824.0],[3016349.0,5028038.0],[3024135.0,5051471.0],[3058125.0,5053756.0],[3104836.0,5008977.0],[3180088.0,5043988.0],[3186551.0,5010368.0],[3242017.0,5000735.0],[3203025.0,4983241.0],[3221309.0,4958506.0],[3201368.0,4938032.0],[3245692.0,4896069.0],[3233201.0,4849004.0],[3133392.0,4785857.0],[2953115.0,4764420.0],[2801939.0,4882218.0],[2796614.0,4884991.0],[2777134.0,4911966.0],[2807713.0,4905170.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":32,"LEVL_CODE":0,"NUTS_BN_ID":32,"OTHR_CNTR_":"T","Shape_Leng":4291.4051474164999},"geometry":{"type":"MultiLineString","coordinates":[[[3138771.0,1457161.0],[3135148.0,1459461.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":50,"LEVL_CODE":0,"NUTS_BN_ID":50,"OTHR_CNTR_":"F","Shape_Leng":5717.3821395207997},"geometry":{"type":"MultiLineString","coordinates":[[[2932372.0,1562565.0],[2929613.0,1567572.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":54,"LEVL_CODE":0,"NUTS_BN_ID":54,"OTHR_CNTR_":"T","Shape_Leng":1117.3849188413999},"geometry":{"type":"MultiLineString","coordinates":[[[2938042.0,1592777.0],[2936960.0,1593057.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":177,"LEVL_CODE":0,"NUTS_BN_ID":177,"OTHR_CNTR_":"F","Shape_Leng":40304.262118311402},"geometry":{"type":"MultiLineString","coordinates":[[[2777974.0,1743032.0],[2776212.0,1783298.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":286,"LEVL_CODE":0,"NUTS_BN_ID":286,"OTHR_CNTR_":"F","Shape_Leng":15606.859860754401},"geometry":{"type":"MultiLineString","coordinates":[[[2841368.0,1845643.0],[2825811.0,1846891.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":287,"LEVL_CODE":0,"NUTS_BN_ID":287,"OTHR_CNTR_":"F","Shape_Leng":98967.785081142501},"geometry":{"type":"MultiLineString","coordinates":[[[2776212.0,1783298.0],[2807855.0,1827404.0],[2831223.0,1826902.0],[2841368.0,1845643.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":365,"LEVL_CODE":0,"NUTS_BN_ID":365,"OTHR_CNTR_":"F","Shape_Leng":69298.329271749302},"geometry":{"type":"MultiLineString","coordinates":[[[2825811.0,1846891.0],[2813571.0,1878282.0],[2830219.0,1909755.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":441,"LEVL_CODE":0,"NUTS_BN_ID":441,"OTHR_CNTR_":"F","Shape_Leng":74517.189173445004},"geometry":{"type":"MultiLineString","coordinates":[[[2830219.0,1909755.0],[2857665.0,1934461.0],[2839691.0,1967475.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":502,"LEVL_CODE":0,"NUTS_BN_ID":502,"OTHR_CNTR_":"F","Shape_Leng":50391.529357274099},"geometry":{"type":"MultiLineString","coordinates":[[[2839691.0,1967475.0],[2822969.0,2015011.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":581,"LEVL_CODE":0,"NUTS_BN_ID":581,"OTHR_CNTR_":"F","Shape_Leng":117761.3927057407},"geometry":{"type":"MultiLineString","coordinates":[[[2822969.0,2015011.0],[2866693.0,2005846.0],[2886974.0,2039964.0],[2877242.0,2055263.0],[2885230.0,2068271.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":584,"LEVL_CODE":0,"NUTS_BN_ID":584,"OTHR_CNTR_":"F","Shape_Leng":7459.4206761014002},"geometry":{"type":"MultiLineString","coordinates":[[[2885230.0,2068271.0],[2892687.0,2068077.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":738,"LEVL_CODE":0,"NUTS_BN_ID":738,"OTHR_CNTR_":"F","Shape_Leng":87322.27927395},"geometry":{"type":"MultiLineString","coordinates":[[[2892687.0,2068077.0],[2911171.0,2130989.0],[2904458.0,2151678.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":783,"LEVL_CODE":0,"NUTS_BN_ID":783,"OTHR_CNTR_":"F","Shape_Leng":27808.479865090099},"geometry":{"type":"MultiLineString","coordinates":[[[2904458.0,2151678.0],[2928115.0,2166295.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":796,"LEVL_CODE":0,"NUTS_BN_ID":796,"OTHR_CNTR_":"F","Shape_Leng":20056.232022702399},"geometry":{"type":"MultiLineString","coordinates":[[[2928115.0,2166295.0],[2947305.0,2172125.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":802,"LEVL_CODE":0,"NUTS_BN_ID":802,"OTHR_CNTR_":"F","Shape_Leng":57471.479892957803},"geometry":{"type":"MultiLineString","coordinates":[[[5647445.0,2163287.0],[5592371.0,2146860.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":804,"LEVL_CODE":0,"NUTS_BN_ID":804,"OTHR_CNTR_":"F","Shape_Leng":6273.6279013405001},"geometry":{"type":"MultiLineString","coordinates":[[[5592371.0,2146860.0],[5587713.0,2151062.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":805,"LEVL_CODE":0,"NUTS_BN_ID":805,"OTHR_CNTR_":"F","Shape_Leng":3832.8223623898998},"geometry":{"type":"MultiLineString","coordinates":[[[5650630.0,2165420.0],[5647445.0,2163287.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":819,"LEVL_CODE":0,"NUTS_BN_ID":819,"OTHR_CNTR_":"F","Shape_Leng":33526.736894287002},"geometry":{"type":"MultiLineString","coordinates":[[[5587713.0,2151062.0],[5554204.0,2149957.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":820,"LEVL_CODE":0,"NUTS_BN_ID":820,"OTHR_CNTR_":"F","Shape_Leng":58620.644777510599},"geometry":{"type":"MultiLineString","coordinates":[[[5458423.0,2133421.0],[5401576.0,2119112.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":844,"LEVL_CODE":0,"NUTS_BN_ID":844,"OTHR_CNTR_":"F","Shape_Leng":40123.8627139456},"geometry":{"type":"MultiLineString","coordinates":[[[5491534.0,2156084.0],[5458423.0,2133421.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":848,"LEVL_CODE":0,"NUTS_BN_ID":848,"OTHR_CNTR_":"F","Shape_Leng":70764.313151647104},"geometry":{"type":"MultiLineString","coordinates":[[[5554204.0,2149957.0],[5528871.0,2168525.0],[5491534.0,2156084.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":873,"LEVL_CODE":0,"NUTS_BN_ID":873,"OTHR_CNTR_":"F","Shape_Leng":78214.919914626007},"geometry":{"type":"MultiLineString","coordinates":[[[5675519.0,2215229.0],[5651804.0,2207462.0],[5666298.0,2176857.0],[5650630.0,2165420.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":883,"LEVL_CODE":0,"NUTS_BN_ID":883,"OTHR_CNTR_":"F","Shape_Leng":9405.9008681903997},"geometry":{"type":"MultiLineString","coordinates":[[[2831796.0,2259162.0],[2822605.0,2261163.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":894,"LEVL_CODE":0,"NUTS_BN_ID":894,"OTHR_CNTR_":"F","Shape_Leng":70906.462057644603},"geometry":{"type":"MultiLineString","coordinates":[[[2901985.0,2249097.0],[2831796.0,2259162.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":898,"LEVL_CODE":0,"NUTS_BN_ID":898,"OTHR_CNTR_":"F","Shape_Leng":2571.8526078158998},"geometry":{"type":"MultiLineString","coordinates":[[[4525474.0,2092653.0],[4524733.0,2092025.0],[4525675.0,2092027.0],[4525474.0,2092653.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":909,"LEVL_CODE":0,"NUTS_BN_ID":909,"OTHR_CNTR_":"F","Shape_Leng":20604.013276075399},"geometry":{"type":"MultiLineString","coordinates":[[[2921681.0,2255144.0],[2901985.0,2249097.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":910,"LEVL_CODE":0,"NUTS_BN_ID":910,"OTHR_CNTR_":"F","Shape_Leng":127185.5561585554},"geometry":{"type":"MultiLineString","coordinates":[[[2947305.0,2172125.0],[2977212.0,2197407.0],[2953508.0,2247312.0],[2921681.0,2255144.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":936,"LEVL_CODE":0,"NUTS_BN_ID":936,"OTHR_CNTR_":"F","Shape_Leng":62795.357375054598},"geometry":{"type":"MultiLineString","coordinates":[[[2828169.0,2298249.0],[2767741.0,2281168.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":937,"LEVL_CODE":0,"NUTS_BN_ID":937,"OTHR_CNTR_":"F","Shape_Leng":37500.940182883998},"geometry":{"type":"MultiLineString","coordinates":[[[2822605.0,2261163.0],[2828169.0,2298249.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":972,"LEVL_CODE":0,"NUTS_BN_ID":972,"OTHR_CNTR_":"F","Shape_Leng":122913.3676381242},"geometry":{"type":"MultiLineString","coordinates":[[[3640545.0,2191503.0],[3658465.0,2177267.0],[3758413.0,2173293.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":982,"LEVL_CODE":0,"NUTS_BN_ID":982,"OTHR_CNTR_":"F","Shape_Leng":1400.4913670398},"geometry":{"type":"MultiLineString","coordinates":[[[3640254.0,2192873.0],[3640545.0,2191503.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":991,"LEVL_CODE":0,"NUTS_BN_ID":991,"OTHR_CNTR_":"F","Shape_Leng":9110.0365018702996},"geometry":{"type":"MultiLineString","coordinates":[[[3645973.0,2199965.0],[3640254.0,2192873.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":998,"LEVL_CODE":0,"NUTS_BN_ID":998,"OTHR_CNTR_":"F","Shape_Leng":25856.974128332899},"geometry":{"type":"MultiLineString","coordinates":[[[3640254.0,2192873.0],[3618229.0,2206418.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":999,"LEVL_CODE":0,"NUTS_BN_ID":999,"OTHR_CNTR_":"F","Shape_Leng":28484.781631130001},"geometry":{"type":"MultiLineString","coordinates":[[[3618229.0,2206418.0],[3645973.0,2199965.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1011,"LEVL_CODE":0,"NUTS_BN_ID":1011,"OTHR_CNTR_":"F","Shape_Leng":15017.1973926544},"geometry":{"type":"MultiLineString","coordinates":[[[3540710.0,2226544.0],[3555450.0,2223671.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1035,"LEVL_CODE":0,"NUTS_BN_ID":1035,"OTHR_CNTR_":"F","Shape_Leng":21985.547178368401},"geometry":{"type":"MultiLineString","coordinates":[[[3555450.0,2223671.0],[3573289.0,2236522.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1036,"LEVL_CODE":0,"NUTS_BN_ID":1036,"OTHR_CNTR_":"F","Shape_Leng":54091.081168964301},"geometry":{"type":"MultiLineString","coordinates":[[[3573289.0,2236522.0],[3618229.0,2206418.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1047,"LEVL_CODE":0,"NUTS_BN_ID":1047,"OTHR_CNTR_":"F","Shape_Leng":67086.711607346297},"geometry":{"type":"MultiLineString","coordinates":[[[3478445.0,2251519.0],[3540710.0,2226544.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1059,"LEVL_CODE":0,"NUTS_BN_ID":1059,"OTHR_CNTR_":"F","Shape_Leng":74333.054055141794},"geometry":{"type":"MultiLineString","coordinates":[[[5014574.0,2200025.0],[4946488.0,2229853.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1072,"LEVL_CODE":0,"NUTS_BN_ID":1072,"OTHR_CNTR_":"F","Shape_Leng":42317.977405924903},"geometry":{"type":"MultiLineString","coordinates":[[[3446155.0,2264004.0],[3458129.0,2246330.0],[3478445.0,2251519.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1108,"LEVL_CODE":0,"NUTS_BN_ID":1108,"OTHR_CNTR_":"F","Shape_Leng":42367.072271140998},"geometry":{"type":"MultiLineString","coordinates":[[[4940446.0,2234753.0],[4950719.0,2239656.0],[4929499.0,2258500.0],[4927372.0,2260005.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1128,"LEVL_CODE":0,"NUTS_BN_ID":1128,"OTHR_CNTR_":"F","Shape_Leng":92238.001053370797},"geometry":{"type":"MultiLineString","coordinates":[[[3371029.0,2317520.0],[3379960.0,2311162.0],[3446155.0,2264004.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1147,"LEVL_CODE":0,"NUTS_BN_ID":1147,"OTHR_CNTR_":"F","Shape_Leng":7646.8607834064996},"geometry":{"type":"MultiLineString","coordinates":[[[3367336.0,2324216.0],[3371029.0,2317520.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2187,"LEVL_CODE":0,"NUTS_BN_ID":2187,"OTHR_CNTR_":"F","Shape_Leng":66659.635583089796},"geometry":{"type":"MultiLineString","coordinates":[[[5279162.0,2843993.0],[5232859.0,2796039.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2191,"LEVL_CODE":0,"NUTS_BN_ID":2191,"OTHR_CNTR_":"F","Shape_Leng":50751.459284322402},"geometry":{"type":"MultiLineString","coordinates":[[[4550493.0,2716599.0],[4535816.0,2765182.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2193,"LEVL_CODE":0,"NUTS_BN_ID":2193,"OTHR_CNTR_":"T","Shape_Leng":118869.0007075968},"geometry":{"type":"MultiLineString","coordinates":[[[5322717.0,2853436.0],[5402508.0,2868514.0],[5434197.0,2848155.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2198,"LEVL_CODE":0,"NUTS_BN_ID":2198,"OTHR_CNTR_":"T","Shape_Leng":90549.893468609793},"geometry":{"type":"MultiLineString","coordinates":[[[5434197.0,2848155.0],[5512617.0,2893427.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2202,"LEVL_CODE":0,"NUTS_BN_ID":2202,"OTHR_CNTR_":"F","Shape_Leng":3956.6112002558998},"geometry":{"type":"MultiLineString","coordinates":[[[4535816.0,2765182.0],[4534509.0,2768916.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2206,"LEVL_CODE":0,"NUTS_BN_ID":2206,"OTHR_CNTR_":"F","Shape_Leng":84221.746479697496},"geometry":{"type":"MultiLineString","coordinates":[[[4854633.0,2791782.0],[4852696.0,2758256.0],[4802941.0,2748834.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2210,"LEVL_CODE":0,"NUTS_BN_ID":2210,"OTHR_CNTR_":"F","Shape_Leng":6491.5310059466001},"geometry":{"type":"MultiLineString","coordinates":[[[4854633.0,2791782.0],[4861009.0,2793005.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2211,"LEVL_CODE":0,"NUTS_BN_ID":2211,"OTHR_CNTR_":"F","Shape_Leng":44261.834731373798},"geometry":{"type":"MultiLineString","coordinates":[[[4861009.0,2793005.0],[4897845.0,2768465.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2220,"LEVL_CODE":0,"NUTS_BN_ID":2220,"OTHR_CNTR_":"F","Shape_Leng":34621.464701427401},"geometry":{"type":"MultiLineString","coordinates":[[[4982213.0,2784592.0],[4973246.0,2801091.0],[4985039.0,2811671.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2225,"LEVL_CODE":0,"NUTS_BN_ID":2225,"OTHR_CNTR_":"F","Shape_Leng":6817.5084339706},"geometry":{"type":"MultiLineString","coordinates":[[[4985039.0,2811671.0],[4991118.0,2814757.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2238,"LEVL_CODE":0,"NUTS_BN_ID":2238,"OTHR_CNTR_":"T","Shape_Leng":55350.517343463303},"geometry":{"type":"MultiLineString","coordinates":[[[5279162.0,2843993.0],[5297638.0,2864792.0],[5322717.0,2853436.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2241,"LEVL_CODE":0,"NUTS_BN_ID":2241,"OTHR_CNTR_":"F","Shape_Leng":15236.010297282801},"geometry":{"type":"MultiLineString","coordinates":[[[4534509.0,2768916.0],[4525936.0,2781512.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2242,"LEVL_CODE":0,"NUTS_BN_ID":2242,"OTHR_CNTR_":"F","Shape_Leng":41415.775402402498},"geometry":{"type":"MultiLineString","coordinates":[[[4136890.0,2739717.0],[4140556.0,2780970.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2248,"LEVL_CODE":0,"NUTS_BN_ID":2248,"OTHR_CNTR_":"F","Shape_Leng":14278.7748900857},"geometry":{"type":"MultiLineString","coordinates":[[[4846490.0,2803511.0],[4854633.0,2791782.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2249,"LEVL_CODE":0,"NUTS_BN_ID":2249,"OTHR_CNTR_":"F","Shape_Leng":639.32087895550001},"geometry":{"type":"MultiLineString","coordinates":[[[4140556.0,2780970.0],[4140623.0,2781606.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2264,"LEVL_CODE":0,"NUTS_BN_ID":2264,"OTHR_CNTR_":"F","Shape_Leng":77870.657853435303},"geometry":{"type":"MultiLineString","coordinates":[[[4991118.0,2814757.0],[5066406.0,2834644.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1479,"LEVL_CODE":0,"NUTS_BN_ID":1479,"OTHR_CNTR_":"F","Shape_Leng":46557.159072634102},"geometry":{"type":"MultiLineString","coordinates":[[[4992125.0,2480503.0],[5033462.0,2459084.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1484,"LEVL_CODE":0,"NUTS_BN_ID":1484,"OTHR_CNTR_":"F","Shape_Leng":55928.687541978397},"geometry":{"type":"MultiLineString","coordinates":[[[4055456.0,2450216.0],[4088123.0,2404819.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1505,"LEVL_CODE":0,"NUTS_BN_ID":1505,"OTHR_CNTR_":"F","Shape_Leng":109578.0607821177},"geometry":{"type":"MultiLineString","coordinates":[[[4882603.0,2476979.0],[4992125.0,2480503.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1520,"LEVL_CODE":0,"NUTS_BN_ID":1520,"OTHR_CNTR_":"F","Shape_Leng":32819.482887313898},"geometry":{"type":"MultiLineString","coordinates":[[[4774121.0,2442304.0],[4779599.0,2474664.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1521,"LEVL_CODE":0,"NUTS_BN_ID":1521,"OTHR_CNTR_":"F","Shape_Leng":124299.42421827609},"geometry":{"type":"MultiLineString","coordinates":[[[4779599.0,2474664.0],[4817079.0,2452460.0],[4833894.0,2479633.0],[4882603.0,2476979.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1566,"LEVL_CODE":0,"NUTS_BN_ID":1566,"OTHR_CNTR_":"T","Shape_Leng":140680.98914608409},"geometry":{"type":"MultiLineString","coordinates":[[[5731143.0,2657535.0],[5737735.0,2654984.0],[5775776.0,2640982.0],[5823620.0,2678716.0],[5848989.0,2658979.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1573,"LEVL_CODE":0,"NUTS_BN_ID":1573,"OTHR_CNTR_":"F","Shape_Leng":66659.149440965906},"geometry":{"type":"MultiLineString","coordinates":[[[4094309.0,2488413.0],[4094992.0,2463458.0],[4055456.0,2450216.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1581,"LEVL_CODE":0,"NUTS_BN_ID":1581,"OTHR_CNTR_":"F","Shape_Leng":41183.971903756501},"geometry":{"type":"MultiLineString","coordinates":[[[4601454.0,2491746.0],[4642550.0,2494429.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1583,"LEVL_CODE":0,"NUTS_BN_ID":1583,"OTHR_CNTR_":"F","Shape_Leng":727.68193288780003},"geometry":{"type":"MultiLineString","coordinates":[[[4642550.0,2494429.0],[4643272.0,2494334.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1618,"LEVL_CODE":0,"NUTS_BN_ID":1618,"OTHR_CNTR_":"F","Shape_Leng":41271.6606737982},"geometry":{"type":"MultiLineString","coordinates":[[[4643272.0,2494334.0],[4677334.0,2517639.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1619,"LEVL_CODE":0,"NUTS_BN_ID":1619,"OTHR_CNTR_":"F","Shape_Leng":58054.867107732804},"geometry":{"type":"MultiLineString","coordinates":[[[4677334.0,2517639.0],[4730255.0,2493771.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1634,"LEVL_CODE":0,"NUTS_BN_ID":1634,"OTHR_CNTR_":"F","Shape_Leng":47792.4526312909},"geometry":{"type":"MultiLineString","coordinates":[[[4730255.0,2493771.0],[4742233.0,2501247.0],[4732879.0,2513697.0],[4735901.0,2531543.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1640,"LEVL_CODE":0,"NUTS_BN_ID":1640,"OTHR_CNTR_":"F","Shape_Leng":41775.333737620902},"geometry":{"type":"MultiLineString","coordinates":[[[4072064.0,2523773.0],[4094309.0,2488413.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1646,"LEVL_CODE":0,"NUTS_BN_ID":1646,"OTHR_CNTR_":"F","Shape_Leng":6597.5114367462002},"geometry":{"type":"MultiLineString","coordinates":[[[4735901.0,2531543.0],[4741351.0,2535262.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1652,"LEVL_CODE":0,"NUTS_BN_ID":1652,"OTHR_CNTR_":"F","Shape_Leng":47589.707115176599},"geometry":{"type":"MultiLineString","coordinates":[[[4600791.0,2528447.0],[4626824.0,2510374.0],[4611761.0,2505289.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1654,"LEVL_CODE":0,"NUTS_BN_ID":1654,"OTHR_CNTR_":"F","Shape_Leng":1288.1922209300001},"geometry":{"type":"MultiLineString","coordinates":[[[4600801.0,2529735.0],[4600791.0,2528447.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1662,"LEVL_CODE":0,"NUTS_BN_ID":1662,"OTHR_CNTR_":"F","Shape_Leng":21165.1712320632},"geometry":{"type":"MultiLineString","coordinates":[[[4914925.0,2556676.0],[4935675.0,2552502.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1670,"LEVL_CODE":0,"NUTS_BN_ID":1670,"OTHR_CNTR_":"F","Shape_Leng":77288.986398396199},"geometry":{"type":"MultiLineString","coordinates":[[[4935675.0,2552502.0],[4977711.0,2551120.0],[5004437.0,2574074.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1672,"LEVL_CODE":0,"NUTS_BN_ID":1672,"OTHR_CNTR_":"F","Shape_Leng":5367.3873677188003},"geometry":{"type":"MultiLineString","coordinates":[[[5004437.0,2574074.0],[5009623.0,2575456.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1675,"LEVL_CODE":0,"NUTS_BN_ID":1675,"OTHR_CNTR_":"F","Shape_Leng":24691.393523468701},"geometry":{"type":"MultiLineString","coordinates":[[[4091540.0,2538951.0],[4072064.0,2523773.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1686,"LEVL_CODE":0,"NUTS_BN_ID":1686,"OTHR_CNTR_":"F","Shape_Leng":31060.747567999701},"geometry":{"type":"MultiLineString","coordinates":[[[4741351.0,2535262.0],[4763299.0,2557240.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1692,"LEVL_CODE":0,"NUTS_BN_ID":1692,"OTHR_CNTR_":"F","Shape_Leng":31769.178169946201},"geometry":{"type":"MultiLineString","coordinates":[[[4885838.0,2569453.0],[4914925.0,2556676.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1705,"LEVL_CODE":0,"NUTS_BN_ID":1705,"OTHR_CNTR_":"F","Shape_Leng":26872.612537209199},"geometry":{"type":"MultiLineString","coordinates":[[[4591854.0,2555074.0],[4600801.0,2529735.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1712,"LEVL_CODE":0,"NUTS_BN_ID":1712,"OTHR_CNTR_":"F","Shape_Leng":13712.779800603499},"geometry":{"type":"MultiLineString","coordinates":[[[4763299.0,2557240.0],[4756288.0,2569025.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1719,"LEVL_CODE":0,"NUTS_BN_ID":1719,"OTHR_CNTR_":"T","Shape_Leng":74070.700805720902},"geometry":{"type":"MultiLineString","coordinates":[[[5731143.0,2657535.0],[5718296.0,2670264.0],[5707440.0,2725187.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1735,"LEVL_CODE":0,"NUTS_BN_ID":1735,"OTHR_CNTR_":"F","Shape_Leng":34305.386742349903},"geometry":{"type":"MultiLineString","coordinates":[[[5145578.0,2620384.0],[5112370.0,2611778.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1752,"LEVL_CODE":0,"NUTS_BN_ID":1752,"OTHR_CNTR_":"F","Shape_Leng":23094.9074714749},"geometry":{"type":"MultiLineString","coordinates":[[[4756288.0,2569025.0],[4767522.0,2589203.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1757,"LEVL_CODE":0,"NUTS_BN_ID":1757,"OTHR_CNTR_":"F","Shape_Leng":13916.584422129101},"geometry":{"type":"MultiLineString","coordinates":[[[5149175.0,2633827.0],[5145578.0,2620384.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1758,"LEVL_CODE":0,"NUTS_BN_ID":1758,"OTHR_CNTR_":"F","Shape_Leng":6984.7692378321999},"geometry":{"type":"MultiLineString","coordinates":[[[4767522.0,2589203.0],[4773915.0,2592016.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1771,"LEVL_CODE":0,"NUTS_BN_ID":1771,"OTHR_CNTR_":"F","Shape_Leng":48956.5158255477},"geometry":{"type":"MultiLineString","coordinates":[[[4850286.0,2603109.0],[4885838.0,2569453.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1778,"LEVL_CODE":0,"NUTS_BN_ID":1778,"OTHR_CNTR_":"F","Shape_Leng":3693.2156311747999},"geometry":{"type":"MultiLineString","coordinates":[[[4848359.0,2606260.0],[4850286.0,2603109.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1785,"LEVL_CODE":0,"NUTS_BN_ID":1785,"OTHR_CNTR_":"F","Shape_Leng":34527.132379782503},"geometry":{"type":"MultiLineString","coordinates":[[[4773915.0,2592016.0],[4805669.0,2605574.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1800,"LEVL_CODE":0,"NUTS_BN_ID":1800,"OTHR_CNTR_":"F","Shape_Leng":73475.884859911806},"geometry":{"type":"MultiLineString","coordinates":[[[4604291.0,2598605.0],[4581260.0,2582029.0],[4604147.0,2569697.0],[4591854.0,2555074.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1802,"LEVL_CODE":0,"NUTS_BN_ID":1802,"OTHR_CNTR_":"F","Shape_Leng":12730.284736589399},"geometry":{"type":"MultiLineString","coordinates":[[[4672387.0,2595157.0],[4661893.0,2602364.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1805,"LEVL_CODE":0,"NUTS_BN_ID":1805,"OTHR_CNTR_":"F","Shape_Leng":12113.0376096239},"geometry":{"type":"MultiLineString","coordinates":[[[4680270.0,2604354.0],[4672387.0,2595157.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1808,"LEVL_CODE":0,"NUTS_BN_ID":1808,"OTHR_CNTR_":"F","Shape_Leng":24209.172653159301},"geometry":{"type":"MultiLineString","coordinates":[[[4827386.0,2618351.0],[4848359.0,2606260.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1811,"LEVL_CODE":0,"NUTS_BN_ID":1811,"OTHR_CNTR_":"F","Shape_Leng":13218.776369784},"geometry":{"type":"MultiLineString","coordinates":[[[4805669.0,2605574.0],[4800110.0,2617567.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1812,"LEVL_CODE":0,"NUTS_BN_ID":1812,"OTHR_CNTR_":"F","Shape_Leng":27287.354194816398},"geometry":{"type":"MultiLineString","coordinates":[[[4800110.0,2617567.0],[4827386.0,2618351.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1816,"LEVL_CODE":0,"NUTS_BN_ID":1816,"OTHR_CNTR_":"F","Shape_Leng":9749.7793300808007},"geometry":{"type":"MultiLineString","coordinates":[[[4606152.0,2608175.0],[4604291.0,2598605.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1817,"LEVL_CODE":0,"NUTS_BN_ID":1817,"OTHR_CNTR_":"F","Shape_Leng":56043.297765786498},"geometry":{"type":"MultiLineString","coordinates":[[[4661893.0,2602364.0],[4606152.0,2608175.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1822,"LEVL_CODE":0,"NUTS_BN_ID":1822,"OTHR_CNTR_":"F","Shape_Leng":16819.422026166601},"geometry":{"type":"MultiLineString","coordinates":[[[4606152.0,2608175.0],[4589829.0,2612229.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1830,"LEVL_CODE":0,"NUTS_BN_ID":1830,"OTHR_CNTR_":"F","Shape_Leng":59736.788827269898},"geometry":{"type":"MultiLineString","coordinates":[[[4589829.0,2612229.0],[4530306.0,2617286.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1831,"LEVL_CODE":0,"NUTS_BN_ID":1831,"OTHR_CNTR_":"F","Shape_Leng":75862.685638274605},"geometry":{"type":"MultiLineString","coordinates":[[[5193728.0,2682801.0],[5174352.0,2636072.0],[5149175.0,2633827.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1833,"LEVL_CODE":0,"NUTS_BN_ID":1833,"OTHR_CNTR_":"F","Shape_Leng":37446.228330603903},"geometry":{"type":"MultiLineString","coordinates":[[[4708765.0,2628649.0],[4680270.0,2604354.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1836,"LEVL_CODE":0,"NUTS_BN_ID":1836,"OTHR_CNTR_":"F","Shape_Leng":25802.816176663498},"geometry":{"type":"MultiLineString","coordinates":[[[4734492.0,2630626.0],[4708765.0,2628649.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1838,"LEVL_CODE":0,"NUTS_BN_ID":1838,"OTHR_CNTR_":"F","Shape_Leng":4010.0509352299},"geometry":{"type":"MultiLineString","coordinates":[[[4530306.0,2617286.0],[4527096.0,2619690.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1840,"LEVL_CODE":0,"NUTS_BN_ID":1840,"OTHR_CNTR_":"F","Shape_Leng":16485.901395185701},"geometry":{"type":"MultiLineString","coordinates":[[[4527096.0,2619690.0],[4510729.0,2621661.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1843,"LEVL_CODE":0,"NUTS_BN_ID":1843,"OTHR_CNTR_":"F","Shape_Leng":19867.2902179169},"geometry":{"type":"MultiLineString","coordinates":[[[4753009.0,2637824.0],[4734492.0,2630626.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1844,"LEVL_CODE":0,"NUTS_BN_ID":1844,"OTHR_CNTR_":"F","Shape_Leng":10441.213881019199},"geometry":{"type":"MultiLineString","coordinates":[[[4763403.0,2638818.0],[4753009.0,2637824.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1846,"LEVL_CODE":0,"NUTS_BN_ID":1846,"OTHR_CNTR_":"F","Shape_Leng":32346.332153679501},"geometry":{"type":"MultiLineString","coordinates":[[[4827386.0,2618351.0],[4807826.0,2644114.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1868,"LEVL_CODE":0,"NUTS_BN_ID":1868,"OTHR_CNTR_":"F","Shape_Leng":40237.754214783701},"geometry":{"type":"MultiLineString","coordinates":[[[4778299.0,2654263.0],[4783044.0,2634666.0],[4763403.0,2638818.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1869,"LEVL_CODE":0,"NUTS_BN_ID":1869,"OTHR_CNTR_":"T","Shape_Leng":84512.405107412793},"geometry":{"type":"MultiLineString","coordinates":[[[5707440.0,2725187.0],[5709705.0,2763616.0],[5688360.0,2804383.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1879,"LEVL_CODE":0,"NUTS_BN_ID":1879,"OTHR_CNTR_":"F","Shape_Leng":9732.3560491857006},"geometry":{"type":"MultiLineString","coordinates":[[[4786948.0,2658725.0],[4778299.0,2654263.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1880,"LEVL_CODE":0,"NUTS_BN_ID":1880,"OTHR_CNTR_":"F","Shape_Leng":25483.150900191598},"geometry":{"type":"MultiLineString","coordinates":[[[4807826.0,2644114.0],[4786948.0,2658725.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1893,"LEVL_CODE":0,"NUTS_BN_ID":1893,"OTHR_CNTR_":"F","Shape_Leng":68120.110926416106},"geometry":{"type":"MultiLineString","coordinates":[[[4409680.0,2650942.0],[4399159.0,2628536.0],[4356849.0,2638051.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1912,"LEVL_CODE":0,"NUTS_BN_ID":1912,"OTHR_CNTR_":"F","Shape_Leng":35641.235280360597},"geometry":{"type":"MultiLineString","coordinates":[[[4444822.0,2656889.0],[4409680.0,2650942.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1913,"LEVL_CODE":0,"NUTS_BN_ID":1913,"OTHR_CNTR_":"F","Shape_Leng":44540.079410411199},"geometry":{"type":"MultiLineString","coordinates":[[[5203938.0,2726155.0],[5193728.0,2682801.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1929,"LEVL_CODE":0,"NUTS_BN_ID":1929,"OTHR_CNTR_":"F","Shape_Leng":55186.324752214598},"geometry":{"type":"MultiLineString","coordinates":[[[4510729.0,2621661.0],[4484431.0,2646838.0],[4491314.0,2664310.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1930,"LEVL_CODE":0,"NUTS_BN_ID":1930,"OTHR_CNTR_":"F","Shape_Leng":39418.230318821501},"geometry":{"type":"MultiLineString","coordinates":[[[4483321.0,2665352.0],[4444822.0,2656889.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1931,"LEVL_CODE":0,"NUTS_BN_ID":1931,"OTHR_CNTR_":"F","Shape_Leng":8061.0384371923001},"geometry":{"type":"MultiLineString","coordinates":[[[4491314.0,2664310.0],[4483321.0,2665352.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1995,"LEVL_CODE":0,"NUTS_BN_ID":1995,"OTHR_CNTR_":"F","Shape_Leng":72959.332691827003},"geometry":{"type":"MultiLineString","coordinates":[[[4806751.0,2714375.0],[4815678.0,2675921.0],[4786948.0,2658725.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2005,"LEVL_CODE":0,"NUTS_BN_ID":2005,"OTHR_CNTR_":"F","Shape_Leng":1911.3354070979001},"geometry":{"type":"MultiLineString","coordinates":[[[4395879.0,2698560.0],[4397790.0,2698612.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2025,"LEVL_CODE":0,"NUTS_BN_ID":2025,"OTHR_CNTR_":"F","Shape_Leng":31049.231531036701},"geometry":{"type":"MultiLineString","coordinates":[[[4397790.0,2698612.0],[4428275.0,2704501.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2029,"LEVL_CODE":0,"NUTS_BN_ID":2029,"OTHR_CNTR_":"F","Shape_Leng":19148.478705371199},"geometry":{"type":"MultiLineString","coordinates":[[[4821839.0,2726166.0],[4806751.0,2714375.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2042,"LEVL_CODE":0,"NUTS_BN_ID":2042,"OTHR_CNTR_":"F","Shape_Leng":27241.316346162501},"geometry":{"type":"MultiLineString","coordinates":[[[4320964.0,2707712.0],[4334507.0,2684075.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2044,"LEVL_CODE":0,"NUTS_BN_ID":2044,"OTHR_CNTR_":"F","Shape_Leng":5670.6330218533003},"geometry":{"type":"MultiLineString","coordinates":[[[4428275.0,2704501.0],[4427326.0,2710092.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2052,"LEVL_CODE":0,"NUTS_BN_ID":2052,"OTHR_CNTR_":"F","Shape_Leng":17523.9424206943},"geometry":{"type":"MultiLineString","coordinates":[[[4387766.0,2714092.0],[4395879.0,2698560.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2055,"LEVL_CODE":0,"NUTS_BN_ID":2055,"OTHR_CNTR_":"F","Shape_Leng":30821.086810846798},"geometry":{"type":"MultiLineString","coordinates":[[[4287757.0,2714352.0],[4318575.0,2714737.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2056,"LEVL_CODE":0,"NUTS_BN_ID":2056,"OTHR_CNTR_":"F","Shape_Leng":7420.0235497119002},"geometry":{"type":"MultiLineString","coordinates":[[[4318575.0,2714737.0],[4320964.0,2707712.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2059,"LEVL_CODE":0,"NUTS_BN_ID":2059,"OTHR_CNTR_":"F","Shape_Leng":37977.521010871402},"geometry":{"type":"MultiLineString","coordinates":[[[4334507.0,2684075.0],[4355225.0,2715903.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2060,"LEVL_CODE":0,"NUTS_BN_ID":2060,"OTHR_CNTR_":"F","Shape_Leng":32590.792561954},"geometry":{"type":"MultiLineString","coordinates":[[[4355225.0,2715903.0],[4387766.0,2714092.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2077,"LEVL_CODE":0,"NUTS_BN_ID":2077,"OTHR_CNTR_":"T","Shape_Leng":99524.462602605607},"geometry":{"type":"MultiLineString","coordinates":[[[5688360.0,2804383.0],[5616142.0,2872864.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2080,"LEVL_CODE":0,"NUTS_BN_ID":2080,"OTHR_CNTR_":"F","Shape_Leng":19950.069670356301},"geometry":{"type":"MultiLineString","coordinates":[[[4427326.0,2710092.0],[4443880.0,2721226.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2082,"LEVL_CODE":0,"NUTS_BN_ID":2082,"OTHR_CNTR_":"F","Shape_Leng":73427.715339984497},"geometry":{"type":"MultiLineString","coordinates":[[[5229004.0,2795172.0],[5203938.0,2726155.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2084,"LEVL_CODE":0,"NUTS_BN_ID":2084,"OTHR_CNTR_":"F","Shape_Leng":3951.8879102203},"geometry":{"type":"MultiLineString","coordinates":[[[5232859.0,2796039.0],[5229004.0,2795172.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2094,"LEVL_CODE":0,"NUTS_BN_ID":2094,"OTHR_CNTR_":"F","Shape_Leng":32319.666286392301},"geometry":{"type":"MultiLineString","coordinates":[[[4443880.0,2721226.0],[4475985.0,2724950.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2108,"LEVL_CODE":0,"NUTS_BN_ID":2108,"OTHR_CNTR_":"F","Shape_Leng":37508.109286326297},"geometry":{"type":"MultiLineString","coordinates":[[[4802941.0,2748834.0],[4820572.0,2745731.0],[4821839.0,2726166.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2112,"LEVL_CODE":0,"NUTS_BN_ID":2112,"OTHR_CNTR_":"F","Shape_Leng":10641.869246504501},"geometry":{"type":"MultiLineString","coordinates":[[[4514604.0,2727669.0],[4523483.0,2733535.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2113,"LEVL_CODE":0,"NUTS_BN_ID":2113,"OTHR_CNTR_":"F","Shape_Leng":31880.5228310899},"geometry":{"type":"MultiLineString","coordinates":[[[4523483.0,2733535.0],[4550493.0,2716599.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2124,"LEVL_CODE":0,"NUTS_BN_ID":2124,"OTHR_CNTR_":"F","Shape_Leng":22599.664276674001},"geometry":{"type":"MultiLineString","coordinates":[[[4475985.0,2724950.0],[4496572.0,2734271.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2125,"LEVL_CODE":0,"NUTS_BN_ID":2125,"OTHR_CNTR_":"F","Shape_Leng":19202.0302286396},"geometry":{"type":"MultiLineString","coordinates":[[[4496572.0,2734271.0],[4514604.0,2727669.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2135,"LEVL_CODE":0,"NUTS_BN_ID":2135,"OTHR_CNTR_":"F","Shape_Leng":17385.712221024802},"geometry":{"type":"MultiLineString","coordinates":[[[4139577.0,2722540.0],[4136890.0,2739717.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2139,"LEVL_CODE":0,"NUTS_BN_ID":2139,"OTHR_CNTR_":"F","Shape_Leng":14290.410307288101},"geometry":{"type":"MultiLineString","coordinates":[[[4897845.0,2768465.0],[4912120.0,2767794.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2154,"LEVL_CODE":0,"NUTS_BN_ID":2154,"OTHR_CNTR_":"F","Shape_Leng":72077.641240944198},"geometry":{"type":"MultiLineString","coordinates":[[[4912120.0,2767794.0],[4982213.0,2784592.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2791,"LEVL_CODE":0,"NUTS_BN_ID":2791,"OTHR_CNTR_":"F","Shape_Leng":38888.653893365903},"geometry":{"type":"MultiLineString","coordinates":[[[4015260.0,2980087.0],[4025893.0,2958179.0],[4018497.0,2945664.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2806,"LEVL_CODE":0,"NUTS_BN_ID":2806,"OTHR_CNTR_":"F","Shape_Leng":19546.627986477499},"geometry":{"type":"MultiLineString","coordinates":[[[4494031.0,2963467.0],[4504236.0,2980139.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2807,"LEVL_CODE":0,"NUTS_BN_ID":2807,"OTHR_CNTR_":"F","Shape_Leng":48041.551233155602},"geometry":{"type":"MultiLineString","coordinates":[[[4935450.0,3013500.0],[4960290.0,2972378.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2821,"LEVL_CODE":0,"NUTS_BN_ID":2821,"OTHR_CNTR_":"F","Shape_Leng":14418.696338019799},"geometry":{"type":"MultiLineString","coordinates":[[[3921742.0,2996169.0],[3907619.0,2999071.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2826,"LEVL_CODE":0,"NUTS_BN_ID":2826,"OTHR_CNTR_":"F","Shape_Leng":7018.2559394371001},"geometry":{"type":"MultiLineString","coordinates":[[[3907619.0,2999071.0],[3901204.0,3001917.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2847,"LEVL_CODE":0,"NUTS_BN_ID":2847,"OTHR_CNTR_":"F","Shape_Leng":26884.638726520199},"geometry":{"type":"MultiLineString","coordinates":[[[4504236.0,2980139.0],[4482882.0,2996473.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2853,"LEVL_CODE":0,"NUTS_BN_ID":2853,"OTHR_CNTR_":"F","Shape_Leng":42399.412515100797},"geometry":{"type":"MultiLineString","coordinates":[[[4895030.0,3026304.0],[4935450.0,3013500.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2879,"LEVL_CODE":0,"NUTS_BN_ID":2879,"OTHR_CNTR_":"F","Shape_Leng":42016.019404066399},"geometry":{"type":"MultiLineString","coordinates":[[[4067411.0,2973722.0],[4044954.0,3009233.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2888,"LEVL_CODE":0,"NUTS_BN_ID":2888,"OTHR_CNTR_":"F","Shape_Leng":34782.032921999598},"geometry":{"type":"MultiLineString","coordinates":[[[3949421.0,3017233.0],[3921742.0,2996169.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2889,"LEVL_CODE":0,"NUTS_BN_ID":2889,"OTHR_CNTR_":"F","Shape_Leng":56025.620596781097},"geometry":{"type":"MultiLineString","coordinates":[[[3959124.0,2977872.0],[3950596.0,2977508.0],[3947872.0,2998752.0],[3956469.0,3015481.0],[3949421.0,3017233.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2897,"LEVL_CODE":0,"NUTS_BN_ID":2897,"OTHR_CNTR_":"F","Shape_Leng":41695.144809460697},"geometry":{"type":"MultiLineString","coordinates":[[[4037218.0,3015532.0],[4015260.0,2980087.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2898,"LEVL_CODE":0,"NUTS_BN_ID":2898,"OTHR_CNTR_":"F","Shape_Leng":9975.8429200717001},"geometry":{"type":"MultiLineString","coordinates":[[[4044954.0,3009233.0],[4037218.0,3015532.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2900,"LEVL_CODE":0,"NUTS_BN_ID":2900,"OTHR_CNTR_":"F","Shape_Leng":21129.946852325498},"geometry":{"type":"MultiLineString","coordinates":[[[4790699.0,3024479.0],[4810262.0,3032463.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2909,"LEVL_CODE":0,"NUTS_BN_ID":2909,"OTHR_CNTR_":"F","Shape_Leng":19354.550080266199},"geometry":{"type":"MultiLineString","coordinates":[[[4482882.0,2996473.0],[4475192.0,3014234.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2925,"LEVL_CODE":0,"NUTS_BN_ID":2925,"OTHR_CNTR_":"T","Shape_Leng":97778.866764241102},"geometry":{"type":"MultiLineString","coordinates":[[[5280979.0,3104580.0],[5233493.0,3019106.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2941,"LEVL_CODE":0,"NUTS_BN_ID":2941,"OTHR_CNTR_":"F","Shape_Leng":11721.672205676199},"geometry":{"type":"MultiLineString","coordinates":[[[4475192.0,3014234.0],[4470617.0,3025026.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2942,"LEVL_CODE":0,"NUTS_BN_ID":2942,"OTHR_CNTR_":"F","Shape_Leng":92349.188366287897},"geometry":{"type":"MultiLineString","coordinates":[[[4849854.0,3042645.0],[4869556.0,3052125.0],[4873722.0,3039763.0],[4862493.0,3033371.0],[4884294.0,3014696.0],[4895030.0,3026304.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2945,"LEVL_CODE":0,"NUTS_BN_ID":2945,"OTHR_CNTR_":"F","Shape_Leng":28742.733486138801},"geometry":{"type":"MultiLineString","coordinates":[[[4065087.0,3029746.0],[4044954.0,3009233.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2271,"LEVL_CODE":0,"NUTS_BN_ID":2271,"OTHR_CNTR_":"F","Shape_Leng":8981.0572633596003},"geometry":{"type":"MultiLineString","coordinates":[[[4839233.0,2808803.0],[4846490.0,2803511.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2279,"LEVL_CODE":0,"NUTS_BN_ID":2279,"OTHR_CNTR_":"F","Shape_Leng":17770.027668014001},"geometry":{"type":"MultiLineString","coordinates":[[[4525936.0,2781512.0],[4539907.0,2792493.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2294,"LEVL_CODE":0,"NUTS_BN_ID":2294,"OTHR_CNTR_":"F","Shape_Leng":16922.0967882402},"geometry":{"type":"MultiLineString","coordinates":[[[4140623.0,2781606.0],[4148737.0,2796455.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2297,"LEVL_CODE":0,"NUTS_BN_ID":2297,"OTHR_CNTR_":"T","Shape_Leng":147978.80847495541},"geometry":{"type":"MultiLineString","coordinates":[[[5616142.0,2872864.0],[5589520.0,2912972.0],[5544404.0,2932763.0],[5512617.0,2893427.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2305,"LEVL_CODE":0,"NUTS_BN_ID":2305,"OTHR_CNTR_":"F","Shape_Leng":19832.617047613199},"geometry":{"type":"MultiLineString","coordinates":[[[4539907.0,2792493.0],[4556759.0,2802949.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2330,"LEVL_CODE":0,"NUTS_BN_ID":2330,"OTHR_CNTR_":"F","Shape_Leng":3778.2482919135},"geometry":{"type":"MultiLineString","coordinates":[[[5214660.0,2880854.0],[5216710.0,2884027.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2331,"LEVL_CODE":0,"NUTS_BN_ID":2331,"OTHR_CNTR_":"T","Shape_Leng":74182.116079186206},"geometry":{"type":"MultiLineString","coordinates":[[[5216710.0,2884027.0],[5279162.0,2843993.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2340,"LEVL_CODE":0,"NUTS_BN_ID":2340,"OTHR_CNTR_":"F","Shape_Leng":31025.244256559301},"geometry":{"type":"MultiLineString","coordinates":[[[4827292.0,2837438.0],[4839233.0,2808803.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2353,"LEVL_CODE":0,"NUTS_BN_ID":2353,"OTHR_CNTR_":"F","Shape_Leng":45023.378013276597},"geometry":{"type":"MultiLineString","coordinates":[[[5066406.0,2834644.0],[5092186.0,2871556.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2371,"LEVL_CODE":0,"NUTS_BN_ID":2371,"OTHR_CNTR_":"F","Shape_Leng":13050.229806925099},"geometry":{"type":"MultiLineString","coordinates":[[[4833566.0,2848881.0],[4827292.0,2837438.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2376,"LEVL_CODE":0,"NUTS_BN_ID":2376,"OTHR_CNTR_":"F","Shape_Leng":38964.795658626397},"geometry":{"type":"MultiLineString","coordinates":[[[4556759.0,2802949.0],[4573483.0,2812350.0],[4574853.0,2832082.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2383,"LEVL_CODE":0,"NUTS_BN_ID":2383,"OTHR_CNTR_":"F","Shape_Leng":136318.296631884},"geometry":{"type":"MultiLineString","coordinates":[[[5092186.0,2871556.0],[5161451.0,2895598.0],[5185993.0,2873091.0],[5214660.0,2880854.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2386,"LEVL_CODE":0,"NUTS_BN_ID":2386,"OTHR_CNTR_":"F","Shape_Leng":7248.7452716690996},"geometry":{"type":"MultiLineString","coordinates":[[[4574853.0,2832082.0],[4580163.0,2837017.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2387,"LEVL_CODE":0,"NUTS_BN_ID":2387,"OTHR_CNTR_":"F","Shape_Leng":17996.4017517182},"geometry":{"type":"MultiLineString","coordinates":[[[4580163.0,2837017.0],[4596342.0,2829134.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2404,"LEVL_CODE":0,"NUTS_BN_ID":2404,"OTHR_CNTR_":"F","Shape_Leng":9085.7477268927996},"geometry":{"type":"MultiLineString","coordinates":[[[4832035.0,2857837.0],[4833566.0,2848881.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2429,"LEVL_CODE":0,"NUTS_BN_ID":2429,"OTHR_CNTR_":"F","Shape_Leng":22880.157571112701},"geometry":{"type":"MultiLineString","coordinates":[[[4596342.0,2829134.0],[4600313.0,2851667.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2430,"LEVL_CODE":0,"NUTS_BN_ID":2430,"OTHR_CNTR_":"F","Shape_Leng":55259.595765866099},"geometry":{"type":"MultiLineString","coordinates":[[[4148737.0,2796455.0],[4170833.0,2847105.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2445,"LEVL_CODE":0,"NUTS_BN_ID":2445,"OTHR_CNTR_":"F","Shape_Leng":7199.4903566467001},"geometry":{"type":"MultiLineString","coordinates":[[[4600313.0,2851667.0],[4603174.0,2858273.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2446,"LEVL_CODE":0,"NUTS_BN_ID":2446,"OTHR_CNTR_":"F","Shape_Leng":66056.0126569563},"geometry":{"type":"MultiLineString","coordinates":[[[4603174.0,2858273.0],[4666961.0,2841108.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2479,"LEVL_CODE":0,"NUTS_BN_ID":2479,"OTHR_CNTR_":"F","Shape_Leng":91050.494683944693},"geometry":{"type":"MultiLineString","coordinates":[[[4742889.0,2876363.0],[4832035.0,2857837.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2480,"LEVL_CODE":0,"NUTS_BN_ID":2480,"OTHR_CNTR_":"F","Shape_Leng":18926.292192080498},"geometry":{"type":"MultiLineString","coordinates":[[[4881191.0,2889220.0],[4863381.0,2882817.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2481,"LEVL_CODE":0,"NUTS_BN_ID":2481,"OTHR_CNTR_":"T","Shape_Leng":53852.324513504602},"geometry":{"type":"MultiLineString","coordinates":[[[5224941.0,2937247.0],[5216710.0,2884027.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2489,"LEVL_CODE":0,"NUTS_BN_ID":2489,"OTHR_CNTR_":"F","Shape_Leng":50836.066396855203},"geometry":{"type":"MultiLineString","coordinates":[[[4863381.0,2882817.0],[4848443.0,2888562.0],[4832035.0,2857837.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2494,"LEVL_CODE":0,"NUTS_BN_ID":2494,"OTHR_CNTR_":"F","Shape_Leng":16664.2652207955},"geometry":{"type":"MultiLineString","coordinates":[[[4726984.0,2881333.0],[4742889.0,2876363.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2509,"LEVL_CODE":0,"NUTS_BN_ID":2509,"OTHR_CNTR_":"F","Shape_Leng":34078.421911526697},"geometry":{"type":"MultiLineString","coordinates":[[[4170833.0,2847105.0],[4191568.0,2874149.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2510,"LEVL_CODE":0,"NUTS_BN_ID":2510,"OTHR_CNTR_":"F","Shape_Leng":30351.453531746502},"geometry":{"type":"MultiLineString","coordinates":[[[4603174.0,2858273.0],[4581003.0,2879001.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2513,"LEVL_CODE":0,"NUTS_BN_ID":2513,"OTHR_CNTR_":"F","Shape_Leng":9971.4189849030008},"geometry":{"type":"MultiLineString","coordinates":[[[4581003.0,2879001.0],[4571072.0,2879895.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2517,"LEVL_CODE":0,"NUTS_BN_ID":2517,"OTHR_CNTR_":"F","Shape_Leng":12564.4762710327},"geometry":{"type":"MultiLineString","coordinates":[[[4191568.0,2874149.0],[4179638.0,2878091.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2518,"LEVL_CODE":0,"NUTS_BN_ID":2518,"OTHR_CNTR_":"F","Shape_Leng":94159.284292126904},"geometry":{"type":"MultiLineString","coordinates":[[[4666961.0,2841108.0],[4685872.0,2889755.0],[4726984.0,2881333.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2530,"LEVL_CODE":0,"NUTS_BN_ID":2530,"OTHR_CNTR_":"F","Shape_Leng":12618.6228034785},"geometry":{"type":"MultiLineString","coordinates":[[[4179638.0,2878091.0],[4168238.0,2883501.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2533,"LEVL_CODE":0,"NUTS_BN_ID":2533,"OTHR_CNTR_":"F","Shape_Leng":20130.965632788098},"geometry":{"type":"MultiLineString","coordinates":[[[4168238.0,2883501.0],[4148170.0,2885086.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2552,"LEVL_CODE":0,"NUTS_BN_ID":2552,"OTHR_CNTR_":"T","Shape_Leng":28603.626722795401},"geometry":{"type":"MultiLineString","coordinates":[[[5234033.0,2964367.0],[5224941.0,2937247.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2559,"LEVL_CODE":0,"NUTS_BN_ID":2559,"OTHR_CNTR_":"F","Shape_Leng":19536.687949351701},"geometry":{"type":"MultiLineString","coordinates":[[[4129089.0,2897694.0],[4109552.0,2897821.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2560,"LEVL_CODE":0,"NUTS_BN_ID":2560,"OTHR_CNTR_":"F","Shape_Leng":22870.746396456099},"geometry":{"type":"MultiLineString","coordinates":[[[4148170.0,2885086.0],[4129089.0,2897694.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2562,"LEVL_CODE":0,"NUTS_BN_ID":2562,"OTHR_CNTR_":"F","Shape_Leng":28016.8692969367},"geometry":{"type":"MultiLineString","coordinates":[[[4571072.0,2879895.0],[4552189.0,2900592.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2571,"LEVL_CODE":0,"NUTS_BN_ID":2571,"OTHR_CNTR_":"F","Shape_Leng":28407.195155579098},"geometry":{"type":"MultiLineString","coordinates":[[[4109552.0,2897821.0],[4082335.0,2905957.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2593,"LEVL_CODE":0,"NUTS_BN_ID":2593,"OTHR_CNTR_":"F","Shape_Leng":71219.613511968899},"geometry":{"type":"MultiLineString","coordinates":[[[4924769.0,2945551.0],[4881191.0,2889220.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2625,"LEVL_CODE":0,"NUTS_BN_ID":2625,"OTHR_CNTR_":"F","Shape_Leng":10844.2687947044},"geometry":{"type":"MultiLineString","coordinates":[[[4929608.0,2955256.0],[4924769.0,2945551.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2633,"LEVL_CODE":0,"NUTS_BN_ID":2633,"OTHR_CNTR_":"F","Shape_Leng":58237.7392460232},"geometry":{"type":"MultiLineString","coordinates":[[[5088278.0,2978299.0],[5038951.0,2947340.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2636,"LEVL_CODE":0,"NUTS_BN_ID":2636,"OTHR_CNTR_":"F","Shape_Leng":25367.542319745698},"geometry":{"type":"MultiLineString","coordinates":[[[4082335.0,2905957.0],[4071243.0,2928771.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2645,"LEVL_CODE":0,"NUTS_BN_ID":2645,"OTHR_CNTR_":"F","Shape_Leng":63822.8090078967},"geometry":{"type":"MultiLineString","coordinates":[[[5144084.0,2988537.0],[5112381.0,2968174.0],[5088278.0,2978299.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2646,"LEVL_CODE":0,"NUTS_BN_ID":2646,"OTHR_CNTR_":"F","Shape_Leng":93138.929789682501},"geometry":{"type":"MultiLineString","coordinates":[[[5234033.0,2964367.0],[5144084.0,2988537.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2655,"LEVL_CODE":0,"NUTS_BN_ID":2655,"OTHR_CNTR_":"F","Shape_Leng":14867.0549265914},"geometry":{"type":"MultiLineString","coordinates":[[[4071243.0,2928771.0],[4057754.0,2935021.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2661,"LEVL_CODE":0,"NUTS_BN_ID":2661,"OTHR_CNTR_":"F","Shape_Leng":51533.491107150498},"geometry":{"type":"MultiLineString","coordinates":[[[4552189.0,2900592.0],[4511864.0,2932679.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2667,"LEVL_CODE":0,"NUTS_BN_ID":2667,"OTHR_CNTR_":"F","Shape_Leng":34463.897637810798},"geometry":{"type":"MultiLineString","coordinates":[[[4023634.0,2939875.0],[4057754.0,2935021.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2673,"LEVL_CODE":0,"NUTS_BN_ID":2673,"OTHR_CNTR_":"F","Shape_Leng":35136.517160363801},"geometry":{"type":"MultiLineString","coordinates":[[[4960290.0,2972378.0],[4929608.0,2955256.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2690,"LEVL_CODE":0,"NUTS_BN_ID":2690,"OTHR_CNTR_":"F","Shape_Leng":7888.6380669027003},"geometry":{"type":"MultiLineString","coordinates":[[[4511864.0,2932679.0],[4508712.0,2939911.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2692,"LEVL_CODE":0,"NUTS_BN_ID":2692,"OTHR_CNTR_":"F","Shape_Leng":19830.841720955101},"geometry":{"type":"MultiLineString","coordinates":[[[4012457.0,2945943.0],[3993084.0,2941705.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2693,"LEVL_CODE":0,"NUTS_BN_ID":2693,"OTHR_CNTR_":"F","Shape_Leng":6047.1352277746},"geometry":{"type":"MultiLineString","coordinates":[[[4018497.0,2945664.0],[4012457.0,2945943.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2694,"LEVL_CODE":0,"NUTS_BN_ID":2694,"OTHR_CNTR_":"F","Shape_Leng":7739.4968046538997},"geometry":{"type":"MultiLineString","coordinates":[[[4018497.0,2945664.0],[4023634.0,2939875.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2700,"LEVL_CODE":0,"NUTS_BN_ID":2700,"OTHR_CNTR_":"F","Shape_Leng":9122.8036038381997},"geometry":{"type":"MultiLineString","coordinates":[[[4057754.0,2935021.0],[4059131.0,2944039.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2701,"LEVL_CODE":0,"NUTS_BN_ID":2701,"OTHR_CNTR_":"T","Shape_Leng":88912.0658104256},"geometry":{"type":"MultiLineString","coordinates":[[[5233493.0,3019106.0],[5258896.0,2960617.0],[5234033.0,2964367.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2719,"LEVL_CODE":0,"NUTS_BN_ID":2719,"OTHR_CNTR_":"F","Shape_Leng":57856.687127077203},"geometry":{"type":"MultiLineString","coordinates":[[[5003134.0,2988592.0],[4983505.0,2962520.0],[4960290.0,2972378.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2720,"LEVL_CODE":0,"NUTS_BN_ID":2720,"OTHR_CNTR_":"F","Shape_Leng":54631.166346709098},"geometry":{"type":"MultiLineString","coordinates":[[[5038951.0,2947340.0],[5003134.0,2988592.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2722,"LEVL_CODE":0,"NUTS_BN_ID":2722,"OTHR_CNTR_":"F","Shape_Leng":14466.085099395401},"geometry":{"type":"MultiLineString","coordinates":[[[3993084.0,2941705.0],[3988313.0,2955361.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2741,"LEVL_CODE":0,"NUTS_BN_ID":2741,"OTHR_CNTR_":"F","Shape_Leng":20631.363138122299},"geometry":{"type":"MultiLineString","coordinates":[[[3988313.0,2955361.0],[3971752.0,2967666.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2758,"LEVL_CODE":0,"NUTS_BN_ID":2758,"OTHR_CNTR_":"F","Shape_Leng":27757.5264904535},"geometry":{"type":"MultiLineString","coordinates":[[[4508712.0,2939911.0],[4494031.0,2963467.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2772,"LEVL_CODE":0,"NUTS_BN_ID":2772,"OTHR_CNTR_":"F","Shape_Leng":16237.0121178023},"geometry":{"type":"MultiLineString","coordinates":[[[3971752.0,2967666.0],[3959124.0,2977872.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2775,"LEVL_CODE":0,"NUTS_BN_ID":2775,"OTHR_CNTR_":"F","Shape_Leng":30815.452714921401},"geometry":{"type":"MultiLineString","coordinates":[[[4059131.0,2944039.0],[4067411.0,2973722.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3539,"LEVL_CODE":0,"NUTS_BN_ID":3539,"OTHR_CNTR_":"F","Shape_Leng":10540.583606275501},"geometry":{"type":"MultiLineString","coordinates":[[[3950634.0,3159703.0],[3957507.0,3167694.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3540,"LEVL_CODE":0,"NUTS_BN_ID":3540,"OTHR_CNTR_":"F","Shape_Leng":25143.231475320601},"geometry":{"type":"MultiLineString","coordinates":[[[3957507.0,3167694.0],[3980659.0,3157888.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3547,"LEVL_CODE":0,"NUTS_BN_ID":3547,"OTHR_CNTR_":"T","Shape_Leng":131172.34684008709},"geometry":{"type":"MultiLineString","coordinates":[[[5214671.0,3322723.0],[5250865.0,3305587.0],[5249499.0,3266639.0],[5260131.0,3243202.0],[5271129.0,3219181.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2960,"LEVL_CODE":0,"NUTS_BN_ID":2960,"OTHR_CNTR_":"F","Shape_Leng":43010.0374835084},"geometry":{"type":"MultiLineString","coordinates":[[[3901204.0,3001917.0],[3896519.0,3044671.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2982,"LEVL_CODE":0,"NUTS_BN_ID":2982,"OTHR_CNTR_":"F","Shape_Leng":35761.329632974099},"geometry":{"type":"MultiLineString","coordinates":[[[4470617.0,3025026.0],[4504645.0,3036025.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":2983,"LEVL_CODE":0,"NUTS_BN_ID":2983,"OTHR_CNTR_":"F","Shape_Leng":25903.613382140898},"geometry":{"type":"MultiLineString","coordinates":[[[4504645.0,3036025.0],[4530540.0,3036694.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3004,"LEVL_CODE":0,"NUTS_BN_ID":3004,"OTHR_CNTR_":"F","Shape_Leng":38176.878685628799},"geometry":{"type":"MultiLineString","coordinates":[[[4810262.0,3032463.0],[4821652.0,3037110.0],[4810829.0,3060614.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3005,"LEVL_CODE":0,"NUTS_BN_ID":3005,"OTHR_CNTR_":"F","Shape_Leng":42962.644354916498},"geometry":{"type":"MultiLineString","coordinates":[[[4810829.0,3060614.0],[4849854.0,3042645.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3008,"LEVL_CODE":0,"NUTS_BN_ID":3008,"OTHR_CNTR_":"F","Shape_Leng":41479.430084720698},"geometry":{"type":"MultiLineString","coordinates":[[[3896519.0,3044671.0],[3873502.0,3040442.0],[3871120.0,3058361.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3016,"LEVL_CODE":0,"NUTS_BN_ID":3016,"OTHR_CNTR_":"F","Shape_Leng":4291.8717869179},"geometry":{"type":"MultiLineString","coordinates":[[[3871120.0,3058361.0],[3868536.0,3061788.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3017,"LEVL_CODE":0,"NUTS_BN_ID":3017,"OTHR_CNTR_":"F","Shape_Leng":20350.165255558899},"geometry":{"type":"MultiLineString","coordinates":[[[4059686.0,3049366.0],[4065087.0,3029746.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3028,"LEVL_CODE":0,"NUTS_BN_ID":3028,"OTHR_CNTR_":"F","Shape_Leng":9206.8644555823994},"geometry":{"type":"MultiLineString","coordinates":[[[4051084.0,3052481.0],[4052083.0,3052457.0],[4059686.0,3049366.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3062,"LEVL_CODE":0,"NUTS_BN_ID":3062,"OTHR_CNTR_":"F","Shape_Leng":46834.219399485402},"geometry":{"type":"MultiLineString","coordinates":[[[4530540.0,3036694.0],[4568655.0,3063911.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3069,"LEVL_CODE":0,"NUTS_BN_ID":3069,"OTHR_CNTR_":"F","Shape_Leng":92046.802083335206},"geometry":{"type":"MultiLineString","coordinates":[[[4752268.0,3079151.0],[4776676.0,3072781.0],[4760637.0,3054175.0],[4790699.0,3024479.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3083,"LEVL_CODE":0,"NUTS_BN_ID":3083,"OTHR_CNTR_":"F","Shape_Leng":51318.674989269697},"geometry":{"type":"MultiLineString","coordinates":[[[3868536.0,3061788.0],[3845700.0,3067991.0],[3844678.0,3088814.0],[3840322.0,3094044.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3095,"LEVL_CODE":0,"NUTS_BN_ID":3095,"OTHR_CNTR_":"F","Shape_Leng":15123.7116634548},"geometry":{"type":"MultiLineString","coordinates":[[[4568655.0,3063911.0],[4578744.0,3075178.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3110,"LEVL_CODE":0,"NUTS_BN_ID":3110,"OTHR_CNTR_":"F","Shape_Leng":36311.075733844402},"geometry":{"type":"MultiLineString","coordinates":[[[4040360.0,3079039.0],[4057085.0,3063861.0],[4051138.0,3057496.0],[4051084.0,3052481.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3113,"LEVL_CODE":0,"NUTS_BN_ID":3113,"OTHR_CNTR_":"F","Shape_Leng":9096.7783337257006},"geometry":{"type":"MultiLineString","coordinates":[[[4031284.0,3079646.0],[4040360.0,3079039.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3117,"LEVL_CODE":0,"NUTS_BN_ID":3117,"OTHR_CNTR_":"F","Shape_Leng":20897.102528141801},"geometry":{"type":"MultiLineString","coordinates":[[[4017252.0,3086773.0],[4016502.0,3080745.0],[4031284.0,3079646.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3126,"LEVL_CODE":0,"NUTS_BN_ID":3126,"OTHR_CNTR_":"F","Shape_Leng":29049.506966597801},"geometry":{"type":"MultiLineString","coordinates":[[[3817785.0,3090854.0],[3802065.0,3115283.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3128,"LEVL_CODE":0,"NUTS_BN_ID":3128,"OTHR_CNTR_":"F","Shape_Leng":6093.9238953763997},"geometry":{"type":"MultiLineString","coordinates":[[[3840322.0,3094044.0],[3835047.0,3097096.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3130,"LEVL_CODE":0,"NUTS_BN_ID":3130,"OTHR_CNTR_":"F","Shape_Leng":42429.073457634098},"geometry":{"type":"MultiLineString","coordinates":[[[4710987.0,3088956.0],[4752268.0,3079151.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3178,"LEVL_CODE":0,"NUTS_BN_ID":3178,"OTHR_CNTR_":"F","Shape_Leng":14467.782980947501},"geometry":{"type":"MultiLineString","coordinates":[[[4645979.0,3093185.0],[4660256.0,3095529.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3196,"LEVL_CODE":0,"NUTS_BN_ID":3196,"OTHR_CNTR_":"F","Shape_Leng":18272.101188238099},"geometry":{"type":"MultiLineString","coordinates":[[[4040360.0,3079039.0],[4045945.0,3096437.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3222,"LEVL_CODE":0,"NUTS_BN_ID":3222,"OTHR_CNTR_":"F","Shape_Leng":22737.584100879099},"geometry":{"type":"MultiLineString","coordinates":[[[4024038.0,3108369.0],[4023137.0,3102353.0],[4017252.0,3086773.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3251,"LEVL_CODE":0,"NUTS_BN_ID":3251,"OTHR_CNTR_":"F","Shape_Leng":66734.937788086696},"geometry":{"type":"MultiLineString","coordinates":[[[4660256.0,3095529.0],[4673806.0,3113260.0],[4710987.0,3088956.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3257,"LEVL_CODE":0,"NUTS_BN_ID":3257,"OTHR_CNTR_":"F","Shape_Leng":19812.8089824134},"geometry":{"type":"MultiLineString","coordinates":[[[4045945.0,3096437.0],[4031952.0,3110464.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3269,"LEVL_CODE":0,"NUTS_BN_ID":3269,"OTHR_CNTR_":"F","Shape_Leng":22523.826101672399},"geometry":{"type":"MultiLineString","coordinates":[[[4635755.0,3113255.0],[4645979.0,3093185.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3270,"LEVL_CODE":0,"NUTS_BN_ID":3270,"OTHR_CNTR_":"F","Shape_Leng":73094.064641625606},"geometry":{"type":"MultiLineString","coordinates":[[[4578744.0,3075178.0],[4629505.0,3096907.0],[4623550.0,3113763.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3271,"LEVL_CODE":0,"NUTS_BN_ID":3271,"OTHR_CNTR_":"F","Shape_Leng":12215.5371940693},"geometry":{"type":"MultiLineString","coordinates":[[[4623550.0,3113763.0],[4635755.0,3113255.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3274,"LEVL_CODE":0,"NUTS_BN_ID":3274,"OTHR_CNTR_":"F","Shape_Leng":6065.7234370707001},"geometry":{"type":"MultiLineString","coordinates":[[[4026611.0,3113862.0],[4024038.0,3108369.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3301,"LEVL_CODE":0,"NUTS_BN_ID":3301,"OTHR_CNTR_":"F","Shape_Leng":20135.009044582901},"geometry":{"type":"MultiLineString","coordinates":[[[3802065.0,3115283.0],[3799789.0,3135289.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3355,"LEVL_CODE":0,"NUTS_BN_ID":3355,"OTHR_CNTR_":"F","Shape_Leng":26870.3743349215},"geometry":{"type":"MultiLineString","coordinates":[[[4031952.0,3110464.0],[4053685.0,3126266.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3369,"LEVL_CODE":0,"NUTS_BN_ID":3369,"OTHR_CNTR_":"F","Shape_Leng":24177.474327299999},"geometry":{"type":"MultiLineString","coordinates":[[[4011460.0,3132703.0],[4026611.0,3113862.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3370,"LEVL_CODE":0,"NUTS_BN_ID":3370,"OTHR_CNTR_":"F","Shape_Leng":8615.4971092502001},"geometry":{"type":"MultiLineString","coordinates":[[[3892268.0,3140258.0],[3900841.0,3141114.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3382,"LEVL_CODE":0,"NUTS_BN_ID":3382,"OTHR_CNTR_":"F","Shape_Leng":9628.6755881247991},"geometry":{"type":"MultiLineString","coordinates":[[[4053685.0,3126266.0],[4046900.0,3133098.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3386,"LEVL_CODE":0,"NUTS_BN_ID":3386,"OTHR_CNTR_":"F","Shape_Leng":23383.449258512799},"geometry":{"type":"MultiLineString","coordinates":[[[3988851.0,3138674.0],[4011460.0,3132703.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3390,"LEVL_CODE":0,"NUTS_BN_ID":3390,"OTHR_CNTR_":"F","Shape_Leng":33938.8679691371},"geometry":{"type":"MultiLineString","coordinates":[[[3859809.0,3150169.0],[3892268.0,3140258.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3392,"LEVL_CODE":0,"NUTS_BN_ID":3392,"OTHR_CNTR_":"T","Shape_Leng":143578.41093285711},"geometry":{"type":"MultiLineString","coordinates":[[[5271129.0,3219181.0],[5309661.0,3180255.0],[5310943.0,3132253.0],[5280979.0,3104580.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3432,"LEVL_CODE":0,"NUTS_BN_ID":3432,"OTHR_CNTR_":"F","Shape_Leng":22564.793468672498},"geometry":{"type":"MultiLineString","coordinates":[[[3900841.0,3141114.0],[3919814.0,3153328.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3444,"LEVL_CODE":0,"NUTS_BN_ID":3444,"OTHR_CNTR_":"F","Shape_Leng":58241.190361224901},"geometry":{"type":"MultiLineString","coordinates":[[[4667129.0,3151023.0],[4672430.0,3137978.0],[4660256.0,3095529.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3445,"LEVL_CODE":0,"NUTS_BN_ID":3445,"OTHR_CNTR_":"F","Shape_Leng":17244.705024367398},"geometry":{"type":"MultiLineString","coordinates":[[[4046900.0,3133098.0],[4058181.0,3146141.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3448,"LEVL_CODE":0,"NUTS_BN_ID":3448,"OTHR_CNTR_":"F","Shape_Leng":10488.3742955339},"geometry":{"type":"MultiLineString","coordinates":[[[3859819.0,3160657.0],[3859809.0,3150169.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3457,"LEVL_CODE":0,"NUTS_BN_ID":3457,"OTHR_CNTR_":"F","Shape_Leng":2502.2856057374001},"geometry":{"type":"MultiLineString","coordinates":[[[3920660.0,3156218.0],[3923162.0,3156164.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3488,"LEVL_CODE":0,"NUTS_BN_ID":3488,"OTHR_CNTR_":"F","Shape_Leng":27698.759374075002},"geometry":{"type":"MultiLineString","coordinates":[[[3923162.0,3156164.0],[3950634.0,3159703.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3492,"LEVL_CODE":0,"NUTS_BN_ID":3492,"OTHR_CNTR_":"F","Shape_Leng":20887.967929022499},"geometry":{"type":"MultiLineString","coordinates":[[[3980659.0,3157888.0],[3988851.0,3138674.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4199,"LEVL_CODE":0,"NUTS_BN_ID":4199,"OTHR_CNTR_":"F","Shape_Leng":31497.513270799998},"geometry":{"type":"MultiLineString","coordinates":[[[4125135.0,3307187.0],[4133736.0,3337488.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4242,"LEVL_CODE":0,"NUTS_BN_ID":4242,"OTHR_CNTR_":"F","Shape_Leng":14450.0951429125},"geometry":{"type":"MultiLineString","coordinates":[[[4133736.0,3337488.0],[4134708.0,3351905.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4274,"LEVL_CODE":0,"NUTS_BN_ID":4274,"OTHR_CNTR_":"F","Shape_Leng":44746.213163179797},"geometry":{"type":"MultiLineString","coordinates":[[[4614776.0,3366892.0],[4599282.0,3324914.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3625,"LEVL_CODE":0,"NUTS_BN_ID":3625,"OTHR_CNTR_":"F","Shape_Leng":29589.960970438999},"geometry":{"type":"MultiLineString","coordinates":[[[4648591.0,3174086.0],[4667129.0,3151023.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3721,"LEVL_CODE":0,"NUTS_BN_ID":3721,"OTHR_CNTR_":"F","Shape_Leng":46574.056159905202},"geometry":{"type":"MultiLineString","coordinates":[[[4058181.0,3146141.0],[4041681.0,3189694.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3773,"LEVL_CODE":0,"NUTS_BN_ID":3773,"OTHR_CNTR_":"F","Shape_Leng":22550.778758508899},"geometry":{"type":"MultiLineString","coordinates":[[[4041681.0,3189694.0],[4057369.0,3205893.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3774,"LEVL_CODE":0,"NUTS_BN_ID":3774,"OTHR_CNTR_":"F","Shape_Leng":18404.255866265499},"geometry":{"type":"MultiLineString","coordinates":[[[4057369.0,3205893.0],[4073466.0,3196970.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3811,"LEVL_CODE":0,"NUTS_BN_ID":3811,"OTHR_CNTR_":"F","Shape_Leng":46689.125615056},"geometry":{"type":"MultiLineString","coordinates":[[[4644665.0,3220610.0],[4648591.0,3174086.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3850,"LEVL_CODE":0,"NUTS_BN_ID":3850,"OTHR_CNTR_":"F","Shape_Leng":8104.3464792021996},"geometry":{"type":"MultiLineString","coordinates":[[[4646803.0,3228427.0],[4644665.0,3220610.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3871,"LEVL_CODE":0,"NUTS_BN_ID":3871,"OTHR_CNTR_":"F","Shape_Leng":50488.737139349498},"geometry":{"type":"MultiLineString","coordinates":[[[4073466.0,3196970.0],[4103094.0,3210743.0],[4099187.0,3228125.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3901,"LEVL_CODE":0,"NUTS_BN_ID":3901,"OTHR_CNTR_":"F","Shape_Leng":24951.789625985999},"geometry":{"type":"MultiLineString","coordinates":[[[4099187.0,3228125.0],[4120624.0,3240895.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3909,"LEVL_CODE":0,"NUTS_BN_ID":3909,"OTHR_CNTR_":"F","Shape_Leng":24842.410935440101},"geometry":{"type":"MultiLineString","coordinates":[[[4634822.0,3250189.0],[4646803.0,3228427.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":3964,"LEVL_CODE":0,"NUTS_BN_ID":3964,"OTHR_CNTR_":"F","Shape_Leng":14418.1481438516},"geometry":{"type":"MultiLineString","coordinates":[[[4629436.0,3263564.0],[4634822.0,3250189.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4009,"LEVL_CODE":0,"NUTS_BN_ID":4009,"OTHR_CNTR_":"F","Shape_Leng":45731.805120532998},"geometry":{"type":"MultiLineString","coordinates":[[[4120624.0,3240895.0],[4116373.0,3266482.0],[4096766.0,3269198.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4064,"LEVL_CODE":0,"NUTS_BN_ID":4064,"OTHR_CNTR_":"F","Shape_Leng":25628.437940638702},"geometry":{"type":"MultiLineString","coordinates":[[[4629911.0,3289188.0],[4629436.0,3263564.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4065,"LEVL_CODE":0,"NUTS_BN_ID":4065,"OTHR_CNTR_":"F","Shape_Leng":15772.9155565726},"geometry":{"type":"MultiLineString","coordinates":[[[4096766.0,3269198.0],[4098288.0,3284898.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4068,"LEVL_CODE":0,"NUTS_BN_ID":4068,"OTHR_CNTR_":"F","Shape_Leng":20109.009065388502},"geometry":{"type":"MultiLineString","coordinates":[[[4098288.0,3284898.0],[4118394.0,3285247.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4082,"LEVL_CODE":0,"NUTS_BN_ID":4082,"OTHR_CNTR_":"F","Shape_Leng":10667.7078642755},"geometry":{"type":"MultiLineString","coordinates":[[[4620842.0,3294804.0],[4629911.0,3289188.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4120,"LEVL_CODE":0,"NUTS_BN_ID":4120,"OTHR_CNTR_":"F","Shape_Leng":22952.576471564898},"geometry":{"type":"MultiLineString","coordinates":[[[4118394.0,3285247.0],[4125135.0,3307187.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4137,"LEVL_CODE":0,"NUTS_BN_ID":4137,"OTHR_CNTR_":"F","Shape_Leng":30541.386288353398},"geometry":{"type":"MultiLineString","coordinates":[[[4600578.0,3317655.0],[4620842.0,3294804.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4140,"LEVL_CODE":0,"NUTS_BN_ID":4140,"OTHR_CNTR_":"T","Shape_Leng":91834.407441509597},"geometry":{"type":"MultiLineString","coordinates":[[[5214671.0,3322723.0],[5256350.0,3379418.0],[5250768.0,3400148.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4151,"LEVL_CODE":0,"NUTS_BN_ID":4151,"OTHR_CNTR_":"F","Shape_Leng":7374.1940247496996},"geometry":{"type":"MultiLineString","coordinates":[[[4599282.0,3324914.0],[4600578.0,3317655.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":868,"LEVL_CODE":0,"NUTS_BN_ID":868,"OTHR_CNTR_":"F","Shape_Leng":107127.0216299227},"geometry":{"type":"MultiLineString","coordinates":[[[3718113.0,2089576.0],[3618795.0,2049424.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":890,"LEVL_CODE":0,"NUTS_BN_ID":890,"OTHR_CNTR_":"F","Shape_Leng":29343.2825661766},"geometry":{"type":"MultiLineString","coordinates":[[[2765264.0,2251930.0],[2767741.0,2281168.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":901,"LEVL_CODE":0,"NUTS_BN_ID":901,"OTHR_CNTR_":"F","Shape_Leng":147897.82811463269},"geometry":{"type":"MultiLineString","coordinates":[[[4748384.0,2106071.0],[4834907.0,2107884.0],[4813971.0,2074940.0],[4826062.0,2056175.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":924,"LEVL_CODE":0,"NUTS_BN_ID":924,"OTHR_CNTR_":"F","Shape_Leng":33683.848695859298},"geometry":{"type":"MultiLineString","coordinates":[[[4717677.0,2119916.0],[4748384.0,2106071.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":940,"LEVL_CODE":0,"NUTS_BN_ID":940,"OTHR_CNTR_":"F","Shape_Leng":119285.4344180264},"geometry":{"type":"MultiLineString","coordinates":[[[4553746.0,2039279.0],[4464783.0,2118744.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":966,"LEVL_CODE":0,"NUTS_BN_ID":966,"OTHR_CNTR_":"F","Shape_Leng":33790.165220036302},"geometry":{"type":"MultiLineString","coordinates":[[[4464783.0,2118744.0],[4440807.0,2142554.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":967,"LEVL_CODE":0,"NUTS_BN_ID":967,"OTHR_CNTR_":"F","Shape_Leng":202991.75680609859},"geometry":{"type":"MultiLineString","coordinates":[[[4271184.0,2084158.0],[4255449.0,2029968.0],[4219540.0,2051401.0],[4203786.0,2096503.0],[4202817.0,2127122.0],[4212681.0,2130031.0],[4203129.0,2142931.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":973,"LEVL_CODE":0,"NUTS_BN_ID":973,"OTHR_CNTR_":"F","Shape_Leng":106154.43437725589},"geometry":{"type":"MultiLineString","coordinates":[[[3758413.0,2173293.0],[3751042.0,2148215.0],[3757374.0,2116335.0],[3718113.0,2089576.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":975,"LEVL_CODE":0,"NUTS_BN_ID":975,"OTHR_CNTR_":"F","Shape_Leng":60007.067347315497},"geometry":{"type":"MultiLineString","coordinates":[[[4671923.0,2158742.0],[4717677.0,2119916.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":985,"LEVL_CODE":0,"NUTS_BN_ID":985,"OTHR_CNTR_":"F","Shape_Leng":12945.998517235001},"geometry":{"type":"MultiLineString","coordinates":[[[4662614.0,2167739.0],[4671923.0,2158742.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1008,"LEVL_CODE":0,"NUTS_BN_ID":1008,"OTHR_CNTR_":"F","Shape_Leng":105049.38176621569},"geometry":{"type":"MultiLineString","coordinates":[[[2767741.0,2281168.0],[2771090.0,2307826.0],[2794796.0,2322341.0],[2785424.0,2345246.0],[2799517.0,2366661.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1041,"LEVL_CODE":0,"NUTS_BN_ID":1041,"OTHR_CNTR_":"F","Shape_Leng":57568.434943896398},"geometry":{"type":"MultiLineString","coordinates":[[[3747273.0,2222080.0],[3750852.0,2219239.0],[3752330.0,2222281.0],[3751473.0,2218745.0],[3758413.0,2173293.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1042,"LEVL_CODE":0,"NUTS_BN_ID":1042,"OTHR_CNTR_":"F","Shape_Leng":132633.2059617193},"geometry":{"type":"MultiLineString","coordinates":[[[5771739.0,2366169.0],[5776433.0,2351506.0],[5746207.0,2316934.0],[5804913.0,2276443.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1064,"LEVL_CODE":0,"NUTS_BN_ID":1064,"OTHR_CNTR_":"F","Shape_Leng":44506.060611000103},"geometry":{"type":"MultiLineString","coordinates":[[[4641630.0,2206987.0],[4662614.0,2167739.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1068,"LEVL_CODE":0,"NUTS_BN_ID":1068,"OTHR_CNTR_":"F","Shape_Leng":198595.73536144229},"geometry":{"type":"MultiLineString","coordinates":[[[5023279.0,2185928.0],[4892116.0,2242112.0],[4931609.0,2231244.0],[4946488.0,2229853.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1073,"LEVL_CODE":0,"NUTS_BN_ID":1073,"OTHR_CNTR_":"F","Shape_Leng":105608.4735078434},"geometry":{"type":"MultiLineString","coordinates":[[[4440807.0,2142554.0],[4411705.0,2143776.0],[4417958.0,2160303.0],[4378765.0,2204150.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1085,"LEVL_CODE":0,"NUTS_BN_ID":1085,"OTHR_CNTR_":"F","Shape_Leng":245748.0813038972},"geometry":{"type":"MultiLineString","coordinates":[[[4203129.0,2142931.0],[4216136.0,2162653.0],[4263585.0,2174993.0],[4267292.0,2210524.0],[4277098.0,2209006.0],[4284459.0,2121475.0],[4271184.0,2084158.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1096,"LEVL_CODE":0,"NUTS_BN_ID":1096,"OTHR_CNTR_":"F","Shape_Leng":19803.475660578799},"geometry":{"type":"MultiLineString","coordinates":[[[4635294.0,2225750.0],[4641630.0,2206987.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1099,"LEVL_CODE":0,"NUTS_BN_ID":1099,"OTHR_CNTR_":"F","Shape_Leng":24468.427615103901},"geometry":{"type":"MultiLineString","coordinates":[[[4940446.0,2234753.0],[4920595.0,2249059.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1126,"LEVL_CODE":0,"NUTS_BN_ID":1126,"OTHR_CNTR_":"F","Shape_Leng":43621.250467002399},"geometry":{"type":"MultiLineString","coordinates":[[[3771052.0,2258650.0],[3747273.0,2222080.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1137,"LEVL_CODE":0,"NUTS_BN_ID":1137,"OTHR_CNTR_":"F","Shape_Leng":26634.0481005908},"geometry":{"type":"MultiLineString","coordinates":[[[4625431.0,2250490.0],[4635294.0,2225750.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1143,"LEVL_CODE":0,"NUTS_BN_ID":1143,"OTHR_CNTR_":"F","Shape_Leng":55320.723767154501},"geometry":{"type":"MultiLineString","coordinates":[[[5773956.0,2421445.0],[5771739.0,2366169.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1146,"LEVL_CODE":0,"NUTS_BN_ID":1146,"OTHR_CNTR_":"F","Shape_Leng":50956.329384246397},"geometry":{"type":"MultiLineString","coordinates":[[[3316622.0,2329179.0],[3367336.0,2324216.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1153,"LEVL_CODE":0,"NUTS_BN_ID":1153,"OTHR_CNTR_":"F","Shape_Leng":62295.5970179215},"geometry":{"type":"MultiLineString","coordinates":[[[3257970.0,2342918.0],[3309899.0,2336552.0],[3316622.0,2329179.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1167,"LEVL_CODE":0,"NUTS_BN_ID":1167,"OTHR_CNTR_":"F","Shape_Leng":111198.1071295023},"geometry":{"type":"MultiLineString","coordinates":[[[3150432.0,2367562.0],[3237268.0,2353438.0],[3257970.0,2342918.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1176,"LEVL_CODE":0,"NUTS_BN_ID":1176,"OTHR_CNTR_":"F","Shape_Leng":121403.63911246489},"geometry":{"type":"MultiLineString","coordinates":[[[3968344.0,2240335.0],[3853358.0,2279283.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1179,"LEVL_CODE":0,"NUTS_BN_ID":1179,"OTHR_CNTR_":"F","Shape_Leng":21542.877114899598},"geometry":{"type":"MultiLineString","coordinates":[[[4616324.0,2270014.0],[4625431.0,2250490.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1180,"LEVL_CODE":0,"NUTS_BN_ID":1180,"OTHR_CNTR_":"F","Shape_Leng":121218.6996542823},"geometry":{"type":"MultiLineString","coordinates":[[[4072360.0,2268584.0],[4045516.0,2233990.0],[3968344.0,2240335.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1186,"LEVL_CODE":0,"NUTS_BN_ID":1186,"OTHR_CNTR_":"F","Shape_Leng":28900.850489167999},"geometry":{"type":"MultiLineString","coordinates":[[[3367336.0,2324216.0],[3391133.0,2340615.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1187,"LEVL_CODE":0,"NUTS_BN_ID":1187,"OTHR_CNTR_":"F","Shape_Leng":136772.28561520769},"geometry":{"type":"MultiLineString","coordinates":[[[4920595.0,2249059.0],[4838213.0,2288752.0],[4845048.0,2292201.0],[4807977.0,2285510.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1191,"LEVL_CODE":0,"NUTS_BN_ID":1191,"OTHR_CNTR_":"F","Shape_Leng":79307.761260768006},"geometry":{"type":"MultiLineString","coordinates":[[[3843678.0,2290510.0],[3771052.0,2258650.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1192,"LEVL_CODE":0,"NUTS_BN_ID":1192,"OTHR_CNTR_":"F","Shape_Leng":14823.746780696099},"geometry":{"type":"MultiLineString","coordinates":[[[3853358.0,2279283.0],[3843678.0,2290510.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1194,"LEVL_CODE":0,"NUTS_BN_ID":1194,"OTHR_CNTR_":"F","Shape_Leng":92863.101677440296},"geometry":{"type":"MultiLineString","coordinates":[[[4378765.0,2204150.0],[4361856.0,2203284.0],[4364030.0,2236127.0],[4345279.0,2274843.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1207,"LEVL_CODE":0,"NUTS_BN_ID":1207,"OTHR_CNTR_":"F","Shape_Leng":208375.59465067679},"geometry":{"type":"MultiLineString","coordinates":[[[2954462.0,2426795.0],[3050708.0,2417929.0],[3150432.0,2367562.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1222,"LEVL_CODE":0,"NUTS_BN_ID":1222,"OTHR_CNTR_":"F","Shape_Leng":58162.001793971198},"geometry":{"type":"MultiLineString","coordinates":[[[2906665.0,2459936.0],[2954462.0,2426795.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1223,"LEVL_CODE":0,"NUTS_BN_ID":1223,"OTHR_CNTR_":"F","Shape_Leng":75373.066729750906},"geometry":{"type":"MultiLineString","coordinates":[[[5803878.0,2477397.0],[5808107.0,2442284.0],[5773956.0,2421445.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1225,"LEVL_CODE":0,"NUTS_BN_ID":1225,"OTHR_CNTR_":"F","Shape_Leng":48577.012639321198},"geometry":{"type":"MultiLineString","coordinates":[[[4112209.0,2296365.0],[4072360.0,2268584.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1227,"LEVL_CODE":0,"NUTS_BN_ID":1227,"OTHR_CNTR_":"F","Shape_Leng":48727.1984363351},"geometry":{"type":"MultiLineString","coordinates":[[[4577064.0,2298876.0],[4616324.0,2270014.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1235,"LEVL_CODE":0,"NUTS_BN_ID":1235,"OTHR_CNTR_":"F","Shape_Leng":221841.32201156189},"geometry":{"type":"MultiLineString","coordinates":[[[2799517.0,2366661.0],[2775644.0,2373900.0],[2765303.0,2416466.0],[2891512.0,2467522.0],[2906665.0,2459936.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1237,"LEVL_CODE":0,"NUTS_BN_ID":1237,"OTHR_CNTR_":"F","Shape_Leng":7726.4861402510996},"geometry":{"type":"MultiLineString","coordinates":[[[4121720.0,2300473.0],[4114107.0,2299149.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1249,"LEVL_CODE":0,"NUTS_BN_ID":1249,"OTHR_CNTR_":"F","Shape_Leng":26066.476755612301},"geometry":{"type":"MultiLineString","coordinates":[[[4345279.0,2274843.0],[4341817.0,2300678.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1257,"LEVL_CODE":0,"NUTS_BN_ID":1257,"OTHR_CNTR_":"F","Shape_Leng":54878.981347229499},"geometry":{"type":"MultiLineString","coordinates":[[[4807977.0,2285510.0],[4768407.0,2323535.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1270,"LEVL_CODE":0,"NUTS_BN_ID":1270,"OTHR_CNTR_":"F","Shape_Leng":51700.2873856242},"geometry":{"type":"MultiLineString","coordinates":[[[4170960.0,2316231.0],[4121720.0,2300473.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1275,"LEVL_CODE":0,"NUTS_BN_ID":1275,"OTHR_CNTR_":"F","Shape_Leng":41806.8156408957},"geometry":{"type":"MultiLineString","coordinates":[[[4542191.0,2321934.0],[4577064.0,2298876.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1278,"LEVL_CODE":0,"NUTS_BN_ID":1278,"OTHR_CNTR_":"F","Shape_Leng":20020.8708463076},"geometry":{"type":"MultiLineString","coordinates":[[[4341817.0,2300678.0],[4332539.0,2318420.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1288,"LEVL_CODE":0,"NUTS_BN_ID":1288,"OTHR_CNTR_":"F","Shape_Leng":12616.134727875},"geometry":{"type":"MultiLineString","coordinates":[[[4332539.0,2318420.0],[4322508.0,2326071.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1317,"LEVL_CODE":0,"NUTS_BN_ID":1317,"OTHR_CNTR_":"F","Shape_Leng":32111.2428015923},"geometry":{"type":"MultiLineString","coordinates":[[[4517387.0,2342327.0],[4542191.0,2321934.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1327,"LEVL_CODE":0,"NUTS_BN_ID":1327,"OTHR_CNTR_":"F","Shape_Leng":44954.475851090298},"geometry":{"type":"MultiLineString","coordinates":[[[4322508.0,2326071.0],[4281866.0,2345283.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1330,"LEVL_CODE":0,"NUTS_BN_ID":1330,"OTHR_CNTR_":"F","Shape_Leng":8716.1481053304997},"geometry":{"type":"MultiLineString","coordinates":[[[4511885.0,2349087.0],[4517387.0,2342327.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1357,"LEVL_CODE":0,"NUTS_BN_ID":1357,"OTHR_CNTR_":"F","Shape_Leng":128655.5015092926},"geometry":{"type":"MultiLineString","coordinates":[[[4768407.0,2323535.0],[4729670.0,2363927.0],[4769270.0,2357030.0],[4743128.0,2376330.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1363,"LEVL_CODE":0,"NUTS_BN_ID":1363,"OTHR_CNTR_":"F","Shape_Leng":63058.1832868079},"geometry":{"type":"MultiLineString","coordinates":[[[4211842.0,2364241.0],[4170960.0,2316231.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1364,"LEVL_CODE":0,"NUTS_BN_ID":1364,"OTHR_CNTR_":"F","Shape_Leng":72544.099304379502},"geometry":{"type":"MultiLineString","coordinates":[[[4281866.0,2345283.0],[4211842.0,2364241.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1379,"LEVL_CODE":0,"NUTS_BN_ID":1379,"OTHR_CNTR_":"F","Shape_Leng":106198.4409449229},"geometry":{"type":"MultiLineString","coordinates":[[[3391133.0,2340615.0],[3427530.0,2440382.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1408,"LEVL_CODE":0,"NUTS_BN_ID":1408,"OTHR_CNTR_":"F","Shape_Leng":45849.068432163898},"geometry":{"type":"MultiLineString","coordinates":[[[4501438.0,2393730.0],[4511885.0,2349087.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1417,"LEVL_CODE":0,"NUTS_BN_ID":1417,"OTHR_CNTR_":"F","Shape_Leng":114358.9584245029},"geometry":{"type":"MultiLineString","coordinates":[[[5811317.0,2587520.0],[5793093.0,2538782.0],[5803878.0,2477397.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1437,"LEVL_CODE":0,"NUTS_BN_ID":1437,"OTHR_CNTR_":"F","Shape_Leng":20761.945665740601},"geometry":{"type":"MultiLineString","coordinates":[[[4511152.0,2412080.0],[4501438.0,2393730.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1472,"LEVL_CODE":0,"NUTS_BN_ID":1472,"OTHR_CNTR_":"F","Shape_Leng":85874.827223610206},"geometry":{"type":"MultiLineString","coordinates":[[[4743128.0,2376330.0],[4709483.0,2411138.0],[4705994.0,2448440.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1478,"LEVL_CODE":0,"NUTS_BN_ID":1478,"OTHR_CNTR_":"F","Shape_Leng":113467.9329099123},"geometry":{"type":"MultiLineString","coordinates":[[[4674467.0,2437757.0],[4680015.0,2399499.0],[4660971.0,2434619.0],[4664618.0,2451880.0],[4674467.0,2437757.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1490,"LEVL_CODE":0,"NUTS_BN_ID":1490,"OTHR_CNTR_":"F","Shape_Leng":61212.899766526098},"geometry":{"type":"MultiLineString","coordinates":[[[4493972.0,2463135.0],[4494479.0,2456527.0],[4504513.0,2452710.0],[4504401.0,2451742.0],[4502350.0,2450127.0],[4500630.0,2448452.0],[4511152.0,2412080.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1519,"LEVL_CODE":0,"NUTS_BN_ID":1519,"OTHR_CNTR_":"F","Shape_Leng":93393.132035596995},"geometry":{"type":"MultiLineString","coordinates":[[[5848989.0,2658979.0],[5853248.0,2617138.0],[5811317.0,2587520.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1523,"LEVL_CODE":0,"NUTS_BN_ID":1523,"OTHR_CNTR_":"F","Shape_Leng":168731.75515582229},"geometry":{"type":"MultiLineString","coordinates":[[[4705994.0,2448440.0],[4681668.0,2469358.0],[4701639.0,2441097.0],[4670897.0,2449632.0],[4681405.0,2469572.0],[4660790.0,2481321.0],[4653708.0,2458524.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1534,"LEVL_CODE":0,"NUTS_BN_ID":1534,"OTHR_CNTR_":"F","Shape_Leng":7157.7776057615001},"geometry":{"type":"MultiLineString","coordinates":[[[4488504.0,2467753.0],[4493972.0,2463135.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1574,"LEVL_CODE":0,"NUTS_BN_ID":1574,"OTHR_CNTR_":"F","Shape_Leng":150618.94106078029},"geometry":{"type":"MultiLineString","coordinates":[[[3427530.0,2440382.0],[3450984.0,2549758.0],[3483488.0,2528649.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1585,"LEVL_CODE":0,"NUTS_BN_ID":1585,"OTHR_CNTR_":"F","Shape_Leng":144417.8333253492},"geometry":{"type":"MultiLineString","coordinates":[[[4653708.0,2458524.0],[4630673.0,2414463.0],[4605155.0,2451877.0],[4594118.0,2492445.0],[4601454.0,2491746.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1601,"LEVL_CODE":0,"NUTS_BN_ID":1601,"OTHR_CNTR_":"F","Shape_Leng":17019.250248521399},"geometry":{"type":"MultiLineString","coordinates":[[[4601454.0,2491746.0],[4611761.0,2505289.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1610,"LEVL_CODE":0,"NUTS_BN_ID":1610,"OTHR_CNTR_":"F","Shape_Leng":129214.3122996336},"geometry":{"type":"MultiLineString","coordinates":[[[4562838.0,2508582.0],[4511755.0,2482245.0],[4526828.0,2494957.0],[4509740.0,2495486.0],[4488504.0,2467753.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1638,"LEVL_CODE":0,"NUTS_BN_ID":1638,"OTHR_CNTR_":"F","Shape_Leng":36437.8118799808},"geometry":{"type":"MultiLineString","coordinates":[[[4586442.0,2518574.0],[4564770.0,2522807.0],[4562838.0,2508582.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1641,"LEVL_CODE":0,"NUTS_BN_ID":1641,"OTHR_CNTR_":"F","Shape_Leng":15153.142274727301},"geometry":{"type":"MultiLineString","coordinates":[[[4599618.0,2526058.0],[4586442.0,2518574.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1642,"LEVL_CODE":0,"NUTS_BN_ID":1642,"OTHR_CNTR_":"F","Shape_Leng":24058.052810972},"geometry":{"type":"MultiLineString","coordinates":[[[4611761.0,2505289.0],[4599618.0,2526058.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1765,"LEVL_CODE":0,"NUTS_BN_ID":1765,"OTHR_CNTR_":"F","Shape_Leng":129856.8917598119},"geometry":{"type":"MultiLineString","coordinates":[[[3483488.0,2528649.0],[3448601.0,2573509.0],[3467375.0,2607017.0],[3466410.0,2641622.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":1914,"LEVL_CODE":0,"NUTS_BN_ID":1914,"OTHR_CNTR_":"F","Shape_Leng":127017.1935429569},"geometry":{"type":"MultiLineString","coordinates":[[[3466410.0,2641622.0],[3417564.0,2669863.0],[3398292.0,2709710.0],[3414076.0,2730788.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2031,"LEVL_CODE":0,"NUTS_BN_ID":2031,"OTHR_CNTR_":"F","Shape_Leng":70673.2800656443},"geometry":{"type":"MultiLineString","coordinates":[[[3414076.0,2730788.0],[3376418.0,2766832.0],[3385829.0,2782812.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2146,"LEVL_CODE":0,"NUTS_BN_ID":2146,"OTHR_CNTR_":"F","Shape_Leng":88537.971950465901},"geometry":{"type":"MultiLineString","coordinates":[[[3385829.0,2782812.0],[3312982.0,2833134.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2415,"LEVL_CODE":0,"NUTS_BN_ID":2415,"OTHR_CNTR_":"F","Shape_Leng":35223.739741815603},"geometry":{"type":"MultiLineString","coordinates":[[[3440577.0,2898569.0],[3450173.0,2907276.0],[3471714.0,2901637.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2417,"LEVL_CODE":0,"NUTS_BN_ID":2417,"OTHR_CNTR_":"F","Shape_Leng":309819.89684931352},"geometry":{"type":"MultiLineString","coordinates":[[[3312982.0,2833134.0],[3230012.0,2878774.0],[3265917.0,2882340.0],[3272326.0,2898653.0],[3272112.0,2916407.0],[3233518.0,2911159.0],[3237876.0,2932103.0],[3299812.0,2934795.0],[3320981.0,2931486.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2485,"LEVL_CODE":0,"NUTS_BN_ID":2485,"OTHR_CNTR_":"F","Shape_Leng":164064.97952370811},"geometry":{"type":"MultiLineString","coordinates":[[[3320981.0,2931486.0],[3366543.0,2946488.0],[3388260.0,2900486.0],[3431172.0,2905743.0],[3429862.0,2909273.0],[3437420.0,2908365.0],[3438982.0,2900126.0],[3440577.0,2898569.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4412,"LEVL_CODE":0,"NUTS_BN_ID":4412,"OTHR_CNTR_":"T","Shape_Leng":92158.033839327298},"geometry":{"type":"MultiLineString","coordinates":[[[5250768.0,3400148.0],[5245487.0,3427862.0],[5212597.0,3482700.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4415,"LEVL_CODE":0,"NUTS_BN_ID":4415,"OTHR_CNTR_":"F","Shape_Leng":42096.681492340897},"geometry":{"type":"MultiLineString","coordinates":[[[4602721.0,3407226.0],[4614776.0,3366892.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4487,"LEVL_CODE":0,"NUTS_BN_ID":4487,"OTHR_CNTR_":"F","Shape_Leng":6974.4538232670002},"geometry":{"type":"MultiLineString","coordinates":[[[4598483.0,3432718.0],[4598024.0,3425759.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4490,"LEVL_CODE":0,"NUTS_BN_ID":4490,"OTHR_CNTR_":"T","Shape_Leng":29495.703695829801},"geometry":{"type":"MultiLineString","coordinates":[[[5212597.0,3482700.0],[5202339.0,3510354.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4525,"LEVL_CODE":0,"NUTS_BN_ID":4525,"OTHR_CNTR_":"T","Shape_Leng":98702.094320768098},"geometry":{"type":"MultiLineString","coordinates":[[[5202339.0,3510354.0],[5262706.0,3515889.0],[5282724.0,3548285.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4550,"LEVL_CODE":0,"NUTS_BN_ID":4550,"OTHR_CNTR_":"F","Shape_Leng":35455.4165490222},"geometry":{"type":"MultiLineString","coordinates":[[[5202339.0,3510354.0],[5183760.0,3540552.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4564,"LEVL_CODE":0,"NUTS_BN_ID":4564,"OTHR_CNTR_":"T","Shape_Leng":80132.211667127296},"geometry":{"type":"MultiLineString","coordinates":[[[5069608.0,3528478.0],[5147704.0,3546424.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4566,"LEVL_CODE":0,"NUTS_BN_ID":4566,"OTHR_CNTR_":"F","Shape_Leng":36530.303142824501},"geometry":{"type":"MultiLineString","coordinates":[[[5183760.0,3540552.0],[5147704.0,3546424.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4569,"LEVL_CODE":0,"NUTS_BN_ID":4569,"OTHR_CNTR_":"T","Shape_Leng":81362.005530954004},"geometry":{"type":"MultiLineString","coordinates":[[[4988318.0,3525041.0],[5069608.0,3528478.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4573,"LEVL_CODE":0,"NUTS_BN_ID":4573,"OTHR_CNTR_":"T","Shape_Leng":33356.466580788998},"geometry":{"type":"MultiLineString","coordinates":[[[4954962.0,3524884.0],[4988318.0,3525041.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4602,"LEVL_CODE":0,"NUTS_BN_ID":4602,"OTHR_CNTR_":"F","Shape_Leng":212025.08499557141},"geometry":{"type":"MultiLineString","coordinates":[[[3190028.0,3639928.0],[3156414.0,3631977.0],[3185445.0,3585546.0],[3227218.0,3609217.0],[3242738.0,3561309.0],[3267014.0,3563206.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4639,"LEVL_CODE":0,"NUTS_BN_ID":4639,"OTHR_CNTR_":"F","Shape_Leng":20264.593810383602},"geometry":{"type":"MultiLineString","coordinates":[[[4264046.0,3530123.0],[4283725.0,3525289.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4647,"LEVL_CODE":0,"NUTS_BN_ID":4647,"OTHR_CNTR_":"F","Shape_Leng":30918.7726108147},"geometry":{"type":"MultiLineString","coordinates":[[[4233489.0,3534838.0],[4264046.0,3530123.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4664,"LEVL_CODE":0,"NUTS_BN_ID":4664,"OTHR_CNTR_":"F","Shape_Leng":82569.976539313604},"geometry":{"type":"MultiLineString","coordinates":[[[3230330.0,3682748.0],[3204366.0,3652336.0],[3178904.0,3652931.0],[3190028.0,3639928.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4665,"LEVL_CODE":0,"NUTS_BN_ID":4665,"OTHR_CNTR_":"T","Shape_Leng":79967.617881241793},"geometry":{"type":"MultiLineString","coordinates":[[[5147704.0,3546424.0],[5120797.0,3621729.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4673,"LEVL_CODE":0,"NUTS_BN_ID":4673,"OTHR_CNTR_":"T","Shape_Leng":61000.673178157696},"geometry":{"type":"MultiLineString","coordinates":[[[5120797.0,3621729.0],[5059830.0,3623763.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4678,"LEVL_CODE":0,"NUTS_BN_ID":4678,"OTHR_CNTR_":"T","Shape_Leng":25663.3724105494},"geometry":{"type":"MultiLineString","coordinates":[[[5059830.0,3623763.0],[5034381.0,3627075.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4679,"LEVL_CODE":0,"NUTS_BN_ID":4679,"OTHR_CNTR_":"T","Shape_Leng":234333.38226665219},"geometry":{"type":"MultiLineString","coordinates":[[[5282724.0,3548285.0],[5320958.0,3574824.0],[5342539.0,3562464.0],[5322383.0,3578824.0],[5331212.0,3607645.0],[5325426.0,3638165.0],[5375053.0,3695401.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4713,"LEVL_CODE":0,"NUTS_BN_ID":4713,"OTHR_CNTR_":"F","Shape_Leng":61001.883545082797},"geometry":{"type":"MultiLineString","coordinates":[[[5375053.0,3695401.0],[5379898.0,3700183.0],[5359861.0,3707286.0],[5356924.0,3740091.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4763,"LEVL_CODE":0,"NUTS_BN_ID":4763,"OTHR_CNTR_":"F","Shape_Leng":46989.234660340997},"geometry":{"type":"MultiLineString","coordinates":[[[5314580.0,3760462.0],[5356924.0,3740091.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4785,"LEVL_CODE":0,"NUTS_BN_ID":4785,"OTHR_CNTR_":"F","Shape_Leng":18512.9651796832},"geometry":{"type":"MultiLineString","coordinates":[[[5298223.0,3769133.0],[5314580.0,3760462.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4797,"LEVL_CODE":0,"NUTS_BN_ID":4797,"OTHR_CNTR_":"T","Shape_Leng":268927.7368789012},"geometry":{"type":"MultiLineString","coordinates":[[[5374000.0,3938766.0],[5386725.0,3932699.0],[5387295.0,3880297.0],[5429843.0,3846698.0],[5435586.0,3815983.0],[5413935.0,3766260.0],[5356924.0,3740091.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4806,"LEVL_CODE":0,"NUTS_BN_ID":4806,"OTHR_CNTR_":"F","Shape_Leng":66555.431601535005},"geometry":{"type":"MultiLineString","coordinates":[[[5007411.0,3715790.0],[5057504.0,3759611.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4808,"LEVL_CODE":0,"NUTS_BN_ID":4808,"OTHR_CNTR_":"F","Shape_Leng":40602.308755583603},"geometry":{"type":"MultiLineString","coordinates":[[[5057504.0,3759611.0],[5097787.0,3764687.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4809,"LEVL_CODE":0,"NUTS_BN_ID":4809,"OTHR_CNTR_":"F","Shape_Leng":17891.7909204434},"geometry":{"type":"MultiLineString","coordinates":[[[5097787.0,3764687.0],[5114449.0,3771207.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4810,"LEVL_CODE":0,"NUTS_BN_ID":4810,"OTHR_CNTR_":"F","Shape_Leng":77810.761795757804},"geometry":{"type":"MultiLineString","coordinates":[[[5114449.0,3771207.0],[5192242.0,3769546.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4813,"LEVL_CODE":0,"NUTS_BN_ID":4813,"OTHR_CNTR_":"F","Shape_Leng":129762.0305867242},"geometry":{"type":"MultiLineString","coordinates":[[[5192242.0,3769546.0],[5234205.0,3799574.0],[5250770.0,3774013.0],[5298223.0,3769133.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4889,"LEVL_CODE":0,"NUTS_BN_ID":4889,"OTHR_CNTR_":"F","Shape_Leng":26249.516281972101},"geometry":{"type":"MultiLineString","coordinates":[[[5350178.0,3949791.0],[5374000.0,3938766.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4913,"LEVL_CODE":0,"NUTS_BN_ID":4913,"OTHR_CNTR_":"F","Shape_Leng":30347.117093793298},"geometry":{"type":"MultiLineString","coordinates":[[[5192748.0,3965598.0],[5167150.0,3949299.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4918,"LEVL_CODE":0,"NUTS_BN_ID":4918,"OTHR_CNTR_":"F","Shape_Leng":14557.064787076501},"geometry":{"type":"MultiLineString","coordinates":[[[5203368.0,3975554.0],[5192748.0,3965598.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4919,"LEVL_CODE":0,"NUTS_BN_ID":4919,"OTHR_CNTR_":"F","Shape_Leng":159486.68299389849},"geometry":{"type":"MultiLineString","coordinates":[[[5350178.0,3949791.0],[5302255.0,3937916.0],[5266426.0,3967657.0],[5203368.0,3975554.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":4950,"LEVL_CODE":0,"NUTS_BN_ID":4950,"OTHR_CNTR_":"T","Shape_Leng":145475.59877958099},"geometry":{"type":"MultiLineString","coordinates":[[[5314985.0,4087161.0],[5352003.0,4006363.0],[5350178.0,3949791.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5032,"LEVL_CODE":0,"NUTS_BN_ID":5032,"OTHR_CNTR_":"T","Shape_Leng":95732.270721543304},"geometry":{"type":"MultiLineString","coordinates":[[[5333197.0,4170600.0],[5345304.0,4162375.0],[5314985.0,4087161.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5215,"LEVL_CODE":0,"NUTS_BN_ID":5215,"OTHR_CNTR_":"F","Shape_Leng":17305.477538482799},"geometry":{"type":"MultiLineString","coordinates":[[[5295069.0,4299086.0],[5288456.0,4283094.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5278,"LEVL_CODE":0,"NUTS_BN_ID":5278,"OTHR_CNTR_":"T","Shape_Leng":174137.54625749451},"geometry":{"type":"MultiLineString","coordinates":[[[5368678.0,4456901.0],[5295069.0,4299086.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5394,"LEVL_CODE":0,"NUTS_BN_ID":5394,"OTHR_CNTR_":"T","Shape_Leng":264208.06934703118},"geometry":{"type":"MultiLineString","coordinates":[[[5296286.0,4657446.0],[5403014.0,4591138.0],[5368678.0,4456901.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5477,"LEVL_CODE":0,"NUTS_BN_ID":5477,"OTHR_CNTR_":"T","Shape_Leng":225013.33132566579},"geometry":{"type":"MultiLineString","coordinates":[[[5227537.0,4839633.0],[5243842.0,4771086.0],[5267071.0,4767184.0],[5277850.0,4727076.0],[5310690.0,4705520.0],[5296286.0,4657446.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5515,"LEVL_CODE":0,"NUTS_BN_ID":5515,"OTHR_CNTR_":"T","Shape_Leng":115306.80954099121},"geometry":{"type":"MultiLineString","coordinates":[[[5187963.0,4936694.0],[5238650.0,4862871.0],[5227537.0,4839633.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5554,"LEVL_CODE":0,"NUTS_BN_ID":5554,"OTHR_CNTR_":"F","Shape_Leng":428971.95381537161},"geometry":{"type":"MultiLineString","coordinates":[[[4967896.0,4811191.0],[4933500.0,4859198.0],[4936326.0,4918472.0],[4894701.0,4985469.0],[4894258.0,5038840.0],[4808022.0,5093125.0],[4744758.0,5136005.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5571,"LEVL_CODE":0,"NUTS_BN_ID":5571,"OTHR_CNTR_":"T","Shape_Leng":356282.75658390188},"geometry":{"type":"MultiLineString","coordinates":[[[5073773.0,5207018.0],[5058369.0,5186959.0],[5074855.0,5186239.0],[5071270.0,5147217.0],[5090892.0,5113062.0],[5163916.0,5073690.0],[5148025.0,4984209.0],[5187963.0,4936694.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":29,"LEVL_CODE":0,"NUTS_BN_ID":29,"OTHR_CNTR_":"F","Shape_Leng":90636.316467335695},"geometry":{"type":"MultiLineString","coordinates":[[[5745263.0,1470712.0],[5675974.0,1450064.0],[5668626.0,1466863.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":30,"LEVL_CODE":0,"NUTS_BN_ID":30,"OTHR_CNTR_":"F","Shape_Leng":40809.759999462498},"geometry":{"type":"MultiLineString","coordinates":[[[5668626.0,1466863.0],[5627846.0,1468434.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":31,"LEVL_CODE":0,"NUTS_BN_ID":31,"OTHR_CNTR_":"F","Shape_Leng":187621.62383398751},"geometry":{"type":"MultiLineString","coordinates":[[[5733951.0,1502942.0],[5758361.0,1512828.0],[5758374.0,1489185.0],[5803946.0,1513885.0],[5808652.0,1497600.0],[5745263.0,1470712.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":34,"LEVL_CODE":0,"NUTS_BN_ID":34,"OTHR_CNTR_":"F","Shape_Leng":8974.8590542310994},"geometry":{"type":"MultiLineString","coordinates":[[[3135148.0,1459461.0],[3137381.0,1462323.0],[3138771.0,1457161.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":37,"LEVL_CODE":0,"NUTS_BN_ID":37,"OTHR_CNTR_":"F","Shape_Leng":52787.232949999903},"geometry":{"type":"MultiLineString","coordinates":[[[5681342.0,1504585.0],[5691603.0,1505852.0],[5733951.0,1502942.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":38,"LEVL_CODE":0,"NUTS_BN_ID":38,"OTHR_CNTR_":"F","Shape_Leng":56380.501295471397},"geometry":{"type":"MultiLineString","coordinates":[[[5627380.0,1488246.0],[5681342.0,1504585.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":44,"LEVL_CODE":0,"NUTS_BN_ID":44,"OTHR_CNTR_":"F","Shape_Leng":194337.08796260081},"geometry":{"type":"MultiLineString","coordinates":[[[5627846.0,1468434.0],[5556179.0,1468066.0],[5557761.0,1506171.0],[5581434.0,1499248.0],[5610365.0,1511192.0],[5627380.0,1488246.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":46,"LEVL_CODE":0,"NUTS_BN_ID":46,"OTHR_CNTR_":"F","Shape_Leng":562698.79212078277},"geometry":{"type":"MultiLineString","coordinates":[[[6515704.0,1746227.0],[6480058.0,1694509.0],[6503587.0,1668427.0],[6468486.0,1657664.0],[6418870.0,1604654.0],[6364981.0,1599112.0],[6342322.0,1629483.0],[6393310.0,1656065.0],[6389935.0,1682938.0],[6454931.0,1698236.0],[6525887.0,1760555.0],[6515704.0,1746227.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":47,"LEVL_CODE":0,"NUTS_BN_ID":47,"OTHR_CNTR_":"F","Shape_Leng":103224.5217529411},"geometry":{"type":"MultiLineString","coordinates":[[[5885301.0,1559359.0],[5879187.0,1545293.0],[5868368.0,1565449.0],[5876581.0,1593783.0],[5885301.0,1559359.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":51,"LEVL_CODE":0,"NUTS_BN_ID":51,"OTHR_CNTR_":"F","Shape_Leng":6933.8685694776996},"geometry":{"type":"MultiLineString","coordinates":[[[2929613.0,1567572.0],[2932333.0,1566615.0],[2932372.0,1562565.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":52,"LEVL_CODE":0,"NUTS_BN_ID":52,"OTHR_CNTR_":"F","Shape_Leng":68566.180083585903},"geometry":{"type":"MultiLineString","coordinates":[[[4737745.0,1433530.0],[4734650.0,1428695.0],[4723721.0,1430338.0],[4716692.0,1434924.0],[4714129.0,1445448.0],[4719148.0,1447612.0],[4716917.0,1445559.0],[4737745.0,1433530.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":53,"LEVL_CODE":0,"NUTS_BN_ID":53,"OTHR_CNTR_":"F","Shape_Leng":33195.215218621001},"geometry":{"type":"MultiLineString","coordinates":[[[4715277.0,1452327.0],[4704680.0,1450496.0],[4701648.0,1452015.0],[4701311.0,1456159.0],[4711861.0,1454881.0],[4715277.0,1452327.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":58,"LEVL_CODE":0,"NUTS_BN_ID":58,"OTHR_CNTR_":"F","Shape_Leng":19060.410280672899},"geometry":{"type":"MultiLineString","coordinates":[[[2948814.0,1608502.0],[2938042.0,1592777.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":64,"LEVL_CODE":0,"NUTS_BN_ID":64,"OTHR_CNTR_":"F","Shape_Leng":162237.66129637961},"geometry":{"type":"MultiLineString","coordinates":[[[5932256.0,1617903.0],[5919195.0,1616053.0],[5913282.0,1638034.0],[5951690.0,1682540.0],[5932256.0,1617903.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":73,"LEVL_CODE":0,"NUTS_BN_ID":73,"OTHR_CNTR_":"F","Shape_Leng":144271.10454110921},"geometry":{"type":"MultiLineString","coordinates":[[[3087264.0,1629828.0],[3030249.0,1638125.0],[2948814.0,1608502.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":75,"LEVL_CODE":0,"NUTS_BN_ID":75,"OTHR_CNTR_":"F","Shape_Leng":58323.786647023502},"geometry":{"type":"MultiLineString","coordinates":[[[3144923.0,1621046.0],[3087264.0,1629828.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":83,"LEVL_CODE":0,"NUTS_BN_ID":83,"OTHR_CNTR_":"F","Shape_Leng":153834.4303961996},"geometry":{"type":"MultiLineString","coordinates":[[[2936960.0,1593057.0],[2932551.0,1591139.0],[2911298.0,1581944.0],[2876646.0,1610067.0],[2852242.0,1674937.0],[2862161.0,1681572.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":106,"LEVL_CODE":0,"NUTS_BN_ID":106,"OTHR_CNTR_":"F","Shape_Leng":73954.467473364697},"geometry":{"type":"MultiLineString","coordinates":[[[4771338.0,1529624.0],[4725279.0,1536027.0],[4710072.0,1558883.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":119,"LEVL_CODE":0,"NUTS_BN_ID":119,"OTHR_CNTR_":"F","Shape_Leng":29289.925687518498},"geometry":{"type":"MultiLineString","coordinates":[[[4710072.0,1558883.0],[4682531.0,1568852.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":125,"LEVL_CODE":0,"NUTS_BN_ID":125,"OTHR_CNTR_":"F","Shape_Leng":109540.74609000199},"geometry":{"type":"MultiLineString","coordinates":[[[2862161.0,1681572.0],[2821913.0,1731468.0],[2777974.0,1743032.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":144,"LEVL_CODE":0,"NUTS_BN_ID":144,"OTHR_CNTR_":"F","Shape_Leng":95205.310224779605},"geometry":{"type":"MultiLineString","coordinates":[[[4775275.0,1602135.0],[4797463.0,1568025.0],[4781969.0,1527249.0],[4771338.0,1529624.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":147,"LEVL_CODE":0,"NUTS_BN_ID":147,"OTHR_CNTR_":"F","Shape_Leng":181905.94230468469},"geometry":{"type":"MultiLineString","coordinates":[[[3287209.0,1667565.0],[3233724.0,1604154.0],[3213798.0,1619600.0],[3181773.0,1607156.0],[3144923.0,1621046.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":149,"LEVL_CODE":0,"NUTS_BN_ID":149,"OTHR_CNTR_":"F","Shape_Leng":352594.50331835501},"geometry":{"type":"MultiLineString","coordinates":[[[5479212.0,1651207.0],[5508398.0,1587644.0],[5465920.0,1620878.0],[5433799.0,1592566.0],[5406086.0,1635756.0],[5387235.0,1628640.0],[5386545.0,1599137.0],[5369812.0,1606988.0],[5352257.0,1643570.0],[5359181.0,1668490.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":163,"LEVL_CODE":0,"NUTS_BN_ID":163,"OTHR_CNTR_":"F","Shape_Leng":199165.2114940435},"geometry":{"type":"MultiLineString","coordinates":[[[2777974.0,1743032.0],[2731366.0,1729850.0],[2673424.0,1762197.0],[2637454.0,1760476.0],[2663468.0,1801242.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":179,"LEVL_CODE":0,"NUTS_BN_ID":179,"OTHR_CNTR_":"F","Shape_Leng":44618.082364160597},"geometry":{"type":"MultiLineString","coordinates":[[[5489168.0,1714339.0],[5506090.0,1713341.0],[5518723.0,1710761.0],[5511953.0,1697631.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":180,"LEVL_CODE":0,"NUTS_BN_ID":180,"OTHR_CNTR_":"F","Shape_Leng":126248.8484733347},"geometry":{"type":"MultiLineString","coordinates":[[[5511953.0,1697631.0],[5447944.0,1704587.0],[5479212.0,1651207.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":181,"LEVL_CODE":0,"NUTS_BN_ID":181,"OTHR_CNTR_":"F","Shape_Leng":114017.70384823051},"geometry":{"type":"MultiLineString","coordinates":[[[4682531.0,1568852.0],[4578760.0,1616091.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":204,"LEVL_CODE":0,"NUTS_BN_ID":204,"OTHR_CNTR_":"F","Shape_Leng":16233.2650314693},"geometry":{"type":"MultiLineString","coordinates":[[[5479887.0,1727657.0],[5489168.0,1714339.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":216,"LEVL_CODE":0,"NUTS_BN_ID":216,"OTHR_CNTR_":"F","Shape_Leng":92174.693011338401},"geometry":{"type":"MultiLineString","coordinates":[[[5803209.0,1799626.0],[5823323.0,1795113.0],[5779495.0,1786813.0],[5803209.0,1799626.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":217,"LEVL_CODE":0,"NUTS_BN_ID":217,"OTHR_CNTR_":"F","Shape_Leng":51796.126428091498},"geometry":{"type":"MultiLineString","coordinates":[[[4787072.0,1652570.0],[4775275.0,1602135.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":225,"LEVL_CODE":0,"NUTS_BN_ID":225,"OTHR_CNTR_":"F","Shape_Leng":121824.2714085443},"geometry":{"type":"MultiLineString","coordinates":[[[3370291.0,1707909.0],[3359956.0,1695392.0],[3370585.0,1681008.0],[3316791.0,1683976.0],[3287209.0,1667565.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":234,"LEVL_CODE":0,"NUTS_BN_ID":234,"OTHR_CNTR_":"F","Shape_Leng":96209.961346943106},"geometry":{"type":"MultiLineString","coordinates":[[[5284776.0,1701826.0],[5293577.0,1695243.0],[5283581.0,1696553.0],[5280403.0,1686600.0],[5260091.0,1703342.0],[5259839.0,1710404.0],[5266094.0,1715566.0],[5284776.0,1701826.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":237,"LEVL_CODE":0,"NUTS_BN_ID":237,"OTHR_CNTR_":"F","Shape_Leng":11486.5674747824},"geometry":{"type":"MultiLineString","coordinates":[[[5532122.0,1750830.0],[5524357.0,1759295.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":240,"LEVL_CODE":0,"NUTS_BN_ID":240,"OTHR_CNTR_":"F","Shape_Leng":86393.535289850493},"geometry":{"type":"MultiLineString","coordinates":[[[5636794.0,1775639.0],[5641418.0,1752557.0],[5612065.0,1776840.0],[5636794.0,1775639.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":241,"LEVL_CODE":0,"NUTS_BN_ID":241,"OTHR_CNTR_":"F","Shape_Leng":106632.1388478505},"geometry":{"type":"MultiLineString","coordinates":[[[5516523.0,1766109.0],[5481335.0,1752736.0],[5477835.0,1748636.0],[5451252.0,1756135.0],[5474074.0,1763692.0],[5472996.0,1775581.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":247,"LEVL_CODE":0,"NUTS_BN_ID":247,"OTHR_CNTR_":"F","Shape_Leng":13814.670154654201},"geometry":{"type":"MultiLineString","coordinates":[[[5524357.0,1759295.0],[5514687.0,1763315.0],[5516523.0,1766109.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":267,"LEVL_CODE":0,"NUTS_BN_ID":267,"OTHR_CNTR_":"F","Shape_Leng":132265.04893778049},"geometry":{"type":"MultiLineString","coordinates":[[[4578760.0,1616091.0],[4558920.0,1613492.0],[4537677.0,1640446.0],[4547368.0,1668825.0],[4561971.0,1681984.0],[4569325.0,1671355.0],[4584163.0,1667360.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":271,"LEVL_CODE":0,"NUTS_BN_ID":271,"OTHR_CNTR_":"F","Shape_Leng":107978.86487866699},"geometry":{"type":"MultiLineString","coordinates":[[[5359181.0,1668490.0],[5301754.0,1712453.0],[5319575.0,1743336.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":278,"LEVL_CODE":0,"NUTS_BN_ID":278,"OTHR_CNTR_":"F","Shape_Leng":90348.288471574997},"geometry":{"type":"MultiLineString","coordinates":[[[5407983.0,1761674.0],[5462416.0,1749236.0],[5483740.0,1736570.0],[5479887.0,1727657.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":282,"LEVL_CODE":0,"NUTS_BN_ID":282,"OTHR_CNTR_":"F","Shape_Leng":117749.8879805527},"geometry":{"type":"MultiLineString","coordinates":[[[4584163.0,1667360.0],[4617854.0,1684431.0],[4652205.0,1662631.0],[4690793.0,1670055.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":292,"LEVL_CODE":0,"NUTS_BN_ID":292,"OTHR_CNTR_":"F","Shape_Leng":195525.32948642629},"geometry":{"type":"MultiLineString","coordinates":[[[4690793.0,1670055.0],[4818636.0,1705650.0],[4811813.0,1701510.0],[4787072.0,1652570.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":302,"LEVL_CODE":0,"NUTS_BN_ID":302,"OTHR_CNTR_":"F","Shape_Leng":223775.19545129361},"geometry":{"type":"MultiLineString","coordinates":[[[5359043.0,1779805.0],[5328424.0,1766964.0],[5328013.0,1769786.0],[5328192.0,1767461.0],[5310932.0,1786409.0],[5298495.0,1762706.0],[5293940.0,1771964.0],[5290382.0,1779207.0],[5279857.0,1800696.0],[5255141.0,1813408.0],[5256387.0,1829525.0],[5283558.0,1824502.0],[5284757.0,1843548.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":303,"LEVL_CODE":0,"NUTS_BN_ID":303,"OTHR_CNTR_":"F","Shape_Leng":101540.90529383819},"geometry":{"type":"MultiLineString","coordinates":[[[5319575.0,1743336.0],[5361340.0,1775697.0],[5407983.0,1761674.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":305,"LEVL_CODE":0,"NUTS_BN_ID":305,"OTHR_CNTR_":"F","Shape_Leng":126636.6586347354},"geometry":{"type":"MultiLineString","coordinates":[[[5518880.0,1803024.0],[5555772.0,1789791.0],[5563828.0,1737397.0],[5532122.0,1750830.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":309,"LEVL_CODE":0,"NUTS_BN_ID":309,"OTHR_CNTR_":"F","Shape_Leng":49893.644257376203},"geometry":{"type":"MultiLineString","coordinates":[[[5472996.0,1775581.0],[5424878.0,1788772.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":311,"LEVL_CODE":0,"NUTS_BN_ID":311,"OTHR_CNTR_":"F","Shape_Leng":66442.658465502303},"geometry":{"type":"MultiLineString","coordinates":[[[5424878.0,1788772.0],[5359043.0,1779805.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":319,"LEVL_CODE":0,"NUTS_BN_ID":319,"OTHR_CNTR_":"F","Shape_Leng":128518.3835535317},"geometry":{"type":"MultiLineString","coordinates":[[[5253426.0,1758626.0],[5271661.0,1732207.0],[5230435.0,1738831.0],[5243461.0,1773343.0],[5253426.0,1758626.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":328,"LEVL_CODE":0,"NUTS_BN_ID":328,"OTHR_CNTR_":"F","Shape_Leng":180270.44418785421},"geometry":{"type":"MultiLineString","coordinates":[[[4898486.0,1734482.0],[4857416.0,1670733.0],[4823160.0,1671384.0],[4817415.0,1701620.0],[4818726.0,1703463.0],[4821555.0,1707446.0],[4840159.0,1733790.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":329,"LEVL_CODE":0,"NUTS_BN_ID":329,"OTHR_CNTR_":"F","Shape_Leng":118689.2303597484},"geometry":{"type":"MultiLineString","coordinates":[[[2663468.0,1801242.0],[2694653.0,1915761.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":331,"LEVL_CODE":0,"NUTS_BN_ID":331,"OTHR_CNTR_":"F","Shape_Leng":47262.898544087198},"geometry":{"type":"MultiLineString","coordinates":[[[5488623.0,1818402.0],[5484777.0,1814967.0],[5504757.0,1818688.0],[5515614.0,1803800.0],[5518880.0,1803024.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":345,"LEVL_CODE":0,"NUTS_BN_ID":345,"OTHR_CNTR_":"F","Shape_Leng":120581.5618855941},"geometry":{"type":"MultiLineString","coordinates":[[[5724013.0,1827643.0],[5708173.0,1829421.0],[5700657.0,1865835.0],[5727114.0,1868405.0],[5724013.0,1827643.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":367,"LEVL_CODE":0,"NUTS_BN_ID":367,"OTHR_CNTR_":"F","Shape_Leng":102603.2932216669},"geometry":{"type":"MultiLineString","coordinates":[[[2694653.0,1915761.0],[2650765.0,1915305.0],[2653807.0,1942980.0],[2684526.0,1946040.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":378,"LEVL_CODE":0,"NUTS_BN_ID":378,"OTHR_CNTR_":"F","Shape_Leng":54054.944736042999},"geometry":{"type":"MultiLineString","coordinates":[[[4840159.0,1733790.0],[4832799.0,1750051.0],[4863490.0,1769259.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":381,"LEVL_CODE":0,"NUTS_BN_ID":381,"OTHR_CNTR_":"F","Shape_Leng":8628.0309782950008},"geometry":{"type":"MultiLineString","coordinates":[[[2684526.0,1946040.0],[2682552.0,1954439.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":382,"LEVL_CODE":0,"NUTS_BN_ID":382,"OTHR_CNTR_":"F","Shape_Leng":75160.945003185203},"geometry":{"type":"MultiLineString","coordinates":[[[5257332.0,1792728.0],[5243244.0,1785353.0],[5244629.0,1808040.0],[5251758.0,1817100.0],[5257332.0,1792728.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":383,"LEVL_CODE":0,"NUTS_BN_ID":383,"OTHR_CNTR_":"F","Shape_Leng":154916.29865635419},"geometry":{"type":"MultiLineString","coordinates":[[[3451494.0,1810154.0],[3466467.0,1793428.0],[3419186.0,1771854.0],[3370291.0,1707909.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":387,"LEVL_CODE":0,"NUTS_BN_ID":387,"OTHR_CNTR_":"F","Shape_Leng":66196.419130879294},"geometry":{"type":"MultiLineString","coordinates":[[[4921369.0,1787170.0],[4894632.0,1766895.0],[4898486.0,1734482.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":392,"LEVL_CODE":0,"NUTS_BN_ID":392,"OTHR_CNTR_":"F","Shape_Leng":128213.0532661082},"geometry":{"type":"MultiLineString","coordinates":[[[5449473.0,1865039.0],[5409747.0,1842189.0],[5488623.0,1818402.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":400,"LEVL_CODE":0,"NUTS_BN_ID":400,"OTHR_CNTR_":"F","Shape_Leng":416067.43868160929},"geometry":{"type":"MultiLineString","coordinates":[[[5486147.0,1860620.0],[5553303.0,1844327.0],[5569127.0,1799674.0],[5601989.0,1783111.0],[5577127.0,1783445.0],[5548826.0,1814703.0],[5514239.0,1808738.0],[5499105.0,1827153.0],[5467674.0,1849365.0],[5436266.0,1842902.0],[5474540.0,1873451.0],[5486147.0,1860620.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":405,"LEVL_CODE":0,"NUTS_BN_ID":405,"OTHR_CNTR_":"F","Shape_Leng":28252.430024966699},"geometry":{"type":"MultiLineString","coordinates":[[[4863490.0,1769259.0],[4851084.0,1794642.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":406,"LEVL_CODE":0,"NUTS_BN_ID":406,"OTHR_CNTR_":"F","Shape_Leng":85457.607911045197},"geometry":{"type":"MultiLineString","coordinates":[[[2682552.0,1954439.0],[2636468.0,1951999.0],[2650545.0,1988702.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":409,"LEVL_CODE":0,"NUTS_BN_ID":409,"OTHR_CNTR_":"F","Shape_Leng":96744.067398519706},"geometry":{"type":"MultiLineString","coordinates":[[[3574122.0,1799637.0],[3568753.0,1791945.0],[3555858.0,1801318.0],[3565914.0,1815897.0],[3591815.0,1818320.0],[3591306.0,1811555.0],[3574122.0,1799637.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":440,"LEVL_CODE":0,"NUTS_BN_ID":440,"OTHR_CNTR_":"F","Shape_Leng":68371.316171643804},"geometry":{"type":"MultiLineString","coordinates":[[[5284757.0,1843548.0],[5253296.0,1835959.0],[5227287.0,1860860.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":450,"LEVL_CODE":0,"NUTS_BN_ID":450,"OTHR_CNTR_":"F","Shape_Leng":162975.74038713169},"geometry":{"type":"MultiLineString","coordinates":[[[5732994.0,1958117.0],[5755625.0,1926457.0],[5685882.0,1931443.0],[5732994.0,1958117.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":470,"LEVL_CODE":0,"NUTS_BN_ID":470,"OTHR_CNTR_":"F","Shape_Leng":61163.0260838697},"geometry":{"type":"MultiLineString","coordinates":[[[4199980.0,1764520.0],[4179226.0,1793187.0],[4181882.0,1818822.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":481,"LEVL_CODE":0,"NUTS_BN_ID":481,"OTHR_CNTR_":"F","Shape_Leng":80996.599627228497},"geometry":{"type":"MultiLineString","coordinates":[[[4927897.0,1849465.0],[4946382.0,1799834.0],[4921369.0,1787170.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":490,"LEVL_CODE":0,"NUTS_BN_ID":490,"OTHR_CNTR_":"F","Shape_Leng":152720.98355199129},"geometry":{"type":"MultiLineString","coordinates":[[[4290842.0,1828772.0],[4282365.0,1782971.0],[4243674.0,1792144.0],[4221423.0,1755303.0],[4199980.0,1764520.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":491,"LEVL_CODE":0,"NUTS_BN_ID":491,"OTHR_CNTR_":"F","Shape_Leng":178546.04822867311},"geometry":{"type":"MultiLineString","coordinates":[[[5430523.0,1929121.0],[5436513.0,1924811.0],[5474805.0,1890258.0],[5452840.0,1874822.0],[5463634.0,1883691.0],[5457262.0,1896720.0],[5427965.0,1892173.0],[5449473.0,1865039.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":503,"LEVL_CODE":0,"NUTS_BN_ID":503,"OTHR_CNTR_":"F","Shape_Leng":64383.135315605199},"geometry":{"type":"MultiLineString","coordinates":[[[5227287.0,1860860.0],[5226145.0,1860508.0],[5211517.0,1863252.0],[5181493.0,1901093.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":504,"LEVL_CODE":0,"NUTS_BN_ID":504,"OTHR_CNTR_":"F","Shape_Leng":30881.378857404801},"geometry":{"type":"MultiLineString","coordinates":[[[4181882.0,1818822.0],[4191866.0,1848045.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":508,"LEVL_CODE":0,"NUTS_BN_ID":508,"OTHR_CNTR_":"F","Shape_Leng":104238.552701861},"geometry":{"type":"MultiLineString","coordinates":[[[3445578.0,1906511.0],[3429041.0,1875472.0],[3451494.0,1810154.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":510,"LEVL_CODE":0,"NUTS_BN_ID":510,"OTHR_CNTR_":"F","Shape_Leng":83960.707902127295},"geometry":{"type":"MultiLineString","coordinates":[[[2650545.0,1988702.0],[2662229.0,2019273.0],[2699298.0,2054639.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":516,"LEVL_CODE":0,"NUTS_BN_ID":516,"OTHR_CNTR_":"F","Shape_Leng":138945.81171122601},"geometry":{"type":"MultiLineString","coordinates":[[[5172205.0,1911091.0],[5167612.0,1895686.0],[5194529.0,1866002.0],[5149337.0,1903439.0],[5172205.0,1911091.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":531,"LEVL_CODE":0,"NUTS_BN_ID":531,"OTHR_CNTR_":"F","Shape_Leng":100714.0227198816},"geometry":{"type":"MultiLineString","coordinates":[[[4851084.0,1794642.0],[4815169.0,1888735.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":538,"LEVL_CODE":0,"NUTS_BN_ID":538,"OTHR_CNTR_":"F","Shape_Leng":275836.53207377199},"geometry":{"type":"MultiLineString","coordinates":[[[3726952.0,1894652.0],[3731372.0,1880083.0],[3748963.0,1880184.0],[3757035.0,1864824.0],[3720594.0,1825037.0],[3660880.0,1866120.0],[3700745.0,1892008.0],[3738845.0,1899549.0],[3726952.0,1894652.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":541,"LEVL_CODE":0,"NUTS_BN_ID":541,"OTHR_CNTR_":"F","Shape_Leng":46334.681672599902},"geometry":{"type":"MultiLineString","coordinates":[[[5402737.0,1966200.0],[5430523.0,1929121.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":549,"LEVL_CODE":0,"NUTS_BN_ID":549,"OTHR_CNTR_":"F","Shape_Leng":16214.878053546099},"geometry":{"type":"MultiLineString","coordinates":[[[4815169.0,1888735.0],[4804764.0,1901170.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":550,"LEVL_CODE":0,"NUTS_BN_ID":550,"OTHR_CNTR_":"F","Shape_Leng":35666.679577830102},"geometry":{"type":"MultiLineString","coordinates":[[[2699298.0,2054639.0],[2718974.0,2084387.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":552,"LEVL_CODE":0,"NUTS_BN_ID":552,"OTHR_CNTR_":"F","Shape_Leng":106318.093987726},"geometry":{"type":"MultiLineString","coordinates":[[[3815045.0,1904586.0],[3829736.0,1876460.0],[3788820.0,1902006.0],[3815045.0,1904586.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":560,"LEVL_CODE":0,"NUTS_BN_ID":560,"OTHR_CNTR_":"F","Shape_Leng":98243.301344616397},"geometry":{"type":"MultiLineString","coordinates":[[[4889506.0,1916502.0],[4883479.0,1866021.0],[4927897.0,1849465.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":571,"LEVL_CODE":0,"NUTS_BN_ID":571,"OTHR_CNTR_":"F","Shape_Leng":106075.2349924005},"geometry":{"type":"MultiLineString","coordinates":[[[5488665.0,1980951.0],[5495644.0,1975878.0],[5461630.0,1973985.0],[5455137.0,1998624.0],[5488665.0,1980951.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":577,"LEVL_CODE":0,"NUTS_BN_ID":577,"OTHR_CNTR_":"F","Shape_Leng":77502.706869503701},"geometry":{"type":"MultiLineString","coordinates":[[[4289051.0,1903388.0],[4298295.0,1886865.0],[4290842.0,1828772.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":596,"LEVL_CODE":0,"NUTS_BN_ID":596,"OTHR_CNTR_":"F","Shape_Leng":179441.73835935639},"geometry":{"type":"MultiLineString","coordinates":[[[5509726.0,2023366.0],[5496701.0,2027199.0],[5483928.0,2017388.0],[5512942.0,2000668.0],[5511856.0,1981358.0],[5481793.0,2008071.0],[5425226.0,2012134.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":601,"LEVL_CODE":0,"NUTS_BN_ID":601,"OTHR_CNTR_":"F","Shape_Leng":36348.828779498399},"geometry":{"type":"MultiLineString","coordinates":[[[4905973.0,1948907.0],[4889506.0,1916502.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":604,"LEVL_CODE":0,"NUTS_BN_ID":604,"OTHR_CNTR_":"F","Shape_Leng":77239.035432467805},"geometry":{"type":"MultiLineString","coordinates":[[[4191866.0,1848045.0],[4184513.0,1924933.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":613,"LEVL_CODE":0,"NUTS_BN_ID":613,"OTHR_CNTR_":"F","Shape_Leng":60783.4736792283},"geometry":{"type":"MultiLineString","coordinates":[[[5394172.0,2022670.0],[5390223.0,1983162.0],[5402737.0,1966200.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":619,"LEVL_CODE":0,"NUTS_BN_ID":619,"OTHR_CNTR_":"F","Shape_Leng":173290.56435657729},"geometry":{"type":"MultiLineString","coordinates":[[[5009077.0,1972177.0],[5048886.0,1934260.0],[5040090.0,1895306.0],[5011180.0,1907147.0],[4983094.0,1945003.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":620,"LEVL_CODE":0,"NUTS_BN_ID":620,"OTHR_CNTR_":"F","Shape_Leng":85250.651300446494},"geometry":{"type":"MultiLineString","coordinates":[[[4983094.0,1945003.0],[4926893.0,1964143.0],[4905973.0,1948907.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":621,"LEVL_CODE":0,"NUTS_BN_ID":621,"OTHR_CNTR_":"F","Shape_Leng":53305.225535390899},"geometry":{"type":"MultiLineString","coordinates":[[[2718974.0,2084387.0],[2740001.0,2133370.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":625,"LEVL_CODE":0,"NUTS_BN_ID":625,"OTHR_CNTR_":"F","Shape_Leng":106556.2709174109},"geometry":{"type":"MultiLineString","coordinates":[[[3515777.0,1986675.0],[3445578.0,1906511.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":630,"LEVL_CODE":0,"NUTS_BN_ID":630,"OTHR_CNTR_":"F","Shape_Leng":4450.2140454842001},"geometry":{"type":"MultiLineString","coordinates":[[[5395086.0,2027025.0],[5394172.0,2022670.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":644,"LEVL_CODE":0,"NUTS_BN_ID":644,"OTHR_CNTR_":"F","Shape_Leng":66621.207235657595},"geometry":{"type":"MultiLineString","coordinates":[[[5425226.0,2012134.0],[5406998.0,2023380.0],[5415617.0,2041512.0],[5395086.0,2027025.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":646,"LEVL_CODE":0,"NUTS_BN_ID":646,"OTHR_CNTR_":"F","Shape_Leng":34424.7557985885},"geometry":{"type":"MultiLineString","coordinates":[[[5483053.0,2054452.0],[5508827.0,2031632.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":653,"LEVL_CODE":0,"NUTS_BN_ID":653,"OTHR_CNTR_":"F","Shape_Leng":53740.788522970201},"geometry":{"type":"MultiLineString","coordinates":[[[4299664.0,1951472.0],[4306269.0,1935064.0],[4289051.0,1903388.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":659,"LEVL_CODE":0,"NUTS_BN_ID":659,"OTHR_CNTR_":"F","Shape_Leng":143185.31655495349},"geometry":{"type":"MultiLineString","coordinates":[[[4804764.0,1901170.0],[4780439.0,1894565.0],[4727396.0,1964907.0],[4723947.0,1965960.0],[4719559.0,1960859.0],[4705818.0,1957042.0],[4700659.0,1958181.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":679,"LEVL_CODE":0,"NUTS_BN_ID":679,"OTHR_CNTR_":"F","Shape_Leng":13690.2441007167},"geometry":{"type":"MultiLineString","coordinates":[[[5481467.0,2068050.0],[5483053.0,2054452.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":682,"LEVL_CODE":0,"NUTS_BN_ID":682,"OTHR_CNTR_":"F","Shape_Leng":9025.3161162649994},"geometry":{"type":"MultiLineString","coordinates":[[[5489626.0,2071908.0],[5481467.0,2068050.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":699,"LEVL_CODE":0,"NUTS_BN_ID":699,"OTHR_CNTR_":"F","Shape_Leng":36658.236280600198},"geometry":{"type":"MultiLineString","coordinates":[[[5670221.0,2102712.0],[5634310.0,2110076.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":703,"LEVL_CODE":0,"NUTS_BN_ID":703,"OTHR_CNTR_":"F","Shape_Leng":72843.040342218606},"geometry":{"type":"MultiLineString","coordinates":[[[4945372.0,2007501.0],[5009077.0,1972177.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":704,"LEVL_CODE":0,"NUTS_BN_ID":704,"OTHR_CNTR_":"F","Shape_Leng":76102.178824420305},"geometry":{"type":"MultiLineString","coordinates":[[[4700659.0,1958181.0],[4688740.0,1951829.0],[4699251.0,1971689.0],[4662108.0,1986871.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":710,"LEVL_CODE":0,"NUTS_BN_ID":710,"OTHR_CNTR_":"F","Shape_Leng":127227.07292390931},"geometry":{"type":"MultiLineString","coordinates":[[[4184513.0,1924933.0],[4162753.0,1961777.0],[4168982.0,1987749.0],[4186904.0,1972502.0],[4219713.0,1982155.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":716,"LEVL_CODE":0,"NUTS_BN_ID":716,"OTHR_CNTR_":"F","Shape_Leng":92000.291241777304},"geometry":{"type":"MultiLineString","coordinates":[[[5566631.0,2095682.0],[5539411.0,2101660.0],[5509073.0,2069123.0],[5489626.0,2071908.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":718,"LEVL_CODE":0,"NUTS_BN_ID":718,"OTHR_CNTR_":"F","Shape_Leng":50312.2726584462},"geometry":{"type":"MultiLineString","coordinates":[[[2740001.0,2133370.0],[2761837.0,2178697.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":723,"LEVL_CODE":0,"NUTS_BN_ID":723,"OTHR_CNTR_":"F","Shape_Leng":31411.881377290101},"geometry":{"type":"MultiLineString","coordinates":[[[5590945.0,2115570.0],[5566631.0,2095682.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":724,"LEVL_CODE":0,"NUTS_BN_ID":724,"OTHR_CNTR_":"F","Shape_Leng":43712.432540985901},"geometry":{"type":"MultiLineString","coordinates":[[[5634310.0,2110076.0],[5590945.0,2115570.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":775,"LEVL_CODE":0,"NUTS_BN_ID":775,"OTHR_CNTR_":"F","Shape_Leng":131613.0116581381},"geometry":{"type":"MultiLineString","coordinates":[[[4219713.0,1982155.0],[4250591.0,2015422.0],[4272417.0,2008706.0],[4299664.0,1951472.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":780,"LEVL_CODE":0,"NUTS_BN_ID":780,"OTHR_CNTR_":"F","Shape_Leng":127412.0849119366},"geometry":{"type":"MultiLineString","coordinates":[[[3618795.0,2049424.0],[3560003.0,2037589.0],[3515777.0,1986675.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":785,"LEVL_CODE":0,"NUTS_BN_ID":785,"OTHR_CNTR_":"F","Shape_Leng":42480.167354753903},"geometry":{"type":"MultiLineString","coordinates":[[[4662108.0,1986871.0],[4637532.0,2021521.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":787,"LEVL_CODE":0,"NUTS_BN_ID":787,"OTHR_CNTR_":"F","Shape_Leng":80375.991658130093},"geometry":{"type":"MultiLineString","coordinates":[[[4871067.0,2038145.0],[4945372.0,2007501.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":826,"LEVL_CODE":0,"NUTS_BN_ID":826,"OTHR_CNTR_":"F","Shape_Leng":91078.8310082237},"geometry":{"type":"MultiLineString","coordinates":[[[4637532.0,2021521.0],[4579266.0,2018759.0],[4553746.0,2039279.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":828,"LEVL_CODE":0,"NUTS_BN_ID":828,"OTHR_CNTR_":"F","Shape_Leng":48481.8282038748},"geometry":{"type":"MultiLineString","coordinates":[[[4826062.0,2056175.0],[4871067.0,2038145.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":836,"LEVL_CODE":0,"NUTS_BN_ID":836,"OTHR_CNTR_":"F","Shape_Leng":57473.110220650196},"geometry":{"type":"MultiLineString","coordinates":[[[2761837.0,2178697.0],[2764566.0,2236105.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":866,"LEVL_CODE":0,"NUTS_BN_ID":866,"OTHR_CNTR_":"F","Shape_Leng":15840.0545796678},"geometry":{"type":"MultiLineString","coordinates":[[[2764566.0,2236105.0],[2765264.0,2251930.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2641,"LEVL_CODE":0,"NUTS_BN_ID":2641,"OTHR_CNTR_":"F","Shape_Leng":103032.71510654211},"geometry":{"type":"MultiLineString","coordinates":[[[3516529.0,2976840.0],[3619366.0,2970503.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2652,"LEVL_CODE":0,"NUTS_BN_ID":2652,"OTHR_CNTR_":"F","Shape_Leng":3263.5281030623},"geometry":{"type":"MultiLineString","coordinates":[[[3619366.0,2970503.0],[3622524.0,2971326.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2743,"LEVL_CODE":0,"NUTS_BN_ID":2743,"OTHR_CNTR_":"F","Shape_Leng":231445.34738372281},"geometry":{"type":"MultiLineString","coordinates":[[[3471714.0,2901637.0],[3485111.0,2901581.0],[3464157.0,3026928.0],[3511689.0,3015906.0],[3506230.0,2999858.0],[3516529.0,2976840.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2851,"LEVL_CODE":0,"NUTS_BN_ID":2851,"OTHR_CNTR_":"F","Shape_Leng":138866.8227858663},"geometry":{"type":"MultiLineString","coordinates":[[[3622524.0,2971326.0],[3603954.0,2981871.0],[3615872.0,3002099.0],[3705364.0,3030969.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2955,"LEVL_CODE":0,"NUTS_BN_ID":2955,"OTHR_CNTR_":"F","Shape_Leng":36999.706871649701},"geometry":{"type":"MultiLineString","coordinates":[[[3705364.0,3030969.0],[3727565.0,3060568.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2964,"LEVL_CODE":0,"NUTS_BN_ID":2964,"OTHR_CNTR_":"F","Shape_Leng":4320.4814221552997},"geometry":{"type":"MultiLineString","coordinates":[[[3322825.0,3122713.0],[3319402.0,3125349.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":2966,"LEVL_CODE":0,"NUTS_BN_ID":2966,"OTHR_CNTR_":"F","Shape_Leng":57760.794152855597},"geometry":{"type":"MultiLineString","coordinates":[[[3366408.0,3118023.0],[3347686.0,3101417.0],[3322825.0,3122713.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3026,"LEVL_CODE":0,"NUTS_BN_ID":3026,"OTHR_CNTR_":"F","Shape_Leng":15336.5037044127},"geometry":{"type":"MultiLineString","coordinates":[[[3369080.0,3133125.0],[3366408.0,3118023.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3085,"LEVL_CODE":0,"NUTS_BN_ID":3085,"OTHR_CNTR_":"F","Shape_Leng":45521.7816007855},"geometry":{"type":"MultiLineString","coordinates":[[[3412062.0,3148119.0],[3369080.0,3133125.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3088,"LEVL_CODE":0,"NUTS_BN_ID":3088,"OTHR_CNTR_":"F","Shape_Leng":86860.899629061605},"geometry":{"type":"MultiLineString","coordinates":[[[3475087.0,3137403.0],[3478878.0,3122557.0],[3412062.0,3148119.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3089,"LEVL_CODE":0,"NUTS_BN_ID":3089,"OTHR_CNTR_":"F","Shape_Leng":21135.780551139898},"geometry":{"type":"MultiLineString","coordinates":[[[3495971.0,3134148.0],[3475087.0,3137403.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3100,"LEVL_CODE":0,"NUTS_BN_ID":3100,"OTHR_CNTR_":"F","Shape_Leng":3817.6100820699999},"geometry":{"type":"MultiLineString","coordinates":[[[3499623.0,3135260.0],[3495971.0,3134148.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3118,"LEVL_CODE":0,"NUTS_BN_ID":3118,"OTHR_CNTR_":"F","Shape_Leng":83612.536730304899},"geometry":{"type":"MultiLineString","coordinates":[[[3542050.0,3122613.0],[3523918.0,3113281.0],[3505694.0,3125991.0],[3527816.0,3133195.0],[3542050.0,3122613.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3153,"LEVL_CODE":0,"NUTS_BN_ID":3153,"OTHR_CNTR_":"F","Shape_Leng":12904.0662240235},"geometry":{"type":"MultiLineString","coordinates":[[[3615846.0,3124915.0],[3603879.0,3129742.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3160,"LEVL_CODE":0,"NUTS_BN_ID":3160,"OTHR_CNTR_":"F","Shape_Leng":6710.0397356100002},"geometry":{"type":"MultiLineString","coordinates":[[[3547930.0,3138859.0],[3541453.0,3140613.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3161,"LEVL_CODE":0,"NUTS_BN_ID":3161,"OTHR_CNTR_":"F","Shape_Leng":6308.3050237748002},"geometry":{"type":"MultiLineString","coordinates":[[[3554237.0,3138740.0],[3547930.0,3138859.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3162,"LEVL_CODE":0,"NUTS_BN_ID":3162,"OTHR_CNTR_":"F","Shape_Leng":50450.950152462101},"geometry":{"type":"MultiLineString","coordinates":[[[3603879.0,3129742.0],[3554237.0,3138740.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3180,"LEVL_CODE":0,"NUTS_BN_ID":3180,"OTHR_CNTR_":"F","Shape_Leng":17971.844369909799},"geometry":{"type":"MultiLineString","coordinates":[[[3541453.0,3140613.0],[3524825.0,3147432.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3199,"LEVL_CODE":0,"NUTS_BN_ID":3199,"OTHR_CNTR_":"F","Shape_Leng":64279.951086632696},"geometry":{"type":"MultiLineString","coordinates":[[[3679891.0,3130408.0],[3615846.0,3124915.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3200,"LEVL_CODE":0,"NUTS_BN_ID":3200,"OTHR_CNTR_":"F","Shape_Leng":45320.421728003399},"geometry":{"type":"MultiLineString","coordinates":[[[3517821.0,3153490.0],[3527846.0,3140166.0],[3499623.0,3135260.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3201,"LEVL_CODE":0,"NUTS_BN_ID":3201,"OTHR_CNTR_":"F","Shape_Leng":9260.3591823307997},"geometry":{"type":"MultiLineString","coordinates":[[[3524825.0,3147432.0],[3517821.0,3153490.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3203,"LEVL_CODE":0,"NUTS_BN_ID":3203,"OTHR_CNTR_":"F","Shape_Leng":231060.27952946251},"geometry":{"type":"MultiLineString","coordinates":[[[3319402.0,3125349.0],[3277823.0,3129409.0],[3240281.0,3095850.0],[3223418.0,3118025.0],[3306084.0,3192206.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3241,"LEVL_CODE":0,"NUTS_BN_ID":3241,"OTHR_CNTR_":"F","Shape_Leng":95192.620518572206},"geometry":{"type":"MultiLineString","coordinates":[[[3727565.0,3060568.0],[3729839.0,3118298.0],[3765498.0,3129635.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3300,"LEVL_CODE":0,"NUTS_BN_ID":3300,"OTHR_CNTR_":"F","Shape_Leng":34754.665289463701},"geometry":{"type":"MultiLineString","coordinates":[[[3765498.0,3129635.0],[3799789.0,3135289.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3342,"LEVL_CODE":0,"NUTS_BN_ID":3342,"OTHR_CNTR_":"F","Shape_Leng":16326.6959199875},"geometry":{"type":"MultiLineString","coordinates":[[[3799789.0,3135289.0],[3814726.0,3141880.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3376,"LEVL_CODE":0,"NUTS_BN_ID":3376,"OTHR_CNTR_":"F","Shape_Leng":80910.523975113203},"geometry":{"type":"MultiLineString","coordinates":[[[3306084.0,3192206.0],[3337179.0,3202934.0],[3335698.0,3217295.0],[3369157.0,3214448.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3398,"LEVL_CODE":0,"NUTS_BN_ID":3398,"OTHR_CNTR_":"F","Shape_Leng":30286.631565073199},"geometry":{"type":"MultiLineString","coordinates":[[[3814726.0,3141880.0],[3841459.0,3156116.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3402,"LEVL_CODE":0,"NUTS_BN_ID":3402,"OTHR_CNTR_":"F","Shape_Leng":51570.357007334504},"geometry":{"type":"MultiLineString","coordinates":[[[3369157.0,3214448.0],[3420727.0,3214769.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3439,"LEVL_CODE":0,"NUTS_BN_ID":3439,"OTHR_CNTR_":"F","Shape_Leng":811.01769680489997},"geometry":{"type":"MultiLineString","coordinates":[[[3919814.0,3153328.0],[3920366.0,3153923.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3447,"LEVL_CODE":0,"NUTS_BN_ID":3447,"OTHR_CNTR_":"F","Shape_Leng":18913.735648433401},"geometry":{"type":"MultiLineString","coordinates":[[[3841459.0,3156116.0],[3859819.0,3160657.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3449,"LEVL_CODE":0,"NUTS_BN_ID":3449,"OTHR_CNTR_":"F","Shape_Leng":60441.040253422303},"geometry":{"type":"MultiLineString","coordinates":[[[3859819.0,3160657.0],[3919814.0,3153328.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3451,"LEVL_CODE":0,"NUTS_BN_ID":3451,"OTHR_CNTR_":"F","Shape_Leng":25608.7237453323},"geometry":{"type":"MultiLineString","coordinates":[[[3670416.0,3182316.0],[3692754.0,3179258.0],[3692324.0,3176225.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3452,"LEVL_CODE":0,"NUTS_BN_ID":3452,"OTHR_CNTR_":"F","Shape_Leng":2313.7528737535999},"geometry":{"type":"MultiLineString","coordinates":[[[3920366.0,3153923.0],[3920660.0,3156218.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3460,"LEVL_CODE":0,"NUTS_BN_ID":3460,"OTHR_CNTR_":"F","Shape_Leng":105623.60256061731},"geometry":{"type":"MultiLineString","coordinates":[[[3692324.0,3176225.0],[3727239.0,3175517.0],[3719328.0,3150096.0],[3679891.0,3130408.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3502,"LEVL_CODE":0,"NUTS_BN_ID":3502,"OTHR_CNTR_":"F","Shape_Leng":3964.1148566626998},"geometry":{"type":"MultiLineString","coordinates":[[[3656085.0,3193339.0],[3659986.0,3192634.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3505,"LEVL_CODE":0,"NUTS_BN_ID":3505,"OTHR_CNTR_":"F","Shape_Leng":39094.922779217697},"geometry":{"type":"MultiLineString","coordinates":[[[3659986.0,3192634.0],[3678058.0,3190825.0],[3664829.0,3186615.0],[3670416.0,3182316.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3517,"LEVL_CODE":0,"NUTS_BN_ID":3517,"OTHR_CNTR_":"F","Shape_Leng":28110.842702673501},"geometry":{"type":"MultiLineString","coordinates":[[[3420727.0,3214769.0],[3445251.0,3228508.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3538,"LEVL_CODE":0,"NUTS_BN_ID":3538,"OTHR_CNTR_":"F","Shape_Leng":38626.458684793601},"geometry":{"type":"MultiLineString","coordinates":[[[3418182.0,3235811.0],[3379716.0,3239322.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3566,"LEVL_CODE":0,"NUTS_BN_ID":3566,"OTHR_CNTR_":"F","Shape_Leng":11361.5409441753},"geometry":{"type":"MultiLineString","coordinates":[[[3664856.0,3200561.0],[3656085.0,3193339.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3570,"LEVL_CODE":0,"NUTS_BN_ID":3570,"OTHR_CNTR_":"F","Shape_Leng":7838.0863784356998},"geometry":{"type":"MultiLineString","coordinates":[[[3672642.0,3199659.0],[3664856.0,3200561.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3583,"LEVL_CODE":0,"NUTS_BN_ID":3583,"OTHR_CNTR_":"F","Shape_Leng":13508.5043070151},"geometry":{"type":"MultiLineString","coordinates":[[[3686128.0,3198892.0],[3672642.0,3199659.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3587,"LEVL_CODE":0,"NUTS_BN_ID":3587,"OTHR_CNTR_":"F","Shape_Leng":7153.7384640226001},"geometry":{"type":"MultiLineString","coordinates":[[[3445251.0,3228508.0],[3446864.0,3235478.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3639,"LEVL_CODE":0,"NUTS_BN_ID":3639,"OTHR_CNTR_":"F","Shape_Leng":23811.137481935901},"geometry":{"type":"MultiLineString","coordinates":[[[3379716.0,3239322.0],[3365916.0,3258726.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3641,"LEVL_CODE":0,"NUTS_BN_ID":3641,"OTHR_CNTR_":"F","Shape_Leng":27749.639023534099},"geometry":{"type":"MultiLineString","coordinates":[[[3683564.0,3210001.0],[3689233.0,3205335.0],[3696628.0,3206438.0],[3686128.0,3198892.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3646,"LEVL_CODE":0,"NUTS_BN_ID":3646,"OTHR_CNTR_":"F","Shape_Leng":32375.4905458625},"geometry":{"type":"MultiLineString","coordinates":[[[3449376.0,3244478.0],[3418182.0,3235811.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3678,"LEVL_CODE":0,"NUTS_BN_ID":3678,"OTHR_CNTR_":"F","Shape_Leng":140140.28265757661},"geometry":{"type":"MultiLineString","coordinates":[[[3920660.0,3156218.0],[3866038.0,3177758.0],[3919827.0,3163422.0],[3917577.0,3189081.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3684,"LEVL_CODE":0,"NUTS_BN_ID":3684,"OTHR_CNTR_":"F","Shape_Leng":80227.655258876301},"geometry":{"type":"MultiLineString","coordinates":[[[3917577.0,3189081.0],[3915786.0,3189948.0],[3884560.0,3195023.0],[3896191.0,3201061.0],[3918217.0,3226298.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3687,"LEVL_CODE":0,"NUTS_BN_ID":3687,"OTHR_CNTR_":"F","Shape_Leng":10299.810763486001},"geometry":{"type":"MultiLineString","coordinates":[[[3458889.0,3248426.0],[3449376.0,3244478.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3688,"LEVL_CODE":0,"NUTS_BN_ID":3688,"OTHR_CNTR_":"F","Shape_Leng":17670.618883870498},"geometry":{"type":"MultiLineString","coordinates":[[[3446864.0,3235478.0],[3458889.0,3248426.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3697,"LEVL_CODE":0,"NUTS_BN_ID":3697,"OTHR_CNTR_":"F","Shape_Leng":49555.374183054199},"geometry":{"type":"MultiLineString","coordinates":[[[3365916.0,3258726.0],[3337194.0,3263566.0],[3356471.0,3270329.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3706,"LEVL_CODE":0,"NUTS_BN_ID":3706,"OTHR_CNTR_":"F","Shape_Leng":44588.825184092399},"geometry":{"type":"MultiLineString","coordinates":[[[3691086.0,3225280.0],[3681155.0,3219108.0],[3683786.0,3216149.0],[3697114.0,3217213.0],[3684388.0,3209815.0],[3683564.0,3210001.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3791,"LEVL_CODE":0,"NUTS_BN_ID":3791,"OTHR_CNTR_":"F","Shape_Leng":50900.364707312103},"geometry":{"type":"MultiLineString","coordinates":[[[3707889.0,3242285.0],[3722875.0,3231387.0],[3691086.0,3225280.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3794,"LEVL_CODE":0,"NUTS_BN_ID":3794,"OTHR_CNTR_":"F","Shape_Leng":462556.33160740079},"geometry":{"type":"MultiLineString","coordinates":[[[3108541.0,3354477.0],[3052854.0,3328352.0],[2962624.0,3334896.0],[2996086.0,3357431.0],[2945694.0,3356901.0],[2940603.0,3393424.0],[2945528.0,3393782.0],[2944788.0,3394511.0],[2985661.0,3410520.0],[2941977.0,3425972.0],[3025955.0,3447672.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3835,"LEVL_CODE":0,"NUTS_BN_ID":3835,"OTHR_CNTR_":"F","Shape_Leng":7669.6371082596997},"geometry":{"type":"MultiLineString","coordinates":[[[3918217.0,3226298.0],[3923498.0,3231860.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3886,"LEVL_CODE":0,"NUTS_BN_ID":3886,"OTHR_CNTR_":"F","Shape_Leng":19094.829170253499},"geometry":{"type":"MultiLineString","coordinates":[[[3923498.0,3231860.0],[3936687.0,3245669.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3933,"LEVL_CODE":0,"NUTS_BN_ID":3933,"OTHR_CNTR_":"F","Shape_Leng":17710.8208529228},"geometry":{"type":"MultiLineString","coordinates":[[[3936687.0,3245669.0],[3946031.0,3260714.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":3977,"LEVL_CODE":0,"NUTS_BN_ID":3977,"OTHR_CNTR_":"F","Shape_Leng":12975.1230108317},"geometry":{"type":"MultiLineString","coordinates":[[[3946031.0,3260714.0],[3951477.0,3272491.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4001,"LEVL_CODE":0,"NUTS_BN_ID":4001,"OTHR_CNTR_":"F","Shape_Leng":89427.773793074404},"geometry":{"type":"MultiLineString","coordinates":[[[3761888.0,3300996.0],[3762195.0,3294192.0],[3731236.0,3243699.0],[3707889.0,3242285.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4039,"LEVL_CODE":0,"NUTS_BN_ID":4039,"OTHR_CNTR_":"F","Shape_Leng":227173.00185910679},"geometry":{"type":"MultiLineString","coordinates":[[[3356471.0,3270329.0],[3294824.0,3270866.0],[3274567.0,3305172.0],[3358112.0,3333759.0],[3382754.0,3361871.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4048,"LEVL_CODE":0,"NUTS_BN_ID":4048,"OTHR_CNTR_":"F","Shape_Leng":15500.415150478801},"geometry":{"type":"MultiLineString","coordinates":[[[3951477.0,3272491.0],[3955930.0,3287338.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4092,"LEVL_CODE":0,"NUTS_BN_ID":4092,"OTHR_CNTR_":"F","Shape_Leng":168700.29587540799},"geometry":{"type":"MultiLineString","coordinates":[[[3240880.0,3412798.0],[3212644.0,3354699.0],[3108541.0,3354477.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4097,"LEVL_CODE":0,"NUTS_BN_ID":4097,"OTHR_CNTR_":"F","Shape_Leng":23864.7431985765},"geometry":{"type":"MultiLineString","coordinates":[[[3760200.0,3324801.0],[3761888.0,3300996.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4100,"LEVL_CODE":0,"NUTS_BN_ID":4100,"OTHR_CNTR_":"F","Shape_Leng":20522.204354602902},"geometry":{"type":"MultiLineString","coordinates":[[[3955930.0,3287338.0],[3960097.0,3307432.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4159,"LEVL_CODE":0,"NUTS_BN_ID":4159,"OTHR_CNTR_":"F","Shape_Leng":106334.591405281},"geometry":{"type":"MultiLineString","coordinates":[[[3666865.0,3344046.0],[3698115.0,3359872.0],[3760200.0,3324801.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4168,"LEVL_CODE":0,"NUTS_BN_ID":4168,"OTHR_CNTR_":"F","Shape_Leng":53010.3832623587},"geometry":{"type":"MultiLineString","coordinates":[[[3960097.0,3307432.0],[3967285.0,3329902.0],[3996616.0,3332178.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4206,"LEVL_CODE":0,"NUTS_BN_ID":4206,"OTHR_CNTR_":"F","Shape_Leng":176492.12995168331},"geometry":{"type":"MultiLineString","coordinates":[[[3025955.0,3447672.0],[3069681.0,3446415.0],[3070062.0,3446331.0],[3069681.0,3446415.0],[3016249.0,3458346.0],[3048255.0,3507979.0],[3065671.0,3502790.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4210,"LEVL_CODE":0,"NUTS_BN_ID":4210,"OTHR_CNTR_":"F","Shape_Leng":23572.8515980099},"geometry":{"type":"MultiLineString","coordinates":[[[3996616.0,3332178.0],[4014218.0,3347858.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4228,"LEVL_CODE":0,"NUTS_BN_ID":4228,"OTHR_CNTR_":"F","Shape_Leng":157485.007103624},"geometry":{"type":"MultiLineString","coordinates":[[[3382754.0,3361871.0],[3370915.0,3370923.0],[3382199.0,3403726.0],[3332749.0,3399393.0],[3377916.0,3436181.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4229,"LEVL_CODE":0,"NUTS_BN_ID":4229,"OTHR_CNTR_":"F","Shape_Leng":52918.087313464501},"geometry":{"type":"MultiLineString","coordinates":[[[3255317.0,3463709.0],[3240880.0,3412798.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4243,"LEVL_CODE":0,"NUTS_BN_ID":4243,"OTHR_CNTR_":"F","Shape_Leng":13244.886051056101},"geometry":{"type":"MultiLineString","coordinates":[[[3379448.0,3437276.0],[3392607.0,3438782.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4247,"LEVL_CODE":0,"NUTS_BN_ID":4247,"OTHR_CNTR_":"F","Shape_Leng":7910.7061257936002},"geometry":{"type":"MultiLineString","coordinates":[[[4127018.0,3353761.0],[4134708.0,3351905.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4255,"LEVL_CODE":0,"NUTS_BN_ID":4255,"OTHR_CNTR_":"F","Shape_Leng":4817.4104626997996},"geometry":{"type":"MultiLineString","coordinates":[[[3453179.0,3428337.0],[3452256.0,3433066.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4262,"LEVL_CODE":0,"NUTS_BN_ID":4262,"OTHR_CNTR_":"F","Shape_Leng":93065.164834807103},"geometry":{"type":"MultiLineString","coordinates":[[[3377916.0,3436181.0],[3348991.0,3454377.0],[3391844.0,3446181.0],[3379448.0,3437276.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4265,"LEVL_CODE":0,"NUTS_BN_ID":4265,"OTHR_CNTR_":"F","Shape_Leng":11735.9499167011},"geometry":{"type":"MultiLineString","coordinates":[[[3464414.0,3432207.0],[3476071.0,3430849.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4271,"LEVL_CODE":0,"NUTS_BN_ID":4271,"OTHR_CNTR_":"F","Shape_Leng":9893.8877560649998},"geometry":{"type":"MultiLineString","coordinates":[[[4134708.0,3351905.0],[4138750.0,3360935.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4280,"LEVL_CODE":0,"NUTS_BN_ID":4280,"OTHR_CNTR_":"F","Shape_Leng":44408.059092687603},"geometry":{"type":"MultiLineString","coordinates":[[[3392607.0,3438782.0],[3436880.0,3442236.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4282,"LEVL_CODE":0,"NUTS_BN_ID":4282,"OTHR_CNTR_":"F","Shape_Leng":21419.683991714399},"geometry":{"type":"MultiLineString","coordinates":[[[3436880.0,3442236.0],[3453179.0,3428337.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4285,"LEVL_CODE":0,"NUTS_BN_ID":4285,"OTHR_CNTR_":"F","Shape_Leng":8245.4449883001998},"geometry":{"type":"MultiLineString","coordinates":[[[3476071.0,3430849.0],[3481906.0,3434313.0],[3480861.0,3435331.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4288,"LEVL_CODE":0,"NUTS_BN_ID":4288,"OTHR_CNTR_":"F","Shape_Leng":18048.075033292698},"geometry":{"type":"MultiLineString","coordinates":[[[4138750.0,3360935.0],[4121277.0,3365454.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4290,"LEVL_CODE":0,"NUTS_BN_ID":4290,"OTHR_CNTR_":"F","Shape_Leng":9479.0583317029996},"geometry":{"type":"MultiLineString","coordinates":[[[3480861.0,3435331.0],[3471546.0,3433575.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4305,"LEVL_CODE":0,"NUTS_BN_ID":4305,"OTHR_CNTR_":"F","Shape_Leng":31883.670838810998},"geometry":{"type":"MultiLineString","coordinates":[[[3452256.0,3433066.0],[3448250.0,3444150.0],[3464414.0,3432207.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4308,"LEVL_CODE":0,"NUTS_BN_ID":4308,"OTHR_CNTR_":"F","Shape_Leng":22197.753007484302},"geometry":{"type":"MultiLineString","coordinates":[[[4113226.0,3371155.0],[4127018.0,3353761.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4310,"LEVL_CODE":0,"NUTS_BN_ID":4310,"OTHR_CNTR_":"F","Shape_Leng":59501.512670542797},"geometry":{"type":"MultiLineString","coordinates":[[[4014218.0,3347858.0],[4067838.0,3373652.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4314,"LEVL_CODE":0,"NUTS_BN_ID":4314,"OTHR_CNTR_":"F","Shape_Leng":16956.781162092298},"geometry":{"type":"MultiLineString","coordinates":[[[3471546.0,3433575.0],[3461783.0,3447440.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4316,"LEVL_CODE":0,"NUTS_BN_ID":4316,"OTHR_CNTR_":"F","Shape_Leng":49738.309029544798},"geometry":{"type":"MultiLineString","coordinates":[[[4067838.0,3373652.0],[4113894.0,3374763.0],[4113226.0,3371155.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4341,"LEVL_CODE":0,"NUTS_BN_ID":4341,"OTHR_CNTR_":"F","Shape_Leng":13980.919429508},"geometry":{"type":"MultiLineString","coordinates":[[[4192373.0,3379298.0],[4201005.0,3368300.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4356,"LEVL_CODE":0,"NUTS_BN_ID":4356,"OTHR_CNTR_":"F","Shape_Leng":99965.790776882001},"geometry":{"type":"MultiLineString","coordinates":[[[3661305.0,3425261.0],[3678534.0,3385422.0],[3653474.0,3356422.0],[3666865.0,3344046.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4375,"LEVL_CODE":0,"NUTS_BN_ID":4375,"OTHR_CNTR_":"F","Shape_Leng":12182.5822460933},"geometry":{"type":"MultiLineString","coordinates":[[[4225157.0,3380667.0],[4220581.0,3389150.0],[4223057.0,3389734.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4381,"LEVL_CODE":0,"NUTS_BN_ID":4381,"OTHR_CNTR_":"F","Shape_Leng":87918.796617968401},"geometry":{"type":"MultiLineString","coordinates":[[[3617034.0,3449572.0],[3614217.0,3441773.0],[3612098.0,3437522.0],[3611691.0,3432250.0],[3614353.0,3441692.0],[3643784.0,3448951.0],[3661305.0,3425261.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4383,"LEVL_CODE":0,"NUTS_BN_ID":4383,"OTHR_CNTR_":"F","Shape_Leng":42381.133864722004},"geometry":{"type":"MultiLineString","coordinates":[[[4201005.0,3368300.0],[4210445.0,3390878.0],[4225157.0,3380667.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4391,"LEVL_CODE":0,"NUTS_BN_ID":4391,"OTHR_CNTR_":"F","Shape_Leng":47787.496740062401},"geometry":{"type":"MultiLineString","coordinates":[[[3258609.0,3511383.0],[3255317.0,3463709.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4394,"LEVL_CODE":0,"NUTS_BN_ID":4394,"OTHR_CNTR_":"F","Shape_Leng":14841.140621860901},"geometry":{"type":"MultiLineString","coordinates":[[[4194752.0,3393947.0],[4192373.0,3379298.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4403,"LEVL_CODE":0,"NUTS_BN_ID":4403,"OTHR_CNTR_":"F","Shape_Leng":58185.120612047598},"geometry":{"type":"MultiLineString","coordinates":[[[4121277.0,3365454.0],[4138842.0,3399051.0],[4159115.0,3399130.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4413,"LEVL_CODE":0,"NUTS_BN_ID":4413,"OTHR_CNTR_":"F","Shape_Leng":33192.524433521503},"geometry":{"type":"MultiLineString","coordinates":[[[3461783.0,3447440.0],[3457769.0,3461005.0],[3470407.0,3475254.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4417,"LEVL_CODE":0,"NUTS_BN_ID":4417,"OTHR_CNTR_":"F","Shape_Leng":17539.689461091701},"geometry":{"type":"MultiLineString","coordinates":[[[4159115.0,3399130.0],[4176383.0,3402210.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4419,"LEVL_CODE":0,"NUTS_BN_ID":4419,"OTHR_CNTR_":"F","Shape_Leng":20142.3272168523},"geometry":{"type":"MultiLineString","coordinates":[[[4176383.0,3402210.0],[4194752.0,3393947.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4425,"LEVL_CODE":0,"NUTS_BN_ID":4425,"OTHR_CNTR_":"F","Shape_Leng":18826.4078787668},"geometry":{"type":"MultiLineString","coordinates":[[[3635824.0,3450748.0],[3617034.0,3449572.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4427,"LEVL_CODE":0,"NUTS_BN_ID":4427,"OTHR_CNTR_":"F","Shape_Leng":8525.1724441687002},"geometry":{"type":"MultiLineString","coordinates":[[[3470407.0,3475254.0],[3478837.0,3476521.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4428,"LEVL_CODE":0,"NUTS_BN_ID":4428,"OTHR_CNTR_":"F","Shape_Leng":10169.1049966828},"geometry":{"type":"MultiLineString","coordinates":[[[3258778.0,3521551.0],[3258609.0,3511383.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4434,"LEVL_CODE":0,"NUTS_BN_ID":4434,"OTHR_CNTR_":"F","Shape_Leng":11247.545104193499},"geometry":{"type":"MultiLineString","coordinates":[[[3647071.0,3450671.0],[3635824.0,3450748.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4444,"LEVL_CODE":0,"NUTS_BN_ID":4444,"OTHR_CNTR_":"F","Shape_Leng":15909.2416588783},"geometry":{"type":"MultiLineString","coordinates":[[[3478837.0,3476521.0],[3465447.0,3485111.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4467,"LEVL_CODE":0,"NUTS_BN_ID":4467,"OTHR_CNTR_":"F","Shape_Leng":70072.708664651698},"geometry":{"type":"MultiLineString","coordinates":[[[4602721.0,3407226.0],[4626271.0,3403317.0],[4621812.0,3425277.0],[4598024.0,3425759.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4468,"LEVL_CODE":0,"NUTS_BN_ID":4468,"OTHR_CNTR_":"F","Shape_Leng":11096.330151763599},"geometry":{"type":"MultiLineString","coordinates":[[[3465447.0,3485111.0],[3468067.0,3495894.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4471,"LEVL_CODE":0,"NUTS_BN_ID":4471,"OTHR_CNTR_":"F","Shape_Leng":6024.2759299425998},"geometry":{"type":"MultiLineString","coordinates":[[[4257112.0,3413573.0],[4256701.0,3419583.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4475,"LEVL_CODE":0,"NUTS_BN_ID":4475,"OTHR_CNTR_":"F","Shape_Leng":59361.5894550675},"geometry":{"type":"MultiLineString","coordinates":[[[4223057.0,3389734.0],[4229906.0,3420310.0],[4257112.0,3413573.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4499,"LEVL_CODE":0,"NUTS_BN_ID":4499,"OTHR_CNTR_":"F","Shape_Leng":5675.5578664725999},"geometry":{"type":"MultiLineString","coordinates":[[[4376161.0,3431975.0],[4380329.0,3428122.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4506,"LEVL_CODE":0,"NUTS_BN_ID":4506,"OTHR_CNTR_":"F","Shape_Leng":43891.724865157899},"geometry":{"type":"MultiLineString","coordinates":[[[4380329.0,3428122.0],[4423357.0,3436787.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4514,"LEVL_CODE":0,"NUTS_BN_ID":4514,"OTHR_CNTR_":"F","Shape_Leng":99224.615562024206},"geometry":{"type":"MultiLineString","coordinates":[[[4598024.0,3425759.0],[4572712.0,3422480.0],[4565999.0,3455597.0],[4580944.0,3447343.0],[4598483.0,3432718.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4518,"LEVL_CODE":0,"NUTS_BN_ID":4518,"OTHR_CNTR_":"F","Shape_Leng":67473.955235136906},"geometry":{"type":"MultiLineString","coordinates":[[[3267014.0,3563206.0],[3274928.0,3549666.0],[3257555.0,3555112.0],[3258778.0,3521551.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4529,"LEVL_CODE":0,"NUTS_BN_ID":4529,"OTHR_CNTR_":"F","Shape_Leng":94444.874790468995},"geometry":{"type":"MultiLineString","coordinates":[[[3656270.0,3497131.0],[3670768.0,3433552.0],[3647071.0,3450671.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4530,"LEVL_CODE":0,"NUTS_BN_ID":4530,"OTHR_CNTR_":"F","Shape_Leng":80268.274577319506},"geometry":{"type":"MultiLineString","coordinates":[[[4598483.0,3432718.0],[4672679.0,3463344.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4533,"LEVL_CODE":0,"NUTS_BN_ID":4533,"OTHR_CNTR_":"F","Shape_Leng":32911.973402903997},"geometry":{"type":"MultiLineString","coordinates":[[[4423357.0,3436787.0],[4451512.0,3453831.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4534,"LEVL_CODE":0,"NUTS_BN_ID":4534,"OTHR_CNTR_":"F","Shape_Leng":38709.800272964603},"geometry":{"type":"MultiLineString","coordinates":[[[3485613.0,3526833.0],[3465993.0,3520985.0],[3464767.0,3523628.0],[3464904.0,3534976.0],[3464404.0,3538919.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4535,"LEVL_CODE":0,"NUTS_BN_ID":4535,"OTHR_CNTR_":"F","Shape_Leng":35567.860197895301},"geometry":{"type":"MultiLineString","coordinates":[[[3468067.0,3495894.0],[3485613.0,3526833.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4538,"LEVL_CODE":0,"NUTS_BN_ID":4538,"OTHR_CNTR_":"F","Shape_Leng":88400.398484763806},"geometry":{"type":"MultiLineString","coordinates":[[[4537622.0,3459062.0],[4539337.0,3457760.0],[4566168.0,3442390.0],[4572298.0,3421595.0],[4602721.0,3407226.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4539,"LEVL_CODE":0,"NUTS_BN_ID":4539,"OTHR_CNTR_":"F","Shape_Leng":27252.2284910532},"geometry":{"type":"MultiLineString","coordinates":[[[3294065.0,3566511.0],[3267014.0,3563206.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4542,"LEVL_CODE":0,"NUTS_BN_ID":4542,"OTHR_CNTR_":"F","Shape_Leng":83682.465896980604},"geometry":{"type":"MultiLineString","coordinates":[[[4367472.0,3466736.0],[4394166.0,3474703.0],[4392396.0,3455248.0],[4370478.0,3438830.0],[4376161.0,3431975.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4547,"LEVL_CODE":0,"NUTS_BN_ID":4547,"OTHR_CNTR_":"F","Shape_Leng":15325.741128621299},"geometry":{"type":"MultiLineString","coordinates":[[[4451512.0,3453831.0],[4464497.0,3461971.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4552,"LEVL_CODE":0,"NUTS_BN_ID":4552,"OTHR_CNTR_":"F","Shape_Leng":44587.004823543903},"geometry":{"type":"MultiLineString","coordinates":[[[4256701.0,3419583.0],[4245717.0,3462796.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4553,"LEVL_CODE":0,"NUTS_BN_ID":4553,"OTHR_CNTR_":"F","Shape_Leng":6451.7105364445997},"geometry":{"type":"MultiLineString","coordinates":[[[4464497.0,3461971.0],[4469893.0,3465507.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4555,"LEVL_CODE":0,"NUTS_BN_ID":4555,"OTHR_CNTR_":"F","Shape_Leng":306447.96567137417},"geometry":{"type":"MultiLineString","coordinates":[[[3065671.0,3502790.0],[3074337.0,3515497.0],[3030448.0,3530601.0],[3030547.0,3530620.0],[3030448.0,3530601.0],[2998929.0,3552365.0],[3002873.0,3568599.0],[3029143.0,3567238.0],[3027596.0,3585772.0],[3053584.0,3592372.0],[3032756.0,3643890.0],[3087910.0,3615180.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4563,"LEVL_CODE":0,"NUTS_BN_ID":4563,"OTHR_CNTR_":"F","Shape_Leng":35406.9576502247},"geometry":{"type":"MultiLineString","coordinates":[[[4332329.0,3471046.0],[4367472.0,3466736.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4571,"LEVL_CODE":0,"NUTS_BN_ID":4571,"OTHR_CNTR_":"F","Shape_Leng":9699.6515188403991},"geometry":{"type":"MultiLineString","coordinates":[[[4331939.0,3480738.0],[4332329.0,3471046.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4572,"LEVL_CODE":0,"NUTS_BN_ID":4572,"OTHR_CNTR_":"F","Shape_Leng":39899.477920665202},"geometry":{"type":"MultiLineString","coordinates":[[[4922207.0,3502101.0],[4954962.0,3524884.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4576,"LEVL_CODE":0,"NUTS_BN_ID":4576,"OTHR_CNTR_":"F","Shape_Leng":78867.078883318201},"geometry":{"type":"MultiLineString","coordinates":[[[4901277.0,3508415.0],[4944144.0,3525203.0],[4944828.0,3524738.0],[4922207.0,3502101.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4579,"LEVL_CODE":0,"NUTS_BN_ID":4579,"OTHR_CNTR_":"F","Shape_Leng":176630.53929871961},"geometry":{"type":"MultiLineString","coordinates":[[[4469893.0,3465507.0],[4484431.0,3488182.0],[4510954.0,3484028.0],[4474978.0,3464796.0],[4516769.0,3485466.0],[4523499.0,3467996.0],[4537622.0,3459062.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4591,"LEVL_CODE":0,"NUTS_BN_ID":4591,"OTHR_CNTR_":"F","Shape_Leng":58392.3750820938},"geometry":{"type":"MultiLineString","coordinates":[[[3625708.0,3546887.0],[3656270.0,3497131.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4592,"LEVL_CODE":0,"NUTS_BN_ID":4592,"OTHR_CNTR_":"F","Shape_Leng":96612.612307921794},"geometry":{"type":"MultiLineString","coordinates":[[[4672679.0,3463344.0],[4753691.0,3515985.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4595,"LEVL_CODE":0,"NUTS_BN_ID":4595,"OTHR_CNTR_":"F","Shape_Leng":30404.2393949713},"geometry":{"type":"MultiLineString","coordinates":[[[3595902.0,3552886.0],[3625708.0,3546887.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4598,"LEVL_CODE":0,"NUTS_BN_ID":4598,"OTHR_CNTR_":"F","Shape_Leng":36565.679876747199},"geometry":{"type":"MultiLineString","coordinates":[[[4871927.0,3530225.0],[4901277.0,3508415.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4606,"LEVL_CODE":0,"NUTS_BN_ID":4606,"OTHR_CNTR_":"F","Shape_Leng":24353.690920253201},"geometry":{"type":"MultiLineString","coordinates":[[[4323013.0,3503397.0],[4331939.0,3480738.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4610,"LEVL_CODE":0,"NUTS_BN_ID":4610,"OTHR_CNTR_":"F","Shape_Leng":4029.8849698397999},"geometry":{"type":"MultiLineString","coordinates":[[[3303103.0,3617512.0],[3306364.0,3615145.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4611,"LEVL_CODE":0,"NUTS_BN_ID":4611,"OTHR_CNTR_":"F","Shape_Leng":142947.12971260099},"geometry":{"type":"MultiLineString","coordinates":[[[4539863.0,3510176.0],[4558961.0,3501246.0],[4560393.0,3477557.0],[4542346.0,3462512.0],[4523591.0,3473857.0],[4532879.0,3479949.0],[4532942.0,3490788.0],[4524455.0,3497852.0],[4539863.0,3510176.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4615,"LEVL_CODE":0,"NUTS_BN_ID":4615,"OTHR_CNTR_":"F","Shape_Leng":18496.701519739301},"geometry":{"type":"MultiLineString","coordinates":[[[3306364.0,3615145.0],[3324861.0,3615200.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4617,"LEVL_CODE":0,"NUTS_BN_ID":4617,"OTHR_CNTR_":"F","Shape_Leng":69378.846190143799},"geometry":{"type":"MultiLineString","coordinates":[[[3324861.0,3615200.0],[3329395.0,3593333.0],[3321561.0,3577943.0],[3294065.0,3566511.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4620,"LEVL_CODE":0,"NUTS_BN_ID":4620,"OTHR_CNTR_":"F","Shape_Leng":16849.638435651701},"geometry":{"type":"MultiLineString","coordinates":[[[3599768.0,3569286.0],[3595902.0,3552886.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4625,"LEVL_CODE":0,"NUTS_BN_ID":4625,"OTHR_CNTR_":"F","Shape_Leng":66739.273863383496},"geometry":{"type":"MultiLineString","coordinates":[[[4753691.0,3515985.0],[4813353.0,3545895.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4631,"LEVL_CODE":0,"NUTS_BN_ID":4631,"OTHR_CNTR_":"F","Shape_Leng":135270.06235685191},"geometry":{"type":"MultiLineString","coordinates":[[[4813353.0,3545895.0],[4857190.0,3554594.0],[4890027.0,3535022.0],[4860483.0,3547137.0],[4871927.0,3530225.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4632,"LEVL_CODE":0,"NUTS_BN_ID":4632,"OTHR_CNTR_":"F","Shape_Leng":40449.569569719803},"geometry":{"type":"MultiLineString","coordinates":[[[4288333.0,3524217.0],[4323013.0,3503397.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4634,"LEVL_CODE":0,"NUTS_BN_ID":4634,"OTHR_CNTR_":"F","Shape_Leng":4438.0504887461002},"geometry":{"type":"MultiLineString","coordinates":[[[4283896.0,3524316.0],[4288333.0,3524217.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4635,"LEVL_CODE":0,"NUTS_BN_ID":4635,"OTHR_CNTR_":"F","Shape_Leng":988.17072790580005},"geometry":{"type":"MultiLineString","coordinates":[[[4283725.0,3525289.0],[4283896.0,3524316.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4636,"LEVL_CODE":0,"NUTS_BN_ID":4636,"OTHR_CNTR_":"F","Shape_Leng":169499.36081489941},"geometry":{"type":"MultiLineString","coordinates":[[[4460262.0,3527531.0],[4415471.0,3501429.0],[4382482.0,3523660.0],[4460262.0,3527531.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4637,"LEVL_CODE":0,"NUTS_BN_ID":4637,"OTHR_CNTR_":"F","Shape_Leng":16796.901318342101},"geometry":{"type":"MultiLineString","coordinates":[[[3595545.0,3585543.0],[3599768.0,3569286.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4642,"LEVL_CODE":0,"NUTS_BN_ID":4642,"OTHR_CNTR_":"F","Shape_Leng":127115.57250138051},"geometry":{"type":"MultiLineString","coordinates":[[[4245717.0,3462796.0],[4230067.0,3471329.0],[4256870.0,3488284.0],[4216564.0,3533539.0],[4233489.0,3534838.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4650,"LEVL_CODE":0,"NUTS_BN_ID":4650,"OTHR_CNTR_":"F","Shape_Leng":99705.690509453794},"geometry":{"type":"MultiLineString","coordinates":[[[3464404.0,3538919.0],[3445353.0,3573857.0],[3466206.0,3608971.0],[3485013.0,3612132.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4653,"LEVL_CODE":0,"NUTS_BN_ID":4653,"OTHR_CNTR_":"F","Shape_Leng":9366.6683421872003},"geometry":{"type":"MultiLineString","coordinates":[[[3595988.0,3594899.0],[3595545.0,3585543.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4656,"LEVL_CODE":0,"NUTS_BN_ID":4656,"OTHR_CNTR_":"F","Shape_Leng":5606.1745608295996},"geometry":{"type":"MultiLineString","coordinates":[[[3485013.0,3612132.0],[3487724.0,3617039.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4658,"LEVL_CODE":0,"NUTS_BN_ID":4658,"OTHR_CNTR_":"F","Shape_Leng":66096.319296756905},"geometry":{"type":"MultiLineString","coordinates":[[[3309325.0,3662898.0],[3306637.0,3655794.0],[3318169.0,3628426.0],[3320955.0,3632010.0],[3320034.0,3627623.0],[3303103.0,3617512.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4659,"LEVL_CODE":0,"NUTS_BN_ID":4659,"OTHR_CNTR_":"F","Shape_Leng":160170.42465989941},"geometry":{"type":"MultiLineString","coordinates":[[[3487724.0,3617039.0],[3398618.0,3600418.0],[3355218.0,3636274.0],[3366185.0,3643678.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4669,"LEVL_CODE":0,"NUTS_BN_ID":4669,"OTHR_CNTR_":"F","Shape_Leng":15788.764977630401},"geometry":{"type":"MultiLineString","coordinates":[[[3592155.0,3610216.0],[3595988.0,3594899.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4676,"LEVL_CODE":0,"NUTS_BN_ID":4676,"OTHR_CNTR_":"F","Shape_Leng":91007.683712065307},"geometry":{"type":"MultiLineString","coordinates":[[[3230330.0,3682748.0],[3240938.0,3684041.0],[3284333.0,3689599.0],[3309325.0,3662898.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4682,"LEVL_CODE":0,"NUTS_BN_ID":4682,"OTHR_CNTR_":"F","Shape_Leng":86047.640339035206},"geometry":{"type":"MultiLineString","coordinates":[[[4650231.0,3564904.0],[4619843.0,3564378.0],[4624546.0,3586180.0],[4650231.0,3564904.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4685,"LEVL_CODE":0,"NUTS_BN_ID":4685,"OTHR_CNTR_":"F","Shape_Leng":318523.97982645419},"geometry":{"type":"MultiLineString","coordinates":[[[3087910.0,3615180.0],[3128647.0,3610568.0],[3163000.0,3646258.0],[3124842.0,3666210.0],[3169713.0,3708703.0],[3233548.0,3717407.0],[3255229.0,3695862.0],[3230330.0,3682748.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4694,"LEVL_CODE":0,"NUTS_BN_ID":4694,"OTHR_CNTR_":"F","Shape_Leng":155270.4789433729},"geometry":{"type":"MultiLineString","coordinates":[[[4300761.0,3600856.0],[4299738.0,3600660.0],[4288625.0,3598549.0],[4284039.0,3547710.0],[4325578.0,3530186.0],[4296586.0,3536563.0],[4283725.0,3525289.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4698,"LEVL_CODE":0,"NUTS_BN_ID":4698,"OTHR_CNTR_":"F","Shape_Leng":224645.691336291},"geometry":{"type":"MultiLineString","coordinates":[[[4304551.0,3602812.0],[4352190.0,3604920.0],[4348053.0,3591673.0],[4375418.0,3576788.0],[4356497.0,3537798.0],[4325616.0,3552456.0],[4300761.0,3600856.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4702,"LEVL_CODE":0,"NUTS_BN_ID":4702,"OTHR_CNTR_":"F","Shape_Leng":68437.239689063499},"geometry":{"type":"MultiLineString","coordinates":[[[3366185.0,3643678.0],[3403235.0,3701218.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4704,"LEVL_CODE":0,"NUTS_BN_ID":4704,"OTHR_CNTR_":"F","Shape_Leng":20759.159514606301},"geometry":{"type":"MultiLineString","coordinates":[[[4470060.0,3612364.0],[4461683.0,3593371.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4707,"LEVL_CODE":0,"NUTS_BN_ID":4707,"OTHR_CNTR_":"F","Shape_Leng":10146.745453731},"geometry":{"type":"MultiLineString","coordinates":[[[4478800.0,3617519.0],[4470060.0,3612364.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4708,"LEVL_CODE":0,"NUTS_BN_ID":4708,"OTHR_CNTR_":"F","Shape_Leng":28476.9715525838},"geometry":{"type":"MultiLineString","coordinates":[[[4483439.0,3627071.0],[4490116.0,3612447.0],[4478800.0,3617519.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4718,"LEVL_CODE":0,"NUTS_BN_ID":4718,"OTHR_CNTR_":"F","Shape_Leng":43071.033512428599},"geometry":{"type":"MultiLineString","coordinates":[[[4300368.0,3623122.0],[4292313.0,3622566.0],[4312222.0,3613411.0],[4304551.0,3602812.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4722,"LEVL_CODE":0,"NUTS_BN_ID":4722,"OTHR_CNTR_":"F","Shape_Leng":90255.732639734706},"geometry":{"type":"MultiLineString","coordinates":[[[4434643.0,3621008.0],[4438868.0,3627450.0],[4443822.0,3640152.0],[4440119.0,3649559.0],[4450452.0,3627155.0],[4445504.0,3626797.0],[4443816.0,3620673.0],[4452289.0,3618543.0],[4452223.0,3625806.0],[4452196.0,3628815.0],[4452161.0,3632629.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4734,"LEVL_CODE":0,"NUTS_BN_ID":4734,"OTHR_CNTR_":"F","Shape_Leng":9572.4412532484002},"geometry":{"type":"MultiLineString","coordinates":[[[4483027.0,3636634.0],[4483439.0,3627071.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4736,"LEVL_CODE":0,"NUTS_BN_ID":4736,"OTHR_CNTR_":"F","Shape_Leng":94123.051989993401},"geometry":{"type":"MultiLineString","coordinates":[[[3570116.0,3697126.0],[3579014.0,3676540.0],[3590218.0,3667456.0],[3592155.0,3610216.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4737,"LEVL_CODE":0,"NUTS_BN_ID":4737,"OTHR_CNTR_":"F","Shape_Leng":124559.32679192669},"geometry":{"type":"MultiLineString","coordinates":[[[4233489.0,3534838.0],[4237097.0,3562280.0],[4233615.0,3592377.0],[4199577.0,3607438.0],[4206270.0,3636027.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4745,"LEVL_CODE":0,"NUTS_BN_ID":4745,"OTHR_CNTR_":"F","Shape_Leng":36887.598131243198},"geometry":{"type":"MultiLineString","coordinates":[[[3403235.0,3701218.0],[3396190.0,3737427.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4765,"LEVL_CODE":0,"NUTS_BN_ID":4765,"OTHR_CNTR_":"F","Shape_Leng":25595.183103651299},"geometry":{"type":"MultiLineString","coordinates":[[[3552262.0,3715466.0],[3570116.0,3697126.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4766,"LEVL_CODE":0,"NUTS_BN_ID":4766,"OTHR_CNTR_":"F","Shape_Leng":34980.619124339799},"geometry":{"type":"MultiLineString","coordinates":[[[3426867.0,3732775.0],[3414918.0,3741710.0],[3404653.0,3758945.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4768,"LEVL_CODE":0,"NUTS_BN_ID":4768,"OTHR_CNTR_":"F","Shape_Leng":44340.031118863299},"geometry":{"type":"MultiLineString","coordinates":[[[3508635.0,3723384.0],[3552262.0,3715466.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4770,"LEVL_CODE":0,"NUTS_BN_ID":4770,"OTHR_CNTR_":"F","Shape_Leng":36485.481683229104},"geometry":{"type":"MultiLineString","coordinates":[[[3396190.0,3737427.0],[3405693.0,3744896.0],[3426867.0,3732775.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4772,"LEVL_CODE":0,"NUTS_BN_ID":4772,"OTHR_CNTR_":"F","Shape_Leng":332337.84966839902},"geometry":{"type":"MultiLineString","coordinates":[[[4461683.0,3593371.0],[4477085.0,3579048.0],[4449277.0,3542063.0],[4424224.0,3554049.0],[4437917.0,3550030.0],[4432323.0,3569578.0],[4400177.0,3567661.0],[4375738.0,3626932.0],[4405713.0,3628950.0],[4413639.0,3651742.0],[4432011.0,3653899.0],[4430431.0,3633024.0],[4434643.0,3621008.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4775,"LEVL_CODE":0,"NUTS_BN_ID":4775,"OTHR_CNTR_":"F","Shape_Leng":22271.575772162701},"geometry":{"type":"MultiLineString","coordinates":[[[3488330.0,3732535.0],[3508635.0,3723384.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4776,"LEVL_CODE":0,"NUTS_BN_ID":4776,"OTHR_CNTR_":"F","Shape_Leng":97574.219732490601},"geometry":{"type":"MultiLineString","coordinates":[[[4452161.0,3632629.0],[4446586.0,3653309.0],[4436243.0,3652922.0],[4481076.0,3657303.0],[4483027.0,3636634.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4779,"LEVL_CODE":0,"NUTS_BN_ID":4779,"OTHR_CNTR_":"F","Shape_Leng":5698.4084230586004},"geometry":{"type":"MultiLineString","coordinates":[[[3482977.0,3734489.0],[3488330.0,3732535.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4786,"LEVL_CODE":0,"NUTS_BN_ID":4786,"OTHR_CNTR_":"F","Shape_Leng":92724.330759239601},"geometry":{"type":"MultiLineString","coordinates":[[[5034381.0,3627075.0],[5007411.0,3715790.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4790,"LEVL_CODE":0,"NUTS_BN_ID":4790,"OTHR_CNTR_":"F","Shape_Leng":21753.886637354601},"geometry":{"type":"MultiLineString","coordinates":[[[3466493.0,3748684.0],[3482977.0,3734489.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4793,"LEVL_CODE":0,"NUTS_BN_ID":4793,"OTHR_CNTR_":"F","Shape_Leng":3757.114337044},"geometry":{"type":"MultiLineString","coordinates":[[[3464122.0,3751599.0],[3466493.0,3748684.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4802,"LEVL_CODE":0,"NUTS_BN_ID":4802,"OTHR_CNTR_":"F","Shape_Leng":144959.34024505521},"geometry":{"type":"MultiLineString","coordinates":[[[4695105.0,3706695.0],[4685082.0,3679412.0],[4667886.0,3692195.0],[4653484.0,3681390.0],[4612159.0,3683206.0],[4619040.0,3668854.0],[4615587.0,3664072.0],[4604193.0,3670894.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4812,"LEVL_CODE":0,"NUTS_BN_ID":4812,"OTHR_CNTR_":"F","Shape_Leng":141675.949558258},"geometry":{"type":"MultiLineString","coordinates":[[[3504923.0,3769882.0],[3505722.0,3769996.0],[3507086.0,3770191.0],[3535498.0,3774358.0],[3542987.0,3752785.0],[3490655.0,3733446.0],[3464122.0,3751599.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4814,"LEVL_CODE":0,"NUTS_BN_ID":4814,"OTHR_CNTR_":"F","Shape_Leng":355948.33738629398},"geometry":{"type":"MultiLineString","coordinates":[[[4604193.0,3670894.0],[4585446.0,3644007.0],[4596163.0,3613850.0],[4586838.0,3594315.0],[4499154.0,3589404.0],[4513816.0,3622510.0],[4472500.0,3691369.0],[4493783.0,3682890.0],[4482751.0,3705063.0],[4499887.0,3708682.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4816,"LEVL_CODE":0,"NUTS_BN_ID":4816,"OTHR_CNTR_":"F","Shape_Leng":18413.803872017801},"geometry":{"type":"MultiLineString","coordinates":[[[3520820.0,3779175.0],[3505314.0,3770110.0],[3504923.0,3769882.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4822,"LEVL_CODE":0,"NUTS_BN_ID":4822,"OTHR_CNTR_":"F","Shape_Leng":530088.18988629489},"geometry":{"type":"MultiLineString","coordinates":[[[3404653.0,3758945.0],[3364347.0,3746780.0],[3345143.0,3689844.0],[3326371.0,3686894.0],[3362391.0,3742731.0],[3346946.0,3739625.0],[3369070.0,3786930.0],[3359994.0,3793598.0],[3381989.0,3815514.0],[3404800.0,3844330.0],[3363124.0,3815746.0],[3336233.0,3846344.0],[3366265.0,3847648.0],[3358786.0,3861864.0],[3375637.0,3882094.0],[3388493.0,3878804.0],[3379671.0,3886803.0],[3381759.0,3892963.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4829,"LEVL_CODE":0,"NUTS_BN_ID":4829,"OTHR_CNTR_":"F","Shape_Leng":129756.8451778817},"geometry":{"type":"MultiLineString","coordinates":[[[3327723.0,3836298.0],[3364025.0,3809053.0],[3315762.0,3802677.0],[3327723.0,3836298.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4830,"LEVL_CODE":0,"NUTS_BN_ID":4830,"OTHR_CNTR_":"F","Shape_Leng":195575.549596789},"geometry":{"type":"MultiLineString","coordinates":[[[4332907.0,3731306.0],[4339940.0,3722670.0],[4380253.0,3704695.0],[4365346.0,3671138.0],[4342490.0,3676763.0],[4321598.0,3621829.0],[4300368.0,3623122.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4831,"LEVL_CODE":0,"NUTS_BN_ID":4831,"OTHR_CNTR_":"F","Shape_Leng":237253.26357010959},"geometry":{"type":"MultiLineString","coordinates":[[[4206270.0,3636027.0],[4220030.0,3645928.0],[4202472.0,3660687.0],[4210433.0,3733826.0],[4238884.0,3707927.0],[4259972.0,3744677.0],[4270554.0,3734203.0],[4263171.0,3725567.0],[4279240.0,3730101.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4837,"LEVL_CODE":0,"NUTS_BN_ID":4837,"OTHR_CNTR_":"F","Shape_Leng":510161.63434578793},"geometry":{"type":"MultiLineString","coordinates":[[[4234115.0,3732803.0],[4223074.0,3730771.0],[4212937.0,3745245.0],[4235484.0,3780333.0],[4284609.0,3784774.0],[4318503.0,3832586.0],[4359448.0,3849159.0],[4346592.0,3782879.0],[4239878.0,3761566.0],[4229956.0,3732436.0],[4233790.0,3733023.0],[4234021.0,3733346.0],[4254020.0,3761544.0],[4245977.0,3733026.0],[4234896.0,3732816.0],[4234115.0,3732803.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4843,"LEVL_CODE":0,"NUTS_BN_ID":4843,"OTHR_CNTR_":"F","Shape_Leng":50825.404655224302},"geometry":{"type":"MultiLineString","coordinates":[[[3564651.0,3804905.0],[3520820.0,3779175.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4854,"LEVL_CODE":0,"NUTS_BN_ID":4854,"OTHR_CNTR_":"F","Shape_Leng":187122.27918938681},"geometry":{"type":"MultiLineString","coordinates":[[[4279240.0,3730101.0],[4269441.0,3730840.0],[4274670.0,3738632.0],[4270011.0,3754297.0],[4337579.0,3759379.0],[4341399.0,3733939.0],[4338022.0,3733122.0],[4308837.0,3726179.0],[4332907.0,3731306.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4863,"LEVL_CODE":0,"NUTS_BN_ID":4863,"OTHR_CNTR_":"F","Shape_Leng":14265.138615727399},"geometry":{"type":"MultiLineString","coordinates":[[[5162340.0,3849279.0],[5171516.0,3860202.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4877,"LEVL_CODE":0,"NUTS_BN_ID":4877,"OTHR_CNTR_":"F","Shape_Leng":68484.074156660703},"geometry":{"type":"MultiLineString","coordinates":[[[5108900.0,3874214.0],[5123593.0,3848373.0],[5162340.0,3849279.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4878,"LEVL_CODE":0,"NUTS_BN_ID":4878,"OTHR_CNTR_":"F","Shape_Leng":263495.54814970028},"geometry":{"type":"MultiLineString","coordinates":[[[3381759.0,3892963.0],[3356464.0,3876873.0],[3321801.0,3931283.0],[3358024.0,3955573.0],[3363263.0,3939094.0],[3357547.0,3910891.0],[3369887.0,3899042.0],[3384285.0,3897760.0],[3382396.0,3894062.0],[3397310.0,3891997.0],[3376789.0,3911847.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4880,"LEVL_CODE":0,"NUTS_BN_ID":4880,"OTHR_CNTR_":"F","Shape_Leng":275272.82797438873},"geometry":{"type":"MultiLineString","coordinates":[[[4748485.0,3807419.0],[4718019.0,3694598.0],[4714787.0,3738368.0],[4740321.0,3819182.0],[4746656.0,3827023.0],[4748485.0,3807419.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4891,"LEVL_CODE":0,"NUTS_BN_ID":4891,"OTHR_CNTR_":"F","Shape_Leng":143404.92808866821},"geometry":{"type":"MultiLineString","coordinates":[[[4499887.0,3708682.0],[4501545.0,3724125.0],[4436181.0,3812518.0],[4436223.0,3830455.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4895,"LEVL_CODE":0,"NUTS_BN_ID":4895,"OTHR_CNTR_":"F","Shape_Leng":100022.37648386641},"geometry":{"type":"MultiLineString","coordinates":[[[3461377.0,3908521.0],[3561339.0,3911996.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4897,"LEVL_CODE":0,"NUTS_BN_ID":4897,"OTHR_CNTR_":"F","Shape_Leng":156060.435631092},"geometry":{"type":"MultiLineString","coordinates":[[[3561339.0,3911996.0],[3617089.0,3880585.0],[3564651.0,3804905.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4903,"LEVL_CODE":0,"NUTS_BN_ID":4903,"OTHR_CNTR_":"F","Shape_Leng":297130.40352957632},"geometry":{"type":"MultiLineString","coordinates":[[[5007411.0,3715790.0],[4996714.0,3746107.0],[4993373.0,3798723.0],[5009552.0,3821537.0],[5006942.0,3853619.0],[5018589.0,3886876.0],[5067856.0,3916863.0],[5108900.0,3874214.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4907,"LEVL_CODE":0,"NUTS_BN_ID":4907,"OTHR_CNTR_":"F","Shape_Leng":241280.42537985131},"geometry":{"type":"MultiLineString","coordinates":[[[4841145.0,3894859.0],[4860714.0,3891909.0],[4845428.0,3877274.0],[4845844.0,3850812.0],[4856107.0,3844641.0],[4846031.0,3825586.0],[4826066.0,3803861.0],[4808639.0,3822818.0],[4805947.0,3853361.0],[4841145.0,3894859.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4909,"LEVL_CODE":0,"NUTS_BN_ID":4909,"OTHR_CNTR_":"F","Shape_Leng":94827.099490617504},"geometry":{"type":"MultiLineString","coordinates":[[[5171516.0,3860202.0],[5184622.0,3883328.0],[5167150.0,3949299.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4916,"LEVL_CODE":0,"NUTS_BN_ID":4916,"OTHR_CNTR_":"F","Shape_Leng":201768.95100600811},"geometry":{"type":"MultiLineString","coordinates":[[[4715178.0,3895576.0],[4716565.0,3895703.0],[4719190.0,3895945.0],[4723828.0,3896376.0],[4724778.0,3834710.0],[4695105.0,3706695.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4939,"LEVL_CODE":0,"NUTS_BN_ID":4939,"OTHR_CNTR_":"F","Shape_Leng":271333.94590140221},"geometry":{"type":"MultiLineString","coordinates":[[[3369107.0,4013393.0],[3381716.0,4013348.0],[3319796.0,3967028.0],[3313239.0,3981146.0],[3333221.0,3983655.0],[3319886.0,3994538.0],[3331992.0,4001063.0],[3321481.0,4006379.0],[3330505.0,4023816.0],[3384567.0,4036482.0],[3369107.0,4013393.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4942,"LEVL_CODE":0,"NUTS_BN_ID":4942,"OTHR_CNTR_":"F","Shape_Leng":206326.9572693432},"geometry":{"type":"MultiLineString","coordinates":[[[4713203.0,3965906.0],[4682423.0,3962890.0],[4726323.0,3950722.0],[4695312.0,3947376.0],[4726718.0,3934659.0],[4708964.0,3935265.0],[4724291.0,3916172.0],[4715178.0,3895576.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4944,"LEVL_CODE":0,"NUTS_BN_ID":4944,"OTHR_CNTR_":"F","Shape_Leng":213181.8537622267},"geometry":{"type":"MultiLineString","coordinates":[[[5092764.0,4018035.0],[5065256.0,3967785.0],[5011872.0,3969212.0],[5046285.0,4013072.0],[5092764.0,4018035.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4945,"LEVL_CODE":0,"NUTS_BN_ID":4945,"OTHR_CNTR_":"F","Shape_Leng":535309.44894294918},"geometry":{"type":"MultiLineString","coordinates":[[[3376789.0,3911847.0],[3389826.0,3965582.0],[3431856.0,3951866.0],[3415743.0,3984462.0],[3455117.0,4038893.0],[3568281.0,4018317.0],[3557135.0,3989123.0],[3473070.0,3954497.0],[3508399.0,3941494.0],[3461377.0,3908521.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4963,"LEVL_CODE":0,"NUTS_BN_ID":4963,"OTHR_CNTR_":"F","Shape_Leng":266206.63204082567},"geometry":{"type":"MultiLineString","coordinates":[[[4793848.0,4144831.0],[4812328.0,4142918.0],[4831268.0,4105789.0],[4778920.0,4056920.0],[4784076.0,4052277.0],[4816927.0,4051454.0],[4780534.0,4010952.0],[4775042.0,3996908.0],[4773303.0,4002847.0],[4772201.0,4000799.0],[4758738.0,4005787.0],[4757954.0,4006079.0],[4756741.0,4006532.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4965,"LEVL_CODE":0,"NUTS_BN_ID":4965,"OTHR_CNTR_":"F","Shape_Leng":59548.204962865799},"geometry":{"type":"MultiLineString","coordinates":[[[4756741.0,4006532.0],[4713203.0,3965906.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4975,"LEVL_CODE":0,"NUTS_BN_ID":4975,"OTHR_CNTR_":"F","Shape_Leng":260049.44652671559},"geometry":{"type":"MultiLineString","coordinates":[[[4436223.0,3830455.0],[4439744.0,3848270.0],[4420519.0,3861941.0],[4429749.0,3896811.0],[4403986.0,3894414.0],[4420623.0,3927009.0],[4392438.0,3923682.0],[4397522.0,3931631.0],[4394044.0,3953599.0],[4389156.0,3958031.0],[4392679.0,3971510.0],[4385130.0,3989098.0],[4405150.0,3988392.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4976,"LEVL_CODE":0,"NUTS_BN_ID":4976,"OTHR_CNTR_":"F","Shape_Leng":77368.748345072599},"geometry":{"type":"MultiLineString","coordinates":[[[3582306.0,4056746.0],[3593094.0,4049773.0],[3556403.0,4060782.0],[3582306.0,4056746.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":4987,"LEVL_CODE":0,"NUTS_BN_ID":4987,"OTHR_CNTR_":"F","Shape_Leng":104522.79407526919},"geometry":{"type":"MultiLineString","coordinates":[[[5061550.0,4053119.0],[5072146.0,4040013.0],[5032688.0,4038870.0],[5039959.0,4062450.0],[5061550.0,4053119.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5005,"LEVL_CODE":0,"NUTS_BN_ID":5005,"OTHR_CNTR_":"F","Shape_Leng":212769.22231243929},"geometry":{"type":"MultiLineString","coordinates":[[[5167150.0,3949299.0],[5169841.0,4001000.0],[5144876.0,3986210.0],[5103795.0,4014998.0],[5087082.0,4064129.0],[5100697.0,4090773.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5038,"LEVL_CODE":0,"NUTS_BN_ID":5038,"OTHR_CNTR_":"F","Shape_Leng":72573.847229663195},"geometry":{"type":"MultiLineString","coordinates":[[[5262089.0,4156089.0],[5333197.0,4170600.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5045,"LEVL_CODE":0,"NUTS_BN_ID":5045,"OTHR_CNTR_":"F","Shape_Leng":53034.989967017602},"geometry":{"type":"MultiLineString","coordinates":[[[5209290.0,4151086.0],[5262089.0,4156089.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5046,"LEVL_CODE":0,"NUTS_BN_ID":5046,"OTHR_CNTR_":"F","Shape_Leng":129115.6847810598},"geometry":{"type":"MultiLineString","coordinates":[[[5100697.0,4090773.0],[5152133.0,4139385.0],[5209290.0,4151086.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5164,"LEVL_CODE":0,"NUTS_BN_ID":5164,"OTHR_CNTR_":"F","Shape_Leng":311145.71453251102},"geometry":{"type":"MultiLineString","coordinates":[[[5218624.0,4259109.0],[5199402.0,4234975.0],[5199313.0,4235513.0],[5197995.0,4237039.0],[5192866.0,4239140.0],[5191375.0,4233929.0],[5196922.0,4228006.0],[5189480.0,4223630.0],[5178603.0,4231369.0],[5183242.0,4233878.0],[5179385.0,4238048.0],[5170724.0,4217719.0],[5159319.0,4213931.0],[5125391.0,4202899.0],[5108657.0,4182239.0],[5089059.0,4177270.0],[5095794.0,4177011.0],[5082070.0,4170622.0],[5084632.0,4167862.0],[5064797.0,4161066.0],[5057456.0,4149510.0],[5043524.0,4146478.0],[5049997.0,4167737.0],[5042870.0,4177808.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5184,"LEVL_CODE":0,"NUTS_BN_ID":5184,"OTHR_CNTR_":"F","Shape_Leng":240399.301519589},"geometry":{"type":"MultiLineString","coordinates":[[[5042870.0,4177808.0],[5032179.0,4186791.0],[5039758.0,4208305.0],[5008074.0,4190091.0],[5014008.0,4203370.0],[5007468.0,4207249.0],[4997052.0,4201526.0],[4994169.0,4204126.0],[4993702.0,4204937.0],[4993419.0,4204803.0],[4967696.0,4224770.0],[4956375.0,4206637.0],[4955498.0,4207536.0],[4956254.0,4209624.0],[4953650.0,4213889.0],[4947961.0,4215458.0],[4927040.0,4244655.0],[4936847.0,4266210.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5188,"LEVL_CODE":0,"NUTS_BN_ID":5188,"OTHR_CNTR_":"F","Shape_Leng":120819.8595711519},"geometry":{"type":"MultiLineString","coordinates":[[[4866704.0,4185193.0],[4888653.0,4172895.0],[4884638.0,4159923.0],[4878949.0,4150973.0],[4875502.0,4150632.0],[4874932.0,4145691.0],[4848581.0,4155233.0],[4866704.0,4185193.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5197,"LEVL_CODE":0,"NUTS_BN_ID":5197,"OTHR_CNTR_":"F","Shape_Leng":73835.722695018005},"geometry":{"type":"MultiLineString","coordinates":[[[5288456.0,4283094.0],[5218624.0,4259109.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5202,"LEVL_CODE":0,"NUTS_BN_ID":5202,"OTHR_CNTR_":"F","Shape_Leng":139585.8015609268},"geometry":{"type":"MultiLineString","coordinates":[[[4724468.0,4193685.0],[4742979.0,4179019.0],[4758862.0,4191804.0],[4798411.0,4154833.0],[4780312.0,4162097.0],[4793848.0,4144831.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5208,"LEVL_CODE":0,"NUTS_BN_ID":5208,"OTHR_CNTR_":"F","Shape_Leng":206326.39692224411},"geometry":{"type":"MultiLineString","coordinates":[[[3691296.0,4211644.0],[3703388.0,4218737.0],[3706134.0,4186051.0],[3690465.0,4133811.0],[3674698.0,4181852.0],[3696497.0,4190049.0],[3682902.0,4206204.0],[3691296.0,4211644.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5279,"LEVL_CODE":0,"NUTS_BN_ID":5279,"OTHR_CNTR_":"F","Shape_Leng":180573.29319960839},"geometry":{"type":"MultiLineString","coordinates":[[[4712401.0,4358106.0],[4706425.0,4325733.0],[4713034.0,4311851.0],[4695517.0,4293562.0],[4705252.0,4219121.0],[4724468.0,4193685.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5283,"LEVL_CODE":0,"NUTS_BN_ID":5283,"OTHR_CNTR_":"F","Shape_Leng":112275.8050702317},"geometry":{"type":"MultiLineString","coordinates":[[[4936847.0,4266210.0],[4942040.0,4324641.0],[4911539.0,4368734.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5354,"LEVL_CODE":0,"NUTS_BN_ID":5354,"OTHR_CNTR_":"F","Shape_Leng":269123.79014482163},"geometry":{"type":"MultiLineString","coordinates":[[[4911539.0,4368734.0],[4908827.0,4410855.0],[4889337.0,4437159.0],[4903232.0,4477485.0],[4901018.0,4481859.0],[4894527.0,4484022.0],[4930011.0,4514880.0],[4931240.0,4514420.0],[4933716.0,4518923.0],[4941165.0,4524987.0],[4932570.0,4551527.0],[4953844.0,4583908.0],[4956751.0,4583560.0],[4960568.0,4579969.0],[4962407.0,4580400.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5381,"LEVL_CODE":0,"NUTS_BN_ID":5381,"OTHR_CNTR_":"F","Shape_Leng":219176.6852675789},"geometry":{"type":"MultiLineString","coordinates":[[[4784816.0,4515904.0],[4743291.0,4464064.0],[4756002.0,4455429.0],[4735840.0,4413595.0],[4702672.0,4403144.0],[4705032.0,4378129.0],[4720015.0,4369663.0],[4712401.0,4358106.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5422,"LEVL_CODE":0,"NUTS_BN_ID":5422,"OTHR_CNTR_":"F","Shape_Leng":40678.504527246798},"geometry":{"type":"MultiLineString","coordinates":[[[4962407.0,4580400.0],[4985007.0,4614223.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5447,"LEVL_CODE":0,"NUTS_BN_ID":5447,"OTHR_CNTR_":"F","Shape_Leng":250285.36765666149},"geometry":{"type":"MultiLineString","coordinates":[[[4865014.0,4706862.0],[4851688.0,4676812.0],[4880425.0,4638607.0],[4832148.0,4545500.0],[4812631.0,4536258.0],[4805060.0,4514695.0],[4784816.0,4515904.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5482,"LEVL_CODE":0,"NUTS_BN_ID":5482,"OTHR_CNTR_":"F","Shape_Leng":217782.24952907721},"geometry":{"type":"MultiLineString","coordinates":[[[4985007.0,4614223.0],[5010230.0,4706334.0],[5050406.0,4731888.0],[5032508.0,4780989.0],[5015510.0,4795586.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5493,"LEVL_CODE":0,"NUTS_BN_ID":5493,"OTHR_CNTR_":"F","Shape_Leng":50482.223156034801},"geometry":{"type":"MultiLineString","coordinates":[[[5015510.0,4795586.0],[5004639.0,4801941.0],[4967896.0,4811191.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"T","EFTA_FLAG":"F","EU_FLAG":"T","FID":5496,"LEVL_CODE":0,"NUTS_BN_ID":5496,"OTHR_CNTR_":"F","Shape_Leng":192999.7278423188},"geometry":{"type":"MultiLineString","coordinates":[[[4967896.0,4811191.0],[4884966.0,4801126.0],[4894873.0,4765509.0],[4879598.0,4754620.0],[4860785.0,4725148.0],[4865014.0,4706862.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":514,"LEVL_CODE":0,"NUTS_BN_ID":514,"OTHR_CNTR_":"F","Shape_Leng":34760.950153430902},"geometry":{"type":"MultiLineString","coordinates":[[[5212815.0,1916170.0],[5181493.0,1901093.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":594,"LEVL_CODE":0,"NUTS_BN_ID":594,"OTHR_CNTR_":"F","Shape_Leng":79837.969654311804},"geometry":{"type":"MultiLineString","coordinates":[[[5237775.0,1982254.0],[5203307.0,1937469.0],[5212815.0,1916170.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":643,"LEVL_CODE":0,"NUTS_BN_ID":643,"OTHR_CNTR_":"F","Shape_Leng":38127.780880488397},"geometry":{"type":"MultiLineString","coordinates":[[[5257241.0,2015038.0],[5237775.0,1982254.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":698,"LEVL_CODE":0,"NUTS_BN_ID":698,"OTHR_CNTR_":"F","Shape_Leng":27147.596869850899},"geometry":{"type":"MultiLineString","coordinates":[[[5247353.0,2040321.0],[5257241.0,2015038.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":711,"LEVL_CODE":0,"NUTS_BN_ID":711,"OTHR_CNTR_":"F","Shape_Leng":68839.247867052298},"geometry":{"type":"MultiLineString","coordinates":[[[5247353.0,2040321.0],[5313655.0,2058838.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":755,"LEVL_CODE":0,"NUTS_BN_ID":755,"OTHR_CNTR_":"F","Shape_Leng":22372.577684246698},"geometry":{"type":"MultiLineString","coordinates":[[[5313655.0,2058838.0],[5322793.0,2079259.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":773,"LEVL_CODE":0,"NUTS_BN_ID":773,"OTHR_CNTR_":"F","Shape_Leng":25455.267657653301},"geometry":{"type":"MultiLineString","coordinates":[[[5322793.0,2079259.0],[5345488.0,2090788.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":774,"LEVL_CODE":0,"NUTS_BN_ID":774,"OTHR_CNTR_":"F","Shape_Leng":11160.4739857573},"geometry":{"type":"MultiLineString","coordinates":[[[5345488.0,2090788.0],[5355938.0,2086870.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":812,"LEVL_CODE":0,"NUTS_BN_ID":812,"OTHR_CNTR_":"F","Shape_Leng":58800.0795867368},"geometry":{"type":"MultiLineString","coordinates":[[[5355938.0,2086870.0],[5388704.0,2095298.0],[5397537.0,2118651.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":814,"LEVL_CODE":0,"NUTS_BN_ID":814,"OTHR_CNTR_":"F","Shape_Leng":4065.0244595049999},"geometry":{"type":"MultiLineString","coordinates":[[[5397537.0,2118651.0],[5401576.0,2119112.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":815,"LEVL_CODE":0,"NUTS_BN_ID":815,"OTHR_CNTR_":"F","Shape_Leng":146812.50208530741},"geometry":{"type":"MultiLineString","coordinates":[[[5675519.0,2215229.0],[5697678.0,2207676.0],[5705719.0,2180408.0],[5682721.0,2164474.0],[5687179.0,2129286.0],[5670221.0,2102712.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":841,"LEVL_CODE":0,"NUTS_BN_ID":841,"OTHR_CNTR_":"F","Shape_Leng":20426.0529032587},"geometry":{"type":"MultiLineString","coordinates":[[[5401576.0,2119112.0],[5401768.0,2139537.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":899,"LEVL_CODE":0,"NUTS_BN_ID":899,"OTHR_CNTR_":"F","Shape_Leng":29513.1783909531},"geometry":{"type":"MultiLineString","coordinates":[[[5687247.0,2242311.0],[5675519.0,2215229.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":912,"LEVL_CODE":0,"NUTS_BN_ID":912,"OTHR_CNTR_":"F","Shape_Leng":33322.157019390899},"geometry":{"type":"MultiLineString","coordinates":[[[5716920.0,2257473.0],[5687247.0,2242311.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":918,"LEVL_CODE":0,"NUTS_BN_ID":918,"OTHR_CNTR_":"F","Shape_Leng":56220.863272070703},"geometry":{"type":"MultiLineString","coordinates":[[[5401768.0,2139537.0],[5384665.0,2193093.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":926,"LEVL_CODE":0,"NUTS_BN_ID":926,"OTHR_CNTR_":"F","Shape_Leng":13509.786717568601},"geometry":{"type":"MultiLineString","coordinates":[[[5723795.0,2269103.0],[5716920.0,2257473.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":927,"LEVL_CODE":0,"NUTS_BN_ID":927,"OTHR_CNTR_":"F","Shape_Leng":86425.259359557502},"geometry":{"type":"MultiLineString","coordinates":[[[5804913.0,2276443.0],[5768426.0,2258661.0],[5723795.0,2269103.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":939,"LEVL_CODE":0,"NUTS_BN_ID":939,"OTHR_CNTR_":"F","Shape_Leng":32879.673925276198},"geometry":{"type":"MultiLineString","coordinates":[[[5384665.0,2193093.0],[5353217.0,2202689.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":963,"LEVL_CODE":0,"NUTS_BN_ID":963,"OTHR_CNTR_":"F","Shape_Leng":21176.452507217102},"geometry":{"type":"MultiLineString","coordinates":[[[5353217.0,2202689.0],[5338320.0,2217739.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":989,"LEVL_CODE":0,"NUTS_BN_ID":989,"OTHR_CNTR_":"F","Shape_Leng":16568.126822177201},"geometry":{"type":"MultiLineString","coordinates":[[[5014574.0,2200025.0],[5023279.0,2185928.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1003,"LEVL_CODE":0,"NUTS_BN_ID":1003,"OTHR_CNTR_":"F","Shape_Leng":45303.9282346443},"geometry":{"type":"MultiLineString","coordinates":[[[5338320.0,2217739.0],[5351627.0,2238987.0],[5340815.0,2256089.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1034,"LEVL_CODE":0,"NUTS_BN_ID":1034,"OTHR_CNTR_":"F","Shape_Leng":46570.881232747102},"geometry":{"type":"MultiLineString","coordinates":[[[5340815.0,2256089.0],[5336281.0,2275236.0],[5341408.0,2280945.0],[5359818.0,2286469.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1122,"LEVL_CODE":0,"NUTS_BN_ID":1122,"OTHR_CNTR_":"F","Shape_Leng":39875.091814906897},"geometry":{"type":"MultiLineString","coordinates":[[[5359818.0,2286469.0],[5375158.0,2323275.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1160,"LEVL_CODE":0,"NUTS_BN_ID":1160,"OTHR_CNTR_":"F","Shape_Leng":29904.374626300501},"geometry":{"type":"MultiLineString","coordinates":[[[5375158.0,2323275.0],[5351004.0,2340907.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1164,"LEVL_CODE":0,"NUTS_BN_ID":1164,"OTHR_CNTR_":"F","Shape_Leng":110209.7703527394},"geometry":{"type":"MultiLineString","coordinates":[[[5351004.0,2340907.0],[5344289.0,2341573.0],[5312546.0,2382010.0],[5322636.0,2410289.0],[5330612.0,2430822.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1403,"LEVL_CODE":0,"NUTS_BN_ID":1403,"OTHR_CNTR_":"F","Shape_Leng":109539.40792582621},"geometry":{"type":"MultiLineString","coordinates":[[[5272190.0,2464261.0],[5271841.0,2464555.0],[5217048.0,2480558.0],[5231715.0,2490409.0],[5220467.0,2522847.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1425,"LEVL_CODE":0,"NUTS_BN_ID":1425,"OTHR_CNTR_":"F","Shape_Leng":134963.85114560041},"geometry":{"type":"MultiLineString","coordinates":[[[5330612.0,2430822.0],[5309060.0,2455533.0],[5326140.0,2473746.0],[5305511.0,2482800.0],[5285606.0,2452111.0],[5272190.0,2464261.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1507,"LEVL_CODE":0,"NUTS_BN_ID":1507,"OTHR_CNTR_":"F","Shape_Leng":103676.92447811049},"geometry":{"type":"MultiLineString","coordinates":[[[5024714.0,2522875.0],[5060947.0,2497458.0],[5034796.0,2491696.0],[5033462.0,2459084.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1538,"LEVL_CODE":0,"NUTS_BN_ID":1538,"OTHR_CNTR_":"F","Shape_Leng":145923.30643980601},"geometry":{"type":"MultiLineString","coordinates":[[[5220467.0,2522847.0],[5182475.0,2531852.0],[5147918.0,2579517.0],[5112370.0,2611778.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1584,"LEVL_CODE":0,"NUTS_BN_ID":1584,"OTHR_CNTR_":"F","Shape_Leng":55693.924140057199},"geometry":{"type":"MultiLineString","coordinates":[[[5009623.0,2575456.0],[5026320.0,2528867.0],[5024714.0,2522875.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1693,"LEVL_CODE":0,"NUTS_BN_ID":1693,"OTHR_CNTR_":"F","Shape_Leng":70670.718762304401},"geometry":{"type":"MultiLineString","coordinates":[[[5068154.0,2612699.0],[5040492.0,2587133.0],[5009623.0,2575456.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"T","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":1732,"LEVL_CODE":0,"NUTS_BN_ID":1732,"OTHR_CNTR_":"F","Shape_Leng":44476.627850147503},"geometry":{"type":"MultiLineString","coordinates":[[[5112370.0,2611778.0],[5081487.0,2610251.0],[5068154.0,2612699.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1676,"LEVL_CODE":0,"NUTS_BN_ID":1676,"OTHR_CNTR_":"F","Shape_Leng":63629.629471327302},"geometry":{"type":"MultiLineString","coordinates":[[[4155108.0,2536148.0],[4091540.0,2538951.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1677,"LEVL_CODE":0,"NUTS_BN_ID":1677,"OTHR_CNTR_":"F","Shape_Leng":1519.7541382918},"geometry":{"type":"MultiLineString","coordinates":[[[4156153.0,2537251.0],[4155108.0,2536148.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1717,"LEVL_CODE":0,"NUTS_BN_ID":1717,"OTHR_CNTR_":"F","Shape_Leng":33386.054446337002},"geometry":{"type":"MultiLineString","coordinates":[[[4236365.0,2524806.0],[4221437.0,2554668.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1739,"LEVL_CODE":0,"NUTS_BN_ID":1739,"OTHR_CNTR_":"F","Shape_Leng":52632.082738888799},"geometry":{"type":"MultiLineString","coordinates":[[[4256007.0,2562205.0],[4242493.0,2540466.0],[4250195.0,2531997.0],[4236365.0,2524806.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1747,"LEVL_CODE":0,"NUTS_BN_ID":1747,"OTHR_CNTR_":"F","Shape_Leng":9908.1862922516993},"geometry":{"type":"MultiLineString","coordinates":[[[4262968.0,2569255.0],[4256007.0,2562205.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1768,"LEVL_CODE":0,"NUTS_BN_ID":1768,"OTHR_CNTR_":"F","Shape_Leng":40324.389042559698},"geometry":{"type":"MultiLineString","coordinates":[[[4029619.0,2585046.0],[4036241.0,2577170.0],[4008291.0,2566177.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1769,"LEVL_CODE":0,"NUTS_BN_ID":1769,"OTHR_CNTR_":"F","Shape_Leng":24350.830847830399},"geometry":{"type":"MultiLineString","coordinates":[[[4008291.0,2566177.0],[4022416.0,2586012.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1792,"LEVL_CODE":0,"NUTS_BN_ID":1792,"OTHR_CNTR_":"F","Shape_Leng":11983.521747275399},"geometry":{"type":"MultiLineString","coordinates":[[[4022416.0,2586012.0],[4018233.0,2597242.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1796,"LEVL_CODE":0,"NUTS_BN_ID":1796,"OTHR_CNTR_":"F","Shape_Leng":49472.122971994198},"geometry":{"type":"MultiLineString","coordinates":[[[4076473.0,2595666.0],[4031470.0,2588477.0],[4030650.0,2586945.0],[4029619.0,2585046.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1797,"LEVL_CODE":0,"NUTS_BN_ID":1797,"OTHR_CNTR_":"F","Shape_Leng":62860.444807008098},"geometry":{"type":"MultiLineString","coordinates":[[[4091540.0,2538951.0],[4073357.0,2563527.0],[4076473.0,2595666.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1806,"LEVL_CODE":0,"NUTS_BN_ID":1806,"OTHR_CNTR_":"F","Shape_Leng":70247.625303483597},"geometry":{"type":"MultiLineString","coordinates":[[[4196777.0,2594561.0],[4156153.0,2537251.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1807,"LEVL_CODE":0,"NUTS_BN_ID":1807,"OTHR_CNTR_":"F","Shape_Leng":46899.352576335201},"geometry":{"type":"MultiLineString","coordinates":[[[4221437.0,2554668.0],[4196777.0,2594561.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1821,"LEVL_CODE":0,"NUTS_BN_ID":1821,"OTHR_CNTR_":"F","Shape_Leng":16698.742054159098},"geometry":{"type":"MultiLineString","coordinates":[[[4018233.0,2597242.0],[4024714.0,2612632.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1827,"LEVL_CODE":0,"NUTS_BN_ID":1827,"OTHR_CNTR_":"F","Shape_Leng":110240.6103465148},"geometry":{"type":"MultiLineString","coordinates":[[[4355774.0,2602037.0],[4339774.0,2612112.0],[4298949.0,2575548.0],[4262968.0,2569255.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1870,"LEVL_CODE":0,"NUTS_BN_ID":1870,"OTHR_CNTR_":"F","Shape_Leng":40862.294001930699},"geometry":{"type":"MultiLineString","coordinates":[[[4024714.0,2612632.0],[4050889.0,2644010.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1873,"LEVL_CODE":0,"NUTS_BN_ID":1873,"OTHR_CNTR_":"F","Shape_Leng":36030.996801353504},"geometry":{"type":"MultiLineString","coordinates":[[[4356849.0,2638051.0],[4355774.0,2602037.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1908,"LEVL_CODE":0,"NUTS_BN_ID":1908,"OTHR_CNTR_":"F","Shape_Leng":42248.688482064201},"geometry":{"type":"MultiLineString","coordinates":[[[4356849.0,2638051.0],[4350635.0,2654190.0],[4332067.0,2637516.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1926,"LEVL_CODE":0,"NUTS_BN_ID":1926,"OTHR_CNTR_":"F","Shape_Leng":47141.024499445899},"geometry":{"type":"MultiLineString","coordinates":[[[4332067.0,2637516.0],[4291125.0,2660883.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1946,"LEVL_CODE":0,"NUTS_BN_ID":1946,"OTHR_CNTR_":"F","Shape_Leng":10145.9515795154},"geometry":{"type":"MultiLineString","coordinates":[[[4291125.0,2660883.0],[4292202.0,2670972.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1953,"LEVL_CODE":0,"NUTS_BN_ID":1953,"OTHR_CNTR_":"F","Shape_Leng":46185.407161197902},"geometry":{"type":"MultiLineString","coordinates":[[[4050889.0,2644010.0],[4082731.0,2677464.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":1978,"LEVL_CODE":0,"NUTS_BN_ID":1978,"OTHR_CNTR_":"F","Shape_Leng":14865.4795551021},"geometry":{"type":"MultiLineString","coordinates":[[[4292202.0,2670972.0],[4285464.0,2684223.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2018,"LEVL_CODE":0,"NUTS_BN_ID":2018,"OTHR_CNTR_":"F","Shape_Leng":48920.379314239697},"geometry":{"type":"MultiLineString","coordinates":[[[4082731.0,2677464.0],[4098860.0,2696644.0],[4085162.0,2698173.0],[4090009.0,2707008.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2022,"LEVL_CODE":0,"NUTS_BN_ID":2022,"OTHR_CNTR_":"F","Shape_Leng":24494.560954525001},"geometry":{"type":"MultiLineString","coordinates":[[[4119244.0,2706559.0],[4123319.0,2705528.0],[4126410.0,2707031.0],[4128268.0,2708672.0],[4133384.0,2713040.0],[4136939.0,2719812.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2048,"LEVL_CODE":0,"NUTS_BN_ID":2048,"OTHR_CNTR_":"F","Shape_Leng":16341.052272279199},"geometry":{"type":"MultiLineString","coordinates":[[[4090009.0,2707008.0],[4104717.0,2714129.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2049,"LEVL_CODE":0,"NUTS_BN_ID":2049,"OTHR_CNTR_":"F","Shape_Leng":16381.3959318873},"geometry":{"type":"MultiLineString","coordinates":[[[4104717.0,2714129.0],[4119244.0,2706559.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2054,"LEVL_CODE":0,"NUTS_BN_ID":2054,"OTHR_CNTR_":"F","Shape_Leng":36186.6586538345},"geometry":{"type":"MultiLineString","coordinates":[[[4285464.0,2684223.0],[4296317.0,2696489.0],[4287757.0,2714352.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2058,"LEVL_CODE":0,"NUTS_BN_ID":2058,"OTHR_CNTR_":"F","Shape_Leng":4871.8305353740998},"geometry":{"type":"MultiLineString","coordinates":[[[4283009.0,2715445.0],[4287757.0,2714352.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2061,"LEVL_CODE":0,"NUTS_BN_ID":2061,"OTHR_CNTR_":"F","Shape_Leng":6470.4578951140002},"geometry":{"type":"MultiLineString","coordinates":[[[4142867.0,2719236.0],[4148793.0,2716636.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2073,"LEVL_CODE":0,"NUTS_BN_ID":2073,"OTHR_CNTR_":"F","Shape_Leng":14542.3521421717},"geometry":{"type":"MultiLineString","coordinates":[[[4148793.0,2716636.0],[4162515.0,2721450.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2074,"LEVL_CODE":0,"NUTS_BN_ID":2074,"OTHR_CNTR_":"F","Shape_Leng":40129.427729307703},"geometry":{"type":"MultiLineString","coordinates":[[[4162515.0,2721450.0],[4202526.0,2718363.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2078,"LEVL_CODE":0,"NUTS_BN_ID":2078,"OTHR_CNTR_":"F","Shape_Leng":3795.0535619982002},"geometry":{"type":"MultiLineString","coordinates":[[[4136939.0,2719812.0],[4139577.0,2722540.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2079,"LEVL_CODE":0,"NUTS_BN_ID":2079,"OTHR_CNTR_":"F","Shape_Leng":4662.7977602054998},"geometry":{"type":"MultiLineString","coordinates":[[[4139577.0,2722540.0],[4142867.0,2719236.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2083,"LEVL_CODE":0,"NUTS_BN_ID":2083,"OTHR_CNTR_":"F","Shape_Leng":20513.387976442398},"geometry":{"type":"MultiLineString","coordinates":[[[4202526.0,2718363.0],[4212861.0,2721696.0],[4215338.0,2722328.0],[4216277.0,2729363.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2103,"LEVL_CODE":0,"NUTS_BN_ID":2103,"OTHR_CNTR_":"F","Shape_Leng":26285.271412136899},"geometry":{"type":"MultiLineString","coordinates":[[[4259528.0,2727259.0],[4283009.0,2715445.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2104,"LEVL_CODE":0,"NUTS_BN_ID":2104,"OTHR_CNTR_":"F","Shape_Leng":40628.598798557403},"geometry":{"type":"MultiLineString","coordinates":[[[4225458.0,2731829.0],[4230515.0,2729845.0],[4234131.0,2733862.0],[4236440.0,2727571.0],[4259528.0,2727259.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2138,"LEVL_CODE":0,"NUTS_BN_ID":2138,"OTHR_CNTR_":"F","Shape_Leng":17745.669352119799},"geometry":{"type":"MultiLineString","coordinates":[[[4216993.0,2744071.0],[4226479.0,2738491.0],[4225458.0,2731829.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2143,"LEVL_CODE":0,"NUTS_BN_ID":2143,"OTHR_CNTR_":"F","Shape_Leng":13934.191028421399},"geometry":{"type":"MultiLineString","coordinates":[[[4216277.0,2729363.0],[4209278.0,2741412.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":2149,"LEVL_CODE":0,"NUTS_BN_ID":2149,"OTHR_CNTR_":"F","Shape_Leng":8160.1806475003004},"geometry":{"type":"MultiLineString","coordinates":[[[4209278.0,2741412.0],[4216993.0,2744071.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5007,"LEVL_CODE":0,"NUTS_BN_ID":5007,"OTHR_CNTR_":"F","Shape_Leng":51621.739300586603},"geometry":{"type":"MultiLineString","coordinates":[[[4425446.0,4016571.0],[4415255.0,3979676.0],[4405150.0,3988392.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5063,"LEVL_CODE":0,"NUTS_BN_ID":5063,"OTHR_CNTR_":"F","Shape_Leng":68801.221951696294},"geometry":{"type":"MultiLineString","coordinates":[[[4429455.0,4078126.0],[4430488.0,4067492.0],[4416745.0,4055462.0],[4425446.0,4016571.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5075,"LEVL_CODE":0,"NUTS_BN_ID":5075,"OTHR_CNTR_":"F","Shape_Leng":7442.9923161778997},"geometry":{"type":"MultiLineString","coordinates":[[[4424394.0,4083583.0],[4429455.0,4078126.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5240,"LEVL_CODE":0,"NUTS_BN_ID":5240,"OTHR_CNTR_":"F","Shape_Leng":177227.80409932791},"geometry":{"type":"MultiLineString","coordinates":[[[4465658.0,4219983.0],[4441655.0,4214384.0],[4464588.0,4159552.0],[4460399.0,4113247.0],[4424394.0,4083583.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5294,"LEVL_CODE":0,"NUTS_BN_ID":5294,"OTHR_CNTR_":"F","Shape_Leng":152586.63561240779},"geometry":{"type":"MultiLineString","coordinates":[[[4440905.0,4353715.0],[4434431.0,4293128.0],[4475081.0,4253757.0],[4465658.0,4219983.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5301,"LEVL_CODE":0,"NUTS_BN_ID":5301,"OTHR_CNTR_":"F","Shape_Leng":7431.0427462410998},"geometry":{"type":"MultiLineString","coordinates":[[[4438332.0,4360687.0],[4440905.0,4353715.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5347,"LEVL_CODE":0,"NUTS_BN_ID":5347,"OTHR_CNTR_":"F","Shape_Leng":98719.750709303204},"geometry":{"type":"MultiLineString","coordinates":[[[4424849.0,4454897.0],[4433924.0,4434852.0],[4427029.0,4391528.0],[4438332.0,4360687.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5462,"LEVL_CODE":0,"NUTS_BN_ID":5462,"OTHR_CNTR_":"F","Shape_Leng":306189.74479239428},"geometry":{"type":"MultiLineString","coordinates":[[[4525408.0,4674222.0],[4497099.0,4612832.0],[4520053.0,4601028.0],[4524051.0,4571569.0],[4516074.0,4550329.0],[4453145.0,4543591.0],[4428268.0,4500546.0],[4420622.0,4464294.0],[4424849.0,4454897.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5510,"LEVL_CODE":0,"NUTS_BN_ID":5510,"OTHR_CNTR_":"F","Shape_Leng":162243.60435138081},"geometry":{"type":"MultiLineString","coordinates":[[[4566979.0,4813266.0],[4526441.0,4786755.0],[4533981.0,4751667.0],[4525408.0,4674222.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5550,"LEVL_CODE":0,"NUTS_BN_ID":5550,"OTHR_CNTR_":"F","Shape_Leng":322545.20629726647},"geometry":{"type":"MultiLineString","coordinates":[[[4655620.0,5065449.0],[4661539.0,5028564.0],[4654289.0,5002181.0],[4626402.0,5015720.0],[4585963.0,4945173.0],[4601135.0,4893950.0],[4562219.0,4828331.0],[4566979.0,4813266.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5572,"LEVL_CODE":0,"NUTS_BN_ID":5572,"OTHR_CNTR_":"F","Shape_Leng":178195.1201799117},"geometry":{"type":"MultiLineString","coordinates":[[[4744758.0,5136005.0],[4725556.0,5131514.0],[4741022.0,5106618.0],[4732172.0,5055416.0],[4655620.0,5065449.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5576,"LEVL_CODE":0,"NUTS_BN_ID":5576,"OTHR_CNTR_":"F","Shape_Leng":79027.000339650607},"geometry":{"type":"MultiLineString","coordinates":[[[4744758.0,5136005.0],[4768728.0,5168051.0],[4801470.0,5146847.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"T","EU_FLAG":"T","FID":5591,"LEVL_CODE":0,"NUTS_BN_ID":5591,"OTHR_CNTR_":"F","Shape_Leng":505785.09845150443},"geometry":{"type":"MultiLineString","coordinates":[[[4801470.0,5146847.0],[4824763.0,5110984.0],[4930205.0,5113908.0],[4952288.0,5171648.0],[4942786.0,5196216.0],[4939869.0,5245944.0],[5006583.0,5299184.0],[5074900.0,5256632.0],[5067030.0,5211946.0],[5073773.0,5207018.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5637,"LEVL_CODE":0,"NUTS_BN_ID":5637,"OTHR_CNTR_":"F","Shape_Leng":13143.3276541672},"geometry":{"type":"MultiLineString","coordinates":[[[3829392.0,3097021.0],[3817785.0,3090854.0]]]}},{"type":"Feature","properties":{"CC_FLAG":"F","COAS_FLAG":"F","EFTA_FLAG":"F","EU_FLAG":"T","FID":5638,"LEVL_CODE":0,"NUTS_BN_ID":5638,"OTHR_CNTR_":"F","Shape_Leng":5655.6667789050998},"geometry":{"type":"MultiLineString","coordinates":[[[3835047.0,3097096.0],[3829392.0,3097021.0]]]}},{"type":"Feature","properties":{"id":10000},"geometry":{"type":"LineString","coordinates":[[6521849.653601857,2918896.9481791346],[6521849.653601857,3580497.914945308],[7210962.739778109,3580497.914945308],[7210962.739778109,2918896.9481791346],[6521849.653601857,2918896.9481791346]]}},{"type":"Feature","properties":{"id":10001},"geometry":{"type":"LineString","coordinates":[[6521849.653601857,2918896.9481791346],[6521849.653601857,3580497.914945308],[7210962.739778109,3580497.914945308],[7210962.739778109,2918896.9481791346],[6521849.653601857,2918896.9481791346]]}},{"type":"Feature","properties":{"id":10002},"geometry":{"type":"LineString","coordinates":[[6521849.653601857,3626881.5597064863],[6521849.653601857,4288482.52647266],[7210962.739778109,4288482.52647266],[7210962.739778109,3626881.5597064863],[6521849.653601857,3626881.5597064863]]}},{"type":"Feature","properties":{"id":10003},"geometry":{"type":"LineString","coordinates":[[6521849.653601857,3626881.5597064863],[6521849.653601857,4288482.52647266],[7210962.739778109,4288482.52647266],[7210962.739778109,3626881.5597064863],[6521849.653601857,3626881.5597064863]]}},{"type":"Feature","properties":{"id":10004},"geometry":{"type":"LineString","coordinates":[[6521849.653601857,4327253.4334754795],[6521849.653601857,4988854.4002416525],[7210962.739778109,4988854.4002416525],[7210962.739778109,4327253.4334754795],[6521849.653601857,4327253.4334754795]]}},{"type":"Feature","properties":{"id":10005},"geometry":{"type":"LineString","coordinates":[[6521849.653601857,4327253.4334754795],[6521849.653601857,4988854.4002416525],[7210962.739778109,4988854.4002416525],[7210962.739778109,4327253.4334754795],[6521849.653601857,4327253.4334754795]]}},{"type":"Feature","properties":{"id":10006},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,2918896.9481791346],[5775801.353282712,3580497.914945308],[6464914.439458964,3580497.914945308],[6464914.439458964,2918896.9481791346],[5775801.353282712,2918896.9481791346]]}},{"type":"Feature","properties":{"id":10007},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,2918896.9481791346],[5775801.353282712,3580497.914945308],[6464914.439458964,3580497.914945308],[6464914.439458964,2918896.9481791346],[5775801.353282712,2918896.9481791346]]}},{"type":"Feature","properties":{"id":10008},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,3626881.5597064863],[5775801.353282712,4288482.52647266],[6464914.439458964,4288482.52647266],[6464914.439458964,3626881.5597064863],[5775801.353282712,3626881.5597064863]]}},{"type":"Feature","properties":{"id":10009},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,3626881.5597064863],[5775801.353282712,4288482.52647266],[6464914.439458964,4288482.52647266],[6464914.439458964,3626881.5597064863],[5775801.353282712,3626881.5597064863]]}},{"type":"Feature","properties":{"id":10010},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,4327253.4334754795],[5775801.353282712,4988854.4002416525],[6464914.439458964,4988854.4002416525],[6464914.439458964,4327253.4334754795],[5775801.353282712,4327253.4334754795]]}},{"type":"Feature","properties":{"id":10011},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,4327253.4334754795],[5775801.353282712,4988854.4002416525],[6464914.439458964,4988854.4002416525],[6464914.439458964,4327253.4334754795],[5775801.353282712,4327253.4334754795]]}},{"type":"Feature","properties":{"id":10012},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,5027625.307244472],[5775801.353282712,5689226.274010646],[6464914.439458964,5689226.274010646],[6464914.439458964,5027625.307244472],[5775801.353282712,5027625.307244472]]}},{"type":"Feature","properties":{"id":10013},"geometry":{"type":"LineString","coordinates":[[5775801.353282712,5027625.307244472],[5775801.353282712,5689226.274010646],[6464914.439458964,5689226.274010646],[6464914.439458964,5027625.307244472],[5775801.353282712,5027625.307244472]]}},{"type":"Feature","properties":{"id":10014},"geometry":{"type":"LineString","coordinates":[[5496224.0,1816735.0],[5494944.0,1845212.0],[5547412.0,1825536.0],[5543952.0,1811812.0],[5515660.0,1803759.0]]}},{"type":"Feature","properties":{"id":10015},"geometry":{"type":"LineString","coordinates":[[4840159.0,1733790.0],[4863490.0,1769259.0]]}},{"type":"Feature","properties":{"id":10016},"geometry":{"type":"LineString","coordinates":[[3447421.0,1813123.0],[3460823.0,1791282.0],[3406426.0,1762028.0],[3370291.0,1707909.0]]}},{"type":"Feature","properties":{"id":10017},"geometry":{"type":"LineString","coordinates":[[5238463.0,1778736.0],[5241114.0,1811624.0],[5253416.0,1823474.0],[5267790.0,1797657.0],[5238463.0,1778736.0]]}},{"type":"Feature","properties":{"id":10018},"geometry":{"type":"LineString","coordinates":[[4921369.0,1787170.0],[4909333.0,1781128.0],[4895576.0,1760870.0],[4898486.0,1734482.0]]}},{"type":"Feature","properties":{"id":10019},"geometry":{"type":"LineString","coordinates":[[5445167.0,1861252.0],[5433921.0,1841243.0],[5488623.0,1818402.0]]}},{"type":"Feature","properties":{"id":10020},"geometry":{"type":"LineString","coordinates":[[5359044.0,1779807.0],[5303207.0,1769046.0],[5258027.0,1819145.0],[5284757.0,1843548.0]]}},{"type":"Feature","properties":{"id":10021},"geometry":{"type":"LineString","coordinates":[[4863490.0,1769259.0],[4851084.0,1794642.0]]}},{"type":"Feature","properties":{"id":10022},"geometry":{"type":"LineString","coordinates":[[2694644.0,1915722.0],[2656160.0,1919938.0],[2640741.0,1957902.0],[2650546.0,1988702.0]]}},{"type":"Feature","properties":{"id":10023},"geometry":{"type":"LineString","coordinates":[[3548589.0,1799186.0],[3560772.0,1820485.0],[3588739.0,1813044.0],[3569607.0,1788721.0],[3548589.0,1799186.0]]}},{"type":"Feature","properties":{"id":10024},"geometry":{"type":"LineString","coordinates":[[5836588.0,1816074.0],[5758196.0,1845970.0],[5780871.0,1907185.0],[5765134.0,1947265.0]]}},{"type":"Feature","properties":{"id":10025},"geometry":{"type":"LineString","coordinates":[[5284757.0,1843548.0],[5249808.0,1838938.0],[5227287.0,1860860.0]]}},{"type":"Feature","properties":{"id":10026},"geometry":{"type":"LineString","coordinates":[[5513241.0,1887784.0],[5538367.0,1912122.0],[5541785.0,1880286.0],[5525805.0,1866517.0],[5513241.0,1887784.0]]}},{"type":"Feature","properties":{"id":10027},"geometry":{"type":"LineString","coordinates":[[5687318.0,1933626.0],[5690806.0,1942674.0],[5729877.0,1958322.0],[5741416.0,1940614.0],[5740734.0,1920089.0],[5717914.0,1918179.0],[5714085.0,1937831.0],[5703903.0,1925096.0],[5687318.0,1933626.0]]}},{"type":"Feature","properties":{"id":10028},"geometry":{"type":"LineString","coordinates":[[4199980.0,1764520.0],[4178712.0,1777248.0],[4181882.0,1818822.0]]}},{"type":"Feature","properties":{"id":10029},"geometry":{"type":"LineString","coordinates":[[4927897.0,1849465.0],[4939271.0,1802361.0],[4921369.0,1787170.0]]}},{"type":"Feature","properties":{"id":10030},"geometry":{"type":"LineString","coordinates":[[5765134.0,1947265.0],[5760725.0,1983692.0],[5744714.0,1984965.0]]}},{"type":"Feature","properties":{"id":10031},"geometry":{"type":"LineString","coordinates":[[4290842.0,1828772.0],[4279336.0,1788231.0],[4199980.0,1764520.0]]}},{"type":"Feature","properties":{"id":10032},"geometry":{"type":"LineString","coordinates":[[5430523.0,1929121.0],[5449490.0,1907782.0],[5445167.0,1861252.0]]}},{"type":"Feature","properties":{"id":10033},"geometry":{"type":"LineString","coordinates":[[5227287.0,1860860.0],[5181590.0,1901159.0]]}},{"type":"Feature","properties":{"id":10034},"geometry":{"type":"LineString","coordinates":[[4181882.0,1818822.0],[4191866.0,1848045.0]]}},{"type":"Feature","properties":{"id":10035},"geometry":{"type":"LineString","coordinates":[[3445578.0,1906511.0],[3431718.0,1869960.0],[3447421.0,1813123.0]]}},{"type":"Feature","properties":{"id":10036},"geometry":{"type":"LineString","coordinates":[[2650546.0,1988702.0],[2699298.0,2054639.0]]}},{"type":"Feature","properties":{"id":10037},"geometry":{"type":"LineString","coordinates":[[5140741.0,1905524.0],[5160423.0,1916811.0],[5173007.0,1910016.0],[5172421.0,1885690.0],[5159431.0,1883576.0],[5140741.0,1905524.0]]}},{"type":"Feature","properties":{"id":10038},"geometry":{"type":"LineString","coordinates":[[4851084.0,1794642.0],[4815169.0,1888735.0]]}},{"type":"Feature","properties":{"id":10039},"geometry":{"type":"LineString","coordinates":[[3666500.0,1865968.0],[3700964.0,1891478.0],[3722706.0,1898039.0],[3731041.0,1879795.0],[3748221.0,1879825.0],[3756255.0,1864875.0],[3734531.0,1834378.0],[3718504.0,1825569.0],[3697085.0,1838182.0],[3685691.0,1861506.0],[3675220.0,1850664.0],[3666500.0,1865968.0]]}},{"type":"Feature","properties":{"id":10040},"geometry":{"type":"LineString","coordinates":[[5402932.0,1966144.0],[5430523.0,1929121.0]]}},{"type":"Feature","properties":{"id":10041},"geometry":{"type":"LineString","coordinates":[[4815169.0,1888735.0],[4804764.0,1901170.0]]}},{"type":"Feature","properties":{"id":10042},"geometry":{"type":"LineString","coordinates":[[2699298.0,2054639.0],[2718975.0,2084387.0]]}},{"type":"Feature","properties":{"id":10043},"geometry":{"type":"LineString","coordinates":[[5597467.0,2004466.0],[5620095.0,2016374.0],[5628488.0,1983296.0],[5601725.0,1984453.0],[5597467.0,2004466.0]]}},{"type":"Feature","properties":{"id":10044},"geometry":{"type":"LineString","coordinates":[[5745263.0,1470712.0],[5684918.0,1454671.0],[5668626.0,1466863.0]]}},{"type":"Feature","properties":{"id":10045},"geometry":{"type":"LineString","coordinates":[[5668626.0,1466863.0],[5627846.0,1468434.0]]}},{"type":"Feature","properties":{"id":10046},"geometry":{"type":"LineString","coordinates":[[5733951.0,1502942.0],[5800945.0,1502612.0],[5795153.0,1485787.0],[5745263.0,1470712.0]]}},{"type":"Feature","properties":{"id":10047},"geometry":{"type":"LineString","coordinates":[[3135235.0,1459882.0],[3137231.0,1462499.0],[3137739.0,1461779.0],[3137650.0,1461082.0],[3138660.0,1459316.0],[3138269.0,1459154.0],[3138029.0,1458218.0],[3138377.0,1457597.0]]}},{"type":"Feature","properties":{"id":10048},"geometry":{"type":"LineString","coordinates":[[5627380.0,1488246.0],[5681342.0,1504585.0]]}},{"type":"Feature","properties":{"id":10049},"geometry":{"type":"LineString","coordinates":[[5681342.0,1504585.0],[5733951.0,1502942.0]]}},{"type":"Feature","properties":{"id":10050},"geometry":{"type":"LineString","coordinates":[[6357016.0,1609133.0],[6357268.0,1635313.0],[6400291.0,1678043.0],[6483594.0,1715913.0],[6487898.0,1674176.0],[6467380.0,1643362.0],[6413299.0,1602176.0],[6378263.0,1596715.0],[6357016.0,1609133.0]]}},{"type":"Feature","properties":{"id":10051},"geometry":{"type":"LineString","coordinates":[[5627846.0,1468434.0],[5568031.0,1465584.0],[5558465.0,1476241.0],[5564777.0,1492092.0],[5603985.0,1506606.0],[5627380.0,1488246.0]]}},{"type":"Feature","properties":{"id":10052},"geometry":{"type":"LineString","coordinates":[[6513551.0,1741191.0],[6523476.0,1783397.0],[6543487.0,1781986.0],[6522804.0,1733815.0],[6513551.0,1741191.0]]}},{"type":"Feature","properties":{"id":10053},"geometry":{"type":"LineString","coordinates":[[2929630.0,1567616.0],[2930066.0,1567858.0],[2931211.0,1567705.0],[2932473.0,1566454.0],[2933353.0,1564854.0],[2934437.0,1565168.0],[2935189.0,1563889.0],[2936390.0,1564075.0],[2936894.0,1564789.0],[2937875.0,1565146.0],[2938533.0,1564338.0],[2938366.0,1563875.0],[2937579.0,1563526.0],[2935840.0,1563196.0],[2934673.0,1563596.0],[2933782.0,1562987.0],[2932890.0,1563032.0],[2932255.0,1562346.0]]}},{"type":"Feature","properties":{"id":10054},"geometry":{"type":"LineString","coordinates":[[4706799.0,1435254.0],[4721965.0,1456527.0],[4743978.0,1443103.0],[4725858.0,1418219.0],[4706799.0,1435254.0]]}},{"type":"Feature","properties":{"id":10055},"geometry":{"type":"LineString","coordinates":[[4700231.0,1455547.0],[4705401.0,1457903.0],[4716375.0,1452229.0],[4708696.0,1449147.0],[4700231.0,1455547.0]]}},{"type":"Feature","properties":{"id":10056},"geometry":{"type":"LineString","coordinates":[[2948814.0,1608502.0],[2938042.0,1592777.0]]}},{"type":"Feature","properties":{"id":10057},"geometry":{"type":"LineString","coordinates":[[5477582.0,1574866.0],[5504351.0,1579442.0],[5502336.0,1541086.0],[5482693.0,1550479.0],[5477582.0,1574866.0]]}},{"type":"Feature","properties":{"id":10058},"geometry":{"type":"LineString","coordinates":[[5913572.0,1634881.0],[5910781.0,1650777.0],[5942015.0,1672627.0],[5946892.0,1642818.0],[5932149.0,1617118.0],[5919815.0,1614900.0],[5913572.0,1634881.0]]}},{"type":"Feature","properties":{"id":10059},"geometry":{"type":"LineString","coordinates":[[5685436.0,1622599.0],[5704893.0,1640638.0],[5722954.0,1624872.0],[5716151.0,1602802.0],[5685436.0,1622599.0]]}},{"type":"Feature","properties":{"id":10060},"geometry":{"type":"LineString","coordinates":[[3087264.0,1629828.0],[3033302.0,1635461.0],[2948814.0,1608502.0]]}},{"type":"Feature","properties":{"id":10061},"geometry":{"type":"LineString","coordinates":[[6520093.0,1880306.0],[6475380.0,1850276.0],[6428169.0,1781894.0],[6340388.0,1747312.0]]}},{"type":"Feature","properties":{"id":10062},"geometry":{"type":"LineString","coordinates":[[3144923.0,1621046.0],[3123118.0,1624308.0],[3087264.0,1629828.0]]}},{"type":"Feature","properties":{"id":10063},"geometry":{"type":"LineString","coordinates":[[2936960.0,1593057.0],[2935430.0,1593683.0],[2930861.0,1595972.0],[2927031.0,1585948.0],[2912634.0,1582547.0],[2896409.0,1593440.0],[2888153.0,1605791.0],[2877072.0,1609937.0],[2853957.0,1668881.0],[2853476.0,1676544.0],[2862161.0,1681572.0]]}},{"type":"Feature","properties":{"id":10064},"geometry":{"type":"LineString","coordinates":[[6340388.0,1747312.0],[6263190.0,1781528.0],[6170186.0,1785985.0],[6153378.0,1775001.0],[6143638.0,1714867.0],[6095150.0,1686268.0],[6046337.0,1688778.0]]}},{"type":"Feature","properties":{"id":10065},"geometry":{"type":"LineString","coordinates":[[6604629.0,1929139.0],[6573381.0,1879906.0],[6520093.0,1880306.0]]}},{"type":"Feature","properties":{"id":10066},"geometry":{"type":"LineString","coordinates":[[4479218.0,1536458.0],[4487649.0,1545686.0],[4518352.0,1531189.0],[4500971.0,1507150.0],[4479218.0,1536458.0]]}},{"type":"Feature","properties":{"id":10067},"geometry":{"type":"LineString","coordinates":[[4771338.0,1529624.0],[4732533.0,1534570.0],[4710072.0,1558883.0]]}},{"type":"Feature","properties":{"id":10068},"geometry":{"type":"LineString","coordinates":[[4710072.0,1558883.0],[4682531.0,1568852.0]]}},{"type":"Feature","properties":{"id":10069},"geometry":{"type":"LineString","coordinates":[[5660024.0,1679253.0],[5666955.0,1699892.0],[5708788.0,1703806.0],[5716324.0,1677820.0],[5699206.0,1671426.0],[5689133.0,1687844.0],[5674014.0,1672224.0],[5660024.0,1679253.0]]}},{"type":"Feature","properties":{"id":10070},"geometry":{"type":"LineString","coordinates":[[2862161.0,1681572.0],[2817387.0,1732249.0],[2777974.0,1743032.0]]}},{"type":"Feature","properties":{"id":10071},"geometry":{"type":"LineString","coordinates":[[4775275.0,1602135.0],[4791106.0,1571966.0],[4771338.0,1529624.0]]}},{"type":"Feature","properties":{"id":10072},"geometry":{"type":"LineString","coordinates":[[3287209.0,1667565.0],[3270542.0,1648420.0],[3259019.0,1635252.0],[3236982.0,1610218.0],[3175488.0,1617311.0],[3144923.0,1621046.0]]}},{"type":"Feature","properties":{"id":10073},"geometry":{"type":"LineString","coordinates":[[5479066.0,1651168.0],[5483653.0,1616536.0],[5432891.0,1606388.0],[5401915.0,1625019.0],[5379500.0,1607847.0],[5359181.0,1668490.0]]}},{"type":"Feature","properties":{"id":10074},"geometry":{"type":"LineString","coordinates":[[5280023.0,1641772.0],[5311962.0,1661822.0],[5323298.0,1642764.0],[5297380.0,1628417.0],[5280023.0,1641772.0]]}},{"type":"Feature","properties":{"id":10075},"geometry":{"type":"LineString","coordinates":[[6046337.0,1688778.0],[5969219.0,1726746.0],[5921216.0,1702196.0],[5917612.0,1728640.0],[5867935.0,1731734.0],[5859175.0,1770512.0]]}},{"type":"Feature","properties":{"id":10076},"geometry":{"type":"LineString","coordinates":[[2777974.0,1743032.0],[2716790.0,1743704.0],[2650903.0,1770069.0],[2663467.0,1801242.0]]}},{"type":"Feature","properties":{"id":10077},"geometry":{"type":"LineString","coordinates":[[5510477.0,1702306.0],[5458096.0,1692110.0],[5479066.0,1651168.0]]}},{"type":"Feature","properties":{"id":10078},"geometry":{"type":"LineString","coordinates":[[4682531.0,1568852.0],[4578760.0,1616091.0]]}},{"type":"Feature","properties":{"id":10079},"geometry":{"type":"LineString","coordinates":[[5479887.0,1727657.0],[5488662.0,1713642.0]]}},{"type":"Feature","properties":{"id":10080},"geometry":{"type":"LineString","coordinates":[[5488662.0,1713642.0],[5499344.0,1717588.0],[5496203.0,1734035.0],[5506721.0,1735910.0],[5510477.0,1702306.0]]}},{"type":"Feature","properties":{"id":10081},"geometry":{"type":"LineString","coordinates":[[4787072.0,1652570.0],[4775275.0,1602135.0]]}},{"type":"Feature","properties":{"id":10082},"geometry":{"type":"LineString","coordinates":[[3370291.0,1707909.0],[3287209.0,1667565.0]]}},{"type":"Feature","properties":{"id":10083},"geometry":{"type":"LineString","coordinates":[[5752924.0,1769872.0],[5787230.0,1775005.0],[5780021.0,1792273.0],[5802592.0,1805812.0],[5817737.0,1795306.0],[5796629.0,1758861.0],[5759899.0,1755539.0],[5752924.0,1769872.0]]}},{"type":"Feature","properties":{"id":10084},"geometry":{"type":"LineString","coordinates":[[5859175.0,1770512.0],[5843581.0,1775483.0],[5836588.0,1816074.0]]}},{"type":"Feature","properties":{"id":10085},"geometry":{"type":"LineString","coordinates":[[5532122.0,1750830.0],[5524357.0,1759295.0]]}},{"type":"Feature","properties":{"id":10086},"geometry":{"type":"LineString","coordinates":[[5481335.0,1752736.0],[5479887.0,1727657.0]]}},{"type":"Feature","properties":{"id":10087},"geometry":{"type":"LineString","coordinates":[[5253064.0,1703315.0],[5262293.0,1724217.0],[5289612.0,1699542.0],[5283990.0,1683128.0],[5253064.0,1703315.0]]}},{"type":"Feature","properties":{"id":10088},"geometry":{"type":"LineString","coordinates":[[5524357.0,1759295.0],[5516523.0,1766109.0]]}},{"type":"Feature","properties":{"id":10089},"geometry":{"type":"LineString","coordinates":[[5516523.0,1766109.0],[5504508.0,1764940.0],[5481335.0,1752736.0]]}},{"type":"Feature","properties":{"id":10090},"geometry":{"type":"LineString","coordinates":[[4578760.0,1616091.0],[4556152.0,1622072.0],[4546804.0,1653886.0],[4584163.0,1667360.0]]}},{"type":"Feature","properties":{"id":10091},"geometry":{"type":"LineString","coordinates":[[5359181.0,1668490.0],[5339112.0,1689276.0],[5310700.0,1715306.0],[5319575.0,1743336.0]]}},{"type":"Feature","properties":{"id":10092},"geometry":{"type":"LineString","coordinates":[[5407983.0,1761674.0],[5474074.0,1763692.0]]}},{"type":"Feature","properties":{"id":10093},"geometry":{"type":"LineString","coordinates":[[4690793.0,1670055.0],[4792130.0,1692431.0],[4787072.0,1652570.0]]}},{"type":"Feature","properties":{"id":10094},"geometry":{"type":"LineString","coordinates":[[5474074.0,1763692.0],[5472996.0,1775581.0]]}},{"type":"Feature","properties":{"id":10095},"geometry":{"type":"LineString","coordinates":[[5558149.0,1782727.0],[5567323.0,1795253.0],[5601404.0,1793566.0],[5588763.0,1767929.0],[5558149.0,1782727.0]]}},{"type":"Feature","properties":{"id":10096},"geometry":{"type":"LineString","coordinates":[[4584163.0,1667360.0],[4605539.0,1685111.0],[4690793.0,1670055.0]]}},{"type":"Feature","properties":{"id":10097},"geometry":{"type":"LineString","coordinates":[[5319575.0,1743336.0],[5361530.0,1770217.0],[5407983.0,1761674.0]]}},{"type":"Feature","properties":{"id":10098},"geometry":{"type":"LineString","coordinates":[[5518880.0,1803024.0],[5546712.0,1796330.0],[5548723.0,1780525.0],[5560887.0,1739450.0],[5532122.0,1750830.0]]}},{"type":"Feature","properties":{"id":10099},"geometry":{"type":"LineString","coordinates":[[5515660.0,1803759.0],[5518880.0,1803024.0]]}},{"type":"Feature","properties":{"id":10100},"geometry":{"type":"LineString","coordinates":[[5472996.0,1775581.0],[5452024.0,1777729.0],[5424908.0,1788694.0]]}},{"type":"Feature","properties":{"id":10101},"geometry":{"type":"LineString","coordinates":[[5424908.0,1788694.0],[5376410.0,1784530.0],[5359044.0,1779807.0]]}},{"type":"Feature","properties":{"id":10102},"geometry":{"type":"LineString","coordinates":[[5233555.0,1743039.0],[5242977.0,1768759.0],[5258661.0,1773480.0],[5264108.0,1730539.0],[5233555.0,1743039.0]]}},{"type":"Feature","properties":{"id":10103},"geometry":{"type":"LineString","coordinates":[[4898486.0,1734482.0],[4836967.0,1669864.0],[4819544.0,1691929.0],[4840159.0,1733790.0]]}},{"type":"Feature","properties":{"id":10104},"geometry":{"type":"LineString","coordinates":[[2663467.0,1801242.0],[2669850.0,1828254.0],[2694644.0,1915722.0]]}},{"type":"Feature","properties":{"id":10105},"geometry":{"type":"LineString","coordinates":[[5488623.0,1818402.0],[5496224.0,1816735.0]]}},{"type":"Feature","properties":{"id":10106},"geometry":{"type":"LineString","coordinates":[[5699493.0,1861229.0],[5712726.0,1870825.0],[5727390.0,1868252.0],[5731824.0,1842012.0],[5722775.0,1822222.0],[5712642.0,1830971.0],[5716012.0,1847459.0],[5699493.0,1861229.0]]}},{"type":"Feature","properties":{"id":10107},"geometry":{"type":"LineString","coordinates":[[4637532.0,2021521.0],[4553746.0,2039279.0]]}},{"type":"Feature","properties":{"id":10108},"geometry":{"type":"LineString","coordinates":[[4826062.0,2056175.0],[4871067.0,2038145.0]]}},{"type":"Feature","properties":{"id":10109},"geometry":{"type":"LineString","coordinates":[[2761837.0,2178697.0],[2764565.0,2236104.0]]}},{"type":"Feature","properties":{"id":10110},"geometry":{"type":"LineString","coordinates":[[5826981.0,2233956.0],[5888007.0,2217366.0]]}},{"type":"Feature","properties":{"id":10111},"geometry":{"type":"LineString","coordinates":[[5119478.0,2069007.0],[5118781.0,2103409.0]]}},{"type":"Feature","properties":{"id":10112},"geometry":{"type":"LineString","coordinates":[[5824292.0,2234996.0],[5826981.0,2233956.0]]}},{"type":"Feature","properties":{"id":10113},"geometry":{"type":"LineString","coordinates":[[6090471.0,2253508.0],[6138407.0,2321628.0]]}},{"type":"Feature","properties":{"id":10114},"geometry":{"type":"LineString","coordinates":[[2764565.0,2236104.0],[2765263.0,2251929.0]]}},{"type":"Feature","properties":{"id":10115},"geometry":{"type":"LineString","coordinates":[[3718113.0,2089576.0],[3618795.0,2049424.0]]}},{"type":"Feature","properties":{"id":10116},"geometry":{"type":"LineString","coordinates":[[6409167.0,2417609.0],[6440998.0,2436614.0],[6484465.0,2407241.0],[6518512.0,2422758.0],[6554504.0,2413418.0]]}},{"type":"Feature","properties":{"id":10117},"geometry":{"type":"LineString","coordinates":[[5118781.0,2103409.0],[5114941.0,2120277.0],[5112297.0,2131908.0]]}},{"type":"Feature","properties":{"id":10118},"geometry":{"type":"LineString","coordinates":[[5112297.0,2131908.0],[5100057.0,2130794.0]]}},{"type":"Feature","properties":{"id":10119},"geometry":{"type":"LineString","coordinates":[[6138407.0,2321628.0],[6164278.0,2347358.0],[6183748.0,2366949.0]]}},{"type":"Feature","properties":{"id":10120},"geometry":{"type":"LineString","coordinates":[[2765263.0,2251929.0],[2767741.0,2281168.0]]}},{"type":"Feature","properties":{"id":10121},"geometry":{"type":"LineString","coordinates":[[4748384.0,2106071.0],[4824161.0,2109317.0],[4824850.0,2090224.0],[4826062.0,2056175.0]]}},{"type":"Feature","properties":{"id":10122},"geometry":{"type":"LineString","coordinates":[[5804913.0,2276443.0],[5816890.0,2250802.0],[5824292.0,2234996.0]]}},{"type":"Feature","properties":{"id":10123},"geometry":{"type":"LineString","coordinates":[[6183748.0,2366949.0],[6228778.0,2399837.0],[6297883.0,2416571.0]]}},{"type":"Feature","properties":{"id":10124},"geometry":{"type":"LineString","coordinates":[[6297883.0,2416571.0],[6356466.0,2443435.0],[6395524.0,2424239.0],[6409167.0,2417609.0]]}},{"type":"Feature","properties":{"id":10125},"geometry":{"type":"LineString","coordinates":[[4717677.0,2119916.0],[4748384.0,2106071.0]]}},{"type":"Feature","properties":{"id":10126},"geometry":{"type":"LineString","coordinates":[[4553746.0,2039279.0],[4513774.0,2073012.0],[4464783.0,2118744.0]]}},{"type":"Feature","properties":{"id":10127},"geometry":{"type":"LineString","coordinates":[[4271177.0,2084154.0],[4266689.0,2070300.0],[4257348.0,2041660.0],[4236116.0,2046353.0],[4228587.0,2070743.0],[4215930.0,2112204.0],[4206959.0,2141948.0]]}},{"type":"Feature","properties":{"id":10128},"geometry":{"type":"LineString","coordinates":[[4464783.0,2118744.0],[4440807.0,2142554.0]]}},{"type":"Feature","properties":{"id":10129},"geometry":{"type":"LineString","coordinates":[[5100057.0,2130794.0],[5023279.0,2185928.0]]}},{"type":"Feature","properties":{"id":10130},"geometry":{"type":"LineString","coordinates":[[3758413.0,2173293.0],[3745684.0,2120436.0],[3718113.0,2089576.0]]}},{"type":"Feature","properties":{"id":10131},"geometry":{"type":"LineString","coordinates":[[4671923.0,2158742.0],[4717677.0,2119916.0]]}},{"type":"Feature","properties":{"id":10132},"geometry":{"type":"LineString","coordinates":[[4826234.0,2163734.0],[4836438.0,2175422.0],[4857612.0,2174401.0],[4868898.0,2156199.0],[4844343.0,2151647.0],[4826234.0,2163734.0]]}},{"type":"Feature","properties":{"id":10133},"geometry":{"type":"LineString","coordinates":[[4662614.0,2167739.0],[4671923.0,2158742.0]]}},{"type":"Feature","properties":{"id":10134},"geometry":{"type":"LineString","coordinates":[[5612028.0,1767654.0],[5626905.0,1786614.0],[5646438.0,1779321.0],[5643831.0,1751145.0],[5612028.0,1767654.0]]}},{"type":"Feature","properties":{"id":10135},"geometry":{"type":"LineString","coordinates":[[2767741.0,2281168.0],[2785737.0,2329544.0],[2799517.0,2366661.0]]}},{"type":"Feature","properties":{"id":10136},"geometry":{"type":"LineString","coordinates":[[4206959.0,2141948.0],[4272738.0,2188027.0],[4271177.0,2084154.0]]}},{"type":"Feature","properties":{"id":10137},"geometry":{"type":"LineString","coordinates":[[3751465.0,2218748.0],[3750769.0,2202241.0],[3758413.0,2173293.0]]}},{"type":"Feature","properties":{"id":10138},"geometry":{"type":"LineString","coordinates":[[5771739.0,2366169.0],[5769660.0,2314718.0],[5794317.0,2287897.0],[5804913.0,2276443.0]]}},{"type":"Feature","properties":{"id":10139},"geometry":{"type":"LineString","coordinates":[[4641630.0,2206987.0],[4650922.0,2184703.0],[4662614.0,2167739.0]]}},{"type":"Feature","properties":{"id":10140},"geometry":{"type":"LineString","coordinates":[[5023279.0,2185928.0],[4972073.0,2210100.0],[4946488.0,2229853.0],[4940446.0,2234753.0]]}},{"type":"Feature","properties":{"id":10141},"geometry":{"type":"LineString","coordinates":[[4440807.0,2142554.0],[4378765.0,2204150.0]]}},{"type":"Feature","properties":{"id":10142},"geometry":{"type":"LineString","coordinates":[[4635294.0,2225750.0],[4641630.0,2206987.0]]}},{"type":"Feature","properties":{"id":10143},"geometry":{"type":"LineString","coordinates":[[2954462.0,2426795.0],[3048811.0,2413342.0],[3150432.0,2367562.0]]}},{"type":"Feature","properties":{"id":10144},"geometry":{"type":"LineString","coordinates":[[2799517.0,2366661.0],[2779357.0,2365202.0],[2768932.0,2408013.0],[2777570.0,2417447.0],[2793854.0,2435305.0],[2823821.0,2434649.0],[2849079.0,2434214.0],[2906665.0,2459936.0]]}},{"type":"Feature","properties":{"id":10145},"geometry":{"type":"LineString","coordinates":[[2906665.0,2459936.0],[2912845.0,2451347.0],[2954462.0,2426795.0]]}},{"type":"Feature","properties":{"id":10146},"geometry":{"type":"LineString","coordinates":[[5803878.0,2477397.0],[5805366.0,2442801.0],[5773956.0,2421445.0]]}},{"type":"Feature","properties":{"id":10147},"geometry":{"type":"LineString","coordinates":[[4577064.0,2298876.0],[4616324.0,2270014.0]]}},{"type":"Feature","properties":{"id":10148},"geometry":{"type":"LineString","coordinates":[[4112225.0,2294422.0],[4072166.0,2268613.0]]}},{"type":"Feature","properties":{"id":10149},"geometry":{"type":"LineString","coordinates":[[4121720.0,2300473.0],[4114290.0,2296841.0]]}},{"type":"Feature","properties":{"id":10150},"geometry":{"type":"LineString","coordinates":[[4345279.0,2274843.0],[4341817.0,2300678.0]]}},{"type":"Feature","properties":{"id":10151},"geometry":{"type":"LineString","coordinates":[[4808250.0,2285466.0],[4766933.0,2321857.0]]}},{"type":"Feature","properties":{"id":10152},"geometry":{"type":"LineString","coordinates":[[4170960.0,2316231.0],[4121720.0,2300473.0]]}},{"type":"Feature","properties":{"id":10153},"geometry":{"type":"LineString","coordinates":[[4749010.0,2330506.0],[4749261.0,2326769.0],[4749292.0,2326310.0],[4749538.0,2322638.0],[4749570.0,2322171.0],[4749610.0,2321563.0],[4749742.0,2319603.0],[4749967.0,2316250.0],[4750169.0,2313239.0],[4741378.0,2321524.0]]}},{"type":"Feature","properties":{"id":10154},"geometry":{"type":"LineString","coordinates":[[4766933.0,2321857.0],[4749010.0,2330506.0]]}},{"type":"Feature","properties":{"id":10155},"geometry":{"type":"LineString","coordinates":[[4542187.0,2321830.0],[4577064.0,2298876.0]]}},{"type":"Feature","properties":{"id":10156},"geometry":{"type":"LineString","coordinates":[[4341817.0,2300678.0],[4332539.0,2318420.0]]}},{"type":"Feature","properties":{"id":10157},"geometry":{"type":"LineString","coordinates":[[4332539.0,2318420.0],[4322508.0,2326071.0]]}},{"type":"Feature","properties":{"id":10158},"geometry":{"type":"LineString","coordinates":[[4940446.0,2234753.0],[4920628.0,2249011.0]]}},{"type":"Feature","properties":{"id":10159},"geometry":{"type":"LineString","coordinates":[[4886811.0,2231552.0],[4894495.0,2246522.0],[4909040.0,2248928.0],[4919648.0,2235888.0],[4916831.0,2223446.0],[4892341.0,2221846.0],[4886811.0,2231552.0]]}},{"type":"Feature","properties":{"id":10160},"geometry":{"type":"LineString","coordinates":[[4766843.0,2225618.0],[4774200.0,2232729.0],[4799661.0,2245652.0],[4812173.0,2241081.0],[4802010.0,2225570.0],[4783944.0,2217553.0],[4766843.0,2225618.0]]}},{"type":"Feature","properties":{"id":10161},"geometry":{"type":"LineString","coordinates":[[3771048.0,2258658.0],[3751465.0,2218748.0]]}},{"type":"Feature","properties":{"id":10162},"geometry":{"type":"LineString","coordinates":[[4625431.0,2250490.0],[4625722.0,2249913.0],[4626261.0,2248711.0],[4626751.0,2247578.0],[4627358.0,2246296.0],[4627654.0,2245721.0],[4628255.0,2244616.0],[4628558.0,2244105.0],[4629808.0,2240147.0],[4631030.0,2237181.0],[4631634.0,2236266.0],[4632308.0,2234299.0],[4633317.0,2232322.0],[4634480.0,2229759.0],[4634828.0,2228808.0],[4634998.0,2227229.0],[4635294.0,2225750.0]]}},{"type":"Feature","properties":{"id":10163},"geometry":{"type":"LineString","coordinates":[[5773956.0,2421445.0],[5771739.0,2366169.0]]}},{"type":"Feature","properties":{"id":10164},"geometry":{"type":"LineString","coordinates":[[3313142.0,2331293.0],[3340071.0,2326831.0],[3358654.0,2325035.0],[3367336.0,2324216.0]]}},{"type":"Feature","properties":{"id":10165},"geometry":{"type":"LineString","coordinates":[[3150432.0,2367562.0],[3241372.0,2352093.0],[3257970.0,2342918.0]]}},{"type":"Feature","properties":{"id":10166},"geometry":{"type":"LineString","coordinates":[[3257970.0,2342918.0],[3288670.0,2346256.0],[3313142.0,2331293.0]]}},{"type":"Feature","properties":{"id":10167},"geometry":{"type":"LineString","coordinates":[[3968344.0,2240335.0],[3853358.0,2279282.0]]}},{"type":"Feature","properties":{"id":10168},"geometry":{"type":"LineString","coordinates":[[4616324.0,2270014.0],[4625431.0,2250490.0]]}},{"type":"Feature","properties":{"id":10169},"geometry":{"type":"LineString","coordinates":[[4072166.0,2268613.0],[4032632.0,2234462.0],[3968344.0,2240335.0]]}},{"type":"Feature","properties":{"id":10170},"geometry":{"type":"LineString","coordinates":[[4920628.0,2249011.0],[4884346.0,2273303.0],[4808250.0,2285466.0]]}},{"type":"Feature","properties":{"id":10171},"geometry":{"type":"LineString","coordinates":[[3367336.0,2324216.0],[3391141.0,2340602.0]]}},{"type":"Feature","properties":{"id":10172},"geometry":{"type":"LineString","coordinates":[[3843685.0,2290547.0],[3798360.0,2270510.0],[3785158.0,2264760.0],[3771048.0,2258658.0]]}},{"type":"Feature","properties":{"id":10173},"geometry":{"type":"LineString","coordinates":[[3853358.0,2279282.0],[3843685.0,2290547.0]]}},{"type":"Feature","properties":{"id":10174},"geometry":{"type":"LineString","coordinates":[[4378765.0,2204150.0],[4345279.0,2274843.0]]}},{"type":"Feature","properties":{"id":10175},"geometry":{"type":"LineString","coordinates":[[3798550.0,1899270.0],[3820936.0,1909529.0],[3838965.0,1880982.0],[3821292.0,1875260.0],[3798550.0,1899270.0]]}},{"type":"Feature","properties":{"id":10176},"geometry":{"type":"LineString","coordinates":[[4889506.0,1916502.0],[4884048.0,1871924.0],[4927897.0,1849465.0]]}},{"type":"Feature","properties":{"id":10177},"geometry":{"type":"LineString","coordinates":[[4289165.0,1900466.0],[4290842.0,1828772.0]]}},{"type":"Feature","properties":{"id":10178},"geometry":{"type":"LineString","coordinates":[[5485349.0,2006014.0],[5514374.0,2008579.0],[5521544.0,1982032.0],[5497392.0,1981817.0],[5485349.0,2006014.0]]}},{"type":"Feature","properties":{"id":10179},"geometry":{"type":"LineString","coordinates":[[5647895.0,2032534.0],[5678158.0,2059037.0],[5686402.0,2038434.0],[5665549.0,2021394.0],[5647895.0,2032534.0]]}},{"type":"Feature","properties":{"id":10180},"geometry":{"type":"LineString","coordinates":[[5744714.0,1984965.0],[5715425.0,1972078.0],[5701752.0,1984521.0],[5693475.0,2016894.0],[5706752.0,2067184.0],[5801743.0,2084105.0]]}},{"type":"Feature","properties":{"id":10181},"geometry":{"type":"LineString","coordinates":[[5801743.0,2084105.0],[5854054.0,2107096.0]]}},{"type":"Feature","properties":{"id":10182},"geometry":{"type":"LineString","coordinates":[[4905973.0,1948907.0],[4889506.0,1916502.0]]}},{"type":"Feature","properties":{"id":10183},"geometry":{"type":"LineString","coordinates":[[4983094.0,1945003.0],[4905973.0,1948907.0]]}},{"type":"Feature","properties":{"id":10184},"geometry":{"type":"LineString","coordinates":[[4191866.0,1848045.0],[4189784.0,1901713.0],[4184513.0,1924933.0]]}},{"type":"Feature","properties":{"id":10185},"geometry":{"type":"LineString","coordinates":[[5854054.0,2107096.0],[5910778.0,2119688.0],[5920391.0,2131892.0]]}},{"type":"Feature","properties":{"id":10186},"geometry":{"type":"LineString","coordinates":[[5394172.0,2022670.0],[5390662.0,1986516.0],[5402932.0,1966144.0]]}},{"type":"Feature","properties":{"id":10187},"geometry":{"type":"LineString","coordinates":[[2718975.0,2084387.0],[2740606.0,2132542.0]]}},{"type":"Feature","properties":{"id":10188},"geometry":{"type":"LineString","coordinates":[[5009077.0,1972177.0],[5041303.0,1938835.0],[5035626.0,1904444.0],[5015703.0,1908574.0],[4983094.0,1945003.0]]}},{"type":"Feature","properties":{"id":10189},"geometry":{"type":"LineString","coordinates":[[3515777.0,1986675.0],[3445578.0,1906511.0]]}},{"type":"Feature","properties":{"id":10190},"geometry":{"type":"LineString","coordinates":[[5395086.0,2027025.0],[5394172.0,2022670.0]]}},{"type":"Feature","properties":{"id":10191},"geometry":{"type":"LineString","coordinates":[[5425133.0,2012116.0],[5395086.0,2027025.0]]}},{"type":"Feature","properties":{"id":10192},"geometry":{"type":"LineString","coordinates":[[5624704.0,2060110.0],[5629116.0,2079460.0],[5648199.0,2078565.0],[5653962.0,2058109.0],[5635578.0,2045419.0],[5624704.0,2060110.0]]}},{"type":"Feature","properties":{"id":10193},"geometry":{"type":"LineString","coordinates":[[5483053.0,2054452.0],[5480097.0,2017692.0],[5452305.0,2001760.0],[5425133.0,2012116.0]]}},{"type":"Feature","properties":{"id":10194},"geometry":{"type":"LineString","coordinates":[[4804764.0,1901170.0],[4756715.0,1912832.0],[4727078.0,1954207.0],[4701598.0,1960714.0]]}},{"type":"Feature","properties":{"id":10195},"geometry":{"type":"LineString","coordinates":[[5751529.0,2100720.0],[5730189.0,2106048.0]]}},{"type":"Feature","properties":{"id":10196},"geometry":{"type":"LineString","coordinates":[[5181590.0,1901159.0],[5179072.0,1902139.0],[5178247.0,1918572.0],[5166823.0,1934022.0],[5137989.0,1949342.0],[5110689.0,1998344.0]]}},{"type":"Feature","properties":{"id":10197},"geometry":{"type":"LineString","coordinates":[[4299705.0,1951217.0],[4289165.0,1900466.0]]}},{"type":"Feature","properties":{"id":10198},"geometry":{"type":"LineString","coordinates":[[5920391.0,2131892.0],[5917207.0,2145272.0],[5959377.0,2169198.0]]}},{"type":"Feature","properties":{"id":10199},"geometry":{"type":"LineString","coordinates":[[5730189.0,2106048.0],[5670221.0,2102712.0]]}},{"type":"Feature","properties":{"id":10200},"geometry":{"type":"LineString","coordinates":[[5481467.0,2068050.0],[5483053.0,2054452.0]]}},{"type":"Feature","properties":{"id":10201},"geometry":{"type":"LineString","coordinates":[[5489626.0,2071908.0],[5481467.0,2068050.0]]}},{"type":"Feature","properties":{"id":10202},"geometry":{"type":"LineString","coordinates":[[5959377.0,2169198.0],[5940444.0,2176265.0]]}},{"type":"Feature","properties":{"id":10203},"geometry":{"type":"LineString","coordinates":[[5670221.0,2102712.0],[5634310.0,2110076.0]]}},{"type":"Feature","properties":{"id":10204},"geometry":{"type":"LineString","coordinates":[[4945372.0,2007501.0],[4990655.0,1988740.0],[5009077.0,1972177.0]]}},{"type":"Feature","properties":{"id":10205},"geometry":{"type":"LineString","coordinates":[[4701598.0,1960714.0],[4662108.0,1986871.0]]}},{"type":"Feature","properties":{"id":10206},"geometry":{"type":"LineString","coordinates":[[5566631.0,2095682.0],[5560640.0,2071344.0],[5540871.0,2095945.0],[5489626.0,2071908.0]]}},{"type":"Feature","properties":{"id":10207},"geometry":{"type":"LineString","coordinates":[[4184513.0,1924933.0],[4171083.0,1968065.0],[4219713.0,1982155.0]]}},{"type":"Feature","properties":{"id":10208},"geometry":{"type":"LineString","coordinates":[[2740606.0,2132542.0],[2761837.0,2178697.0]]}},{"type":"Feature","properties":{"id":10209},"geometry":{"type":"LineString","coordinates":[[5590945.0,2115570.0],[5566631.0,2095682.0]]}},{"type":"Feature","properties":{"id":10210},"geometry":{"type":"LineString","coordinates":[[5634310.0,2110076.0],[5590945.0,2115570.0]]}},{"type":"Feature","properties":{"id":10211},"geometry":{"type":"LineString","coordinates":[[5110689.0,1998344.0],[5116608.0,2038729.0]]}},{"type":"Feature","properties":{"id":10212},"geometry":{"type":"LineString","coordinates":[[5824749.0,2171035.0],[5791287.0,2156409.0],[5751529.0,2100720.0]]}},{"type":"Feature","properties":{"id":10213},"geometry":{"type":"LineString","coordinates":[[6636246.0,2422567.0],[6714845.0,2468397.0]]}},{"type":"Feature","properties":{"id":10214},"geometry":{"type":"LineString","coordinates":[[6714845.0,2468397.0],[6806798.0,2496974.0]]}},{"type":"Feature","properties":{"id":10215},"geometry":{"type":"LineString","coordinates":[[6066416.0,2241475.0],[6090471.0,2253508.0]]}},{"type":"Feature","properties":{"id":10216},"geometry":{"type":"LineString","coordinates":[[6554504.0,2413418.0],[6636246.0,2422567.0]]}},{"type":"Feature","properties":{"id":10217},"geometry":{"type":"LineString","coordinates":[[5974176.0,2223871.0],[6012650.0,2239141.0]]}},{"type":"Feature","properties":{"id":10218},"geometry":{"type":"LineString","coordinates":[[6012650.0,2239141.0],[6066416.0,2241475.0]]}},{"type":"Feature","properties":{"id":10219},"geometry":{"type":"LineString","coordinates":[[3618795.0,2049424.0],[3556316.0,2032334.0],[3538321.0,2011973.0],[3515777.0,1986675.0]]}},{"type":"Feature","properties":{"id":10220},"geometry":{"type":"LineString","coordinates":[[4219713.0,1982155.0],[4268807.0,2010861.0],[4299705.0,1951217.0]]}},{"type":"Feature","properties":{"id":10221},"geometry":{"type":"LineString","coordinates":[[4662108.0,1986871.0],[4637532.0,2021521.0]]}},{"type":"Feature","properties":{"id":10222},"geometry":{"type":"LineString","coordinates":[[4871067.0,2038145.0],[4945372.0,2007501.0]]}},{"type":"Feature","properties":{"id":10223},"geometry":{"type":"LineString","coordinates":[[5940444.0,2176265.0],[5903692.0,2182081.0],[5912477.0,2219091.0],[5974176.0,2223871.0]]}},{"type":"Feature","properties":{"id":10224},"geometry":{"type":"LineString","coordinates":[[5116608.0,2038729.0],[5119478.0,2069007.0]]}},{"type":"Feature","properties":{"id":10225},"geometry":{"type":"LineString","coordinates":[[5888007.0,2217366.0],[5895969.0,2183332.0],[5824749.0,2171035.0]]}},{"type":"Feature","properties":{"id":10226},"geometry":{"type":"LineString","coordinates":[[6806798.0,2496974.0],[6863319.0,2563703.0]]}},{"type":"Feature","properties":{"id":10227},"geometry":{"type":"LineString","coordinates":[[3464112.0,2643534.0],[3420152.0,2673330.0],[3414051.0,2687679.0],[3407139.0,2704063.0],[3414069.0,2730768.0]]}},{"type":"Feature","properties":{"id":10228},"geometry":{"type":"LineString","coordinates":[[4517387.0,2342327.0],[4542187.0,2321830.0]]}},{"type":"Feature","properties":{"id":10229},"geometry":{"type":"LineString","coordinates":[[4322508.0,2326071.0],[4281866.0,2345283.0]]}},{"type":"Feature","properties":{"id":10230},"geometry":{"type":"LineString","coordinates":[[4511885.0,2349087.0],[4517387.0,2342327.0]]}},{"type":"Feature","properties":{"id":10231},"geometry":{"type":"LineString","coordinates":[[4741378.0,2321524.0],[4724763.0,2349761.0],[4742243.0,2376583.0]]}},{"type":"Feature","properties":{"id":10232},"geometry":{"type":"LineString","coordinates":[[4211842.0,2364241.0],[4170960.0,2316231.0]]}},{"type":"Feature","properties":{"id":10233},"geometry":{"type":"LineString","coordinates":[[4281866.0,2345283.0],[4211842.0,2364241.0]]}},{"type":"Feature","properties":{"id":10234},"geometry":{"type":"LineString","coordinates":[[3391141.0,2340602.0],[3427515.0,2440388.0]]}},{"type":"Feature","properties":{"id":10235},"geometry":{"type":"LineString","coordinates":[[4501438.0,2393730.0],[4511885.0,2349087.0]]}},{"type":"Feature","properties":{"id":10236},"geometry":{"type":"LineString","coordinates":[[5811317.0,2587520.0],[5797649.0,2549193.0],[5803878.0,2477397.0]]}},{"type":"Feature","properties":{"id":10237},"geometry":{"type":"LineString","coordinates":[[4511152.0,2412080.0],[4501438.0,2393730.0]]}},{"type":"Feature","properties":{"id":10238},"geometry":{"type":"LineString","coordinates":[[4742243.0,2376583.0],[4715103.0,2395120.0],[4710045.0,2410425.0],[4706013.0,2448079.0]]}},{"type":"Feature","properties":{"id":10239},"geometry":{"type":"LineString","coordinates":[[4706013.0,2448079.0],[4678710.0,2434725.0],[4653694.0,2458517.0]]}},{"type":"Feature","properties":{"id":10240},"geometry":{"type":"LineString","coordinates":[[4504513.0,2452710.0],[4511152.0,2412080.0]]}},{"type":"Feature","properties":{"id":10241},"geometry":{"type":"LineString","coordinates":[[3427515.0,2440388.0],[3451405.0,2543018.0],[3482990.0,2528821.0]]}},{"type":"Feature","properties":{"id":10242},"geometry":{"type":"LineString","coordinates":[[4653694.0,2458517.0],[4625173.0,2427476.0],[4599009.0,2476415.0],[4606911.0,2489415.0]]}},{"type":"Feature","properties":{"id":10243},"geometry":{"type":"LineString","coordinates":[[4606911.0,2489415.0],[4611707.0,2505313.0]]}},{"type":"Feature","properties":{"id":10244},"geometry":{"type":"LineString","coordinates":[[4562838.0,2508582.0],[4495895.0,2470763.0],[4504513.0,2452710.0]]}},{"type":"Feature","properties":{"id":10245},"geometry":{"type":"LineString","coordinates":[[4582187.0,2519521.0],[4562838.0,2508582.0]]}},{"type":"Feature","properties":{"id":10246},"geometry":{"type":"LineString","coordinates":[[4599618.0,2526058.0],[4589954.0,2516386.0],[4582187.0,2519521.0]]}},{"type":"Feature","properties":{"id":10247},"geometry":{"type":"LineString","coordinates":[[4611707.0,2505313.0],[4599618.0,2526058.0]]}},{"type":"Feature","properties":{"id":10248},"geometry":{"type":"LineString","coordinates":[[3482990.0,2528821.0],[3457114.0,2585136.0],[3464112.0,2643534.0]]}},{"type":"Feature","properties":{"id":10249},"geometry":{"type":"LineString","coordinates":[[3442784.0,2896432.0],[3471714.0,2901644.0]]}},{"type":"Feature","properties":{"id":10250},"geometry":{"type":"LineString","coordinates":[[3314790.0,2840825.0],[3256615.0,2855615.0],[3259546.0,2886464.0],[3243120.0,2916493.0],[3264232.0,2938073.0],[3320985.0,2931509.0]]}},{"type":"Feature","properties":{"id":10251},"geometry":{"type":"LineString","coordinates":[[3320985.0,2931509.0],[3343001.0,2935486.0],[3362406.0,2939072.0],[3382724.0,2911833.0],[3442784.0,2896432.0]]}},{"type":"Feature","properties":{"id":10252},"geometry":{"type":"LineString","coordinates":[[3515982.0,2973171.0],[3619367.0,2970507.0]]}},{"type":"Feature","properties":{"id":10253},"geometry":{"type":"LineString","coordinates":[[3619367.0,2970507.0],[3644489.0,2968707.0]]}},{"type":"Feature","properties":{"id":10254},"geometry":{"type":"LineString","coordinates":[[3414069.0,2730768.0],[3385828.0,2782799.0]]}},{"type":"Feature","properties":{"id":10255},"geometry":{"type":"LineString","coordinates":[[3385828.0,2782799.0],[3363647.0,2799697.0],[3338782.0,2790545.0],[3323014.0,2823440.0],[3314790.0,2840825.0]]}},{"type":"Feature","properties":{"id":10256},"geometry":{"type":"LineString","coordinates":[[3727769.0,3060350.0],[3726112.0,3087332.0],[3734384.0,3117050.0],[3765498.0,3129649.0]]}},{"type":"Feature","properties":{"id":10257},"geometry":{"type":"LineString","coordinates":[[3412062.0,3148119.0],[3380453.0,3142176.0],[3369080.0,3133125.0]]}},{"type":"Feature","properties":{"id":10258},"geometry":{"type":"LineString","coordinates":[[3480319.0,3136038.0],[3423258.0,3146072.0],[3412062.0,3148119.0]]}},{"type":"Feature","properties":{"id":10259},"geometry":{"type":"LineString","coordinates":[[3495971.0,3134148.0],[3492808.0,3134526.0],[3485287.0,3135433.0],[3480319.0,3136038.0]]}},{"type":"Feature","properties":{"id":10260},"geometry":{"type":"LineString","coordinates":[[3499623.0,3135260.0],[3495971.0,3134148.0]]}},{"type":"Feature","properties":{"id":10261},"geometry":{"type":"LineString","coordinates":[[3471714.0,2901644.0],[3473346.0,3001726.0],[3500006.0,3008007.0],[3515982.0,2973171.0]]}},{"type":"Feature","properties":{"id":10262},"geometry":{"type":"LineString","coordinates":[[3644489.0,2968707.0],[3648739.0,2975372.0],[3652783.0,2976094.0],[3652818.0,2976375.0],[3652853.0,2976656.0],[3608006.0,2984296.0],[3621889.0,3003960.0],[3657642.0,3015041.0],[3705361.0,3030982.0]]}},{"type":"Feature","properties":{"id":10263},"geometry":{"type":"LineString","coordinates":[[3705361.0,3030982.0],[3727769.0,3060350.0]]}},{"type":"Feature","properties":{"id":10264},"geometry":{"type":"LineString","coordinates":[[3362853.0,3119437.0],[3344543.0,3108428.0],[3326732.0,3122780.0]]}},{"type":"Feature","properties":{"id":10265},"geometry":{"type":"LineString","coordinates":[[3326732.0,3122780.0],[3320728.0,3126475.0],[3322252.0,3132619.0]]}},{"type":"Feature","properties":{"id":10266},"geometry":{"type":"LineString","coordinates":[[3322252.0,3132619.0],[3318908.0,3138087.0]]}},{"type":"Feature","properties":{"id":10267},"geometry":{"type":"LineString","coordinates":[[3369080.0,3133125.0],[3368336.0,3123718.0],[3362853.0,3119437.0]]}},{"type":"Feature","properties":{"id":10268},"geometry":{"type":"LineString","coordinates":[[3513561.0,3128341.0],[3522551.0,3139324.0],[3539420.0,3132835.0],[3535765.0,3108411.0],[3518487.0,3111151.0],[3513561.0,3128341.0]]}},{"type":"Feature","properties":{"id":10269},"geometry":{"type":"LineString","coordinates":[[3546122.0,3135665.0],[3534366.0,3137639.0]]}},{"type":"Feature","properties":{"id":10270},"geometry":{"type":"LineString","coordinates":[[3553352.0,3136848.0],[3546122.0,3135665.0]]}},{"type":"Feature","properties":{"id":10271},"geometry":{"type":"LineString","coordinates":[[3603879.0,3129742.0],[3553352.0,3136848.0]]}},{"type":"Feature","properties":{"id":10272},"geometry":{"type":"LineString","coordinates":[[3615846.0,3124915.0],[3603879.0,3129742.0]]}},{"type":"Feature","properties":{"id":10273},"geometry":{"type":"LineString","coordinates":[[3534366.0,3137639.0],[3524825.0,3147432.0]]}},{"type":"Feature","properties":{"id":10274},"geometry":{"type":"LineString","coordinates":[[3522689.0,3148844.0],[3499623.0,3135260.0]]}},{"type":"Feature","properties":{"id":10275},"geometry":{"type":"LineString","coordinates":[[3524825.0,3147432.0],[3522689.0,3148844.0]]}},{"type":"Feature","properties":{"id":10276},"geometry":{"type":"LineString","coordinates":[[3679891.0,3130408.0],[3672051.0,3129692.0],[3615846.0,3124915.0]]}},{"type":"Feature","properties":{"id":10277},"geometry":{"type":"LineString","coordinates":[[3318908.0,3138087.0],[3246077.0,3105948.0],[3225412.0,3119550.0],[3306084.0,3192206.0]]}},{"type":"Feature","properties":{"id":10278},"geometry":{"type":"LineString","coordinates":[[3443456.0,3231526.0],[3446881.0,3235493.0]]}},{"type":"Feature","properties":{"id":10279},"geometry":{"type":"LineString","coordinates":[[3681174.0,3201642.0],[3684014.0,3200543.0],[3683737.0,3197133.0],[3680718.0,3198061.0],[3672443.0,3200616.0],[3673905.0,3204464.0],[3681174.0,3201642.0]]}},{"type":"Feature","properties":{"id":10280},"geometry":{"type":"LineString","coordinates":[[3379716.0,3239322.0],[3365916.0,3258726.0]]}},{"type":"Feature","properties":{"id":10281},"geometry":{"type":"LineString","coordinates":[[3671574.0,3210859.0],[3671065.0,3198229.0],[3664856.0,3200561.0]]}},{"type":"Feature","properties":{"id":10282},"geometry":{"type":"LineString","coordinates":[[3449232.0,3245832.0],[3440288.0,3242921.0],[3418182.0,3235811.0]]}},{"type":"Feature","properties":{"id":10283},"geometry":{"type":"LineString","coordinates":[[3461943.0,3481447.0],[3464057.0,3491282.0],[3471741.0,3502049.0],[3472385.0,3481604.0],[3461943.0,3481447.0]]}},{"type":"Feature","properties":{"id":10284},"geometry":{"type":"LineString","coordinates":[[3682807.0,3214473.0],[3671574.0,3210859.0]]}},{"type":"Feature","properties":{"id":10285},"geometry":{"type":"LineString","coordinates":[[3458893.0,3248428.0],[3449232.0,3245832.0]]}},{"type":"Feature","properties":{"id":10286},"geometry":{"type":"LineString","coordinates":[[3446881.0,3235493.0],[3458893.0,3248428.0]]}},{"type":"Feature","properties":{"id":10287},"geometry":{"type":"LineString","coordinates":[[3365916.0,3258726.0],[3356471.0,3270329.0]]}},{"type":"Feature","properties":{"id":10288},"geometry":{"type":"LineString","coordinates":[[3697392.0,3219210.0],[3682807.0,3214473.0]]}},{"type":"Feature","properties":{"id":10289},"geometry":{"type":"LineString","coordinates":[[3920660.0,3156218.0],[3883443.0,3175162.0],[3896191.0,3201061.0]]}},{"type":"Feature","properties":{"id":10290},"geometry":{"type":"LineString","coordinates":[[3707889.0,3242285.0],[3697392.0,3219210.0]]}},{"type":"Feature","properties":{"id":10291},"geometry":{"type":"LineString","coordinates":[[3896191.0,3201061.0],[3918217.0,3226298.0]]}},{"type":"Feature","properties":{"id":10292},"geometry":{"type":"LineString","coordinates":[[3918217.0,3226298.0],[3923498.0,3231860.0]]}},{"type":"Feature","properties":{"id":10293},"geometry":{"type":"LineString","coordinates":[[3936687.0,3245669.0],[3946031.0,3260714.0]]}},{"type":"Feature","properties":{"id":10294},"geometry":{"type":"LineString","coordinates":[[3946031.0,3260714.0],[3951477.0,3272491.0]]}},{"type":"Feature","properties":{"id":10295},"geometry":{"type":"LineString","coordinates":[[3923498.0,3231860.0],[3936687.0,3245669.0]]}},{"type":"Feature","properties":{"id":10296},"geometry":{"type":"LineString","coordinates":[[3765498.0,3129649.0],[3799789.0,3135289.0]]}},{"type":"Feature","properties":{"id":10297},"geometry":{"type":"LineString","coordinates":[[3799789.0,3135289.0],[3814726.0,3141880.0]]}},{"type":"Feature","properties":{"id":10298},"geometry":{"type":"LineString","coordinates":[[3306084.0,3192206.0],[3369157.0,3214448.0]]}},{"type":"Feature","properties":{"id":10299},"geometry":{"type":"LineString","coordinates":[[3814726.0,3141880.0],[3841459.0,3156116.0]]}},{"type":"Feature","properties":{"id":10300},"geometry":{"type":"LineString","coordinates":[[3369157.0,3214448.0],[3392402.0,3207260.0],[3401610.0,3204447.0],[3420727.0,3214769.0]]}},{"type":"Feature","properties":{"id":10301},"geometry":{"type":"LineString","coordinates":[[3692324.0,3176225.0],[3714279.0,3173099.0],[3718157.0,3159924.0],[3687544.0,3129788.0],[3679891.0,3130408.0]]}},{"type":"Feature","properties":{"id":10302},"geometry":{"type":"LineString","coordinates":[[3919814.0,3153328.0],[3920366.0,3153923.0]]}},{"type":"Feature","properties":{"id":10303},"geometry":{"type":"LineString","coordinates":[[3678433.0,3180074.0],[3692324.0,3176225.0]]}},{"type":"Feature","properties":{"id":10304},"geometry":{"type":"LineString","coordinates":[[3841459.0,3156116.0],[3859737.0,3160855.0]]}},{"type":"Feature","properties":{"id":10305},"geometry":{"type":"LineString","coordinates":[[3859737.0,3160855.0],[3919814.0,3153328.0]]}},{"type":"Feature","properties":{"id":10306},"geometry":{"type":"LineString","coordinates":[[3920366.0,3153923.0],[3920660.0,3156218.0]]}},{"type":"Feature","properties":{"id":10307},"geometry":{"type":"LineString","coordinates":[[3670416.0,3182316.0],[3678433.0,3180074.0]]}},{"type":"Feature","properties":{"id":10308},"geometry":{"type":"LineString","coordinates":[[3659986.0,3192634.0],[3669374.0,3192661.0],[3670416.0,3182316.0]]}},{"type":"Feature","properties":{"id":10309},"geometry":{"type":"LineString","coordinates":[[3643744.0,3197625.0],[3644571.0,3196739.0],[3645112.0,3196160.0],[3645384.0,3195936.0],[3646116.0,3195334.0],[3647490.0,3194132.0],[3647903.0,3194119.0],[3648588.0,3194236.0],[3649860.0,3195230.0],[3650263.0,3195054.0],[3650995.0,3193365.0],[3651676.0,3192902.0],[3652769.0,3192562.0],[3653709.0,3192373.0],[3656217.0,3191822.0],[3657773.0,3192007.0],[3658134.0,3192032.0],[3658425.0,3191988.0],[3658830.0,3192231.0],[3659986.0,3192634.0]]}},{"type":"Feature","properties":{"id":10310},"geometry":{"type":"LineString","coordinates":[[3613362.0,3200895.0],[3620056.0,3201443.0]]}},{"type":"Feature","properties":{"id":10311},"geometry":{"type":"LineString","coordinates":[[3627186.0,3200517.0],[3643744.0,3197625.0]]}},{"type":"Feature","properties":{"id":10312},"geometry":{"type":"LineString","coordinates":[[3612136.0,3202968.0],[3613362.0,3200895.0]]}},{"type":"Feature","properties":{"id":10313},"geometry":{"type":"LineString","coordinates":[[3618580.0,3201701.0],[3612136.0,3202968.0]]}},{"type":"Feature","properties":{"id":10314},"geometry":{"type":"LineString","coordinates":[[3418182.0,3235811.0],[3396104.0,3227338.0],[3379716.0,3239322.0]]}},{"type":"Feature","properties":{"id":10315},"geometry":{"type":"LineString","coordinates":[[3420727.0,3214769.0],[3443456.0,3231526.0]]}},{"type":"Feature","properties":{"id":10316},"geometry":{"type":"LineString","coordinates":[[3629856.0,3202561.0],[3623764.0,3203485.0]]}},{"type":"Feature","properties":{"id":10317},"geometry":{"type":"LineString","coordinates":[[3620056.0,3201443.0],[3621681.0,3203977.0]]}},{"type":"Feature","properties":{"id":10318},"geometry":{"type":"LineString","coordinates":[[3621681.0,3203977.0],[3627186.0,3200517.0]]}},{"type":"Feature","properties":{"id":10319},"geometry":{"type":"LineString","coordinates":[[3621527.0,3204088.0],[3618580.0,3201701.0]]}},{"type":"Feature","properties":{"id":10320},"geometry":{"type":"LineString","coordinates":[[3623764.0,3203485.0],[3621681.0,3203977.0]]}},{"type":"Feature","properties":{"id":10321},"geometry":{"type":"LineString","coordinates":[[3636000.0,3202680.0],[3629856.0,3202561.0]]}},{"type":"Feature","properties":{"id":10322},"geometry":{"type":"LineString","coordinates":[[3643417.0,3198789.0],[3636000.0,3202680.0]]}},{"type":"Feature","properties":{"id":10323},"geometry":{"type":"LineString","coordinates":[[3664856.0,3200561.0],[3654719.0,3193810.0],[3643417.0,3198789.0]]}},{"type":"Feature","properties":{"id":10324},"geometry":{"type":"LineString","coordinates":[[3625708.0,3546887.0],[3656090.0,3496747.0]]}},{"type":"Feature","properties":{"id":10325},"geometry":{"type":"LineString","coordinates":[[4307694.0,3495169.0],[4331939.0,3480738.0]]}},{"type":"Feature","properties":{"id":10326},"geometry":{"type":"LineString","coordinates":[[4469893.0,3465507.0],[4531388.0,3500547.0],[4551178.0,3486755.0],[4537622.0,3459062.0]]}},{"type":"Feature","properties":{"id":10327},"geometry":{"type":"LineString","coordinates":[[4672679.0,3463344.0],[4753691.0,3515985.0]]}},{"type":"Feature","properties":{"id":10328},"geometry":{"type":"LineString","coordinates":[[3599388.0,3553305.0],[3625708.0,3546887.0]]}},{"type":"Feature","properties":{"id":10329},"geometry":{"type":"LineString","coordinates":[[4871927.0,3530225.0],[4901277.0,3508415.0]]}},{"type":"Feature","properties":{"id":10330},"geometry":{"type":"LineString","coordinates":[[3303772.0,3618198.0],[3309523.0,3616907.0]]}},{"type":"Feature","properties":{"id":10331},"geometry":{"type":"LineString","coordinates":[[3309523.0,3616907.0],[3326116.0,3613225.0],[3325818.0,3586023.0],[3320895.0,3580735.0],[3316940.0,3592764.0]]}},{"type":"Feature","properties":{"id":10332},"geometry":{"type":"LineString","coordinates":[[3306911.0,3621319.0],[3303772.0,3618198.0]]}},{"type":"Feature","properties":{"id":10333},"geometry":{"type":"LineString","coordinates":[[3599768.0,3569286.0],[3599388.0,3553305.0]]}},{"type":"Feature","properties":{"id":10334},"geometry":{"type":"LineString","coordinates":[[4753691.0,3515985.0],[4813353.0,3545895.0]]}},{"type":"Feature","properties":{"id":10335},"geometry":{"type":"LineString","coordinates":[[4813353.0,3545895.0],[4852860.0,3552931.0],[4871927.0,3530225.0]]}},{"type":"Feature","properties":{"id":10336},"geometry":{"type":"LineString","coordinates":[[4286823.0,3523626.0],[4288333.0,3524217.0]]}},{"type":"Feature","properties":{"id":10337},"geometry":{"type":"LineString","coordinates":[[4288333.0,3524217.0],[4306700.0,3513564.0],[4307694.0,3495169.0]]}},{"type":"Feature","properties":{"id":10338},"geometry":{"type":"LineString","coordinates":[[4283857.0,3525296.0],[4286823.0,3523626.0]]}},{"type":"Feature","properties":{"id":10339},"geometry":{"type":"LineString","coordinates":[[3595545.0,3585543.0],[3599768.0,3569286.0]]}},{"type":"Feature","properties":{"id":10340},"geometry":{"type":"LineString","coordinates":[[4245717.0,3462796.0],[4233489.0,3534838.0]]}},{"type":"Feature","properties":{"id":10341},"geometry":{"type":"LineString","coordinates":[[3466270.0,3521148.0],[3449638.0,3576479.0],[3466493.0,3603701.0],[3485013.0,3612132.0]]}},{"type":"Feature","properties":{"id":10342},"geometry":{"type":"LineString","coordinates":[[3595988.0,3594899.0],[3595545.0,3585543.0]]}},{"type":"Feature","properties":{"id":10343},"geometry":{"type":"LineString","coordinates":[[3485013.0,3612132.0],[3490109.0,3617888.0]]}},{"type":"Feature","properties":{"id":10344},"geometry":{"type":"LineString","coordinates":[[3490109.0,3617888.0],[3469109.0,3615722.0],[3390818.0,3608524.0],[3360498.0,3628304.0],[3366151.0,3643821.0]]}},{"type":"Feature","properties":{"id":10345},"geometry":{"type":"LineString","coordinates":[[3309325.0,3662898.0],[3306911.0,3621319.0]]}},{"type":"Feature","properties":{"id":10346},"geometry":{"type":"LineString","coordinates":[[3230330.0,3682748.0],[3236307.0,3678562.0]]}},{"type":"Feature","properties":{"id":10347},"geometry":{"type":"LineString","coordinates":[[3592155.0,3610216.0],[3595988.0,3594899.0]]}},{"type":"Feature","properties":{"id":10348},"geometry":{"type":"LineString","coordinates":[[3761888.0,3300996.0],[3741353.0,3254283.0],[3707889.0,3242285.0]]}},{"type":"Feature","properties":{"id":10349},"geometry":{"type":"LineString","coordinates":[[3258609.0,3511383.0],[3263290.0,3493217.0],[3255317.0,3463709.0]]}},{"type":"Feature","properties":{"id":10350},"geometry":{"type":"LineString","coordinates":[[4194752.0,3393947.0],[4197879.0,3384616.0],[4192373.0,3379298.0]]}},{"type":"Feature","properties":{"id":10351},"geometry":{"type":"LineString","coordinates":[[4127540.0,3366605.0],[4155275.0,3399818.0]]}},{"type":"Feature","properties":{"id":10352},"geometry":{"type":"LineString","coordinates":[[3617034.0,3449572.0],[3636536.0,3447546.0],[3661305.0,3425261.0]]}},{"type":"Feature","properties":{"id":10353},"geometry":{"type":"LineString","coordinates":[[3461783.0,3447440.0],[3460572.0,3462266.0],[3470407.0,3475254.0]]}},{"type":"Feature","properties":{"id":10354},"geometry":{"type":"LineString","coordinates":[[4155275.0,3399818.0],[4176383.0,3402210.0]]}},{"type":"Feature","properties":{"id":10355},"geometry":{"type":"LineString","coordinates":[[4176383.0,3402210.0],[4194752.0,3393947.0]]}},{"type":"Feature","properties":{"id":10356},"geometry":{"type":"LineString","coordinates":[[3635824.0,3450748.0],[3617034.0,3449572.0]]}},{"type":"Feature","properties":{"id":10357},"geometry":{"type":"LineString","coordinates":[[3470407.0,3475254.0],[3482000.0,3476444.0]]}},{"type":"Feature","properties":{"id":10358},"geometry":{"type":"LineString","coordinates":[[3644569.0,3454642.0],[3635824.0,3450748.0]]}},{"type":"Feature","properties":{"id":10359},"geometry":{"type":"LineString","coordinates":[[3482000.0,3476444.0],[3474370.0,3491918.0]]}},{"type":"Feature","properties":{"id":10360},"geometry":{"type":"LineString","coordinates":[[4223057.0,3389734.0],[4229550.0,3407325.0],[4234678.0,3421310.0]]}},{"type":"Feature","properties":{"id":10361},"geometry":{"type":"LineString","coordinates":[[3236307.0,3678562.0],[3252819.0,3689150.0],[3300388.0,3689756.0],[3309325.0,3662898.0]]}},{"type":"Feature","properties":{"id":10362},"geometry":{"type":"LineString","coordinates":[[4620474.0,3568133.0],[4624297.0,3584536.0],[4635780.0,3578897.0],[4650437.0,3566065.0],[4646834.0,3554928.0],[4637472.0,3554821.0],[4620474.0,3568133.0]]}},{"type":"Feature","properties":{"id":10363},"geometry":{"type":"LineString","coordinates":[[3356471.0,3270329.0],[3292872.0,3275532.0],[3281088.0,3296441.0],[3382754.0,3361871.0]]}},{"type":"Feature","properties":{"id":10364},"geometry":{"type":"LineString","coordinates":[[3951477.0,3272491.0],[3955930.0,3287338.0]]}},{"type":"Feature","properties":{"id":10365},"geometry":{"type":"LineString","coordinates":[[3108541.0,3354477.0],[2978351.0,3337522.0],[2945860.0,3376723.0],[2965101.0,3427072.0],[3025762.0,3449549.0]]}},{"type":"Feature","properties":{"id":10366},"geometry":{"type":"LineString","coordinates":[[3240880.0,3412798.0],[3205615.0,3361773.0],[3108541.0,3354477.0]]}},{"type":"Feature","properties":{"id":10367},"geometry":{"type":"LineString","coordinates":[[3760200.0,3324801.0],[3761888.0,3300996.0]]}},{"type":"Feature","properties":{"id":10368},"geometry":{"type":"LineString","coordinates":[[3955930.0,3287338.0],[3960097.0,3307432.0]]}},{"type":"Feature","properties":{"id":10369},"geometry":{"type":"LineString","coordinates":[[3666865.0,3344046.0],[3700408.0,3351757.0],[3714436.0,3355059.0],[3739366.0,3346663.0],[3760200.0,3324801.0]]}},{"type":"Feature","properties":{"id":10370},"geometry":{"type":"LineString","coordinates":[[3025762.0,3449549.0],[3035186.0,3491157.0],[3065671.0,3502790.0]]}},{"type":"Feature","properties":{"id":10371},"geometry":{"type":"LineString","coordinates":[[3996616.0,3332178.0],[4014218.0,3347858.0]]}},{"type":"Feature","properties":{"id":10372},"geometry":{"type":"LineString","coordinates":[[3960097.0,3307432.0],[3971474.0,3356964.0],[3996616.0,3332178.0]]}},{"type":"Feature","properties":{"id":10373},"geometry":{"type":"LineString","coordinates":[[3255317.0,3463709.0],[3240880.0,3412798.0]]}},{"type":"Feature","properties":{"id":10374},"geometry":{"type":"LineString","coordinates":[[3382754.0,3361871.0],[3363478.0,3414600.0],[3392607.0,3438782.0]]}},{"type":"Feature","properties":{"id":10375},"geometry":{"type":"LineString","coordinates":[[4127371.0,3353524.0],[4134708.0,3351905.0]]}},{"type":"Feature","properties":{"id":10376},"geometry":{"type":"LineString","coordinates":[[3453179.0,3428337.0],[3452256.0,3433066.0]]}},{"type":"Feature","properties":{"id":10377},"geometry":{"type":"LineString","coordinates":[[3464414.0,3432207.0],[3473829.0,3431100.0]]}},{"type":"Feature","properties":{"id":10378},"geometry":{"type":"LineString","coordinates":[[4134708.0,3351905.0],[4138750.0,3360935.0]]}},{"type":"Feature","properties":{"id":10379},"geometry":{"type":"LineString","coordinates":[[3473829.0,3431100.0],[3471546.0,3433575.0],[3471270.0,3434116.0]]}},{"type":"Feature","properties":{"id":10380},"geometry":{"type":"LineString","coordinates":[[3392607.0,3438782.0],[3435927.0,3440956.0]]}},{"type":"Feature","properties":{"id":10381},"geometry":{"type":"LineString","coordinates":[[3435927.0,3440956.0],[3453179.0,3428337.0]]}},{"type":"Feature","properties":{"id":10382},"geometry":{"type":"LineString","coordinates":[[4138750.0,3360935.0],[4127540.0,3366605.0]]}},{"type":"Feature","properties":{"id":10383},"geometry":{"type":"LineString","coordinates":[[3452256.0,3433066.0],[3455782.0,3444576.0],[3464414.0,3432207.0]]}},{"type":"Feature","properties":{"id":10384},"geometry":{"type":"LineString","coordinates":[[4113226.0,3371155.0],[4127371.0,3353524.0]]}},{"type":"Feature","properties":{"id":10385},"geometry":{"type":"LineString","coordinates":[[4014218.0,3347858.0],[4022187.0,3358880.0],[4046789.0,3371595.0],[4067838.0,3373652.0]]}},{"type":"Feature","properties":{"id":10386},"geometry":{"type":"LineString","coordinates":[[4067838.0,3373652.0],[4085029.0,3374111.0],[4113226.0,3371155.0]]}},{"type":"Feature","properties":{"id":10387},"geometry":{"type":"LineString","coordinates":[[3354541.0,3456996.0],[3379028.0,3463202.0],[3383213.0,3440412.0],[3366761.0,3427444.0],[3354541.0,3456996.0]]}},{"type":"Feature","properties":{"id":10388},"geometry":{"type":"LineString","coordinates":[[3471270.0,3434116.0],[3461783.0,3447440.0]]}},{"type":"Feature","properties":{"id":10389},"geometry":{"type":"LineString","coordinates":[[4192373.0,3379298.0],[4201005.0,3368300.0]]}},{"type":"Feature","properties":{"id":10390},"geometry":{"type":"LineString","coordinates":[[4201005.0,3368300.0],[4225157.0,3380667.0]]}},{"type":"Feature","properties":{"id":10391},"geometry":{"type":"LineString","coordinates":[[3661305.0,3425261.0],[3673865.0,3390410.0],[3658415.0,3356366.0],[3666865.0,3344046.0]]}},{"type":"Feature","properties":{"id":10392},"geometry":{"type":"LineString","coordinates":[[4225157.0,3380667.0],[4223057.0,3389734.0]]}},{"type":"Feature","properties":{"id":10393},"geometry":{"type":"LineString","coordinates":[[4376190.0,3431980.0],[4380329.0,3428122.0]]}},{"type":"Feature","properties":{"id":10394},"geometry":{"type":"LineString","coordinates":[[4380329.0,3428122.0],[4423357.0,3436787.0]]}},{"type":"Feature","properties":{"id":10395},"geometry":{"type":"LineString","coordinates":[[4210703.0,3415765.0],[4221198.0,3439473.0],[4236123.0,3426692.0],[4220741.0,3412520.0],[4210703.0,3415765.0]]}},{"type":"Feature","properties":{"id":10396},"geometry":{"type":"LineString","coordinates":[[3267014.0,3563206.0],[3258609.0,3511383.0]]}},{"type":"Feature","properties":{"id":10397},"geometry":{"type":"LineString","coordinates":[[3656090.0,3496747.0],[3654434.0,3476709.0],[3660686.0,3452358.0],[3644569.0,3454642.0]]}},{"type":"Feature","properties":{"id":10398},"geometry":{"type":"LineString","coordinates":[[4602721.0,3407226.0],[4672679.0,3463344.0]]}},{"type":"Feature","properties":{"id":10399},"geometry":{"type":"LineString","coordinates":[[4423357.0,3436787.0],[4451512.0,3453831.0]]}},{"type":"Feature","properties":{"id":10400},"geometry":{"type":"LineString","coordinates":[[3485613.0,3526833.0],[3466270.0,3521148.0]]}},{"type":"Feature","properties":{"id":10401},"geometry":{"type":"LineString","coordinates":[[3474370.0,3491918.0],[3481172.0,3504640.0],[3485613.0,3526833.0]]}},{"type":"Feature","properties":{"id":10402},"geometry":{"type":"LineString","coordinates":[[4537622.0,3459062.0],[4598483.0,3432718.0],[4598024.0,3425759.0],[4591127.0,3414093.0],[4602721.0,3407226.0]]}},{"type":"Feature","properties":{"id":10403},"geometry":{"type":"LineString","coordinates":[[4451512.0,3453831.0],[4464497.0,3461971.0]]}},{"type":"Feature","properties":{"id":10404},"geometry":{"type":"LineString","coordinates":[[3065671.0,3502790.0],[3016106.0,3538828.0],[3005533.0,3570045.0],[3019430.0,3589715.0],[3018438.0,3617603.0],[3042559.0,3639690.0],[3087910.0,3615180.0]]}},{"type":"Feature","properties":{"id":10405},"geometry":{"type":"LineString","coordinates":[[4268365.0,3419505.0],[4244479.0,3435837.0],[4245717.0,3462796.0]]}},{"type":"Feature","properties":{"id":10406},"geometry":{"type":"LineString","coordinates":[[4464497.0,3461971.0],[4469893.0,3465507.0]]}},{"type":"Feature","properties":{"id":10407},"geometry":{"type":"LineString","coordinates":[[4367472.0,3466736.0],[4386497.0,3468979.0],[4376190.0,3431980.0]]}},{"type":"Feature","properties":{"id":10408},"geometry":{"type":"LineString","coordinates":[[4166955.0,3464870.0],[4184292.0,3472667.0],[4194193.0,3462176.0],[4188683.0,3433561.0],[4166955.0,3464870.0]]}},{"type":"Feature","properties":{"id":10409},"geometry":{"type":"LineString","coordinates":[[4332329.0,3471046.0],[4367472.0,3466736.0]]}},{"type":"Feature","properties":{"id":10410},"geometry":{"type":"LineString","coordinates":[[4331939.0,3480738.0],[4332329.0,3471046.0]]}},{"type":"Feature","properties":{"id":10411},"geometry":{"type":"LineString","coordinates":[[4922207.0,3502101.0],[4954962.0,3524884.0],[4976731.0,3524959.0],[4988318.0,3525041.0]]}},{"type":"Feature","properties":{"id":10412},"geometry":{"type":"LineString","coordinates":[[4901277.0,3508415.0],[4944136.0,3525194.0],[4944638.0,3524518.0],[4925941.0,3510877.0],[4922207.0,3502101.0]]}},{"type":"Feature","properties":{"id":10413},"geometry":{"type":"LineString","coordinates":[[3316940.0,3592764.0],[3313863.0,3576299.0],[3285070.0,3554457.0],[3267014.0,3563206.0]]}},{"type":"Feature","properties":{"id":10414},"geometry":{"type":"LineString","coordinates":[[3087910.0,3615180.0],[3142931.0,3637197.0],[3133727.0,3663080.0],[3170811.0,3705283.0],[3233385.0,3710083.0],[3230330.0,3682748.0]]}},{"type":"Feature","properties":{"id":10415},"geometry":{"type":"LineString","coordinates":[[4306133.0,3584923.0],[4323871.0,3607135.0],[4364880.0,3604561.0],[4377518.0,3548324.0],[4372611.0,3530144.0],[4348493.0,3530953.0],[4340720.0,3530914.0],[4306133.0,3584923.0]]}},{"type":"Feature","properties":{"id":10416},"geometry":{"type":"LineString","coordinates":[[3366151.0,3643821.0],[3386061.0,3676922.0],[3403235.0,3701218.0]]}},{"type":"Feature","properties":{"id":10417},"geometry":{"type":"LineString","coordinates":[[4470059.0,3612362.0],[4461580.0,3593304.0]]}},{"type":"Feature","properties":{"id":10418},"geometry":{"type":"LineString","coordinates":[[4478645.0,3616398.0],[4470059.0,3612362.0]]}},{"type":"Feature","properties":{"id":10419},"geometry":{"type":"LineString","coordinates":[[4300375.0,3623120.0],[4310655.0,3543740.0],[4296791.0,3530751.0],[4283857.0,3525296.0]]}},{"type":"Feature","properties":{"id":10420},"geometry":{"type":"LineString","coordinates":[[4483443.0,3627096.0],[4494202.0,3619376.0],[4486272.0,3610440.0],[4478645.0,3616398.0]]}},{"type":"Feature","properties":{"id":10421},"geometry":{"type":"LineString","coordinates":[[4483004.0,3636653.0],[4483443.0,3627096.0]]}},{"type":"Feature","properties":{"id":10422},"geometry":{"type":"LineString","coordinates":[[3570116.0,3697126.0],[3576951.0,3684729.0],[3582188.0,3675298.0],[3589903.0,3661273.0],[3590374.0,3636826.0],[3592155.0,3610216.0]]}},{"type":"Feature","properties":{"id":10423},"geometry":{"type":"LineString","coordinates":[[4233489.0,3534838.0],[4206730.0,3607914.0],[4207098.0,3636783.0]]}},{"type":"Feature","properties":{"id":10424},"geometry":{"type":"LineString","coordinates":[[4461580.0,3593304.0],[4466904.0,3569193.0],[4447265.0,3510328.0],[4409463.0,3523908.0],[4415599.0,3550646.0],[4398888.0,3579315.0],[4398650.0,3616063.0],[4416604.0,3640366.0],[4442809.0,3636989.0]]}},{"type":"Feature","properties":{"id":10425},"geometry":{"type":"LineString","coordinates":[[3403235.0,3701218.0],[3393176.0,3718032.0],[3396190.0,3737427.0]]}},{"type":"Feature","properties":{"id":10426},"geometry":{"type":"LineString","coordinates":[[3418029.0,3738401.0],[3418312.0,3739744.0]]}},{"type":"Feature","properties":{"id":10427},"geometry":{"type":"LineString","coordinates":[[3552262.0,3715466.0],[3570116.0,3697126.0]]}},{"type":"Feature","properties":{"id":10428},"geometry":{"type":"LineString","coordinates":[[3508635.0,3723384.0],[3552262.0,3715466.0]]}},{"type":"Feature","properties":{"id":10429},"geometry":{"type":"LineString","coordinates":[[3298814.0,3750249.0],[3307297.0,3758116.0],[3331199.0,3760455.0],[3327237.0,3743384.0],[3321163.0,3732133.0],[3312182.0,3728381.0],[3298814.0,3750249.0]]}},{"type":"Feature","properties":{"id":10430},"geometry":{"type":"LineString","coordinates":[[3396190.0,3737427.0],[3404091.0,3744590.0],[3418029.0,3738401.0]]}},{"type":"Feature","properties":{"id":10431},"geometry":{"type":"LineString","coordinates":[[3488330.0,3732535.0],[3508635.0,3723384.0]]}},{"type":"Feature","properties":{"id":10432},"geometry":{"type":"LineString","coordinates":[[3482977.0,3734489.0],[3488330.0,3732535.0]]}},{"type":"Feature","properties":{"id":10433},"geometry":{"type":"LineString","coordinates":[[5059830.0,3623763.0],[5041851.0,3630961.0],[5034954.0,3627178.0],[5009299.0,3698293.0],[5007411.0,3715790.0]]}},{"type":"Feature","properties":{"id":10434},"geometry":{"type":"LineString","coordinates":[[4442809.0,3636989.0],[4454857.0,3667686.0],[4477925.0,3664114.0],[4478970.0,3648033.0],[4483004.0,3636653.0]]}},{"type":"Feature","properties":{"id":10435},"geometry":{"type":"LineString","coordinates":[[3466493.0,3748684.0],[3472509.0,3738956.0],[3482977.0,3734489.0]]}},{"type":"Feature","properties":{"id":10436},"geometry":{"type":"LineString","coordinates":[[3464001.0,3750092.0],[3464309.0,3750074.0],[3464481.0,3750174.0],[3464710.0,3750504.0],[3464748.0,3751192.0],[3465158.0,3750993.0],[3465741.0,3750630.0],[3465405.0,3749798.0],[3465487.0,3749155.0],[3465772.0,3748837.0],[3466493.0,3748684.0]]}},{"type":"Feature","properties":{"id":10437},"geometry":{"type":"LineString","coordinates":[[3418312.0,3739744.0],[3411165.0,3748588.0],[3412437.0,3771494.0]]}},{"type":"Feature","properties":{"id":10438},"geometry":{"type":"LineString","coordinates":[[4695105.0,3706695.0],[4680619.0,3681309.0],[4604193.0,3670894.0]]}},{"type":"Feature","properties":{"id":10439},"geometry":{"type":"LineString","coordinates":[[3504923.0,3769882.0],[3523750.0,3761758.0],[3524675.0,3761008.0],[3525337.0,3759730.0],[3525669.0,3758051.0],[3525635.0,3756148.0],[3525239.0,3754226.0],[3524522.0,3752490.0],[3523561.0,3751127.0],[3522452.0,3750271.0],[3492175.0,3735818.0],[3491443.0,3735536.0],[3490944.0,3735794.0],[3490541.0,3735610.0],[3491164.0,3735222.0],[3490959.0,3734672.0],[3490982.0,3734086.0],[3490705.0,3733513.0],[3490464.0,3733891.0],[3490003.0,3734038.0],[3489798.0,3734556.0],[3489509.0,3734929.0],[3487951.0,3735870.0],[3487608.0,3735751.0],[3487456.0,3735586.0],[3487141.0,3735898.0],[3487021.0,3736571.0],[3485477.0,3737665.0],[3484370.0,3737854.0],[3483637.0,3738804.0],[3482920.0,3738766.0],[3481978.0,3739045.0],[3481488.0,3739544.0],[3481291.0,3740279.0],[3480479.0,3741395.0],[3479690.0,3741590.0],[3479796.0,3741079.0],[3479648.0,3740586.0],[3479430.0,3740301.0],[3479085.0,3740206.0],[3478327.0,3740414.0],[3478087.0,3741342.0],[3477872.0,3741542.0],[3475853.0,3741607.0],[3474503.0,3741154.0],[3473612.0,3741495.0],[3472457.0,3742587.0],[3471613.0,3744338.0],[3470941.0,3745423.0],[3470391.0,3745757.0],[3469946.0,3746132.0],[3469714.0,3746327.0],[3469073.0,3747566.0],[3468323.0,3749053.0],[3467717.0,3749733.0],[3466777.0,3749968.0],[3466010.0,3749202.0],[3465948.0,3749430.0],[3465886.0,3749657.0],[3466308.0,3749946.0],[3466363.0,3750433.0],[3466003.0,3750937.0],[3465247.0,3751553.0],[3464716.0,3751447.0],[3464589.0,3751204.0],[3464380.0,3750348.0],[3464001.0,3750092.0]]}},{"type":"Feature","properties":{"id":10440},"geometry":{"type":"LineString","coordinates":[[4604193.0,3670894.0],[4583909.0,3601419.0],[4522236.0,3592092.0],[4487079.0,3662743.0],[4499887.0,3708682.0]]}},{"type":"Feature","properties":{"id":10441},"geometry":{"type":"LineString","coordinates":[[3520820.0,3779175.0],[3504923.0,3769882.0]]}},{"type":"Feature","properties":{"id":10442},"geometry":{"type":"LineString","coordinates":[[4333207.0,3731189.0],[4371445.0,3709873.0],[4373684.0,3691339.0],[4317589.0,3625126.0],[4300375.0,3623120.0]]}},{"type":"Feature","properties":{"id":10443},"geometry":{"type":"LineString","coordinates":[[4207098.0,3636783.0],[4209646.0,3718057.0],[4239258.0,3714501.0],[4252908.0,3735150.0],[4278367.0,3732416.0]]}},{"type":"Feature","properties":{"id":10444},"geometry":{"type":"LineString","coordinates":[[3564651.0,3804905.0],[3557179.0,3793273.0],[3544611.0,3781611.0],[3520820.0,3779175.0]]}},{"type":"Feature","properties":{"id":10445},"geometry":{"type":"LineString","coordinates":[[5162340.0,3849279.0],[5171516.0,3860202.0]]}},{"type":"Feature","properties":{"id":10446},"geometry":{"type":"LineString","coordinates":[[5108900.0,3874214.0],[5134269.0,3848235.0],[5162340.0,3849279.0]]}},{"type":"Feature","properties":{"id":10447},"geometry":{"type":"LineString","coordinates":[[3412437.0,3771494.0],[3367217.0,3706570.0],[3331176.0,3694017.0],[3358646.0,3790645.0],[3335896.0,3826324.0],[3356677.0,3841125.0],[3379703.0,3895855.0],[3395470.0,3908045.0]]}},{"type":"Feature","properties":{"id":10448},"geometry":{"type":"LineString","coordinates":[[4499887.0,3708682.0],[4436223.0,3830455.0]]}},{"type":"Feature","properties":{"id":10449},"geometry":{"type":"LineString","coordinates":[[4278367.0,3732416.0],[4264071.0,3758783.0],[4253282.0,3758474.0],[4242406.0,3736611.0],[4218669.0,3749597.0],[4237985.0,3778485.0],[4253632.0,3780310.0],[4337943.0,3832935.0],[4350873.0,3805523.0],[4333207.0,3731189.0]]}},{"type":"Feature","properties":{"id":10450},"geometry":{"type":"LineString","coordinates":[[3461377.0,3908521.0],[3526308.0,3910506.0],[3561339.0,3911996.0]]}},{"type":"Feature","properties":{"id":10451},"geometry":{"type":"LineString","coordinates":[[3561339.0,3911996.0],[3608639.0,3876201.0],[3564651.0,3804905.0]]}},{"type":"Feature","properties":{"id":10452},"geometry":{"type":"LineString","coordinates":[[5007411.0,3715790.0],[4995327.0,3794589.0],[5019721.0,3883841.0],[5062315.0,3909757.0],[5108900.0,3874214.0]]}},{"type":"Feature","properties":{"id":10453},"geometry":{"type":"LineString","coordinates":[[3323563.0,3931364.0],[3346926.0,3940907.0],[3358588.0,3958999.0],[3368084.0,3908537.0],[3358110.0,3877276.0],[3349877.0,3886091.0],[3334528.0,3863828.0],[3328550.0,3879443.0],[3349304.0,3900734.0],[3344392.0,3914011.0],[3323651.0,3918921.0],[3323563.0,3931364.0]]}},{"type":"Feature","properties":{"id":10454},"geometry":{"type":"LineString","coordinates":[[5171516.0,3860202.0],[5181786.0,3888519.0],[5167150.0,3949299.0]]}},{"type":"Feature","properties":{"id":10455},"geometry":{"type":"LineString","coordinates":[[3218031.0,4015195.0],[3243682.0,3996999.0],[3233528.0,3979585.0],[3217022.0,3996131.0],[3218031.0,4015195.0]]}},{"type":"Feature","properties":{"id":10456},"geometry":{"type":"LineString","coordinates":[[4808951.0,3823346.0],[4812959.0,3837543.0],[4806241.0,3853279.0],[4823232.0,3886956.0],[4837869.0,3900907.0],[4859011.0,3904881.0],[4856710.0,3882759.0],[4845993.0,3871328.0],[4848367.0,3829771.0],[4819113.0,3791718.0],[4817976.0,3810697.0],[4808951.0,3823346.0]]}},{"type":"Feature","properties":{"id":10457},"geometry":{"type":"LineString","coordinates":[[4715178.0,3895576.0],[4723660.0,3846239.0],[4714642.0,3797036.0],[4734262.0,3762691.0],[4722887.0,3713585.0],[4707053.0,3735828.0],[4695105.0,3706695.0]]}},{"type":"Feature","properties":{"id":10458},"geometry":{"type":"LineString","coordinates":[[4213958.0,3894853.0],[4160463.0,3880519.0],[4111864.0,3915148.0]]}},{"type":"Feature","properties":{"id":10459},"geometry":{"type":"LineString","coordinates":[[3395470.0,3908045.0],[3402307.0,3954367.0],[3444222.0,4007274.0],[3516379.0,4000441.0],[3461377.0,3908521.0]]}},{"type":"Feature","properties":{"id":10460},"geometry":{"type":"LineString","coordinates":[[3283557.0,4039540.0],[3315661.0,4048203.0],[3303502.0,4021071.0],[3285167.0,4028795.0],[3283557.0,4039540.0]]}},{"type":"Feature","properties":{"id":10461},"geometry":{"type":"LineString","coordinates":[[3274897.0,3908116.0],[3287729.0,3937607.0],[3290299.0,3967785.0],[3315587.0,3977885.0],[3316722.0,4000967.0],[3334274.0,4023626.0],[3377292.0,4038243.0],[3378770.0,4018108.0],[3361723.0,3990130.0],[3327093.0,3973344.0],[3301991.0,3955780.0],[3301840.0,3944764.0],[3280062.0,3903740.0],[3274897.0,3908116.0]]}},{"type":"Feature","properties":{"id":10462},"geometry":{"type":"LineString","coordinates":[[4713516.0,3965892.0],[4730318.0,3916416.0],[4715178.0,3895576.0]]}},{"type":"Feature","properties":{"id":10463},"geometry":{"type":"LineString","coordinates":[[4279981.0,3964790.0],[4256066.0,3930742.0],[4213958.0,3894853.0]]}},{"type":"Feature","properties":{"id":10464},"geometry":{"type":"LineString","coordinates":[[4756741.0,4006532.0],[4749147.0,3979009.0],[4713516.0,3965892.0]]}},{"type":"Feature","properties":{"id":10465},"geometry":{"type":"LineString","coordinates":[[4436223.0,3830455.0],[4409724.0,3876750.0],[4390495.0,3950683.0],[4390977.0,3986335.0],[4404885.0,3988539.0]]}},{"type":"Feature","properties":{"id":10466},"geometry":{"type":"LineString","coordinates":[[4311751.0,3993711.0],[4279981.0,3964790.0]]}},{"type":"Feature","properties":{"id":10467},"geometry":{"type":"LineString","coordinates":[[5013912.0,3983249.0],[5041780.0,4011076.0],[5041690.0,4058791.0],[5068119.0,4043693.0],[5066259.0,4016325.0],[5083635.0,4020511.0],[5085144.0,4000835.0],[5053057.0,3958959.0],[5030958.0,3957907.0],[5013912.0,3983249.0]]}},{"type":"Feature","properties":{"id":10468},"geometry":{"type":"LineString","coordinates":[[5167150.0,3949299.0],[5166522.0,3996787.0],[5135024.0,3990002.0],[5103396.0,4016848.0],[5090939.0,4077903.0],[5100684.0,4090792.0]]}},{"type":"Feature","properties":{"id":10469},"geometry":{"type":"LineString","coordinates":[[3554209.0,4051884.0],[3560861.0,4068428.0],[3586366.0,4090902.0],[3592915.0,4072843.0]]}},{"type":"Feature","properties":{"id":10470},"geometry":{"type":"LineString","coordinates":[[3592902.0,4074583.0],[3606123.0,4088443.0],[3606912.0,4064160.0],[3593740.0,4055353.0],[3592915.0,4072843.0]]}},{"type":"Feature","properties":{"id":10471},"geometry":{"type":"LineString","coordinates":[[4404885.0,3988539.0],[4401998.0,3995042.0],[4373394.0,3994670.0],[4359073.0,4038767.0]]}},{"type":"Feature","properties":{"id":10472},"geometry":{"type":"LineString","coordinates":[[4067516.0,4048740.0],[4066964.0,4034094.0],[4049999.0,4016026.0],[4050941.0,4049817.0]]}},{"type":"Feature","properties":{"id":10473},"geometry":{"type":"LineString","coordinates":[[5262087.0,4156078.0],[5333199.0,4170603.0]]}},{"type":"Feature","properties":{"id":10474},"geometry":{"type":"LineString","coordinates":[[5100684.0,4090792.0],[5209290.0,4151086.0]]}},{"type":"Feature","properties":{"id":10475},"geometry":{"type":"LineString","coordinates":[[5209290.0,4151086.0],[5218020.0,4159433.0],[5262087.0,4156078.0]]}},{"type":"Feature","properties":{"id":10476},"geometry":{"type":"LineString","coordinates":[[4111864.0,3915148.0],[4063430.0,3969120.0],[4062754.0,3997635.0],[4078630.0,4025681.0],[4076161.0,4060048.0],[4086574.0,4065582.0]]}},{"type":"Feature","properties":{"id":10477},"geometry":{"type":"LineString","coordinates":[[4339298.0,4065645.0],[4346423.0,4037055.0],[4346757.0,4003238.0],[4332808.0,3989225.0],[4311751.0,3993711.0]]}},{"type":"Feature","properties":{"id":10478},"geometry":{"type":"LineString","coordinates":[[4086574.0,4065582.0],[4073655.0,4082010.0],[4067516.0,4048740.0]]}},{"type":"Feature","properties":{"id":10479},"geometry":{"type":"LineString","coordinates":[[4349264.0,4075770.0],[4351023.0,4053305.0],[4339298.0,4065645.0]]}},{"type":"Feature","properties":{"id":10480},"geometry":{"type":"LineString","coordinates":[[4359073.0,4038767.0],[4349264.0,4075770.0]]}},{"type":"Feature","properties":{"id":10481},"geometry":{"type":"LineString","coordinates":[[4976175.0,4151379.0],[4992664.0,4157357.0],[5001266.0,4135606.0],[4991594.0,4121921.0],[4983243.0,4137835.0],[4976175.0,4151379.0]]}},{"type":"Feature","properties":{"id":10482},"geometry":{"type":"LineString","coordinates":[[3676999.0,4139732.0],[3684494.0,4153634.0],[3702442.0,4135469.0],[3687478.0,4118856.0],[3680384.0,4129674.0],[3676999.0,4139732.0]]}},{"type":"Feature","properties":{"id":10483},"geometry":{"type":"LineString","coordinates":[[4802428.0,4155191.0],[4828639.0,4099628.0],[4813628.0,4024026.0],[4778124.0,3992595.0],[4756741.0,4006532.0]]}},{"type":"Feature","properties":{"id":10484},"geometry":{"type":"LineString","coordinates":[[4849742.0,4160483.0],[4852847.0,4171726.0],[4880172.0,4177511.0],[4895042.0,4177026.0],[4906992.0,4154329.0],[4885223.0,4144300.0],[4849742.0,4160483.0]]}},{"type":"Feature","properties":{"id":10485},"geometry":{"type":"LineString","coordinates":[[5218624.0,4259109.0],[5072006.0,4157719.0],[5046108.0,4154066.0],[5041165.0,4175348.0]]}},{"type":"Feature","properties":{"id":10486},"geometry":{"type":"LineString","coordinates":[[5288693.0,4283534.0],[5273757.0,4265294.0],[5235584.0,4253988.0],[5218624.0,4259109.0]]}},{"type":"Feature","properties":{"id":10487},"geometry":{"type":"LineString","coordinates":[[4912181.0,4177879.0],[4916773.0,4208000.0],[4930820.0,4199583.0],[4931862.0,4177671.0],[4912181.0,4177879.0]]}},{"type":"Feature","properties":{"id":10488},"geometry":{"type":"LineString","coordinates":[[4724601.0,4193676.0],[4802428.0,4155191.0]]}},{"type":"Feature","properties":{"id":10489},"geometry":{"type":"LineString","coordinates":[[3692417.0,4197914.0],[3700198.0,4210129.0],[3708947.0,4200875.0],[3713935.0,4230457.0],[3728996.0,4228088.0],[3703741.0,4175491.0],[3692925.0,4162961.0],[3692417.0,4197914.0]]}},{"type":"Feature","properties":{"id":10490},"geometry":{"type":"LineString","coordinates":[[4050941.0,4049817.0],[4042375.0,4151462.0],[4055301.0,4201494.0]]}},{"type":"Feature","properties":{"id":10491},"geometry":{"type":"LineString","coordinates":[[5041165.0,4175348.0],[5018495.0,4156323.0],[4995851.0,4183129.0],[4951957.0,4163053.0],[4928832.0,4235379.0],[4936924.0,4266002.0]]}},{"type":"Feature","properties":{"id":10492},"geometry":{"type":"LineString","coordinates":[[4936924.0,4266002.0],[4936631.0,4321582.0],[4914878.0,4364837.0]]}},{"type":"Feature","properties":{"id":10493},"geometry":{"type":"LineString","coordinates":[[4712401.0,4358106.0],[4708560.0,4324518.0],[4717891.0,4307526.0],[4707582.0,4249823.0],[4724601.0,4193676.0]]}},{"type":"Feature","properties":{"id":10494},"geometry":{"type":"LineString","coordinates":[[4055301.0,4201494.0],[4028866.0,4211715.0],[4043571.0,4246645.0],[4050153.0,4300287.0],[4065300.0,4319486.0],[4065105.0,4346555.0],[4083260.0,4327950.0]]}},{"type":"Feature","properties":{"id":10495},"geometry":{"type":"LineString","coordinates":[[4083260.0,4327950.0],[4082496.0,4349754.0],[4097728.0,4347844.0],[4127569.0,4396800.0],[4168270.0,4431122.0],[4202990.0,4434137.0],[4214590.0,4479884.0],[4251819.0,4476424.0]]}},{"type":"Feature","properties":{"id":10496},"geometry":{"type":"LineString","coordinates":[[4784816.0,4515904.0],[4748513.0,4460125.0],[4748690.0,4441849.0],[4708275.0,4382150.0],[4712401.0,4358106.0]]}},{"type":"Feature","properties":{"id":10497},"geometry":{"type":"LineString","coordinates":[[4914878.0,4364837.0],[4889604.0,4446257.0],[4885968.0,4486648.0],[4960842.0,4587133.0]]}},{"type":"Feature","properties":{"id":10498},"geometry":{"type":"LineString","coordinates":[[4281551.0,4547228.0],[4274344.0,4524241.0],[4254760.0,4532858.0],[4258827.0,4545550.0],[4281551.0,4547228.0]]}},{"type":"Feature","properties":{"id":10499},"geometry":{"type":"LineString","coordinates":[[4960842.0,4587133.0],[4985007.0,4614223.0]]}},{"type":"Feature","properties":{"id":10500},"geometry":{"type":"LineString","coordinates":[[2807713.0,4905170.0],[2838649.0,4925563.0],[2858074.0,4922790.0]]}},{"type":"Feature","properties":{"id":10501},"geometry":{"type":"LineString","coordinates":[[4251819.0,4476424.0],[4237473.0,4493231.0],[4240360.0,4507768.0],[4265631.0,4503597.0],[4273302.0,4491523.0],[4306292.0,4506001.0],[4317480.0,4546301.0],[4356382.0,4589914.0]]}},{"type":"Feature","properties":{"id":10502},"geometry":{"type":"LineString","coordinates":[[4356382.0,4589914.0],[4371705.0,4611538.0],[4372242.0,4650389.0],[4422522.0,4658515.0]]}},{"type":"Feature","properties":{"id":10503},"geometry":{"type":"LineString","coordinates":[[4865014.0,4706862.0],[4852405.0,4671787.0],[4863192.0,4648472.0],[4866056.0,4612842.0],[4824122.0,4539690.0],[4784816.0,4515904.0]]}},{"type":"Feature","properties":{"id":10504},"geometry":{"type":"LineString","coordinates":[[4985007.0,4614223.0],[5005514.0,4674930.0],[5012198.0,4702483.0],[5003689.0,4735026.0],[5015893.0,4739799.0],[5026116.0,4715435.0],[5040403.0,4727559.0],[5015510.0,4795586.0]]}},{"type":"Feature","properties":{"id":10505},"geometry":{"type":"LineString","coordinates":[[4967896.0,4811191.0],[4971227.0,4797935.0],[4915519.0,4784777.0],[4897827.0,4749344.0],[4882949.0,4752631.0],[4865014.0,4706862.0]]}},{"type":"Feature","properties":{"id":10506},"geometry":{"type":"LineString","coordinates":[[5015510.0,4795586.0],[4994333.0,4799920.0],[4967896.0,4811191.0]]}},{"type":"Feature","properties":{"id":10507},"geometry":{"type":"LineString","coordinates":[[2858074.0,4922790.0],[2829547.0,4943650.0],[2812929.0,4999240.0],[2865876.0,5053660.0],[2823221.0,5079215.0],[2822381.0,5107070.0],[2905636.0,5139349.0],[2929483.0,5108677.0],[2934493.0,5028953.0],[2992572.0,5054149.0],[3105558.0,5016974.0],[3182249.0,5029089.0],[3215343.0,4973811.0],[3232233.0,4908819.0],[3228234.0,4870364.0],[3204110.0,4833705.0],[3134323.0,4791821.0],[2952145.0,4768793.0],[2869562.0,4813198.0],[2806152.0,4886032.0],[2807713.0,4905170.0]]}},{"type":"Feature","properties":{"id":10508},"geometry":{"type":"LineString","coordinates":[[4441308.0,4977367.0],[4450606.0,5009443.0],[4457512.0,4989894.0],[4449988.0,4967044.0],[4441308.0,4977367.0]]}},{"type":"Feature","properties":{"id":10509},"geometry":{"type":"LineString","coordinates":[[4462356.0,5003033.0],[4483972.0,5031489.0],[4489351.0,5012889.0],[4468198.0,4995012.0],[4462356.0,5003033.0]]}},{"type":"Feature","properties":{"id":10510},"geometry":{"type":"LineString","coordinates":[[4422522.0,4658515.0],[4414948.0,4727918.0],[4427038.0,4783167.0],[4446799.0,4822303.0],[4459084.0,4813829.0],[4463487.0,4851215.0],[4480659.0,4880435.0],[4504124.0,4900429.0],[4524697.0,4973595.0],[4562851.0,5012394.0],[4554862.0,5031192.0],[4510750.0,5023980.0],[4510925.0,5071568.0],[4554801.0,5123441.0],[4564713.0,5084523.0]]}},{"type":"Feature","properties":{"id":10511},"geometry":{"type":"LineString","coordinates":[[4564713.0,5084523.0],[4583196.0,5103805.0],[4613870.0,5083916.0],[4600030.0,5146387.0],[4653396.0,5197696.0],[4662259.0,5238895.0],[4695442.0,5242799.0],[4704025.0,5215904.0],[4727614.0,5214817.0],[4730784.0,5245331.0],[4750209.0,5236474.0],[4759009.0,5264465.0]]}},{"type":"Feature","properties":{"id":10512},"geometry":{"type":"LineString","coordinates":[[4759009.0,5264465.0],[4789654.0,5277248.0],[4802860.0,5328246.0],[4832692.0,5327945.0],[4889649.0,5378319.0],[4903835.0,5335205.0],[4971011.0,5401020.0],[5001187.0,5378719.0],[5027556.0,5391153.0],[5074654.0,5377304.0],[5089120.0,5354899.0],[5089239.0,5313295.0],[5121980.0,5303619.0]]}},{"type":"Feature","properties":{"id":10513},"geometry":{"type":"LineString","coordinates":[[4830628.0,5382140.0],[4838530.0,5391087.0],[4848304.0,5361192.0],[4838085.0,5358305.0],[4830628.0,5382140.0]]}},{"type":"Feature","properties":{"id":10514},"geometry":{"type":"LineString","coordinates":[[6632484.0,1824592.0],[6613550.0,1863789.0],[6629679.0,1913289.0],[6604629.0,1929139.0]]}},{"type":"Feature","properties":{"id":10515},"geometry":{"type":"LineString","coordinates":[[6863319.0,2563703.0],[6877693.0,2593565.0]]}},{"type":"Feature","properties":{"id":10516},"geometry":{"type":"LineString","coordinates":[[5845264.0,2669526.0],[5848989.0,2658979.0],[5849006.0,2619963.0],[5811317.0,2587520.0]]}},{"type":"Feature","properties":{"id":10517},"geometry":{"type":"LineString","coordinates":[[3464122.0,3751599.0],[3464201.0,3751021.0],[3463717.0,3750666.0],[3463709.0,3750213.0],[3464001.0,3750092.0]]}},{"type":"Feature","properties":{"id":10518},"geometry":{"type":"LineString","coordinates":[[3621681.0,3203977.0],[3621527.0,3204088.0]]}},{"type":"Feature","properties":{"id":10519},"geometry":{"type":"LineString","coordinates":[[3592915.0,4072843.0],[3563498.0,4038565.0],[3554209.0,4051884.0]]}},{"type":"Feature","properties":{"id":10520},"geometry":{"type":"LineString","coordinates":[[3592915.0,4072843.0],[3592902.0,4074583.0]]}}]};/* harmony default export */ __webpack_exports__["a"] = (countryLevel);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_objects_objectTools__ = __webpack_require__(47);
var generalConfig={chart:{style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'},backgroundColor:'rgba(255, 0,0, 0.0)',marginBottom:30},title:{text:''},credits:{enabled:true,text:'',href:'https://www.orkestra.deusto.es',position:{y:-10},style:{fontSize:'12px'}},exporting:{sourceWidth:800,sourceHeight:550,buttons:{contextButton:{enabled:false}},allowHTML:true},tooltip:{enabled:true,valueSuffix:'',formatter:function formatter(){return'<span style="font-weight: bold; font-size: 10px">'+this.point.options.countryName+'</span><br/> <span>'+this.point.options.name+' ('+this.point.options.code+')</span>';},style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'}},mapNavigation:{enabled:true,buttonOptions:{verticalAlign:'top',align:'left',x:-9}},colorAxis:{tickPixelInterval:50,startOnTick:false,endOnTick:false,labels:{align:'right',x:30},reversed:false},legend:{enabled:false,borderWidth:0,padding:0,itemDistance:2,layout:'vertical',align:'left',verticalAlign:'bottom',floating:false},series:[]};var selectedRegionConfig=__WEBPACK_IMPORTED_MODULE_1_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var chartMapConfig={geoJSON:__WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__["a" /* default */],generalConfig:generalConfig,selectedRegionConfig:selectedRegionConfig};/* harmony default export */ __webpack_exports__["a"] = (chartMapConfig);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1045);
var _this=this;var Error=function Error(props){var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].error));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(Error));

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({error:{id:'Error.error',description:'Mensaje de error',defaultMessage:'No se han podido recuperar los datos'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_app_appTools__ = __webpack_require__(25);
var _this=this;var Footer=function Footer(props){var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;var lang=__WEBPACK_IMPORTED_MODULE_3_utils_app_appTools__["a" /* default */].getActualLanguage();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ork-skeleton__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-footer__block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-footer__copyright'},'\xA9\xA02018-2026',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.orkestra.deusto.es/'+lang,target:'_blank',rel:'noopener',className:'text-primary'},'Orkestra'),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'visible-md-block'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].competitivenessBasqueInstitute)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].anInitiativeOf)),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.deusto.es',taget:'_blank',rel:'noopener',className:'text-primary'},'Deusto'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-footer__block',dangerouslySetInnerHTML:{__html:_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].spriGroup)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-footer__block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-envelope fa-lg text-primary'}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:behatoki@orkestra.deusto.es'},'behatoki@orkestra.deusto.es')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.orkestra.deusto.es/'+lang+'/'+_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].privacy),target:'_blank',rel:'noopener noreferrer'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].privacy))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(Footer));

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({competitivenessBasqueInstitute:{id:'Footer.competitivenessBasqueInstitute',description:'Texto para el footer, Insituto Vasco de Competitividad',defaultMessage:'Instituto Vasco de Competitividad'},anInitiativeOf:{id:'Footer.anInitiativeOf',description:'Texto para el footer, una iniciativa de...',defaultMessage:'Una iniciativa de'},spriGroup:{id:'Footer.spriGroup',description:'[Mantener HTML] Texto para el mensaje central del footer',defaultMessage:'Esta plataforma cuenta con la financiación del <strong>Grupo SPRI</strong>,<br /> agencia vasca de desarrollo empresarial'},privacy:{id:'Footer.privacy',description:'Texto de privacidad para el footer',defaultMessage:'Privacidad'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Controllers_Survey_SurveyController__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_app_urls__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveyControllerContainer=function(_Component){_inherits(SurveyControllerContainer,_Component);function SurveyControllerContainer(props){_classCallCheck(this,SurveyControllerContainer);var _this=_possibleConstructorReturn(this,(SurveyControllerContainer.__proto__||Object.getPrototypeOf(SurveyControllerContainer)).call(this,props));_this.SECONDS_TO_APPEAR=120;_this.state={timeLeftToOpen:_this.SECONDS_TO_APPEAR,shouldOpen:false};return _this;}_createClass(SurveyControllerContainer,[{key:'componentDidMount',value:function componentDidMount(){var enterTime=sessionStorage.getItem('surveyEnterTime');var alreadyShown=sessionStorage.getItem('surveyAlreadyShown')==='true'?true:false;var reachedLayer2=sessionStorage.getItem('surveyReachedLayer2')==='true'?true:false;var timesShown=Number(localStorage.getItem('surveyTimesShown'));var currentURL=this.props.match.url;var currentLayer=__WEBPACK_IMPORTED_MODULE_2_utils_app_urls__["a" /* default */].getLayerFromURL(currentURL);if(!enterTime){enterTime=new Date();alreadyShown=false;reachedLayer2=currentLayer>1;if(!timesShown)timesShown=0;sessionStorage.setItem('surveyEnterTime',enterTime);sessionStorage.setItem('surveyAlreadyShown',alreadyShown);sessionStorage.setItem('surveyReachedLayer2',reachedLayer2);localStorage.setItem('surveyTimesShown',timesShown);}if(currentLayer>1){reachedLayer2=true;sessionStorage.setItem('surveyReachedLayer2',reachedLayer2);}if(timesShown>=3){this.setState({shoulOpen:false});}else{var now=new Date().getTime();var then=new Date(enterTime).getTime();var timeDifference=(now-then)/1000;var timeLeftToOpen=this.SECONDS_TO_APPEAR-timeDifference;if(!alreadyShown&&reachedLayer2){if(timeLeftToOpen<5){this.setState({timeLeftToOpen:5,shouldOpen:true});}else{this.setState({timeLeftToOpen:timeLeftToOpen,shouldOpen:true});}}}}},{key:'renderIfAllOK',value:function renderIfAllOK(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Controllers_Survey_SurveyController__["a" /* default */],{shouldOpen:this.state.shouldOpen,timeLeftToOpen:this.state.timeLeftToOpen});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return SurveyControllerContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SurveyControllerContainer);

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SurveyController__ = __webpack_require__(1050);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SurveyController__["a" /* default */]);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1051);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveyController=function(_Component){_inherits(SurveyController,_Component);function SurveyController(props){_classCallCheck(this,SurveyController);var _this=_possibleConstructorReturn(this,(SurveyController.__proto__||Object.getPrototypeOf(SurveyController)).call(this,props));_this.closeSurvey=function(){_this.setState({open:false});};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={running:false,open:false,alreadyShown:false};_this.timeout={};_this.interval={};return _this;}_createClass(SurveyController,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.shouldOpen){this.initializeCountdown();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.shouldOpen){this.initializeCountdown();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timeout);clearInterval(this.interval);}},{key:'initializeCountdown',value:function initializeCountdown(){var _this2=this;if(!this.state.running){var timeLeftToOpen=this.props.timeLeftToOpen;//Interval for debugging purposes only
// let time = timeLeftToOpen
// this.interval = setInterval(() => {
//   time--
//   console.log('Countdown', time)
//   if (time < 0) clearInterval(this.interval)
// }, 1000)
this.timeout=setTimeout(function(){var timesShown=Number(localStorage.getItem('surveyTimesShown'));sessionStorage.setItem('surveyAlreadyShown',true);localStorage.setItem('surveyTimesShown',timesShown+1);_this2.setState({open:true,alreadyShown:true});},timeLeftToOpen*1000);this.setState({running:true});}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;var BASE_URL= true?"/competitiveness-observatory":'';var bottom='10%';if(this.state.alreadyShown){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-access-to-survey '+(this.state.open?'animated faster slideInLeft':'animated faster slideOutLeft'),style:{position:'fixed',top:'auto',bottom:bottom}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ork-access-to-survey__close js-ork-access-to-survey__close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-times fa-2x',onClick:this.closeSurvey})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ork-access-to-survey__logo-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].logo),alt:'Observatorio de competitividad'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-access-to-survey__highlighted text-primary'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].hello))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].thanks))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-access-to-survey__highlighted text-primary'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].helpUs))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].thanksAgain))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ork-u-mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].surveyLink),role:'button',className:'btn btn-warning',target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-pencil-alt fa-lg'}),'\xA0',this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yes)),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'js-ork-access-to-survey__close',onClick:this.closeSurvey},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].no))));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return SurveyController;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(SurveyController));

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({surveyLink:{id:'SurveyController.surveyLink',description:'URL a la encuesta',defaultMessage:'https://www.orkestra.deusto.es/es/?option=com_rsform&view=rsform&formId=12'},logo:{id:'SurveyController/logo',description:'Logo que aparece en la encuesta',defaultMessage:'/img/logo-observatorio-competitividad-es.svg'},hello:{id:'SurveyController.hello',description:'Texto que encabeza el elemento',defaultMessage:'Hola,'},thanks:{id:'SurveyController.thanks',description:'Texto de agradecimiento',defaultMessage:'Muchas gracias por utilizar el Observatorio de Competividad de Orkestra.'},helpUs:{id:'SurveyController.helpUs',description:'Texto principal',defaultMessage:'Ayúdanos a mejorar tu experiencia respondiendo a 4 preguntas en esta breve encuesta.'},thanksAgain:{id:'SurveyController.thanksAgain',description:'Agradecimiento final',defaultMessage:'Gracias de nuevo. El equipo de Orkestra.'},yes:{id:'SurveyController.yes',description:'Sí',defaultMessage:'Sí, encantado'},no:{id:'SurveyController.no',description:'No',defaultMessage:'No, gracias'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HTMLTitleController=function(_Component){_inherits(HTMLTitleController,_Component);function HTMLTitleController(props){_classCallCheck(this,HTMLTitleController);var _this=_possibleConstructorReturn(this,(HTMLTitleController.__proto__||Object.getPrototypeOf(HTMLTitleController)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={loading:true};return _this;}_createClass(HTMLTitleController,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setHTMLTitle();}},{key:'setHTMLTitle',value:function setHTMLTitle(){var url=this.props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_3_utils_app_urls__["a" /* default */].getLayerFromURL(url);if(this.state.loading){var title='Orkestra';switch(layer){case 0:title=this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].regional)+' - '+this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].institute);break;case 1:if(this.props.regionsData&&this.props.selectedRegionId){var selectedRegionName=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:this.props.regionsData,id:this.props.selectedRegionId});title=selectedRegionName+' - '+this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].regional);}break;case 2:if(this.props.regionsData&&this.props.selectedRegionId){var _selectedRegionName=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:this.props.regionsData,id:this.props.selectedRegionId});var _url=this.props.location.pathname;var level=__WEBPACK_IMPORTED_MODULE_3_utils_app_urls__["a" /* default */].getLevelFromURL(_url);var dimensionTitle=__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].getDimensionTitle(level);title=dimensionTitle+' - '+_selectedRegionName;}break;case 3:if(this.props.regionsData&&this.props.selectedRegionId&&this.props.indicatorsData){var _selectedRegionName2=__WEBPACK_IMPORTED_MODULE_5_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:this.props.regionsData,id:this.props.selectedRegionId});var _url2=this.props.location.pathname;var indicatorId=__WEBPACK_IMPORTED_MODULE_3_utils_app_urls__["a" /* default */].getIndicatorFromURL(_url2);var indicatorName=__WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__["a" /* default */].getIndicatorNameFromId({indicatorsData:this.props.indicatorsData,id:indicatorId});title=indicatorName+' - '+_selectedRegionName2;}break;case'methodology':title=this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].methodology)+' - '+this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].regional);break;default:title='Orkestra';break;}document.querySelector('head title').innerHTML=title;}}},{key:'render',value:function render(){return'';}}]);return HTMLTitleController;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(HTMLTitleController));

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({regional:{id:'HTMLTitleController.regional',description:'Texto para el title de capas 0 y 1',defaultMessage:'Observatorio de Competitividad Regional'},institute:{id:'HTMLTitleController.institute',description:'Texto para el title de capa 0',defaultMessage:'Orkestra Instituto Vasco de Competitividad'},methodology:{id:'HTMLTitleController.methodology',description:'Texto para el title de metodologia',defaultMessage:'Metodología'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitivenessGeneralDashboard__ = __webpack_require__(1055);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__CompetitivenessGeneralDashboard__["a" /* default */]);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_LayerHeader__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentContainer__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_SelectedRegion_SelectedRegionController__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompetitivenessGeneralDashboard=function(_Component){_inherits(CompetitivenessGeneralDashboard,_Component);function CompetitivenessGeneralDashboard(){_classCallCheck(this,CompetitivenessGeneralDashboard);return _possibleConstructorReturn(this,(CompetitivenessGeneralDashboard.__proto__||Object.getPrototypeOf(CompetitivenessGeneralDashboard)).apply(this,arguments));}_createClass(CompetitivenessGeneralDashboard,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_SelectedRegion_SelectedRegionController__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LayerHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return CompetitivenessGeneralDashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CompetitivenessGeneralDashboard);

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Breadcrumbs__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RegionOverview__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Controllers_RegionChanger_RegionChangerController__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Charts_Map_LayerHeaderMap__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_config__ = __webpack_require__(46);
var LayerHeader=function LayerHeader(){var regionChangeController=void 0;if(__WEBPACK_IMPORTED_MODULE_5_utils_config__["a" /* default */].getProperty("enable_region_change",true)){regionChangeController=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Controllers_RegionChanger_RegionChangerController__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Breadcrumbs__["a" /* default */],{responsive:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_RegionOverview__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-sm-offset-3 col-md-3 col-md-offset-0 ork-region-changing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Charts_Map_LayerHeaderMap__["a" /* default */],null),regionChangeController)));};/* harmony default export */ __webpack_exports__["a"] = (LayerHeader);

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegionOverview__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,regionsData:state.REGIONS.regionsData,countriesData:state.REGIONS.countriesData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__RegionOverview__["a" /* default */])));

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Indicators_Header_HeaderIndicatorsContainer__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messages__ = __webpack_require__(1063);
var _this=this;var RegionOverview=function RegionOverview(props){var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;// const language = props.match.params.lang;
var selectedRegionName='';if(props.regionsData){selectedRegionName=__WEBPACK_IMPORTED_MODULE_3_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:props.regionsData,id:props.selectedRegionId});}// let button;
// let regionMeta = Config.getConfig().region_meta;
// if ( regionMeta.hasOwnProperty( String( props.selectedRegionId ) ) ) {
//   let altview = Config.getConfig().region_meta[ String( props.selectedRegionId ) ][ "altview" ]; 
//   let alturl = altview.url.replace('{language}', language);
//   button = <a className="btn btn-sm btn-primary btn-reg-altview" href={alturl} style={{float: "right"}} role="button">{this.formatMessage(messages[altview.msgid])}</a>;
// }
var reportPanelBanner=null;if(props.selectedRegionId===1){var path=props.history.location.pathname;var reportPanelLink=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getReportPanelLink(path);reportPanelBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert-new',dangerouslySetInnerHTML:{__html:_this.formatMessage(__WEBPACK_IMPORTED_MODULE_5__messages__["a" /* default */].alertNewReportPanel,{reportPanelLink:reportPanelLink})}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{display:"inline"}},selectedRegionName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-region-overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Indicators_Header_HeaderIndicatorsContainer__["a" /* default */],null)),reportPanelBanner);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(RegionOverview));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderIndicatorsContainer__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__HeaderIndicatorsContainer__["a" /* default */]));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Indicators_Header_HeaderIndicator__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_config__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderIndicatorsContainer=function(_Component){_inherits(HeaderIndicatorsContainer,_Component);function HeaderIndicatorsContainer(){_classCallCheck(this,HeaderIndicatorsContainer);return _possibleConstructorReturn(this,(HeaderIndicatorsContainer.__proto__||Object.getPrototypeOf(HeaderIndicatorsContainer)).apply(this,arguments));}_createClass(HeaderIndicatorsContainer,[{key:'render',value:function render(){var BASE_URL= true?"/competitiveness-observatory":'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Indicators_Header_HeaderIndicator__["a" /* default */],{key:'PIB per capita',indicator:__WEBPACK_IMPORTED_MODULE_2_utils_config__["a" /* default */].getConfig().header.indicators[0],selectedRegionId:this.props.selectedRegionId,imgPath:BASE_URL+'/img/icono-pib-per-capita.svg?v=02'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Indicators_Header_HeaderIndicator__["a" /* default */],{key:'Población total',indicator:__WEBPACK_IMPORTED_MODULE_2_utils_config__["a" /* default */].getConfig().header.indicators[1],selectedRegionId:this.props.selectedRegionId,imgPath:BASE_URL+'/img/icono-poblacion.svg?v=02'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Indicators_Header_HeaderIndicator__["a" /* default */],{key:'Tasa de desempleo',indicator:__WEBPACK_IMPORTED_MODULE_2_utils_config__["a" /* default */].getConfig().header.indicators[2],selectedRegionId:this.props.selectedRegionId,imgPath:BASE_URL+'/img/icono-desempleo.svg?v=02'}));}}]);return HeaderIndicatorsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HeaderIndicatorsContainer);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderIndicator__ = __webpack_require__(1062);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__HeaderIndicator__["a" /* default */]);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_api_urls_v1__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderIndicator=function(_Component){_inherits(HeaderIndicator,_Component);function HeaderIndicator(props){_classCallCheck(this,HeaderIndicator);var _this=_possibleConstructorReturn(this,(HeaderIndicator.__proto__||Object.getPrototypeOf(HeaderIndicator)).call(this,props));_this.getIndicator=function(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:_this.props.indicator},indicator=_ref.indicator;if(_this.props.selectedRegionId===null)return;var dataAndMetaPromise=Promise.resolve(__WEBPACK_IMPORTED_MODULE_2_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_3_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:[_this.props.selectedRegionId],time:["newest"],meta:true})));Promise.all([dataAndMetaPromise]).then(function(response){var data=response[0].data;var meta=response[0].meta;var indicatorData=meta;indicatorData.value=data[0].value;indicatorData.lastUpdated=data[0].time;_this.setState({indicatorData:indicatorData,loading:false});}).catch(function(reason){console.error(reason);_this.setState({error:true,loading:false});});};var formatNumber=_this.props.intl.formatNumber;_this.formatNumber=formatNumber;_this.state={indicatorData:{},loading:true,error:false};return _this;}_createClass(HeaderIndicator,[{key:'componentDidMount',value:function componentDidMount(){this.getIndicator();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(prevProps!==this.props){this.setState({loading:true,error:false},function(){return _this2.getIndicator();});}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Loading__["a" /* default */],null);}else{var indicatorData=this.state.indicatorData;var indicatorName=__WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorName(indicatorData.name);var indicatorUnit=__WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorUnit(indicatorData.unit);var indicatorNameMainPart=indicatorName.split('(')[0];var indicatorNameParenthesis='';if(indicatorName.split('(')[1]===''||indicatorName.split('(')[1]===undefined){indicatorNameParenthesis='';}else{indicatorNameParenthesis='('+indicatorName.split('(')[1];}var lastUpdated=__WEBPACK_IMPORTED_MODULE_4_utils_dates_dateTools__["a" /* default */].getYearFromDateString(indicatorData.lastUpdated);renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-region-overview__item',key:indicatorName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-region-overview__item__img-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.imgPath,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,lastUpdated)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-region-overview__item__text-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-region-overview__item__text-block__key'},indicatorNameMainPart,' ',indicatorNameParenthesis!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null):'',' ',indicatorNameParenthesis),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-region-overview__item__text-block__value'},''+__WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__["a" /* default */].formatValue(indicatorData.value,indicatorData.unit),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-region-overview__item__text-block__unit'},''+indicatorUnit))));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return HeaderIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(HeaderIndicator));

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({altVersionBtnEustat:{id:'RegionOverview.altVersionBtnEustat',description:'Botón para cambiar a Eustat',defaultMessage:'Cambiar a versión EUSTAT'},altVersionBtnEurostat:{id:'RegionOverview.altVersionBtnEurostat',description:'Botón para cambiar a Eurostat',defaultMessage:'Cambiar a versión EUROSTAT'},alertNewReportPanel:{id:'RegionOverview.alertNewReportPanel',description:'Banner de anuncio del nuevo panel',defaultMessage:'<h4>¡NUEVO!</h4>Accede al <a href="{reportPanelLink}">panel de diagnóstico</a> del Informe de Competitividad del País Vasco 2025<a href="{reportPanelLink}">aquí</a>'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LayerHeaderMap__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{regionsData:state.REGIONS.regionsData,selectedRegionId:state.REGIONS.selectedRegionId};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__LayerHeaderMap__["a" /* default */]));

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LayerHeaderMapConfig__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LayerHeaderMapAdapter__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LayerHeaderMap=function(_Component){_inherits(LayerHeaderMap,_Component);function LayerHeaderMap(props){_classCallCheck(this,LayerHeaderMap);var _this=_possibleConstructorReturn(this,(LayerHeaderMap.__proto__||Object.getPrototypeOf(LayerHeaderMap)).call(this,props));_this.state={loading:true,error:false};_this.mapRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(LayerHeaderMap,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.regionsData&&this.props.selectedRegionId){this.getMap();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.regionsData===undefined&&this.props.regionsData!==undefined||prevProps.selectedRegionId===undefined&&this.props.selectedRegionId!==undefined){this.getMap();}else if(this.props.regionsData&&this.props.selectedRegionId){if(prevProps.selectedRegionId!==this.props.selectedRegionId){this.setState({loading:true,error:false},this.getMap);}}}},{key:'getMap',value:function getMap(){if(this.state.loading){var chartConfig=__WEBPACK_IMPORTED_MODULE_2__LayerHeaderMapConfig__["a" /* default */].generalConfig;var series=__WEBPACK_IMPORTED_MODULE_3__LayerHeaderMapAdapter__["a" /* default */].formatMapSeries({regionsData:this.props.regionsData,selectedRegionId:this.props.selectedRegionId});chartConfig.series=series;this.setState({chartConfig:chartConfig,loading:false,error:false});}}},{key:'renderIfAllOK',value:function renderIfAllOK(){if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Error__["a" /* default */],null);}else if(this.state.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Loading__["a" /* default */],null);}else{var renderingComponent=void 0;var width=document.querySelector('.ork-region-changing').clientWidth-30;var domProps=__WEBPACK_IMPORTED_MODULE_4_utils_objects_objectTools__["a" /* default */].copyObject(__WEBPACK_IMPORTED_MODULE_2__LayerHeaderMapConfig__["a" /* default */].domProps);domProps.style.height=width+'px';renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_highcharts_ReactHighmaps_src___default.a,{ref:this.mapRef,config:this.state.chartConfig,domProps:domProps});return renderingComponent;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return LayerHeaderMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LayerHeaderMap);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_objects_objectTools__ = __webpack_require__(47);
var generalConfig={chart:{style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'},marginBottom:30,events:{load:function load(){var series=this.series[0].data;var id=void 0;for(var i=0;i<series.length;i++){var item=series[i];if(item.id){id=item.id;}}var x=this.get(id).plotX;var y=this.get(id).plotY;this.mapZoom(0.3,this.xAxis[0].toValue(x,false),this.yAxis[0].toValue(y,true),x,y);}}},title:{text:'',floating:true,align:'right',x:1,y:12,useHTML:true,style:{fontSize:'12px',fontWeight:'bold',color:'#717171',backgroundColor:'#FFF',padding:'5px 10px 5px 10px',borderRadius:'0px 0px 0px 10px'}},credits:{enabled:false,text:'',href:'https://www.orkestra.deusto.es',position:{y:-10},style:{fontSize:'12px'}},exporting:{sourceWidth:800,sourceHeight:550,buttons:{contextButton:{enabled:false}},allowHTML:true},tooltip:{enabled:false,valueSuffix:'',formatter:function formatter(){return'<span style="font-weight: bold; font-size: 10px">'+this.point.options.countryName+'</span><br/> <span>'+this.point.options.name+' ('+this.point.options.code+')</span>';},style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'}},mapNavigation:{enabled:true,enableButtons:false,buttonOptions:{verticalAlign:'top',alignTo:'spacingBox'}},colorAxis:{tickPixelInterval:50,startOnTick:false,endOnTick:false,labels:{align:'right',x:30},reversed:false},legend:{enabled:false,borderWidth:0,padding:0,itemDistance:2,layout:'vertical',align:'left',verticalAlign:'bottom',floating:false},series:[]};var selectedRegionConfig=__WEBPACK_IMPORTED_MODULE_1_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var domProps={style:{},id:'cosaChart'};var chartMapConfig={geoJSON:__WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__["a" /* default */],generalConfig:generalConfig,selectedRegionConfig:selectedRegionConfig,domProps:domProps};/* harmony default export */ __webpack_exports__["a"] = (chartMapConfig);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__ = __webpack_require__(116);
var formatMapSeries=function formatMapSeries(_ref){var regionsData=_ref.regionsData,selectedRegionId=_ref.selectedRegionId;var chartData=regionsData.map(function(region){var name=region.name;var code=region.code;var color='#FFFFFF';var id=void 0;if(region.id===selectedRegionId){color='#0fa4c4';id=selectedRegionId;}return{name:name,code:code,color:color,id:id};});var series=[{type:'map',index:1,mapData:__WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__["a" /* default */].regionLevel,data:chartData,joinBy:['NUTS_ID','code']},{type:'mapline',index:2,mapData:__WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__["a" /* default */].countryLevel,nullColor:'#333',showInLegend:false,includeInCSVExport:false,name:'borders',lineWidth:0.75,color:'#CCCCCC',dataLabels:{enabled:false},states:{hover:{enabled:false}}}];return series;};var mapChartAdapter={formatMapSeries:formatMapSeries};/* harmony default export */ __webpack_exports__["a"] = (mapChartAdapter);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentHeader__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Filters_FilterContainer__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Content_PanelSection__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentChart_ContentChartWrapper__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Content_ContentChart_PanelDimensionContainer__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentContainer=function(_Component){_inherits(ContentContainer,_Component);function ContentContainer(props){_classCallCheck(this,ContentContainer);var _this=_possibleConstructorReturn(this,(ContentContainer.__proto__||Object.getPrototypeOf(ContentContainer)).call(this,props));_this.state={layer:1,loading:true,error:false};return _this;}_createClass(ContentContainer,[{key:'componentDidMount',value:function componentDidMount(){document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll');this.loadData();var url=this.props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_8_utils_app_urls__["a" /* default */].getLayerFromURL(url);this.setState({layer:layer});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.selectedRegionId!==prevProps.selectedRegionId){this.loadData();}}},{key:'loadData',value:function loadData(){var _this2=this;if(this.props.selectedRegionId===null)return;var p1=__WEBPACK_IMPORTED_MODULE_7_utils_api_api__["a" /* default */].getRegions().then(function(regions){return __WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getDataFromRegions(regions);});// if (Config.getConfig().app.USE_REFREGIONS) {
//   const p2 = p1
//     .then(regionsData => {
//       return { regionsPromise: API.getReferenceRegions(regionsData, this.props.selectedRegionId), regionsData }
//     })
//     .then(({ regionsPromise, regionsData }) =>
//       regionsPromise.then(regions =>
//         RegionTools.getDataFromReferenceRegions({ regions, regionsData, selectedRegionId: this.props.selectedRegionId })
//       )
//     )
// }
var p3=__WEBPACK_IMPORTED_MODULE_7_utils_api_api__["a" /* default */].getRegions().then(function(regions){return __WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getSameCountryRegionsData(regions,_this2.props.selectedRegionId);});var p4=__WEBPACK_IMPORTED_MODULE_7_utils_api_api__["a" /* default */].getIndicators().then(function(indicators){return __WEBPACK_IMPORTED_MODULE_10_utils_indicators_indicatorTools__["a" /* default */].getDataFromIndicators(indicators);});var p5=__WEBPACK_IMPORTED_MODULE_7_utils_api_api__["a" /* default */].getIndicatorsStatus().then(function(indicatorsStatus){return indicatorsStatus.last_checked_on;});var p6=__WEBPACK_IMPORTED_MODULE_7_utils_api_api__["a" /* default */].getCountries().then(function(countries){return __WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getDataFromCountries(countries);});Promise.all([p1,/*p2,*/p3,p4,p5,p6]).then(function(values){_this2.props.setRegionsData(values[0]);if(__WEBPACK_IMPORTED_MODULE_1_utils_config__["a" /* default */].getConfig().app.USE_REFREGIONS){_this2.props.setReferenceRegionsData(values[1]);_this2.props.setSameCountryRegionsData(values[2]);_this2.props.setIndicatorsData(values[3]);_this2.props.setIndicatorsLastUpdated(values[4]);_this2.props.setCountriesData(values[5]);}else{_this2.props.setSameCountryRegionsData(values[1]);_this2.props.setIndicatorsData(values[2]);_this2.props.setIndicatorsLastUpdated(values[3]);_this2.props.setCountriesData(values[4]);}var selectedRegionMeta=values[0].filter(function(region){return Number(region.id)===Number(_this2.props.selectedRegionId);})[0];var selectedRegionCountryMeta=__WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].countryCodeToMeta(__WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getCountryCodeFromRegionCode(selectedRegionMeta.code));_this2.props.setSelectedRegionCountryMeta(selectedRegionCountryMeta);}).then(function(){_this2.setState({loading:false,error:false});}).catch(function(reason){_this2.setState({error:true,loading:false});});}},{key:'decide',value:function decide(){switch(this.state.layer){case 1:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_PanelSection__["a" /* default */],{layer:this.state.layer,dimension:0,collapsed:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_PanelSection__["a" /* default */],{layer:this.state.layer,dimension:1,collapsed:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_PanelSection__["a" /* default */],{layer:this.state.layer,dimension:2,collapsed:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_PanelSection__["a" /* default */],{layer:this.state.layer,dimension:3,collapsed:true}));case 2:var level=this.props.match.params.level;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_modules_Content_ContentChart_PanelDimensionContainer__["a" /* default */],{layer:this.state.layer,dimension:level}));case 3:var indicator=__WEBPACK_IMPORTED_MODULE_8_utils_app_urls__["a" /* default */].getIndicatorFromURL(this.props.history.location.pathname);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentChart_ContentChartWrapper__["a" /* default */],{layer:this.state.layer,level:0,indicator:indicator}));default:return'';}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Loading__["a" /* default */],null);}else{var layer=this.state.layer;var dimension=void 0;var indicatorId=void 0;if(layer===3){indicatorId=Number(this.props.match.params.indicatorId);dimension=__WEBPACK_IMPORTED_MODULE_10_utils_indicators_indicatorTools__["a" /* default */].getDimensionFromIndicator(indicatorId);}else{dimension=this.props.match.params.level;indicatorId=0;}var contentClass='obs-panel-'+dimension;var filterContainer=null;if(layer>1){filterContainer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Filters_FilterContainer__["a" /* default */],{layer:this.state.layer,typeAheadMultiple:this.state.layer===1?false:true}));}renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:contentClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentHeader__["a" /* default */],{layer:this.state.layer,level:dimension,indicator:indicatorId}),filterContainer,this.decide()));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid ork-gray-box'},this.renderIfAllOK());}}]);return ContentContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContentContainer);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentHeader__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{indicatorsData:state.INDICATORS.indicatorsData,lastUpdated:state.INDICATORS.lastUpdated};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__ContentHeader__["a" /* default */])));

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draggabilly__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draggabilly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draggabilly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_RelatedDocuments_RelatedDocumentsDraggable__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Content_MiniMap__ = __webpack_require__(408);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentHeader=function(_Component){_inherits(ContentHeader,_Component);function ContentHeader(props){_classCallCheck(this,ContentHeader);var _this=_possibleConstructorReturn(this,(ContentHeader.__proto__||Object.getPrototypeOf(ContentHeader)).call(this,props));_this.getRef=function(ref){_this.setState({elementRef:ref});};_this.areRelatedDocumentsAvailable=function(available){_this.setState({relatedDocumentsAvailable:available});};_this.openRelatedDocuments=function(){if(_this.relatedDocuments&&_this.state.elementRef){var windowHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;var windowWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;var scroll=window.pageYOffset;var element=_this.state.elementRef.current;var elementHeight=element.offsetHeight;var elementWidth=element.offsetWidth;var height=windowHeight/2-elementHeight/2;height=height+scroll;if(height<scroll)height=scroll;var width=windowWidth/2-elementWidth/2;_this.relatedDocuments.setPosition(width,height);_this.setState({relatedDocumentsOpen:true});}};_this.closeRelatedDocuments=function(){if(_this.relatedDocuments){_this.setState({relatedDocumentsOpen:false});}};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].importFormatter(formatMessage);_this.state={relatedDocumentsOpen:false,relatedDocumentsAvailable:false,elementRef:null};_this.relatedDocuments=null;return _this;}_createClass(ContentHeader,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.state.elementRef){var element=this.state.elementRef.current;if(element){this.relatedDocuments=new __WEBPACK_IMPORTED_MODULE_1_draggabilly___default.a(element,{containment:'#root',// para evitar que se salga de los lÃ­mites del navegador
handle:'.ork-related-documents__heading__drag'});}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.relatedDocuments!==null){this.relatedDocuments.destroy();}}},{key:'renderLayer1Header',value:function renderLayer1Header(){var lastUpdated=__WEBPACK_IMPORTED_MODULE_7_utils_dates_dateTools__["a" /* default */].formatDateForContentHeader(this.props.lastUpdated);var methodologyLink=__WEBPACK_IMPORTED_MODULE_6_utils_app_urls__["a" /* default */].getMethodologyLink(this.props.history.location.pathname);var header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Content_MiniMap__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer1Title,{lastUpdated:lastUpdated})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer1Subtitle,{methodologyLink:methodologyLink})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].knowMoreAboutMethodology,{methodologyLink:methodologyLink})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].moreDataAvailableNote,{methodologyLink:methodologyLink})}})));return header;}},{key:'renderLayer2Header',value:function renderLayer2Header(){var lastUpdated=__WEBPACK_IMPORTED_MODULE_7_utils_dates_dateTools__["a" /* default */].formatDateForContentHeader(this.props.lastUpdated);var levelTitle=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getDimensionTitle(this.props.level);var methodologyLink=__WEBPACK_IMPORTED_MODULE_6_utils_app_urls__["a" /* default */].getMethodologyLink(this.props.history.location.pathname);var subtitle=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getDimensionSubtitle(this.props.level);var header=void 0;header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Content_MiniMap__["a" /* default */],{dimension:this.props.level}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer2Title,{lastUpdated:lastUpdated,levelNumber:levelTitle.levelNumber,levelName:levelTitle})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-lead__text-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'panel-description',dangerouslySetInnerHTML:{__html:subtitle}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'panel-description',dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].knowMoreAboutMethodology,{methodologyLink:methodologyLink})}}))))// 			{/* <div className="ork-lead__btn-wrapper">
//       <button
//         data-related-documents="related-documents"
//         className="btn btn-warning"
//         onClick={this.openRelatedDocuments}
//         disabled={!this.state.relatedDocumentsAvailable}
//       >
//         <i className="fal fa-file-alt fa-lg" data-related-documents="related-documents" />
// 					&nbsp;
//         <span className="ork-u-ml" data-related-documents="related-documents">
//           {this.formatMessage(messages.relatedDocuments)}
//         </span>
//       </button>
//     </div> */}
// 		{/* <RelatedDocumentsDraggable
//     getRef={this.getRef}
//     layer={2}
//     level={Number(this.props.level)}
//     open={this.state.relatedDocumentsOpen}
//     close={this.closeRelatedDocuments}
//     areAvailable={this.areRelatedDocumentsAvailable}
//   /> */}
;return header;}},{key:'renderLayer3Header',value:function renderLayer3Header(){var _this2=this;var header=void 0;var indicator_id=Number(this.props.indicator);var dimension=__WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].getDimensionFromIndicator(indicator_id);var indicatorData=this.props.indicatorsData.filter(function(item){return Number(item.id)===Number(_this2.props.indicator);})[0];var indicatorName=__WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorName(indicatorData.name);var indicatorUnit=indicatorData.unit;var indicatorSource=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getComposedDataSource(indicatorData.dataSource);var indicatorLastUpdated=__WEBPACK_IMPORTED_MODULE_7_utils_dates_dateTools__["a" /* default */].formatDateForContentHeader(indicatorData.lastUpdated);var subTitle=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].unit)+': '+indicatorUnit+' '+(indicatorSource!==''?'| '+indicatorSource:'');header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Content_MiniMap__["a" /* default */],{dimension:dimension}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layer3Title,{indicatorName:indicatorName,indicatorLastUpdated:indicatorLastUpdated})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-lead__text-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:subTitle}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-lead__btn-wrapper'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_RelatedDocuments_RelatedDocumentsDraggable__["a" /* default */],{getRef:this.getRef,layer:this.props.layer,level:this.props.level,indicator:this.props.indicator,open:this.state.relatedDocumentsOpen,close:this.closeRelatedDocuments,areAvailable:this.areRelatedDocumentsAvailable}));return header;}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;switch(this.props.layer){case 1:renderingComponent=this.renderLayer1Header();break;case 2:renderingComponent=this.renderLayer2Header();break;case 3:renderingComponent=this.renderLayer3Header();break;default:renderingComponent=null;}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return ContentHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(ContentHeader));

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Draggabilly v2.2.0
 * Make that shiz draggable
 * https://draggabilly.desandro.com
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(1072),
        __webpack_require__(1073)
      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( getSize, Unidragger ) {
        return factory( window, getSize, Unidragger );
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('get-size'),
      require('unidragger')
    );
  } else {
    // browser global
    window.Draggabilly = factory(
      window,
      window.getSize,
      window.Unidragger
    );
  }

}( window, function factory( window, getSize, Unidragger ) {

'use strict';

// -------------------------- helpers & variables -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

function noop() {}

var jQuery = window.jQuery;

// --------------------------  -------------------------- //

function Draggabilly( element, options ) {
  // querySelector if string
  this.element = typeof element == 'string' ?
    document.querySelector( element ) : element;

  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = extend( {}, this.constructor.defaults );
  this.option( options );

  this._create();
}

// inherit Unidragger methods
var proto = Draggabilly.prototype = Object.create( Unidragger.prototype );

Draggabilly.defaults = {
};

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  extend( this.options, opts );
};

// css position values that don't need to be set
var positionValues = {
  relative: true,
  absolute: true,
  fixed: true
};

proto._create = function() {
  // properties
  this.position = {};
  this._getPosition();

  this.startPoint = { x: 0, y: 0 };
  this.dragPoint = { x: 0, y: 0 };

  this.startPosition = extend( {}, this.position );

  // set relative positioning
  var style = getComputedStyle( this.element );
  if ( !positionValues[ style.position ] ) {
    this.element.style.position = 'relative';
  }

  // events, bridge jQuery events from vanilla
  this.on( 'pointerDown', this.onPointerDown );
  this.on( 'pointerMove', this.onPointerMove );
  this.on( 'pointerUp', this.onPointerUp );

  this.enable();
  this.setHandles();
};

/**
 * set this.handles and bind start events to 'em
 */
proto.setHandles = function() {
  this.handles = this.options.handle ?
    this.element.querySelectorAll( this.options.handle ) : [ this.element ];

  this.bindHandles();
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = [ event ].concat( args );
  this.emitEvent( type, emitArgs );
  this.dispatchJQueryEvent( type, event, args );
};

proto.dispatchJQueryEvent = function( type, event, args ) {
  var jQuery = window.jQuery;
  // trigger jQuery event
  if ( !jQuery || !this.$element ) {
    return;
  }
  // create jQuery event
  var $event = jQuery.Event( event );
  $event.type = type;
  this.$element.trigger( $event, args );
};

// -------------------------- position -------------------------- //

// get x/y position from style
proto._getPosition = function() {
  var style = getComputedStyle( this.element );
  var x = this._getPositionCoord( style.left, 'width' );
  var y = this._getPositionCoord( style.top, 'height' );
  // clean up 'auto' or other non-integer values
  this.position.x = isNaN( x ) ? 0 : x;
  this.position.y = isNaN( y ) ? 0 : y;

  this._addTransformPosition( style );
};

proto._getPositionCoord = function( styleSide, measure ) {
  if ( styleSide.indexOf('%') != -1 ) {
    // convert percent into pixel for Safari, #75
    var parentSize = getSize( this.element.parentNode );
    // prevent not-in-DOM element throwing bug, #131
    return !parentSize ? 0 :
      ( parseFloat( styleSide ) / 100 ) * parentSize[ measure ];
  }
  return parseInt( styleSide, 10 );
};

// add transform: translate( x, y ) to position
proto._addTransformPosition = function( style ) {
  var transform = style.transform;
  // bail out if value is 'none'
  if ( transform.indexOf('matrix') !== 0 ) {
    return;
  }
  // split matrix(1, 0, 0, 1, x, y)
  var matrixValues = transform.split(',');
  // translate X value is in 12th or 4th position
  var xIndex = transform.indexOf('matrix3d') === 0 ? 12 : 4;
  var translateX = parseInt( matrixValues[ xIndex ], 10 );
  // translate Y value is in 13th or 5th position
  var translateY = parseInt( matrixValues[ xIndex + 1 ], 10 );
  this.position.x += translateX;
  this.position.y += translateY;
};

// -------------------------- events -------------------------- //

proto.onPointerDown = function( event, pointer ) {
  this.element.classList.add('is-pointer-down');
  this.dispatchJQueryEvent( 'pointerDown', event, [ pointer ] );
};

/**
 * drag start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.dragStart = function( event, pointer ) {
  if ( !this.isEnabled ) {
    return;
  }
  this._getPosition();
  this.measureContainment();
  // position _when_ drag began
  this.startPosition.x = this.position.x;
  this.startPosition.y = this.position.y;
  // reset left/top style
  this.setLeftTop();

  this.dragPoint.x = 0;
  this.dragPoint.y = 0;

  this.element.classList.add('is-dragging');
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
  // start animation
  this.animate();
};

proto.measureContainment = function() {
  var container = this.getContainer();
  if ( !container ) {
    return;
  }

  var elemSize = getSize( this.element );
  var containerSize = getSize( container );
  var elemRect = this.element.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();

  var borderSizeX = containerSize.borderLeftWidth + containerSize.borderRightWidth;
  var borderSizeY = containerSize.borderTopWidth + containerSize.borderBottomWidth;

  var position = this.relativeStartPosition = {
    x: elemRect.left - ( containerRect.left + containerSize.borderLeftWidth ),
    y: elemRect.top - ( containerRect.top + containerSize.borderTopWidth )
  };

  this.containSize = {
    width: ( containerSize.width - borderSizeX ) - position.x - elemSize.width,
    height: ( containerSize.height - borderSizeY ) - position.y - elemSize.height
  };
};

proto.getContainer = function() {
  var containment = this.options.containment;
  if ( !containment ) {
    return;
  }
  var isElement = containment instanceof HTMLElement;
  // use as element
  if ( isElement ) {
    return containment;
  }
  // querySelector if string
  if ( typeof containment == 'string' ) {
    return document.querySelector( containment );
  }
  // fallback to parent element
  return this.element.parentNode;
};

// ----- move event ----- //

proto.onPointerMove = function( event, pointer, moveVector ) {
  this.dispatchJQueryEvent( 'pointerMove', event, [ pointer, moveVector ] );
};

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isEnabled ) {
    return;
  }
  var dragX = moveVector.x;
  var dragY = moveVector.y;

  var grid = this.options.grid;
  var gridX = grid && grid[0];
  var gridY = grid && grid[1];

  dragX = applyGrid( dragX, gridX );
  dragY = applyGrid( dragY, gridY );

  dragX = this.containDrag( 'x', dragX, gridX );
  dragY = this.containDrag( 'y', dragY, gridY );

  // constrain to axis
  dragX = this.options.axis == 'y' ? 0 : dragX;
  dragY = this.options.axis == 'x' ? 0 : dragY;

  this.position.x = this.startPosition.x + dragX;
  this.position.y = this.startPosition.y + dragY;
  // set dragPoint properties
  this.dragPoint.x = dragX;
  this.dragPoint.y = dragY;

  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

function applyGrid( value, grid, method ) {
  method = method || 'round';
  return grid ? Math[ method ]( value / grid ) * grid : value;
}

proto.containDrag = function( axis, drag, grid ) {
  if ( !this.options.containment ) {
    return drag;
  }
  var measure = axis == 'x' ? 'width' : 'height';

  var rel = this.relativeStartPosition[ axis ];
  var min = applyGrid( -rel, grid, 'ceil' );
  var max = this.containSize[ measure ];
  max = applyGrid( max, grid, 'floor' );
  return  Math.max( min, Math.min( max, drag ) );
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.onPointerUp = function( event, pointer ) {
  this.element.classList.remove('is-pointer-down');
  this.dispatchJQueryEvent( 'pointerUp', event, [ pointer ] );
};

/**
 * drag end
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.dragEnd = function( event, pointer ) {
  if ( !this.isEnabled ) {
    return;
  }
  // use top left position when complete
  this.element.style.transform = '';
  this.setLeftTop();
  this.element.classList.remove('is-dragging');
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

// -------------------------- animation -------------------------- //

proto.animate = function() {
  // only render and animate if dragging
  if ( !this.isDragging ) {
    return;
  }

  this.positionDrag();

  var _this = this;
  requestAnimationFrame( function animateFrame() {
    _this.animate();
  });

};

// left/top positioning
proto.setLeftTop = function() {
  this.element.style.left = this.position.x + 'px';
  this.element.style.top  = this.position.y + 'px';
};

proto.positionDrag = function() {
  this.element.style.transform = 'translate3d( ' + this.dragPoint.x +
    'px, ' + this.dragPoint.y + 'px, 0)';
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  this.dispatchEvent( 'staticClick', event, [ pointer ] );
};

// ----- methods ----- //

/**
 * @param {Number} x
 * @param {Number} y
 */
proto.setPosition = function( x, y ) {
  this.position.x = x;
  this.position.y = y;
  this.setLeftTop();
};

proto.enable = function() {
  this.isEnabled = true;
};

proto.disable = function() {
  this.isEnabled = false;
  if ( this.isDragging ) {
    this.dragEnd();
  }
};

proto.destroy = function() {
  this.disable();
  // reset styles
  this.element.style.transform = '';
  this.element.style.left = '';
  this.element.style.top = '';
  this.element.style.position = '';
  // unbind handles
  this.unbindHandles();
  // remove jQuery data
  if ( this.$element ) {
    this.$element.removeData('draggabilly');
  }
};

// ----- jQuery bridget ----- //

// required for jQuery bridget
proto._init = noop;

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'draggabilly', Draggabilly );
}

// -----  ----- //

return Draggabilly;

}));


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(1074)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
      return factory( window, Unipointer );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  this.pointerDownPointer = pointer;

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(1075)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
      return factory( window, EvEmitter );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  } else if ( 'ontouchstart' in window ) {
    // Touch Events. iOS Safari
    startEvent = 'touchstart';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({layer1Title:{id:'ContentHeader.layer1Title',description:'[Mantener HTML] Titulo de la cabecera del contenido de la capa 1',defaultMessage:'Panel de indicadores de competitividad <small>actualizado a { lastUpdated }</small>'},layer1Subtitle:{id:'ContentHeader.layer1Subtitle',description:'[Mantener HTML] Subtitulo de la cabecera del contenido de la capa 1',defaultMessage:'El panel se organiza en <strong>cuatro dimensiones</strong> esenciales a la hora de identificar las claves de la competitividad al servicio del bienestar inclusivo y sostenible. Utiliza el <strong>mini mapa</strong> a la derecha para orientarte.'},layer2Title:{id:'ContentHeader.layer2Title',description:'[Mantner HTML] Titulo de la cabecera del contenido de la capa 2',defaultMessage:'<span class="ork-u-default-text-color">{levelNumber}</span> {levelName} <small>actualizado a {lastUpdated}</small>'},layer2Subtitle:{id:'ContentHeader.layer2Subtitle',description:'[Mantener HTML] Subtitulo de la cabecera del contenido de la capa2',defaultMessage:'El panel se organiza en <strong>cuatro niveles</strong> que determinan el desempeño competitivo. Conocer más sobre la <a href={methodologyLink}>metodología de elaboración del panel</a>.'},layer3Title:{id:'ContentHeader.layer3Title',description:'[Mantener HTML] Titulo de la cabecera del contenido de la capa 3',defaultMessage:'{indicatorName} <small>actualizado a {indicatorLastUpdated}</small>'},knowMoreAboutMethodology:{id:'ContentHeader.knowMoreAboutMethodology',description:'[Mantener HTML] Subtitulo de la cabecera del contenido de la capa 1',defaultMessage:'Conocer más sobre <a href={methodologyLink}>el marco y la metodología de elaboración del panel</a>.'},moreDataAvailableNote:{id:'ContentHeader.moreDataAvailableNote',description:'[Mantener HTML] Subtitulo de la cabecera del contenido de la capa 1',defaultMessage:'(*) En caso de disponer de datos más recientes para la región se indica con un <sup>*</sup> junto al año de comparación.'},relatedDocuments:{id:'ContentHeader.relatedDocuments',description:'Texto del botón que abre los análisis relacionados',defaultMessage:'Análisis relacionados'},unit:{id:'ContentHeader.unit',description:'Unidad',defaultMessage:'Unidad'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsDraggable__ = __webpack_require__(1078);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsDraggable__["a" /* default */]);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_RelatedDocuments_RelatedDocumentsBody__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentDraggable=function(_Component){_inherits(ContentDraggable,_Component);function ContentDraggable(props){_classCallCheck(this,ContentDraggable);var _this=_possibleConstructorReturn(this,(ContentDraggable.__proto__||Object.getPrototypeOf(ContentDraggable)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={collapsed:true};_this.draggableRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ContentDraggable,[{key:'componentDidMount',value:function componentDidMount(){this.props.getRef(this.draggableRef);}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;var layer=this.props.layer;var level=this.props.level;var levelTitle=void 0;var levelNumber=void 0;if(layer===1){levelTitle=__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].getTitleFromLevel(level);levelNumber=levelTitle.levelNumber.toLowerCase();levelNumber=levelNumber.slice(0,-1);}renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.draggableRef,className:'ork-related-documents '+(this.props.open?'':'invisible')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-related-documents__heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-related-documents__heading__drag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-expand-arrows'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-related-documents__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-file-alt fa-lg'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-u-ml'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].relatedDocuments),' ',levelNumber?'('+levelNumber+')':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-related-documents__heading__close',onClick:this.props.close},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-times fa-lg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_RelatedDocuments_RelatedDocumentsBody__["a" /* default */],{layer:this.props.layer,level:this.props.level,indicator:this.props.indicator,areAvailable:this.props.areAvailable}));return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return ContentDraggable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ContentDraggable));

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({relatedDocuments:{id:'RelatedDocumentsDraggable.relatedDocuments',description:'Texto de Análisis relacionados',defaultMessage:'Análisis relacionados'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBody__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,regionsData:state.REGIONS.regionsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBody__["a" /* default */])));

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RelatedDocumentsBodyAdapter__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_RelatedDocuments_RelatedDocumentsBodyNavMenu__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_RelatedDocuments_RelatedDocumentsBodyNavContent__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_urls__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatedDocumentsBody=function(_Component){_inherits(RelatedDocumentsBody,_Component);function RelatedDocumentsBody(props){_classCallCheck(this,RelatedDocumentsBody);var _this=_possibleConstructorReturn(this,(RelatedDocumentsBody.__proto__||Object.getPrototypeOf(RelatedDocumentsBody)).call(this,props));_this.setDefaultActiveTab=function(){var relatedDocumentsData=_this.state.relatedDocumentsData;var tabs=relatedDocumentsData.map(function(item){return item.year;}).sort().reverse();return tabs[0];};_this.state={loading:true,error:false};return _this;}_createClass(RelatedDocumentsBody,[{key:'componentDidMount',value:function componentDidMount(){this.loadRelatedDocuments();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.selectedRegionId!==prevProps.selectedRegionId){this.setState({loading:true,error:false},this.loadRelatedDocuments());}}},{key:'loadRelatedDocuments',value:function loadRelatedDocuments(){var _this2=this;var layer=this.props.layer;var level=this.props.level;var indicator=this.props.indicator;var selectedRegionCode=__WEBPACK_IMPORTED_MODULE_7_utils_regions_regionTools__["a" /* default */].getRegionCodeFromId({regionsData:this.props.regionsData,id:this.props.selectedRegionId});var response=void 0;if(layer===1||layer===2){response=__WEBPACK_IMPORTED_MODULE_5_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_6_utils_api_urls__["a" /* default */].getRelatedDocumentsLevel({selectedRegionCode:selectedRegionCode,level:level}));}else if(layer===3){response=__WEBPACK_IMPORTED_MODULE_5_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_6_utils_api_urls__["a" /* default */].getRelatedDocumentsIndicator({selectedRegionCode:selectedRegionCode,indicator:indicator}));}response.then(function(data){return __WEBPACK_IMPORTED_MODULE_2__RelatedDocumentsBodyAdapter__["a" /* default */].getUsefulData(data);}).then(function(usefulData){_this2.setState({relatedDocumentsData:usefulData,loading:false,error:false});if(usefulData.length>0)_this2.props.areAvailable(true);else _this2.props.areAvailable(false);}).catch(function(reason){_this2.setState({loading:false,error:true});});}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null);}else{var defaultActiveTab=this.setDefaultActiveTab();renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-related-documents__body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["l" /* Tab */].Container,{id:'tabs-with-dropdown',defaultActiveKey:defaultActiveTab},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["k" /* Row */],{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_RelatedDocuments_RelatedDocumentsBodyNavMenu__["a" /* default */],{relatedDocumentsData:this.state.relatedDocumentsData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_RelatedDocuments_RelatedDocumentsBodyNavContent__["a" /* default */],{relatedDocumentsData:this.state.relatedDocumentsData})))));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return RelatedDocumentsBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RelatedDocumentsBody);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__ = __webpack_require__(54);
var getUsefulData=function getUsefulData(data){var usefulData=data.items.sort(function(itemA,itemB){return itemA.date>itemB.date?-1:1;}).map(function(item){return{year:__WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.date),description:item.description,title:item.title,url:item.url};});return usefulData;};var relatedDocumentsBodyAdapter={getUsefulData:getUsefulData};/* harmony default export */ __webpack_exports__["a"] = (relatedDocumentsBodyAdapter);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBodyNavMenu__ = __webpack_require__(1084);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBodyNavMenu__["a" /* default */]);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatedDocumentsBodyNavMenu=function(_Component){_inherits(RelatedDocumentsBodyNavMenu,_Component);function RelatedDocumentsBodyNavMenu(props){_classCallCheck(this,RelatedDocumentsBodyNavMenu);var _this=_possibleConstructorReturn(this,(RelatedDocumentsBodyNavMenu.__proto__||Object.getPrototypeOf(RelatedDocumentsBodyNavMenu)).call(this,props));_this.state={loading:true};_this.tabs=[];return _this;}_createClass(RelatedDocumentsBodyNavMenu,[{key:'componentDidMount',value:function componentDidMount(){var tabs=[];var relatedDocumentsData=this.props.relatedDocumentsData;if(relatedDocumentsData){tabs=[].concat(_toConsumableArray(new Set(relatedDocumentsData.map(function(item){return item.year;})))).sort().reverse();//Se utiliza Set para que no se añadan años repetidos
}this.tabs=tabs;if(this.state.loading){this.setState({loading:false});}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var tabs=this.tabs;var navBuffer=[];var dropdownBuffer=[];var renderingComponent=void 0;if(!this.state.loading){for(var i=0;i<tabs.length;i++){if(i<2){var navItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* NavItem */],{eventKey:tabs[i],key:tabs[i]},tabs[i]);navBuffer.push(navItem);}else{var menuItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* MenuItem */],{eventKey:tabs[i],key:tabs[i]},tabs[i]);dropdownBuffer.push(menuItem);}}renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Nav */],{bsStyle:'tabs',className:'ork-related-documents__nav-tabs'},navBuffer,dropdownBuffer.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* NavDropdown */],{eventKey:'dropdown',title:'A\xF1os anteriores',noCaret:true},dropdownBuffer):''));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return RelatedDocumentsBodyNavMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RelatedDocumentsBodyNavMenu);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBodyNavContent__ = __webpack_require__(1086);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBodyNavContent__["a" /* default */]);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_RelatedDocuments_RelatedDocumentsBodyNavContentCollapsible__ = __webpack_require__(1087);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatedDocumentsBodyNavContent=function(_Component){_inherits(RelatedDocumentsBodyNavContent,_Component);function RelatedDocumentsBodyNavContent(props){_classCallCheck(this,RelatedDocumentsBodyNavContent);var _this=_possibleConstructorReturn(this,(RelatedDocumentsBodyNavContent.__proto__||Object.getPrototypeOf(RelatedDocumentsBodyNavContent)).call(this,props));_this.classifyDocumentsData=function(documentsData){var classifiedDocumentsDataArray=[];documentsData.forEach(function(item){var titleAlreadyExists=false;var titleIndex=-1;for(var i=0;i<classifiedDocumentsDataArray.length;i++){if(classifiedDocumentsDataArray[i].title===item.title){titleAlreadyExists=true;titleIndex=i;break;}}if(!titleAlreadyExists){classifiedDocumentsDataArray.push({title:item.title,data:[]});titleIndex=classifiedDocumentsDataArray.length-1;}classifiedDocumentsDataArray[titleIndex].data.push({description:item.description,url:item.url});});return classifiedDocumentsDataArray;};_this.renderTabContent=function(tab){var collapsibleBuffer=[];var documentsOfSelectedTab=_this.props.relatedDocumentsData.filter(function(item){return item.year===tab;});var classifiedDocumentsData=_this.classifyDocumentsData(documentsOfSelectedTab);classifiedDocumentsData.forEach(function(item,index){if(index===0){collapsibleBuffer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_RelatedDocuments_RelatedDocumentsBodyNavContentCollapsible__["a" /* default */],{key:index,collapsed:false,documentsData:item}));}else{collapsibleBuffer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_RelatedDocuments_RelatedDocumentsBodyNavContentCollapsible__["a" /* default */],{key:index,collapsed:true,documentsData:item}));}});return collapsibleBuffer;};_this.state={loading:true};_this.tabs=[];var windowHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;_this.tabContentHeight=windowHeight*0.8-105;// Los 105 pixels son la altura de la cabecera de la modal más la altra de los tabs
return _this;}_createClass(RelatedDocumentsBodyNavContent,[{key:'componentDidMount',value:function componentDidMount(){var tabs=[];var relatedDocumentsData=this.props.relatedDocumentsData;if(relatedDocumentsData){tabs=[].concat(_toConsumableArray(new Set(relatedDocumentsData.map(function(item){return item.year;})))).sort().reverse();//Se utiliza Set para que no se añadan años repetidos
}this.tabs=tabs;if(this.state.loading){this.setState({loading:false});}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var tabs=this.tabs;var tabBuffer=[];var renderingComponent=void 0;if(!this.state.loading){for(var i=0;i<tabs.length;i++){var tabPane=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["l" /* Tab */].Pane,{className:'ork-related-documents__tab-pane',eventKey:tabs[i],key:tabs[i]},this.renderTabContent(tabs[i]));tabBuffer.push(tabPane);}renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["l" /* Tab */].Content,{animation:true,className:'ork-related-documents__tab-content',style:{maxHeight:this.tabContentHeight+'px'}},tabBuffer);}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return RelatedDocumentsBodyNavContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RelatedDocumentsBodyNavContent);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBodyNavContentCollapsible__ = __webpack_require__(1088);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RelatedDocumentsBodyNavContentCollapsible__["a" /* default */]);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatedDocumentsBodyNavContentCollapsible=function(_Component){_inherits(RelatedDocumentsBodyNavContentCollapsible,_Component);function RelatedDocumentsBodyNavContentCollapsible(props){_classCallCheck(this,RelatedDocumentsBodyNavContentCollapsible);var _this=_possibleConstructorReturn(this,(RelatedDocumentsBodyNavContentCollapsible.__proto__||Object.getPrototypeOf(RelatedDocumentsBodyNavContentCollapsible)).call(this,props));_this.state={collapsed:_this.props.collapsed};return _this;}_createClass(RelatedDocumentsBodyNavContentCollapsible,[{key:'renderIfAllOK',value:function renderIfAllOK(){var _this2=this;var documentsData=this.props.documentsData;var title=documentsData.title;var documentBuffer=[];if(documentsData.data){if(documentsData.data.length>0){documentsData.data.forEach(function(item,index){documentBuffer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.url,target:'_blank',rel:'noopener'},'"'+item.description+'"',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-external-link-square fa-lg text-primary'}))));});}}var renderingComponent=null;if(documentBuffer.length>0){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-related-documents__collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ork-related-documents__collapse__heading '+(this.state.collapsed?'collapsed':''),role:'button','data-toggle':'collapse',onClick:function onClick(){return _this2.setState({collapsed:!_this2.state.collapsed});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-related-documents__collapse__heading__title h4'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-related-documents__collapse__heading__toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-arrow-circle-down fa-2x'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["c" /* Collapse */],{'in':!this.state.collapsed},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-related-documents__collapse__body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,documentBuffer))));}return renderingComponent;}},{key:'render',value:function render(){return this.renderIfAllOK();}}]);return RelatedDocumentsBodyNavContentCollapsible;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RelatedDocumentsBodyNavContentCollapsible);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_app_urls__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAP_DIMENSIONS=[{id:0,x:150,y:50,w:150,h:50,r:10},{id:1,x:150,y:125,w:150,h:50,r:10},{id:2,x:350,y:25,w:75,h:175,r:10},{id:3,x:25,y:25,w:75,h:175,r:10}];var MiniMap=function(_Component){_inherits(MiniMap,_Component);function MiniMap(){_classCallCheck(this,MiniMap);return _possibleConstructorReturn(this,(MiniMap.__proto__||Object.getPrototypeOf(MiniMap)).apply(this,arguments));}_createClass(MiniMap,[{key:'componentDidMount',value:function componentDidMount(){// console.log(this.props);
}},{key:'componentDidUpdate',value:function componentDidUpdate(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this2=this;// const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : '';
var actualURL=this.props.history.location.pathname;var defaultStyle={fill:"rgb(177, 196, 220)",stroke:"rgb(216, 216, 216)"};var tooltips={};tooltips["dim_0"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},'Dimension 0');tooltips["dim_1"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},'Dimension 1');tooltips["dim_2"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},'Dimension 2');tooltips["dim_3"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},'Dimension 3');var dimensionRects=[];MAP_DIMENSIONS.forEach(function(d,index){var title=__WEBPACK_IMPORTED_MODULE_2_utils_app_appTools__["a" /* default */].getDimensionTitle(d.id);var tooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},title);var dimensionLink=null;if(_this2.props.dimensionLinks!==undefined){dimensionLink=_this2.props.dimensionLinks[d.id];}else{dimensionLink=__WEBPACK_IMPORTED_MODULE_3_utils_app_urls__["a" /* default */].getLevelDetailLink({url:actualURL,level:d.id});}var className='obs-dimension-'+d.id;if(_this2.props.dimension!==undefined&&d.id!==Number(_this2.props.dimension)){className+=' disabled';}var dimensionRect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{width:d.w,height:d.h,className:className,rx:d.r,ry:d.r,x:d.x,y:d.y}));if(dimensionLink!==null){dimensionRect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["j" /* OverlayTrigger */],{overlay:tooltip,placement:'top',key:'minimap-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:dimensionLink},dimensionRect));}dimensionRects.push(dimensionRect);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'framework-map'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',viewBox:'20 20 410 185'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{width:'200',height:'175',style:defaultStyle,rx:'10',ry:'10',x:'125',y:'25'}),dimensionRects)));}},{key:'render',value:function render(){return this.renderIfAllOK();}}]);return MiniMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MiniMap);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterContainer__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(68);
var mapStateToProps=function mapStateToProps(state){return{regionsData:state.REGIONS.regionsData,referenceRegionsData:state.REGIONS.referenceRegionsData,selectedRegionId:state.REGIONS.selectedRegionId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{manageAllFilter:function manageAllFilter(checked){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].manageAllFilter(checked));},manageReferenceFilter:function manageReferenceFilter(checked){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].manageReferenceFilter(checked));},manageSameCountryFilter:function manageSameCountryFilter(checked){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].manageSameCountryFilter(checked));},manageTypeAheadFilter:function manageTypeAheadFilter(selected){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].manageTypeAheadFilter(selected));},manageEvolutionFilter:function manageEvolutionFilter(selected){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].manageEvolutionFilter(selected));},manageChartTypeFilter:function manageChartTypeFilter(selected){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* default */].manageChartTypeFilter(selected));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__FilterContainer__["a" /* default */]));

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Filters_CheckBoxFilter__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Filters_TypeAheadFilter__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Filters_EvolutionFilter__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Filters_ChartTypeFilter__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Filters_FilterModal__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterContainer=function(_Component){_inherits(FilterContainer,_Component);function FilterContainer(props){_classCallCheck(this,FilterContainer);var _this=_possibleConstructorReturn(this,(FilterContainer.__proto__||Object.getPrototypeOf(FilterContainer)).call(this,props));_this.manageAll=function(checked){_this.setState({allRegions:checked});_this.props.manageAllFilter(checked);};_this.manageReference=function(checked){_this.setState({referenceRegions:checked});_this.props.manageReferenceFilter(checked);};_this.manageSameCountry=function(checked){_this.setState({sameCountryRegions:checked});_this.props.manageSameCountryFilter(checked);};_this.manageTypeAhead=function(selected){_this.setState({otherRegions:selected});_this.props.manageTypeAheadFilter(selected);};_this.manageEvolution=function(selected){_this.setState({evolution:selected});_this.props.manageEvolutionFilter(selected);};_this.manageChartType=function(selected){_this.setState({chartType:selected});_this.props.manageChartTypeFilter(selected);};_this.openAllRegionsModal=function(){_this.setState({showAllRegionsModal:true});};_this.closeAllRegionsModal=function(){_this.setState({showAllRegionsModal:false});};_this.openReferenceRegionsModal=function(){_this.setState({showReferenceRegionsModal:true});};_this.closeReferenceRegionsModal=function(){_this.setState({showReferenceRegionsModal:false});};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={allRegions:true,referenceRegions:false,sameCountryRegions:false,otherRegions:[],yearsEvolution:1,chartType:'evolutionAbsolute',showAllRegionsModal:false,showReferenceRegionsModal:false};_this.regionName=__WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:props.regionsData,id:props.selectedRegionId});_this.tooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].tooltip));return _this;}_createClass(FilterContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.manageAllFilter(this.state.allRegions);this.props.manageReferenceFilter(this.state.referenceRegions);this.props.manageSameCountryFilter(this.state.sameCountryRegions);this.props.manageTypeAheadFilter(this.state.otherRegions);this.props.manageEvolutionFilter(this.state.yearsEvolution);this.props.manageChartTypeFilter(this.state.chartType);}},{key:'showAllRegionsFilter',value:function showAllRegionsFilter(){var regionName=__WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:this.props.regionsData,id:this.props.selectedRegionId});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col ork-indicators-filters__european-regions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{placement:'left',overlay:this.tooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col__more-info',onClick:this.openAllRegionsModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-lg fa-info-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Filters_CheckBoxFilter__["a" /* default */],{label:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].showAllRegions),fn:this.manageAll,checked:this.state.allRegions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Filters_FilterModal__["a" /* default */],{type:'all',regionsData:this.props.regionsData,open:this.state.showAllRegionsModal,closeModal:this.closeAllRegionsModal,regionName:regionName}));}},{key:'showReferenceRegionsFilter',value:function showReferenceRegionsFilter(){// FIX: disabled referene regions
var regionsData=[];// this.props.referenceRegionsData.filter(region => region.id !== this.props.selectedRegionId)
var regionName=__WEBPACK_IMPORTED_MODULE_9_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:this.props.regionsData,id:this.props.selectedRegionId});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col ork-indicators-filters__reference-regions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{placement:'left',overlay:this.tooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col__more-info',onClick:this.openReferenceRegionsModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-lg fa-info-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Filters_CheckBoxFilter__["a" /* default */],{label:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].showReferenceRegions),fn:this.manageReference,checked:this.state.referenceRegions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Filters_FilterModal__["a" /* default */],{type:'reference',regionsData:regionsData,open:this.state.showReferenceRegionsModal,closeModal:this.closeReferenceRegionsModal,regionName:regionName}));}},{key:'showSameCountryRegionsFilter',value:function showSameCountryRegionsFilter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col ork-indicators-filters__ccaa'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Filters_CheckBoxFilter__["a" /* default */],{label:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].showSameCountryRegions),fn:this.manageSameCountry,checked:this.state.sameCountryRegions})));}},{key:'showTypeAheadFilter',value:function showTypeAheadFilter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].compareWith)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_modules_Filters_TypeAheadFilter__["a" /* default */],{fn:this.manageTypeAhead,regionsData:this.props.regionsData,multiple:this.props.typeAheadMultiple})));}},{key:'showEvolutionFilter',value:function showEvolutionFilter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters__col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_modules_Filters_EvolutionFilter__["a" /* default */],{fn:this.manageEvolution,label:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].evolutionSince)})));}},{key:'showChartTypeFilter',value:function showChartTypeFilter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-graphic-type-changing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-graphic-type-changing__label'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].chartType),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Filters_ChartTypeFilter__["a" /* default */],{fn:this.manageChartType}));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel ork-u-mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body ork-indicators-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h4 ork-u-mt-0'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].visualizationOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-indicators-filters ork-indicators-filters--capa'+this.props.layer},this.showAllRegionsFilter(),this.showSameCountryRegionsFilter(),this.showTypeAheadFilter()),this.showChartTypeFilter()));}}]);return FilterContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(FilterContainer));

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({showAllRegions:{id:'FilterContainer.showAllRegions',description:'Texto para el filtro de todas las regiones',defaultMessage:'Comparar con UE27 (2020)'},showReferenceRegions:{id:'FilterContainer.showReferenceRegions',description:'Texto para el filtro de las regiones de referencia',defaultMessage:'Regiones de referencia'},showSameCountryRegions:{id:'FilterContainer.showSameCountryRegions',description:'Texto para el filtro de las regiones del mismo país',defaultMessage:'Comparar con país'},compareWith:{id:'FilterContainer.compareWith',description:'Texto del label para comparar con otra region',defaultMessage:'Comparar con...'},evolutionSince:{id:'FilterContainer.evolutionSince',description:'Texto del label para seleccionar la evolucion',defaultMessage:'Evolución desde hace...'},chartType:{id:'FilterContainer.chartType',description:'Texto del label para seleccionar el tipo de gráfico',defaultMessage:'Tipo de gráfico'},visualizationOptions:{id:'FilterContainer.visualizationOptions',description:'Titulo para la seccion de filtros',defaultMessage:'Opciones de visualización'},tooltip:{id:'FilterContainer',description:'Texto para el tooltip',defaultMessage:'Ver listado de regiones incluídas'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckBoxFilter__ = __webpack_require__(1094);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__CheckBoxFilter__["a" /* default */]);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckBoxFilter=function(_Component){_inherits(CheckBoxFilter,_Component);function CheckBoxFilter(props){_classCallCheck(this,CheckBoxFilter);var _this=_possibleConstructorReturn(this,(CheckBoxFilter.__proto__||Object.getPrototypeOf(CheckBoxFilter)).call(this,props));_this.handleToggle=function(){_this.props.fn(_this.checkBox.current.checked);};_this.state={checked:props.checked};_this.checkBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(CheckBoxFilter,[{key:"componentDidMount",value:function componentDidMount(){this.checkBox.current.checked=this.state.checked;}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{ref:this.checkBox,type:"checkbox",onChange:this.handleToggle})," ",this.props.label);}}]);return CheckBoxFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CheckBoxFilter);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TypeAheadFilter__ = __webpack_require__(1096);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TypeAheadFilter__["a" /* default */]);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__ = __webpack_require__(22);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TypeAheadFilter=function(_Component){_inherits(TypeAheadFilter,_Component);function TypeAheadFilter(props){_classCallCheck(this,TypeAheadFilter);var _this=_possibleConstructorReturn(this,(TypeAheadFilter.__proto__||Object.getPrototypeOf(TypeAheadFilter)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={selected:[],regionsDataByCountry:__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getRegionsDataByCountry(_this.props.regionsData)};_this.typeAhead=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(TypeAheadFilter,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;var selectedElements=document.querySelectorAll('.rbt-token-removeable');if(selectedElements.length){var _loop=function _loop(i){var removeItemOnClick=function removeItemOnClick(e){if(e.target===selectedElements[i]){var name=selectedElements[i].innerHTML.split('<')[0];var newSelected=_this2.state.selected.filter(function(selectedItem){return selectedItem.name+' ('+selectedItem.code+')'!==name;});_this2.setState({selected:newSelected});_this2.handleChange(newSelected);}};selectedElements[i].onclick=removeItemOnClick;};for(var i=0;i<selectedElements.length;i++){_loop(i);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var selectedElements=document.querySelectorAll('.rbt-token-removeable');if(selectedElements.length){selectedElements.forEach(function(element){element.onclick=undefined;});}}},{key:'loadOptions',value:function loadOptions(){var _this3=this;if(this.state.regionsDataByCountry){var _ret2=function(){var regionsDataByCountry=_this3.state.regionsDataByCountry;var sortedCountryCodes=__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getSortedCountryCodesByCountryName({regionsDataByCountry:regionsDataByCountry});var processedData=[];var _loop2=function _loop2(i){var actualCountryData=regionsDataByCountry[sortedCountryCodes[i]];actualCountryData.regions=__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getSortedRegionsByRegionName({regionsData:actualCountryData.regions});var processedCountry={countryCode:sortedCountryCodes[i],countryFullName:actualCountryData.countryFullName,code:sortedCountryCodes[i],name:actualCountryData.countryFullName,isCountry:true};processedData.push(processedCountry);actualCountryData.regions.forEach(function(region){var processedRegion=region;processedRegion.countryCode=sortedCountryCodes[i];processedRegion.countryFullName=actualCountryData.countryFullName;processedRegion.isCountry=false;processedData.push(processedRegion);});};for(var i=0;i<sortedCountryCodes.length;i++){_loop2(i);}return{v:processedData};}();if((typeof _ret2==='undefined'?'undefined':_typeof(_ret2))==="object")return _ret2.v;}return[];}},{key:'renderMenuItemChildren',value:function renderMenuItemChildren(option,props,index){if(option.isCountry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,option.name));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,option.name+' ('+option.code+')');}}},{key:'handleChange',value:function handleChange(selected){selected=this.handleMultiple(selected);var selectedPlaces=[];var regionsDataByCountry=this.state.regionsDataByCountry;selected.forEach(function(item){if(item.isCountry){var country={};country.isCountry=true;country.countryFullName=regionsDataByCountry[item.countryCode].countryFullName;country.regionsData=regionsDataByCountry[item.countryCode].regions;country.regionId=regionsDataByCountry[item.countryCode].countryId;selectedPlaces.push(country);}else{var region={};region.isCountry=false;region.regionsData=[item];region.regionId=item.id;selectedPlaces.push(region);}});this.props.fn(selectedPlaces);this.setState({selected:selected});}},{key:'handleMultiple',value:function handleMultiple(selected){if(!this.props.multiple){if(selected.length>1){selected.shift();}}return selected;}},{key:'render',value:function render(){var _this4=this;var placeholder=void 0;if(this.props.multiple){placeholder=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].placeholder2);}else{placeholder=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].placeholder);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"],{ref:this.typeAhead,selected:this.state.selected,multiple:true,onChange:function onChange(selected){return _this4.handleChange(selected);},options:this.loadOptions(),labelKey:function labelKey(option){return option.name+' ('+option.code+')';},filterBy:['countryFullName','code'],renderMenuItemChildren:this.renderMenuItemChildren,selectHintOnEnter:true,placeholder:placeholder});}}]);return TypeAheadFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(TypeAheadFilter));

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({placeholder:{id:'TypeAheadFilter.placeholder',description:'Texto para el placeholder del filtro TypeAhead',defaultMessage:'Región o país'},placeholder2:{id:'TypeAheadFilter.placeholder2',description:'Texto para el placeholder del filtro TypeAhead',defaultMessage:'Añadir regiones y/o países'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EvolutionFilter__ = __webpack_require__(1099);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EvolutionFilter__["a" /* default */]);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EvolutionFilter=function(_Component){_inherits(EvolutionFilter,_Component);function EvolutionFilter(props){_classCallCheck(this,EvolutionFilter);var _this=_possibleConstructorReturn(this,(EvolutionFilter.__proto__||Object.getPrototypeOf(EvolutionFilter)).call(this,props));_this.handleChange=function(){if(_this.select.current.selectedOptions){if(_this.select.current.selectedOptions.length>0)_this.props.fn(_this.select.current.selectedOptions[0].value);}else{// For compatibility with IE11
_this.props.fn(_this.select.current.value);}};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.select=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(EvolutionFilter,[{key:'componentDidMount',value:function componentDidMount(){this.handleChange();}},{key:'renderIfAllOK',value:function renderIfAllOK(){var options=[];var renderingComponent=null;for(var i=1;i<11;i++){var option=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:i},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].option,{years:i}));options.push(option);}renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'select02'},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:this.select,onChange:this.handleChange,className:'form-control',id:'select02'},options));return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return EvolutionFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(EvolutionFilter));

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({option:{id:'EvolutionFilter.option',description:'Opcion para seleccionar años de evolución',defaultMessage:'{years, plural, one{# año} other{# años}}'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChartTypeFilter__ = __webpack_require__(1102);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ChartTypeFilter__["a" /* default */]);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_mixin__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(1111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartTypeFilter=function(_Component){_inherits(ChartTypeFilter,_Component);function ChartTypeFilter(props){_classCallCheck(this,ChartTypeFilter);var _this=_possibleConstructorReturn(this,(ChartTypeFilter.__proto__||Object.getPrototypeOf(ChartTypeFilter)).call(this,props));_this.handleClick=function(event){if(event){_this.props.fn(event.target.value);_this.setState({activeButton:event.target.value});}else{_this.props.fn('evolutionAbsolute');}};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.select=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={activeButton:'evolutionAbsolute',responsive:true};return _this;}_createClass(ChartTypeFilter,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2_react_responsive_mixin___default.a.media({minWidth:992},function(){return _this2.setState({responsive:false});});__WEBPACK_IMPORTED_MODULE_2_react_responsive_mixin___default.a.media({maxWidth:991},function(){return _this2.setState({responsive:true});});this.handleClick();}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;var buttonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{value:'evolutionAbsolute',onClick:this.handleClick,active:this.state.activeButton==='evolutionAbsolute'?true:false},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].absoluteValuesEvolution)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{value:'map',onClick:this.handleClick,active:this.state.activeButton==='map'?true:false},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].map)));renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,buttonGroup);return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return ChartTypeFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(ChartTypeFilter));

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var canUseDOM = __webpack_require__(1104);
var enquire = canUseDOM && __webpack_require__(1105);
var json2mq = __webpack_require__(1109);

var ResponsiveMixin = {
  media: function (query, handler) {
    query = json2mq(query);
    if (typeof handler === 'function') {
      handler = {
        match: handler
      };
    }
    canUseDOM && enquire.register(query, handler);

    // Queue the handlers to unregister them at unmount  
    if (! this._responsiveMediaHandlers) {
      this._responsiveMediaHandlers = [];
    }
    this._responsiveMediaHandlers.push({query: query, handler: handler});
  },
  componentWillUnmount: function () {
    if (this._responsiveMediaHandlers) {
      this._responsiveMediaHandlers.forEach(function(obj) {
        canUseDOM && enquire.unregister(obj.query, obj.handler);
      });
    }
  }
};

module.exports = ResponsiveMixin;


/***/ }),
/* 1104 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(1106);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(1107);
var Util = __webpack_require__(409);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(1108);
var each = __webpack_require__(409).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(1110);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({absoluteValuesEvolution:{id:'ChartTypeFilter.absoluteValuesEvolution',description:'Texto para elegir el tipo de gráfico',defaultMessage:'Evolución valores absolutos'},map:{id:'ChartTypeFilter.map',description:'Texto para elegir el tipo de gráfico',defaultMessage:'Mapa'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterModal__ = __webpack_require__(1113);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FilterModal__["a" /* default */]);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterModal=function(_Component){_inherits(FilterModal,_Component);function FilterModal(props){_classCallCheck(this,FilterModal);var _this=_possibleConstructorReturn(this,(FilterModal.__proto__||Object.getPrototypeOf(FilterModal)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={};return _this;}_createClass(FilterModal,[{key:'renderBody',value:function renderBody(){var regionName=this.props.regionName;var regionNumber=this.props.regionsData.length;var bodyIntro=this.props.type==='all'?this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].allRegionsModalBodyIntro,{regionName:regionName,regionNumber:regionNumber}):this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].referenceRegionsModalBodyIntro,{regionName:regionName,regionNumber:regionNumber});var regionsDataByCountry=__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getRegionsDataByCountry(this.props.regionsData);var sortedCountryCodes=__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getSortedCountryCodesByCountryName({regionsDataByCountry:regionsDataByCountry});var processedData=[];var _loop=function _loop(i){var actualCountryData=regionsDataByCountry[sortedCountryCodes[i]];actualCountryData.regions=__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getSortedRegionsByRegionName({regionsData:actualCountryData.regions});var processedCountry={countryCode:sortedCountryCodes[i],countryFullName:actualCountryData.countryFullName,code:sortedCountryCodes[i],name:actualCountryData.countryFullName,isCountry:true};processedData.push(processedCountry);actualCountryData.regions.forEach(function(region){var processedRegion=region;processedRegion.countryCode=sortedCountryCodes[i];processedRegion.countryFullName=actualCountryData.countryFullName;processedRegion.isCountry=false;processedData.push(processedRegion);});};for(var i=0;i<sortedCountryCodes.length;i++){_loop(i);}var bodyItems=[];processedData.forEach(function(item){if(item.isCountry){bodyItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'key-'+item.name}));bodyItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'ork-epigraph ork-epigraph--small ork-u-mb',key:'c-'+item.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,item.name)));}else{bodyItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',{key:'r-'+item.name,className:'ork-u-mb-half ork-u-ml'},item.name,' (',item.code,')'));}});var body=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',null,bodyItems);return{bodyIntro:bodyIntro,body:body};}},{key:'render',value:function render(){var modalTitle=void 0;if(this.props.type==='all'){modalTitle=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].showAllRegions);}else{modalTitle=this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].showReferenceRegions);}var _renderBody=this.renderBody(),bodyIntro=_renderBody.bodyIntro,body=_renderBody.body;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */],{show:this.props.open,onHide:this.props.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Header,{closeButton:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Title,{id:'modal-rango-fechas-01-label'},modalTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Body,{className:'ork-modal-body--border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:bodyIntro}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),body),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-sm btn-primary',onClick:this.props.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-check fa-lg'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-u-ml-half'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].accept)))));}}]);return FilterModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(FilterModal));

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({showAllRegions:{id:'FilterModal.showAllRegions',description:'Texto para el modal del filtro de todas las regiones',defaultMessage:'Conjunto de regiones europeas (UE27_2020)'},showReferenceRegions:{id:'FilterModal.showReferenceRegions',description:'Texto para el modal del filtro de las regiones de referencia',defaultMessage:'Regiones de referencia'},allRegionsModalBodyIntro:{id:'FilterModal.allRegionsModalBodyIntro',description:'Texto para la introducción del modal con UE28',defaultMessage:'Se compara la situación de <strong>{regionName}</strong> con la del conjunto de las <strong>{regionNumber} regiones</strong> de la UE27 (2020).'},referenceRegionsModalBodyIntro:{id:'FilterModal.referenceRegionsModalBodyIntro',description:'Texto para la introducción del modal con regiones de referencia',defaultMessage:'<strong>{regionName}</strong> se compara con un grupo de <strong>{regionNumber} regiones</strong> de características similares. Éstas han sido elegidas por ser las que presentan una mayor similitud con <strong>{regionName}</strong> en términos de condiciones estructurales de partida (sociodemográficas, e especialización económica y tecnológica, y de estructura empresarial).'},accept:{id:'FilterModal.accept',description:'Texto para el botón de aceptar del modal',defaultMessage:'Aceptar'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelSection__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selecedRegionId,selectedRegionCountryMeta:state.REGIONS.selectedRegionCountryMeta};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__PanelSection__["a" /* default */])));

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Charts_PanelRow_PanelRowContainer__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Loading__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelSection=function(_Component){_inherits(PanelSection,_Component);function PanelSection(props){_classCallCheck(this,PanelSection);var _this=_possibleConstructorReturn(this,(PanelSection.__proto__||Object.getPrototypeOf(PanelSection)).call(this,props));_this.toggleCollapse=function(){_this.setState({collapsed:!_this.state.collapsed});};_this.composePanelRows=function(indicators){var rows=[];for(var i=0;i<indicators.length;i++){rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Charts_PanelRow_PanelRowContainer__["a" /* default */],{key:indicators[i],indicator:indicators[i]}));}return rows;};_this.renderPanelSubsection=function(dimension,subdimension,indicators){var title=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getSubDimensionTitle(dimension,subdimension);// `Subsection ${subdimension} title`;
var rankingTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].rankingTooltip));var firstHeadColumns=subdimension===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row visible-lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 panel-slim-column'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].columnRegion)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 panel-slim-column'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].columnCountry)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 panel-slim-column',dangerouslySetInnerHTML:{__html:_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].columnEU)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 panel-slim-column'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].columnRanking),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:rankingTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'*')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-2'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].columnEvolution)))))):null;var key=dimension+'.'+subdimension;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row obs-panel-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},firstHeadColumns)),_this.composePanelRows(indicators));};_this.composePanelSubsections=function(dimension){var subsections=[];_this.state.levelIndicators.forEach(function(subLevelIndicators,subLevel){subsections.push(_this.renderPanelSubsection(dimension,subLevel,subLevelIndicators));});return subsections;};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={loading:true,error:false,collapsed:_this.props.collapsed,levelTitle:'',levelIndicators:[]};return _this;}_createClass(PanelSection,[{key:'componentDidMount',value:function componentDidMount(){var levelIndicators=__WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].getIndicatorsFromLevel(this.props.dimension);this.setState({levelIndicators:levelIndicators,loading:false});}},{key:'renderPanelTable',value:function renderPanelTable(){var title=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getDimensionTitle(this.props.dimension);var subtitle=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getDimensionSubtitle(this.props.dimension);var panelClass='obs-panel-'+this.props.dimension;var actualURL=this.props.history.location.pathname;var dimensionLink=__WEBPACK_IMPORTED_MODULE_6_utils_app_urls__["a" /* default */].getLevelDetailLink({url:actualURL,level:this.props.dimension});var dimensionLinkTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].dimensionLinkTooltip,{dimensionTitle:title})}}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:panelClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title,' \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:dimensionLinkTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:dimensionLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-search-plus'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,subtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 obs-panel'},this.composePanelSubsections(this.props.dimension))));}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Loading__["a" /* default */],null);}else{renderingComponent=this.renderPanelTable();}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return PanelSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(PanelSection));

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelRowContainer__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,selectedRegionCountryMeta:state.REGIONS.selectedRegionCountryMeta,regionsData:state.REGIONS.regionsData,countriesData:state.REGIONS.countriesData,referenceRegionsData:state.REGIONS.referenceRegionsData,sameCountryRegionsData:state.REGIONS.sameCountryRegionsData,allRegionsGroupRegionId:state.REGIONS.allRegionsGroupRegionId,allRegionsFilter:state.FILTERS.allRegionsFilter,referenceRegionsFilter:state.FILTERS.referenceRegionsFilter,sameCountryRegionsFilter:state.FILTERS.sameCountryRegionsFilter,otherRegionsFilter:state.FILTERS.otherRegionsFilter,yearsEvolution:state.FILTERS.evolutionFilter,indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__PanelRowContainer__["a" /* default */])));

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Charts_PanelRow_PanelRowValues__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messages__ = __webpack_require__(1122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelRowContainer=function(_Component){_inherits(PanelRowContainer,_Component);function PanelRowContainer(props){_classCallCheck(this,PanelRowContainer);var _this=_possibleConstructorReturn(this,(PanelRowContainer.__proto__||Object.getPrototypeOf(PanelRowContainer)).call(this,props));_this.getUnit=function(indicatorsData){var indicator_id=_this.props.indicator;var indicatorData=indicatorsData.filter(function(item){return item.id===indicator_id;})[0];var unit=indicatorData.unit;return unit;};var _props$intl=props.intl,formatNumber=_props$intl.formatNumber,formatMessage=_props$intl.formatMessage;_this.formatNumber=formatNumber;_this.formatMessage=formatMessage;_this.state={"lastCommonYear":"","mostRecentYear":""};_this.allRegionsChartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.referenceRegionsChartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.sameCountryRegionsChartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.unit=_this.getUnit(props.indicatorsData);// var updateTime = this.updateTime.bind( this );
return _this;}_createClass(PanelRowContainer,[{key:'componentDidMount',value:function componentDidMount(){this.setState({'loadinh':true});}},{key:'renderValues',value:function renderValues(){var _this2=this;var renderingComponentALL=null;var comparative=null;var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this2.props.indicator;})[0];if(this.props.otherRegionsFilter!==undefined&&this.props.otherRegionsFilter.length!==0){comparative=this.props.otherRegionsFilter[0];}var topLevelRegions={"ctry":this.props.selectedRegionCountryMeta.id,"eu":this.props.allRegionsGroupRegionId};renderingComponentALL=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Charts_PanelRow_PanelRowValues__["a" /* default */],{key:this.allRegionsChartRef,regionsData:JSON.stringify(this.props.regionsData),indicator:this.props.indicator,indicatorData:indicatorData,unit:this.unit,selectedRegionId:this.props.selectedRegionId,comparative:comparative,config:'allRegions',topLevelRegions:topLevelRegions,updateTime:this.updateTime.bind(this)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,renderingComponentALL);}},{key:'updateTime',value:function updateTime(lastCommonYear,mostRecentYear){this.setState({"lastCommonYear":lastCommonYear,"mostRecentYear":mostRecentYear});}},{key:'getTimeFragment',value:function getTimeFragment(){var moreRecentDataAvail=this.state.lastCommonYear<this.state.mostRecentYear;if(moreRecentDataAvail){var tooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_7__messages__["a" /* default */].moreRecentDataAvail,{mostRecentYear:this.state.mostRecentYear}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'(',this.state.lastCommonYear,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:tooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'*'))),')');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'(',this.state.lastCommonYear,')');}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this3=this;var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this3.props.indicator;})[0];var indicatorName=__WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorName(indicatorData.name);var indicatorUnit=__WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorUnit(indicatorData.unit);var actualURL=this.props.history.location.pathname;var indicatorDetailUrl=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getIndicatorDetailLink({url:actualURL,indicator:indicatorData.id});var tooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_7__messages__["a" /* default */].moreIndicatorDetail));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row obs-panel-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6 panel-indicator-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:tooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:indicatorDetailUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-search-plus'}))),'\xA0',indicatorName,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-gray-600'},this.getTimeFragment()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'panel-indicator-unit'},indicatorUnit)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},this.renderValues()));}},{key:'render',value:function render(){return this.renderIfAllOK();}}]);return PanelRowContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(PanelRowContainer));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelRowValues__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{yearsEvolution:state.FILTERS.evolutionFilter};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__PanelRowValues__["a" /* default */]));

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelRowValuesAdapter__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_urls_v1__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_dataTools__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SparkLineChart__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__messages__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_Content_PanelSection_messages__ = __webpack_require__(410);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rankData=function rankData(data,rankOrdering){var orderedData=data.sort(function(a,b){return b.value-a.value;});if(rankOrdering!=='descending'){orderedData=orderedData.reverse();}return addRank(orderedData);};var addRank=function addRank(data){return data.map(function(item,i){if(i>0){//Get our previous list item
var prevItem=data[i-1];if(prevItem.value===item.value){//Same score = same rank
item.rank=prevItem.rank;}else{//Not the same score, give em the current iterated index + 1
item.rank=i+1;}}else{//First item takes the rank 1 spot
item.rank=1;}return item;});};var PanelRowValues=function(_Component){_inherits(PanelRowValues,_Component);function PanelRowValues(props){_classCallCheck(this,PanelRowValues);var _this=_possibleConstructorReturn(this,(PanelRowValues.__proto__||Object.getPrototypeOf(PanelRowValues)).call(this,props));_this.getData=function(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:_this.props.indicatorData.id,selectedRegionId:_this.props.selectedRegionId,comparative:_this.props.comparative},indicator=_ref.indicator,selectedRegionId=_ref.selectedRegionId,comparative=_ref.comparative;var promises=[];// get time series for all needed regions: reg, country, eu
// maybe get all the series for benchmarkregions plus country and eu and work with all that?
var countryId=_this.props.topLevelRegions["ctry"];var euId=_this.props.topLevelRegions["eu"];var geo=[selectedRegionId,countryId,euId];// const generalPromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorData({ indicator, geo })))
// promises.push(generalPromise);
var regionsData=JSON.parse(_this.props.regionsData);var benchmarkRegionIds=regionsData.map(function(o){return o["id"];});benchmarkRegionIds.forEach(function(geo_id){if(geo_id!==selectedRegionId){geo.push(geo_id);}});// v1 hispeed
var completePromise=Promise.resolve(__WEBPACK_IMPORTED_MODULE_5_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_6_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:geo})));var geo_key="geo";// v0 facade
// const completePromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorDataV0Facade({ indicator, geo })));
// const geo_key = "geoset";
promises.push(completePromise);Promise.all(promises).then(function(values){var data=values[0].data.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].ascending(a["time"],b["time"]);});// we should have all the data in data, let's wrangle
var availableTimes=__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].uniquePropertyValues(data,"time").sort(__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].descending);// v0
// selectedRegionId = String(selectedRegionId);
// countryId = String(countryId);
// euId = String(euId);
var summary={"last":{},"prev":null,"delta":null,"series":{},"ranking":null};summary["series"]["rg"]=data.filter(function(d){return d["value"]!=null&d[geo_key]===selectedRegionId;});summary["series"]["ct"]=data.filter(function(d){return d["value"]!=null&d[geo_key]===countryId;});summary["series"]["eu"]=data.filter(function(d){return d["value"]!=null&d[geo_key]===euId;});// v0
// let rankingValues = PanelRowValuesAdapter.firstComparableSet( data, benchmarkRegionIds.map( String ), availableTimes, 0.8, "geoset" );
// v1
var rankingValues=__WEBPACK_IMPORTED_MODULE_4__PanelRowValuesAdapter__["a" /* default */].firstComparableSet(data,benchmarkRegionIds,availableTimes,0.8,geo_key);if(rankingValues!==null){var rankedData=rankData(rankingValues,_this.props.indicatorData.rankOrdering);var regionRank=rankedData.filter(function(d){return d[geo_key]===selectedRegionId;})[0];if(regionRank!==undefined){summary["ranking"]={};summary["ranking"]["rank"]=regionRank["rank"];summary["ranking"]["time"]=regionRank["time"];summary["ranking"]["time_display"]=regionRank["time_display"];summary["ranking"]["count"]=rankedData.length;}}// find common years
var commonTimes=__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].intersection(["rg","ct","eu"].map(function(series){return __WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].uniquePropertyValues(summary["series"][series],"time");}));var lastCommonYear=__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].arrayAt(commonTimes,-1);var prevCommonYear=__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].arrayAt(commonTimes,-2);var seriesDateValue=function seriesDateValue(series,time){return __WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].arrayAt(series.filter(function(s){return s["time"]===time;}),0);};summary["last"]["rg"]=seriesDateValue(summary["series"]["rg"],lastCommonYear);summary["last"]["ct"]=seriesDateValue(summary["series"]["ct"],lastCommonYear);summary["last"]["eu"]=seriesDateValue(summary["series"]["eu"],lastCommonYear);_this.props.updateTime(summary["last"]["rg"].time_display,__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].arrayAt(summary["series"]["rg"],-1).time_display);if(prevCommonYear!=null){summary["prev"]={};summary["prev"]["rg"]=seriesDateValue(summary["series"]["rg"],prevCommonYear);summary["prev"]["ct"]=seriesDateValue(summary["series"]["ct"],prevCommonYear);summary["prev"]["eu"]=seriesDateValue(summary["series"]["eu"],prevCommonYear);var deltaValue=function deltaValue(v0,v1){if(v0&&v0["value"]!==null&&v1&&v1["value"]!==null){return v0["value"]-v1["value"];}return null;};summary["delta"]={};summary["delta"]["rg"]=deltaValue(summary["last"]["rg"],summary["prev"]["rg"]);summary["delta"]["ct"]=deltaValue(summary["last"]["ct"],summary["prev"]["ct"]);summary["delta"]["eu"]=deltaValue(summary["last"]["ct"],summary["prev"]["eu"]);}_this.setState({summary:summary,loading:false});}).catch(function(reason){console.log(reason);_this.setState({error:true,loading:false});});};_this.renderIfAllOK=function(){var renderingComponent=null;var unit=_this.props.indicatorData.unit;var arrow=function arrow(v){if(v==null){return"";}else if(v>0){//return <React.Fragment><span>{"\u2191"}</span></React.Fragment>;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-arrow-up'}));}else if(v<0){//return <React.Fragment><span>{"\u2193"}</span></React.Fragment>;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-arrow-down'}));}else{//return <React.Fragment><span>{"="}</span></React.Fragment>;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-exchange'}));}};var getSparkLineOptions=function getSparkLineOptions(data){var values=data["rg"].map(function(d){return{x:__WEBPACK_IMPORTED_MODULE_9_utils_dates_dateTools__["a" /* default */].getYearFromDateString(d["time"]),//x: +d["time_display"],
y:d["value"]};}).filter(function(p){return p.x>=2000;});// const values_eu = data["eu"].map( d => { 
// 	return {
// 		x: DateTools.getYearFromDateString(d["time"]),
// 		//x: +d["time_display"],
// 		y: d["value"]
// 	}
// } );
return{series:[{data:values// color: "rgba( 255, 0, 0, 0.8 )"
/*, {
					data: values_eu,
					color: "rgba( 0, 0, 255, 0.8 )"
				}*/}],tooltip:{headerFormat:'<span style="font-size:10px">{point.x}</span><br/>',pointFormat:'<b>{point.y:.2f}</b> '+unit}};};var getValueTooltip=function getValueTooltip(summary_data,area){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tooltip-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},summary_data.last[area].time_display),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this.formatValue(summary_data.last[area].value,1)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},summary_data.prev[area].time_display),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this.formatValue(summary_data.prev[area].value,1)))))));};if(_this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Error__["a" /* default */],null));}else if(_this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Loading__["a" /* default */],null));}else{var formattedValue={};var tooltip={};Object.keys(_this.state.summary.last).forEach(function(area){if(_this.state.summary.last[area]&&_this.state.summary.last[area].value){formattedValue[area]=_this.formatValue(_this.state.summary.last[area].value);tooltip[area]=getValueTooltip(_this.state.summary,area);}else{formattedValue[area]="n/a";tooltip[area]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'});}});var rankFragment="n/a";if(_this.state.summary.ranking){rankFragment=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.state.summary.ranking.rank,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'rank-count'},'/ ',_this.state.summary.ranking.count)));tooltip["rank"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},_this.state.summary.ranking.time_display);}else{tooltip["rank"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_14__messages__["a" /* default */].noDataAvailable));}var getValueAndDelta=function getValueAndDelta(ctxt){var delta=null;if(_this.state.summary.delta){delta=arrow(_this.state.summary.delta[ctxt]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:tooltip[ctxt],placement:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#',className:'value-tooltip'},formattedValue[ctxt],' ',delta));};renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-8 col-md-4 col-xs-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-xs-6 hidden-lg'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_15_modules_Content_PanelSection_messages__["a" /* default */].columnRegion)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 col-md-6 col-xs-6 panel-slim-column text-right'},getValueAndDelta("rg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-xs-6 hidden-lg'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_15_modules_Content_PanelSection_messages__["a" /* default */].columnCountry)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 col-md-6 col-xs-6 panel-slim-column text-right panel-indicator-value-other'},getValueAndDelta("ct")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-xs-6 hidden-lg',dangerouslySetInnerHTML:{__html:_this.formatMessage(__WEBPACK_IMPORTED_MODULE_15_modules_Content_PanelSection_messages__["a" /* default */].columnEU)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 col-md-6 col-xs-6 panel-slim-column text-right panel-indicator-value-other'},getValueAndDelta("eu")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-xs-6 hidden-lg'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_15_modules_Content_PanelSection_messages__["a" /* default */].columnRanking)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3 col-md-6 col-xs-6 panel-slim-column text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:tooltip.rank,placement:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#',className:'value-tooltip'},rankFragment))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md-8 col-xs-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SparkLineChart__["a" /* default */],{options:getSparkLineOptions(_this.state.summary.series)})))));}return renderingComponent;};_this.state={loading:true,error:false};var _props$intl=props.intl,formatNumber=_props$intl.formatNumber,formatMessage=_props$intl.formatMessage;_this.formatNumber=formatNumber;_this.formatMessage=formatMessage;__WEBPACK_IMPORTED_MODULE_4__PanelRowValuesAdapter__["a" /* default */].importFormatter(_this.formatMessage);return _this;}_createClass(PanelRowValues,[{key:'componentDidMount',value:function componentDidMount(){this.getData();// this.getRankingChart();
}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var shouldUpdate=!__WEBPACK_IMPORTED_MODULE_7_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_7_utils_objects_objectTools__["a" /* default */].compareObjects(this.state,nextState);return shouldUpdate;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(prevProps!==this.props){this.setState({loading:true,error:false,regionsData:JSON.parse(this.props.regionsData)},function(){return _this2.getData();});}}},{key:'formatValue',value:function formatValue(v){var minFractionDigits=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return __WEBPACK_IMPORTED_MODULE_10_utils_indicators_indicatorTools__["a" /* default */].formatValue(v,this.props.indicatorData.unit,minFractionDigits);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,prevState){if(nextProps!==prevState){return nextProps;}return null;}}]);return PanelRowValues;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(PanelRowValues));

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultOptions={chart:{backgroundColor:null,borderWidth:0,type:'line',// 'area'
margin:[2,0,2,0],// width: 120,
// height: 24,
style:{overflow:'visible'},// small optimalization, saves 1-2 ms each sparkline
skipClone:true},exporting:{buttons:{contextButton:{enabled:false}}},title:{text:''},credits:{enabled:false},xAxis:{labels:{enabled:false},title:{text:null},startOnTick:false,endOnTick:false,tickPositions:[]},yAxis:{endOnTick:false,startOnTick:false,labels:{enabled:false},title:{text:null},tickPositions:[0]},legend:{enabled:false},tooltip:{backgroundColor:'white',borderWidth:1,hideDelay:0,shared:true,padding:8,borderColor:'silver',borderRadius:3,positioner:function positioner(w,h,point){return{x:point.plotX-w/2,y:point.plotY-h};}},plotOptions:{series:{animation:false,lineWidth:2,shadow:false,states:{hover:{lineWidth:2}},marker:{radius:1,states:{hover:{radius:2}}},fillOpacity:0.25},column:{negativeColor:'#910000',borderColor:'silver'}},series:[{data:[1,2,3]}]};var SparkLineChart=function(_React$Component){_inherits(SparkLineChart,_React$Component);function SparkLineChart(){_classCallCheck(this,SparkLineChart);return _possibleConstructorReturn(this,(SparkLineChart.__proto__||Object.getPrototypeOf(SparkLineChart)).apply(this,arguments));}_createClass(SparkLineChart,[{key:'componentDidMount',// useless constructor
// constructor(props) {
// 	super(props)
// }
value:function componentDidMount(){var options=__WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.merge(defaultOptions,this.props.options);this.chart=__WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.chart(this.container,options);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.chart.destroy();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12 sparkline',ref:function ref(container){return _this2.container=container;}});}}]);return SparkLineChart;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SparkLineChart);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({moreRecentDataAvail:{id:'PanelRowCointaner.moreRecentDataAvail',description:'Texto para indicar que hay datos más recientes',defaultMessage:'Datos de región disponibles hasta {mostRecentYear}'},moreIndicatorDetail:{id:'PanelRowCointaner.moreIndicatorDetail',description:'Texto para indicar más detalle en indicador',defaultMessage:'Ver indicador en detalle'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentChartWrapper__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{chartTypeFilter:state.FILTERS.chartTypeFilter};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__ContentChartWrapper__["a" /* default */]));

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Charts_Lines_LinesChartContainer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Charts_Map_MapChartContainer__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentChartWrapper=function(_Component){_inherits(ContentChartWrapper,_Component);function ContentChartWrapper(props){_classCallCheck(this,ContentChartWrapper);var _this=_possibleConstructorReturn(this,(ContentChartWrapper.__proto__||Object.getPrototypeOf(ContentChartWrapper)).call(this,props));_this.composeCharts=function(_ref){var indicator=_ref.indicator;var chart=null;if(_this.props.layer===2){switch(_this.props.chartTypeFilter){case'evolutionAbsolute':chart=_this.renderLinesChart(indicator);break;case'map':chart=_this.renderMapChart(indicator);break;default:chart=null;break;}}else{chart=_this.renderAllCharts(indicator);}return chart;};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={loading:true,error:false,levelIndicators:[]};return _this;}_createClass(ContentChartWrapper,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.level!==0){var levelIndicators=__WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__["a" /* default */].getIndicatorsFromLevel(this.props.level);this.setState({levelIndicators:levelIndicators,loading:false,error:false});}else{this.setState({loading:false,error:false});}}},{key:'renderLinesChart',value:function renderLinesChart(indicator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Charts_Lines_LinesChartContainer__["a" /* default */],{indicator:indicator});}},{key:'renderMapChart',value:function renderMapChart(indicator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Charts_Map_MapChartContainer__["a" /* default */],{indicator:indicator});}},{key:'renderAllCharts',value:function renderAllCharts(indicator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Charts_Lines_LinesChartContainer__["a" /* default */],{indicator:indicator,layer:this.props.layer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Charts_Map_MapChartContainer__["a" /* default */],{indicator:indicator,layer:this.props.layer}));}},{key:'getSubLevelTitle',value:function getSubLevelTitle(subLevel){switch(subLevel){case 0:return this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].businessBehavior);case 1:return this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].specialization);case 2:return this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].businessEnvironment);default:return'';}}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this2=this;var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Loading__["a" /* default */],null);}else{var charts=[];if(this.props.level!==0){var levelIndicators=this.state.levelIndicators;// if (Number(this.props.level) === 3) {
levelIndicators.forEach(function(subLevelIndicators,subLevel){var numberOfRows=Math.ceil(subLevelIndicators.length/2);charts.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ork-epigraph ork-epigraph--grey '+(subLevel===0?'ork-u-mt-2':'ork-u-mt-4')+' ork-u-mb-2',key:'row'+subLevel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,_this2.getSubLevelTitle(subLevel))));for(var i=0;i<numberOfRows;i++){charts.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',key:'row'+subLevel+'.'+i},_this2.composeCharts({indicator:subLevelIndicators[i*2]}),subLevelIndicators[i*2+1]?_this2.composeCharts({indicator:subLevelIndicators[i*2+1]}):null));}});/*
	      } else {
	        let numberOfRows = Math.ceil(levelIndicators.length / 2)
	        for (let i = 0; i < numberOfRows; i++) {
	          charts.push(
	            <div className="row" key={`row${i}`}>
	              {this.composeCharts({ indicator: levelIndicators[i * 2] })}
	              {levelIndicators[i * 2 + 1] ? this.composeCharts({ indicator: levelIndicators[i * 2 + 1] }) : null}
	            </div>
	          )
	        }
	      }
		  */}else{charts.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',key:'row'+1},this.composeCharts({indicator:this.props.indicator})));}renderingComponent=charts;}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return ContentChartWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ContentChartWrapper));

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({businessBehavior:{id:'ContentChartWrapper.businessBehavior',description:'Texto para el primer epígrafe del nivel 3',defaultMessage:'Comportamiento empresarial'},specialization:{id:'ContentChartWrapper.specialization',description:'Texto para el segundo epígrafe del nivel 3',defaultMessage:'Especialización'},businessEnvironment:{id:'ContentChartWrapper.businessEnvironment',description:'Texto para el tercer epígrafe del nivel 3',defaultMessage:'Entorno empresarial'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Charts_Lines_LinesChart__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentChart_ContentChartTitle__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Content_ContentChart_ContentChartFooter__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Content_ContentChart_ContentDateModal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_urls__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_queries_queryTools__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LinesChartContainer=function(_Component){_inherits(LinesChartContainer,_Component);function LinesChartContainer(props){_classCallCheck(this,LinesChartContainer);var _this=_possibleConstructorReturn(this,(LinesChartContainer.__proto__||Object.getPrototypeOf(LinesChartContainer)).call(this,props));_this.getRef=function(ref){_this.setState({chartRef:ref});};_this.state={showLegend:true,showByGender:false,showTable:false,showModal:false,expanded:false,startingYear:1900,endingYear:2020,minYear:0,maxYear:0,chartRef:null,indicatorData:{},loading:true,error:false};return _this;}_createClass(LinesChartContainer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var selectedRegionId=this.props.selectedRegionId;var indicator=this.props.indicator;var query=__WEBPACK_IMPORTED_MODULE_8_utils_queries_queryTools__["a" /* default */].formatQuerySingleGEOFromId(selectedRegionId);__WEBPACK_IMPORTED_MODULE_5_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_6_utils_api_urls__["a" /* default */].getEvolutionForIndicatorAndRegions({indicator:indicator,query:query})).then(function(response){return __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__["a" /* default */].getIndicatorEvolutionData(response.data);}).then(function(indicatorEvolutionData){return __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__["a" /* default */].getMaxAndMinYearFromIndicator(indicatorEvolutionData);}).then(function(_ref){var min=_ref.min,max=_ref.max;if(max-10>=min)min=max-10;_this2.setState({minYear:min,maxYear:max,startingYear:min,endingYear:max,loading:false,error:false});}).catch(function(reason){_this2.setState({loading:false,error:true});});var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this2.props.indicator;})[0];this.setState({indicatorData:indicatorData});}},{key:'functionSet',value:function functionSet(){var _this3=this;var chartRef=this.state.chartRef;var shouldShowLegend=this.state.showLegend;var showLegend=function showLegend(){shouldShowLegend=!shouldShowLegend;chartRef.current.chart.legend.update({enabled:shouldShowLegend});_this3.setState({showLegend:shouldShowLegend});};var shouldShowByGender=this.state.showByGender;var showByGender=function showByGender(){shouldShowByGender=!shouldShowByGender;_this3.setState({showByGender:shouldShowByGender});};var showTable=function showTable(shouldShow){_this3.setState({showTable:shouldShow});};var modalFunctions=function modalFunctions(){var setDateRange=function setDateRange(_ref2){var startingYear=_ref2.startingYear,endingYear=_ref2.endingYear;_this3.setState({startingYear:startingYear,endingYear:endingYear});};var openModal=function openModal(){_this3.setState({showModal:true});};var closeModal=function closeModal(){_this3.setState({showModal:false});};return{setDateRange:setDateRange,openModal:openModal,closeModal:closeModal};};var exportChart=function exportChart(fileType){var chart=chartRef.current.getChart();var fileName=_this3.state.indicatorData.name;var optionsToExport={filename:fileName};if(fileType==='CSV'){var csv=chart.getCSV(false);var hiddenElement=document.createElement('a');hiddenElement.href='data:attachment/text,'+encodeURI(csv);hiddenElement.target='_blank';hiddenElement.download=fileName+'.csv';hiddenElement.click();}else{switch(fileType){case'PNG':optionsToExport.type='image/png';break;case'JPEG':optionsToExport.type='image/jpeg';break;case'PDF':optionsToExport.type='application/pdf';break;case'SVG':optionsToExport.type='image/svg+xml';break;default:optionsToExport.type='image/png';break;}chart.exportChart(optionsToExport);}};var expandChart=function expandChart(){var shouldExpand=!_this3.state.expanded;if(shouldExpand){document.getElementsByTagName('html')[0].classList.add('ork-no-scroll');}else{document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll');}_this3.setState({expanded:shouldExpand});};return{showLegend:showLegend,showByGender:showByGender,showTable:showTable,modalFunctions:modalFunctions,exportChart:exportChart,expandChart:expandChart};}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null);}else{var _props=this.props,regionsData=_props.regionsData,referenceRegionsData=_props.referenceRegionsData,sameCountryRegionsData=_props.sameCountryRegionsData,allRegionsGroupRegionId=_props.allRegionsGroupRegionId;var comparative=void 0;if(this.props.otherRegionsFilter!==undefined&&this.props.otherRegionsFilter.length!==0){comparative=this.props.otherRegionsFilter;}else{comparative={};}var generalRegionsData={regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,allRegionsGroupRegionId:allRegionsGroupRegionId};var linesToShow={allRegionsFilter:this.props.allRegionsFilter,referenceRegionsFilter:this.props.referenceRegionsFilter,sameCountryRegionsFilter:this.props.sameCountryRegionsFilter,otherRegionsFilter:comparative};renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel panel-default '+(this.state.expanded?'panel-expanded':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentChart_ContentChartTitle__["a" /* default */],{indicator:this.props.indicator,layer:this.props.layer,chartType:'evolutionAbsolute'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Charts_Lines_LinesChart__["a" /* default */],{generalRegionsData:JSON.stringify(generalRegionsData),linesToShow:JSON.stringify(linesToShow),indicator:this.props.indicator,startingYear:this.state.startingYear,endingYear:this.state.endingYear,selectedRegionId:this.props.selectedRegionId,indicatorData:this.state.indicatorData,expanded:this.state.expanded,showLegend:this.state.showLegend,showByGender:this.state.showByGender,fn:this.getRef})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Content_ContentChart_ContentChartFooter__["a" /* default */],{fn:this.functionSet(),indicatorData:this.state.indicatorData,expanded:this.state.expanded,chartType:'evolutionAbsolute',showByGender:this.state.showByGender})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_ContentChart_ContentDateModal__["a" /* default */],{show:this.state.showModal,fn:this.functionSet().modalFunctions(),startingYear:this.state.startingYear,endingYear:this.state.endingYear,minYear:this.state.minYear,maxYear:this.state.maxYear,multiple:true}));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderIfAllOK());}}]);return LinesChartContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LinesChartContainer);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinesChart__ = __webpack_require__(1128);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LinesChart__["a" /* default */]);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LinesChartConfig__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_api_urls__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_queries_queryTools__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_colors_colors__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LinesChart=function(_Component){_inherits(LinesChart,_Component);function LinesChart(props){_classCallCheck(this,LinesChart);var _this=_possibleConstructorReturn(this,(LinesChart.__proto__||Object.getPrototypeOf(LinesChart)).call(this,props));_initialiseProps.call(_this);var _props$intl=props.intl,formatMessage=_props$intl.formatMessage,formatNumber=_props$intl.formatNumber;_this.formatMessage=formatMessage;_this.formatNumber=formatNumber;__WEBPACK_IMPORTED_MODULE_9_utils_app_appTools__["a" /* default */].importFormatter(formatMessage);_this.state={loading:true,error:false};_this.chartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(LinesChart,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.fn(this.chartRef);var generalRegionsData=JSON.parse(this.props.generalRegionsData);var regionsData=generalRegionsData.regionsData,referenceRegionsData=generalRegionsData.referenceRegionsData,sameCountryRegionsData=generalRegionsData.sameCountryRegionsData,comparative=generalRegionsData.comparative,allRegionsGroupRegionId=generalRegionsData.allRegionsGroupRegionId;this.setState({regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,allRegionsGroupRegionId:allRegionsGroupRegionId},function(){_this2.getLinesChart();});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(this.props.showLegend!==nextProps.showLegend)return false;var shouldUpdate=!__WEBPACK_IMPORTED_MODULE_13_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_13_utils_objects_objectTools__["a" /* default */].compareObjects(this.state,nextState);return shouldUpdate;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(!__WEBPACK_IMPORTED_MODULE_13_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,prevProps)){var generalRegionsData=JSON.parse(this.props.generalRegionsData);var regionsData=generalRegionsData.regionsData,referenceRegionsData=generalRegionsData.referenceRegionsData,sameCountryRegionsData=generalRegionsData.sameCountryRegionsData,comparative=generalRegionsData.comparative,allRegionsGroupRegionId=generalRegionsData.allRegionsGroupRegionId;this.setState({regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,allRegionsGroupRegionId:allRegionsGroupRegionId,loading:true,error:false},function(){return _this3.getLinesChart();});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return LinesChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.getLinesChart=function(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:_this4.props.indicator,selectedRegionId:_this4.props.selectedRegionId},indicator=_ref.indicator,selectedRegionId=_ref.selectedRegionId;var regionsData=_this4.state.regionsData;// let referenceRegionsData = this.state.referenceRegionsData
//   let sameCountryRegionsData = this.state.sameCountryRegionsData
var comparative=_this4.state.comparative;var allRegionsGroupRegionId=_this4.state.allRegionsGroupRegionId;var linesToShow=JSON.parse(_this4.props.linesToShow);var allRegionsFilter=linesToShow.allRegionsFilter,sameCountryRegionsFilter=linesToShow.sameCountryRegionsFilter,otherRegionsFilter=linesToShow.otherRegionsFilter;var comparativeShouldShow=Object.keys(otherRegionsFilter).length!==0;var showByGender=_this4.props.showByGender;var indicatorFemale=0;var indicatorMale=0;if(showByGender){indicatorFemale=_this4.props.indicatorData.relationships.sexFemale;indicatorMale=_this4.props.indicatorData.relationships.sexMale;}var chartConfig=_this4.selectConfig('selectedRegion').chartConfig;var promises=[];// This is the line of the selected region
if(true){var chartColor=_this4.selectConfig('selectedRegion').chartColor;// const query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)
var geo=[selectedRegionId];if(!showByGender){var promise=Promise.resolve(// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:geo})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:__WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:regionsData,id:selectedRegionId}),data:data,color:chartColor,startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));promises.push(promise);}else{var promiseFemale=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicatorFemale,geo:geo})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:__WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:regionsData,id:selectedRegionId}),data:data,color:chartColor,gender:'Female',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));var promiseMale=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicatorMale,geo:geo})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:__WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({regionsData:regionsData,id:selectedRegionId}),data:data,color:chartColor,gender:'Male',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));promises.push(promiseFemale);promises.push(promiseMale);}}if(allRegionsFilter){var _chartColor=_this4.selectConfig('allRegions').chartColor;// let query = undefined
// if (allRegionsGroupRegionId === undefined) {
// 	query = QueryTools.formatQueryInSameGEO(regionsData)
// } else {
// 	query = QueryTools.formatQuerySingleGEOFromId(allRegionsGroupRegionId)
// }
var _geo=[allRegionsGroupRegionId];if(!showByGender){var _promise=Promise.resolve(// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:_geo})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].euAcronym),data:data,color:_chartColor,startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));promises.push(_promise);}else{var _promiseFemale=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicatorFemale,geo:_geo})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].euAcronym),data:data,color:_chartColor,gender:'Female',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));var _promiseMale=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicatorMale,geo:_geo})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].euAcronym),data:data,color:_chartColor,gender:'Male',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));promises.push(_promiseFemale);promises.push(_promiseMale);}}if(sameCountryRegionsFilter){var _chartColor2=_this4.selectConfig('sameCountryRegions').chartColor;var selectedRegionData=regionsData.filter(function(item){return item.id===selectedRegionId;})[0];var selectedCountryCode=__WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__["a" /* default */].getCountryCodeFromRegionCode(selectedRegionData.code);var selectedCountryMeta=__WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__["a" /* default */].countryCodeToMeta(selectedCountryCode);var selectedCountryName=__WEBPACK_IMPORTED_MODULE_11_utils_regions_regionTools__["a" /* default */].countryCodeToFullName(selectedCountryCode);// let query = QueryTools.formatQuerySingleGEOFromId(selectedCountryMeta.id);
var _geo2=[selectedCountryMeta.id];if(!showByGender){var _promise2=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:_geo2})).then(function(data){return(// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
__WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:selectedCountryName,data:data,color:_chartColor2,startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage}));}));promises.push(_promise2);}else{var _promiseFemale2=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicatorFemale,geo:_geo2})).then(function(data){return(// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator: indicatorFemale, query })).then(data =>
__WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:selectedCountryName,data:data,color:_chartColor2,gender:'Female',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage}));}));var _promiseMale2=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_8_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicatorMale,geo:_geo2})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:selectedCountryName,data:data,color:_chartColor2,gender:'Male',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,formatMessage:_this4.formatMessage});}));promises.push(_promiseFemale2);promises.push(_promiseMale2);}}if(comparativeShouldShow){comparative.forEach(function(comparativeItem,index){var chartColor=_this4.selectConfig('otherRegions',index).chartColor;//   let query = QueryTools.formatQueryInSameGEO(comparativeItem.regionsData)
var query=__WEBPACK_IMPORTED_MODULE_10_utils_queries_queryTools__["a" /* default */].formatQuerySingleGEOFromId(comparativeItem.regionId);var name=comparativeItem.isCountry?comparativeItem.countryFullName:comparativeItem.regionsData[0].name;if(!showByGender){var _promise3=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getEvolutionForIndicatorAndRegions({indicator:indicator,query:query})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:name,data:data,color:chartColor,startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,dashedLine:true,formatMessage:_this4.formatMessage});}));promises.push(_promise3);}else{var _promiseFemale3=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getEvolutionForIndicatorAndRegions({indicator:indicatorFemale,query:query})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:name,data:data,color:chartColor,gender:'Female',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,dashedLine:true,formatMessage:_this4.formatMessage});}));var _promiseMale3=Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getEvolutionForIndicatorAndRegions({indicator:indicatorMale,query:query})).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:name,data:data,color:chartColor,gender:'Male',startingYear:_this4.props.startingYear,endingYear:_this4.props.endingYear,dashedLine:true,formatMessage:_this4.formatMessage});}));promises.push(_promiseFemale3);promises.push(_promiseMale3);}});}Promise.all(promises).then(function(values){var customLinesConfig=__WEBPACK_IMPORTED_MODULE_13_utils_objects_objectTools__["a" /* default */].copyObject(chartConfig);console.log(values);customLinesConfig.series=values;if(_this4.props.expanded){var panelHeight=document.querySelector('.panel-expanded').offsetHeight;var panelHeaderHeight=document.querySelector('.panel-expanded>.panel-heading').offsetHeight;var panelFooterHeight=document.querySelector('.panel-expanded>.panel-footer').offsetHeight;var panelBody=document.querySelector('.panel-expanded>.panel-body');var paddingTop=parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-top'),10);var paddingBottom=parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-bottom'),10);var panelBodyHeight=panelHeight-panelHeaderHeight-panelFooterHeight-paddingTop-paddingBottom;customLinesConfig.chart.height=panelBodyHeight+'px';}customLinesConfig.legend.enabled=_this4.props.showLegend;customLinesConfig.credits.text=__WEBPACK_IMPORTED_MODULE_9_utils_app_appTools__["a" /* default */].getComposedDataSource(_this4.props.indicatorData.dataSource);customLinesConfig.yAxis.title.text=_this4.props.indicatorData.unit;var formatNumber=_this4.formatNumber;var unit=_this4.props.indicatorData.unit;customLinesConfig.tooltip.pointFormatter=function(){var tooltip='<span style="color:'+this.color+'">●</span><b>'+this.series.name+'</b>: '+formatNumber(this.y.toFixed(2))+' '+unit;if(this.notes){tooltip+='<br/>'+this.notes;}return tooltip;};_this4.setState({chartConfig:customLinesConfig,loading:false});}).catch(function(reason){_this4.setState({error:true,loading:false});});};this.selectConfig=function(config,index){switch(config){case'selectedRegion':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__LinesChartConfig__["a" /* default */].selectedRegionConfig,chartColor:__WEBPACK_IMPORTED_MODULE_12_utils_colors_colors__["a" /* default */].selectedRegionColor};case'allRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__LinesChartConfig__["a" /* default */].allRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_12_utils_colors_colors__["a" /* default */].allRegionsColor};case'referenceRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__LinesChartConfig__["a" /* default */].referenceRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_12_utils_colors_colors__["a" /* default */].referenceRegionsColor};case'sameCountryRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__LinesChartConfig__["a" /* default */].sameCountryRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_12_utils_colors_colors__["a" /* default */].sameCountryRegionsColor};case'otherRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__LinesChartConfig__["a" /* default */].otherRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_12_utils_colors_colors__["a" /* default */].selectOtherRegionsColor(index)};default:return _this4.selectConfig('allRegions');}};this.renderIfAllOK=function(){var renderingComponent=null;if(_this4.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Error__["a" /* default */],null);}else if(_this4.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Loading__["a" /* default */],null);}else{renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_highcharts___default.a,{ref:_this4.chartRef,config:_this4.state.chartConfig});}return renderingComponent;};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(LinesChart));

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__ = __webpack_require__(47);
var generalConfig={chart:{type:'line',style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'},marginBottom:60,backgroundColor:'rgba(0,0,0,0)'},credits:{enabled:true,text:'',href:'https://www.orkestra.deusto.es',position:{y:-5},style:{fontSize:'12px'}},exporting:{sourceWidth:800,sourceHeight:500,buttons:{contextButton:{enabled:false}}},title:{text:''},subtitle:{text:''},xAxis:{allowDecimals:false},yAxis:{title:{text:''}},tooltip:{valueSuffix:''},legend:{enabled:true,layout:'horizontal',align:'right',verticalAlign:'top',y:-30,itemStyle:{fontWeight:'normal'},symbolWidth:30},plotOptions:{series:{marker:{enabled:false,symbol:'circle'},label:{enabled:false}}},series:[]};var selectedRegionConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var allRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var referenceRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var sameCountryRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var otherRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var chartLinesConfig={selectedRegionConfig:selectedRegionConfig,allRegionsConfig:allRegionsConfig,referenceRegionsConfig:referenceRegionsConfig,sameCountryRegionsConfig:sameCountryRegionsConfig,otherRegionsConfig:otherRegionsConfig};/* harmony default export */ __webpack_exports__["a"] = (chartLinesConfig);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_colors_colors__ = __webpack_require__(118);
function getMetaFlag(dp){if(dp.meta&&dp.meta.flag){return dp.meta.flag;}return null;}var formatLinesSeries=function formatLinesSeries(_ref){var data=_ref.data,name=_ref.name,color=_ref.color,startingYear=_ref.startingYear,endingYear=_ref.endingYear,_ref$dashedLine=_ref.dashedLine,dashedLine=_ref$dashedLine===undefined?false:_ref$dashedLine,_ref$gender=_ref.gender,gender=_ref$gender===undefined?'Total':_ref$gender,formatMessage=_ref.formatMessage;var values=[];var orderedData=data.data.sort(function(a,b){return a.time>b.time?1:-1;});console.log(orderedData);orderedData.forEach(function(item){if(__WEBPACK_IMPORTED_MODULE_1_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time)>=startingYear&&__WEBPACK_IMPORTED_MODULE_1_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time)<=endingYear){if(item.value!=null){var flag_note=getMetaFlag(item);values.push({x:__WEBPACK_IMPORTED_MODULE_1_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time),y:item.value,notes:flag_note});}}});var markerEnabled=false;if(values.length<2)markerEnabled=true;var dashStyle='Solid';if(gender!=='Total'){if(gender==='Male'){if(dashedLine){dashStyle='Dot';}else{dashStyle='ShortDot';}}else{if(dashedLine){dashStyle='LongDashDot';}else{dashStyle='ShortDashDot';}}}else{if(dashedLine){dashStyle='Dash';}else{dashStyle='Solid';}}var lineName=name;if(gender==='Male'){lineName=name+' ('+formatMessage(__WEBPACK_IMPORTED_MODULE_0__messages__["a" /* default */].maleAcronym)+')';}if(gender==='Female'){lineName=name+' ('+formatMessage(__WEBPACK_IMPORTED_MODULE_0__messages__["a" /* default */].femaleAcronym)+')';}return{name:lineName,color:__WEBPACK_IMPORTED_MODULE_2_utils_colors_colors__["a" /* default */].colorToRGBA(color),data:values,dashStyle:dashStyle,marker:{enabled:markerEnabled}};};var linesChartAdapter={formatLinesSeries:formatLinesSeries};/* harmony default export */ __webpack_exports__["a"] = (linesChartAdapter);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_api_urls__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Loading__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentChartTitle=function(_Component){_inherits(ContentChartTitle,_Component);function ContentChartTitle(props){_classCallCheck(this,ContentChartTitle);var _this=_possibleConstructorReturn(this,(ContentChartTitle.__proto__||Object.getPrototypeOf(ContentChartTitle)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={loading:true,error:false};return _this;}_createClass(ContentChartTitle,[{key:'componentDidMount',value:function componentDidMount(){this.getIndicator();}},{key:'getIndicator',value:function getIndicator(){var _this2=this;var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:this.props.indicator},indicator=_ref.indicator;__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_4_utils_api_urls__["a" /* default */].getIndicator(indicator)).then(function(data){return __WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__["a" /* default */].getDataFromSingleIndicator(data);}).then(function(indicatorData){return _this2.setState({indicatorData:indicatorData,loading:false,error:false});}).catch(function(reason){return _this2.setState({loading:false,error:true});});}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Loading__["a" /* default */],null);}else{if(this.props.layer===3){var title=void 0;if(this.props.chartType==='evolutionAbsolute')title=this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].absoluteValuesEvolution);if(this.props.chartType==='map')title=this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].map);renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'panel-title'},title));}else{var indicatorData=this.state.indicatorData;renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'panel-title'},indicatorData.name));}}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return ContentChartTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ContentChartTitle));

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({absoluteValuesEvolution:{id:'ContentChartTitle',description:'Texto para el titulo del gráfico de lineas en la capa 3',defaultMessage:'Evolución'},map:{id:'ContentChartTitle.map',description:'Texto para el titulo del gráfico de mapa en la capa 3',defaultMessage:'Mapa'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_urls__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentChartFooter=function(_Component){_inherits(ContentChartFooter,_Component);function ContentChartFooter(props){_classCallCheck(this,ContentChartFooter);var _this=_possibleConstructorReturn(this,(ContentChartFooter.__proto__||Object.getPrototypeOf(ContentChartFooter)).call(this,props));_this.showLegend=function(){_this.showLegendButton.current.blur();_this.props.fn.showLegend();};_this.showByGender=function(){_this.showByGenderButton.current.blur();_this.props.fn.showByGender();};_this.showTable=function(){_this.showTableButton.current.blur();_this.props.fn.showTable();};_this.openModal=function(){_this.openModalButton.current.blur();_this.props.fn.modalFunctions().openModal();};_this.exportChart=function(eventKey){var fileType=eventKey.split('_')[0];var gender=void 0;if(eventKey.split('_').length>1){gender=eventKey.split('_')[1];}_this.props.fn.exportChart(fileType,gender);};_this.expandChart=function(){_this.expandChartButton.current.blur();_this.props.fn.expandChart();};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={};_this.showLegendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.showByGenderButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.showTableButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.openModalButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.exportChartButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.expandChartButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.showLegendTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* Tooltip */],{id:'showLegendTooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].showLegendTooltip));_this.showByGenderTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* Tooltip */],{id:'showByGenderTooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].showByGenderTooltip));_this.showTableTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* Tooltip */],{id:'showTableTooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].showTableTooltip));_this.openModalTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* Tooltip */],{id:'openModalTooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].openModalTooltip));_this.exportChartTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* Tooltip */],{id:'exportChartTooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].exportChartTooltip));_this.expandChartTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* Tooltip */],{id:'expandChartTooltip'},_this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].expandChartTooltip));return _this;}_createClass(ContentChartFooter,[{key:'renderLinkToIndicatorDetail',value:function renderLinkToIndicatorDetail(){var actualURL=this.props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getLayerFromURL(actualURL);var renderingLink=null;if(layer!==3){var newURL=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getIndicatorDetailLink({url:actualURL,indicator:this.props.indicatorData.id});renderingLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:newURL,className:'btn btn-sm btn-primary',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-search-plus fa-lg'}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-u-ml-half'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].indicatorDetail)));}return renderingLink;}},{key:'renderExportOptions',value:function renderExportOptions(){var renderingExportOptions=null;if(this.props.chartType==='map'&&this.props.showByGender){renderingExportOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{header:true},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].female)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'PNG_Female',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadPNG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'JPEG_Female',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadJPEG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'PDF_Female',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadPDF)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'SVG_Female',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadSVG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'CSV_Female',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadCSV)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{divider:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{header:true},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].male)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'PNG_Male',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadPNG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'JPEG_Male',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadJPEG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'PDF_Male',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadPDF)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'SVG_Male',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadSVG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'CSV_Male',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadCSV)));}else{renderingExportOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'PNG',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadPNG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'JPEG',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadJPEG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'PDF',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadPDF)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'SVG',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadSVG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* MenuItem */],{eventKey:'CSV',onSelect:this.exportChart},this.formatMessage(__WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */].downloadCSV)));}return renderingExportOptions;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4'},this.props.showLinkToDetail?this.renderLinkToIndicatorDetail():""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ork-panel-toolbar btn-group btn-group-sm',role:'group','aria-label':'toolbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["j" /* OverlayTrigger */],{placement:'top',overlay:this.showLegendTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',ref:this.showLegendButton,onClick:this.showLegend},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-tag'}))),this.props.indicatorData.relationships.exist?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["j" /* OverlayTrigger */],{placement:'top',overlay:this.showByGenderTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',ref:this.showByGenderButton,onClick:this.showByGender},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-venus-mars'}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["j" /* OverlayTrigger */],{placement:'top',overlay:this.openModalTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',ref:this.openModalButton,onClick:this.openModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-calendar-alt'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["j" /* OverlayTrigger */],{placement:'top',overlay:this.exportChartTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* DropdownButton */],{ref:this.exportChartButton,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-file-export'}),pullRight:true,noCaret:true,dropup:this.props.expanded,id:'exportDropdown'},this.renderExportOptions())),this.props.allowFullscreen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["j" /* OverlayTrigger */],{placement:'top',overlay:this.expandChartTooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',ref:this.expandChartButton,onClick:this.expandChart},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-expand-alt'}))):''))));}}]);return ContentChartFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Set default props
ContentChartFooter.defaultProps={showLinkToDetail:true,allowFullscreen:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(ContentChartFooter));

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({showLegendTooltip:{id:'ContentChartFooter.showLegendTooltip',description:'Texto para el tooltip de la leyenda',defaultMessage:'Leyenda'},showByGenderTooltip:{id:'ContentChartFooter.showByGenderTooltip',description:'Texto para el tooltip del desglose por sexo',defaultMessage:'Desglose por género'},showTableTooltip:{id:'ContentChartFooter.showTableTooltip',description:'Texto para el tooltip de la tabla',defaultMessage:'Datos como tabla'},openModalTooltip:{id:'ContentChartFooter.openModalTooltip',description:'Texto para el tooltip del modal',defaultMessage:'Seleccionar el rango de fechas'},exportChartTooltip:{id:'ContentChartFooter.exportChartTooltip',description:'Texto para el tooltip de exportar',defaultMessage:'Exportar gráfico'},expandChartTooltip:{id:'ContentChartFooter.expandChartTooltip',description:'Texto para el tooltip de pantalla completa',defaultMessage:'Pantalla completa'},indicatorDetail:{id:'ContentChartFooter.indicatorDetail',description:'Texto para el botón para acceder al detalle de indicador',defaultMessage:'Detalle del indicador'},downloadPNG:{id:'ContentChartFooter.downloadPNG',description:'Texto para el botón de descargar en PNG',defaultMessage:'Descargar en PNG'},downloadJPEG:{id:'ContentChartFooter.downloadJPEG',description:'Texto para el botón de descargar en JPEG',defaultMessage:'Descargar en JPEG'},downloadPDF:{id:'ContentChartFooter.downloadPDF',description:'Texto para el botón de descargar en PDF',defaultMessage:'Descargar en PDF'},downloadSVG:{id:'ContentChartFooter.downloadSVG',description:'Texto para el botón de descargar en SVG',defaultMessage:'Descargar en SVG'},downloadCSV:{id:'ContentChartFooter.downloadCSV',description:'Texto para el botón de descargar en CSV',defaultMessage:'Descargar en CSV'},female:{id:'ContentChartFooter.female',description:'Texto para mujeres',defaultMessage:'Mujeres'},male:{id:'ContentChartFooter.male',description:'Texto para hombres',defaultMessage:'Hombres'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(1136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentDateModal=function(_Component){_inherits(ContentDateModal,_Component);function ContentDateModal(props){_classCallCheck(this,ContentDateModal);var _this=_possibleConstructorReturn(this,(ContentDateModal.__proto__||Object.getPrototypeOf(ContentDateModal)).call(this,props));_this.handleApply=function(){var from=void 0;var to=void 0;if(_this.props.multiple){if(_this.selectFrom.current.selectedOptions){from=Number(_this.selectFrom.current.selectedOptions[0].value);}else{from=Number(_this.selectFrom.current.value);// For compatibility with IE11
}}else{from=0;}if(_this.selectTo.current.selectedOptions){to=Number(_this.selectTo.current.selectedOptions[0].value);}else{to=Number(_this.selectTo.current.value);}if(from>to){return;}_this.props.fn.setDateRange({startingYear:from,endingYear:to});_this.props.fn.closeModal();};_this.renderFromOptions=function(){var options=[];var year=_this.props.minYear;while(year<=_this.props.maxYear){options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:year,value:year,disabled:year>_this.props.endingYear},year));year++;}return options;};_this.renderToOptions=function(){var options=[];var year=_this.props.maxYear;while(year>=_this.props.minYear){options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:year,value:year,disabled:year<_this.props.startingYear},year));year--;}return options;};_this.changeFrom=function(event){var selectedValue=event.target.value;for(var i=0;i<_this.selectTo.current.options.length;i++){var item=_this.selectTo.current.options[i];if(item.value<selectedValue)item.disabled=true;else item.disabled=false;}};_this.changeTo=function(event){var selectedValue=event.target.value;for(var i=0;i<_this.selectFrom.current.options.length;i++){var item=_this.selectFrom.current.options[i];if(item.value>selectedValue)item.disabled=true;else item.disabled=false;}};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={};_this.selectFrom=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.selectTo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ContentDateModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */],{show:this.props.show,onHide:this.props.fn.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Header,{closeButton:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Title,{id:'modal-rango-fechas-01-label'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].modalTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Body,{className:'ork-modal-body--border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-horizontal'},this.props.multiple?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rango-fechas-desde',className:'col-sm-5 control-label'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].modalFrom)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:this.selectFrom,className:'form-control',id:'rango-fechas-desde',defaultValue:this.props.startingYear,onChange:this.changeFrom},this.renderFromOptions()))):'',this.props.multiple?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rango-fechas-hasta',className:'col-sm-5 control-label'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].modalTo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:this.selectTo,className:'form-control',id:'rango-fechas-hasta',defaultValue:this.props.endingYear,onChange:this.changeTo},this.renderToOptions()))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rango-fechas-hasta',className:'col-sm-5 control-label'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].modalYear)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:this.selectTo,className:'form-control',id:'rango-fechas-hasta',defaultValue:this.props.endingYear},this.renderToOptions()))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Modal */].Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-sm btn-default','data-dismiss':'modal',onClick:this.props.fn.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-times fa-lg'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-u-ml-half'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].modalClose))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-sm btn-primary',onClick:this.handleApply},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-check fa-lg'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ork-u-ml-half'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].modalApply)))));}}]);return ContentDateModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(ContentDateModal));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({modalTitle:{id:'ContentDateModal.modalTitle',description:'Texto para el titulo del modal para la seleccion de fechas',defaultMessage:'Cambiar el rango de fechas'},modalFrom:{id:'ContentDateModal.modalFrom',description:'Texto para seleccionar la fecha inicial',defaultMessage:'Desde'},modalTo:{id:'ContentDateModal.modalTo',description:'Texto para seleccionar la fecha final',defaultMessage:'Hasta'},modalYear:{id:'ContentDateModal.modalYear',description:'Texto para seleccionar la fecha cuando solo es posible seleccionar un año',defaultMessage:'Año'},modalClose:{id:'ContentDateModal.modalClose',description:'Texto para el boton de cerrar el modal',defaultMessage:'Cerrar'},modalApply:{id:'ContentDateModal.modalApply',description:'Texto para el boton de aplicar del modal',defaultMessage:'Aplicar'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Charts_Map_MapChart__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentChart_ContentChartTitle__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Content_ContentChart_ContentChartFooter__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Content_ContentChart_ContentDateModal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Charts_PanelRow_PanelRowValues_PanelRowValuesAdapter__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_api_urls_v1__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_dataTools__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import QueryTools from 'utils/queries/queryTools'
// import APIURL from 'utils/api/urls'
// import IndicatorTools from 'utils/indicators/indicatorTools'
var MINIMUM_MAP_COVERAGE=0.15;//percentage 2.0/201;
var MapChartContainer=function(_Component){_inherits(MapChartContainer,_Component);function MapChartContainer(props){_classCallCheck(this,MapChartContainer);var _this=_possibleConstructorReturn(this,(MapChartContainer.__proto__||Object.getPrototypeOf(MapChartContainer)).call(this,props));_this.getRef=function(ref){_this.setState({chartRef:ref});};_this.getFemaleRef=function(ref){_this.setState({femaleChartRef:ref});};_this.getMaleRef=function(ref){_this.setState({maleChartRef:ref});};_this.renderMap=function(generalRegionsData,regionsToShow){var renderingMap=null;if(_this.state.showByGender){var indicatorMale=_this.state.indicatorData.relationships.sexMale;var indicatorFemale=_this.state.indicatorData.relationships.sexFemale;renderingMap=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Charts_Map_MapChart__["a" /* default */],{generalRegionsData:JSON.stringify(generalRegionsData),regionsToShow:JSON.stringify(regionsToShow),indicator:indicatorFemale,gender:'Female',year:_this.state.endingYear,selectedRegionId:_this.props.selectedRegionId,indicatorData:_this.state.indicatorData,expanded:_this.state.expanded,showLegend:_this.state.showLegend,fn:_this.getFemaleRef})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Charts_Map_MapChart__["a" /* default */],{generalRegionsData:JSON.stringify(generalRegionsData),regionsToShow:JSON.stringify(regionsToShow),indicator:indicatorMale,gender:'Male',year:_this.state.endingYear,selectedRegionId:_this.props.selectedRegionId,indicatorData:_this.state.indicatorData,expanded:_this.state.expanded,showLegend:_this.state.showLegend,fn:_this.getMaleRef})));}else{renderingMap=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Charts_Map_MapChart__["a" /* default */],{generalRegionsData:JSON.stringify(generalRegionsData),regionsToShow:JSON.stringify(regionsToShow),indicator:_this.props.indicator,gender:'Total',year:_this.state.endingYear,selectedRegionId:_this.props.selectedRegionId,indicatorData:_this.state.indicatorData,expanded:_this.state.expanded,showLegend:_this.state.showLegend,fn:_this.getRef});}return renderingMap;};_this.state={showLegend:true,showByGender:false,showTable:false,showModal:false,expanded:false,startingYear:0,endingYear:0,latestCoveredYear:0,minYear:0,maxYear:0,chartRef:null,femaleChartRef:null,maleChartRef:null,indicatorData:{},loading:true,error:false};return _this;}_createClass(MapChartContainer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var selectedRegionId=this.props.selectedRegionId;var indicator=this.props.indicator;var geo=[selectedRegionId];var regionsData=this.props.regionsData;var benchmarkRegionIds=regionsData.map(function(o){return o["id"];});benchmarkRegionIds.forEach(function(geo_id){if(geo_id!==selectedRegionId){geo.push(geo_id);}});__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:geo})).then(function(values){var data=values.data;var availableTimes=__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].uniquePropertyValues(data,"time").sort(__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].descending);// console.log( availableTimes );
// minimum: two regions
var latestSet=__WEBPACK_IMPORTED_MODULE_5_modules_Charts_PanelRow_PanelRowValues_PanelRowValuesAdapter__["a" /* default */].firstComparableSet(data,benchmarkRegionIds,availableTimes,MINIMUM_MAP_COVERAGE,"geo");var max=__WEBPACK_IMPORTED_MODULE_9_utils_dates_dateTools__["a" /* default */].getYearFromDateString(latestSet[0].time);var min=__WEBPACK_IMPORTED_MODULE_9_utils_dates_dateTools__["a" /* default */].getYearFromDateString(__WEBPACK_IMPORTED_MODULE_8_utils_dataTools__["a" /* default */].arrayAt(availableTimes,-1));// console.log( min, max );
return{min:min,max:max};})// let query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)
// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query }))
//   .then(data => IndicatorTools.getIndicatorEvolutionData(data))
//   .then(indicatorEvolutionData => IndicatorTools.getMaxAndMinYearFromIndicator(indicatorEvolutionData))
.then(function(_ref){var min=_ref.min,max=_ref.max;if(max-10>=min)min=max-10;_this2.setState({minYear:min,maxYear:max,startingYear:min,endingYear:max,loading:false,error:false});}).catch(function(reason){_this2.setState({loading:false,error:true});});var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this2.props.indicator;})[0];this.setState({indicatorData:indicatorData});}},{key:'functionSet',value:function functionSet(){var _this3=this;var chartRef=this.state.chartRef;var femaleChartRef=this.state.femaleChartRef;var maleChartRef=this.state.maleChartRef;var shouldShowLegend=this.state.showLegend;var showLegend=function showLegend(){shouldShowLegend=!shouldShowLegend;chartRef.current.chart.legend.update({enabled:shouldShowLegend});_this3.setState({showLegend:shouldShowLegend});};var shouldShowByGender=this.state.showByGender;var showByGender=function showByGender(){shouldShowByGender=!shouldShowByGender;_this3.setState({showByGender:shouldShowByGender});};var showTable=function showTable(shouldShow){_this3.setState({showTable:shouldShow});};var modalFunctions=function modalFunctions(){var setDateRange=function setDateRange(_ref2){var startingYear=_ref2.startingYear,endingYear=_ref2.endingYear;_this3.setState({startingYear:startingYear,endingYear:endingYear});};var openModal=function openModal(){_this3.setState({showModal:true});};var closeModal=function closeModal(){_this3.setState({showModal:false});};return{setDateRange:setDateRange,openModal:openModal,closeModal:closeModal};};var exportChart=function exportChart(fileType,gender){var chart=void 0;var fileName=void 0;if(_this3.state.showByGender){if(gender==='Female'){chart=femaleChartRef.current.getChart();fileName='Female - '+_this3.state.indicatorData.name;}else{chart=maleChartRef.current.getChart();fileName='Male - '+_this3.state.indicatorData.name;}}else{chart=chartRef.current.getChart();fileName=_this3.state.indicatorData.name;}var optionsToExport={filename:fileName};if(fileType==='CSV'){var csv=_this3.composeCSV(chart);var hiddenElement=document.createElement('a');hiddenElement.href='data:attachment/text,'+encodeURI(csv);hiddenElement.target='_blank';hiddenElement.download=fileName+'.csv';hiddenElement.click();}else{switch(fileType){case'PNG':optionsToExport.type='image/png';break;case'JPEG':optionsToExport.type='image/jpeg';break;case'PDF':optionsToExport.type='application/pdf';break;case'SVG':optionsToExport.type='image/svg+xml';break;default:optionsToExport.type='image/png';break;}chart.exportChart(optionsToExport);}};var expandChart=function expandChart(){var shouldExpand=!_this3.state.expanded;if(shouldExpand){document.getElementsByTagName('html')[0].classList.add('ork-no-scroll');}else{document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll');}_this3.setState({expanded:shouldExpand});};return{showLegend:showLegend,showByGender:showByGender,showTable:showTable,modalFunctions:modalFunctions,exportChart:exportChart,expandChart:expandChart};}},{key:'composeCSV',value:function composeCSV(chart){var data=chart.series[0].data;var csv='"Region Name", "Values"\n';data.forEach(function(item,index){if(item.regionName!==undefined&&index!==0){csv=csv+(item.regionName.replace(',',' ')+','+item.value+'\n');}});return csv;}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Loading__["a" /* default */],null);}else{var comparative=void 0;if(this.props.otherRegionsFilter!==undefined&&this.props.otherRegionsFilter.length!==0){comparative=this.props.otherRegionsFilter;}else{comparative={};}var _props=this.props,regionsData=_props.regionsData,referenceRegionsData=_props.referenceRegionsData,sameCountryRegionsData=_props.sameCountryRegionsData;var generalRegionsData={regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative};var regionsToShow={allRegionsFilter:this.props.allRegionsFilter,referenceRegionsFilter:this.props.referenceRegionsFilter,sameCountryRegionsFilter:this.props.sameCountryRegionsFilter,otherRegionsFilter:comparative};renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel panel-default '+(this.state.expanded?'panel-expanded':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentChart_ContentChartTitle__["a" /* default */],{indicator:this.props.indicator,layer:this.props.layer,chartType:'map'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},this.renderMap(generalRegionsData,regionsToShow)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Content_ContentChart_ContentChartFooter__["a" /* default */],{fn:this.functionSet(),indicatorData:this.state.indicatorData,expanded:this.state.expanded,chartType:'map',showByGender:this.state.showByGender})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_ContentChart_ContentDateModal__["a" /* default */],{show:this.state.showModal,fn:this.functionSet().modalFunctions(),startingYear:this.state.startingYear,endingYear:this.state.endingYear,minYear:this.state.minYear,maxYear:this.state.maxYear,multiple:false}));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderIfAllOK());}}]);return MapChartContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MapChartContainer);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapChart__ = __webpack_require__(1139);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MapChart__["a" /* default */]);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_highcharts_ReactHighmaps_src__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_highcharts_ReactHighmaps_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_highcharts_ReactHighmaps_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MapChartConfig__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MapChartAdapter__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_api_urls__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_queries_queryTools__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MapChart=function(_Component){_inherits(MapChart,_Component);function MapChart(props){_classCallCheck(this,MapChart);var _this=_possibleConstructorReturn(this,(MapChart.__proto__||Object.getPrototypeOf(MapChart)).call(this,props));_initialiseProps.call(_this);var _props$intl=props.intl,formatMessage=_props$intl.formatMessage,formatNumber=_props$intl.formatNumber;_this.formatNumber=formatNumber;_this.formatMessage=formatMessage;__WEBPACK_IMPORTED_MODULE_8_utils_app_appTools__["a" /* default */].importFormatter(formatMessage);_this.state={loading:true,error:false};_this.mapChart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(MapChart,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.fn(this.mapChart);var generalRegionsData=JSON.parse(this.props.generalRegionsData);var regionsData=generalRegionsData.regionsData,referenceRegionsData=generalRegionsData.referenceRegionsData,sameCountryRegionsData=generalRegionsData.sameCountryRegionsData,comparative=generalRegionsData.comparative;this.setState({regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative},function(){return _this2.getMapChart();});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var shouldUpdate=!__WEBPACK_IMPORTED_MODULE_10_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_10_utils_objects_objectTools__["a" /* default */].compareObjects(this.state,nextState);return shouldUpdate;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(!__WEBPACK_IMPORTED_MODULE_10_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,prevProps)){var generalRegionsData=JSON.parse(this.props.generalRegionsData);var regionsData=generalRegionsData.regionsData,referenceRegionsData=generalRegionsData.referenceRegionsData,sameCountryRegionsData=generalRegionsData.sameCountryRegionsData,comparative=generalRegionsData.comparative;this.setState({regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,loading:true,error:false},function(){return _this3.getMapChart();});}this.setZoomAfterRendering();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return MapChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.getMapChart=function(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:_this4.props.indicator,selectedRegionId:_this4.props.selectedRegionId},indicator=_ref.indicator,selectedRegionId=_ref.selectedRegionId;var regionsData=_this4.state.regionsData;var referenceRegionsData=_this4.state.referenceRegionsData;var sameCountryRegionsData=_this4.state.sameCountryRegionsData;var comparative=_this4.state.comparative;var regionsToShow=JSON.parse(_this4.props.regionsToShow);var allRegionsFilter=regionsToShow.allRegionsFilter,referenceRegionsFilter=regionsToShow.referenceRegionsFilter,sameCountryRegionsFilter=regionsToShow.sameCountryRegionsFilter,otherRegionsFilter=regionsToShow.otherRegionsFilter;var comparativeShouldShow=Object.keys(otherRegionsFilter).length!==0;var chartConfig=_this4.selectConfig('general').chartConfig;var year=_this4.props.year;var promises=[];var query=__WEBPACK_IMPORTED_MODULE_9_utils_queries_queryTools__["a" /* default */].formatQuerySingleGEOFromId(selectedRegionId);promises.push(Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getDataInSpecificYearForIndicatorAndRegions({indicator:indicator,query:query,year:year}))));if(allRegionsFilter){var _query=__WEBPACK_IMPORTED_MODULE_9_utils_queries_queryTools__["a" /* default */].formatQueryInDifferentGEOs(regionsData);promises.push(Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getDataInSpecificYearForIndicatorAndRegions({indicator:indicator,query:_query,year:year}))));}if(referenceRegionsFilter){var _query2=__WEBPACK_IMPORTED_MODULE_9_utils_queries_queryTools__["a" /* default */].formatQueryInDifferentGEOs(referenceRegionsData);promises.push(Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getDataInSpecificYearForIndicatorAndRegions({indicator:indicator,query:_query2,year:year}))));}if(sameCountryRegionsFilter){var _query3=__WEBPACK_IMPORTED_MODULE_9_utils_queries_queryTools__["a" /* default */].formatQueryInDifferentGEOs(sameCountryRegionsData);promises.push(Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getDataInSpecificYearForIndicatorAndRegions({indicator:indicator,query:_query3,year:year}))));}if(comparativeShouldShow){var _query4='';var offset=0;comparative.forEach(function(comparativeItem){_query4+='&'+__WEBPACK_IMPORTED_MODULE_9_utils_queries_queryTools__["a" /* default */].formatQueryInDifferentGEOs(comparativeItem.regionsData,offset);offset=offset+comparativeItem.regionsData.length;});promises.push(Promise.resolve(__WEBPACK_IMPORTED_MODULE_6_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_7_utils_api_urls__["a" /* default */].getDataInSpecificYearForIndicatorAndRegions({indicator:indicator,query:_query4,year:year}))));}Promise.all(promises).then(function(values){return __WEBPACK_IMPORTED_MODULE_5__MapChartAdapter__["a" /* default */].preFormatDataFromResponse.apply(__WEBPACK_IMPORTED_MODULE_5__MapChartAdapter__["a" /* default */],_toConsumableArray(values));}).then(function(data){return __WEBPACK_IMPORTED_MODULE_5__MapChartAdapter__["a" /* default */].formatMapSeries({regionsData:regionsData,data:data,selectedRegionId:selectedRegionId});}).then(function(series){var customMapConfig=__WEBPACK_IMPORTED_MODULE_10_utils_objects_objectTools__["a" /* default */].copyObject(chartConfig);var _MapChartAdapter$getM=__WEBPACK_IMPORTED_MODULE_5__MapChartAdapter__["a" /* default */].getMaxAndMinValue(series),max=_MapChartAdapter$getM.max,min=_MapChartAdapter$getM.min;if(_this4.props.expanded){var panelHeight=document.querySelector('.panel-expanded').offsetHeight;var panelHeaderHeight=document.querySelector('.panel-expanded>.panel-heading').offsetHeight;var panelFooterHeight=document.querySelector('.panel-expanded>.panel-footer').offsetHeight;var panelBody=document.querySelector('.panel-expanded>.panel-body');var paddingTop=parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-top'),10);var paddingBottom=parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-bottom'),10);var panelBodyHeight=panelHeight-panelHeaderHeight-panelFooterHeight-paddingTop-paddingBottom;customMapConfig.chart.height=panelBodyHeight+'px';}customMapConfig.legend.enabled=_this4.props.showLegend;customMapConfig.credits.text=__WEBPACK_IMPORTED_MODULE_8_utils_app_appTools__["a" /* default */].getComposedDataSource(_this4.props.indicatorData.dataSource);var divergent=false;var min_sign=Math.sign(min);var max_sign=Math.sign(max);if(min_sign!==0&max_sign!==0&min_sign!==max_sign){divergent=true;var max_abs=Math.max(Math.abs(min),Math.abs(max));min=-max_abs;max=max_abs;}// customMapConfig.colorAxis.max = max
// customMapConfig.colorAxis.min = min
var mapMaxColor=void 0;var mapMinColor=void 0;var chartTitle=void 0;if(_this4.props.indicatorData.rankOrdering==='descending'){if(_this4.props.gender==='Female'){mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorDescendingFemale);mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMinColorDescendingFemale);chartTitle=_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].female)+' | '+_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yearAndUnit,{year:year,unit:_this4.props.indicatorData.unit});}else if(_this4.props.gender==='Male'){mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorDescending);mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMinColorDescending);chartTitle=_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].male)+' | '+_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yearAndUnit,{year:year,unit:_this4.props.indicatorData.unit});}else{mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorDescending);mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMinColorDescending);chartTitle=_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yearAndUnit,{year:year,unit:_this4.props.indicatorData.unit});}}else{if(_this4.props.gender==='Female'){mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorAscendingFemale);mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMinColorAscendingFemale);chartTitle=_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].female)+' | '+_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yearAndUnit,{year:year,unit:_this4.props.indicatorData.unit});}else if(_this4.props.gender==='Male'){mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorAscending);mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMinColorAscending);chartTitle=_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].male)+' | '+_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yearAndUnit,{year:year,unit:_this4.props.indicatorData.unit});}else{mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorAscending);mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMinColorAscending);chartTitle=_this4.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].yearAndUnit,{year:year,unit:_this4.props.indicatorData.unit});}}//   customMapConfig.colorAxis.maxColor = mapMaxColor
//   customMapConfig.colorAxis.minColor = mapMinColor
if(divergent){if(_this4.props.gender==='Female'){mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorAscendingFemale);mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorDescendingFemale);}else{mapMinColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorAscending);mapMaxColor=__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].colorToRGBA(__WEBPACK_IMPORTED_MODULE_11_utils_colors_colors__["a" /* default */].mapMaxColorDescending);}customMapConfig.colorAxis.stops=[[0.0,mapMinColor],[0.5,"rgba( 255, 255, 255, 1 )"],[1.0,mapMaxColor]];customMapConfig.colorAxis.min=min;customMapConfig.colorAxis.max=max;}else{customMapConfig.colorAxis.stops=[[0.0,mapMinColor],[1.0,mapMaxColor]];}customMapConfig.title.text=chartTitle;customMapConfig.series=series;var formatNumber=_this4.formatNumber;var unit=_this4.props.indicatorData.unit;customMapConfig.tooltip.headerFormat='<span style="font-size: 10px">'+year+'</span><br/>';customMapConfig.tooltip.pointFormatter=function(){return'<span style="color:'+this.color+'">●</span><b>'+this.regionName+'</b>: '+formatNumber(this.value.toFixed(2))+' '+unit;};_this4.setState({chartConfig:customMapConfig,loading:false});}).catch(function(reason){console.log(reason);_this4.setState({error:true,loading:false});});};this.selectConfig=function(config){switch(config){case'selectedRegion':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__MapChartConfig__["a" /* default */].selectedRegionConfig};case'general':return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__MapChartConfig__["a" /* default */].generalConfig};default:return{chartConfig:__WEBPACK_IMPORTED_MODULE_4__MapChartConfig__["a" /* default */].generalConfig};}};this.getZoomBeforeRendering=function(){if(_this4.mapChart.current){var chartArray=_this4.mapChart.current.Highcharts.charts;_this4.zoomXMin=chartArray[chartArray.length-1].xAxis[0].getExtremes().min;_this4.zoomXMax=chartArray[chartArray.length-1].xAxis[0].getExtremes().max;_this4.zoomYMin=chartArray[chartArray.length-1].yAxis[0].getExtremes().min;_this4.zoomYMax=chartArray[chartArray.length-1].yAxis[0].getExtremes().max;}};this.setZoomAfterRendering=function(){if(_this4.mapChart.current){var chartArray=_this4.mapChart.current.Highcharts.charts;chartArray[chartArray.length-1].xAxis[0].setExtremes(_this4.zoomXMin,_this4.zoomXMax,false);chartArray[chartArray.length-1].yAxis[0].setExtremes(_this4.zoomYMin,_this4.zoomYMax,false);}};this.renderIfAllOK=function(){var renderingComponent=null;if(_this4.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Error__["a" /* default */],null);}else if(_this4.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Loading__["a" /* default */],null);}else{_this4.getZoomBeforeRendering();renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_highcharts_ReactHighmaps_src___default.a,{ref:_this4.mapChart,config:_this4.state.chartConfig});}return renderingComponent;};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(MapChart));

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({yearAndUnit:{id:'MapChart.yearAndUnit',description:'Texto donde se muestra el año y la unidad en el MapChart',defaultMessage:'Año {year} | Unidad: {unit}'},female:{id:'MapChart.female',description:'Texto para mujeres',defaultMessage:'Mujeres'},male:{id:'MapChart.male',description:'Texto para hombres',defaultMessage:'Hombres'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_objects_objectTools__ = __webpack_require__(47);
var generalConfig={chart:{style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'},marginBottom:30,backgroundColor:'rgba(0,0,0,0)'},title:{text:'',floating:true,align:'right',x:1,y:12,useHTML:true,style:{fontSize:'12px',fontWeight:'bold',color:'#717171',backgroundColor:'#FFF',padding:'5px 10px 5px 10px',borderRadius:'0px 0px 0px 10px'}},credits:{enabled:true,text:'',href:'https://www.orkestra.deusto.es',position:{y:-10},style:{fontSize:'12px'}},exporting:{sourceWidth:800,sourceHeight:550,buttons:{contextButton:{enabled:false}},allowHTML:true},tooltip:{enabled:true,valueSuffix:'',style:{fontFamily:'\'Montserrat\', Helvetica, Arial, sans-serif'}},mapNavigation:{enabled:true,buttonOptions:{verticalAlign:'top',alignTo:'spacingBox'}},colorAxis:{tickPixelInterval:50,startOnTick:false,endOnTick:false,labels:{align:'right',x:30},reversed:false},legend:{borderWidth:0,padding:0,itemDistance:2,layout:'vertical',align:'left',verticalAlign:'bottom',floating:false},series:[]};var selectedRegionConfig=__WEBPACK_IMPORTED_MODULE_1_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var chartMapConfig={geoJSON:__WEBPACK_IMPORTED_MODULE_0_utils_geoJSON_geoJSON__["a" /* default */],generalConfig:generalConfig,selectedRegionConfig:selectedRegionConfig};/* harmony default export */ __webpack_exports__["a"] = (chartMapConfig);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_geoJSON_geoJSON__ = __webpack_require__(116);
var formatMapSeries=function formatMapSeries(_ref){var data=_ref.data,regionsData=_ref.regionsData,selectedRegionId=_ref.selectedRegionId;var chartData=[];var usefulData=data.data.map(function(item){return{name:__WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__["a" /* default */].getRegionNameFromId({id:data.query.geo[item.geoset],regionsData:regionsData}),code:__WEBPACK_IMPORTED_MODULE_0_utils_regions_regionTools__["a" /* default */].getRegionCodeFromId({id:data.query.geo[item.geoset],regionsData:regionsData}),id:data.query.geo[item.geoset],value:item.value};});usefulData.forEach(function(item){if(Number(item.id)===Number(selectedRegionId)){chartData.push({code:item.code,regionName:item.name,value:item.value});}else{chartData.push({code:item.code,regionName:item.name,value:item.value});}});var series=[{type:'map',index:1,mapData:__WEBPACK_IMPORTED_MODULE_1_utils_geoJSON_geoJSON__["a" /* default */].regionLevel,data:chartData,joinBy:['NUTS_ID','code'],states:{hover:{color:'#0fa4c4'}}},{type:'mapline',index:2,mapData:__WEBPACK_IMPORTED_MODULE_1_utils_geoJSON_geoJSON__["a" /* default */].countryLevel,nullColor:'#333',showInLegend:false,includeInCSVExport:false,name:'borders',lineWidth:0.75,color:'#CCCCCC',dataLabels:{enabled:false},states:{hover:{enabled:false}}}];return series;};var preFormatDataFromResponse=function preFormatDataFromResponse(){for(var _len=arguments.length,response=Array(_len),_key=0;_key<_len;_key++){response[_key]=arguments[_key];}var newData=[];var query={};var geo={};var jIndex=0;var getPreFormattedOBJ=function getPreFormattedOBJ(responseOBJ){responseOBJ.data.forEach(function(item){var aux={geoset:''+jIndex,time:item.time,value:item.value};geo[jIndex]=responseOBJ.query.geo[item.geoset];jIndex++;newData.push(aux);});};for(var i=0;i<response.length;i++){var responseOBJ=response[i];if(responseOBJ.error===undefined){// no error if there's no data
getPreFormattedOBJ(responseOBJ);}}query.geo=geo;return{data:newData,query:query};};var getMaxAndMinValue=function getMaxAndMinValue(series){var max=void 0;var min=void 0;var values=series[0].data.map(function(item){return item.value;}).filter(function(v){return v!==null;});max=values[0];min=values[0];// max = Math.max( values );
// min = Math.min( values );
values.forEach(function(value){if(value>max)max=value;if(value<min)min=value;});return{max:max,min:min};};var mapChartAdapter={formatMapSeries:formatMapSeries,preFormatDataFromResponse:preFormatDataFromResponse,getMaxAndMinValue:getMaxAndMinValue};/* harmony default export */ __webpack_exports__["a"] = (mapChartAdapter);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelDimensionContainer__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{chartTypeFilter:state.FILTERS.chartTypeFilter};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__PanelDimensionContainer__["a" /* default */]));

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Charts_Lines_LinesChartContainer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Charts_Map_MapChartContainer__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelDimensionContainer=function(_Component){_inherits(PanelDimensionContainer,_Component);function PanelDimensionContainer(props){_classCallCheck(this,PanelDimensionContainer);var _this=_possibleConstructorReturn(this,(PanelDimensionContainer.__proto__||Object.getPrototypeOf(PanelDimensionContainer)).call(this,props));_this.renderChart=function(indicator){var chart=null;switch(_this.props.chartTypeFilter){case'evolutionAbsolute':chart=_this.renderLinesChart(indicator);break;case'map':chart=_this.renderMapChart(indicator);break;default:chart=null;break;}return chart;};_this.composeCharts=function(subdimension,indicators){var charts=[];var numberOfRows=Math.ceil(indicators.length/2);for(var i=0;i<numberOfRows;i++){charts.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',key:'row'+subdimension+'.'+i},_this.renderChart(indicators[i*2]),indicators[i*2+1]?_this.renderChart(indicators[i*2+1]):null));}return charts;};_this.renderPanelSubsection=function(dimension,subdimension,indicators){var title=__WEBPACK_IMPORTED_MODULE_4_utils_app_appTools__["a" /* default */].getSubDimensionTitle(dimension,subdimension);// `Subsection ${subdimension} title`;
var key=dimension+'.'+subdimension;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title),_this.composeCharts(subdimension,indicators));};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={loading:true,error:false,levelIndicators:[]};return _this;}_createClass(PanelDimensionContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.level!==0){var levelIndicators=__WEBPACK_IMPORTED_MODULE_5_utils_indicators_indicatorTools__["a" /* default */].getIndicatorsFromLevel(this.props.dimension);this.setState({levelIndicators:levelIndicators,loading:false,error:false});}else{this.setState({loading:false,error:false});}}},{key:'renderLinesChart',value:function renderLinesChart(indicator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Charts_Lines_LinesChartContainer__["a" /* default */],{indicator:indicator});}},{key:'renderMapChart',value:function renderMapChart(indicator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Charts_Map_MapChartContainer__["a" /* default */],{indicator:indicator});}},{key:'renderAllCharts',value:function renderAllCharts(indicator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Charts_Lines_LinesChartContainer__["a" /* default */],{indicator:indicator,layer:this.props.layer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Charts_Map_MapChartContainer__["a" /* default */],{indicator:indicator,layer:this.props.layer}));}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this2=this;var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Loading__["a" /* default */],null);}else{var subsections=[];if(this.props.level!==0){this.state.levelIndicators.forEach(function(subLevelIndicators,subLevel){subsections.push(_this2.renderPanelSubsection(_this2.props.dimension,subLevel,subLevelIndicators));});}else{subsections.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',key:'row'+1},this.composeCharts({indicator:this.props.indicator})));}renderingComponent=subsections;}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return PanelDimensionContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(PanelDimensionContainer));

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectedRegionController=function(_Component){_inherits(SelectedRegionController,_Component);function SelectedRegionController(props){_classCallCheck(this,SelectedRegionController);var _this=_possibleConstructorReturn(this,(SelectedRegionController.__proto__||Object.getPrototypeOf(SelectedRegionController)).call(this,props));_this.setSelectedRegionId=function(id){_this.props.setSelectedRegionId(id);};_this.state={error:false};return _this;}_createClass(SelectedRegionController,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var selectedRegionCode=this.props.match.params.regionCode;__WEBPACK_IMPORTED_MODULE_1_utils_api_api__["a" /* default */].getRegions().then(function(regions){return __WEBPACK_IMPORTED_MODULE_2_utils_regions_regionTools__["a" /* default */].getDataFromRegions(regions);}).then(function(regionsData){var selectedRegionId=__WEBPACK_IMPORTED_MODULE_2_utils_regions_regionTools__["a" /* default */].getRegionIdFromCode({regionsData:regionsData,code:selectedRegionCode});_this2.setSelectedRegionId(selectedRegionId);}).catch(function(reason){_this2.setState({error:true});});}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Error__["a" /* default */],null);}else{renderingComponent='';}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return SelectedRegionController;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectedRegionController);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorsPerformance__ = __webpack_require__(1147);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__IndicatorsPerformance__["a" /* default */]);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_LayerHeader__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentContainer__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_SelectedRegion_SelectedRegionController__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndicatorsPerformance=function(_Component){_inherits(IndicatorsPerformance,_Component);function IndicatorsPerformance(){_classCallCheck(this,IndicatorsPerformance);return _possibleConstructorReturn(this,(IndicatorsPerformance.__proto__||Object.getPrototypeOf(IndicatorsPerformance)).apply(this,arguments));}_createClass(IndicatorsPerformance,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_SelectedRegion_SelectedRegionController__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LayerHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return IndicatorsPerformance;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IndicatorsPerformance);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorDetail__ = __webpack_require__(1149);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__IndicatorDetail__["a" /* default */]);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_LayerHeader__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentContainer__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_SelectedRegion_SelectedRegionController__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndicatorDetail=function(_Component){_inherits(IndicatorDetail,_Component);function IndicatorDetail(){_classCallCheck(this,IndicatorDetail);return _possibleConstructorReturn(this,(IndicatorDetail.__proto__||Object.getPrototypeOf(IndicatorDetail)).apply(this,arguments));}_createClass(IndicatorDetail,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_SelectedRegion_SelectedRegionController__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LayerHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_modules_Content_ContentContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return IndicatorDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IndicatorDetail);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorEvolutionPage__ = __webpack_require__(1151);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__IndicatorEvolutionPage__["a" /* default */]);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Controllers_SelectedRegion_SelectedRegionController__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Content_IndicatorEvolutionContainer__ = __webpack_require__(417);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndicatorEvolutionPage=function(_Component){_inherits(IndicatorEvolutionPage,_Component);function IndicatorEvolutionPage(){_classCallCheck(this,IndicatorEvolutionPage);return _possibleConstructorReturn(this,(IndicatorEvolutionPage.__proto__||Object.getPrototypeOf(IndicatorEvolutionPage)).apply(this,arguments));}_createClass(IndicatorEvolutionPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_modules_Controllers_SelectedRegion_SelectedRegionController__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid ork-gray-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Content_IndicatorEvolutionContainer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return IndicatorEvolutionPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IndicatorEvolutionPage);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Charts_DecoupledLines_DecoupledLinesChartContainer__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndicatorEvolutionContainer=function(_Component){_inherits(IndicatorEvolutionContainer,_Component);function IndicatorEvolutionContainer(props){_classCallCheck(this,IndicatorEvolutionContainer);var _this=_possibleConstructorReturn(this,(IndicatorEvolutionContainer.__proto__||Object.getPrototypeOf(IndicatorEvolutionContainer)).call(this,props));_this.state={layer:1,loading:true,error:false};return _this;}_createClass(IndicatorEvolutionContainer,[{key:'componentDidMount',value:function componentDidMount(){document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll');this.loadData();// let url = this.props.history.location.pathname;
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.selectedRegionId!==prevProps.selectedRegionId){this.loadData();}}},{key:'loadData',value:function loadData(){var _this2=this;if(this.props.selectedRegionId===null)return;// let indicatorId = Number( this.props.match.params.indicatorId );
// console.log(indicatorId);
var promises=[];var regionsMetaPromise=__WEBPACK_IMPORTED_MODULE_2_utils_api_api__["a" /* default */].getRegions().then(function(regions){return __WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getDataFromRegions(regions);});var countriesMetaPromise=__WEBPACK_IMPORTED_MODULE_2_utils_api_api__["a" /* default */].getCountries().then(function(countries){return __WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getDataFromCountries(countries);});// const dataPromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorData({ indicator: indicatorId, geo: [1], meta: true })));
promises.push(regionsMetaPromise);promises.push(countriesMetaPromise);// promises.push(dataPromise);
// const p1 = API.getRegions().then(regions => RegionTools.getDataFromRegions(regions))
var indicatorsMetaPromise=__WEBPACK_IMPORTED_MODULE_2_utils_api_api__["a" /* default */].getIndicators().then(function(indicators){return __WEBPACK_IMPORTED_MODULE_3_utils_indicators_indicatorTools__["a" /* default */].getDataFromIndicators(indicators);});promises.push(indicatorsMetaPromise);// const p5 = API.getIndicatorsStatus().then(indicatorsStatus => indicatorsStatus.last_checked_on)
// const p6 = API.getCountries().then(countries => RegionTools.getDataFromCountries(countries))
Promise.all(promises).then(function(values){// console.log( this.props );
_this2.props.setRegionsData(values[0]);_this2.props.setCountriesData(values[1]);_this2.props.setIndicatorsData(values[2]);var selectedRegionMeta=values[0].filter(function(region){return Number(region.id)===Number(_this2.props.selectedRegionId);})[0];var selectedRegionCountryMeta=__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].countryCodeToMeta(__WEBPACK_IMPORTED_MODULE_4_utils_regions_regionTools__["a" /* default */].getCountryCodeFromRegionCode(selectedRegionMeta.code));_this2.props.setSelectedRegionCountryMeta(selectedRegionCountryMeta);var indicatorData=values[2].filter(function(item){return Number(item.id)===Number(_this2.props.match.params.indicatorId);})[0];return indicatorData;// console.log("ok")
// this.props.setIndicatorsData([values[0]["meta"]]);
}).then(function(indicatorData){_this2.setState({loading:false,error:false,indicatorData:indicatorData});}).catch(function(reason){_this2.setState({error:true,loading:false});});}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Loading__["a" /* default */],null);}else{var indicatorId=Number(this.props.match.params.indicatorId);// console.log( this.state.indicatorData );
renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Charts_DecoupledLines_DecoupledLinesChartContainer__["a" /* default */],{indicator:indicatorId,selectedRegionId:this.props.selectedRegionId,startingYear:this.props.timePeriodStart,endingYear:this.props.timePeriodEnd,numberOfYears:this.props.timePeriodLength,geoIds:this.props.geoIds,regionsToPlot:this.props.regionsToPlot,embed:this.props.embed}));}return renderingComponent;}},{key:'render',value:function render(){// return <div className="container-fluid ork-gray-box">{this.renderIfAllOK()}</div>
return this.renderIfAllOK();}}]);return IndicatorEvolutionContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IndicatorEvolutionContainer.defaultProps={timePeriodStart:null,timePeriodEnd:null,timePeriodLength:null,geoIds:null,regionsToPlot:null};/* harmony default export */ __webpack_exports__["a"] = (IndicatorEvolutionContainer);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DecoupledLinesChartContainer__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,regionsData:state.REGIONS.regionsData,countriesData:state.REGIONS.countriesData,referenceRegionsData:state.REGIONS.referenceRegionsData,sameCountryRegionsData:state.REGIONS.sameCountryRegionsData,allRegionsGroupRegionId:state.REGIONS.allRegionsGroupRegionId,allRegionsFilter:state.FILTERS.allRegionsFilter,referenceRegionsFilter:state.FILTERS.referenceRegionsFilter,sameCountryRegionsFilter:state.FILTERS.sameCountryRegionsFilter,otherRegionsFilter:state.FILTERS.otherRegionsFilter,indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__DecoupledLinesChartContainer__["a" /* default */]));

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Charts_DecoupledLines_DecoupledLinesChart__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentChart_ContentChartTitle__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Content_ContentChart_ContentChartFooter__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Content_ContentChart_ContentDateModal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api_urls_v1__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_NUMBER_OF_YEARS_TO_SHOW=10;//10;
var DecoupledLinesChartContainer=function(_Component){_inherits(DecoupledLinesChartContainer,_Component);function DecoupledLinesChartContainer(props){_classCallCheck(this,DecoupledLinesChartContainer);var _this=_possibleConstructorReturn(this,(DecoupledLinesChartContainer.__proto__||Object.getPrototypeOf(DecoupledLinesChartContainer)).call(this,props));_this.getRef=function(ref){_this.setState({chartRef:ref});};_this.state={showLegend:true,showByGender:false,showTable:false,showModal:false,expanded:false,startingYear:1900,endingYear:2020,minYear:0,maxYear:0,chartRef:null,indicatorData:{},loading:true,error:false};return _this;}_createClass(DecoupledLinesChartContainer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var selectedRegionId=this.props.selectedRegionId;var indicator=this.props.indicator;// TODO: get from URL?
var regionsToPlot=[selectedRegionId,411,325,2692,326,560];// let query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)
// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query }))
__WEBPACK_IMPORTED_MODULE_5_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_6_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:regionsToPlot})).then(function(responseData){responseData.data=responseData.data.filter(function(item){return item.value!==null;});responseData.data.forEach(function(item){item["time_year"]=__WEBPACK_IMPORTED_MODULE_8_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time);});_this2.setState({data:responseData.data});var selectedRegionData=responseData["data"].filter(function(item){return item.geo===selectedRegionId;});return __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__["a" /* default */].getIndicatorEvolutionData(selectedRegionData);}).then(function(regionEvolutionData){return __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__["a" /* default */].getMaxAndMinYearFromIndicator(regionEvolutionData);}).then(function(extent){// console.log(extent);
var minYear=extent.min;var maxYear=extent.max;var numberOfYears=_this2.props.numberOfYears||DEFAULT_NUMBER_OF_YEARS_TO_SHOW;if(extent.max-(numberOfYears-1)>=extent.min){minYear=extent.max-(numberOfYears-1);}// use configProps
// adjust values for only one tip of period
var startingYear=null;var endingYear=null;if(_this2.props.endingYear&&_this2.props.endingYear<=extent.max){endingYear=_this2.props.endingYear;}else{endingYear=extent.max;}if(_this2.props.startingYear&&_this2.props.startingYear>=extent.min){startingYear=_this2.props.startingYear;}else{startingYear=endingYear-(numberOfYears-1);}if(_this2.props.startingYear&&!_this2.props.endingYear){endingYear=startingYear+(numberOfYears-1);}if(!_this2.props.startingYear&&_this2.props.endingYear){startingYear=endingYear-(numberOfYears-1);}_this2.setState({// evolutionData: indicatorEvolutionData,
minYear:minYear,maxYear:maxYear,startingYear:startingYear,endingYear:endingYear,loading:false,error:false});}).catch(function(reason){console.error("error",reason);_this2.setState({loading:false,error:true});});var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this2.props.indicator;})[0];this.setState({indicatorData:indicatorData});}},{key:'functionSet',value:function functionSet(){var _this3=this;var chartRef=this.state.chartRef;var shouldShowLegend=this.state.showLegend;var showLegend=function showLegend(){shouldShowLegend=!shouldShowLegend;chartRef.current.chart.legend.update({enabled:shouldShowLegend});_this3.setState({showLegend:shouldShowLegend});};var shouldShowByGender=this.state.showByGender;var showByGender=function showByGender(){shouldShowByGender=!shouldShowByGender;_this3.setState({showByGender:shouldShowByGender});};var showTable=function showTable(shouldShow){_this3.setState({showTable:shouldShow});};var modalFunctions=function modalFunctions(){var setDateRange=function setDateRange(_ref){var startingYear=_ref.startingYear,endingYear=_ref.endingYear;_this3.setState({startingYear:startingYear,endingYear:endingYear});};var openModal=function openModal(){_this3.setState({showModal:true});};var closeModal=function closeModal(){_this3.setState({showModal:false});};return{setDateRange:setDateRange,openModal:openModal,closeModal:closeModal};};var exportChart=function exportChart(fileType){var chart=chartRef.current.getChart();var fileName=_this3.state.indicatorData.name;var optionsToExport={filename:fileName};if(fileType==='CSV'){var csv=chart.getCSV(false);var hiddenElement=document.createElement('a');hiddenElement.href='data:attachment/text,'+encodeURI(csv);hiddenElement.target='_blank';hiddenElement.download=fileName+'.csv';hiddenElement.click();}else{switch(fileType){case'PNG':optionsToExport.type='image/png';break;case'JPEG':optionsToExport.type='image/jpeg';break;case'PDF':optionsToExport.type='application/pdf';break;case'SVG':optionsToExport.type='image/svg+xml';break;default:optionsToExport.type='image/png';break;}chart.exportChart(optionsToExport);}};var expandChart=function expandChart(){var shouldExpand=!_this3.state.expanded;if(shouldExpand){document.getElementsByTagName('html')[0].classList.add('ork-no-scroll');}else{document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll');}_this3.setState({expanded:shouldExpand});};return{showLegend:showLegend,showByGender:showByGender,showTable:showTable,modalFunctions:modalFunctions,exportChart:exportChart,expandChart:expandChart};}},{key:'renderIfAllOK',value:function renderIfAllOK(){var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null);}else{var _props=this.props,regionsData=_props.regionsData,countriesData=_props.countriesData,referenceRegionsData=_props.referenceRegionsData,sameCountryRegionsData=_props.sameCountryRegionsData,allRegionsGroupRegionId=_props.allRegionsGroupRegionId;var comparative=void 0;if(this.props.otherRegionsFilter!==undefined&&this.props.otherRegionsFilter.length!==0){comparative=this.props.otherRegionsFilter;}else{comparative={};}var generalRegionsData={regionsData:regionsData,countriesData:countriesData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,allRegionsGroupRegionId:allRegionsGroupRegionId};var linesToShow={allRegionsFilter:this.props.allRegionsFilter,referenceRegionsFilter:this.props.referenceRegionsFilter,sameCountryRegionsFilter:this.props.sameCountryRegionsFilter,otherRegionsFilter:comparative};var allowFullscreen=true;if(this.props.embed){allowFullscreen=false;}renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel panel-default '+(this.state.expanded?'panel-expanded':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Content_ContentChart_ContentChartTitle__["a" /* default */],{indicator:this.props.indicator,layer:this.props.layer,chartType:'evolutionAbsolute'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_modules_Charts_DecoupledLines_DecoupledLinesChart__["a" /* default */],{generalRegionsData:JSON.stringify(generalRegionsData),linesToShow:JSON.stringify(linesToShow),indicator:this.props.indicator,data:this.state.data,startingYear:this.state.startingYear,endingYear:this.state.endingYear,selectedRegionId:this.props.selectedRegionId,geoIds:this.props.geoIds,regionsToPlot:this.props.regionsToPlot,indicatorData:this.state.indicatorData,expanded:this.state.expanded,showLegend:this.state.showLegend,showByGender:this.state.showByGender,fn:this.getRef})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Content_ContentChart_ContentChartFooter__["a" /* default */],{fn:this.functionSet(),showLinkToDetail:false,allowFullscreen:allowFullscreen,indicatorData:this.state.indicatorData,expanded:this.state.expanded,chartType:'evolutionAbsolute',showByGender:this.state.showByGender})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_ContentChart_ContentDateModal__["a" /* default */],{show:this.state.showModal,fn:this.functionSet().modalFunctions(),startingYear:this.state.startingYear,endingYear:this.state.endingYear,minYear:this.state.minYear,maxYear:this.state.maxYear,multiple:true}));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderIfAllOK());}}]);return DecoupledLinesChartContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DecoupledLinesChartContainer.defaultProps={startingYear:null,endingYear:null,numberOfYears:DEFAULT_NUMBER_OF_YEARS_TO_SHOW,regionsToPlot:null};/* harmony default export */ __webpack_exports__["a"] = (DecoupledLinesChartContainer);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DecoupledLinesChart__ = __webpack_require__(1156);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DecoupledLinesChart__["a" /* default */]);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DecoupledLinesChartConfig__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LinesChartAdapter__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_dataTools__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Error__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DecoupledLinesChart=function(_Component){_inherits(DecoupledLinesChart,_Component);function DecoupledLinesChart(props){_classCallCheck(this,DecoupledLinesChart);// console.log( props );
var _this=_possibleConstructorReturn(this,(DecoupledLinesChart.__proto__||Object.getPrototypeOf(DecoupledLinesChart)).call(this,props));_initialiseProps.call(_this);var _props$intl=props.intl,formatMessage=_props$intl.formatMessage,formatNumber=_props$intl.formatNumber;_this.formatMessage=formatMessage;_this.formatNumber=formatNumber;__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].importFormatter(formatMessage);_this.state={loading:true,error:false};_this.chartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(DecoupledLinesChart,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.fn(this.chartRef);var generalRegionsData=JSON.parse(this.props.generalRegionsData);var regionsData=generalRegionsData.regionsData,countriesData=generalRegionsData.countriesData,referenceRegionsData=generalRegionsData.referenceRegionsData,sameCountryRegionsData=generalRegionsData.sameCountryRegionsData,comparative=generalRegionsData.comparative,allRegionsGroupRegionId=generalRegionsData.allRegionsGroupRegionId;this.setState({regionsData:regionsData,countriesData:countriesData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,allRegionsGroupRegionId:allRegionsGroupRegionId},function(){return _this2.getLinesChart();});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(this.props.showLegend!==nextProps.showLegend)return false;var shouldUpdate=!__WEBPACK_IMPORTED_MODULE_9_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_9_utils_objects_objectTools__["a" /* default */].compareObjects(this.state,nextState);return shouldUpdate;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(!__WEBPACK_IMPORTED_MODULE_9_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,prevProps)){var generalRegionsData=JSON.parse(this.props.generalRegionsData);var regionsData=generalRegionsData.regionsData,referenceRegionsData=generalRegionsData.referenceRegionsData,sameCountryRegionsData=generalRegionsData.sameCountryRegionsData,comparative=generalRegionsData.comparative,allRegionsGroupRegionId=generalRegionsData.allRegionsGroupRegionId;this.setState({regionsData:regionsData,referenceRegionsData:referenceRegionsData,sameCountryRegionsData:sameCountryRegionsData,comparative:comparative,allRegionsGroupRegionId:allRegionsGroupRegionId,loading:true,error:false},function(){return _this3.getLinesChart();});}}},{key:'_getGeoLocalizedName',value:function _getGeoLocalizedName(geo_id,locale){var names={1:{"es":"País Vasco","en":"Basque Country","eu":"EAE"},411:{"es":"España","en":"Spain","eu":"Espainia"},325:{"es":"Alemania","en":"Germany","eu":"Alemania"},2692:{"es":"UE-27","en":"EU-27","eu":"EB-27"},326:{"es":"Baden-Wurtemberg","en":"Baden-Würtemberg","eu":"Baden-Wurtemberg"},560:{"es":"Alta Austria","en":"Upper Austria","eu":"Austria Garaia"}};return names[geo_id][locale];}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}]);return DecoupledLinesChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.getRegionMeta=function(regionId,geosMeta){var regionMeta=geosMeta.find(function(item){return item.id===regionId;});return regionMeta;};this.getRegionsToPlot=function(geosMeta){var regionDefs=[];if(_this4.props.regionsToPlot){_this4.props.regionsToPlot.forEach(function(region){var regionMeta=_this4.getRegionMeta(region.id,geosMeta);regionDefs.push({regionId:region.id,regionType:"selected",name:regionMeta.name,dashStyle:region.style||"solid"});});}return regionDefs;};this.getLinesChart=function(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:_this4.props.indicator,selectedRegionId:_this4.props.selectedRegionId},indicator=_ref.indicator,selectedRegionId=_ref.selectedRegionId;var regionsData=_this4.state.regionsData;var countriesData=_this4.state.countriesData;var geoMeta=regionsData.concat(countriesData);// // let referenceRegionsData = this.state.referenceRegionsData
// //   let sameCountryRegionsData = this.state.sameCountryRegionsData
// let comparative = this.state.comparative
var allRegionsGroupRegionId=_this4.state.allRegionsGroupRegionId;// const linesToShow = JSON.parse(this.props.linesToShow)
// const { allRegionsFilter, /* referenceRegionsFilter, */ sameCountryRegionsFilter, otherRegionsFilter } = linesToShow
// let comparativeShouldShow = Object.keys(otherRegionsFilter).length !== 0
// const showByGender = this.props.showByGender
// let indicatorFemale = 0
// let indicatorMale = 0
// if (showByGender) {
// 	indicatorFemale = this.props.indicatorData.relationships.sexFemale
// 	indicatorMale = this.props.indicatorData.relationships.sexMale
// }
// dynamic country code: Usar el selectedCountryMeta.id para ID
var selectedRegionData=regionsData.filter(function(item){return item.id===selectedRegionId;})[0];var selectedCountryCode=__WEBPACK_IMPORTED_MODULE_7_utils_regions_regionTools__["a" /* default */].getCountryCodeFromRegionCode(selectedRegionData.code);var selectedCountryMeta=__WEBPACK_IMPORTED_MODULE_7_utils_regions_regionTools__["a" /* default */].countryCodeToMeta(selectedCountryCode);// let selectedCountryName = RegionTools.countryCodeToFullName(selectedCountryCode)
var chartConfig=_this4.selectConfig('selectedRegion').chartConfig;// const promises = []
var regionsToPlot=_this4.getRegionsToPlot(geoMeta);var currentLocale=_this4.props.intl.locale;if(regionsToPlot.length===0){regionsToPlot=[{regionId:selectedRegionId,regionType:"selected",name:_this4._getGeoLocalizedName(1,currentLocale),// "País Vasco",
dashStyle:"solid"},{regionId:selectedCountryMeta.id,// 411
regionType:"country",name:_this4._getGeoLocalizedName(411,currentLocale),//  "España",
dashStyle:"Dash"},{regionId:325,regionType:"country",name:_this4._getGeoLocalizedName(325,currentLocale),//  "Alemania",
dashStyle:"Dash"},{regionId:allRegionsGroupRegionId,// 2692,
regionType:"sup-country",name:_this4._getGeoLocalizedName(2692,currentLocale),//  "UE-27",
dashStyle:"LongDash"},{regionId:326,regionType:"sub-country",name:_this4._getGeoLocalizedName(326,currentLocale),//  "Baden-Wurtemberg",
dashStyle:"solid"},{regionId:560,regionType:"sub-country",name:_this4._getGeoLocalizedName(560,currentLocale),//  "Alta Austria",
dashStyle:"solid"}];}regionsToPlot.forEach(function(lineItem){var geo=lineItem.regionId;lineItem.data=_this4.props.data.filter(function(item){return item.geo===geo;});});var extent=[_this4.props.startingYear,_this4.props.endingYear];var commonTimes=__WEBPACK_IMPORTED_MODULE_6_utils_dataTools__["a" /* default */].intersection(regionsToPlot.filter(function(lineItem){return lineItem.data&&lineItem.data.length>0;}).map(function(lineItem){var uv=__WEBPACK_IMPORTED_MODULE_6_utils_dataTools__["a" /* default */].uniquePropertyValues(lineItem.data,"time_year");return uv;}));var lastCommonYear=Math.max.apply(Math,_toConsumableArray(commonTimes.filter(function(y){return y>=extent[0]&&y<=extent[1];})));// console.log( commonTimes, lastCommonYear );
var series=regionsToPlot.map(function(lineItem,index){var chartColor=__WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__["a" /* default */].getColorByRegionId(lineItem.regionId);var name=lineItem.name;var regionData=lineItem.data;if(regionData&&regionData.length){return __WEBPACK_IMPORTED_MODULE_4__LinesChartAdapter__["a" /* default */].formatLinesSeries({name:name,data:regionData,color:chartColor,extent:extent,lastCommonYear:lastCommonYear,dashedLineStyle:lineItem.dashStyle,formatMessage:_this4.formatMessage});}else{return null;}});var customLinesConfig=__WEBPACK_IMPORTED_MODULE_9_utils_objects_objectTools__["a" /* default */].copyObject(chartConfig);series=series.filter(function(v){return v!==null;});customLinesConfig.series=series;if(_this4.props.expanded){var panelHeight=document.querySelector('.panel-expanded').offsetHeight;var panelHeaderHeight=document.querySelector('.panel-expanded>.panel-heading').offsetHeight;var panelFooterHeight=document.querySelector('.panel-expanded>.panel-footer').offsetHeight;var panelBody=document.querySelector('.panel-expanded>.panel-body');var paddingTop=parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-top'),10);var paddingBottom=parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-bottom'),10);var panelBodyHeight=panelHeight-panelHeaderHeight-panelFooterHeight-paddingTop-paddingBottom;customLinesConfig.chart.height=panelBodyHeight+'px';}var dataSource=_this4.props.indicatorData.dataSource;dataSource=dataSource?dataSource:"Sin definir";customLinesConfig.legend.enabled=_this4.props.showLegend;customLinesConfig.credits.text=dataSource+"<br/>Elaboración Orkestra";// AppTools.getComposedDataSource( dataSource );
customLinesConfig.yAxis.title.text=_this4.props.indicatorData.unit;var formatNumber=_this4.formatNumber;var unit=_this4.props.indicatorData.unit;// console.log(this.props)
customLinesConfig.tooltip.pointFormatter=function(){var tooltip='<span style="color:'+this.color+'">●</span><b>'+this.series.name+'</b>: '+formatNumber(this.y.toFixed(2))+' '+unit;if(this.notes){tooltip+='<br/>'+this.notes;}return tooltip;};_this4.setState({chartConfig:customLinesConfig,loading:false});};this.selectConfig=function(config,index){switch(config){case'selectedRegion':return{chartConfig:__WEBPACK_IMPORTED_MODULE_3__DecoupledLinesChartConfig__["a" /* default */].selectedRegionConfig,chartColor:__WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__["a" /* default */].selectedRegionColor};case'allRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_3__DecoupledLinesChartConfig__["a" /* default */].allRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__["a" /* default */].allRegionsColor};case'referenceRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_3__DecoupledLinesChartConfig__["a" /* default */].referenceRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__["a" /* default */].referenceRegionsColor};case'sameCountryRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_3__DecoupledLinesChartConfig__["a" /* default */].sameCountryRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__["a" /* default */].sameCountryRegionsColor};case'otherRegions':return{chartConfig:__WEBPACK_IMPORTED_MODULE_3__DecoupledLinesChartConfig__["a" /* default */].otherRegionsConfig,chartColor:__WEBPACK_IMPORTED_MODULE_8_utils_colors_colors__["a" /* default */].selectOtherRegionsColor(index)};default:return _this4.selectConfig('allRegions');}};this.renderIfAllOK=function(){var renderingComponent=null;if(_this4.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Error__["a" /* default */],null);}else if(_this4.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Loading__["a" /* default */],null);}else{renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_highcharts___default.a,{ref:_this4.chartRef,config:_this4.state.chartConfig});}return renderingComponent;};};DecoupledLinesChart.defaultProps={regionsToPlat:null,// array of dicts [{id:, style:}],
geoIds:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DecoupledLinesChart));

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__ = __webpack_require__(47);
var generalConfig={chart:{type:'line',style:{fontFamily:'\'Open Sans\', Helvetica, Arial, sans-serif'},marginBottom:60,backgroundColor:'rgba(0,0,0,0)',events:{load:function load(){if(this.renderer.forExport){console.log("exporting");this.yAxis[0].update({labels:{style:{fontSize:'4px'}},title:{style:{fontSize:'4px'}}});this.xAxis[0].update({labels:{style:{fontSize:'4px'},formatter:function formatter(){return this.value.substring(0,2);}}});}}}},credits:{enabled:true,text:'',href:'https://www.orkestra.deusto.es',position:{y:-5},style:{fontSize:'9px'}},exporting:{enabled:true,// url: "http://localhost:7801",
sourceWidth:450,sourceHeight:375,buttons:{contextButton:{enabled:false}},chartOptions:{plotOptions:{}}},title:{text:''},subtitle:{text:''},xAxis:{allowDecimals:false,title:{style:{fontSize:"12px"}},labels:{style:{fontSize:"12px",color:"#000000"}},lineWidth:0.75,lineColor:"#000000",tickLength:0,gridLineColor:"#b3b3b3"},yAxis:{title:{text:'',style:{fontSize:"12px",color:"#000000"}},labels:{style:{fontSize:"12px",color:"#000000"}}},tooltip:{valueSuffix:''},legend:{enabled:true,layout:'horizontal',align:'right',verticalAlign:'top',y:-30,itemStyle:{fontWeight:'normal',fontSize:'12px'},symbolWidth:30},plotOptions:{series:{marker:{enabled:false,symbol:'circle'},label:{enabled:false}}},series:[]};var selectedRegionConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var allRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var referenceRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var sameCountryRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var otherRegionsConfig=__WEBPACK_IMPORTED_MODULE_0_utils_objects_objectTools__["a" /* default */].copyObject(generalConfig);var chartLinesConfig={selectedRegionConfig:selectedRegionConfig,allRegionsConfig:allRegionsConfig,referenceRegionsConfig:referenceRegionsConfig,sameCountryRegionsConfig:sameCountryRegionsConfig,otherRegionsConfig:otherRegionsConfig};/* harmony default export */ __webpack_exports__["a"] = (chartLinesConfig);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__ = __webpack_require__(118);
function getMetaFlag(dp){if(dp.meta&&dp.meta.flag){return dp.meta.flag;}return null;}var formatLinesSeries=function formatLinesSeries(_ref){var data=_ref.data,name=_ref.name,color=_ref.color,extent=_ref.extent,_ref$lastCommonYear=_ref.lastCommonYear,lastCommonYear=_ref$lastCommonYear===undefined?null:_ref$lastCommonYear,_ref$dashedLineStyle=_ref.dashedLineStyle,dashedLineStyle=_ref$dashedLineStyle===undefined?false:_ref$dashedLineStyle,formatMessage=_ref.formatMessage;var values=[];var orderedData=data.sort(function(a,b){return a.time>b.time?1:-1;});orderedData=orderedData.filter(function(item){var dataItemYear=__WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time);return dataItemYear>=extent[0]&&dataItemYear<=extent[1]&&item.value!=null;});orderedData.forEach(function(item,index){var time_year=item.time_year;// DateTools.getYearFromDateString(item.time);
var flag_note=getMetaFlag(item);var markerEnabled=index===0||index===orderedData.length-1||time_year===lastCommonYear;var value={x:__WEBPACK_IMPORTED_MODULE_0_utils_dates_dateTools__["a" /* default */].getYearFromDateString(item.time),y:item.value,marker:{enabled:markerEnabled},notes:flag_note};values.push(value);// add first and last values (and common last value too)
});var markerEnabled=false;if(values.length<2)markerEnabled=true;var dashStyle='Solid';if(dashedLineStyle){dashStyle=dashedLineStyle;}var lineName=name;return{name:lineName,color:__WEBPACK_IMPORTED_MODULE_1_utils_colors_colors__["a" /* default */].colorToRGBA(color),data:values,dashStyle:dashStyle,lineWidth:2,marker:{enabled:markerEnabled,radius:3}};};var linesChartAdapter={formatLinesSeries:formatLinesSeries};/* harmony default export */ __webpack_exports__["a"] = (linesChartAdapter);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorEvolutionEmbedPage__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_0__IndicatorEvolutionEmbedPage__["a" /* default */]));

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Controllers_SelectedRegion_SelectedRegionController__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Content_IndicatorEvolutionContainer__ = __webpack_require__(417);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndicatorEvolutionEmbedPage=function(_React$Component){_inherits(IndicatorEvolutionEmbedPage,_React$Component);function IndicatorEvolutionEmbedPage(){_classCallCheck(this,IndicatorEvolutionEmbedPage);return _possibleConstructorReturn(this,(IndicatorEvolutionEmbedPage.__proto__||Object.getPrototypeOf(IndicatorEvolutionEmbedPage)).apply(this,arguments));}_createClass(IndicatorEvolutionEmbedPage,[{key:'render',// constructor( props ) {
//   super( props );
// }
value:function render(){var searchParams=new URLSearchParams(this.props.location.search);// timeperiod
var timePeriodStart=parseInt(searchParams.get("timeperiod.start"),10);var timePeriodEnd=parseInt(searchParams.get("timeperiod.end"),10);var timePeriodLength=parseInt(searchParams.get("timeperiod.length"),10);// regions
var geoIds=searchParams.getAll("geo.id").map(function(v){return parseInt(v,10);});var geoStyles=searchParams.getAll("geo.style");var regionsToPlot=geoIds.map(function(geoId,i){return{id:geoId,style:geoStyles.at(i)};});console.log(regionsToPlot);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_modules_Controllers_SelectedRegion_SelectedRegionController__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Content_IndicatorEvolutionContainer__["a" /* default */],{embed:true,timePeriodStart:timePeriodStart,timePeriodEnd:timePeriodEnd,timePeriodLength:timePeriodLength,geoIds:geoIds,regionsToPlot:regionsToPlot}));}}]);return IndicatorEvolutionEmbedPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (IndicatorEvolutionEmbedPage);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelsDevelopmentMethodology__ = __webpack_require__(1162);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PanelsDevelopmentMethodology__["a" /* default */]);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_PanelsDevelopmentMethodology__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelsDevelopmentMethodology=function(_Component){_inherits(PanelsDevelopmentMethodology,_Component);function PanelsDevelopmentMethodology(){_classCallCheck(this,PanelsDevelopmentMethodology);return _possibleConstructorReturn(this,(PanelsDevelopmentMethodology.__proto__||Object.getPrototypeOf(PanelsDevelopmentMethodology)).apply(this,arguments));}_createClass(PanelsDevelopmentMethodology,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_PanelsDevelopmentMethodology__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return PanelsDevelopmentMethodology;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PanelsDevelopmentMethodology);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelsDevelopmentMethodology__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
var mapStateToProps=function mapStateToProps(state){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__PanelsDevelopmentMethodology__["a" /* default */])));

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Breadcrumbs__ = __webpack_require__(233);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import APPURL from 'utils/app/urls'
var PanelsDevelopmentMethodology=function(_Component){_inherits(PanelsDevelopmentMethodology,_Component);function PanelsDevelopmentMethodology(props){_classCallCheck(this,PanelsDevelopmentMethodology);var _this=_possibleConstructorReturn(this,(PanelsDevelopmentMethodology.__proto__||Object.getPrototypeOf(PanelsDevelopmentMethodology)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={};return _this;}_createClass(PanelsDevelopmentMethodology,[{key:'render',value:function render(){var BASE_URL= true?"/competitiveness-observatory":'';var imgLink=this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].imgLink);// const path = this.props.history.location.pathname;
// const dimensionLink0 = APPURL.getPanelDimensionLink(path, 0);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Breadcrumbs__["a" /* default */],{responsive:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'ork-u-mb'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].methodology))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid ork-gray-box ork-u-more-legible-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].framework)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].introductionParagraph1)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].introductionParagraph2)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ork-u-mt-3 ork-u-mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:BASE_URL+imgLink,className:'img-responsive',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].level1Paragraph)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].level2Paragraph)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].level3Paragraph)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].level4Paragraph)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dimensionColophonParagraph1)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].geographicalScope))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].geographicalScopeParagraph1)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].geographicalScopeParagraph2)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].temporalScope))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].temporalScopeParagraph)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dataSources))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dataSourcesParagraph)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dataSourcesItem1)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dataSourcesItem2)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dataSourcesItem3)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].dataSourcesItem4)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].temporalSeriesCompletion))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].temporalSeriesCompletionParagraph)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].indicatorCalculation))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].indicatorCalculationParagraph))));}}]);return PanelsDevelopmentMethodology;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(PanelsDevelopmentMethodology));

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({imgLink:{id:'PanelsDevelopmentMethodology.imgLink',description:'Link a la imagen por idiomas',defaultMessage:'/img/ES-Marco-completo-sincabecera.png'},methodology:{id:'PanelsDevelopmentMethodology.methodology',description:'Texto para el título de la página sobre la metodología',defaultMessage:'Metodología'},framework:{id:'PanelsDevelopmentMethodology.framework',description:'Titulo',defaultMessage:'Marco de competitividad de Orkestra'},introductionParagraph1:{id:'PanelsDevelopmentMethodology.introductionParagraph1',description:'Párrafo introductorio 1',defaultMessage:'En Orkestra utilizamos un marco para analizar la competitividad territorial que propone una serie de elementos esenciales a la hora de identificar las claves de la competitividad al servicio del bienestar inclusivo y sostenible.'},introductionParagraph2:{id:'PanelsDevelopmentMethodology.introductionParagraph2',description:'Párrafo introductorio 2',defaultMessage:'Este marco, que presentamos en el <a href="https://www.orkestra.deusto.es/es/investigacion/informe-de-competitividad-del-pais-vasco-2021" class="font-weight-bold" target="_blank">Informe de Competitividad del País Vasco 2021</a>, también nos ayuda a poner en marcha estrategias e iniciativas para el fomento de la competitividad al servicio del bienestar de las personas.'},level1Paragraph:{id:'PanelsDevelopmentMethodology.level1Paragraph',description:'Parrafo sobre el nivel 1',defaultMessage:'En el centro del marco <span class="obs-dimension-0 font-weight-bold">(en azul)</span> encontramos las <a class="font-weight-bold" href="{dimensionLink0}">dimensiones de resultado económico-empresarial</a>, que típicamente forman parte del análisis de la competitividad territorial, y las <a href="{dimensionLink0}" class="font-weight-bold">dimensiones de bienestar</a>, a cuyas necesidades debería responder en última instancia la competitividad territorial.'},level2Paragraph:{id:'PanelsDevelopmentMethodology.level2Paragraph',description:'Parrafo sobre el nivel 2',defaultMessage:'En la parte izquierda <span class="obs-dimension-2 font-weight-bold">(en naranja)</span> se sitúa el <a class="font-weight-bold" href="{dimensionLink02}">contexto estructural</a> del territorio, que incluye características que, en gran medida, vienen dadas y que no son ni buenas ni malas per se. Estos elementos cambian lentamente en el tiempo, pero es posible provocar cambios en algunos de ellos en el medio-largo plazo a través de políticas o estrategias enfocadas en las palancas dinámicas.'},level3Paragraph:{id:'PanelsDevelopmentMethodology.level3Paragraph',description:'Parrafo sobre el nivel 3',defaultMessage:'A la derecha <span class="obs-dimension-3 font-weight-bold">(en verde)</span> están las <a class="font-weight-bold" href="{dimensionLink3}">palancas dinámicas</a> de la competitividad, que incluyen todos los factores que inciden de alguna manera en la competitividad y el bienestar del territorio y sobre las que las políticas y las estrategias (de los actores, los gobiernos y el territorio en sí) pueden incidir para marcar la dirección en que se debe avanzar, así como promover cambios en el medio-largo plazo en ciertos elementos del contexto estructural.'},level4Paragraph:{id:'PanelsDevelopmentMethodology.level4Paragraph',description:'Parrafo sobre el nivel 4',defaultMessage:'Completan el marco dos dimensiones transversales: la <strong>inclusividad</strong>, que se manifiesta de distintas maneras que pueden ser más o menos relevantes según la dimensión analizada (desigualdades de riqueza, género, raza, edad, orientación sexual, discapacidad, etc.), y la <strong>conexión internacional</strong>, que está vinculada tanto a los resultados económico-empresariales como a los análisis de las dimensiones del bienestar y de las palancas.'},dimensionColophonParagraph1:{id:'PanelsDevelopmentMethodology.dimensionColophonParagraph1',description:'Parrafo final sobre dimensiones',defaultMessage:'Partiendo de este marco se selecciona una batería de indicadores relevantes dentro de cada dimensión, que se va contrastando y actualizando continuamente en los diferentes proyectos e informes realizados por Orkestra.'},geographicalScope:{id:'PanelsDevelopmentMethodology.geographicalScope',description:'Titulo alcance geográfico',defaultMessage:'Alcance geográfico'},geographicalScopeParagraph1:{id:'PanelsDevelopmentMethodology.geographicalScopeParagraph1',description:'Parrafo sobre el alcance geográfico 1',defaultMessage:'El Observatorio de Competitividad de Orkestra abarca datos regionales a nivel europeo. La subdivisión en regiones utilizadas se basa en los niveles NUTS (<a href="https://ec.europa.eu/eurostat/web/nuts/background"> Nomenclature des Unités Territoriales Statistiques</a>) definidos por la Unión Europea.'},geographicalScopeParagraph2:{id:'PanelsDevelopmentMethodology.geographicalScopeParagraph2',description:'Parrafo sobre el alcance geográfico 2',defaultMessage:'Puesto que el ámbito geográfico de las subdivisiones NUTS varía de estado miembro a estado miembro, en nuestro análisis utilizamos una	combinación de niveles NUTS2 y NUTS1, eligiendo el nivel que mejor se aproxime a las divisiones administrativas de cada país.'},temporalScope:{id:'PanelsDevelopmentMethodology.temporalScope',description:'Titulo alcance temporal',defaultMessage:'Alcance temporal'},temporalScopeParagraph:{id:'PanelsDevelopmentMethodology.temporalScopeParagraph',description:'Parrafro sobre el alcance temporal',defaultMessage:'Este panel se basa en una plataforma de datos de Orkestra que actualiza continuamente los indicadores en función de su disponibilidad.	Cuando se utilizan datos que requieren un tratamiento mínimo su actualización es automática.En los casos de datos que han de ser tratados	estadísticamente en Orkestra la actualización puede llevar algo más de tiempo. En todo caso, si hay algo que te llama la atención, no dudes en ponerte en <a href="mailto:behatoki@orkerstra.deusto.es">contacto con nosotr@s</a >.'},dataSources:{id:'PanelsDevelopmentMethodology.dataSources',description:'Titulo Fuentes de datos',defaultMessage:'Fuentes de datos'},dataSourcesParagraph:{id:'PanelsDevelopmentMethodology.dataSourcesParagraph',description:'Parrafo sobre fuentes de datos',defaultMessage:'Las fuentes primarias de los datos utilizados para la elaboración de este panel son:'},dataSourcesItem1:{id:'PanelsDevelopmentMethodology.dataSourcesItem1',description:'Primer item de la lista sobre fuentes de datos',defaultMessage:'<a href="https://ec.europa.eu/eurostat" target="_blank">Eurostat</a>, la oficina estadística de la Unión Europea.'},dataSourcesItem2:{id:'PanelsDevelopmentMethodology.dataSourcesItem2',description:'Segundo item de la lista sobre fuentes de datos',defaultMessage:'La base de datos <a href="https://www.oecd-ilibrary.org/science-and-technology/the-oecd-regpat-database_241437144144" target="_blank">REGPAT</a> de la <a href="https://www.oecd.org/" target="_blank">OECD</a> [explotada estadísticamente en Orkestra].'},dataSourcesItem3:{id:'PanelsDevelopmentMethodology.dataSourcesItem3',description:'Tercer item de la lista sobre fuentes de datos',defaultMessage:'La Encuesta Social Europea (<a href="https://www.europeansocialsurvey.org/" target="_blank">European Social Survey</a>) [explotada estadísticamente en	Orkestra].'},dataSourcesItem4:{id:'PanelsDevelopmentMethodology.dataSourcesItem4',description:'Tercer item de la lista sobre fuentes de datos',defaultMessage:'<a href="https://www.eustat.eus" target="_blank">EUSTAT</a> para los datos de la C.A. de Euskadi cuando son metodológicamente comparables a los de Eurostat'},temporalSeriesCompletion:{id:'PanelsDevelopmentMethodology.temporalSeriesCompletion',description:'Titulo completado de series temporales',defaultMessage:'Completado de series temporales'},temporalSeriesCompletionParagraph:{id:'PanelsDevelopmentMethodology.temporalSeriesCompletionParagraph',description:'Parrafo sobre completado de series temporales',defaultMessage:'En la mayor parte de los casos se disponen de datos para todas las regiones europeas consideradas y con marco temporal comparable entre	ellas. En otras ocasiones nuestra plataforma de datos se encarga de estimar valores perdidos de forma que podamos ofrecer las series más	completas posibles. Los métodos de estimación se adecúan a cada indicador y abarcan triangulaciones, interpolaciones lineales, resolución y herencia jerárquicas o repetición de la última observación.'},indicatorCalculation:{id:'PanelsDevelopmentMethodology.indicatorCalculation',description:'Titulo Explotación y cálculo de indicadores',defaultMessage:'Explotación y cálculo de indicadores'},indicatorCalculationParagraph:{id:'PanelsDevelopmentMethodology.indicatorCalculationParagraph',description:'Parrafo sobre la explotación y cálculo de indicadores',defaultMessage:'Además de utilizar datos provenientes directamente de las fuentes utilizadas, en otras ocasiones realizamos cálculos combinando diferentes indicadores para obtener uno nuevo que refleje mejor la realidad que intentamos monitorizar.'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTablePage__ = __webpack_require__(1167);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ReportTablePage__["a" /* default */]);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gtm__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Footer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ReportTableSubheader__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Controllers_SelectedRegion_SelectedRegionController__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Controllers_Survey_SurveyControllerContainer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Controllers_HTMLTitle_HTMLTitleController__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Content_ReportTableContainer__ = __webpack_require__(1171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportTablePage=function(_Component){_inherits(ReportTablePage,_Component);function ReportTablePage(){_classCallCheck(this,ReportTablePage);return _possibleConstructorReturn(this,(ReportTablePage.__proto__||Object.getPrototypeOf(ReportTablePage)).apply(this,arguments));}_createClass(ReportTablePage,[{key:'componentDidMount',value:function componentDidMount(){// let url = this.props.history.location.pathname;
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gtm__["a" /* default */],{gtmId:'GTM-NXH8F9G'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_modules_Controllers_SelectedRegion_SelectedRegionController__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_modules_Controllers_Survey_SurveyControllerContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MenuOffCanvas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ReportTableSubheader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_modules_Content_ReportTableContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Controllers_HTMLTitle_HTMLTitleController__["a" /* default */],null));}}]);return ReportTablePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReportTablePage);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTableSubheader__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{indicatorsData:state.INDICATORS.indicatorsData,lastUpdated:state.INDICATORS.lastUpdated};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__ReportTableSubheader__["a" /* default */])));

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Content_MiniMap__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_dates_dateTools__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_app_urls__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportTableSubheader=function(_React$Component){_inherits(ReportTableSubheader,_React$Component);function ReportTableSubheader(props){_classCallCheck(this,ReportTableSubheader);var _this=_possibleConstructorReturn(this,(ReportTableSubheader.__proto__||Object.getPrototypeOf(ReportTableSubheader)).call(this,props));var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={collapsed:true};return _this;}_createClass(ReportTableSubheader,[{key:'toggleCollapse',value:function toggleCollapse(){this.setState({collapsed:!this.state.collapsed});}},{key:'render',value:function render(){var dimensionLinks={0:"#anchor-dimension-0",1:"#anchor-dimension-1",2:"#anchor-dimension-2",3:"#anchor-dimension-3"};var lastUpdated=__WEBPACK_IMPORTED_MODULE_5_utils_dates_dateTools__["a" /* default */].formatDateForContentHeader(this.props.lastUpdated);var collpaseIconClass="fal "+(this.state.collapsed?"fa-angle-down":"fa-angle-up");var methodologyLink=__WEBPACK_IMPORTED_MODULE_6_utils_app_urls__["a" /* default */].getMethodologyLink(this.props.history.location.pathname);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].ReportTable_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'last-updated',dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].ReportTable_lastUpdated,{lastUpdated:lastUpdated})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].ReportTable_p1,{methodologyLink:methodologyLink})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Content_MiniMap__["a" /* default */],{dimensionLinks:dimensionLinks}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].ReportTable_p2)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small ork-collapsible report-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{onClick:this.toggleCollapse.bind(this)},this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].ReportTable_instructions_title),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:collpaseIconClass})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["c" /* Collapse */],{'in':!this.state.collapsed},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:this.formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].ReportTable_instructions_paragraph)}}))))));}}]);return ReportTableSubheader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(ReportTableSubheader));

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({ReportTable_title:{id:'SubHeader.ReportTable_title',description:'',defaultMessage:'Panel de diagnóstico del Informe de Competitividad del País Vasco'},ReportTable_lastUpdated:{id:'SubHeader.ReportTable_lastUpdated',description:'',defaultMessage:'Actualizado a <strong>{ lastUpdated }</strong>'},ReportTable_p1:{id:'SubHeader.ReportTable_p1',description:'',defaultMessage:'Con el objetivo de proporcionar un <strong>diagnóstico más detallado</strong> para el <strong>País Vasco</strong>, este nuevo panel presenta una serie de indicadores de desempeño económico-empresarial, bienestar y palancas que forman parte del <a href={ methodologyLink }>marco de competitividad Orkestra</a>. Este enfoque amplía la perspectiva de la comparativa regional al incorporar <strong>nuevos indicadores</strong> disponibles únicamente para el País Vasco, así como para los niveles nacional y de la Unión Europea.'},ReportTable_p2:{id:'SubHeader.ReportTable_p2',description:'',defaultMessage:'Puedes moverte entre las dimensiones del marco con el siguiente mini mapa y volver al inicio desde el encabezado de cada dimensión. Al hacer clic en cualquier indicador, se accederá a un gráfico de evolución comparativa que incluye, además del País Vasco y la UE-27, las líneas de tendencia de España, Alemania y las regiones comparables (Alta Austria y Baden-Wurtemberg), siempre que estén disponibles.'},ReportTable_instructions_title:{id:'SubHeader.ReportTable_instructions_title',description:'',defaultMessage:'Cómo leer el panel'},ReportTable_instructions_paragraph:{id:'SubHeader.ReportTable_instructions_paragraph',description:'',defaultMessage:'Se presenta una visi\xF3n m\xE1s sint\xE9tica del nivel y la evoluci\xF3n de los indicadores en comparaci\xF3n con la Uni\xF3n Europea, utilizando un c\xF3digo de colores y s\xEDmbolos de f\xE1cil interpretaci\xF3n. El <span class="positive">color</span> verde indica un resultado positivo, el <span class="negative">color rojo</span> se\xF1ala un resultado negativo y el <span class="stable">color gris</span> representa una diferencia nula o muy peque\xF1a.\n<ul>\n    <li>La primera columna muestra la evoluci\xF3n interanual del Pa\xEDs Vasco; un s\xEDmbolo indica que la diferencia se encuentra entre el 1% y el 5%, mientras que dos s\xEDmbolos indican que la diferencia supera el 5%.</li>\n    <li>La segunda columna compara el valor del Pa\xEDs Vasco con el de la UE-27, empleando un s\xEDmbolo para diferencias entre el 1% y el 5%, y dos s\xEDmbolos para diferencias superiores al 5%.</li>\n    <li>La tercera columna recoge la comparativa de la evoluci\xF3n interanual del indicador para el Pa\xEDs Vasco frente a la evoluci\xF3n de la UE-27. En este caso, un s\xEDmbolo indica que el cambio en el Pa\xEDs Vasco difiere entre 0.5 y 3 puntos porcentuales en relaci\xF3n con el cambio en la UE-27, mientras que dos s\xEDmbolos se\xF1alan que la diferencia es superior a 3 puntos porcentuales.</li>\n    <li>En los tres casos, si la diferencia es inferior a los valores indicados, se indica con un signo de igual.</li>\n    <li>Finalmente, al pasar el cursor por encima de los s\xEDmbolos o hacer click en ellos, se mostrar\xE1n los valores subyacentes asociados a cada uno de ellos.</li>\n</ul>'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTableContainer__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(68);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,lastUpdated:state.INDICATORS.lastUpdated};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setRegionsData:function setRegionsData(regionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setRegionsData(regionsData));},setReferenceRegionsData:function setReferenceRegionsData(referenceRegionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setReferenceRegionsData(referenceRegionsData));},setSameCountryRegionsData:function setSameCountryRegionsData(sameCountryRegionsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSameCountryRegionsData(sameCountryRegionsData));},setIndicatorsData:function setIndicatorsData(indicatorsData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsData(indicatorsData));},setIndicatorsLastUpdated:function setIndicatorsLastUpdated(lastUpdated){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setIndicatorsLastUpdated(lastUpdated));},setCountriesData:function setCountriesData(countriesData){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setCountriesData(countriesData));},setSelectedRegionCountryMeta:function setSelectedRegionCountryMeta(countryMeta){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["a" /* default */].setSelectedRegionCountryMeta(countryMeta));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__ReportTableContainer__["a" /* default */])));

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_regions_regionTools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_Charts_ReportTableRow_ReportTableRowContainer__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__messages__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportTableExcelHelper__ = __webpack_require__(1180);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_PRECISION=1;// decimals to show
var ReportTableContainer=function(_Component){_inherits(ReportTableContainer,_Component);function ReportTableContainer(props){_classCallCheck(this,ReportTableContainer);var _this=_possibleConstructorReturn(this,(ReportTableContainer.__proto__||Object.getPrototypeOf(ReportTableContainer)).call(this,props));_this.composeTableBodySections=function(table){var sections=table["items"];var tbodies=[];var title=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getSectionText("report",[table.title_id],"title");tbodies.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:table.title_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row section',id:"anchor-dimension-"+table.anchor_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12'},title.toUpperCase(),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#anchor-report-table-index'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fal fa-arrow-to-top'}))))));for(var i=0;i<sections.length;i++){tbodies.push(_this.composeTableBodySection(sections[i]));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:table.title_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"row "+table["style"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12'},tbodies)));};_this.composeTableBodySection=function(section){var indicator_defs=section["items"].map(function(e){var decimals=e.length>2?e[2]:DEFAULT_PRECISION;var ignoreColor=section["ignoreColor"]||false;return{"id":e[1],"precision":decimals,"ignoreColor":ignoreColor};});var title=__WEBPACK_IMPORTED_MODULE_5_utils_app_appTools__["a" /* default */].getSectionText("report",[section.title_id],"title");var tbody=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:section.title_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row sub-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12'},title)),_this.composeTableBodyRows(indicator_defs));return tbody;};_this.addDataRow=function(rowId,data){_this.setState(function(prevState){return{reportDataRows:Object.assign({},prevState.reportDataRows,_defineProperty({},rowId,data))};});};_this.composeTableBodyRows=function(indicator_defs){var rows=[];var handleRowUpdate=function handleRowUpdate(rowId,data){// console.log(`Received from row ${rowId}:`, data);
// setMasterData(prev => ([ ...prev, data ]));
_this.addDataRow(rowId,data);};for(var i=0;i<indicator_defs.length;i++){rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_modules_Charts_ReportTableRow_ReportTableRowContainer__["a" /* default */],{key:indicator_defs[i].id,indicator:indicator_defs[i].id,precision:indicator_defs[i].precision,ignoreColor:indicator_defs[i].ignoreColor,sendDataUp:handleRowUpdate}));}return rows;};var formatMessage=props.intl.formatMessage;_this.formatMessage=formatMessage;_this.state={layer:1,loading:true,error:false,reportDataRows:{}};return _this;}_createClass(ReportTableContainer,[{key:'componentDidMount',value:function componentDidMount(){document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll');this.loadData();var url=this.props.history.location.pathname;var layer=__WEBPACK_IMPORTED_MODULE_4_utils_app_urls__["a" /* default */].getLayerFromURL(url);this.setState({layer:layer});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.selectedRegionId!==prevProps.selectedRegionId){this.loadData();}}},{key:'loadData',value:function loadData(){var _this2=this;if(this.props.selectedRegionId===null)return;var p1=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getRegions().then(function(regions){return __WEBPACK_IMPORTED_MODULE_6_utils_regions_regionTools__["a" /* default */].getDataFromRegions(regions);});var p4=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getIndicators().then(function(indicators){return __WEBPACK_IMPORTED_MODULE_7_utils_indicators_indicatorTools__["a" /* default */].getDataFromIndicators(indicators);});var p5=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getIndicatorsStatus().then(function(indicatorsStatus){return indicatorsStatus.last_checked_on;});var p6=__WEBPACK_IMPORTED_MODULE_3_utils_api_api__["a" /* default */].getCountries().then(function(countries){return __WEBPACK_IMPORTED_MODULE_6_utils_regions_regionTools__["a" /* default */].getDataFromCountries(countries);});Promise.all([p1,p4,p5,p6]).then(function(values){_this2.props.setRegionsData(values[0]);if(__WEBPACK_IMPORTED_MODULE_2_utils_config__["a" /* default */].getConfig().app.USE_REFREGIONS){_this2.props.setReferenceRegionsData(values[1]);_this2.props.setIndicatorsData(values[2]);_this2.props.setIndicatorsLastUpdated(values[3]);_this2.props.setCountriesData(values[4]);}else{_this2.props.setIndicatorsData(values[1]);_this2.props.setIndicatorsLastUpdated(values[2]);_this2.props.setCountriesData(values[3]);}var selectedRegionMeta=values[0].filter(function(region){return Number(region.id)===Number(_this2.props.selectedRegionId);})[0];var selectedRegionCountryMeta=__WEBPACK_IMPORTED_MODULE_6_utils_regions_regionTools__["a" /* default */].countryCodeToMeta(__WEBPACK_IMPORTED_MODULE_6_utils_regions_regionTools__["a" /* default */].getCountryCodeFromRegionCode(selectedRegionMeta.code));_this2.props.setSelectedRegionCountryMeta(selectedRegionCountryMeta);}).then(function(){_this2.setState({loading:false,error:false});}).catch(function(reason){_this2.setState({error:true,loading:false});});}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this3=this;var renderingComponent=null;if(this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Error__["a" /* default */],null);}else if(this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null);}else{// let indicators = Config.getProperty("report-table")[0].map(e => e[1]);
// let section = Config.getProperty("report-table")[0]["items"][0];
// let table0 = Config.getProperty("report-table")[0];
// let table1 = Config.getProperty("report-table")[1];
// let table2 = Config.getProperty("report-table")[2];
var reportTableDefinition=__WEBPACK_IMPORTED_MODULE_2_utils_config__["a" /* default */].getProperty("report-table");var dimensionSections=reportTableDefinition.map(function(table){return _this3.composeTableBodySections(table);});var header=[this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnIndicator),"Unidad",this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnYear),this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnValue),this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnEvo),// this.formatMessage(messages.columnEvoLastYear),
// this.formatMessage(messages.columnEU27Header),
this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnYear),this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnLevel),this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnChange)];var lastUpdated=this.props.lastUpdated;var exportExcel=function exportExcel(){Object(__WEBPACK_IMPORTED_MODULE_12__ReportTableExcelHelper__["a" /* exportToExcel */])(_this3.state.reportDataRows,reportTableDefinition,header,lastUpdated);};renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-table',id:'anchor-report-table-index'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row report-table-head visible-lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-7 text-left report-table-head-col'},header[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-2 report-table-head-col'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnYear)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-2 report-table-head-col'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnValue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-2 report-table-head-col'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnEvo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-gray-600'},'(',this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnEvoLastYear),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12 report-table-head-col'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnEU27Header)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 report-table-head-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnYear))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 report-table-head-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnLevel))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 report-table-head-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].columnChange))))))),dimensionSections,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:exportExcel,className:'btn-excel'},'Exportar a Excel')));}return renderingComponent;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid ork-gray-box'},this.renderIfAllOK());}}]);return ReportTableContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ReportTableContainer));

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTableRowContainer__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{selectedRegionId:state.REGIONS.selectedRegionId,selectedRegionCountryMeta:state.REGIONS.selectedRegionCountryMeta,regionsData:state.REGIONS.regionsData,countriesData:state.REGIONS.countriesData,referenceRegionsData:state.REGIONS.referenceRegionsData,sameCountryRegionsData:state.REGIONS.sameCountryRegionsData,allRegionsGroupRegionId:state.REGIONS.allRegionsGroupRegionId,allRegionsFilter:state.FILTERS.allRegionsFilter,referenceRegionsFilter:state.FILTERS.referenceRegionsFilter,sameCountryRegionsFilter:state.FILTERS.sameCountryRegionsFilter,otherRegionsFilter:state.FILTERS.otherRegionsFilter,yearsEvolution:state.FILTERS.evolutionFilter,indicatorsData:state.INDICATORS.indicatorsData};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__ReportTableRowContainer__["a" /* default */])));

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Charts_ReportTableRow_ReportTableRowValues__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_app_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messages__ = __webpack_require__(1178);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportTableRowContainer=function(_Component){_inherits(ReportTableRowContainer,_Component);function ReportTableRowContainer(props){_classCallCheck(this,ReportTableRowContainer);var _this=_possibleConstructorReturn(this,(ReportTableRowContainer.__proto__||Object.getPrototypeOf(ReportTableRowContainer)).call(this,props));_this.getUnit=function(indicatorsData){var indicator_id=_this.props.indicator;var indicatorData=indicatorsData.filter(function(item){return item.id===indicator_id;})[0];var unit=indicatorData?indicatorData.unit:"n.d.";return unit;};var _props$intl=props.intl,formatNumber=_props$intl.formatNumber,formatMessage=_props$intl.formatMessage;_this.formatNumber=formatNumber;_this.formatMessage=formatMessage;_this.state={"lastCommonYear":"","mostRecentYear":""};_this.allRegionsChartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.referenceRegionsChartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.sameCountryRegionsChartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.unit=_this.getUnit(props.indicatorsData);// var updateTime = this.updateTime.bind( this );
return _this;}_createClass(ReportTableRowContainer,[{key:'componentDidMount',value:function componentDidMount(){this.setState({'loading':true});}},{key:'renderValues',value:function renderValues(){var _this2=this;var renderingComponentALL=null;var comparative=null;var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this2.props.indicator;})[0];if(this.props.otherRegionsFilter!==undefined&&this.props.otherRegionsFilter.length!==0){comparative=this.props.otherRegionsFilter[0];}var topLevelRegions={"ctry":this.props.selectedRegionCountryMeta.id,"eu":this.props.allRegionsGroupRegionId};renderingComponentALL=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Charts_ReportTableRow_ReportTableRowValues__["a" /* default */],{key:"values",regionsData:JSON.stringify(this.props.regionsData),indicator:this.props.indicator,indicatorData:indicatorData,precision:this.props.precision,unit:this.unit,selectedRegionId:this.props.selectedRegionId,comparative:comparative,config:'allRegions',topLevelRegions:topLevelRegions,updateTime:this.updateTime.bind(this),sendDataUp:this.props.sendDataUp,ignoreColor:this.props.ignoreColor});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,renderingComponentALL);}},{key:'updateTime',value:function updateTime(lastCommonYear,mostRecentYear){this.setState({"lastCommonYear":lastCommonYear,"mostRecentYear":mostRecentYear});}},{key:'getInfoNote',value:function getInfoNote(notetext,sourcetext){var noteLine=null;var noteIconClass="fal fa-info-circle";if(notetext){noteLine=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'note-warning'},this.formatMessage(__WEBPACK_IMPORTED_MODULE_7__messages__["a" /* default */].dataNote)),': ',notetext)));noteIconClass="fal fa-info-circle note-warning";}var noteTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip',className:'tooltip-note'},noteLine,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.formatMessage(__WEBPACK_IMPORTED_MODULE_7__messages__["a" /* default */].dataSource)),': ',sourcetext)));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:noteTooltip,placement:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#',className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:noteIconClass}))));// info-circle ?
}},{key:'renderIfAllOK',value:function renderIfAllOK(){var _this3=this;var indicatorData=this.props.indicatorsData.filter(function(item){return item.id===_this3.props.indicator;})[0];var indicatorName=__WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorName(indicatorData.name);var indicatorUnit=__WEBPACK_IMPORTED_MODULE_6_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorUnit(indicatorData.unit);var indicatorNote=indicatorData.note;var indicatorSource=indicatorData.dataSource;var actualURL=this.props.history.location.pathname;var indicatorDetailUrl=__WEBPACK_IMPORTED_MODULE_5_utils_app_urls__["a" /* default */].getIndicatorDetailLinkEx({url:actualURL,indicator:indicatorData.id});var infoFragment=this.getInfoNote(indicatorNote,indicatorSource);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row report-table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-indicator-note'},infoFragment),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-indicator-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:indicatorDetailUrl},indicatorName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'report-indicator-unit visible-lg'},'(',indicatorUnit,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'report-indicator-year hidden-lg'},this.state.mostRecentYear))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-5'},this.renderValues()));}},{key:'render',value:function render(){return this.renderIfAllOK();}}]);return ReportTableRowContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ReportTableRowContainer));

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTableRowValues__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
var mapStateToProps=function mapStateToProps(state){return{yearsEvolution:state.FILTERS.evolutionFilter};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__ReportTableRowValues__["a" /* default */]));

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_api_api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_api_urls_v1__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_objects_objectTools__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_dataTools__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__messages__ = __webpack_require__(1177);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createSimpleTooltip(text,tooltip){var noteTooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip',className:'tooltip-note'},tooltip);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:noteTooltip,placement:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#'},text)));}var seriesDateValue=function seriesDateValue(series,time){return __WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].arrayAt(series.filter(function(s){return s&&s["time"]===time;}),0);};var extractYearFromDateStr=function extractYearFromDateStr(date_str){if(date_str){return parseInt(date_str.substring(0,4),10);}else{return null;}};// const lastPeriodString = (times) => {
// 	// times: array of string times
// 	return times.at(-2).substring(0, 4) + "-" + times.at(-1).substring(2, 4);
// }
var prevPeriodString=function prevPeriodString(commonData){// times: array of string times
return commonData.prev["rg"].time.substring(0,4)+"-"+commonData.last["rg"].time.substring(2,4);};var compareValues=function compareValues(v,v_ref,tolerances,useAbsoluteTolerances){// tolerances is a list of thresholds (positive)
// it has to contain at least one value
// the first threshold is for equality (make it zero to force equality)
// tolerances are percentual to ref value if ot useAbolsuteToleraces =true: then tolerances are the absolute values
if(v==null||v_ref==null){return null;}else{var diff=v-v_ref;var abs_diff=Math.abs(diff);// if v_ref == 0 we use the first tolerance step because if not it will tend to infinity
if(v_ref===0){var _l=tolerances.length===1?0:1;return _l*Math.sign(diff);}var l=0;for(;l<tolerances.length;l++){var abs_threshold=Math.abs(v_ref)*tolerances[l];if(useAbsoluteTolerances===true){abs_threshold=tolerances[l];}if(abs_diff<abs_threshold){break;// exit and return current level
}}return l*Math.sign(diff);}};var ReportTableRowValues=function(_Component){_inherits(ReportTableRowValues,_Component);function ReportTableRowValues(props){_classCallCheck(this,ReportTableRowValues);var _this=_possibleConstructorReturn(this,(ReportTableRowValues.__proto__||Object.getPrototypeOf(ReportTableRowValues)).call(this,props));_this.getData=function(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{indicator:_this.props.indicatorData.id,selectedRegionId:_this.props.selectedRegionId,comparative:_this.props.comparative},indicator=_ref.indicator,selectedRegionId=_ref.selectedRegionId,comparative=_ref.comparative;var promises=[];// get time series for all needed regions: reg, country, eu
// maybe get all the series for benchmarkregions plus country and eu and work with all that?
var countryId=_this.props.topLevelRegions["ctry"];var euId=_this.props.topLevelRegions["eu"];var geo=[selectedRegionId,countryId,euId];// const generalPromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorData({ indicator, geo })))
// promises.push(generalPromise);
var regionsData=JSON.parse(_this.props.regionsData);var benchmarkRegionIds=regionsData.map(function(o){return o["id"];});benchmarkRegionIds.forEach(function(geo_id){if(geo_id!==selectedRegionId){geo.push(geo_id);}});// v1 hispeed
var completePromise=Promise.resolve(__WEBPACK_IMPORTED_MODULE_4_utils_api_api__["a" /* default */].getQuery(__WEBPACK_IMPORTED_MODULE_5_utils_api_urls_v1__["a" /* default */].getIndicatorData({indicator:indicator,geo:geo})));var geo_key="geo";// v0 facade
// const completePromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorDataV0Facade({ indicator, geo })));
// const geo_key = "geoset";
promises.push(completePromise);Promise.all(promises).then(function(values){var data=values[0].data.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].ascending(a["time"],b["time"]);});var summary={"last":{},"prev":null,"delta":null,"delta_pc":null,"series":{},"common":null,"short":null};var timeseries={};timeseries["rg"]=data.filter(function(d){return d["value"]!=null&d[geo_key]===selectedRegionId;});timeseries["eu"]=data.filter(function(d){return d["value"]!=null&d[geo_key]===euId;});summary["series"]=timeseries;var timeDelta=1;// available times
var times=[];times["rg"]=__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].uniquePropertyValues(summary["series"]["rg"],"time").sort(__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].ascending);times["eu"]=__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].uniquePropertyValues(summary["series"]["eu"],"time").sort(__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].ascending);summary["times"]=times;// regionTimes
var regionYears=times["rg"].map(function(d){return extractYearFromDateStr(d);});var prevRegionTimeIndex=findPrevDeltaYearIndex(regionYears,timeDelta);// find common years
var commonTimes=__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].intersection(["rg","eu"].map(function(series){return times[series];})).sort(__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].ascending);var commonYears=commonTimes.map(function(d){return extractYearFromDateStr(d);});// console.log( "commonyears", commonYears );
var prevCommonTimeIndex=findPrevDeltaYearIndex(commonYears,timeDelta);// short common times for dsplay purposes: combines available period for region and for eu
var shortTimes=new Set();shortTimes.add(times["rg"].at(-1));// region last year
shortTimes.add(times["rg"].at(prevRegionTimeIndex));// region prev year
// shortTimes.add( DataTools.arrayAt( commonTimes, -1 ) );
// shortTimes.add( DataTools.arrayAt( commonTimes, -2 ) );
shortTimes.add(commonTimes.at(-1));// common last year
shortTimes.add(commonTimes.at(prevCommonTimeIndex));// common prev year
shortTimes=Array.from(shortTimes).sort(__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].ascending);var shortYears=shortTimes.map(function(d){return extractYearFromDateStr(d);});// remove undefined values
shortTimes=shortTimes.filter(function(t){return t;});var prevShortTimeIndex=findPrevDeltaYearIndex(shortYears,timeDelta);// console.log( "shortyears", shortYears );
// console.log( "prevShortTimeIndex", prevShortTimeIndex );
// reduced series for smaller table
var shortSeries={};shortSeries["rg"]=shortTimes.map(function(t){return seriesDateValue(timeseries["rg"],t);});shortSeries["eu"]=shortTimes.map(function(t){return seriesDateValue(timeseries["eu"],t);});summary["short"]={};summary["short"]["times"]=shortTimes;summary["short"]["series"]=shortSeries;// common series for comparison
var commonSeries={};commonSeries["rg"]=commonTimes.map(function(t){return seriesDateValue(timeseries["rg"],t);});commonSeries["eu"]=commonTimes.map(function(t){return seriesDateValue(timeseries["eu"],t);});summary["last"]["rg"]=shortSeries["rg"].at(-1);summary["last"]["eu"]=shortSeries["eu"].at(-1);_this.props.updateTime(summary["last"]["rg"].time_display,__WEBPACK_IMPORTED_MODULE_7_utils_dataTools__["a" /* default */].arrayAt(summary["series"]["rg"],-1).time_display);var deltaValue=function deltaValue(v0,v1){if(v0&&v0["value"]!==null&&v1&&v1["value"]!==null){return v1["value"]-v0["value"];}return null;};var pcDeltaValue=function pcDeltaValue(v0,v1){if(v0&&v0["value"]!==null&&v1&&v1["value"]!==null&&v1["value"]!==0.0){return(v1["value"]-v0["value"])/v0["value"];}return null;};function findPrevDeltaYearIndex(commonYears,yearDelta){var lastYear=commonYears.at(-1);var prevYear=lastYear-yearDelta;// let's find
// for (let i = 0; i < commonYears.length; i++ ) {
// 	if ( commonYears[i] >= prevYear ) {
// 		return i;
// 	}
// }
for(var i=commonYears.length-1;i>=0;i--){if(commonYears[i]<=prevYear){return i;}}// if not found and length > 1 we return the last year
if(commonYears.length>1){return 0;}// else, no comparison
return null;}// console.log( "indicador: " + indicator );
if(times["rg"].length>1){summary["prev"]={};summary["prev"]["rg"]=shortSeries["rg"].at(prevShortTimeIndex);summary["delta"]={};summary["delta"]["rg"]=deltaValue(shortSeries["rg"].at(prevShortTimeIndex),shortSeries["rg"].at(-1));summary["delta_pc"]={};summary["delta_pc"]["rg"]=pcDeltaValue(shortSeries["rg"].at(prevShortTimeIndex),shortSeries["rg"].at(-1));}summary["common"]={};summary["common"]["times"]=commonTimes;summary["common"]["series"]=commonSeries;summary["common"]["last"]={};summary["common"]["last"]["rg"]=commonSeries["rg"].at(-1);summary["common"]["last"]["eu"]=commonSeries["eu"].at(-1);summary["common"]["prev"]={};// summary["common"]["prev"]["rg"] = commonSeries["rg"].at( -2 );
// summary["common"]["prev"]["eu"] = commonSeries["eu"].at( -2 );
summary["common"]["prev"]["rg"]=commonSeries["rg"].at(prevCommonTimeIndex);summary["common"]["prev"]["eu"]=commonSeries["eu"].at(prevCommonTimeIndex);summary["common"]["delta"]={};// summary["common"]["delta"]["rg"] = deltaValue( commonSeries["rg"].at( -2 ), commonSeries["rg"].at( -1 ) );
// summary["common"]["delta"]["eu"] = deltaValue( commonSeries["eu"].at( -2 ), commonSeries["eu"].at( -1 ) );
summary["common"]["delta"]["rg"]=deltaValue(summary["common"]["prev"]["rg"],summary["common"]["last"]["rg"]);summary["common"]["delta"]["eu"]=deltaValue(summary["common"]["prev"]["eu"],summary["common"]["last"]["eu"]);summary["common"]["delta_pc"]={};// summary["common"]["delta_pc"]["rg"] = pcDeltaValue( commonSeries["rg"].at( -2 ), commonSeries["rg"].at( -1 ) );
// summary["common"]["delta_pc"]["eu"] = pcDeltaValue( commonSeries["eu"].at( -2 ), commonSeries["eu"].at( -1 ) );
summary["common"]["delta_pc"]["rg"]=pcDeltaValue(summary["common"]["prev"]["rg"],summary["common"]["last"]["rg"]);summary["common"]["delta_pc"]["eu"]=pcDeltaValue(summary["common"]["prev"]["eu"],summary["common"]["last"]["eu"]);// console.log(summary)
var rowData=_this.prepareRowData(summary);_this.props.sendDataUp(_this.props.indicator,rowData);_this.setState({summary:summary,rowData:rowData,loading:false});}).catch(function(reason){console.log(reason);_this.setState({error:true,loading:false});});};_this.orderingSignedValue=function(v){// console.log(v, this.props.indicatorData);
if(v==null){return null;}else if(_this.props.indicatorData.rankOrdering==="ascending"){return-v;}else{return v;}};_this.renderIfAllOK=function(){var renderingComponent=null;// let unit = this.props.indicatorData.unit;
// const COMPARISON_ARROWS_UD = [ "\u2191", "\u2193", "=" ];
// const COMPARISON_ARROWS_LR = [ "\u2192", "\u2190", "=" ];
// const COMPARISON_PLUSMINUS = [ "+", "-", "=" ];
var COMPARISON_ICONS_ARROWS_UD=["arrow-up","arrow-down","equals"];var COMPARISON_ICONS_ARROWS_LR=["arrow-right","arrow-left","equals"];var COMPARISON_ICONS_PLUSMINUS=["plus","minus","equals"];var getIcon=function getIcon(name,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:"fal fa-"+name}));};var comparisonIcons=function comparisonIcons(count,strings){var icons=[];if(count==null){return _this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].notAvailableShort);}else if(count>0){while(count--){icons.push(getIcon(strings[0],count));}// resultString = strings[0].repeat(count);
}else if(count<0){while(count++){icons.push(getIcon(strings[1],count));}// resultString = strings[1].repeat(-count);
}else{// resultString = strings[2];
icons.push(getIcon(strings[2],count));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,icons);};var ignoreColor=_this.props.ignoreColor;var cellColor=function cellColor(v){if(ignoreColor||v==null){return"";}else if(v>0){return"positive";}else if(v<0){//return <React.Fragment><span>{"\u2193"}</span></React.Fragment>;
return"negative";}else{return"stable";}};var getValueTooltip=function getValueTooltip(summary_data,highlight){var shortData=summary_data["short"];var shortTimes=shortData["times"];var shortSeries=shortData["series"];// add common change values
var commonData=summary_data["common"];var regionPeriodTimes=[];if(summary_data.prev["rg"]){regionPeriodTimes.push(summary_data.prev["rg"].time);}regionPeriodTimes.push(summary_data.last["rg"].time);// selective highlighting
var highlightEvoRg='';var highlightLvlEU='';var highlightEvoEU='';if(highlight!==undefined){if("evo_rg"in highlight){highlightEvoRg=cellColor(highlight["evo_rg"]);}else if("lvl_eu"in highlight){highlightLvlEU=cellColor(highlight["lvl_eu"]);}else if("evo_eu"in highlight){highlightEvoEU=cellColor(highlight["evo_eu"]);}}var timeHeaders=[];var rgValues=[];var euValues=[];var i=0;// use as key for react things
for(;/* let i = 0 */i<shortTimes.length;i++){var t=shortTimes[i];if(t){var v_rg=seriesDateValue(shortSeries["rg"],t);v_rg=v_rg?v_rg["value"]:v_rg;var v_eu=seriesDateValue(shortSeries["eu"],t);v_eu=v_eu?v_eu["value"]:v_eu;var rgClassName='';var euClassName='';// if ( highlightEvoRg && (i >= (shortTimes.length - 2) ) ) {
if(highlightEvoRg&&regionPeriodTimes.includes(shortTimes[i])){rgClassName=highlightEvoRg;}else if(highlightLvlEU&&commonData&&t===commonData.times.at(-1)){rgClassName=highlightLvlEU;euClassName=highlightLvlEU;}timeHeaders.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:i,className:'text-right'},t.substring(0,4)));rgValues.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:rgClassName},_this.formatValueSimple(v_rg)));euValues.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:euClassName},_this.formatValueSimple(v_eu)));}}// and region change values if different any of last two years
var rgTimes=summary_data["times"]["rg"];var rgEvoSingleDisplay=false;if(commonData.times&&commonData.times.length>1){// check if periods are the same
if(extractYearFromDateStr(commonData.times.at(-1))!==extractYearFromDateStr(rgTimes.at(-1))||extractYearFromDateStr(commonData.times.at(-2))!==extractYearFromDateStr(rgTimes.at(-2))){rgEvoSingleDisplay=true;}var _rgClassName=highlightEvoEU;var _euClassName=highlightEvoEU;if(highlightEvoRg&&!rgEvoSingleDisplay){_rgClassName=highlightEvoRg;}rgValues.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:_rgClassName},_this.formatValue(commonData.delta_pc["rg"]*100,1),'%'));euValues.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:_euClassName},_this.formatValue(commonData.delta_pc["eu"]*100,1),'%'));// timeHeaders.push(<th key={i} className=''>{lastPeriodString(commonData.times)}</th>)
timeHeaders.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:i,className:''},prevPeriodString(commonData)));i++;// another key
}else{rgEvoSingleDisplay=true;}if(rgEvoSingleDisplay){rgValues.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:highlightEvoRg},_this.formatValue(summary_data.delta_pc["rg"]*100,1),'%'));euValues.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:''},_this.formatValue(null)));// timeHeaders.push(<th key={i} className={highlightEvoRg}>{lastPeriodString(rgTimes)}</th>);
timeHeaders.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:i,className:highlightEvoRg},prevPeriodString(summary_data)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* Tooltip */],{id:'tooltip',className:'tooltip-values'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'report-table-tooltip-values'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),timeHeaders)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},'regi\xF3n'),rgValues),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},'EU27'),euValues))));};if(_this.state.error){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Error__["a" /* default */],null));}else if(_this.state.loading){renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null));}else{var summary=_this.state.summary;var formattedValue={};Object.keys(summary.last).forEach(function(area){if(summary.last[area]&&summary.last[area].value){formattedValue[area]=_this.formatValueSimple(summary.last[area].value);// tooltip[area] = getValueTooltip( this.state.summary, area );
}else{formattedValue[area]="n/a";// tooltip[area] = <Tooltip id="tooltip"></Tooltip>;
}});// let rgPrevYearDelta = this.state.summary.delta["rg"];
/*
			const commonData = summary.common;
			const last_rg = summary.last["rg"].value;
			const prev_rg = summary.prev["rg"].value;
			const rg_last_time = summary.last["rg"].time;
			let common_last_rg = commonData.last["rg"] ? commonData.last["rg"].value : null;
			let common_last_eu = commonData.last["eu"] ? commonData.last["eu"].value : null;
			let common_pchg_rg = commonData.delta_pc["rg"];
			let common_pchg_eu = commonData.delta_pc["eu"];

			let eu27_last_time = commonData.last["eu"] ? commonData.last["eu"].time : null;
			// let common_period = null;
			if ( eu27_last_time ) {
				// if last EU27 is more than 3 years apart from region data, hide it 
				if ( (extractYearFromDateStr(summary.last["rg"].time) - extractYearFromDateStr(eu27_last_time)) > 3 ) {
					common_last_eu = null;
					common_pchg_eu = null;
					eu27_last_time = null;
				} //else {
					// common_period = lastPeriodString(commonData.times);
				//}
			}

			let tolerances = [ 0.01, 0.05 ];
			// let tolerances25 = [ 0.01, 0.25 ];
			let tolerancesAbs3 = [ 0.005, 0.03 ];

			let comparisonEvoRg = this.orderingSignedValue(compareValues(last_rg, prev_rg, tolerances));
			let comparisonLvlEU = this.orderingSignedValue(compareValues(common_last_rg, common_last_eu, tolerances));
			let comparisonEvoEU = this.orderingSignedValue(compareValues(common_pchg_rg, common_pchg_eu, tolerancesAbs3, true));
			*/var rowData=_this.state.rowData;var indicatorUnit=__WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorUnit(_this.props.indicatorData.unit);renderingComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'0',className:'col-lg-2 visible-lg report-table-cell-value'},rowData["last_rg_year"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'1',className:'hidden-lg col-md-6 col-xs-6 report-table-mini-head'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'2',className:'hidden-lg col-md-2 col-xs-2 report-table-mini-head text-center'},createSimpleTooltip("Evo","Evolución desdel el último año")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'3',className:'hidden-lg col-md-2 col-xs-2 report-table-mini-head text-center'},createSimpleTooltip("EU27 Pos","Posición relativa respecto EU-27")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'4',className:'hidden-lg col-md-2 col-xs-2 report-table-mini-head text-center'},createSimpleTooltip("EU27 Evo","Comparación evolución respecto EU-27")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'5',className:'col-lg-2 col-md-6 col-xs-6 text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:getValueTooltip(summary),placement:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#'},formattedValue["rg"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hidden-lg report-indicator-unit'},' ',indicatorUnit)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'6',className:'col-lg-2 col-md-2 col-xs-2 report-table-cell-icons '+cellColor(rowData["comparisonEvoRg"])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:getValueTooltip(summary,{"evo_rg":rowData["comparisonEvoRg"]}),placement:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#'},comparisonIcons(rowData["comparisonEvoRg"],COMPARISON_ICONS_ARROWS_LR)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'7',className:'col-lg-2 visible-lg report-table-cell-value'},rowData["vs_eu27_year"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'8',className:"col-lg-2 col-md-2 col-xs-2 report-table-cell-icons "+cellColor(rowData["comparisonLvlEU"])},rowData["comparisonLvlEU"]!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:getValueTooltip(summary,{"lvl_eu":rowData["comparisonLvlEU"]}),placement:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#'},comparisonIcons(rowData["comparisonLvlEU"],COMPARISON_ICONS_ARROWS_UD))):_this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].notAvailableShort)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'9',className:"col-lg-2 col-md-2 col-xs-2 report-table-cell-icons "+cellColor(rowData["comparisonEvoEU"])},rowData["comparisonEvoEU"]!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* OverlayTrigger */],{overlay:getValueTooltip(summary,{"evo_eu":rowData["comparisonEvoEU"]}),placement:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'#'},comparisonIcons(rowData["comparisonEvoEU"],COMPARISON_ICONS_PLUSMINUS))):_this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].notAvailableShort)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'10',className:"col-12 hidden-lg"},'\xA0')));}return renderingComponent;};_this.state={loading:true,error:false};var _props$intl=props.intl,formatNumber=_props$intl.formatNumber,formatMessage=_props$intl.formatMessage;_this.formatNumber=formatNumber;_this.formatMessage=formatMessage;return _this;}_createClass(ReportTableRowValues,[{key:'componentDidMount',value:function componentDidMount(){this.getData();// this.getRankingChart();
}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var shouldUpdate=!__WEBPACK_IMPORTED_MODULE_6_utils_objects_objectTools__["a" /* default */].compareObjects(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_6_utils_objects_objectTools__["a" /* default */].compareObjects(this.state,nextState);return shouldUpdate;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(prevProps!==this.props){this.setState({loading:true,error:false,regionsData:JSON.parse(this.props.regionsData)},function(){return _this2.getData();});}}},{key:'prepareRowData',value:function prepareRowData(summary){var _this3=this;var formattedValue={};Object.keys(summary.last).forEach(function(area){if(summary.last[area]&&summary.last[area].value){formattedValue[area]=_this3.formatValueSimple(summary.last[area].value);// tooltip[area] = getValueTooltip( this.state.summary, area );
}else{formattedValue[area]="n/a";// tooltip[area] = <Tooltip id="tooltip"></Tooltip>;
}});// let rgPrevYearDelta = this.state.summary.delta["rg"];
var commonData=summary.common;var last_rg=summary.last["rg"].value;var prev_rg=summary.prev["rg"].value;var rg_last_time=summary.last["rg"].time;var common_last_rg=commonData.last["rg"]?commonData.last["rg"].value:null;var common_last_eu=commonData.last["eu"]?commonData.last["eu"].value:null;var common_pchg_rg=commonData.delta_pc["rg"];var common_pchg_eu=commonData.delta_pc["eu"];var eu27_last_time=commonData.last["eu"]?commonData.last["eu"].time:null;// let common_period = null;
if(eu27_last_time){// if last EU27 is more than 3 years apart from region data, hide it 
if(extractYearFromDateStr(summary.last["rg"].time)-extractYearFromDateStr(eu27_last_time)>3){common_last_eu=null;common_pchg_eu=null;eu27_last_time=null;}}var tolerances=[0.01,0.05];var tolerancesAbs3=[0.005,0.03];var comparisonEvoRg=this.orderingSignedValue(compareValues(last_rg,prev_rg,tolerances));var comparisonLvlEU=this.orderingSignedValue(compareValues(common_last_rg,common_last_eu,tolerances));var comparisonEvoEU=this.orderingSignedValue(compareValues(common_pchg_rg,common_pchg_eu,tolerancesAbs3,true));var indicatorName=__WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorName(this.props.indicatorData.name);var indicatorUnit=__WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].cleanIndicatorUnit(this.props.indicatorData.unit);// prepare data row
var rowData={"name":indicatorName,"unit":indicatorUnit,"last_rg_year":extractYearFromDateStr(rg_last_time),"last_rg_value":last_rg,"comparisonEvoRg":comparisonEvoRg,// "last_rg_evo":		comparisonIcons(comparisonEvoRg, COMPARISON_ARROWS_LR),
"vs_eu27_year":extractYearFromDateStr(eu27_last_time),"vs_eu27_value":null,"comparisonLvlEU":comparisonLvlEU,"comparisonEvoEU":comparisonEvoEU// "vs_eu27_level":	comparisonIcons(comparisonLvlEU, COMPARISON_ARROWS_UD),
// "vs_eu27_evo":		comparisonIcons(comparisonEvoEU, COMPARISON_PLUSMINUS)
};return rowData;}},{key:'formatValue',value:function formatValue(v){var minFractionDigits=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(v==null){return this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].notAvailableShort);}return __WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].formatValue(v,this.props.indicatorData.unit,minFractionDigits);}},{key:'formatValueSimple',value:function formatValueSimple(v){if(v==null){return this.formatMessage(__WEBPACK_IMPORTED_MODULE_11__messages__["a" /* default */].notAvailableShort);}return __WEBPACK_IMPORTED_MODULE_8_utils_indicators_indicatorTools__["a" /* default */].formatValue(v,"",this.props.precision);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderIfAllOK());}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,prevState){if(nextProps!==prevState){return nextProps;}return null;}}]);return ReportTableRowValues;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ReportTableRowValues));

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({notAvailableShort:{id:'ReportTableRowValues.notAvailableShort',description:'Texto para indicar N/D',defaultMessage:'n.d.'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({dataSource:{id:'ReportTable.dataSource',description:'Fuente',defaultMessage:'Fuente'},dataNote:{id:'ReportTable.dataNote',description:'Nota',defaultMessage:'Nota'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(8);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({columnIndicator:{id:'ReportTable.columnIndicator',description:'Cabecera de columna',defaultMessage:'Indicador'},columnYear:{id:'ReportTable.columnYear',description:'Cabecera de columna',defaultMessage:'Año'},columnValue:{id:'ReportTable.columnValue',description:'Cabecera de columna',defaultMessage:'Valor'},columnEvo:{id:'ReportTable.columnEvo',description:'Cabecera de columna',defaultMessage:'Evolución'},columnEvoLastYear:{id:'ReportTable.columnEvoLastYear',description:'Cabecera de columna',defaultMessage:'último año'},columnEU27Header:{id:'ReportTable.columnEU27Header',description:'Cabecera de columna',defaultMessage:'Posicionamiento relativo UE27'},columnLevel:{id:'ReportTable.columnLevel',description:'Cabecera de columna',defaultMessage:'Nivel'},columnChange:{id:'ReportTable.columnChange',description:'Cabecera de columna',defaultMessage:'Cambio'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportToExcel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx_js_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__ = __webpack_require__(25);
var DEFAULT_PRECISION=1;// decimals to show
var headerProperties=["name","unit","last_rg_year","last_rg_value","comparisonEvoRg","vs_eu27_year","comparisonLvlEU","comparisonEvoEU"];var DIMENSION_STYLES={"obs-dimension-0":{color:"0078BB00",fill:"0078BB00"},"obs-dimension-1":{color:"3d9fce",fill:"3d9fce"},"obs-dimension-2":{color:"63bb6b",fill:"63bb6b"},"obs-dimension-3":{color:"fe8511",fill:"fe8511"}};var COMPARISON_ARROWS_UD=['\u2191','\u2193',"="];var COMPARISON_ARROWS_LR=['\u2192','\u2190',"="];var COMPARISON_PLUSMINUS=["+","-","="];var comparisonChars=function comparisonChars(count,strings){var resultString="";if(count==null){return"";}else if(count>0){resultString=strings[0].repeat(count);}else if(count<0){resultString=strings[1].repeat(-count);}else{resultString=strings[2];}return resultString;};var cellStyle=function cellStyle(v,ignoreColor){if(v==null){return{};}else if(ignoreColor){return{font:{bold:true},alignment:{horizontal:'center'}};}else if(v>0){return{font:{bold:true,color:{rgb:"008000"}},fill:{fgColor:{rgb:"CEF8CE"}},alignment:{horizontal:'center'}};}else if(v<0){return{font:{bold:true,color:{rgb:"8B0000"}},fill:{fgColor:{rgb:"F5B9B9"}},alignment:{horizontal:'center'}};}else{return{font:{bold:true,color:{rgb:"000000"}},fill:{fgColor:{rgb:"E0E0E0"}},alignment:{horizontal:'center'}};}};var comparisonCell=function comparisonCell(result,strings,ignoreColor){var v=comparisonChars(result,strings);var s=cellStyle(result,ignoreColor);return{v:v,t:"s",s:s};};var formattedNumberCell=function formattedNumberCell(n,unit){var minFractionDigits=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var z="";if(unit.indexOf('%')>=0){z="0."+"0".repeat(minFractionDigits+1)+"%";n=n/100;}else{z="#,##0"+(minFractionDigits>0?".":"")+"0".repeat(minFractionDigits);}return{v:n,t:"n",z:z};};var exportToExcel=function exportToExcel(data,reportTableDefinition,header,lastUpdated){var fileName=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'CAPVPanelReport.xlsx';var wsMetaData=[[{v:"Panel de diagnóstico del Informe de Competitividad del País Vasco",t:"s",s:{font:{sz:14,bold:true}}}],[{v:"Orkestra - Instituto Vasco de Competitividad",t:"s",s:{font:{sz:11}}}],[],["Fecha de generación",new Date()],["Fecha de actualización",{v:lastUpdated// z: "yyyy-mm-dd hh:mm:ss"
}]];var wsMeta=__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].aoa_to_sheet(wsMetaData);var ws=__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].aoa_to_sheet([[]]);var row=1;var merges=[];var mergedRowLen=headerProperties.length-1;var headerWithStyle=header.map(function(t){return{v:t,t:"s",s:{font:{bold:true}}};});__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].sheet_add_aoa(ws,[["","","","","","Posicionamiento relativo UE27"]],{origin:'A'+row});merges.push({s:{c:0,r:row-1},e:{c:4,r:row-1}});merges.push({s:{c:5,r:row-1},e:{c:mergedRowLen,r:row-1}});row++;__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].sheet_add_aoa(ws,[headerWithStyle],{origin:'A'+row});row++;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=reportTableDefinition[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var table=_step.value;var sections=table["items"];var title=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getSectionText("report",[table.title_id],"title");__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].sheet_add_aoa(ws,[[title.toUpperCase()]],{origin:'A'+row});merges.push({s:{c:0,r:row-1},e:{c:mergedRowLen,r:row-1}});ws['A'+row].s={font:{bold:true,color:{rgb:"FFFFFFFF"}},fill:{fgColor:{rgb:DIMENSION_STYLES[table.style]["fill"]}}};row++;var _loop=function _loop(section){var title=__WEBPACK_IMPORTED_MODULE_1_utils_app_appTools__["a" /* default */].getSectionText("report",[section.title_id],"title");__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].sheet_add_aoa(ws,[[title]],{origin:'A'+row});merges.push({s:{c:0,r:row-1},e:{c:mergedRowLen,r:row-1}});for(var c=0;c<=mergedRowLen;c++){var cellAddress=__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].encode_cell({r:row-1,c:c});if(!ws[cellAddress]){ws[cellAddress]={v:"",t:"s"};}ws[cellAddress].s={font:{bold:true,color:{rgb:DIMENSION_STYLES[table.style]["color"]}},border:{bottom:{style:'thick',color:{rgb:DIMENSION_STYLES[table.style]["color"]}}}};}row++;var indicator_defs=section["items"].map(function(e){var decimals=e.length>2?e[2]:DEFAULT_PRECISION;var ignoreColor=section["ignoreColor"]||false;return{"id":e[1],"precision":decimals,"ignoreColor":ignoreColor};});for(var i=0;i<indicator_defs.length;i++){var dataRow=data[indicator_defs[i].id];var ignoreColor=indicator_defs[i].ignoreColor;var styleRow=[{v:dataRow["name"],t:"s"},{v:dataRow["unit"],t:"s"},{v:dataRow["last_rg_year"],t:"s"},formattedNumberCell(dataRow["last_rg_value"],dataRow["unit"],indicator_defs[i]["precision"]),comparisonCell(dataRow["comparisonEvoRg"],COMPARISON_ARROWS_LR,ignoreColor),{v:dataRow["vs_eu27_year"]||"",t:"s"},comparisonCell(dataRow["comparisonLvlEU"],COMPARISON_ARROWS_UD,ignoreColor),comparisonCell(dataRow["comparisonEvoEU"],COMPARISON_PLUSMINUS,ignoreColor)];__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].sheet_add_aoa(ws,[styleRow],{origin:'A'+row});// XLSX.utils.sheet_add_json(ws, [styleRow], {origin: `A${row}`, header: headerProperties, skipHeader: true});
row++;}};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=sections[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var section=_step2.value;_loop(section);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}ws["!merges"]=merges;ws['!cols']=[{wch:48},{wch:8}];// 2. Crear un libro de trabajo (workbook) vacío
var workbook=__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].book_new();// 3. Añadir la hoja al libro
__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].book_append_sheet(workbook,wsMeta,'META');__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["utils"].book_append_sheet(workbook,ws,'PanelReport');// 4. Generar el archivo y disparar la descarga
__WEBPACK_IMPORTED_MODULE_0_xlsx_js_style__["writeFile"](workbook,fileName);};

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {/* xlsx-js-style 1.2.0-beta @ 2022-04-05T01:40:40.843Z */
var XLSX={};function make_xlsx_lib(a){a.version="0.18.5",a.style_version="1.2.0";var re,f=1200,_=1252;"undefined"!=typeof cptable?re=cptable:"undefined"!=typeof module&&"undefined"!="function"&&(re=__webpack_require__(1186));var t=[874,932,936,949,950,1250,1251,1252,1253,1254,1255,1256,1257,1258,1e4],l={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969},c=function(e){-1!=t.indexOf(e)&&(_=l[0]=e)};var ie=function(e){c(f=e)};function h(){ie(1200),c(1252)}function ae(e){for(var t=[],r=0,a=e.length;r<a;++r)t[r]=e.charCodeAt(r);return t}function s(e){for(var t=[],r=0;r<e.length>>1;++r)t[r]=String.fromCharCode(e.charCodeAt(2*r+1)+(e.charCodeAt(2*r)<<8));return t.join("")}var ne=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1);return 255==t&&254==r?function(e){for(var t=[],r=0;r<e.length>>1;++r)t[r]=String.fromCharCode(e.charCodeAt(2*r)+(e.charCodeAt(2*r+1)<<8));return t.join("")}(e.slice(2)):254==t&&255==r?s(e.slice(2)):65279==t?e.slice(1):e},u=function(e){return String.fromCharCode(e)},n=function(e){return String.fromCharCode(e)};void 0!==re&&(ie=function(e){c(f=e)},ne=function(e){return 255===e.charCodeAt(0)&&254===e.charCodeAt(1)?re.utils.decode(1200,ae(e.slice(2))):e},u=function(e){return 1200===f?String.fromCharCode(e):re.utils.decode(f,[255&e,e>>8])[0]},n=function(e){return re.utils.decode(_,[e])[0]});var oe=null,d=!0,p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function ee(e){for(var t,r,a,n,s,i="",o=0,c=0,l=0;l<e.length;)n=(t=e.charCodeAt(l++))>>2,s=(3&t)<<4|(r=e.charCodeAt(l++))>>4,o=(15&r)<<2|(a=e.charCodeAt(l++))>>6,c=63&a,isNaN(r)?o=c=64:isNaN(a)&&(c=64),i+=p.charAt(n)+p.charAt(s)+p.charAt(o)+p.charAt(c);return i}function te(e){var t,r,a,n,s,i,o="";e=e.replace(/[^\w\+\/\=]/g,"");for(var c=0;c<e.length;)t=p.indexOf(e.charAt(c++))<<2|(n=p.indexOf(e.charAt(c++)))>>4,o+=String.fromCharCode(t),r=(15&n)<<4|(s=p.indexOf(e.charAt(c++)))>>2,64!==s&&(o+=String.fromCharCode(r)),a=(3&s)<<6|(i=p.indexOf(e.charAt(c++))),64!==i&&(o+=String.fromCharCode(a));return o}var se="undefined"!=typeof Buffer&&"undefined"!=typeof process&&void 0!==process.versions&&!!process.versions.node,ce=function(){if("undefined"==typeof Buffer)return function(){};var t=!Buffer.from;if(!t)try{Buffer.from("foo","utf8")}catch(e){t=!0}return t?function(e,t){return t?new Buffer(e,t):new Buffer(e)}:Buffer.from.bind(Buffer)}();function le(e){return se?Buffer.alloc?Buffer.alloc(e):new Buffer(e):new("undefined"!=typeof Uint8Array?Uint8Array:Array)(e)}function fe(e){return se?Buffer.allocUnsafe?Buffer.allocUnsafe(e):new Buffer(e):new("undefined"!=typeof Uint8Array?Uint8Array:Array)(e)}var he=function(e){return se?ce(e,"binary"):e.split("").map(function(e){return 255&e.charCodeAt(0)})};function o(e){if("undefined"==typeof ArrayBuffer)return he(e);for(var t=new ArrayBuffer(e.length),r=new Uint8Array(t),a=0;a!=e.length;++a)r[a]=255&e.charCodeAt(a);return t}function i(e){if(Array.isArray(e))return e.map(function(e){return String.fromCharCode(e)}).join("");for(var t=[],r=0;r<e.length;++r)t[r]=String.fromCharCode(e[r]);return t.join("")}function m(e){if("undefined"==typeof ArrayBuffer)throw new Error("Unsupported");if(e instanceof ArrayBuffer)return m(new Uint8Array(e));for(var t=new Array(e.length),r=0;r<e.length;++r)t[r]=e[r];return t}var ue=se?function(e){return Buffer.concat(e.map(function(e){return Buffer.isBuffer(e)?e:ce(e)}))}:function(e){if("undefined"==typeof Uint8Array)return[].concat.apply([],e.map(function(e){return Array.isArray(e)?e:[].slice.call(e)}));for(var t=0,r=0,t=0;t<e.length;++t)r+=e[t].length;for(var a,n=new Uint8Array(r),r=t=0;t<e.length;r+=a,++t)if(a=e[t].length,e[t]instanceof Uint8Array)n.set(e[t],r);else{if("string"==typeof e[t])throw"wtf";n.set(new Uint8Array(e[t]),r)}return n};var de=/\u0000/g,pe=/[\u0001-\u0006]/g;function v(e){for(var t="",r=e.length-1;0<=r;)t+=e.charAt(r--);return t}function x(e,t){e=""+e;return t<=e.length?e:Ge("0",t-e.length)+e}function w(e,t){e=""+e;return t<=e.length?e:Ge(" ",t-e.length)+e}function T(e,t){e=""+e;return t<=e.length?e:e+Ge(" ",t-e.length)}var g=Math.pow(2,32);function E(e,t){if(g<e||e<-g)return r=e,a=t,r=""+Math.round(r),a<=r.length?r:Ge("0",a-r.length)+r;var r,a,e=Math.round(e);return(t=t)<=(e=""+(e=e)).length?e:Ge("0",t-e.length)+e}function A(e,t){return t=t||0,e.length>=7+t&&103==(32|e.charCodeAt(t))&&101==(32|e.charCodeAt(t+1))&&110==(32|e.charCodeAt(t+2))&&101==(32|e.charCodeAt(t+3))&&114==(32|e.charCodeAt(t+4))&&97==(32|e.charCodeAt(t+5))&&108==(32|e.charCodeAt(t+6))}var C=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]],R=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];var me={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"m/d/yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@",56:'"上午/下午 "hh"時"mm"分"ss"秒 "'},b={5:37,6:38,7:39,8:40,23:0,24:0,25:0,26:0,27:14,28:14,29:14,30:14,31:14,50:14,51:14,52:14,53:14,54:14,55:14,56:14,57:14,58:14,59:1,60:2,61:3,62:4,67:9,68:10,69:12,70:13,71:14,72:14,73:15,74:16,75:17,76:20,77:21,78:22,79:45,80:46,81:47,82:0},k={5:'"$"#,##0_);\\("$"#,##0\\)',63:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',41:'_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'};function y(e,t,r){for(var a=e<0?-1:1,n=e*a,s=0,i=1,o=0,c=1,l=0,f=0,h=Math.floor(n);l<t&&(o=(h=Math.floor(n))*i+s,f=h*l+c,!(n-h<5e-8));)n=1/(n-h),s=i,i=o,c=l,l=f;if(t<f&&(o=t<l?(f=c,s):(f=l,i)),!r)return[0,a*o,f];r=Math.floor(a*o/f);return[r,a*o-r*f,f]}function L(e,t,r){if(2958465<e||e<0)return null;var a=0|e,n=Math.floor(86400*(e-a)),s=0,i=[],e={D:a,T:n,u:86400*(e-a)-n,y:0,m:0,d:0,H:0,M:0,S:0,q:0};return Math.abs(e.u)<1e-6&&(e.u=0),t&&t.date1904&&(a+=1462),.9999<e.u&&(e.u=0,86400==++n&&(e.T=n=0,++a,++e.D)),60===a?(i=r?[1317,10,29]:[1900,2,29],s=3):0===a?(i=r?[1317,8,29]:[1900,1,0],s=6):(60<a&&--a,(t=new Date(1900,0,1)).setDate(t.getDate()+a-1),i=[t.getFullYear(),t.getMonth()+1,t.getDate()],s=t.getDay(),a<60&&(s=(s+6)%7),r&&(s=function(e,t){t[0]-=581;t=e.getDay();e<60&&(t=(t+6)%7);return t}(t,i))),e.y=i[0],e.m=i[1],e.d=i[2],e.S=n%60,n=Math.floor(n/60),e.M=n%60,n=Math.floor(n/60),e.H=n,e.q=s,e}var S=new Date(1899,11,31,0,0,0),O=S.getTime(),I=new Date(1900,2,1,0,0,0);function N(e,t){var r=e.getTime();return t?r-=1262304e5:I<=e&&(r+=864e5),(r-(O+6e4*(e.getTimezoneOffset()-S.getTimezoneOffset())))/864e5}function F(e){return-1==e.indexOf(".")?e:e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/,"$1")}function D(e){var t,r,a,n=Math.floor(Math.log(Math.abs(e))*Math.LOG10E),s=-4<=n&&n<=-1?e.toPrecision(10+n):Math.abs(n)<=9?(r=(t=e)<0?12:11,(a=F(t.toFixed(12))).length<=r||(a=t.toPrecision(10)).length<=r?a:t.toExponential(5)):10===n?e.toFixed(10).substr(0,12):(s=F((e=e).toFixed(11))).length>(e<0?12:11)||"0"===s||"-0"===s?e.toPrecision(6):s;return F(-1==(s=s.toUpperCase()).indexOf("E")?s:s.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2"))}function P(e,t){switch(typeof e){case"string":return e;case"boolean":return e?"TRUE":"FALSE";case"number":return(0|e)===e?e.toString(10):D(e);case"undefined":return"";case"object":if(null==e)return"";if(e instanceof Date)return ve(14,N(e,t&&t.date1904),t)}throw new Error("unsupported value in General format: "+e)}function M(e){if(e.length<=3)return e;for(var t=e.length%3,r=e.substr(0,t);t!=e.length;t+=3)r+=(0<r.length?",":"")+e.substr(t,3);return r}var U=/%/g;var B=/# (\?+)( ?)\/( ?)(\d+)/;var W=/^#*0*\.([0#]+)/,H=/\).*[0#]/,z=/\(###\) ###\\?-####/;function V(e){for(var t,r="",a=0;a!=e.length;++a)switch(t=e.charCodeAt(a)){case 35:break;case 63:r+=" ";break;case 48:r+="0";break;default:r+=String.fromCharCode(t)}return r}function G(e,t){t=Math.pow(10,t);return""+Math.round(e*t)/t}function j(e,t){var r=e-Math.floor(e),e=Math.pow(10,t);return t<(""+Math.round(r*e)).length?0:Math.round(r*e)}function X(e,t,r){if(40===e.charCodeAt(0)&&!t.match(H)){var a=t.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");return 0<=r?X("n",a,r):"("+X("n",a,-r)+")"}if(44===t.charCodeAt(t.length-1))return function(e,t,r){for(var a=t.length-1;44===t.charCodeAt(a-1);)--a;return K(e,t.substr(0,a),r/Math.pow(10,3*(t.length-a)))}(e,t,r);if(-1!==t.indexOf("%"))return o=e,l=r,c=(f=t).replace(U,""),f=f.length-c.length,K(o,c,l*Math.pow(10,2*f))+Ge("%",f);var n;if(-1!==t.indexOf("E"))return function e(t,r){var a,n=t.indexOf("E")-t.indexOf(".")-1;if(t.match(/^#+0.0E\+0$/)){if(0==r)return"0.0E+0";if(r<0)return"-"+e(t,-r);var s=t.indexOf(".");-1===s&&(s=t.indexOf("E"));var i=Math.floor(Math.log(r)*Math.LOG10E)%s;if(i<0&&(i+=s),-1===(a=(r/Math.pow(10,i)).toPrecision(1+n+(s+i)%s)).indexOf("e")){var o=Math.floor(Math.log(r)*Math.LOG10E);for(-1===a.indexOf(".")?a=a.charAt(0)+"."+a.substr(1)+"E+"+(o-a.length+i):a+="E+"+(o-i);"0."===a.substr(0,2);)a=(a=a.charAt(0)+a.substr(2,s)+"."+a.substr(2+s)).replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");a=a.replace(/\+-/,"-")}a=a.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,t,r,a){return t+r+a.substr(0,(s+i)%s)+"."+a.substr(i)+"E"})}else a=r.toExponential(n);return t.match(/E\+00$/)&&a.match(/e[+-]\d$/)&&(a=a.substr(0,a.length-1)+"0"+a.charAt(a.length-1)),(a=t.match(/E\-/)&&a.match(/e\+/)?a.replace(/e\+/,"e"):a).replace("e","E")}(t,r);if(36===t.charCodeAt(0))return"$"+X(e,t.substr(" "==t.charAt(1)?2:1),r);var s,i,o,c,l,f,h,u=Math.abs(r),d=r<0?"-":"";if(t.match(/^00+$/))return d+E(u,t.length);if(t.match(/^[#?]+$/))return(n="0"===(n=E(r,0))?"":n).length>t.length?n:V(t.substr(0,t.length-n.length))+n;if(s=t.match(B))return h=s,o=u,c=d,l=parseInt(h[4],10),f=Math.round(o*l),o=Math.floor(f/l),l,c+(0===o?"":""+o)+" "+(0==(f-=o*l)?Ge(" ",h[1].length+1+h[4].length):w(f,h[1].length)+h[2]+"/"+h[3]+x(l,h[4].length));if(t.match(/^#+0+$/))return d+E(u,t.length-t.indexOf("0"));if(s=t.match(W))return n=G(r,s[1].length).replace(/^([^\.]+)$/,"$1."+V(s[1])).replace(/\.$/,"."+V(s[1])).replace(/\.(\d*)$/,function(e,t){return"."+t+Ge("0",V(s[1]).length-t.length)}),-1!==t.indexOf("0.")?n:n.replace(/^0\./,".");if(t=t.replace(/^#+([0.])/,"$1"),s=t.match(/^(0*)\.(#*)$/))return d+G(u,s[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,s[1].length?"0.":".");if(s=t.match(/^#{1,3},##0(\.?)$/))return d+M(E(u,0));if(s=t.match(/^#,##0\.([#0]*0)$/))return r<0?"-"+X(e,t,-r):M(""+(Math.floor(r)+(h=r,(p=s[1].length)<(""+Math.round((h-Math.floor(h))*Math.pow(10,p))).length?1:0)))+"."+x(j(r,s[1].length),s[1].length);if(s=t.match(/^#,#*,#0/))return X(e,t.replace(/^#,#*,/,""),r);if(s=t.match(/^([0#]+)(\\?-([0#]+))+$/))return n=v(X(e,t.replace(/[\\-]/g,""),r)),i=0,v(v(t.replace(/\\/g,"")).replace(/[0#]/g,function(e){return i<n.length?n.charAt(i++):"0"===e?"0":""}));if(t.match(z))return"("+(n=X(e,"##########",r)).substr(0,3)+") "+n.substr(3,3)+"-"+n.substr(6);var p="";if(s=t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))return i=Math.min(s[4].length,7),m=y(u,Math.pow(10,i)-1,!1),n=d," "==(p=K("n",s[1],m[1])).charAt(p.length-1)&&(p=p.substr(0,p.length-1)+"0"),n+=p+s[2]+"/"+s[3],(p=T(m[2],i)).length<s[4].length&&(p=V(s[4].substr(s[4].length-p.length))+p),n+=p;if(s=t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))return i=Math.min(Math.max(s[1].length,s[4].length),7),d+((m=y(u,Math.pow(10,i)-1,!0))[0]||(m[1]?"":"0"))+" "+(m[1]?w(m[1],i)+s[2]+"/"+s[3]+T(m[2],i):Ge(" ",2*i+1+s[2].length+s[3].length));if(s=t.match(/^[#0?]+$/))return n=E(r,0),t.length<=n.length?n:V(t.substr(0,t.length-n.length))+n;if(s=t.match(/^([#0?]+)\.([#0]+)$/)){n=""+r.toFixed(Math.min(s[2].length,10)).replace(/([^0])0+$/,"$1"),i=n.indexOf(".");var m=t.indexOf(".")-i,g=t.length-n.length-m;return V(t.substr(0,m)+n+t.substr(t.length-g))}if(s=t.match(/^00,000\.([#0]*0)$/))return i=j(r,s[1].length),r<0?"-"+X(e,t,-r):M((g=r)<2147483647&&-2147483648<g?""+(0<=g?0|g:g-1|0):""+Math.floor(g)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?x(0,3-e.length):"")+e})+"."+x(i,s[1].length);switch(t){case"###,##0.00":return X(e,"#,##0.00",r);case"###,###":case"##,###":case"#,###":var b=M(E(u,0));return"0"!==b?d+b:"";case"###,###.00":return X(e,"###,##0.00",r).replace(/^0\./,".");case"#,###.00":return X(e,"#,##0.00",r).replace(/^0\./,".")}throw new Error("unsupported format |"+t+"|")}function Y(e,t,r){if(40===e.charCodeAt(0)&&!t.match(H)){var a=t.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");return 0<=r?Y("n",a,r):"("+Y("n",a,-r)+")"}if(44===t.charCodeAt(t.length-1))return function(e,t,r){for(var a=t.length-1;44===t.charCodeAt(a-1);)--a;return K(e,t.substr(0,a),r/Math.pow(10,3*(t.length-a)))}(e,t,r);if(-1!==t.indexOf("%"))return n=e,i=r,a=(s=t).replace(U,""),s=s.length-a.length,K(n,a,i*Math.pow(10,2*s))+Ge("%",s);var n,s,i,o;if(-1!==t.indexOf("E"))return function e(t,r){var a,n=t.indexOf("E")-t.indexOf(".")-1;if(t.match(/^#+0.0E\+0$/)){if(0==r)return"0.0E+0";if(r<0)return"-"+e(t,-r);var s=t.indexOf(".");-1===s&&(s=t.indexOf("E"));var i,o=Math.floor(Math.log(r)*Math.LOG10E)%s;o<0&&(o+=s),(a=(r/Math.pow(10,o)).toPrecision(1+n+(s+o)%s)).match(/[Ee]/)||(i=Math.floor(Math.log(r)*Math.LOG10E),-1===a.indexOf(".")?a=a.charAt(0)+"."+a.substr(1)+"E+"+(i-a.length+o):a+="E+"+(i-o),a=a.replace(/\+-/,"-")),a=a.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,t,r,a){return t+r+a.substr(0,(s+o)%s)+"."+a.substr(o)+"E"})}else a=r.toExponential(n);return t.match(/E\+00$/)&&a.match(/e[+-]\d$/)&&(a=a.substr(0,a.length-1)+"0"+a.charAt(a.length-1)),(a=t.match(/E\-/)&&a.match(/e\+/)?a.replace(/e\+/,"e"):a).replace("e","E")}(t,r);if(36===t.charCodeAt(0))return"$"+Y(e,t.substr(" "==t.charAt(1)?2:1),r);var c,l,f=Math.abs(r),h=r<0?"-":"";if(t.match(/^00+$/))return h+x(f,t.length);if(t.match(/^[#?]+$/))return(o=0===r?"":""+r).length>t.length?o:V(t.substr(0,t.length-o.length))+o;if(c=t.match(B))return h+(0===(u=f)?"":""+u)+Ge(" ",(u=c)[1].length+2+u[4].length);if(t.match(/^#+0+$/))return h+x(f,t.length-t.indexOf("0"));if(c=t.match(W))return o=(o=(""+r).replace(/^([^\.]+)$/,"$1."+V(c[1])).replace(/\.$/,"."+V(c[1]))).replace(/\.(\d*)$/,function(e,t){return"."+t+Ge("0",V(c[1]).length-t.length)}),-1!==t.indexOf("0.")?o:o.replace(/^0\./,".");if(t=t.replace(/^#+([0.])/,"$1"),c=t.match(/^(0*)\.(#*)$/))return h+(""+f).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,c[1].length?"0.":".");if(c=t.match(/^#{1,3},##0(\.?)$/))return h+M(""+f);if(c=t.match(/^#,##0\.([#0]*0)$/))return r<0?"-"+Y(e,t,-r):M(""+r)+"."+Ge("0",c[1].length);if(c=t.match(/^#,#*,#0/))return Y(e,t.replace(/^#,#*,/,""),r);if(c=t.match(/^([0#]+)(\\?-([0#]+))+$/))return o=v(Y(e,t.replace(/[\\-]/g,""),r)),l=0,v(v(t.replace(/\\/g,"")).replace(/[0#]/g,function(e){return l<o.length?o.charAt(l++):"0"===e?"0":""}));if(t.match(z))return"("+(o=Y(e,"##########",r)).substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);var u="";if(c=t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))return l=Math.min(c[4].length,7),d=y(f,Math.pow(10,l)-1,!1),o=h," "==(u=K("n",c[1],d[1])).charAt(u.length-1)&&(u=u.substr(0,u.length-1)+"0"),o+=u+c[2]+"/"+c[3],(u=T(d[2],l)).length<c[4].length&&(u=V(c[4].substr(c[4].length-u.length))+u),o+=u;if(c=t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))return l=Math.min(Math.max(c[1].length,c[4].length),7),h+((d=y(f,Math.pow(10,l)-1,!0))[0]||(d[1]?"":"0"))+" "+(d[1]?w(d[1],l)+c[2]+"/"+c[3]+T(d[2],l):Ge(" ",2*l+1+c[2].length+c[3].length));if(c=t.match(/^[#0?]+$/))return o=""+r,t.length<=o.length?o:V(t.substr(0,t.length-o.length))+o;if(c=t.match(/^([#0]+)\.([#0]+)$/)){o=""+r.toFixed(Math.min(c[2].length,10)).replace(/([^0])0+$/,"$1"),l=o.indexOf(".");var u=t.indexOf(".")-l,d=t.length-o.length-u;return V(t.substr(0,u)+o+t.substr(t.length-d))}if(c=t.match(/^00,000\.([#0]*0)$/))return r<0?"-"+Y(e,t,-r):M(""+r).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?x(0,3-e.length):"")+e})+"."+x(0,c[1].length);switch(t){case"###,###":case"##,###":case"#,###":var p=M(""+f);return"0"!==p?h+p:"";default:if(t.match(/\.[0#?]*$/))return Y(e,t.slice(0,t.lastIndexOf(".")),r)+V(t.slice(t.lastIndexOf(".")))}throw new Error("unsupported format |"+t+"|")}function K(e,t,r){return((0|r)===r?Y:X)(e,t,r)}var J=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function q(e){for(var t=0,r="",a="";t<e.length;)switch(r=e.charAt(t)){case"G":A(e,t)&&(t+=6),t++;break;case'"':for(;34!==e.charCodeAt(++t)&&t<e.length;);++t;break;case"\\":case"_":t+=2;break;case"@":++t;break;case"B":case"b":if("1"===e.charAt(t+1)||"2"===e.charAt(t+1))return!0;case"M":case"D":case"Y":case"H":case"S":case"E":case"m":case"d":case"y":case"h":case"s":case"e":case"g":return!0;case"A":case"a":case"上":if("A/P"===e.substr(t,3).toUpperCase())return!0;if("AM/PM"===e.substr(t,5).toUpperCase())return!0;if("上午/下午"===e.substr(t,5).toUpperCase())return!0;++t;break;case"[":for(a=r;"]"!==e.charAt(t++)&&t<e.length;)a+=e.charAt(t);if(a.match(J))return!0;break;case".":case"0":case"#":for(;t<e.length&&(-1<"0#?.,E+-%".indexOf(r=e.charAt(++t))||"\\"==r&&"-"==e.charAt(t+1)&&-1<"0#".indexOf(e.charAt(t+2))););break;case"?":for(;e.charAt(++t)===r;);break;case"*":++t," "!=e.charAt(t)&&"*"!=e.charAt(t)||++t;break;case"(":case")":++t;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":for(;t<e.length&&-1<"0123456789".indexOf(e.charAt(++t)););break;case" ":default:++t}return!1}function Z(e,t,r,a){for(var n,s,i,o=[],c="",l=0,f="",h="t",u="H";l<e.length;)switch(f=e.charAt(l)){case"G":if(!A(e,l))throw new Error("unrecognized character "+f+" in "+e);o[o.length]={t:"G",v:"General"},l+=7;break;case'"':for(c="";34!==(i=e.charCodeAt(++l))&&l<e.length;)c+=String.fromCharCode(i);o[o.length]={t:"t",v:c},++l;break;case"\\":var d=e.charAt(++l),p="("===d||")"===d?d:"t";o[o.length]={t:p,v:d},++l;break;case"_":o[o.length]={t:"t",v:" "},l+=2;break;case"@":o[o.length]={t:"T",v:t},++l;break;case"B":case"b":if("1"===e.charAt(l+1)||"2"===e.charAt(l+1)){if(null==n&&null==(n=L(t,r,"2"===e.charAt(l+1))))return"";o[o.length]={t:"X",v:e.substr(l,2)},h=f,l+=2;break}case"M":case"D":case"Y":case"H":case"S":case"E":f=f.toLowerCase();case"m":case"d":case"y":case"h":case"s":case"e":case"g":if(t<0)return"";if(null==n&&null==(n=L(t,r)))return"";for(c=f;++l<e.length&&e.charAt(l).toLowerCase()===f;)c+=f;"h"===(f="m"===f&&"h"===h.toLowerCase()?"M":f)&&(f=u),o[o.length]={t:f,v:c},h=f;break;case"A":case"a":case"上":d={t:f,v:f};if(null==n&&(n=L(t,r)),"A/P"===e.substr(l,3).toUpperCase()?(null!=n&&(d.v=12<=n.H?"P":"A"),d.t="T",u="h",l+=3):"AM/PM"===e.substr(l,5).toUpperCase()?(null!=n&&(d.v=12<=n.H?"PM":"AM"),d.t="T",l+=5,u="h"):"上午/下午"===e.substr(l,5).toUpperCase()?(null!=n&&(d.v=12<=n.H?"下午":"上午"),d.t="T",l+=5,u="h"):(d.t="t",++l),null==n&&"T"===d.t)return"";o[o.length]=d,h=f;break;case"[":for(c=f;"]"!==e.charAt(l++)&&l<e.length;)c+=e.charAt(l);if("]"!==c.slice(-1))throw'unterminated "[" block: |'+c+"|";if(c.match(J)){if(null==n&&null==(n=L(t,r)))return"";o[o.length]={t:"Z",v:c.toLowerCase()},h=c.charAt(1)}else-1<c.indexOf("$")&&(c=(c.match(/\$([^-\[\]]*)/)||[])[1]||"$",q(e)||(o[o.length]={t:"t",v:c}));break;case".":if(null!=n){for(c=f;++l<e.length&&"0"===(f=e.charAt(l));)c+=f;o[o.length]={t:"s",v:c};break}case"0":case"#":for(c=f;++l<e.length&&-1<"0#?.,E+-%".indexOf(f=e.charAt(l));)c+=f;o[o.length]={t:"n",v:c};break;case"?":for(c=f;e.charAt(++l)===f;)c+=f;o[o.length]={t:f,v:c},h=f;break;case"*":++l," "!=e.charAt(l)&&"*"!=e.charAt(l)||++l;break;case"(":case")":o[o.length]={t:1===a?"t":f,v:f},++l;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":for(c=f;l<e.length&&-1<"0123456789".indexOf(e.charAt(++l));)c+=e.charAt(l);o[o.length]={t:"D",v:c};break;case" ":o[o.length]={t:f,v:f},++l;break;case"$":o[o.length]={t:"t",v:"$"},++l;break;default:if(-1===",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f))throw new Error("unrecognized character "+f+" in "+e);o[o.length]={t:"t",v:f},++l}var m,g=0,b=0;for(l=o.length-1,h="t";0<=l;--l)switch(o[l].t){case"h":case"H":o[l].t=u,h="h",g<1&&(g=1);break;case"s":(m=o[l].v.match(/\.0+$/))&&(b=Math.max(b,m[0].length-1)),g<3&&(g=3);case"d":case"y":case"M":case"e":h=o[l].t;break;case"m":"s"===h&&(o[l].t="M",g<2&&(g=2));break;case"X":break;case"Z":(g=(g=g<1&&o[l].v.match(/[Hh]/)?1:g)<2&&o[l].v.match(/[Mm]/)?2:g)<3&&o[l].v.match(/[Ss]/)&&(g=3)}switch(g){case 0:break;case 1:.5<=n.u&&(n.u=0,++n.S),60<=n.S&&(n.S=0,++n.M),60<=n.M&&(n.M=0,++n.H);break;case 2:.5<=n.u&&(n.u=0,++n.S),60<=n.S&&(n.S=0,++n.M)}var v,w="";for(l=0;l<o.length;++l)switch(o[l].t){case"t":case"T":case" ":case"D":break;case"X":o[l].v="",o[l].t=";";break;case"d":case"m":case"y":case"h":case"H":case"M":case"s":case"e":case"b":case"Z":o[l].v=function(e,t,r,a){var n,s="",i=0,o=0,c=r.y,l=0;switch(e){case 98:c=r.y+543;case 121:switch(t.length){case 1:case 2:n=c%100,l=2;break;default:n=c%1e4,l=4}break;case 109:switch(t.length){case 1:case 2:n=r.m,l=t.length;break;case 3:return R[r.m-1][1];case 5:return R[r.m-1][0];default:return R[r.m-1][2]}break;case 100:switch(t.length){case 1:case 2:n=r.d,l=t.length;break;case 3:return C[r.q][0];default:return C[r.q][1]}break;case 104:switch(t.length){case 1:case 2:n=1+(r.H+11)%12,l=t.length;break;default:throw"bad hour format: "+t}break;case 72:switch(t.length){case 1:case 2:n=r.H,l=t.length;break;default:throw"bad hour format: "+t}break;case 77:switch(t.length){case 1:case 2:n=r.M,l=t.length;break;default:throw"bad minute format: "+t}break;case 115:if("s"!=t&&"ss"!=t&&".0"!=t&&".00"!=t&&".000"!=t)throw"bad second format: "+t;return 0!==r.u||"s"!=t&&"ss"!=t?(60*(o=2<=a?3===a?1e3:100:1===a?10:1)<=(i=Math.round(o*(r.S+r.u)))&&(i=0),"s"===t?0===i?"0":""+i/o:(s=x(i,2+a),"ss"===t?s.substr(0,2):"."+s.substr(2,t.length-1))):x(r.S,t.length);case 90:switch(t){case"[h]":case"[hh]":n=24*r.D+r.H;break;case"[m]":case"[mm]":n=60*(24*r.D+r.H)+r.M;break;case"[s]":case"[ss]":n=60*(60*(24*r.D+r.H)+r.M)+Math.round(r.S+r.u);break;default:throw"bad abstime format: "+t}l=3===t.length?1:2;break;case 101:n=c,l=1}return 0<l?x(n,l):""}(o[l].t.charCodeAt(0),o[l].v,n,b),o[l].t="t";break;case"n":case"?":for(v=l+1;null!=o[v]&&("?"===(f=o[v].t)||"D"===f||(" "===f||"t"===f)&&null!=o[v+1]&&("?"===o[v+1].t||"t"===o[v+1].t&&"/"===o[v+1].v)||"("===o[l].t&&(" "===f||"n"===f||")"===f)||"t"===f&&("/"===o[v].v||" "===o[v].v&&null!=o[v+1]&&"?"==o[v+1].t));)o[l].v+=o[v].v,o[v]={v:"",t:";"},++v;w+=o[l].v,l=v-1;break;case"G":o[l].t="t",o[l].v=P(t,r)}var T,E,k="";if(0<w.length){40==w.charCodeAt(0)?(T=t<0&&45===w.charCodeAt(0)?-t:t,E=K("n",w,T)):(E=K("n",w,T=t<0&&1<a?-t:t),T<0&&o[0]&&"t"==o[0].t&&(E=E.substr(1),o[0].v="-"+o[0].v)),v=E.length-1;for(var y=o.length,l=0;l<o.length;++l)if(null!=o[l]&&"t"!=o[l].t&&-1<o[l].v.indexOf(".")){y=l;break}var S=o.length;if(y===o.length&&-1===E.indexOf("E")){for(l=o.length-1;0<=l;--l)null!=o[l]&&-1!=="n?".indexOf(o[l].t)&&(v>=o[l].v.length-1?(v-=o[l].v.length,o[l].v=E.substr(v+1,o[l].v.length)):v<0?o[l].v="":(o[l].v=E.substr(0,v+1),v=-1),o[l].t="t",S=l);0<=v&&S<o.length&&(o[S].v=E.substr(0,v+1)+o[S].v)}else if(y!==o.length&&-1===E.indexOf("E")){for(v=E.indexOf(".")-1,l=y;0<=l;--l)if(null!=o[l]&&-1!=="n?".indexOf(o[l].t)){for(s=-1<o[l].v.indexOf(".")&&l===y?o[l].v.indexOf(".")-1:o[l].v.length-1,k=o[l].v.substr(s+1);0<=s;--s)0<=v&&("0"===o[l].v.charAt(s)||"#"===o[l].v.charAt(s))&&(k=E.charAt(v--)+k);o[l].v=k,o[l].t="t",S=l}for(0<=v&&S<o.length&&(o[S].v=E.substr(0,v+1)+o[S].v),v=E.indexOf(".")+1,l=y;l<o.length;++l)if(null!=o[l]&&(-1!=="n?(".indexOf(o[l].t)||l===y)){for(s=-1<o[l].v.indexOf(".")&&l===y?o[l].v.indexOf(".")+1:0,k=o[l].v.substr(0,s);s<o[l].v.length;++s)v<E.length&&(k+=E.charAt(v++));o[l].v=k,o[l].t="t",S=l}}}for(l=0;l<o.length;++l)null!=o[l]&&-1<"n?".indexOf(o[l].t)&&(T=1<a&&t<0&&0<l&&"-"===o[l-1].v?-t:t,o[l].v=K(o[l].t,o[l].v,T),o[l].t="t");var _="";for(l=0;l!==o.length;++l)null!=o[l]&&(_+=o[l].v);return _}var Q=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function ge(e,t){if(null!=t){var r=parseFloat(t[2]);switch(t[1]){case"=":if(e==r)return 1;break;case">":if(r<e)return 1;break;case"<":if(e<r)return 1;break;case"<>":if(e!=r)return 1;break;case">=":if(r<=e)return 1;break;case"<=":if(e<=r)return 1}}}function be(e,t){var r=function(e){for(var t=[],r=!1,a=0,n=0;a<e.length;++a)switch(e.charCodeAt(a)){case 34:r=!r;break;case 95:case 42:case 92:++a;break;case 59:t[t.length]=e.substr(n,a-n),n=a+1}if(t[t.length]=e.substr(n),!0===r)throw new Error("Format |"+e+"| unterminated string ");return t}(e),a=r.length,n=r[a-1].indexOf("@");if(a<4&&-1<n&&--a,4<r.length)throw new Error("cannot find right format for |"+r.join("|")+"|");if("number"!=typeof t)return[4,4===r.length||-1<n?r[r.length-1]:"@"];switch(r.length){case 1:r=-1<n?["General","General","General",r[0]]:[r[0],r[0],r[0],"@"];break;case 2:r=-1<n?[r[0],r[0],r[0],r[1]]:[r[0],r[1],r[0],"@"];break;case 3:r=-1<n?[r[0],r[1],r[0],r[2]]:[r[0],r[1],r[2],"@"]}var s=0<t?r[0]:t<0?r[1]:r[2];if(-1===r[0].indexOf("[")&&-1===r[1].indexOf("["))return[a,s];if(null==r[0].match(/\[[=<>]/)&&null==r[1].match(/\[[=<>]/))return[a,s];e=r[0].match(Q),s=r[1].match(Q);return ge(t,e)?[a,r[0]]:ge(t,s)?[a,r[1]]:[a,r[null!=e&&null!=s?2:1]]}function ve(e,t,r){null==r&&(r={});var a="";switch(typeof e){case"string":a="m/d/yy"==e&&r.dateNF?r.dateNF:e;break;case"number":null==(a=null==(a=14==e&&r.dateNF?r.dateNF:(null!=r.table?r.table:me)[e])?r.table&&r.table[b[e]]||me[b[e]]:a)&&(a=k[e]||"General")}if(A(a,0))return P(t,r);var n=be(a,t=t instanceof Date?N(t,r.date1904):t);if(A(n[1]))return P(t,r);if(!0===t)t="TRUE";else if(!1===t)t="FALSE";else if(""===t||null==t)return"";return Z(n[1],t,r,n[0])}function we(e,t){if("number"!=typeof t){t=+t||-1;for(var r=0;r<392;++r)if(null!=me[r]){if(me[r]==e){t=r;break}}else t<0&&(t=r);t<0&&(t=391)}return me[t]=e,t}function Te(e){for(var t=0;392!=t;++t)void 0!==e[t]&&we(e[t],t)}function Ee(){var e;(e=e||{})[0]="General",e[1]="0",e[2]="0.00",e[3]="#,##0",e[4]="#,##0.00",e[9]="0%",e[10]="0.00%",e[11]="0.00E+00",e[12]="# ?/?",e[13]="# ??/??",e[14]="m/d/yy",e[15]="d-mmm-yy",e[16]="d-mmm",e[17]="mmm-yy",e[18]="h:mm AM/PM",e[19]="h:mm:ss AM/PM",e[20]="h:mm",e[21]="h:mm:ss",e[22]="m/d/yy h:mm",e[37]="#,##0 ;(#,##0)",e[38]="#,##0 ;[Red](#,##0)",e[39]="#,##0.00;(#,##0.00)",e[40]="#,##0.00;[Red](#,##0.00)",e[45]="mm:ss",e[46]="[h]:mm:ss",e[47]="mmss.0",e[48]="##0.0E+0",e[49]="@",e[56]='"上午/下午 "hh"時"mm"分"ss"秒 "',me=e}var e={format:ve,load:we,_table:me,load_table:Te,parse_date_code:L,is_date:q,get_table:function(){return e._table=me}},ke={5:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',23:"General",24:"General",25:"General",26:"General",27:"m/d/yy",28:"m/d/yy",29:"m/d/yy",30:"m/d/yy",31:"m/d/yy",32:"h:mm:ss",33:"h:mm:ss",34:"h:mm:ss",35:"h:mm:ss",36:"m/d/yy",41:'_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',50:"m/d/yy",51:"m/d/yy",52:"m/d/yy",53:"m/d/yy",54:"m/d/yy",55:"m/d/yy",56:"m/d/yy",57:"m/d/yy",58:"m/d/yy",59:"0",60:"0.00",61:"#,##0",62:"#,##0.00",63:'"$"#,##0_);\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',67:"0%",68:"0.00%",69:"# ?/?",70:"# ??/??",71:"m/d/yy",72:"m/d/yy",73:"d-mmm-yy",74:"d-mmm",75:"mmm-yy",76:"h:mm",77:"h:mm:ss",78:"m/d/yy h:mm",79:"mm:ss",80:"[h]:mm:ss",81:"mmss.0"},ye=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;var Se,_e=function(){var e={};e.version="1.2.0";var o=function(){for(var e=0,t=new Array(256),r=0;256!=r;++r)e=1&(e=1&(e=1&(e=1&(e=1&(e=1&(e=1&(e=1&(e=r)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1,t[r]=e;return"undefined"!=typeof Int32Array?new Int32Array(t):t}();var t=function(e){for(var t=0,r=0,a=0,n=new("undefined"!=typeof Int32Array?Int32Array:Array)(4096),a=0;256!=a;++a)n[a]=e[a];for(a=0;256!=a;++a)for(r=e[a],t=256+a;t<4096;t+=256)r=n[t]=r>>>8^e[255&r];var s=[];for(a=1;16!=a;++a)s[a-1]="undefined"!=typeof Int32Array?n.subarray(256*a,256*a+256):n.slice(256*a,256*a+256);return s}(o),s=t[0],i=t[1],c=t[2],l=t[3],f=t[4],h=t[5],u=t[6],d=t[7],p=t[8],m=t[9],g=t[10],b=t[11],v=t[12],w=t[13],T=t[14];return e.table=o,e.bstr=function(e,t){for(var r=-1^t,a=0,n=e.length;a<n;)r=r>>>8^o[255&(r^e.charCodeAt(a++))];return~r},e.buf=function(e,t){for(var r=-1^t,a=e.length-15,n=0;n<a;)r=T[e[n++]^255&r]^w[e[n++]^r>>8&255]^v[e[n++]^r>>16&255]^b[e[n++]^r>>>24]^g[e[n++]]^m[e[n++]]^p[e[n++]]^d[e[n++]]^u[e[n++]]^h[e[n++]]^f[e[n++]]^l[e[n++]]^c[e[n++]]^i[e[n++]]^s[e[n++]]^o[e[n++]];for(a+=15;n<a;)r=r>>>8^o[255&(r^e[n++])];return~r},e.str=function(e,t){for(var r,a=-1^t,n=0,s=e.length,i=0;n<s;)a=(i=e.charCodeAt(n++))<128?a>>>8^o[255&(a^i)]:i<2048?(a=a>>>8^o[255&(a^(192|i>>6&31))])>>>8^o[255&(a^(128|63&i))]:55296<=i&&i<57344?(i=64+(1023&i),r=1023&e.charCodeAt(n++),(a=(a=(a=a>>>8^o[255&(a^(240|i>>8&7))])>>>8^o[255&(a^(128|i>>2&63))])>>>8^o[255&(a^(128|r>>6&15|(3&i)<<4))])>>>8^o[255&(a^(128|63&r))]):(a=(a=a>>>8^o[255&(a^(224|i>>12&15))])>>>8^o[255&(a^(128|i>>6&63))])>>>8^o[255&(a^(128|63&i))];return~a},e}(),xe=function(){var s,e={};function d(e){if("/"==e.charAt(e.length-1))return-1===e.slice(0,-1).indexOf("/")?e:d(e.slice(0,-1));var t=e.lastIndexOf("/");return-1===t?e:e.slice(0,t+1)}function p(e){if("/"==e.charAt(e.length-1))return p(e.slice(0,-1));var t=e.lastIndexOf("/");return-1===t?e:e.slice(t+1)}function g(e){Dr(e,0);for(var t,r={};e.l<=e.length-4;){var a=e.read_shift(2),n=e.read_shift(2),s=e.l+n,i={};21589===a&&(1&(t=e.read_shift(1))&&(i.mtime=e.read_shift(4)),5<n&&(2&t&&(i.atime=e.read_shift(4)),4&t&&(i.ctime=e.read_shift(4))),i.mtime&&(i.mt=new Date(1e3*i.mtime))),e.l=s,r[a]=i}return r}function i(){return s=s||__webpack_require__(419)}function o(e,t){if(80==e[0]&&75==e[1])return q(e,t);if(109==(32|e[0])&&105==(32|e[1]))return function(e,t){if("mime-version:"!=_(e.slice(0,13)).toLowerCase())throw new Error("Unsupported MAD header");var r=t&&t.root||"",a=(se&&Buffer.isBuffer(e)?e.toString("binary"):_(e)).split("\r\n"),n=0,s="";for(n=0;n<a.length;++n)if(s=a[n],/^Content-Location:/i.test(s)&&(s=s.slice(s.indexOf("file")),r=r||s.slice(0,s.lastIndexOf("/")+1),s.slice(0,r.length)!=r))for(;0<r.length&&(r=(r=r.slice(0,r.length-1)).slice(0,r.lastIndexOf("/")+1),s.slice(0,r.length)!=r););e=(a[1]||"").match(/boundary="(.*?)"/);if(!e)throw new Error("MAD cannot find boundary");var i="--"+(e[1]||""),o={FileIndex:[],FullPaths:[]};w(o);var c,l=0;for(n=0;n<a.length;++n){var f=a[n];f!==i&&f!==i+"--"||(l++&&function(e,t,r){for(var a,n="",s="",i="",o=0;o<10;++o){var c=t[o];if(!c||c.match(/^\s*$/))break;var l=c.match(/^(.*?):\s*([^\s].*)$/);if(l)switch(l[1].toLowerCase()){case"content-location":n=l[2].trim();break;case"content-type":i=l[2].trim();break;case"content-transfer-encoding":s=l[2].trim()}}switch(++o,s.toLowerCase()){case"base64":a=he(te(t.slice(o).join("")));break;case"quoted-printable":a=function(e){for(var t=[],r=0;r<e.length;++r){for(var a=e[r];r<=e.length&&"="==a.charAt(a.length-1);)a=a.slice(0,a.length-1)+e[++r];t.push(a)}for(var n=0;n<t.length;++n)t[n]=t[n].replace(/[=][0-9A-Fa-f]{2}/g,function(e){return String.fromCharCode(parseInt(e.slice(1),16))});return he(t.join("\r\n"))}(t.slice(o));break;default:throw new Error("Unsupported Content-Transfer-Encoding "+s)}r=Q(e,n.slice(r.length),a,{unsafe:!0}),i&&(r.ctype=i)}(o,a.slice(c,n),r),c=n)}return o}(e,t);if(e.length<512)throw new Error("CFB file size "+e.length+" < 512");var r,m,a,n=3,s=512,i=0,o=[],c=e.slice(0,512);Dr(c,0);var l=function(e){if(80==e[e.l]&&75==e[e.l+1])return[0,0];e.chk(y,"Header Signature: "),e.l+=16;var t=e.read_shift(2,"u");return[e.read_shift(2,"u"),t]}(c);switch(n=l[0]){case 3:s=512;break;case 4:s=4096;break;case 0:if(0==l[1])return q(e,t);default:throw new Error("Major Version: Expected 3 or 4 saw "+n)}512!==s&&Dr(c=e.slice(0,s),28);var f=e.slice(0,s);!function(e,t){var r=9;switch(e.l+=2,r=e.read_shift(2)){case 9:if(3!=t)throw new Error("Sector Shift: Expected 9 saw "+r);break;case 12:if(4!=t)throw new Error("Sector Shift: Expected 12 saw "+r);break;default:throw new Error("Sector Shift: Expected 9 or 12 saw "+r)}e.chk("0600","Mini Sector Shift: "),e.chk("000000000000","Reserved: ")}(c,n);var h=c.read_shift(4,"i");if(3===n&&0!==h)throw new Error("# Directory Sectors: Expected 0 saw "+h);c.l+=4,m=c.read_shift(4,"i"),c.l+=4,c.chk("00100000","Mini Stream Cutoff Size: "),a=c.read_shift(4,"i"),r=c.read_shift(4,"i"),b=c.read_shift(4,"i"),i=c.read_shift(4,"i");for(var u,d=0;d<109&&!((u=c.read_shift(4,"i"))<0);++d)o[d]=u;var p=function(e,t){for(var r=Math.ceil(e.length/t)-1,a=[],n=1;n<r;++n)a[n-1]=e.slice(n*t,(n+1)*t);return a[r-1]=e.slice(r*t),a}(e,s);!function e(t,r,a,n,s){var i=k;if(t===k){if(0!==r)throw new Error("DIFAT chain shorter than expected")}else if(-1!==t){var o=a[t],c=(n>>>2)-1;if(o){for(var l=0;l<c&&(i=xr(o,4*l))!==k;++l)s.push(i);e(xr(o,n-4),r-1,a,n,s)}}}(b,i,p,s,o);var g=function(e,t,r,a){var n=e.length,s=[],i=[],o=[],c=[],l=a-1,f=0,h=0,u=0,d=0;for(f=0;f<n;++f)if(o=[],n<=(u=f+t)&&(u-=n),!i[u]){c=[];var p=[];for(h=u;0<=h;){p[h]=!0,i[h]=!0,o[o.length]=h,c.push(e[h]);var m=r[Math.floor(4*h/a)];if(a<4+(d=4*h&l))throw new Error("FAT boundary crossed: "+h+" 4 "+a);if(!e[m])break;if(h=xr(e[m],d),p[h])break}s[u]={nodes:o,data:hr([c])}}return s}(p,m,o,s);g[m].name="!Directory",0<r&&a!==k&&(g[a].name="!MiniFAT"),g[o[0]].name="!FAT",g.fat_addrs=o,g.ssz=s;var h=[],b=[],i=[];!function(e,t,r,a,n,s,i){for(var o,c=0,l=r.length?2:0,f=e[m].data,h=0,u=0;h<f.length;h+=128){var d=f.slice(h,h+128);Dr(d,64),u=d.read_shift(2),o=ur(d,0,u-l),r.push(o);var p={name:o,type:d.read_shift(1),color:d.read_shift(1),L:d.read_shift(4,"i"),R:d.read_shift(4,"i"),C:d.read_shift(4,"i"),clsid:d.read_shift(16),state:d.read_shift(4,"i"),start:0,size:0};0!==d.read_shift(2)+d.read_shift(2)+d.read_shift(2)+d.read_shift(2)&&(p.ct=v(d,d.l-8)),0!==d.read_shift(2)+d.read_shift(2)+d.read_shift(2)+d.read_shift(2)&&(p.mt=v(d,d.l-8)),p.start=d.read_shift(4,"i"),p.size=d.read_shift(4,"i"),p.size<0&&p.start<0&&(p.size=p.type=0,p.start=k,p.name=""),5===p.type?(c=p.start,0<a&&c!==k&&(e[c].name="!StreamData")):4096<=p.size?(p.storage="fat",void 0===e[p.start]&&(e[p.start]=function(e,t,r,a,n){var s=[],i=[];n=n||[];var o=a-1,c=0,l=0;for(c=t;0<=c;){n[c]=!0,s[s.length]=c,i.push(e[c]);var f=r[Math.floor(4*c/a)];if(a<4+(l=4*c&o))throw new Error("FAT boundary crossed: "+c+" 4 "+a);if(!e[f])break;c=xr(e[f],l)}return{nodes:s,data:hr([i])}}(t,p.start,e.fat_addrs,e.ssz)),e[p.start].name=p.name,p.content=e[p.start].data.slice(0,p.size)):(p.storage="minifat",p.size<0?p.size=0:c!==k&&p.start!==k&&e[c]&&(p.content=function(e,t,r){var a=e.start,n=e.size,s=[],i=a;for(;r&&0<n&&0<=i;)s.push(t.slice(i*E,i*E+E)),n-=E,i=xr(r,4*i);return 0===s.length?Lr(0):ue(s).slice(0,e.size)}(p,e[c].data,(e[i]||{}).data))),p.content&&Dr(p.content,0),n[o]=p,s.push(p)}}(g,p,h,r,{},b,a),function(e,t,r){for(var a=0,n=0,s=0,i=0,o=0,c=r.length,l=[],f=[];a<c;++a)l[a]=f[a]=a,t[a]=r[a];for(;o<f.length;++o)a=f[o],n=e[a].L,s=e[a].R,i=e[a].C,l[a]===a&&(-1!==n&&l[n]!==n&&(l[a]=l[n]),-1!==s&&l[s]!==s&&(l[a]=l[s])),-1!==i&&(l[i]=a),-1!==n&&a!=l[a]&&(l[n]=l[a],f.lastIndexOf(n)<o&&f.push(n)),-1!==s&&a!=l[a]&&(l[s]=l[a],f.lastIndexOf(s)<o&&f.push(s));for(a=1;a<c;++a)l[a]===a&&(-1!==s&&l[s]!==s?l[a]=l[s]:-1!==n&&l[n]!==n&&(l[a]=l[n]));for(a=1;a<c;++a)if(0!==e[a].type){if((o=a)!=l[o])for(;o=l[o],t[a]=t[o]+"/"+t[a],0!==o&&-1!==l[o]&&o!=l[o];);l[a]=-1}for(t[0]+="/",a=1;a<c;++a)2!==e[a].type&&(t[a]+="/")}(b,i,h),h.shift();i={FileIndex:b,FullPaths:i};return t&&t.raw&&(i.raw={header:f,sectors:p}),i}function v(e,t){return new Date(1e3*(_r(e,t+4)/1e7*Math.pow(2,32)+_r(e,t)/1e7-11644473600))}function w(e,t){var r=t||{},t=r.root||"Root Entry";if(e.FullPaths||(e.FullPaths=[]),e.FileIndex||(e.FileIndex=[]),e.FullPaths.length!==e.FileIndex.length)throw new Error("inconsistent CFB structure");0===e.FullPaths.length&&(e.FullPaths[0]=t+"/",e.FileIndex[0]={name:t,type:5}),r.CLSID&&(e.FileIndex[0].clsid=r.CLSID),t=e,r="Sh33tJ5",xe.find(t,"/"+r)||((e=Lr(4))[0]=55,e[1]=e[3]=50,e[2]=54,t.FileIndex.push({name:r,type:2,content:e,size:4,L:69,R:69,C:69}),t.FullPaths.push(t.FullPaths[0]+r),u(t))}function u(e,t){w(e);for(var r=!1,a=!1,n=e.FullPaths.length-1;0<=n;--n){var s=e.FileIndex[n];switch(s.type){case 0:a?r=!0:(e.FileIndex.pop(),e.FullPaths.pop());break;case 1:case 2:case 5:a=!0,isNaN(s.R*s.L*s.C)&&(r=!0),-1<s.R&&-1<s.L&&s.R==s.L&&(r=!0);break;default:r=!0}}if(r||t){for(var i=new Date(1987,1,19),o=0,c=Object.create?Object.create(null):{},l=[],n=0;n<e.FullPaths.length;++n)c[e.FullPaths[n]]=!0,0!==e.FileIndex[n].type&&l.push([e.FullPaths[n],e.FileIndex[n]]);for(n=0;n<l.length;++n){var f=d(l[n][0]);(a=c[f])||(l.push([f,{name:p(f).replace("/",""),type:1,clsid:b,ct:i,mt:i,content:null}]),c[f]=!0)}for(l.sort(function(e,t){return function(e,t){for(var r,a=e.split("/"),n=t.split("/"),s=0,i=Math.min(a.length,n.length);s<i;++s){if(r=a[s].length-n[s].length)return r;if(a[s]!=n[s])return a[s]<n[s]?-1:1}return a.length-n.length}(e[0],t[0])}),e.FullPaths=[],e.FileIndex=[],n=0;n<l.length;++n)e.FullPaths[n]=l[n][0],e.FileIndex[n]=l[n][1];for(n=0;n<l.length;++n){var h=e.FileIndex[n],u=e.FullPaths[n];if(h.name=p(u).replace("/",""),h.L=h.R=h.C=-(h.color=1),h.size=h.content?h.content.length:0,h.start=0,h.clsid=h.clsid||b,0===n)h.C=1<l.length?1:-1,h.size=0,h.type=5;else if("/"==u.slice(-1)){for(o=n+1;o<l.length&&d(e.FullPaths[o])!=u;++o);for(h.C=o>=l.length?-1:o,o=n+1;o<l.length&&d(e.FullPaths[o])!=d(u);++o);h.R=o>=l.length?-1:o,h.type=1}else d(e.FullPaths[n+1]||"")==d(u)&&(h.R=n+1),h.type=2}}}function a(e,t){var r=t||{};if("mad"==r.fileType)return function(e,t){for(var r=t||{},a=r.boundary||"SheetJS",n=["MIME-Version: 1.0",'Content-Type: multipart/related; boundary="'+(a="------="+a).slice(2)+'"',"","",""],s=e.FullPaths[0],i=s,o=e.FileIndex[0],c=1;c<e.FullPaths.length;++c)if(i=e.FullPaths[c].slice(s.length),(o=e.FileIndex[c]).size&&o.content&&"Sh33tJ5"!=i){i=i.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g,function(e){return"_x"+e.charCodeAt(0).toString(16)+"_"}).replace(/[\u0080-\uFFFF]/g,function(e){return"_u"+e.charCodeAt(0).toString(16)+"_"});for(var l=o.content,f=se&&Buffer.isBuffer(l)?l.toString("binary"):_(l),h=0,u=Math.min(1024,f.length),d=0,p=0;p<=u;++p)32<=(d=f.charCodeAt(p))&&d<128&&++h;l=4*u/5<=h;n.push(a),n.push("Content-Location: "+(r.root||"file:///C:/SheetJS/")+i),n.push("Content-Transfer-Encoding: "+(l?"quoted-printable":"base64")),n.push("Content-Type: "+function(e,t){if(e.ctype)return e.ctype;var r=e.name||"",e=r.match(/\.([^\.]+)$/);if(e&&Z[e[1]])return Z[e[1]];if(t&&(e=(r=t).match(/[\.\\]([^\.\\])+$/))&&Z[e[1]])return Z[e[1]];return"application/octet-stream"}(o,i)),n.push(""),n.push((l?function(e){e=e.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g,function(e){e=e.charCodeAt(0).toString(16).toUpperCase();return"="+(1==e.length?"0"+e:e)});"\n"==(e=e.replace(/ $/gm,"=20").replace(/\t$/gm,"=09")).charAt(0)&&(e="=0D"+e.slice(1));e=e.replace(/\r(?!\n)/gm,"=0D").replace(/\n\n/gm,"\n=0A").replace(/([^\r\n])\n/gm,"$1=0A");for(var t=[],r=e.split("\r\n"),a=0;a<r.length;++a){var n=r[a];if(0!=n.length)for(var s=0;s<n.length;){var i=76,o=n.slice(s,s+i);"="==o.charAt(i-1)?i--:"="==o.charAt(i-2)?i-=2:"="==o.charAt(i-3)&&(i-=3),o=n.slice(s,s+i),(s+=i)<n.length&&(o+="="),t.push(o)}else t.push("")}return t.join("\r\n")}:function(e){for(var t=ee(e),r=[],a=0;a<t.length;a+=76)r.push(t.slice(a,a+76));return r.join("\r\n")+"\r\n"})(f))}return n.push(a+"--\r\n"),n.join("\r\n")}(e,r);if(u(e),"zip"===r.fileType)return function(e,t){var t=t||{},r=[],a=[],n=Lr(1),s=t.compression?8:0,i=0;0;var o=0,c=0,l=0,f=0,h=e.FullPaths[0],u=h,d=e.FileIndex[0],p=[],m=0;for(o=1;o<e.FullPaths.length;++o)if(u=e.FullPaths[o].slice(h.length),(d=e.FileIndex[o]).size&&d.content&&"Sh33tJ5"!=u){var g=l,b=Lr(u.length);for(c=0;c<u.length;++c)b.write_shift(1,127&u.charCodeAt(c));b=b.slice(0,b.l),p[f]=_e.buf(d.content,0);var v=d.content;8==s&&(v=function(e){return T?T.deflateRawSync(e):V(e)}(v)),(n=Lr(30)).write_shift(4,67324752),n.write_shift(2,20),n.write_shift(2,i),n.write_shift(2,s),d.mt?function(e,t){var r=(t="string"==typeof t?new Date(t):t).getHours();r=(r=r<<6|t.getMinutes())<<5|t.getSeconds()>>>1,e.write_shift(2,r),r=(r=(r=t.getFullYear()-1980)<<4|t.getMonth()+1)<<5|t.getDate(),e.write_shift(2,r)}(n,d.mt):n.write_shift(4,0),n.write_shift(-4,8&i?0:p[f]),n.write_shift(4,8&i?0:v.length),n.write_shift(4,8&i?0:d.content.length),n.write_shift(2,b.length),n.write_shift(2,0),l+=n.length,r.push(n),l+=b.length,r.push(b),l+=v.length,r.push(v),8&i&&((n=Lr(12)).write_shift(-4,p[f]),n.write_shift(4,v.length),n.write_shift(4,d.content.length),l+=n.l,r.push(n)),(n=Lr(46)).write_shift(4,33639248),n.write_shift(2,0),n.write_shift(2,20),n.write_shift(2,i),n.write_shift(2,s),n.write_shift(4,0),n.write_shift(-4,p[f]),n.write_shift(4,v.length),n.write_shift(4,d.content.length),n.write_shift(2,b.length),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(4,0),n.write_shift(4,g),m+=n.l,a.push(n),m+=b.length,a.push(b),++f}return(n=Lr(22)).write_shift(4,101010256),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,f),n.write_shift(2,f),n.write_shift(4,m),n.write_shift(4,l),n.write_shift(2,0),ue([ue(r),ue(a),n])}(e,r);for(var a=function(e){for(var t=0,r=0,a=0;a<e.FileIndex.length;++a){var n=e.FileIndex[a];n.content&&(0<(n=n.content.length)&&(n<4096?t+=n+63>>6:r+=n+511>>9))}for(var s=e.FullPaths.length+3>>2,i=t+127>>7,o=(t+7>>3)+r+s+i,c=o+127>>7,l=c<=109?0:Math.ceil((c-109)/127);c<o+c+l+127>>7;)l=++c<=109?0:Math.ceil((c-109)/127);s=[1,l,c,i,s,r,t,0];return e.FileIndex[0].size=t<<6,s[7]=(e.FileIndex[0].start=s[0]+s[1]+s[2]+s[3]+s[4]+s[5])+(s[6]+7>>3),s}(e),n=Lr(a[7]<<9),s=0,i=0,s=0;s<8;++s)n.write_shift(1,m[s]);for(s=0;s<8;++s)n.write_shift(2,0);for(n.write_shift(2,62),n.write_shift(2,3),n.write_shift(2,65534),n.write_shift(2,9),n.write_shift(2,6),s=0;s<3;++s)n.write_shift(2,0);for(n.write_shift(4,0),n.write_shift(4,a[2]),n.write_shift(4,a[0]+a[1]+a[2]+a[3]-1),n.write_shift(4,0),n.write_shift(4,4096),n.write_shift(4,a[3]?a[0]+a[1]+a[2]-1:k),n.write_shift(4,a[3]),n.write_shift(-4,a[1]?a[0]-1:k),n.write_shift(4,a[1]),s=0;s<109;++s)n.write_shift(-4,s<a[2]?a[1]+s:-1);if(a[1])for(i=0;i<a[1];++i){for(;s<236+127*i;++s)n.write_shift(-4,s<a[2]?a[1]+s:-1);n.write_shift(-4,i===a[1]-1?k:i+1)}function o(e){for(i+=e;s<i-1;++s)n.write_shift(-4,s+1);e&&(++s,n.write_shift(-4,k))}i=s=0;for(i+=a[1];s<i;++s)n.write_shift(-4,S.DIFSECT);for(i+=a[2];s<i;++s)n.write_shift(-4,S.FATSECT);o(a[3]),o(a[4]);for(var c=0,l=0,f=e.FileIndex[0];c<e.FileIndex.length;++c)(f=e.FileIndex[c]).content&&((l=f.content.length)<4096||(f.start=i,o(l+511>>9)));for(o(a[6]+7>>3);511&n.l;)n.write_shift(-4,S.ENDOFCHAIN);for(c=i=s=0;c<e.FileIndex.length;++c)(f=e.FileIndex[c]).content&&(!(l=f.content.length)||4096<=l||(f.start=i,o(l+63>>6)));for(;511&n.l;)n.write_shift(-4,S.ENDOFCHAIN);for(s=0;s<a[4]<<2;++s){var h=e.FullPaths[s];if(h&&0!==h.length){f=e.FileIndex[s],0===s&&(f.start=f.size?f.start-1:k);h=0===s&&r.root||f.name,l=2*(h.length+1);if(n.write_shift(64,h,"utf16le"),n.write_shift(2,l),n.write_shift(1,f.type),n.write_shift(1,f.color),n.write_shift(-4,f.L),n.write_shift(-4,f.R),n.write_shift(-4,f.C),f.clsid)n.write_shift(16,f.clsid,"hex");else for(c=0;c<4;++c)n.write_shift(4,0);n.write_shift(4,f.state||0),n.write_shift(4,0),n.write_shift(4,0),n.write_shift(4,0),n.write_shift(4,0),n.write_shift(4,f.start),n.write_shift(4,f.size),n.write_shift(4,0)}else{for(c=0;c<17;++c)n.write_shift(4,0);for(c=0;c<3;++c)n.write_shift(4,-1);for(c=0;c<12;++c)n.write_shift(4,0)}}for(s=1;s<e.FileIndex.length;++s)if(4096<=(f=e.FileIndex[s]).size)if(n.l=f.start+1<<9,se&&Buffer.isBuffer(f.content))f.content.copy(n,n.l,0,f.size),n.l+=f.size+511&-512;else{for(c=0;c<f.size;++c)n.write_shift(1,f.content[c]);for(;511&c;++c)n.write_shift(1,0)}for(s=1;s<e.FileIndex.length;++s)if(0<(f=e.FileIndex[s]).size&&f.size<4096)if(se&&Buffer.isBuffer(f.content))f.content.copy(n,n.l,0,f.size),n.l+=f.size+63&-64;else{for(c=0;c<f.size;++c)n.write_shift(1,f.content[c]);for(;63&c;++c)n.write_shift(1,0)}if(se)n.l=n.length;else for(;n.l<n.length;)n.write_shift(1,0);return n}e.version="1.2.1";var T,E=64,k=-2,y="d0cf11e0a1b11ae1",m=[208,207,17,224,161,177,26,225],b="00000000000000000000000000000000",S={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:k,FREESECT:-1,HEADER_SIGNATURE:y,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:b,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};function _(e){for(var t=new Array(e.length),r=0;r<e.length;++r)t[r]=String.fromCharCode(e[r]);return t.join("")}var x=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],A=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258],C=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];for(var t,R="undefined"!=typeof Uint8Array,O=R?new Uint8Array(256):[],r=0;r<256;++r)O[r]=255&((t=139536&((t=r)<<1|t<<11)|558144&(t<<5|t<<15))>>16|t>>8|t);function I(e,t){var r=7&t,t=t>>>3;return(e[t]|(r<=5?0:e[1+t]<<8))>>>r&7}function N(e,t){var r=7&t,t=t>>>3;return(e[t]|(r<=3?0:e[1+t]<<8))>>>r&31}function F(e,t){var r=7&t,t=t>>>3;return(e[t]|(r<=1?0:e[1+t]<<8))>>>r&127}function D(e,t,r){var a=7&t,n=t>>>3,s=(1<<r)-1,t=e[n]>>>a;return r<8-a?t&s:(t|=e[1+n]<<8-a,r<16-a?t&s:(t|=e[2+n]<<16-a,r<24-a?t&s:(t|=e[3+n]<<24-a)&s))}function P(e,t,r){var a=7&t,n=t>>>3;return a<=5?e[n]|=(7&r)<<a:(e[n]|=r<<a&255,e[1+n]=(7&r)>>8-a),t+3}function L(e,t,r){var a=t>>>3;return r<<=7&t,e[a]|=255&r,r>>>=8,e[1+a]=r,t+8}function M(e,t,r){var a=t>>>3;return r<<=7&t,e[a]|=255&r,r>>>=8,e[1+a]=255&r,e[2+a]=r>>>8,t+16}function U(e,t){var r=e.length,a=t<2*r?2*r:t+5,n=0;if(t<=r)return e;if(se){var s=fe(a);if(e.copy)e.copy(s);else for(;n<e.length;++n)s[n]=e[n];return s}if(R){var i=new Uint8Array(a);if(i.set)i.set(e);else for(;n<r;++n)i[n]=e[n];return i}return e.length=a,e}function B(e){for(var t=new Array(e),r=0;r<e;++r)t[r]=0;return t}function W(e,t,r){for(var a,n=1,s=0,i=0,o=0,c=e.length,l=R?new Uint16Array(32):B(32),s=0;s<32;++s)l[s]=0;for(s=c;s<r;++s)e[s]=0;c=e.length;var f=R?new Uint16Array(c):B(c);for(s=0;s<c;++s)l[a=e[s]]++,n<a&&(n=a),f[s]=0;for(l[0]=0,s=1;s<=n;++s)l[s+16]=o=o+l[s-1]<<1;for(s=0;s<c;++s)0!=(o=e[s])&&(f[s]=l[o+16]++);var h,u,d,p;for(s=0;s<c;++s)if(0!=(h=e[s]))for(u=f[s],d=n,p=void 0,p=O[255&u],o=(d<=8?p>>>8-d:(p=p<<8|O[u>>8&255],d<=16?p>>>16-d:(p=p<<8|O[u>>16&255])>>>24-d))>>n-h,i=(1<<n+4-h)-1;0<=i;--i)t[o|i<<h]=15&h|s<<4;return n}var H=R?new Uint16Array(512):B(512),z=R?new Uint16Array(32):B(32);if(!R){for(var n=0;n<512;++n)H[n]=0;for(n=0;n<32;++n)z[n]=0}!function(){for(var e=[],t=0;t<32;t++)e.push(5);W(e,z,32);for(var r=[],t=0;t<=143;t++)r.push(8);for(;t<=255;t++)r.push(9);for(;t<=279;t++)r.push(7);for(;t<=287;t++)r.push(8);W(r,H,288)}();var c=function(){for(var d=R?new Uint8Array(32768):[],e=0,t=0;e<C.length-1;++e)for(;t<C[e+1];++t)d[t]=e;for(;t<32768;++t)d[t]=29;for(var p=R?new Uint8Array(259):[],e=0,t=0;e<A.length-1;++e)for(;t<A[e+1];++t)p[t]=e;return function(e,t){return(e.length<8?function(e,t){for(var r=0;r<e.length;){var a=Math.min(65535,e.length-r),n=r+a==e.length;for(t.write_shift(1,+n),t.write_shift(2,a),t.write_shift(2,65535&~a);0<a--;)t[t.l++]=e[r++]}return t.l}:function(e,t){for(var r=0,a=0,n=R?new Uint16Array(32768):[];a<e.length;){var s=Math.min(65535,e.length-a);if(s<10){for(7&(r=P(t,r,+!(a+s!=e.length)))&&(r+=8-(7&r)),t.l=r/8|0,t.write_shift(2,s),t.write_shift(2,65535&~s);0<s--;)t[t.l++]=e[a++];r=8*t.l}else{r=P(t,r,+!(a+s!=e.length)+2);for(var i=0;0<s--;){var o=e[a],i=32767&(i<<5^o),c=-1,l=0;if((c=n[i])&&(a<(c|=-32768&a)&&(c-=32768),c<a))for(;e[c+l]==e[a+l]&&l<250;)++l;if(2<l){(o=p[l])<=22?r=L(t,r,O[o+1]>>1)-1:(L(t,r,3),L(t,r+=5,O[o-23]>>5),r+=3);var f=o<8?0:o-4>>2;0<f&&(M(t,r,l-A[o]),r+=f),o=d[a-c],r=L(t,r,O[o]>>3),r-=3;var h=o<4?0:o-2>>1;0<h&&(M(t,r,a-c-C[o]),r+=h);for(var u=0;u<l;++u)n[i]=32767&a,i=32767&(i<<5^e[a]),++a;s-=l-1}else o<=143?o+=48:(f=((f=1)&f)<<(7&(h=r)),t[h>>>3]|=f,r=h+1),r=L(t,r,O[o]),n[i]=32767&a,++a}r=L(t,r,0)-1}}return t.l=(r+7)/8|0,t.l})(e,t)}}();function V(e){var t=Lr(50+Math.floor(1.1*e.length)),e=c(e,t);return t.slice(0,e)}var G=R?new Uint16Array(32768):B(32768),j=R?new Uint16Array(32768):B(32768),$=R?new Uint16Array(128):B(128),X=1,Y=1;function l(e,t){if(3==e[0]&&!(3&e[1]))return[le(t),2];for(var r=0,a=0,n=fe(t||1<<18),s=0,i=n.length>>>0,o=0,c=0;0==(1&a);)if(a=I(e,r),r+=3,a>>>1!=0)for(c=a>>1==1?(o=9,5):(r=function(e,t){var r,a,n,s=N(e,t)+257,i=N(e,t+=5)+1,o=(n=7&(a=t+=5),4+(((r=e)[a=a>>>3]|(n<=4?0:r[1+a]<<8))>>>n&15));t+=4;for(var c=0,l=R?new Uint8Array(19):B(19),f=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],h=1,u=R?new Uint8Array(8):B(8),d=R?new Uint8Array(8):B(8),p=l.length,m=0;m<o;++m)l[x[m]]=c=I(e,t),h<c&&(h=c),u[c]++,t+=3;var g=0;for(u[0]=0,m=1;m<=h;++m)d[m]=g=g+u[m-1]<<1;for(m=0;m<p;++m)0!=(g=l[m])&&(f[m]=d[g]++);for(var b,m=0;m<p;++m)if(0!=(b=l[m])){g=O[f[m]]>>8-b;for(var v=(1<<7-b)-1;0<=v;--v)$[g|v<<b]=7&b|m<<3}for(var w,T,E,k=[],h=1;k.length<s+i;)switch(t+=7&(g=$[F(e,t)]),g>>>=3){case 16:for(c=3+(E=void 0,E=7&(T=t),((w=e)[T=T>>>3]|(E<=6?0:w[1+T]<<8))>>>E&3),t+=2,g=k[k.length-1];0<c--;)k.push(g);break;case 17:for(c=3+I(e,t),t+=3;0<c--;)k.push(0);break;case 18:for(c=11+F(e,t),t+=7;0<c--;)k.push(0);break;default:k.push(g),h<g&&(h=g)}var y=k.slice(0,s),S=k.slice(s);for(m=s;m<286;++m)y[m]=0;for(m=i;m<30;++m)S[m]=0;return X=W(y,G,286),Y=W(S,j,30),t}(e,r),o=X,Y);;){!t&&i<s+32767&&(i=(n=U(n,s+32767)).length);var l=D(e,r,o),f=(a>>>1==1?H:G)[l];if(r+=15&f,0==((f>>>=4)>>>8&255))n[s++]=f;else{if(256==f)break;var h=(f-=257)<8?0:f-4>>2;5<h&&(h=0);var u=s+A[f];0<h&&(u+=D(e,r,h),r+=h),l=D(e,r,c),r+=15&(f=(a>>>1==1?z:j)[l]);var l=(f>>>=4)<4?0:f-2>>1,d=C[f];for(0<l&&(d+=D(e,r,l),r+=l),!t&&i<u&&(i=(n=U(n,u+100)).length);s<u;)n[s]=n[s-d],++s}}else{7&r&&(r+=8-(7&r));var p=e[r>>>3]|e[1+(r>>>3)]<<8;if(r+=32,0<p)for(!t&&i<s+p&&(i=(n=U(n,s+p)).length);0<p--;)n[s++]=e[r>>>3],r+=8}return t?[n,r+7>>>3]:[n.slice(0,s),r+7>>>3]}function K(e,t){t=l(e.slice(e.l||0),t);return e.l+=t[1],t[0]}function J(e,t){if(!e)throw new Error(t);"undefined"!=typeof console&&console.error(t)}function q(e,t){var r=e;Dr(r,0);var a={FileIndex:[],FullPaths:[]};w(a,{root:t.root});for(var n=r.length-4;(80!=r[n]||75!=r[n+1]||5!=r[n+2]||6!=r[n+3])&&0<=n;)--n;r.l=n+4,r.l+=4;var s=r.read_shift(2);r.l+=6;t=r.read_shift(4);for(r.l=t,n=0;n<s;++n){r.l+=20;var i=r.read_shift(4),o=r.read_shift(4),c=r.read_shift(2),l=r.read_shift(2),f=r.read_shift(2);r.l+=8;var h=r.read_shift(4),u=g(r.slice(r.l+c,r.l+c+l));r.l+=c+l+f;f=r.l;r.l=h+4,function(e,t,r,a,n){e.l+=2;var s=e.read_shift(2),i=e.read_shift(2),o=function(e){var t=65535&e.read_shift(2),r=65535&e.read_shift(2),a=new Date,n=31&r,e=15&(r>>>=5);return r>>>=4,a.setMilliseconds(0),a.setFullYear(1980+r),a.setMonth(e-1),a.setDate(n),e=31&t,n=63&(t>>>=5),t>>>=6,a.setHours(t),a.setMinutes(n),a.setSeconds(e<<1),a}(e);if(8257&s)throw new Error("Unsupported ZIP encryption");e.read_shift(4);for(var c,l=e.read_shift(4),f=e.read_shift(4),h=e.read_shift(2),u=e.read_shift(2),d="",p=0;p<h;++p)d+=String.fromCharCode(e[e.l++]);u&&(((c=g(e.slice(e.l,e.l+u)))[21589]||{}).mt&&(o=c[21589].mt),((n||{})[21589]||{}).mt&&(o=n[21589].mt)),e.l+=u;var m=e.slice(e.l,e.l+l);switch(i){case 8:m=function(e,t){if(!T)return K(e,t);var r=new T.InflateRaw,t=r._processChunk(e.slice(e.l),r._finishFlushFlag);return e.l+=r.bytesRead,t}(e,f);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+i)}u=!1,8&s&&(134695760==e.read_shift(4)&&(e.read_shift(4),u=!0),l=e.read_shift(4),f=e.read_shift(4)),l!=t&&J(u,"Bad compressed size: "+t+" != "+l),f!=r&&J(u,"Bad uncompressed size: "+r+" != "+f),Q(a,d,m,{unsafe:!0,mt:o})}(r,i,o,a,u),r.l=f}return a}var Z={htm:"text/html",xml:"text/xml",gif:"image/gif",jpg:"image/jpeg",png:"image/png",mso:"application/x-mso",thmx:"application/vnd.ms-officetheme",sh33tj5:"application/octet-stream"};function Q(e,t,r,a){var n=a&&a.unsafe;n||w(e);var s,i=!n&&xe.find(e,t);return i||(s=e.FullPaths[0],s=t.slice(0,s.length)==s?t:("/"!=s.slice(-1)&&(s+="/"),(s+t).replace("//","/")),i={name:p(t),type:2},e.FileIndex.push(i),e.FullPaths.push(s),n||xe.utils.cfb_gc(e)),i.content=r,i.size=r?r.length:0,a&&(a.CLSID&&(i.clsid=a.CLSID),a.mt&&(i.mt=a.mt),a.ct&&(i.ct=a.ct)),i}return e.find=function(e,t){var r=e.FullPaths.map(function(e){return e.toUpperCase()}),a=r.map(function(e){var t=e.split("/");return t[t.length-("/"==e.slice(-1)?2:1)]}),n=!1;47===t.charCodeAt(0)?(n=!0,t=r[0].slice(0,-1)+t):n=-1!==t.indexOf("/");var s=t.toUpperCase(),i=(!0===n?r:a).indexOf(s);if(-1!==i)return e.FileIndex[i];var o=!s.match(pe),s=s.replace(de,"");for(o&&(s=s.replace(pe,"!")),i=0;i<r.length;++i){if((o?r[i].replace(pe,"!"):r[i]).replace(de,"")==s)return e.FileIndex[i];if((o?a[i].replace(pe,"!"):a[i]).replace(de,"")==s)return e.FileIndex[i]}return null},e.read=function(e,t){var r,a,n=t&&t.type;switch(n||se&&Buffer.isBuffer(e)&&(n="buffer"),n||"base64"){case"file":return r=e,a=t,i(),o(s.readFileSync(r),a);case"base64":return o(he(te(e)),t);case"binary":return o(he(e),t)}return o(e,t)},e.parse=o,e.write=function(e,t){var r=a(e,t);switch(t&&t.type||"buffer"){case"file":return i(),s.writeFileSync(t.filename,r),r;case"binary":return"string"==typeof r?r:_(r);case"base64":return ee("string"==typeof r?r:_(r));case"buffer":if(se)return Buffer.isBuffer(r)?r:ce(r);case"array":return"string"==typeof r?he(r):r}return r},e.writeFile=function(e,t,r){i(),r=a(e,r),s.writeFileSync(t,r)},e.utils={cfb_new:function(e){var t={};return w(t,e),t},cfb_add:Q,cfb_del:function(e,t){w(e);var r=xe.find(e,t);if(r)for(var a=0;a<e.FileIndex.length;++a)if(e.FileIndex[a]==r)return e.FileIndex.splice(a,1),e.FullPaths.splice(a,1),!0;return!1},cfb_mov:function(e,t,r){w(e);var a=xe.find(e,t);if(a)for(var n=0;n<e.FileIndex.length;++n)if(e.FileIndex[n]==a)return e.FileIndex[n].name=p(r),e.FullPaths[n]=r,!0;return!1},cfb_gc:function(e){u(e,!0)},ReadShift:Cr,CheckField:Fr,prep_blob:Dr,bconcat:ue,use_zlib:function(e){try{var t=new e.InflateRaw;if(t._processChunk(new Uint8Array([3,0]),t._finishFlushFlag),!t.bytesRead)throw new Error("zlib does not expose bytesRead");T=e}catch(e){console.error("cannot use native zlib: "+(e.message||e))}},_deflateRaw:V,_inflateRaw:K,consts:S},e}();if(true)try{Se=__webpack_require__(419)}catch(e){}function Ae(e){return"string"==typeof e?o(e):Array.isArray(e)?function(e){if("undefined"==typeof Uint8Array)throw new Error("Unsupported");return new Uint8Array(e)}(e):e}function Ce(e,t,r){if(void 0!==Se&&Se.writeFileSync)return r?Se.writeFileSync(e,t,r):Se.writeFileSync(e,t);if("undefined"!=typeof Deno){if(r&&"string"==typeof t)switch(r){case"utf8":t=new TextEncoder(r).encode(t);break;case"binary":t=o(t);break;default:throw new Error("Unsupported encoding "+r)}return Deno.writeFileSync(e,t)}var a="utf8"==r?Ut(t):t;if("undefined"!=typeof IE_SaveFile)return IE_SaveFile(a,e);if("undefined"!=typeof Blob){a=new Blob([Ae(a)],{type:"application/octet-stream"});if("undefined"!=typeof navigator&&navigator.msSaveBlob)return navigator.msSaveBlob(a,e);if("undefined"!=typeof saveAs)return saveAs(a,e);if("undefined"!=typeof URL&&"undefined"!=typeof document&&document.createElement&&URL.createObjectURL){var n=URL.createObjectURL(a);if("object"==typeof chrome&&"function"==typeof(chrome.downloads||{}).download)return URL.revokeObjectURL&&"undefined"!=typeof setTimeout&&setTimeout(function(){URL.revokeObjectURL(n)},6e4),chrome.downloads.download({url:n,filename:e,saveAs:!0});a=document.createElement("a");if(null!=a.download)return a.download=e,a.href=n,document.body.appendChild(a),a.click(),document.body.removeChild(a),URL.revokeObjectURL&&"undefined"!=typeof setTimeout&&setTimeout(function(){URL.revokeObjectURL(n)},6e4),n}}if("undefined"!=typeof $&&"undefined"!=typeof File&&"undefined"!=typeof Folder)try{var s=File(e);return s.open("w"),s.encoding="binary",Array.isArray(t)&&(t=i(t)),s.write(t),s.close(),t}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e}throw new Error("cannot save file "+e)}function Re(e){for(var t=Object.keys(e),r=[],a=0;a<t.length;++a)Object.prototype.hasOwnProperty.call(e,t[a])&&r.push(t[a]);return r}function Oe(e,t){for(var r=[],a=Re(e),n=0;n!==a.length;++n)null==r[e[a[n]][t]]&&(r[e[a[n]][t]]=a[n]);return r}function Ie(e){for(var t=[],r=Re(e),a=0;a!==r.length;++a)t[e[r[a]]]=r[a];return t}function Ne(e){for(var t=[],r=Re(e),a=0;a!==r.length;++a)t[e[r[a]]]=parseInt(r[a],10);return t}var Fe=new Date(1899,11,30,0,0,0);function De(e,t){var r=e.getTime();return t&&(r-=1263168e5),(r-(Fe.getTime()+6e4*(e.getTimezoneOffset()-Fe.getTimezoneOffset())))/864e5}var r=new Date,Pe=Fe.getTime()+6e4*(r.getTimezoneOffset()-Fe.getTimezoneOffset()),Le=r.getTimezoneOffset();function Me(e){var t=new Date;return t.setTime(24*e*60*60*1e3+Pe),t.getTimezoneOffset()!==Le&&t.setTime(t.getTime()+6e4*(t.getTimezoneOffset()-Le)),t}var Ue=new Date("2017-02-19T19:06:09.000Z"),Be=isNaN(Ue.getFullYear())?new Date("2/19/17"):Ue,We=2017==Be.getFullYear();function He(e,t){var r=new Date(e);if(We)return 0<t?r.setTime(r.getTime()+60*r.getTimezoneOffset()*1e3):t<0&&r.setTime(r.getTime()-60*r.getTimezoneOffset()*1e3),r;if(e instanceof Date)return e;if(1917==Be.getFullYear()&&!isNaN(r.getFullYear())){t=r.getFullYear();return-1<e.indexOf(""+t)?r:(r.setFullYear(r.getFullYear()+100),r)}r=e.match(/\d+/g)||["2017","2","19","0","0","0"],r=new Date(+r[0],+r[1]-1,+r[2],+r[3]||0,+r[4]||0,+r[5]||0);return r=-1<e.indexOf("Z")?new Date(r.getTime()-60*r.getTimezoneOffset()*1e3):r}function ze(e,t){if(se&&Buffer.isBuffer(e)){if(t){if(255==e[0]&&254==e[1])return Ut(e.slice(2).toString("utf16le"));if(254==e[1]&&255==e[2])return Ut(s(e.slice(2).toString("binary")))}return e.toString("binary")}if("undefined"!=typeof TextDecoder)try{if(t){if(255==e[0]&&254==e[1])return Ut(new TextDecoder("utf-16le").decode(e.slice(2)));if(254==e[0]&&255==e[1])return Ut(new TextDecoder("utf-16be").decode(e.slice(2)))}var r={"€":"","‚":"","ƒ":"","„":"","…":"","†":"","‡":"","ˆ":"","‰":"","Š":"","‹":"","Œ":"","Ž":"","‘":"","’":"","“":"","”":"","•":"","–":"","—":"","˜":"","™":"","š":"","›":"","œ":"","ž":"","Ÿ":""};return Array.isArray(e)&&(e=new Uint8Array(e)),new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g,function(e){return r[e]||e})}catch(e){}for(var a=[],n=0;n!=e.length;++n)a.push(String.fromCharCode(e[n]));return a.join("")}function Ve(e){if("undefined"!=typeof JSON&&!Array.isArray(e))return JSON.parse(JSON.stringify(e));if("object"!=typeof e||null==e)return e;if(e instanceof Date)return new Date(e.getTime());var t,r={};for(t in e)Object.prototype.hasOwnProperty.call(e,t)&&(r[t]=Ve(e[t]));return r}function Ge(e,t){for(var r="";r.length<t;)r+=e;return r}function je(e){var t=Number(e);if(!isNaN(t))return isFinite(t)?t:NaN;if(!/\d/.test(e))return t;var r=1,e=e.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){return r*=100,""});return isNaN(t=Number(e))?(e=e.replace(/[(](.*)[)]/,function(e,t){return r=-r,t}),isNaN(t=Number(e))?t:t/r):t/r}var $e=["january","february","march","april","may","june","july","august","september","october","november","december"];function Xe(e){var t=new Date(e),r=new Date(NaN),a=t.getYear(),n=t.getMonth(),s=t.getDate();if(isNaN(s))return r;var i=e.toLowerCase();if(i.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)){if(3<(i=i.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"")).length&&-1==$e.indexOf(i))return r}else if(i.match(/[a-z]/))return r;return a<0||8099<a||(!(0<n||1<s)||101==a)&&e.match(/[^-0-9:,\/\\]/)?r:t}var Ye,Ke=(Ye=5=="abacaba".split(/(:?b)/i).length,function(e,t,r){if(Ye||"string"==typeof t)return e.split(t);for(var a=e.split(t),n=[a[0]],s=1;s<a.length;++s)n.push(r),n.push(a[s]);return n});function Je(e){return e?e.content&&e.type?ze(e.content,!0):e.data?ne(e.data):e.asNodeBuffer&&se?ne(e.asNodeBuffer().toString("binary")):e.asBinary?ne(e.asBinary()):e._data&&e._data.getContent?ne(ze(Array.prototype.slice.call(e._data.getContent(),0))):null:null}function qe(e){if(!e)return null;if(e.data)return ae(e.data);if(e.asNodeBuffer&&se)return e.asNodeBuffer();if(e._data&&e._data.getContent){var t=e._data.getContent();return"string"==typeof t?ae(t):Array.prototype.slice.call(t)}return e.content&&e.type?e.content:null}function Ze(e,t){for(var r=e.FullPaths||Re(e.files),a=t.toLowerCase().replace(/[\/]/g,"\\"),n=a.replace(/\\/g,"/"),s=0;s<r.length;++s){var i=r[s].replace(/^Root Entry[\/]/,"").toLowerCase();if(a==i||n==i)return e.files?e.files[r[s]]:e.FileIndex[s]}return null}function Qe(e,t){e=Ze(e,t);if(null==e)throw new Error("Cannot find file "+t+" in zip");return e}function et(e,t,r){if(!r)return((r=Qe(e,t))&&".bin"===r.name.slice(-4)?qe:Je)(r);if(!t)return null;try{return et(e,t)}catch(e){return null}}function tt(e,t,r){if(!r)return Je(Qe(e,t));if(!t)return null;try{return tt(e,t)}catch(e){return null}}function rt(e){for(var t=e.FullPaths||Re(e.files),r=[],a=0;a<t.length;++a)"/"!=t[a].slice(-1)&&r.push(t[a].replace(/^Root Entry[\/]/,""));return r.sort()}function at(e,t,r){if(e.FullPaths){if("string"==typeof r){var a=(se?ce:function(e){for(var t=[],r=0,a=e.length+250,n=le(e.length+255),s=0;s<e.length;++s){var i,o=e.charCodeAt(s);o<128?n[r++]=o:o<2048?(n[r++]=192|o>>6&31,n[r++]=128|63&o):55296<=o&&o<57344?(o=64+(1023&o),i=1023&e.charCodeAt(++s),n[r++]=240|o>>8&7,n[r++]=128|o>>2&63,n[r++]=128|i>>6&15|(3&o)<<4,n[r++]=128|63&i):(n[r++]=224|o>>12&15,n[r++]=128|o>>6&63,n[r++]=128|63&o),a<r&&(t.push(n.slice(0,r)),r=0,n=le(65535),a=65530)}return t.push(n.slice(0,r)),ue(t)})(r);return xe.utils.cfb_add(e,t,a)}xe.utils.cfb_add(e,t,r)}else e.file(t,r)}function nt(){return xe.utils.cfb_new()}function st(e,t){switch(t.type){case"base64":return xe.read(e,{type:"base64"});case"binary":return xe.read(e,{type:"binary"});case"buffer":case"array":return xe.read(e,{type:"buffer"})}throw new Error("Unrecognized type "+t.type)}function it(e,t){if("/"==e.charAt(0))return e.slice(1);var r=t.split("/");"/"!=t.slice(-1)&&r.pop();for(var a=e.split("/");0!==a.length;){var n=a.shift();".."===n?r.pop():"."!==n&&r.push(n)}return r.join("/")}var ot='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n',ct=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g,lt=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm,ft=ot.match(lt)?lt:/<[^>]*>/g,ht=/<\w*:/,ut=/<(\/?)\w+:/;function dt(e,t,r){for(var a={},n=0,s=0;n!==e.length&&(32!==(s=e.charCodeAt(n))&&10!==s&&13!==s);++n);if(t||(a[0]=e.slice(0,n)),n===e.length)return a;var i,o,c,l=e.match(ct),f=0,h=0,u="",d="";if(l)for(h=0;h!=l.length;++h){for(d=l[h],s=0;s!=d.length&&61!==d.charCodeAt(s);++s);for(u=d.slice(0,s).trim();32==d.charCodeAt(s+1);)++s;for(o=34==(n=d.charCodeAt(s+1))||39==n?1:0,i=d.slice(s+1+o,d.length-o),f=0;f!=u.length&&58!==u.charCodeAt(f);++f);f===u.length?(a[u=0<u.indexOf("_")?u.slice(0,u.indexOf("_")):u]=i,r||(a[u.toLowerCase()]=i)):a[c=(5===f&&"xmlns"===u.slice(0,5)?"xmlns":"")+u.slice(f+1)]&&"ext"==u.slice(f-3,f)||(a[c]=i,r||(a[c.toLowerCase()]=i))}return a}function pt(e){return e.replace(ut,"<$1")}var mt,gt,bt={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"},vt=Ie(bt),wt=(mt=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi,gt=/_x([\da-fA-F]{4})_/gi,function e(t){var r=t+"",a=r.indexOf("<![CDATA[");if(-1==a)return r.replace(mt,function(e,t){return bt[e]||String.fromCharCode(parseInt(t,-1<e.indexOf("x")?16:10))||e}).replace(gt,function(e,t){return String.fromCharCode(parseInt(t,16))});t=r.indexOf("]]>");return e(r.slice(0,a))+r.slice(a+9,t)+e(r.slice(t+3))}),Tt=/[&<>'"]/g,Et=/[\u0000-\u0008\u000b-\u001f]/g;function kt(e){return(e+"").replace(Tt,function(e){return vt[e]}).replace(Et,function(e){return"_x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+"_"})}function yt(e){return kt(e).replace(/ /g,"_x0020_")}var St=/[\u0000-\u001f]/g;function _t(e){return(e+"").replace(Tt,function(e){return vt[e]}).replace(/\n/g,"<br/>").replace(St,function(e){return"&#x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+";"})}var xt,At=(xt=/&#(\d+);/g,function(e){return e.replace(xt,Ct)});function Ct(e,t){return String.fromCharCode(parseInt(t,10))}function Rt(e){switch(e){case 1:case!0:case"1":case"true":case"TRUE":return!0;default:return!1}}function Ot(e){for(var t,r,a,n,s="",i=0,o=0;i<e.length;)(t=e.charCodeAt(i++))<128?s+=String.fromCharCode(t):(r=e.charCodeAt(i++),191<t&&t<224?(o=(31&t)<<6,o|=63&r,s+=String.fromCharCode(o)):(a=e.charCodeAt(i++),t<240?s+=String.fromCharCode((15&t)<<12|(63&r)<<6|63&a):(n=((7&t)<<18|(63&r)<<12|(63&a)<<6|63&(o=e.charCodeAt(i++)))-65536,s+=String.fromCharCode(55296+(n>>>10&1023)),s+=String.fromCharCode(56320+(1023&n)))));return s}function It(e){for(var t,r,a=le(2*e.length),n=1,s=0,i=0,o=0;o<e.length;o+=n)n=1,(r=e.charCodeAt(o))<128?t=r:r<224?(t=64*(31&r)+(63&e.charCodeAt(o+1)),n=2):r<240?(t=4096*(15&r)+64*(63&e.charCodeAt(o+1))+(63&e.charCodeAt(o+2)),n=3):(n=4,t=262144*(7&r)+4096*(63&e.charCodeAt(o+1))+64*(63&e.charCodeAt(o+2))+(63&e.charCodeAt(o+3)),i=55296+((t-=65536)>>>10&1023),t=56320+(1023&t)),0!==i&&(a[s++]=255&i,a[s++]=i>>>8,i=0),a[s++]=t%256,a[s++]=t>>>8;return a.slice(0,s).toString("ucs2")}function Nt(e){return ce(e,"binary").toString("utf8")}var Ft,Dt,Pt,Lt="foo bar bazâð£",Mt=se&&(Nt(Lt)==Ot(Lt)?Nt:It(Lt)==Ot(Lt)&&It)||Ot,Ut=se?function(e){return ce(e,"utf8").toString("binary")}:function(e){for(var t,r=[],a=0,n=0;a<e.length;)switch(!0){case(n=e.charCodeAt(a++))<128:r.push(String.fromCharCode(n));break;case n<2048:r.push(String.fromCharCode(192+(n>>6))),r.push(String.fromCharCode(128+(63&n)));break;case 55296<=n&&n<57344:n-=55296,t=e.charCodeAt(a++)-56320+(n<<10),r.push(String.fromCharCode(240+(t>>18&7))),r.push(String.fromCharCode(144+(t>>12&63))),r.push(String.fromCharCode(128+(t>>6&63))),r.push(String.fromCharCode(128+(63&t)));break;default:r.push(String.fromCharCode(224+(n>>12))),r.push(String.fromCharCode(128+(n>>6&63))),r.push(String.fromCharCode(128+(63&n)))}return r.join("")},Bt=(Ft={},function(e,t){var r=e+"|"+(t||"");return Ft[r]||(Ft[r]=new RegExp("<(?:\\w+:)?"+e+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+e+">",t||""))}),Wt=(Dt=[["nbsp"," "],["middot","·"],["quot",'"'],["apos","'"],["gt",">"],["lt","<"],["amp","&"]].map(function(e){return[new RegExp("&"+e[0]+";","ig"),e[1]]}),function(e){for(var t=e.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/>\s+/g,">").replace(/\s+</g,"<").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,""),r=0;r<Dt.length;++r)t=t.replace(Dt[r][0],Dt[r][1]);return t}),Ht=(Pt={},function(e){return void 0!==Pt[e]?Pt[e]:Pt[e]=new RegExp("<(?:vt:)?"+e+">([\\s\\S]*?)</(?:vt:)?"+e+">","g")}),zt=/<\/?(?:vt:)?variant>/g,Vt=/<(?:vt:)([^>]*)>([\s\S]*)</;function Gt(e,t){var r=dt(e),e=e.match(Ht(r.baseType))||[],a=[];if(e.length==r.size)return e.forEach(function(e){e=e.replace(zt,"").match(Vt);e&&a.push({v:Mt(e[2]),t:e[1]})}),a;if(t.WTF)throw new Error("unexpected vector length "+e.length+" != "+r.size);return a}var jt=/(^\s|\s$|\n)/;function $t(e,t){return"<"+e+(t.match(jt)?' xml:space="preserve"':"")+">"+t+"</"+e+">"}function Xt(t){return Re(t).map(function(e){return" "+e+'="'+t[e]+'"'}).join("")}function Yt(e,t,r){return"<"+e+(null!=r?Xt(r):"")+(null!=t?(t.match(jt)?' xml:space="preserve"':"")+">"+t+"</"+e:"/")+">"}function Kt(e,t){try{return e.toISOString().replace(/\.\d*/,"")}catch(e){if(t)throw e}return""}function Jt(e){if(se&&Buffer.isBuffer(e))return e.toString("utf8");if("string"==typeof e)return e;if("undefined"!=typeof Uint8Array&&e instanceof Uint8Array)return Mt(i(m(e)));throw new Error("Bad input format: expected Buffer or string")}var qt=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/gm,Zt={CORE_PROPS:"http://schemas.openxmlformats.org/package/2006/metadata/core-properties",CUST_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",EXT_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",CT:"http://schemas.openxmlformats.org/package/2006/content-types",RELS:"http://schemas.openxmlformats.org/package/2006/relationships",TCMNT:"http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"},Qt=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"],er={o:"urn:schemas-microsoft-com:office:office",x:"urn:schemas-microsoft-com:office:excel",ss:"urn:schemas-microsoft-com:office:spreadsheet",dt:"uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",mv:"http://macVmlSchemaUri",v:"urn:schemas-microsoft-com:vml",html:"http://www.w3.org/TR/REC-html40"};function tr(e){for(var t=[],r=0;r<e[0].length;++r)if(e[0][r])for(var a=0,n=e[0][r].length;a<n;a+=10240)t.push.apply(t,e[0][r].slice(a,a+10240));return t}function rr(e,t,r){for(var a=[],n=t;n<r;n+=2)a.push(String.fromCharCode(yr(e,n)));return a.join("").replace(de,"")}function ar(e,t,r){for(var a=[],n=t;n<t+r;++n)a.push(("0"+e[n].toString(16)).slice(-2));return a.join("")}function nr(e,t,r){for(var a=[],n=t;n<r;n++)a.push(String.fromCharCode(kr(e,n)));return a.join("")}function sr(e,t){var r=_r(e,t);return 0<r?pr(e,t+4,t+4+r-1):""}function ir(e,t){var r=_r(e,t);return 0<r?pr(e,t+4,t+4+r-1):""}function or(e,t){var r=2*_r(e,t);return 0<r?pr(e,t+4,t+4+r-1):""}function cr(e,t){var r=_r(e,t);return 0<r?ur(e,t+4,t+4+r):""}function lr(e,t){var r=_r(e,t);return 0<r?pr(e,t+4,t+4+r):""}function fr(e,t){for(var r=1-2*(e[t+7]>>>7),a=((127&e[t+7])<<4)+(e[t+6]>>>4&15),n=15&e[t+6],s=5;0<=s;--s)n=256*n+e[t+s];return 2047==a?0==n?1/0*r:NaN:(0==a?a=-1022:(a-=1023,n+=Math.pow(2,52)),r*Math.pow(2,a-52)*n)}var hr=se?function(e){return 0<e[0].length&&Buffer.isBuffer(e[0][0])?Buffer.concat(e[0].map(function(e){return Buffer.isBuffer(e)?e:ce(e)})):tr(e)}:tr,ur=se?function(e,t,r){return Buffer.isBuffer(e)?e.toString("utf16le",t,r).replace(de,""):rr(e,t,r)}:rr,dr=se?function(e,t,r){return Buffer.isBuffer(e)?e.toString("hex",t,t+r):ar(e,t,r)}:ar,pr=se?function(e,t,r){return Buffer.isBuffer(e)?e.toString("utf8",t,r):nr(e,t,r)}:nr,mr=sr,gr=ir,br=or,vr=cr,wr=lr,Tr=fr,Er=function(e){return Array.isArray(e)||"undefined"!=typeof Uint8Array&&e instanceof Uint8Array};se&&(mr=function(e,t){if(!Buffer.isBuffer(e))return sr(e,t);var r=e.readUInt32LE(t);return 0<r?e.toString("utf8",t+4,t+4+r-1):""},gr=function(e,t){if(!Buffer.isBuffer(e))return ir(e,t);var r=e.readUInt32LE(t);return 0<r?e.toString("utf8",t+4,t+4+r-1):""},br=function(e,t){if(!Buffer.isBuffer(e))return or(e,t);var r=2*e.readUInt32LE(t);return e.toString("utf16le",t+4,t+4+r-1)},vr=function(e,t){if(!Buffer.isBuffer(e))return cr(e,t);var r=e.readUInt32LE(t);return e.toString("utf16le",t+4,t+4+r)},wr=function(e,t){if(!Buffer.isBuffer(e))return lr(e,t);var r=e.readUInt32LE(t);return e.toString("utf8",t+4,t+4+r)},Tr=function(e,t){return Buffer.isBuffer(e)?e.readDoubleLE(t):fr(e,t)},Er=function(e){return Buffer.isBuffer(e)||Array.isArray(e)||"undefined"!=typeof Uint8Array&&e instanceof Uint8Array}),void 0!==re&&(ur=function(e,t,r){return re.utils.decode(1200,e.slice(t,r)).replace(de,"")},pr=function(e,t,r){return re.utils.decode(65001,e.slice(t,r))},mr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(_,e.slice(t+4,t+4+r-1)):""},gr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(f,e.slice(t+4,t+4+r-1)):""},br=function(e,t){var r=2*_r(e,t);return 0<r?re.utils.decode(1200,e.slice(t+4,t+4+r-1)):""},vr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(1200,e.slice(t+4,t+4+r)):""},wr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(65001,e.slice(t+4,t+4+r)):""});var kr=function(e,t){return e[t]},yr=function(e,t){return 256*e[t+1]+e[t]},Sr=function(e,t){t=256*e[t+1]+e[t];return t<32768?t:-1*(65535-t+1)},_r=function(e,t){return e[t+3]*(1<<24)+(e[t+2]<<16)+(e[t+1]<<8)+e[t]},xr=function(e,t){return e[t+3]<<24|e[t+2]<<16|e[t+1]<<8|e[t]},Ar=function(e,t){return e[t]<<24|e[t+1]<<16|e[t+2]<<8|e[t+3]};function Cr(e,t){var r,a,n,s,i,o,c="",l=[];switch(t){case"dbcs":if(o=this.l,se&&Buffer.isBuffer(this))c=this.slice(this.l,this.l+2*e).toString("utf16le");else for(i=0;i<e;++i)c+=String.fromCharCode(yr(this,o)),o+=2;e*=2;break;case"utf8":c=pr(this,this.l,this.l+e);break;case"utf16le":e*=2,c=ur(this,this.l,this.l+e);break;case"wstr":if(void 0===re)return Cr.call(this,e,"dbcs");c=re.utils.decode(f,this.slice(this.l,this.l+2*e)),e*=2;break;case"lpstr-ansi":c=mr(this,this.l),e=4+_r(this,this.l);break;case"lpstr-cp":c=gr(this,this.l),e=4+_r(this,this.l);break;case"lpwstr":c=br(this,this.l),e=4+2*_r(this,this.l);break;case"lpp4":e=4+_r(this,this.l),c=vr(this,this.l),2&e&&(e+=2);break;case"8lpp4":e=4+_r(this,this.l),c=wr(this,this.l),3&e&&(e+=4-(3&e));break;case"cstr":for(e=0,c="";0!==(n=kr(this,this.l+e++));)l.push(u(n));c=l.join("");break;case"_wstr":for(e=0,c="";0!==(n=yr(this,this.l+e));)l.push(u(n)),e+=2;e+=2,c=l.join("");break;case"dbcs-cont":for(c="",o=this.l,i=0;i<e;++i){if(this.lens&&-1!==this.lens.indexOf(o))return n=kr(this,o),this.l=o+1,s=Cr.call(this,e-i,n?"dbcs-cont":"sbcs-cont"),l.join("")+s;l.push(u(yr(this,o))),o+=2}c=l.join(""),e*=2;break;case"cpstr":if(void 0!==re){c=re.utils.decode(f,this.slice(this.l,this.l+e));break}case"sbcs-cont":for(c="",o=this.l,i=0;i!=e;++i){if(this.lens&&-1!==this.lens.indexOf(o))return n=kr(this,o),this.l=o+1,s=Cr.call(this,e-i,n?"dbcs-cont":"sbcs-cont"),l.join("")+s;l.push(u(kr(this,o))),o+=1}c=l.join("");break;default:switch(e){case 1:return r=kr(this,this.l),this.l++,r;case 2:return r=("i"===t?Sr:yr)(this,this.l),this.l+=2,r;case 4:case-4:return"i"===t||0==(128&this[this.l+3])?(r=(0<e?xr:Ar)(this,this.l),this.l+=4,r):(a=_r(this,this.l),this.l+=4,a);case 8:case-8:if("f"===t)return a=8==e?Tr(this,this.l):Tr([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0),this.l+=8,a;e=8;case 16:c=dr(this,this.l,e)}}return this.l+=e,c}var Rr=function(e,t,r){e[r]=255&t,e[r+1]=t>>>8&255,e[r+2]=t>>>16&255,e[r+3]=t>>>24&255},Or=function(e,t,r){e[r]=255&t,e[r+1]=t>>8&255,e[r+2]=t>>16&255,e[r+3]=t>>24&255},Ir=function(e,t,r){e[r]=255&t,e[r+1]=t>>>8&255};function Nr(e,t,r){var a=0,n=0;if("dbcs"===r){for(n=0;n!=t.length;++n)Ir(this,t.charCodeAt(n),this.l+2*n);a=2*t.length}else if("sbcs"===r){if(void 0!==re&&874==_)for(n=0;n!=t.length;++n){var s=re.utils.encode(_,t.charAt(n));this[this.l+n]=s[0]}else for(t=t.replace(/[^\x00-\x7F]/g,"_"),n=0;n!=t.length;++n)this[this.l+n]=255&t.charCodeAt(n);a=t.length}else{if("hex"===r){for(;n<e;++n)this[this.l++]=parseInt(t.slice(2*n,2*n+2),16)||0;return this}if("utf16le"===r){for(var i=Math.min(this.l+e,this.length),n=0;n<Math.min(t.length,e);++n){var o=t.charCodeAt(n);this[this.l++]=255&o,this[this.l++]=o>>8}for(;this.l<i;)this[this.l++]=0;return this}switch(e){case 1:a=1,this[this.l]=255&t;break;case 2:a=2,this[this.l]=255&t,t>>>=8,this[this.l+1]=255&t;break;case 3:a=3,this[this.l]=255&t,t>>>=8,this[this.l+1]=255&t,t>>>=8,this[this.l+2]=255&t;break;case 4:a=4,Rr(this,t,this.l);break;case 8:if(a=8,"f"===r){!function(e,t,r){var a=(t<0||1/t==-1/0?1:0)<<7,n=0,s=0,i=a?-t:t;isFinite(i)?0==i?n=s=0:(n=Math.floor(Math.log(i)/Math.LN2),s=i*Math.pow(2,52-n),n<=-1023&&(!isFinite(s)||s<Math.pow(2,52))?n=-1022:(s-=Math.pow(2,52),n+=1023)):(n=2047,s=isNaN(t)?26985:0);for(var o=0;o<=5;++o,s/=256)e[r+o]=255&s;e[r+6]=(15&n)<<4|15&s,e[r+7]=n>>4|a}(this,t,this.l);break}case 16:break;case-4:a=4,Or(this,t,this.l)}}return this.l+=a,this}function Fr(e,t){var r=dr(this,this.l,e.length>>1);if(r!==e)throw new Error(t+"Expected "+e+" saw "+r);this.l+=e.length>>1}function Dr(e,t){e.l=t,e.read_shift=Cr,e.chk=Fr,e.write_shift=Nr}function Pr(e,t){e.l+=t}function Lr(e){e=le(e);return Dr(e,0),e}function Mr(e,t,r){if(e){Dr(e,e.l||0);for(var a,n=e.length,s=0;e.l<n;){128&(s=e.read_shift(1))&&(s=(127&s)+((127&e.read_shift(1))<<7));for(var i,o=Df[s]||Df[65535],c=127&(i=e.read_shift(1)),l=1;l<4&&128&i;++l)c+=(127&(i=e.read_shift(1)))<<7*l;a=e.l+c;var f=o.f&&o.f(e,c,r);if(e.l=a,t(f,o,s))return}}}function Ur(){function t(e){return Dr(e=Lr(e),0),e}function r(){s&&(s.length>s.l&&((s=s.slice(0,s.l)).l=s.length),0<s.length&&e.push(s),s=null)}function a(e){return s&&e<s.length-s.l?s:(r(),s=t(Math.max(e+1,n)))}var e=[],n=se?256:2048,s=t(n);return{next:a,push:function(e){r(),null==(s=e).l&&(s.l=s.length),a(n)},end:function(){return r(),ue(e)},_bufs:e}}function Br(e,t,r,a){var n=+t;if(!isNaN(n)){t=1+(128<=n?1:0)+1,128<=(a=a||(Df[n].p||(r||[]).length||0))&&++t,16384<=a&&++t,2097152<=a&&++t;var s=e.next(t);n<=127?s.write_shift(1,n):(s.write_shift(1,128+(127&n)),s.write_shift(1,n>>7));for(var i=0;4!=i;++i){if(!(128<=a)){s.write_shift(1,a);break}s.write_shift(1,128+(127&a)),a>>=7}0<a&&Er(r)&&e.push(r)}}function Wr(e,t,r){var a=Ve(e);if(t.s?(a.cRel&&(a.c+=t.s.c),a.rRel&&(a.r+=t.s.r)):(a.cRel&&(a.c+=t.c),a.rRel&&(a.r+=t.r)),!r||r.biff<12){for(;256<=a.c;)a.c-=256;for(;65536<=a.r;)a.r-=65536}return a}function Hr(e,t,r){e=Ve(e);return e.s=Wr(e.s,t.s,r),e.e=Wr(e.e,t.s,r),e}function zr(e,t){if(e.cRel&&e.c<0)for(e=Ve(e);e.c<0;)e.c+=8<t?16384:256;if(e.rRel&&e.r<0)for(e=Ve(e);e.r<0;)e.r+=8<t?1048576:5<t?65536:16384;var r=Kr(e);return e.cRel||null==e.cRel||(r=r.replace(/^([A-Z])/,"$$$1")),r=!e.rRel&&null!=e.rRel?r.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"):r}function Vr(e,t){return 0!=e.s.r||e.s.rRel||e.e.r!=(12<=t.biff?1048575:8<=t.biff?65536:16384)||e.e.rRel?0!=e.s.c||e.s.cRel||e.e.c!=(12<=t.biff?16383:255)||e.e.cRel?zr(e.s,t.biff)+":"+zr(e.e,t.biff):(e.s.rRel?"":"$")+jr(e.s.r)+":"+(e.e.rRel?"":"$")+jr(e.e.r):(e.s.cRel?"":"$")+Xr(e.s.c)+":"+(e.e.cRel?"":"$")+Xr(e.e.c)}function Gr(e){return parseInt(e.replace(/\$(\d+)$/,"$1"),10)-1}function jr(e){return""+(e+1)}function $r(e){for(var t=e.replace(/^\$([A-Z])/,"$1"),r=0,a=0;a!==t.length;++a)r=26*r+t.charCodeAt(a)-64;return r-1}function Xr(e){if(e<0)throw new Error("invalid column "+e);var t="";for(++e;e;e=Math.floor((e-1)/26))t=String.fromCharCode((e-1)%26+65)+t;return t}function Yr(e){for(var t=0,r=0,a=0;a<e.length;++a){var n=e.charCodeAt(a);48<=n&&n<=57?t=10*t+(n-48):65<=n&&n<=90&&(r=26*r+(n-64))}return{c:r-1,r:t-1}}function Kr(e){for(var t=e.c+1,r="";t;t=(t-1)/26|0)r=String.fromCharCode((t-1)%26+65)+r;return r+(e.r+1)}function Jr(e){var t=e.indexOf(":");return-1==t?{s:Yr(e),e:Yr(e)}:{s:Yr(e.slice(0,t)),e:Yr(e.slice(t+1))}}function qr(e,t){return void 0===t||"number"==typeof t?qr(e.s,e.e):(e="string"!=typeof e?Kr(e):e)==(t="string"!=typeof t?Kr(t):t)?e:e+":"+t}function Zr(e){for(var t={s:{c:0,r:0},e:{c:0,r:0}},r=0,a=0,n=0,s=e.length,r=0;a<s&&!((n=e.charCodeAt(a)-64)<1||26<n);++a)r=26*r+n;for(t.s.c=--r,r=0;a<s&&!((n=e.charCodeAt(a)-48)<0||9<n);++a)r=10*r+n;if(t.s.r=--r,a===s||10!=n)return t.e.c=t.s.c,t.e.r=t.s.r,t;for(++a,r=0;a!=s&&!((n=e.charCodeAt(a)-64)<1||26<n);++a)r=26*r+n;for(t.e.c=--r,r=0;a!=s&&!((n=e.charCodeAt(a)-48)<0||9<n);++a)r=10*r+n;return t.e.r=--r,t}function Qr(e,t){var r="d"==e.t&&t instanceof Date;if(null!=e.z)try{return e.w=ve(e.z,r?De(t):t)}catch(e){}try{return e.w=ve((e.XF||{}).numFmtId||(r?14:0),r?De(t):t)}catch(e){return""+t}}function ea(e,t,r){return null==e||null==e.t||"z"==e.t?"":void 0!==e.w?e.w:("d"==e.t&&!e.z&&r&&r.dateNF&&(e.z=r.dateNF),"e"==e.t?Wa[e.v]||e.v:Qr(e,null==t?e.v:t))}function ta(e,t){var r=t&&t.sheet?t.sheet:"Sheet1",t={};return t[r]=e,{SheetNames:[r],Sheets:t}}function ra(e,t,r){var a=r||{},n=e?Array.isArray(e):a.dense;null!=oe&&null==n&&(n=oe);var s=e||(n?[]:{}),i=0,o=0;s&&null!=a.origin&&("number"==typeof a.origin?i=a.origin:(i=(c="string"==typeof a.origin?Yr(a.origin):a.origin).r,o=c.c),s["!ref"]||(s["!ref"]="A1:A1"));var c,l={s:{c:1e7,r:1e7},e:{c:0,r:0}};s["!ref"]&&(c=Zr(s["!ref"]),l.s.c=c.s.c,l.s.r=c.s.r,l.e.c=Math.max(l.e.c,c.e.c),l.e.r=Math.max(l.e.r,c.e.r),-1==i&&(l.e.r=i=c.e.r+1));for(var f=0;f!=t.length;++f)if(t[f]){if(!Array.isArray(t[f]))throw new Error("aoa_to_sheet expects an array of arrays");for(var h=0;h!=t[f].length;++h)if(void 0!==t[f][h]){var u={v:t[f][h]},d=i+f,p=o+h;if(l.s.r>d&&(l.s.r=d),l.s.c>p&&(l.s.c=p),l.e.r<d&&(l.e.r=d),l.e.c<p&&(l.e.c=p),!t[f][h]||"object"!=typeof t[f][h]||Array.isArray(t[f][h])||t[f][h]instanceof Date)if(Array.isArray(u.v)&&(u.f=t[f][h][1],u.v=u.v[0]),null===u.v)if(u.f)u.t="n";else if(a.nullError)u.t="e",u.v=0;else{if(!a.sheetStubs)continue;u.t="z"}else"number"==typeof u.v?u.t="n":"boolean"==typeof u.v?u.t="b":u.v instanceof Date?(u.z=a.dateNF||me[14],a.cellDates?(u.t="d",u.w=ve(u.z,De(u.v))):(u.t="n",u.v=De(u.v),u.w=ve(u.z,u.v))):u.t="s";else u=t[f][h];n?(s[d]||(s[d]=[]),s[d][p]&&s[d][p].z&&(u.z=s[d][p].z),s[d][p]=u):(s[d=Kr({c:p,r:d})]&&s[d].z&&(u.z=s[d].z),s[d]=u)}}return l.s.c<1e7&&(s["!ref"]=qr(l)),s}function aa(e,t){return ra(null,e,t)}function na(e,t){return(t=t||Lr(4)).write_shift(4,e),t}function sa(e){var t=e.read_shift(4);return 0===t?"":e.read_shift(t,"dbcs")}function ia(e,t){var r=!1;return null==t&&(r=!0,t=Lr(4+2*e.length)),t.write_shift(4,e.length),0<e.length&&t.write_shift(0,e,"dbcs"),r?t.slice(0,t.l):t}function oa(e,t){var r,a=e.l,n=e.read_shift(1),s=sa(e),i=[],s={t:s,h:s};if(0!=(1&n)){for(var o=e.read_shift(4),c=0;c!=o;++c)i.push({ich:(r=e).read_shift(2),ifnt:r.read_shift(2)});s.r=i}else s.r=[{ich:0,ifnt:0}];return e.l=a+t,s}var ca=oa;function la(e,t){var r,a=!1;return null==t&&(a=!0,t=Lr(23+4*e.t.length)),t.write_shift(1,1),ia(e.t,t),t.write_shift(4,1),r={ich:0,ifnt:0},(e=(e=t)||Lr(4)).write_shift(2,r.ich||0),e.write_shift(2,r.ifnt||0),a?t.slice(0,t.l):t}function fa(e){var t=e.read_shift(4),r=e.read_shift(2);return r+=e.read_shift(1)<<16,e.l++,{c:t,iStyleRef:r}}function ha(e,t){return(t=null==t?Lr(8):t).write_shift(-4,e.c),t.write_shift(3,e.iStyleRef||e.s),t.write_shift(1,0),t}function ua(e){var t=e.read_shift(2);return t+=e.read_shift(1)<<16,e.l++,{c:-1,iStyleRef:t}}function da(e,t){return(t=null==t?Lr(4):t).write_shift(3,e.iStyleRef||e.s),t.write_shift(1,0),t}var pa=sa,ma=ia;function ga(e){var t=e.read_shift(4);return 0===t||4294967295===t?"":e.read_shift(t,"dbcs")}function ba(e,t){var r=!1;return null==t&&(r=!0,t=Lr(127)),t.write_shift(4,0<e.length?e.length:4294967295),0<e.length&&t.write_shift(0,e,"dbcs"),r?t.slice(0,t.l):t}var va=sa,wa=ga,Ta=ba;function Ea(e){var t=e.slice(e.l,e.l+4),r=1&t[0],a=2&t[0];e.l+=4;t=0==a?Tr([0,0,0,0,252&t[0],t[1],t[2],t[3]],0):xr(t,0)>>2;return r?t/100:t}function ka(e,t){null==t&&(t=Lr(4));var r=0,a=0,n=100*e;if(e==(0|e)&&-(1<<29)<=e&&e<1<<29?a=1:n==(0|n)&&-(1<<29)<=n&&n<1<<29&&(r=a=1),!a)throw new Error("unsupported RkNumber "+e);t.write_shift(-4,((r?n:e)<<2)+(r+2))}function ya(e){var t={s:{},e:{}};return t.s.r=e.read_shift(4),t.e.r=e.read_shift(4),t.s.c=e.read_shift(4),t.e.c=e.read_shift(4),t}var Sa=ya,_a=function(e,t){return(t=t||Lr(16)).write_shift(4,e.s.r),t.write_shift(4,e.e.r),t.write_shift(4,e.s.c),t.write_shift(4,e.e.c),t};function xa(e){if(e.length-e.l<8)throw"XLS Xnum Buffer underflow";return e.read_shift(8,"f")}function Aa(e,t){return(t||Lr(8)).write_shift(8,e,"f")}function Ca(e,t){if(t=t||Lr(8),!e||e.auto)return t.write_shift(4,0),t.write_shift(4,0),t;null!=e.index?(t.write_shift(1,2),t.write_shift(1,e.index)):null!=e.theme?(t.write_shift(1,6),t.write_shift(1,e.theme)):(t.write_shift(1,5),t.write_shift(1,0));var r=e.tint||0;return 0<r?r*=32767:r<0&&(r*=32768),t.write_shift(2,r),e.rgb&&null==e.theme?("number"==typeof(e=e.rgb||"FFFFFF")&&(e=("000000"+e.toString(16)).slice(-6)),t.write_shift(1,parseInt(e.slice(0,2),16)),t.write_shift(1,parseInt(e.slice(2,4),16)),t.write_shift(1,parseInt(e.slice(4,6),16)),t.write_shift(1,255)):(t.write_shift(2,0),t.write_shift(1,0),t.write_shift(1,0)),t}function Ra(e,t){var r=e.read_shift(4);switch(r){case 0:return"";case 4294967295:case 4294967294:return{2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"}[e.read_shift(4)]||""}if(400<r)throw new Error("Unsupported Clipboard: "+r.toString(16));return e.l-=4,e.read_shift(0,1==t?"lpstr":"lpwstr")}var Oa=2,Ia=3,Na=12,Fa=81,Da=[80,Fa],Pa={1:{n:"CodePage",t:Oa},2:{n:"Category",t:80},3:{n:"PresentationFormat",t:80},4:{n:"ByteCount",t:Ia},5:{n:"LineCount",t:Ia},6:{n:"ParagraphCount",t:Ia},7:{n:"SlideCount",t:Ia},8:{n:"NoteCount",t:Ia},9:{n:"HiddenCount",t:Ia},10:{n:"MultimediaClipCount",t:Ia},11:{n:"ScaleCrop",t:11},12:{n:"HeadingPairs",t:4108},13:{n:"TitlesOfParts",t:4126},14:{n:"Manager",t:80},15:{n:"Company",t:80},16:{n:"LinksUpToDate",t:11},17:{n:"CharacterCount",t:Ia},19:{n:"SharedDoc",t:11},22:{n:"HyperlinksChanged",t:11},23:{n:"AppVersion",t:Ia,p:"version"},24:{n:"DigSig",t:65},26:{n:"ContentType",t:80},27:{n:"ContentStatus",t:80},28:{n:"Language",t:80},29:{n:"Version",t:80},255:{},2147483648:{n:"Locale",t:19},2147483651:{n:"Behavior",t:19},1919054434:{}},La={1:{n:"CodePage",t:Oa},2:{n:"Title",t:80},3:{n:"Subject",t:80},4:{n:"Author",t:80},5:{n:"Keywords",t:80},6:{n:"Comments",t:80},7:{n:"Template",t:80},8:{n:"LastAuthor",t:80},9:{n:"RevNumber",t:80},10:{n:"EditTime",t:64},11:{n:"LastPrinted",t:64},12:{n:"CreatedDate",t:64},13:{n:"ModifiedDate",t:64},14:{n:"PageCount",t:Ia},15:{n:"WordCount",t:Ia},16:{n:"CharCount",t:Ia},17:{n:"Thumbnail",t:71},18:{n:"Application",t:80},19:{n:"DocSecurity",t:Ia},255:{},2147483648:{n:"Locale",t:19},2147483651:{n:"Behavior",t:19},1919054434:{}},Ma={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"},Ua=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var Ba=Ve([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0].map(function(e){return[e>>16&255,e>>8&255,255&e]})),Wa={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"},Ha={"#NULL!":0,"#DIV/0!":7,"#VALUE!":15,"#REF!":23,"#NAME?":29,"#NUM!":36,"#N/A":42,"#GETTING_DATA":43,"#WTF?":255},za={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.sheet.macroEnabled.main+xml":"workbooks","application/vnd.ms-excel.sheet.binary.macroEnabled.main":"workbooks","application/vnd.ms-excel.addin.macroEnabled.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":"sheets","application/vnd.ms-excel.worksheet":"sheets","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":"charts","application/vnd.ms-excel.chartsheet":"charts","application/vnd.ms-excel.macrosheet+xml":"macros","application/vnd.ms-excel.macrosheet":"macros","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":"dialogs","application/vnd.ms-excel.dialogsheet":"dialogs","application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml":"strs","application/vnd.ms-excel.sharedStrings":"strs","application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":"styles","application/vnd.ms-excel.styles":"styles","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":"comments","application/vnd.ms-excel.comments":"comments","application/vnd.ms-excel.threadedcomments+xml":"threadedcomments","application/vnd.ms-excel.person+xml":"people","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"metadata","application/vnd.ms-excel.sheetMetadata":"metadata","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-office.chartex+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"TODO","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO",sheet:"js"},Va={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},metadata:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",xlsb:"application/vnd.ms-excel.sheetMetadata"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};function Ga(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],threadedcomments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],metadata:[],people:[],TODO:[],xmlns:""}}function ja(r,a){var t,n=function(e){for(var t=[],r=Re(e),a=0;a!==r.length;++a)null==t[e[r[a]]]&&(t[e[r[a]]]=[]),t[e[r[a]]].push(r[a]);return t}(za),s=[];s[s.length]=ot,s[s.length]=Yt("Types",null,{xmlns:Zt.CT,"xmlns:xsd":Zt.xsd,"xmlns:xsi":Zt.xsi}),s=s.concat([["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["vml","application/vnd.openxmlformats-officedocument.vmlDrawing"],["data","application/vnd.openxmlformats-officedocument.model+data"],["bmp","image/bmp"],["png","image/png"],["gif","image/gif"],["emf","image/x-emf"],["wmf","image/x-wmf"],["jpg","image/jpeg"],["jpeg","image/jpeg"],["tif","image/tiff"],["tiff","image/tiff"],["pdf","application/pdf"],["rels","application/vnd.openxmlformats-package.relationships+xml"]].map(function(e){return Yt("Default",null,{Extension:e[0],ContentType:e[1]})}));function e(e){r[e]&&0<r[e].length&&(t=r[e][0],s[s.length]=Yt("Override",null,{PartName:("/"==t[0]?"":"/")+t,ContentType:Va[e][a.bookType]||Va[e].xlsx}))}function i(t){(r[t]||[]).forEach(function(e){s[s.length]=Yt("Override",null,{PartName:("/"==e[0]?"":"/")+e,ContentType:Va[t][a.bookType]||Va[t].xlsx})})}function o(t){(r[t]||[]).forEach(function(e){s[s.length]=Yt("Override",null,{PartName:("/"==e[0]?"":"/")+e,ContentType:n[t][0]})})}return e("workbooks"),i("sheets"),i("charts"),o("themes"),["strs","styles"].forEach(e),["coreprops","extprops","custprops"].forEach(o),o("vba"),o("comments"),o("threadedcomments"),o("drawings"),i("metadata"),o("people"),2<s.length&&(s[s.length]="</Types>",s[1]=s[1].replace("/>",">")),s.join("")}var $a={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",CMNT:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",CORE_PROPS:"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",EXT_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",CUST_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",SST:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",STY:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",THEME:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",CHART:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",CHARTEX:"http://schemas.microsoft.com/office/2014/relationships/chartEx",CS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",WS:["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"],DS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",MS:"http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",IMG:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",DRAW:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",XLMETA:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",TCMNT:"http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",PEOPLE:"http://schemas.microsoft.com/office/2017/10/relationships/person",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function Xa(e){var t=e.lastIndexOf("/");return e.slice(0,t+1)+"_rels/"+e.slice(t+1)+".rels"}function Ya(e,a){var n={"!id":{}};if(!e)return n;"/"!==a.charAt(0)&&(a="/"+a);var s={};return(e.match(ft)||[]).forEach(function(e){var t,r=dt(e);"<Relationship"===r[0]&&((t={}).Type=r.Type,t.Target=r.Target,t.Id=r.Id,r.TargetMode&&(t.TargetMode=r.TargetMode),e="External"===r.TargetMode?r.Target:it(r.Target,a),n[e]=t,s[r.Id]=t)}),n["!id"]=s,n}function Ka(t){var r=[ot,Yt("Relationships",null,{xmlns:Zt.RELS})];return Re(t["!id"]).forEach(function(e){r[r.length]=Yt("Relationship",null,t["!id"][e])}),2<r.length&&(r[r.length]="</Relationships>",r[1]=r[1].replace("/>",">")),r.join("")}function Ja(e,t,r,a,n,s){if(n=n||{},e["!id"]||(e["!id"]={}),e["!idx"]||(e["!idx"]=1),t<0)for(t=e["!idx"];e["!id"]["rId"+t];++t);if(e["!idx"]=t+1,n.Id="rId"+t,n.Type=a,n.Target=r,s?n.TargetMode=s:-1<[$a.HLINK,$a.XPATH,$a.XMISS].indexOf(n.Type)&&(n.TargetMode="External"),e["!id"][n.Id])throw new Error("Cannot rewrite rId "+t);return e["!id"][n.Id]=n,e[("/"+n.Target).replace("//","/")]=n,t}var qa="application/vnd.oasis.opendocument.spreadsheet";function Za(e,t,r){return['  <rdf:Description rdf:about="'+e+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(r||"odf")+"#"+t+'"/>\n',"  </rdf:Description>\n"].join("")}function Qa(){return'<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS '+a.version+"</meta:generator></office:meta></office:document-meta>"}var en=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]],tn=function(){for(var e=new Array(en.length),t=0;t<en.length;++t){var r=en[t],r="(?:"+r[0].slice(0,r[0].indexOf(":"))+":)"+r[0].slice(r[0].indexOf(":")+1);e[t]=new RegExp("<"+r+"[^>]*>([\\s\\S]*?)</"+r+">")}return e}();function rn(e){var t={};e=Mt(e);for(var r=0;r<en.length;++r){var a=en[r],n=e.match(tn[r]);null!=n&&0<n.length&&(t[a[1]]=wt(n[1])),"date"===a[2]&&t[a[1]]&&(t[a[1]]=He(t[a[1]]))}return t}function an(e,t,r,a,n){null==n[e]&&null!=t&&""!==t&&(t=kt(n[e]=t),a[a.length]=r?Yt(e,t,r):$t(e,t))}function nn(e,t){var r=t||{},a=[ot,Yt("cp:coreProperties",null,{"xmlns:cp":Zt.CORE_PROPS,"xmlns:dc":Zt.dc,"xmlns:dcterms":Zt.dcterms,"xmlns:dcmitype":Zt.dcmitype,"xmlns:xsi":Zt.xsi})],n={};if(!e&&!r.Props)return a.join("");e&&(null!=e.CreatedDate&&an("dcterms:created","string"==typeof e.CreatedDate?e.CreatedDate:Kt(e.CreatedDate,r.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n),null!=e.ModifiedDate&&an("dcterms:modified","string"==typeof e.ModifiedDate?e.ModifiedDate:Kt(e.ModifiedDate,r.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n));for(var s=0;s!=en.length;++s){var i=en[s],o=r.Props&&null!=r.Props[i[1]]?r.Props[i[1]]:e?e[i[1]]:null;!0===o?o="1":!1===o?o="0":"number"==typeof o&&(o=String(o)),null!=o&&an(i[0],o,null,a,n)}return 2<a.length&&(a[a.length]="</cp:coreProperties>",a[1]=a[1].replace("/>",">")),a.join("")}var sn=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]],on=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function cn(e,t,r,a){var n=[];if("string"==typeof e)n=Gt(e,a);else for(var s=0;s<e.length;++s)n=n.concat(e[s].map(function(e){return{v:e}}));var i,o="string"==typeof t?Gt(t,a).map(function(e){return e.v}):t,c=0;if(0<o.length)for(var l=0;l!==n.length;l+=2){switch(i=+n[l+1].v,n[l].v){case"Worksheets":case"工作表":case"Листы":case"أوراق العمل":case"ワークシート":case"גליונות עבודה":case"Arbeitsblätter":case"Çalışma Sayfaları":case"Feuilles de calcul":case"Fogli di lavoro":case"Folhas de cálculo":case"Planilhas":case"Regneark":case"Hojas de cálculo":case"Werkbladen":r.Worksheets=i,r.SheetNames=o.slice(c,c+i);break;case"Named Ranges":case"Rangos con nombre":case"名前付き一覧":case"Benannte Bereiche":case"Navngivne områder":r.NamedRanges=i,r.DefinedNames=o.slice(c,c+i);break;case"Charts":case"Diagramme":r.Chartsheets=i,r.ChartNames=o.slice(c,c+i)}c+=i}}function ln(r){var a=[],n=Yt;return(r=r||{}).Application="SheetJS",a[a.length]=ot,a[a.length]=Yt("Properties",null,{xmlns:Zt.EXT_PROPS,"xmlns:vt":Zt.vt}),sn.forEach(function(e){if(void 0!==r[e[1]]){var t;switch(e[2]){case"string":t=kt(String(r[e[1]]));break;case"bool":t=r[e[1]]?"true":"false"}void 0!==t&&(a[a.length]=n(e[0],t))}}),a[a.length]=n("HeadingPairs",n("vt:vector",n("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+n("vt:variant",n("vt:i4",String(r.Worksheets))),{size:2,baseType:"variant"})),a[a.length]=n("TitlesOfParts",n("vt:vector",r.SheetNames.map(function(e){return"<vt:lpstr>"+kt(e)+"</vt:lpstr>"}).join(""),{size:r.Worksheets,baseType:"lpstr"})),2<a.length&&(a[a.length]="</Properties>",a[1]=a[1].replace("/>",">")),a.join("")}var fn=/<[^>]+>[^<]*/g;function hn(t){var r=[ot,Yt("Properties",null,{xmlns:Zt.CUST_PROPS,"xmlns:vt":Zt.vt})];if(!t)return r.join("");var a=1;return Re(t).forEach(function(e){++a,r[r.length]=Yt("property",function(e,t){switch(typeof e){case"string":var r=Yt("vt:lpwstr",kt(e));return r=t?r.replace(/&quot;/g,"_x0022_"):r;case"number":return Yt((0|e)==e?"vt:i4":"vt:r8",kt(String(e)));case"boolean":return Yt("vt:bool",e?"true":"false")}if(e instanceof Date)return Yt("vt:filetime",Kt(e));throw new Error("Unable to serialize "+e)}(t[e],!0),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:a,name:kt(e)})}),2<r.length&&(r[r.length]="</Properties>",r[1]=r[1].replace("/>",">")),r.join("")}var un,dn={Title:"Title",Subject:"Subject",Author:"Author",Keywords:"Keywords",Comments:"Description",LastAuthor:"LastAuthor",RevNumber:"Revision",Application:"AppName",LastPrinted:"LastPrinted",CreatedDate:"Created",ModifiedDate:"LastSaved",Category:"Category",Manager:"Manager",Company:"Company",AppVersion:"Version",ContentStatus:"ContentStatus",Identifier:"Identifier",Language:"Language"};function pn(e){var t=e.read_shift(4),e=e.read_shift(4);return new Date(1e3*(e/1e7*Math.pow(2,32)+t/1e7-11644473600)).toISOString().replace(/\.000/,"")}function mn(e,t,r){var a=e.l,n=e.read_shift(0,"lpstr-cp");if(r)for(;e.l-a&3;)++e.l;return n}function gn(e,t,r){var a=e.read_shift(0,"lpwstr");return r&&(e.l+=4-(a.length+1&3)&3),a}function bn(e,t,r){return 31===t?gn(e):mn(e,0,r)}function vn(e,t,r){return bn(e,t,!1===r?0:4)}function wn(e){for(var t,r,a,n=e.read_shift(4),s=[],i=0;i<n/2;++i)s.push((a=r=void 0,r=(t=e).l,a=kn(t,Fa),0==t[t.l]&&0==t[t.l+1]&&t.l-r&2&&(t.l+=2),[a,kn(t,Ia)]));return s}function Tn(e,t){for(var r=e.read_shift(4),a={},n=0;n!=r;++n){var s=e.read_shift(4),i=e.read_shift(4);a[s]=e.read_shift(i,1200===t?"utf16le":"utf8").replace(de,"").replace(pe,"!"),1200===t&&i%2&&(e.l+=2)}return 3&e.l&&(e.l=e.l>>3<<2),a}function En(e){var t=e.read_shift(4),r=e.slice(e.l,e.l+t);return e.l+=t,0<(3&t)&&(e.l+=4-(3&t)&3),r}function kn(e,t,r){var a,n,s=e.read_shift(2),i=r||{};if(e.l+=2,t!==Na&&s!==t&&-1===Da.indexOf(t)&&(4126!=(65534&t)||4126!=(65534&s)))throw new Error("Expected type "+t+" saw "+s);switch(t===Na?s:t){case 2:return a=e.read_shift(2,"i"),i.raw||(e.l+=2),a;case 3:return a=e.read_shift(4,"i");case 11:return 0!==e.read_shift(4);case 19:return a=e.read_shift(4);case 30:return mn(e,0,4).replace(de,"");case 31:return gn(e);case 64:return pn(e);case 65:return En(e);case 71:return(n={}).Size=(a=e).read_shift(4),a.l+=n.Size+3-(n.Size-1)%4,n;case 80:return vn(e,s,!i.raw).replace(de,"");case 81:return function(e,t){if(!t)throw new Error("VtUnalignedString must have positive length");return bn(e,t,0)}(e,s).replace(de,"");case 4108:return wn(e);case 4126:case 4127:return(4127==s?function(e){for(var t=e.read_shift(4),r=[],a=0;a!=t;++a){var n=e.l;r[a]=e.read_shift(0,"lpwstr").replace(de,""),e.l-n&2&&(e.l+=2)}return r}:function(e){for(var t=e.read_shift(4),r=[],a=0;a!=t;++a)r[a]=e.read_shift(0,"lpstr-cp").replace(de,"");return r})(e);default:throw new Error("TypedPropertyValue unrecognized type "+t+" "+s)}}function yn(e,t){var r,a,n,s=Lr(4),i=Lr(4);switch(s.write_shift(4,80==e?31:e),e){case 3:i.write_shift(-4,t);break;case 5:(i=Lr(8)).write_shift(8,t,"f");break;case 11:i.write_shift(4,t?1:0);break;case 64:a=("string"==typeof(r=t)?new Date(Date.parse(r)):r).getTime()/1e3+11644473600,n=a%Math.pow(2,32),r=(a-n)/Math.pow(2,32),r*=1e7,0<(a=(n*=1e7)/Math.pow(2,32)|0)&&(n%=Math.pow(2,32),r+=a),(a=Lr(8)).write_shift(4,n),a.write_shift(4,r),i=a;break;case 31:case 80:for((i=Lr(4+2*(t.length+1)+(t.length%2?0:2))).write_shift(4,t.length+1),i.write_shift(0,t,"dbcs");i.l!=i.length;)i.write_shift(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+e+" "+t)}return ue([s,i])}function Sn(e,t){for(var r=e.l,a=e.read_shift(4),n=e.read_shift(4),s=[],i=0,o=0,c=-1,l={},i=0;i!=n;++i){var f=e.read_shift(4),h=e.read_shift(4);s[i]=[f,h+r]}s.sort(function(e,t){return e[1]-t[1]});var u={};for(i=0;i!=n;++i){if(e.l!==s[i][1]){var d=!0;if(0<i&&t)switch(t[s[i-1][0]].t){case 2:e.l+2===s[i][1]&&(e.l+=2,d=!1);break;case 80:case 4108:e.l<=s[i][1]&&(e.l=s[i][1],d=!1)}if((!t||0==i)&&e.l<=s[i][1]&&(d=!1,e.l=s[i][1]),d)throw new Error("Read Error: Expected address "+s[i][1]+" at "+e.l+" :"+i)}if(t){var p=t[s[i][0]];if(u[p.n]=kn(e,p.t,{raw:!0}),"version"===p.p&&(u[p.n]=String(u[p.n]>>16)+"."+("0000"+String(65535&u[p.n])).slice(-4)),"CodePage"==p.n)switch(u[p.n]){case 0:u[p.n]=1252;case 874:case 932:case 936:case 949:case 950:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 1e4:case 1200:case 1201:case 1252:case 65e3:case-536:case 65001:case-535:ie(o=u[p.n]>>>0&65535);break;default:throw new Error("Unsupported CodePage: "+u[p.n])}}else if(1===s[i][0]){o=u.CodePage=kn(e,Oa);ie(o),-1!==c&&(g=e.l,e.l=s[c][1],l=Tn(e,o),e.l=g)}else if(0===s[i][0])0!==o?l=Tn(e,o):(c=i,e.l=s[i+1][1]);else{var m,g=l[s[i][0]];switch(e[e.l]){case 65:e.l+=4,m=En(e);break;case 30:case 31:e.l+=4,m=vn(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 3:e.l+=4,m=e.read_shift(4,"i");break;case 19:e.l+=4,m=e.read_shift(4);break;case 5:e.l+=4,m=e.read_shift(8,"f");break;case 11:e.l+=4,m=On(e,4);break;case 64:e.l+=4,m=He(pn(e));break;default:throw new Error("unparsed value: "+e[e.l])}u[g]=m}}return e.l=r+a,u}var _n=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"];function xn(e,t,r){var a,n,s,i,o=Lr(8),c=[],l=[],f=8,h=0,u=Lr(8),d=Lr(8);if(u.write_shift(4,2),u.write_shift(4,1200),d.write_shift(4,1),l.push(u),c.push(d),f+=8+u.length,!t){(d=Lr(8)).write_shift(4,0),c.unshift(d);var p=[Lr(4)];for(p[0].write_shift(4,e.length),h=0;h<e.length;++h){var m=e[h][0];for((u=Lr(8+2*(m.length+1)+(m.length%2?0:2))).write_shift(4,h+2),u.write_shift(4,m.length+1),u.write_shift(0,m,"dbcs");u.l!=u.length;)u.write_shift(1,0);p.push(u)}u=ue(p),l.unshift(u),f+=8+u.length}for(h=0;h<e.length;++h)t&&!t[e[h][0]]||-1<_n.indexOf(e[h][0])||-1<on.indexOf(e[h][0])||null!=e[h][1]&&(s=e[h][1],a=0,u=t?("version"==(i=r[a=+t[e[h][0]]]).p&&"string"==typeof s&&(s=(+(n=s.split("."))[0]<<16)+(+n[1]||0)),yn(i.t,s)):(-1==(i=function(e){switch(typeof e){case"boolean":return 11;case"number":return(0|e)==e?3:5;case"string":return 31;case"object":if(e instanceof Date)return 64}return-1}(s))&&(i=31,s=String(s)),yn(i,s)),l.push(u),(d=Lr(8)).write_shift(4,t?a:2+h),c.push(d),f+=8+u.length);for(var g=8*(l.length+1),h=0;h<l.length;++h)c[h].write_shift(4,g),g+=l[h].length;return o.write_shift(4,f),o.write_shift(4,l.length),ue([o].concat(c).concat(l))}function An(e,t,r){var a=e.content;if(!a)return{};Dr(a,0);var n,s=0;a.chk("feff","Byte Order: "),a.read_shift(2);var i=a.read_shift(4),o=a.read_shift(16);if(o!==xe.utils.consts.HEADER_CLSID&&o!==r)throw new Error("Bad PropertySet CLSID "+o);if(1!==(e=a.read_shift(4))&&2!==e)throw new Error("Unrecognized #Sets: "+e);if(r=a.read_shift(16),o=a.read_shift(4),1===e&&o!==a.l)throw new Error("Length mismatch: "+o+" !== "+a.l);2===e&&(n=a.read_shift(16),s=a.read_shift(4));var c,l,f=Sn(a,t),h={SystemIdentifier:i};for(c in f)h[c]=f[c];if(h.FMTID=r,1===e)return h;if(s-a.l==2&&(a.l+=2),a.l!==s)throw new Error("Length mismatch 2: "+a.l+" !== "+s);try{l=Sn(a,null)}catch(e){}for(c in l)h[c]=l[c];return h.FMTID=[r,n],h}function Cn(e,t,r,a,n,s){var i=Lr(n?68:48),o=[i];i.write_shift(2,65534),i.write_shift(2,0),i.write_shift(4,842412599),i.write_shift(16,xe.utils.consts.HEADER_CLSID,"hex"),i.write_shift(4,n?2:1),i.write_shift(16,t,"hex"),i.write_shift(4,n?68:48);a=xn(e,r,a);return o.push(a),n&&(n=xn(n,null,null),i.write_shift(16,s,"hex"),i.write_shift(4,68+a.length),o.push(n)),ue(o)}function Rn(e,t){return e.read_shift(t),null}function On(e,t){return 1===e.read_shift(t)}function In(e,t){return(t=t||Lr(2)).write_shift(2,+!!e),t}function Nn(e){return e.read_shift(2,"u")}function Fn(e,t){return(t=t||Lr(2)).write_shift(2,e),t}function Dn(e,t){return function(e,t,r){for(var a=[],n=e.l+t;e.l<n;)a.push(r(e,n-e.l));if(n!==e.l)throw new Error("Slurp error");return a}(e,t,Nn)}function Pn(e,t,r){return(r=r||Lr(2)).write_shift(1,"e"==t?+e:+!!e),r.write_shift(1,"e"==t?1:0),r}function Ln(e,t,r){var a=e.read_shift(r&&12<=r.biff?2:1),n="sbcs-cont",s=f;r&&8<=r.biff&&(f=1200),r&&8!=r.biff?12==r.biff&&(n="wstr"):e.read_shift(1)&&(n="dbcs-cont"),2<=r.biff&&r.biff<=5&&(n="cpstr");n=a?e.read_shift(a,n):"";return f=s,n}function Mn(e,t,r){if(r){if(2<=r.biff&&r.biff<=5)return e.read_shift(t,"cpstr");if(12<=r.biff)return e.read_shift(t,"dbcs-cont")}return 0===e.read_shift(1)?e.read_shift(t,"sbcs-cont"):e.read_shift(t,"dbcs-cont")}function Un(e,t,r){var a=e.read_shift(r&&2==r.biff?1:2);return 0===a?(e.l++,""):Mn(e,a,r)}function Bn(e,t,r){if(5<r.biff)return Un(e,0,r);var a=e.read_shift(1);return 0===a?(e.l++,""):e.read_shift(a,r.biff<=4||!e.lens?"cpstr":"sbcs-cont")}function Wn(e,t,r){return(r=r||Lr(3+2*e.length)).write_shift(2,e.length),r.write_shift(1,1),r.write_shift(31,e,"utf16le"),r}function Hn(e){var t,r,a,n,s=e.read_shift(16);switch(s){case"e0c9ea79f9bace118c8200aa004ba90b":return r=(t=e).read_shift(4),a=t.l,n=!1,24<r&&(t.l+=r-24,"795881f43b1d7f48af2c825dc4852763"===t.read_shift(16)&&(n=!0),t.l=a),r=t.read_shift((n?r-24:r)>>1,"utf16le").replace(de,""),n&&(t.l+=24),r;case"0303000000000000c000000000000046":return function(e){for(var t=e.read_shift(2),r="";0<t--;)r+="../";var a=e.read_shift(0,"lpstr-ansi");if(e.l+=2,57005!=e.read_shift(2))throw new Error("Bad FileMoniker");if(0===e.read_shift(4))return r+a.replace(/\\/g,"/");if(a=e.read_shift(4),3!=e.read_shift(2))throw new Error("Bad FileMoniker");return r+e.read_shift(a>>1,"utf16le").replace(de,"")}(e);default:throw new Error("Unsupported Moniker "+s)}}function zn(e){var t=e.read_shift(4);return 0<t?e.read_shift(t,"utf16le").replace(de,""):""}function Vn(e,t){(t=t||Lr(6+2*e.length)).write_shift(4,1+e.length);for(var r=0;r<e.length;++r)t.write_shift(2,e.charCodeAt(r));return t.write_shift(2,0),t}function Gn(e){return[e.read_shift(1),e.read_shift(1),e.read_shift(1),e.read_shift(1)]}function jn(e){e=Gn(e);return e[3]=0,e}function $n(e){return{r:e.read_shift(2),c:e.read_shift(2),ixfe:e.read_shift(2)}}function Xn(e,t,r,a){return(a=a||Lr(6)).write_shift(2,e),a.write_shift(2,t),a.write_shift(2,r||0),a}function Yn(e){return[e.read_shift(2),Ea(e)]}function Kn(e){var t=e.read_shift(2),r=e.read_shift(2);return{s:{c:e.read_shift(2),r:t},e:{c:e.read_shift(2),r:r}}}function Jn(e,t){return(t=t||Lr(8)).write_shift(2,e.s.r),t.write_shift(2,e.e.r),t.write_shift(2,e.s.c),t.write_shift(2,e.e.c),t}function qn(e){var t=e.read_shift(2),r=e.read_shift(2);return{s:{c:e.read_shift(1),r:t},e:{c:e.read_shift(1),r:r}}}var Zn=qn;function Qn(e){e.l+=4;var t=e.read_shift(2),r=e.read_shift(2),a=e.read_shift(2);return e.l+=12,[r,t,a]}function es(e){e.l+=2,e.l+=e.read_shift(2)}var ts={0:es,4:es,5:es,6:es,7:function(e){return e.l+=4,e.cf=e.read_shift(2),{}},8:es,9:es,10:es,11:es,12:es,13:function(e){var t={};return e.l+=4,e.l+=16,t.fSharedNote=e.read_shift(2),e.l+=4,t},14:es,15:es,16:es,17:es,18:es,19:es,20:es,21:Qn};function rs(e,t){var r={BIFFVer:0,dt:0};switch(r.BIFFVer=e.read_shift(2),2<=(t-=2)&&(r.dt=e.read_shift(2),e.l-=2),r.BIFFVer){case 1536:case 1280:case 1024:case 768:case 512:case 2:case 7:break;default:if(6<t)throw new Error("Unexpected BIFF Ver "+r.BIFFVer)}return e.read_shift(t),r}function as(e,t,r){var a=1536,n=16;switch(r.bookType){case"biff8":break;case"biff5":a=1280,n=8;break;case"biff4":a=4,n=6;break;case"biff3":a=3,n=6;break;case"biff2":a=2,n=4;break;case"xla":break;default:throw new Error("unsupported BIFF version")}r=Lr(n);return r.write_shift(2,a),r.write_shift(2,t),4<n&&r.write_shift(2,29282),6<n&&r.write_shift(2,1997),8<n&&(r.write_shift(2,49161),r.write_shift(2,1),r.write_shift(2,1798),r.write_shift(2,0)),r}function ns(e){var t=Lr(8);t.write_shift(4,e.Count),t.write_shift(4,e.Unique);for(var r,a,n,s=[],i=0;i<e.length;++i)s[i]=(r=e[i],n=a=void 0,a=r.t||"",(n=Lr(3)).write_shift(2,a.length),n.write_shift(1,1),(r=Lr(2*a.length)).write_shift(2*a.length,a,"utf16le"),ue([n,r]));var o=ue([t].concat(s));return o.parts=[t.length].concat(s.map(function(e){return e.length})),o}function ss(e,t,r){var a=0;r&&2==r.biff||(a=e.read_shift(2));e=e.read_shift(2);return r&&2==r.biff&&(a=1-(e>>15),e&=32767),[{Unsynced:1&a,DyZero:(2&a)>>1,ExAsc:(4&a)>>2,ExDsc:(8&a)>>3},e]}var is=Bn;function os(e,t,r){var a=e.l+t,n=8!=r.biff&&r.biff?2:4,s=e.read_shift(n),t=e.read_shift(n),r=e.read_shift(2),n=e.read_shift(2);return e.l=a,{s:{r:s,c:r},e:{r:t,c:n}}}function cs(e,t,r,a){r=r&&5==r.biff;(a=a||Lr(r?16:20)).write_shift(2,0),e.style?(a.write_shift(2,e.numFmtId||0),a.write_shift(2,65524)):(a.write_shift(2,e.numFmtId||0),a.write_shift(2,t<<4));t=0;return 0<e.numFmtId&&r&&(t|=1024),a.write_shift(4,t),a.write_shift(4,0),r||a.write_shift(4,0),a.write_shift(2,0),a}function ls(e,t,r){var a=$n(e);2!=r.biff&&9!=t||++e.l;e=(t=e).read_shift(1),e=1===t.read_shift(1)?e:1===e;return a.val=e,a.t=!0===e||!1===e?"b":"e",a}function fs(e,t,r){return 0===t?"":Bn(e,0,r)}function hs(e,t,r){var a,n=e.read_shift(2),n={fBuiltIn:1&n,fWantAdvise:n>>>1&1,fWantPict:n>>>2&1,fOle:n>>>3&1,fOleLink:n>>>4&1,cf:n>>>5&1023,fIcon:n>>>15&1};return 14849===r.sbcch&&(a=function(e,t,r){e.l+=4,t-=4;var a=e.l+t,t=Ln(e,0,r);if((r=e.read_shift(2))!==(a-=e.l))throw new Error("Malformed AddinUdf: padding = "+a+" != "+r);return e.l+=r,t}(e,t-2,r)),n.body=a||e.read_shift(t-2),"string"==typeof a&&(n.Name=a),n}var us=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function ds(e,t,r){var a=e.l+t,n=e.read_shift(2),s=e.read_shift(1),i=e.read_shift(1),o=e.read_shift(r&&2==r.biff?1:2),t=0;(!r||5<=r.biff)&&(5!=r.biff&&(e.l+=2),t=e.read_shift(2),5==r.biff&&(e.l+=2),e.l+=4);i=Mn(e,i,r);32&n&&(i=us[i.charCodeAt(0)]);n=a-e.l;return r&&2==r.biff&&--n,{chKey:s,Name:i,itab:t,rgce:a!=e.l&&0!==o&&0<n?function(e,t,r,a){var n,t=e.l+t,a=Ic(e,a,r);t!==e.l&&(n=Oc(e,t-e.l,a,r));return[a,n]}(e,n,r,o):[]}}function ps(e,t,r){if(r.biff<8)return function(e,t){3==e[e.l+1]&&e[e.l]++;t=Ln(e,0,t);return 3==t.charCodeAt(0)?t.slice(1):t}(e,r);for(var a,n,s=[],t=e.l+t,i=e.read_shift(8<r.biff?4:2);0!=i--;)s.push((a=e,r.biff,n=8<(n=r).biff?4:2,[a.read_shift(n),a.read_shift(n,"i"),a.read_shift(n,"i")]));if(e.l!=t)throw new Error("Bad ExternSheet: "+e.l+" != "+t);return s}function ms(e,t,r){var a=Zn(e,6);switch(r.biff){case 2:e.l++,t-=7;break;case 3:case 4:e.l+=2,t-=8;break;default:e.l+=6,t-=12}return[a,function(e,t,r){var a,n=e.l+t,s=2==r.biff?1:2,i=e.read_shift(s);if(65535==i)return[[],Pr(e,t-2)];var o=Ic(e,i,r);t!==i+s&&(a=Oc(e,t-i-s,o,r));return e.l=n,[o,a]}(e,t,r)]}var gs={8:function(e,t){var r=e.l+t;e.l+=10;var a=e.read_shift(2);e.l+=4,e.l+=2,e.l+=2,e.l+=2,e.l+=4;t=e.read_shift(1);return e.l+=t,e.l=r,{fmt:a}}};function bs(e){var t=Lr(24),r=Yr(e[0]);t.write_shift(2,r.r),t.write_shift(2,r.r),t.write_shift(2,r.c),t.write_shift(2,r.c);for(var a="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "),n=0;n<16;++n)t.write_shift(1,parseInt(a[n],16));return ue([t,function(e){var t=Lr(512),r=0,a=e.Target,n=-1<(e=(a="file://"==a.slice(0,7)?a.slice(7):a).indexOf("#"))?31:23;switch(a.charAt(0)){case"#":n=28;break;case".":n&=-3}t.write_shift(4,2),t.write_shift(4,n);for(var s=[8,6815827,6619237,4849780,83],r=0;r<s.length;++r)t.write_shift(4,s[r]);if(28==n)Vn(a=a.slice(1),t);else if(2&n){for(s="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "),r=0;r<s.length;++r)t.write_shift(1,parseInt(s[r],16));var i=-1<e?a.slice(0,e):a;for(t.write_shift(4,2*(i.length+1)),r=0;r<i.length;++r)t.write_shift(2,i.charCodeAt(r));t.write_shift(2,0),8&n&&Vn(-1<e?a.slice(e+1):"",t)}else{for(s="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "),r=0;r<s.length;++r)t.write_shift(1,parseInt(s[r],16));for(var o=0;"../"==a.slice(3*o,3*o+3)||"..\\"==a.slice(3*o,3*o+3);)++o;for(t.write_shift(2,o),t.write_shift(4,a.length-3*o+1),r=0;r<a.length-3*o;++r)t.write_shift(1,255&a.charCodeAt(r+3*o));for(t.write_shift(1,0),t.write_shift(2,65535),t.write_shift(2,57005),r=0;r<6;++r)t.write_shift(4,0)}return t.slice(0,t.l)}(e[1])])}function vs(e,t,r){if(!r.cellStyles)return Pr(e,t);var a=r&&12<=r.biff?4:2,n=e.read_shift(a),s=e.read_shift(a),i=e.read_shift(a),o=e.read_shift(a),t=e.read_shift(2);2==a&&(e.l+=2);o={s:n,e:s,w:i,ixfe:o,flags:t};return(5<=r.biff||!r.biff)&&(o.level=t>>8&7),o}var ws=$n,Ts=Dn,Es=Un;var ks,ys,Ss,_s=[2,3,48,49,131,139,140,245],xs=(ks={1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127,8:865,9:437,10:850,11:437,13:437,14:850,15:437,16:850,17:437,18:850,19:932,20:850,21:437,22:850,23:865,24:437,25:437,26:850,27:437,28:863,29:850,31:852,34:852,35:852,36:860,37:850,38:866,55:850,64:852,77:936,78:949,79:950,80:874,87:1252,88:1252,89:1252,108:863,134:737,135:852,136:857,204:1257,255:16969},ys=Ie({1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127}),Ss={B:8,C:250,L:1,D:8,"?":0,"":0},{to_workbook:function(e,t){try{return ta(As(e,t),t)}catch(e){if(t&&t.WTF)throw e}return{SheetNames:[],Sheets:{}}},to_sheet:As,from_sheet:function(e,t){if(0<=+(t=t||{}).codepage&&ie(+t.codepage),"string"==t.type)throw new Error("Cannot write DBF to JS string");for(var r=Ur(),a=(t=iu(e,{header:1,raw:!0,cellDates:!0}))[0],n=t.slice(1),s=e["!cols"]||[],i=0,o=0,c=0,l=1,i=0;i<a.length;++i)if(((s[i]||{}).DBF||{}).name)a[i]=s[i].DBF.name,++c;else if(null!=a[i]){if(++c,"number"==typeof a[i]&&(a[i]=a[i].toString(10)),"string"!=typeof a[i])throw new Error("DBF Invalid column name "+a[i]+" |"+typeof a[i]+"|");if(a.indexOf(a[i])!==i)for(o=0;o<1024;++o)if(-1==a.indexOf(a[i]+"_"+o)){a[i]+="_"+o;break}}var f=Zr(e["!ref"]),h=[],u=[],d=[];for(i=0;i<=f.e.c-f.s.c;++i){for(var p="",m="",g=0,b=[],o=0;o<n.length;++o)null!=n[o][i]&&b.push(n[o][i]);if(0!=b.length&&null!=a[i]){for(o=0;o<b.length;++o){switch(typeof b[o]){case"number":m="B";break;case"string":m="C";break;case"boolean":m="L";break;case"object":m=b[o]instanceof Date?"D":"C";break;default:m="C"}g=Math.max(g,String(b[o]).length),p=p&&p!=m?"C":m}250<g&&(g=250),"C"==(m=((s[i]||{}).DBF||{}).type)&&s[i].DBF.len>g&&(g=s[i].DBF.len),"B"==p&&"N"==m&&(p="N",d[i]=s[i].DBF.dec,g=s[i].DBF.len),u[i]="C"==p||"N"==m?g:Ss[p]||0,l+=u[i],h[i]=p}else h[i]="?"}var v,w,T=r.next(32);for(T.write_shift(4,318902576),T.write_shift(4,n.length),T.write_shift(2,296+32*c),T.write_shift(2,l),i=0;i<4;++i)T.write_shift(4,0);for(T.write_shift(4,0|(+ys[_]||3)<<8),o=i=0;i<a.length;++i)null!=a[i]&&(v=r.next(32),w=(a[i].slice(-10)+"\0\0\0\0\0\0\0\0\0\0\0").slice(0,11),v.write_shift(1,w,"sbcs"),v.write_shift(1,"?"==h[i]?"C":h[i],"sbcs"),v.write_shift(4,o),v.write_shift(1,u[i]||Ss[h[i]]||0),v.write_shift(1,d[i]||0),v.write_shift(1,2),v.write_shift(4,0),v.write_shift(1,0),v.write_shift(4,0),v.write_shift(4,0),o+=u[i]||Ss[h[i]]||0);var E=r.next(264);for(E.write_shift(4,13),i=0;i<65;++i)E.write_shift(4,0);for(i=0;i<n.length;++i){var k=r.next(l);for(k.write_shift(1,0),o=0;o<a.length;++o)if(null!=a[o])switch(h[o]){case"L":k.write_shift(1,null==n[i][o]?63:n[i][o]?84:70);break;case"B":k.write_shift(8,n[i][o]||0,"f");break;case"N":var y="0";for("number"==typeof n[i][o]&&(y=n[i][o].toFixed(d[o]||0)),c=0;c<u[o]-y.length;++c)k.write_shift(1,32);k.write_shift(1,y,"sbcs");break;case"D":n[i][o]?(k.write_shift(4,("0000"+n[i][o].getFullYear()).slice(-4),"sbcs"),k.write_shift(2,("00"+(n[i][o].getMonth()+1)).slice(-2),"sbcs"),k.write_shift(2,("00"+n[i][o].getDate()).slice(-2),"sbcs")):k.write_shift(8,"00000000","sbcs");break;case"C":var S=String(null!=n[i][o]?n[i][o]:"").slice(0,u[o]);for(k.write_shift(1,S,"sbcs"),c=0;c<u[o]-S.length;++c)k.write_shift(1,32)}}return r.next(1).write_shift(1,26),r.end()}});function As(e,t){t=t||{};t.dateNF||(t.dateNF="yyyymmdd");e=aa(function(e,t){var r=[],a=le(1);switch(t.type){case"base64":a=he(te(e));break;case"binary":a=he(e);break;case"buffer":case"array":a=e}Dr(a,0);var n=a.read_shift(1),s=!!(136&n),i=!1,o=!1;switch(n){case 2:case 3:break;case 48:case 49:s=i=!0;break;case 131:case 139:break;case 140:o=!0;break;case 245:break;default:throw new Error("DBF Unsupported Version: "+n.toString(16))}var c=0,l=521;2==n&&(c=a.read_shift(2)),a.l+=3,1048576<(c=2!=n?a.read_shift(4):c)&&(c=1e6),2!=n&&(l=a.read_shift(2));var f=a.read_shift(2),h=t.codepage||1252;2!=n&&(a.l+=16,a.read_shift(1),0!==a[a.l]&&(h=ks[a[a.l]]),a.l+=1,a.l+=2),o&&(a.l+=36);for(var u=[],d={},p=Math.min(a.length,2==n?521:l-10-(i?264:0)),m=o?32:11;a.l<p&&13!=a[a.l];)switch((d={}).name=re.utils.decode(h,a.slice(a.l,a.l+m)).replace(/[\u0000\r\n].*$/g,""),a.l+=m,d.type=String.fromCharCode(a.read_shift(1)),2==n||o||(d.offset=a.read_shift(4)),d.len=a.read_shift(1),2==n&&(d.offset=a.read_shift(2)),d.dec=a.read_shift(1),d.name.length&&u.push(d),2!=n&&(a.l+=o?13:14),d.type){case"B":i&&8==d.len||!t.WTF||console.log("Skipping "+d.name+":"+d.type);break;case"G":case"P":t.WTF&&console.log("Skipping "+d.name+":"+d.type);break;case"+":case"0":case"@":case"C":case"D":case"F":case"I":case"L":case"M":case"N":case"O":case"T":case"Y":break;default:throw new Error("Unknown Field Type: "+d.type)}if(13!==a[a.l]&&(a.l=l-1),13!==a.read_shift(1))throw new Error("DBF Terminator not found "+a.l+" "+a[a.l]);a.l=l;var g=0,b=0;for(r[0]=[],b=0;b!=u.length;++b)r[0][b]=u[b].name;for(;0<c--;)if(42!==a[a.l])for(++a.l,r[++g]=[],b=b=0;b!=u.length;++b){var v=a.slice(a.l,a.l+u[b].len);a.l+=u[b].len,Dr(v,0);var w=re.utils.decode(h,v);switch(u[b].type){case"C":w.trim().length&&(r[g][b]=w.replace(/\s+$/,""));break;case"D":8===w.length?r[g][b]=new Date(+w.slice(0,4),+w.slice(4,6)-1,+w.slice(6,8)):r[g][b]=w;break;case"F":r[g][b]=parseFloat(w.trim());break;case"+":case"I":r[g][b]=o?2147483648^v.read_shift(-4,"i"):v.read_shift(4,"i");break;case"L":switch(w.trim().toUpperCase()){case"Y":case"T":r[g][b]=!0;break;case"N":case"F":r[g][b]=!1;break;case"":case"?":break;default:throw new Error("DBF Unrecognized L:|"+w+"|")}break;case"M":if(!s)throw new Error("DBF Unexpected MEMO for type "+n.toString(16));r[g][b]="##MEMO##"+(o?parseInt(w.trim(),10):v.read_shift(4));break;case"N":(w=w.replace(/\u0000/g,"").trim())&&"."!=w&&(r[g][b]=+w||0);break;case"@":r[g][b]=new Date(v.read_shift(-8,"f")-621356832e5);break;case"T":r[g][b]=new Date(864e5*(v.read_shift(4)-2440588)+v.read_shift(4));break;case"Y":r[g][b]=v.read_shift(4,"i")/1e4+v.read_shift(4,"i")/1e4*Math.pow(2,32);break;case"O":r[g][b]=-v.read_shift(-8,"f");break;case"B":if(i&&8==u[b].len){r[g][b]=v.read_shift(8,"f");break}case"G":case"P":v.l+=u[b].len;break;case"0":if("_NullFlags"===u[b].name)break;default:throw new Error("DBF Unsupported data type "+u[b].type)}}else a.l+=f;if(2!=n&&a.l<a.length&&26!=a[a.l++])throw new Error("DBF EOF Marker missing "+(a.l-1)+" of "+a.length+" "+a[a.l-1].toString(16));return t&&t.sheetRows&&(r=r.slice(0,t.sheetRows)),t.DBF=u,r}(e,t),t);return e["!cols"]=t.DBF.map(function(e){return{wch:e.len,DBF:e}}),delete t.DBF,e}var Cs,Rs,Os,Is,Ns=(Cs={AA:"À",BA:"Á",CA:"Â",DA:195,HA:"Ä",JA:197,AE:"È",BE:"É",CE:"Ê",HE:"Ë",AI:"Ì",BI:"Í",CI:"Î",HI:"Ï",AO:"Ò",BO:"Ó",CO:"Ô",DO:213,HO:"Ö",AU:"Ù",BU:"Ú",CU:"Û",HU:"Ü",Aa:"à",Ba:"á",Ca:"â",Da:227,Ha:"ä",Ja:229,Ae:"è",Be:"é",Ce:"ê",He:"ë",Ai:"ì",Bi:"í",Ci:"î",Hi:"ï",Ao:"ò",Bo:"ó",Co:"ô",Do:245,Ho:"ö",Au:"ù",Bu:"ú",Cu:"û",Hu:"ü",KC:"Ç",Kc:"ç",q:"æ",z:"œ",a:"Æ",j:"Œ",DN:209,Dn:241,Hy:255,S:169,c:170,R:174,"B ":180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223},Rs=new RegExp("N("+Re(Cs).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm"),Os=function(e,t){t=Cs[t];return"number"==typeof t?n(t):t},Is=function(e,t,r){r=t.charCodeAt(0)-32<<4|r.charCodeAt(0)-48;return 59==r?e:n(r)},Cs["|"]=254,{to_workbook:function(e,t){return ta(Ds(e,t),t)},to_sheet:Ds,from_sheet:function(e,t){var r,a,n=["ID;PWXL;N;E"],s=[],i=Zr(e["!ref"]),o=Array.isArray(e),c="\r\n";n.push("P;PGeneral"),n.push("F;P0;DG0G8;M255"),e["!cols"]&&(r=n,e["!cols"].forEach(function(e,t){t="F;W"+(t+1)+" "+(t+1)+" ";e.hidden?t+="0":("number"!=typeof e.width||e.wpx||(e.wpx=so(e.width)),"number"!=typeof e.wpx||e.wch||(e.wch=io(e.wpx)),"number"==typeof e.wch&&(t+=Math.round(e.wch)))," "!=t.charAt(t.length-1)&&r.push(t)})),e["!rows"]&&(a=n,e["!rows"].forEach(function(e,t){var r="F;";e.hidden?r+="M0;":e.hpt?r+="M"+20*e.hpt+";":e.hpx&&(r+="M"+20*uo(e.hpx)+";"),2<r.length&&a.push(r+"R"+(t+1))})),n.push("B;Y"+(i.e.r-i.s.r+1)+";X"+(i.e.c-i.s.c+1)+";D"+[i.s.c,i.s.r,i.e.c,i.e.r].join(" "));for(var l=i.s.r;l<=i.e.r;++l)for(var f=i.s.c;f<=i.e.c;++f){var h=Kr({r:l,c:f});(h=o?(e[l]||[])[f]:e[h])&&(null!=h.v||h.f&&!h.F)&&s.push(function(e,t,r){var a="C;Y"+(t+1)+";X"+(r+1)+";K";switch(e.t){case"n":a+=e.v||0,e.f&&!e.F&&(a+=";E"+fc(e.f,{r:t,c:r}));break;case"b":a+=e.v?"TRUE":"FALSE";break;case"e":a+=e.w||e.v;break;case"d":a+='"'+(e.w||e.v)+'"';break;case"s":a+='"'+e.v.replace(/"/g,"").replace(/;/g,";;")+'"'}return a}(h,l,f))}return n.join(c)+c+s.join(c)+c+"E"+c}});function Fs(e,t){var r,a,n=e.split(/[\n\r]+/),s=-1,i=-1,o=0,c=0,l=[],f=[],h=null,e={},u=[],d=[],p=0;for(0<=+t.codepage&&ie(+t.codepage);o!==n.length;++o){p=0;var m,g=n[o].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,Is).replace(Rs,Os),b=g.replace(/;;/g,"\0").split(";").map(function(e){return e.replace(/\u0000/g,";")}),v=b[0];if(0<g.length)switch(v){case"ID":case"E":case"B":case"O":case"W":break;case"P":"P"==b[1].charAt(0)&&f.push(g.slice(3).replace(/;;/g,";"));break;case"C":for(var w=!1,T=!1,E=!1,k=!1,y=-1,S=-1,c=1;c<b.length;++c)switch(b[c].charAt(0)){case"A":break;case"X":i=parseInt(b[c].slice(1))-1,T=!0;break;case"Y":for(s=parseInt(b[c].slice(1))-1,T||(i=0),a=l.length;a<=s;++a)l[a]=[];break;case"K":'"'===(m=b[c].slice(1)).charAt(0)?m=m.slice(1,m.length-1):"TRUE"===m?m=!0:"FALSE"===m?m=!1:isNaN(je(m))?isNaN(Xe(m).getDate())||(m=He(m)):(m=je(m),null!==h&&q(h)&&(m=Me(m))),void 0!==re&&"string"==typeof m&&"string"!=(t||{}).type&&(t||{}).codepage&&(m=re.utils.decode(t.codepage,m)),w=!0;break;case"E":k=!0;var _=oc(b[c].slice(1),{r:s,c:i});l[s][i]=[l[s][i],_];break;case"S":E=!0,l[s][i]=[l[s][i],"S5S"];break;case"G":break;case"R":y=parseInt(b[c].slice(1))-1;break;case"C":S=parseInt(b[c].slice(1))-1;break;default:if(t&&t.WTF)throw new Error("SYLK bad record "+g)}if(w&&(l[s][i]&&2==l[s][i].length?l[s][i][0]=m:l[s][i]=m,h=null),E){if(k)throw new Error("SYLK shared formula cannot have own formula");var x=-1<y&&l[y][S];if(!x||!x[1])throw new Error("SYLK shared formula cannot find base");l[s][i][1]=hc(x[1],{r:s-y,c:i-S})}break;case"F":var A=0;for(c=1;c<b.length;++c)switch(b[c].charAt(0)){case"X":i=parseInt(b[c].slice(1))-1,++A;break;case"Y":for(s=parseInt(b[c].slice(1))-1,a=l.length;a<=s;++a)l[a]=[];break;case"M":p=parseInt(b[c].slice(1))/20;break;case"F":case"G":break;case"P":h=f[parseInt(b[c].slice(1))];break;case"S":case"D":case"N":break;case"W":for(r=b[c].slice(1).split(" "),a=parseInt(r[0],10);a<=parseInt(r[1],10);++a)p=parseInt(r[2],10),d[a-1]=0===p?{hidden:!0}:{wch:p},fo(d[a-1]);break;case"C":d[i=parseInt(b[c].slice(1))-1]||(d[i]={});break;case"R":u[s=parseInt(b[c].slice(1))-1]||(u[s]={}),0<p?(u[s].hpt=p,u[s].hpx=po(p)):0===p&&(u[s].hidden=!0);break;default:if(t&&t.WTF)throw new Error("SYLK bad record "+g)}A<1&&(h=null);break;default:if(t&&t.WTF)throw new Error("SYLK bad record "+g)}}return 0<u.length&&(e["!rows"]=u),0<d.length&&(e["!cols"]=d),[l=t&&t.sheetRows?l.slice(0,t.sheetRows):l,e]}function Ds(e,t){var r=function(e,t){switch(t.type){case"base64":return Fs(te(e),t);case"binary":return Fs(e,t);case"buffer":return Fs(se&&Buffer.isBuffer(e)?e.toString("binary"):i(e),t);case"array":return Fs(ze(e),t)}throw new Error("Unrecognized type "+t.type)}(e,t),e=r[0],a=r[1],n=aa(e,t);return Re(a).forEach(function(e){n[e]=a[e]}),n}var Ps={to_workbook:function(e,t){return ta(Ms(e,t),t)},to_sheet:Ms,from_sheet:function(e){var t=[],r=Zr(e["!ref"]),a=Array.isArray(e);Us(t,"TABLE",0,1,"sheetjs"),Us(t,"VECTORS",0,r.e.r-r.s.r+1,""),Us(t,"TUPLES",0,r.e.c-r.s.c+1,""),Us(t,"DATA",0,0,"");for(var n=r.s.r;n<=r.e.r;++n){Bs(t,-1,0,"BOT");for(var s=r.s.c;s<=r.e.c;++s){var i,o=Kr({r:n,c:s});if(i=a?(e[n]||[])[s]:e[o])switch(i.t){case"n":var c=d?i.w:i.v;null==(c=!c&&null!=i.v?i.v:c)?d&&i.f&&!i.F?Bs(t,1,0,"="+i.f):Bs(t,1,0,""):Bs(t,0,c,"V");break;case"b":Bs(t,0,i.v?1:0,i.v?"TRUE":"FALSE");break;case"s":Bs(t,1,0,!d||isNaN(i.v)?i.v:'="'+i.v+'"');break;case"d":i.w||(i.w=ve(i.z||me[14],De(He(i.v)))),d?Bs(t,0,i.w,"V"):Bs(t,1,0,i.w);break;default:Bs(t,1,0,"")}else Bs(t,1,0,"")}}Bs(t,-1,0,"EOD");return t.join("\r\n")}};function Ls(e,t){for(var r=e.split("\n"),a=-1,n=-1,s=0,i=[];s!==r.length;++s)if("BOT"!==r[s].trim()){if(!(a<0)){for(var o=r[s].trim().split(","),c=o[0],l=o[1],f=r[++s]||"";1&(f.match(/["]/g)||[]).length&&s<r.length-1;)f+="\n"+r[++s];switch(f=f.trim(),+c){case-1:if("BOT"===f){i[++a]=[],n=0;continue}if("EOD"!==f)throw new Error("Unrecognized DIF special command "+f);break;case 0:"TRUE"===f?i[a][n]=!0:"FALSE"===f?i[a][n]=!1:isNaN(je(l))?isNaN(Xe(l).getDate())?i[a][n]=l:i[a][n]=He(l):i[a][n]=je(l),++n;break;case 1:f=(f=f.slice(1,f.length-1)).replace(/""/g,'"'),d&&f&&f.match(/^=".*"$/)&&(f=f.slice(2,-1)),i[a][n++]=""!==f?f:null}if("EOD"===f)break}}else i[++a]=[],n=0;return i=t&&t.sheetRows?i.slice(0,t.sheetRows):i}function Ms(e,t){return aa(function(e,t){switch(t.type){case"base64":return Ls(te(e),t);case"binary":return Ls(e,t);case"buffer":return Ls(se&&Buffer.isBuffer(e)?e.toString("binary"):i(e),t);case"array":return Ls(ze(e),t)}throw new Error("Unrecognized type "+t.type)}(e,t),t)}function Us(e,t,r,a,n){e.push(t),e.push(r+","+a),e.push('"'+n.replace(/"/g,'""')+'"')}function Bs(e,t,r,a){e.push(t+","+r),e.push(1==t?'"'+a.replace(/"/g,'""')+'"':a)}var Ws,Hs,zs,Vs,Gs=(Ws=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n"),Hs=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n",zs=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n"),Vs="--SocialCalcSpreadsheetControlSave--",{to_workbook:function(e,t){return ta($s(e,t),t)},to_sheet:$s,from_sheet:function(e){return[Ws,Hs,zs,Hs,function(e){if(!e||!e["!ref"])return"";for(var t,r,a=[],n=[],s=Jr(e["!ref"]),i=Array.isArray(e),o=s.s.r;o<=s.e.r;++o)for(var c=s.s.c;c<=s.e.c;++c)if(r=Kr({r:o,c:c}),(t=i?(e[o]||[])[c]:e[r])&&null!=t.v&&"z"!==t.t){switch(n=["cell",r,"t"],t.t){case"s":case"str":n.push(js(t.v));break;case"n":t.f?(n[2]="vtf",n[3]="n",n[4]=t.v,n[5]=js(t.f)):(n[2]="v",n[3]=t.v);break;case"b":n[2]="vt"+(t.f?"f":"c"),n[3]="nl",n[4]=t.v?"1":"0",n[5]=js(t.f||(t.v?"TRUE":"FALSE"));break;case"d":var l=De(He(t.v));n[2]="vtc",n[3]="nd",n[4]=""+l,n[5]=t.w||ve(t.z||me[14],l);break;case"e":continue}a.push(n.join(":"))}return a.push("sheet:c:"+(s.e.c-s.s.c+1)+":r:"+(s.e.r-s.s.r+1)+":tvf:1"),a.push("valueformat:1:text-wiki"),a.join("\n")}(e),Vs].join("\n")}});function js(e){return e.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n")}function $s(e,t){return aa(function(e,t){for(var r,a=e.split("\n"),n=-1,s=0,i=[];s!==a.length;++s){var o=a[s].trim().split(":");if("cell"===o[0]){var c=Yr(o[1]);if(i.length<=c.r)for(n=i.length;n<=c.r;++n)i[n]||(i[n]=[]);switch(n=c.r,r=c.c,o[2]){case"t":i[n][r]=o[3].replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n");break;case"v":i[n][r]=+o[3];break;case"vtf":var l=o[o.length-1];case"vtc":"nl"===o[3]?i[n][r]=!!+o[4]:i[n][r]=+o[4],"vtf"==o[2]&&(i[n][r]=[i[n][r],l])}}}return i=t&&t.sheetRows?i.slice(0,t.sheetRows):i}(e,t),t)}var Xs,Ys,Ks=(Xs={44:",",9:"\t",59:";",124:"|"},Ys={44:3,9:2,59:1,124:0},{to_workbook:function(e,t){return ta(ei(e,t),t)},to_sheet:ei,from_sheet:function(e){for(var t=[],r=Zr(e["!ref"]),a=Array.isArray(e),n=r.s.r;n<=r.e.r;++n){for(var s=[],i=r.s.c;i<=r.e.c;++i){var o=Kr({r:n,c:i});if((o=a?(e[n]||[])[i]:e[o])&&null!=o.v){for(var c=(o.w||(ea(o),o.w)||"").slice(0,10);c.length<10;)c+=" ";s.push(c+(0===i?" ":""))}else s.push("          ")}t.push(s.join(""))}return t.join("\n")}});function Js(e,t,r,a,n){n.raw?t[r][a]=e:""===e||("TRUE"===e?t[r][a]=!0:"FALSE"===e?t[r][a]=!1:isNaN(je(e))?isNaN(Xe(e).getDate())?t[r][a]=e:t[r][a]=He(e):t[r][a]=je(e))}function qs(e){for(var t={},r=!1,a=0,n=0;a<e.length;++a)34==(n=e.charCodeAt(a))?r=!r:!r&&n in Xs&&(t[n]=(t[n]||0)+1);for(a in n=[],t)Object.prototype.hasOwnProperty.call(t,a)&&n.push([t[a],a]);if(!n.length)for(a in t=Ys)Object.prototype.hasOwnProperty.call(t,a)&&n.push([t[a],a]);return n.sort(function(e,t){return e[0]-t[0]||Ys[e[1]]-Ys[t[1]]}),Xs[n.pop()[1]]||44}function Zs(a,e){var n=e||{},e="";null!=oe&&null==n.dense&&(n.dense=oe);var s=n.dense?[]:{},i={s:{c:0,r:0},e:{c:0,r:0}};"sep="==a.slice(0,4)?13==a.charCodeAt(5)&&10==a.charCodeAt(6)?(e=a.charAt(4),a=a.slice(7)):13==a.charCodeAt(5)||10==a.charCodeAt(5)?(e=a.charAt(4),a=a.slice(6)):e=qs(a.slice(0,1024)):e=n&&n.FS?n.FS:qs(a.slice(0,1024));var o=0,c=0,l=0,f=0,h=0,u=e.charCodeAt(0),t=!1,d=0,p=a.charCodeAt(0);a=a.replace(/\r\n/gm,"\n");var m=null!=n.dateNF?(e=(e="number"==typeof(e=n.dateNF)?me[e]:e).replace(ye,"(\\d+)"),new RegExp("^"+e+"$")):null;function r(){var e,t=a.slice(f,h),r={};if(0===(t='"'==t.charAt(0)&&'"'==t.charAt(t.length-1)?t.slice(1,-1).replace(/""/g,'"'):t).length?r.t="z":n.raw||0===t.trim().length?(r.t="s",r.v=t):61==t.charCodeAt(0)?34==t.charCodeAt(1)&&34==t.charCodeAt(t.length-1)?(r.t="s",r.v=t.slice(2,-1).replace(/""/g,'"')):1!=t.length?(r.t="n",r.f=t.slice(1)):(r.t="s",r.v=t):"TRUE"==t?(r.t="b",r.v=!0):"FALSE"==t?(r.t="b",r.v=!1):isNaN(l=je(t))?!isNaN(Xe(t).getDate())||m&&t.match(m)?(r.z=n.dateNF||me[14],e=0,m&&t.match(m)&&(t=function(e,a){var n=-1,s=-1,i=-1,o=-1,c=-1,l=-1;(e.match(ye)||[]).forEach(function(e,t){var r=parseInt(a[t+1],10);switch(e.toLowerCase().charAt(0)){case"y":n=r;break;case"d":i=r;break;case"h":o=r;break;case"s":l=r;break;case"m":0<=o?c=r:s=r}}),0<=l&&-1==c&&0<=s&&(c=s,s=-1);var t=(""+(0<=n?n:(new Date).getFullYear())).slice(-4)+"-"+("00"+(1<=s?s:1)).slice(-2)+"-"+("00"+(1<=i?i:1)).slice(-2);return 8==(t=7==t.length?"0"+t:t).length&&(t="20"+t),e=("00"+(0<=o?o:0)).slice(-2)+":"+("00"+(0<=c?c:0)).slice(-2)+":"+("00"+(0<=l?l:0)).slice(-2),-1==o&&-1==c&&-1==l?t:-1==n&&-1==s&&-1==i?e:t+"T"+e}(n.dateNF,t.match(m)||[]),e=1),n.cellDates?(r.t="d",r.v=He(t,e)):(r.t="n",r.v=De(He(t,e))),!1!==n.cellText&&(r.w=ve(r.z,r.v instanceof Date?De(r.v):r.v)),n.cellNF||delete r.z):(r.t="s",r.v=t):(!(r.t="n")!==n.cellText&&(r.w=t),r.v=l),"z"==r.t||(n.dense?(s[o]||(s[o]=[]),s[o][c]=r):s[Kr({c:c,r:o})]=r),f=h+1,p=a.charCodeAt(f),i.e.c<c&&(i.e.c=c),i.e.r<o&&(i.e.r=o),d!=u)return c=0,++o,n.sheetRows&&n.sheetRows<=o?1:void 0;++c}e:for(;h<a.length;++h)switch(d=a.charCodeAt(h)){case 34:34===p&&(t=!t);break;case u:case 10:case 13:if(!t&&r())break e}return 0<h-f&&r(),s["!ref"]=qr(i),s}function Qs(e,t){return!t||!t.PRN||t.FS||"sep="==e.slice(0,4)||0<=e.indexOf("\t")||0<=e.indexOf(",")||0<=e.indexOf(";")?Zs(e,t):aa(function(e,t){var r=t||{},a=[];if(!e||0===e.length)return a;for(var n=e.split(/[\r\n]/),s=n.length-1;0<=s&&0===n[s].length;)--s;for(var i=10,o=0,c=0;c<=s;++c)-1==(o=n[c].indexOf(" "))?o=n[c].length:o++,i=Math.max(i,o);for(c=0;c<=s;++c){a[c]=[];var l=0;for(Js(n[c].slice(0,i).trim(),a,c,l,r),l=1;l<=(n[c].length-i)/10+1;++l)Js(n[c].slice(i+10*(l-1),i+10*l).trim(),a,c,l,r)}return a=r.sheetRows?a.slice(0,r.sheetRows):a}(e,t),t)}function ei(e,t){var r="",a="string"==t.type?[0,0,0,0]:$h(e,t);switch(t.type){case"base64":r=te(e);break;case"binary":r=e;break;case"buffer":r=65001==t.codepage?e.toString("utf8"):t.codepage&&void 0!==re?re.utils.decode(t.codepage,e):se&&Buffer.isBuffer(e)?e.toString("binary"):i(e);break;case"array":r=ze(e);break;case"string":r=e;break;default:throw new Error("Unrecognized type "+t.type)}return 239==a[0]&&187==a[1]&&191==a[2]?r=Mt(r.slice(3)):"string"!=t.type&&"buffer"!=t.type&&65001==t.codepage?r=Mt(r):"binary"==t.type&&void 0!==re&&t.codepage&&(r=re.utils.decode(t.codepage,re.utils.encode(28591,r))),"socialcalc:version:"==r.slice(0,19)?Gs.to_sheet("string"==t.type?r:Mt(r),t):Qs(r,t)}var ti,ri,ai,ni,si=(ti={51:["FALSE",0],52:["TRUE",0],70:["LEN",1],80:["SUM",69],81:["AVERAGEA",69],82:["COUNTA",69],83:["MINA",69],84:["MAXA",69],111:["T",1]},ri=["","","","","","","","","","+","-","*","/","^","=","<>","<=",">=","<",">","","","","","&","","","","","","",""],ai={0:{n:"BOF",f:Nn},1:{n:"EOF"},2:{n:"CALCMODE"},3:{n:"CALCORDER"},4:{n:"SPLIT"},5:{n:"SYNC"},6:{n:"RANGE",f:function(e,t,r){var a={s:{c:0,r:0},e:{c:0,r:0}};return 8==t&&r.qpro?(a.s.c=e.read_shift(1),e.l++,a.s.r=e.read_shift(2),a.e.c=e.read_shift(1),e.l++,a.e.r=e.read_shift(2)):(a.s.c=e.read_shift(2),a.s.r=e.read_shift(2),12==t&&r.qpro&&(e.l+=2),a.e.c=e.read_shift(2),a.e.r=e.read_shift(2),12==t&&r.qpro&&(e.l+=2),65535==a.s.c&&(a.s.c=a.e.c=a.s.r=a.e.r=0)),a}},7:{n:"WINDOW1"},8:{n:"COLW1"},9:{n:"WINTWO"},10:{n:"COLW2"},11:{n:"NAME"},12:{n:"BLANK"},13:{n:"INTEGER",f:function(e,t,r){return(r=ci(e,0,r))[1].v=e.read_shift(2,"i"),r}},14:{n:"NUMBER",f:function(e,t,r){return(r=ci(e,0,r))[1].v=e.read_shift(8,"f"),r}},15:{n:"LABEL",f:li},16:{n:"FORMULA",f:function(e,t,r){var a=e.l+t;return(t=ci(e,0,r))[1].v=e.read_shift(8,"f"),r.qpro?e.l=a:(a=e.read_shift(2),function(e,t){Dr(e,0);for(var r=[],a=0,n="",s="",i="",o="";e.l<e.length;){var c=e[e.l++];switch(c){case 0:r.push(e.read_shift(8,"f"));break;case 1:s=fi(t[0].c,e.read_shift(2),!0),n=fi(t[0].r,e.read_shift(2),!1),r.push(s+n);break;case 2:var l=fi(t[0].c,e.read_shift(2),!0),f=fi(t[0].r,e.read_shift(2),!1);s=fi(t[0].c,e.read_shift(2),!0),n=fi(t[0].r,e.read_shift(2),!1),r.push(l+f+":"+s+n);break;case 3:if(e.l<e.length)return console.error("WK1 premature formula end");break;case 4:r.push("("+r.pop()+")");break;case 5:r.push(e.read_shift(2));break;case 6:for(var h="";c=e[e.l++];)h+=String.fromCharCode(c);r.push('"'+h.replace(/"/g,'""')+'"');break;case 8:r.push("-"+r.pop());break;case 23:r.push("+"+r.pop());break;case 22:r.push("NOT("+r.pop()+")");break;case 20:case 21:o=r.pop(),i=r.pop(),r.push(["AND","OR"][c-20]+"("+i+","+o+")");break;default:if(c<32&&ri[c])o=r.pop(),i=r.pop(),r.push(i+ri[c]+o);else{if(!ti[c])return c<=7?console.error("WK1 invalid opcode "+c.toString(16)):c<=24?console.error("WK1 unsupported op "+c.toString(16)):c<=30?console.error("WK1 invalid opcode "+c.toString(16)):c<=115?console.error("WK1 unsupported function opcode "+c.toString(16)):console.error("WK1 unrecognized opcode "+c.toString(16));if((a=69==(a=ti[c][1])?e[e.l++]:a)>r.length)return console.error("WK1 bad formula parse 0x"+c.toString(16)+":|"+r.join("|")+"|");f=r.slice(-a);r.length-=a,r.push(ti[c][0]+"("+f.join(",")+")")}}}1==r.length?t[1].f=""+r[0]:console.error("WK1 bad formula parse |"+r.join("|")+"|")}(e.slice(e.l,e.l+a),t),e.l+=a),t}},24:{n:"TABLE"},25:{n:"ORANGE"},26:{n:"PRANGE"},27:{n:"SRANGE"},28:{n:"FRANGE"},29:{n:"KRANGE1"},32:{n:"HRANGE"},35:{n:"KRANGE2"},36:{n:"PROTEC"},37:{n:"FOOTER"},38:{n:"HEADER"},39:{n:"SETUP"},40:{n:"MARGINS"},41:{n:"LABELFMT"},42:{n:"TITLES"},43:{n:"SHEETJS"},45:{n:"GRAPH"},46:{n:"NGRAPH"},47:{n:"CALCCOUNT"},48:{n:"UNFORMATTED"},49:{n:"CURSORW12"},50:{n:"WINDOW"},51:{n:"STRING",f:li},55:{n:"PASSWORD"},56:{n:"LOCKED"},60:{n:"QUERY"},61:{n:"QUERYNAME"},62:{n:"PRINT"},63:{n:"PRINTNAME"},64:{n:"GRAPH2"},65:{n:"GRAPHNAME"},66:{n:"ZOOM"},67:{n:"SYMSPLIT"},68:{n:"NSROWS"},69:{n:"NSCOLS"},70:{n:"RULER"},71:{n:"NNAME"},72:{n:"ACOMM"},73:{n:"AMACRO"},74:{n:"PARSE"},102:{n:"PRANGES??"},103:{n:"RRANGES??"},104:{n:"FNAME??"},105:{n:"MRANGES??"},204:{n:"SHEETNAMECS",f:pi},222:{n:"SHEETNAMELP",f:function(e,t){var r=e[e.l++];t-1<r&&(r=t-1);for(var a="";a.length<r;)a+=String.fromCharCode(e[e.l++]);return a}},65535:{n:""}},ni={0:{n:"BOF"},1:{n:"EOF"},2:{n:"PASSWORD"},3:{n:"CALCSET"},4:{n:"WINDOWSET"},5:{n:"SHEETCELLPTR"},6:{n:"SHEETLAYOUT"},7:{n:"COLUMNWIDTH"},8:{n:"HIDDENCOLUMN"},9:{n:"USERRANGE"},10:{n:"SYSTEMRANGE"},11:{n:"ZEROFORCE"},12:{n:"SORTKEYDIR"},13:{n:"FILESEAL"},14:{n:"DATAFILLNUMS"},15:{n:"PRINTMAIN"},16:{n:"PRINTSTRING"},17:{n:"GRAPHMAIN"},18:{n:"GRAPHSTRING"},19:{n:"??"},20:{n:"ERRCELL"},21:{n:"NACELL"},22:{n:"LABEL16",f:function(e,t){var r=hi(e);return r[1].t="s",r[1].v=e.read_shift(t-4,"cstr"),r}},23:{n:"NUMBER17",f:ui},24:{n:"NUMBER18",f:function(e,t){var r=hi(e);r[1].v=e.read_shift(2);var a=r[1].v>>1;if(1&r[1].v)switch(7&a){case 0:a=5e3*(a>>3);break;case 1:a=500*(a>>3);break;case 2:a=(a>>3)/20;break;case 3:a=(a>>3)/200;break;case 4:a=(a>>3)/2e3;break;case 5:a=(a>>3)/2e4;break;case 6:a=(a>>3)/16;break;case 7:a=(a>>3)/64}return r[1].v=a,r}},25:{n:"FORMULA19",f:function(e,t){var r=ui(e);return e.l+=t-14,r}},26:{n:"FORMULA1A"},27:{n:"XFORMAT",f:function(e,t){for(var r={},a=e.l+t;e.l<a;){var n=e.read_shift(2);if(14e3==n){for(r[n]=[0,""],r[n][0]=e.read_shift(2);e[e.l];)r[n][1]+=String.fromCharCode(e[e.l]),e.l++;e.l++}}return r}},28:{n:"DTLABELMISC"},29:{n:"DTLABELCELL"},30:{n:"GRAPHWINDOW"},31:{n:"CPA"},32:{n:"LPLAUTO"},33:{n:"QUERY"},34:{n:"HIDDENSHEET"},35:{n:"??"},37:{n:"NUMBER25",f:function(e,t){var r=hi(e),e=e.read_shift(4);return r[1].v=e>>6,r}},38:{n:"??"},39:{n:"NUMBER27",f:di},40:{n:"FORMULA28",f:function(e,t){var r=di(e);return e.l+=t-10,r}},142:{n:"??"},147:{n:"??"},150:{n:"??"},151:{n:"??"},152:{n:"??"},153:{n:"??"},154:{n:"??"},155:{n:"??"},156:{n:"??"},163:{n:"??"},174:{n:"??"},175:{n:"??"},176:{n:"??"},177:{n:"??"},184:{n:"??"},185:{n:"??"},186:{n:"??"},187:{n:"??"},188:{n:"??"},195:{n:"??"},201:{n:"??"},204:{n:"SHEETNAMECS",f:pi},205:{n:"??"},206:{n:"??"},207:{n:"??"},208:{n:"??"},256:{n:"??"},259:{n:"??"},260:{n:"??"},261:{n:"??"},262:{n:"??"},263:{n:"??"},265:{n:"??"},266:{n:"??"},267:{n:"??"},268:{n:"??"},270:{n:"??"},271:{n:"??"},384:{n:"??"},389:{n:"??"},390:{n:"??"},393:{n:"??"},396:{n:"??"},512:{n:"??"},514:{n:"??"},513:{n:"??"},516:{n:"??"},517:{n:"??"},640:{n:"??"},641:{n:"??"},642:{n:"??"},643:{n:"??"},644:{n:"??"},645:{n:"??"},646:{n:"??"},647:{n:"??"},648:{n:"??"},658:{n:"??"},659:{n:"??"},660:{n:"??"},661:{n:"??"},662:{n:"??"},665:{n:"??"},666:{n:"??"},768:{n:"??"},772:{n:"??"},1537:{n:"SHEETINFOQP",f:function(e,t,r){if(r.qpro&&!(t<21)){r=e.read_shift(1);return e.l+=17,e.l+=1,e.l+=2,[r,e.read_shift(t-21,"cstr")]}}},1600:{n:"??"},1602:{n:"??"},1793:{n:"??"},1794:{n:"??"},1795:{n:"??"},1796:{n:"??"},1920:{n:"??"},2048:{n:"??"},2049:{n:"??"},2052:{n:"??"},2688:{n:"??"},10998:{n:"??"},12849:{n:"??"},28233:{n:"??"},28484:{n:"??"},65535:{n:""}},{sheet_to_wk1:function(e,t){var r=t||{};if(0<=+r.codepage&&ie(+r.codepage),"string"==r.type)throw new Error("Cannot write WK1 to JS string");var a=Ur(),n=Zr(e["!ref"]),s=Array.isArray(e),i=[];Lf(a,0,(t=1030,(r=Lr(2)).write_shift(2,t),r)),Lf(a,6,(t=n,(r=Lr(8)).write_shift(2,t.s.c),r.write_shift(2,t.s.r),r.write_shift(2,t.e.c),r.write_shift(2,t.e.r),r));for(var o,c,l,f,h=Math.min(n.e.r,8191),u=n.s.r;u<=h;++u)for(var d=jr(u),p=n.s.c;p<=n.e.c;++p){u===n.s.r&&(i[p]=Xr(p));var m=i[p]+d,m=s?(e[u]||[])[p]:e[m];m&&"z"!=m.t&&("n"==m.t?(0|m.v)==m.v&&-32768<=m.v&&m.v<=32767?Lf(a,13,(o=u,c=p,l=m.v,f=void 0,(f=Lr(7)).write_shift(1,255),f.write_shift(2,c),f.write_shift(2,o),f.write_shift(2,l,"i"),f)):Lf(a,14,(c=u,o=p,l=m.v,f=void 0,(f=Lr(13)).write_shift(1,255),f.write_shift(2,o),f.write_shift(2,c),f.write_shift(8,l,"f"),f)):Lf(a,15,function(e,t,r){var a=Lr(7+r.length);a.write_shift(1,255),a.write_shift(2,t),a.write_shift(2,e),a.write_shift(1,39);for(var n=0;n<a.length;++n){var s=r.charCodeAt(n);a.write_shift(1,128<=s?95:s)}return a.write_shift(1,0),a}(u,p,ea(m).slice(0,239))))}return Lf(a,1),a.end()},book_to_wk3:function(e,t){if(0<=+(t=t||{}).codepage&&ie(+t.codepage),"string"==t.type)throw new Error("Cannot write WK3 to JS string");var r=Ur();Lf(r,0,function(e){var t=Lr(26);t.write_shift(2,4096),t.write_shift(2,4),t.write_shift(4,0);for(var r=0,a=0,n=0,s=0;s<e.SheetNames.length;++s){var i=e.SheetNames[s],i=e.Sheets[i];i&&i["!ref"]&&(++n,i=Jr(i["!ref"]),r<i.e.r&&(r=i.e.r),a<i.e.c&&(a=i.e.c))}8191<r&&(r=8191);return t.write_shift(2,r),t.write_shift(1,n),t.write_shift(1,a),t.write_shift(2,0),t.write_shift(2,0),t.write_shift(1,1),t.write_shift(1,2),t.write_shift(4,0),t.write_shift(4,0),t}(e));for(var a=0,n=0;a<e.SheetNames.length;++a)(e.Sheets[e.SheetNames[a]]||{})["!ref"]&&Lf(r,27,function(e,t){var r=Lr(5+e.length);r.write_shift(2,14e3),r.write_shift(2,t);for(var a=0;a<e.length;++a){var n=e.charCodeAt(a);r[r.l++]=127<n?95:n}return r[r.l++]=0,r}(e.SheetNames[a],n++));for(var s=0,a=0;a<e.SheetNames.length;++a){var i=e.Sheets[e.SheetNames[a]];if(i&&i["!ref"]){for(var o=Zr(i["!ref"]),c=Array.isArray(i),l=[],f=Math.min(o.e.r,8191),h=o.s.r;h<=f;++h)for(var u=jr(h),d=o.s.c;d<=o.e.c;++d){h===o.s.r&&(l[d]=Xr(d));var p=l[d]+u,p=c?(i[h]||[])[d]:i[p];p&&"z"!=p.t&&("n"==p.t?Lf(r,23,function(e,t,r,a){var n=Lr(14);if(n.write_shift(2,e),n.write_shift(1,r),n.write_shift(1,t),0==a)return n.write_shift(4,0),n.write_shift(4,0),n.write_shift(2,65535),n;var s=0,e=0,r=0,t=0;a<0&&(s=1,a=-a);e=0|Math.log2(a),a/=Math.pow(2,e-31),0==(2147483648&(t=a>>>0))&&(++e,t=(a/=2)>>>0);return a-=t,t|=2147483648,t>>>=0,a*=Math.pow(2,32),r=a>>>0,n.write_shift(4,r),n.write_shift(4,t),e+=16383+(s?32768:0),n.write_shift(2,e),n}(h,d,s,p.v)):Lf(r,22,function(e,t,r,a){var n=Lr(6+a.length);n.write_shift(2,e),n.write_shift(1,r),n.write_shift(1,t),n.write_shift(1,39);for(var s=0;s<a.length;++s){var i=a.charCodeAt(s);n.write_shift(1,128<=i?95:i)}return n.write_shift(1,0),n}(h,d,s,ea(p).slice(0,239))))}++s}}return Lf(r,1),r.end()},to_workbook:function(e,t){switch(t.type){case"base64":return oi(he(te(e)),t);case"binary":return oi(he(e),t);case"buffer":case"array":return oi(e,t)}throw"Unsupported type "+t.type}});function ii(e,t,r){if(e){Dr(e,e.l||0);for(var a=r.Enum||ai;e.l<e.length;){var n=e.read_shift(2),s=a[n]||a[65535],i=e.read_shift(2),o=e.l+i,i=s.f&&s.f(e,i,r);if(e.l=o,t(i,s,n))return}}}function oi(e,t){if(!e)return e;var n=t||{};null!=oe&&null==n.dense&&(n.dense=oe);var s=n.dense?[]:{},i="Sheet1",o="",c=0,l={},f=[],a=[],h={s:{r:0,c:0},e:{r:0,c:0}},u=n.sheetRows||0;if(0==e[2]&&(8==e[3]||9==e[3])&&16<=e.length&&5==e[14]&&108===e[15])throw new Error("Unsupported Works 3 for Mac file");if(2==e[2])n.Enum=ai,ii(e,function(e,t,r){switch(r){case 0:4096<=(n.vers=e)&&(n.qpro=!0);break;case 6:h=e;break;case 204:e&&(o=e);break;case 222:o=e;break;case 15:case 51:n.qpro||(e[1].v=e[1].v.slice(1));case 13:case 14:case 16:14==r&&112==(112&e[2])&&1<(15&e[2])&&(15&e[2])<15&&(e[1].z=n.dateNF||me[14],n.cellDates&&(e[1].t="d",e[1].v=Me(e[1].v))),n.qpro&&e[3]>c&&(s["!ref"]=qr(h),l[i]=s,f.push(i),s=n.dense?[]:{},h={s:{r:0,c:0},e:{r:0,c:0}},c=e[3],i=o||"Sheet"+(c+1),o="");var a=n.dense?(s[e[0].r]||[])[e[0].c]:s[Kr(e[0])];if(a){a.t=e[1].t,a.v=e[1].v,null!=e[1].z&&(a.z=e[1].z),null!=e[1].f&&(a.f=e[1].f);break}n.dense?(s[e[0].r]||(s[e[0].r]=[]),s[e[0].r][e[0].c]=e[1]):s[Kr(e[0])]=e[1]}},n);else{if(26!=e[2]&&14!=e[2])throw new Error("Unrecognized LOTUS BOF "+e[2]);n.Enum=ni,14==e[2]&&(n.qpro=!0,e.l=0),ii(e,function(e,t,r){switch(r){case 204:i=e;break;case 22:e[1].v=e[1].v.slice(1);case 23:case 24:case 25:case 37:case 39:case 40:if(e[3]>c&&(s["!ref"]=qr(h),l[i]=s,f.push(i),s=n.dense?[]:{},h={s:{r:0,c:0},e:{r:0,c:0}},c=e[3],i="Sheet"+(c+1)),0<u&&e[0].r>=u)break;n.dense?(s[e[0].r]||(s[e[0].r]=[]),s[e[0].r][e[0].c]=e[1]):s[Kr(e[0])]=e[1],h.e.c<e[0].c&&(h.e.c=e[0].c),h.e.r<e[0].r&&(h.e.r=e[0].r);break;case 27:e[14e3]&&(a[e[14e3][0]]=e[14e3][1]);break;case 1537:a[e[0]]=e[1],e[0]==c&&(i=e[1])}},n)}if(s["!ref"]=qr(h),l[o||i]=s,f.push(o||i),!a.length)return{SheetNames:f,Sheets:l};for(var r={},d=[],p=0;p<a.length;++p)l[f[p]]?(d.push(a[p]||f[p]),r[a[p]]=l[a[p]]||l[f[p]]):(d.push(a[p]),r[a[p]]={"!ref":"A1"});return{SheetNames:d,Sheets:r}}function ci(e,t,r){var a=[{c:0,r:0},{t:"n",v:0},0,0];return r.qpro&&20768!=r.vers?(a[0].c=e.read_shift(1),a[3]=e.read_shift(1),a[0].r=e.read_shift(2),e.l+=2):(a[2]=e.read_shift(1),a[0].c=e.read_shift(2),a[0].r=e.read_shift(2)),a}function li(e,t,r){var a=e.l+t,t=ci(e,0,r);if(t[1].t="s",20768!=r.vers)return r.qpro&&e.l++,t[1].v=e.read_shift(a-e.l,"cstr"),t;e.l++;a=e.read_shift(1);return t[1].v=e.read_shift(a,"utf8"),t}function fi(e,t,r){var a=32768&t;return(a?"":"$")+(r?Xr:jr)(t=(a?e:0)+(8192<=(t&=-32769)?t-16384:t))}function hi(e){var t=[{c:0,r:0},{t:"n",v:0},0];return t[0].r=e.read_shift(2),t[3]=e[e.l++],t[0].c=e[e.l++],t}function ui(e,t){var r=hi(e),a=e.read_shift(4),n=e.read_shift(4);if(65535==(s=e.read_shift(2)))return 0===a&&3221225472===n?(r[1].t="e",r[1].v=15):0===a&&3489660928===n?(r[1].t="e",r[1].v=42):r[1].v=0,r;var e=32768&s,s=(32767&s)-16446;return r[1].v=(1-2*e)*(n*Math.pow(2,32+s)+a*Math.pow(2,s)),r}function di(e,t){var r=hi(e),e=e.read_shift(8,"f");return r[1].v=e,r}function pi(e,t){return 0==e[e.l+t-1]?e.read_shift(t,"cstr"):""}var mi,gi,bi,vi,wi=(mi=Bt("t"),gi=Bt("rPr"),bi=/<(?:\w+:)?r>/g,vi=/<\/(?:\w+:)?r>/,function(e){return e.replace(bi,"").split(vi).map(Ti).filter(function(e){return e.v})});function Ti(e){var t=e.match(mi);if(!t)return{t:"s",v:""};t={t:"s",v:wt(t[1])},e=e.match(gi);return e&&(t.s=function(e){var t={},r=e.match(ft),a=0,n=!1;if(r)for(;a!=r.length;++a){var s=dt(r[a]);switch(s[0].replace(/\w*:/g,"")){case"<condense":case"<extend":break;case"<shadow":if(!s.val)break;case"<shadow>":case"<shadow/>":t.shadow=1;break;case"</shadow>":break;case"<charset":if("1"==s.val)break;t.cp=l[parseInt(s.val,10)];break;case"<outline":if(!s.val)break;case"<outline>":case"<outline/>":t.outline=1;break;case"</outline>":break;case"<rFont":t.name=s.val;break;case"<sz":t.sz=s.val;break;case"<strike":if(!s.val)break;case"<strike>":case"<strike/>":t.strike=1;break;case"</strike>":break;case"<u":if(!s.val)break;switch(s.val){case"double":t.uval="double";break;case"singleAccounting":t.uval="single-accounting";break;case"doubleAccounting":t.uval="double-accounting"}case"<u>":case"<u/>":t.u=1;break;case"</u>":break;case"<b":if("0"==s.val)break;case"<b>":case"<b/>":t.b=1;break;case"</b>":break;case"<i":if("0"==s.val)break;case"<i>":case"<i/>":t.i=1;break;case"</i>":break;case"<color":s.rgb&&(t.color=s.rgb.slice(2,8));break;case"<color>":case"<color/>":case"</color>":break;case"<family":t.family=s.val;break;case"<family>":case"<family/>":case"</family>":break;case"<vertAlign":t.valign=s.val;break;case"<vertAlign>":case"<vertAlign/>":case"</vertAlign>":case"<scheme":break;case"<scheme>":case"<scheme/>":case"</scheme>":break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":n=!0;break;case"</ext>":n=!1;break;default:if(47!==s[0].charCodeAt(1)&&!n)throw new Error("Unrecognized rich format "+s[0])}}return t}(e[1])),t}var Ei,ki=(Ei=/(\r\n|\n)/g,function(e){return e.map(yi).join("")});function yi(e){var t,r,a,n=[[],e.v,[]];return e.v?(e.s&&(t=e.s,r=n[0],a=n[2],e=[],t.u&&e.push("text-decoration: underline;"),t.uval&&e.push("text-underline-style:"+t.uval+";"),t.sz&&e.push("font-size:"+t.sz+"pt;"),t.outline&&e.push("text-effect: outline;"),t.shadow&&e.push("text-shadow: auto;"),r.push('<span style="'+e.join("")+'">'),t.b&&(r.push("<b>"),a.push("</b>")),t.i&&(r.push("<i>"),a.push("</i>")),t.strike&&(r.push("<s>"),a.push("</s>")),"superscript"==(e=t.valign||"")||"super"==e?e="sup":"subscript"==e&&(e="sub"),""!=e&&(r.push("<"+e+">"),a.push("</"+e+">")),a.push("</span>")),n[0].join("")+n[1].replace(Ei,"<br/>")+n[2].join("")):""}var Si=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,_i=/<(?:\w+:)?r>/,xi=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function Ai(e,t){var r=!t||t.cellHTML,t={};return e?(e.match(/^\s*<(?:\w+:)?t[^>]*>/)?(t.t=wt(Mt(e.slice(e.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||"")),t.r=Mt(e),r&&(t.h=_t(t.t))):e.match(_i)&&(t.r=Mt(e),t.t=wt(Mt((e.replace(xi,"").match(Si)||[]).join("").replace(ft,""))),r&&(t.h=ki(wi(t.r)))),t):{t:""}}var Ci=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/,Ri=/<(?:\w+:)?(?:si|sstItem)>/g,Oi=/<\/(?:\w+:)?(?:si|sstItem)>/;var Ii=/^\s|\s$|[\t\n\r]/;function Ni(e,t){if(!t.bookSST)return"";var r=[ot];r[r.length]=Yt("sst",null,{xmlns:Qt[0],count:e.Count,uniqueCount:e.Unique});for(var a,n,s=0;s!=e.length;++s)null!=e[s]&&(n="<si>",(a=e[s]).r?n+=a.r:(n+="<t",a.t||(a.t=""),a.t.match(Ii)&&(n+=' xml:space="preserve"'),n+=">"+kt(a.t)+"</t>"),n+="</si>",r[r.length]=n);return 2<r.length&&(r[r.length]="</sst>",r[1]=r[1].replace("/>",">")),r.join("")}var Fi=function(e,t){var r=!1;return null==t&&(r=!0,t=Lr(15+4*e.t.length)),t.write_shift(1,0),ia(e.t,t),r?t.slice(0,t.l):t};function Di(e){var t,r,a=Ur();Br(a,159,(t=e,(r=r||Lr(8)).write_shift(4,t.Count),r.write_shift(4,t.Unique),r));for(var n=0;n<e.length;++n)Br(a,19,Fi(e[n]));return Br(a,160),a.end()}function Pi(e){if(void 0!==re)return re.utils.encode(_,e);for(var t=[],r=e.split(""),a=0;a<r.length;++a)t[a]=r[a].charCodeAt(0);return t}function Li(e,t){var r={};return r.Major=e.read_shift(2),r.Minor=e.read_shift(2),4<=t&&(e.l+=t-4),r}function Mi(e){var t=[];e.l+=4;for(var r=e.read_shift(4);0<r--;)t.push(function(e){for(var t=e.read_shift(4),r=e.l+t-4,t={},a=e.read_shift(4),n=[];0<a--;)n.push({t:e.read_shift(4),v:e.read_shift(0,"lpp4")});if(t.name=e.read_shift(0,"lpp4"),t.comps=n,e.l!=r)throw new Error("Bad DataSpaceMapEntry: "+e.l+" != "+r);return t}(e));return t}function Ui(e){var t,r,r=(r={},(t=e).read_shift(4),t.l+=4,r.id=t.read_shift(0,"lpp4"),r.name=t.read_shift(0,"lpp4"),r.R=Li(t,4),r.U=Li(t,4),r.W=Li(t,4),r);if(r.ename=e.read_shift(0,"8lpp4"),r.blksz=e.read_shift(4),r.cmode=e.read_shift(4),4!=e.read_shift(4))throw new Error("Bad !Primary record");return r}function Bi(e,t){var t=e.l+t,r={};r.Flags=63&e.read_shift(4),e.l+=4,r.AlgID=e.read_shift(4);var a=!1;switch(r.AlgID){case 26126:case 26127:case 26128:a=36==r.Flags;break;case 26625:a=4==r.Flags;break;case 0:a=16==r.Flags||4==r.Flags||36==r.Flags;break;default:throw"Unrecognized encryption algorithm: "+r.AlgID}if(!a)throw new Error("Encryption Flags/AlgID mismatch");return r.AlgIDHash=e.read_shift(4),r.KeySize=e.read_shift(4),r.ProviderType=e.read_shift(4),e.l+=8,r.CSPName=e.read_shift(t-e.l>>1,"utf16le"),e.l=t,r}function Wi(e,t){var r={},t=e.l+t;return e.l+=4,r.Salt=e.slice(e.l,e.l+16),e.l+=16,r.Verifier=e.slice(e.l,e.l+16),e.l+=16,e.read_shift(4),r.VerifierHash=e.slice(e.l,t),e.l=t,r}function Hi(e){var t=Li(e);switch(t.Minor){case 2:return[t.Minor,function(e){if(36!=(63&e.read_shift(4)))throw new Error("EncryptionInfo mismatch");var t=e.read_shift(4),t=Bi(e,t),e=Wi(e,e.length-e.l);return{t:"Std",h:t,v:e}}(e)];case 3:return[t.Minor,function(){throw new Error("File is password-protected: ECMA-376 Extensible")}()];case 4:return[t.Minor,function(e){var r=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];e.l+=4;var e=e.read_shift(e.length-e.l,"utf8"),a={};return e.replace(ft,function(e){var t=dt(e);switch(pt(t[0])){case"<?xml":break;case"<encryption":case"</encryption>":break;case"<keyData":r.forEach(function(e){a[e]=t[e]});break;case"<dataIntegrity":a.encryptedHmacKey=t.encryptedHmacKey,a.encryptedHmacValue=t.encryptedHmacValue;break;case"<keyEncryptors>":case"<keyEncryptors":a.encs=[];break;case"</keyEncryptors>":break;case"<keyEncryptor":a.uri=t.uri;break;case"</keyEncryptor>":break;case"<encryptedKey":a.encs.push(t);break;default:throw t[0]}}),a}(e)]}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+t.Minor)}function zi(e){var t,r=0,a=Pi(e),n=a.length+1,s=le(n);for(s[0]=a.length,t=1;t!=n;++t)s[t]=a[t-1];for(t=n-1;0<=t;--t)r=((0==(16384&r)?0:1)|r<<1&32767)^s[t];return 52811^r}var Vi,Gi,ji,$i=(Vi=[187,255,255,186,255,255,185,128,0,190,15,0,191,15,0],Gi=[57840,7439,52380,33984,4364,3600,61902,12606,6258,57657,54287,34041,10252,43370,20163],ji=[44796,19929,39858,10053,20106,40212,10761,31585,63170,64933,60267,50935,40399,11199,17763,35526,1453,2906,5812,11624,23248,885,1770,3540,7080,14160,28320,56640,55369,41139,20807,41614,21821,43642,17621,28485,56970,44341,19019,38038,14605,29210,60195,50791,40175,10751,21502,43004,24537,18387,36774,3949,7898,15796,31592,63184,47201,24803,49606,37805,14203,28406,56812,17824,35648,1697,3394,6788,13576,27152,43601,17539,35078,557,1114,2228,4456,30388,60776,51953,34243,7079,14158,28316,14128,28256,56512,43425,17251,34502,7597,13105,26210,52420,35241,883,1766,3532,4129,8258,16516,33032,4657,9314,18628],function(e){for(var t,r,a=Pi(e),n=function(e){for(var t=Gi[e.length-1],r=104,a=e.length-1;0<=a;--a)for(var n=e[a],s=0;7!=s;++s)64&n&&(t^=ji[r]),n*=2,--r;return t}(a),s=a.length,i=le(16),o=0;16!=o;++o)i[o]=0;for(1==(1&s)&&(t=n>>8,i[s]=Xi(Vi[0],t),--s,t=255&n,e=a[a.length-1],i[s]=Xi(e,t));0<s;)t=n>>8,i[--s]=Xi(a[s],t),t=255&n,i[--s]=Xi(a[s],t);for(r=(s=15)-a.length;0<r;)t=n>>8,i[s]=Xi(Vi[r],t),--r,t=255&n,i[--s]=Xi(a[s],t),--s,--r;return i});function Xi(e,t){return 255&((t=e^t)/2|128*t)}var Yi=function(e){var t=0,r=$i(e);return function(e){e=function(e,t,r,a,n){var s,i;for(n=n||t,a=a||$i(e),s=0;s!=t.length;++s)i=t[s],i=255&((i^=a[r])>>5|i<<3),n[s]=i,++r;return[n,r,a]}("",e,t,r);return t=e[1],e[0]}};function Ki(e,t,r){r=r||{};return r.Info=e.read_shift(2),e.l-=2,1===r.Info?r.Data=function(e){var t={},r=t.EncryptionVersionInfo=Li(e,4);if(1!=r.Major||1!=r.Minor)throw"unrecognized version code "+r.Major+" : "+r.Minor;return t.Salt=e.read_shift(16),t.EncryptedVerifier=e.read_shift(16),t.EncryptedVerifierHash=e.read_shift(16),t}(e):r.Data=function(e,t){var r={},a=r.EncryptionVersionInfo=Li(e,4);if(t-=4,2!=a.Minor)throw new Error("unrecognized minor version code: "+a.Minor);if(4<a.Major||a.Major<2)throw new Error("unrecognized major version code: "+a.Major);return r.Flags=e.read_shift(4),t-=4,a=e.read_shift(4),t-=4,r.EncryptionHeader=Bi(e,a),t-=a,r.EncryptionVerifier=Wi(e,t),r}(e,t),r}var Ji={to_workbook:function(e,t){return ta(qi(e,t),t)},to_sheet:qi,from_sheet:function(e){for(var t=["{\\rtf1\\ansi"],r=Zr(e["!ref"]),a=Array.isArray(e),n=r.s.r;n<=r.e.r;++n){t.push("\\trowd\\trautofit1");for(var s=r.s.c;s<=r.e.c;++s)t.push("\\cellx"+(s+1));for(t.push("\\pard\\intbl"),s=r.s.c;s<=r.e.c;++s){var i=Kr({r:n,c:s});(i=a?(e[n]||[])[s]:e[i])&&(null!=i.v||i.f&&!i.F)&&(t.push(" "+(i.w||(ea(i),i.w))),t.push("\\cell"))}t.push("\\pard\\intbl\\row")}return t.join("")+"}"}};function qi(e,t){switch(t.type){case"base64":return Zi(te(e),t);case"binary":return Zi(e,t);case"buffer":return Zi(se&&Buffer.isBuffer(e)?e.toString("binary"):i(e),t);case"array":return Zi(ze(e),t)}throw new Error("Unrecognized type "+t.type)}function Zi(e,t){var i=(t||{}).dense?[]:{},e=e.match(/\\trowd.*?\\row\b/g);if(!e.length)throw new Error("RTF missing table");var o={s:{c:0,r:0},e:{c:0,r:e.length-1}};return e.forEach(function(e,t){Array.isArray(i)&&(i[t]=[]);for(var r,a=/\\\w+\b/g,n=0,s=-1;r=a.exec(e);)"\\cell"===r[0]&&(++s,(r=" "==(r=e.slice(n,a.lastIndex-r[0].length))[0]?r.slice(1):r).length&&(r={v:r,t:"s"},Array.isArray(i)?i[t][s]=r:i[Kr({r:t,c:s})]=r)),n=a.lastIndex;s>o.e.c&&(o.e.c=s)}),i["!ref"]=qr(o),i}function Qi(e){for(var t=0,r=1;3!=t;++t)r=256*r+(255<e[t]?255:e[t]<0?0:e[t]);return r.toString(16).toUpperCase().slice(1)}function eo(e,t){if(0===t)return e;e=function(e){var t=e[0]/255,r=e[1]/255,a=e[2]/255,n=Math.max(t,r,a),s=Math.min(t,r,a),i=n-s;if(0==i)return[0,0,t];var o=0,e=0,e=i/(1<(s=n+s)?2-s:s);switch(n){case t:o=((r-a)/i+6)%6;break;case r:o=(a-t)/i+2;break;case a:o=(t-r)/i+4}return[o/6,e,s/2]}((e=(e=e).slice("#"===e[0]?1:0).slice(0,6),[parseInt(e.slice(0,2),16),parseInt(e.slice(2,4),16),parseInt(e.slice(4,6),16)]));return e[2]=t<0?e[2]*(1+t):1-(1-e[2])*(1-t),Qi(function(e){var t,r=e[0],a=e[1],e=e[2],n=2*a*(e<.5?e:1-e),s=[e=e-n/2,e,e],i=6*r;if(0!==a)switch(0|i){case 0:case 6:t=n*i,s[0]+=n,s[1]+=t;break;case 1:t=n*(2-i),s[0]+=t,s[1]+=n;break;case 2:t=n*(i-2),s[1]+=n,s[2]+=t;break;case 3:t=n*(4-i),s[1]+=t,s[2]+=n;break;case 4:t=n*(i-4),s[2]+=n,s[0]+=t;break;case 5:t=n*(6-i),s[2]+=t,s[0]+=n}for(var o=0;3!=o;++o)s[o]=Math.round(255*s[o]);return s}(e))}var to=6,ro=15,ao=1,no=to;function so(e){return Math.floor((e+Math.round(128/no)/256)*no)}function io(e){return Math.floor((e-5)/no*100+.5)/100}function oo(e){return Math.round((e*no+5)/no*256)/256}function co(e){return oo(io(so(e)))}function lo(e){var t=Math.abs(e-co(e)),r=no;if(.005<t)for(no=ao;no<ro;++no)Math.abs(e-co(e))<=t&&(t=Math.abs(e-co(e)),r=no);no=r}function fo(e){e.width?(e.wpx=so(e.width),e.wch=io(e.wpx),e.MDW=no):e.wpx?(e.wch=io(e.wpx),e.width=oo(e.wch),e.MDW=no):"number"==typeof e.wch&&(e.width=oo(e.wch),e.wpx=so(e.width),e.MDW=no),e.customWidth&&delete e.customWidth}var ho=96;function uo(e){return 96*e/ho}function po(e){return e*ho/96}var mo={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};var go=["numFmtId","fillId","fontId","borderId","xfId"],bo=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];var vo,wo,To,Eo,ko,yo,So=(vo=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/,wo=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/,To=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/,Eo=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/,ko=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/,function(e,t,r){var a,n,s,i,o,c={};return e&&((a=(e=e.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"")).match(vo))&&function(e,t,r){t.NumberFmt=[];for(var a=Re(me),n=0;n<a.length;++n)t.NumberFmt[a[n]]=me[a[n]];var s=e[0].match(ft);if(s)for(n=0;n<s.length;++n){var i=dt(s[n]);switch(pt(i[0])){case"<numFmts":case"</numFmts>":case"<numFmts/>":case"<numFmts>":break;case"<numFmt":var o=wt(Mt(i.formatCode)),c=parseInt(i.numFmtId,10);if(t.NumberFmt[c]=o,0<c){if(392<c){for(c=392;60<c&&null!=t.NumberFmt[c];--c);t.NumberFmt[c]=o}we(o,c)}break;case"</numFmt>":break;default:if(r.WTF)throw new Error("unrecognized "+i[0]+" in numFmts")}}}(a,c,r),(a=e.match(Eo))&&function(e,a,n,s){a.Fonts=[];var i={},o=!1;(e[0].match(ft)||[]).forEach(function(e){var t,r=dt(e);switch(pt(r[0])){case"<fonts":case"<fonts>":case"</fonts>":break;case"<font":case"<font>":break;case"</font>":case"<font/>":a.Fonts.push(i),i={};break;case"<name":r.val&&(i.name=Mt(r.val));break;case"<name/>":case"</name>":break;case"<b":i.bold=r.val?Rt(r.val):1;break;case"<b/>":i.bold=1;break;case"<i":i.italic=r.val?Rt(r.val):1;break;case"<i/>":i.italic=1;break;case"<u":switch(r.val){case"none":i.underline=0;break;case"single":i.underline=1;break;case"double":i.underline=2;break;case"singleAccounting":i.underline=33;break;case"doubleAccounting":i.underline=34}break;case"<u/>":i.underline=1;break;case"<strike":i.strike=r.val?Rt(r.val):1;break;case"<strike/>":i.strike=1;break;case"<outline":i.outline=r.val?Rt(r.val):1;break;case"<outline/>":i.outline=1;break;case"<shadow":i.shadow=r.val?Rt(r.val):1;break;case"<shadow/>":i.shadow=1;break;case"<condense":i.condense=r.val?Rt(r.val):1;break;case"<condense/>":i.condense=1;break;case"<extend":i.extend=r.val?Rt(r.val):1;break;case"<extend/>":i.extend=1;break;case"<sz":r.val&&(i.sz=+r.val);break;case"<sz/>":case"</sz>":break;case"<vertAlign":r.val&&(i.vertAlign=r.val);break;case"<vertAlign/>":case"</vertAlign>":break;case"<family":r.val&&(i.family=parseInt(r.val,10));break;case"<family/>":case"</family>":break;case"<scheme":r.val&&(i.scheme=r.val);break;case"<scheme/>":case"</scheme>":break;case"<charset":if("1"==r.val)break;r.codepage=l[parseInt(r.val,10)];break;case"<color":i.color||(i.color={}),r.auto&&(i.color.auto=Rt(r.auto)),r.rgb?i.color.rgb=r.rgb.slice(-6):r.indexed?(i.color.index=parseInt(r.indexed,10),t=Ba[i.color.index],t=(t=81==i.color.index?Ba[1]:t)||Ba[1],i.color.rgb=t[0].toString(16)+t[1].toString(16)+t[2].toString(16)):r.theme&&(i.color.theme=parseInt(r.theme,10),r.tint&&(i.color.tint=parseFloat(r.tint)),r.theme&&n.themeElements&&n.themeElements.clrScheme&&(i.color.rgb=eo(n.themeElements.clrScheme[i.color.theme].rgb,i.color.tint||0)));break;case"<color/>":case"</color>":break;case"<AlternateContent":o=!0;break;case"</AlternateContent>":o=!1;break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":o=!0;break;case"</ext>":o=!1;break;default:if(s&&s.WTF&&!o)throw new Error("unrecognized "+r[0]+" in fonts")}})}(a,c,t,r),(a=e.match(To))&&function(e,r,a){r.Fills=[];var n={},s=!1;(e[0].match(ft)||[]).forEach(function(e){var t=dt(e);switch(pt(t[0])){case"<fills":case"<fills>":case"</fills>":break;case"<fill>":case"<fill":case"<fill/>":n={},r.Fills.push(n);break;case"</fill>":case"<gradientFill>":break;case"<gradientFill":case"</gradientFill>":r.Fills.push(n),n={};break;case"<patternFill":case"<patternFill>":t.patternType&&(n.patternType=t.patternType);break;case"<patternFill/>":case"</patternFill>":break;case"<bgColor":n.bgColor||(n.bgColor={}),t.indexed&&(n.bgColor.indexed=parseInt(t.indexed,10)),t.theme&&(n.bgColor.theme=parseInt(t.theme,10)),t.tint&&(n.bgColor.tint=parseFloat(t.tint)),t.rgb&&(n.bgColor.rgb=t.rgb.slice(-6));break;case"<bgColor/>":case"</bgColor>":break;case"<fgColor":n.fgColor||(n.fgColor={}),t.theme&&(n.fgColor.theme=parseInt(t.theme,10)),t.tint&&(n.fgColor.tint=parseFloat(t.tint)),null!=t.rgb&&(n.fgColor.rgb=t.rgb.slice(-6));break;case"<fgColor/>":case"</fgColor>":break;case"<stop":case"<stop/>":case"</stop>":break;case"<color":case"<color/>":case"</color>":break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":s=!0;break;case"</ext>":s=!1;break;default:if(a&&a.WTF&&!s)throw new Error("unrecognized "+t[0]+" in fills")}})}(a,c,r),(a=e.match(ko))&&function(e,r,a){r.Borders=[];var n={},s=!1;(e[0].match(ft)||[]).forEach(function(e){var t=dt(e);switch(pt(t[0])){case"<borders":case"<borders>":case"</borders>":break;case"<border":case"<border>":case"<border/>":n={},t.diagonalUp&&(n.diagonalUp=Rt(t.diagonalUp)),t.diagonalDown&&(n.diagonalDown=Rt(t.diagonalDown)),r.Borders.push(n);break;case"</border>":case"<left/>":break;case"<left":case"<left>":case"</left>":case"<right/>":break;case"<right":case"<right>":case"</right>":case"<top/>":break;case"<top":case"<top>":case"</top>":case"<bottom/>":break;case"<bottom":case"<bottom>":case"</bottom>":break;case"<diagonal":case"<diagonal>":case"<diagonal/>":case"</diagonal>":break;case"<horizontal":case"<horizontal>":case"<horizontal/>":case"</horizontal>":break;case"<vertical":case"<vertical>":case"<vertical/>":case"</vertical>":break;case"<start":case"<start>":case"<start/>":case"</start>":break;case"<end":case"<end>":case"<end/>":case"</end>":break;case"<color":case"<color>":break;case"<color/>":case"</color>":break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":s=!0;break;case"</ext>":s=!1;break;default:if(a&&a.WTF&&!s)throw new Error("unrecognized "+t[0]+" in borders")}})}(a,c,r),(a=e.match(wo))&&(a=a,s=r,o=!((n=c).CellXf=[]),(a[0].match(ft)||[]).forEach(function(e){var t=dt(e),r=0;switch(pt(t[0])){case"<cellXfs":case"<cellXfs>":case"<cellXfs/>":case"</cellXfs>":break;case"<xf":case"<xf/>":for(delete(i=t)[0],r=0;r<go.length;++r)i[go[r]]&&(i[go[r]]=parseInt(i[go[r]],10));for(r=0;r<bo.length;++r)i[bo[r]]&&(i[bo[r]]=Rt(i[bo[r]]));if(n.NumberFmt&&392<i.numFmtId)for(r=392;60<r;--r)if(n.NumberFmt[i.numFmtId]==n.NumberFmt[r]){i.numFmtId=r;break}n.CellXf.push(i);break;case"</xf>":break;case"<alignment":case"<alignment/>":var a={};t.vertical&&(a.vertical=t.vertical),t.horizontal&&(a.horizontal=t.horizontal),null!=t.textRotation&&(a.textRotation=t.textRotation),t.indent&&(a.indent=t.indent),t.wrapText&&(a.wrapText=Rt(t.wrapText)),i.alignment=a;break;case"</alignment>":case"<protection":break;case"</protection>":case"<protection/>":break;case"<AlternateContent":o=!0;break;case"</AlternateContent>":o=!1;break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":o=!0;break;case"</ext>":o=!1;break;default:if(s&&s.WTF&&!o)throw new Error("unrecognized "+t[0]+" in cellXfs")}}))),c});function _o(e,t){if(void 0!==yo)return yo.toXml();var r,a,n,s,i=[ot,Yt("styleSheet",null,{xmlns:Qt[0],"xmlns:vt":Zt.vt})];return e.SSF&&null!=(a=e.SSF,n=["<numFmts>"],[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t=e[0];t<=e[1];++t)null!=a[t]&&(n[n.length]=Yt("numFmt",null,{numFmtId:t,formatCode:kt(a[t])}))}),r=1===n.length?"":(n[n.length]="</numFmts>",n[0]=Yt("numFmts",null,{count:n.length-2}).replace("/>",">"),n.join("")))&&(i[i.length]=r),i[i.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>',i[i.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>',i[i.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>',i[i.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>',t=t.cellXfs,(s=[])[s.length]="<cellXfs/>",t.forEach(function(e){s[s.length]=Yt("xf",null,e)}),s[s.length]="</cellXfs>",(r=2===s.length?"":(s[0]=Yt("cellXfs",null,{count:s.length-2}).replace("/>",">"),s.join("")))&&(i[i.length]=r),i[i.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>',i[i.length]='<dxfs count="0"/>',i[i.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>',2<i.length&&(i[i.length]="</styleSheet>",i[1]=i[1].replace("/>",">")),i.join("")}function xo(e,t){var r;(t=t||Lr(153)).write_shift(2,20*e.sz),r=e,a=(a=t)||Lr(2),r=(r.italic?2:0)|(r.strike?8:0)|(r.outline?16:0)|(r.shadow?32:0)|(r.condense?64:0)|(r.extend?128:0),a.write_shift(1,r),a.write_shift(1,0),t.write_shift(2,e.bold?700:400);var a=0;"superscript"==e.vertAlign?a=1:"subscript"==e.vertAlign&&(a=2),t.write_shift(2,a),t.write_shift(1,e.underline||0),t.write_shift(1,e.family||0),t.write_shift(1,e.charset||0),t.write_shift(1,0),Ca(e.color,t);a=0;return"major"==e.scheme&&(a=1),"minor"==e.scheme&&(a=2),t.write_shift(1,a),ia(e.name,t),t.length>t.l?t.slice(0,t.l):t}var Ao,Co=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"],Ro=Pr;function Oo(e,t){t=t||Lr(84);e=(Ao=Ao||Ie(Co))[e.patternType];null==e&&(e=40),t.write_shift(4,e);var r=0;if(40!=e)for(Ca({auto:1},t),Ca({auto:1},t);r<12;++r)t.write_shift(4,0);else{for(;r<4;++r)t.write_shift(4,0);for(;r<12;++r)t.write_shift(4,0)}return t.length>t.l?t.slice(0,t.l):t}function Io(e,t,r){(r=r||Lr(16)).write_shift(2,t||0),r.write_shift(2,e.numFmtId||0),r.write_shift(2,0),r.write_shift(2,0),r.write_shift(2,0),r.write_shift(1,0),r.write_shift(1,0);return r.write_shift(1,0),r.write_shift(1,0),r.write_shift(1,0),r.write_shift(1,0),r}function No(e,t){return(t=t||Lr(10)).write_shift(1,0),t.write_shift(1,0),t.write_shift(4,0),t.write_shift(4,0),t}r=Pr;function Fo(s,i){var r;i&&(r=0,[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t=e[0];t<=e[1];++t)null!=i[t]&&++r}),0!=r&&(Br(s,615,na(r)),[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t,r,a,n=e[0];n<=e[1];++n)null!=i[n]&&Br(s,44,(t=n,r=i[n],(a=(a=void 0)||Lr(6+4*r.length)).write_shift(2,t),ia(r,a),r=a.length>a.l?a.slice(0,a.l):a,null==a.l&&(a.l=a.length),r))}),Br(s,616)))}function Do(e){var t;Br(e,613,na(1)),Br(e,46,((t=t||Lr(51)).write_shift(1,0),No(0,t),No(0,t),No(0,t),No(0,t),No(0,t),t.length>t.l?t.slice(0,t.l):t)),Br(e,614)}function Po(e){var t,r;Br(e,619,na(1)),Br(e,48,(t={xfId:0,builtinId:0,name:"Normal"},(r=r||Lr(52)).write_shift(4,t.xfId),r.write_shift(2,1),r.write_shift(1,+t.builtinId),r.write_shift(1,0),ba(t.name||"",r),r.length>r.l?r.slice(0,r.l):r)),Br(e,620)}function Lo(e){var t,r,a,n;Br(e,508,(t=0,r="TableStyleMedium9",a="PivotStyleMedium4",(n=Lr(2052)).write_shift(4,t),ba(r,n),ba(a,n),n.length>n.l?n.slice(0,n.l):n)),Br(e,509)}function Mo(e,t){var r,a=Ur();return Br(a,278),Fo(a,e.SSF),Br(e=a,611,na(1)),Br(e,43,xo({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"})),Br(e,612),Br(e=a,603,na(2)),Br(e,45,Oo({patternType:"none"})),Br(e,45,Oo({patternType:"gray125"})),Br(e,604),Do(a),Br(e=a,626,na(1)),Br(e,47,Io({numFmtId:0,fontId:0,fillId:0,borderId:0},65535)),Br(e,627),r=a,t=t.cellXfs,Br(r,617,na(t.length)),t.forEach(function(e){Br(r,47,Io(e,0))}),Br(r,618),Po(a),Br(t=a,505,na(0)),Br(t,506),Lo(a),Br(a,279),a.end()}var Uo=["</a:lt1>","</a:dk1>","</a:lt2>","</a:dk2>","</a:accent1>","</a:accent2>","</a:accent3>","</a:accent4>","</a:accent5>","</a:accent6>","</a:hlink>","</a:folHlink>"];function Bo(e,r,a){r.themeElements.clrScheme=[];var n={};(e[0].match(ft)||[]).forEach(function(e){var t=dt(e);switch(t[0]){case"<a:clrScheme":case"</a:clrScheme>":break;case"<a:srgbClr":n.rgb=t.val;break;case"<a:sysClr":n.rgb=t.lastClr;break;case"<a:dk1>":case"</a:dk1>":case"<a:lt1>":case"</a:lt1>":case"<a:dk2>":case"</a:dk2>":case"<a:lt2>":case"</a:lt2>":case"<a:accent1>":case"</a:accent1>":case"<a:accent2>":case"</a:accent2>":case"<a:accent3>":case"</a:accent3>":case"<a:accent4>":case"</a:accent4>":case"<a:accent5>":case"</a:accent5>":case"<a:accent6>":case"</a:accent6>":case"<a:hlink>":case"</a:hlink>":case"<a:folHlink>":case"</a:folHlink>":"/"===t[0].charAt(1)?(r.themeElements.clrScheme[Uo.indexOf(t[0])]=n,n={}):n.name=t[0].slice(3,t[0].length-1);break;default:if(a&&a.WTF)throw new Error("Unrecognized "+t[0]+" in clrScheme")}})}function Wo(){}function Ho(){}var zo=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/,Vo=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/,Go=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;var jo=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function $o(e,t){var r,a,n,s,i,o={};if(!(r=(e=!e||0===e.length?Xo():e).match(jo)))throw new Error("themeElements not found in theme");return a=r[0],s=t,(n=o).themeElements={},[["clrScheme",zo,Bo],["fontScheme",Vo,Wo],["fmtScheme",Go,Ho]].forEach(function(e){if(!(i=a.match(e[1])))throw new Error(e[0]+" not found in themeElements");e[2](i,n,s)}),o.raw=e,o}function Xo(e,t){if(t&&t.themeXLSX)return t.themeXLSX;if(e&&"string"==typeof e.raw)return e.raw;e=[ot];return e[e.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">',e[e.length]="<a:themeElements>",e[e.length]='<a:clrScheme name="Office">',e[e.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>',e[e.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>',e[e.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>',e[e.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>',e[e.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>',e[e.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>',e[e.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>',e[e.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>',e[e.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>',e[e.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>',e[e.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>',e[e.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>',e[e.length]="</a:clrScheme>",e[e.length]='<a:fontScheme name="Office">',e[e.length]="<a:majorFont>",e[e.length]='<a:latin typeface="Cambria"/>',e[e.length]='<a:ea typeface=""/>',e[e.length]='<a:cs typeface=""/>',e[e.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>',e[e.length]='<a:font script="Hang" typeface="맑은 고딕"/>',e[e.length]='<a:font script="Hans" typeface="宋体"/>',e[e.length]='<a:font script="Hant" typeface="新細明體"/>',e[e.length]='<a:font script="Arab" typeface="Times New Roman"/>',e[e.length]='<a:font script="Hebr" typeface="Times New Roman"/>',e[e.length]='<a:font script="Thai" typeface="Tahoma"/>',e[e.length]='<a:font script="Ethi" typeface="Nyala"/>',e[e.length]='<a:font script="Beng" typeface="Vrinda"/>',e[e.length]='<a:font script="Gujr" typeface="Shruti"/>',e[e.length]='<a:font script="Khmr" typeface="MoolBoran"/>',e[e.length]='<a:font script="Knda" typeface="Tunga"/>',e[e.length]='<a:font script="Guru" typeface="Raavi"/>',e[e.length]='<a:font script="Cans" typeface="Euphemia"/>',e[e.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>',e[e.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>',e[e.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>',e[e.length]='<a:font script="Thaa" typeface="MV Boli"/>',e[e.length]='<a:font script="Deva" typeface="Mangal"/>',e[e.length]='<a:font script="Telu" typeface="Gautami"/>',e[e.length]='<a:font script="Taml" typeface="Latha"/>',e[e.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>',e[e.length]='<a:font script="Orya" typeface="Kalinga"/>',e[e.length]='<a:font script="Mlym" typeface="Kartika"/>',e[e.length]='<a:font script="Laoo" typeface="DokChampa"/>',e[e.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>',e[e.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>',e[e.length]='<a:font script="Viet" typeface="Times New Roman"/>',e[e.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>',e[e.length]='<a:font script="Geor" typeface="Sylfaen"/>',e[e.length]="</a:majorFont>",e[e.length]="<a:minorFont>",e[e.length]='<a:latin typeface="Calibri"/>',e[e.length]='<a:ea typeface=""/>',e[e.length]='<a:cs typeface=""/>',e[e.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>',e[e.length]='<a:font script="Hang" typeface="맑은 고딕"/>',e[e.length]='<a:font script="Hans" typeface="宋体"/>',e[e.length]='<a:font script="Hant" typeface="新細明體"/>',e[e.length]='<a:font script="Arab" typeface="Arial"/>',e[e.length]='<a:font script="Hebr" typeface="Arial"/>',e[e.length]='<a:font script="Thai" typeface="Tahoma"/>',e[e.length]='<a:font script="Ethi" typeface="Nyala"/>',e[e.length]='<a:font script="Beng" typeface="Vrinda"/>',e[e.length]='<a:font script="Gujr" typeface="Shruti"/>',e[e.length]='<a:font script="Khmr" typeface="DaunPenh"/>',e[e.length]='<a:font script="Knda" typeface="Tunga"/>',e[e.length]='<a:font script="Guru" typeface="Raavi"/>',e[e.length]='<a:font script="Cans" typeface="Euphemia"/>',e[e.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>',e[e.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>',e[e.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>',e[e.length]='<a:font script="Thaa" typeface="MV Boli"/>',e[e.length]='<a:font script="Deva" typeface="Mangal"/>',e[e.length]='<a:font script="Telu" typeface="Gautami"/>',e[e.length]='<a:font script="Taml" typeface="Latha"/>',e[e.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>',e[e.length]='<a:font script="Orya" typeface="Kalinga"/>',e[e.length]='<a:font script="Mlym" typeface="Kartika"/>',e[e.length]='<a:font script="Laoo" typeface="DokChampa"/>',e[e.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>',e[e.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>',e[e.length]='<a:font script="Viet" typeface="Arial"/>',e[e.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>',e[e.length]='<a:font script="Geor" typeface="Sylfaen"/>',e[e.length]="</a:minorFont>",e[e.length]="</a:fontScheme>",e[e.length]='<a:fmtScheme name="Office">',e[e.length]="<a:fillStyleLst>",e[e.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>',e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:lin ang="16200000" scaled="1"/>',e[e.length]="</a:gradFill>",e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:lin ang="16200000" scaled="0"/>',e[e.length]="</a:gradFill>",e[e.length]="</a:fillStyleLst>",e[e.length]="<a:lnStyleLst>",e[e.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>',e[e.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>',e[e.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>',e[e.length]="</a:lnStyleLst>",e[e.length]="<a:effectStyleLst>",e[e.length]="<a:effectStyle>",e[e.length]="<a:effectLst>",e[e.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>',e[e.length]="</a:effectLst>",e[e.length]="</a:effectStyle>",e[e.length]="<a:effectStyle>",e[e.length]="<a:effectLst>",e[e.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>',e[e.length]="</a:effectLst>",e[e.length]="</a:effectStyle>",e[e.length]="<a:effectStyle>",e[e.length]="<a:effectLst>",e[e.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>',e[e.length]="</a:effectLst>",e[e.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>',e[e.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>',e[e.length]="</a:effectStyle>",e[e.length]="</a:effectStyleLst>",e[e.length]="<a:bgFillStyleLst>",e[e.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>',e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>',e[e.length]="</a:gradFill>",e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>',e[e.length]="</a:gradFill>",e[e.length]="</a:bgFillStyleLst>",e[e.length]="</a:fmtScheme>",e[e.length]="</a:themeElements>",e[e.length]="<a:objectDefaults>",e[e.length]="<a:spDef>",e[e.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>',e[e.length]="</a:spDef>",e[e.length]="<a:lnDef>",e[e.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>',e[e.length]="</a:lnDef>",e[e.length]="</a:objectDefaults>",e[e.length]="<a:extraClrSchemeLst/>",e[e.length]="</a:theme>",e.join("")}function Yo(e){var t={};switch(t.xclrType=e.read_shift(2),t.nTintShade=e.read_shift(2),t.xclrType){case 0:e.l+=4;break;case 1:t.xclrValue=Pr(e,4);break;case 2:t.xclrValue=Gn(e);break;case 3:t.xclrValue=e.read_shift(4);break;case 4:e.l+=4}return e.l+=8,t}function Ko(e){var t=e.read_shift(2),r=e.read_shift(2)-4,a=[t];switch(t){case 4:case 5:case 7:case 8:case 9:case 10:case 11:case 13:a[1]=Yo(e);break;case 6:a[1]=Pr(e,r);break;case 14:case 15:a[1]=e.read_shift(1==r?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+t+" "+r)}return a}function Jo(){var e,t,r,a=Ur();return Br(a,332),Br(a,334,na(1)),Br(a,335,((r=Lr(12+2*(t={name:"XLDAPR",version:12e4,flags:3496657072}).name.length)).write_shift(4,t.flags),r.write_shift(4,t.version),ia(t.name,r),r.slice(0,r.l))),Br(a,336),Br(a,339,(e=1,(r=Lr(8+2*(t="XLDAPR").length)).write_shift(4,e),ia(t,r),r.slice(0,r.l))),Br(a,52),Br(a,35,na(514)),Br(a,4096,na(0)),Br(a,4097,Fn(1)),Br(a,36),Br(a,53),Br(a,340),Br(a,337,(e=1,t=!0,(r=Lr(8)).write_shift(4,e),r.write_shift(4,t?1:0),r)),Br(a,51,function(e){var t=Lr(4+8*e.length);t.write_shift(4,e.length);for(var r=0;r<e.length;++r)t.write_shift(4,e[r][0]),t.write_shift(4,e[r][1]);return t}([[1,0]])),Br(a,338),Br(a,333),a.end()}function qo(){var e=[ot];return e.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>'),e.join("")}var Zo=1024;function Qo(e,t){for(var r=[21600,21600],a=["m0,0l0",r[1],r[0],r[1],r[0],"0xe"].join(","),n=[Yt("xml",null,{"xmlns:v":er.v,"xmlns:o":er.o,"xmlns:x":er.x,"xmlns:mv":er.mv}).replace(/\/>/,">"),Yt("o:shapelayout",Yt("o:idmap",null,{"v:ext":"edit",data:e}),{"v:ext":"edit"}),Yt("v:shapetype",[Yt("v:stroke",null,{joinstyle:"miter"}),Yt("v:path",null,{gradientshapeok:"t","o:connecttype":"rect"})].join(""),{id:"_x0000_t202","o:spt":202,coordsize:r.join(","),path:a})];Zo<1e3*e;)Zo+=1e3;return t.forEach(function(e){var t=Yr(e[0]),r={color2:"#BEFF82",type:"gradient"};"gradient"==r.type&&(r.angle="-180");var a="gradient"==r.type?Yt("o:fill",null,{type:"gradientUnscaled","v:ext":"view"}):null,r=Yt("v:fill",a,r);++Zo,n=n.concat(["<v:shape"+Xt({id:"_x0000_s"+Zo,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(e[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+">",r,Yt("v:shadow",null,{on:"t",obscured:"t"}),Yt("v:path",null,{"o:connecttype":"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">',"<x:MoveWithCells/>","<x:SizeWithCells/>",$t("x:Anchor",[t.c+1,0,t.r+1,0,t.c+3,20,t.r+5,20].join(",")),$t("x:AutoFill","False"),$t("x:Row",String(t.r)),$t("x:Column",String(t.c)),e[1].hidden?"":"<x:Visible/>","</x:ClientData>","</v:shape>"])}),n.push("</xml>"),n.join("")}function ec(s,e,i,o){var c,l=Array.isArray(s);e.forEach(function(e){var t,r=Yr(e.ref);(c=l?(s[r.r]||(s[r.r]=[]),s[r.r][r.c]):s[e.ref])||(c={t:"z"},l?s[r.r][r.c]=c:s[e.ref]=c,(t=Zr(s["!ref"]||"BDWGO1000001:A1")).s.r>r.r&&(t.s.r=r.r),t.e.r<r.r&&(t.e.r=r.r),t.s.c>r.c&&(t.s.c=r.c),t.e.c<r.c&&(t.e.c=r.c),(t=qr(t))!==s["!ref"]&&(s["!ref"]=t)),c.c||(c.c=[]);var a={a:e.author,t:e.t,r:e.r,T:i};e.h&&(a.h=e.h);for(var n=c.c.length-1;0<=n;--n){if(!i&&c.c[n].T)return;i&&!c.c[n].T&&c.c.splice(n,1)}if(i&&o)for(n=0;n<o.length;++n)if(a.a==o[n].id){a.a=o[n].name||a.a;break}c.c.push(a)})}function tc(e){var s=[ot,Yt("comments",null,{xmlns:Qt[0]})],i=[];return s.push("<authors>"),e.forEach(function(e){e[1].forEach(function(e){var t=kt(e.a);-1==i.indexOf(t)&&(i.push(t),s.push("<author>"+t+"</author>")),e.T&&e.ID&&-1==i.indexOf("tc="+e.ID)&&(i.push("tc="+e.ID),s.push("<author>tc="+e.ID+"</author>"))})}),0==i.length&&(i.push("SheetJ5"),s.push("<author>SheetJ5</author>")),s.push("</authors>"),s.push("<commentList>"),e.forEach(function(e){var t=0,r=[];if(e[1][0]&&e[1][0].T&&e[1][0].ID?t=i.indexOf("tc="+e[1][0].ID):e[1].forEach(function(e){e.a&&(t=i.indexOf(kt(e.a))),r.push(e.t||"")}),s.push('<comment ref="'+e[0]+'" authorId="'+t+'"><text>'),r.length<=1)s.push($t("t",kt(r[0]||"")));else{for(var a="Comment:\n    "+r[0]+"\n",n=1;n<r.length;++n)a+="Reply:\n    "+r[n]+"\n";s.push($t("t",kt(a)))}s.push("</text></comment>")}),s.push("</commentList>"),2<s.length&&(s[s.length]="</comments>",s[1]=s[1].replace("/>",">")),s.join("")}Ue=sa;function rc(e){var n=Ur(),s=[];return Br(n,628),Br(n,630),e.forEach(function(e){e[1].forEach(function(e){-1<s.indexOf(e.a)||(s.push(e.a.slice(0,54)),Br(n,632,ia(e.a.slice(0,54))))})}),Br(n,631),Br(n,633),e.forEach(function(a){a[1].forEach(function(e){e.iauthor=s.indexOf(e.a);var t,r={s:Yr(a[0]),e:Yr(a[0])};Br(n,635,(r=[r,e],(t=null==t?Lr(36):t).write_shift(4,r[1].iauthor),_a(r[0],t),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(4,0),t)),e.t&&0<e.t.length&&Br(n,637,la(e)),Br(n,636),delete e.iauthor})}),Br(n,634),Br(n,629),n.end()}var ac="application/vnd.ms-office.vbaProject";var nc=["xlsb","xlsm","xlam","biff8","xla"];var sc,ic,oc=(ic=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g,function(e,t){return sc=t,e.replace(ic,cc)});function cc(e,t,r,a){var n=!1,s=!1;0==r.length?s=!0:"["==r.charAt(0)&&(s=!0,r=r.slice(1,-1)),0==a.length?n=!0:"["==a.charAt(0)&&(n=!0,a=a.slice(1,-1));r=0<r.length?0|parseInt(r,10):0,a=0<a.length?0|parseInt(a,10):0;return n?a+=sc.c:--a,s?r+=sc.r:--r,t+(n?"":"$")+Xr(a)+(s?"":"$")+jr(r)}var lc=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g,fc=function(e,i){return e.replace(lc,function(e,t,r,a,n,s){a=$r(a)-(r?0:i.c),s=Gr(s)-(n?0:i.r);return t+"R"+(0==s?"":n?1+s:"["+s+"]")+"C"+(0==a?"":r?1+a:"["+a+"]")})};function hc(e,i){return e.replace(lc,function(e,t,r,a,n,s){return t+("$"==r?r+a:Xr($r(a)+i.c))+("$"==n?n+s:jr(Gr(s)+i.r))})}function uc(e){return e.replace(/_xlfn\./g,"")}function dc(e){e.l+=1}function pc(e,t){t=e.read_shift(1==t?1:2);return[16383&t,t>>14&1,t>>15&1]}function mc(e,t,r){var a=2;if(r){if(2<=r.biff&&r.biff<=5)return gc(e);12==r.biff&&(a=4)}var n=e.read_shift(a),r=e.read_shift(a),a=pc(e,2),e=pc(e,2);return{s:{r:n,c:a[0],cRel:a[1],rRel:a[2]},e:{r:r,c:e[0],cRel:e[1],rRel:e[2]}}}function gc(e){var t=pc(e,2),r=pc(e,2),a=e.read_shift(1),e=e.read_shift(1);return{s:{r:t[0],c:a,cRel:t[1],rRel:t[2]},e:{r:r[0],c:e,cRel:r[1],rRel:r[2]}}}function bc(e,t,r){if(r&&2<=r.biff&&r.biff<=5)return n=pc(a=e,2),a=a.read_shift(1),{r:n[0],c:a,cRel:n[1],rRel:n[2]};var a,n,r=e.read_shift(r&&12==r.biff?4:2),e=pc(e,2);return{r:r,c:e[0],cRel:e[1],rRel:e[2]}}function vc(e,t,r){r=r&&r.biff?r.biff:8;if(2<=r&&r<=5)return function(e){var t=e.read_shift(2),r=e.read_shift(1),a=(32768&t)>>15,e=(16384&t)>>14;t&=16383,1==a&&8192<=t&&(t-=16384);1==e&&128<=r&&(r-=256);return{r:t,c:r,cRel:e,rRel:a}}(e);var a=e.read_shift(12<=r?4:2),n=e.read_shift(2),r=(16384&n)>>14,e=(32768&n)>>15;if(n&=16383,1==e)for(;524287<a;)a-=1048576;if(1==r)for(;8191<n;)n-=16384;return{r:a,c:n,cRel:r,rRel:e}}function wc(e){var t=1&e[e.l+1];return e.l+=4,[t,1]}function Tc(e){return[e.read_shift(1),e.read_shift(1)]}function Ec(e,t,r){var a=0,n=0;12==r.biff?(a=e.read_shift(4),n=e.read_shift(4)):(n=1+e.read_shift(1),a=1+e.read_shift(2)),2<=r.biff&&r.biff<8&&(--a,0==--n&&(n=256));for(var s=0,i=[];s!=a&&(i[s]=[]);++s)for(var o=0;o!=n;++o)i[s][o]=function(e,t){var r=[e.read_shift(1)];if(12==t)switch(r[0]){case 2:r[0]=4;break;case 4:r[0]=16;break;case 0:r[0]=1;break;case 1:r[0]=2}switch(r[0]){case 4:r[1]=On(e,1)?"TRUE":"FALSE",12!=t&&(e.l+=7);break;case 37:case 16:r[1]=Wa[e[e.l]],e.l+=12==t?4:8;break;case 0:e.l+=8;break;case 1:r[1]=xa(e);break;case 2:r[1]=Bn(e,0,{biff:0<t&&t<8?2:t});break;default:throw new Error("Bad SerAr: "+r[0])}return r}(e,r.biff);return i}function kc(e,t,r){return e.l+=2,[(e=(a=e).read_shift(2),a=a.read_shift(2),{r:e,c:255&a,fQuoted:!!(16384&a),cRel:a>>15,rRel:a>>15})];var a}function yc(e){return e.l+=6,[]}function Sc(e){return e.l+=2,[Nn(e),1&e.read_shift(2)]}var _c=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];var xc={1:{n:"PtgExp",f:function(e,t,r){return e.l++,r&&12==r.biff?[e.read_shift(4,"i"),0]:[e.read_shift(2),e.read_shift(r&&2==r.biff?1:2)]}},2:{n:"PtgTbl",f:Pr},3:{n:"PtgAdd",f:dc},4:{n:"PtgSub",f:dc},5:{n:"PtgMul",f:dc},6:{n:"PtgDiv",f:dc},7:{n:"PtgPower",f:dc},8:{n:"PtgConcat",f:dc},9:{n:"PtgLt",f:dc},10:{n:"PtgLe",f:dc},11:{n:"PtgEq",f:dc},12:{n:"PtgGe",f:dc},13:{n:"PtgGt",f:dc},14:{n:"PtgNe",f:dc},15:{n:"PtgIsect",f:dc},16:{n:"PtgUnion",f:dc},17:{n:"PtgRange",f:dc},18:{n:"PtgUplus",f:dc},19:{n:"PtgUminus",f:dc},20:{n:"PtgPercent",f:dc},21:{n:"PtgParen",f:dc},22:{n:"PtgMissArg",f:dc},23:{n:"PtgStr",f:function(e,t,r){return e.l++,Ln(e,0,r)}},26:{n:"PtgSheet",f:function(e,t,r){return e.l+=5,e.l+=2,e.l+=2==r.biff?1:4,["PTGSHEET"]}},27:{n:"PtgEndSheet",f:function(e,t,r){return e.l+=2==r.biff?4:5,["PTGENDSHEET"]}},28:{n:"PtgErr",f:function(e){return e.l++,Wa[e.read_shift(1)]}},29:{n:"PtgBool",f:function(e){return e.l++,0!==e.read_shift(1)}},30:{n:"PtgInt",f:function(e){return e.l++,e.read_shift(2)}},31:{n:"PtgNum",f:function(e){return e.l++,xa(e)}},32:{n:"PtgArray",f:function(e,t,r){var a=(96&e[e.l++])>>5;return e.l+=2==r.biff?6:12==r.biff?14:7,[a]}},33:{n:"PtgFunc",f:function(e,t,r){var a=(96&e[e.l])>>5;return e.l+=1,r=e.read_shift(r&&r.biff<=3?1:2),[jc[r],Gc[r],a]}},34:{n:"PtgFuncVar",f:function(e,t,r){var a=e[e.l++],n=e.read_shift(1),s=r&&r.biff<=3?[88==a?-1:0,e.read_shift(1)]:[(s=e)[s.l+1]>>7,32767&s.read_shift(2)];return[n,(0===s[0]?Gc:Vc)[s[1]]]}},35:{n:"PtgName",f:function(e,t,r){var a=e.read_shift(1)>>>5&3,n=!r||8<=r.biff?4:2,n=e.read_shift(n);switch(r.biff){case 2:e.l+=5;break;case 3:case 4:e.l+=8;break;case 5:e.l+=12}return[a,0,n]}},36:{n:"PtgRef",f:function(e,t,r){var a=(96&e[e.l])>>5;return e.l+=1,[a,bc(e,0,r)]}},37:{n:"PtgArea",f:function(e,t,r){return[(96&e[e.l++])>>5,mc(e,2<=r.biff&&r.biff,r)]}},38:{n:"PtgMemArea",f:function(e,t,r){var a=e.read_shift(1)>>>5&3;return e.l+=r&&2==r.biff?3:4,[a,e.read_shift(r&&2==r.biff?1:2)]}},39:{n:"PtgMemErr",f:Pr},40:{n:"PtgMemNoMem",f:Pr},41:{n:"PtgMemFunc",f:function(e,t,r){return[e.read_shift(1)>>>5&3,e.read_shift(r&&2==r.biff?1:2)]}},42:{n:"PtgRefErr",f:function(e,t,r){var a=e.read_shift(1)>>>5&3;return e.l+=4,r.biff<8&&e.l--,12==r.biff&&(e.l+=2),[a]}},43:{n:"PtgAreaErr",f:function(e,t,r){var a=(96&e[e.l++])>>5;return e.l+=r&&8<r.biff?12:r.biff<8?6:8,[a]}},44:{n:"PtgRefN",f:function(e,t,r){var a=(96&e[e.l])>>5;return e.l+=1,[a,vc(e,0,r)]}},45:{n:"PtgAreaN",f:function(e,t,r){return[(96&e[e.l++])>>5,function(e,t){if(t.biff<8)return gc(e);var r=e.read_shift(12==t.biff?4:2),a=e.read_shift(12==t.biff?4:2),t=pc(e,2),e=pc(e,2);return{s:{r:r,c:t[0],cRel:t[1],rRel:t[2]},e:{r:a,c:e[0],cRel:e[1],rRel:e[2]}}}(e,r)]}},46:{n:"PtgMemAreaN",f:function(e){return[e.read_shift(1)>>>5&3,e.read_shift(2)]}},47:{n:"PtgMemNoMemN",f:function(e){return[e.read_shift(1)>>>5&3,e.read_shift(2)]}},57:{n:"PtgNameX",f:function(e,t,r){return 5==r.biff?function(e){var t=e.read_shift(1)>>>5&3,r=e.read_shift(2,"i");e.l+=8;var a=e.read_shift(2);return e.l+=12,[t,r,a]}(e):[e.read_shift(1)>>>5&3,e.read_shift(2),e.read_shift(4)]}},58:{n:"PtgRef3d",f:function(e,t,r){var a=(96&e[e.l])>>5;e.l+=1;var n=e.read_shift(2);return r&&5==r.biff&&(e.l+=12),[a,n,bc(e,0,r)]}},59:{n:"PtgArea3d",f:function(e,t,r){var a=(96&e[e.l++])>>5,n=e.read_shift(2,"i");if(r)switch(r.biff){case 5:e.l+=12,0;break;case 12:0}return[a,n,mc(e,0,r)]}},60:{n:"PtgRefErr3d",f:function(e,t,r){var a=(96&e[e.l++])>>5,n=e.read_shift(2),s=4;if(r)switch(r.biff){case 5:s=15;break;case 12:s=6}return e.l+=s,[a,n]}},61:{n:"PtgAreaErr3d",f:function(e,t,r){var a=(96&e[e.l++])>>5,n=e.read_shift(2),s=8;if(r)switch(r.biff){case 5:e.l+=12,s=6;break;case 12:s=12}return e.l+=s,[a,n]}},255:{}},Ac={64:32,96:32,65:33,97:33,66:34,98:34,67:35,99:35,68:36,100:36,69:37,101:37,70:38,102:38,71:39,103:39,72:40,104:40,73:41,105:41,74:42,106:42,75:43,107:43,76:44,108:44,77:45,109:45,78:46,110:46,79:47,111:47,88:34,120:34,89:57,121:57,90:58,122:58,91:59,123:59,92:60,124:60,93:61,125:61},Cc={1:{n:"PtgElfLel",f:Sc},2:{n:"PtgElfRw",f:kc},3:{n:"PtgElfCol",f:kc},6:{n:"PtgElfRwV",f:kc},7:{n:"PtgElfColV",f:kc},10:{n:"PtgElfRadical",f:kc},11:{n:"PtgElfRadicalS",f:yc},13:{n:"PtgElfColS",f:yc},15:{n:"PtgElfColSV",f:yc},16:{n:"PtgElfRadicalLel",f:Sc},25:{n:"PtgList",f:function(e){e.l+=2;var t=e.read_shift(2),r=e.read_shift(2),a=e.read_shift(4),n=e.read_shift(2),e=e.read_shift(2);return{ixti:t,coltype:3&r,rt:_c[r>>2&31],idx:a,c:n,C:e}}},29:{n:"PtgSxName",f:function(e){return e.l+=2,[e.read_shift(4)]}},255:{}},Rc={0:{n:"PtgAttrNoop",f:function(e){return e.l+=4,[0,0]}},1:{n:"PtgAttrSemi",f:function(e,t,r){var a=255&e[e.l+1]?1:0;return e.l+=r&&2==r.biff?3:4,[a]}},2:{n:"PtgAttrIf",f:function(e,t,r){var a=255&e[e.l+1]?1:0;return e.l+=2,[a,e.read_shift(r&&2==r.biff?1:2)]}},4:{n:"PtgAttrChoose",f:function(e,t,r){e.l+=2;for(var a=e.read_shift(r&&2==r.biff?1:2),n=[],s=0;s<=a;++s)n.push(e.read_shift(r&&2==r.biff?1:2));return n}},8:{n:"PtgAttrGoto",f:function(e,t,r){var a=255&e[e.l+1]?1:0;return e.l+=2,[a,e.read_shift(r&&2==r.biff?1:2)]}},16:{n:"PtgAttrSum",f:function(e,t,r){e.l+=r&&2==r.biff?3:4}},32:{n:"PtgAttrBaxcel",f:wc},33:{n:"PtgAttrBaxcel",f:wc},64:{n:"PtgAttrSpace",f:function(e){return e.read_shift(2),Tc(e)}},65:{n:"PtgAttrSpaceSemi",f:function(e){return e.read_shift(2),Tc(e)}},128:{n:"PtgAttrIfError",f:function(e){var t=255&e[e.l+1]?1:0;return e.l+=2,[t,e.read_shift(2)]}},255:{}};function Oc(e,t,r,a){if(a.biff<8)return Pr(e,t);for(var n=e.l+t,s=[],i=0;i!==r.length;++i)switch(r[i][0]){case"PtgArray":r[i][1]=Ec(e,0,a),s.push(r[i][1]);break;case"PtgMemArea":r[i][2]=function(e,t){for(var r=e.read_shift(12==t.biff?4:2),a=[],n=0;n!=r;++n)a.push((12==t.biff?Sa:Kn)(e,8));return a}(e,(r[i][1],a)),s.push(r[i][2]);break;case"PtgExp":a&&12==a.biff&&(r[i][1][1]=e.read_shift(4),s.push(r[i][1]));break;case"PtgList":case"PtgElfRadicalS":case"PtgElfColS":case"PtgElfColSV":throw"Unsupported "+r[i][0]}return 0!==(t=n-e.l)&&s.push(Pr(e,t)),s}function Ic(e,t,r){for(var a,n,s=e.l+t,i=[];s!=e.l;)t=s-e.l,n=e[e.l],a=xc[n]||xc[Ac[n]],(a=24===n||25===n?(24===n?Cc:Rc)[e[e.l+1]]:a)&&a.f?i.push([a.n,a.f(e,t,r)]):Pr(e,t);return i}var Nc={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};function Fc(e,t,r){if(!e)return"SH33TJSERR0";if(8<r.biff&&(!e.XTI||!e.XTI[t]))return e.SheetNames[t];if(!e.XTI)return"SH33TJSERR6";var a=e.XTI[t];if(r.biff<8)return 1e4<t&&(t-=65536),0==(t=t<0?-t:t)?"":e.XTI[t-1];if(!a)return"SH33TJSERR1";var n="";if(8<r.biff)switch(e[a[0]][0]){case 357:return n=-1==a[1]?"#REF":e.SheetNames[a[1]],a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 358:return null!=r.SID?e.SheetNames[r.SID]:"SH33TJSSAME"+e[a[0]][0];case 355:default:return"SH33TJSSRC"+e[a[0]][0]}switch(e[a[0]][0][0]){case 1025:return n=-1==a[1]?"#REF":e.SheetNames[a[1]]||"SH33TJSERR3",a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 14849:return e[a[0]].slice(1).map(function(e){return e.Name}).join(";;");default:return e[a[0]][0][3]?(n=-1==a[1]?"#REF":e[a[0]][0][3][a[1]]||"SH33TJSERR4",a[1]==a[2]?n:n+":"+e[a[0]][0][3][a[2]]):"SH33TJSERR2"}}function Dc(e,t,r){t=Fc(e,t,r);return"#REF"==t?t:function(e,t){if(!(e||t&&t.biff<=5&&2<=t.biff))throw new Error("empty sheet name");return/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e)?"'"+e+"'":e}(t,r)}function Pc(e,t,r,a,n){var s,i,o,c=n&&n.biff||8,l={s:{c:0,r:0},e:{c:0,r:0}},f=[],h=0,u=0,d="";if(!e[0]||!e[0][0])return"";for(var p=-1,m="",g=0,b=e[0].length;g<b;++g){var v=e[0][g];switch(v[0]){case"PtgUminus":f.push("-"+f.pop());break;case"PtgUplus":f.push("+"+f.pop());break;case"PtgPercent":f.push(f.pop()+"%");break;case"PtgAdd":case"PtgConcat":case"PtgDiv":case"PtgEq":case"PtgGe":case"PtgGt":case"PtgLe":case"PtgLt":case"PtgMul":case"PtgNe":case"PtgPower":case"PtgSub":if(O=f.pop(),s=f.pop(),0<=p){switch(e[0][p][1][0]){case 0:m=Ge(" ",e[0][p][1][1]);break;case 1:m=Ge("\r",e[0][p][1][1]);break;default:if(m="",n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][p][1][0])}s+=m,p=-1}f.push(s+Nc[v[0]]+O);break;case"PtgIsect":O=f.pop(),s=f.pop(),f.push(s+" "+O);break;case"PtgUnion":O=f.pop(),s=f.pop(),f.push(s+","+O);break;case"PtgRange":O=f.pop(),s=f.pop(),f.push(s+":"+O);break;case"PtgAttrChoose":case"PtgAttrGoto":case"PtgAttrIf":case"PtgAttrIfError":break;case"PtgRef":i=Wr(v[1][1],l,n),f.push(zr(i,c));break;case"PtgRefN":i=r?Wr(v[1][1],r,n):v[1][1],f.push(zr(i,c));break;case"PtgRef3d":h=v[1][1],i=Wr(v[1][2],l,n);d=Dc(a,h,n);f.push(d+"!"+zr(i,c));break;case"PtgFunc":case"PtgFuncVar":var w=v[1][0],T=v[1][1],w=w||0,E=0==(w&=127)?[]:f.slice(-w);f.length-=w,"User"===T&&(T=E.shift()),f.push(T+"("+E.join(",")+")");break;case"PtgBool":f.push(v[1]?"TRUE":"FALSE");break;case"PtgInt":f.push(v[1]);break;case"PtgNum":f.push(String(v[1]));break;case"PtgStr":f.push('"'+v[1].replace(/"/g,'""')+'"');break;case"PtgErr":f.push(v[1]);break;case"PtgAreaN":o=Hr(v[1][1],r?{s:r}:l,n),f.push(Vr(o,n));break;case"PtgArea":o=Hr(v[1][1],l,n),f.push(Vr(o,n));break;case"PtgArea3d":h=v[1][1],o=v[1][2],d=Dc(a,h,n),f.push(d+"!"+Vr(o,n));break;case"PtgAttrSum":f.push("SUM("+f.pop()+")");break;case"PtgAttrBaxcel":case"PtgAttrSemi":break;case"PtgName":u=v[1][2];var k=(a.names||[])[u-1]||(a[0]||[])[u],y=k?k.Name:"SH33TJSNAME"+String(u);y&&"_xlfn."==y.slice(0,6)&&!n.xlfn&&(y=y.slice(6)),f.push(y);break;case"PtgNameX":var S,_=v[1][1],u=v[1][2];if(!(n.biff<=5)){k="";14849==((a[_]||[])[0]||[])[0]||(1025==((a[_]||[])[0]||[])[0]?a[_][u]&&0<a[_][u].itab&&(k=a.SheetNames[a[_][u].itab-1]+"!"):k=a.SheetNames[u-1]+"!"),a[_]&&a[_][u]?k+=a[_][u].Name:a[0]&&a[0][u]?k+=a[0][u].Name:(y=(Fc(a,_,n)||"").split(";;"))[u-1]?k=y[u-1]:k+="SH33TJSERRX",f.push(k);break}S=(S=a[_=_<0?-_:_]?a[_][u]:S)||{Name:"SH33TJSERRY"},f.push(S.Name);break;case"PtgParen":var x="(",A=")";if(0<=p){switch(m="",e[0][p][1][0]){case 2:x=Ge(" ",e[0][p][1][1])+x;break;case 3:x=Ge("\r",e[0][p][1][1])+x;break;case 4:A=Ge(" ",e[0][p][1][1])+A;break;case 5:A=Ge("\r",e[0][p][1][1])+A;break;default:if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][p][1][0])}p=-1}f.push(x+f.pop()+A);break;case"PtgRefErr":case"PtgRefErr3d":f.push("#REF!");break;case"PtgExp":i={c:v[1][1],r:v[1][0]};var C={c:r.c,r:r.r};if(a.sharedf[Kr(i)]){_=a.sharedf[Kr(i)];f.push(Pc(_,0,C,a,n))}else{for(var R=!1,O=0;O!=a.arrayf.length;++O)if(s=a.arrayf[O],!(i.c<s[0].s.c||i.c>s[0].e.c||i.r<s[0].s.r||i.r>s[0].e.r)){f.push(Pc(s[1],0,C,a,n)),R=!0;break}R||f.push(v[1])}break;case"PtgArray":f.push("{"+function(e){for(var t=[],r=0;r<e.length;++r){for(var a=e[r],n=[],s=0;s<a.length;++s){var i=a[s];i?2===i[0]?n.push('"'+i[1].replace(/"/g,'""')+'"'):n.push(i[1]):n.push("")}t.push(n.join(","))}return t.join(";")}(v[1])+"}");break;case"PtgMemArea":break;case"PtgAttrSpace":case"PtgAttrSpaceSemi":p=g;break;case"PtgTbl":case"PtgMemErr":break;case"PtgMissArg":f.push("");break;case"PtgAreaErr":case"PtgAreaErr3d":f.push("#REF!");break;case"PtgList":f.push("Table"+v[1].idx+"[#"+v[1].rt+"]");break;case"PtgMemAreaN":case"PtgMemNoMemN":case"PtgAttrNoop":case"PtgSheet":case"PtgEndSheet":case"PtgMemFunc":case"PtgMemNoMem":break;case"PtgElfCol":case"PtgElfColS":case"PtgElfColSV":case"PtgElfColV":case"PtgElfLel":case"PtgElfRadical":case"PtgElfRadicalLel":case"PtgElfRadicalS":case"PtgElfRw":case"PtgElfRwV":throw new Error("Unsupported ELFs");case"PtgSxName":default:throw new Error("Unrecognized Formula Token: "+String(v))}if(3!=n.biff&&0<=p&&-1==["PtgAttrSpace","PtgAttrSpaceSemi","PtgAttrGoto"].indexOf(e[0][g][0])){var I=!0;switch((v=e[0][p])[1][0]){case 4:I=!1;case 0:m=Ge(" ",v[1][1]);break;case 5:I=!1;case 1:m=Ge("\r",v[1][1]);break;default:if(m="",n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+v[1][0])}f.push((I?m:"")+f.pop()+(I?"":m)),p=-1}}if(1<f.length&&n.WTF)throw new Error("bad formula stack");return f[0]}function Lc(e,t,r){var a=e.l+t,n=$n(e);2==r.biff&&++e.l;var s=function(e){var t;if(65535!==yr(e,e.l+6))return[xa(e),"n"];switch(e[e.l]){case 0:return e.l+=8,["String","s"];case 1:return t=1===e[e.l+2],e.l+=8,[t,"b"];case 2:return t=e[e.l+2],e.l+=8,[t,"e"];case 3:return e.l+=8,["","s"]}return[]}(e),t=e.read_shift(1);2!=r.biff&&(e.read_shift(1),5<=r.biff&&e.read_shift(4));r=function(e,t,r){var a,n=e.l+t,s=2==r.biff?1:2,i=e.read_shift(s);if(65535==i)return[[],Pr(e,t-2)];var o=Ic(e,i,r);return t!==i+s&&(a=Oc(e,t-i-s,o,r)),e.l=n,[o,a]}(e,a-e.l,r);return{cell:n,val:s[0],formula:r,shared:t>>3&1,tt:s[1]}}function Mc(e,t,r,a,n){t=Xn(t,r,n),n=null!=(r=e.v)?Aa("number"==typeof r?r:0):((r=Lr(8)).write_shift(1,3),r.write_shift(1,0),r.write_shift(2,0),r.write_shift(2,0),r.write_shift(2,65535),r),r=Lr(6);r.write_shift(2,33),r.write_shift(4,0);for(var s=Lr(e.bf.length),i=0;i<e.bf.length;++i)s[i]=e.bf[i];return ue([t,n,r,s])}function Uc(e,t,r){var a=e.read_shift(4),n=Ic(e,a,r),a=e.read_shift(4);return[n,0<a?Oc(e,a,n,r):null]}var Bc=Uc,Wc=Uc,Hc=Uc,zc=Uc,Vc={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"},Gc={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"},jc={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};function $c(e){return(e=(e=(e=(e=61==(e="of:"==e.slice(0,3)?e.slice(3):e).charCodeAt(0)&&61==(e=e.slice(1)).charCodeAt(0)?e.slice(1):e).replace(/COM\.MICROSOFT\./g,"")).replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function(e,t){return t.replace(/\./g,"")})).replace(/\[.(#[A-Z]*[?!])\]/g,"$1")).replace(/[;~]/g,",").replace(/\|/g,";")}function Xc(e){e=e.split(":");return[e[0].split(".")[0],e[0].split(".")[1]+(1<e.length?":"+(e[1].split(".")[1]||e[1].split(".")[0]):"")]}var Yc={},Kc={},Jc="undefined"!=typeof Map;function qc(e,t,r){var a=0,n=e.length;if(r){if(Jc?r.has(t):Object.prototype.hasOwnProperty.call(r,t))for(var s=Jc?r.get(t):r[t];a<s.length;++a)if(e[s[a]].t===t)return e.Count++,s[a]}else for(;a<n;++a)if(e[a].t===t)return e.Count++,a;return e[n]={t:t},e.Count++,e.Unique++,r&&(Jc?(r.has(t)||r.set(t,[]),r.get(t).push(n)):(Object.prototype.hasOwnProperty.call(r,t)||(r[t]=[]),r[t].push(n))),n}function Zc(e,t){var r={min:e+1,max:e+1},e=-1;return t.MDW&&(no=t.MDW),null!=t.width?r.customWidth=1:null!=t.wpx?e=io(t.wpx):null!=t.wch&&(e=t.wch),-1<e?(r.width=oo(e),r.customWidth=1):null!=t.width&&(r.width=t.width),t.hidden&&(r.hidden=!0),null!=t.level&&(r.outlineLevel=r.level=t.level),r}function Qc(e,t){e&&(t="xlml"==t?[1,1,1,1,.5,.5]:[.7,.7,.75,.75,.3,.3],null==e.left&&(e.left=t[0]),null==e.right&&(e.right=t[1]),null==e.top&&(e.top=t[2]),null==e.bottom&&(e.bottom=t[3]),null==e.header&&(e.header=t[4]),null==e.footer&&(e.footer=t[5]))}function el(e,t,r){if(void 0!==yo){if(/^\d+$/.exec(t.s))return t.s;if(t.s&&t.s==+t.s)return t.s;var a=t.s||{};return t.z&&(a.numFmt=t.z),yo.addStyle(a)}var n=r.revssf[null!=t.z?t.z:"General"],s=60,i=e.length;if(null==n&&r.ssf)for(;s<392;++s)if(null==r.ssf[s]){we(t.z,s),r.ssf[s]=t.z,r.revssf[t.z]=n=s;break}for(s=0;s!=i;++s)if(e[s].numFmtId===n)return s;return e[i]={numFmtId:n,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1},i}function tl(e,t,r,a,n,s){try{a.cellNF&&(e.z=me[t])}catch(e){if(a.WTF)throw e}if("z"!==e.t||a.cellStyles){if("d"===e.t&&"string"==typeof e.v&&(e.v=He(e.v)),(!a||!1!==a.cellText)&&"z"!==e.t)try{if(null==me[t]&&we(ke[t]||"General",t),"e"===e.t)e.w=e.w||Wa[e.v];else if(0===t)if("n"===e.t)(0|e.v)===e.v?e.w=e.v.toString(10):e.w=D(e.v);else if("d"===e.t){var i=De(e.v);e.w=(0|i)===i?i.toString(10):D(i)}else{if(void 0===e.v)return;e.w=P(e.v,Kc)}else"d"===e.t?e.w=ve(t,De(e.v),Kc):e.w=ve(t,e.v,Kc)}catch(e){if(a.WTF)throw e}if(a.cellStyles&&null!=r)try{e.s=s.Fills[r],e.s.fgColor&&e.s.fgColor.theme&&!e.s.fgColor.rgb&&(e.s.fgColor.rgb=eo(n.themeElements.clrScheme[e.s.fgColor.theme].rgb,e.s.fgColor.tint||0),a.WTF&&(e.s.fgColor.raw_rgb=n.themeElements.clrScheme[e.s.fgColor.theme].rgb)),e.s.bgColor&&e.s.bgColor.theme&&(e.s.bgColor.rgb=eo(n.themeElements.clrScheme[e.s.bgColor.theme].rgb,e.s.bgColor.tint||0),a.WTF&&(e.s.bgColor.raw_rgb=n.themeElements.clrScheme[e.s.bgColor.theme].rgb))}catch(e){if(a.WTF&&s.Fills)throw e}}}var rl=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g,al=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/,nl=/<(?:\w:)?hyperlink [^>]*>/gm,sl=/"(\w*:\w*)"/,il=/<(?:\w:)?col\b[^>]*[\/]?>/g,ol=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g,cl=/<(?:\w:)?pageMargins[^>]*\/>/g,ll=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/,fl=/<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/,hl=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function ul(e,t,r,a,n,s,i){if(!e)return e;a=a||{"!id":{}},null!=oe&&null==t.dense&&(t.dense=oe);var o=t.dense?[]:{},c={s:{r:2e6,c:2e6},e:{r:0,c:0}},l="",f="",h=e.match(al);h?(l=e.slice(0,h.index),f=e.slice(h.index+h[0].length)):l=f=e;var u=l.match(ll);u?dl(u[0],0,n,r):(u=l.match(fl))&&(e=u[0],u[1],u=o,d=n,p=r,dl(e.slice(0,e.indexOf(">")),0,d,p));var d,p,m=(l.match(/<(?:\w*:)?dimension/)||{index:-1}).index;0<m&&((d=l.slice(m,m+50).match(sl))&&(p=o,(b=Zr(b=d[1])).s.r<=b.e.r&&b.s.c<=b.e.c&&0<=b.s.r&&0<=b.s.c&&(p["!ref"]=qr(b))));var g,b=l.match(hl);b&&b[1]&&(w=b[1],(g=n).Views||(g.Views=[{}]),(w.match(gl)||[]).forEach(function(e,t){e=dt(e);g.Views[t]||(g.Views[t]={}),+e.zoomScale&&(g.Views[t].zoom=+e.zoomScale),Rt(e.rightToLeft)&&(g.Views[t].RTL=!0)}));var v,w=[];t.cellStyles&&(v=l.match(il))&&function(e,t){for(var r=!1,a=0;a!=t.length;++a){var n=dt(t[a],!0);n.hidden&&(n.hidden=Rt(n.hidden));var s=parseInt(n.min,10)-1,i=parseInt(n.max,10)-1;for(n.outlineLevel&&(n.level=+n.outlineLevel||0),delete n.min,delete n.max,n.width=+n.width,!r&&n.width&&(r=!0,lo(n.width)),fo(n);s<=i;)e[s++]=Ve(n)}}(w,v),h&&Sl(h[1],o,t,c,s,i);i=f.match(ol);i&&(o["!autofilter"]={ref:(i[0].match(/ref="([^"]*)"/)||[])[1]});var T=[],E=f.match(rl);if(E)for(m=0;m!=E.length;++m)T[m]=Zr(E[m].slice(E[m].indexOf('"')+1));i=f.match(nl);i&&function(e,t,r){for(var a=Array.isArray(e),n=0;n!=t.length;++n){var s=dt(Mt(t[n]),!0);if(!s.ref)return;var i=((r||{})["!id"]||[])[s.id];i?(s.Target=i.Target,s.location&&(s.Target+="#"+wt(s.location))):(s.Target="#"+wt(s.location),i={Target:s.Target,TargetMode:"Internal"}),s.Rel=i,s.tooltip&&(s.Tooltip=s.tooltip,delete s.tooltip);for(var o=Zr(s.ref),c=o.s.r;c<=o.e.r;++c)for(var l=o.s.c;l<=o.e.c;++l){var f=Kr({c:l,r:c});a?(e[c]||(e[c]=[]),e[c][l]||(e[c][l]={t:"z",v:void 0}),e[c][l].l=s):(e[f]||(e[f]={t:"z",v:void 0}),e[f].l=s)}}}(o,i,a);var k,y,f=f.match(cl);return f&&(o["!margins"]=(k=dt(f[0]),y={},["left","right","top","bottom","header","footer"].forEach(function(e){k[e]&&(y[e]=parseFloat(k[e]))}),y)),!o["!ref"]&&c.e.c>=c.s.c&&c.e.r>=c.s.r&&(o["!ref"]=qr(c)),0<t.sheetRows&&o["!ref"]&&(f=Zr(o["!ref"]),t.sheetRows<=+f.e.r&&(f.e.r=t.sheetRows-1,f.e.r>c.e.r&&(f.e.r=c.e.r),f.e.r<f.s.r&&(f.s.r=f.e.r),f.e.c>c.e.c&&(f.e.c=c.e.c),f.e.c<f.s.c&&(f.s.c=f.e.c),o["!fullref"]=o["!ref"],o["!ref"]=qr(f))),0<w.length&&(o["!cols"]=w),0<T.length&&(o["!merges"]=T),o}function dl(e,t,r,a){e=dt(e);r.Sheets[a]||(r.Sheets[a]={}),e.codeName&&(r.Sheets[a].CodeName=wt(Mt(e.codeName)))}var pl=["objects","scenarios","selectLockedCells","selectUnlockedCells"],ml=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];var gl=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;var bl,vl,wl,Tl,El,kl,yl,Sl=(bl=/<(?:\w+:)?c[ \/>]/,vl=/<\/(?:\w+:)?row>/,wl=/r=["']([^"']*)["']/,Tl=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/,El=/ref=["']([^"']*)["']/,kl=Bt("v"),yl=Bt("f"),function(e,t,r,a,n,s){for(var i,o,c,l,f,h,u=0,d="",p=[],m=[],g=0,b=0,v="",w=0,T=0,E=0,k=0,y=Array.isArray(s.CellXf),S=[],_=[],x=Array.isArray(t),A=[],C={},R=!1,O=!!r.sheetStubs,I=e.split(vl),N=0,F=I.length;N!=F;++N){var D=(d=I[N].trim()).length;if(0!==D){var P=0;e:for(u=0;u<D;++u)switch(d[u]){case">":if("/"!=d[u-1]){++u;break e}if(r&&r.cellStyles){if(w=null!=(c=dt(d.slice(P,u),!0)).r?parseInt(c.r,10):w+1,T=-1,r.sheetRows&&r.sheetRows<w)continue;R=!(C={}),c.ht&&(R=!0,C.hpt=parseFloat(c.ht),C.hpx=po(C.hpt)),"1"==c.hidden&&(R=!0,C.hidden=!0),null!=c.outlineLevel&&(R=!0,C.level=+c.outlineLevel),R&&(A[w-1]=C)}break;case"<":P=u}if(u<=P)break;if(w=null!=(c=dt(d.slice(P,u),!0)).r?parseInt(c.r,10):w+1,T=-1,!(r.sheetRows&&r.sheetRows<w)){a.s.r>w-1&&(a.s.r=w-1),a.e.r<w-1&&(a.e.r=w-1),r&&r.cellStyles&&(R=!(C={}),c.ht&&(R=!0,C.hpt=parseFloat(c.ht),C.hpx=po(C.hpt)),"1"==c.hidden&&(R=!0,C.hidden=!0),null!=c.outlineLevel&&(R=!0,C.level=+c.outlineLevel),R&&(A[w-1]=C)),p=d.slice(u).split(bl);for(var L,M=0;M!=p.length&&"<"==p[M].trim().charAt(0);++M);for(p=p.slice(M),u=0;u!=p.length;++u)if(0!==(d=p[u].trim()).length){if(m=d.match(wl),g=u,b=0,d="<c "+("<"==d.slice(0,1)?">":"")+d,null!=m&&2===m.length){for(g=0,v=m[1],b=0;b!=v.length&&!((i=v.charCodeAt(b)-64)<1||26<i);++b)g=26*g+i;T=--g}else++T;for(b=0;b!=d.length&&62!==d.charCodeAt(b);++b);if(++b,(c=dt(d.slice(0,b),!0)).r||(c.r=Kr({r:w-1,c:T})),o={t:""},null!=(m=(v=d.slice(b)).match(kl))&&""!==m[1]&&(o.v=wt(m[1])),r.cellFormula){null!=(m=v.match(yl))&&""!==m[1]?(o.f=wt(Mt(m[1])).replace(/\r\n/g,"\n"),r.xlfn||(o.f=uc(o.f)),-1<m[0].indexOf('t="array"')?(o.F=(v.match(El)||[])[1],-1<o.F.indexOf(":")&&S.push([Zr(o.F),o.F])):-1<m[0].indexOf('t="shared"')&&(f=dt(m[0]),L=wt(Mt(m[1])),r.xlfn||(L=uc(L)),_[parseInt(f.si,10)]=[f,L,c.r])):(m=v.match(/<f[^>]*\/>/))&&_[(f=dt(m[0])).si]&&(o.f=(h=_[f.si][1],W=_[f.si][2],L=c.r,W=Jr(W).s,L=Yr(L),hc(h,{r:L.r-W.r,c:L.c-W.c})));for(var U=Yr(c.r),b=0;b<S.length;++b)U.r>=S[b][0].s.r&&U.r<=S[b][0].e.r&&U.c>=S[b][0].s.c&&U.c<=S[b][0].e.c&&(o.F=S[b][1])}if(null==c.t&&void 0===o.v)if(o.f||o.F)o.v=0,o.t="n";else{if(!O)continue;o.t="z"}else o.t=c.t||"n";switch(a.s.c>T&&(a.s.c=T),a.e.c<T&&(a.e.c=T),o.t){case"n":if(""==o.v||null==o.v){if(!O)continue;o.t="z"}else o.v=parseFloat(o.v);break;case"s":if(void 0===o.v){if(!O)continue;o.t="z"}else l=Yc[parseInt(o.v,10)],o.v=l.t,o.r=l.r,r.cellHTML&&(o.h=l.h);break;case"str":o.t="s",o.v=null!=o.v?Mt(o.v):"",r.cellHTML&&(o.h=_t(o.v));break;case"inlineStr":m=v.match(Tl),o.t="s",null!=m&&(l=Ai(m[1]))?(o.v=l.t,r.cellHTML&&(o.h=l.h)):o.v="";break;case"b":o.v=Rt(o.v);break;case"d":r.cellDates?o.v=He(o.v,1):(o.v=De(He(o.v,1)),o.t="n");break;case"e":r&&!1===r.cellText||(o.w=o.v),o.v=Ha[o.v]}var B,E=k=0,W=null;y&&void 0!==c.s&&null!=(W=s.CellXf[c.s])&&(null!=W.numFmtId&&(E=W.numFmtId),r.cellStyles&&null!=W.fillId&&(k=W.fillId)),tl(o,E,k,r,n,s),r.cellDates&&y&&"n"==o.t&&q(me[E])&&(o.t="d",o.v=Me(o.v)),c.cm&&r.xlmeta&&((B=(r.xlmeta.Cell||[])[+c.cm-1])&&"XLDAPR"==B.type&&(o.D=!0)),x?(t[(B=Yr(c.r)).r]||(t[B.r]=[]),t[B.r][B.c]=o):t[c.r]=o}}}}0<A.length&&(t["!rows"]=A)});function _l(e,t){for(var r,a,n,s,i=[],o=[],c=Zr(e["!ref"]),l=[],f=0,h=0,u=e["!rows"],d=Array.isArray(e),p={r:""},m=-1,h=c.s.c;h<=c.e.c;++h)l[h]=Xr(h);for(f=c.s.r;f<=c.e.r;++f){for(o=[],n=jr(f),h=c.s.c;h<=c.e.c;++h){a=l[h]+n;var g=d?(e[f]||[])[h]:e[a];void 0!==g&&null!=(r=function(e,t,r,a){if(e.c&&r["!comments"].push([t,e.c]),void 0===e.v&&"string"!=typeof e.f||"z"===e.t&&!e.f)return"";var n="",s=e.t,i=e.v;if("z"!==e.t)switch(e.t){case"b":n=e.v?"1":"0";break;case"n":n=""+e.v;break;case"e":n=Wa[e.v];break;case"d":n=a&&a.cellDates?He(e.v,-1).toISOString():((e=Ve(e)).t="n",""+(e.v=De(He(e.v)))),void 0===e.z&&(e.z=me[14]);break;default:n=e.v}var o=$t("v",kt(n)),c={r:t},l=el(a.cellXfs,e,a);switch(0!==l&&(c.s=l),e.t){case"n":break;case"d":c.t="d";break;case"b":c.t="b";break;case"e":c.t="e";break;case"z":break;default:if(null==e.v){delete e.t;break}if(32767<e.v.length)throw new Error("Text length must not exceed 32767 characters");if(a&&a.bookSST){o=$t("v",""+qc(a.Strings,e.v,a.revStrings)),c.t="s";break}c.t="str"}return e.t!=s&&(e.t=s,e.v=i),"string"==typeof e.f&&e.f&&(i=e.F&&e.F.slice(0,t.length)==t?{t:"array",ref:e.F}:null,o=Yt("f",kt(e.f),i)+(null!=e.v?o:"")),e.l&&r["!links"].push([t,e.l]),e.D&&(c.cm=1),Yt("c",o,c)}(g,a,e,t))&&o.push(r)}(0<o.length||u&&u[f])&&(p={r:n},u&&u[f]&&((s=u[f]).hidden&&(p.hidden=1),m=-1,s.hpx?m=uo(s.hpx):s.hpt&&(m=s.hpt),-1<m&&(p.ht=m,p.customHeight=1),s.level&&(p.outlineLevel=s.level)),i[i.length]=Yt("row",o.join(""),p))}if(u)for(;f<u.length;++f)u&&u[f]&&(p={r:f+1},(s=u[f]).hidden&&(p.hidden=1),m=-1,s.hpx?m=uo(s.hpx):s.hpt&&(m=s.hpt),-1<m&&(p.ht=m,p.customHeight=1),s.level&&(p.outlineLevel=s.level),i[i.length]=Yt("row","",p));return i.join("")}function xl(e,t,r,a){var n,s,i=[ot,Yt("worksheet",null,{xmlns:Qt[0],"xmlns:r":Zt.r})],o=r.SheetNames[e],c=r.Sheets[o],l=(c=null==c?{}:c)["!ref"]||"A1",f=Zr(l);if(16383<f.e.c||1048575<f.e.r){if(t.WTF)throw new Error("Range "+l+" exceeds format limit A1:XFD1048576");f.e.c=Math.min(f.e.c,16383),f.e.r=Math.min(f.e.c,1048575),l=qr(f)}a=a||{},c["!comments"]=[];var h,u,d=[];!function(e,t,r,a,n){var s=!1,i={},o=null;if("xlsx"!==a.bookType&&t.vbaraw){var c=t.SheetNames[r];try{t.Workbook&&(c=t.Workbook.Sheets[r].CodeName||c)}catch(e){}s=!0,i.codeName=Ut(kt(c))}e&&e["!outline"]&&(a={summaryBelow:1,summaryRight:1},e["!outline"].above&&(a.summaryBelow=0),e["!outline"].left&&(a.summaryRight=0),o=(o||"")+Yt("outlinePr",null,a)),(s||o)&&(n[n.length]=Yt("sheetPr",o,i))}(c,r,e,t,i),i[i.length]=Yt("dimension",null,{ref:l}),i[i.length]=(o={workbookViewId:"0"},((((f=r)||{}).Workbook||{}).Views||[])[0]&&(o.rightToLeft=f.Workbook.Views[0].RTL?"1":"0"),Yt("sheetViews",Yt("sheetView",null,o),{})),t.sheetFormat&&(i[i.length]=Yt("sheetFormatPr",null,{defaultRowHeight:t.sheetFormat.defaultRowHeight||"16",baseColWidth:t.sheetFormat.baseColWidth||"10",outlineLevelRow:t.sheetFormat.outlineLevelRow||"7"})),null!=c["!cols"]&&0<c["!cols"].length&&(i[i.length]=function(e){for(var t,r=["<cols>"],a=0;a!=e.length;++a)(t=e[a])&&(r[r.length]=Yt("col",null,Zc(a,t)));return r[r.length]="</cols>",r.join("")}(c["!cols"])),i[n=i.length]="<sheetData/>",c["!links"]=[],null!=c["!ref"]&&0<(s=_l(c,t)).length&&(i[i.length]=s),i.length>n+1&&(i[i.length]="</sheetData>",i[n]=i[n].replace("/>",">")),c["!protect"]&&(i[i.length]=(h=c["!protect"],u={sheet:1},pl.forEach(function(e){null!=h[e]&&h[e]&&(u[e]="1")}),ml.forEach(function(e){null==h[e]||h[e]||(u[e]="0")}),h.password&&(u.password=zi(h.password).toString(16).toUpperCase()),Yt("sheetProtection",null,u))),null!=c["!autofilter"]&&(i[i.length]=function(e,t,r,a){var n="string"==typeof e.ref?e.ref:qr(e.ref);r.Workbook||(r.Workbook={Sheets:[]}),r.Workbook.Names||(r.Workbook.Names=[]);var s=r.Workbook.Names;(e=Jr(n)).s.r==e.e.r&&(e.e.r=Jr(t["!ref"]).e.r,n=qr(e));for(var i=0;i<s.length;++i){var o=s[i];if("_xlnm._FilterDatabase"==o.Name&&o.Sheet==a){o.Ref="'"+r.SheetNames[a]+"'!"+n;break}}return i==s.length&&s.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+r.SheetNames[a]+"'!"+n}),Yt("autoFilter",null,{ref:n})}(c["!autofilter"],c,r,e)),null!=c["!merges"]&&0<c["!merges"].length&&(i[i.length]=function(e){if(0===e.length)return"";for(var t='<mergeCells count="'+e.length+'">',r=0;r!=e.length;++r)t+='<mergeCell ref="'+qr(e[r])+'"/>';return t+"</mergeCells>"}(c["!merges"]));var p,m,g=-1;return 0<c["!links"].length&&(i[i.length]="<hyperlinks>",c["!links"].forEach(function(e){e[1].Target&&(m={ref:e[0]},"#"!=e[1].Target.charAt(0)&&(g=Ja(a,-1,kt(e[1].Target).replace(/#.*$/,""),$a.HLINK),m["r:id"]="rId"+g),-1<(p=e[1].Target.indexOf("#"))&&(m.location=kt(e[1].Target.slice(p+1))),e[1].Tooltip&&(m.tooltip=kt(e[1].Tooltip)),i[i.length]=Yt("hyperlink",null,m))}),i[i.length]="</hyperlinks>"),delete c["!links"],null!=c["!margins"]&&(i[i.length]=(Qc(r=c["!margins"]),Yt("pageMargins",null,r))),t&&!t.ignoreEC&&null!=t.ignoreEC||(i[i.length]=$t("ignoredErrors",Yt("ignoredError",null,{numberStoredAsText:1,sqref:l}))),0<d.length&&(g=Ja(a,-1,"../drawings/drawing"+(e+1)+".xml",$a.DRAW),i[i.length]=Yt("drawing",null,{"r:id":"rId"+g}),c["!drawing"]=d),0<c["!comments"].length&&(g=Ja(a,-1,"../drawings/vmlDrawing"+(e+1)+".vml",$a.VML),i[i.length]=Yt("legacyDrawing",null,{"r:id":"rId"+g}),c["!legacy"]=g),1<i.length&&(i[i.length]="</worksheet>",i[1]=i[1].replace("/>",">")),i.join("")}function Al(e,t,r,a){r=function(e,t,r){var a=Lr(145),n=(r["!rows"]||[])[e]||{};a.write_shift(4,e),a.write_shift(4,0);var s=320;n.hpx?s=20*uo(n.hpx):n.hpt&&(s=20*n.hpt),a.write_shift(2,s),a.write_shift(1,0),s=0,n.level&&(s|=n.level),n.hidden&&(s|=16),(n.hpx||n.hpt)&&(s|=32),a.write_shift(1,s),a.write_shift(1,0);var i=0,s=a.l;a.l+=4;for(var o={r:e,c:0},c=0;c<16;++c)if(!(t.s.c>c+1<<10||t.e.c<c<<10)){for(var l=-1,f=-1,h=c<<10;h<c+1<<10;++h)o.c=h,(Array.isArray(r)?(r[o.r]||[])[o.c]:r[Kr(o)])&&(l<0&&(l=h),f=h);l<0||(++i,a.write_shift(4,l),a.write_shift(4,f))}return e=a.l,a.l=s,a.write_shift(4,i),a.l=e,a.length>a.l?a.slice(0,a.l):a}(a,r,t);(17<r.length||(t["!rows"]||[])[a])&&Br(e,0,r)}var lt=Sa,Cl=_a;function Rl(e){return[ua(e),xa(e),"n"]}var Lt=Sa,Ol=_a;var Il=["left","right","top","bottom","header","footer"];function Nl(e,t,r,a,n,s,i){if(void 0===t.v)return!1;var o="";switch(t.t){case"b":o=t.v?"1":"0";break;case"d":(t=Ve(t)).z=t.z||me[14],t.v=De(He(t.v)),t.t="n";break;case"n":case"e":o=""+t.v;break;default:o=t.v}var c,l,f,h,u,d,p,m,g,b,v,w,T,E,k,y,S,_,x,A,C={r:r,c:a};switch(C.s=el(n.cellXfs,t,n),t.l&&s["!links"].push([Kr(C),t.l]),t.c&&s["!comments"].push([Kr(C),t.c]),t.t){case"s":case"str":return n.bookSST?(o=qc(n.Strings,t.v,n.revStrings),C.t="s",C.v=o,i?Br(e,18,(da(S=C,_=null==_?Lr(8):_),_.write_shift(4,S.v),_)):Br(e,7,(ha(S=C,y=null==y?Lr(12):y),y.write_shift(4,S.v),y))):(C.t="str",i?Br(e,17,(E=t,da(C,k=null==k?Lr(8+4*E.v.length):k),ia(E.v,k),k.length>k.l?k.slice(0,k.l):k)):Br(e,6,(E=t,ha(C,T=null==T?Lr(12+4*E.v.length):T),ia(E.v,T),T.length>T.l?T.slice(0,T.l):T))),!0;case"n":return t.v==(0|t.v)&&-1e3<t.v&&t.v<1e3?i?Br(e,13,(v=t,da(C,w=null==w?Lr(8):w),ka(v.v,w),w)):Br(e,2,(v=t,ha(C,b=null==b?Lr(12):b),ka(v.v,b),b)):i?Br(e,16,(m=t,da(C,g=null==g?Lr(12):g),Aa(m.v,g),g)):Br(e,5,(m=t,ha(C,p=null==p?Lr(16):p),Aa(m.v,p),p)),!0;case"b":return C.t="b",i?Br(e,15,(u=t,da(C,d=null==d?Lr(5):d),d.write_shift(1,u.v?1:0),d)):Br(e,4,(u=t,ha(C,h=null==h?Lr(9):h),h.write_shift(1,u.v?1:0),h)),!0;case"e":return C.t="e",i?Br(e,14,(l=t,da(C,f=null==f?Lr(8):f),f.write_shift(1,l.v),f.write_shift(2,0),f.write_shift(1,0),f)):Br(e,3,(l=t,ha(C,c=null==c?Lr(9):c),c.write_shift(1,l.v),c)),!0}return i?Br(e,12,da(C,A=null==A?Lr(4):A)):Br(e,1,ha(C,x=null==x?Lr(8):x)),!0}function Fl(t,e){var r,a;e&&e["!merges"]&&(Br(t,177,(r=e["!merges"].length,(a=null==a?Lr(4):a).write_shift(4,r),a)),e["!merges"].forEach(function(e){Br(t,176,Ol(e))}),Br(t,178))}function Dl(r,e){e&&e["!cols"]&&(Br(r,390),e["!cols"].forEach(function(e,t){e&&Br(r,60,function(e,t,r){null==r&&(r=Lr(18));var a=Zc(e,t);return r.write_shift(-4,e),r.write_shift(-4,e),r.write_shift(4,256*(a.width||10)),r.write_shift(4,0),e=0,t.hidden&&(e|=1),"number"==typeof a.width&&(e|=2),t.level&&(e|=t.level<<8),r.write_shift(2,e),r}(t,e))}),Br(r,391))}function Pl(e,t){var r;t&&t["!ref"]&&(Br(e,648),Br(e,649,(r=Zr(t["!ref"]),(t=Lr(24)).write_shift(4,4),t.write_shift(4,1),_a(r,t),t)),Br(e,650))}function Ll(a,e,n){e["!links"].forEach(function(e){var t,r;e[1].Target&&(t=Ja(n,-1,e[1].Target.replace(/#.*$/,""),$a.HLINK),Br(a,494,(r=t,e=Lr(50+4*((t=e)[1].Target.length+(t[1].Tooltip||"").length)),_a({s:Yr(t[0]),e:Yr(t[0])},e),Ta("rId"+r,e),ia((-1==(r=t[1].Target.indexOf("#"))?"":t[1].Target.slice(r+1))||"",e),ia(t[1].Tooltip||"",e),ia("",e),e.slice(0,e.l))))}),delete e["!links"]}function Ml(e,t,r){Br(e,133),Br(e,137,function(e,t){null==t&&(t=Lr(30));var r=924;return(((e||{}).Views||[])[0]||{}).RTL&&(r|=32),t.write_shift(2,r),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(1,0),t.write_shift(1,0),t.write_shift(2,0),t.write_shift(2,100),t.write_shift(2,0),t.write_shift(2,0),t.write_shift(2,0),t.write_shift(4,0),t}(r)),Br(e,138),Br(e,134)}function Ul(e,t){var r,a;t["!protect"]&&Br(e,535,(r=t["!protect"],(a=null==a?Lr(66):a).write_shift(2,r.password?zi(r.password):0),a.write_shift(4,1),[["objects",!1],["scenarios",!1],["formatCells",!0],["formatColumns",!0],["formatRows",!0],["insertColumns",!0],["insertRows",!0],["insertHyperlinks",!0],["deleteColumns",!0],["deleteRows",!0],["selectLockedCells",!1],["sort",!0],["autoFilter",!0],["pivotTables",!0],["selectUnlockedCells",!1]].forEach(function(e){e[1]?a.write_shift(4,null==r[e[0]]||r[e[0]]?0:1):a.write_shift(4,null!=r[e[0]]&&r[e[0]]?0:1)}),a))}function Bl(e,t,r,a){var n=Ur(),s=r.SheetNames[e],i=r.Sheets[s]||{},o=s;try{r&&r.Workbook&&(o=r.Workbook.Sheets[e].CodeName||o)}catch(e){}var c,l,s=Zr(i["!ref"]||"A1");if(16383<s.e.c||1048575<s.e.r){if(t.WTF)throw new Error("Range "+(i["!ref"]||"A1")+" exceeds format limit A1:XFD1048576");s.e.c=Math.min(s.e.c,16383),s.e.r=Math.min(s.e.c,1048575)}return i["!links"]=[],i["!comments"]=[],Br(n,129),(r.vbaraw||i["!outline"])&&Br(n,147,function(e,t,r){null==r&&(r=Lr(84+4*e.length));var a=192;t&&(t.above&&(a&=-65),t.left&&(a&=-129)),r.write_shift(1,a);for(var n=1;n<3;++n)r.write_shift(1,0);return Ca({auto:1},r),r.write_shift(-4,-1),r.write_shift(-4,-1),ma(e,r),r.slice(0,r.l)}(o,i["!outline"])),Br(n,148,Cl(s)),Ml(n,0,r.Workbook),Dl(n,i),function(e,t,r){var a,n=Zr(t["!ref"]||"A1"),s=[];Br(e,145);var i=Array.isArray(t),o=n.e.r;t["!rows"]&&(o=Math.max(n.e.r,t["!rows"].length-1));for(var c=n.s.r;c<=o;++c){a=jr(c),Al(e,t,n,c);var l=!1;if(c<=n.e.r)for(var f=n.s.c;f<=n.e.c;++f){c===n.s.r&&(s[f]=Xr(f)),h=s[f]+a;var h=i?(t[c]||[])[f]:t[h];h?l=Nl(e,h,c,f,r,t,l):l=!1}}Br(e,146)}(n,i,t),Ul(n,i),function(e,t,r,a){if(t["!autofilter"]){var n=t["!autofilter"],s="string"==typeof n.ref?n.ref:qr(n.ref);r.Workbook||(r.Workbook={Sheets:[]}),r.Workbook.Names||(r.Workbook.Names=[]);var i=r.Workbook.Names,n=Jr(s);n.s.r==n.e.r&&(n.e.r=Jr(t["!ref"]).e.r,s=qr(n));for(var o=0;o<i.length;++o){var c=i[o];if("_xlnm._FilterDatabase"==c.Name&&c.Sheet==a){c.Ref="'"+r.SheetNames[a]+"'!"+s;break}}o==i.length&&i.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+r.SheetNames[a]+"'!"+s}),Br(e,161,_a(Zr(s))),Br(e,162)}}(n,i,r,e),Fl(n,i),Ll(n,i,a),i["!margins"]&&Br(n,476,(c=i["!margins"],null==l&&(l=Lr(48)),Qc(c),Il.forEach(function(e){Aa(c[e],l)}),l)),t&&!t.ignoreEC&&null!=t.ignoreEC||Pl(n,i),s=n,t=e,a=a,0<(i=i)["!comments"].length&&(t=Ja(a,-1,"../drawings/vmlDrawing"+(t+1)+".vml",$a.VML),Br(s,551,Ta("rId"+t)),i["!legacy"]=t),Br(n,130),n.end()}function Wl(e,t,r,a,n,s){var i=s||{"!type":"chart"};if(!e)return s;var o,c=0,l=0,f={s:{r:2e6,c:2e6},e:{r:0,c:0}};return(e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(e){var r=function(e){var t,r=[],a=e.match(/^<c:numCache>/);(e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm)||[]).forEach(function(e){e=e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);e&&(r[+e[1]]=a?+e[2]:e[2])});var n=wt((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);return(e.match(/<c:f>(.*?)<\/c:f>/gm)||[]).forEach(function(e){t=e.replace(/<.*?>/g,"")}),[r,n,t]}(e);f.s.r=f.s.c=0,f.e.c=c,o=Xr(c),r[0].forEach(function(e,t){i[o+jr(t)]={t:"n",v:e,z:r[1]},l=t}),f.e.r<l&&(f.e.r=l),++c}),0<c&&(i["!ref"]=qr(f)),i}var Hl=[["allowRefreshQuery",!1,"bool"],["autoCompressPictures",!0,"bool"],["backupFile",!1,"bool"],["checkCompatibility",!1,"bool"],["CodeName",""],["date1904",!1,"bool"],["defaultThemeVersion",0,"int"],["filterPrivacy",!1,"bool"],["hidePivotFieldList",!1,"bool"],["promptedSolutions",!1,"bool"],["publishItems",!1,"bool"],["refreshAllConnections",!1,"bool"],["saveExternalLinkValues",!0,"bool"],["showBorderUnselectedTables",!0,"bool"],["showInkAnnotation",!0,"bool"],["showObjects","all"],["showPivotChartFilter",!1,"bool"],["updateLinks","userSet"]],zl=[["activeTab",0,"int"],["autoFilterDateGrouping",!0,"bool"],["firstSheet",0,"int"],["minimized",!1,"bool"],["showHorizontalScroll",!0,"bool"],["showSheetTabs",!0,"bool"],["showVerticalScroll",!0,"bool"],["tabRatio",600,"int"],["visibility","visible"]],Vl=[],Gl=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];function jl(e,t){for(var r=0;r!=e.length;++r)for(var a=e[r],n=0;n!=t.length;++n){var s=t[n];if(null==a[s[0]])a[s[0]]=s[1];else switch(s[2]){case"bool":"string"==typeof a[s[0]]&&(a[s[0]]=Rt(a[s[0]]));break;case"int":"string"==typeof a[s[0]]&&(a[s[0]]=parseInt(a[s[0]],10))}}}function $l(e,t){for(var r=0;r!=t.length;++r){var a=t[r];if(null==e[a[0]])e[a[0]]=a[1];else switch(a[2]){case"bool":"string"==typeof e[a[0]]&&(e[a[0]]=Rt(e[a[0]]));break;case"int":"string"==typeof e[a[0]]&&(e[a[0]]=parseInt(e[a[0]],10))}}}function Xl(e){$l(e.WBProps,Hl),$l(e.CalcPr,Gl),jl(e.WBView,zl),jl(e.Sheets,Vl),Kc.date1904=Rt(e.WBProps.date1904)}var Yl="][*?/\\".split("");function Kl(t,r){if(31<t.length){if(r)return;throw new Error("Sheet names cannot exceed 31 chars")}var a=!0;return Yl.forEach(function(e){if(-1!=t.indexOf(e)){if(!r)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");a=!1}}),a}function Jl(e){if(!e||!e.SheetNames||!e.Sheets)throw new Error("Invalid Workbook");if(!e.SheetNames.length)throw new Error("Workbook is empty");var n,s,i,t=e.Workbook&&e.Workbook.Sheets||[];n=e.SheetNames,s=t,i=!!e.vbaraw,n.forEach(function(e,t){Kl(e);for(var r=0;r<t;++r)if(e==n[r])throw new Error("Duplicate Sheet Name: "+e);if(i){var a=s&&s[t]&&s[t].CodeName||e;if(95==a.charCodeAt(0)&&22<a.length)throw new Error("Bad Code Name: Worksheet"+a)}});for(var r=0;r<e.SheetNames.length;++r)!function(e,t){if(e&&e["!ref"]){var r=Zr(e["!ref"]);if(r.e.c<r.s.c||r.e.r<r.s.r)throw new Error("Bad range ("+t+"): "+e["!ref"])}}(e.Sheets[e.SheetNames[r]],(e.SheetNames[r],r))}var ql=/<\w+:workbook/;function Zl(t){var r=[ot];r[r.length]=Yt("workbook",null,{xmlns:Qt[0],"xmlns:r":Zt.r});var e=t.Workbook&&0<(t.Workbook.Names||[]).length,a={codeName:"ThisWorkbook"};t.Workbook&&t.Workbook.WBProps&&(Hl.forEach(function(e){null!=t.Workbook.WBProps[e[0]]&&t.Workbook.WBProps[e[0]]!=e[1]&&(a[e[0]]=t.Workbook.WBProps[e[0]])}),t.Workbook.WBProps.CodeName&&(a.codeName=t.Workbook.WBProps.CodeName,delete a.CodeName)),r[r.length]=Yt("workbookPr",null,a);var n=t.Workbook&&t.Workbook.Sheets||[],s=0;if(n&&n[0]&&n[0].Hidden){for(r[r.length]="<bookViews>",s=0;s!=t.SheetNames.length&&n[s]&&n[s].Hidden;++s);s==t.SheetNames.length&&(s=0),r[r.length]='<workbookView firstSheet="'+s+'" activeTab="'+s+'"/>',r[r.length]="</bookViews>"}for(r[r.length]="<sheets>",s=0;s!=t.SheetNames.length;++s){var i={name:kt(t.SheetNames[s].slice(0,31))};if(i.sheetId=""+(s+1),i["r:id"]="rId"+(s+1),n[s])switch(n[s].Hidden){case 1:i.state="hidden";break;case 2:i.state="veryHidden"}r[r.length]=Yt("sheet",null,i)}return r[r.length]="</sheets>",e&&(r[r.length]="<definedNames>",t.Workbook&&t.Workbook.Names&&t.Workbook.Names.forEach(function(e){var t={name:e.Name};e.Comment&&(t.comment=e.Comment),null!=e.Sheet&&(t.localSheetId=""+e.Sheet),e.Hidden&&(t.hidden="1"),e.Ref&&(r[r.length]=Yt("definedName",kt(e.Ref),t))}),r[r.length]="</definedNames>"),2<r.length&&(r[r.length]="</workbook>",r[1]=r[1].replace("/>",">")),r.join("")}function Ql(e,t){var r={};return e.read_shift(4),r.ArchID=e.read_shift(4),e.l+=t-8,r}function ef(e,t){Br(e,143);for(var r,a=0;a!=t.SheetNames.length;++a){var n={Hidden:t.Workbook&&t.Workbook.Sheets&&t.Workbook.Sheets[a]&&t.Workbook.Sheets[a].Hidden||0,iTabID:a+1,strRelID:"rId"+(a+1),name:t.SheetNames[a]};Br(e,156,(r=n,(n=(n=void 0)||Lr(127)).write_shift(4,r.Hidden),n.write_shift(4,r.iTabID),Ta(r.strRelID,n),ia(r.name.slice(0,31),n),n.length>n.l?n.slice(0,n.l):n))}Br(e,144)}function tf(e,t){if(t.Workbook&&t.Workbook.Sheets){for(var r,a=t.Workbook.Sheets,n=0,s=-1,i=-1;n<a.length;++n)!a[n]||!a[n].Hidden&&-1==s?s=n:1==a[n].Hidden&&-1==i&&(i=n);s<i||(Br(e,135),Br(e,158,(t=s,(r=r||Lr(29)).write_shift(-4,0),r.write_shift(-4,460),r.write_shift(4,28800),r.write_shift(4,17600),r.write_shift(4,500),r.write_shift(4,t),r.write_shift(4,t),r.write_shift(1,120),r.length>r.l?r.slice(0,r.l):r)),Br(e,136))}}function rf(e,t){var r=Ur();return Br(r,131),Br(r,128,function(e){e=e||Lr(127);for(var t=0;4!=t;++t)e.write_shift(4,0);return ia("SheetJS",e),ia(a.version,e),ia(a.version,e),ia("7262",e),e.length>e.l?e.slice(0,e.l):e}()),Br(r,153,function(e,t){t=t||Lr(72);var r=0;return e&&e.filterPrivacy&&(r|=8),t.write_shift(4,r),t.write_shift(4,0),ma(e&&e.CodeName||"ThisWorkbook",t),t.slice(0,t.l)}(e.Workbook&&e.Workbook.WBProps||null)),tf(r,e),ef(r,e),Br(r,132),r.end()}function af(e,t,r){return(".bin"===t.slice(-4)?function(e,a){var n={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""},s=[],i=!1;(a=a||{}).biff=12;var o=[],c=[[]];return c.SheetNames=[],c.XTI=[],Df[16]={n:"BrtFRTArchID$",f:Ql},Mr(e,function(e,t,r){switch(r){case 156:c.SheetNames.push(e.name),n.Sheets.push(e);break;case 153:n.WBProps=e;break;case 39:null!=e.Sheet&&(a.SID=e.Sheet),e.Ref=Pc(e.Ptg,0,null,c,a),delete a.SID,delete e.Ptg,o.push(e);break;case 1036:break;case 357:case 358:case 355:case 667:c[0].length?c.push([r,e]):c[0]=[r,e],c[c.length-1].XTI=[];break;case 362:0===c.length&&(c[0]=[],c[0].XTI=[]),c[c.length-1].XTI=c[c.length-1].XTI.concat(e),c.XTI=c.XTI.concat(e);break;case 361:break;case 2071:case 158:case 143:case 664:case 353:break;case 3072:case 3073:case 534:case 677:case 157:case 610:case 2050:case 155:case 548:case 676:case 128:case 665:case 2128:case 2125:case 549:case 2053:case 596:case 2076:case 2075:case 2082:case 397:case 154:case 1117:case 553:case 2091:break;case 35:s.push(r),i=!0;break;case 36:s.pop(),i=!1;break;case 37:s.push(r),i=!0;break;case 38:s.pop(),i=!1;break;case 16:break;default:if(!t.T&&(!i||a.WTF&&37!=s[s.length-1]&&35!=s[s.length-1]))throw new Error("Unexpected record 0x"+r.toString(16))}},a),Xl(n),n.Names=o,n.supbooks=c,n}:function(a,n){if(!a)throw new Error("Could not find file");var s={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""},i=!1,o="xmlns",c={},l=0;if(a.replace(ft,function(e,t){var r=dt(e);switch(pt(r[0])){case"<?xml":break;case"<workbook":e.match(ql)&&(o="xmlns"+e.match(/<(\w+):/)[1]),s.xmlns=r[o];break;case"</workbook>":break;case"<fileVersion":delete r[0],s.AppVersion=r;break;case"<fileVersion/>":case"</fileVersion>":case"<fileSharing":case"<fileSharing/>":break;case"<workbookPr":case"<workbookPr/>":Hl.forEach(function(e){if(null!=r[e[0]])switch(e[2]){case"bool":s.WBProps[e[0]]=Rt(r[e[0]]);break;case"int":s.WBProps[e[0]]=parseInt(r[e[0]],10);break;default:s.WBProps[e[0]]=r[e[0]]}}),r.codeName&&(s.WBProps.CodeName=Mt(r.codeName));break;case"</workbookPr>":case"<workbookProtection":case"<workbookProtection/>":break;case"<bookViews":case"<bookViews>":case"</bookViews>":break;case"<workbookView":case"<workbookView/>":delete r[0],s.WBView.push(r);break;case"</workbookView>":break;case"<sheets":case"<sheets>":case"</sheets>":break;case"<sheet":switch(r.state){case"hidden":r.Hidden=1;break;case"veryHidden":r.Hidden=2;break;default:r.Hidden=0}delete r.state,r.name=wt(Mt(r.name)),delete r[0],s.Sheets.push(r);break;case"</sheet>":break;case"<functionGroups":case"<functionGroups/>":case"<functionGroup":break;case"<externalReferences":case"</externalReferences>":case"<externalReferences>":case"<externalReference":case"<definedNames/>":break;case"<definedNames>":case"<definedNames":i=!0;break;case"</definedNames>":i=!1;break;case"<definedName":(c={}).Name=Mt(r.name),r.comment&&(c.Comment=r.comment),r.localSheetId&&(c.Sheet=+r.localSheetId),Rt(r.hidden||"0")&&(c.Hidden=!0),l=t+e.length;break;case"</definedName>":c.Ref=wt(Mt(a.slice(l,t))),s.Names.push(c);break;case"<definedName/>":break;case"<calcPr":case"<calcPr/>":delete r[0],s.CalcPr=r;break;case"</calcPr>":case"<oleSize":break;case"<customWorkbookViews>":case"</customWorkbookViews>":case"<customWorkbookViews":break;case"<customWorkbookView":case"</customWorkbookView>":break;case"<pivotCaches>":case"</pivotCaches>":case"<pivotCaches":case"<pivotCache":break;case"<smartTagPr":case"<smartTagPr/>":break;case"<smartTagTypes":case"<smartTagTypes>":case"</smartTagTypes>":case"<smartTagType":break;case"<webPublishing":case"<webPublishing/>":break;case"<fileRecoveryPr":case"<fileRecoveryPr/>":break;case"<webPublishObjects>":case"<webPublishObjects":case"</webPublishObjects>":case"<webPublishObject":break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":i=!0;break;case"</ext>":i=!1;break;case"<ArchID":break;case"<AlternateContent":case"<AlternateContent>":i=!0;break;case"</AlternateContent>":i=!1;break;case"<revisionPtr":break;default:if(!i&&n.WTF)throw new Error("unrecognized "+r[0]+" in workbook")}return e}),-1===Qt.indexOf(s.xmlns))throw new Error("Unknown Namespace: "+s.xmlns);return Xl(s),s})(e,r)}function nf(e,t,r,a,n,s,i,o){return(".bin"===t.slice(-4)?function(e,t,s,i,o,c,l){if(!e)return e;var f=t||{};i=i||{"!id":{}},null!=oe&&null==f.dense&&(f.dense=oe);var h,u,d,p,m,g,b,v,w,T,E=f.dense?[]:{},k={s:{r:2e6,c:2e6},e:{r:0,c:0}},y=[],S=!1,_=!1,x=[];f.biff=12;var A=f["!row"]=0,C=!1,R=[],O={},I=f.supbooks||o.supbooks||[[]];if(I.sharedf=O,I.arrayf=R,I.SheetNames=o.SheetNames||o.Sheets.map(function(e){return e.name}),!f.supbooks&&(f.supbooks=I,o.Names))for(var r=0;r<o.Names.length;++r)I[0][r+1]=o.Names[r];var N,F=[],D=[],P=!1;return Df[16]={n:"BrtShortReal",f:Rl},Mr(e,function(e,t,r){if(!_)switch(r){case 148:h=e;break;case 0:u=e,f.sheetRows&&f.sheetRows<=u.r&&(_=!0),w=jr(m=u.r),f["!row"]=u.r,(e.hidden||e.hpt||null!=e.level)&&(e.hpt&&(e.hpx=po(e.hpt)),D[e.r]=e);break;case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 17:case 18:case 62:switch(d={t:e[2]},e[2]){case"n":d.v=e[1];break;case"s":v=Yc[e[1]],d.v=v.t,d.r=v.r;break;case"b":d.v=!!e[1];break;case"e":d.v=e[1],!1!==f.cellText&&(d.w=Wa[d.v]);break;case"str":d.t="s",d.v=e[1];break;case"is":d.t="s",d.v=e[1].t}if((p=l.CellXf[e[0].iStyleRef])&&tl(d,p.numFmtId,null,f,c,l),g=-1==e[0].c?g+1:e[0].c,f.dense?(E[m]||(E[m]=[]),E[m][g]=d):E[Xr(g)+w]=d,f.cellFormula){for(C=!1,A=0;A<R.length;++A){var a=R[A];u.r>=a[0].s.r&&u.r<=a[0].e.r&&g>=a[0].s.c&&g<=a[0].e.c&&(d.F=qr(a[0]),C=!0)}!C&&3<e.length&&(d.f=e[3])}k.s.r>u.r&&(k.s.r=u.r),k.s.c>g&&(k.s.c=g),k.e.r<u.r&&(k.e.r=u.r),k.e.c<g&&(k.e.c=g),f.cellDates&&p&&"n"==d.t&&q(me[p.numFmtId])&&((n=L(d.v))&&(d.t="d",d.v=new Date(n.y,n.m-1,n.d,n.H,n.M,n.S,n.u))),N&&("XLDAPR"==N.type&&(d.D=!0),N=void 0),0;break;case 1:case 12:if(!f.sheetStubs||S)break;d={t:"z",v:void 0},g=-1==e[0].c?g+1:e[0].c,f.dense?(E[m]||(E[m]=[]),E[m][g]=d):E[Xr(g)+w]=d,k.s.r>u.r&&(k.s.r=u.r),k.s.c>g&&(k.s.c=g),k.e.r<u.r&&(k.e.r=u.r),k.e.c<g&&(k.e.c=g),N&&("XLDAPR"==N.type&&(d.D=!0),N=void 0),0;break;case 176:x.push(e);break;case 49:N=((f.xlmeta||{}).Cell||[])[e-1];break;case 494:var n=i["!id"][e.relId];for(n?(e.Target=n.Target,e.loc&&(e.Target+="#"+e.loc),e.Rel=n):""==e.relId&&(e.Target="#"+e.loc),m=e.rfx.s.r;m<=e.rfx.e.r;++m)for(g=e.rfx.s.c;g<=e.rfx.e.c;++g)f.dense?(E[m]||(E[m]=[]),E[m][g]||(E[m][g]={t:"z",v:void 0}),E[m][g].l=e):(b=Kr({c:g,r:m}),E[b]||(E[b]={t:"z",v:void 0}),E[b].l=e);break;case 426:if(!f.cellFormula)break;R.push(e),(T=f.dense?E[m][g]:E[Xr(g)+w]).f=Pc(e[1],0,{r:u.r,c:g},I,f),T.F=qr(e[0]);break;case 427:if(!f.cellFormula)break;O[Kr(e[0].s)]=e[1],(T=f.dense?E[m][g]:E[Xr(g)+w]).f=Pc(e[1],0,{r:u.r,c:g},I,f);break;case 60:if(!f.cellStyles)break;for(;e.e>=e.s;)F[e.e--]={width:e.w/256,hidden:!!(1&e.flags),level:e.level},P||(P=!0,lo(e.w/256)),fo(F[e.e+1]);break;case 161:E["!autofilter"]={ref:qr(e)};break;case 476:E["!margins"]=e;break;case 147:o.Sheets[s]||(o.Sheets[s]={}),e.name&&(o.Sheets[s].CodeName=e.name),(e.above||e.left)&&(E["!outline"]={above:e.above,left:e.left});break;case 137:o.Views||(o.Views=[{}]),o.Views[0]||(o.Views[0]={}),e.RTL&&(o.Views[0].RTL=!0);break;case 485:break;case 64:case 1053:case 151:break;case 152:case 175:case 644:case 625:case 562:case 396:case 1112:case 1146:case 471:case 1050:case 649:case 1105:case 589:case 607:case 564:case 1055:case 168:case 174:case 1180:case 499:case 507:case 550:case 171:case 167:case 1177:case 169:case 1181:case 551:case 552:case 661:case 639:case 478:case 537:case 477:case 536:case 1103:case 680:case 1104:case 1024:case 663:case 535:case 678:case 504:case 1043:case 428:case 170:case 3072:case 50:case 2070:case 1045:break;case 35:S=!0;break;case 36:S=!1;break;case 37:y.push(r),S=!0;break;case 38:y.pop(),S=!1;break;default:if(!t.T&&(!S||f.WTF))throw new Error("Unexpected record 0x"+r.toString(16))}},f),delete f.supbooks,delete f["!row"],!E["!ref"]&&(k.s.r<2e6||h&&(0<h.e.r||0<h.e.c||0<h.s.r||0<h.s.c))&&(E["!ref"]=qr(h||k)),f.sheetRows&&E["!ref"]&&(e=Zr(E["!ref"]),f.sheetRows<=+e.e.r&&(e.e.r=f.sheetRows-1,e.e.r>k.e.r&&(e.e.r=k.e.r),e.e.r<e.s.r&&(e.s.r=e.e.r),e.e.c>k.e.c&&(e.e.c=k.e.c),e.e.c<e.s.c&&(e.s.c=e.e.c),E["!fullref"]=E["!ref"],E["!ref"]=qr(e))),0<x.length&&(E["!merges"]=x),0<F.length&&(E["!cols"]=F),0<D.length&&(E["!rows"]=D),E}:ul)(e,a,r,n,s,i,o)}function sf(e,t,r,a,n,s){return".bin"===t.slice(-4)?function(e,a,n,t,s){if(!e)return e;t=t||{"!id":{}};var i={"!type":"chart","!drawel":null,"!rel":""},o=[],c=!1;return Mr(e,function(e,t,r){switch(r){case 550:i["!rel"]=e;break;case 651:s.Sheets[n]||(s.Sheets[n]={}),e.name&&(s.Sheets[n].CodeName=e.name);break;case 562:case 652:case 669:case 679:case 551:case 552:case 476:case 3072:break;case 35:c=!0;break;case 36:c=!1;break;case 37:o.push(r);break;case 38:o.pop();break;default:if(0<t.T)o.push(r);else if(t.T<0)o.pop();else if(!c||a.WTF)throw new Error("Unexpected record 0x"+r.toString(16))}},a),t["!id"][i["!rel"]]&&(i["!drawel"]=t["!id"][i["!rel"]]),i}(e,a,r,n,s):function(e,t,r,a){if(!e)return e;r=r||{"!id":{}};var n={"!type":"chart","!drawel":null,"!rel":""},s=e.match(ll);return s&&dl(s[0],0,a,t),(e=e.match(/drawing r:id="(.*?)"/))&&(n["!rel"]=e[1]),r["!id"][n["!rel"]]&&(n["!drawel"]=r["!id"][n["!rel"]]),n}(e,r,n,s)}function of(e,t,r,a){return(".bin"===t.slice(-4)?function(e,a,n){var t,s={NumberFmt:[]};for(t in me)s.NumberFmt[t]=me[t];s.CellXf=[],s.Fonts=[];var i=[],o=!1;return Mr(e,function(e,t,r){switch(r){case 44:s.NumberFmt[e[0]]=e[1],we(e[1],e[0]);break;case 43:s.Fonts.push(e),null!=e.color.theme&&a&&a.themeElements&&a.themeElements.clrScheme&&(e.color.rgb=eo(a.themeElements.clrScheme[e.color.theme].rgb,e.color.tint||0));break;case 1025:case 45:case 46:break;case 47:617==i[i.length-1]&&s.CellXf.push(e);break;case 48:case 507:case 572:case 475:break;case 1171:case 2102:case 1130:case 512:case 2095:case 3072:break;case 35:o=!0;break;case 36:o=!1;break;case 37:i.push(r),o=!0;break;case 38:i.pop(),o=!1;break;default:if(0<t.T)i.push(r);else if(t.T<0)i.pop();else if(!o||n.WTF&&37!=i[i.length-1])throw new Error("Unexpected record 0x"+r.toString(16))}}),s}:So)(e,r,a)}function cf(e,t,r){return".bin"===t.slice(-4)?(a=r,s=!(n=[]),Mr(e,function(e,t,r){switch(r){case 159:n.Count=e[0],n.Unique=e[1];break;case 19:n.push(e);break;case 160:return 1;case 35:s=!0;break;case 36:s=!1;break;default:if(t.T,!s||a.WTF)throw new Error("Unexpected record 0x"+r.toString(16))}}),n):function(e,t){var r=[],a="";if(!e)return r;if(e=e.match(Ci)){a=e[2].replace(Ri,"").split(Oi);for(var n=0;n!=a.length;++n){var s=Ai(a[n].trim(),t);null!=s&&(r[r.length]=s)}e=dt(e[1]),r.Count=e.count,r.Unique=e.uniqueCount}return r}(e,r);var a,n,s}function lf(e,t,r){return".bin"===t.slice(-4)?(a=r,n=[],s=[],o=!(i={}),Mr(e,function(e,t,r){switch(r){case 632:s.push(e);break;case 635:i=e;break;case 637:i.t=e.t,i.h=e.h,i.r=e.r;break;case 636:if(i.author=s[i.iauthor],delete i.iauthor,a.sheetRows&&i.rfx&&a.sheetRows<=i.rfx.r)break;i.t||(i.t=""),delete i.rfx,n.push(i);break;case 3072:break;case 35:o=!0;break;case 36:o=!1;break;case 37:case 38:break;default:if(!t.T&&(!o||a.WTF))throw new Error("Unexpected record 0x"+r.toString(16))}}),n):function(e,a){if(e.match(/<(?:\w+:)?comments *\/>/))return[];var n=[],s=[],t=e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);return t&&t[1]&&t[1].split(/<\/\w*:?author>/).forEach(function(e){""===e||""===e.trim()||(e=e.match(/<(?:\w+:)?author[^>]*>(.*)/))&&n.push(e[1])}),(e=e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/))&&e[1]&&e[1].split(/<\/\w*:?comment>/).forEach(function(e){var t,r;""===e||""===e.trim()||(t=e.match(/<(?:\w+:)?comment[^>]*>/))&&(t={author:(r=dt(t[0])).authorId&&n[r.authorId]||"sheetjsghost",ref:r.ref,guid:r.guid},r=Yr(r.ref),a.sheetRows&&a.sheetRows<=r.r||(e=!!(e=e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/))&&!!e[1]&&Ai(e[1])||{r:"",t:"",h:""},t.r=e.r,"<t></t>"==e.r&&(e.t=e.h=""),t.t=(e.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n"),a.cellHTML&&(t.h=e.h),s.push(t)))}),s}(e,r);var a,n,s,i,o}function ff(e,t){return".bin"===t.slice(-4)?(a=[],Mr(e,function(e,t,r){if(63===r)a.push(e);else if(!t.T)throw new Error("Unexpected record 0x"+r.toString(16))}),a):function(e){var r=[];if(!e)return r;var a=1;return(e.match(ft)||[]).forEach(function(e){var t=dt(e);switch(t[0]){case"<?xml":break;case"<calcChain":case"<calcChain>":case"</calcChain>":break;case"<c":delete t[0],t.i?a=t.i:t.i=a,r.push(t)}}),r}(e);var a}function hf(e,t,r,a){if(".bin"===r.slice(-4))return function(e,t){if(!e)return e;var a=t||{},n=!1;Mr(e,function(e,t,r){switch(0,r){case 359:case 363:case 364:case 366:case 367:case 368:case 369:case 370:case 371:case 472:case 577:case 578:case 579:case 580:case 581:case 582:case 583:case 584:case 585:case 586:case 587:break;case 35:n=!0;break;case 36:n=!1;break;default:if(!t.T&&(!n||a.WTF))throw new Error("Unexpected record 0x"+r.toString(16))}},a)}(e,a)}function uf(e,t,r){return".bin"===t.slice(-4)?(a={Types:[],Cell:[],Value:[]},n=r||{},i=!(s=[]),o=2,Mr(e,function(e,t,r){switch(r){case 335:a.Types.push({name:e.name});break;case 51:e.forEach(function(e){1==o?a.Cell.push({type:a.Types[e[0]-1].name,index:e[1]}):0==o&&a.Value.push({type:a.Types[e[0]-1].name,index:e[1]})});break;case 337:o=e?1:0;break;case 338:o=2;break;case 35:s.push(r),i=!0;break;case 36:s.pop(),i=!1;break;default:if(!t.T&&(!i||n.WTF&&35!=s[s.length-1]))throw new Error("Unexpected record 0x"+r.toString(16))}}),a):function(e,a){var n={Types:[],Cell:[],Value:[]};if(!e)return n;var s,i=!1,o=2;return e.replace(ft,function(e){var t=dt(e);switch(pt(t[0])){case"<?xml":break;case"<metadata":case"</metadata>":break;case"<metadataTypes":case"</metadataTypes>":break;case"<metadataType":n.Types.push({name:t.name});break;case"</metadataType>":break;case"<futureMetadata":for(var r=0;r<n.Types.length;++r)n.Types[r].name==t.name&&(s=n.Types[r]);break;case"</futureMetadata>":case"<bk>":case"</bk>":break;case"<rc":1==o?n.Cell.push({type:n.Types[t.t-1].name,index:+t.v}):0==o&&n.Value.push({type:n.Types[t.t-1].name,index:+t.v});break;case"</rc>":break;case"<cellMetadata":o=1;break;case"</cellMetadata>":o=2;break;case"<valueMetadata":o=0;break;case"</valueMetadata>":o=2;break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":i=!0;break;case"</ext>":i=!1;break;case"<rvb":if(!s)break;s.offsets||(s.offsets=[]),s.offsets.push(+t.i);break;default:if(!i&&a.WTF)throw new Error("unrecognized "+t[0]+" in metadata")}return e}),n}(e,r);var a,n,s,i,o}var df,pf=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g,mf=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function gf(e,t){var r=e.split(/\s+/),a=[];if(t||(a[0]=r[0]),1===r.length)return a;var n,s,i,o=e.match(pf);if(o)for(i=0;i!=o.length;++i)-1===(s=(n=o[i].match(mf))[1].indexOf(":"))?a[n[1]]=n[2].slice(1,n[2].length-1):a["xmlns:"===n[1].slice(0,6)?"xmlns"+n[1].slice(6):n[1].slice(s+1)]=n[2].slice(1,n[2].length-1);return a}function bf(e,t,r){if("z"!==e.t){if(!r||!1!==r.cellText)try{"e"===e.t?e.w=e.w||Wa[e.v]:"General"===t?"n"===e.t?(0|e.v)===e.v?e.w=e.v.toString(10):e.w=D(e.v):e.w=P(e.v):e.w=(a=t||"General",n=e.v,"General"===(a=df[a]||wt(a))?P(n):ve(a,n))}catch(e){if(r.WTF)throw e}var a,n;try{var s=df[t]||t||"General";r.cellNF&&(e.z=s),r.cellDates&&"n"==e.t&&q(s)&&((s=L(e.v))&&(e.t="d",e.v=new Date(s.y,s.m-1,s.d,s.H,s.M,s.S,s.u)))}catch(e){if(r.WTF)throw e}}}function vf(e,t){var r=t||{};Ee();var a,n=ne(Jt(e)),s=(n="binary"==r.type||"array"==r.type||"base64"==r.type?void 0!==re?re.utils.decode(65001,ae(n)):Mt(n):n).slice(0,1024).toLowerCase(),i=!1;if((1023&(s=s.replace(/".*?"/g,"")).indexOf(">"))>Math.min(1023&s.indexOf(","),1023&s.indexOf(";"))){var o=Ve(r);return o.type="string",Ks.to_workbook(n,o)}if(-1==s.indexOf("<?xml")&&["html","table","head","meta","script","style","div"].forEach(function(e){0<=s.indexOf("<"+e)&&(i=!0)}),i)return function(e,r){e=e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);if(!e||0==e.length)throw new Error("Invalid HTML: could not find <table>");if(1==e.length)return ta(Yf(e[0],r),r);var a=du();return e.forEach(function(e,t){pu(a,Yf(e,r),"Sheet"+(t+1))}),a}(n,r);df={"General Number":"General","General Date":me[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":me[15],"Short Date":me[14],"Long Time":me[19],"Medium Time":me[18],"Short Time":me[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:me[2],Standard:me[4],Percent:me[10],Scientific:me[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var c,l=[];null!=oe&&null==r.dense&&(r.dense=oe);var f,h={},u=[],d=r.dense?[]:{},p="",m={},g={},b=gf('<Data ss:Type="String">'),v=0,w=0,T=0,E={s:{r:2e6,c:2e6},e:{r:0,c:0}},k={},y={},S="",_=0,x=[],A={},C={},R=0,O=[],I=[],N={},F=[],D=!1,P=[],L=[],M={},U=0,B=0,W={Sheets:[],WBProps:{date1904:!1}},H={};qt.lastIndex=0,n=n.replace(/<!--([\s\S]*?)-->/gm,"");for(var z,V,G,j,$="";a=qt.exec(n);)switch(a[3]=($=a[3]).toLowerCase()){case"data":if("data"==$){if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&l.push([a[3],!0]);break}if(l[l.length-1][1])break;"/"===a[1]?function(e,t,r,a,n,s,i,o,c,l){var f="General",h=a.StyleID,u={};l=l||{};var d=[],p=0;for(void 0===(h=void 0===h&&o?o.StyleID:h)&&i&&(h=i.StyleID);void 0!==s[h]&&(s[h].nf&&(f=s[h].nf),s[h].Interior&&d.push(s[h].Interior),s[h].Parent);)h=s[h].Parent;switch(r.Type){case"Boolean":a.t="b",a.v=Rt(e);break;case"String":a.t="s",a.r=At(wt(e)),a.v=-1<e.indexOf("<")?wt(t||e).replace(/<.*?>/g,""):a.r;break;case"DateTime":"Z"!=e.slice(-1)&&(e+="Z"),a.v=(He(e)-new Date(Date.UTC(1899,11,30)))/864e5,a.v!=a.v?a.v=wt(e):a.v<60&&(a.v=a.v-1),f&&"General"!=f||(f="yyyy-mm-dd");case"Number":void 0===a.v&&(a.v=+e),a.t||(a.t="n");break;case"Error":a.t="e",a.v=Ha[e],!1!==l.cellText&&(a.w=e);break;default:""==e&&""==t?a.t="z":(a.t="s",a.v=At(t||e))}if(bf(a,f,l),!1!==l.cellFormula)if(a.Formula){r=wt(a.Formula);61==r.charCodeAt(0)&&(r=r.slice(1)),a.f=oc(r,n),delete a.Formula,"RC"==a.ArrayRange?a.F=oc("RC:RC",n):a.ArrayRange&&(a.F=oc(a.ArrayRange,n),c.push([Zr(a.F),a.F]))}else for(p=0;p<c.length;++p)n.r>=c[p][0].s.r&&n.r<=c[p][0].e.r&&n.c>=c[p][0].s.c&&n.c<=c[p][0].e.c&&(a.F=c[p][1]);l.cellStyles&&(d.forEach(function(e){!u.patternType&&e.patternType&&(u.patternType=e.patternType)}),a.s=u),void 0!==a.StyleID&&(a.ixfe=a.StyleID)}(n.slice(v,a.index),S,b,"comment"==l[l.length-1][0]?N:m,{c:w,r:T},k,F[w],g,P,r):(S="",b=gf(a[0]),v=a.index+a[0].length);break;case"cell":if("/"===a[1])if(0<I.length&&(m.c=I),(!r.sheetRows||r.sheetRows>T)&&void 0!==m.v&&(r.dense?(d[T]||(d[T]=[]),d[T][w]=m):d[Xr(w)+jr(T)]=m),m.HRef&&(m.l={Target:wt(m.HRef)},m.HRefScreenTip&&(m.l.Tooltip=m.HRefScreenTip),delete m.HRef,delete m.HRefScreenTip),(m.MergeAcross||m.MergeDown)&&(U=w+(0|parseInt(m.MergeAcross,10)),B=T+(0|parseInt(m.MergeDown,10)),x.push({s:{c:w,r:T},e:{c:U,r:B}})),r.sheetStubs)if(m.MergeAcross||m.MergeDown){for(var X=w;X<=U;++X)for(var Y=T;Y<=B;++Y)(w<X||T<Y)&&(r.dense?(d[Y]||(d[Y]=[]),d[Y][X]={t:"z"}):d[Xr(X)+jr(Y)]={t:"z"});w=U+1}else++w;else m.MergeAcross?w=U+1:++w;else(w=(m=function(e){var t={};if(1===e.split(/\s+/).length)return t;var r,a,n,s=e.match(pf);if(s)for(n=0;n!=s.length;++n)-1===(a=(r=s[n].match(mf))[1].indexOf(":"))?t[r[1]]=r[2].slice(1,r[2].length-1):t["xmlns:"===r[1].slice(0,6)?"xmlns"+r[1].slice(6):r[1].slice(a+1)]=r[2].slice(1,r[2].length-1);return t}(a[0])).Index?+m.Index-1:w)<E.s.c&&(E.s.c=w),w>E.e.c&&(E.e.c=w),"/>"===a[0].slice(-2)&&++w,I=[];break;case"row":"/"===a[1]||"/>"===a[0].slice(-2)?(T<E.s.r&&(E.s.r=T),T>E.e.r&&(E.e.r=T),"/>"===a[0].slice(-2)&&(g=gf(a[0])).Index&&(T=+g.Index-1),w=0,++T):((g=gf(a[0])).Index&&(T=+g.Index-1),M={},"0"!=g.AutoFitHeight&&!g.Height||(M.hpx=parseInt(g.Height,10),M.hpt=uo(M.hpx),L[T]=M),"1"==g.Hidden&&(M.hidden=!0,L[T]=M));break;case"worksheet":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"));u.push(p),E.s.r<=E.e.r&&E.s.c<=E.e.c&&(d["!ref"]=qr(E),r.sheetRows&&r.sheetRows<=E.e.r&&(d["!fullref"]=d["!ref"],E.e.r=r.sheetRows-1,d["!ref"]=qr(E))),x.length&&(d["!merges"]=x),0<F.length&&(d["!cols"]=F),0<L.length&&(d["!rows"]=L),h[p]=d}else E={s:{r:2e6,c:2e6},e:{r:0,c:0}},T=w=0,l.push([a[3],!1]),c=gf(a[0]),p=wt(c.Name),d=r.dense?[]:{},x=[],P=[],L=[],H={name:p,Hidden:0},W.Sheets.push(H);break;case"table":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else{if("/>"==a[0].slice(-2))break;l.push([a[3],!1]),D=!(F=[])}break;case"style":"/"===a[1]?(V=k,G=y,(j=r).cellStyles&&(!G.Interior||(j=G.Interior).Pattern&&(j.patternType=mo[j.Pattern]||j.Pattern)),V[G.ID]=G):y=gf(a[0]);break;case"numberformat":y.nf=wt(gf(a[0]).Format||"General"),df[y.nf]&&(y.nf=df[y.nf]);for(var K=0;392!=K&&me[K]!=y.nf;++K);if(392==K)for(K=57;392!=K;++K)if(null==me[K]){we(y.nf,K);break}break;case"column":if("table"!==l[l.length-1][0])break;if((f=gf(a[0])).Hidden&&(f.hidden=!0,delete f.Hidden),f.Width&&(f.wpx=parseInt(f.Width,10)),!D&&10<f.wpx){D=!0,no=to;for(var J=0;J<F.length;++J)F[J]&&fo(F[J])}D&&fo(f),F[f.Index-1||F.length]=f;for(var q=0;q<+f.Span;++q)F[F.length]=Ve(f);break;case"namedrange":if("/"===a[1])break;W.Names||(W.Names=[]);var Z=dt(a[0]),Q={Name:Z.Name,Ref:oc(Z.RefersTo.slice(1),{r:0,c:0})};0<W.Sheets.length&&(Q.Sheet=W.Sheets.length-1),W.Names.push(Q);break;case"namedcell":case"b":case"i":case"u":case"s":case"em":case"h2":case"h3":case"sub":case"sup":case"span":case"alignment":case"borders":case"border":break;case"font":if("/>"===a[0].slice(-2))break;"/"===a[1]?S+=n.slice(_,a.index):_=a.index+a[0].length;break;case"interior":if(!r.cellStyles)break;y.Interior=gf(a[0]);break;case"protection":break;case"author":case"title":case"description":case"created":case"keywords":case"subject":case"category":case"company":case"lastauthor":case"lastsaved":case"lastprinted":case"version":case"revision":case"totaltime":case"hyperlinkbase":case"manager":case"contentstatus":case"identifier":case"language":case"appname":if("/>"===a[0].slice(-2))break;"/"===a[1]?(G=A,Z=$,Q=n.slice(R,a.index),G[Z=(un=un||Ie(dn))[Z]||Z]=Q):R=a.index+a[0].length;break;case"paragraphs":break;case"styles":case"workbook":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else l.push([a[3],!1]);break;case"comment":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"));(z=N).t=z.v||"",z.t=z.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n"),z.v=z.w=z.ixfe=void 0,I.push(N)}else l.push([a[3],!1]),N={a:(c=gf(a[0])).Author};break;case"autofilter":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&(z=gf(a[0]),d["!autofilter"]={ref:oc(z.Range).replace(/\$/g,"")},l.push([a[3],!0]));break;case"name":break;case"datavalidation":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&l.push([a[3],!0]);break;case"pixelsperinch":break;case"componentoptions":case"documentproperties":case"customdocumentproperties":case"officedocumentsettings":case"pivottable":case"pivotcache":case"names":case"mapinfo":case"pagebreaks":case"querytable":case"sorting":case"schema":case"conditionalformatting":case"smarttagtype":case"smarttags":case"excelworkbook":case"workbookoptions":case"worksheetoptions":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&l.push([a[3],!0]);break;case"null":break;default:if(0==l.length&&"document"==a[3])return ih(n,r);if(0==l.length&&"uof"==a[3])return ih(n,r);var ee=!0;switch(l[l.length-1][0]){case"officedocumentsettings":switch(a[3]){case"allowpng":case"removepersonalinformation":case"downloadcomponents":case"locationofcomponents":case"colors":case"color":case"index":case"rgb":case"targetscreensize":case"readonlyrecommended":break;default:ee=!1}break;case"componentoptions":switch(a[3]){case"toolbar":case"hideofficelogo":case"spreadsheetautofit":case"label":case"caption":case"maxheight":case"maxwidth":case"nextsheetnumber":break;default:ee=!1}break;case"excelworkbook":switch(a[3]){case"date1904":W.WBProps.date1904=!0;break;case"windowheight":case"windowwidth":case"windowtopx":case"windowtopy":case"tabratio":case"protectstructure":case"protectwindow":case"protectwindows":case"activesheet":case"displayinknotes":case"firstvisiblesheet":case"supbook":case"sheetname":case"sheetindex":case"sheetindexfirst":case"sheetindexlast":case"dll":case"acceptlabelsinformulas":case"donotsavelinkvalues":case"iteration":case"maxiterations":case"maxchange":case"path":case"xct":case"count":case"selectedsheets":case"calculation":case"uncalced":case"startupprompt":case"crn":case"externname":case"formula":case"colfirst":case"collast":case"wantadvise":case"boolean":case"error":case"text":case"ole":case"noautorecover":case"publishobjects":case"donotcalculatebeforesave":case"number":case"refmoder1c1":case"embedsavesmarttags":break;default:ee=!1}break;case"workbookoptions":switch(a[3]){case"owcversion":case"height":case"width":break;default:ee=!1}break;case"worksheetoptions":switch(a[3]){case"visible":if("/>"!==a[0].slice(-2))if("/"===a[1])switch(n.slice(R,a.index)){case"SheetHidden":H.Hidden=1;break;case"SheetVeryHidden":H.Hidden=2}else R=a.index+a[0].length;break;case"header":d["!margins"]||Qc(d["!margins"]={},"xlml"),isNaN(+dt(a[0]).Margin)||(d["!margins"].header=+dt(a[0]).Margin);break;case"footer":d["!margins"]||Qc(d["!margins"]={},"xlml"),isNaN(+dt(a[0]).Margin)||(d["!margins"].footer=+dt(a[0]).Margin);break;case"pagemargins":var te=dt(a[0]);d["!margins"]||Qc(d["!margins"]={},"xlml"),isNaN(+te.Top)||(d["!margins"].top=+te.Top),isNaN(+te.Left)||(d["!margins"].left=+te.Left),isNaN(+te.Right)||(d["!margins"].right=+te.Right),isNaN(+te.Bottom)||(d["!margins"].bottom=+te.Bottom);break;case"displayrighttoleft":W.Views||(W.Views=[]),W.Views[0]||(W.Views[0]={}),W.Views[0].RTL=!0;break;case"freezepanes":case"frozennosplit":break;case"splithorizontal":case"splitvertical":case"donotdisplaygridlines":case"activerow":case"activecol":case"toprowbottompane":case"leftcolumnrightpane":case"unsynced":case"print":case"printerrors":case"panes":case"scale":case"pane":case"number":case"layout":case"pagesetup":case"selected":case"protectobjects":case"enableselection":case"protectscenarios":case"validprinterinfo":case"horizontalresolution":case"verticalresolution":case"numberofcopies":case"activepane":case"toprowvisible":case"leftcolumnvisible":case"fittopage":case"rangeselection":case"papersizeindex":case"pagelayoutzoom":case"pagebreakzoom":case"filteron":case"fitwidth":case"fitheight":case"commentslayout":case"zoom":case"lefttoright":case"gridlines":case"allowsort":case"allowfilter":case"allowinsertrows":case"allowdeleterows":case"allowinsertcols":case"allowdeletecols":case"allowinserthyperlinks":case"allowformatcells":case"allowsizecols":case"allowsizerows":break;case"nosummaryrowsbelowdetail":d["!outline"]||(d["!outline"]={}),d["!outline"].above=!0;break;case"tabcolorindex":case"donotdisplayheadings":case"showpagelayoutzoom":break;case"nosummarycolumnsrightdetail":d["!outline"]||(d["!outline"]={}),d["!outline"].left=!0;break;case"blackandwhite":case"donotdisplayzeros":case"displaypagebreak":case"rowcolheadings":case"donotdisplayoutline":case"noorientation":case"allowusepivottables":case"zeroheight":case"viewablerange":case"selection":case"protectcontents":break;default:ee=!1}break;case"pivottable":case"pivotcache":switch(a[3]){case"immediateitemsondrop":case"showpagemultipleitemlabel":case"compactrowindent":case"location":case"pivotfield":case"orientation":case"layoutform":case"layoutsubtotallocation":case"layoutcompactrow":case"position":case"pivotitem":case"datatype":case"datafield":case"sourcename":case"parentfield":case"ptlineitems":case"ptlineitem":case"countofsameitems":case"item":case"itemtype":case"ptsource":case"cacheindex":case"consolidationreference":case"filename":case"reference":case"nocolumngrand":case"norowgrand":case"blanklineafteritems":case"hidden":case"subtotal":case"basefield":case"mapchilditems":case"function":case"refreshonfileopen":case"printsettitles":case"mergelabels":case"defaultversion":case"refreshname":case"refreshdate":case"refreshdatecopy":case"versionlastrefresh":case"versionlastupdate":case"versionupdateablemin":case"versionrefreshablemin":case"calculation":break;default:ee=!1}break;case"pagebreaks":switch(a[3]){case"colbreaks":case"colbreak":case"rowbreaks":case"rowbreak":case"colstart":case"colend":case"rowend":break;default:ee=!1}break;case"autofilter":switch(a[3]){case"autofiltercolumn":case"autofiltercondition":case"autofilterand":case"autofilteror":break;default:ee=!1}break;case"querytable":switch(a[3]){case"id":case"autoformatfont":case"autoformatpattern":case"querysource":case"querytype":case"enableredirections":case"refreshedinxl9":case"urlstring":case"htmltables":case"connection":case"commandtext":case"refreshinfo":case"notitles":case"nextid":case"columninfo":case"overwritecells":case"donotpromptforfile":case"textwizardsettings":case"source":case"number":case"decimal":case"thousandseparator":case"trailingminusnumbers":case"formatsettings":case"fieldtype":case"delimiters":case"tab":case"comma":case"autoformatname":case"versionlastedit":case"versionlastrefresh":break;default:ee=!1}break;case"datavalidation":switch(a[3]){case"range":case"type":case"min":case"max":case"sort":case"descending":case"order":case"casesensitive":case"value":case"errorstyle":case"errormessage":case"errortitle":case"inputmessage":case"inputtitle":case"combohide":case"inputhide":case"condition":case"qualifier":case"useblank":case"value1":case"value2":case"format":case"cellrangelist":break;default:ee=!1}break;case"sorting":case"conditionalformatting":switch(a[3]){case"range":case"type":case"min":case"max":case"sort":case"descending":case"order":case"casesensitive":case"value":case"errorstyle":case"errormessage":case"errortitle":case"cellrangelist":case"inputmessage":case"inputtitle":case"combohide":case"inputhide":case"condition":case"qualifier":case"useblank":case"value1":case"value2":case"format":break;default:ee=!1}break;case"mapinfo":case"schema":case"data":switch(a[3]){case"map":case"entry":case"range":case"xpath":case"field":case"xsdtype":case"filteron":case"aggregate":case"elementtype":case"attributetype":break;case"schema":case"element":case"complextype":case"datatype":case"all":case"attribute":case"extends":case"row":break;default:ee=!1}break;case"smarttags":break;default:ee=!1}if(ee)break;if(a[3].match(/!\[CDATA/))break;if(!l[l.length-1][1])throw"Unrecognized tag: "+a[3]+"|"+l.join("|");if("customdocumentproperties"===l[l.length-1][0]){if("/>"===a[0].slice(-2))break;"/"===a[1]?function(e,t,r,a){var n=a;switch((r[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":n=Rt(a);break;case"i2":case"int":n=parseInt(a,10);break;case"r4":case"float":n=parseFloat(a);break;case"date":case"dateTime.tz":n=He(a);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw new Error("bad custprop:"+r[0])}e[wt(t)]=n}(C,$,O,n.slice(R,a.index)):R=(O=a).index+a[0].length;break}if(r.WTF)throw"Unrecognized tag: "+a[3]+"|"+l.join("|")}o={};return r.bookSheets||r.bookProps||(o.Sheets=h),o.SheetNames=u,o.Workbook=W,o.SSF=Ve(me),o.Props=A,o.Custprops=C,o}function wf(e,t){switch(Mh(t=t||{}),t.type||"base64"){case"base64":return vf(te(e),t);case"binary":case"buffer":case"file":return vf(e,t);case"array":return vf(i(e),t)}}function Tf(e,t){var r,a,n,s,i,o,c,l=[];return e.Props&&l.push((r=e.Props,a=t,n=[],Re(dn).map(function(e){for(var t=0;t<en.length;++t)if(en[t][1]==e)return en[t];for(t=0;t<sn.length;++t)if(sn[t][1]==e)return sn[t];throw e}).forEach(function(e){var t;null!=r[e[1]]&&(t=(a&&a.Props&&null!=a.Props[e[1]]?a.Props:r)[e[1]],"number"==typeof(t="date"===e[2]?new Date(t).toISOString().replace(/\.\d*Z/,"Z"):t)?t=String(t):!0===t||!1===t?t=t?"1":"0":t instanceof Date&&(t=new Date(t).toISOString().replace(/\.\d*Z/,"")),n.push($t(dn[e[1]]||e[1],t)))}),Yt("DocumentProperties",n.join(""),{xmlns:er.o}))),e.Custprops&&l.push((s=e.Props,i=e.Custprops,o=["Worksheets","SheetNames"],e="CustomDocumentProperties",c=[],s&&Re(s).forEach(function(e){if(Object.prototype.hasOwnProperty.call(s,e)){for(var t=0;t<en.length;++t)if(e==en[t][1])return;for(t=0;t<sn.length;++t)if(e==sn[t][1])return;for(t=0;t<o.length;++t)if(e==o[t])return;var r="string",a="number"==typeof(a=s[e])?(r="float",String(a)):!0===a||!1===a?(r="boolean",a?"1":"0"):String(a);c.push(Yt(yt(e),a,{"dt:dt":r}))}}),i&&Re(i).forEach(function(e){var t,r;Object.prototype.hasOwnProperty.call(i,e)&&(s&&Object.prototype.hasOwnProperty.call(s,e)||(t="string",r="number"==typeof(r=i[e])?(t="float",String(r)):!0===r||!1===r?(t="boolean",r?"1":"0"):r instanceof Date?(t="dateTime.tz",r.toISOString()):String(r),c.push(Yt(yt(e),r,{"dt:dt":t}))))}),"<"+e+' xmlns="'+er.o+'">'+c.join("")+"</"+e+">")),l.join("")}function Ef(e){return Yt("NamedRange",null,{"ss:Name":e.Name,"ss:RefersTo":"="+fc(e.Ref,{r:0,c:0})})}function kf(e,t,r,a,n,s,i){if(!e||null==e.v&&null==e.f)return"";var o={};if(e.f&&(o["ss:Formula"]="="+kt(fc(e.f,i))),e.F&&e.F.slice(0,t.length)==t&&(t=Yr(e.F.slice(t.length+1)),o["ss:ArrayRange"]="RC:R"+(t.r==i.r?"":"["+(t.r-i.r)+"]")+"C"+(t.c==i.c?"":"["+(t.c-i.c)+"]")),e.l&&e.l.Target&&(o["ss:HRef"]=kt(e.l.Target),e.l.Tooltip&&(o["x:HRefScreenTip"]=kt(e.l.Tooltip))),r["!merges"])for(var c=r["!merges"],l=0;l!=c.length;++l)c[l].s.c==i.c&&c[l].s.r==i.r&&(c[l].e.c>c[l].s.c&&(o["ss:MergeAcross"]=c[l].e.c-c[l].s.c),c[l].e.r>c[l].s.r&&(o["ss:MergeDown"]=c[l].e.r-c[l].s.r));var f="",h="";switch(e.t){case"z":if(!a.sheetStubs)return"";break;case"n":f="Number",h=String(e.v);break;case"b":f="Boolean",h=e.v?"1":"0";break;case"e":f="Error",h=Wa[e.v];break;case"d":f="DateTime",h=new Date(e.v).toISOString(),null==e.z&&(e.z=e.z||me[14]);break;case"s":f="String",h=((e.v||"")+"").replace(Tt,function(e){return vt[e]}).replace(St,function(e){return"&#x"+e.charCodeAt(0).toString(16).toUpperCase()+";"})}r=el(a.cellXfs,e,a);o["ss:StyleID"]="s"+(21+r),o["ss:Index"]=i.c+1;r=null!=e.v?h:"",r="z"==e.t?"":'<Data ss:Type="'+f+'">'+r+"</Data>";return 0<(e.c||[]).length&&(r+=e.c.map(function(e){var t=Yt("ss:Data",(e.t||"").replace(/(\r\n|[\r\n])/g,"&#10;"),{xmlns:"http://www.w3.org/TR/REC-html40"});return Yt("Comment",t,{"ss:Author":e.a})}).join("")),Yt("Cell",r,o)}function yf(e,t){if(!e["!ref"])return"";var r=Zr(e["!ref"]),a=e["!merges"]||[],n=0,s=[];e["!cols"]&&e["!cols"].forEach(function(e,t){fo(e);var r=!!e.width,a=Zc(t,e),t={"ss:Index":t+1};r&&(t["ss:Width"]=so(a.width)),e.hidden&&(t["ss:Hidden"]="1"),s.push(Yt("Column",null,t))});for(var i,o,c=Array.isArray(e),l=r.s.r;l<=r.e.r;++l){for(var f=[(i=l,o=(e["!rows"]||[])[l],i='<Row ss:Index="'+(i+1)+'"',o&&(o.hpt&&!o.hpx&&(o.hpx=po(o.hpt)),o.hpx&&(i+=' ss:AutoFitHeight="0" ss:Height="'+o.hpx+'"'),o.hidden&&(i+=' ss:Hidden="1"')),i+">")],h=r.s.c;h<=r.e.c;++h){for(var u,d,p,m=!1,n=0;n!=a.length;++n)if(!(a[n].s.c>h||a[n].s.r>l||a[n].e.c<h||a[n].e.r<l)){a[n].s.c==h&&a[n].s.r==l||(m=!0);break}m||(d=Kr(u={r:l,c:h}),p=c?(e[l]||[])[h]:e[d],f.push(kf(p,d,e,t,0,0,u)))}f.push("</Row>"),2<f.length&&s.push(f.join(""))}return s.join("")}function Sf(e,t,r){var a=[],n=r.SheetNames[e],s=r.Sheets[n],n=s?function(e,t,r){if(!e)return"";if(!((r||{}).Workbook||{}).Names)return"";for(var a=r.Workbook.Names,n=[],s=0;s<a.length;++s){var i=a[s];i.Sheet==t&&(i.Name.match(/^_xlfn\./)||n.push(Ef(i)))}return n.join("")}(s,e,r):"";return 0<n.length&&a.push("<Names>"+n+"</Names>"),0<(n=s?yf(s,t):"").length&&a.push("<Table>"+n+"</Table>"),a.push(function(t,e,r){if(!t)return"";var a=[];if(t["!margins"]&&(a.push("<PageSetup>"),t["!margins"].header&&a.push(Yt("Header",null,{"x:Margin":t["!margins"].header})),t["!margins"].footer&&a.push(Yt("Footer",null,{"x:Margin":t["!margins"].footer})),a.push(Yt("PageMargins",null,{"x:Bottom":t["!margins"].bottom||"0.75","x:Left":t["!margins"].left||"0.7","x:Right":t["!margins"].right||"0.7","x:Top":t["!margins"].top||"0.75"})),a.push("</PageSetup>")),r&&r.Workbook&&r.Workbook.Sheets&&r.Workbook.Sheets[e])if(r.Workbook.Sheets[e].Hidden)a.push(Yt("Visible",1==r.Workbook.Sheets[e].Hidden?"SheetHidden":"SheetVeryHidden",{}));else{for(var n=0;n<e&&(!r.Workbook.Sheets[n]||r.Workbook.Sheets[n].Hidden);++n);n==e&&a.push("<Selected/>")}return((((r||{}).Workbook||{}).Views||[])[0]||{}).RTL&&a.push("<DisplayRightToLeft/>"),t["!protect"]&&(a.push($t("ProtectContents","True")),t["!protect"].objects&&a.push($t("ProtectObjects","True")),t["!protect"].scenarios&&a.push($t("ProtectScenarios","True")),null==t["!protect"].selectLockedCells||t["!protect"].selectLockedCells?null==t["!protect"].selectUnlockedCells||t["!protect"].selectUnlockedCells||a.push($t("EnableSelection","UnlockedCells")):a.push($t("EnableSelection","NoSelection")),[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(e){t["!protect"][e[0]]&&a.push("<"+e[1]+"/>")})),0==a.length?"":Yt("WorksheetOptions",a.join(""),{xmlns:er.x})}(s,e,r)),a.join("")}function _f(e,t){t=t||{},e.SSF||(e.SSF=Ve(me)),e.SSF&&(Ee(),Te(e.SSF),t.revssf=Ne(e.SSF),t.revssf[e.SSF[65535]]=0,t.ssf=e.SSF,t.cellXfs=[],el(t.cellXfs,{},{revssf:{General:0}}));var r=[];r.push(Tf(e,t)),r.push(""),r.push(""),r.push("");for(var a,n=0;n<e.SheetNames.length;++n)r.push(Yt("Worksheet",Sf(n,t,e),{"ss:Name":kt(e.SheetNames[n])}));return r[2]=(a=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'],t.cellXfs.forEach(function(e,t){var r=[];r.push(Yt("NumberFormat",null,{"ss:Format":kt(me[e.numFmtId])}));t={"ss:ID":"s"+(21+t)};a.push(Yt("Style",r.join(""),t))}),Yt("Styles",a.join(""))),r[3]=function(e){if(!((e||{}).Workbook||{}).Names)return"";for(var t=e.Workbook.Names,r=[],a=0;a<t.length;++a){var n=t[a];null==n.Sheet&&(n.Name.match(/^_xlfn\./)||r.push(Ef(n)))}return Yt("Names",r.join(""))}(e),ot+Yt("Workbook",r.join(""),{xmlns:er.ss,"xmlns:o":er.o,"xmlns:x":er.x,"xmlns:ss":er.ss,"xmlns:dt":er.dt,"xmlns:html":er.html})}function xf(e){var t={},r=e.content;if(r.l=28,t.AnsiUserType=r.read_shift(0,"lpstr-ansi"),t.AnsiClipboardFormat=Ra(r,1),r.length-r.l<=4)return t;e=r.read_shift(4);return 0==e||40<e?t:(r.l-=4,t.Reserved1=r.read_shift(0,"lpstr-ansi"),r.length-r.l<=4||1907505652!==(e=r.read_shift(4))?t:(t.UnicodeClipboardFormat=Ra(r,2),0==(e=r.read_shift(4))||40<e?t:(r.l-=4,void(t.Reserved2=r.read_shift(0,"lpwstr")))))}var Af=[60,1084,2066,2165,2175];function Cf(e,t,r){if("z"!==e.t&&e.XF){var a,n=0;try{n=e.z||e.XF.numFmtId||0,t.cellNF&&(e.z=me[n])}catch(e){if(t.WTF)throw e}if(!t||!1!==t.cellText)try{"e"===e.t?e.w=e.w||Wa[e.v]:0===n||"General"==n?"n"===e.t?(0|e.v)===e.v?e.w=e.v.toString(10):e.w=D(e.v):e.w=P(e.v):e.w=ve(n,e.v,{date1904:!!r,dateNF:t&&t.dateNF})}catch(e){if(t.WTF)throw e}t.cellDates&&n&&"n"==e.t&&q(me[n]||String(n))&&((a=L(e.v))&&(e.t="d",e.v=new Date(a.y,a.m-1,a.d,a.H,a.M,a.S,a.u)))}}function Rf(e,t,r){return{v:e,ixfe:t,t:r}}function Of(e,t){var r={opts:{}},a={};null!=oe&&null==t.dense&&(t.dense=oe);function o(e){return!(e<8)&&e<64&&k[e-8]||Ba[e]}function n(e,t,r){if(!(1<D||r.sheetRows&&e.r>=r.sheetRows)){var a,n,s;if(r.cellStyles&&t.XF&&t.XF.data&&(n=r,(s=(a=t).XF.data)&&s.patternType&&n&&n.cellStyles&&(a.s={},a.s.patternType=s.patternType,(n=Qi(o(s.icvFore)))&&(a.s.fgColor={rgb:n}),(n=Qi(o(s.icvBack)))&&(a.s.bgColor={rgb:n}))),delete t.ixfe,delete t.XF,v=Kr(c=e),d&&d.s&&d.e||(d={s:{r:0,c:0},e:{r:0,c:0}}),e.r<d.s.r&&(d.s.r=e.r),e.c<d.s.c&&(d.s.c=e.c),e.r+1>d.e.r&&(d.e.r=e.r+1),e.c+1>d.e.c&&(d.e.c=e.c+1),r.cellFormula&&t.f)for(var i=0;i<T.length;++i)if(!(T[i][0].s.c>e.c||T[i][0].s.r>e.r||T[i][0].e.c<e.c||T[i][0].e.r<e.r)){t.F=qr(T[i][0]),T[i][0].s.c==e.c&&T[i][0].s.r==e.r||delete t.f,t.f&&(t.f=""+Pc(T[i][1],0,e,I,_));break}r.dense?(h[e.r]||(h[e.r]=[]),h[e.r][e.c]=t):h[v]=t}}var c,s,i,l,f,h=t.dense?[]:{},u={},d={},p=null,m=[],g="",b={},v="",w={},T=[],E=[],k=[],y={Sheets:[],WBProps:{date1904:!1},Views:[{}]},S={},_={enc:!1,sbcch:0,snames:[],sharedf:w,arrayf:T,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,cellStyles:!!t&&!!t.cellStyles,WTF:!!t&&!!t.wtf};t.password&&(_.password=t.password);var x=[],A=[],C=[],R=[],O=!1,I=[];I.SheetNames=_.snames,I.sharedf=_.sharedf,I.arrayf=_.arrayf,I.names=[],I.XTI=[];var N,F=0,D=0,P=0,L=[],M=[];_.codepage=1200,ie(1200);for(var U=!1;e.l<e.length-1;){var B=e.l,W=e.read_shift(2);if(0===W&&10===F)break;var H=e.l===e.length?0:e.read_shift(2),z=Pf[W];if(z&&z.f){if(t.bookSheets&&133===F&&133!==W)break;if(F=W,2===z.r||12==z.r){var V=e.read_shift(2);if(H-=2,!_.enc&&V!==W&&((255&V)<<8|V>>8)!==W)throw new Error("rt mismatch: "+V+"!="+W);12==z.r&&(e.l+=10,H-=10)}var G,j,$,X={},X=10===W?z.f(e,H,_):function(e,t,r,a,n){var s=a,i=[],o=r.slice(r.l,r.l+s);if(n&&n.enc&&n.enc.insitu&&0<o.length)switch(e){case 9:case 521:case 1033:case 2057:case 47:case 405:case 225:case 406:case 312:case 404:case 10:case 133:break;default:n.enc.insitu(o)}i.push(o),r.l+=s;for(var c=yr(r,r.l),l=Pf[c],f=0;null!=l&&-1<Af.indexOf(c);)s=yr(r,r.l+2),f=r.l+4,2066==c?f+=4:2165!=c&&2175!=c||(f+=12),o=r.slice(f,r.l+4+s),i.push(o),r.l+=4+s,l=Pf[c=yr(r,r.l)];var h=ue(i);Dr(h,0);var u=0;h.lens=[];for(var d=0;d<i.length;++d)h.lens.push(u),u+=i[d].length;if(h.length<a)throw"XLS Record 0x"+e.toString(16)+" Truncated: "+h.length+" < "+a;return t.f(h,h.length,n)}(W,z,e,H,_);if(0!=D||-1!==[9,521,1033,2057].indexOf(F))switch(W){case 34:r.opts.Date1904=y.WBProps.date1904=X;break;case 134:r.opts.WriteProtect=!0;break;case 47:if(_.enc||(e.l=0),_.enc=X,!t.password)throw new Error("File is password-protected");if(null==X.valid)throw new Error("Encryption scheme unsupported");if(!X.valid)throw new Error("Password is incorrect");break;case 92:_.lastuser=X;break;case 66:var Y=Number(X);switch(Y){case 21010:Y=1200;break;case 32768:Y=1e4;break;case 32769:Y=1252}ie(_.codepage=Y),U=!0;break;case 317:_.rrtabid=X;break;case 25:_.winlocked=X;break;case 439:r.opts.RefreshAll=X;break;case 12:r.opts.CalcCount=X;break;case 16:r.opts.CalcDelta=X;break;case 17:r.opts.CalcIter=X;break;case 13:r.opts.CalcMode=X;break;case 14:r.opts.CalcPrecision=X;break;case 95:r.opts.CalcSaveRecalc=X;break;case 15:_.CalcRefMode=X;break;case 2211:r.opts.FullCalc=X;break;case 129:X.fDialog&&(h["!type"]="dialog"),X.fBelow||((h["!outline"]||(h["!outline"]={})).above=!0),X.fRight||((h["!outline"]||(h["!outline"]={})).left=!0);break;case 224:E.push(X);break;case 430:I.push([X]),I[I.length-1].XTI=[];break;case 35:case 547:I[I.length-1].push(X);break;case 24:case 536:N={Name:X.Name,Ref:Pc(X.rgce,0,null,I,_)},0<X.itab&&(N.Sheet=X.itab-1),I.names.push(N),I[0]||(I[0]=[],I[0].XTI=[]),I[I.length-1].push(X),"_xlnm._FilterDatabase"==X.Name&&0<X.itab&&X.rgce&&X.rgce[0]&&X.rgce[0][0]&&"PtgArea3d"==X.rgce[0][0][0]&&(M[X.itab-1]={ref:qr(X.rgce[0][0][1][2])});break;case 22:_.ExternCount=X;break;case 23:0==I.length&&(I[0]=[],I[0].XTI=[]),I[I.length-1].XTI=I[I.length-1].XTI.concat(X),I.XTI=I.XTI.concat(X);break;case 2196:if(_.biff<8)break;null!=N&&(N.Comment=X[1]);break;case 18:h["!protect"]=X;break;case 19:0!==X&&_.WTF&&console.error("Password verifier: "+X);break;case 133:u[X.pos]=X,_.snames.push(X.name);break;case 10:if(--D)break;d.e&&(0<d.e.r&&0<d.e.c&&(d.e.r--,d.e.c--,h["!ref"]=qr(d),t.sheetRows&&t.sheetRows<=d.e.r&&(K=d.e.r,d.e.r=t.sheetRows-1,h["!fullref"]=h["!ref"],h["!ref"]=qr(d),d.e.r=K),d.e.r++,d.e.c++),0<x.length&&(h["!merges"]=x),0<A.length&&(h["!objects"]=A),0<C.length&&(h["!cols"]=C),0<R.length&&(h["!rows"]=R),y.Sheets.push(S)),""===g?b=h:a[g]=h,h=t.dense?[]:{};break;case 9:case 521:case 1033:case 2057:if(8===_.biff&&(_.biff={9:2,521:3,1033:4}[W]||{512:2,768:3,1024:4,1280:5,1536:8,2:2,7:2}[X.BIFFVer]||8),_.biffguess=0==X.BIFFVer,0==X.BIFFVer&&4096==X.dt&&(_.biff=5,U=!0,ie(_.codepage=28591)),8==_.biff&&0==X.BIFFVer&&16==X.dt&&(_.biff=2),D++)break;var K,h=t.dense?[]:{};_.biff<8&&!U&&(U=!0,ie(_.codepage=t.codepage||1252)),_.biff<5||0==X.BIFFVer&&4096==X.dt?(""===g&&(g="Sheet1"),d={s:{r:0,c:0},e:{r:0,c:0}},K={pos:e.l-H,name:g},u[K.pos]=K,_.snames.push(g)):g=(u[B]||{name:""}).name,32==X.dt&&(h["!type"]="chart"),64==X.dt&&(h["!type"]="macro"),x=[],A=[],_.arrayf=T=[],C=[],O=!(R=[]),S={Hidden:(u[B]||{hs:0}).hs,name:g};break;case 515:case 3:case 2:"chart"==h["!type"]&&(t.dense?(h[X.r]||[])[X.c]:h[Kr({c:X.c,r:X.r})])&&++X.c,Z={ixfe:X.ixfe,XF:E[X.ixfe]||{},v:X.val,t:"n"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 5:case 517:Z={ixfe:X.ixfe,XF:E[X.ixfe],v:X.val,t:X.t},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 638:Z={ixfe:X.ixfe,XF:E[X.ixfe],v:X.rknum,t:"n"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 189:for(var J=X.c;J<=X.C;++J){var q=X.rkrec[J-X.c][0],Z={ixfe:q,XF:E[q],v:X.rkrec[J-X.c][1],t:"n"};0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:J,r:X.r},Z,t)}break;case 6:case 518:case 1030:if("String"==X.val){p=X;break}(Z=Rf(X.val,X.cell.ixfe,X.tt)).XF=E[Z.ixfe],t.cellFormula&&(!((Q=X.formula)&&Q[0]&&Q[0][0]&&"PtgExp"==Q[0][0][0])||w[$=Kr({r:G=Q[0][0][1][0],c:j=Q[0][0][1][1]})]?Z.f=""+Pc(X.formula,0,X.cell,I,_):Z.F=((t.dense?(h[G]||[])[j]:h[$])||{}).F),0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n(X.cell,Z,t),p=X;break;case 7:case 519:if(!p)throw new Error("String record expects Formula");(Z=Rf(p.val=X,p.cell.ixfe,"s")).XF=E[Z.ixfe],t.cellFormula&&(Z.f=""+Pc(p.formula,0,p.cell,I,_)),0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n(p.cell,Z,t),p=null;break;case 33:case 545:T.push(X);var Q=Kr(X[0].s),ee=t.dense?(h[X[0].s.r]||[])[X[0].s.c]:h[Q];if(t.cellFormula&&ee){if(!p)break;if(!Q||!ee)break;ee.f=""+Pc(X[1],0,X[0],I,_),ee.F=qr(X[0])}break;case 1212:if(!t.cellFormula)break;if(v){if(!p)break;w[Kr(p.cell)]=X[0],((ee=t.dense?(h[p.cell.r]||[])[p.cell.c]:h[Kr(p.cell)])||{}).f=""+Pc(X[0],0,c,I,_)}break;case 253:Z=Rf(m[X.isst].t,X.ixfe,"s"),m[X.isst].h&&(Z.h=m[X.isst].h),Z.XF=E[Z.ixfe],0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 513:t.sheetStubs&&(Z={ixfe:X.ixfe,XF:E[X.ixfe],t:"z"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t));break;case 190:if(t.sheetStubs)for(var te=X.c;te<=X.C;++te){var re=X.ixfe[te-X.c];Z={ixfe:re,XF:E[re],t:"z"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:te,r:X.r},Z,t)}break;case 214:case 516:case 4:(Z=Rf(X.val,X.ixfe,"s")).XF=E[Z.ixfe],0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 0:case 512:1===D&&(d=X);break;case 252:m=X;break;case 1054:if(4==_.biff){L[P++]=X[1];for(var ae=0;ae<P+163&&me[ae]!=X[1];++ae);163<=ae&&we(X[1],P+163)}else we(X[1],X[0]);break;case 30:L[P++]=X;for(var ne=0;ne<P+163&&me[ne]!=X;++ne);163<=ne&&we(X,P+163);break;case 229:x=x.concat(X);break;case 93:A[X.cmo[0]]=_.lastobj=X;break;case 438:_.lastobj.TxO=X;break;case 127:_.lastobj.ImData=X;break;case 440:for(i=X[0].s.r;i<=X[0].e.r;++i)for(s=X[0].s.c;s<=X[0].e.c;++s)(ee=t.dense?(h[i]||[])[s]:h[Kr({c:s,r:i})])&&(ee.l=X[1]);break;case 2048:for(i=X[0].s.r;i<=X[0].e.r;++i)for(s=X[0].s.c;s<=X[0].e.c;++s)(ee=t.dense?(h[i]||[])[s]:h[Kr({c:s,r:i})])&&ee.l&&(ee.l.Tooltip=X[1]);break;case 28:if(_.biff<=5&&2<=_.biff)break;ee=t.dense?(h[X[0].r]||[])[X[0].c]:h[Kr(X[0])];var se=A[X[2]];ee||(ee=t.dense?(h[X[0].r]||(h[X[0].r]=[]),h[X[0].r][X[0].c]={t:"z"}):h[Kr(X[0])]={t:"z"},d.e.r=Math.max(d.e.r,X[0].r),d.s.r=Math.min(d.s.r,X[0].r),d.e.c=Math.max(d.e.c,X[0].c),d.s.c=Math.min(d.s.c,X[0].c)),ee.c||(ee.c=[]),se={a:X[1],t:se.TxO.t},ee.c.push(se);break;case 2173:E[X.ixfe],X.ext.forEach(function(e){e[0]});break;case 125:if(!_.cellStyles)break;for(;X.e>=X.s;)C[X.e--]={width:X.w/256,level:X.level||0,hidden:!!(1&X.flags)},O||(O=!0,lo(X.w/256)),fo(C[X.e+1]);break;case 520:se={};null!=X.level&&((R[X.r]=se).level=X.level),X.hidden&&((R[X.r]=se).hidden=!0),X.hpt&&((R[X.r]=se).hpt=X.hpt,se.hpx=po(X.hpt));break;case 38:case 39:case 40:case 41:h["!margins"]||Qc(h["!margins"]={}),h["!margins"][{38:"left",39:"right",40:"top",41:"bottom"}[W]]=X;break;case 161:h["!margins"]||Qc(h["!margins"]={}),h["!margins"].header=X.header,h["!margins"].footer=X.footer;break;case 574:X.RTL&&(y.Views[0].RTL=!0);break;case 146:k=X;break;case 2198:f=X;break;case 140:l=X;break;case 442:g?S.CodeName=X||S.name:y.WBProps.CodeName=X||"ThisWorkbook"}}else z||console.error("Missing Info for XLS Record 0x"+W.toString(16)),e.l+=H}return r.SheetNames=Re(u).sort(function(e,t){return Number(e)-Number(t)}).map(function(e){return u[e].name}),t.bookSheets||(r.Sheets=a),!r.SheetNames.length&&b["!ref"]?(r.SheetNames.push("Sheet1"),r.Sheets&&(r.Sheets.Sheet1=b)):r.Preamble=b,r.Sheets&&M.forEach(function(e,t){r.Sheets[r.SheetNames[t]]["!autofilter"]=e}),r.Strings=m,r.SSF=Ve(me),_.enc&&(r.Encryption=_.enc),f&&(r.Themes=f),r.Metadata={},void 0!==l&&(r.Metadata.Country=l),0<I.names.length&&(y.Names=I.names),r.Workbook=y,r}var If={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function Nf(e,t){var r,a,n,s,i;if(Mh(t=t||{}),h(),t.codepage&&c(t.codepage),e.FullPaths){if(xe.find(e,"/encryption"))throw new Error("File is password-protected");r=xe.find(e,"!CompObj"),n=xe.find(e,"/Workbook")||xe.find(e,"/Book")}else{switch(t.type){case"base64":e=he(te(e));break;case"binary":e=he(e);break;case"buffer":break;case"array":Array.isArray(e)||(e=Array.prototype.slice.call(e))}Dr(e,0),n={content:e}}if(r&&xf(r),t.bookProps&&!t.bookSheets)a={};else{var o=se?"buffer":"array";if(n&&n.content)a=Of(n.content,t);else if((n=xe.find(e,"PerfectOffice_MAIN"))&&n.content)a=si.to_workbook(n.content,(t.type=o,t));else{if(!(n=xe.find(e,"NativeContent_MAIN"))||!n.content)throw(n=xe.find(e,"MN0"))&&n.content?new Error("Unsupported Works 4 for Mac file"):new Error("Cannot find Workbook stream");a=si.to_workbook(n.content,(t.type=o,t))}t.bookVBA&&e.FullPaths&&xe.find(e,"/_VBA_PROJECT_CUR/VBA/dir")&&(a.vbaraw=(s=e,i=xe.utils.cfb_new({root:"R"}),s.FullPaths.forEach(function(e,t){"/"!==e.slice(-1)&&e.match(/_VBA_PROJECT_CUR/)&&(e=e.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,""),xe.utils.cfb_add(i,e,s.FileIndex[t].content))}),xe.write(i)))}o={};return e.FullPaths&&function(e,t,r){var a=xe.find(e,"/!DocumentSummaryInformation");if(a&&0<a.size)try{var n,s=An(a,Pa,If.DSI);for(n in s)t[n]=s[n]}catch(e){if(r.WTF)throw e}var i=xe.find(e,"/!SummaryInformation");if(i&&0<i.size)try{var o,c=An(i,La,If.SI);for(o in c)null==t[o]&&(t[o]=c[o])}catch(e){if(r.WTF)throw e}t.HeadingPairs&&t.TitlesOfParts&&(cn(t.HeadingPairs,t.TitlesOfParts,t,r),delete t.HeadingPairs,delete t.TitlesOfParts)}(e,o,t),a.Props=a.Custprops=o,t.bookFiles&&(a.cfb=e),a}function Ff(e,t){var r,a,n=t||{},t=xe.utils.cfb_new({root:"R"}),s="/Workbook";switch(n.bookType||"xls"){case"xls":n.bookType="biff8";case"xla":n.bookType||(n.bookType="xla");case"biff8":s="/Workbook",n.biff=8;break;case"biff5":s="/Book",n.biff=5;break;default:throw new Error("invalid type "+n.bookType+" for XLS CFB")}return xe.utils.cfb_add(t,s,Xf(e,n)),8==n.biff&&(e.Props||e.Custprops)&&function(e,t){var r,a=[],n=[],s=[],i=0,o=Oe(Pa,"n"),c=Oe(La,"n");if(e.Props)for(r=Re(e.Props),i=0;i<r.length;++i)(Object.prototype.hasOwnProperty.call(o,r[i])?a:Object.prototype.hasOwnProperty.call(c,r[i])?n:s).push([r[i],e.Props[r[i]]]);if(e.Custprops)for(r=Re(e.Custprops),i=0;i<r.length;++i)Object.prototype.hasOwnProperty.call(e.Props||{},r[i])||(Object.prototype.hasOwnProperty.call(o,r[i])?a:Object.prototype.hasOwnProperty.call(c,r[i])?n:s).push([r[i],e.Custprops[r[i]]]);for(var l=[],i=0;i<s.length;++i)-1<_n.indexOf(s[i][0])||-1<on.indexOf(s[i][0])||null!=s[i][1]&&l.push(s[i]);n.length&&xe.utils.cfb_add(t,"/SummaryInformation",Cn(n,If.SI,c,La)),(a.length||l.length)&&xe.utils.cfb_add(t,"/DocumentSummaryInformation",Cn(a,If.DSI,o,Pa,l.length?l:null,If.UDI))}(e,t),8==n.biff&&e.vbaraw&&(r=t,(a=xe.read(e.vbaraw,{type:"string"==typeof e.vbaraw?"binary":"buffer"})).FullPaths.forEach(function(e,t){0==t||"/"!==(e=e.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/")).slice(-1)&&xe.utils.cfb_add(r,e,a.FileIndex[t].content)})),t}var Df={0:{f:function(e,t){var r={},a=e.l+t;r.r=e.read_shift(4),e.l+=4;var n=e.read_shift(2);return e.l+=1,t=e.read_shift(1),e.l=a,7&t&&(r.level=7&t),16&t&&(r.hidden=!0),32&t&&(r.hpt=n/20),r}},1:{f:function(e){return[fa(e)]}},2:{f:function(e){return[fa(e),Ea(e),"n"]}},3:{f:function(e){return[fa(e),e.read_shift(1),"e"]}},4:{f:function(e){return[fa(e),e.read_shift(1),"b"]}},5:{f:function(e){return[fa(e),xa(e),"n"]}},6:{f:function(e){return[fa(e),sa(e),"str"]}},7:{f:function(e){return[fa(e),e.read_shift(4),"s"]}},8:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,sa(e),"str"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},9:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,xa(e),"n"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},10:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,e.read_shift(1),"b"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},11:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,e.read_shift(1),"e"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},12:{f:function(e){return[ua(e)]}},13:{f:function(e){return[ua(e),Ea(e),"n"]}},14:{f:function(e){return[ua(e),e.read_shift(1),"e"]}},15:{f:function(e){return[ua(e),e.read_shift(1),"b"]}},16:{f:Rl},17:{f:function(e){return[ua(e),sa(e),"str"]}},18:{f:function(e){return[ua(e),e.read_shift(4),"s"]}},19:{f:oa},20:{},21:{},22:{},23:{},24:{},25:{},26:{},27:{},28:{},29:{},30:{},31:{},32:{},33:{},34:{},35:{T:1},36:{T:-1},37:{T:1},38:{T:-1},39:{f:function(e,t,r){var a=e.l+t;e.l+=4,e.l+=1;var n=e.read_shift(4),s=va(e),t=Hc(e,0,r),r=ga(e);return e.l=a,t={Name:s,Ptg:t},n<268435455&&(t.Sheet=n),r&&(t.Comment=r),t}},40:{},42:{},43:{f:function(e,t,r){var a={};a.sz=e.read_shift(2)/20;var n,s=(s=(n=e).read_shift(1),n.l++,{fBold:1&s,fItalic:2&s,fUnderline:4&s,fStrikeout:8&s,fOutline:16&s,fShadow:32&s,fCondense:64&s,fExtend:128&s});switch(s.fItalic&&(a.italic=1),s.fCondense&&(a.condense=1),s.fExtend&&(a.extend=1),s.fShadow&&(a.shadow=1),s.fOutline&&(a.outline=1),s.fStrikeout&&(a.strike=1),700===e.read_shift(2)&&(a.bold=1),e.read_shift(2)){case 1:a.vertAlign="superscript";break;case 2:a.vertAlign="subscript"}switch(0!=(s=e.read_shift(1))&&(a.underline=s),0<(s=e.read_shift(1))&&(a.family=s),0<(s=e.read_shift(1))&&(a.charset=s),e.l++,a.color=function(e){var t={},r=e.read_shift(1)>>>1,a=e.read_shift(1),n=e.read_shift(2,"i"),s=e.read_shift(1),i=e.read_shift(1),o=e.read_shift(1);switch(e.l++,r){case 0:t.auto=1;break;case 1:t.index=a;var c=Ba[a];c&&(t.rgb=Qi(c));break;case 2:t.rgb=Qi([s,i,o]);break;case 3:t.theme=a}return 0!=n&&(t.tint=0<n?n/32767:n/32768),t}(e),e.read_shift(1)){case 1:a.scheme="major";break;case 2:a.scheme="minor"}return a.name=sa(e),a}},44:{f:function(e,t){return[e.read_shift(2),sa(e)]}},45:{f:Ro},46:{f:r},47:{f:function(e,t){var r=e.l+t,a=e.read_shift(2),t=e.read_shift(2);return e.l=r,{ixfe:a,numFmtId:t}}},48:{},49:{f:function(e){return e.read_shift(4,"i")}},50:{},51:{f:function(e){for(var t=[],r=e.read_shift(4);0<r--;)t.push([e.read_shift(4),e.read_shift(4)]);return t}},52:{T:1},53:{T:-1},54:{T:1},55:{T:-1},56:{T:1},57:{T:-1},58:{},59:{},60:{f:vs},62:{f:function(e){return[fa(e),oa(e),"is"]}},63:{f:function(e){var t={};t.i=e.read_shift(4);var r={};return r.r=e.read_shift(4),r.c=e.read_shift(4),t.r=Kr(r),2&(e=e.read_shift(1))&&(t.l="1"),8&e&&(t.a="1"),t}},64:{f:function(){}},65:{},66:{},67:{},68:{},69:{},70:{},128:{},129:{T:1},130:{T:-1},131:{T:1,f:Pr,p:0},132:{T:-1},133:{T:1},134:{T:-1},135:{T:1},136:{T:-1},137:{T:1,f:function(e){var t=e.read_shift(2);return e.l+=28,{RTL:32&t}}},138:{T:-1},139:{T:1},140:{T:-1},141:{T:1},142:{T:-1},143:{T:1},144:{T:-1},145:{T:1},146:{T:-1},147:{f:function(e,t){var r={},a=e[e.l];return++e.l,r.above=!(64&a),r.left=!(128&a),e.l+=18,r.name=pa(e,t-19),r}},148:{f:lt,p:16},151:{f:function(){}},152:{},153:{f:function(e,t){var r={},a=e.read_shift(4);return r.defaultThemeVersion=e.read_shift(4),0<(e=8<t?sa(e):"").length&&(r.CodeName=e),r.autoCompressPictures=!!(65536&a),r.backupFile=!!(64&a),r.checkCompatibility=!!(4096&a),r.date1904=!!(1&a),r.filterPrivacy=!!(8&a),r.hidePivotFieldList=!!(1024&a),r.promptedSolutions=!!(16&a),r.publishItems=!!(2048&a),r.refreshAllConnections=!!(262144&a),r.saveExternalLinkValues=!!(128&a),r.showBorderUnselectedTables=!!(4&a),r.showInkAnnotation=!!(32&a),r.showObjects=["all","placeholders","none"][a>>13&3],r.showPivotChartFilter=!!(32768&a),r.updateLinks=["userSet","never","always"][a>>8&3],r}},154:{},155:{},156:{f:function(e,t){var r={};return r.Hidden=e.read_shift(4),r.iTabID=e.read_shift(4),r.strRelID=wa(e,t-8),r.name=sa(e),r}},157:{},158:{},159:{T:1,f:function(e){return[e.read_shift(4),e.read_shift(4)]}},160:{T:-1},161:{T:1,f:Sa},162:{T:-1},163:{T:1},164:{T:-1},165:{T:1},166:{T:-1},167:{},168:{},169:{},170:{},171:{},172:{T:1},173:{T:-1},174:{},175:{},176:{f:Lt},177:{T:1},178:{T:-1},179:{T:1},180:{T:-1},181:{T:1},182:{T:-1},183:{T:1},184:{T:-1},185:{T:1},186:{T:-1},187:{T:1},188:{T:-1},189:{T:1},190:{T:-1},191:{T:1},192:{T:-1},193:{T:1},194:{T:-1},195:{T:1},196:{T:-1},197:{T:1},198:{T:-1},199:{T:1},200:{T:-1},201:{T:1},202:{T:-1},203:{T:1},204:{T:-1},205:{T:1},206:{T:-1},207:{T:1},208:{T:-1},209:{T:1},210:{T:-1},211:{T:1},212:{T:-1},213:{T:1},214:{T:-1},215:{T:1},216:{T:-1},217:{T:1},218:{T:-1},219:{T:1},220:{T:-1},221:{T:1},222:{T:-1},223:{T:1},224:{T:-1},225:{T:1},226:{T:-1},227:{T:1},228:{T:-1},229:{T:1},230:{T:-1},231:{T:1},232:{T:-1},233:{T:1},234:{T:-1},235:{T:1},236:{T:-1},237:{T:1},238:{T:-1},239:{T:1},240:{T:-1},241:{T:1},242:{T:-1},243:{T:1},244:{T:-1},245:{T:1},246:{T:-1},247:{T:1},248:{T:-1},249:{T:1},250:{T:-1},251:{T:1},252:{T:-1},253:{T:1},254:{T:-1},255:{T:1},256:{T:-1},257:{T:1},258:{T:-1},259:{T:1},260:{T:-1},261:{T:1},262:{T:-1},263:{T:1},264:{T:-1},265:{T:1},266:{T:-1},267:{T:1},268:{T:-1},269:{T:1},270:{T:-1},271:{T:1},272:{T:-1},273:{T:1},274:{T:-1},275:{T:1},276:{T:-1},277:{},278:{T:1},279:{T:-1},280:{T:1},281:{T:-1},282:{T:1},283:{T:1},284:{T:-1},285:{T:1},286:{T:-1},287:{T:1},288:{T:-1},289:{T:1},290:{T:-1},291:{T:1},292:{T:-1},293:{T:1},294:{T:-1},295:{T:1},296:{T:-1},297:{T:1},298:{T:-1},299:{T:1},300:{T:-1},301:{T:1},302:{T:-1},303:{T:1},304:{T:-1},305:{T:1},306:{T:-1},307:{T:1},308:{T:-1},309:{T:1},310:{T:-1},311:{T:1},312:{T:-1},313:{T:-1},314:{T:1},315:{T:-1},316:{T:1},317:{T:-1},318:{T:1},319:{T:-1},320:{T:1},321:{T:-1},322:{T:1},323:{T:-1},324:{T:1},325:{T:-1},326:{T:1},327:{T:-1},328:{T:1},329:{T:-1},330:{T:1},331:{T:-1},332:{T:1},333:{T:-1},334:{T:1},335:{f:function(e,t){return{flags:e.read_shift(4),version:e.read_shift(4),name:sa(e)}}},336:{T:-1},337:{f:function(e){return e.l+=4,0!=e.read_shift(4)},T:1},338:{T:-1},339:{T:1},340:{T:-1},341:{T:1},342:{T:-1},343:{T:1},344:{T:-1},345:{T:1},346:{T:-1},347:{T:1},348:{T:-1},349:{T:1},350:{T:-1},351:{},352:{},353:{T:1},354:{T:-1},355:{f:wa},357:{},358:{},359:{},360:{T:1},361:{},362:{f:ps},363:{},364:{},366:{},367:{},368:{},369:{},370:{},371:{},372:{T:1},373:{T:-1},374:{T:1},375:{T:-1},376:{T:1},377:{T:-1},378:{T:1},379:{T:-1},380:{T:1},381:{T:-1},382:{T:1},383:{T:-1},384:{T:1},385:{T:-1},386:{T:1},387:{T:-1},388:{T:1},389:{T:-1},390:{T:1},391:{T:-1},392:{T:1},393:{T:-1},394:{T:1},395:{T:-1},396:{},397:{},398:{},399:{},400:{},401:{T:1},403:{},404:{},405:{},406:{},407:{},408:{},409:{},410:{},411:{},412:{},413:{},414:{},415:{},416:{},417:{},418:{},419:{},420:{},421:{},422:{T:1},423:{T:1},424:{T:-1},425:{T:-1},426:{f:function(e,t,r){var a=e.l+t,n=ya(e),t=e.read_shift(1);return(n=[n])[2]=t,r.cellFormula?(r=Bc(e,a-e.l,r),n[1]=r):e.l=a,n}},427:{f:function(e,t,r){var a=e.l+t,t=[Sa(e,16)];return r.cellFormula&&(r=zc(e,a-e.l,r),t[1]=r),e.l=a,t}},428:{},429:{T:1},430:{T:-1},431:{T:1},432:{T:-1},433:{T:1},434:{T:-1},435:{T:1},436:{T:-1},437:{T:1},438:{T:-1},439:{T:1},440:{T:-1},441:{T:1},442:{T:-1},443:{T:1},444:{T:-1},445:{T:1},446:{T:-1},447:{T:1},448:{T:-1},449:{T:1},450:{T:-1},451:{T:1},452:{T:-1},453:{T:1},454:{T:-1},455:{T:1},456:{T:-1},457:{T:1},458:{T:-1},459:{T:1},460:{T:-1},461:{T:1},462:{T:-1},463:{T:1},464:{T:-1},465:{T:1},466:{T:-1},467:{T:1},468:{T:-1},469:{T:1},470:{T:-1},471:{},472:{},473:{T:1},474:{T:-1},475:{},476:{f:function(t){var r={};return Il.forEach(function(e){r[e]=xa(t)}),r}},477:{},478:{},479:{T:1},480:{T:-1},481:{T:1},482:{T:-1},483:{T:1},484:{T:-1},485:{f:function(){}},486:{T:1},487:{T:-1},488:{T:1},489:{T:-1},490:{T:1},491:{T:-1},492:{T:1},493:{T:-1},494:{f:function(e,t){var r=e.l+t,a=Sa(e,16),n=ga(e),s=sa(e),i=sa(e),t=sa(e);return e.l=r,t={rfx:a,relId:n,loc:s,display:t},i&&(t.Tooltip=i),t}},495:{T:1},496:{T:-1},497:{T:1},498:{T:-1},499:{},500:{T:1},501:{T:-1},502:{T:1},503:{T:-1},504:{},505:{T:1},506:{T:-1},507:{},508:{T:1},509:{T:-1},510:{T:1},511:{T:-1},512:{},513:{},514:{T:1},515:{T:-1},516:{T:1},517:{T:-1},518:{T:1},519:{T:-1},520:{T:1},521:{T:-1},522:{},523:{},524:{},525:{},526:{},527:{},528:{T:1},529:{T:-1},530:{T:1},531:{T:-1},532:{T:1},533:{T:-1},534:{},535:{},536:{},537:{},538:{T:1},539:{T:-1},540:{T:1},541:{T:-1},542:{T:1},548:{},549:{},550:{f:wa},551:{},552:{},553:{},554:{T:1},555:{T:-1},556:{T:1},557:{T:-1},558:{T:1},559:{T:-1},560:{T:1},561:{T:-1},562:{},564:{},565:{T:1},566:{T:-1},569:{T:1},570:{T:-1},572:{},573:{T:1},574:{T:-1},577:{},578:{},579:{},580:{},581:{},582:{},583:{},584:{},585:{},586:{},587:{},588:{T:-1},589:{},590:{T:1},591:{T:-1},592:{T:1},593:{T:-1},594:{T:1},595:{T:-1},596:{},597:{T:1},598:{T:-1},599:{T:1},600:{T:-1},601:{T:1},602:{T:-1},603:{T:1},604:{T:-1},605:{T:1},606:{T:-1},607:{},608:{T:1},609:{T:-1},610:{},611:{T:1},612:{T:-1},613:{T:1},614:{T:-1},615:{T:1},616:{T:-1},617:{T:1},618:{T:-1},619:{T:1},620:{T:-1},625:{},626:{T:1},627:{T:-1},628:{T:1},629:{T:-1},630:{T:1},631:{T:-1},632:{f:Ue},633:{T:1},634:{T:-1},635:{T:1,f:function(e){var t={};t.iauthor=e.read_shift(4);var r=Sa(e,16);return t.rfx=r.s,t.ref=Kr(r.s),e.l+=16,t}},636:{T:-1},637:{f:ca},638:{T:1},639:{},640:{T:-1},641:{T:1},642:{T:-1},643:{T:1},644:{},645:{T:-1},646:{T:1},648:{T:1},649:{},650:{T:-1},651:{f:function(e,t){return e.l+=10,{name:sa(e)}}},652:{},653:{T:1},654:{T:-1},655:{T:1},656:{T:-1},657:{T:1},658:{T:-1},659:{},660:{T:1},661:{},662:{T:-1},663:{},664:{T:1},665:{},666:{T:-1},667:{},668:{},669:{},671:{T:1},672:{T:-1},673:{T:1},674:{T:-1},675:{},676:{},677:{},678:{},679:{},680:{},681:{},1024:{},1025:{},1026:{T:1},1027:{T:-1},1028:{T:1},1029:{T:-1},1030:{},1031:{T:1},1032:{T:-1},1033:{T:1},1034:{T:-1},1035:{},1036:{},1037:{},1038:{T:1},1039:{T:-1},1040:{},1041:{T:1},1042:{T:-1},1043:{},1044:{},1045:{},1046:{T:1},1047:{T:-1},1048:{T:1},1049:{T:-1},1050:{},1051:{T:1},1052:{T:1},1053:{f:function(){}},1054:{T:1},1055:{},1056:{T:1},1057:{T:-1},1058:{T:1},1059:{T:-1},1061:{},1062:{T:1},1063:{T:-1},1064:{T:1},1065:{T:-1},1066:{T:1},1067:{T:-1},1068:{T:1},1069:{T:-1},1070:{T:1},1071:{T:-1},1072:{T:1},1073:{T:-1},1075:{T:1},1076:{T:-1},1077:{T:1},1078:{T:-1},1079:{T:1},1080:{T:-1},1081:{T:1},1082:{T:-1},1083:{T:1},1084:{T:-1},1085:{},1086:{T:1},1087:{T:-1},1088:{T:1},1089:{T:-1},1090:{T:1},1091:{T:-1},1092:{T:1},1093:{T:-1},1094:{T:1},1095:{T:-1},1096:{},1097:{T:1},1098:{},1099:{T:-1},1100:{T:1},1101:{T:-1},1102:{},1103:{},1104:{},1105:{},1111:{},1112:{},1113:{T:1},1114:{T:-1},1115:{T:1},1116:{T:-1},1117:{},1118:{T:1},1119:{T:-1},1120:{T:1},1121:{T:-1},1122:{T:1},1123:{T:-1},1124:{T:1},1125:{T:-1},1126:{},1128:{T:1},1129:{T:-1},1130:{},1131:{T:1},1132:{T:-1},1133:{T:1},1134:{T:-1},1135:{T:1},1136:{T:-1},1137:{T:1},1138:{T:-1},1139:{T:1},1140:{T:-1},1141:{},1142:{T:1},1143:{T:-1},1144:{T:1},1145:{T:-1},1146:{},1147:{T:1},1148:{T:-1},1149:{T:1},1150:{T:-1},1152:{T:1},1153:{T:-1},1154:{T:-1},1155:{T:-1},1156:{T:-1},1157:{T:1},1158:{T:-1},1159:{T:1},1160:{T:-1},1161:{T:1},1162:{T:-1},1163:{T:1},1164:{T:-1},1165:{T:1},1166:{T:-1},1167:{T:1},1168:{T:-1},1169:{T:1},1170:{T:-1},1171:{},1172:{T:1},1173:{T:-1},1177:{},1178:{T:1},1180:{},1181:{},1182:{},2048:{T:1},2049:{T:-1},2050:{},2051:{T:1},2052:{T:-1},2053:{},2054:{},2055:{T:1},2056:{T:-1},2057:{T:1},2058:{T:-1},2060:{},2067:{},2068:{T:1},2069:{T:-1},2070:{},2071:{},2072:{T:1},2073:{T:-1},2075:{},2076:{},2077:{T:1},2078:{T:-1},2079:{},2080:{T:1},2081:{T:-1},2082:{},2083:{T:1},2084:{T:-1},2085:{T:1},2086:{T:-1},2087:{T:1},2088:{T:-1},2089:{T:1},2090:{T:-1},2091:{},2092:{},2093:{T:1},2094:{T:-1},2095:{},2096:{T:1},2097:{T:-1},2098:{T:1},2099:{T:-1},2100:{T:1},2101:{T:-1},2102:{},2103:{T:1},2104:{T:-1},2105:{},2106:{T:1},2107:{T:-1},2108:{},2109:{T:1},2110:{T:-1},2111:{T:1},2112:{T:-1},2113:{T:1},2114:{T:-1},2115:{},2116:{},2117:{},2118:{T:1},2119:{T:-1},2120:{},2121:{T:1},2122:{T:-1},2123:{T:1},2124:{T:-1},2125:{},2126:{T:1},2127:{T:-1},2128:{},2129:{T:1},2130:{T:-1},2131:{T:1},2132:{T:-1},2133:{T:1},2134:{},2135:{},2136:{},2137:{T:1},2138:{T:-1},2139:{T:1},2140:{T:-1},2141:{},3072:{},3073:{},4096:{T:1},4097:{T:-1},5002:{T:1},5003:{T:-1},5081:{T:1},5082:{T:-1},5083:{},5084:{T:1},5085:{T:-1},5086:{T:1},5087:{T:-1},5088:{},5089:{},5090:{},5092:{T:1},5093:{T:-1},5094:{},5095:{T:1},5096:{T:-1},5097:{},5099:{},65535:{n:""}},Pf={6:{f:Lc},10:{f:Rn},12:{f:Nn},13:{f:Nn},14:{f:On},15:{f:On},16:{f:xa},17:{f:On},18:{f:On},19:{f:Nn},20:{f:fs},21:{f:fs},23:{f:ps},24:{f:ds},25:{f:On},26:{},27:{},28:{f:function(e,t,r){return function(e,t){if(!(t.biff<8)){var r=e.read_shift(2),a=e.read_shift(2),n=e.read_shift(2),s=e.read_shift(2),i=Bn(e,0,t);return t.biff<8&&e.read_shift(1),[{r:r,c:a},i,s,n]}}(e,r)}},29:{},34:{f:On},35:{f:hs},38:{f:xa},39:{f:xa},40:{f:xa},41:{f:xa},42:{f:On},43:{f:On},47:{f:function(e,t,r){var a={Type:8<=r.biff?e.read_shift(2):0};return a.Type?Ki(e,t-2,a):(t=e,r.biff,e=r,r=a,t={key:Nn(t),verificationBytes:Nn(t)},e.password&&(t.verifier=zi(e.password)),r.valid=t.verificationBytes===t.verifier,r.valid&&(r.insitu=Yi(e.password))),a}},49:{f:function(e,t,r){var a={dyHeight:e.read_shift(2),fl:e.read_shift(2)};switch(r&&r.biff||8){case 2:break;case 3:case 4:e.l+=2;break;default:e.l+=10}return a.name=Ln(e,0,r),a}},51:{f:Nn},60:{},61:{f:function(e){return{Pos:[e.read_shift(2),e.read_shift(2)],Dim:[e.read_shift(2),e.read_shift(2)],Flags:e.read_shift(2),CurTab:e.read_shift(2),FirstTab:e.read_shift(2),Selected:e.read_shift(2),TabRatio:e.read_shift(2)}}},64:{f:On},65:{f:function(){}},66:{f:Nn},77:{},80:{},81:{},82:{},85:{f:Nn},89:{},90:{},91:{},92:{f:function(e,t,r){if(r.enc)return e.l+=t,"";var a=e.l,r=Bn(e,0,r);return e.read_shift(t+a-e.l),r}},93:{f:function(e,t,r){return r&&r.biff<8?function(e,t,r){e.l+=4;var a=e.read_shift(2),n=e.read_shift(2),s=e.read_shift(2);e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=6,t-=36;var i=[];return i.push((gs[a]||Pr)(e,t,r)),{cmo:[n,a,s],ft:i}}(e,t,r):{cmo:r=Qn(e),ft:function(t,e){for(var r=t.l+e,a=[];t.l<r;){var n=t.read_shift(2);t.l-=2;try{a.push(ts[n](t,r-t.l))}catch(e){return t.l=r,a}}return t.l!=r&&(t.l=r),a}(e,t-22,r[1])}}},94:{},95:{f:On},96:{},97:{},99:{f:On},125:{f:vs},128:{f:function(e){if(e.l+=4,0!==(e=[e.read_shift(2),e.read_shift(2)])[0]&&e[0]--,0!==e[1]&&e[1]--,7<e[0]||7<e[1])throw new Error("Bad Gutters: "+e.join("|"));return e}},129:{f:function(e,t,r){return{fDialog:16&(t=r&&8==r.biff||2==t?e.read_shift(2):(e.l+=t,0)),fBelow:64&t,fRight:128&t}}},130:{f:Nn},131:{f:On},132:{f:On},133:{f:function(e,t,r){var a=e.read_shift(4),n=3&e.read_shift(1),s=e.read_shift(1);switch(s){case 0:s="Worksheet";break;case 1:s="Macrosheet";break;case 2:s="Chartsheet";break;case 6:s="VBAModule"}return r=Ln(e,0,r),{pos:a,hs:n,dt:s,name:r=0===r.length?"Sheet1":r}}},134:{},140:{f:function(e){var t=[0,0],r=e.read_shift(2);return t[0]=Ma[r]||r,r=e.read_shift(2),t[1]=Ma[r]||r,t}},141:{f:Nn},144:{},146:{f:function(e){for(var t=e.read_shift(2),r=[];0<t--;)r.push(jn(e));return r}},151:{},152:{},153:{},154:{},155:{},156:{f:Nn},157:{},158:{},160:{f:Ts},161:{f:function(e,t){var r={};return t<32||(e.l+=16,r.header=xa(e),r.footer=xa(e),e.l+=2),r}},174:{},175:{},176:{},177:{},178:{},180:{},181:{},182:{},184:{},185:{},189:{f:function(e,t){for(var r=e.l+t-2,a=e.read_shift(2),n=e.read_shift(2),s=[];e.l<r;)s.push(Yn(e));if(e.l!==r)throw new Error("MulRK read error");if(t=e.read_shift(2),s.length!=t-n+1)throw new Error("MulRK length mismatch");return{r:a,c:n,C:t,rkrec:s}}},190:{f:function(e,t){for(var r=e.l+t-2,a=e.read_shift(2),n=e.read_shift(2),s=[];e.l<r;)s.push(e.read_shift(2));if(e.l!==r)throw new Error("MulBlank read error");if(t=e.read_shift(2),s.length!=t-n+1)throw new Error("MulBlank length mismatch");return{r:a,c:n,C:t,ixfe:s}}},193:{f:Rn},197:{},198:{},199:{},200:{},201:{},202:{f:On},203:{},204:{},205:{},206:{},207:{},208:{},209:{},210:{},211:{},213:{},215:{},216:{},217:{},218:{f:Nn},220:{},221:{f:On},222:{},224:{f:function(e,t,r){var a,n,s,i={};return i.ifnt=e.read_shift(2),i.numFmtId=e.read_shift(2),i.flags=e.read_shift(2),i.fStyle=i.flags>>2&1,t-=6,i.data=(a=e,i.fStyle,n=r,s={},t=a.read_shift(4),e=a.read_shift(4),r=a.read_shift(4),a=a.read_shift(2),s.patternType=Ua[r>>26],n.cellStyles&&(s.alc=7&t,s.fWrap=t>>3&1,s.alcV=t>>4&7,s.fJustLast=t>>7&1,s.trot=t>>8&255,s.cIndent=t>>16&15,s.fShrinkToFit=t>>20&1,s.iReadOrder=t>>22&2,s.fAtrNum=t>>26&1,s.fAtrFnt=t>>27&1,s.fAtrAlc=t>>28&1,s.fAtrBdr=t>>29&1,s.fAtrPat=t>>30&1,s.fAtrProt=t>>31&1,s.dgLeft=15&e,s.dgRight=e>>4&15,s.dgTop=e>>8&15,s.dgBottom=e>>12&15,s.icvLeft=e>>16&127,s.icvRight=e>>23&127,s.grbitDiag=e>>30&3,s.icvTop=127&r,s.icvBottom=r>>7&127,s.icvDiag=r>>14&127,s.dgDiag=r>>21&15,s.icvFore=127&a,s.icvBack=a>>7&127,s.fsxButton=a>>14&1),s),i}},225:{f:function(e,t){return 0===t||e.read_shift(2),1200}},226:{f:Rn},227:{},229:{f:function(e,t){for(var r=[],a=e.read_shift(2);a--;)r.push(Kn(e));return r}},233:{},235:{},236:{},237:{},239:{},240:{},241:{},242:{},244:{},245:{},246:{},247:{},248:{},249:{},251:{},252:{f:function(e,t){for(var r=e.l+t,t=e.read_shift(4),a=e.read_shift(4),n=[],s=0;s!=a&&e.l<r;++s)n.push(function(e){var t=f;f=1200;var r,a=e.read_shift(2),n=4&(c=e.read_shift(1)),s=8&c,i=1+(1&c),o=0,c={};return s&&(o=e.read_shift(2)),n&&(r=e.read_shift(4)),i=2==i?"dbcs-cont":"sbcs-cont",i=0===a?"":e.read_shift(a,i),s&&(e.l+=4*o),n&&(e.l+=r),c.t=i,s||(c.raw="<t>"+c.t+"</t>",c.r=c.t),f=t,c}(e));return n.Count=t,n.Unique=a,n}},253:{f:function(e){var t=$n(e);return t.isst=e.read_shift(4),t}},255:{f:function(e,t){var r={};return r.dsst=e.read_shift(2),e.l+=t-2,r}},256:{},259:{},290:{},311:{},312:{},315:{},317:{f:Dn},318:{},319:{},320:{},330:{},331:{},333:{},334:{},335:{},336:{},337:{},338:{},339:{},340:{},351:{},352:{f:On},353:{f:Rn},401:{},402:{},403:{},404:{},405:{},406:{},407:{},408:{},425:{},426:{},427:{},428:{},429:{},430:{f:function(e,t,r){var a=e.l+t,n=e.read_shift(2),t=e.read_shift(2);if(1025==(r.sbcch=t)||14849==t)return[t,n];if(t<1||255<t)throw new Error("Unexpected SupBook type: "+t);for(var r=Mn(e,t),s=[];a>e.l;)s.push(Un(e));return[t,n,r,s]}},431:{f:On},432:{},433:{},434:{},437:{},438:{f:function(t,r,e){var a=t.l,n="";try{t.l+=4;var s=(e.lastobj||{cmo:[0,0]}).cmo[1];-1==[0,5,7,11,12,14].indexOf(s)?t.l+=6:function(e){var t=e.read_shift(1);e.l++;var r=e.read_shift(2);e.l+=2}(t);var i=t.read_shift(2);t.read_shift(2),Nn(t);s=t.read_shift(2);t.l+=s;for(var o=1;o<t.lens.length-1;++o){if(t.l-a!=t.lens[o])throw new Error("TxO: bad continue record");var c=t[t.l];if((n+=Mn(t,t.lens[o+1]-t.lens[o]-1)).length>=(c?i:2*i))break}if(n.length!==i&&n.length!==2*i)throw new Error("cchText: "+i+" != "+n.length);return t.l=a+r,{t:n}}catch(e){return t.l=a+r,{t:n}}}},439:{f:On},440:{f:function(e,t){var r=Kn(e);return e.l+=16,[r,function(e,t){var r=e.l+t;if(2!==(c=e.read_shift(4)))throw new Error("Unrecognized streamVersion: "+c);t=e.read_shift(2),e.l+=2;var a,n,s,i,o,c="";16&t&&(a=zn(e,e.l)),128&t&&(n=zn(e,e.l)),257==(257&t)&&(s=zn(e,e.l)),1==(257&t)&&(l=Hn(e,e.l)),8&t&&(c=zn(e,e.l)),32&t&&(i=e.read_shift(16)),64&t&&(o=pn(e)),e.l=r;var l=n||s||l||"";return l&&c&&(l+="#"+c),l=l||"#"+c,l={Target:l=2&t&&"/"==l.charAt(0)&&"/"!=l.charAt(1)?"file://"+l:l},i&&(l.guid=i),o&&(l.time=o),a&&(l.Tooltip=a),l}(e,t-24)]}},441:{},442:{f:Un},443:{},444:{f:Nn},445:{},446:{},448:{f:Rn},449:{f:function(e){return e.read_shift(2),e.read_shift(4)},r:2},450:{f:Rn},512:{f:os},513:{f:ws},515:{f:function(e,t,r){return r.biffguess&&2==r.biff&&(r.biff=5),r=$n(e),e=xa(e),r.val=e,r}},516:{f:function(e,t,r){return r.biffguess&&2==r.biff&&(r.biff=5),e.l,t=$n(e),2==r.biff&&e.l++,r=Un(e,e.l,r),t.val=r,t}},517:{f:ls},519:{f:Es},520:{f:function(e){var t={};t.r=e.read_shift(2),t.c=e.read_shift(2),t.cnt=e.read_shift(2)-t.c;var r=e.read_shift(2);e.l+=4;var a=e.read_shift(1);return e.l+=3,7&a&&(t.level=7&a),32&a&&(t.hidden=!0),64&a&&(t.hpt=r/20),t}},523:{},545:{f:ms},549:{f:ss},566:{},574:{f:function(e,t,r){return r&&2<=r.biff&&r.biff<5?{}:{RTL:64&e.read_shift(2)}}},638:{f:function(e){var t=e.read_shift(2),r=e.read_shift(2),e=Yn(e);return{r:t,c:r,ixfe:e[0],rknum:e[1]}}},659:{},1048:{},1054:{f:function(e,t,r){return[e.read_shift(2),Bn(e,0,r)]}},1084:{},1212:{f:function(e,t,r){var a=qn(e);e.l++;var n=e.read_shift(1);return[function(e,t,r){var a,n=e.l+t,s=e.read_shift(2),i=Ic(e,s,r);if(65535==s)return[[],Pr(e,t-2)];t!==s+2&&(a=Oc(e,n-s-2,i,r));return[i,a]}(e,t-=8,r),n,a]}},2048:{f:function(e,t){return e.read_shift(2),[Kn(e),e.read_shift((t-10)/2,"dbcs-cont").replace(de,"")]}},2049:{},2050:{},2051:{},2052:{},2053:{},2054:{},2055:{},2056:{},2057:{f:rs},2058:{},2059:{},2060:{},2061:{},2062:{},2063:{},2064:{},2066:{},2067:{},2128:{},2129:{},2130:{},2131:{},2132:{},2133:{},2134:{},2135:{},2136:{},2137:{},2138:{},2146:{},2147:{r:12},2148:{},2149:{},2150:{},2151:{f:Rn},2152:{},2154:{},2155:{},2156:{},2161:{},2162:{},2164:{},2165:{},2166:{},2167:{},2168:{},2169:{},2170:{},2171:{},2172:{f:function(e){e.l+=2;var t={cxfs:0,crc:0};return t.cxfs=e.read_shift(2),t.crc=e.read_shift(4),t},r:12},2173:{f:function(e,t){e.l,e.l+=2,t=e.read_shift(2),e.l+=2;for(var r=e.read_shift(2),a=[];0<r--;)a.push(Ko(e,e.l));return{ixfe:t,ext:a}},r:12},2174:{},2175:{},2180:{},2181:{},2182:{},2183:{},2184:{},2185:{},2186:{},2187:{},2188:{f:On,r:12},2189:{},2190:{r:12},2191:{},2192:{},2194:{},2195:{},2196:{f:function(e,t,r){if(!(r.biff<8)){var a=e.read_shift(2),n=e.read_shift(2);return[Mn(e,a,r),Mn(e,n,r)]}e.l+=t},r:12},2197:{},2198:{f:function(e,t,r){var a=e.l+t;if(124226!==e.read_shift(4))if(r.cellStyles){var n,s=e.slice(e.l);e.l=a;try{n=st(s,{type:"array"})}catch(e){return}t=tt(n,"theme/theme/theme1.xml",!0);if(t)return $o(t,r)}else e.l=a},r:12},2199:{},2200:{},2201:{},2202:{f:function(e){return[0!==e.read_shift(4),0!==e.read_shift(4),e.read_shift(4)]},r:12},2203:{f:Rn},2204:{},2205:{},2206:{},2207:{},2211:{f:function(e){var t,r,a=(r=(t=e).read_shift(2),a=t.read_shift(2),t.l+=8,{type:r,flags:a});if(2211!=a.type)throw new Error("Invalid Future Record "+a.type);return 0!==e.read_shift(4)}},2212:{},2213:{},2214:{},2215:{},4097:{},4098:{},4099:{},4102:{},4103:{},4105:{},4106:{},4107:{},4108:{},4109:{},4116:{},4117:{},4118:{},4119:{},4120:{},4121:{},4122:{},4123:{},4124:{},4125:{},4126:{},4127:{},4128:{},4129:{},4130:{},4132:{},4133:{},4134:{f:Nn},4135:{},4146:{},4147:{},4148:{},4149:{},4154:{},4156:{},4157:{},4158:{},4159:{},4160:{},4161:{},4163:{},4164:{f:function(e,t,r){var a={area:!1};return 5!=r.biff?e.l+=t:(t=e.read_shift(1),e.l+=3,16&t&&(a.area=!0)),a}},4165:{},4166:{},4168:{},4170:{},4171:{},4174:{},4175:{},4176:{},4177:{},4187:{},4188:{f:function(e){for(var t=e.read_shift(2),r=[];0<t--;)r.push(jn(e));return r}},4189:{},4191:{},4192:{},4193:{},4194:{},4195:{},4196:{},4197:{},4198:{},4199:{},4200:{},0:{f:os},1:{},2:{f:function(e){var t=$n(e);return++e.l,e=e.read_shift(2),t.t="n",t.val=e,t}},3:{f:function(e){var t=$n(e);return++e.l,e=xa(e),t.t="n",t.val=e,t}},4:{f:function(e,t,r){r.biffguess&&5==r.biff&&(r.biff=2);var a=$n(e);return++e.l,r=Bn(e,0,r),a.t="str",a.val=r,a}},5:{f:ls},7:{f:function(e){var t=e.read_shift(1);return 0===t?(e.l++,""):e.read_shift(t,"sbcs-cont")}},8:{},9:{f:rs},11:{},22:{f:Nn},30:{f:is},31:{},32:{},33:{f:ms},36:{},37:{f:ss},50:{f:function(e,t){e.l+=6,e.l+=2,e.l+=1,e.l+=3,e.l+=1,e.l+=t-13}},62:{},52:{},67:{},68:{f:Nn},69:{},86:{},126:{},127:{f:function(e){var t=e.read_shift(2),r=e.read_shift(2),a=e.read_shift(4),r={fmt:t,env:r,len:a,data:e.slice(e.l,e.l+a)};return e.l+=a,r}},135:{},136:{},137:{},145:{},148:{},149:{},150:{},169:{},171:{},188:{},191:{},192:{},194:{},195:{},214:{f:function(e,t,r){var a=e.l+t,n=$n(e),t=e.read_shift(2),r=Mn(e,t,r);return e.l=a,n.t="str",n.val=r,n}},223:{},234:{},354:{},421:{},518:{f:Lc},521:{f:rs},536:{f:ds},547:{f:hs},561:{},579:{},1030:{f:Lc},1033:{f:rs},1091:{},2157:{},2163:{},2177:{},2240:{},2241:{},2242:{},2243:{},2244:{},2245:{},2246:{},2247:{},2248:{},2249:{},2250:{},2251:{},2262:{r:12},29282:{}};function Lf(e,t,r,a){var n=t;isNaN(n)||(t=a||(r||[]).length||0,(a=e.next(4)).write_shift(2,n),a.write_shift(2,t),0<t&&Er(r)&&e.push(r))}function Mf(e,t,r){return(e=e||Lr(7)).write_shift(2,t),e.write_shift(2,r),e.write_shift(2,0),e.write_shift(1,0),e}function Uf(e,t,r,a){if(null!=t.v)switch(t.t){case"d":case"n":var n="d"==t.t?De(He(t.v)):t.v;return void(n==(0|n)&&0<=n&&n<65536?Lf(e,2,(f=r,h=a,u=n,Mf(d=Lr(9),f,h),d.write_shift(2,u),d)):Lf(e,3,(u=r,d=a,n=n,Mf(l=Lr(15),u,d),l.write_shift(8,n,"f"),l)));case"b":case"e":return void Lf(e,5,(l=r,s=a,i=t.v,o=t.t,Mf(c=Lr(9),l,s),Pn(i,o||"b",c),c));case"s":case"str":return void Lf(e,4,(s=r,i=a,o=(t.v||"").slice(0,255),Mf(c=Lr(8+2*o.length),s,i),c.write_shift(1,o.length),c.write_shift(o.length,o,"sbcs"),c.l<c.length?c.slice(0,c.l):c))}var s,i,o,c,l,f,h,u,d;Lf(e,1,Mf(null,r,a))}function Bf(e,t){var r=t||{};null!=oe&&null==r.dense&&(r.dense=oe);for(var t=Ur(),a=0,n=0;n<e.SheetNames.length;++n)e.SheetNames[n]==r.sheet&&(a=n);if(0==a&&r.sheet&&e.SheetNames[0]!=r.sheet)throw new Error("Sheet not found: "+r.sheet);return Lf(t,4==r.biff?1033:3==r.biff?521:9,as(0,16,r)),function(e,t,r){var a,n,s=Array.isArray(t),i=Zr(t["!ref"]||"A1"),o=[];if(255<i.e.c||16383<i.e.r){if(r.WTF)throw new Error("Range "+(t["!ref"]||"A1")+" exceeds format limit A1:IV16384");i.e.c=Math.min(i.e.c,255),i.e.r=Math.min(i.e.c,16383),a=qr(i)}for(var c=i.s.r;c<=i.e.r;++c){n=jr(c);for(var l=i.s.c;l<=i.e.c;++l){c===i.s.r&&(o[l]=Xr(l)),a=o[l]+n;var f=s?(t[c]||[])[l]:t[a];f&&Uf(e,f,c,l)}}}(t,e.Sheets[e.SheetNames[a]],r),Lf(t,10),t.end()}function Wf(e,t,r){var a,n;Lf(e,49,(n=(a={sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"}).name||"Arial",(e=Lr((r=(e=r)&&5==e.biff)?15+n.length:16+2*n.length)).write_shift(2,20*(a.sz||12)),e.write_shift(4,0),e.write_shift(2,400),e.write_shift(4,0),e.write_shift(2,0),e.write_shift(1,n.length),r||e.write_shift(1,1),e.write_shift((r?1:2)*n.length,n,r?"sbcs":"utf16le"),e))}function Hf(i,o,c){o&&[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t,r,a,n,s=e[0];s<=e[1];++s)null!=o[s]&&Lf(i,1054,(t=s,r=o[s],n=void 0,a=(a=c)&&5==a.biff,(n=n||Lr(a?3+r.length:5+2*r.length)).write_shift(2,t),n.write_shift(a?1:2,r.length),a||n.write_shift(1,1),n.write_shift((a?1:2)*r.length,r,a?"sbcs":"utf16le"),null==(n=n.length>n.l?n.slice(0,n.l):n).l&&(n.l=n.length),n))})}function zf(e,t){for(var r=0;r<t["!links"].length;++r){var a=t["!links"][r];Lf(e,440,bs(a)),a[1].Tooltip&&Lf(e,2048,function(e){var t=e[1].Tooltip,r=Lr(10+2*(t.length+1));r.write_shift(2,2048),e=Yr(e[0]),r.write_shift(2,e.r),r.write_shift(2,e.r),r.write_shift(2,e.c),r.write_shift(2,e.c);for(var a=0;a<t.length;++a)r.write_shift(2,t.charCodeAt(a));return r.write_shift(2,0),r}(a))}delete t["!links"]}function Vf(a,e){var n;e&&(n=0,e.forEach(function(e,t){var r;++n<=256&&e&&Lf(a,125,(r=Zc(t,e),e=t,(t=Lr(12)).write_shift(2,e),t.write_shift(2,e),t.write_shift(2,256*r.width),t.write_shift(2,0),e=0,r.hidden&&(e|=1),t.write_shift(1,e),e=r.level||0,t.write_shift(1,e),t.write_shift(2,0),t))}))}function Gf(e,t,r,a,n){var s,i,o,c,l,f,h,u,d,p,m,g=16+el(n.cellXfs,t,n);if(null!=t.v||t.bf)if(t.bf)Lf(e,6,Mc(t,r,a,0,g));else switch(t.t){case"d":case"n":var b="d"==t.t?De(He(t.v)):t.v;Lf(e,515,(f=r,h=a,u=b,d=g,p=Lr(14),Xn(f,h,d,p),Aa(u,p),p));break;case"b":case"e":Lf(e,517,(b=r,f=a,h=t.v,d=g,u=t.t,p=Lr(8),Xn(b,f,d,p),Pn(h,u,p),p));break;case"s":case"str":n.bookSST?(m=qc(n.Strings,t.v,n.revStrings),Lf(e,253,(s=r,i=a,o=m,c=g,l=Lr(10),Xn(s,i,c,l),l.write_shift(4,o),l))):Lf(e,516,(m=r,s=a,i=(t.v||"").slice(0,255),c=g,o=Lr(+(l=!(o=n)||8==o.biff)+8+(1+l)*i.length),Xn(m,s,c,o),o.write_shift(2,i.length),l&&o.write_shift(1,1),o.write_shift((1+l)*i.length,i,l?"utf16le":"sbcs"),o));break;default:Lf(e,513,Xn(r,a,g))}else Lf(e,513,Xn(r,a,g))}function jf(e,t,r){var a,n,s=Ur(),i=r.SheetNames[e],o=r.Sheets[i]||{},c=(r||{}).Workbook||{},l=(c.Sheets||[])[e]||{},f=Array.isArray(o),h=8==t.biff,u=[],d=Zr(o["!ref"]||"A1"),p=h?65536:16384;if(255<d.e.c||d.e.r>=p){if(t.WTF)throw new Error("Range "+(o["!ref"]||"A1")+" exceeds format limit A1:IV16384");d.e.c=Math.min(d.e.c,255),d.e.r=Math.min(d.e.c,p-1)}Lf(s,2057,as(0,16,t)),Lf(s,13,Fn(1)),Lf(s,12,Fn(100)),Lf(s,15,In(!0)),Lf(s,17,In(!1)),Lf(s,16,Aa(.001)),Lf(s,95,In(!0)),Lf(s,42,In(!1)),Lf(s,43,In(!1)),Lf(s,130,Fn(1)),Lf(s,128,(r=[0,0],(e=Lr(8)).write_shift(4,0),e.write_shift(2,r[0]?r[0]+1:0),e.write_shift(2,r[1]?r[1]+1:0),e)),Lf(s,131,In(!1)),Lf(s,132,In(!1)),h&&Vf(s,o["!cols"]),Lf(s,512,(p=d,(r=Lr(2*(e=8!=(r=t).biff&&r.biff?2:4)+6)).write_shift(e,p.s.r),r.write_shift(e,p.e.r+1),r.write_shift(2,p.s.c),r.write_shift(2,p.e.c+1),r.write_shift(2,0),r)),h&&(o["!links"]=[]);for(var m=d.s.r;m<=d.e.r;++m){n=jr(m);for(var g=d.s.c;g<=d.e.c;++g){m===d.s.r&&(u[g]=Xr(g)),a=u[g]+n;var b=f?(o[m]||[])[g]:o[a];b&&(Gf(s,b,m,g,t),h&&b.l&&o["!links"].push([a,b.l]))}}var v,w,i=l.CodeName||l.name||i;return h&&Lf(s,574,(c=(c.Views||[])[0],w=Lr(18),v=1718,c&&c.RTL&&(v|=64),w.write_shift(2,v),w.write_shift(4,0),w.write_shift(4,64),w.write_shift(4,0),w.write_shift(4,0),w)),h&&(o["!merges"]||[]).length&&Lf(s,229,function(e){var t=Lr(2+8*e.length);t.write_shift(2,e.length);for(var r=0;r<e.length;++r)Jn(e[r],t);return t}(o["!merges"])),h&&zf(s,o),Lf(s,442,Wn(i)),h&&(v=s,w=o,(i=Lr(19)).write_shift(4,2151),i.write_shift(4,0),i.write_shift(4,0),i.write_shift(2,3),i.write_shift(1,1),i.write_shift(4,0),Lf(v,2151,i),(i=Lr(39)).write_shift(4,2152),i.write_shift(4,0),i.write_shift(4,0),i.write_shift(2,3),i.write_shift(1,0),i.write_shift(4,0),i.write_shift(2,1),i.write_shift(4,4),i.write_shift(2,0),Jn(Zr(w["!ref"]||"A1"),i),i.write_shift(4,4),Lf(v,2152,i)),Lf(s,10),s.end()}function $f(e,t,r){var a=Ur(),n=(e||{}).Workbook||{},s=n.Sheets||[],i=n.WBProps||{},o=8==r.biff,n=5==r.biff;Lf(a,2057,as(0,5,r)),"xla"==r.bookType&&Lf(a,135),Lf(a,225,o?Fn(1200):null),Lf(a,193,function(e,t){t=t||Lr(e);for(var r=0;r<e;++r)t.write_shift(1,0);return t}(2)),n&&Lf(a,191),n&&Lf(a,192),Lf(a,226),Lf(a,92,function(e){var t=!e||8==e.biff,r=Lr(t?112:54);for(r.write_shift(8==e.biff?2:1,7),t&&r.write_shift(1,0),r.write_shift(4,859007059),r.write_shift(4,5458548|(t?0:536870912));r.l<r.length;)r.write_shift(1,t?0:32);return r}(r)),Lf(a,66,Fn(o?1200:1252)),o&&Lf(a,353,Fn(0)),o&&Lf(a,448),Lf(a,317,function(e){for(var t=Lr(2*e),r=0;r<e;++r)t.write_shift(2,r+1);return t}(e.SheetNames.length)),o&&e.vbaraw&&Lf(a,211),o&&e.vbaraw&&Lf(a,442,Wn(i.CodeName||"ThisWorkbook")),Lf(a,156,Fn(17)),Lf(a,25,In(!1)),Lf(a,18,In(!1)),Lf(a,19,Fn(0)),o&&Lf(a,431,In(!1)),o&&Lf(a,444,Fn(0)),Lf(a,61,((n=Lr(18)).write_shift(2,0),n.write_shift(2,0),n.write_shift(2,29280),n.write_shift(2,17600),n.write_shift(2,56),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,1),n.write_shift(2,500),n)),Lf(a,64,In(!1)),Lf(a,141,Fn(0)),Lf(a,34,In("true"==((i=e).Workbook&&i.Workbook.WBProps&&Rt(i.Workbook.WBProps.date1904)?"true":"false"))),Lf(a,14,In(!0)),o&&Lf(a,439,In(!1)),Lf(a,218,Fn(0)),Wf(a,0,r),Hf(a,e.SSF,r),function(t,r){for(var e=0;e<16;++e)Lf(t,224,cs({numFmtId:0,style:!0},0,r));r.cellXfs.forEach(function(e){Lf(t,224,cs(e,0,r))})}(a,r),o&&Lf(a,352,In(!1));n=a.end(),i=Ur();o&&Lf(i,140,((g=g||Lr(4)).write_shift(2,1),g.write_shift(2,1),g)),o&&r.Strings&&function(e,t,r){var a=void 0||(r||[]).length||0;if(a<=8224)return Lf(e,t,r,a);if(!isNaN(t)){for(var n=r.parts||[],s=0,i=0,o=0;o+(n[s]||8224)<=8224;)o+=n[s]||8224,s++;var c=e.next(4);for(c.write_shift(2,t),c.write_shift(2,o),e.push(r.slice(i,i+o)),i+=o;i<a;){for((c=e.next(4)).write_shift(2,60),o=0;o+(n[s]||8224)<=8224;)o+=n[s]||8224,s++;c.write_shift(2,o),e.push(r.slice(i,i+o)),i+=o}}}(i,252,ns(r.Strings)),Lf(i,10);for(var a=i.end(),c=Ur(),l=0,f=0,f=0;f<e.SheetNames.length;++f)l+=(o?12:11)+(o?2:1)*e.SheetNames[f].length;var h,u,d,p,m=n.length+l+a.length;for(f=0;f<e.SheetNames.length;++f)Lf(c,133,(h={pos:m,hs:(s[f]||{}).Hidden||0,dt:0,name:e.SheetNames[f]},p=d=void 0,d=!(u=r)||8<=u.biff?2:1,(p=Lr(8+d*h.name.length)).write_shift(4,h.pos),p.write_shift(1,h.hs||0),p.write_shift(1,h.dt),p.write_shift(1,h.name.length),8<=u.biff&&p.write_shift(1,1),p.write_shift(d*h.name.length,h.name,u.biff<8?"sbcs":"utf16le"),(u=p.slice(0,p.l)).l=p.l,u)),m+=t[f].length;var g=c.end();if(l!=g.length)throw new Error("BS8 "+l+" != "+g.length);i=[];return n.length&&i.push(n),g.length&&i.push(g),a.length&&i.push(a),ue(i)}function Xf(e,t){for(var r=0;r<=e.SheetNames.length;++r){var a=e.Sheets[e.SheetNames[r]];a&&a["!ref"]&&255<Jr(a["!ref"]).e.c&&"undefined"!=typeof console&&console.error&&console.error("Worksheet '"+e.SheetNames[r]+"' extends beyond column IV (255).  Data may be lost.")}var n=t||{};switch(n.biff||2){case 8:case 5:return function(e,t){var r=t||{},a=[];e&&!e.SSF&&(e.SSF=Ve(me)),e&&e.SSF&&(Ee(),Te(e.SSF),r.revssf=Ne(e.SSF),r.revssf[e.SSF[65535]]=0,r.ssf=e.SSF),r.Strings=[],r.Strings.Count=0,r.Strings.Unique=0,Uh(r),r.cellXfs=[],el(r.cellXfs,{},{revssf:{General:0}}),e.Props||(e.Props={});for(var n=0;n<e.SheetNames.length;++n)a[a.length]=jf(n,r,e);return a.unshift($f(e,a,r)),ue(a)}(e,t);case 4:case 3:case 2:return Bf(e,t)}throw new Error("invalid type "+n.bookType+" for BIFF")}function Yf(e,t){var r=t||{};null!=oe&&null==r.dense&&(r.dense=oe);var a=r.dense?[]:{},n=(e=e.replace(/<!--.*?-->/g,"")).match(/<table/i);if(!n)throw new Error("Invalid HTML: could not find <table>");for(var s,t=e.match(/<\/table/i),i=n.index,o=t&&t.index||e.length,c=Ke(e.slice(i,o),/(:?<tr[^>]*>)/i,"<tr>"),l=-1,f=0,h={s:{r:1e7,c:1e7},e:{r:0,c:0}},u=[],i=0;i<c.length;++i){var d=c[i].trim(),p=d.slice(0,3).toLowerCase();if("<tr"!=p){if("<td"==p||"<th"==p)for(var m=d.split(/<\/t[dh]>/i),o=0;o<m.length;++o){var g=m[o].trim();if(g.match(/<t[dh]/i)){for(var b=g,v=0;"<"==b.charAt(0)&&-1<(v=b.indexOf(">"));)b=b.slice(v+1);for(var w=0;w<u.length;++w){var T=u[w];T.s.c==f&&T.s.r<l&&l<=T.e.r&&(f=T.e.c+1,w=-1)}var E=dt(g.slice(0,g.indexOf(">"))),k=E.colspan?+E.colspan:1;(1<(s=+E.rowspan)||1<k)&&u.push({s:{r:l,c:f},e:{r:l+(s||1)-1,c:f+k-1}});g=E.t||E["data-t"]||"";b.length&&(b=Wt(b),h.s.r>l&&(h.s.r=l),h.e.r<l&&(h.e.r=l),h.s.c>f&&(h.s.c=f),h.e.c<f&&(h.e.c=f),b.length&&(E={t:"s",v:b},r.raw||!b.trim().length||"s"==g||("TRUE"===b?E={t:"b",v:!0}:"FALSE"===b?E={t:"b",v:!1}:isNaN(je(b))?isNaN(Xe(b).getDate())||(E={t:"d",v:He(b)},(E=!r.cellDates?{t:"n",v:De(E.v)}:E).z=r.dateNF||me[14]):E={t:"n",v:je(b)}),r.dense?(a[l]||(a[l]=[]),a[l][f]=E):a[Kr({r:l,c:f})]=E)),f+=k}}}else{if(++l,r.sheetRows&&r.sheetRows<=l){--l;break}f=0}}return a["!ref"]=qr(h),u.length&&(a["!merges"]=u),a}function Kf(e,t,r,a){for(var n=e["!merges"]||[],s=[],i=t.s.c;i<=t.e.c;++i){for(var o,c,l,f,h=0,u=0,d=0;d<n.length;++d)if(!(n[d].s.r>r||n[d].s.c>i||n[d].e.r<r||n[d].e.c<i)){if(n[d].s.r<r||n[d].s.c<i){h=-1;break}h=n[d].e.r-n[d].s.r+1,u=n[d].e.c-n[d].s.c+1;break}h<0||(o=Kr({r:r,c:i}),l=(c=a.dense?(e[r]||[])[i]:e[o])&&null!=c.v&&(c.h||_t(c.w||(ea(c),c.w)||""))||"",f={},1<h&&(f.rowspan=h),1<u&&(f.colspan=u),a.editable?l='<span contenteditable="true">'+l+"</span>":c&&(f["data-t"]=c&&c.t||"z",null!=c.v&&(f["data-v"]=c.v),null!=c.z&&(f["data-z"]=c.z),c.l&&"#"!=(c.l.Target||"#").charAt(0)&&(l='<a href="'+c.l.Target+'">'+l+"</a>")),f.id=(a.id||"sjs")+"-"+o,s.push(Yt("td",l,f)))}return"<tr>"+s.join("")+"</tr>"}var Jf='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>',qf="</body></html>";function Zf(e,t,r){return[].join("")+"<table"+(r&&r.id?' id="'+r.id+'"':"")+">"}function Qf(e,t){var r=t||{},a=null!=r.header?r.header:Jf,t=null!=r.footer?r.footer:qf,n=[a],s=Jr(e["!ref"]);r.dense=Array.isArray(e),n.push(Zf(0,0,r));for(var i=s.s.r;i<=s.e.r;++i)n.push(Kf(e,s,i,r));return n.push("</table>"+t),n.join("")}function eh(e,t,r){var a=r||{};null!=oe&&(a.dense=oe);var n=0,s=0;null!=a.origin&&("number"==typeof a.origin?n=a.origin:(n=(r="string"==typeof a.origin?Yr(a.origin):a.origin).r,s=r.c));var i=t.getElementsByTagName("tr"),o=Math.min(a.sheetRows||1e7,i.length),c={s:{r:0,c:0},e:{r:n,c:s}};e["!ref"]&&(t=Jr(e["!ref"]),c.s.r=Math.min(c.s.r,t.s.r),c.s.c=Math.min(c.s.c,t.s.c),c.e.r=Math.max(c.e.r,t.e.r),c.e.c=Math.max(c.e.c,t.e.c),-1==n&&(c.e.r=n=t.e.r+1));var l,f,h=[],u=0,d=e["!rows"]||(e["!rows"]=[]),p=0,m=0,g=0,b=0;for(e["!cols"]||(e["!cols"]=[]);p<i.length&&m<o;++p){var v=i[p];if(rh(v)){if(a.display)continue;d[m]={hidden:!0}}for(var w=v.children,g=b=0;g<w.length;++g){var T=w[g];if(!a.display||!rh(T)){for(var E=T.hasAttribute("data-v")?T.getAttribute("data-v"):T.hasAttribute("v")?T.getAttribute("v"):Wt(T.innerHTML),k=T.getAttribute("data-z")||T.getAttribute("z"),u=0;u<h.length;++u){var y=h[u];y.s.c==b+s&&y.s.r<m+n&&m+n<=y.e.r&&(b=y.e.c+1-s,u=-1)}f=+T.getAttribute("colspan")||1,(1<(l=+T.getAttribute("rowspan")||1)||1<f)&&h.push({s:{r:m+n,c:b+s},e:{r:m+n+(l||1)-1,c:b+s+(f||1)-1}});var S={t:"s",v:E},_=T.getAttribute("data-t")||T.getAttribute("t")||"";null!=E&&(0==E.length?S.t=_||"z":a.raw||0==E.trim().length||"s"==_||("TRUE"===E?S={t:"b",v:!0}:"FALSE"===E?S={t:"b",v:!1}:isNaN(je(E))?isNaN(Xe(E).getDate())||(S={t:"d",v:He(E)},(S=!a.cellDates?{t:"n",v:De(S.v)}:S).z=a.dateNF||me[14]):S={t:"n",v:je(E)})),void 0===S.z&&null!=k&&(S.z=k);var x="",A=T.getElementsByTagName("A");if(A&&A.length)for(var C=0;C<A.length&&(!A[C].hasAttribute("href")||"#"==(x=A[C].getAttribute("href")).charAt(0));++C);x&&"#"!=x.charAt(0)&&(S.l={Target:x}),a.dense?(e[m+n]||(e[m+n]=[]),e[m+n][b+s]=S):e[Kr({c:b+s,r:m+n})]=S,c.e.c<b+s&&(c.e.c=b+s),b+=f}}++m}return h.length&&(e["!merges"]=(e["!merges"]||[]).concat(h)),c.e.r=Math.max(c.e.r,m-1+n),e["!ref"]=qr(c),o<=m&&(e["!fullref"]=qr((c.e.r=i.length-p+m-1+n,c))),e}function th(e,t){return eh((t||{}).dense?[]:{},e,t)}function rh(e){var t,r="",t=(t=e).ownerDocument.defaultView&&"function"==typeof t.ownerDocument.defaultView.getComputedStyle?t.ownerDocument.defaultView.getComputedStyle:"function"==typeof getComputedStyle?getComputedStyle:null;return"none"===(r=(r=t?t(e).getPropertyValue("display"):r)||e.style&&e.style.display)}var ah={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm",'m\\"th quarter"']};function nh(e,t){var r=t||{};null!=oe&&null==r.dense&&(r.dense=oe);var a,n,s,i,o,c=Jt(e),l=[],f={name:""},h="",u=0,d={},p=[],m=r.dense?[]:{},g={value:""},b="",v=0,w=[],T=-1,E=-1,k={s:{r:1e6,c:1e7},e:{r:0,c:0}},y=0,S={},_=[],x={},A=[],C=1,R=1,O=[],I={Names:[]},N={},F=["",""],D=[],P={},L="",M=0,U=!1,B=!1,W=0;for(qt.lastIndex=0,c=c.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");i=qt.exec(c);)switch(i[3]=i[3].replace(/_.*$/,"")){case"table":case"工作表":"/"===i[1]?(k.e.c>=k.s.c&&k.e.r>=k.s.r?m["!ref"]=qr(k):m["!ref"]="A1:A1",0<r.sheetRows&&r.sheetRows<=k.e.r&&(m["!fullref"]=m["!ref"],k.e.r=r.sheetRows-1,m["!ref"]=qr(k)),_.length&&(m["!merges"]=_),A.length&&(m["!rows"]=A),s.name=s["名称"]||s.name,"undefined"!=typeof JSON&&JSON.stringify(s),p.push(s.name),d[s.name]=m,B=!1):"/"!==i[0].charAt(i[0].length-2)&&(s=dt(i[0],!1),T=E=-1,k.s.r=k.s.c=1e7,k.e.r=k.e.c=0,m=r.dense?[]:{},_=[],A=[],B=!0);break;case"table-row-group":"/"===i[1]?--y:++y;break;case"table-row":case"行":if("/"===i[1]){T+=C,C=1;break}if((H=dt(i[0],!1))["行号"]?T=H["行号"]-1:-1==T&&(T=0),(C=+H["number-rows-repeated"]||1)<10)for(W=0;W<C;++W)0<y&&(A[T+W]={level:y});E=-1;break;case"covered-table-cell":"/"!==i[1]&&++E,r.sheetStubs&&(r.dense?(m[T]||(m[T]=[]),m[T][E]={t:"z"}):m[Kr({r:T,c:E})]={t:"z"}),b="",w=[];break;case"table-cell":case"数据":if("/"===i[0].charAt(i[0].length-2))++E,g=dt(i[0],!1),R=parseInt(g["number-columns-repeated"]||"1",10),o={t:"z",v:null},g.formula&&0!=r.cellFormula&&(o.f=$c(wt(g.formula))),"string"==(g["数据类型"]||g["value-type"])&&(o.t="s",o.v=wt(g["string-value"]||""),r.dense?(m[T]||(m[T]=[]),m[T][E]=o):m[Kr({r:T,c:E})]=o),E+=R-1;else if("/"!==i[1]){b="",v=0,w=[],R=1;var H=C?T+C-1:T;if(++E>k.e.c&&(k.e.c=E),E<k.s.c&&(k.s.c=E),T<k.s.r&&(k.s.r=T),H>k.e.r&&(k.e.r=H),D=[],P={},o={t:(g=dt(i[0],!1))["数据类型"]||g["value-type"],v:null},r.cellFormula)if(g.formula&&(g.formula=wt(g.formula)),g["number-matrix-columns-spanned"]&&g["number-matrix-rows-spanned"]&&(x={s:{r:T,c:E},e:{r:T+(parseInt(g["number-matrix-rows-spanned"],10)||0)-1,c:E+(parseInt(g["number-matrix-columns-spanned"],10)||0)-1}},o.F=qr(x),O.push([x,o.F])),g.formula)o.f=$c(g.formula);else for(W=0;W<O.length;++W)T>=O[W][0].s.r&&T<=O[W][0].e.r&&E>=O[W][0].s.c&&E<=O[W][0].e.c&&(o.F=O[W][1]);switch((g["number-columns-spanned"]||g["number-rows-spanned"])&&(x={s:{r:T,c:E},e:{r:T+(parseInt(g["number-rows-spanned"],10)||0)-1,c:E+(parseInt(g["number-columns-spanned"],10)||0)-1}},_.push(x)),g["number-columns-repeated"]&&(R=parseInt(g["number-columns-repeated"],10)),o.t){case"boolean":o.t="b",o.v=Rt(g["boolean-value"]);break;case"float":case"percentage":case"currency":o.t="n",o.v=parseFloat(g.value);break;case"date":o.t="d",o.v=He(g["date-value"]),r.cellDates||(o.t="n",o.v=De(o.v)),o.z="m/d/yy";break;case"time":o.t="n",o.v=function(e){var t=0,r=0,a=!1,n=e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!n)throw new Error("|"+e+"| is not an ISO8601 Duration");for(var s=1;s!=n.length;++s)if(n[s]){switch(r=1,3<s&&(a=!0),n[s].slice(n[s].length-1)){case"Y":throw new Error("Unsupported ISO Duration Field: "+n[s].slice(n[s].length-1));case"D":r*=24;case"H":r*=60;case"M":if(!a)throw new Error("Unsupported ISO Duration Field: M");r*=60}t+=r*parseInt(n[s],10)}return t}(g["time-value"])/86400,r.cellDates&&(o.t="d",o.v=Me(o.v)),o.z="HH:MM:SS";break;case"number":o.t="n",o.v=parseFloat(g["数据数值"]);break;default:if("string"!==o.t&&"text"!==o.t&&o.t)throw new Error("Unsupported value type "+o.t);o.t="s",null!=g["string-value"]&&(b=wt(g["string-value"]),w=[])}}else{if(U=!1,"s"===o.t&&(o.v=b||"",w.length&&(o.R=w),U=0==v),N.Target&&(o.l=N),0<D.length&&(o.c=D,D=[]),b&&!1!==r.cellText&&(o.w=b),U&&(o.t="z",delete o.v),(!U||r.sheetStubs)&&!(r.sheetRows&&r.sheetRows<=T))for(var z=0;z<C;++z){if(R=parseInt(g["number-columns-repeated"]||"1",10),r.dense)for(m[T+z]||(m[T+z]=[]),m[T+z][E]=0==z?o:Ve(o);0<--R;)m[T+z][E+R]=Ve(o);else for(m[Kr({r:T+z,c:E})]=o;0<--R;)m[Kr({r:T+z,c:E+R})]=Ve(o);k.e.c<=E&&(k.e.c=E)}E+=(R=parseInt(g["number-columns-repeated"]||"1",10))-1,R=0,o={},b="",w=[]}N={};break;case"document":case"document-content":case"电子表格文档":case"spreadsheet":case"主体":case"scripts":case"styles":case"font-face-decls":case"master-styles":if("/"===i[1]){if((a=l.pop())[0]!==i[3])throw"Bad state: "+a}else"/"!==i[0].charAt(i[0].length-2)&&l.push([i[3],!0]);break;case"annotation":if("/"===i[1]){if((a=l.pop())[0]!==i[3])throw"Bad state: "+a;P.t=b,w.length&&(P.R=w),P.a=L,D.push(P)}else"/"!==i[0].charAt(i[0].length-2)&&l.push([i[3],!1]);b=L="",v=M=0,w=[];break;case"creator":"/"===i[1]?L=c.slice(M,i.index):M=i.index+i[0].length;break;case"meta":case"元数据":case"settings":case"config-item-set":case"config-item-map-indexed":case"config-item-map-entry":case"config-item-map-named":case"shapes":case"frame":case"text-box":case"image":case"data-pilot-tables":case"list-style":case"form":case"dde-links":case"event-listeners":case"chart":if("/"===i[1]){if((a=l.pop())[0]!==i[3])throw"Bad state: "+a}else"/"!==i[0].charAt(i[0].length-2)&&l.push([i[3],!1]);b="",v=0,w=[];break;case"scientific-number":case"currency-symbol":case"currency-style":break;case"number-style":case"percentage-style":case"date-style":case"time-style":if("/"===i[1]){if(S[f.name]=h,(a=l.pop())[0]!==i[3])throw"Bad state: "+a}else"/"!==i[0].charAt(i[0].length-2)&&(h="",f=dt(i[0],!1),l.push([i[3],!0]));break;case"script":case"libraries":case"automatic-styles":break;case"default-style":case"page-layout":case"style":case"map":case"font-face":case"paragraph-properties":case"table-properties":case"table-column-properties":case"table-row-properties":case"table-cell-properties":break;case"number":switch(l[l.length-1][0]){case"time-style":case"date-style":n=dt(i[0],!1),h+=ah[i[3]]["long"===n.style?1:0]}break;case"fraction":break;case"day":case"month":case"year":case"era":case"day-of-week":case"week-of-year":case"quarter":case"hours":case"minutes":case"seconds":case"am-pm":switch(l[l.length-1][0]){case"time-style":case"date-style":n=dt(i[0],!1),h+=ah[i[3]]["long"===n.style?1:0]}break;case"boolean-style":case"boolean":case"text-style":break;case"text":if("/>"===i[0].slice(-2))break;if("/"===i[1])switch(l[l.length-1][0]){case"number-style":case"date-style":case"time-style":h+=c.slice(u,i.index)}else u=i.index+i[0].length;break;case"named-range":F=Xc((n=dt(i[0],!1))["cell-range-address"]);var V={Name:n.name,Ref:F[0]+"!"+F[1]};B&&(V.Sheet=p.length),I.Names.push(V);break;case"text-content":case"text-properties":case"embedded-text":break;case"body":case"电子表格":case"forms":case"table-column":case"table-header-rows":case"table-rows":case"table-column-group":case"table-header-columns":case"table-columns":case"null-date":case"graphic-properties":case"calculation-settings":case"named-expressions":case"label-range":case"label-ranges":case"named-expression":case"sort":case"sort-by":case"sort-groups":case"tab":case"line-break":case"span":break;case"p":case"文本串":if(-1<["master-styles"].indexOf(l[l.length-1][0]))break;"/"!==i[1]||g&&g["string-value"]?(dt(i[0],!1),v=i.index+i[0].length):(V=(V=c.slice(v,i.index)).replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function(e,t){return Array(parseInt(t,10)+1).join(" ")}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n"),V=[wt(V.replace(/<[^>]*>/g,""))],b=(0<b.length?b+"\n":"")+V[0]);break;case"s":break;case"database-range":if("/"===i[1])break;try{d[(F=Xc(dt(i[0])["target-range-address"]))[0]]["!autofilter"]={ref:F[1]}}catch(e){}break;case"date":case"object":break;case"title":case"标题":case"desc":case"binary-data":case"table-source":case"scenario":case"iteration":case"content-validations":case"content-validation":case"help-message":case"error-message":case"database-ranges":case"filter":case"filter-and":case"filter-or":case"filter-condition":case"list-level-style-bullet":case"list-level-style-number":case"list-level-properties":break;case"sender-firstname":case"sender-lastname":case"sender-initials":case"sender-title":case"sender-position":case"sender-email":case"sender-phone-private":case"sender-fax":case"sender-company":case"sender-phone-work":case"sender-street":case"sender-city":case"sender-postal-code":case"sender-country":case"sender-state-or-province":case"author-name":case"author-initials":case"chapter":case"file-name":case"template-name":case"sheet-name":case"event-listener":break;case"initial-creator":case"creation-date":case"print-date":case"generator":case"document-statistic":case"user-defined":case"editing-duration":case"editing-cycles":case"config-item":case"page-number":case"page-count":case"time":case"cell-range-source":case"detective":case"operation":case"highlighted-range":break;case"data-pilot-table":case"source-cell-range":case"source-service":case"data-pilot-field":case"data-pilot-level":case"data-pilot-subtotals":case"data-pilot-subtotal":case"data-pilot-members":case"data-pilot-member":case"data-pilot-display-info":case"data-pilot-sort-info":case"data-pilot-layout-info":case"data-pilot-field-reference":case"data-pilot-groups":case"data-pilot-group":case"data-pilot-group-member":case"rect":break;case"dde-connection-decls":case"dde-connection-decl":case"dde-link":case"dde-source":case"properties":case"property":break;case"a":if("/"!==i[1]){if(!(N=dt(i[0],!1)).href)break;N.Target=wt(N.href),delete N.href,"#"==N.Target.charAt(0)&&-1<N.Target.indexOf(".")?(F=Xc(N.Target.slice(1)),N.Target="#"+F[0]+"!"+F[1]):N.Target.match(/^\.\.[\\\/]/)&&(N.Target=N.Target.slice(3))}break;case"table-protection":case"data-pilot-grand-total":case"office-document-common-attrs":break;default:switch(i[2]){case"dc:":case"calcext:":case"loext:":case"ooo:":case"chartooo:":case"draw:":case"style:":case"chart:":case"form:":case"uof:":case"表:":case"字:":break;default:if(r.WTF)throw new Error(i)}}e={Sheets:d,SheetNames:p,Workbook:I};return r.bookSheets&&delete e.Sheets,e}function sh(e,t){t=t||{},Ze(e,"META-INF/manifest.xml")&&function(e,t){for(var r,a,n=Jt(e);r=qt.exec(n);)switch(r[3]){case"manifest":break;case"file-entry":if("/"==(a=dt(r[0],!1)).path&&a.type!==qa)throw new Error("This OpenDocument is not a spreadsheet");break;case"encryption-data":case"algorithm":case"start-key-generation":case"key-derivation":throw new Error("Unsupported ODS Encryption");default:if(t&&t.WTF)throw r}}(et(e,"META-INF/manifest.xml"),t);var r=tt(e,"content.xml");if(!r)throw new Error("Missing content.xml in ODS / UOF file");t=nh(Mt(r),t);return Ze(e,"meta.xml")&&(t.Props=rn(et(e,"meta.xml"))),t}function ih(e,t){return nh(e,t)}var oh=function(){var e=["<office:master-styles>",'<style:master-page style:name="mp1" style:page-layout-name="mp1">',"<style:header/>",'<style:header-left style:display="false"/>',"<style:footer/>",'<style:footer-left style:display="false"/>',"</style:master-page>","</office:master-styles>"].join(""),t="<office:document-styles "+Xt({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","office:version":"1.2"})+">"+e+"</office:document-styles>";return function(){return ot+t}}(),ch=function(){function i(e,t,r){var a=[];a.push('      <table:table table:name="'+kt(t.SheetNames[r])+'" table:style-name="ta1">\n');var n=0,s=0,i=Jr(e["!ref"]||"A1"),o=e["!merges"]||[],c=0,l=Array.isArray(e);if(e["!cols"])for(s=0;s<=i.e.c;++s)a.push("        <table:table-column"+(e["!cols"][s]?' table:style-name="co'+e["!cols"][s].ods+'"':"")+"></table:table-column>\n");for(var f="",h=e["!rows"]||[],n=0;n<i.s.r;++n)f=h[n]?' table:style-name="ro'+h[n].ods+'"':"",a.push("        <table:table-row"+f+"></table:table-row>\n");for(;n<=i.e.r;++n){for(f=h[n]?' table:style-name="ro'+h[n].ods+'"':"",a.push("        <table:table-row"+f+">\n"),s=0;s<i.s.c;++s)a.push(v);for(;s<=i.e.c;++s){for(var u=!1,d={},p="",c=0;c!=o.length;++c)if(!(o[c].s.c>s||o[c].s.r>n||o[c].e.c<s||o[c].e.r<n)){o[c].s.c==s&&o[c].s.r==n||(u=!0),d["table:number-columns-spanned"]=o[c].e.c-o[c].s.c+1,d["table:number-rows-spanned"]=o[c].e.r-o[c].s.r+1;break}if(u)a.push("          <table:covered-table-cell/>\n");else{var m=Kr({r:n,c:s}),g=l?(e[n]||[])[s]:e[m];if(g&&g.f&&(d["table:formula"]=kt(("of:="+g.f.replace(lc,"$1[.$2$3$4$5]").replace(/\]:\[/g,":")).replace(/;/g,"|").replace(/,/g,";")),g.F&&g.F.slice(0,m.length)==m&&(b=Jr(g.F),d["table:number-matrix-columns-spanned"]=b.e.c-b.s.c+1,d["table:number-matrix-rows-spanned"]=b.e.r-b.s.r+1)),g){switch(g.t){case"b":p=g.v?"TRUE":"FALSE",d["office:value-type"]="boolean",d["office:boolean-value"]=g.v?"true":"false";break;case"n":p=g.w||String(g.v||0),d["office:value-type"]="float",d["office:value"]=g.v||0;break;case"s":case"str":p=null==g.v?"":g.v,d["office:value-type"]="string";break;case"d":p=g.w||He(g.v).toISOString(),d["office:value-type"]="date",d["office:date-value"]=He(g.v).toISOString(),d["table:style-name"]="ce1";break;default:a.push(v);continue}var b,m=kt(p).replace(/  +/g,function(e){return'<text:s text:c="'+e.length+'"/>'}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>");g.l&&g.l.Target&&(m=Yt("text:a",m,{"xlink:href":(b="#"!=(b="#"==(b=g.l.Target).charAt(0)?"#"+b.slice(1).replace(/\./,"!"):b).charAt(0)&&!b.match(/^\w+:/)?"../"+b:b).replace(/&/g,"&amp;")})),a.push("          "+Yt("table:table-cell",Yt("text:p",m,{}),d)+"\n")}else a.push(v)}}a.push("        </table:table-row>\n")}return a.push("      </table:table>\n"),a.join("")}var v="          <table:table-cell />\n";return function(e,t){var r=[ot],a=Xt({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:meta":"urn:oasis:names:tc:opendocument:xmlns:meta:1.0","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:presentation":"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:chart":"urn:oasis:names:tc:opendocument:xmlns:chart:1.0","xmlns:dr3d":"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0","xmlns:math":"http://www.w3.org/1998/Math/MathML","xmlns:form":"urn:oasis:names:tc:opendocument:xmlns:form:1.0","xmlns:script":"urn:oasis:names:tc:opendocument:xmlns:script:1.0","xmlns:ooo":"http://openoffice.org/2004/office","xmlns:ooow":"http://openoffice.org/2004/writer","xmlns:oooc":"http://openoffice.org/2004/calc","xmlns:dom":"http://www.w3.org/2001/xml-events","xmlns:xforms":"http://www.w3.org/2002/xforms","xmlns:xsd":"http://www.w3.org/2001/XMLSchema","xmlns:xsi":"http://www.w3.org/2001/XMLSchema-instance","xmlns:sheet":"urn:oasis:names:tc:opendocument:sh33tjs:1.0","xmlns:rpt":"http://openoffice.org/2005/report","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","xmlns:xhtml":"http://www.w3.org/1999/xhtml","xmlns:grddl":"http://www.w3.org/2003/g/data-view#","xmlns:tableooo":"http://openoffice.org/2009/table","xmlns:drawooo":"http://openoffice.org/2010/draw","xmlns:calcext":"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0","xmlns:loext":"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0","xmlns:field":"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0","xmlns:formx":"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0","xmlns:css3t":"http://www.w3.org/TR/css3-text/","office:version":"1.2"}),n=Xt({"xmlns:config":"urn:oasis:names:tc:opendocument:xmlns:config:1.0","office:mimetype":"application/vnd.oasis.opendocument.spreadsheet"});"fods"==t.bookType?(r.push("<office:document"+a+n+">\n"),r.push(Qa().replace(/office:document-meta/g,"office:meta"))):r.push("<office:document-content"+a+">\n"),function(a,t){a.push(" <office:automatic-styles>\n"),a.push('  <number:date-style style:name="N37" number:automatic-order="true">\n'),a.push('   <number:month number:style="long"/>\n'),a.push("   <number:text>/</number:text>\n"),a.push('   <number:day number:style="long"/>\n'),a.push("   <number:text>/</number:text>\n"),a.push("   <number:year/>\n"),a.push("  </number:date-style>\n");var n=0;t.SheetNames.map(function(e){return t.Sheets[e]}).forEach(function(e){if(e&&e["!cols"])for(var t=0;t<e["!cols"].length;++t)if(e["!cols"][t]){var r=e["!cols"][t];if(null==r.width&&null==r.wpx&&null==r.wch)continue;fo(r),r.ods=n;r=e["!cols"][t].wpx+"px";a.push('  <style:style style:name="co'+n+'" style:family="table-column">\n'),a.push('   <style:table-column-properties fo:break-before="auto" style:column-width="'+r+'"/>\n'),a.push("  </style:style>\n"),++n}});var s=0;t.SheetNames.map(function(e){return t.Sheets[e]}).forEach(function(e){if(e&&e["!rows"])for(var t,r=0;r<e["!rows"].length;++r)e["!rows"][r]&&(e["!rows"][r].ods=s,t=e["!rows"][r].hpx+"px",a.push('  <style:style style:name="ro'+s+'" style:family="table-row">\n'),a.push('   <style:table-row-properties fo:break-before="auto" style:row-height="'+t+'"/>\n'),a.push("  </style:style>\n"),++s)}),a.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n'),a.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n'),a.push("  </style:style>\n"),a.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n'),a.push(" </office:automatic-styles>\n")}(r,e),r.push("  <office:body>\n"),r.push("    <office:spreadsheet>\n");for(var s=0;s!=e.SheetNames.length;++s)r.push(i(e.Sheets[e.SheetNames[s]],e,s));return r.push("    </office:spreadsheet>\n"),r.push("  </office:body>\n"),"fods"==t.bookType?r.push("</office:document>"):r.push("</office:document-content>"),r.join("")}}();function lh(e,t){if("fods"==t.bookType)return ch(e,t);var r=nt(),a=[],n=[];return at(r,"mimetype","application/vnd.oasis.opendocument.spreadsheet"),at(r,"content.xml",ch(e,t)),a.push(["content.xml","text/xml"]),n.push(["content.xml","ContentFile"]),at(r,"styles.xml",oh(e,t)),a.push(["styles.xml","text/xml"]),n.push(["styles.xml","StylesFile"]),at(r,"meta.xml",ot+Qa()),a.push(["meta.xml","text/xml"]),n.push(["meta.xml","MetadataFile"]),at(r,"manifest.rdf",function(e){var t=[ot];t.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var r=0;r!=e.length;++r)t.push(Za(e[r][0],e[r][1])),t.push(['  <rdf:Description rdf:about="">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+e[r][0]+'"/>\n',"  </rdf:Description>\n"].join(""));return t.push(Za("","Document","pkg")),t.push("</rdf:RDF>"),t.join("")}(n)),a.push(["manifest.rdf","application/rdf+xml"]),at(r,"META-INF/manifest.xml",function(e){var t=[ot];t.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n'),t.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var r=0;r<e.length;++r)t.push('  <manifest:file-entry manifest:full-path="'+e[r][0]+'" manifest:media-type="'+e[r][1]+'"/>\n');return t.push("</manifest:manifest>"),t.join("")}(a)),r}function fh(e){return new DataView(e.buffer,e.byteOffset,e.byteLength)}function hh(e){return"undefined"!=typeof TextDecoder?(new TextDecoder).decode(e):Mt(i(e))}function uh(e){return"undefined"!=typeof TextEncoder?(new TextEncoder).encode(e):he(Ut(e))}function dh(e){var t=e.reduce(function(e,t){return e+t.length},0),r=new Uint8Array(t),a=0;return e.forEach(function(e){r.set(e,a),a+=e.length}),r}function ph(e){return 16843009*((e=(858993459&(e-=e>>1&1431655765))+(e>>2&858993459))+(e>>4)&252645135)>>>24}function mh(e,t){var r=t?t[0]:0,a=127&e[r];return 128<=e[r++]&&(a|=(127&e[r])<<7,e[r++]<128||(a|=(127&e[r])<<14,e[r++]<128||(a|=(127&e[r])<<21,e[r++]<128||(a+=(127&e[r])*Math.pow(2,28),++r,e[r++]<128||(a+=(127&e[r])*Math.pow(2,35),++r,e[r++]<128||(a+=(127&e[r])*Math.pow(2,42),++r,e[r++])))))),t&&(t[0]=r),a}function gh(e){var t=new Uint8Array(7);t[0]=127&e;var r=1;return 127<e&&(t[r-1]|=128,t[r]=e>>7&127,++r,e<=16383||(t[r-1]|=128,t[r]=e>>14&127,++r,e<=2097151||(t[r-1]|=128,t[r]=e>>21&127,++r,e<=268435455||(t[r-1]|=128,t[r]=e/256>>>21&127,++r,e<=34359738367||(t[r-1]|=128,t[r]=e/65536>>>21&127,++r,e<=4398046511103||(t[r-1]|=128,t[r]=e/16777216>>>21&127,++r)))))),t.slice(0,r)}function bh(e){var t=0,r=127&e[0];return 128<=e[t++]&&(r|=(127&e[1])<<7,e[t++]<128||(r|=(127&e[2])<<14,e[t++]<128||(r|=(127&e[3])<<21,e[+t]<128||(r|=(127&e[4])<<28)))),r}function vh(e){for(var t=[],r=[0];r[0]<e.length;){var a,n=r[0],s=mh(e,r),i=7&s,o=0;if(0==(s=Math.floor(s/8)))break;switch(i){case 0:for(var c=r[0];128<=e[r[0]++];);a=e.slice(c,r[0]);break;case 5:o=4,a=e.slice(r[0],r[0]+o),r[0]+=o;break;case 1:o=8,a=e.slice(r[0],r[0]+o),r[0]+=o;break;case 2:o=mh(e,r),a=e.slice(r[0],r[0]+o),r[0]+=o;break;case 3:case 4:default:throw new Error("PB Type ".concat(i," for Field ").concat(s," at offset ").concat(n))}var l={data:a,type:i};null==t[s]?t[s]=[l]:t[s].push(l)}return t}function wh(e){var r=[];return e.forEach(function(e,t){0!=t&&e.forEach(function(e){e.data&&(r.push(gh(8*t+e.type)),2==e.type&&r.push(gh(e.data.length)),r.push(e.data))})}),dh(r)}function Th(e,t){return(null==e?void 0:e.map(function(e){return t(e.data)}))||[]}function Eh(r){for(var e=[],a=[0];a[0]<r.length;){var t=mh(r,a),n=vh(r.slice(a[0],a[0]+t));a[0]+=t;var s={id:bh(n[1][0].data),messages:[]};n[2].forEach(function(e){var t=vh(e.data),e=bh(t[3][0].data);s.messages.push({meta:t,data:r.slice(a[0],a[0]+e)}),a[0]+=e}),null!=(t=n[3])&&t[0]&&(s.merge=0<bh(n[3][0].data)>>>0),e.push(s)}return e}function kh(e){var a=[];return e.forEach(function(e){var t=[[],[{data:gh(e.id),type:0}],[]];null!=e.merge&&(t[3]=[{data:gh(+!!e.merge),type:0}]);var r=[];e.messages.forEach(function(e){r.push(e.data),e.meta[3]=[{type:0,data:gh(e.data.length)}],t[2].push({data:wh(e.meta),type:2})});e=wh(t);a.push(gh(e.length)),a.push(e),r.forEach(function(e){return a.push(e)})}),dh(a)}function yh(e){for(var t=[],r=0;r<e.length;){var a=e[r++],n=e[r]|e[r+1]<<8|e[r+2]<<16;r+=3,t.push(function(e,t){if(0!=e)throw new Error("Unexpected Snappy chunk type ".concat(e));for(var r=[0],a=mh(t,r),n=[];r[0]<t.length;){var s=3&t[r[0]];if(0!=s){var i=0,o=0;if(1==s?(o=4+(t[r[0]]>>2&7),i=(224&t[r[0]++])<<3,i|=t[r[0]++]):(o=1+(t[r[0]++]>>2),2==s?(i=t[r[0]]|t[r[0]+1]<<8,r[0]+=2):(i=(t[r[0]]|t[r[0]+1]<<8|t[r[0]+2]<<16|t[r[0]+3]<<24)>>>0,r[0]+=4)),n=[dh(n)],0==i)throw new Error("Invalid offset 0");if(i>n[0].length)throw new Error("Invalid offset beyond length");if(i<=o)for(n.push(n[0].slice(-i)),o-=i;o>=n[n.length-1].length;)n.push(n[n.length-1]),o-=n[n.length-1].length;n.push(n[0].slice(-i,-i+o))}else{s=t[r[0]++]>>2;s<60?++s:(i=s-59,s=t[r[0]],1<i&&(s|=t[r[0]+1]<<8),2<i&&(s|=t[r[0]+2]<<16),3<i&&(s|=t[r[0]+3]<<24),s>>>=0,s++,r[0]+=i),n.push(t.slice(r[0],r[0]+s)),r[0]+=s}}if((e=dh(n)).length!=a)throw new Error("Unexpected length: ".concat(e.length," != ").concat(a));return e}(a,e.slice(r,r+n))),r+=n}if(r!==e.length)throw new Error("data is not a valid framed stream!");return dh(t)}function Sh(e){for(var t=[],r=0;r<e.length;){var a=Math.min(e.length-r,268435455),n=new Uint8Array(4);t.push(n);var s=gh(a),i=s.length;t.push(s),a<=60?(i++,t.push(new Uint8Array([a-1<<2]))):a<=256?(i+=2,t.push(new Uint8Array([240,a-1&255]))):a<=65536?(i+=3,t.push(new Uint8Array([244,a-1&255,a-1>>8&255]))):a<=16777216?(i+=4,t.push(new Uint8Array([248,a-1&255,a-1>>8&255,a-1>>16&255]))):a<=4294967296&&(i+=5,t.push(new Uint8Array([252,a-1&255,a-1>>8&255,a-1>>16&255,a-1>>>24&255]))),t.push(e.slice(r,r+a)),i+=a,n[0]=0,n[1]=255&i,n[2]=i>>8&255,n[3]=i>>16&255,r+=a}return dh(t)}function _h(e,t,r){var a,n=fh(e),s=n.getUint32(8,!0),i=12,o=-1,c=-1,l=NaN,f=NaN,h=new Date(2001,0,1);switch(1&s&&(l=function(e,t){for(var r=(127&e[t+15])<<7|e[t+14]>>1,a=1&e[t+14],n=t+13;t<=n;--n)a=256*a+e[n];return(128&e[t+15]?-a:a)*Math.pow(10,r-6176)}(e,i),i+=16),2&s&&(f=n.getFloat64(i,!0),i+=8),4&s&&(h.setTime(h.getTime()+1e3*n.getFloat64(i,!0)),i+=8),8&s&&(c=n.getUint32(i,!0),i+=4),16&s&&(o=n.getUint32(i,!0),i+=4),e[1]){case 0:break;case 2:a={t:"n",v:l};break;case 3:a={t:"s",v:t[c]};break;case 5:a={t:"d",v:h};break;case 6:a={t:"b",v:0<f};break;case 7:a={t:"n",v:f/86400};break;case 8:a={t:"e",v:0};break;case 9:if(!(-1<o))throw new Error("Unsupported cell type ".concat(e[1]," : ").concat(31&s," : ").concat(e.slice(0,4)));a={t:"s",v:r[o]};break;case 10:a={t:"n",v:l};break;default:throw new Error("Unsupported cell type ".concat(e[1]," : ").concat(31&s," : ").concat(e.slice(0,4)))}return a}function xh(e,t){var r=new Uint8Array(32),a=fh(r),n=12,s=0;switch(r[0]=5,e.t){case"n":r[1]=2,function(e,t,r){var a=Math.floor(0==r?0:Math.LOG10E*Math.log(Math.abs(r)))+6176-16,n=r/Math.pow(10,a-6176);e[t+15]|=a>>7,e[t+14]|=(127&a)<<1;for(var s=0;1<=n;++s,n/=256)e[t+s]=255&n;e[t+15]|=0<=r?0:128}(r,n,e.v),s|=1,n+=16;break;case"b":r[1]=6,a.setFloat64(n,e.v?1:0,!0),s|=2,n+=8;break;case"s":if(-1==t.indexOf(e.v))throw new Error("Value ".concat(e.v," missing from SST!"));r[1]=3,a.setUint32(n,t.indexOf(e.v),!0),s|=8,n+=4;break;default:throw"unsupported cell type "+e.t}return a.setUint32(8,s,!0),r.slice(0,n)}function Ah(e,t){var r=new Uint8Array(32),a=fh(r),n=12,s=0;switch(r[0]=3,e.t){case"n":r[2]=2,a.setFloat64(n,e.v,!0),s|=32,n+=8;break;case"b":r[2]=6,a.setFloat64(n,e.v?1:0,!0),s|=32,n+=8;break;case"s":if(-1==t.indexOf(e.v))throw new Error("Value ".concat(e.v," missing from SST!"));r[2]=3,a.setUint32(n,t.indexOf(e.v),!0),s|=16,n+=4;break;default:throw"unsupported cell type "+e.t}return a.setUint32(4,s,!0),r.slice(0,n)}function Ch(e,t,r){switch(e[0]){case 0:case 1:case 2:case 3:return function(e,t,r,a){var n,s=fh(e),i=s.getUint32(4,!0),o=(1<a?12:8)+4*ph(i&(1<a?3470:398)),c=-1,l=-1,f=NaN,h=new Date(2001,0,1);switch(512&i&&(c=s.getUint32(o,!0),o+=4),o+=4*ph(i&(1<a?12288:4096)),16&i&&(l=s.getUint32(o,!0),o+=4),32&i&&(f=s.getFloat64(o,!0),o+=8),64&i&&(h.setTime(h.getTime()+1e3*s.getFloat64(o,!0)),o+=8),e[2]){case 0:break;case 2:n={t:"n",v:f};break;case 3:n={t:"s",v:t[l]};break;case 5:n={t:"d",v:h};break;case 6:n={t:"b",v:0<f};break;case 7:n={t:"n",v:f/86400};break;case 8:n={t:"e",v:0};break;case 9:if(-1<c)n={t:"s",v:r[c]};else if(-1<l)n={t:"s",v:t[l]};else{if(isNaN(f))throw new Error("Unsupported cell type ".concat(e.slice(0,4)));n={t:"n",v:f}}break;default:throw new Error("Unsupported cell type ".concat(e.slice(0,4)))}return n}(e,t,r,e[0]);case 5:return _h(e,t,r);default:throw new Error("Unsupported payload version ".concat(e[0]))}}function Rh(e){return mh(vh(e)[1][0].data)}function Oh(s,e){var e=vh(e.data),i=bh(e[1][0].data),e=e[3],o=[];return(e||[]).forEach(function(e){var t=vh(e.data),r=bh(t[1][0].data)>>>0;switch(i){case 1:o[r]=hh(t[3][0].data);break;case 8:var a=vh(s[Rh(t[9][0].data)][0].data),n=s[Rh(a[1][0].data)][0],a=bh(n.meta[1][0].data);if(2001!=a)throw new Error("2000 unexpected reference to ".concat(a));n=vh(n.data);o[r]=n[3].map(function(e){return hh(e.data)}).join("")}}),o}function Ih(e,t){var r=vh(t.data),a=null!=(t=null==r?void 0:r[7])&&t[0]?0<bh(r[7][0].data)>>>0?1:0:-1,t=Th(r[5],function(e){return function(e,t){var r,a,n,s=vh(e),i=bh(s[1][0].data)>>>0,o=bh(s[2][0].data)>>>0,c=(null==(e=null==(c=s[8])?void 0:c[0])?void 0:e.data)&&0<bh(s[8][0].data)||!1;if(null!=(e=null==(e=s[7])?void 0:e[0])&&e.data&&0!=t)a=null==(r=null==(r=s[7])?void 0:r[0])?void 0:r.data,n=null==(r=null==(r=s[6])?void 0:r[0])?void 0:r.data;else{if(null==(r=null==(r=s[4])?void 0:r[0])||!r.data||1==t)throw"NUMBERS Tile missing ".concat(t," cell storage");a=null==(t=null==(t=s[4])?void 0:t[0])?void 0:t.data,n=null==(s=null==(s=s[3])?void 0:s[0])?void 0:s.data}for(var l=c?4:1,f=fh(a),h=[],u=0;u<a.length/2;++u){var d=f.getUint16(2*u,!0);d<65535&&h.push([u,d])}if(h.length!=o)throw"Expected ".concat(o," cells, found ").concat(h.length);for(var p=[],u=0;u<h.length-1;++u)p[h[u][0]]=n.subarray(h[u][1]*l,h[u+1][1]*l);return 1<=h.length&&(p[h[h.length-1][0]]=n.subarray(h[h.length-1][1]*l)),{R:i,cells:p}}(e,a)});return{nrows:bh(r[4][0].data)>>>0,data:t.reduce(function(r,a){return r[a.R]||(r[a.R]=[]),a.cells.forEach(function(e,t){if(r[a.R][t])throw new Error("Duplicate cell r=".concat(a.R," c=").concat(t));r[a.R][t]=e}),r},[])}}function Nh(e,t){var r={"!ref":"A1"},a=e[Rh(vh(t.data)[2][0].data)],t=bh(a[0].meta[1][0].data);if(6001!=t)throw new Error("6000 unexpected reference to ".concat(t));return function(r,e,a){var t=vh(e.data);if((e={s:{r:0,c:0},e:{r:0,c:0}}).e.r=(bh(t[6][0].data)>>>0)-1,e.e.r<0)throw new Error("Invalid row varint ".concat(t[6][0].data));if(e.e.c=(bh(t[7][0].data)>>>0)-1,e.e.c<0)throw new Error("Invalid col varint ".concat(t[7][0].data));a["!ref"]=qr(e);var e=vh(t[4][0].data),n=Oh(r,r[Rh(e[4][0].data)][0]),s=null!=(t=e[17])&&t[0]?Oh(r,r[Rh(e[17][0].data)][0]):[],t=vh(e[3][0].data),i=0;if(t[1].forEach(function(e){var t=vh(e.data),e=r[Rh(t[2][0].data)][0],t=bh(e.meta[1][0].data);if(6002!=t)throw new Error("6001 unexpected reference to ".concat(t));e=Ih(0,e);e.data.forEach(function(e,r){e.forEach(function(e,t){t=Kr({r:i+r,c:t}),e=Ch(e,n,s);e&&(a[t]=e)})}),i+=e.nrows}),null!=(t=e[13])&&t[0]){t=r[Rh(e[13][0].data)][0],e=bh(t.meta[1][0].data);if(6144!=e)throw new Error("Expected merge type 6144, found ".concat(e));a["!merges"]=null==(t=vh(t.data))?void 0:t[1].map(function(e){var t=vh(e.data),e=fh(vh(t[1][0].data)[1][0].data),t=fh(vh(t[2][0].data)[1][0].data);return{s:{r:e.getUint16(0,!0),c:e.getUint16(2,!0)},e:{r:e.getUint16(0,!0)+t.getUint16(0,!0)-1,c:e.getUint16(2,!0)+t.getUint16(2,!0)-1}}})}}(e,a[0],r),r}function Fh(s,e){var i=du(),t=vh(e.data);if(null!=(e=t[2])&&e[0])throw new Error("Keynote presentations are not supported");if(Th(t[1],Rh).forEach(function(e){s[e].forEach(function(e){var r,t,a,n;2==bh(e.meta[1][0].data)&&(t=s,e=vh((a=e).data),n={name:null!=(a=e[1])&&a[0]?hh(e[1][0].data):"",sheets:[]},Th(e[2],Rh).forEach(function(e){t[e].forEach(function(e){6e3==bh(e.meta[1][0].data)&&n.sheets.push(Nh(t,e))})}),(r=n).sheets.forEach(function(e,t){pu(i,e,0==t?r.name:r.name+"_"+t,!0)}))})}),0==i.SheetNames.length)throw new Error("Empty NUMBERS file");return i}function Dh(e){var a={},n=[];if(e.FullPaths.forEach(function(e){if(e.match(/\.iwpv2/))throw new Error("Unsupported password protection")}),e.FileIndex.forEach(function(t){if(t.name.match(/\.iwa$/)){var e,r;try{e=yh(t.content)}catch(e){return console.log("?? "+t.content.length+" "+(e.message||e))}try{r=Eh(e)}catch(e){return console.log("## "+(e.message||e))}r.forEach(function(e){a[e.id]=e.messages,n.push(e.id)})}}),!n.length)throw new Error("File has no messages");if(null!=(e=null==(e=null==(e=null==(e=null==a?void 0:a[1])?void 0:e[0])?void 0:e.meta)?void 0:e[1])&&e[0].data&&1e4==bh(a[1][0].meta[1][0].data))throw new Error("Pages documents are not supported");var t=(null==(e=null==(e=null==(e=null==(e=null==a?void 0:a[1])?void 0:e[0])?void 0:e.meta)?void 0:e[1])?void 0:e[0].data)&&1==bh(a[1][0].meta[1][0].data)&&a[1][0];if(t||n.forEach(function(e){a[e].forEach(function(e){if(1==bh(e.meta[1][0].data)>>>0){if(t)throw new Error("Document has multiple roots");t=e}})}),!t)throw new Error("Cannot find Document root");return Fh(a,t)}function Ph(e,t){if(!t||!t.numbers)throw new Error("Must pass a `numbers` option -- check the README");var r=e.Sheets[e.SheetNames[0]];1<e.SheetNames.length&&console.error("The Numbers writer currently writes only the first table");var f=Jr(r["!ref"]);f.s.r=f.s.c=0;var a=!1;9<f.e.c&&(a=!0,f.e.c=9),49<f.e.r&&(a=!0,f.e.r=49),a&&console.error("The Numbers writer is currently limited to ".concat(qr(f)));var h=iu(r,{range:f,header:1}),u=["~Sh33tJ5~"];h.forEach(function(e){return e.forEach(function(e){"string"==typeof e&&u.push(e)})});var d={},n=[],p=xe.read(t.numbers,{type:"base64"});p.FileIndex.map(function(e,t){return[e,p.FullPaths[t]]}).forEach(function(e){var t=e[0],r=e[1];2==t.type&&t.name.match(/\.iwa/)&&Eh(yh(t.content)).forEach(function(e){n.push(e.id),d[e.id]={deps:[],location:r,type:bh(e.messages[0].meta[1][0].data)}})}),n.sort(function(e,t){return e-t});var s=n.filter(function(e){return 1<e}).map(function(e){return[e,gh(e)]});p.FileIndex.map(function(e,t){return[e,p.FullPaths[t]]}).forEach(function(e){var t=e[0];e[1];t.name.match(/\.iwa/)&&Eh(yh(t.content)).forEach(function(r){r.messages.forEach(function(e){s.forEach(function(t){r.messages.some(function(e){return 11006!=bh(e.meta[1][0].data)&&function(e,t){e:for(var r=0;r<=e.length-t.length;++r){for(var a=0;a<t.length;++a)if(e[r+a]!=t[a])continue e;return!0}return!1}(e.data,t[1])})&&d[t[0]].deps.push(r.id)})})})});for(var i,o=xe.find(p,d[1].location),c=Eh(yh(o.content)),l=0;l<c.length;++l){var m=c[l];1==m.id&&(i=m)}for(var g=Rh(vh(i.messages[0].data)[1][0].data),c=Eh(yh((o=xe.find(p,d[g].location)).content)),l=0;l<c.length;++l)(m=c[l]).id==g&&(i=m);var b=vh(i.messages[0].data);for(b[1]=[{type:2,data:uh(e.SheetNames[0])}],i.messages[0].data=wh(b),o.content=Sh(kh(c)),o.size=o.content.length,g=Rh(b[2][0].data),c=Eh(yh((o=xe.find(p,d[g].location)).content)),l=0;l<c.length;++l)(m=c[l]).id==g&&(i=m);for(g=Rh(vh(i.messages[0].data)[2][0].data),c=Eh(yh((o=xe.find(p,d[g].location)).content)),l=0;l<c.length;++l)(m=c[l]).id==g&&(i=m);a=vh(i.messages[0].data);a[6][0].data=gh(f.e.r+1),a[7][0].data=gh(f.e.c+1);for(var v=Rh(a[46][0].data),t=xe.find(p,d[v].location),w=Eh(yh(t.content)),T=0;T<w.length&&w[T].id!=v;++T);if(w[T].id!=v)throw"Bad ColumnRowUIDMapArchive";var E=vh(w[T].messages[0].data);E[1]=[],E[2]=[],E[3]=[];for(var k=0;k<=f.e.c;++k)E[1].push({type:2,data:wh([[],[{type:0,data:gh(k+420690)}],[{type:0,data:gh(k+420690)}]])}),E[2].push({type:0,data:gh(k)}),E[3].push({type:0,data:gh(k)});E[4]=[],E[5]=[],E[6]=[];for(var y=0;y<=f.e.r;++y)E[4].push({type:2,data:wh([[],[{type:0,data:gh(y+726270)}],[{type:0,data:gh(y+726270)}]])}),E[5].push({type:0,data:gh(y)}),E[6].push({type:0,data:gh(y)});w[T].messages[0].data=wh(E),t.content=Sh(kh(w)),t.size=t.content.length,delete a[46];e=vh(a[4][0].data);e[7][0].data=gh(f.e.r+1);b=Rh(vh(e[1][0].data)[2][0].data);if((w=Eh(yh((t=xe.find(p,d[b].location)).content)))[0].id!=b)throw"Bad HeaderStorageBucket";for(var S=vh(w[0].messages[0].data),y=0;y<h.length;++y){var _=vh(S[2][0].data);_[1][0].data=gh(y),_[4][0].data=gh(h[y].length),S[2][y]={type:S[2][0].type,data:wh(_)}}w[0].messages[0].data=wh(S),t.content=Sh(kh(w)),t.size=t.content.length;var x,b=Rh(e[2][0].data);if((w=Eh(yh((t=xe.find(p,d[b].location)).content)))[0].id!=b)throw"Bad HeaderStorageBucket";for(S=vh(w[0].messages[0].data),k=0;k<=f.e.c;++k)(_=vh(S[2][0].data))[1][0].data=gh(k),_[4][0].data=gh(f.e.r+1),S[2][k]={type:S[2][0].type,data:wh(_)};w[0].messages[0].data=wh(S),t.content=Sh(kh(w)),t.size=t.content.length,r["!merges"]&&(O=function(e){for(var t=927262;t<2e6;++t)if(!d[t])return d[t]=e,t;throw new Error("Too many messages")}({type:6144,deps:[g],location:d[g].location}),x=[[],[]],r["!merges"].forEach(function(e){x[1].push({type:2,data:wh([[],[{type:2,data:wh([[],[{type:5,data:new Uint8Array(new Uint16Array([e.s.r,e.s.c]).buffer)}]])}],[{type:2,data:wh([[],[{type:5,data:new Uint8Array(new Uint16Array([e.e.r-e.s.r+1,e.e.c-e.s.c+1]).buffer)}]])}]])})}),e[13]=[{type:2,data:wh([[],[{type:0,data:gh(O)}]])}],c.push({id:O,messages:[(R=6144,O=wh(x),{meta:[[],[{type:0,data:gh(R)}]],data:O})]}));var A=Rh(e[4][0].data);!function(){for(var e,t=xe.find(p,d[A].location),r=Eh(yh(t.content)),a=0;a<r.length;++a){var n=r[a];n.id==A&&(e=n)}var s=vh(e.messages[0].data);s[3]=[],u.forEach(function(e,t){s[3].push({type:2,data:wh([[],[{type:0,data:gh(t)}],[{type:0,data:gh(1)}],[{type:2,data:uh(e)}]])})}),e.messages[0].data=wh(s),t.content=Sh(kh(r)),t.size=t.content.length}();var C=vh(e[3][0].data),R=C[1][0];delete C[2];var R,O,O=vh(R.data),I=Rh(O[2][0].data);return function(){for(var e,t=xe.find(p,d[I].location),r=Eh(yh(t.content)),a=0;a<r.length;++a){var n=r[a];n.id==I&&(e=n)}var s=vh(e.messages[0].data);delete s[6],delete C[7];var i=new Uint8Array(s[5][0].data);s[5]=[];for(var o=0,c=0;c<=f.e.r;++c){var l=vh(i);o+=function(e,t,r){var a,n;if(null==(a=e[6])||!a[0]||null==(n=e[7])||!n[0])throw"Mutation only works on post-BNC storages!";if((null==(n=null==(n=e[8])?void 0:n[0])?void 0:n.data)&&0<bh(e[8][0].data)||!1)throw"Math only works with normal offsets";for(var s,i,o=0,c=fh(e[7][0].data),l=0,f=[],h=fh(e[4][0].data),u=0,d=[],p=0;p<t.length;++p)if(null!=t[p]){switch(c.setUint16(2*p,l,!0),h.setUint16(2*p,u,!0),typeof t[p]){case"string":s=xh({t:"s",v:t[p]},r),i=Ah({t:"s",v:t[p]},r);break;case"number":s=xh({t:"n",v:t[p]},r),i=Ah({t:"n",v:t[p]},r);break;case"boolean":s=xh({t:"b",v:t[p]},r),i=Ah({t:"b",v:t[p]},r);break;default:throw new Error("Unsupported value "+t[p])}f.push(s),l+=s.length,d.push(i),u+=i.length,++o}else c.setUint16(2*p,65535,!0),h.setUint16(2*p,65535);for(e[2][0].data=gh(o);p<e[7][0].data.length/2;++p)c.setUint16(2*p,65535,!0),h.setUint16(2*p,65535,!0);return e[6][0].data=dh(f),e[3][0].data=dh(d),o}(l,h[c],u),l[1][0].data=gh(c),s[5].push({data:wh(l),type:2})}s[1]=[{type:0,data:gh(f.e.c+1)}],s[2]=[{type:0,data:gh(f.e.r+1)}],s[3]=[{type:0,data:gh(o)}],s[4]=[{type:0,data:gh(f.e.r+1)}],e.messages[0].data=wh(s),t.content=Sh(kh(r)),t.size=t.content.length}(),R.data=wh(O),e[3][0].data=wh(C),a[4][0].data=wh(e),i.messages[0].data=wh(a),o.content=Sh(kh(c)),o.size=o.content.length,p}function Lh(a){return function(e){for(var t=0;t!=a.length;++t){var r=a[t];void 0===e[r[0]]&&(e[r[0]]=r[1]),"n"===r[2]&&(e[r[0]]=Number(e[r[0]]))}}}function Mh(e){Lh([["cellNF",!1],["cellHTML",!0],["cellFormula",!0],["cellStyles",!1],["cellText",!0],["cellDates",!1],["sheetStubs",!1],["sheetRows",0,"n"],["bookDeps",!1],["bookSheets",!1],["bookProps",!1],["bookFiles",!1],["bookVBA",!1],["password",""],["WTF",!1]])(e)}function Uh(e){Lh([["cellDates",!1],["bookSST",!1],["bookType","xlsx"],["compression",!1],["WTF",!1]])(e)}function Bh(t,e){if(!t)return 0;try{t=e.map(function(e){return e.id||(e.id=e.strRelID),[e.name,t["!id"][e.id].Target,(e=t["!id"][e.id].Type,-1<$a.WS.indexOf(e)?"sheet":$a.CS&&e==$a.CS?"chart":$a.DS&&e==$a.DS?"dialog":$a.MS&&e==$a.MS?"macro":e&&e.length?e:"sheet")]})}catch(e){return null}return t&&0!==t.length?t:null}function Wh(l,f,e,h,t,u,r,a,d,n,s,i){try{u[h]=Ya(tt(l,e,!0),f);var o=et(l,f);switch(a){case"sheet":g=nf(o,f,t,d,u[h],n,s,i);break;case"chart":if(!(g=sf(o,f,t,d,u[h],n))||!g["!drawel"])break;var c=it(g["!drawel"].Target,f),p=Xa(c),m=it((m=tt(l,c,!0),p=Ya(tt(l,p,!0),c),m?(m=(m.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1],p["!id"][m].Target):"??"),c),c=Xa(m),g=Wl(tt(l,m,!0),0,0,Ya(tt(l,c,!0),m),0,g);break;case"macro":v=f,u[h],v.slice(-4),g={"!type":"macro"};break;case"dialog":v=f,u[h],v.slice(-4),g={"!type":"dialog"};break;default:throw new Error("Unrecognized sheet type "+a)}r[h]=g;var b=[];u&&u[h]&&Re(u[h]).forEach(function(e){var a,n,s,i,o,c,t="";if(u[h][e].Type==$a.CMNT){t=it(u[h][e].Target,f);var r=lf(et(l,t,!0),t,d);if(!r||!r.length)return;ec(g,r,!1)}u[h][e].Type==$a.TCMNT&&(t=it(u[h][e].Target,f),b=b.concat((a=et(l,t,!0),n=d,i=!(s=[]),o={},c=0,a.replace(ft,function(e,t){var r=dt(e);switch(pt(r[0])){case"<?xml":case"<ThreadedComments":case"</ThreadedComments>":break;case"<threadedComment":o={author:r.personId,guid:r.id,ref:r.ref,T:1};break;case"</threadedComment>":null!=o.t&&s.push(o);break;case"<text>":case"<text":c=t+e.length;break;case"</text>":o.t=a.slice(c,t).replace(/\r\n/g,"\n").replace(/\r/g,"\n");break;case"<mentions":case"<mentions>":i=!0;break;case"</mentions>":i=!1;break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":i=!0;break;case"</ext>":i=!1;break;default:if(!i&&n.WTF)throw new Error("unrecognized "+r[0]+" in threaded comments")}return e}),s)))}),b&&b.length&&ec(g,b,!0,d.people||[])}catch(e){if(d.WTF)throw e}var v,m}function Hh(e){return"/"==e.charAt(0)?e.slice(1):e}function zh(r,t){if(Ee(),Mh(t=t||{}),Ze(r,"META-INF/manifest.xml"))return sh(r,t);if(Ze(r,"objectdata.xml"))return sh(r,t);if(Ze(r,"Index/Document.iwa")){if("undefined"==typeof Uint8Array)throw new Error("NUMBERS file parsing requires Uint8Array support");if(0,r.FileIndex)return Dh(r);var a=xe.utils.cfb_new();return rt(r).forEach(function(e){at(a,e,function e(t,r,a){if(!a)return qe(Qe(t,r));if(!r)return null;try{return e(t,r)}catch(e){return null}}(r,e))}),Dh(a)}if(!Ze(r,"[Content_Types].xml")){if(Ze(r,"index.xml.gz"))throw new Error("Unsupported NUMBERS 08 file");if(Ze(r,"index.xml"))throw new Error("Unsupported NUMBERS 09 file");throw new Error("Unsupported ZIP file")}var e,n,s=rt(r),i=function(e){var r=Ga();if(!e||!e.match)return r;var a={};if((e.match(ft)||[]).forEach(function(e){var t=dt(e);switch(t[0].replace(ht,"<")){case"<?xml":break;case"<Types":r.xmlns=t["xmlns"+(t[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":a[t.Extension]=t.ContentType;break;case"<Override":void 0!==r[za[t.ContentType]]&&r[za[t.ContentType]].push(t.PartName)}}),r.xmlns!==Zt.CT)throw new Error("Unknown Namespace: "+r.xmlns);return r.calcchain=0<r.calcchains.length?r.calcchains[0]:"",r.sst=0<r.strs.length?r.strs[0]:"",r.style=0<r.styles.length?r.styles[0]:"",r.defaults=a,delete r.calcchains,r}(tt(r,"[Content_Types].xml")),o=!1;if(0===i.workbooks.length&&et(r,n="xl/workbook.xml",!0)&&i.workbooks.push(n),0===i.workbooks.length){if(!et(r,n="xl/workbook.bin",!0))throw new Error("Could not find workbook");i.workbooks.push(n),o=!0}"bin"==i.workbooks[0].slice(-3)&&(o=!0);var c={},l={};if(!t.bookSheets&&!t.bookProps){if(Yc=[],i.sst)try{Yc=cf(et(r,Hh(i.sst)),i.sst,t)}catch(e){if(t.WTF)throw e}t.cellStyles&&i.themes.length&&(m=tt(r,i.themes[0].replace(/^\//,""),!0)||"",i.themes[0],c=$o(m,t)),i.style&&(l=of(et(r,Hh(i.style)),i.style,c,t))}i.links.map(function(e){try{Ya(tt(r,Xa(Hh(e))),e);return hf(et(r,Hh(e)),0,e,t)}catch(e){}});var f,h,u,d=af(et(r,Hh(i.workbooks[0])),i.workbooks[0],t),p={},m="";i.coreprops.length&&((m=et(r,Hh(i.coreprops[0]),!0))&&(p=rn(m)),0!==i.extprops.length&&(m=et(r,Hh(i.extprops[0]),!0))&&(g=t,u={},h=(h=p)||{},f=Mt(f=m),sn.forEach(function(e){var t=(f.match(Bt(e[0]))||[])[1];switch(e[2]){case"string":t&&(h[e[1]]=wt(t));break;case"bool":h[e[1]]="true"===t;break;case"raw":var r=f.match(new RegExp("<"+e[0]+"[^>]*>([\\s\\S]*?)</"+e[0]+">"));r&&0<r.length&&(u[e[1]]=r[1])}}),u.HeadingPairs&&u.TitlesOfParts&&cn(u.HeadingPairs,u.TitlesOfParts,h,g)));var g={};t.bookSheets&&!t.bookProps||0!==i.custprops.length&&(m=tt(r,Hh(i.custprops[0]),!0))&&(g=function(e,t){var r={},a="",n=e.match(fn);if(n)for(var s=0;s!=n.length;++s){var i=n[s],o=dt(i);switch(o[0]){case"<?xml":case"<Properties":break;case"<property":a=wt(o.name);break;case"</property>":a=null;break;default:if(0===i.indexOf("<vt:")){var c=i.split(">"),l=c[0].slice(4),f=c[1];switch(l){case"lpstr":case"bstr":case"lpwstr":r[a]=wt(f);break;case"bool":r[a]=Rt(f);break;case"i1":case"i2":case"i4":case"i8":case"int":case"uint":r[a]=parseInt(f,10);break;case"r4":case"r8":case"decimal":r[a]=parseFloat(f);break;case"filetime":case"date":r[a]=He(f);break;case"cy":case"error":r[a]=wt(f);break;default:if("/"==l.slice(-1))break;t.WTF&&"undefined"!=typeof console&&console.warn("Unexpected",i,l,c)}}else if("</"!==i.slice(0,2)&&t.WTF)throw new Error(i)}}return r}(m,t));var b={};if((t.bookSheets||t.bookProps)&&(d.Sheets?e=d.Sheets.map(function(e){return e.name}):p.Worksheets&&0<p.SheetNames.length&&(e=p.SheetNames),t.bookProps&&(b.Props=p,b.Custprops=g),t.bookSheets&&void 0!==e&&(b.SheetNames=e),t.bookSheets?b.SheetNames:t.bookProps))return b;e={};m={};t.bookDeps&&i.calcchain&&(m=ff(et(r,Hh(i.calcchain)),i.calcchain));var v,w,T=0,E={},k=d.Sheets;p.Worksheets=k.length,p.SheetNames=[];for(var y=0;y!=k.length;++y)p.SheetNames[y]=k[y].name;var S=o?"bin":"xml",o=i.workbooks[0].lastIndexOf("/"),_=(i.workbooks[0].slice(0,o+1)+"_rels/"+i.workbooks[0].slice(o+1)+".rels").replace(/^\//,"");Ze(r,_)||(_="xl/_rels/workbook."+S+".rels");var x,A,C,R=Ya(tt(r,_,!0),_.replace(/_rels.*/,"s5s"));1<=(i.metadata||[]).length&&(t.xlmeta=uf(et(r,Hh(i.metadata[0])),i.metadata[0],t)),1<=(i.people||[]).length&&(t.people=(o=et(r,Hh(i.people[0])),x=t,C=!(A=[]),o.replace(ft,function(e){var t=dt(e);switch(pt(t[0])){case"<?xml":case"<personList":case"</personList>":break;case"<person":A.push({name:t.displayname,id:t.id});break;case"</person>":break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":C=!0;break;case"</ext>":C=!1;break;default:if(!C&&x.WTF)throw new Error("unrecognized "+t[0]+" in threaded comments")}return e}),A)),R=R&&Bh(R,d.Sheets);var O=et(r,"xl/worksheets/sheet.xml",!0)?1:0;e:for(T=0;T!=p.Worksheets;++T){var I="sheet";if(R&&R[T]?(v="xl/"+R[T][1].replace(/[\/]?xl\//,""),Ze(r,v)||(v=R[T][1]),Ze(r,v)||(v=_.replace(/_rels\/.*$/,"")+R[T][1]),I=R[T][2]):v=(v="xl/worksheets/sheet"+(T+1-O)+"."+S).replace(/sheet0\./,"sheet."),w=v.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels"),t&&null!=t.sheets)switch(typeof t.sheets){case"number":if(T!=t.sheets)continue e;break;case"string":if(p.SheetNames[T].toLowerCase()!=t.sheets.toLowerCase())continue e;break;default:if(Array.isArray&&Array.isArray(t.sheets)){for(var N=!1,F=0;F!=t.sheets.length;++F)"number"==typeof t.sheets[F]&&t.sheets[F]==T&&(N=1),"string"==typeof t.sheets[F]&&t.sheets[F].toLowerCase()==p.SheetNames[T].toLowerCase()&&(N=1);if(!N)continue e}}Wh(r,v,w,p.SheetNames[T],T,E,e,I,t,d,c,l)}return b={Directory:i,Workbook:d,Props:p,Custprops:g,Deps:m,Sheets:e,SheetNames:p.SheetNames,Strings:Yc,Styles:l,Themes:c,SSF:Ve(me)},t&&t.bookFiles&&(r.files?(b.keys=s,b.files=r.files):(b.keys=[],b.files={},r.FullPaths.forEach(function(e,t){e=e.replace(/^Root Entry[\/]/,""),b.keys.push(e),b.files[e]=r.FileIndex[t]}))),t&&t.bookVBA&&(0<i.vba.length?b.vbaraw=et(r,Hh(i.vba[0]),!0):i.defaults&&i.defaults.bin===ac&&(b.vbaraw=et(r,"xl/vbaProject.bin",!0))),b}function Vh(e,t){var r,a=t||{},n="Workbook",s=xe.find(e,n);try{if(n="/!DataSpaces/Version",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);if(i=s.content,(r={}).id=i.read_shift(0,"lpp4"),r.R=Li(i,4),r.U=Li(i,4),r.W=Li(i,4),n="/!DataSpaces/DataSpaceMap",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);var i=Mi(s.content);if(1!==i.length||1!==i[0].comps.length||0!==i[0].comps[0].t||"StrongEncryptionDataSpace"!==i[0].name||"EncryptedPackage"!==i[0].comps[0].v)throw new Error("ECMA-376 Encrypted file bad "+n);if(n="/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);i=function(e){var t=[];e.l+=4;for(var r=e.read_shift(4);0<r--;)t.push(e.read_shift(0,"lpp4"));return t}(s.content);if(1!=i.length||"StrongEncryptionTransform"!=i[0])throw new Error("ECMA-376 Encrypted file bad "+n);if(n="/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);Ui(s.content)}catch(e){}if(n="/EncryptionInfo",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);t=Hi(s.content),n="/EncryptedPackage";if(!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);if(4==t[0]&&"undefined"!=typeof decrypt_agile)return decrypt_agile(t[1],s.content,a.password||"",a);if(2==t[0]&&"undefined"!=typeof decrypt_std76)return decrypt_std76(t[1],s.content,a.password||"",a);throw new Error("File is password-protected")}function Gh(e,t){return("ods"==t.bookType?lh:"numbers"==t.bookType?Ph:"xlsb"==t.bookType?function(e,t){Zo=1024,e&&!e.SSF&&(e.SSF=Ve(me));e&&e.SSF&&(Ee(),Te(e.SSF),t.revssf=Ne(e.SSF),t.revssf[e.SSF[65535]]=0,t.ssf=e.SSF);t.rels={},t.wbrels={},t.Strings=[],t.Strings.Count=0,t.Strings.Unique=0,Jc?t.revStrings=new Map:(t.revStrings={},t.revStrings.foo=[],delete t.revStrings.foo);var r="xlsb"==t.bookType?"bin":"xml",a=-1<nc.indexOf(t.bookType),n=Ga();Uh(t=t||{});var s=nt(),i="",o=0;t.cellXfs=[],el(t.cellXfs,{},{revssf:{General:0}}),e.Props||(e.Props={});if(at(s,i="docProps/core.xml",nn(e.Props,t)),n.coreprops.push(i),Ja(t.rels,2,i,$a.CORE_PROPS),i="docProps/app.xml",!e.Props||!e.Props.SheetNames)if(e.Workbook&&e.Workbook.Sheets){for(var c=[],l=0;l<e.SheetNames.length;++l)2!=(e.Workbook.Sheets[l]||{}).Hidden&&c.push(e.SheetNames[l]);e.Props.SheetNames=c}else e.Props.SheetNames=e.SheetNames;e.Props.Worksheets=e.Props.SheetNames.length,at(s,i,ln(e.Props)),n.extprops.push(i),Ja(t.rels,3,i,$a.EXT_PROPS),e.Custprops!==e.Props&&0<Re(e.Custprops||{}).length&&(at(s,i="docProps/custom.xml",hn(e.Custprops)),n.custprops.push(i),Ja(t.rels,4,i,$a.CUST_PROPS));for(o=1;o<=e.SheetNames.length;++o){var f,h,u,d={"!id":{}},p=e.Sheets[e.SheetNames[o-1]];at(s,i="xl/worksheets/sheet"+o+"."+r,function(e,t,r,a,n){return(".bin"===t.slice(-4)?Bl:xl)(e,r,a,n)}(o-1,i,t,e,d)),n.sheets.push(i),Ja(t.wbrels,-1,"worksheets/sheet"+o+"."+r,$a.WS[0]),p&&(f=p["!comments"],h=!1,u="",f&&0<f.length&&(at(s,u="xl/comments"+o+"."+r,function(e,t,r){return(".bin"===t.slice(-4)?rc:tc)(e,r)}(f,u,t)),n.comments.push(u),Ja(d,-1,"../comments"+o+"."+r,$a.CMNT),h=!0),p["!legacy"]&&h&&at(s,"xl/drawings/vmlDrawing"+o+".vml",Qo(o,p["!comments"])),delete p["!comments"],delete p["!legacy"]),d["!id"].rId1&&at(s,Xa(i),Ka(d))}null!=t.Strings&&0<t.Strings.length&&(at(s,i="xl/sharedStrings."+r,function(e,t,r){return(".bin"===t.slice(-4)?Di:Ni)(e,r)}(t.Strings,i,t)),n.strs.push(i),Ja(t.wbrels,-1,"sharedStrings."+r,$a.SST));at(s,i="xl/workbook."+r,function(e,t,r){return(".bin"===t.slice(-4)?rf:Zl)(e,r)}(e,i,t)),n.workbooks.push(i),Ja(t.rels,1,i,$a.WB),at(s,i="xl/theme/theme1.xml",Xo(e.Themes,t)),n.themes.push(i),Ja(t.wbrels,-1,"theme/theme1.xml",$a.THEME),at(s,i="xl/styles."+r,function(e,t,r){return(".bin"===t.slice(-4)?Mo:_o)(e,r)}(e,i,t)),n.styles.push(i),Ja(t.wbrels,-1,"styles."+r,$a.STY),e.vbaraw&&a&&(at(s,i="xl/vbaProject.bin",e.vbaraw),n.vba.push(i),Ja(t.wbrels,-1,"vbaProject.bin",$a.VBA));return at(s,i="xl/metadata."+r,function(e){return(".bin"===e.slice(-4)?Jo:qo)()}(i)),n.metadata.push(i),Ja(t.wbrels,-1,"metadata."+r,$a.XLMETA),at(s,"[Content_Types].xml",ja(n,t)),at(s,"_rels/.rels",Ka(t.rels)),at(s,"xl/_rels/workbook."+r+".rels",Ka(t.wbrels)),delete t.revssf,delete t.ssf,s}:jh)(e,t)}function jh(e,t){Zo=1024,e&&!e.SSF&&(e.SSF=Ve(me)),e&&e.SSF&&(Ee(),Te(e.SSF),t.revssf=Ne(e.SSF),t.revssf[e.SSF[65535]]=0,t.ssf=e.SSF),t.rels={},t.wbrels={},t.Strings=[],t.Strings.Count=0,t.Strings.Unique=0,Jc?t.revStrings=new Map:(t.revStrings={},t.revStrings.foo=[],delete t.revStrings.foo);var r="xml",a=-1<nc.indexOf(t.bookType),n=Ga();Uh(t=t||{});var s=nt(),i="",o=0;if(t.cellXfs=[],el(t.cellXfs,{},{revssf:{General:0}}),e.Props||(e.Props={}),i="docProps/core.xml",at(s,i,nn(e.Props,t)),n.coreprops.push(i),Ja(t.rels,2,i,$a.CORE_PROPS),i="docProps/app.xml",!e.Props||!e.Props.SheetNames)if(e.Workbook&&e.Workbook.Sheets){for(var c=[],l=0;l<e.SheetNames.length;++l)2!=(e.Workbook.Sheets[l]||{}).Hidden&&c.push(e.SheetNames[l]);e.Props.SheetNames=c}else e.Props.SheetNames=e.SheetNames;e.Props.Worksheets=e.Props.SheetNames.length,at(s,i,ln(e.Props)),n.extprops.push(i),Ja(t.rels,3,i,$a.EXT_PROPS),e.Custprops!==e.Props&&0<Re(e.Custprops||{}).length&&(at(s,i="docProps/custom.xml",hn(e.Custprops)),n.custprops.push(i),Ja(t.rels,4,i,$a.CUST_PROPS));var f,h=["SheetJ5"];for(t.tcid=0,o=1;o<=e.SheetNames.length;++o){var u,d,p,m,g={"!id":{}},b=e.Sheets[e.SheetNames[o-1]];at(s,i="xl/worksheets/sheet"+o+"."+r,xl(o-1,t,e,g)),n.sheets.push(i),Ja(t.wbrels,-1,"worksheets/sheet"+o+"."+r,$a.WS[0]),b&&(d=!1,p="",(u=b["!comments"])&&0<u.length&&(m=!1,u.forEach(function(e){e[1].forEach(function(e){1==e.T&&(m=!0)})}),m&&(at(s,p="xl/threadedComments/threadedComment"+o+"."+r,function(e,s,i){var o=[ot,Yt("ThreadedComments",null,{xmlns:Zt.TCMNT}).replace(/[\/]>/,">")];return e.forEach(function(a){var n="";(a[1]||[]).forEach(function(e,t){var r;e.T?(e.a&&-1==s.indexOf(e.a)&&s.push(e.a),r={ref:a[0],id:"{54EE7951-7262-4200-6969-"+("000000000000"+i.tcid++).slice(-12)+"}"},0==t?n=r.id:r.parentId=n,e.ID=r.id,e.a&&(r.personId="{54EE7950-7262-4200-6969-"+("000000000000"+s.indexOf(e.a)).slice(-12)+"}"),o.push(Yt("threadedComment",$t("text",e.t||""),r))):delete e.ID})}),o.push("</ThreadedComments>"),o.join("")}(u,h,t)),n.threadedcomments.push(p),Ja(g,-1,"../threadedComments/threadedComment"+o+"."+r,$a.TCMNT)),at(s,p="xl/comments"+o+"."+r,tc(u)),n.comments.push(p),Ja(g,-1,"../comments"+o+"."+r,$a.CMNT),d=!0),b["!legacy"]&&d&&at(s,"xl/drawings/vmlDrawing"+o+".vml",Qo(o,b["!comments"])),delete b["!comments"],delete b["!legacy"]),g["!id"].rId1&&at(s,Xa(i),Ka(g))}return null!=t.Strings&&0<t.Strings.length&&(at(s,i="xl/sharedStrings.xml",Ni(t.Strings,t)),n.strs.push(i),Ja(t.wbrels,-1,"sharedStrings.xml",$a.SST)),at(s,i="xl/workbook.xml",Zl(e)),n.workbooks.push(i),Ja(t.rels,1,i,$a.WB),at(s,i="xl/theme/theme1.xml",Xo(e.Themes,t)),n.themes.push(i),Ja(t.wbrels,-1,"theme/theme1.xml",$a.THEME),at(s,i="xl/styles.xml",_o(e,t)),n.styles.push(i),Ja(t.wbrels,-1,"styles.xml",$a.STY),e.vbaraw&&a&&(at(s,i="xl/vbaProject.bin",e.vbaraw),n.vba.push(i),Ja(t.wbrels,-1,"vbaProject.bin",$a.VBA)),at(s,i="xl/metadata.xml",qo()),n.metadata.push(i),Ja(t.wbrels,-1,"metadata.xml",$a.XLMETA),1<h.length&&(at(s,i="xl/persons/person.xml",(a=h,f=[ot,Yt("personList",null,{xmlns:Zt.TCMNT,"xmlns:x":Qt[0]}).replace(/[\/]>/,">")],a.forEach(function(e,t){f.push(Yt("person",null,{displayName:e,id:"{54EE7950-7262-4200-6969-"+("000000000000"+t).slice(-12)+"}",userId:e,providerId:"None"}))}),f.push("</personList>"),f.join(""))),n.people.push(i),Ja(t.wbrels,-1,"persons/person.xml",$a.PEOPLE)),at(s,"[Content_Types].xml",ja(n,t)),at(s,"_rels/.rels",Ka(t.rels)),at(s,"xl/_rels/workbook.xml.rels",Ka(t.wbrels)),delete t.revssf,delete t.ssf,s}function $h(e,t){var r="";switch((t||{}).type||"base64"){case"buffer":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];case"base64":r=te(e.slice(0,12));break;case"binary":r=e;break;case"array":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];default:throw new Error("Unrecognized type "+(t&&t.type||"undefined"))}return[r.charCodeAt(0),r.charCodeAt(1),r.charCodeAt(2),r.charCodeAt(3),r.charCodeAt(4),r.charCodeAt(5),r.charCodeAt(6),r.charCodeAt(7)]}function Xh(e,t){var r=0;e:for(;r<e.length;)switch(e.charCodeAt(r)){case 10:case 13:case 32:++r;break;case 60:return wf(e.slice(r),t);default:break e}return Ks.to_workbook(e,t)}function Yh(e,t,r,a){return a?(r.type="string",Ks.to_workbook(e,r)):Ks.to_workbook(t,r)}function Kh(e,t){h();var r=t||{};if("undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer)return Kh(new Uint8Array(e),((r=Ve(r)).type="array",r));"undefined"!=typeof Uint8Array&&e instanceof Uint8Array&&!r.type&&(r.type="undefined"!=typeof Deno?"buffer":"array");var a,n,s,i,o,c=e,l=!1;if(r.cellStyles&&(r.cellNF=!0,r.sheetStubs=!0),Kc={},r.dateNF&&(Kc.dateNF=r.dateNF),r.type||(r.type=se&&Buffer.isBuffer(e)?"buffer":"base64"),"file"==r.type&&(r.type=se?"buffer":"binary",c=function(e){if(void 0!==Se)return Se.readFileSync(e);if("undefined"!=typeof Deno)return Deno.readFileSync(e);if("undefined"!=typeof $&&"undefined"!=typeof File&&"undefined"!=typeof Folder)try{var t=File(e);t.open("r"),t.encoding="binary";var r=t.read();return t.close(),r}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e}throw new Error("Cannot access file "+e)}(e),"undefined"==typeof Uint8Array||se||(r.type="array")),"string"==r.type&&(l=!0,r.type="binary",r.codepage=65001,c=(f=e).match(/[^\x00-\x7F]/)?Ut(f):f),"array"==r.type&&"undefined"!=typeof Uint8Array&&e instanceof Uint8Array&&"undefined"!=typeof ArrayBuffer){var f=new ArrayBuffer(3),f=new Uint8Array(f);if(f.foo="bar",!f.foo)return(r=Ve(r)).type="array",Kh(m(c),r)}switch((a=$h(c,r))[0]){case 208:if(207===a[1]&&17===a[2]&&224===a[3]&&161===a[4]&&177===a[5]&&26===a[6]&&225===a[7])return i=xe.read(c,r),o=r,(xe.find(i,"EncryptedPackage")?Vh:Nf)(i,o);break;case 9:if(a[1]<=8)return Nf(c,r);break;case 60:return wf(c,r);case 73:if(73===a[1]&&42===a[2]&&0===a[3])throw new Error("TIFF Image File is not a spreadsheet");if(68===a[1])return function(t,r){var a=r||{},n=!!a.WTF;a.WTF=!0;try{var e=Ns.to_workbook(t,a);return a.WTF=n,e}catch(e){if(a.WTF=n,!e.message.match(/SYLK bad record ID/)&&n)throw e;return Ks.to_workbook(t,r)}}(c,r);break;case 84:if(65===a[1]&&66===a[2]&&76===a[3])return Ps.to_workbook(c,r);break;case 80:return 75===a[1]&&a[2]<9&&a[3]<9?(s=o=c,(n=(n=r)||{}).type||(n.type=se&&Buffer.isBuffer(o)?"buffer":"base64"),zh(st(s,n),n)):Yh(e,c,r,l);case 239:return 60===a[3]?wf(c,r):Yh(e,c,r,l);case 255:if(254===a[1])return s=c,"base64"==(n=r).type&&(s=te(s)),s=re.utils.decode(1200,s.slice(2),"str"),n.type="binary",Xh(s,n);if(0===a[1]&&2===a[2]&&0===a[3])return si.to_workbook(c,r);break;case 0:if(0===a[1]){if(2<=a[2]&&0===a[3])return si.to_workbook(c,r);if(0===a[2]&&(8===a[3]||9===a[3]))return si.to_workbook(c,r)}break;case 3:case 131:case 139:case 140:return xs.to_workbook(c,r);case 123:if(92===a[1]&&114===a[2]&&116===a[3])return Ji.to_workbook(c,r);break;case 10:case 13:case 32:return function(e,t){var r="",a=$h(e,t);switch(t.type){case"base64":r=te(e);break;case"binary":r=e;break;case"buffer":r=e.toString("binary");break;case"array":r=ze(e);break;default:throw new Error("Unrecognized type "+t.type)}return 239==a[0]&&187==a[1]&&191==a[2]&&(r=Mt(r)),t.type="binary",Xh(r,t)}(c,r);case 137:if(80===a[1]&&78===a[2]&&71===a[3])throw new Error("PNG Image File is not a spreadsheet")}return-1<_s.indexOf(a[0])&&a[2]<=12&&a[3]<=31?xs.to_workbook(c,r):Yh(e,c,r,l)}function Jh(e,t){t=t||{};return t.type="file",Kh(e,t)}function qh(e,t){switch(t.type){case"base64":case"binary":break;case"buffer":case"array":t.type="";break;case"file":return Ce(t.file,xe.write(e,{type:se?"buffer":""}));case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");default:throw new Error("Unrecognized type "+t.type)}return xe.write(e,t)}function Zh(e,t){var r={},a=se?"nodebuffer":"undefined"!=typeof Uint8Array?"array":"string";if(t.compression&&(r.compression="DEFLATE"),t.password)r.type=a;else switch(t.type){case"base64":r.type="base64";break;case"binary":r.type="string";break;case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");case"buffer":case"file":r.type=a;break;default:throw new Error("Unrecognized type "+t.type)}e=e.FullPaths?xe.write(e,{fileType:"zip",type:{nodebuffer:"buffer",string:"binary"}[r.type]||r.type,compression:!!t.compression}):e.generate(r);if("undefined"!=typeof Deno&&"string"==typeof e){if("binary"==t.type||"base64"==t.type)return e;e=new Uint8Array(o(e))}return t.password&&"undefined"!=typeof encrypt_agile?qh(encrypt_agile(e,t.password),t):"file"===t.type?Ce(t.file,e):"string"==t.type?Mt(e):e}function Qh(e,t,r){var a=(r=r||"")+e;switch(t.type){case"base64":return ee(Ut(a));case"binary":return Ut(a);case"string":return e;case"file":return Ce(t.file,a,"utf8");case"buffer":return se?ce(a,"utf8"):"undefined"!=typeof TextEncoder?(new TextEncoder).encode(a):Qh(a,{type:"binary"}).split("").map(function(e){return e.charCodeAt(0)})}throw new Error("Unrecognized type "+t.type)}function eu(e,t){switch(t.type){case"string":case"base64":case"binary":for(var r="",a=0;a<e.length;++a)r+=String.fromCharCode(e[a]);return"base64"==t.type?ee(r):"string"==t.type?Mt(r):r;case"file":return Ce(t.file,e);case"buffer":return e;default:throw new Error("Unrecognized type "+t.type)}}function tu(e,t){h(),Jl(e);var r,a=Ve(t||{});if(a.cellStyles&&(a.cellNF=!0,a.sheetStubs=!0),"array"!=a.type)return r=e,t=Ve((t=a)||{}),Zh(jh(r,t),t);a.type="binary";e=tu(e,a);return a.type="array",o(e)}function ru(e,t){h(),Jl(e);var r=Ve(t||{});if(r.cellStyles&&(r.cellNF=!0,r.sheetStubs=!0),"array"==r.type){r.type="binary";t=ru(e,r);return r.type="array",o(t)}var a,n,s,i=0;if(r.sheet&&(i="number"==typeof r.sheet?r.sheet:e.SheetNames.indexOf(r.sheet),!e.SheetNames[i]))throw new Error("Sheet not found: "+r.sheet+" : "+typeof r.sheet);switch(r.bookType||"xlsb"){case"xml":case"xlml":return Qh(_f(e,r),r);case"slk":case"sylk":return Qh(Ns.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"htm":case"html":return Qh(Qf(e.Sheets[e.SheetNames[i]],r),r);case"txt":return function(e,t){switch(t.type){case"base64":return ee(e);case"binary":case"string":return e;case"file":return Ce(t.file,e,"binary");case"buffer":return se?ce(e,"binary"):e.split("").map(function(e){return e.charCodeAt(0)})}throw new Error("Unrecognized type "+t.type)}(fu(e.Sheets[e.SheetNames[i]],r),r);case"csv":return Qh(lu(e.Sheets[e.SheetNames[i]],r),r,"\ufeff");case"dif":return Qh(Ps.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"dbf":return eu(xs.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"prn":return Qh(Ks.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"rtf":return Qh(Ji.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"eth":return Qh(Gs.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"fods":return Qh(lh(e,r),r);case"wk1":return eu(si.sheet_to_wk1(e.Sheets[e.SheetNames[i]],r),r);case"wk3":return eu(si.book_to_wk3(e,r),r);case"biff2":r.biff||(r.biff=2);case"biff3":r.biff||(r.biff=3);case"biff4":return r.biff||(r.biff=4),eu(Xf(e,r),r);case"biff5":r.biff||(r.biff=5);case"biff8":case"xla":case"xls":return r.biff||(r.biff=8),qh(Ff(e,s=(s=r)||{}),s);case"xlsx":case"xlsm":case"xlam":case"xlsb":case"numbers":case"ods":return a=e,s=Ve((n=r)||{}),yo=new wu(n),Zh(Gh(a,s),s);default:throw new Error("Unrecognized bookType |"+r.bookType+"|")}}function au(e){var t;e.bookType||((t=e.file.slice(e.file.lastIndexOf(".")).toLowerCase()).match(/^\.[a-z]+$/)&&(e.bookType=t.slice(1)),e.bookType={xls:"biff8",htm:"html",slk:"sylk",socialcalc:"eth",Sh33tJS:"WTF"}[e.bookType]||e.bookType)}function nu(e,t,r){r=r||{};return r.type="file",r.file=t,au(r),ru(e,r)}function su(e,t,r,a,n,s,i,o){var c=jr(r),l=o.defval,f=o.raw||!Object.prototype.hasOwnProperty.call(o,"raw"),h=!0,u=1===n?[]:{};if(1!==n)if(Object.defineProperty)try{Object.defineProperty(u,"__rowNum__",{value:r,enumerable:!1})}catch(e){u.__rowNum__=r}else u.__rowNum__=r;if(!i||e[r])for(var d=t.s.c;d<=t.e.c;++d){var p=i?e[r][d]:e[a[d]+c];if(void 0!==p&&void 0!==p.t){var m=p.v;switch(p.t){case"z":if(null==m)break;continue;case"e":m=0==m?null:void 0;break;case"s":case"d":case"b":case"n":break;default:throw new Error("unrecognized type "+p.t)}if(null!=s[d]){if(null==m)if("e"==p.t&&null===m)u[s[d]]=null;else if(void 0!==l)u[s[d]]=l;else{if(!f||null!==m)continue;u[s[d]]=null}else u[s[d]]=f&&("n"!==p.t||"n"===p.t&&!1!==o.rawNumbers)?m:ea(p,m,o);null!=m&&(h=!1)}}else void 0!==l&&null!=s[d]&&(u[s[d]]=l)}return{row:u,isempty:h}}function iu(e,t){if(null==e||null==e["!ref"])return[];var r,a={t:"n",v:0},n=0,s=1,i=[],o="",c={s:{r:0,c:0},e:{r:0,c:0}},l=t||{},f=null!=l.range?l.range:e["!ref"];switch(1===l.header?n=1:"A"===l.header?n=2:Array.isArray(l.header)?n=3:null==l.header&&(n=0),typeof f){case"string":c=Zr(f);break;case"number":(c=Zr(e["!ref"])).s.r=f;break;default:c=f}0<n&&(s=0);var h=jr(c.s.r),u=[],d=[],p=0,m=0,g=Array.isArray(e),b=c.s.r,v=0,w={};g&&!e[b]&&(e[b]=[]);for(var T,E=l.skipHidden&&e["!cols"]||[],k=l.skipHidden&&e["!rows"]||[],v=c.s.c;v<=c.e.c;++v)if(!(E[v]||{}).hidden)switch(u[v]=Xr(v),a=g?e[b][v]:e[u[v]+h],n){case 1:i[v]=v-c.s.c;break;case 2:i[v]=u[v];break;case 3:i[v]=l.header[v-c.s.c];break;default:if(o=r=ea(a=null==a?{w:"__EMPTY",t:"s"}:a,null,l),m=w[r]||0){for(;o=r+"_"+m++,w[o];);w[r]=m,w[o]=1}else w[r]=1;i[v]=o}for(b=c.s.r+s;b<=c.e.r;++b)(k[b]||{}).hidden||(!1!==(T=su(e,c,b,u,n,i,g,l)).isempty&&(1===n?!1===l.blankrows:!l.blankrows)||(d[p++]=T.row));return d.length=p,d}var ou=/"/g;function cu(e,t,r,a,n,s,i,o){for(var c=!0,l=[],f="",h=jr(r),u=t.s.c;u<=t.e.c;++u)if(a[u]){var d=o.dense?(e[r]||[])[u]:e[a[u]+h];if(null==d)f="";else if(null!=d.v){c=!1,f=""+(o.rawNumbers&&"n"==d.t?d.v:ea(d,null,o));for(var p,m=0;m!==f.length;++m)if((p=f.charCodeAt(m))===n||p===s||34===p||o.forceQuotes){f='"'+f.replace(ou,'""')+'"';break}"ID"==f&&(f='"ID"')}else null==d.f||d.F?f="":(c=!1,0<=(f="="+d.f).indexOf(",")&&(f='"'+f.replace(ou,'""')+'"'));l.push(f)}return!1===o.blankrows&&c?null:l.join(i)}function lu(e,t){var r=[],a=null==t?{}:t;if(null==e||null==e["!ref"])return"";var n=Zr(e["!ref"]),s=void 0!==a.FS?a.FS:",",i=s.charCodeAt(0),o=void 0!==a.RS?a.RS:"\n",c=o.charCodeAt(0),l=new RegExp(("|"==s?"\\|":s)+"+$"),f="",h=[];a.dense=Array.isArray(e);for(var u=a.skipHidden&&e["!cols"]||[],d=a.skipHidden&&e["!rows"]||[],p=n.s.c;p<=n.e.c;++p)(u[p]||{}).hidden||(h[p]=Xr(p));for(var m=0,g=n.s.r;g<=n.e.r;++g)(d[g]||{}).hidden||null!=(f=cu(e,n,g,h,i,c,s,a))&&(!(f=a.strip?f.replace(l,""):f)&&!1===a.blankrows||r.push((m++?o:"")+f));return delete a.dense,r.join("")}function fu(e,t){(t=t||{}).FS="\t",t.RS="\n";e=lu(e,t);if(void 0===re||"string"==t.type)return e;e=re.utils.encode(1200,e,"str");return String.fromCharCode(255)+String.fromCharCode(254)+e}function hu(e,t,r){var i,o=r||{},c=+!o.skipHeader,l=e||{},f=0,h=0;l&&null!=o.origin&&("number"==typeof o.origin?f=o.origin:(a="string"==typeof o.origin?Yr(o.origin):o.origin,f=a.r,h=a.c));var a,e={s:{c:0,r:0},e:{c:h,r:f+t.length-1+c}};l["!ref"]?(a=Zr(l["!ref"]),e.e.c=Math.max(e.e.c,a.e.c),e.e.r=Math.max(e.e.r,a.e.r),-1==f&&(f=a.e.r+1,e.e.r=f+t.length-1+c)):-1==f&&(f=0,e.e.r=t.length-1+c);var u=o.header||[],d=0;t.forEach(function(n,s){Re(n).forEach(function(e){-1==(d=u.indexOf(e))&&(u[d=u.length]=e);var t=n[e],r="z",a="",e=Kr({c:h+d,r:f+s+c});i=uu(l,e),!t||"object"!=typeof t||t instanceof Date?("number"==typeof t?r="n":"boolean"==typeof t?r="b":"string"==typeof t?r="s":t instanceof Date?(r="d",o.cellDates||(r="n",t=De(t)),a=o.dateNF||me[14]):null===t&&o.nullError&&(r="e",t=0),i?(i.t=r,i.v=t,delete i.w,delete i.R,a&&(i.z=a)):l[e]=i={t:r,v:t},a&&(i.z=a)):l[e]=t})}),e.e.c=Math.max(e.e.c,h+u.length-1);var n=jr(f);if(c)for(d=0;d<u.length;++d)l[Xr(d+h)+n]={t:"s",v:u[d]};return l["!ref"]=qr(e),l}function uu(e,t,r){if("string"!=typeof t)return uu(e,Kr("number"!=typeof t?t:{r:t,c:r||0}));if(Array.isArray(e)){r=Yr(t);return e[r.r]||(e[r.r]=[]),e[r.r][r.c]||(e[r.r][r.c]={t:"z"})}return e[t]||(e[t]={t:"z"})}function du(){return{SheetNames:[],Sheets:{}}}function pu(e,t,r,a){var n=1;if(!r)for(;n<=65535&&-1!=e.SheetNames.indexOf(r="Sheet"+n);++n,r=void 0);if(!r||65535<=e.SheetNames.length)throw new Error("Too many worksheets");if(a&&0<=e.SheetNames.indexOf(r)){var a=r.match(/(^.*?)(\d+)$/),n=a&&+a[2]||0,s=a&&a[1]||r;for(++n;n<=65535&&-1!=e.SheetNames.indexOf(r=s+n);++n);}if(Kl(r),0<=e.SheetNames.indexOf(r))throw new Error("Worksheet with name |"+r+"| already exists!");return e.SheetNames.push(r),e.Sheets[r]=t,r}function mu(e,t,r){return t?(e.l={Target:t},r&&(e.l.Tooltip=r)):delete e.l,e}var gu,Es={encode_col:Xr,encode_row:jr,encode_cell:Kr,encode_range:qr,decode_col:$r,decode_row:Gr,split_cell:function(e){return e.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")},decode_cell:Yr,decode_range:Jr,format_cell:ea,sheet_add_aoa:ra,sheet_add_json:hu,sheet_add_dom:eh,aoa_to_sheet:aa,json_to_sheet:function(e,t){return hu(null,e,t)},table_to_sheet:th,table_to_book:function(e,t){return ta(th(e,t),t)},sheet_to_csv:lu,sheet_to_txt:fu,sheet_to_json:iu,sheet_to_html:Qf,sheet_to_formulae:function(e){var t,r="",a="";if(null==e||null==e["!ref"])return[];for(var n,s=Zr(e["!ref"]),i=[],o=[],c=Array.isArray(e),l=s.s.c;l<=s.e.c;++l)i[l]=Xr(l);for(var f=s.s.r;f<=s.e.r;++f)for(n=jr(f),l=s.s.c;l<=s.e.c;++l)if(r=i[l]+n,a="",void 0!==(t=c?(e[f]||[])[l]:e[r])){if(null!=t.F){if(r=t.F,!t.f)continue;a=t.f,-1==r.indexOf(":")&&(r=r+":"+r)}if(null!=t.f)a=t.f;else{if("z"==t.t)continue;if("n"==t.t&&null!=t.v)a=""+t.v;else if("b"==t.t)a=t.v?"TRUE":"FALSE";else if(void 0!==t.w)a="'"+t.w;else{if(void 0===t.v)continue;a="s"==t.t?"'"+t.v:""+t.v}}o[o.length]=r+"="+a}return o},sheet_to_row_object_array:iu,sheet_get_cell:uu,book_new:du,book_append_sheet:pu,book_set_sheet_visibility:function(e,t,r){switch(e.Workbook||(e.Workbook={}),e.Workbook.Sheets||(e.Workbook.Sheets=[]),t=function(e,t){if("number"==typeof t){if(0<=t&&e.SheetNames.length>t)return t;throw new Error("Cannot find sheet # "+t)}if("string"!=typeof t)throw new Error("Cannot find sheet |"+t+"|");if(-1<(e=e.SheetNames.indexOf(t)))return e;throw new Error("Cannot find sheet name |"+t+"|")}(e,t),e.Workbook.Sheets[t]||(e.Workbook.Sheets[t]={}),r){case 0:case 1:case 2:break;default:throw new Error("Bad sheet visibility setting "+r)}e.Workbook.Sheets[t].Hidden=r},cell_set_number_format:function(e,t){return e.z=t,e},cell_set_hyperlink:mu,cell_set_internal_link:function(e,t,r){return mu(e,"#"+t,r)},cell_add_comment:function(e,t,r){e.c||(e.c=[]),e.c.push({t:t,a:r||"SheetJS"})},sheet_set_array_formula:function(e,t,r,a){for(var n="string"!=typeof t?t:Zr(t),s="string"==typeof t?t:qr(t),i=n.s.r;i<=n.e.r;++i)for(var o=n.s.c;o<=n.e.c;++o){var c=uu(e,i,o);c.t="n",c.F=s,delete c.v,i==n.s.r&&o==n.s.c&&(c.f=r,a&&(c.D=!0))}return e},consts:{SHEET_VISIBLE:0,SHEET_HIDDEN:1,SHEET_VERY_HIDDEN:2}};function bu(e){gu=e}var is={to_json:function(t,e){var r=gu({objectMode:!0});if(null==t||null==t["!ref"])return r.push(null),r;var a,n={t:"n",v:0},s=0,i=1,o=[],c="",l={s:{r:0,c:0},e:{r:0,c:0}},f=e||{},h=null!=f.range?f.range:t["!ref"];switch(1===f.header?s=1:"A"===f.header?s=2:Array.isArray(f.header)&&(s=3),typeof h){case"string":l=Zr(h);break;case"number":(l=Zr(t["!ref"])).s.r=h;break;default:l=h}0<s&&(i=0);var u=jr(l.s.r),d=[],p=0,m=Array.isArray(t),g=l.s.r,b=0,v={};m&&!t[g]&&(t[g]=[]);for(var w=f.skipHidden&&t["!cols"]||[],T=f.skipHidden&&t["!rows"]||[],b=l.s.c;b<=l.e.c;++b)if(!(w[b]||{}).hidden)switch(d[b]=Xr(b),n=m?t[g][b]:t[d[b]+u],s){case 1:o[b]=b-l.s.c;break;case 2:o[b]=d[b];break;case 3:o[b]=f.header[b-l.s.c];break;default:if(c=a=ea(n=null==n?{w:"__EMPTY",t:"s"}:n,null,f),p=v[a]||0){for(;c=a+"_"+p++,v[c];);v[a]=p,v[c]=1}else v[a]=1;o[b]=c}return g=l.s.r+i,r._read=function(){for(;g<=l.e.r;)if(!(T[g-1]||{}).hidden){var e=su(t,l,g,d,s,o,m,f);if(++g,!1===e.isempty||(1===s?!1!==f.blankrows:f.blankrows))return void r.push(e.row)}return r.push(null)},r},to_html:function(e,t){var r=gu(),a=t||{},t=null!=a.header?a.header:Jf,n=null!=a.footer?a.footer:qf;r.push(t);var s=Jr(e["!ref"]);a.dense=Array.isArray(e),r.push(Zf(0,0,a));var i=s.s.r,o=!1;return r._read=function(){if(i>s.e.r)return o||(o=!0,r.push("</table>"+n)),r.push(null);for(;i<=s.e.r;){r.push(Kf(e,s,i,a)),++i;break}},r},to_csv:function(e,t){var r=gu(),a=null==t?{}:t;if(null==e||null==e["!ref"])return r.push(null),r;var n=Zr(e["!ref"]),s=void 0!==a.FS?a.FS:",",i=s.charCodeAt(0),o=void 0!==a.RS?a.RS:"\n",c=o.charCodeAt(0),l=new RegExp(("|"==s?"\\|":s)+"+$"),f="",h=[];a.dense=Array.isArray(e);for(var u=a.skipHidden&&e["!cols"]||[],d=a.skipHidden&&e["!rows"]||[],p=n.s.c;p<=n.e.c;++p)(u[p]||{}).hidden||(h[p]=Xr(p));var m=n.s.r,g=!1,b=0;return r._read=function(){if(!g)return g=!0,r.push("\ufeff");for(;m<=n.e.r;)if(++m,!(d[m-1]||{}).hidden&&(f=cu(e,n,m-1,h,i,c,s,a),null!=f&&((f=a.strip?f.replace(l,""):f)||!1!==a.blankrows)))return r.push((b++?o:"")+f);return r.push(null)},r},set_readable:bu},vu=function(){function a(e,t,r){return this instanceof a?(this.tagName=e,this._attributes=t||{},this._children=r||[],this._prefix="",this):new a(e,t,r)}a.prototype.createElement=function(){return new a(arguments)},a.prototype.children=function(){return this._children},a.prototype.append=function(e){return this._children.push(e),this},a.prototype.prefix=function(e){return 0==arguments.length?this._prefix:(this._prefix=e,this)},a.prototype.attr=function(e,t){if(null==t)return delete this._attributes[e],this;if(0==arguments.length)return this._attributes;if("string"==typeof e&&1==arguments.length)return this._attributes.attr[e];if("object"==typeof e&&1==arguments.length)for(var r in e)this._attributes[r]=e[r];else 2==arguments.length&&"string"==typeof e&&(this._attributes[e]=t);return this};return a.prototype.escapeAttributeValue=function(e){return'"'+e.replace(/\"/g,"&quot;")+'"'},a.prototype.toXml=function(e){var t=(e=e||this)._prefix;if(t+="<"+e.tagName,e._attributes)for(var r in e._attributes)t+=" "+r+"="+this.escapeAttributeValue(""+e._attributes[r]);if(e._children&&0<e._children.length){t+=">";for(var a=0;a<e._children.length;a++)t+=this.toXml(e._children[a]);t+="</"+e.tagName+">"}else t+="/>";return t},a}(),wu=function(e){var t,r=164,a={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"m/d/yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@",56:'"上午/下午 "hh"時"mm"分"ss"秒 "'},n={};for(t in a)n[a[t]]=t;var s={};return{initialize:function(e){this.$fonts=vu("fonts").attr("count",0).attr("x14ac:knownFonts","1"),this.$fills=vu("fills").attr("count",0),this.$borders=vu("borders").attr("count",0),this.$numFmts=vu("numFmts").attr("count",0),this.$cellStyleXfs=vu("cellStyleXfs"),this.$xf=vu("xf").attr("numFmtId",0).attr("fontId",0).attr("fillId",0).attr("borderId",0),this.$cellXfs=vu("cellXfs").attr("count",0),this.$cellStyles=vu("cellStyles").append(vu("cellStyle").attr("name","Normal").attr("xfId",0).attr("builtinId",0)),this.$dxfs=vu("dxfs").attr("count","0"),this.$tableStyles=vu("tableStyles").attr("count","0").attr("defaultTableStyle","TableStyleMedium9").attr("defaultPivotStyle","PivotStyleMedium4"),this.$styles=vu("styleSheet").attr("xmlns:mc","http://schemas.openxmlformats.org/markup-compatibility/2006").attr("xmlns:x14ac","http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac").attr("xmlns","http://schemas.openxmlformats.org/spreadsheetml/2006/main").attr("mc:Ignorable","x14ac").prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>').append(this.$numFmts).append(this.$fonts).append(this.$fills).append(this.$borders).append(this.$cellStyleXfs.append(this.$xf)).append(this.$cellXfs).append(this.$cellStyles).append(this.$dxfs).append(this.$tableStyles);var t=e.defaultCellStyle||{};t.font||(t.font={name:"Calibri",sz:"11"}),t.font.name||(t.font.name="Calibri"),t.font.sz||(t.font.sz=11),t.fill||(t.fill={patternType:"none",fgColor:{}}),t.border||(t.border={}),t.numFmt||(t.numFmt=0),this.defaultStyle=t;e=JSON.parse(JSON.stringify(t));return e.fill={patternType:"gray125",fgColor:{}},this.addStyles([t,e]),this},addStyle:function(e){var t=JSON.stringify(e),r=s[t];return null==r?(r=this._addXf(e),s[t]=r):r=s[t],r},addStyles:function(e){var t=this;return e.map(function(e){return t.addStyle(e)})},_duckTypeStyle:function(e){return"object"==typeof e&&(e.patternFill||e.fgColor)?{fill:e}:e.font||e.numFmt||e.border||e.fill?e:this._getStyleCSS(e)},_getStyleCSS:function(e){return e},_addXf:function(e){var t=this._addFont(e.font),r=this._addFill(e.fill),a=this._addBorder(e.border),n=this._addNumFmt(e.numFmt),s=vu("xf").attr("numFmtId",n).attr("fontId",t).attr("fillId",r).attr("borderId",a).attr("xfId","0");0<t&&s.attr("applyFont","1"),0<r&&s.attr("applyFill","1"),0<a&&s.attr("applyBorder","1"),0<n&&s.attr("applyNumberFormat","1"),e.alignment&&(n=vu("alignment"),e.alignment.horizontal&&n.attr("horizontal",e.alignment.horizontal),e.alignment.vertical&&n.attr("vertical",e.alignment.vertical),e.alignment.indent&&n.attr("indent",e.alignment.indent),e.alignment.readingOrder&&n.attr("readingOrder",e.alignment.readingOrder),e.alignment.wrapText&&n.attr("wrapText",e.alignment.wrapText),null!=e.alignment.textRotation&&n.attr("textRotation",e.alignment.textRotation),s.append(n).attr("applyAlignment",1)),this.$cellXfs.append(s);s=+this.$cellXfs.children().length;return this.$cellXfs.attr("count",s),s-1},_addFont:function(e){if(!e)return 0;var t=vu("font").append(vu("sz").attr("val",e.sz||this.defaultStyle.font.sz)).append(vu("name").attr("val",e.name||this.defaultStyle.font.name));e.bold&&t.append(vu("b")),e.underline&&t.append(vu("u")),e.italic&&t.append(vu("i")),e.strike&&t.append(vu("strike")),e.outline&&t.append(vu("outline")),e.shadow&&t.append(vu("shadow")),e.vertAlign&&t.append(vu("vertAlign").attr("val",e.vertAlign)),e.color&&(e.color.theme?(t.append(vu("color").attr("theme",e.color.theme)),e.color.tint&&t.append(vu("tint").attr("theme",e.color.tint))):e.color.rgb&&t.append(vu("color").attr("rgb",e.color.rgb))),this.$fonts.append(t);t=this.$fonts.children().length;return this.$fonts.attr("count",t),t-1},_addNumFmt:function(e){if(!e)return 0;if("string"==typeof e){var t=n[e];if(0<=t)return t}if(/^[0-9]+$/.exec(e))return e;e=e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;");e=vu("numFmt").attr("numFmtId",++r).attr("formatCode",e);this.$numFmts.append(e);e=this.$numFmts.children().length;return this.$numFmts.attr("count",e),r},_addFill:function(e){if(!e)return 0;var t,r=vu("patternFill").attr("patternType",e.patternType||"solid");e.fgColor&&(t=vu("fgColor"),e.fgColor.rgb?(6==e.fgColor.rgb.length&&(e.fgColor.rgb="FF"+e.fgColor.rgb),t.attr("rgb",e.fgColor.rgb),r.append(t)):e.fgColor.theme&&(t.attr("theme",e.fgColor.theme),e.fgColor.tint&&t.attr("tint",e.fgColor.tint),r.append(t)),e.bgColor||(e.bgColor={indexed:"64"})),e.bgColor&&(e=vu("bgColor").attr(e.bgColor),r.append(e));r=vu("fill").append(r);this.$fills.append(r);r=this.$fills.children().length;return this.$fills.attr("count",r),r-1},_getSubBorder:function(e,t){var r=vu(e);return t&&(r.attr("style",t.style||"medium"),t.color&&(e=vu("color"),t.color.auto?e.attr("auto",t.color.auto):t.color.rgb?e.attr("rgb",t.color.rgb):(t.color.theme||t.color.tint)&&(e.attr("theme",t.color.theme||"1"),e.attr("tint",t.color.tint||"0")),r.append(e))),r},_addBorder:function(t){if(!t)return 0;var r=this,a=vu("border").attr("diagonalUp",t.diagonalUp).attr("diagonalDown",t.diagonalDown);["left","right","top","bottom","diagonal"].forEach(function(e){a.append(r._getSubBorder(e,t[e]))}),this.$borders.append(a);var e=this.$borders.children().length;return this.$borders.attr("count",e),e-1},toXml:function(){return this.$styles.toXml()}}.initialize(e||{})};void 0!==Nf&&(a.parse_xlscfb=Nf),a.parse_zip=zh,a.read=Kh,a.readFile=Jh,a.readFileSync=Jh,a.write=ru,a.writeFile=nu,a.writeFileSync=nu,a.writeFileAsync=function(e,t,r,a){var n=r||{};return n.type="file",n.file=e,au(n),n.type="buffer",a instanceof Function||(a=r),Se.writeFile(e,ru(t,n),a)},a.utils=Es,a.writeXLSX=tu,a.writeFileXLSX=function(e,t,r){return(r=r||{}).type="file",r.file=t,au(r),tu(e,r)},a.SSF=e,void 0!==is&&(a.stream=is),void 0!==xe&&(a.CFB=xe),"undefined"=="function"||((is=__webpack_require__(1187))||{}).Readable&&bu(is.Readable)}if( true?make_xlsx_lib(exports):"undefined"!=typeof module&&module.exports?make_xlsx_lib(module.exports):"function"==typeof define&&define.amd?define("xlsx",function(){return XLSX.version||make_xlsx_lib(XLSX),XLSX}):make_xlsx_lib(XLSX),"undefined"!=typeof window&&!window.XLSX)try{window.XLSX=XLSX}catch(e){}
//# sourceMappingURL=xlsx.min.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(418).Buffer, __webpack_require__(1185)))

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1183 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1184 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W100 */
var cptable = {version:"1.15.0"};
cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[932] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
return {"enc": e, "dec": d }; })();
cptable[936] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
return {"enc": e, "dec": d }; })();
cptable[949] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
return {"enc": e, "dec": d }; })();
cptable[950] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
return {"enc": e, "dec": d }; })();
cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
return {"enc": e, "dec": d }; })();
cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[28591] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
// eslint-disable-next-line no-undef
if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ft=javascript: */
/*jshint newcap: false */
(function(root, factory) {
  /*jshint ignore:start */
  /*eslint-disable */
  "use strict";
  if(typeof cptable === "undefined") {
    if(true){
      var cpt = cptable;
      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
      else root.cptable = factory(cpt);
    } else throw new Error("cptable not found");
  } else cptable = factory(cptable);
  /*eslint-enable */
  /*jshint ignore:end */
}(this, function(cpt){
  "use strict";
  /*global module, Buffer */
  var magic = {
    "1200":"utf16le",
    "1201":"utf16be",
    "12000":"utf32le",
    "12001":"utf32be",
    "16969":"utf64le",
    "20127":"ascii",
    "65000":"utf7",
    "65001":"utf8"
  };

  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
  var dbcs_cache = [932,936,949,950];
  var magic_cache = [65001];
  var magic_decode = {};
  var magic_encode = {};
  var cpdcache = {};
  var cpecache = {};

  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
  var cca = function cca(x) { return x.charCodeAt(0); };

  var has_buf = (typeof Buffer !== 'undefined');
  var Buffer_from = function(){};
  if(has_buf) {
    var nbfs = !Buffer.from;
    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
    // $FlowIgnore
    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };

    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
    var make_EE = function make_EE(E){
      var EE = Buffer.allocUnsafe(65536);
      for(var i = 0; i < 65536;++i) EE[i] = 0;
      var keys = Object.keys(E), len = keys.length;
      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
        if(!(e = keys[ee])) continue;
        EE[e.charCodeAt(0)] = E[e];
      }
      return EE;
    };
    var sbcs_encode = function make_sbcs_encode(cp) {
      var EE = make_EE(cpt[cp].enc);
      return function sbcs_e(data, ofmt) {
        var len = data.length;
        var out, i=0, j=0, D=0, w=0;
        if(typeof data === 'string') {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
        } else if(Buffer.isBuffer(data)) {
          out = Buffer.allocUnsafe(2*len);
          j = 0;
          for(i = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) out[j++] = EE[D];
            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
            else {
              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
              if(w < 65536) out[j++] = EE[w];
              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
            }
          }
          out = out.slice(0,j);
        } else {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var sbcs_decode = function make_sbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c="";
      for(d=0;d<D.length;++d) {
        if(!(c=D[d])) continue;
        var w = c.charCodeAt(0);
        DD[2*d] = w&255; DD[2*d+1] = w>>8;
      }
      return function sbcs_d(data) {
        var len = data.length, i=0, j=0;
        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        }
        return mdb.slice(0, 2 * len).toString('ucs2');
      };
    };
    var dbcs_encode = function make_dbcs_encode(cp) {
      var E = cpt[cp].enc;
      var EE = Buffer.allocUnsafe(131072);
      for(var i = 0; i < 131072; ++i) EE[i] = 0;
      var keys = Object.keys(E);
      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
        if(!(e = keys[ee])) continue;
        var f = e.charCodeAt(0);
        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
      }
      return function dbcs_e(data, ofmt) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
        if(typeof data === 'string') {
          for(i = k = 0; i < len; ++i) {
            j = data.charCodeAt(i)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
          out = out.slice(0,k);
        } else if(Buffer.isBuffer(data)) {
          for(i = k = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) j = D;
            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
            else { jj = j-65536;
              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
            }
          }
          out = out.slice(0,k);
        } else {
          for(i = k = 0; i < len; i++) {
            j = data[i].charCodeAt(0)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var dbcs_decode = function make_dbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
      for(d = 0; d < D.length; ++d) {
        if(!(c=D[d])) continue;
        w = c.charCodeAt(0);
        j = 2*d;
        DD[j] = w&255; DD[j+1] = w>>8;
      }
      return function dbcs_d(data) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        }
        return out.slice(0,k).toString('ucs2');
      };
    };
    magic_decode[65001] = function utf8_d(data) {
      if(typeof data === "string") return utf8_d(data.split("").map(cca));
      var len = data.length, w = 0, ww = 0;
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      var i = 0;
      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
        j = 1; D = data[i];
        if(D < 128) w = D;
        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
        else {
          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
        }
      }
      return mdb.slice(0,k).toString('ucs2');
    };
    magic_encode[65001] = function utf8_e(data, ofmt) {
      if(has_buf && Buffer.isBuffer(data)) {
        if(!ofmt || ofmt === 'buf') return data;
        if(ofmt !== 'arr') return data.toString('binary');
        return [].slice.call(data);
      }
      var len = data.length, w = 0, ww = 0, j = 0;
      var direct = typeof data === "string";
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      for(var i = 0; i < len; ++i) {
        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
        if(w <= 0x007F) mdb[j++] = w;
        else if(w <= 0x07FF) {
          mdb[j++] = 192 + (w >> 6);
          mdb[j++] = 128 + (w&63);
        } else if(w >= 0xD800 && w <= 0xDFFF) {
          w -= 0xD800; ++i;
          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
          mdb[j++] = 240 + ((ww>>>18) & 0x07);
          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
          mdb[j++] = 128 + (ww & 0x3F);
        } else {
          mdb[j++] = 224 + (w >> 12);
          mdb[j++] = 128 + ((w >> 6)&63);
          mdb[j++] = 128 + (w&63);
        }
      }
      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
      return [].slice.call(mdb, 0, j);
    };
  }

  var encache = function encache() {
    if(has_buf) {
      if(cpdcache[sbcs_cache[0]]) return;
      var i=0, s=0;
      for(i = 0; i < sbcs_cache.length; ++i) {
        s = sbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = sbcs_decode(s);
          cpecache[s] = sbcs_encode(s);
        }
      }
      for(i = 0; i < dbcs_cache.length; ++i) {
        s = dbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = dbcs_decode(s);
          cpecache[s] = dbcs_encode(s);
        }
      }
      for(i = 0; i < magic_cache.length; ++i) {
        s = magic_cache[i];
        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
        if(magic_encode[s]) cpecache[s] = magic_encode[s];
      }
    }
  };
  var null_enc = function(data, ofmt) { void ofmt; return ""; };
  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
  var decache = function decache() {
    if(has_buf) {
      if(!cpdcache[sbcs_cache[0]]) return;
      sbcs_cache.forEach(cp_decache);
      dbcs_cache.forEach(cp_decache);
      magic_cache.forEach(cp_decache);
    }
    last_enc = null_enc; last_cp = 0;
  };
  var cache = {
    encache: encache,
    decache: decache,
    sbcs: sbcs_cache,
    dbcs: dbcs_cache
  };

  encache();

  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
  var last_enc = null_enc, last_cp = 0;
  var encode = function encode(cp, data, ofmt) {
    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
    var len = data.length;
    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
    var C = cpt[cp], E, M = "";
    var isstr = typeof data === 'string';
    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
      w = E[isstr? data.charAt(i) : data[i]];
      if(w > 255) {
        out[j] = w>>8;
        out[++j] = w&255;
      } else out[j] = w&255;
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else if(w <= 0x07FF) {
            out[j]   = 192 + (w >> 6);
            out[++j] = 128 + (w&63);
          } else if(w >= 0xD800 && w <= 0xDFFF) {
            w -= 0xD800;
            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
            out[j]   = 240 + ((ww>>>18) & 0x07);
            out[++j] = 144 + ((ww>>>12) & 0x3F);
            out[++j] = 128 + ((ww>>>6) & 0x3F);
            out[++j] = 128 + (ww & 0x3F);
          } else {
            out[j]   = 224 + (w >> 12);
            out[++j] = 128 + ((w >> 6)&63);
            out[++j] = 128 + (w&63);
          }
        }
        break;
      case "ascii":
        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else throw new Error("bad ascii " + w);
        }
        break;
      case "utf16le":
        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w&255;
          out[j++] = w>>8;
        }
        break;
      case "utf16be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w>>8;
          out[j++] = w&255;
        }
        break;
      case "utf32le":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255;
        }
        break;
      case "utf32be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j+3] = w&255; w >>= 8;
          out[j+2] = w&255; w >>= 8;
          out[j+1] = w&255; w >>= 8;
          out[j] = w&255;
          j+=4;
        }
        break;
      case "utf7":
        for(i = 0; i < len; i++) {
          var c = isstr ? data.charAt(i) : data[i].charAt(0);
          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
          var tt = encode(1201, c);
          out[j++] = 0x2b;
          out[j++] = BM.charCodeAt(tt[0]>>2);
          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
          out[j++] = 0x2d;
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    out = out.slice(0,j);
    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
    if(!ofmt || ofmt === 'buf') return out;
    if(ofmt !== 'arr') return out.toString('binary');
    return [].slice.call(out);
  };
  var decode = function decode(cp, data) {
    var F; if((F=cpdcache[cp])) return F(data);
    if(typeof data === "string") return decode(cp, data.split("").map(cca));
    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
    var C = cpt[cp], D, M="";
    if(C && (D=C.dec)) {
      for(i = 0; i < len; i+=j) {
        j = 2;
        s = D[(data[i]<<8)+ data[i+1]];
        if(!s) {
          j = 1;
          s = D[data[i]];
        }
        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
        out[k++] = s;
      }
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
        for(; i < len; i+=j) {
          j = 1;
          if(data[i] < 128) w = data[i];
          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
          if(w < 65536) { out[k++] = String.fromCharCode(w); }
          else {
            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
          }
        }
        break;
      case "ascii":
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
        k = len; break;
      case "utf16le":
        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
        }
        break;
      case "utf16be":
        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
        }
        break;
      case "utf32le":
        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf32be":
        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf7":
        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
        }
        for(; i < len; i+=j) {
          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
          j=1;
          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
          // eslint-disable-next-line no-useless-escape
          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
          var dash = 0;
          if(data[i+j] === 0x2d) { ++j; dash=1; }
          var tt = [];
          var o64 = "";
          var c1=0, c2=0, c3=0;
          var e1=0, e2=0, e3=0, e4=0;
          for(var l = 1; l < j - dash;) {
            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
            c1 = e1 << 2 | e2 >> 4;
            tt.push(c1);
            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e3 === -1) break;
            c2 = (e2 & 15) << 4 | e3 >> 2;
            tt.push(c2);
            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e4 === -1) break;
            c3 = (e3 & 3) << 6 | e4;
            if(e4 < 64) tt.push(c3);
          }
          o64 = decode(1201, tt);
          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    return out.slice(0,k).join("");
  };
  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
  return cpt;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(418).Buffer))

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

/*
 Highcharts JS v6.0.4 (2017-12-15)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(x){"object"===typeof module&&module.exports?module.exports=x:x(Highcharts)})(function(x){(function(a){var t=a.deg2rad,v=a.isNumber,w=a.pick,n=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,e=this.chart,k=2*(a.slicedOffset||0),b=e.plotWidth-2*k,e=e.plotHeight-2*k,c=a.center,c=[w(c[0],"50%"),w(c[1],"50%"),a.size||"100%",a.innerSize||0],l=Math.min(b,e),g,d;for(g=0;4>g;++g)d=c[g],a=2>g||2===g&&/%$/.test(d),c[g]=n(d,[b,e,l,c[2]][g])+(a?k:0);c[3]>c[2]&&(c[3]=c[2]);
return c},getStartAndEndRadians:function(a,e){a=v(a)?a:0;e=v(e)&&e>a&&360>e-a?e:a+360;return{start:t*(a+-90),end:t*(e+-90)}}}})(x);(function(a){function t(a,b){this.init(a,b)}var v=a.CenteredSeriesMixin,w=a.each,n=a.extend,m=a.merge,e=a.splat;n(t.prototype,{coll:"pane",init:function(a,b){this.chart=b;this.background=[];b.pane.push(this);this.setOptions(a)},setOptions:function(a){this.options=m(this.defaultOptions,this.chart.angular?{background:{}}:void 0,a)},render:function(){var a=this.options,b=
this.options.background,c=this.chart.renderer;this.group||(this.group=c.g("pane-group").attr({zIndex:a.zIndex||0}).add());this.updateCenter();if(b)for(b=e(b),a=Math.max(b.length,this.background.length||0),c=0;c<a;c++)b[c]&&this.axis?this.renderBackground(m(this.defaultBackgroundOptions,b[c]),c):this.background[c]&&(this.background[c]=this.background[c].destroy(),this.background.splice(c,1))},renderBackground:function(a,b){var c="animate";this.background[b]||(this.background[b]=this.chart.renderer.path().add(this.group),
c="attr");this.background[b][c]({d:this.axis.getPlotBandPath(a.from,a.to,a)}).attr({fill:a.backgroundColor,stroke:a.borderColor,"stroke-width":a.borderWidth,"class":"highcharts-pane "+(a.className||"")})},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"},
updateCenter:function(a){this.center=(a||this.axis||{}).center=v.getCenter.call(this)},update:function(a,b){m(!0,this.options,a);this.setOptions(this.options);this.render();w(this.chart.axes,function(c){c.pane===this&&(c.pane=null,c.update({},b))},this)}});a.Pane=t})(x);(function(a){var t=a.each,v=a.extend,w=a.map,n=a.merge,m=a.noop,e=a.pick,k=a.pInt,b=a.wrap,c,l,g=a.Axis.prototype;a=a.Tick.prototype;c={getOffset:m,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:m,setCategories:m,
setTitle:m};l={defaultRadialGaugeOptions:{labels:{align:"center",x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null,style:{textOverflow:"none"}},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",
x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(b){b=this.options=n(this.defaultOptions,this.defaultRadialOptions,b);b.plotBands||(b.plotBands=[])},getOffset:function(){g.getOffset.call(this);this.chart.axisOffset[this.side]=0},getLinePath:function(b,c){b=this.center;var d=this.chart,f=e(c,b[2]/2-this.offset);this.isCircular||void 0!==c?(c=this.chart.renderer.symbols.arc(this.left+b[0],this.top+b[1],f,f,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}),
c.xBounds=[this.left+b[0]],c.yBounds=[this.top+b[1]-f]):(c=this.postTranslate(this.angleRad,f),c=["M",b[0]+d.plotLeft,b[1]+d.plotTop,"L",c.x,c.y]);return c},setAxisTranslation:function(){g.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=this.isCircular&&
void 0===e(this.userMax,this.options.max)&&this.endAngleRad-this.startAngleRad===2*Math.PI)this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0},setAxisSize:function(){g.setAxisSize.call(this);this.isRadial&&(this.pane.updateCenter(this),this.isCircular&&(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=this.height=this.center[2]*e(this.sector,1)/2)},getPosition:function(b,c){return this.postTranslate(this.isCircular?this.translate(b):this.angleRad,e(this.isCircular?
c:this.translate(b),this.center[2]/2)-this.offset)},postTranslate:function(b,c){var d=this.chart,f=this.center;b=this.startAngleRad+b;return{x:d.plotLeft+f[0]+Math.cos(b)*c,y:d.plotTop+f[1]+Math.sin(b)*c}},getPlotBandPath:function(b,c,a){var d=this.center,f=this.startAngleRad,l=d[2]/2,h=[e(a.outerRadius,"100%"),a.innerRadius,e(a.thickness,10)],g=Math.min(this.offset,0),u=/%$/,m,n=this.isCircular;"polygon"===this.options.gridLineInterpolation?d=this.getPlotLinePath(b).concat(this.getPlotLinePath(c,
!0)):(b=Math.max(b,this.min),c=Math.min(c,this.max),n||(h[0]=this.translate(b),h[1]=this.translate(c)),h=w(h,function(b){u.test(b)&&(b=k(b,10)*l/100);return b}),"circle"!==a.shape&&n?(b=f+this.translate(b),c=f+this.translate(c)):(b=-Math.PI/2,c=1.5*Math.PI,m=!0),h[0]-=g,h[2]-=g,d=this.chart.renderer.symbols.arc(this.left+d[0],this.top+d[1],h[0],h[0],{start:Math.min(b,c),end:Math.max(b,c),innerR:e(h[1],h[0]-h[2]),open:m}));return d},getPlotLinePath:function(b,c){var d=this,f=d.center,a=d.chart,l=d.getPosition(b),
g,e,u;d.isCircular?u=["M",f[0]+a.plotLeft,f[1]+a.plotTop,"L",l.x,l.y]:"circle"===d.options.gridLineInterpolation?(b=d.translate(b))&&(u=d.getLinePath(0,b)):(t(a.xAxis,function(b){b.pane===d.pane&&(g=b)}),u=[],b=d.translate(b),f=g.tickPositions,g.autoConnect&&(f=f.concat([f[0]])),c&&(f=[].concat(f).reverse()),t(f,function(c,d){e=g.getPosition(c,b);u.push(d?"L":"M",e.x,e.y)}));return u},getTitlePosition:function(){var b=this.center,c=this.chart,a=this.options.title;return{x:c.plotLeft+b[0]+(a.x||0),
y:c.plotTop+b[1]-{high:.5,middle:.25,low:0}[a.align]*b[2]+(a.y||0)}}};b(g,"init",function(b,f,a){var d=f.angular,h=f.polar,g=a.isX,y=d&&g,m,u=f.options,k=a.pane||0,t=this.pane=f.pane&&f.pane[k],k=t&&t.options;if(d){if(v(this,y?c:l),m=!g)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else h&&(v(this,l),this.defaultRadialOptions=(m=g)?this.defaultRadialXOptions:n(this.defaultYAxisOptions,this.defaultRadialYOptions));d||h?(this.isRadial=!0,f.inverted=!1,u.chart.zoomType=null):this.isRadial=
!1;t&&m&&(t.axis=this);b.call(this,f,a);!y&&t&&(d||h)&&(b=this.options,this.angleRad=(b.angle||0)*Math.PI/180,this.startAngleRad=(k.startAngle-90)*Math.PI/180,this.endAngleRad=(e(k.endAngle,k.startAngle+360)-90)*Math.PI/180,this.offset=b.offset||0,this.isCircular=m)});b(g,"autoLabelAlign",function(b){if(!this.isRadial)return b.apply(this,[].slice.call(arguments,1))});b(a,"getPosition",function(b,c,a,l,g){var d=this.axis;return d.getPosition?d.getPosition(a):b.call(this,c,a,l,g)});b(a,"getLabelPosition",
function(b,c,a,l,g,r,y,m,u){var d=this.axis,f=r.y,h=20,p=r.align,q=(d.translate(this.pos)+d.startAngleRad+Math.PI/2)/Math.PI*180%360;d.isRadial?(b=d.getPosition(this.pos,d.center[2]/2+e(r.distance,-25)),"auto"===r.rotation?l.attr({rotation:q}):null===f&&(f=d.chart.renderer.fontMetrics(l.styles.fontSize).b-l.getBBox().height/2),null===p&&(d.isCircular?(this.label.getBBox().width>d.len*d.tickInterval/(d.max-d.min)&&(h=0),p=q>h&&q<180-h?"left":q>180+h&&q<360-h?"right":"center"):p="center",l.attr({align:p})),
b.x+=r.x,b.y+=f):b=b.call(this,c,a,l,g,r,y,m,u);return b});b(a,"getMarkPath",function(b,c,a,l,g,r,e){var d=this.axis;d.isRadial?(b=d.getPosition(this.pos,d.center[2]/2+l),c=["M",c,a,"L",b.x,b.y]):c=b.call(this,c,a,l,g,r,e);return c})})(x);(function(a){var t=a.each,v=a.pick,w=a.defined,n=a.seriesType,m=a.seriesTypes,e=a.Series.prototype,k=a.Point.prototype;n("arearange","area",{lineWidth:1,threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{series.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},
trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0}},{pointArrayMap:["low","high"],dataLabelCollections:["dataLabel","dataLabelUpper"],toYData:function(b){return[b.low,b.high]},pointValKey:"low",deferTranslatePolar:!0,highToXY:function(b){var c=this.chart,a=this.xAxis.postTranslate(b.rectPlotX,this.yAxis.len-b.plotHigh);b.plotHighX=a.x-c.plotLeft;b.plotHigh=a.y-c.plotTop;b.plotLowX=b.plotX},translate:function(){var b=this,c=b.yAxis,a=!!b.modifyValue;m.area.prototype.translate.apply(b);
t(b.points,function(l){var d=l.low,f=l.high,h=l.plotY;null===f||null===d?(l.isNull=!0,l.plotY=null):(l.plotLow=h,l.plotHigh=c.translate(a?b.modifyValue(f,l):f,0,1,0,1),a&&(l.yBottom=l.plotHigh))});this.chart.polar&&t(this.points,function(c){b.highToXY(c);c.tooltipPos=[(c.plotHighX+c.plotLowX)/2,(c.plotHigh+c.plotLow)/2]})},getGraphPath:function(b){var c=[],a=[],g,d=m.area.prototype.getGraphPath,f,h,q;q=this.options;var p=this.chart.polar&&!1!==q.connectEnds,r=q.connectNulls,e=q.step;b=b||this.points;
for(g=b.length;g--;)f=b[g],f.isNull||p||r||b[g+1]&&!b[g+1].isNull||a.push({plotX:f.plotX,plotY:f.plotY,doCurve:!1}),h={polarPlotY:f.polarPlotY,rectPlotX:f.rectPlotX,yBottom:f.yBottom,plotX:v(f.plotHighX,f.plotX),plotY:f.plotHigh,isNull:f.isNull},a.push(h),c.push(h),f.isNull||p||r||b[g-1]&&!b[g-1].isNull||a.push({plotX:f.plotX,plotY:f.plotY,doCurve:!1});b=d.call(this,b);e&&(!0===e&&(e="left"),q.step={left:"right",center:"center",right:"left"}[e]);c=d.call(this,c);a=d.call(this,a);q.step=e;q=[].concat(b,
c);this.chart.polar||"M"!==a[0]||(a[0]="L");this.graphPath=q;this.areaPath=b.concat(a);q.isArea=!0;q.xMap=b.xMap;this.areaPath.xMap=b.xMap;return q},drawDataLabels:function(){var b=this.data,c=b.length,a,g=[],d=this.options.dataLabels,f=d.align,h=d.verticalAlign,q=d.inside,p,r,y=this.chart.inverted;if(d.enabled||this._hasPointLabels){for(a=c;a--;)if(p=b[a])r=q?p.plotHigh<p.plotLow:p.plotHigh>p.plotLow,p.y=p.high,p._plotY=p.plotY,p.plotY=p.plotHigh,g[a]=p.dataLabel,p.dataLabel=p.dataLabelUpper,p.below=
r,y?f||(d.align=r?"right":"left"):h||(d.verticalAlign=r?"top":"bottom"),d.x=d.xHigh,d.y=d.yHigh;e.drawDataLabels&&e.drawDataLabels.apply(this,arguments);for(a=c;a--;)if(p=b[a])r=q?p.plotHigh<p.plotLow:p.plotHigh>p.plotLow,p.dataLabelUpper=p.dataLabel,p.dataLabel=g[a],p.y=p.low,p.plotY=p._plotY,p.below=!r,y?f||(d.align=r?"left":"right"):h||(d.verticalAlign=r?"bottom":"top"),d.x=d.xLow,d.y=d.yLow;e.drawDataLabels&&e.drawDataLabels.apply(this,arguments)}d.align=f;d.verticalAlign=h},alignDataLabel:function(){m.column.prototype.alignDataLabel.apply(this,
arguments)},drawPoints:function(){var b=this.points.length,c,a;e.drawPoints.apply(this,arguments);for(a=0;a<b;)c=this.points[a],c.lowerGraphic=c.graphic,c.graphic=c.upperGraphic,c._plotY=c.plotY,c._plotX=c.plotX,c.plotY=c.plotHigh,w(c.plotHighX)&&(c.plotX=c.plotHighX),a++;e.drawPoints.apply(this,arguments);for(a=0;a<b;)c=this.points[a],c.upperGraphic=c.graphic,c.graphic=c.lowerGraphic,c.plotY=c._plotY,c.plotX=c._plotX,a++},setStackedPoints:a.noop},{setState:function(){var b=this.state,c=this.series,
a=c.chart.polar;w(this.plotHigh)||(this.plotHigh=c.yAxis.toPixels(this.high,!0));w(this.plotLow)||(this.plotLow=this.plotY=c.yAxis.toPixels(this.low,!0));k.setState.apply(this,arguments);this.graphic=this.upperGraphic;this.plotY=this.plotHigh;a&&(this.plotX=this.plotHighX);this.state=b;c.stateMarkerGraphic&&(c.lowerStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.upperStateMarkerGraphic);k.setState.apply(this,arguments);this.plotY=this.plotLow;this.graphic=this.lowerGraphic;a&&(this.plotX=
this.plotLowX);c.stateMarkerGraphic&&(c.upperStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.lowerStateMarkerGraphic,c.lowerStateMarkerGraphic=void 0)},haloPath:function(){var b=this.series.chart.polar,c;this.plotY=this.plotLow;b&&(this.plotX=this.plotLowX);c=k.haloPath.apply(this,arguments);this.plotY=this.plotHigh;b&&(this.plotX=this.plotHighX);return c=c.concat(k.haloPath.apply(this,arguments))},destroy:function(){this.upperGraphic&&(this.upperGraphic=this.upperGraphic.destroy());
return k.destroy.apply(this,arguments)}})})(x);(function(a){var t=a.seriesType;t("areasplinerange","arearange",null,{getPointSpline:a.seriesTypes.spline.prototype.getPointSpline})})(x);(function(a){var t=a.defaultPlotOptions,v=a.each,w=a.merge,n=a.noop,m=a.pick,e=a.seriesType,k=a.seriesTypes.column.prototype;e("columnrange","arearange",w(t.column,t.arearange,{pointRange:null,marker:null,states:{hover:{halo:!1}}}),{translate:function(){var b=this,c=b.yAxis,a=b.xAxis,g=a.startAngleRad,d,f=b.chart,h=
b.xAxis.isRadial,q=Math.max(f.chartWidth,f.chartHeight)+999,p;k.translate.apply(b);v(b.points,function(l){var r=l.shapeArgs,e=b.options.minPointLength,u,k;l.plotHigh=p=Math.min(Math.max(-q,c.translate(l.high,0,1,0,1)),q);l.plotLow=Math.min(Math.max(-q,l.plotY),q);k=p;u=m(l.rectPlotY,l.plotY)-p;Math.abs(u)<e?(e-=u,u+=e,k-=e/2):0>u&&(u*=-1,k-=u);h?(d=l.barX+g,l.shapeType="path",l.shapeArgs={d:b.polarArc(k+u,k,d,d+l.pointWidth)}):(r.height=u,r.y=k,l.tooltipPos=f.inverted?[c.len+c.pos-f.plotLeft-k-u/
2,a.len+a.pos-f.plotTop-r.x-r.width/2,u]:[a.left-f.plotLeft+r.x+r.width/2,c.pos-f.plotTop+k+u/2,u])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:n,getSymbol:n,crispCol:k.crispCol,drawPoints:k.drawPoints,drawTracker:k.drawTracker,getColumnMetrics:k.getColumnMetrics,pointAttribs:k.pointAttribs,animate:function(){return k.animate.apply(this,arguments)},polarArc:function(){return k.polarArc.apply(this,arguments)},translate3dPoints:function(){return k.translate3dPoints.apply(this,
arguments)},translate3dShapes:function(){return k.translate3dShapes.apply(this,arguments)}},{setState:k.pointClass.prototype.setState})})(x);(function(a){var t=a.each,v=a.isNumber,w=a.merge,n=a.pick,m=a.pInt,e=a.Series,k=a.seriesType,b=a.TrackerMixin;k("gauge","line",{dataLabels:{enabled:!0,defer:!1,y:15,borderRadius:3,crop:!1,verticalAlign:"top",zIndex:2,borderWidth:1,borderColor:"#cccccc"},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},{angular:!0,directTouch:!0,drawGraph:a.noop,fixedBox:!0,
forceDL:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var b=this.yAxis,a=this.options,g=b.center;this.generatePoints();t(this.points,function(c){var d=w(a.dial,c.dial),l=m(n(d.radius,80))*g[2]/200,q=m(n(d.baseLength,70))*l/100,p=m(n(d.rearLength,10))*l/100,r=d.baseWidth||3,e=d.topWidth||1,k=a.overshoot,u=b.startAngleRad+b.translate(c.y,null,null,null,!0);v(k)?(k=k/180*Math.PI,u=Math.max(b.startAngleRad-k,Math.min(b.endAngleRad+k,u))):!1===a.wrap&&(u=Math.max(b.startAngleRad,
Math.min(b.endAngleRad,u)));u=180*u/Math.PI;c.shapeType="path";c.shapeArgs={d:d.path||["M",-p,-r/2,"L",q,-r/2,l,-e/2,l,e/2,q,r/2,-p,r/2,"z"],translateX:g[0],translateY:g[1],rotation:u};c.plotX=g[0];c.plotY=g[1]})},drawPoints:function(){var b=this,a=b.yAxis.center,g=b.pivot,d=b.options,f=d.pivot,h=b.chart.renderer;t(b.points,function(c){var a=c.graphic,f=c.shapeArgs,l=f.d,g=w(d.dial,c.dial);a?(a.animate(f),f.d=l):(c.graphic=h[c.shapeType](f).attr({rotation:f.rotation,zIndex:1}).addClass("highcharts-dial").add(b.group),
c.graphic.attr({stroke:g.borderColor||"none","stroke-width":g.borderWidth||0,fill:g.backgroundColor||"#000000"}))});g?g.animate({translateX:a[0],translateY:a[1]}):(b.pivot=h.circle(0,0,n(f.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(a[0],a[1]).add(b.group),b.pivot.attr({"stroke-width":f.borderWidth||0,stroke:f.borderColor||"#cccccc",fill:f.backgroundColor||"#000000"}))},animate:function(b){var c=this;b||(t(c.points,function(b){var a=b.graphic;a&&(a.attr({rotation:180*c.yAxis.startAngleRad/
Math.PI}),a.animate({rotation:b.shapeArgs.rotation},c.options.animation))}),c.animate=null)},render:function(){this.group=this.plotGroup("group","series",this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);e.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(b,a){e.prototype.setData.call(this,b,!1);this.processData();this.generatePoints();n(a,!0)&&this.chart.redraw()},drawTracker:b&&b.drawTrackerPoint},{setState:function(b){this.state=b}})})(x);
(function(a){var t=a.each,v=a.noop,w=a.pick,n=a.seriesType,m=a.seriesTypes;n("boxplot","column",{threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eMaximum: {point.high}\x3cbr/\x3eUpper quartile: {point.q3}\x3cbr/\x3eMedian: {point.median}\x3cbr/\x3eLower quartile: {point.q1}\x3cbr/\x3eMinimum: {point.low}\x3cbr/\x3e'},whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,states:{hover:{brightness:-.3}},
whiskerWidth:2},{pointArrayMap:["low","q1","median","q3","high"],toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:"high",pointAttribs:function(a){var e=this.options,b=a&&a.color||this.color;return{fill:a.fillColor||e.fillColor||b,stroke:e.lineColor||b,"stroke-width":e.lineWidth||0}},drawDataLabels:v,translate:function(){var a=this.yAxis,k=this.pointArrayMap;m.column.prototype.translate.apply(this);t(this.points,function(b){t(k,function(c){null!==b[c]&&(b[c+"Plot"]=a.translate(b[c],
0,1,0,1))})})},drawPoints:function(){var a=this,k=a.options,b=a.chart.renderer,c,l,g,d,f,h,q=0,p,r,m,n,u=!1!==a.doQuartiles,v,A=a.options.whiskerLength;t(a.points,function(e){var y=e.graphic,t=y?"animate":"attr",J=e.shapeArgs,x={},C={},H={},I=e.color||a.color;void 0!==e.plotY&&(p=J.width,r=Math.floor(J.x),m=r+p,n=Math.round(p/2),c=Math.floor(u?e.q1Plot:e.lowPlot),l=Math.floor(u?e.q3Plot:e.lowPlot),g=Math.floor(e.highPlot),d=Math.floor(e.lowPlot),y||(e.graphic=y=b.g("point").add(a.group),e.stem=b.path().addClass("highcharts-boxplot-stem").add(y),
A&&(e.whiskers=b.path().addClass("highcharts-boxplot-whisker").add(y)),u&&(e.box=b.path(void 0).addClass("highcharts-boxplot-box").add(y)),e.medianShape=b.path(void 0).addClass("highcharts-boxplot-median").add(y)),x.stroke=e.stemColor||k.stemColor||I,x["stroke-width"]=w(e.stemWidth,k.stemWidth,k.lineWidth),x.dashstyle=e.stemDashStyle||k.stemDashStyle,e.stem.attr(x),A&&(C.stroke=e.whiskerColor||k.whiskerColor||I,C["stroke-width"]=w(e.whiskerWidth,k.whiskerWidth,k.lineWidth),e.whiskers.attr(C)),u&&
(y=a.pointAttribs(e),e.box.attr(y)),H.stroke=e.medianColor||k.medianColor||I,H["stroke-width"]=w(e.medianWidth,k.medianWidth,k.lineWidth),e.medianShape.attr(H),h=e.stem.strokeWidth()%2/2,q=r+n+h,e.stem[t]({d:["M",q,l,"L",q,g,"M",q,c,"L",q,d]}),u&&(h=e.box.strokeWidth()%2/2,c=Math.floor(c)+h,l=Math.floor(l)+h,r+=h,m+=h,e.box[t]({d:["M",r,l,"L",r,c,"L",m,c,"L",m,l,"L",r,l,"z"]})),A&&(h=e.whiskers.strokeWidth()%2/2,g+=h,d+=h,v=/%$/.test(A)?n*parseFloat(A)/100:A/2,e.whiskers[t]({d:["M",q-v,g,"L",q+v,
g,"M",q-v,d,"L",q+v,d]})),f=Math.round(e.medianPlot),h=e.medianShape.strokeWidth()%2/2,f+=h,e.medianShape[t]({d:["M",r,f,"L",m,f]}))})},setStackedPoints:v})})(x);(function(a){var t=a.each,v=a.noop,w=a.seriesType,n=a.seriesTypes;w("errorbar","boxplot",{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},whiskerWidth:null},{type:"errorbar",
pointArrayMap:["low","high"],toYData:function(a){return[a.low,a.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:n.arearange?function(){var a=this.pointValKey;n.arearange.prototype.drawDataLabels.call(this);t(this.data,function(e){e.y=e[a]})}:v,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||n.column.prototype.getColumnMetrics.call(this)}})})(x);(function(a){var t=a.correctFloat,v=a.isNumber,w=a.pick,n=a.Point,m=a.Series,e=a.seriesType,k=a.seriesTypes;
e("waterfall","column",{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"dot",borderColor:"#333333",states:{hover:{lineWidthPlus:0}}},{pointValKey:"y",translate:function(){var b=this.options,c=this.yAxis,a,g,d,f,h,e,p,r,m,n,u=w(b.minPointLength,5),v=u/2,x=b.threshold,D=b.stacking,z;k.column.prototype.translate.apply(this);r=m=x;g=this.points;a=0;for(b=g.length;a<b;a++)d=g[a],p=this.processedYData[a],f=d.shapeArgs,h=D&&c.stacks[(this.negStacks&&p<x?"-":"")+this.stackKey],z=this.getStackIndicator(z,
d.x,this.index),n=h?h[d.x].points[z.key]:[0,p],d.isSum?d.y=t(p):d.isIntermediateSum&&(d.y=t(p-m)),e=Math.max(r,r+d.y)+n[0],f.y=c.translate(e,0,1,0,1),d.isSum?(f.y=c.translate(n[1],0,1,0,1),f.height=Math.min(c.translate(n[0],0,1,0,1),c.len)-f.y):d.isIntermediateSum?(f.y=c.translate(n[1],0,1,0,1),f.height=Math.min(c.translate(m,0,1,0,1),c.len)-f.y,m=n[1]):(f.height=0<p?c.translate(r,0,1,0,1)-f.y:c.translate(r,0,1,0,1)-c.translate(r-p,0,1,0,1),r+=h&&h[d.x]?h[d.x].total:p),0>f.height&&(f.y+=f.height,
f.height*=-1),d.plotY=f.y=Math.round(f.y)-this.borderWidth%2/2,f.height=Math.max(Math.round(f.height),.001),d.yBottom=f.y+f.height,f.height<=u&&!d.isNull?(f.height=u,f.y-=v,d.plotY=f.y,d.minPointLengthOffset=0>d.y?-v:v):d.minPointLengthOffset=0,f=d.plotY+(d.negative?f.height:0),this.chart.inverted?d.tooltipPos[0]=c.len-f:d.tooltipPos[1]=f},processData:function(b){var c=this.yData,a=this.options.data,e,d=c.length,f,h,q,p,r,k;h=f=q=p=this.options.threshold||0;for(k=0;k<d;k++)r=c[k],e=a&&a[k]?a[k]:{},
"sum"===r||e.isSum?c[k]=t(h):"intermediateSum"===r||e.isIntermediateSum?c[k]=t(f):(h+=r,f+=r),q=Math.min(h,q),p=Math.max(h,p);m.prototype.processData.call(this,b);this.options.stacking||(this.dataMin=q,this.dataMax=p)},toYData:function(b){return b.isSum?0===b.x?null:"sum":b.isIntermediateSum?0===b.x?null:"intermediateSum":b.y},pointAttribs:function(b,a){var c=this.options.upColor;c&&!b.options.color&&(b.color=0<b.y?c:null);b=k.column.prototype.pointAttribs.call(this,b,a);delete b.dashstyle;return b},
getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var b=this.data,a=b.length,e=this.graph.strokeWidth()+this.borderWidth,e=Math.round(e)%2/2,g=this.yAxis.reversed,d=[],f,h,q;for(q=1;q<a;q++){h=b[q].shapeArgs;f=b[q-1].shapeArgs;h=["M",f.x+f.width,f.y+b[q-1].minPointLengthOffset+e,"L",h.x,f.y+b[q-1].minPointLengthOffset+e];if(0>b[q-1].y&&!g||0<b[q-1].y&&g)h[2]+=f.height,h[5]+=f.height;d=d.concat(h)}return d},drawGraph:function(){m.prototype.drawGraph.call(this);this.graph.attr({d:this.getCrispPath()})},
setStackedPoints:function(){var b=this.options,a,e;m.prototype.setStackedPoints.apply(this,arguments);a=this.stackedYData?this.stackedYData.length:0;for(e=1;e<a;e++)b.data[e].isSum||b.data[e].isIntermediateSum||(this.stackedYData[e]+=this.stackedYData[e-1])},getExtremes:function(){if(this.options.stacking)return m.prototype.getExtremes.apply(this,arguments)}},{getClassName:function(){var b=n.prototype.getClassName.call(this);this.isSum?b+=" highcharts-sum":this.isIntermediateSum&&(b+=" highcharts-intermediate-sum");
return b},isValid:function(){return v(this.y,!0)||this.isSum||this.isIntermediateSum}})})(x);(function(a){var t=a.Series,v=a.seriesType,w=a.seriesTypes;v("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var a=t.prototype.getGraphPath.call(this),m=a.length+1;m--;)(m===a.length||"M"===a[m])&&0<m&&a.splice(m,0,"z");return this.areaPath=a},drawGraph:function(){this.options.fillColor=
this.color;w.area.prototype.drawGraph.call(this)},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawTracker:t.prototype.drawTracker,setStackedPoints:a.noop})})(x);(function(a){var t=a.arrayMax,v=a.arrayMin,w=a.Axis,n=a.color,m=a.each,e=a.isNumber,k=a.noop,b=a.pick,c=a.pInt,l=a.Point,g=a.Series,d=a.seriesType,f=a.seriesTypes;d("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},marker:{lineColor:null,lineWidth:1,radius:null,states:{hover:{radiusPlus:0}},
symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,pointAttribs:function(a,c){var d=b(this.options.marker.fillOpacity,.5);a=g.prototype.pointAttribs.call(this,a,c);1!==d&&(a.fill=n(a.fill).setOpacity(d).get("rgba"));
return a},getRadii:function(b,a,c,d){var f,e,h,g=this.zData,l=[],p=this.options,r="width"!==p.sizeBy,q=p.zThreshold,k=a-b;e=0;for(f=g.length;e<f;e++)h=g[e],p.sizeByAbsoluteValue&&null!==h&&(h=Math.abs(h-q),a=Math.max(a-q,Math.abs(b-q)),b=0),null===h?h=null:h<b?h=c/2-1:(h=0<k?(h-b)/k:.5,r&&0<=h&&(h=Math.sqrt(h)),h=Math.ceil(c+h*(d-c))/2),l.push(h);this.radii=l},animate:function(b){var a=this.options.animation;b||(m(this.points,function(b){var c=b.graphic,d;c&&c.width&&(d={x:c.x,y:c.y,width:c.width,
height:c.height},c.attr({x:b.plotX,y:b.plotY,width:1,height:1}),c.animate(d,a))}),this.animate=null)},translate:function(){var b,c=this.data,d,g,l=this.radii;f.scatter.prototype.translate.call(this);for(b=c.length;b--;)d=c[b],g=l?l[b]:0,e(g)&&g>=this.minPxSize/2?(d.marker=a.extend(d.marker,{radius:g,width:2*g,height:2*g}),d.dlBox={x:d.plotX-g,y:d.plotY-g,width:2*g,height:2*g}):d.shapeArgs=d.plotY=d.dlBox=void 0},alignDataLabel:f.column.prototype.alignDataLabel,buildKDTree:k,applyZones:k},{haloPath:function(b){return l.prototype.haloPath.call(this,
0===b?0:(this.marker?this.marker.radius||0:0)+b)},ttBelow:!1});w.prototype.beforePadding=function(){var a=this,d=this.len,f=this.chart,g=0,l=d,k=this.isXAxis,n=k?"xData":"yData",w=this.min,x={},D=Math.min(f.plotWidth,f.plotHeight),z=Number.MAX_VALUE,E=-Number.MAX_VALUE,F=this.max-w,B=d/F,G=[];m(this.series,function(d){var e=d.options;!d.bubblePadding||!d.visible&&f.options.chart.ignoreHiddenSeries||(a.allowZoomOutside=!0,G.push(d),k&&(m(["minSize","maxSize"],function(b){var a=e[b],d=/%$/.test(a),
a=c(a);x[b]=d?D*a/100:a}),d.minPxSize=x.minSize,d.maxPxSize=Math.max(x.maxSize,x.minSize),d=d.zData,d.length&&(z=b(e.zMin,Math.min(z,Math.max(v(d),!1===e.displayNegative?e.zThreshold:-Number.MAX_VALUE))),E=b(e.zMax,Math.max(E,t(d))))))});m(G,function(b){var c=b[n],d=c.length,f;k&&b.getRadii(z,E,b.minPxSize,b.maxPxSize);if(0<F)for(;d--;)e(c[d])&&a.dataMin<=c[d]&&c[d]<=a.dataMax&&(f=b.radii[d],g=Math.min((c[d]-w)*B-f,g),l=Math.max((c[d]-w)*B+f,l))});G.length&&0<F&&!this.isLog&&(l-=d,B*=(d+g-l)/d,m([["min",
"userMin",g],["max","userMax",l]],function(c){void 0===b(a.options[c[0]],a[c[1]])&&(a[c[0]]+=c[2]/B)}))}})(x);(function(a){function t(b,a){var c=this.chart,e=this.options.animation,d=this.group,f=this.markerGroup,h=this.xAxis.center,k=c.plotLeft,p=c.plotTop;c.polar?c.renderer.isSVG&&(!0===e&&(e={}),a?(b={translateX:h[0]+k,translateY:h[1]+p,scaleX:.001,scaleY:.001},d.attr(b),f&&f.attr(b)):(b={translateX:k,translateY:p,scaleX:1,scaleY:1},d.animate(b,e),f&&f.animate(b,e),this.animate=null)):b.call(this,
a)}var v=a.each,w=a.pick,n=a.seriesTypes,m=a.wrap,e=a.Series.prototype,k=a.Pointer.prototype;e.searchPointByAngle=function(b){var a=this.chart,e=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(b.chartX-e[0]-a.plotLeft,b.chartY-e[1]-a.plotTop)})};e.getConnectors=function(b,a,e,g){var c,f,h,l,k,m,n,t;f=g?1:0;c=0<=a&&a<=b.length-1?a:0>a?b.length-1+a:0;a=0>c-1?b.length-(1+f):c-1;f=c+1>b.length-1?f:c+1;h=b[a];f=b[f];l=h.plotX;h=h.plotY;k=f.plotX;m=f.plotY;f=b[c].plotX;
c=b[c].plotY;l=(1.5*f+l)/2.5;h=(1.5*c+h)/2.5;k=(1.5*f+k)/2.5;n=(1.5*c+m)/2.5;m=Math.sqrt(Math.pow(l-f,2)+Math.pow(h-c,2));t=Math.sqrt(Math.pow(k-f,2)+Math.pow(n-c,2));l=Math.atan2(h-c,l-f);n=Math.PI/2+(l+Math.atan2(n-c,k-f))/2;Math.abs(l-n)>Math.PI/2&&(n-=Math.PI);l=f+Math.cos(n)*m;h=c+Math.sin(n)*m;k=f+Math.cos(Math.PI+n)*t;n=c+Math.sin(Math.PI+n)*t;f={rightContX:k,rightContY:n,leftContX:l,leftContY:h,plotX:f,plotY:c};e&&(f.prevPointCont=this.getConnectors(b,a,!1,g));return f};m(e,"buildKDTree",
function(b){this.chart.polar&&(this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.options.findNearestPointBy="xy");b.apply(this)});e.toXY=function(b){var a,e=this.chart,g=b.plotX;a=b.plotY;b.rectPlotX=g;b.rectPlotY=a;a=this.xAxis.postTranslate(b.plotX,this.yAxis.len-a);b.plotX=b.polarPlotX=a.x-e.plotLeft;b.plotY=b.polarPlotY=a.y-e.plotTop;this.kdByAngle?(e=(g/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>e&&(e+=360),b.clientX=e):b.clientX=b.plotX};n.spline&&(m(n.spline.prototype,
"getPointSpline",function(b,a,e,g){this.chart.polar?g?(b=this.getConnectors(a,g,!0,this.connectEnds),b=["C",b.prevPointCont.rightContX,b.prevPointCont.rightContY,b.leftContX,b.leftContY,b.plotX,b.plotY]):b=["M",e.plotX,e.plotY]:b=b.call(this,a,e,g);return b}),n.areasplinerange&&(n.areasplinerange.prototype.getPointSpline=n.spline.prototype.getPointSpline));m(e,"translate",function(b){var a=this.chart;b.call(this);if(a.polar&&(this.kdByAngle=a.tooltip&&a.tooltip.shared,!this.preventPostTranslate))for(b=
this.points,a=b.length;a--;)this.toXY(b[a])});m(e,"getGraphPath",function(b,a){var c=this,e,d,f;if(this.chart.polar){a=a||this.points;for(e=0;e<a.length;e++)if(!a[e].isNull){d=e;break}!1!==this.options.connectEnds&&void 0!==d&&(this.connectEnds=!0,a.splice(a.length,0,a[d]),f=!0);v(a,function(b){void 0===b.polarPlotY&&c.toXY(b)})}e=b.apply(this,[].slice.call(arguments,1));f&&a.pop();return e});m(e,"animate",t);n.column&&(n=n.column.prototype,n.polarArc=function(b,a,e,g){var c=this.xAxis.center,f=this.yAxis.len;
return this.chart.renderer.symbols.arc(c[0],c[1],f-a,null,{start:e,end:g,innerR:f-w(b,f)})},m(n,"animate",t),m(n,"translate",function(b){var a=this.xAxis,e=a.startAngleRad,g,d,f;this.preventPostTranslate=!0;b.call(this);if(a.isRadial)for(g=this.points,f=g.length;f--;)d=g[f],b=d.barX+e,d.shapeType="path",d.shapeArgs={d:this.polarArc(d.yBottom,d.plotY,b,b+d.pointWidth)},this.toXY(d),d.tooltipPos=[d.plotX,d.plotY],d.ttBelow=d.plotY>a.center[1]}),m(n,"alignDataLabel",function(a,c,l,g,d,f){this.chart.polar?
(a=c.rectPlotX/Math.PI*180,null===g.align&&(g.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===g.verticalAlign&&(g.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),e.alignDataLabel.call(this,c,l,g,d,f)):a.call(this,c,l,g,d,f)}));m(k,"getCoordinates",function(a,c){var b=this.chart,e={xAxis:[],yAxis:[]};b.polar?v(b.axes,function(a){var d=a.isXAxis,g=a.center,k=c.chartX-g[0]-b.plotLeft,g=c.chartY-g[1]-b.plotTop;e[d?"xAxis":"yAxis"].push({axis:a,value:a.translate(d?Math.PI-
Math.atan2(k,g):Math.sqrt(Math.pow(k,2)+Math.pow(g,2)),!0)})}):e=a.call(this,c);return e});m(a.Chart.prototype,"getAxes",function(b){this.pane||(this.pane=[]);v(a.splat(this.options.pane),function(b){new a.Pane(b,this)},this);b.call(this)});m(a.Chart.prototype,"drawChartBox",function(a){a.call(this);v(this.pane,function(a){a.render()})});m(a.Chart.prototype,"get",function(b,c){return a.find(this.pane,function(a){return a.options.id===c})||b.call(this,c)})})(x)});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.1.2 (2018-08-31)
 Exporting module

 (c) 2010-2017 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(g){"object"===typeof module&&module.exports?module.exports=g: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return g}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):g(Highcharts)})(function(g){(function(f){var g=f.defaultOptions,z=f.doc,A=f.Chart,q=f.addEvent,I=f.removeEvent,C=f.fireEvent,r=f.createElement,D=f.discardElement,u=f.css,p=f.merge,B=f.pick,k=f.each,F=f.objectEach,t=f.extend,J=f.isTouchDevice,E=f.win,G=E.navigator.userAgent,K=f.Renderer.prototype.symbols;/Edge\/|Trident\/|MSIE /.test(G);/firefox/i.test(G);t(g.lang,
{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});g.navigation={buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}};p(!0,g.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",background:"none",
color:"#333333",fontSize:J?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{fill:"#ffffff",stroke:"none",padding:5}}});g.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",
menuItems:"printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},menuItemDefinitions:{printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",
onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};f.post=function(a,b,e){var c=r("form",p({method:"post",action:a,enctype:"multipart/form-data"},e),{display:"none"},z.body);F(b,function(a,b){r("input",{type:"hidden",name:b,value:a},null,c)});c.submit();D(c)};t(A.prototype,{sanitizeSVG:function(a,b){if(b&&b.exporting&&b.exporting.allowHTML){var e=a.match(/<\/svg>(.*?$)/);e&&e[1]&&(e='\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+b.chart.width+'" height\x3d"'+b.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+
e[1]+"\x3c/body\x3e\x3c/foreignObject\x3e",a=a.replace("\x3c/svg\x3e",e+"\x3c/svg\x3e"))}a=a.replace(/zIndex="[^"]+"/g,"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+\:)href=/g," xlink:href\x3d").replace(/\n/," ").replace(/<\/svg>.*?$/,"\x3c/svg\x3e").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,
'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(a=this.ieSanitizeSVG(a));return a},getChartHTML:function(){return this.container.innerHTML},getSVG:function(a){var b,e,c,v,m,h=p(this.options,a);e=r("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},z.body);c=this.renderTo.style.width;m=this.renderTo.style.height;c=h.exporting.sourceWidth||h.chart.width||/px$/.test(c)&&parseInt(c,10)||
600;m=h.exporting.sourceHeight||h.chart.height||/px$/.test(m)&&parseInt(m,10)||400;t(h.chart,{animation:!1,renderTo:e,forExport:!0,renderer:"SVGRenderer",width:c,height:m});h.exporting.enabled=!1;delete h.data;h.series=[];k(this.series,function(a){v=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});v.isInternal||h.series.push(v)});k(this.axes,function(a){a.userOptions.internalKey||(a.userOptions.internalKey=f.uniqueKey())});b=new f.Chart(h,this.callback);a&&
k(["xAxis","yAxis","series"],function(c){var d={};a[c]&&(d[c]=a[c],b.update(d))});k(this.axes,function(a){var c=f.find(b.axes,function(b){return b.options.internalKey===a.userOptions.internalKey}),d=a.getExtremes(),e=d.userMin,d=d.userMax;c&&(void 0!==e&&e!==c.min||void 0!==d&&d!==c.max)&&c.setExtremes(e,d,!0,!1)});c=b.getChartHTML();C(this,"getSVG",{chartCopy:b});c=this.sanitizeSVG(c,h);h=null;b.destroy();D(e);return c},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},
e.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=p(this.options.exporting,a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale,svg:b},a.formAttributes)},print:function(){var a=this,b=a.container,e=[],c=b.parentNode,f=z.body,m=f.childNodes,h=a.options.exporting.printMaxWidth,d,n;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,
0);C(a,"beforePrint");if(n=h&&a.chartWidth>h)d=[a.options.chart.width,void 0,!1],a.setSize(h,void 0,!1);k(m,function(a,b){1===a.nodeType&&(e[b]=a.style.display,a.style.display="none")});f.appendChild(b);setTimeout(function(){E.focus();E.print();setTimeout(function(){c.appendChild(b);k(m,function(a,b){1===a.nodeType&&(a.style.display=e[b])});a.isPrinting=!1;n&&a.setSize.apply(a,d);C(a,"afterPrint")},1E3)},1)}},contextMenu:function(a,b,e,c,v,m,h){var d=this,n=d.options.navigation,g=d.chartWidth,H=d.chartHeight,
p="cache-"+a,l=d[p],w=Math.max(v,m),x,y;l||(d[p]=l=r("div",{className:a},{position:"absolute",zIndex:1E3,padding:w+"px",pointerEvents:"auto"},d.fixedDiv||d.container),x=r("div",{className:"highcharts-menu"},null,l),u(x,t({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},n.menuStyle)),y=function(){u(l,{display:"none"});h&&h.setState(0);d.openMenu=!1},d.exportEvents.push(q(l,"mouseleave",function(){l.hideTimer=setTimeout(y,500)}),q(l,"mouseenter",function(){f.clearTimeout(l.hideTimer)}),
q(z,"mouseup",function(b){d.pointer.inClass(b.target,a)||y()}),q(l,"click",function(){d.openMenu&&y()})),k(b,function(a){"string"===typeof a&&(a=d.options.exporting.menuItemDefinitions[a]);if(f.isObject(a,!0)){var b;a.separator?b=r("hr",null,null,x):(b=r("div",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();y();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},null,x),b.onmouseover=function(){u(this,n.menuItemHoverStyle)},b.onmouseout=
function(){u(this,n.menuItemStyle)},u(b,t({cursor:"pointer"},n.menuItemStyle)));d.exportDivElements.push(b)}}),d.exportDivElements.push(x,l),d.exportMenuWidth=l.offsetWidth,d.exportMenuHeight=l.offsetHeight);b={display:"block"};e+d.exportMenuWidth>g?b.right=g-e-v-w+"px":b.left=e-w+"px";c+m+d.exportMenuHeight>H&&"top"!==h.alignOptions.verticalAlign?b.bottom=H-c-w+"px":b.top=c+m-w+"px";u(l,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,c=p(b.options.navigation.buttonOptions,a),f=c.onclick,
m=c.menuItems,h,d,n=c.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==c.enabled){var g=c.theme,k=g.states,q=k&&k.hover,k=k&&k.select,l;delete g.states;f?l=function(a){a.stopPropagation();f.call(b,a)}:m&&(l=function(){b.contextMenu(d.menuClassName,m,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?g.paddingLeft=B(g.paddingLeft,25):c.text||t(g,{width:c.width,height:c.height,padding:0});d=e.button(c.text,
0,0,l,g,q,k).addClass(a.className).attr({"stroke-linecap":"round",title:B(b.options.lang[c._titleKey],"")});d.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;c.symbol&&(h=e.symbol(c.symbol,c.symbolX-n/2,c.symbolY-n/2,n,n,{width:n,height:n}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(d),h.attr({stroke:c.symbolStroke,fill:c.symbolFill,"stroke-width":c.symbolStrokeWidth||1}));d.add(b.exportingGroup).align(t(c,{width:d.width,x:B(c.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=
(d.width+c.buttonSpacing)*("right"===c.align?-1:1);b.exportSVGElements.push(d,h)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var e=b.exportDivElements,c=b.exportEvents,g;a&&(k(a,function(a,c){a&&(a.onclick=a.ontouchstart=null,g="cache-"+a.menuClassName,b[g]&&delete b[g],b.exportSVGElements[c]=a.destroy())}),a.length=0);b.exportingGroup&&(b.exportingGroup.destroy(),delete b.exportingGroup);e&&(k(e,function(a,c){f.clearTimeout(a.hideTimer);I(a,"mouseleave");b.exportDivElements[c]=
a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;D(a)}),e.length=0);c&&(k(c,function(a){a()}),c.length=0)}});K.menu=function(a,b,e,c){return["M",a,b+2.5,"L",a+e,b+2.5,"M",a,b+c/2+.5,"L",a+e,b+c/2+.5,"M",a,b+c-1.5,"L",a+e,b+c-1.5]};A.prototype.renderExporting=function(){var a=this,b=a.options.exporting,e=b.buttons,c=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();c&&!1!==b.enabled&&(a.exportEvents=[],a.exportingGroup=a.exportingGroup||a.renderer.g("exporting-group").attr({zIndex:3}).add(),
F(e,function(b){a.addButton(b)}),a.isDirtyExporting=!1);q(a,"destroy",a.destroyExport)};q(A,"init",function(){var a=this;k(["exporting","navigation"],function(b){a[b]={update:function(e,c){a.isDirtyExporting=!0;p(!0,a.options[b],e);B(c,!0)&&a.redraw()}}})});A.prototype.callbacks.push(function(a){a.renderExporting();q(a,"redraw",a.renderExporting)})})(g)});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.1.2 (2018-08-31)
 Exporting module

 (c) 2010-2017 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(e){"object"===typeof module&&module.exports?module.exports=e: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return e}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):e(Highcharts)})(function(e){(function(a){a.ajax=function(e){var c=a.merge(!0,{url:!1,type:"GET",dataType:"json",success:!1,error:!1,data:!1,headers:{}},e);e={json:"application/json",xml:"application/xml",text:"text/plain",octet:"application/octet-stream"};var m=new XMLHttpRequest;if(!c.url)return!1;m.open(c.type.toUpperCase(),c.url,!0);m.setRequestHeader("Content-Type",
e[c.dataType]||e.text);a.objectEach(c.headers,function(a,c){m.setRequestHeader(c,a)});m.onreadystatechange=function(){var a;if(4===m.readyState){if(200===m.status){a=m.responseText;if("json"===c.dataType)try{a=JSON.parse(a)}catch(g){c.error&&c.error(m,g);return}return c.success&&c.success(a)}c.error&&c.error(m,m.responseText)}};try{c.data=JSON.stringify(c.data)}catch(t){}m.send(c.data||!0)}})(e);(function(a){var e=a.defined,c=a.each,m=a.pick,t=a.win,g=t.document,p=a.seriesTypes,E=void 0!==g.createElement("a").download;
a.setOptions({exporting:{csv:{columnHeaderFormatter:null,dateFormat:"%Y-%m-%d %H:%M:%S",decimalPoint:null,itemDelimiter:null,lineDelimiter:"\n"},showTable:!1,useMultiLevelHeaders:!0,useRowspanHeaders:!0},lang:{downloadCSV:"Download CSV",downloadXLS:"Download XLS",openInCloud:"Open in Highcharts Cloud",viewData:"View data table"}});a.addEvent(a.Chart,"render",function(){this.options&&this.options.exporting&&this.options.exporting.showTable&&this.viewData()});a.Chart.prototype.setUpKeyToAxis=function(){p.arearange&&
(p.arearange.prototype.keyToAxis={low:"y",high:"y"})};a.Chart.prototype.getDataRows=function(f){var u=this.time,h=this.options.exporting&&this.options.exporting.csv||{},d,l=this.xAxis,q={},g=[],n,C=[],v=[],z,w,k,D=function(b,d,k){if(h.columnHeaderFormatter){var u=h.columnHeaderFormatter(b,d,k);if(!1!==u)return u}return b?b instanceof a.Axis?b.options.title&&b.options.title.text||(b.isDatetimeAxis?"DateTime":"Category"):f?{columnTitle:1<k?d:b.name,topLevelColumnTitle:b.name}:b.name+(1<k?" ("+d+")":
""):"Category"},A=[];w=0;this.setUpKeyToAxis();c(this.series,function(b){var d=b.options.keys||b.pointArrayMap||["y"],k=d.length,x=!b.requireSorting&&{},n={},g={},e=a.inArray(b.xAxis,l),y,r;c(d,function(d){var a=(b.keyToAxis&&b.keyToAxis[d]||d)+"Axis";n[d]=b[a]&&b[a].categories||[];g[d]=b[a]&&b[a].isDatetimeAxis});if(!1!==b.options.includeInCSVExport&&!b.options.isInternal&&!1!==b.visible){a.find(A,function(b){return b[0]===e})||A.push([e,w]);for(r=0;r<k;)z=D(b,d[r],d.length),v.push(z.columnTitle||
z),f&&C.push(z.topLevelColumnTitle||z),r++;y={chart:b.chart,autoIncrement:b.autoIncrement,options:b.options,pointArrayMap:b.pointArrayMap};c(b.options.data,function(a,f){var c,l;l={series:y};b.pointClass.prototype.applyOptions.apply(l,[a]);a=l.x;c=b.data[f]&&b.data[f].name;x&&(x[a]&&(a+="|"+f),x[a]=!0);r=0;b.xAxis&&"name"!==b.exportKey||(a=c);q[a]||(q[a]=[],q[a].xValues=[]);q[a].x=l.x;q[a].name=c;for(q[a].xValues[e]=l.x;r<k;)f=d[r],c=l[f],q[a][w+r]=m(n[f][c],g[f]?u.dateFormat(h.dateFormat,c):null,
c),r++});w+=r}});for(n in q)q.hasOwnProperty(n)&&g.push(q[n]);var x,y;n=f?[C,v]:[v];for(w=A.length;w--;)x=A[w][0],y=A[w][1],d=l[x],g.sort(function(b,a){return b.xValues[x]-a.xValues[x]}),k=D(d),n[0].splice(y,0,k),f&&n[1]&&n[1].splice(y,0,k),c(g,function(b){var a=b.name;d&&!e(a)&&(d.isDatetimeAxis?(b.x instanceof Date&&(b.x=b.x.getTime()),a=u.dateFormat(h.dateFormat,b.x)):a=d.categories?m(d.names[b.x],d.categories[b.x],b.x):b.x);b.splice(y,0,a)});n=n.concat(g);a.fireEvent(this,"exportData",{dataRows:n});
return n};a.Chart.prototype.getCSV=function(a){var f="",h=this.getDataRows(),d=this.options.exporting.csv,l=m(d.decimalPoint,","!==d.itemDelimiter&&a?(1.1).toLocaleString()[1]:"."),e=m(d.itemDelimiter,","===l?";":","),g=d.lineDelimiter;c(h,function(a,d){for(var c,u=a.length;u--;)c=a[u],"string"===typeof c&&(c='"'+c+'"'),"number"===typeof c&&"."!==l&&(c=c.toString().replace(".",l)),a[u]=c;f+=a.join(e);d<h.length-1&&(f+=g)});return f};a.Chart.prototype.getTable=function(a){var f="\x3ctable\x3e",h=this.options,
d=a?(1.1).toLocaleString()[1]:".",l=m(h.exporting.useMultiLevelHeaders,!0);a=this.getDataRows(l);var e=0,g=l?a.shift():null,n=a.shift(),p=function(a,c,f,l){var k=m(l,"");c="text"+(c?" "+c:"");"number"===typeof k?(k=k.toString(),","===d&&(k=k.replace(".",d)),c="number"):l||(c="empty");return"\x3c"+a+(f?" "+f:"")+' class\x3d"'+c+'"\x3e'+k+"\x3c/"+a+"\x3e"};!1!==h.exporting.tableCaption&&(f+='\x3ccaption class\x3d"highcharts-table-caption"\x3e'+m(h.exporting.tableCaption,h.title.text?h.title.text.replace(/&/g,
"\x26amp;").replace(/</g,"\x26lt;").replace(/>/g,"\x26gt;").replace(/"/g,"\x26quot;").replace(/'/g,"\x26#x27;").replace(/\//g,"\x26#x2F;"):"Chart")+"\x3c/caption\x3e");for(var v=0,t=a.length;v<t;++v)a[v].length>e&&(e=a[v].length);f+=function(a,d,c){var f="\x3cthead\x3e",e=0;c=c||d&&d.length;var k,b,g=0;if(b=l&&a&&d){a:if(b=a.length,d.length===b){for(;b--;)if(a[b]!==d[b]){b=!1;break a}b=!0}else b=!1;b=!b}if(b){for(f+="\x3ctr\x3e";e<c;++e)b=a[e],k=a[e+1],b===k?++g:g?(f+=p("th","highcharts-table-topheading",
'scope\x3d"col" colspan\x3d"'+(g+1)+'"',b),g=0):(b===d[e]?h.exporting.useRowspanHeaders?(k=2,delete d[e]):(k=1,d[e]=""):k=1,f+=p("th","highcharts-table-topheading",'scope\x3d"col"'+(1<k?' valign\x3d"top" rowspan\x3d"'+k+'"':""),b));f+="\x3c/tr\x3e"}if(d){f+="\x3ctr\x3e";e=0;for(c=d.length;e<c;++e)void 0!==d[e]&&(f+=p("th",null,'scope\x3d"col"',d[e]));f+="\x3c/tr\x3e"}return f+"\x3c/thead\x3e"}(g,n,Math.max(e,n.length));f+="\x3ctbody\x3e";c(a,function(a){f+="\x3ctr\x3e";for(var d=0;d<e;d++)f+=p(d?
"td":"th",null,d?"":'scope\x3d"row"',a[d]);f+="\x3c/tr\x3e"});return f+="\x3c/tbody\x3e\x3c/table\x3e"};a.Chart.prototype.fileDownload=function(c,e,h){var d;d=this.options.exporting.filename?this.options.exporting.filename:this.title&&this.title.textStr?this.title.textStr.replace(/ /g,"-").toLowerCase():"chart";t.Blob&&t.navigator.msSaveOrOpenBlob?(c=new t.Blob(["\ufeff"+h],{type:"text/csv"}),t.navigator.msSaveOrOpenBlob(c,d+"."+e)):E?(h=g.createElement("a"),h.href=c,h.download=d+"."+e,this.container.appendChild(h),
h.click(),h.remove()):a.error("The browser doesn't support downloading files")};a.Chart.prototype.downloadCSV=function(){var a=this.getCSV(!0);this.fileDownload("data:text/csv,\ufeff"+encodeURIComponent(a),"csv",a,"text/csv")};a.Chart.prototype.downloadXLS=function(){var a='\x3chtml xmlns:o\x3d"urn:schemas-microsoft-com:office:office" xmlns:x\x3d"urn:schemas-microsoft-com:office:excel" xmlns\x3d"http://www.w3.org/TR/REC-html40"\x3e\x3chead\x3e\x3c!--[if gte mso 9]\x3e\x3cxml\x3e\x3cx:ExcelWorkbook\x3e\x3cx:ExcelWorksheets\x3e\x3cx:ExcelWorksheet\x3e\x3cx:Name\x3eArk1\x3c/x:Name\x3e\x3cx:WorksheetOptions\x3e\x3cx:DisplayGridlines/\x3e\x3c/x:WorksheetOptions\x3e\x3c/x:ExcelWorksheet\x3e\x3c/x:ExcelWorksheets\x3e\x3c/x:ExcelWorkbook\x3e\x3c/xml\x3e\x3c![endif]--\x3e\x3cstyle\x3etd{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}\x3c/style\x3e\x3cmeta name\x3dProgId content\x3dExcel.Sheet\x3e\x3cmeta charset\x3dUTF-8\x3e\x3c/head\x3e\x3cbody\x3e'+
this.getTable(!0)+"\x3c/body\x3e\x3c/html\x3e";this.fileDownload("data:application/vnd.ms-excel;base64,"+t.btoa(unescape(encodeURIComponent(a))),"xls",a,"application/vnd.ms-excel")};a.Chart.prototype.viewData=function(){this.dataTableDiv||(this.dataTableDiv=g.createElement("div"),this.dataTableDiv.className="highcharts-data-table",this.renderTo.parentNode.insertBefore(this.dataTableDiv,this.renderTo.nextSibling));this.dataTableDiv.innerHTML=this.getTable()};a.Chart.prototype.openInCloud=function(){function c(d){Object.keys(d).forEach(function(e){"function"===
typeof d[e]&&delete d[e];a.isObject(d[e])&&c(d[e])})}var e,h;e=a.merge(this.userOptions);c(e);e={name:e.title&&e.title.text||"Chart title",options:e,settings:{constructor:"Chart",dataProvider:{csv:this.getCSV()}}};h=JSON.stringify(e);(function(){var a=g.createElement("form");g.body.appendChild(a);a.method="post";a.action="https://cloud-api.highcharts.com/openincloud";a.target="_blank";var c=g.createElement("input");c.type="hidden";c.name="chart";c.value=h;a.appendChild(c);a.submit();g.body.removeChild(a)})()};
var B=a.getOptions().exporting;B&&(a.extend(B.menuItemDefinitions,{downloadCSV:{textKey:"downloadCSV",onclick:function(){this.downloadCSV()}},downloadXLS:{textKey:"downloadXLS",onclick:function(){this.downloadXLS()}},viewData:{textKey:"viewData",onclick:function(){this.viewData()}},openInCloud:{textKey:"openInCloud",onclick:function(){this.openInCloud()}}}),B.buttons.contextButton.menuItems.push("separator","downloadCSV","downloadXLS","viewData","openInCloud"));p.map&&(p.map.prototype.exportKey="name");
p.mapbubble&&(p.mapbubble.prototype.exportKey="name");p.treemap&&(p.treemap.prototype.exportKey="name")})(e)});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.1.2 (2018-08-31)
 Client side exporting module

 (c) 2015 Torstein Honsi / Oystein Moseng

 License: www.highcharts.com/license
*/
(function(h){"object"===typeof module&&module.exports?module.exports=h: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return h}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):h(Highcharts)})(function(h){(function(c){function h(b,f){var d=r.getElementsByTagName("head")[0],a=r.createElement("script");a.type="text/javascript";a.src=b;a.onload=f;a.onerror=function(){c.error("Error loading script "+b)};d.appendChild(a)}var D=c.addEvent,E=c.merge,e=c.win,n=e.navigator,r=e.document,x=c.each,y=e.URL||e.webkitURL||e,B=/Edge\/|Trident\/|MSIE /.test(n.userAgent),
F=/Edge\/\d+/.test(n.userAgent),G=B?150:0;c.CanVGRenderer={};c.dataURLtoBlob=function(b){if(e.atob&&e.ArrayBuffer&&e.Uint8Array&&e.Blob&&y.createObjectURL){b=b.match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);for(var c=e.atob(b[3]),d=new e.ArrayBuffer(c.length),d=new e.Uint8Array(d),a=0;a<d.length;++a)d[a]=c.charCodeAt(a);b=new e.Blob([d],{type:b[1]});return y.createObjectURL(b)}};c.downloadURL=function(b,f){var d=r.createElement("a"),a;if("string"===typeof b||b instanceof String||!n.msSaveOrOpenBlob){if(F||
2E6<b.length)if(b=c.dataURLtoBlob(b),!b)throw"Data URL length limit reached";if(void 0!==d.download)d.href=b,d.download=f,r.body.appendChild(d),d.click(),r.body.removeChild(d);else try{if(a=e.open(b,"chart"),void 0===a||null===a)throw"Failed to open window";}catch(t){e.location.href=b}}else n.msSaveOrOpenBlob(b,f)};c.svgToDataUrl=function(b){var c=-1<n.userAgent.indexOf("WebKit")&&0>n.userAgent.indexOf("Chrome");try{if(!c&&0>n.userAgent.toLowerCase().indexOf("firefox"))return y.createObjectURL(new e.Blob([b],
{type:"image/svg+xml;charset-utf-16"}))}catch(d){}return"data:image/svg+xml;charset\x3dUTF-8,"+encodeURIComponent(b)};c.imageToDataUrl=function(b,c,d,a,t,m,l,h,p){var g=new e.Image,k,f=function(){setTimeout(function(){var e=r.createElement("canvas"),f=e.getContext&&e.getContext("2d"),w;try{if(f){e.height=g.height*a;e.width=g.width*a;f.drawImage(g,0,0,e.width,e.height);try{w=e.toDataURL(c),t(w,c,d,a)}catch(C){k(b,c,d,a)}}else l(b,c,d,a)}finally{p&&p(b,c,d,a)}},G)},q=function(){h(b,c,d,a);p&&p(b,c,
d,a)};k=function(){g=new e.Image;k=m;g.crossOrigin="Anonymous";g.onload=f;g.onerror=q;g.src=b};g.onload=f;g.onerror=q;g.src=b};c.downloadSVGLocal=function(b,f,d,a){function t(a,b){b=new e.jsPDF("l","pt",[a.width.baseVal.value+2*b,a.height.baseVal.value+2*b]);x(a.querySelectorAll('*[visibility\x3d"hidden"]'),function(a){a.parentNode.removeChild(a)});e.svg2pdf(a,b,{removeInvalid:!0});return b.output("datauristring")}function m(){z.innerHTML=b;var e=z.getElementsByTagName("text"),f;x(e,function(a){x(["font-family",
"font-size"],function(b){for(var c=a;c&&c!==z;){if(c.style[b]){a.style[b]=c.style[b];break}c=c.parentNode}});a.style["font-family"]=a.style["font-family"]&&a.style["font-family"].split(" ").splice(-1);f=a.getElementsByTagName("title");x(f,function(b){a.removeChild(b)})});e=t(z.firstChild,0);try{c.downloadURL(e,v),a&&a()}catch(H){d(H)}}var l,u,p=!0,g,k=f.libURL||c.getOptions().exporting.libURL,z=r.createElement("div"),q=f.type||"image/png",v=(f.filename||"chart")+"."+("image/svg+xml"===q?"svg":q.split("/")[1]),
A=f.scale||1,k="/"!==k.slice(-1)?k+"/":k;if("image/svg+xml"===q)try{n.msSaveOrOpenBlob?(u=new MSBlobBuilder,u.append(b),l=u.getBlob("image/svg+xml")):l=c.svgToDataUrl(b),c.downloadURL(l,v),a&&a()}catch(w){d(w)}else"application/pdf"===q?e.jsPDF&&e.svg2pdf?m():(p=!0,h(k+"jspdf.js",function(){h(k+"svg2pdf.js",function(){m()})})):(l=c.svgToDataUrl(b),g=function(){try{y.revokeObjectURL(l)}catch(w){}},c.imageToDataUrl(l,q,{},A,function(b){try{c.downloadURL(b,v),a&&a()}catch(C){d(C)}},function(){var f=r.createElement("canvas"),
t=f.getContext("2d"),m=b.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1]*A,l=b.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1]*A,u=function(){t.drawSvg(b,0,0,m,l);try{c.downloadURL(n.msSaveOrOpenBlob?f.msToBlob():f.toDataURL(q),v),a&&a()}catch(I){d(I)}finally{g()}};f.width=m;f.height=l;e.canvg?u():(p=!0,h(k+"rgbcolor.js",function(){h(k+"canvg.js",function(){u()})}))},d,d,function(){p&&g()}))};c.Chart.prototype.getSVGForLocalExport=function(b,e,d,a){var f=this,m,l=0,h,p,g,k,n,q=function(b,
c,d){++l;d.imageElement.setAttributeNS("http://www.w3.org/1999/xlink","href",b);l===m.length&&a(f.sanitizeSVG(h.innerHTML,p))};f.unbindGetSVG=D(f,"getSVG",function(a){p=a.chartCopy.options;h=a.chartCopy.container.cloneNode(!0)});f.getSVGForExport(b,e);m=h.getElementsByTagName("image");try{if(!m.length){a(f.sanitizeSVG(h.innerHTML,p));return}k=0;for(n=m.length;k<n;++k)g=m[k],c.imageToDataUrl(g.getAttributeNS("http://www.w3.org/1999/xlink","href"),"image/png",{imageElement:g},b.scale,q,d,d,d)}catch(v){d(v)}f.unbindGetSVG()};
c.Chart.prototype.exportChartLocal=function(b,e){var d=this,a=c.merge(d.options.exporting,b),f=function(b){!1===a.fallbackToExportServer?a.error?a.error(a,b):c.error(28,!0):d.exportChart(a)};B&&("application/pdf"===a.type||d.container.getElementsByTagName("image").length&&"image/svg+xml"!==a.type)||"application/pdf"===a.type&&d.container.getElementsByTagName("image").length?f("Image type not supported for this chart/browser."):d.getSVGForLocalExport(a,e,f,function(b){-1<b.indexOf("\x3cforeignObject")&&
"image/svg+xml"!==a.type?f("Image type not supported for charts with embedded HTML"):c.downloadSVGLocal(b,a,f)})};E(!0,c.getOptions().exporting,{libURL:"https://code.highcharts.com/6.1.2/lib/",menuItemDefinitions:{downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChartLocal()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChartLocal({type:"image/jpeg"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChartLocal({type:"image/svg+xml"})}},downloadPDF:{textKey:"downloadPDF",
onclick:function(){this.exportChartLocal({type:"application/pdf"})}}}})})(h)});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.1.2 (2018-08-31)
 Data module

 (c) 2012-2017 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(q){"object"===typeof module&&module.exports?module.exports=q: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return q}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):q(Highcharts)})(function(q){(function(h){h.ajax=function(q){var m=h.merge(!0,{url:!1,type:"GET",dataType:"json",success:!1,error:!1,data:!1,headers:{}},q);q={json:"application/json",xml:"application/xml",text:"text/plain",octet:"application/octet-stream"};var p=new XMLHttpRequest;if(!m.url)return!1;p.open(m.type.toUpperCase(),m.url,!0);p.setRequestHeader("Content-Type",
q[m.dataType]||q.text);h.objectEach(m.headers,function(h,m){p.setRequestHeader(m,h)});p.onreadystatechange=function(){var h;if(4===p.readyState){if(200===p.status){h=p.responseText;if("json"===m.dataType)try{h=JSON.parse(h)}catch(C){m.error&&m.error(p,C);return}return m.success&&m.success(h)}m.error&&m.error(p,p.responseText)}};try{m.data=JSON.stringify(m.data)}catch(u){}p.send(m.data||!0)}})(q);(function(h){var q=h.addEvent,m=h.Chart,p=h.win.document,u=h.each,C=h.objectEach,H=h.pick,E=h.inArray,
F=h.isNumber,z=h.merge,I=h.splat,J=h.fireEvent,K=h.some,x,A=function(a,b,c){this.init(a,b,c)};h.extend(A.prototype,{init:function(a,b,c){var f=a.decimalPoint,e;b&&(this.chartOptions=b);c&&(this.chart=c);"."!==f&&","!==f&&(f=void 0);this.options=a;this.columns=a.columns||this.rowsToColumns(a.rows)||[];this.firstRowAsNames=H(a.firstRowAsNames,this.firstRowAsNames,!0);this.decimalRegex=f&&new RegExp("^(-?[0-9]+)"+f+"([0-9]+)$");this.rawColumns=[];this.columns.length&&(this.dataFound(),e=!0);e||(e=this.fetchLiveData());
e||(e=!!this.parseCSV().length);e||(e=!!this.parseTable().length);e||(e=this.parseGoogleSpreadsheet());!e&&a.afterComplete&&a.afterComplete()},getColumnDistribution:function(){var a=this.chartOptions,b=this.options,c=[],f=function(a){return(h.seriesTypes[a||"line"].prototype.pointArrayMap||[0]).length},e=a&&a.chart&&a.chart.type,d=[],l=[],w=0,b=b&&b.seriesMapping||a&&a.series&&h.map(a.series,function(){return{x:0}})||[],g;u(a&&a.series||[],function(a){d.push(f(a.type||e))});u(b,function(a){c.push(a.x||
0)});0===c.length&&c.push(0);u(b,function(b){var c=new x,D=d[w]||f(e),n=h.seriesTypes[((a&&a.series||[])[w]||{}).type||e||"line"].prototype.pointArrayMap||["y"];c.addColumnReader(b.x,"x");C(b,function(a,b){"x"!==b&&c.addColumnReader(a,b)});for(g=0;g<D;g++)c.hasReader(n[g])||c.addColumnReader(void 0,n[g]);l.push(c);w++});b=h.seriesTypes[e||"line"].prototype.pointArrayMap;void 0===b&&(b=["y"]);this.valueCount={global:f(e),xColumns:c,individual:d,seriesBuilders:l,globalPointArrayMap:b}},dataFound:function(){this.options.switchRowsAndColumns&&
(this.columns=this.rowsToColumns(this.columns));this.getColumnDistribution();this.parseTypes();!1!==this.parsed()&&this.complete()},parseCSV:function(a){function b(a,b,c,d){function e(b){k=a[b];r=a[b-1];w=a[b+1]}function f(a){v.length<t+1&&v.push([a]);v[t][v[t].length-1]!==a&&v[t].push(a)}function g(){D>B||B>m?(++B,n=""):(!isNaN(parseFloat(n))&&isFinite(n)?(n=parseFloat(n),f("number")):isNaN(Date.parse(n))?f("string"):(n=n.replace(/\//g,"-"),f("date")),h.length<t+1&&h.push([]),c||(h[t][b]=n),n="",
++t,++B)}var l=0,k="",r="",w="",n="",B=0,t=0;if(a.trim().length&&"#"!==a.trim()[0]){for(;l<a.length;l++){e(l);if("#"===k){g();return}if('"'===k)for(e(++l);l<a.length&&('"'!==k||'"'===r||'"'===w);){if('"'!==k||'"'===k&&'"'!==r)n+=k;e(++l)}else d&&d[k]?d[k](k,n)&&g():k===y?g():n+=k}g()}}function c(a){var b=0,c=0,f=!1;K(a,function(a,d){var e=!1,f,k,g="";if(13<d)return!0;for(var l=0;l<a.length;l++){d=a[l];f=a[l+1];k=a[l-1];if("#"===d)break;else if('"'===d)if(e){if('"'!==k&&'"'!==f){for(;" "===f&&l<a.length;)f=
a[++l];"undefined"!==typeof t[f]&&t[f]++;e=!1}}else e=!0;else"undefined"!==typeof t[d]?(g=g.trim(),isNaN(Date.parse(g))?!isNaN(g)&&isFinite(g)||t[d]++:t[d]++,g=""):g+=d;","===d&&c++;"."===d&&b++}});f=t[";"]>t[","]?";":",";d.decimalPoint||(d.decimalPoint=b>c?".":",",e.decimalRegex=new RegExp("^(-?[0-9]+)"+d.decimalPoint+"([0-9]+)$"));return f}function f(a,b){var c,f,g=0,l=!1,h=[],n=[],k;if(!b||b>a.length)b=a.length;for(;g<b;g++)if("undefined"!==typeof a[g]&&a[g]&&a[g].length)for(c=a[g].trim().replace(/\//g,
" ").replace(/\-/g," ").split(" "),f=["","",""],k=0;k<c.length;k++)k<f.length&&(c[k]=parseInt(c[k],10),c[k]&&(n[k]=!n[k]||n[k]<c[k]?c[k]:n[k],"undefined"!==typeof h[k]?h[k]!==c[k]&&(h[k]=!1):h[k]=c[k],31<c[k]?f[k]=100>c[k]?"YY":"YYYY":12<c[k]&&31>=c[k]?(f[k]="dd",l=!0):f[k].length||(f[k]="mm")));if(l){for(k=0;k<h.length;k++)!1!==h[k]?12<n[k]&&"YY"!==f[k]&&"YYYY"!==f[k]&&(f[k]="YY"):12<n[k]&&"mm"===f[k]&&(f[k]="dd");3===f.length&&"dd"===f[1]&&"dd"===f[2]&&(f[2]="YY");a=f.join("/");return(d.dateFormats||
e.dateFormats)[a]?a:(J("deduceDateFailed"),"YYYY/mm/dd")}return"YYYY/mm/dd"}var e=this,d=a||this.options,l=d.csv,h;a="undefined"!==typeof d.startRow&&d.startRow?d.startRow:0;var g=d.endRow||Number.MAX_VALUE,D="undefined"!==typeof d.startColumn&&d.startColumn?d.startColumn:0,m=d.endColumn||Number.MAX_VALUE,y,n=0,v=[],t={",":0,";":0,"\t":0};h=this.columns=[];l&&d.beforeParse&&(l=d.beforeParse.call(this,l));if(l){l=l.replace(/\r\n/g,"\n").replace(/\r/g,"\n").split(d.lineDelimiter||"\n");if(!a||0>a)a=
0;if(!g||g>=l.length)g=l.length-1;d.itemDelimiter?y=d.itemDelimiter:(y=null,y=c(l));for(var G=0,n=a;n<=g;n++)"#"===l[n][0]?G++:b(l[n],n-a-G);d.columnTypes&&0!==d.columnTypes.length||!v.length||!v[0].length||"date"!==v[0][1]||d.dateFormat||(d.dateFormat=f(h[0]));this.dataFound()}return h},parseTable:function(){var a=this.options,b=a.table,c=this.columns,f=a.startRow||0,e=a.endRow||Number.MAX_VALUE,d=a.startColumn||0,l=a.endColumn||Number.MAX_VALUE;b&&("string"===typeof b&&(b=p.getElementById(b)),u(b.getElementsByTagName("tr"),
function(a,b){b>=f&&b<=e&&u(a.children,function(a,e){("TD"===a.tagName||"TH"===a.tagName)&&e>=d&&e<=l&&(c[e-d]||(c[e-d]=[]),c[e-d][b-f]=a.innerHTML)})}),this.dataFound());return c},fetchLiveData:function(){function a(w){function g(g,l,y){function n(){e&&b.liveDataURL===g&&(b.liveDataTimeout=setTimeout(a,d))}if(!g||0!==g.indexOf("http"))return g&&c.error&&c.error("Invalid URL"),!1;w&&(clearTimeout(b.liveDataTimeout),b.liveDataURL=g);h.ajax({url:g,dataType:y||"json",success:function(a){b&&b.series&&
l(a);n()},error:function(a,b){3>++f&&n();return c.error&&c.error(b,a)}});return!0}g(l.csvURL,function(a){b.update({data:{csv:a}})},"text")||g(l.rowsURL,function(a){b.update({data:{rows:a}})})||g(l.columnsURL,function(a){b.update({data:{columns:a}})})}var b=this.chart,c=this.options,f=0,e=c.enablePolling,d=1E3*(c.dataRefreshRate||2),l=z(c);if(!c||!c.csvURL&&!c.rowsURL&&!c.columnsURL)return!1;1E3>d&&(d=1E3);delete c.csvURL;delete c.rowsURL;delete c.columnsURL;a(!0);return c&&(c.csvURL||c.rowsURL||c.columnsURL)},
parseGoogleSpreadsheet:function(){function a(b){var e=["https://spreadsheets.google.com/feeds/cells",f,d,"public/values?alt\x3djson"].join("/");h.ajax({url:e,dataType:"json",success:function(d){b(d);c.enablePolling&&setTimeout(function(){a(b)},c.dataRefreshRate)},error:function(a,b){return c.error&&c.error(b,a)}})}var b=this,c=this.options,f=c.googleSpreadsheetKey,e=this.chart,d=c.googleSpreadsheetWorksheet||1,l=c.startRow||0,w=c.endRow||Number.MAX_VALUE,g=c.startColumn||0,m=c.endColumn||Number.MAX_VALUE,
q=1E3*(c.dataRefreshRate||2);4E3>q&&(q=4E3);f&&(delete c.googleSpreadsheetKey,a(function(a){var c=[];a=a.feed.entry;var d,f=(a||[]).length,h=0,q,p,r;if(!a||0===a.length)return!1;for(r=0;r<f;r++)d=a[r],h=Math.max(h,d.gs$cell.col);for(r=0;r<h;r++)r>=g&&r<=m&&(c[r-g]=[]);for(r=0;r<f;r++)d=a[r],h=d.gs$cell.row-1,q=d.gs$cell.col-1,q>=g&&q<=m&&h>=l&&h<=w&&(p=d.gs$cell||d.content,d=null,p.numericValue?d=0<=p.$t.indexOf("/")||0<=p.$t.indexOf("-")?p.$t:0<p.$t.indexOf("%")?100*parseFloat(p.numericValue):parseFloat(p.numericValue):
p.$t&&p.$t.length&&(d=p.$t),c[q-g][h-l]=d);u(c,function(a){for(r=0;r<a.length;r++)void 0===a[r]&&(a[r]=null)});e&&e.series?e.update({data:{columns:c}}):(b.columns=c,b.dataFound())}));return!1},trim:function(a,b){"string"===typeof a&&(a=a.replace(/^\s+|\s+$/g,""),b&&/^[0-9\s]+$/.test(a)&&(a=a.replace(/\s/g,"")),this.decimalRegex&&(a=a.replace(this.decimalRegex,"$1.$2")));return a},parseTypes:function(){for(var a=this.columns,b=a.length;b--;)this.parseColumn(a[b],b)},parseColumn:function(a,b){var c=
this.rawColumns,f=this.columns,e=a.length,d,l,h,g,p=this.firstRowAsNames,m=-1!==E(b,this.valueCount.xColumns),q,n=[],v=this.chartOptions,t,u=(this.options.columnTypes||[])[b],v=m&&(v&&v.xAxis&&"category"===I(v.xAxis)[0].type||"string"===u);for(c[b]||(c[b]=[]);e--;)d=n[e]||a[e],h=this.trim(d),g=this.trim(d,!0),l=parseFloat(g),void 0===c[b][e]&&(c[b][e]=h),v||0===e&&p?a[e]=""+h:+g===l?(a[e]=l,31536E6<l&&"float"!==u?a.isDatetime=!0:a.isNumeric=!0,void 0!==a[e+1]&&(t=l>a[e+1])):(h&&h.length&&(q=this.parseDate(d)),
m&&F(q)&&"float"!==u?(n[e]=d,a[e]=q,a.isDatetime=!0,void 0!==a[e+1]&&(d=q>a[e+1],d!==t&&void 0!==t&&(this.alternativeFormat?(this.dateFormat=this.alternativeFormat,e=a.length,this.alternativeFormat=this.dateFormats[this.dateFormat].alternative):a.unsorted=!0),t=d)):(a[e]=""===h?null:h,0!==e&&(a.isDatetime||a.isNumeric)&&(a.mixed=!0)));m&&a.mixed&&(f[b]=c[b]);if(m&&t&&this.options.sort)for(b=0;b<f.length;b++)f[b].reverse(),p&&f[b].unshift(f[b].pop())},dateFormats:{"YYYY/mm/dd":{regex:/^([0-9]{4})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{1,2})$/,
parser:function(a){return Date.UTC(+a[1],a[2]-1,+a[3])}},"dd/mm/YYYY":{regex:/^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{4})$/,parser:function(a){return Date.UTC(+a[3],a[2]-1,+a[1])},alternative:"mm/dd/YYYY"},"mm/dd/YYYY":{regex:/^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{4})$/,parser:function(a){return Date.UTC(+a[3],a[1]-1,+a[2])}},"dd/mm/YY":{regex:/^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{2})$/,parser:function(a){var b=+a[3],b=b>(new Date).getFullYear()-2E3?b+1900:b+2E3;return Date.UTC(b,
a[2]-1,+a[1])},alternative:"mm/dd/YY"},"mm/dd/YY":{regex:/^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{2})$/,parser:function(a){return Date.UTC(+a[3]+2E3,a[1]-1,+a[2])}}},parseDate:function(a){var b=this.options.parseDate,c,f,e=this.options.dateFormat||this.dateFormat,d;if(b)c=b(a);else if("string"===typeof a){if(e)(b=this.dateFormats[e])||(b=this.dateFormats["YYYY/mm/dd"]),(d=a.match(b.regex))&&(c=b.parser(d));else for(f in this.dateFormats)if(b=this.dateFormats[f],d=a.match(b.regex)){this.dateFormat=
f;this.alternativeFormat=b.alternative;c=b.parser(d);break}d||(d=Date.parse(a),"object"===typeof d&&null!==d&&d.getTime?c=d.getTime()-6E4*d.getTimezoneOffset():F(d)&&(c=d-6E4*(new Date(d)).getTimezoneOffset()))}return c},rowsToColumns:function(a){var b,c,f,e,d;if(a)for(d=[],c=a.length,b=0;b<c;b++)for(e=a[b].length,f=0;f<e;f++)d[f]||(d[f]=[]),d[f][b]=a[b][f];return d},parsed:function(){if(this.options.parsed)return this.options.parsed.call(this,this.columns)},getFreeIndexes:function(a,b){var c,f=[],
e=[],d;for(c=0;c<a;c+=1)f.push(!0);for(a=0;a<b.length;a+=1)for(d=b[a].getReferencedColumnIndexes(),c=0;c<d.length;c+=1)f[d[c]]=!1;for(c=0;c<f.length;c+=1)f[c]&&e.push(c);return e},complete:function(){var a=this.columns,b,c=this.options,f,e,d,h,m=[],g;if(c.complete||c.afterComplete){if(this.firstRowAsNames)for(d=0;d<a.length;d++)a[d].name=a[d].shift();f=[];e=this.getFreeIndexes(a.length,this.valueCount.seriesBuilders);for(d=0;d<this.valueCount.seriesBuilders.length;d++)g=this.valueCount.seriesBuilders[d],
g.populateColumns(e)&&m.push(g);for(;0<e.length;){g=new x;g.addColumnReader(0,"x");d=E(0,e);-1!==d&&e.splice(d,1);for(d=0;d<this.valueCount.global;d++)g.addColumnReader(void 0,this.valueCount.globalPointArrayMap[d]);g.populateColumns(e)&&m.push(g)}0<m.length&&0<m[0].readers.length&&(g=a[m[0].readers[0].columnIndex],void 0!==g&&(g.isDatetime?b="datetime":g.isNumeric||(b="category")));if("category"===b)for(d=0;d<m.length;d++)for(g=m[d],e=0;e<g.readers.length;e++)"x"===g.readers[e].configName&&(g.readers[e].configName=
"name");for(d=0;d<m.length;d++){g=m[d];e=[];for(h=0;h<a[0].length;h++)e[h]=g.read(a,h);f[d]={data:e};g.name&&(f[d].name=g.name);"category"===b&&(f[d].turboThreshold=0)}a={series:f};b&&(a.xAxis={type:b},"category"===b&&(a.xAxis.uniqueNames=!1));c.complete&&c.complete(a);c.afterComplete&&c.afterComplete(a)}},update:function(a,b){var c=this.chart;a&&(a.afterComplete=function(a){a.xAxis&&c.xAxis[0]&&a.xAxis.type===c.xAxis[0].options.type&&delete a.xAxis;c.update(a,b,!0)},z(!0,this.options,a),this.init(this.options))}});
h.Data=A;h.data=function(a,b){return new A(a,b)};q(m,"init",function(a){var b=this,c=a.args[0],f=a.args[1];c&&c.data&&!b.hasDataDef&&(b.hasDataDef=!0,b.data=new A(h.extend(c.data,{afterComplete:function(a){var d,e;if(c.hasOwnProperty("series"))if("object"===typeof c.series)for(d=Math.max(c.series.length,a&&a.series?a.series.length:0);d--;)e=c.series[d]||{},c.series[d]=z(e,a&&a.series?a.series[d]:{});else delete c.series;c=z(a,c);b.init(c,f)}}),c,b),a.preventDefault())});x=function(){this.readers=
[];this.pointIsArray=!0};x.prototype.populateColumns=function(a){var b=!0;u(this.readers,function(b){void 0===b.columnIndex&&(b.columnIndex=a.shift())});u(this.readers,function(a){void 0===a.columnIndex&&(b=!1)});return b};x.prototype.read=function(a,b){var c=this.pointIsArray,f=c?[]:{},e;u(this.readers,function(d){var e=a[d.columnIndex][b];c?f.push(e):0<d.configName.indexOf(".")?h.Point.prototype.setNestedProperty(f,e,d.configName):f[d.configName]=e});void 0===this.name&&2<=this.readers.length&&
(e=this.getReferencedColumnIndexes(),2<=e.length&&(e.shift(),e.sort(function(a,b){return a-b}),this.name=a[e.shift()].name));return f};x.prototype.addColumnReader=function(a,b){this.readers.push({columnIndex:a,configName:b});"x"!==b&&"y"!==b&&void 0!==b&&(this.pointIsArray=!1)};x.prototype.getReferencedColumnIndexes=function(){var a,b=[],c;for(a=0;a<this.readers.length;a+=1)c=this.readers[a],void 0!==c.columnIndex&&b.push(c.columnIndex);return b};x.prototype.hasReader=function(a){var b,c;for(b=0;b<
this.readers.length;b+=1)if(c=this.readers[b],c.configName===a)return!0}})(q)});


/***/ }),
/* 1193 */
/***/ (function(module, exports) {

/**
 * A Highcharts plugin for exporting data from a rendered chart as CSV, XLS or HTML table
 *
 * Author:   Torstein Honsi
 * Licence:  MIT
 * Version:  1.4.8
 */
/*global Highcharts, window, document, Blob */
(function (factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
})(function (Highcharts) {

    'use strict';

    var each = Highcharts.each,
        pick = Highcharts.pick,
        seriesTypes = Highcharts.seriesTypes,
        downloadAttrSupported = document.createElement('a').download !== undefined;

    Highcharts.setOptions({
        lang: {
            downloadCSV: 'Download CSV',
            downloadXLS: 'Download XLS',
            viewData: 'View data table'
        }
    });


    /**
     * Get the data rows as a two dimensional array
     */
    Highcharts.Chart.prototype.getDataRows = function () {
        var options = (this.options.exporting || {}).csv || {},
            xAxis,
            xAxes = this.xAxis,
            rows = {},
            rowArr = [],
            dataRows,
            names = [],
            i,
            x,
            xTitle,
            // Options
            dateFormat = options.dateFormat || '%Y-%m-%d %H:%M:%S',
            columnHeaderFormatter = options.columnHeaderFormatter || function (item, key, keyLength) {
                if (item instanceof Highcharts.Axis) {
                    return (item.options.title && item.options.title.text) ||
                        (item.isDatetimeAxis ? 'DateTime' : 'Category');
                }
                return item ? 
                    item.name + (keyLength > 1 ? ' ('+ key + ')' : '') :
                    'Category';
            },
            xAxisIndices = [];

        // Loop the series and index values
        i = 0;
        each(this.series, function (series) {
            var keys = series.options.keys,
                pointArrayMap = keys || series.pointArrayMap || ['y'],
                valueCount = pointArrayMap.length,
                requireSorting = series.requireSorting,
                categoryMap = {},
                xAxisIndex = Highcharts.inArray(series.xAxis, xAxes),
                j;

            // Map the categories for value axes
            each(pointArrayMap, function (prop) {
                categoryMap[prop] = (series[prop + 'Axis'] && series[prop + 'Axis'].categories) || [];
            });

            if (series.options.includeInCSVExport !== false && series.visible !== false) { // #55

                // Build a lookup for X axis index and the position of the first
                // series that belongs to that X axis. Includes -1 for non-axis
                // series types like pies.
                if (!Highcharts.find(xAxisIndices, function (index) {
                    return index[0] === xAxisIndex;
                })) {
                    xAxisIndices.push([xAxisIndex, i]);
                }

                // Add the column headers, usually the same as series names
                j = 0;
                while (j < valueCount) {
                    names.push(columnHeaderFormatter(series, pointArrayMap[j], pointArrayMap.length));
                    j = j + 1;
                }

                each(series.points, function (point, pIdx) {
                    var key = requireSorting ? point.x : pIdx,
                        prop,
                        val;

                    j = 0;

                    if (!rows[key]) {
                        // Generate the row
                        rows[key] = [];
                        // Contain the X values from one or more X axes
                        rows[key].xValues = [];
                    }
                    rows[key].x = point.x;
                    rows[key].xValues[xAxisIndex] = point.x;
                    
                    // Pies, funnels, geo maps etc. use point name in X row
                    if (!series.xAxis || series.exportKey === 'name') {
                        rows[key].name = point.name;
                    }

                    while (j < valueCount) {
                        prop = pointArrayMap[j]; // y, z etc
                        val = point[prop];
                        rows[key][i + j] = pick(categoryMap[prop][val], val); // Pick a Y axis category if present
                        j = j + 1;
                    }

                });
                i = i + j;
            }
        });

        // Make a sortable array
        for (x in rows) {
            if (rows.hasOwnProperty(x)) {
                rowArr.push(rows[x]);
            }
        }

        var binding, xAxisIndex, column;
        dataRows = [names];

        i = xAxisIndices.length;
        while (i--) { // Start from end to splice in
            xAxisIndex = xAxisIndices[i][0];
            column = xAxisIndices[i][1];
            xAxis = xAxes[xAxisIndex];

            // Sort it by X values
            rowArr.sort(function (a, b) {
                return a.xValues[xAxisIndex] - b.xValues[xAxisIndex];
            });

            // Add header row
            xTitle = columnHeaderFormatter(xAxis);
            //dataRows = [[xTitle].concat(names)];
            dataRows[0].splice(column, 0, xTitle);

            // Add the category column
            each(rowArr, function (row) {

                var category = row.name;
                if (!category) {
                    if (xAxis.isDatetimeAxis) {
                        if (row.x instanceof Date) {
                            row.x = row.x.getTime();
                        }
                        category = Highcharts.dateFormat(dateFormat, row.x);
                    } else if (xAxis.categories) {
                        category = pick(
                            xAxis.names[row.x],
                            xAxis.categories[row.x],
                            row.x
                        )
                    } else {
                        category = row.x;
                    }
                }

                // Add the X/date/category
                row.splice(column, 0, category);
            });
        }
        dataRows = dataRows.concat(rowArr);

        return dataRows;
    };

    /**
     * Get a CSV string
     */
    Highcharts.Chart.prototype.getCSV = function (useLocalDecimalPoint) {
        var csv = '',
            rows = this.getDataRows(),
            options = (this.options.exporting || {}).csv || {},
            itemDelimiter = options.itemDelimiter || ',', // use ';' for direct import to Excel
            lineDelimiter = options.lineDelimiter || '\n'; // '\n' isn't working with the js csv data extraction

        // Transform the rows to CSV
        each(rows, function (row, i) {
            var val = '',
                j = row.length,
                n = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.';
            while (j--) {
                val = row[j];
                if (typeof val === "string") {
                    val = '"' + val + '"';
                }
                if (typeof val === 'number') {
                    if (n === ',') {
                        val = val.toString().replace(".", ",");
                    }
                }
                row[j] = val;
            }
            // Add the values
            csv += row.join(itemDelimiter);

            // Add the line delimiter
            if (i < rows.length - 1) {
                csv += lineDelimiter;
            }
        });
        return csv;
    };

    /**
     * Build a HTML table with the data
     */
    Highcharts.Chart.prototype.getTable = function (useLocalDecimalPoint) {
        var html = '<table><thead>',
            rows = this.getDataRows();

        // Transform the rows to HTML
        each(rows, function (row, i) {
            var tag = i ? 'td' : 'th',
                val,
                j,
                n = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.';

            html += '<tr>';
            for (j = 0; j < row.length; j = j + 1) {
                val = row[j];
                // Add the cell
                if (typeof val === 'number') {
                    val = val.toString();
                    if (n === ',') {
                        val = val.replace('.', n);
                    }
                    html += '<' + tag + ' class="number">' + val + '</' + tag + '>';

                } else {
                    html += '<' + tag + '>' + (val === undefined ? '' : val) + '</' + tag + '>';
                }
            }

            html += '</tr>';

            // After the first row, end head and start body
            if (!i) {
                html += '</thead><tbody>';
            }
            
        });
        html += '</tbody></table>';

        return html;
    };

    function getContent(chart, href, extension, content, MIME) {
        var a,
            blobObject,
            name,
            options = (chart.options.exporting || {}).csv || {},
            url = options.url || 'http://www.highcharts.com/studies/csv-export/download.php';

        if (chart.options.exporting.filename) {
            name = chart.options.exporting.filename;
        } else if (chart.title) {
            name = chart.title.textStr.replace(/ /g, '-').toLowerCase();
        } else {
            name = 'chart';
        }

        // MS specific. Check this first because of bug with Edge (#76)
        if (window.Blob && window.navigator.msSaveOrOpenBlob) {
            // Falls to msSaveOrOpenBlob if download attribute is not supported
            blobObject = new Blob([content]);
            window.navigator.msSaveOrOpenBlob(blobObject, name + '.' + extension);

        // Download attribute supported
        } else if (downloadAttrSupported) {
            a = document.createElement('a');
            a.href = href;
            a.target = '_blank';
            a.download = name + '.' + extension;
            chart.container.append(a); // #111
            a.click();
            a.remove();

        } else {
            // Fall back to server side handling
            Highcharts.post(url, {
                data: content,
                type: MIME,
                extension: extension
            });
        }
    }

    /**
     * Call this on click of 'Download CSV' button
     */
    Highcharts.Chart.prototype.downloadCSV = function () {
        var csv = this.getCSV(true);
        getContent(
            this,
            'data:text/csv,\uFEFF' + encodeURIComponent(csv),
            'csv',
            csv,
            'text/csv'
        );
    };

    /**
     * Call this on click of 'Download XLS' button
     */
    Highcharts.Chart.prototype.downloadXLS = function () {
        var uri = 'data:application/vnd.ms-excel;base64,',
            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
                '<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' +
                '<x:Name>Ark1</x:Name>' +
                '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' +
                '<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";}</style>' +
                '<meta name=ProgId content=Excel.Sheet>' +
                '<meta charset=UTF-8>' +
                '</head><body>' +
                this.getTable(true) +
                '</body></html>',
            base64 = function (s) { 
                return window.btoa(unescape(encodeURIComponent(s))); // #50
            };
        getContent(
            this,
            uri + base64(template),
            'xls',
            template,
            'application/vnd.ms-excel'
        );
    };

    /**
     * View the data in a table below the chart
     */
    Highcharts.Chart.prototype.viewData = function () {
        if (!this.dataTableDiv) {
            this.dataTableDiv = document.createElement('div');
            this.dataTableDiv.className = 'highcharts-data-table';
            
            // Insert after the chart container
            this.renderTo.parentNode.insertBefore(
                this.dataTableDiv,
                this.renderTo.nextSibling
            );
        }

        this.dataTableDiv.innerHTML = this.getTable();
    };


    // Add "Download CSV" to the exporting menu. Use download attribute if supported, else
    // run a simple PHP script that returns a file. The source code for the PHP script can be viewed at
    // https://raw.github.com/highslide-software/highcharts.com/master/studies/csv-export/csv.php
    if (Highcharts.getOptions().exporting) {
        Highcharts.getOptions().exporting.buttons.contextButton.menuItems.push({
            textKey: 'downloadCSV',
            onclick: function () { this.downloadCSV(); }
        }, {
            textKey: 'downloadXLS',
            onclick: function () { this.downloadXLS(); }
        }, {
            textKey: 'viewData',
            onclick: function () { this.viewData(); }
        });
    }

    // Series specific
    if (seriesTypes.map) {
        seriesTypes.map.prototype.exportKey = 'name';
    }
    if (seriesTypes.mapbubble) {
        seriesTypes.mapbubble.prototype.exportKey = 'name';
    }

});


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.6a198c11.js